import './experimental.css';var l$ = Object.defineProperty;
var d$ = (t, e, n) => e in t ? l$(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n;
var we = (t, e, n) => d$(t, typeof e != "symbol" ? e + "" : e, n);
import { a5 as A4, a6 as L4, a7 as ow, a8 as zd, a9 as c$, aa as u$, ab as f$, ac as zh, ad as m$, ae as h$, af as p$, ag as re, ah as I4, ai as g$, aj as ds, ak as id, al as Hu, am as y$, an as Ic, ao as v$, ap as Vh, aq as b$, ar as w$, as as Rc, at as k$, au as x$, av as _$, aw as sw, ax as M$, ay as lw, az as C$, aA as R4, aB as j4, aC as P$, f as S$, aD as N$, aE as $$, aF as D$, b as dw, aG as E$, aH as T$, a as E, Y as Cm, c as Wi, aI as st, aJ as Bu, aK as xn, P as qe, aL as Pm, aM as Vd, aN as Si, aO as F4, aP as Ir, aQ as z4, aR as ge, aS as V4, aT as O$, aU as Wn, aV as H4, aW as B4, aX as q4, aY as G4, aZ as Cy, a_ as X4, a$ as cw, b0 as Y4, a1 as Hd, S as No, I as me, F as Py, b1 as W$, b2 as et, j as It, b3 as K4, b4 as U4, b5 as J4, b6 as Q4, b7 as Z4, M as Sm, p as ue, b8 as Ke, b9 as Ji, ba as e5, bb as Ue, bc as Nm, bd as Mp, be as Sy, bf as _n, m as so, n as Rr, bg as t5, x as $o, y as Do, E as Eo, C as ui, s as A$, bh as Ny, w as Bt, v as Ce, bi as Cp, bj as L$, bk as I$, bl as qu, bm as R$, bn as j$, bo as F$, bp as z$, bq as V$, br as H$, bs as B$, bt as q$, bu as G$, bv as X$, o as $y, a2 as Bd, bw as Y$, a4 as K$, bx as ga, a3 as U$, by as J$, bz as Q$, bA as Z$, bB as eD, bC as tD, bD as nD, bE as iD, bF as Oa, L as ns, bG as Dy, bH as n5, bI as Ey, T as rD, bJ as i5, bK as r5, bL as a5, bM as aD, bN as o5, D as s5, k as l5, bO as oD, bP as $m, z as sD, i as lD, W as dD, bQ as qd, l as Pp, Q as d5, bR as Gd, bS as c5, q as Xd, bT as Yd, bU as Kd, bV as Ty, r as Ud, t as u5, u as cD, Z as Sp, bW as uD, bX as f5, bY as fD, bZ as mD, b_ as hD, b$ as Jd, c0 as Oy, c1 as Wy, c2 as Qd, c3 as m5, _ as h5, c4 as pD, c5 as gD, c6 as yD, A as vD, B as bD, e as wD, g as kD, V as xD, d as _D, c7 as MD, c8 as CD, c9 as PD, ca as SD, cb as p5 } from "./imageHandler-DsUJRWaf.js";
import { cc as gKe } from "./imageHandler-DsUJRWaf.js";
import { jsxs as k, jsx as d, Fragment as Ee } from "react/jsx-runtime";
import * as S from "react";
import H, { forwardRef as X, createContext as hn, useRef as Oe, useState as q, useCallback as Le, useContext as Wt, useMemo as ve, useEffect as le, PureComponent as ND, useId as Wa, createElement as Gu, useLayoutEffect as Zd, memo as ec, Fragment as rd, useTransition as $D, isValidElement as DD, cloneElement as g5, useDeferredValue as ED, useDebugValue as y5, createRef as TD, version as uw, useImperativeHandle as Dm, Children as v5 } from "react";
import * as Ay from "react-dom";
import Em, { flushSync as OD } from "react-dom";
const WD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinejoin: "round",
          d: "M4 13C7.31371 13 10 9.86599 10 6C10 9.86599 12.6863 13 16 13C12.6863 13 10 16.134 10 20C10 16.134 7.31371 13 4 13Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M17.5001 3.35001C17.8591 3.35001 18.1501 3.64102 18.1501 4.00001C18.1501 5.02173 18.9784 5.85001 20.0001 5.85001C20.3591 5.85001 20.6501 6.14102 20.6501 6.50001C20.6501 6.85899 20.3591 7.15001 20.0001 7.15001C18.9784 7.15001 18.1501 7.97828 18.1501 9.00001C18.1501 9.35899 17.8591 9.65001 17.5001 9.65001C17.1411 9.65001 16.8501 9.35899 16.8501 9.00001C16.8501 7.97828 16.0218 7.15001 15.0001 7.15001C14.6411 7.15001 14.3501 6.85899 14.3501 6.50001C14.3501 6.14102 14.6411 5.85001 15.0001 5.85001C16.0218 5.85001 16.8501 5.02173 16.8501 4.00001C16.8501 3.64102 17.1411 3.35001 17.5001 3.35001Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Ly = X(WD), AD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M12 14V6.99997",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M12 17.1V17",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), LD = X(AD), ID = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 8H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 16L15 16",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), b5 = X(ID), RD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 8H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 16H19",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), w5 = X(RD), jD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 8H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 16H11",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Np = X(jD), FD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 8H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13 16H19",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), k5 = X(FD), zD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 13L12 19L6.00002 13",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 5L12 18.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), ad = X(zD), VD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M6 11L12 5.00002L18 11",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 19L12 5.50002",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Iy = X(VD), HD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M9.76367 18C10.313 18.6137 11.1113 19 11.9998 19C12.8883 19 13.6866 18.6137 14.2359 18",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M12 4C9.23858 4 7 6.23858 7 9V9.72607C7 9.90146 6.93033 10.0697 6.8063 10.1937L6.03225 10.9678C5.39962 11.6004 5.17871 12.5361 5.46164 13.3849C5.78314 14.3494 6.68577 15 7.70246 15H16.2975C17.3142 15 18.2169 14.3494 18.5384 13.3849C18.8213 12.5361 18.6004 11.6004 17.9678 10.9678L17.1937 10.1937C17.0697 10.0697 17 9.90146 17 9.72607V9C17 6.23858 14.7614 4 12 4Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), x5 = X(HD), BD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M12.5 11.5C14.1569 11.5 15.5 10.1569 15.5 8.5C15.5 6.84315 14.1569 5.5 12.5 5.5L9 5.5C7.89543 5.5 7 6.39543 7 7.5L7 16.5C7 17.6046 7.89543 18.5 9 18.5H15",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M14.8333 18.5C16.8584 18.5 18.5 16.933 18.5 15C18.5 13.067 16.8584 11.5 14.8333 11.5H7.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), qD = X(BD), GD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 3V5M15 7V5M15 5H9M15 5H16C17.6569 5 19 6.34315 19 8V10V16C19 17.6569 17.6569 19 16 19H8C6.34315 19 5 17.6569 5 16V10V8C5 6.34315 6.34315 5 8 5H9M9 5V3M9 5V7",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 10H19",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), XD = X(GD), YD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M12 18L19.5 8",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4.5 13L7.67769 16.1777C8.11041 16.6104 8.82683 16.5564 9.18985 16.0638L15.5 7.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), _5 = X(YD), KD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 10L12 16",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M6 10L12 16",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), zn = X(KD), UD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 14L12 8",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M6 14L12 8",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), qs = X(UD), JD = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "rect",
      {
        width: 16,
        height: 16,
        x: 4,
        y: 4,
        fill: "currentColor",
        rx: 8,
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), M5 = X(JD), QD = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 17L4 12L9 7",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 17L20 12L15 7",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), C5 = X(QD), ZD = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        d: "M17 6H6.85714C5.27919 6 4 7.27919 4 8.85714V15.1293C4 16.7148 5.28525 18 6.87068 18C6.94791 18 7.01647 18.0494 7.04089 18.1227L7.56126 19.6838C7.7771 20.3313 8.56389 20.5771 9.10994 20.1675L11.7333 18.2C11.9064 18.0702 12.117 18 12.3333 18H17C18.6569 18 20 16.6569 20 15V9C20 7.34315 18.6569 6 17 6Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), eE = X(ZD), tE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M3.35001 12C3.35001 7.22273 7.22274 3.35 12 3.35C16.7773 3.35 20.65 7.22273 20.65 12C20.65 16.7773 16.7773 20.65 12 20.65C7.22274 20.65 3.35001 16.7773 3.35001 12ZM9.45963 8.54038C9.20578 8.28654 8.79423 8.28654 8.54039 8.54038C8.28655 8.79422 8.28655 9.20578 8.54039 9.45962L11.0808 12L8.54039 14.5404C8.28655 14.7942 8.28655 15.2058 8.54039 15.4596C8.79423 15.7135 9.20578 15.7135 9.45963 15.4596L12 12.9192L14.5404 15.4596C14.7942 15.7135 15.2058 15.7135 15.4596 15.4596C15.7135 15.2058 15.7135 14.7942 15.4596 14.5404L12.9192 12L15.4596 9.45962C15.7135 9.20578 15.7135 8.79422 15.4596 8.54038C15.2058 8.28654 14.7942 8.28654 14.5404 8.54038L12 11.0808L9.45963 8.54038Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), vs = X(tE), nE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 8V17C17 18.6569 15.6569 20 14 20H10C8.34315 20 7 18.6569 7 17V8M17 8H15.5M17 8H18.5M7 8H8.5M7 8H5.5M15.5 8V5C15.5 4.44772 15.0523 4 14.5 4L9.5 4C8.94772 4 8.5 4.44772 8.5 5V8M15.5 8H8.5",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), tc = X(nE), iE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "rect",
        {
          width: 16,
          height: 16,
          x: 4,
          y: 4,
          fill: "#052657",
          fillOpacity: 0.06,
          rx: 4,
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "#0D1625",
          d: "M8.5 10.25L12 13.75L15.5 10.25",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), rE = X(iE), aE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 1.5,
          fill: "currentColor",
          transform: "rotate(90 12 12)",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 6.5,
          r: 1.5,
          fill: "currentColor",
          transform: "rotate(90 12 6.5)",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 17.5,
          r: 1.5,
          fill: "currentColor",
          transform: "rotate(90 12 17.5)",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Tm = X(aE), oE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 1.5,
          fill: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 6.5,
          cy: 12,
          r: 1.5,
          fill: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 17.5,
          cy: 12,
          r: 1.5,
          fill: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Ma = X(oE), sE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19.5919 7.66492C18.318 10.297 15.5536 12.6649 11.9999 12.6649C8.44623 12.6649 5.68183 10.297 4.40796 7.66492",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M10.0083 13.0159L8.89773 16.3351",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M14.0576 13.0159L15.1682 16.3351",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M17.5232 10.543L20 13.0159",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M6.47681 10.543L4.00002 13.0159",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), lE = X(sE), dE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinejoin: "round",
          d: "M20 12C19 9 16 6 12 6C8 6 5 9 4 12C5 15 8 18 12 18C16 18 19 15 20 12Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 2.35,
          stroke: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), cE = X(dE), uE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 12.5C10.4746 12.5 9.27255 13.1111 8.47461 13.6914C8.07397 13.9828 7.76382 14.2739 7.55176 14.4951C7.44532 14.6062 7.36235 14.7016 7.30371 14.7715C7.27447 14.8063 7.25062 14.8347 7.2334 14.8564C7.22482 14.8673 7.21747 14.8766 7.21191 14.8838C7.20915 14.8874 7.20708 14.8909 7.20508 14.8936L7.20215 14.8975L7.2002 14.9004C6.86897 15.3422 6.95863 15.9685 7.40039 16.2998C7.84221 16.631 8.46847 16.5424 8.7998 16.1006L8.79883 16.1025L8.80176 16.0986C8.80771 16.0911 8.81843 16.0763 8.83496 16.0566C8.86806 16.0172 8.92209 15.9561 8.99512 15.8799C9.1424 15.7262 9.36385 15.517 9.65039 15.3086C10.2274 14.8889 11.0255 14.5 12 14.5C12.9745 14.5 13.7726 14.8889 14.3496 15.3086C14.6361 15.517 14.8576 15.7262 15.0049 15.8799C15.0779 15.9561 15.1319 16.0172 15.165 16.0566C15.1816 16.0763 15.1923 16.0911 15.1982 16.0986L15.2002 16.1006L15.2012 16.0996C15.5326 16.5411 16.1579 16.631 16.5996 16.2998C17.0414 15.9685 17.131 15.3412 16.7998 14.8994L16.7979 14.8975L16.7949 14.8936C16.7929 14.8909 16.7908 14.8874 16.7881 14.8838C16.7825 14.8766 16.7752 14.8673 16.7666 14.8564C16.7494 14.8347 16.7255 14.8063 16.6963 14.7715C16.6376 14.7016 16.5547 14.6062 16.4482 14.4951C16.2362 14.2739 15.926 13.9828 15.5254 13.6914C14.7275 13.1111 13.5254 12.5 12 12.5ZM8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11H10C10.5523 11 11 10.5523 11 10C11 9.44772 10.5523 9 10 9H8ZM14 9C13.4477 9 13 9.44772 13 10C13 10.5523 13.4477 11 14 11H16C16.5523 11 17 10.5523 17 10C17 9.44772 16.5523 9 16 9H14Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), fE = X(uE), mE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM8 14C7.44772 14 7 14.4477 7 15C7 15.5523 7.44772 16 8 16H16C16.5523 16 17 15.5523 17 15C17 14.4477 16.5523 14 16 14H8ZM10 8C9.44772 8 9 8.44772 9 9V11C9 11.5523 9.44772 12 10 12C10.5523 12 11 11.5523 11 11V9C11 8.44772 10.5523 8 10 8ZM14 8C13.4477 8 13 8.44772 13 9V11C13 11.5523 13.4477 12 14 12C14.5523 12 15 11.5523 15 11V9C15 8.44772 14.5523 8 14 8Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), hE = X(mE), pE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM16.5996 13.7002C16.1578 13.3691 15.5315 13.4588 15.2002 13.9004L15.2012 13.8975L15.1982 13.9014C15.1923 13.9089 15.1814 13.9238 15.165 13.9434C15.132 13.9828 15.0778 14.044 15.0049 14.1201C14.8576 14.2738 14.636 14.4831 14.3496 14.6914C13.7726 15.111 12.9742 15.4999 12 15.5C11.0258 15.4999 10.2274 15.111 9.65039 14.6914C9.36401 14.4831 9.14237 14.2738 8.99512 14.1201C8.92223 14.044 8.86805 13.9828 8.83496 13.9434C8.81858 13.9238 8.80772 13.9089 8.80176 13.9014L8.7998 13.8994L8.79883 13.9004C8.46746 13.4591 7.84205 13.3692 7.40039 13.7002C6.95881 14.0315 6.86912 14.6588 7.2002 15.1006L7.20215 15.1025L7.20508 15.1064C7.20703 15.109 7.20924 15.1127 7.21191 15.1162C7.21744 15.1234 7.22491 15.1328 7.2334 15.1436C7.25059 15.1653 7.27457 15.1938 7.30371 15.2285C7.36233 15.2983 7.44544 15.3939 7.55176 15.5049C7.76379 15.7261 8.07413 16.0173 8.47461 16.3086C9.2725 16.8888 10.4748 17.4999 12 17.5C13.5252 17.4999 14.7275 16.8888 15.5254 16.3086C15.9259 16.0173 16.2362 15.7261 16.4482 15.5049C16.5546 15.3939 16.6377 15.2983 16.6963 15.2285C16.7254 15.1938 16.7494 15.1653 16.7666 15.1436C16.7751 15.1328 16.7826 15.1234 16.7881 15.1162C16.7908 15.1127 16.793 15.109 16.7949 15.1064L16.7979 15.1025L16.7998 15.0996C17.1309 14.6579 17.0412 14.0315 16.5996 13.7002ZM10 8C9.44784 8.00014 9 8.4478 9 9V11C9 11.5522 9.44784 11.9999 10 12C10.5522 11.9998 11 11.5522 11 11V9C11 8.44781 10.5522 8.00015 10 8ZM14 8C13.4478 8.00014 13 8.4478 13 9V11C13 11.5522 13.4478 11.9999 14 12C14.5522 11.9998 15 11.5522 15 11V9C15 8.44781 14.5522 8.00015 14 8Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), gE = X(pE), yE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM12 13.5C10.9629 13.5 10.0117 13.8245 9.2998 14.3252C8.62327 14.801 8.00007 15.5654 8 16.5C8.00007 17.0176 8.39345 17.4437 8.89746 17.4951L9 17.5H15C15.5176 17.4999 15.9437 17.1066 15.9951 16.6025L16 16.5C15.9999 15.5655 15.3767 14.801 14.7002 14.3252C13.9883 13.8246 13.037 13.5 12 13.5ZM8.44043 8.10254C7.98585 7.87888 7.42683 8.03102 7.15234 8.46973C6.87809 8.90859 6.98572 9.47831 7.38574 9.78906L7.46973 9.84766L8.11328 10.25L7.46973 10.6523C7.00174 10.9451 6.85986 11.5621 7.15234 12.0303C7.44518 12.4982 8.06211 12.6402 8.53027 12.3477L10.5303 11.0977L10.6338 11.0234C10.8638 10.835 11 10.5518 11 10.25C11 9.9483 10.8637 9.665 10.6338 9.47656L10.5303 9.40234L8.53027 8.15234L8.44043 8.10254ZM16.8477 8.46973C16.5731 8.03107 16.0141 7.8788 15.5596 8.10254L15.4697 8.15234L13.4697 9.40234L13.3662 9.47656C13.1362 9.665 13 9.94824 13 10.25C13 10.5517 13.1363 10.835 13.3662 11.0234L13.4697 11.0977L15.4697 12.3477C15.9379 12.6401 16.5549 12.4982 16.8477 12.0303C17.1402 11.5621 16.9982 10.9452 16.5303 10.6523L15.8867 10.25L16.5303 9.84766L16.6143 9.78906C17.0144 9.47836 17.1219 8.90864 16.8477 8.46973Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), vE = X(yE), bE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3ZM9 14C8.48235 14 8.05621 14.3934 8.00488 14.8975L8 15C8 15.9347 8.62324 16.6989 9.2998 17.1748C10.0117 17.6755 10.9629 18 12 18C13.0371 18 13.9883 17.6755 14.7002 17.1748C15.3768 16.6989 16 15.9347 16 15C16 14.4823 15.6066 14.0562 15.1025 14.0049L15 14H9ZM8.75 9C7.86303 9.00002 7.1348 9.51775 6.67285 10.1982L6.61914 10.2861C6.37872 10.732 6.51041 11.2962 6.93848 11.5869C7.36681 11.8776 7.94005 11.7916 8.26562 11.4033L8.32715 11.3213C8.52342 11.0322 8.6954 11 8.75 11C8.78986 11 8.92242 11.0175 9.10254 11.2314L9.18262 11.3359L9.24512 11.416C9.57734 11.7991 10.1528 11.8754 10.5762 11.5771C10.9992 11.2789 11.1205 10.7121 10.8721 10.2705L10.8174 10.1836L10.6328 9.94434C10.1749 9.40337 9.53409 9.00002 8.75 9ZM15.25 9C14.363 9.00002 13.6348 9.51775 13.1729 10.1982L13.1191 10.2861C12.8787 10.732 13.0104 11.2962 13.4385 11.5869C13.8668 11.8776 14.4401 11.7916 14.7656 11.4033L14.8271 11.3213C15.0234 11.0322 15.1954 11 15.25 11C15.2899 11 15.4224 11.0175 15.6025 11.2314L15.6826 11.3359L15.7451 11.416C16.0773 11.7991 16.6528 11.8754 17.0762 11.5771C17.4992 11.2789 17.6205 10.7121 17.3721 10.2705L17.3174 10.1836L17.1328 9.94434C16.6749 9.40337 16.0341 9.00002 15.25 9Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), wE = X(bE), kE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        d: "M5.41496 6.65079C4.85896 6.00212 5.31987 5 6.17422 5H17.8258C18.6801 5 19.141 6.00212 18.585 6.65079L14.2407 11.7191C14.0854 11.9004 14 12.1312 14 12.3699V16.5C14 16.8148 13.8518 17.1111 13.6 17.3L11.6 18.8C10.9408 19.2944 10 18.824 10 18V12.3699C10 12.1312 9.91461 11.9004 9.75926 11.7191L5.41496 6.65079Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), xE = X(kE), _E = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 10 14",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M0.5 1.5C0.5 2.32843 1.17157 3 2 3C2.82843 3 3.5 2.32843 3.5 1.5C3.5 0.671573 2.82843 0 2 0C1.17157 0 0.5 0.671573 0.5 1.5ZM0.5 7C0.5 7.82843 1.17157 8.5 2 8.5C2.82843 8.5 3.5 7.82843 3.5 7C3.5 6.17157 2.82843 5.5 2 5.5C1.17157 5.5 0.5 6.17157 0.5 7ZM2 14C1.17157 14 0.5 13.3284 0.5 12.5C0.5 11.6716 1.17157 11 2 11C2.82843 11 3.5 11.6716 3.5 12.5C3.5 13.3284 2.82843 14 2 14ZM6.5 1.5C6.5 2.32843 7.17157 3 8 3C8.82843 3 9.5 2.32843 9.5 1.5C9.5 0.671573 8.82843 0 8 0C7.17157 0 6.5 0.671573 6.5 1.5ZM6.5 7C6.5 7.82843 7.17157 8.5 8 8.5C8.82843 8.5 9.5 7.82843 9.5 7C9.5 6.17157 8.82843 5.5 8 5.5C7.17157 5.5 6.5 6.17157 6.5 7ZM8 14C7.17157 14 6.5 13.3284 6.5 12.5C6.5 11.6716 7.17157 11 8 11C8.82843 11 9.5 11.6716 9.5 12.5C9.5 13.3284 8.82843 14 8 14Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), ME = X(_E), CE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 7V12M5 17V12M5 12H12V7V17",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 7V17",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M16 9C17 9 18 8 18 7",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), P5 = X(CE), PE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4 7V12M4 17V12M4 12H11V7V17",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 9.5V9.5C15 8.11929 16.1193 7 17.5 7V7C18.8807 7 20 8.11929 20 9.5V9.5C20 10.8807 18.8807 12 17.5 12V12C16.1193 12 15 13.1193 15 14.5V17H20",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), S5 = X(PE), SE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 9V9C15 7.89543 15.8954 7 17 7H17.5C18.8807 7 20 8.11929 20 9.5V9.5C20 10.8807 18.8807 12 17.5 12V12",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 15V15C15 16.1046 15.8954 17 17 17H17.5C18.8807 17 20 15.8807 20 14.5V14.5C20 13.1193 18.8807 12 17.5 12V12",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4 7V12M4 17V12M4 12H11V7V17",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), N5 = X(SE), NE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 8,
          stroke: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M11.9999 18C15.3136 18 17.9999 15.3137 17.9999 12C17.9999 8.68629 15.3136 6 11.9999 6V18Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), $E = X(NE), DE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M17 6H13M9 6H13M13 6L11 18H7H15",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), EE = X(DE), TE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 6.5C5 5.67157 5.67157 5 6.5 5H9C9.82843 5 10.5 5.67157 10.5 6.5V17.5C10.5 18.3284 9.82843 19 9 19H6.5C5.67157 19 5 18.3284 5 17.5V6.5Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13.5 6.5C13.5 5.67157 14.1716 5 15 5H17.5C18.3284 5 19 5.67157 19 6.5V13.5C19 14.3284 18.3284 15 17.5 15H15C14.1716 15 13.5 14.3284 13.5 13.5V6.5Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), OE = X(TE), WE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M11 18V18C9.61929 19.3807 7.38071 19.3807 6 18V18C4.61929 16.6193 4.61929 14.3807 6 13L9 10C10.1046 8.89543 11.8954 8.89543 13 10V10",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M13 5.99999V5.99999C14.3807 4.61928 16.6193 4.61929 18 6V6C19.3807 7.38071 19.3807 9.61929 18 11L15 14C13.8954 15.1046 12.1046 15.1046 11 14V14",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), fw = X(WE), AE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 8H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 16H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M4.5 8C4.5 7.72386 4.72386 7.5 5 7.5C5.27614 7.5 5.5 7.72386 5.5 8C5.5 8.27614 5.27614 8.5 5 8.5C4.72386 8.5 4.5 8.27614 4.5 8ZM4.5 12C4.5 11.7239 4.72386 11.5 5 11.5C5.27614 11.5 5.5 11.7239 5.5 12C5.5 12.2761 5.27614 12.5 5 12.5C4.72386 12.5 4.5 12.2761 4.5 12ZM4.5 16C4.5 15.7239 4.72386 15.5 5 15.5C5.27614 15.5 5.5 15.7239 5.5 16C5.5 16.2761 5.27614 16.5 5 16.5C4.72386 16.5 4.5 16.2761 4.5 16Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Ry = X(AE), LE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M6.91895 16.2844C5.94243 15.1275 5.35384 13.6325 5.35384 12C5.35384 8.32943 8.32943 5.35384 12 5.35384C15.6706 5.35384 18.6461 8.32943 18.6461 12C18.6461 13.6325 18.0576 15.1275 17.0811 16.2844C17.417 16.4944 17.739 16.7244 18.0453 16.973L18.1792 17.0815C19.3168 15.6997 20 13.9296 20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 13.9296 4.68318 15.6997 5.82087 17.0815L5.95467 16.973C6.26096 16.7244 6.58297 16.4944 6.91895 16.2844Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M17.0372 18.2154C15.6619 19.3313 13.9091 20 12 20C10.0909 20 8.33808 19.3313 6.96283 18.2154C8.33808 17.0995 10.0909 16.4308 12 16.4308C13.9091 16.4308 15.6619 17.0995 17.0372 18.2154Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M12 14.7077C13.6314 14.7077 14.9539 13.3852 14.9539 11.7539C14.9539 10.1225 13.6314 8.8 12 8.8C10.3686 8.8 9.04614 10.1225 9.04614 11.7539C9.04614 13.3852 10.3686 14.7077 12 14.7077Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), IE = X(LE), RE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13.5 10.5L19 5M19 5H15M19 5V9",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M10.5 13.5L5 19M5 19H9M5 19V15",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), jE = X(RE), FE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinejoin: "round",
          d: "M17 6L13.9669 7.21324C12.6676 7.73297 11.281 8 9.88159 8H6C4.89543 8 4 8.89543 4 10V13C4 14.1046 4.89543 15 6 15H7V17.25C7 18.2165 7.7835 19 8.75 19V19C9.7165 19 10.5 18.2165 10.5 17.25V15H10.8445C11.6078 15 12.3641 15.1457 13.0728 15.4291L17 17V6Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M20 10V14",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), $5 = X(FE), zE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4.99989 7H18.9999",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M4.99989 17H18.9999",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), D5 = X(zE), VE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 5L13.5 10.5M13.5 10.5L17.5 10.5M13.5 10.5L13.5 6.5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 19L10.5 13.5M10.5 13.5L6.5 13.5M10.5 13.5L10.5 17.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), HE = X(VE), BE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M19 12H5",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), jy = X(BE), qE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M12.5004 7H7C5.89543 7 5 7.89543 5 9V15C5 16.1046 5.89543 17 7 17H9.5004",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8.0004 19L10.0004 17L8.0004 15",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6.7,
          height: 6.7,
          x: 0.65,
          y: -0.65,
          fill: "currentColor",
          stroke: "currentColor",
          rx: 1.35,
          transform: "matrix(1 0 0 -1 12 19.7)",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6.7,
          height: 6.7,
          x: 0.65,
          y: -0.65,
          stroke: "currentColor",
          rx: 1.35,
          transform: "matrix(1 0 0 -1 12 9.7)",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), GE = X(qE), XE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          d: "M12.5004 17H7C5.89543 17 5 16.1046 5 15V9C5 7.89543 5.89543 7 7 7H9.5004",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8.0004 5L10.0004 7L8.0004 9",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6.7,
          height: 6.7,
          x: 12.65,
          y: 3.65,
          fill: "currentColor",
          stroke: "currentColor",
          rx: 1.35,
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6.7,
          height: 6.7,
          x: 12.65,
          y: 13.65,
          stroke: "currentColor",
          rx: 1.35,
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), YE = X(XE), KE = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M7 4V10",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13 7H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13 12H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M13 17H19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 14V14C5 12.8954 5.89543 12 7 12V12C8.10457 12 9 12.8954 9 14V14C9 15.1046 8.10457 16 7 16V16C5.89543 16 5 16.8954 5 18V19H9",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 6C6 6 7 5 7 4",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), E5 = X(KE), UE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        d: "M15 11L10 16C9.44772 16.5523 8.55228 16.5523 8 16V16C7.44772 15.4477 7.44772 14.5523 8 14L15 7C16.1046 5.89543 17.8954 5.89543 19 7V7C20.1046 8.10457 20.1046 9.89543 19 11L12 18C10.3431 19.6569 7.65685 19.6569 6 18V18C4.34315 16.3431 4.34315 13.6569 6 12L11 7",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), JE = X(UE), QE = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M7 13L5.5 18.5L11 17M7 13L14.5 5.5C15.6046 4.39543 17.3954 4.39543 18.5 5.5V5.5C19.6046 6.60457 19.6046 8.39543 18.5 9.5L11 17M7 13L11 17",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), ZE = X(QE), eT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 9,
          r: 4,
          stroke: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M7 18C7 18 8.5 16 12 16C15.5 16 17 18 17 18",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), mw = X(eT), tT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "circle",
        {
          cx: 12,
          cy: 12,
          r: 8,
          stroke: "currentColor",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinejoin: "round",
          d: "M17.5 6.5L6.5 17.5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinejoin: "round",
          d: "M17.5 17.5L6.5 6.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), T5 = X(tT), nT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M12.65 5.00001C12.65 4.64102 12.359 4.35001 12 4.35001C11.641 4.35001 11.35 4.64102 11.35 5.00001V11.35H5C4.64102 11.35 4.35 11.641 4.35 12C4.35 12.359 4.64102 12.65 5 12.65H11.35V19C11.35 19.359 11.641 19.65 12 19.65C12.359 19.65 12.65 19.359 12.65 19V12.65H19C19.359 12.65 19.65 12.359 19.65 12C19.65 11.641 19.359 11.35 19 11.35H12.65V5.00001Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), O5 = X(nT), iT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M9 9C9 7 10.5 6 12 6C13.5 6 15 7.5 15 9C15 12 12 11.5 12 14",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M12 17V17.1",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), W5 = X(iT), rT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M10 6V6C7.23858 6 5 8.23858 5 11V13M5 13V15.5C5 16.8807 6.11929 18 7.5 18V18C8.88071 18 10 16.8807 10 15.5V15.5C10 14.1193 8.88071 13 7.5 13H5Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 6V6C16.2386 6 14 8.23858 14 11V13M14 13V15.5C14 16.8807 15.1193 18 16.5 18V18C17.8807 18 19 16.8807 19 15.5V15.5C19 14.1193 17.8807 13 16.5 13H14Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), A5 = X(rT), aT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 12C19 15.866 15.866 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M10 10V11",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M14 10V11",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M9.5 14V14C10.9616 15.1693 13.0384 15.1693 14.5 14V14",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M18 3V6M18 9V6M18 6H15H21",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), L5 = X(aT), oT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M5 13.5C5 14.8845 5.41054 16.2378 6.17971 17.389C6.94888 18.5401 8.04213 19.4373 9.32122 19.9672C10.6003 20.497 12.0078 20.6356 13.3656 20.3655C14.7235 20.0954 15.9708 19.4287 16.9497 18.4497C17.9287 17.4708 18.5954 16.2235 18.8655 14.8656C19.1356 13.5078 18.997 12.1003 18.4672 10.8212C17.9373 9.54213 17.0401 8.44888 15.889 7.67971C14.7378 6.91054 13.3845 6.5 12 6.5L5.5 6.5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M8 3.5L5 6.5L8 9.5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), sT = X(oT), lT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M16 16L19 19",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 14,
          height: 14,
          x: 4,
          y: 4,
          stroke: "currentColor",
          rx: 7,
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), Om = X(lT), dT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M8 13.0001L8 21.0001",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M16 3.00006L16 11.0001",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M8.00001 3.00006L8.00001 4.00006",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M16 20.0001L16 21.0001",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6,
          height: 3,
          x: 5,
          y: 7,
          stroke: "currentColor",
          rx: 1.5,
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "rect",
        {
          width: 6,
          height: 3,
          x: 13,
          y: 14,
          stroke: "currentColor",
          rx: 1.5,
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), cT = X(dT), uT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M5.99999 17V6.99999C5.99999 5.89542 6.89542 4.99999 7.99999 4.99999C9.10456 4.99999 9.99999 5.89542 9.99999 6.99999V17C9.99999 18.1046 9.10456 19 7.99999 19C6.89542 19 5.99999 18.1046 5.99999 17Z",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          d: "M14 17V6.99999C14 5.89542 14.8954 4.99999 16 4.99999C17.1046 4.99999 18 5.89542 18 6.99999V17C18 18.1046 17.1046 19 16 19C14.8954 19 14 18.1046 14 17Z",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), hw = X(uT), fT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        d: "M5.99988 16.5536V7.44636C5.99988 5.91072 7.65884 4.94798 8.99216 5.70988L16.961 10.2635C18.3047 11.0313 18.3047 12.9687 16.961 13.7365L8.99216 18.2901C7.65884 19.052 5.99988 18.0893 5.99988 16.5536Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), pw = X(fT), mT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        d: "M8 5H16C17.6569 5 19 6.34315 19 8V16C19 17.6569 17.6569 19 16 19H8C6.34315 19 5 17.6569 5 16V8C5 6.34315 6.34315 5 8 5Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), gw = X(mT), hT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        d: "M19 12C19 13.3845 18.5895 14.7378 17.8203 15.889C17.0511 17.0401 15.9579 17.9373 14.6788 18.4672C13.3997 18.997 11.9922 19.1356 10.6344 18.8655C9.2765 18.5954 8.02922 17.9287 7.05025 16.9497C6.07128 15.9708 5.4046 14.7235 5.1345 13.3656C4.86441 12.0078 5.00303 10.6003 5.53284 9.32122C6.06266 8.04213 6.95986 6.94888 8.11101 6.17971C9.26215 5.41054 10.6155 5 12 5",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), I5 = X(hT), pT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        fillRule: "evenodd",
        d: "M11.5391 4.10845C11.8282 3.96385 12.1669 3.96385 12.4561 4.10845C12.6966 4.22873 12.8295 4.43653 12.9008 4.55867C12.9757 4.68708 13.0538 4.8529 13.1345 5.02446L13.1449 5.0467L14.847 8.66357L18.6417 9.24535L18.6666 9.24916C18.8456 9.27657 19.0229 9.30372 19.1655 9.33968C19.3067 9.3753 19.5399 9.4471 19.7207 9.64735C19.9315 9.88069 20.0252 10.1936 19.9867 10.4989C19.9542 10.7577 19.814 10.9489 19.721 11.0629C19.6272 11.1779 19.5002 11.3076 19.3698 11.4408L19.3526 11.4583L16.5947 14.2759C16.593 14.2776 16.5914 14.2793 16.5897 14.281C16.5905 14.2856 16.5913 14.2905 16.5921 14.2955L17.2429 18.2753L17.2468 18.2991C17.2777 18.4883 17.3074 18.6698 17.3187 18.819C17.3296 18.9634 17.3368 19.202 17.2171 19.4332C17.0735 19.7105 16.811 19.9173 16.4925 19.9792C16.222 20.0318 15.9881 19.9421 15.858 19.8854C15.723 19.8267 15.565 19.7395 15.4046 19.651L15.3825 19.6388L11.9976 17.7717L8.61264 19.6388L8.59058 19.651C8.43018 19.7395 8.27213 19.8267 8.13718 19.8854C8.00709 19.9421 7.77317 20.0318 7.50272 19.9792C7.18414 19.9173 6.92171 19.7105 6.77813 19.4332C6.65841 19.202 6.66558 18.9634 6.67648 18.819C6.68774 18.6698 6.71745 18.4883 6.7484 18.2991L6.75231 18.2753L7.40306 14.2955C7.40388 14.2905 7.40467 14.2856 7.40543 14.281C7.40382 14.2793 7.40218 14.2776 7.40051 14.2759L4.64254 11.4583L4.62536 11.4408C4.49496 11.3076 4.36799 11.1779 4.27414 11.0629C4.18122 10.9489 4.04102 10.7577 4.00844 10.4989C3.96999 10.1936 4.06368 9.88069 4.27444 9.64735C4.45531 9.4471 4.68848 9.3753 4.8297 9.33968C4.97227 9.30372 5.14958 9.27657 5.3286 9.24916C5.33689 9.24789 5.34518 9.24662 5.35347 9.24535L9.14816 8.66357L10.8503 5.0467C10.8538 5.03927 10.8572 5.03186 10.8607 5.02446C10.9414 4.8529 11.0194 4.68708 11.0944 4.55867C11.1657 4.43653 11.2986 4.22873 11.5391 4.10845ZM11.9976 5.66171L10.322 9.22235C10.3186 9.22952 10.3149 9.23742 10.311 9.24596C10.2726 9.32878 10.2066 9.47138 10.1021 9.58939C10.0123 9.69078 9.90295 9.77471 9.77927 9.83504C9.63302 9.90638 9.47424 9.92954 9.38761 9.94218C9.37873 9.94347 9.3706 9.94466 9.36332 9.94578L5.55295 10.53C5.55905 10.5362 5.56525 10.5425 5.57156 10.549L8.32952 13.3666C8.33498 13.3722 8.341 13.3782 8.3475 13.3848C8.4114 13.4493 8.5214 13.5603 8.59584 13.7005C8.65879 13.8191 8.69852 13.9481 8.71381 14.0803C8.73171 14.2352 8.70592 14.3875 8.69039 14.4792C8.68881 14.4886 8.68733 14.4973 8.68602 14.5053L8.0375 18.4714L11.3934 16.6203C11.3999 16.6167 11.4072 16.6126 11.4151 16.6082C11.4919 16.5651 11.6326 16.4861 11.7916 16.4534C11.9276 16.4254 12.0676 16.4254 12.2036 16.4534C12.3626 16.4861 12.5033 16.5651 12.5801 16.6082C12.588 16.6126 12.5953 16.6167 12.6018 16.6203L15.9577 18.4714L15.3092 14.5053C15.3078 14.4973 15.3064 14.4886 15.3048 14.4792C15.2893 14.3875 15.2635 14.2352 15.2814 14.0803C15.2967 13.9481 15.3364 13.8191 15.3993 13.7005C15.4738 13.5603 15.5838 13.4493 15.6477 13.3848C15.6542 13.3782 15.6602 13.3722 15.6657 13.3666L18.4236 10.549C18.4299 10.5425 18.4361 10.5362 18.4422 10.53L14.6319 9.94578C14.6246 9.94466 14.6164 9.94347 14.6076 9.94218C14.5209 9.92954 14.3622 9.90638 14.2159 9.83504C14.0922 9.77471 13.9829 9.69078 13.8931 9.58939C13.7886 9.47138 13.7226 9.32878 13.6842 9.24596C13.6803 9.23742 13.6766 9.22952 13.6732 9.22235L11.9976 5.66171Z",
        clipRule: "evenodd",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), gT = X(pT), yT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        fill: "currentColor",
        d: "M11.5495 4.45657C11.8336 4.31449 12.1664 4.31449 12.4505 4.45657C12.6882 4.57541 12.8186 4.78023 12.887 4.89749C12.9592 5.02106 13.034 5.18019 13.1106 5.34302L14.7355 8.79579L18.3589 9.3513C18.5287 9.37731 18.699 9.40338 18.8363 9.43801C18.9722 9.4723 19.2019 9.54251 19.3806 9.74033C19.5875 9.96943 19.6794 10.2765 19.6417 10.5761C19.6095 10.8315 19.4713 11.0193 19.3819 11.1289C19.2916 11.2396 19.1697 11.3641 19.046 11.4905L19.0459 11.4905L16.4078 14.1857L17.0313 17.9992C17.0607 18.1787 17.0892 18.3529 17.1 18.4964C17.1105 18.6351 17.118 18.8698 16.9998 19.098C16.8589 19.3701 16.6012 19.5733 16.2881 19.6342C16.0208 19.6862 15.7906 19.5973 15.6655 19.5429C15.5356 19.4863 15.3838 19.4026 15.2316 19.3186L12 17.536L8.76837 19.3186C8.61616 19.4026 8.46442 19.4863 8.3345 19.5429C8.20944 19.5973 7.97922 19.6862 7.71191 19.6342C7.3988 19.5733 7.14108 19.3701 7.00016 19.098C6.88196 18.8698 6.88949 18.6351 6.89996 18.4964C6.91079 18.3529 6.9393 18.1787 6.96867 17.9992L6.96868 17.9992L7.59224 14.1857L4.95406 11.4905L4.95405 11.4905C4.8303 11.3641 4.70842 11.2396 4.6181 11.1289C4.52873 11.0193 4.39045 10.8315 4.35829 10.5761C4.32058 10.2765 4.41246 9.96944 4.6194 9.74033C4.79807 9.54251 5.02777 9.4723 5.16369 9.43801C5.30099 9.40338 5.47126 9.37731 5.64114 9.3513L5.66555 9.34756L9.26452 8.79579L10.8791 5.36484L10.8894 5.34299C10.966 5.18017 11.0409 5.02105 11.113 4.89749C11.1814 4.78023 11.3118 4.57541 11.5495 4.45657Z",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), vT = X(yT), bT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M15 7.5V7.5C14.7014 6.60421 13.8631 6 12.9189 6H11.6056C10.6025 6 9.6658 6.5013 9.1094 7.3359V7.3359C8.4376 8.3436 8.4376 9.6564 9.1094 10.6641V10.6641C9.6658 11.4987 10.6025 12 11.6056 12H12.3944C13.3975 12 14.3342 12.5013 14.8906 13.3359V13.3359C15.5624 14.3436 15.5624 15.6564 14.8906 16.6641V16.6641C14.3342 17.4987 13.3975 18 12.3944 18H11.0811C10.1369 18 9.2986 17.3958 9 16.5V16.5",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M19 12H5",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), wT = X(bT), kT = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4.00001 9.5L4.00001 17C4.00001 18.1046 4.89544 19 6.00001 19H12M4.00001 9.5L4.00001 7C4.00001 5.89543 4.89544 5 6.00001 5H12H18C19.1046 5 20 5.89543 20 7V9.5M4.00001 9.5H12M20 9.5V17C20 18.1046 19.1046 19 18 19H12M20 9.5H12M4.00001 14H20M12 19V9.5",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), xT = X(kT), _T = (t, e) => /* @__PURE__ */ d(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: /* @__PURE__ */ d(
      "path",
      {
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeLinejoin: "round",
        d: "M4 6H9M14 6H9M9 6V18M13 12H16M19 12H16M16 12V18",
        vectorEffect: "non-scaling-stroke"
      }
    )
  }
), MT = X(_T), CT = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          d: "M16 6V11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11V6",
          vectorEffect: "non-scaling-stroke"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          stroke: "currentColor",
          strokeLinecap: "round",
          strokeLinejoin: "round",
          d: "M7 18H17",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), PT = X(CT), ST = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d("title", { children: "Windows" }),
      /* @__PURE__ */ d(
        "path",
        {
          fill: "currentColor",
          fillRule: "evenodd",
          d: "M20 4L11.4628 5.24738V11.4067H20V4ZM20 20.2501V12.7255L11.4628 12.71V18.9003L20 20.2501ZM10.3286 12.6633V18.7916L4.0046 17.9073V12.6323L10.3286 12.6633ZM10.3286 5.35601L4 6.24035L4.00307 11.4843H10.3286V5.35601Z",
          clipRule: "evenodd",
          vectorEffect: "non-scaling-stroke"
        }
      )
    ]
  }
), NT = X(ST), $T = hn(null);
function DT() {
  const t = Oe(!1);
  return A4(() => (t.current = !0, () => {
    t.current = !1;
  }), []), t;
}
function ET() {
  const t = DT(), [e, n] = q(0), i = Le(() => {
    t.current && n(e + 1);
  }, [e]);
  return [Le(() => L4.postRender(i), [i]), e];
}
const TT = (t) => !t.isLayoutDirty && t.willUpdate(!1);
function yw() {
  const t = /* @__PURE__ */ new Set(), e = /* @__PURE__ */ new WeakMap(), n = () => t.forEach(TT);
  return {
    add: (i) => {
      t.add(i), e.set(i, i.addEventListener("willUpdate", n));
    },
    remove: (i) => {
      t.delete(i);
      const r = e.get(i);
      r && (r(), e.delete(i)), n();
    },
    dirty: n
  };
}
const R5 = (t) => t === !0, OT = (t) => R5(t === !0) || t === "id", Wm = ({ children: t, id: e, inherit: n = !0 }) => {
  const i = Wt(ow), r = Wt($T), [a, o] = ET(), s = Oe(null), l = i.id || r;
  s.current === null && (OT(n) && l && (e = e ? l + "-" + e : l), s.current = {
    id: e,
    group: R5(n) && i.group || yw()
  });
  const c = ve(() => ({ ...s.current, forceRender: a }), [o]);
  return d(ow.Provider, { value: c, children: t });
};
function j5(t) {
  const e = zd(() => c$(t)), { isStatic: n } = Wt(u$);
  if (n) {
    const [, i] = q(t);
    le(() => e.on("change", i), []);
  }
  return e;
}
function F5(t, e) {
  const n = j5(e()), i = () => n.set(e());
  return i(), A4(() => {
    const r = () => L4.preRender(i, !1, !0), a = t.map((o) => o.on("change", r));
    return () => {
      a.forEach((o) => o()), f$(i);
    };
  }), n;
}
function WT(t) {
  zh.current = [], t();
  const e = F5(zh.current, t);
  return zh.current = void 0, e;
}
function AT(...t) {
  const e = !Array.isArray(t[0]), n = e ? 0 : -1, i = t[0 + n], r = t[1 + n], a = t[2 + n], o = t[3 + n], s = m$(r, a, o);
  return e ? s(i) : s;
}
function LT(t, e, n, i) {
  if (typeof t == "function")
    return WT(t);
  const r = typeof e == "function" ? e : AT(e, n, i);
  return Array.isArray(t) ? vw(t, r) : vw([t], ([a]) => r(a));
}
function vw(t, e) {
  const n = zd(() => []);
  return F5(t, () => {
    n.length = 0;
    const i = t.length;
    for (let r = 0; r < i; r++)
      n[r] = t[r].get();
    return e(n);
  });
}
class IT {
  constructor() {
    this.componentControls = /* @__PURE__ */ new Set();
  }
  /**
   * Subscribe a component's internal `VisualElementDragControls` to the user-facing API.
   *
   * @internal
   */
  subscribe(e) {
    return this.componentControls.add(e), () => this.componentControls.delete(e);
  }
  /**
   * Start a drag gesture on every `motion` component that has this set of drag controls
   * passed into it via the `dragControls` prop.
   *
   * ```jsx
   * dragControls.start(e, {
   *   snapToCursor: true
   * })
   * ```
   *
   * @param event - PointerEvent
   * @param options - Options
   *
   * @public
   */
  start(e, n) {
    this.componentControls.forEach((i) => {
      i.start(e.nativeEvent || e, n);
    });
  }
}
const RT = () => new IT();
function jT() {
  return zd(RT);
}
const z5 = hn(null);
function FT(t, e, n, i) {
  if (!i)
    return t;
  const r = t.findIndex((u) => u.value === e);
  if (r === -1)
    return t;
  const a = i > 0 ? 1 : -1, o = t[r + a];
  if (!o)
    return t;
  const s = t[r], l = o.layout, c = h$(l.min, l.max, 0.5);
  return a === 1 && s.layout.max + n > c || a === -1 && s.layout.min + n < c ? p$(t, r, r + a) : t;
}
function zT({ children: t, as: e = "ul", axis: n = "y", onReorder: i, values: r, ...a }, o) {
  const s = zd(() => re[e]), l = [], c = Oe(!1);
  I4(!!r, "Reorder.Group must be provided a values prop");
  const u = {
    axis: n,
    registerItem: (f, m) => {
      const h = l.findIndex((p) => f === p.value);
      h !== -1 ? l[h].layout = m[n] : l.push({ value: f, layout: m[n] }), l.sort(HT);
    },
    updateOrder: (f, m, h) => {
      if (c.current)
        return;
      const p = FT(l, f, m, h);
      l !== p && (c.current = !0, i(p.map(VT).filter((g) => r.indexOf(g) !== -1)));
    }
  };
  return le(() => {
    c.current = !1;
  }), d(s, { ...a, ref: o, ignoreStrict: !0, children: d(z5.Provider, { value: u, children: t }) });
}
const bw = /* @__PURE__ */ X(zT);
function VT(t) {
  return t.value;
}
function HT(t, e) {
  return t.layout.min - e.layout.min;
}
function ww(t, e = 0) {
  return g$(t) ? t : j5(e);
}
function BT({ children: t, style: e = {}, value: n, as: i = "li", onDrag: r, layout: a = !0, ...o }, s) {
  const l = zd(() => re[i]), c = Wt(z5), u = {
    x: ww(e.x),
    y: ww(e.y)
  }, f = LT([u.x, u.y], ([g, y]) => g || y ? 1 : "unset");
  I4(!!c, "Reorder.Item must be a child of Reorder.Group");
  const { axis: m, registerItem: h, updateOrder: p } = c;
  return d(l, { drag: m, ...o, dragSnapToOrigin: !0, style: { ...e, x: u.x, y: u.y, zIndex: f }, layout: a, onDrag: (g, y) => {
    const { velocity: v } = y;
    v[m] && p(n, u[m].get(), v[m]), r && r(g, y);
  }, onLayoutMeasure: (g) => h(n, g), ref: s, ignoreStrict: !0, children: t });
}
const V5 = /* @__PURE__ */ X(BT);
var qT = ["cx", "cy", "innerRadius", "outerRadius", "gridType", "radialLines"];
function od(t) {
  "@babel/helpers - typeof";
  return od = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, od(t);
}
function GT(t, e) {
  if (t == null) return {};
  var n = XT(t, e), i, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (r = 0; r < a.length; r++)
      i = a[r], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
function XT(t, e) {
  if (t == null) return {};
  var n = {};
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      if (e.indexOf(i) >= 0) continue;
      n[i] = t[i];
    }
  return n;
}
function jr() {
  return jr = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, jr.apply(this, arguments);
}
function kw(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function sd(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? kw(Object(n), !0).forEach(function(i) {
      YT(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : kw(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function YT(t, e, n) {
  return e = KT(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function KT(t) {
  var e = UT(t, "string");
  return od(e) == "symbol" ? e : e + "";
}
function UT(t, e) {
  if (od(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e);
    if (od(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
var JT = function(e, n, i, r) {
  var a = "";
  return r.forEach(function(o, s) {
    var l = id(n, i, e, o);
    s ? a += "L ".concat(l.x, ",").concat(l.y) : a += "M ".concat(l.x, ",").concat(l.y);
  }), a += "Z", a;
}, QT = function(e) {
  var n = e.cx, i = e.cy, r = e.innerRadius, a = e.outerRadius, o = e.polarAngles, s = e.radialLines;
  if (!o || !o.length || !s)
    return null;
  var l = sd({
    stroke: "#ccc"
  }, ds(e, !1));
  return /* @__PURE__ */ H.createElement("g", {
    className: "recharts-polar-grid-angle"
  }, o.map(function(c) {
    var u = id(n, i, r, c), f = id(n, i, a, c);
    return /* @__PURE__ */ H.createElement("line", jr({}, l, {
      key: "line-".concat(c),
      x1: u.x,
      y1: u.y,
      x2: f.x,
      y2: f.y
    }));
  }));
}, ZT = function(e) {
  var n = e.cx, i = e.cy, r = e.radius, a = e.index, o = sd(sd({
    stroke: "#ccc"
  }, ds(e, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ H.createElement("circle", jr({}, o, {
    className: Hu("recharts-polar-grid-concentric-circle", e.className),
    key: "circle-".concat(a),
    cx: n,
    cy: i,
    r
  }));
}, eO = function(e) {
  var n = e.radius, i = e.index, r = sd(sd({
    stroke: "#ccc"
  }, ds(e, !1)), {}, {
    fill: "none"
  });
  return /* @__PURE__ */ H.createElement("path", jr({}, r, {
    className: Hu("recharts-polar-grid-concentric-polygon", e.className),
    key: "path-".concat(i),
    d: JT(n, e.cx, e.cy, e.polarAngles)
  }));
}, tO = function(e) {
  var n = e.polarRadius, i = e.gridType;
  return !n || !n.length ? null : /* @__PURE__ */ H.createElement("g", {
    className: "recharts-polar-grid-concentric"
  }, n.map(function(r, a) {
    var o = a;
    return i === "circle" ? /* @__PURE__ */ H.createElement(ZT, jr({
      key: o
    }, e, {
      radius: r,
      index: a
    })) : /* @__PURE__ */ H.createElement(eO, jr({
      key: o
    }, e, {
      radius: r,
      index: a
    }));
  }));
}, H5 = function(e) {
  var n = e.cx, i = n === void 0 ? 0 : n, r = e.cy, a = r === void 0 ? 0 : r, o = e.innerRadius, s = o === void 0 ? 0 : o, l = e.outerRadius, c = l === void 0 ? 0 : l, u = e.gridType, f = u === void 0 ? "polygon" : u, m = e.radialLines, h = m === void 0 ? !0 : m, p = GT(e, qT);
  return c <= 0 ? null : /* @__PURE__ */ H.createElement("g", {
    className: "recharts-polar-grid"
  }, /* @__PURE__ */ H.createElement(QT, jr({
    cx: i,
    cy: a,
    innerRadius: s,
    outerRadius: c,
    gridType: f,
    radialLines: h
  }, p)), /* @__PURE__ */ H.createElement(tO, jr({
    cx: i,
    cy: a,
    innerRadius: s,
    outerRadius: c,
    gridType: f,
    radialLines: h
  }, p)));
};
H5.displayName = "PolarGrid";
var Hh, xw;
function nO() {
  if (xw) return Hh;
  xw = 1;
  function t(e) {
    return e && e.length ? e[0] : void 0;
  }
  return Hh = t, Hh;
}
var Bh, _w;
function iO() {
  return _w || (_w = 1, Bh = nO()), Bh;
}
var rO = iO();
const aO = /* @__PURE__ */ y$(rO);
var oO = ["key"];
function bs(t) {
  "@babel/helpers - typeof";
  return bs = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, bs(t);
}
function sO(t, e) {
  if (t == null) return {};
  var n = lO(t, e), i, r;
  if (Object.getOwnPropertySymbols) {
    var a = Object.getOwnPropertySymbols(t);
    for (r = 0; r < a.length; r++)
      i = a[r], !(e.indexOf(i) >= 0) && Object.prototype.propertyIsEnumerable.call(t, i) && (n[i] = t[i]);
  }
  return n;
}
function lO(t, e) {
  if (t == null) return {};
  var n = {};
  for (var i in t)
    if (Object.prototype.hasOwnProperty.call(t, i)) {
      if (e.indexOf(i) >= 0) continue;
      n[i] = t[i];
    }
  return n;
}
function Xu() {
  return Xu = Object.assign ? Object.assign.bind() : function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var n = arguments[e];
      for (var i in n)
        Object.prototype.hasOwnProperty.call(n, i) && (t[i] = n[i]);
    }
    return t;
  }, Xu.apply(this, arguments);
}
function Mw(t, e) {
  var n = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var i = Object.getOwnPropertySymbols(t);
    e && (i = i.filter(function(r) {
      return Object.getOwnPropertyDescriptor(t, r).enumerable;
    })), n.push.apply(n, i);
  }
  return n;
}
function Tn(t) {
  for (var e = 1; e < arguments.length; e++) {
    var n = arguments[e] != null ? arguments[e] : {};
    e % 2 ? Mw(Object(n), !0).forEach(function(i) {
      $r(t, i, n[i]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(n)) : Mw(Object(n)).forEach(function(i) {
      Object.defineProperty(t, i, Object.getOwnPropertyDescriptor(n, i));
    });
  }
  return t;
}
function dO(t, e) {
  if (!(t instanceof e))
    throw new TypeError("Cannot call a class as a function");
}
function Cw(t, e) {
  for (var n = 0; n < e.length; n++) {
    var i = e[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, q5(i.key), i);
  }
}
function cO(t, e, n) {
  return e && Cw(t.prototype, e), n && Cw(t, n), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
function uO(t, e, n) {
  return e = Yu(e), fO(t, B5() ? Reflect.construct(e, n || [], Yu(t).constructor) : e.apply(t, n));
}
function fO(t, e) {
  if (e && (bs(e) === "object" || typeof e == "function"))
    return e;
  if (e !== void 0)
    throw new TypeError("Derived constructors may only return object or undefined");
  return mO(t);
}
function mO(t) {
  if (t === void 0)
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function B5() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {
    }));
  } catch {
  }
  return (B5 = function() {
    return !!t;
  })();
}
function Yu(t) {
  return Yu = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(n) {
    return n.__proto__ || Object.getPrototypeOf(n);
  }, Yu(t);
}
function hO(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && $p(t, e);
}
function $p(t, e) {
  return $p = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(i, r) {
    return i.__proto__ = r, i;
  }, $p(t, e);
}
function $r(t, e, n) {
  return e = q5(e), e in t ? Object.defineProperty(t, e, { value: n, enumerable: !0, configurable: !0, writable: !0 }) : t[e] = n, t;
}
function q5(t) {
  var e = pO(t, "string");
  return bs(e) == "symbol" ? e : e + "";
}
function pO(t, e) {
  if (bs(t) != "object" || !t) return t;
  var n = t[Symbol.toPrimitive];
  if (n !== void 0) {
    var i = n.call(t, e);
    if (bs(i) != "object") return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return String(t);
}
var nc = /* @__PURE__ */ function(t) {
  function e() {
    var n;
    dO(this, e);
    for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++)
      r[a] = arguments[a];
    return n = uO(this, e, [].concat(r)), $r(n, "state", {
      isAnimationFinished: !1
    }), $r(n, "handleAnimationEnd", function() {
      var o = n.props.onAnimationEnd;
      n.setState({
        isAnimationFinished: !0
      }), Ic(o) && o();
    }), $r(n, "handleAnimationStart", function() {
      var o = n.props.onAnimationStart;
      n.setState({
        isAnimationFinished: !1
      }), Ic(o) && o();
    }), $r(n, "handleMouseEnter", function(o) {
      var s = n.props.onMouseEnter;
      s && s(n.props, o);
    }), $r(n, "handleMouseLeave", function(o) {
      var s = n.props.onMouseLeave;
      s && s(n.props, o);
    }), n;
  }
  return hO(e, t), cO(e, [{
    key: "renderDots",
    value: function(i) {
      var r = this.props, a = r.dot, o = r.dataKey, s = ds(this.props, !1), l = ds(a, !0), c = i.map(function(u, f) {
        var m = Tn(Tn(Tn({
          key: "dot-".concat(f),
          r: 3
        }, s), l), {}, {
          dataKey: o,
          cx: u.x,
          cy: u.y,
          index: f,
          payload: u
        });
        return e.renderDotItem(a, m);
      });
      return /* @__PURE__ */ H.createElement(Vh, {
        className: "recharts-radar-dots"
      }, c);
    }
  }, {
    key: "renderPolygonStatically",
    value: function(i) {
      var r = this.props, a = r.shape, o = r.dot, s = r.isRange, l = r.baseLinePoints, c = r.connectNulls, u;
      return /* @__PURE__ */ H.isValidElement(a) ? u = /* @__PURE__ */ H.cloneElement(a, Tn(Tn({}, this.props), {}, {
        points: i
      })) : Ic(a) ? u = a(Tn(Tn({}, this.props), {}, {
        points: i
      })) : u = /* @__PURE__ */ H.createElement(b$, Xu({}, ds(this.props, !0), {
        onMouseEnter: this.handleMouseEnter,
        onMouseLeave: this.handleMouseLeave,
        points: i,
        baseLinePoints: s ? l : null,
        connectNulls: c
      })), /* @__PURE__ */ H.createElement(Vh, {
        className: "recharts-radar-polygon"
      }, u, o ? this.renderDots(i) : null);
    }
  }, {
    key: "renderPolygonWithAnimation",
    value: function() {
      var i = this, r = this.props, a = r.points, o = r.isAnimationActive, s = r.animationBegin, l = r.animationDuration, c = r.animationEasing, u = r.animationId, f = this.state.prevPoints;
      return /* @__PURE__ */ H.createElement(w$, {
        begin: s,
        duration: l,
        isActive: o,
        easing: c,
        from: {
          t: 0
        },
        to: {
          t: 1
        },
        key: "radar-".concat(u),
        onAnimationEnd: this.handleAnimationEnd,
        onAnimationStart: this.handleAnimationStart
      }, function(m) {
        var h = m.t, p = f && f.length / a.length, g = a.map(function(y, v) {
          var w = f && f[Math.floor(v * p)];
          if (w) {
            var x = Rc(w.x, y.x), b = Rc(w.y, y.y);
            return Tn(Tn({}, y), {}, {
              x: x(h),
              y: b(h)
            });
          }
          var M = Rc(y.cx, y.x), _ = Rc(y.cy, y.y);
          return Tn(Tn({}, y), {}, {
            x: M(h),
            y: _(h)
          });
        });
        return i.renderPolygonStatically(g);
      });
    }
  }, {
    key: "renderPolygon",
    value: function() {
      var i = this.props, r = i.points, a = i.isAnimationActive, o = i.isRange, s = this.state.prevPoints;
      return a && r && r.length && !o && (!s || !k$(s, r)) ? this.renderPolygonWithAnimation() : this.renderPolygonStatically(r);
    }
  }, {
    key: "render",
    value: function() {
      var i = this.props, r = i.hide, a = i.className, o = i.points, s = i.isAnimationActive;
      if (r || !o || !o.length)
        return null;
      var l = this.state.isAnimationFinished, c = Hu("recharts-radar", a);
      return /* @__PURE__ */ H.createElement(Vh, {
        className: c
      }, this.renderPolygon(), (!s || l) && x$.renderCallByParent(this.props, o));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function(i, r) {
      return i.animationId !== r.prevAnimationId ? {
        prevAnimationId: i.animationId,
        curPoints: i.points,
        prevPoints: r.curPoints
      } : i.points !== r.curPoints ? {
        curPoints: i.points
      } : null;
    }
  }, {
    key: "renderDotItem",
    value: function(i, r) {
      var a;
      if (/* @__PURE__ */ H.isValidElement(i))
        a = /* @__PURE__ */ H.cloneElement(i, r);
      else if (Ic(i))
        a = i(r);
      else {
        var o = r.key, s = sO(r, oO);
        a = /* @__PURE__ */ H.createElement(v$, Xu({}, s, {
          key: o,
          className: Hu("recharts-radar-dot", typeof i != "boolean" ? i.className : "")
        }));
      }
      return a;
    }
  }]);
}(ND);
$r(nc, "displayName", "Radar");
$r(nc, "defaultProps", {
  angleAxisId: 0,
  radiusAxisId: 0,
  hide: !1,
  activeDot: !0,
  dot: !1,
  legendType: "rect",
  isAnimationActive: !_$.isSsr,
  animationBegin: 0,
  animationDuration: 1500,
  animationEasing: "ease"
});
$r(nc, "getComposedData", function(t) {
  var e = t.radiusAxis, n = t.angleAxis, i = t.displayedData, r = t.dataKey, a = t.bandSize, o = n.cx, s = n.cy, l = !1, c = [], u = n.type !== "number" ? a ?? 0 : 0;
  i.forEach(function(m, h) {
    var p = sw(m, n.dataKey, h), g = sw(m, r), y = n.scale(p) + u, v = Array.isArray(g) ? M$(g) : g, w = lw(v) ? void 0 : e.scale(v);
    Array.isArray(g) && g.length >= 2 && (l = !0), c.push(Tn(Tn({}, id(o, s, w, y)), {}, {
      name: p,
      value: g,
      cx: o,
      cy: s,
      radius: w,
      angle: y,
      payload: m
    }));
  });
  var f = [];
  return l && c.forEach(function(m) {
    if (Array.isArray(m.value)) {
      var h = aO(m.value), p = lw(h) ? void 0 : e.scale(h);
      f.push(Tn(Tn({}, m), {}, {
        radius: p
      }, id(o, s, p, m.angle)));
    } else
      f.push(m);
  }), {
    points: c,
    isRange: l,
    baseLinePoints: f
  };
});
var gO = C$({
  chartName: "RadarChart",
  GraphicalChild: nc,
  axisComponents: [{
    axisType: "angleAxis",
    AxisComp: R4
  }, {
    axisType: "radiusAxis",
    AxisComp: j4
  }],
  formatAxisMap: P$,
  defaultProps: {
    layout: "centric",
    startAngle: 90,
    endAngle: -270,
    cx: "50%",
    cy: "50%",
    innerRadius: 0,
    outerRadius: "80%"
  }
});
const yO = ({ data: t, dataConfig: e, scaleMin: n, scaleMax: i, aspect: r }, a) => {
  const o = Object.keys(e), s = t.map((l) => ({
    subject: l.label,
    ...l.values
  }));
  return /* @__PURE__ */ d(
    N$,
    {
      config: e,
      ref: a,
      aspect: r,
      "data-chromatic": "ignore",
      children: /* @__PURE__ */ k(gO, { accessibilityLayer: !0, data: s, children: [
        /* @__PURE__ */ d(
          $$,
          {
            cursor: !0,
            content: /* @__PURE__ */ d(D$, { indicator: "dot" })
          }
        ),
        /* @__PURE__ */ d(H5, { gridType: "circle" }),
        /* @__PURE__ */ d(R4, { dataKey: "subject" }),
        /* @__PURE__ */ d(
          j4,
          {
            angle: 90,
            type: "number",
            domain: [n ?? "dataMin", i ?? "dataMax"]
          }
        ),
        o.map((l, c) => /* @__PURE__ */ d(
          nc,
          {
            dataKey: l,
            fill: e[l].color || dw(c),
            stroke: e[l].color || dw(c),
            strokeWidth: 1.5,
            fillOpacity: 0.3,
            label: e[l].label,
            isAnimationActive: !1
          },
          l
        )),
        Object.keys(e).length > 1 && /* @__PURE__ */ d(E$, { iconType: "star", content: /* @__PURE__ */ d(T$, {}) })
      ] })
    }
  );
}, jXe = S$(yO);
function Fo(t, e, n) {
  let i = n.initialDeps ?? [], r;
  function a() {
    var o, s, l, c;
    let u;
    n.key && ((o = n.debug) != null && o.call(n)) && (u = Date.now());
    const f = t();
    if (!(f.length !== i.length || f.some((p, g) => i[g] !== p)))
      return r;
    i = f;
    let h;
    if (n.key && ((s = n.debug) != null && s.call(n)) && (h = Date.now()), r = e(...f), n.key && ((l = n.debug) != null && l.call(n))) {
      const p = Math.round((Date.now() - u) * 100) / 100, g = Math.round((Date.now() - h) * 100) / 100, y = g / 16, v = (w, x) => {
        for (w = String(w); w.length < x; )
          w = " " + w;
        return w;
      };
      console.info(
        `%c⏱ ${v(g, 5)} /${v(p, 5)} ms`,
        `
            font-size: .6rem;
            font-weight: bold;
            color: hsl(${Math.max(
          0,
          Math.min(120 - 120 * y, 120)
        )}deg 100% 31%);`,
        n == null ? void 0 : n.key
      );
    }
    return (c = n == null ? void 0 : n.onChange) == null || c.call(n, r), r;
  }
  return a.updateDeps = (o) => {
    i = o;
  }, a;
}
function qh(t, e) {
  if (t === void 0)
    throw new Error("Unexpected undefined");
  return t;
}
const vO = (t, e) => Math.abs(t - e) < 1, bO = (t, e, n) => {
  let i;
  return function(...r) {
    t.clearTimeout(i), i = t.setTimeout(() => e.apply(this, r), n);
  };
}, wO = (t) => t, kO = (t) => {
  const e = Math.max(t.startIndex - t.overscan, 0), n = Math.min(t.endIndex + t.overscan, t.count - 1), i = [];
  for (let r = e; r <= n; r++)
    i.push(r);
  return i;
}, xO = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const i = t.targetWindow;
  if (!i)
    return;
  const r = (o) => {
    const { width: s, height: l } = o;
    e({ width: Math.round(s), height: Math.round(l) });
  };
  if (r(n.getBoundingClientRect()), !i.ResizeObserver)
    return () => {
    };
  const a = new i.ResizeObserver((o) => {
    const s = () => {
      const l = o[0];
      if (l != null && l.borderBoxSize) {
        const c = l.borderBoxSize[0];
        if (c) {
          r({ width: c.inlineSize, height: c.blockSize });
          return;
        }
      }
      r(n.getBoundingClientRect());
    };
    t.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(s) : s();
  });
  return a.observe(n, { box: "border-box" }), () => {
    a.unobserve(n);
  };
}, Pw = {
  passive: !0
}, Sw = typeof window > "u" ? !0 : "onscrollend" in window, _O = (t, e) => {
  const n = t.scrollElement;
  if (!n)
    return;
  const i = t.targetWindow;
  if (!i)
    return;
  let r = 0;
  const a = t.options.useScrollendEvent && Sw ? () => {
  } : bO(
    i,
    () => {
      e(r, !1);
    },
    t.options.isScrollingResetDelay
  ), o = (u) => () => {
    const { horizontal: f, isRtl: m } = t.options;
    r = f ? n.scrollLeft * (m && -1 || 1) : n.scrollTop, a(), e(r, u);
  }, s = o(!0), l = o(!1);
  l(), n.addEventListener("scroll", s, Pw);
  const c = t.options.useScrollendEvent && Sw;
  return c && n.addEventListener("scrollend", l, Pw), () => {
    n.removeEventListener("scroll", s), c && n.removeEventListener("scrollend", l);
  };
}, MO = (t, e, n) => {
  if (e != null && e.borderBoxSize) {
    const i = e.borderBoxSize[0];
    if (i)
      return Math.round(
        i[n.options.horizontal ? "inlineSize" : "blockSize"]
      );
  }
  return Math.round(
    t.getBoundingClientRect()[n.options.horizontal ? "width" : "height"]
  );
}, CO = (t, {
  adjustments: e = 0,
  behavior: n
}, i) => {
  var r, a;
  const o = t + e;
  (a = (r = i.scrollElement) == null ? void 0 : r.scrollTo) == null || a.call(r, {
    [i.options.horizontal ? "left" : "top"]: o,
    behavior: n
  });
};
class PO {
  constructor(e) {
    this.unsubs = [], this.scrollElement = null, this.targetWindow = null, this.isScrolling = !1, this.scrollToIndexTimeoutId = null, this.measurementsCache = [], this.itemSizeCache = /* @__PURE__ */ new Map(), this.pendingMeasuredCacheIndexes = [], this.scrollRect = null, this.scrollOffset = null, this.scrollDirection = null, this.scrollAdjustments = 0, this.elementsCache = /* @__PURE__ */ new Map(), this.observer = /* @__PURE__ */ (() => {
      let n = null;
      const i = () => n || (!this.targetWindow || !this.targetWindow.ResizeObserver ? null : n = new this.targetWindow.ResizeObserver((r) => {
        r.forEach((a) => {
          const o = () => {
            this._measureElement(a.target, a);
          };
          this.options.useAnimationFrameWithResizeObserver ? requestAnimationFrame(o) : o();
        });
      }));
      return {
        disconnect: () => {
          var r;
          (r = i()) == null || r.disconnect(), n = null;
        },
        observe: (r) => {
          var a;
          return (a = i()) == null ? void 0 : a.observe(r, { box: "border-box" });
        },
        unobserve: (r) => {
          var a;
          return (a = i()) == null ? void 0 : a.unobserve(r);
        }
      };
    })(), this.range = null, this.setOptions = (n) => {
      Object.entries(n).forEach(([i, r]) => {
        typeof r > "u" && delete n[i];
      }), this.options = {
        debug: !1,
        initialOffset: 0,
        overscan: 1,
        paddingStart: 0,
        paddingEnd: 0,
        scrollPaddingStart: 0,
        scrollPaddingEnd: 0,
        horizontal: !1,
        getItemKey: wO,
        rangeExtractor: kO,
        onChange: () => {
        },
        measureElement: MO,
        initialRect: { width: 0, height: 0 },
        scrollMargin: 0,
        gap: 0,
        indexAttribute: "data-index",
        initialMeasurementsCache: [],
        lanes: 1,
        isScrollingResetDelay: 150,
        enabled: !0,
        isRtl: !1,
        useScrollendEvent: !1,
        useAnimationFrameWithResizeObserver: !1,
        ...n
      };
    }, this.notify = (n) => {
      var i, r;
      (r = (i = this.options).onChange) == null || r.call(i, this, n);
    }, this.maybeNotify = Fo(
      () => (this.calculateRange(), [
        this.isScrolling,
        this.range ? this.range.startIndex : null,
        this.range ? this.range.endIndex : null
      ]),
      (n) => {
        this.notify(n);
      },
      {
        key: process.env.NODE_ENV !== "production" && "maybeNotify",
        debug: () => this.options.debug,
        initialDeps: [
          this.isScrolling,
          this.range ? this.range.startIndex : null,
          this.range ? this.range.endIndex : null
        ]
      }
    ), this.cleanup = () => {
      this.unsubs.filter(Boolean).forEach((n) => n()), this.unsubs = [], this.observer.disconnect(), this.scrollElement = null, this.targetWindow = null;
    }, this._didMount = () => () => {
      this.cleanup();
    }, this._willUpdate = () => {
      var n;
      const i = this.options.enabled ? this.options.getScrollElement() : null;
      if (this.scrollElement !== i) {
        if (this.cleanup(), !i) {
          this.maybeNotify();
          return;
        }
        this.scrollElement = i, this.scrollElement && "ownerDocument" in this.scrollElement ? this.targetWindow = this.scrollElement.ownerDocument.defaultView : this.targetWindow = ((n = this.scrollElement) == null ? void 0 : n.window) ?? null, this.elementsCache.forEach((r) => {
          this.observer.observe(r);
        }), this._scrollToOffset(this.getScrollOffset(), {
          adjustments: void 0,
          behavior: void 0
        }), this.unsubs.push(
          this.options.observeElementRect(this, (r) => {
            this.scrollRect = r, this.maybeNotify();
          })
        ), this.unsubs.push(
          this.options.observeElementOffset(this, (r, a) => {
            this.scrollAdjustments = 0, this.scrollDirection = a ? this.getScrollOffset() < r ? "forward" : "backward" : null, this.scrollOffset = r, this.isScrolling = a, this.maybeNotify();
          })
        );
      }
    }, this.getSize = () => this.options.enabled ? (this.scrollRect = this.scrollRect ?? this.options.initialRect, this.scrollRect[this.options.horizontal ? "width" : "height"]) : (this.scrollRect = null, 0), this.getScrollOffset = () => this.options.enabled ? (this.scrollOffset = this.scrollOffset ?? (typeof this.options.initialOffset == "function" ? this.options.initialOffset() : this.options.initialOffset), this.scrollOffset) : (this.scrollOffset = null, 0), this.getFurthestMeasurement = (n, i) => {
      const r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
      for (let o = i - 1; o >= 0; o--) {
        const s = n[o];
        if (r.has(s.lane))
          continue;
        const l = a.get(
          s.lane
        );
        if (l == null || s.end > l.end ? a.set(s.lane, s) : s.end < l.end && r.set(s.lane, !0), r.size === this.options.lanes)
          break;
      }
      return a.size === this.options.lanes ? Array.from(a.values()).sort((o, s) => o.end === s.end ? o.index - s.index : o.end - s.end)[0] : void 0;
    }, this.getMeasurementOptions = Fo(
      () => [
        this.options.count,
        this.options.paddingStart,
        this.options.scrollMargin,
        this.options.getItemKey,
        this.options.enabled
      ],
      (n, i, r, a, o) => (this.pendingMeasuredCacheIndexes = [], {
        count: n,
        paddingStart: i,
        scrollMargin: r,
        getItemKey: a,
        enabled: o
      }),
      {
        key: !1
      }
    ), this.getMeasurements = Fo(
      () => [this.getMeasurementOptions(), this.itemSizeCache],
      ({ count: n, paddingStart: i, scrollMargin: r, getItemKey: a, enabled: o }, s) => {
        if (!o)
          return this.measurementsCache = [], this.itemSizeCache.clear(), [];
        this.measurementsCache.length === 0 && (this.measurementsCache = this.options.initialMeasurementsCache, this.measurementsCache.forEach((u) => {
          this.itemSizeCache.set(u.key, u.size);
        }));
        const l = this.pendingMeasuredCacheIndexes.length > 0 ? Math.min(...this.pendingMeasuredCacheIndexes) : 0;
        this.pendingMeasuredCacheIndexes = [];
        const c = this.measurementsCache.slice(0, l);
        for (let u = l; u < n; u++) {
          const f = a(u), m = this.options.lanes === 1 ? c[u - 1] : this.getFurthestMeasurement(c, u), h = m ? m.end + this.options.gap : i + r, p = s.get(f), g = typeof p == "number" ? p : this.options.estimateSize(u), y = h + g, v = m ? m.lane : u % this.options.lanes;
          c[u] = {
            index: u,
            start: h,
            size: g,
            end: y,
            key: f,
            lane: v
          };
        }
        return this.measurementsCache = c, c;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getMeasurements",
        debug: () => this.options.debug
      }
    ), this.calculateRange = Fo(
      () => [
        this.getMeasurements(),
        this.getSize(),
        this.getScrollOffset(),
        this.options.lanes
      ],
      (n, i, r, a) => this.range = n.length > 0 && i > 0 ? SO({
        measurements: n,
        outerSize: i,
        scrollOffset: r,
        lanes: a
      }) : null,
      {
        key: process.env.NODE_ENV !== "production" && "calculateRange",
        debug: () => this.options.debug
      }
    ), this.getVirtualIndexes = Fo(
      () => {
        let n = null, i = null;
        const r = this.calculateRange();
        return r && (n = r.startIndex, i = r.endIndex), this.maybeNotify.updateDeps([this.isScrolling, n, i]), [
          this.options.rangeExtractor,
          this.options.overscan,
          this.options.count,
          n,
          i
        ];
      },
      (n, i, r, a, o) => a === null || o === null ? [] : n({
        startIndex: a,
        endIndex: o,
        overscan: i,
        count: r
      }),
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualIndexes",
        debug: () => this.options.debug
      }
    ), this.indexFromElement = (n) => {
      const i = this.options.indexAttribute, r = n.getAttribute(i);
      return r ? parseInt(r, 10) : (console.warn(
        `Missing attribute name '${i}={index}' on measured element.`
      ), -1);
    }, this._measureElement = (n, i) => {
      const r = this.indexFromElement(n), a = this.measurementsCache[r];
      if (!a)
        return;
      const o = a.key, s = this.elementsCache.get(o);
      s !== n && (s && this.observer.unobserve(s), this.observer.observe(n), this.elementsCache.set(o, n)), n.isConnected && this.resizeItem(r, this.options.measureElement(n, i, this));
    }, this.resizeItem = (n, i) => {
      const r = this.measurementsCache[n];
      if (!r)
        return;
      const a = this.itemSizeCache.get(r.key) ?? r.size, o = i - a;
      o !== 0 && ((this.shouldAdjustScrollPositionOnItemSizeChange !== void 0 ? this.shouldAdjustScrollPositionOnItemSizeChange(r, o, this) : r.start < this.getScrollOffset() + this.scrollAdjustments) && (process.env.NODE_ENV !== "production" && this.options.debug && console.info("correction", o), this._scrollToOffset(this.getScrollOffset(), {
        adjustments: this.scrollAdjustments += o,
        behavior: void 0
      })), this.pendingMeasuredCacheIndexes.push(r.index), this.itemSizeCache = new Map(this.itemSizeCache.set(r.key, i)), this.notify(!1));
    }, this.measureElement = (n) => {
      if (!n) {
        this.elementsCache.forEach((i, r) => {
          i.isConnected || (this.observer.unobserve(i), this.elementsCache.delete(r));
        });
        return;
      }
      this._measureElement(n, void 0);
    }, this.getVirtualItems = Fo(
      () => [this.getVirtualIndexes(), this.getMeasurements()],
      (n, i) => {
        const r = [];
        for (let a = 0, o = n.length; a < o; a++) {
          const s = n[a], l = i[s];
          r.push(l);
        }
        return r;
      },
      {
        key: process.env.NODE_ENV !== "production" && "getVirtualItems",
        debug: () => this.options.debug
      }
    ), this.getVirtualItemForOffset = (n) => {
      const i = this.getMeasurements();
      if (i.length !== 0)
        return qh(
          i[G5(
            0,
            i.length - 1,
            (r) => qh(i[r]).start,
            n
          )]
        );
    }, this.getOffsetForAlignment = (n, i, r = 0) => {
      const a = this.getSize(), o = this.getScrollOffset();
      i === "auto" && (i = n >= o + a ? "end" : "start"), i === "center" ? n += (r - a) / 2 : i === "end" && (n -= a);
      const s = this.options.horizontal ? "scrollWidth" : "scrollHeight", c = (this.scrollElement ? "document" in this.scrollElement ? this.scrollElement.document.documentElement[s] : this.scrollElement[s] : 0) - a;
      return Math.max(Math.min(c, n), 0);
    }, this.getOffsetForIndex = (n, i = "auto") => {
      n = Math.max(0, Math.min(n, this.options.count - 1));
      const r = this.measurementsCache[n];
      if (!r)
        return;
      const a = this.getSize(), o = this.getScrollOffset();
      if (i === "auto")
        if (r.end >= o + a - this.options.scrollPaddingEnd)
          i = "end";
        else if (r.start <= o + this.options.scrollPaddingStart)
          i = "start";
        else
          return [o, i];
      const s = i === "end" ? r.end + this.options.scrollPaddingEnd : r.start - this.options.scrollPaddingStart;
      return [
        this.getOffsetForAlignment(s, i, r.size),
        i
      ];
    }, this.isDynamicMode = () => this.elementsCache.size > 0, this.cancelScrollToIndex = () => {
      this.scrollToIndexTimeoutId !== null && this.targetWindow && (this.targetWindow.clearTimeout(this.scrollToIndexTimeoutId), this.scrollToIndexTimeoutId = null);
    }, this.scrollToOffset = (n, { align: i = "start", behavior: r } = {}) => {
      this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getOffsetForAlignment(n, i), {
        adjustments: void 0,
        behavior: r
      });
    }, this.scrollToIndex = (n, { align: i = "auto", behavior: r } = {}) => {
      n = Math.max(0, Math.min(n, this.options.count - 1)), this.cancelScrollToIndex(), r === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      );
      const a = this.getOffsetForIndex(n, i);
      if (!a) return;
      const [o, s] = a;
      this._scrollToOffset(o, { adjustments: void 0, behavior: r }), r !== "smooth" && this.isDynamicMode() && this.targetWindow && (this.scrollToIndexTimeoutId = this.targetWindow.setTimeout(() => {
        if (this.scrollToIndexTimeoutId = null, this.elementsCache.has(
          this.options.getItemKey(n)
        )) {
          const [c] = qh(
            this.getOffsetForIndex(n, s)
          );
          vO(c, this.getScrollOffset()) || this.scrollToIndex(n, { align: s, behavior: r });
        } else
          this.scrollToIndex(n, { align: s, behavior: r });
      }));
    }, this.scrollBy = (n, { behavior: i } = {}) => {
      this.cancelScrollToIndex(), i === "smooth" && this.isDynamicMode() && console.warn(
        "The `smooth` scroll behavior is not fully supported with dynamic size."
      ), this._scrollToOffset(this.getScrollOffset() + n, {
        adjustments: void 0,
        behavior: i
      });
    }, this.getTotalSize = () => {
      var n;
      const i = this.getMeasurements();
      let r;
      if (i.length === 0)
        r = this.options.paddingStart;
      else if (this.options.lanes === 1)
        r = ((n = i[i.length - 1]) == null ? void 0 : n.end) ?? 0;
      else {
        const a = Array(this.options.lanes).fill(null);
        let o = i.length - 1;
        for (; o >= 0 && a.some((s) => s === null); ) {
          const s = i[o];
          a[s.lane] === null && (a[s.lane] = s.end), o--;
        }
        r = Math.max(...a.filter((s) => s !== null));
      }
      return Math.max(
        r - this.options.scrollMargin + this.options.paddingEnd,
        0
      );
    }, this._scrollToOffset = (n, {
      adjustments: i,
      behavior: r
    }) => {
      this.options.scrollToFn(n, { behavior: r, adjustments: i }, this);
    }, this.measure = () => {
      this.itemSizeCache = /* @__PURE__ */ new Map(), this.notify(!1);
    }, this.setOptions(e);
  }
}
const G5 = (t, e, n, i) => {
  for (; t <= e; ) {
    const r = (t + e) / 2 | 0, a = n(r);
    if (a < i)
      t = r + 1;
    else if (a > i)
      e = r - 1;
    else
      return r;
  }
  return t > 0 ? t - 1 : 0;
};
function SO({
  measurements: t,
  outerSize: e,
  scrollOffset: n,
  lanes: i
}) {
  const r = t.length - 1, a = (l) => t[l].start;
  if (t.length <= i)
    return {
      startIndex: 0,
      endIndex: r
    };
  let o = G5(
    0,
    r,
    a,
    n
  ), s = o;
  if (i === 1)
    for (; s < r && t[s].end < n + e; )
      s++;
  else if (i > 1) {
    const l = Array(i).fill(0);
    for (; s < r && l.some((u) => u < n + e); ) {
      const u = t[s];
      l[u.lane] = u.end, s++;
    }
    const c = Array(i).fill(n + e);
    for (; o >= 0 && c.some((u) => u >= n); ) {
      const u = t[o];
      c[u.lane] = u.start, o--;
    }
    o = Math.max(0, o - o % i), s = Math.min(r, s + (i - 1 - s % i));
  }
  return { startIndex: o, endIndex: s };
}
const Nw = typeof document < "u" ? S.useLayoutEffect : S.useEffect;
function NO(t) {
  const e = S.useReducer(() => ({}), {})[1], n = {
    ...t,
    onChange: (r, a) => {
      var o;
      a ? OD(e) : e(), (o = t.onChange) == null || o.call(t, r, a);
    }
  }, [i] = S.useState(
    () => new PO(n)
  );
  return i.setOptions(n), Nw(() => i._didMount(), []), Nw(() => i._willUpdate()), i;
}
function X5(t) {
  return NO({
    observeElementRect: xO,
    observeElementOffset: _O,
    scrollToFn: CO,
    ...t
  });
}
const Ku = X(
  ({ height: t, itemCount: e, itemSize: n, className: i, renderer: r }, a) => {
    const o = H.useRef(null);
    H.useImperativeHandle(
      a,
      () => o.current,
      []
    );
    const s = X5({
      count: e,
      getScrollElement: () => o.current,
      estimateSize: typeof n == "number" ? () => n : n,
      overscan: 5
    });
    return /* @__PURE__ */ d(
      "div",
      {
        ref: o,
        className: E("scrollbar-macos w-full overflow-auto", i),
        style: {
          height: `${t}px`
        },
        children: /* @__PURE__ */ d(
          "div",
          {
            style: {
              height: `${s.getTotalSize()}px`,
              width: "100%",
              position: "relative"
            },
            children: s.getVirtualItems().map((l) => /* @__PURE__ */ d(
              "div",
              {
                style: {
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "100%",
                  height: `${l.size}px`,
                  transform: `translateY(${l.start}px)`
                },
                children: l ? r(l) : /* @__PURE__ */ d(Ee, {})
              },
              l.key
            ))
          }
        )
      }
    );
  }
);
Ku.displayName = "VirtualList";
const $O = (t, e) => {
  if (e.disallowEmpty && t.length === 0)
    throw Error("You need to provide some text that is not empty");
  if (e.maxLength !== void 0 && t.length > e.maxLength)
    throw Error(
      `"${t}" should have no more than ${e.maxLength} characters`
    );
  if (e.minLength !== void 0 && t.length < e.minLength)
    throw Error(`"${t}" should have at least ${e.minLength} characters`);
}, To = (t, e) => {
  le(() => {
    t !== void 0 && e && $O(t, e);
  }, [t, e]);
}, Aa = X(
  ({ left: t, text: e, right: n, additionalAccesibleText: i, onClick: r, className: a }, o) => /* @__PURE__ */ k(
    "div",
    {
      ref: o,
      className: E(
        "flex flex-row items-center justify-start gap-0.5 rounded-full py-0.5 pr-2 text-base font-medium text-f1-foreground",
        r && "cursor-pointer hover:bg-f1-background-hover",
        !e && "aspect-square w-6 items-center justify-center p-1",
        t ? "pl-1" : "pl-2",
        a
      ),
      onClick: r,
      children: [
        t,
        !!e && /* @__PURE__ */ d("span", { title: e, className: "line-clamp-1", children: e }),
        i && /* @__PURE__ */ d("span", { className: "sr-only", children: i }),
        n
      ]
    }
  )
);
Aa.displayName = "BaseTag";
const Ni = X(
  ({ text: t, additionalAccesibleText: e, icon: n, noBorder: i, className: r }, a) => (To(t, { disallowEmpty: !0 }), /* @__PURE__ */ d(
    Aa,
    {
      ref: a,
      className: E(
        !i && "border-[1px] border-solid border-f1-border-secondary",
        r
      ),
      left: n ? /* @__PURE__ */ d(Cm, { icon: n, size: "sm", className: "text-f1-icon", "aria-hidden": !0 }) : null,
      text: t,
      additionalAccesibleText: e
    }
  ))
);
Ni.displayName = "RawTag";
function ic(t) {
  const e = t + "CollectionProvider", [n, i] = Wi(e), [r, a] = n(
    e,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), o = (h) => {
    const { scope: p, children: g } = h, y = H.useRef(null), v = H.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ d(r, { scope: p, itemMap: v, collectionRef: y, children: g });
  };
  o.displayName = e;
  const s = t + "CollectionSlot", l = H.forwardRef(
    (h, p) => {
      const { scope: g, children: y } = h, v = a(s, g), w = st(p, v.collectionRef);
      return /* @__PURE__ */ d(Bu, { ref: w, children: y });
    }
  );
  l.displayName = s;
  const c = t + "CollectionItemSlot", u = "data-radix-collection-item", f = H.forwardRef(
    (h, p) => {
      const { scope: g, children: y, ...v } = h, w = H.useRef(null), x = st(p, w), b = a(c, g);
      return H.useEffect(() => (b.itemMap.set(w, { ref: w, ...v }), () => void b.itemMap.delete(w))), /* @__PURE__ */ d(Bu, { [u]: "", ref: x, children: y });
    }
  );
  f.displayName = c;
  function m(h) {
    const p = a(t + "CollectionConsumer", h);
    return H.useCallback(() => {
      const y = p.collectionRef.current;
      if (!y) return [];
      const v = Array.from(y.querySelectorAll(`[${u}]`));
      return Array.from(p.itemMap.values()).sort(
        (b, M) => v.indexOf(b.ref.current) - v.indexOf(M.ref.current)
      );
    }, [p.collectionRef, p.itemMap]);
  }
  return [
    { Provider: o, Slot: l, ItemSlot: f },
    m,
    i
  ];
}
function Fy(t) {
  const e = S.useRef({ value: t, previous: t });
  return S.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
var DO = [" ", "Enter", "ArrowUp", "ArrowDown"], EO = [" ", "Enter"], rc = "Select", [Am, Lm, TO] = ic(rc), [Gs, FXe] = Wi(rc, [
  TO,
  Pm
]), Im = Pm(), [OO, La] = Gs(rc), [WO, AO] = Gs(rc), Y5 = (t) => {
  const {
    __scopeSelect: e,
    children: n,
    open: i,
    defaultOpen: r,
    onOpenChange: a,
    value: o,
    defaultValue: s,
    onValueChange: l,
    dir: c,
    name: u,
    autoComplete: f,
    disabled: m,
    required: h,
    form: p
  } = t, g = Im(e), [y, v] = S.useState(null), [w, x] = S.useState(null), [b, M] = S.useState(!1), _ = Vd(c), [N = !1, $] = Si({
    prop: i,
    defaultProp: r,
    onChange: a
  }), [D, W] = Si({
    prop: o,
    defaultProp: s,
    onChange: l
  }), j = S.useRef(null), O = y ? p || !!y.closest("form") : !0, [I, L] = S.useState(/* @__PURE__ */ new Set()), R = Array.from(I).map((B) => B.props.value).join(";");
  return /* @__PURE__ */ d(F4, { ...g, children: /* @__PURE__ */ k(
    OO,
    {
      required: h,
      scope: e,
      trigger: y,
      onTriggerChange: v,
      valueNode: w,
      onValueNodeChange: x,
      valueNodeHasChildren: b,
      onValueNodeHasChildrenChange: M,
      contentId: Ir(),
      value: D,
      onValueChange: W,
      open: N,
      onOpenChange: $,
      dir: _,
      triggerPointerDownPosRef: j,
      disabled: m,
      children: [
        /* @__PURE__ */ d(Am.Provider, { scope: e, children: /* @__PURE__ */ d(
          WO,
          {
            scope: t.__scopeSelect,
            onNativeOptionAdd: S.useCallback((B) => {
              L((F) => new Set(F).add(B));
            }, []),
            onNativeOptionRemove: S.useCallback((B) => {
              L((F) => {
                const z = new Set(F);
                return z.delete(B), z;
              });
            }, []),
            children: n
          }
        ) }),
        O ? /* @__PURE__ */ k(
          p6,
          {
            "aria-hidden": !0,
            required: h,
            tabIndex: -1,
            name: u,
            autoComplete: f,
            value: D,
            onChange: (B) => W(B.target.value),
            disabled: m,
            form: p,
            children: [
              D === void 0 ? /* @__PURE__ */ d("option", { value: "" }) : null,
              Array.from(I)
            ]
          },
          R
        ) : null
      ]
    }
  ) });
};
Y5.displayName = rc;
var K5 = "SelectTrigger", U5 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, disabled: i = !1, ...r } = t, a = Im(n), o = La(K5, n), s = o.disabled || i, l = st(e, o.onTriggerChange), c = Lm(n), u = S.useRef("touch"), [f, m, h] = g6((g) => {
      const y = c().filter((x) => !x.disabled), v = y.find((x) => x.value === o.value), w = y6(y, g, v);
      w !== void 0 && o.onValueChange(w.value);
    }), p = (g) => {
      s || (o.onOpenChange(!0), h()), g && (o.triggerPointerDownPosRef.current = {
        x: Math.round(g.pageX),
        y: Math.round(g.pageY)
      });
    };
    return /* @__PURE__ */ d(z4, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      qe.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": o.contentId,
        "aria-expanded": o.open,
        "aria-required": o.required,
        "aria-autocomplete": "none",
        dir: o.dir,
        "data-state": o.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": h6(o.value) ? "" : void 0,
        ...r,
        ref: l,
        onClick: ge(r.onClick, (g) => {
          g.currentTarget.focus(), u.current !== "mouse" && p(g);
        }),
        onPointerDown: ge(r.onPointerDown, (g) => {
          u.current = g.pointerType;
          const y = g.target;
          y.hasPointerCapture(g.pointerId) && y.releasePointerCapture(g.pointerId), g.button === 0 && g.ctrlKey === !1 && g.pointerType === "mouse" && (p(g), g.preventDefault());
        }),
        onKeyDown: ge(r.onKeyDown, (g) => {
          const y = f.current !== "";
          !(g.ctrlKey || g.altKey || g.metaKey) && g.key.length === 1 && m(g.key), !(y && g.key === " ") && DO.includes(g.key) && (p(), g.preventDefault());
        })
      }
    ) });
  }
);
U5.displayName = K5;
var J5 = "SelectValue", Q5 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: i, style: r, children: a, placeholder: o = "", ...s } = t, l = La(J5, n), { onValueNodeHasChildrenChange: c } = l, u = a !== void 0, f = st(e, l.onValueNodeChange);
    return xn(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ d(
      qe.span,
      {
        ...s,
        ref: f,
        style: { pointerEvents: "none" },
        children: h6(l.value) ? /* @__PURE__ */ d(Ee, { children: o }) : a
      }
    );
  }
);
Q5.displayName = J5;
var LO = "SelectIcon", IO = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, children: i, ...r } = t;
    return /* @__PURE__ */ d(qe.span, { "aria-hidden": !0, ...r, ref: e, children: i || "▼" });
  }
);
IO.displayName = LO;
var RO = "SelectPortal", Z5 = (t) => /* @__PURE__ */ d(V4, { asChild: !0, ...t });
Z5.displayName = RO;
var vo = "SelectContent", e6 = S.forwardRef(
  (t, e) => {
    const n = La(vo, t.__scopeSelect), [i, r] = S.useState();
    if (xn(() => {
      r(new DocumentFragment());
    }, []), !n.open) {
      const a = i;
      return a ? Ay.createPortal(
        /* @__PURE__ */ d(t6, { scope: t.__scopeSelect, children: /* @__PURE__ */ d(Am.Slot, { scope: t.__scopeSelect, children: /* @__PURE__ */ d("div", { children: t.children }) }) }),
        a
      ) : null;
    }
    return /* @__PURE__ */ d(n6, { ...t, ref: e });
  }
);
e6.displayName = vo;
var Ri = 10, [t6, Ia] = Gs(vo), jO = "SelectContentImpl", n6 = S.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      position: i = "item-aligned",
      onCloseAutoFocus: r,
      onEscapeKeyDown: a,
      onPointerDownOutside: o,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: y,
      //
      ...v
    } = t, w = La(vo, n), [x, b] = S.useState(null), [M, _] = S.useState(null), N = st(e, (Y) => b(Y)), [$, D] = S.useState(null), [W, j] = S.useState(
      null
    ), O = Lm(n), [I, L] = S.useState(!1), R = S.useRef(!1);
    S.useEffect(() => {
      if (x) return H4(x);
    }, [x]), B4();
    const B = S.useCallback(
      (Y) => {
        const [oe, ...se] = O().map((De) => De.ref.current), [J] = se.slice(-1), xe = document.activeElement;
        for (const De of Y)
          if (De === xe || (De == null || De.scrollIntoView({ block: "nearest" }), De === oe && M && (M.scrollTop = 0), De === J && M && (M.scrollTop = M.scrollHeight), De == null || De.focus(), document.activeElement !== xe)) return;
      },
      [O, M]
    ), F = S.useCallback(
      () => B([$, x]),
      [B, $, x]
    );
    S.useEffect(() => {
      I && F();
    }, [I, F]);
    const { onOpenChange: z, triggerPointerDownPosRef: K } = w;
    S.useEffect(() => {
      if (x) {
        let Y = { x: 0, y: 0 };
        const oe = (J) => {
          var xe, De;
          Y = {
            x: Math.abs(Math.round(J.pageX) - (((xe = K.current) == null ? void 0 : xe.x) ?? 0)),
            y: Math.abs(Math.round(J.pageY) - (((De = K.current) == null ? void 0 : De.y) ?? 0))
          };
        }, se = (J) => {
          Y.x <= 10 && Y.y <= 10 ? J.preventDefault() : x.contains(J.target) || z(!1), document.removeEventListener("pointermove", oe), K.current = null;
        };
        return K.current !== null && (document.addEventListener("pointermove", oe), document.addEventListener("pointerup", se, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", oe), document.removeEventListener("pointerup", se, { capture: !0 });
        };
      }
    }, [x, z, K]), S.useEffect(() => {
      const Y = () => z(!1);
      return window.addEventListener("blur", Y), window.addEventListener("resize", Y), () => {
        window.removeEventListener("blur", Y), window.removeEventListener("resize", Y);
      };
    }, [z]);
    const [ae, Q] = g6((Y) => {
      const oe = O().filter((xe) => !xe.disabled), se = oe.find((xe) => xe.ref.current === document.activeElement), J = y6(oe, Y, se);
      J && setTimeout(() => J.ref.current.focus());
    }), te = S.useCallback(
      (Y, oe, se) => {
        const J = !R.current && !se;
        (w.value !== void 0 && w.value === oe || J) && (D(Y), J && (R.current = !0));
      },
      [w.value]
    ), be = S.useCallback(() => x == null ? void 0 : x.focus(), [x]), Pe = S.useCallback(
      (Y, oe, se) => {
        const J = !R.current && !se;
        (w.value !== void 0 && w.value === oe || J) && j(Y);
      },
      [w.value]
    ), We = i === "popper" ? Dp : i6, $e = We === Dp ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: f,
      collisionBoundary: m,
      collisionPadding: h,
      sticky: p,
      hideWhenDetached: g,
      avoidCollisions: y
    } : {};
    return /* @__PURE__ */ d(
      t6,
      {
        scope: n,
        content: x,
        viewport: M,
        onViewportChange: _,
        itemRefCallback: te,
        selectedItem: $,
        onItemLeave: be,
        itemTextRefCallback: Pe,
        focusSelectedItem: F,
        selectedItemText: W,
        position: i,
        isPositioned: I,
        searchRef: ae,
        children: /* @__PURE__ */ d(q4, { as: Bu, allowPinchZoom: !0, children: /* @__PURE__ */ d(
          G4,
          {
            asChild: !0,
            trapped: w.open,
            onMountAutoFocus: (Y) => {
              Y.preventDefault();
            },
            onUnmountAutoFocus: ge(r, (Y) => {
              var oe;
              (oe = w.trigger) == null || oe.focus({ preventScroll: !0 }), Y.preventDefault();
            }),
            children: /* @__PURE__ */ d(
              Cy,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: a,
                onPointerDownOutside: o,
                onFocusOutside: (Y) => Y.preventDefault(),
                onDismiss: () => w.onOpenChange(!1),
                children: /* @__PURE__ */ d(
                  We,
                  {
                    role: "listbox",
                    id: w.contentId,
                    "data-state": w.open ? "open" : "closed",
                    dir: w.dir,
                    onContextMenu: (Y) => Y.preventDefault(),
                    ...v,
                    ...$e,
                    onPlaced: () => L(!0),
                    ref: N,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...v.style
                    },
                    onKeyDown: ge(v.onKeyDown, (Y) => {
                      const oe = Y.ctrlKey || Y.altKey || Y.metaKey;
                      if (Y.key === "Tab" && Y.preventDefault(), !oe && Y.key.length === 1 && Q(Y.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(Y.key)) {
                        let J = O().filter((xe) => !xe.disabled).map((xe) => xe.ref.current);
                        if (["ArrowUp", "End"].includes(Y.key) && (J = J.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(Y.key)) {
                          const xe = Y.target, De = J.indexOf(xe);
                          J = J.slice(De + 1);
                        }
                        setTimeout(() => B(J)), Y.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
n6.displayName = jO;
var FO = "SelectItemAlignedPosition", i6 = S.forwardRef((t, e) => {
  const { __scopeSelect: n, onPlaced: i, ...r } = t, a = La(vo, n), o = Ia(vo, n), [s, l] = S.useState(null), [c, u] = S.useState(null), f = st(e, (N) => u(N)), m = Lm(n), h = S.useRef(!1), p = S.useRef(!0), { viewport: g, selectedItem: y, selectedItemText: v, focusSelectedItem: w } = o, x = S.useCallback(() => {
    if (a.trigger && a.valueNode && s && c && g && y && v) {
      const N = a.trigger.getBoundingClientRect(), $ = c.getBoundingClientRect(), D = a.valueNode.getBoundingClientRect(), W = v.getBoundingClientRect();
      if (a.dir !== "rtl") {
        const xe = W.left - $.left, De = D.left - xe, _e = N.left - De, ce = N.width + _e, wt = Math.max(ce, $.width), St = window.innerWidth - Ri, ze = cw(De, [
          Ri,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Ri, St - wt)
        ]);
        s.style.minWidth = ce + "px", s.style.left = ze + "px";
      } else {
        const xe = $.right - W.right, De = window.innerWidth - D.right - xe, _e = window.innerWidth - N.right - De, ce = N.width + _e, wt = Math.max(ce, $.width), St = window.innerWidth - Ri, ze = cw(De, [
          Ri,
          Math.max(Ri, St - wt)
        ]);
        s.style.minWidth = ce + "px", s.style.right = ze + "px";
      }
      const j = m(), O = window.innerHeight - Ri * 2, I = g.scrollHeight, L = window.getComputedStyle(c), R = parseInt(L.borderTopWidth, 10), B = parseInt(L.paddingTop, 10), F = parseInt(L.borderBottomWidth, 10), z = parseInt(L.paddingBottom, 10), K = R + B + I + z + F, ae = Math.min(y.offsetHeight * 5, K), Q = window.getComputedStyle(g), te = parseInt(Q.paddingTop, 10), be = parseInt(Q.paddingBottom, 10), Pe = N.top + N.height / 2 - Ri, We = O - Pe, $e = y.offsetHeight / 2, Y = y.offsetTop + $e, oe = R + B + Y, se = K - oe;
      if (oe <= Pe) {
        const xe = j.length > 0 && y === j[j.length - 1].ref.current;
        s.style.bottom = "0px";
        const De = c.clientHeight - g.offsetTop - g.offsetHeight, _e = Math.max(
          We,
          $e + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (xe ? be : 0) + De + F
        ), ce = oe + _e;
        s.style.height = ce + "px";
      } else {
        const xe = j.length > 0 && y === j[0].ref.current;
        s.style.top = "0px";
        const _e = Math.max(
          Pe,
          R + g.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (xe ? te : 0) + $e
        ) + se;
        s.style.height = _e + "px", g.scrollTop = oe - Pe + g.offsetTop;
      }
      s.style.margin = `${Ri}px 0`, s.style.minHeight = ae + "px", s.style.maxHeight = O + "px", i == null || i(), requestAnimationFrame(() => h.current = !0);
    }
  }, [
    m,
    a.trigger,
    a.valueNode,
    s,
    c,
    g,
    y,
    v,
    a.dir,
    i
  ]);
  xn(() => x(), [x]);
  const [b, M] = S.useState();
  xn(() => {
    c && M(window.getComputedStyle(c).zIndex);
  }, [c]);
  const _ = S.useCallback(
    (N) => {
      N && p.current === !0 && (x(), w == null || w(), p.current = !1);
    },
    [x, w]
  );
  return /* @__PURE__ */ d(
    VO,
    {
      scope: n,
      contentWrapper: s,
      shouldExpandOnScrollRef: h,
      onScrollButtonChange: _,
      children: /* @__PURE__ */ d(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: b
          },
          children: /* @__PURE__ */ d(
            qe.div,
            {
              ...r,
              ref: f,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...r.style
              }
            }
          )
        }
      )
    }
  );
});
i6.displayName = FO;
var zO = "SelectPopperPosition", Dp = S.forwardRef((t, e) => {
  const {
    __scopeSelect: n,
    align: i = "start",
    collisionPadding: r = Ri,
    ...a
  } = t, o = Im(n);
  return /* @__PURE__ */ d(
    X4,
    {
      ...o,
      ...a,
      ref: e,
      align: i,
      collisionPadding: r,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...a.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Dp.displayName = zO;
var [VO, zy] = Gs(vo, {}), Ep = "SelectViewport", r6 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, nonce: i, ...r } = t, a = Ia(Ep, n), o = zy(Ep, n), s = st(e, a.onViewportChange), l = S.useRef(0);
    return /* @__PURE__ */ k(Ee, { children: [
      /* @__PURE__ */ d(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: i
        }
      ),
      /* @__PURE__ */ d(Am.Slot, { scope: n, children: /* @__PURE__ */ d(
        qe.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...r,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...r.style
          },
          onScroll: ge(r.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: f, shouldExpandOnScrollRef: m } = o;
            if (m != null && m.current && f) {
              const h = Math.abs(l.current - u.scrollTop);
              if (h > 0) {
                const p = window.innerHeight - Ri * 2, g = parseFloat(f.style.minHeight), y = parseFloat(f.style.height), v = Math.max(g, y);
                if (v < p) {
                  const w = v + h, x = Math.min(p, w), b = w - x;
                  f.style.height = x + "px", f.style.bottom === "0px" && (u.scrollTop = b > 0 ? b : 0, f.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
r6.displayName = Ep;
var a6 = "SelectGroup", [HO, BO] = Gs(a6), qO = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...i } = t, r = Ir();
    return /* @__PURE__ */ d(HO, { scope: n, id: r, children: /* @__PURE__ */ d(qe.div, { role: "group", "aria-labelledby": r, ...i, ref: e }) });
  }
);
qO.displayName = a6;
var o6 = "SelectLabel", GO = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...i } = t, r = BO(o6, n);
    return /* @__PURE__ */ d(qe.div, { id: r.id, ...i, ref: e });
  }
);
GO.displayName = o6;
var Uu = "SelectItem", [XO, s6] = Gs(Uu), l6 = S.forwardRef(
  (t, e) => {
    const {
      __scopeSelect: n,
      value: i,
      disabled: r = !1,
      textValue: a,
      ...o
    } = t, s = La(Uu, n), l = Ia(Uu, n), c = s.value === i, [u, f] = S.useState(a ?? ""), [m, h] = S.useState(!1), p = st(
      e,
      (w) => {
        var x;
        return (x = l.itemRefCallback) == null ? void 0 : x.call(l, w, i, r);
      }
    ), g = Ir(), y = S.useRef("touch"), v = () => {
      r || (s.onValueChange(i), s.onOpenChange(!1));
    };
    if (i === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ d(
      XO,
      {
        scope: n,
        value: i,
        disabled: r,
        textId: g,
        isSelected: c,
        onItemTextChange: S.useCallback((w) => {
          f((x) => x || ((w == null ? void 0 : w.textContent) ?? "").trim());
        }, []),
        children: /* @__PURE__ */ d(
          Am.ItemSlot,
          {
            scope: n,
            value: i,
            disabled: r,
            textValue: u,
            children: /* @__PURE__ */ d(
              qe.div,
              {
                role: "option",
                "aria-labelledby": g,
                "data-highlighted": m ? "" : void 0,
                "aria-selected": c && m,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": r || void 0,
                "data-disabled": r ? "" : void 0,
                tabIndex: r ? void 0 : -1,
                ...o,
                ref: p,
                onFocus: ge(o.onFocus, () => h(!0)),
                onBlur: ge(o.onBlur, () => h(!1)),
                onClick: ge(o.onClick, () => {
                  y.current !== "mouse" && v();
                }),
                onPointerUp: ge(o.onPointerUp, () => {
                  y.current === "mouse" && v();
                }),
                onPointerDown: ge(o.onPointerDown, (w) => {
                  y.current = w.pointerType;
                }),
                onPointerMove: ge(o.onPointerMove, (w) => {
                  var x;
                  y.current = w.pointerType, r ? (x = l.onItemLeave) == null || x.call(l) : y.current === "mouse" && w.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ge(o.onPointerLeave, (w) => {
                  var x;
                  w.currentTarget === document.activeElement && ((x = l.onItemLeave) == null || x.call(l));
                }),
                onKeyDown: ge(o.onKeyDown, (w) => {
                  var b;
                  ((b = l.searchRef) == null ? void 0 : b.current) !== "" && w.key === " " || (EO.includes(w.key) && v(), w.key === " " && w.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
l6.displayName = Uu;
var El = "SelectItemText", d6 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, className: i, style: r, ...a } = t, o = La(El, n), s = Ia(El, n), l = s6(El, n), c = AO(El, n), [u, f] = S.useState(null), m = st(
      e,
      (v) => f(v),
      l.onItemTextChange,
      (v) => {
        var w;
        return (w = s.itemTextRefCallback) == null ? void 0 : w.call(s, v, l.value, l.disabled);
      }
    ), h = u == null ? void 0 : u.textContent, p = S.useMemo(
      () => /* @__PURE__ */ d("option", { value: l.value, disabled: l.disabled, children: h }, l.value),
      [l.disabled, l.value, h]
    ), { onNativeOptionAdd: g, onNativeOptionRemove: y } = c;
    return xn(() => (g(p), () => y(p)), [g, y, p]), /* @__PURE__ */ k(Ee, { children: [
      /* @__PURE__ */ d(qe.span, { id: l.textId, ...a, ref: m }),
      l.isSelected && o.valueNode && !o.valueNodeHasChildren ? Ay.createPortal(a.children, o.valueNode) : null
    ] });
  }
);
d6.displayName = El;
var c6 = "SelectItemIndicator", u6 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...i } = t;
    return s6(c6, n).isSelected ? /* @__PURE__ */ d(qe.span, { "aria-hidden": !0, ...i, ref: e }) : null;
  }
);
u6.displayName = c6;
var Tp = "SelectScrollUpButton", YO = S.forwardRef((t, e) => {
  const n = Ia(Tp, t.__scopeSelect), i = zy(Tp, t.__scopeSelect), [r, a] = S.useState(!1), o = st(e, i.onScrollButtonChange);
  return xn(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        a(c);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ d(
    f6,
    {
      ...t,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
YO.displayName = Tp;
var Op = "SelectScrollDownButton", KO = S.forwardRef((t, e) => {
  const n = Ia(Op, t.__scopeSelect), i = zy(Op, t.__scopeSelect), [r, a] = S.useState(!1), o = st(e, i.onScrollButtonChange);
  return xn(() => {
    if (n.viewport && n.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        a(u);
      };
      const l = n.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [n.viewport, n.isPositioned]), r ? /* @__PURE__ */ d(
    f6,
    {
      ...t,
      ref: o,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = n;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
KO.displayName = Op;
var f6 = S.forwardRef((t, e) => {
  const { __scopeSelect: n, onAutoScroll: i, ...r } = t, a = Ia("SelectScrollButton", n), o = S.useRef(null), s = Lm(n), l = S.useCallback(() => {
    o.current !== null && (window.clearInterval(o.current), o.current = null);
  }, []);
  return S.useEffect(() => () => l(), [l]), xn(() => {
    var u;
    const c = s().find((f) => f.ref.current === document.activeElement);
    (u = c == null ? void 0 : c.ref.current) == null || u.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ d(
    qe.div,
    {
      "aria-hidden": !0,
      ...r,
      ref: e,
      style: { flexShrink: 0, ...r.style },
      onPointerDown: ge(r.onPointerDown, () => {
        o.current === null && (o.current = window.setInterval(i, 50));
      }),
      onPointerMove: ge(r.onPointerMove, () => {
        var c;
        (c = a.onItemLeave) == null || c.call(a), o.current === null && (o.current = window.setInterval(i, 50));
      }),
      onPointerLeave: ge(r.onPointerLeave, () => {
        l();
      })
    }
  );
}), UO = "SelectSeparator", m6 = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...i } = t;
    return /* @__PURE__ */ d(qe.div, { "aria-hidden": !0, ...i, ref: e });
  }
);
m6.displayName = UO;
var Wp = "SelectArrow", JO = S.forwardRef(
  (t, e) => {
    const { __scopeSelect: n, ...i } = t, r = Im(n), a = La(Wp, n), o = Ia(Wp, n);
    return a.open && o.position === "popper" ? /* @__PURE__ */ d(Y4, { ...r, ...i, ref: e }) : null;
  }
);
JO.displayName = Wp;
function h6(t) {
  return t === "" || t === void 0;
}
var p6 = S.forwardRef(
  (t, e) => {
    const { value: n, ...i } = t, r = S.useRef(null), a = st(e, r), o = Fy(n);
    return S.useEffect(() => {
      const s = r.current, l = window.HTMLSelectElement.prototype, u = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (o !== n && u) {
        const f = new Event("change", { bubbles: !0 });
        u.call(s, n), s.dispatchEvent(f);
      }
    }, [o, n]), /* @__PURE__ */ d(O$, { asChild: !0, children: /* @__PURE__ */ d("select", { ...i, ref: a, defaultValue: n }) });
  }
);
p6.displayName = "BubbleSelect";
function g6(t) {
  const e = Wn(t), n = S.useRef(""), i = S.useRef(0), r = S.useCallback(
    (o) => {
      const s = n.current + o;
      e(s), function l(c) {
        n.current = c, window.clearTimeout(i.current), c !== "" && (i.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [e]
  ), a = S.useCallback(() => {
    n.current = "", window.clearTimeout(i.current);
  }, []);
  return S.useEffect(() => () => window.clearTimeout(i.current), []), [n, r, a];
}
function y6(t, e, n) {
  const r = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, a = n ? t.indexOf(n) : -1;
  let o = QO(t, Math.max(a, 0));
  r.length === 1 && (o = o.filter((c) => c !== n));
  const l = o.find(
    (c) => c.textValue.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function QO(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
var v6 = Y5, b6 = U5, ZO = Q5, eW = Z5, w6 = e6, tW = r6, k6 = l6, nW = d6, iW = u6, x6 = m6;
const Vy = hn({
  value: void 0,
  open: !1,
  asList: !1
}), Rm = (t) => {
  const [e, n] = q(!!t.asList), i = t.asList ? !0 : t.open !== void 0 ? t.open : e;
  return /* @__PURE__ */ d("div", { className: "[&>div]:!relative", children: /* @__PURE__ */ d(
    v6,
    {
      ...t,
      open: i,
      onOpenChange: (a) => {
        var o;
        t.open === void 0 && n(a), (o = t.onOpenChange) == null || o.call(t, a);
      },
      children: /* @__PURE__ */ d(
        Vy.Provider,
        {
          value: {
            value: t.value,
            open: i,
            asList: t.asList
          },
          children: t.children
        }
      )
    }
  ) });
};
Rm.displayName = v6.displayName;
const rW = 8, jm = X(
  ({
    items: t = void 0,
    className: e,
    children: n,
    position: i = "popper",
    emptyMessage: r,
    ...a
  }, o) => {
    var N;
    const s = Oe(null), l = Array.isArray(t), c = ve(() => l ? t.filter(($) => $.value).length === 0 : !n, [l, t, n]), u = Hd(), [f, m] = q(u), [h, p] = q(!1), { value: g, open: y, asList: v } = Wt(Vy), w = ve(() => t && t.findIndex(($) => $.value === g) || 0, [t, g]), x = X5({
      count: (t == null ? void 0 : t.length) || 0,
      getScrollElement: () => s.current,
      estimateSize: ($) => {
        var D;
        return ((D = t == null ? void 0 : t[$]) == null ? void 0 : D.height) || 0;
      },
      overscan: 5,
      // If the content is a list, we need to check if the animation is enabled
      enabled: v || u || h
    });
    le(() => {
      y || (p(!1), m(!0));
    }, [y]), le(() => {
      x.measure(), x.scrollToIndex(w);
    }, [x, w, h, v]);
    const b = x.getVirtualItems(), M = c ? /* @__PURE__ */ d("p", { className: "p-2 text-center", children: r || "-" }) : l ? /* @__PURE__ */ d(
      "div",
      {
        className: E(
          !v && "transition-opacity delay-100",
          v || f ? "" : "opacity-0"
        ),
        style: {
          height: x.getTotalSize() + rW,
          width: "100%",
          position: "relative"
        },
        children: /* @__PURE__ */ d(
          "div",
          {
            style: {
              top: 0,
              left: 0,
              width: "100%",
              transform: `translateY(${((N = b[0]) == null ? void 0 : N.start) ?? 0}px)`
            },
            children: b.map(($) => /* @__PURE__ */ d(
              "div",
              {
                "data-index": $.index,
                ref: x.measureElement,
                tabIndex: $.index === w ? 0 : -1,
                children: t[$.index].item
              },
              $.key
            ))
          }
        )
      }
    ) : /* @__PURE__ */ d(Ee, { children: n }), _ = /* @__PURE__ */ d(
      w6,
      {
        asChild: v,
        ref: o,
        className: E(
          "relative z-50 max-h-96 min-w-[8rem] overflow-hidden text-f1-foreground",
          !v && "rounded-md border border-solid border-f1-border-secondary bg-f1-background shadow-md data-[state=closed]:fade-out-0 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 motion-safe:data-[state=open]:animate-in motion-safe:data-[state=closed]:animate-out motion-safe:data-[state=open]:fade-in-0 motion-safe:data-[state=closed]:zoom-out-95 motion-safe:data-[state=open]:zoom-in-95 motion-safe:data-[side=bottom]:slide-in-from-top-2",
          !v && i === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
          e,
          // Hides the content when the virtual list is not ready
          !v && l && !f && "opacity-0"
        ),
        position: v ? "item-aligned" : i,
        ...a,
        onAnimationStart: () => {
          p(!0), setTimeout(() => {
            x.scrollToIndex(w, { align: "center" }), m(!0);
          });
        },
        children: /* @__PURE__ */ k(Ee, { children: [
          a.top,
          /* @__PURE__ */ d(
            No,
            {
              viewportRef: s,
              className: E(
                "flex flex-col overflow-y-auto",
                v ? "max-h-full" : "max-h-[300px]"
              ),
              children: v ? M : /* @__PURE__ */ d(
                tW,
                {
                  asChild: !0,
                  className: E(
                    "p-1",
                    !v && i === "popper" && "h-[var(--radix-select-trigger-height)] min-w-[var(--radix-select-trigger-width)]"
                  ),
                  children: M
                }
              )
            }
          ),
          a.bottom
        ] })
      }
    );
    return v ? _ : /* @__PURE__ */ d(eW, { children: _ });
  }
);
jm.displayName = w6.displayName;
const ld = S.forwardRef(({ className: t, children: e, withIndicator: n = !0, ...i }, r) => /* @__PURE__ */ k(
  k6,
  {
    ref: r,
    className: E(
      "relative grid w-full cursor-default select-none gap-x-1.5 rounded px-3 py-2 outline-none transition-colors after:absolute after:inset-x-1 after:inset-y-0 after:z-0 after:h-full after:rounded after:bg-f1-background-hover after:opacity-0 after:transition-opacity after:duration-75 after:content-[''] first:pt-3 first:after:top-1 first:after:h-[calc(100%-0.25rem)] last:pb-3 last:after:bottom-1 last:after:h-[calc(100%-0.5rem)] hover:after:opacity-100 focus:after:bg-f1-background-hover focus:after:text-f1-foreground focus:after:opacity-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50 [&_*]:z-10",
      "data-[state=checked]:after:bg-f1-background-selected-bold/10 data-[state=checked]:after:opacity-100 hover:data-[state=checked]:after:bg-f1-background-selected-bold/10 dark:data-[state=checked]:after:bg-f1-background-selected-bold/20 dark:hover:data-[state=checked]:after:bg-f1-background-selected-bold/20",
      "focus:outline-none focus:ring-0 focus:ring-transparent",
      // Temporal fix for Gamma issue
      n ? "grid-cols-[1fr_20px]" : void 0,
      t
    ),
    ...i,
    children: [
      /* @__PURE__ */ d(nW, { children: e }),
      n && /* @__PURE__ */ d(iW, { className: "flex text-f1-icon-selected", children: /* @__PURE__ */ d(me, { icon: Py, size: "md" }) })
    ]
  }
));
ld.displayName = k6.displayName;
const Hy = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  x6,
  {
    ref: n,
    className: E("-mx-1 my-1 h-px bg-f1-border-secondary", t),
    ...e
  }
));
Hy.displayName = x6.displayName;
const _6 = S.forwardRef(({ className: t, children: e, ...n }, i) => {
  const { asList: r } = Wt(Vy);
  return r ? null : /* @__PURE__ */ d(b6, { ref: i, className: E(t), ...n, children: e });
});
_6.displayName = b6.displayName;
const aW = ZO, oW = It({
  base: "flex h-5 min-w-[1ch] items-center justify-center rounded-xs border border-solid py-0.5 font-sans text-sm font-semibold leading-none",
  variants: {
    variant: {
      default: "border-f1-border-secondary bg-f1-background-tertiary text-f1-foreground-secondary",
      inverse: "border-f1-border-inverse text-f1-foreground-inverse-secondary"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), sW = /* @__PURE__ */ new Set([
  "cmd",
  "option",
  "ctrl"
]), lW = {
  mac: {
    cmd: "⌘",
    option: "⌥",
    ctrl: "⌃"
  },
  windows: {
    ctrl: "Ctrl",
    cmd: NT,
    option: "Alt"
  },
  linux: {
    ctrl: "^",
    cmd: "Meta",
    option: "Alt"
  }
}, dW = (t) => sW.has(t);
function M6({ keys: t, variant: e }) {
  const n = W$(), i = et();
  if (n === "unknown" || n === "mobile")
    return null;
  const r = lW[n];
  return /* @__PURE__ */ k("div", { className: "flex flex-wrap items-center gap-0.5", children: [
    /* @__PURE__ */ d("span", { className: "sr-only", children: i.shortcut }),
    t.map((a, o) => {
      const s = a.toLowerCase(), l = dW(s), c = l ? r[s] : a, u = typeof c != "string";
      return /* @__PURE__ */ d(
        "kbd",
        {
          className: E(
            oW({ variant: e }),
            l ? "" : "uppercase",
            u ? "w-5 px-0.5" : "min-w-5 px-1"
          ),
          children: u ? /* @__PURE__ */ d(me, { icon: c, size: "sm" }) : c
        },
        o
      );
    })
  ] });
}
function Kt({
  label: t,
  description: e,
  children: n,
  shortcut: i
}) {
  return /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ d(K4, { children: /* @__PURE__ */ k(U4, { children: [
    /* @__PURE__ */ d(J4, { asChild: !0, className: "pointer-events-auto", children: n }),
    /* @__PURE__ */ d(Q4, { className: E("max-w-xs", i && "pr-1.5"), children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
        t && /* @__PURE__ */ d("p", { className: "font-semibold", children: t }),
        i && /* @__PURE__ */ d(M6, { keys: i, variant: "inverse" })
      ] }),
      e && /* @__PURE__ */ d("p", { className: "font-normal", children: e })
    ] }) })
  ] }) }) });
}
var By = "Avatar", [cW, zXe] = Wi(By), [uW, C6] = cW(By), P6 = S.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, ...i } = t, [r, a] = S.useState("idle");
    return /* @__PURE__ */ d(
      uW,
      {
        scope: n,
        imageLoadingStatus: r,
        onImageLoadingStatusChange: a,
        children: /* @__PURE__ */ d(qe.span, { ...i, ref: e })
      }
    );
  }
);
P6.displayName = By;
var S6 = "AvatarImage", N6 = S.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, src: i, onLoadingStatusChange: r = () => {
    }, ...a } = t, o = C6(S6, n), s = fW(i, a.referrerPolicy), l = Wn((c) => {
      r(c), o.onImageLoadingStatusChange(c);
    });
    return xn(() => {
      s !== "idle" && l(s);
    }, [s, l]), s === "loaded" ? /* @__PURE__ */ d(qe.img, { ...a, ref: e, src: i }) : null;
  }
);
N6.displayName = S6;
var $6 = "AvatarFallback", D6 = S.forwardRef(
  (t, e) => {
    const { __scopeAvatar: n, delayMs: i, ...r } = t, a = C6($6, n), [o, s] = S.useState(i === void 0);
    return S.useEffect(() => {
      if (i !== void 0) {
        const l = window.setTimeout(() => s(!0), i);
        return () => window.clearTimeout(l);
      }
    }, [i]), o && a.imageLoadingStatus !== "loaded" ? /* @__PURE__ */ d(qe.span, { ...r, ref: e }) : null;
  }
);
D6.displayName = $6;
function fW(t, e) {
  const [n, i] = S.useState("idle");
  return xn(() => {
    if (!t) {
      i("error");
      return;
    }
    let r = !0;
    const a = new window.Image(), o = (s) => () => {
      r && i(s);
    };
    return i("loading"), a.onload = o("loaded"), a.onerror = o("error"), a.src = t, e && (a.referrerPolicy = e), () => {
      r = !1;
    };
  }, [t, e]), n;
}
var E6 = P6, T6 = N6, O6 = D6;
const jc = [
  "viridian",
  "malibu",
  "yellow",
  "purple",
  "lilac",
  "barbie",
  "smoke",
  "army",
  "flubber",
  "indigo",
  "camel"
], mW = It({
  base: "relative flex shrink-0 items-center justify-center overflow-hidden text-center font-semibold ring-1 ring-inset ring-f1-border-secondary",
  variants: {
    size: {
      xsmall: "size-5 rounded-xs text-sm",
      small: "size-6 rounded-sm text-sm",
      medium: "size-8 rounded",
      large: "size-14 rounded-xl text-2xl",
      xlarge: "size-18 rounded-[20px] text-3xl"
    },
    type: {
      base: "",
      rounded: "rounded-full"
    },
    color: {
      viridian: "bg-[hsl(theme(colors.viridian.50))]",
      malibu: "bg-[hsl(theme(colors.malibu.50))]",
      yellow: "bg-[hsl(theme(colors.yellow.50))]",
      purple: "bg-[hsl(theme(colors.purple.50))]",
      lilac: "bg-[hsl(theme(colors.lilac.50))]",
      barbie: "bg-[hsl(theme(colors.barbie.50))]",
      smoke: "bg-[hsl(theme(colors.smoke.50))]",
      army: "bg-[hsl(theme(colors.army.50))]",
      flubber: "bg-[hsl(theme(colors.flubber.50))]",
      indigo: "bg-[hsl(theme(colors.indigo.50))]",
      camel: "bg-[hsl(theme(colors.camel.50))]"
    }
  },
  defaultVariants: {
    size: "medium",
    type: "base",
    color: "viridian"
  }
}), qy = S.forwardRef(({ size: t, type: e, color: n, className: i, ...r }, a) => /* @__PURE__ */ d(
  E6,
  {
    ref: a,
    "data-a11y-color-contrast-ignore": !0,
    className: E(mW({ size: t, type: e, color: n, className: i })),
    ...r
  }
));
qy.displayName = E6.displayName;
const W6 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  T6,
  {
    ref: n,
    className: E("aspect-square h-full w-full object-cover", t),
    ...e,
    asChild: !0,
    children: /* @__PURE__ */ d(Z4, {})
  }
));
W6.displayName = T6.displayName;
const Gy = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  O6,
  {
    ref: n,
    className: E(
      "flex h-full w-full items-center justify-center text-f1-foreground-inverse/90",
      t
    ),
    ...e
  }
));
Gy.displayName = O6.displayName;
const hW = It({
  base: "flex shrink-0 items-center justify-center rounded-full",
  variants: {
    type: {
      neutral: "bg-transparent text-f1-icon",
      highlight: "text-f1-special-highlight",
      positive: "bg-f1-background-positive-bold text-f1-foreground-inverse",
      critical: "bg-f1-icon-critical text-f1-foreground-inverse",
      warning: "bg-f1-background-warning-bold text-f1-foreground-inverse"
    },
    size: {
      xs: "h-2.5 w-2.5",
      sm: "h-3 w-3",
      md: "h-5 w-5",
      lg: "h-6 w-6"
    }
  },
  defaultVariants: {
    type: "neutral",
    size: "md"
  }
}), pW = {
  xs: "xs",
  sm: "xs",
  md: "sm",
  lg: "md"
}, Xy = ({ type: t, size: e = "md", icon: n }) => /* @__PURE__ */ d("div", { className: hW({ type: t, size: e }), children: /* @__PURE__ */ d(me, { icon: n, size: pW[e] }) });
function gW(t, e) {
  const n = Array.isArray(t) ? t : [t];
  return e === "xsmall" || e === "small" ? (n[0][0] ?? "").toUpperCase() : Array.isArray(t) ? n.slice(0, 2).map((r) => r[0]).join("").toUpperCase() : t.slice(0, 2).toUpperCase();
}
function A6(t) {
  let e = 0;
  for (let i = 0; i < t.length; i++)
    e = t.charCodeAt(i) + ((e << 5) - e), e = e & e;
  const n = (e % jc.length + jc.length) % jc.length;
  return jc[n];
}
const L6 = {
  base: {
    xlarge: {
      default: "path('M72 0H0V72H52.202C49.6089 69.459 48 65.9174 48 62C48 54.268 54.268 48 62 48C65.9174 48 69.459 49.6089 72 52.202V0ZM72 71.798C71.9333 71.866 71.866 71.9333 71.798 72H72V71.798Z')",
      module: "path('M46.4004 0C55.3609 3.65342e-10 59.8411 0.00029099 63.2637 1.74414C66.2743 3.27811 68.7219 5.72573 70.2559 8.73633C71.9997 12.1589 72 16.6391 72 25.5996V46.4004C72 47.7896 71.9987 49.0712 71.9922 50.2578C69.7863 48.658 66.5508 48 62 48C51.5 48 48 51.5 48 62C48 66.5508 48.658 69.7863 50.2578 71.9922C49.0712 71.9987 47.7896 72 46.4004 72H25.5996C16.6391 72 12.1589 71.9997 8.73633 70.2559C5.72573 68.7219 3.27811 66.2743 1.74414 63.2637C0.000291109 59.8411 3.69382e-10 55.3609 0 46.4004V25.5996C3.65342e-10 16.6391 0.00029099 12.1589 1.74414 8.73633C3.27811 5.72573 5.72573 3.27811 8.73633 1.74414C12.1589 0.000291109 16.6391 3.69382e-10 25.5996 0H46.4004Z')"
    },
    large: {
      default: "path('M56 0H0V56H39.0556C37.1554 53.877 36 51.0734 36 48C36 41.3726 41.3726 36 48 36C51.0734 36 53.877 37.1554 56 39.0556V0Z')",
      module: "path('M30.4004 0C39.3609 3.71637e-10 43.8411 0.000291228 47.2637 1.74414C50.2743 3.27811 52.7219 5.72573 54.2559 8.73633C55.9997 12.1589 56 16.6391 56 25.5996V30.4004C56 33.1737 55.9999 35.5178 55.9482 37.5342C54.087 36.4528 51.4963 36 48 36C39 36 36 39 36 48C36 51.4963 36.4528 54.087 37.5342 55.9482C35.5178 55.9999 33.1737 56 30.4004 56H25.5996C16.6391 56 12.1589 55.9997 8.73633 54.2559C5.72573 52.7219 3.27811 50.2743 1.74414 47.2637C0.000291109 43.8411 3.68483e-10 39.3609 0 30.4004V25.5996C3.71637e-10 16.6391 0.000291228 12.1589 1.74414 8.73633C3.27811 5.72573 5.72573 3.27811 8.73633 1.74414C12.1589 0.000291109 16.6391 3.68483e-10 25.5996 0H30.4004Z')"
    },
    medium: {
      default: "path('M32 0H0V32H22.2547C21.4638 30.8662 21 29.4872 21 28C21 24.134 24.134 21 28 21C29.4872 21 30.8662 21.4638 32 22.2547V0Z')",
      module: "path('M16 0C21.6005 0 24.4009 -9.10759e-05 26.54 1.08984C28.4216 2.04857 29.9514 3.5784 30.9102 5.45996C32.0001 7.59908 32 10.3995 32 16C32 18.2626 31.9977 20.0681 31.9258 21.5576C30.9188 21.169 29.6278 21 28 21C22.75 21 21 22.75 21 28C21 29.6278 21.169 30.9188 21.5576 31.9258C20.0681 31.9977 18.2626 32 16 32C10.3995 32 7.59908 32.0001 5.45996 30.9102C3.5784 29.9514 2.04857 28.4216 1.08984 26.54C-9.10759e-05 24.4009 0 21.6005 0 16C0 10.3995 -9.10759e-05 7.59908 1.08984 5.45996C2.04857 3.5784 3.5784 2.04857 5.45996 1.08984C7.59908 -9.10759e-05 10.3995 0 16 0Z')"
    },
    small: {
      default: "path('M24 0H0V24H14.2547C13.4638 22.8662 13 21.4872 13 20C13 16.134 16.134 13 20 13C21.4872 13 22.8662 13.4638 24 14.2547V0Z')",
      module: "path('M12 0C15.7275 0 17.5914 0.000411272 19.0615 0.609375C21.0216 1.42132 22.5787 2.97841 23.3906 4.93848C23.9996 6.40865 24 8.27247 24 12C24 12.5706 23.9983 13.0974 23.9961 13.5859C22.9791 13.1775 21.666 13 20 13C14.75 13 13 14.75 13 20C13 21.666 13.1775 22.9791 13.5859 23.9961C13.0974 23.9983 12.5706 24 12 24C8.27247 24 6.40865 23.9996 4.93848 23.3906C2.97841 22.5787 1.42132 21.0216 0.609375 19.0615C0.000411272 17.5914 0 15.7275 0 12C0 8.27247 0.000411272 6.40865 0.609375 4.93848C1.42132 2.97841 2.97841 1.42132 4.93848 0.609375C6.40865 0.000411272 8.27247 0 12 0Z')"
    },
    xsmall: {
      default: "path('M20 0H0V20H10.2547C9.46381 18.8662 9 17.4872 9 16C9 12.134 12.134 9 16 9C17.4872 9 18.8662 9.46381 20 10.2547V0Z')",
      module: "path('M10.4004 0C13.7603 9.83795e-10 15.4402 0.00041759 16.7236 0.654297C17.8526 1.22954 18.7705 2.14739 19.3457 3.27637C19.9996 4.55977 20 6.23965 20 9.59961V10.4004C20 10.7343 19.9997 11.0516 19.999 11.3535C19.1953 11.1094 18.2055 11 17 11C12.5 11 11 12.5 11 17C11 18.2055 11.1094 19.1953 11.3535 19.999C11.0516 19.9997 10.7343 20 10.4004 20H9.59961C6.23965 20 4.55977 19.9996 3.27637 19.3457C2.14739 18.7705 1.22954 17.8526 0.654297 16.7236C0.00041759 15.4402 9.83795e-10 13.7603 0 10.4004V9.59961C9.83795e-10 6.23965 0.00041759 4.55977 0.654297 3.27637C1.22954 2.14739 2.14739 1.22954 3.27637 0.654297C4.55977 0.00041759 6.23965 9.83795e-10 9.59961 0H10.4004Z')"
    }
  },
  rounded: {
    xlarge: {
      default: "path('M69.1842 49.9814C70.9975 45.6828 72 40.9585 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72C40.9585 72 45.6828 70.9975 49.9814 69.1842C48.7232 67.0839 48 64.6264 48 62C48 54.268 54.268 48 62 48C64.6264 48 67.0839 48.7232 69.1842 49.9814Z')",
      module: "path('M36 0C55.8823 0 72 16.1177 72 36C72 40.588 71.139 44.9745 69.5742 49.0098C67.6022 48.3059 65.1076 48 62 48C51.5 48 48 51.5 48 62C48 65.1077 48.3067 67.6022 49.0107 69.5742C44.9752 71.1392 40.5883 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0Z')"
    },
    large: {
      default: "path('M54.2534 37.7562C55.3828 34.7182 56 31.4312 56 28C56 12.536 43.464 0 28 0C12.536 0 0 12.536 0 28C0 43.464 12.536 56 28 56C31.4312 56 34.7182 55.3828 37.7562 54.2534C36.6421 52.4324 36 50.2912 36 48C36 41.3726 41.3726 36 48 36C50.2912 36 52.4324 36.6421 54.2534 37.7562Z')",
      module: "path('M28 0C43.464 0 56 12.536 56 28C56 31.108 55.4924 34.0972 54.5576 36.8906C52.8571 36.2704 50.6984 36 48 36C39 36 36 39 36 48C36 50.6984 36.2704 52.8571 36.8906 54.5576C34.0972 55.4924 31.108 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0Z')"
    },
    medium: {
      default: "path('M30.9702 21.6596C31.6358 19.9001 32 17.9926 32 16C32 7.16344 24.8366 0 16 0C7.16344 0 0 7.16344 0 16C0 24.8366 7.16344 32 16 32C17.9926 32 19.9001 31.6358 21.6596 30.9702C21.2365 30.0686 21 29.0619 21 28C21 24.134 24.134 21 28 21C29.0619 21 30.0686 21.2365 30.9702 21.6596Z')",
      module: "path('M16 0C24.8366 0 32 7.16344 32 16C32 17.8588 31.6815 19.6431 31.0986 21.3027C30.238 21.0945 29.2125 21 28 21C22.75 21 21 22.75 21 28C21 29.2125 21.0945 30.238 21.3027 31.0986C19.6431 31.6815 17.8588 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0Z')"
    },
    small: {
      default: "path('M23.8119 14.128C23.9355 13.4373 24 12.7262 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C12.7262 24 13.4373 23.9355 14.128 23.8119C13.4145 22.7151 13 21.406 13 20C13 16.134 16.134 13 20 13C21.406 13 22.7151 13.4145 23.8119 14.128Z')",
      module: "path('M12 0C18.6274 0 24 5.37258 24 12C24 12.5245 23.9657 13.0411 23.9004 13.5479C22.8971 13.1662 21.6141 13 20 13C14.75 13 13 14.75 13 20C13 21.6141 13.1662 22.8971 13.5479 23.9004C13.0411 23.9657 12.5245 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0Z')"
    },
    xsmall: {
      default: "path('M10 0C15.5228 0 20 4.47715 20 10C20 10.5862 19.9464 11.1602 19.8496 11.7188C19.0019 11.2604 18.0314 11 17 11C13.6863 11 11 13.6863 11 17C11 18.0314 11.2604 19.0019 11.7188 19.8496C11.1602 19.9464 10.5862 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z')",
      module: "path('M10 0C15.5228 0 20 4.47715 20 10C20 10.4498 19.9667 10.8921 19.9092 11.3262C19.1218 11.1008 18.1609 11 17 11C12.5 11 11 12.5 11 17C11 18.1609 11.1008 19.1218 11.3262 19.9092C10.8921 19.9667 10.4498 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0Z')"
    }
  },
  get: (t = "base", e = "medium", n = "default") => L6[t][e][n]
}, yW = (t) => {
  const e = {
    xlarge: "lg",
    large: "md",
    small: "sm",
    xsmall: "xs"
  };
  return t && e[t] ? e[t] : e.small;
}, vW = (t) => {
  const e = {
    xlarge: "md",
    large: "sm",
    small: "xs",
    xsmall: "xxs"
  };
  return t && e[t] ? e[t] : e.small;
}, Xs = X(
  ({
    src: t,
    name: e,
    size: n,
    type: i = "base",
    color: r = "random",
    "aria-label": a,
    "aria-labelledby": o,
    badge: s
  }, l) => {
    const c = gW(e, n), u = r === "random" ? A6(Array.isArray(e) ? e.join("") : e) : r, f = !!(a || o), m = yW(n), h = vW(n), p = ve(
      () => s ? /* @__PURE__ */ k(Ee, { children: [
        s.type === "module" && /* @__PURE__ */ d(Sm, { module: s.module, size: h }),
        s.type !== "module" && /* @__PURE__ */ d(Xy, { type: s.type, icon: s.icon, size: m })
      ] }) : null,
      [s, m, h]
    );
    return /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ k("div", { className: "relative inline-flex", children: [
      /* @__PURE__ */ d(
        "div",
        {
          className: "h-fit w-fit",
          style: s ? {
            clipPath: L6.get(
              i === "rounded" ? "rounded" : "base",
              n,
              s.type === "module" ? "module" : "default"
            )
          } : void 0,
          children: /* @__PURE__ */ k(
            qy,
            {
              size: n,
              type: i,
              color: u,
              ref: l,
              role: "img",
              "aria-hidden": !f,
              "aria-label": a,
              "aria-labelledby": o,
              "data-a11y-color-contrast-ignore": !0,
              className: t ? "bg-f1-background dark:bg-f1-background-inverse-secondary" : "",
              children: [
                /* @__PURE__ */ d(W6, { src: t, alt: c }),
                /* @__PURE__ */ d(Gy, { "data-a11y-color-contrast-ignore": !0, children: c })
              ]
            }
          )
        }
      ),
      s && /* @__PURE__ */ d("div", { className: "absolute -bottom-0.5 -right-0.5", children: s.tooltip ? /* @__PURE__ */ d(Kt, { description: s.tooltip, children: /* @__PURE__ */ d("div", { className: "cursor-help", children: p }) }) : p })
    ] }) });
  }
);
Xs.displayName = "BaseAvatar";
const ac = ({
  name: t,
  src: e,
  size: n,
  "aria-label": i,
  "aria-labelledby": r,
  badge: a
}) => /* @__PURE__ */ d(
  Xs,
  {
    type: "base",
    name: t,
    src: e,
    size: n,
    color: "viridian",
    "aria-label": i,
    "aria-labelledby": r,
    badge: a
  }
);
ac.displayName = "CompanyAvatar";
const ti = ({
  firstName: t,
  lastName: e,
  src: n,
  size: i,
  "aria-label": r,
  "aria-labelledby": a,
  badge: o
}) => /* @__PURE__ */ d(
  Xs,
  {
    type: "rounded",
    name: [t, e],
    src: n,
    size: i,
    color: "random",
    "aria-label": r,
    "aria-labelledby": a,
    badge: o
  }
);
ti.displayName = "PersonAvatar";
const Fm = ({
  name: t,
  src: e,
  size: n,
  "aria-label": i,
  "aria-labelledby": r,
  badge: a
}) => /* @__PURE__ */ d(
  Xs,
  {
    type: "base",
    name: t,
    src: e,
    size: n,
    color: "random",
    "aria-label": i,
    "aria-labelledby": r,
    badge: a
  }
);
Fm.displayName = "TeamAvatar";
const ni = ({
  avatar: t,
  size: e = "xsmall"
}) => {
  switch (t.type) {
    case "person":
      return /* @__PURE__ */ d(
        ti,
        {
          firstName: t.firstName,
          lastName: t.lastName,
          badge: t.badge,
          src: t.src,
          size: e,
          "aria-label": t["aria-label"],
          "aria-labelledby": t["aria-labelledby"]
        }
      );
    case "team":
      return /* @__PURE__ */ d(
        Fm,
        {
          name: t.name,
          src: t.src,
          badge: t.badge,
          size: e,
          "aria-label": t["aria-label"],
          "aria-labelledby": t["aria-labelledby"]
        }
      );
    case "company":
      return /* @__PURE__ */ d(
        ac,
        {
          name: t.name,
          src: t.src,
          badge: t.badge,
          size: e,
          "aria-label": t["aria-label"],
          "aria-labelledby": t["aria-labelledby"]
        }
      );
  }
}, bW = ({ actions: t }) => t ? /* @__PURE__ */ d("div", { className: "flex w-full flex-row gap-2 border-0 border-t border-solid border-f1-border-secondary p-2", children: t.map((e) => /* @__PURE__ */ d(
  ue,
  {
    variant: e.variant,
    onClick: e.onClick,
    icon: e.icon,
    label: e.label
  },
  e.label
)) }) : null, Fr = S.forwardRef(
  ({ className: t, type: e, icon: n, clearable: i, error: r, ...a }, o) => /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex w-full appearance-none rounded-md border-0 bg-f1-background p-2 ring-1 ring-inset ring-f1-border transition-all placeholder:text-f1-foreground-tertiary hover:ring-f1-border-hover",
        Ke("focus:ring-f1-border-hover"),
        n ? "flex gap-1 py-1.5 ps-2" : "ps-3",
        a.disabled && "cursor-not-allowed bg-f1-background-secondary opacity-50",
        r && "ring-f1-border-critical-bold",
        t
      ),
      children: [
        n && /* @__PURE__ */ d(
          me,
          {
            icon: n,
            className: "h-5 w-5 shrink-0 text-f1-foreground-secondary"
          }
        ),
        /* @__PURE__ */ d(
          "input",
          {
            type: e,
            ref: o,
            ...a,
            className: E(
              i ? "" : "[&::-webkit-search-cancel-button]:hidden",
              "w-full shrink disabled:cursor-not-allowed"
            )
          }
        )
      ]
    }
  )
);
Fr.displayName = "Input";
const I6 = X(
  ({
    value: t,
    threshold: e = 0,
    onChange: n,
    debounceTime: i = 0,
    clearable: r = !1,
    ...a
  }, o) => {
    const s = Oe(void 0), l = (c) => {
      n && // It should emit the change when the user clears the field
      (c.target.value.length >= e || c.target.value.length === 0) && (s.current === void 0 && setTimeout(() => {
        s.current !== void 0 && n(s.current), s.current = void 0;
      }, i), s.current = c.target.value);
    };
    return /* @__PURE__ */ d(
      Fr,
      {
        ref: o,
        type: "search",
        icon: Om,
        value: t,
        placeholder: a.placeholder,
        disabled: a.disabled,
        onChange: l,
        role: "searchbox",
        autoFocus: a.autoFocus,
        clearable: r
      }
    );
  }
);
I6.displayName = "F1SearchBox";
const wW = ({
  showSearchBox: t,
  searchBoxPlaceholder: e,
  onSearchChange: n,
  searchValue: i,
  searchInputRef: r
}) => t ? /* @__PURE__ */ d("div", { className: "px-2 pt-2", children: /* @__PURE__ */ d(
  I6,
  {
    placeholder: e,
    onChange: n,
    clearable: !0,
    value: i,
    ref: r
  },
  "search-input"
) }) : null, kW = ({ item: t }) => /* @__PURE__ */ d(ld, { value: String(t.value), children: /* @__PURE__ */ k("div", { className: "flex w-full items-start gap-1.5", children: [
  t.avatar && /* @__PURE__ */ d(ni, { avatar: t.avatar, size: "xsmall" }),
  t.icon && /* @__PURE__ */ d("div", { className: "text-f1-icon", children: /* @__PURE__ */ d(me, { icon: t.icon }) }),
  /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col", children: [
    /* @__PURE__ */ d("span", { className: "line-clamp-2 font-medium", children: t.label }),
    t.description && /* @__PURE__ */ d("div", { className: "line-clamp-2 text-f1-foreground-secondary", children: t.description })
  ] }),
  t.tag && /* @__PURE__ */ d("div", { className: "self-center", children: /* @__PURE__ */ d(Ni, { text: t.tag }) })
] }) }), xW = X(function({ item: e }, n) {
  return /* @__PURE__ */ k("div", { className: "flex items-center gap-1.5", ref: n, children: [
    e.icon && /* @__PURE__ */ d("div", { className: "h-5 shrink-0 text-f1-icon", children: /* @__PURE__ */ d(me, { icon: e.icon }) }),
    e.label
  ] });
}), _W = "flex h-10 w-full items-center justify-between rounded-md border border-solid border-f1-border bg-f1-background pl-3 pr-2 py-2.5 transition-colors placeholder:text-f1-foreground-secondary hover:border-f1-border-hover disabled:cursor-not-allowed disabled:bg-f1-background-secondary disabled:opacity-50 [&>span]:line-clamp-1", MW = X(function({
  placeholder: e,
  options: n = [],
  onChange: i,
  value: r,
  children: a,
  disabled: o,
  open: s,
  onOpenChange: l,
  showSearchBox: c,
  onSearchChange: u,
  searchBoxPlaceholder: f,
  externalSearch: m,
  searchEmptyMessage: h,
  className: p,
  selectContentClassName: g,
  actions: y,
  ...v
}, w) {
  const x = n.find(
    (L) => L.type !== "separator" && L.value === r
  ), b = Oe(null), [M, _] = q(
    v.searchValue || ""
  ), [N, $] = q(s), D = ve(() => {
    if (m)
      return n;
    const L = n.filter(
      (R) => R.type === "separator" || !M || R.label.toLowerCase().includes(M.toLowerCase())
    );
    return setTimeout(() => {
      var R;
      (R = b.current) == null || R.focus();
    }, 0), L;
  }, [n, m, M]);
  le(() => {
    var L;
    s && ((L = b.current) == null || L.focus());
  }, [s]);
  const W = Le(
    (L) => {
      _(L), u == null || u(L);
    },
    [_, u]
  ), j = (L) => {
    _("");
    const R = n.find(
      (B) => B.type !== "separator" && String(B.value) === L
    );
    R && (i == null || i(R.value, R.item));
  }, O = (L) => {
    l == null || l(L), $(L), setTimeout(() => {
      var R;
      (R = b.current) == null || R.focus();
    }, 0);
  }, I = ve(
    () => D.map(
      (L, R) => L.type === "separator" ? {
        height: 1,
        item: /* @__PURE__ */ d(Hy, {}, `separator-${R}`)
      } : {
        height: L.description ? 64 : 32,
        item: /* @__PURE__ */ d(kW, { item: L }, String(L.value)),
        value: String(L.value)
      }
    ),
    [D]
  );
  return /* @__PURE__ */ k(
    Rm,
    {
      onValueChange: j,
      value: r != null ? String(r) : void 0,
      disabled: o,
      open: s,
      onOpenChange: O,
      ...v,
      children: [
        /* @__PURE__ */ d(_6, { ref: w, asChild: !0, children: a || /* @__PURE__ */ k(
          "button",
          {
            "aria-label": "Select unfoldable",
            className: E(
              _W,
              p,
              Ke("focus-visible:border-f1-border-hover")
            ),
            children: [
              /* @__PURE__ */ d(aW, { placeholder: e, asChild: !0, children: x && /* @__PURE__ */ d(xW, { item: x }) }),
              /* @__PURE__ */ d("div", { className: "flex h-6 w-6 items-center justify-center", children: /* @__PURE__ */ d("div", { className: "h-4 w-4 rounded-2xs bg-f1-background-secondary", children: /* @__PURE__ */ d(
                me,
                {
                  icon: zn,
                  size: "sm",
                  className: "rounded-2xs bg-f1-background-secondary p-0.5"
                }
              ) }) })
            ]
          }
        ) }),
        N && /* @__PURE__ */ d(
          jm,
          {
            items: I,
            className: g,
            emptyMessage: h,
            bottom: /* @__PURE__ */ d(bW, { actions: y }),
            top: /* @__PURE__ */ d(
              wW,
              {
                searchInputRef: b,
                searchValue: M,
                onSearchChange: W,
                searchBoxPlaceholder: f,
                showSearchBox: c
              }
            )
          }
        )
      ]
    }
  );
}), Ca = MW;
var Yy = "Checkbox", [CW, VXe] = Wi(Yy), [PW, SW] = CW(Yy), R6 = S.forwardRef(
  (t, e) => {
    const {
      __scopeCheckbox: n,
      name: i,
      checked: r,
      defaultChecked: a,
      required: o,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...f
    } = t, [m, h] = S.useState(null), p = st(e, (b) => h(b)), g = S.useRef(!1), y = m ? u || !!m.closest("form") : !0, [v = !1, w] = Si({
      prop: r,
      defaultProp: a,
      onChange: c
    }), x = S.useRef(v);
    return S.useEffect(() => {
      const b = m == null ? void 0 : m.form;
      if (b) {
        const M = () => w(x.current);
        return b.addEventListener("reset", M), () => b.removeEventListener("reset", M);
      }
    }, [m, w]), /* @__PURE__ */ k(PW, { scope: n, state: v, disabled: s, children: [
      /* @__PURE__ */ d(
        qe.button,
        {
          type: "button",
          role: "checkbox",
          "aria-checked": ya(v) ? "mixed" : v,
          "aria-required": o,
          "data-state": z6(v),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: p,
          onKeyDown: ge(t.onKeyDown, (b) => {
            b.key === "Enter" && b.preventDefault();
          }),
          onClick: ge(t.onClick, (b) => {
            w((M) => ya(M) ? !0 : !M), y && (g.current = b.isPropagationStopped(), g.current || b.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ d(
        NW,
        {
          control: m,
          bubbles: !g.current,
          name: i,
          value: l,
          checked: v,
          required: o,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" },
          defaultChecked: ya(a) ? !1 : a
        }
      )
    ] });
  }
);
R6.displayName = Yy;
var j6 = "CheckboxIndicator", F6 = S.forwardRef(
  (t, e) => {
    const { __scopeCheckbox: n, forceMount: i, ...r } = t, a = SW(j6, n);
    return /* @__PURE__ */ d(Ji, { present: i || ya(a.state) || a.state === !0, children: /* @__PURE__ */ d(
      qe.span,
      {
        "data-state": z6(a.state),
        "data-disabled": a.disabled ? "" : void 0,
        ...r,
        ref: e,
        style: { pointerEvents: "none", ...t.style }
      }
    ) });
  }
);
F6.displayName = j6;
var NW = (t) => {
  const { control: e, checked: n, bubbles: i = !0, defaultChecked: r, ...a } = t, o = S.useRef(null), s = Fy(n), l = e5(e);
  S.useEffect(() => {
    const u = o.current, f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(f, "checked").set;
    if (s !== n && h) {
      const p = new Event("click", { bubbles: i });
      u.indeterminate = ya(n), h.call(u, ya(n) ? !1 : n), u.dispatchEvent(p);
    }
  }, [s, n, i]);
  const c = S.useRef(ya(n) ? !1 : n);
  return /* @__PURE__ */ d(
    "input",
    {
      type: "checkbox",
      "aria-hidden": !0,
      defaultChecked: r ?? c.current,
      ...a,
      tabIndex: -1,
      ref: o,
      style: {
        ...t.style,
        ...l,
        position: "absolute",
        pointerEvents: "none",
        opacity: 0,
        margin: 0
      }
    }
  );
};
function ya(t) {
  return t === "indeterminate";
}
function z6(t) {
  return ya(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
var V6 = R6, $W = F6;
const Ys = S.forwardRef(({ className: t, indeterminate: e, disabled: n, hideLabel: i, ...r }, a) => {
  const o = Wa(), s = r.id || o;
  return /* @__PURE__ */ k("div", { className: "flex items-center", children: [
    /* @__PURE__ */ d(
      V6,
      {
        ...r,
        ref: a,
        id: s,
        name: s,
        "aria-label": r.title,
        className: E(
          "h-5 w-5 shrink-0 rounded-xs border border-solid border-f1-border text-f1-foreground-selected transition-[background-color,border-color] hover:border-f1-border-hover data-[state=checked]:bg-f1-background-selected-bold data-[state=checked]:text-f1-foreground-inverse hover:data-[state=checked]:border-transparent",
          n && "cursor-not-allowed opacity-50 hover:border-f1-border",
          e && "data-[state=checked]:bg-f1-background data-[state=checked]:text-f1-foreground-selected hover:data-[state=checked]:border-f1-border-hover",
          r.checked && n && "data-[state=checked]:bg-f1-background-secondary data-[state=checked]:text-f1-foreground-secondary",
          Ke(),
          t
        ),
        checked: r.checked,
        onCheckedChange: r.onCheckedChange,
        disabled: n,
        children: /* @__PURE__ */ d(Ue, { children: /* @__PURE__ */ d($W, { className: "flex items-center justify-center text-current transition-none", children: /* @__PURE__ */ d(
          re.div,
          {
            initial: { opacity: 0, scale: 0.6 },
            animate: { opacity: 1, scale: 1 },
            exit: { opacity: 0, scale: 0.6 },
            transition: {
              ease: [0.175, 0.885, 0.32, 1.275],
              duration: 0.4
            },
            className: "flex items-center justify-center",
            children: e ? /* @__PURE__ */ d(me, { icon: jy, size: "sm" }) : /* @__PURE__ */ d(me, { icon: Nm, size: "sm" })
          }
        ) }) })
      }
    ),
    r.title && !i && /* @__PURE__ */ d(
      "label",
      {
        htmlFor: s,
        className: E(
          "flex items-center justify-center pl-2.5 text-current hover:cursor-pointer disabled:cursor-not-allowed disabled:opacity-50",
          n && "cursor-not-allowed opacity-50 hover:cursor-not-allowed"
        ),
        children: r.title
      }
    )
  ] });
});
Ys.displayName = V6.displayName;
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const DW = (t) => t.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase(), H6 = (...t) => t.filter((e, n, i) => !!e && i.indexOf(e) === n).join(" ");
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
var EW = {
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
};
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const TW = X(
  ({
    color: t = "currentColor",
    size: e = 24,
    strokeWidth: n = 2,
    absoluteStrokeWidth: i,
    className: r = "",
    children: a,
    iconNode: o,
    ...s
  }, l) => Gu(
    "svg",
    {
      ref: l,
      ...EW,
      width: e,
      height: e,
      stroke: t,
      strokeWidth: i ? Number(n) * 24 / Number(e) : n,
      className: H6("lucide", r),
      ...s
    },
    [
      ...o.map(([c, u]) => Gu(c, u)),
      ...Array.isArray(a) ? a : [a]
    ]
  )
);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const gr = (t, e) => {
  const n = X(
    ({ className: i, ...r }, a) => Gu(TW, {
      ref: a,
      iconNode: e,
      className: H6(`lucide-${DW(t)}`, i),
      ...r
    })
  );
  return n.displayName = `${t}`, n;
};
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const OW = gr("BookOpen", [
  ["path", { d: "M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z", key: "vv98re" }],
  ["path", { d: "M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z", key: "1cyq3y" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const WW = gr("Check", [["path", { d: "M20 6 9 17l-5-5", key: "1gmf2c" }]]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const AW = gr("ChevronDown", [
  ["path", { d: "m6 9 6 6 6-6", key: "qrunsl" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const LW = gr("ChevronLeft", [
  ["path", { d: "m15 18-6-6 6-6", key: "1wnfg3" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const Ky = gr("ChevronRight", [
  ["path", { d: "m9 18 6-6-6-6", key: "mthhwq" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const IW = gr("CircleCheck", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["path", { d: "m9 12 2 2 4-4", key: "dzmm74" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const RW = gr("Circle", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const jW = gr("OctagonX", [
  [
    "polygon",
    {
      points: "7.86 2 16.14 2 22 7.86 22 16.14 16.14 22 7.86 22 2 16.14 2 7.86 7.86 2",
      key: "h1p8hx"
    }
  ],
  ["path", { d: "m15 9-6 6", key: "1uzhvr" }],
  ["path", { d: "m9 9 6 6", key: "z0biqf" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const FW = gr("Search", [
  ["circle", { cx: "11", cy: "11", r: "8", key: "4ej97u" }],
  ["path", { d: "m21 21-4.3-4.3", key: "1qie3q" }]
]);
/**
 * @license lucide-react v0.383.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const zW = gr("TriangleAlert", [
  [
    "path",
    {
      d: "m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3",
      key: "wmoenq"
    }
  ],
  ["path", { d: "M12 9v4", key: "juzpu7" }],
  ["path", { d: "M12 17h.01", key: "p32p05" }]
]), B6 = ({
  text: t,
  search: e,
  searchKeys: n = [],
  semiBold: i = !1
}) => {
  if (!e)
    return /* @__PURE__ */ d("span", { className: E("line-clamp-1", i ? "font-semibold" : ""), children: t });
  if (t.toLowerCase().indexOf(e.toLowerCase()) === -1)
    if (n.find(
      (o) => o.toLowerCase().indexOf(e.toLowerCase().trim()) >= 0
    ))
      e = t.split(" ")[0];
    else
      return /* @__PURE__ */ d("span", { className: E("line-clamp-1", i ? "font-semibold" : ""), children: t });
  const r = new RegExp(`(${e})`, "gi"), a = t.split(r);
  return /* @__PURE__ */ d("span", { className: E("line-clamp-1", i ? "font-semibold" : ""), children: a.map(
    (o, s) => o.toLowerCase() === e.toLowerCase() ? /* @__PURE__ */ d(
      "span",
      {
        className: "truncate font-medium",
        style: {
          fontWeight: "bold"
        },
        children: o
      },
      s
    ) : o
  ) });
};
function zm(t, e) {
  const i = Array.from(
    document.querySelectorAll('[data-avatarname-navigator-element="true"]')
  ), r = i.indexOf(t);
  r >= 0 && r < i.length - 1 ? i[r + 1].focus() : i.length > 0 && (e == null || e());
}
function Vm(t, e) {
  const i = Array.from(
    document.querySelectorAll('[data-avatarname-navigator-element="true"]')
  ), r = i.indexOf(t);
  r > 0 ? i[r - 1].focus() : i.length > 0 && (e == null || e());
}
const VW = ({
  entity: t,
  selected: e,
  onSelect: n,
  onRemove: i,
  marginLeft: r,
  search: a,
  goToFirst: o,
  goToLast: s,
  singleSelector: l = !1,
  disabled: c = !1,
  hiddenAvatar: u = !1
}) => {
  const f = t.name.split(" "), m = f[0] || "", h = f.slice(1).join(" "), p = (y) => {
    y.preventDefault(), y.stopPropagation(), !c && (e ? i(t) : n(t));
  }, g = (y) => {
    if (y.key === "Enter" || y.key === " ") {
      if (y.preventDefault(), c) return;
      e ? e && i(t) : n(t);
    } else y.key === "ArrowDown" ? zm(y.currentTarget, o) : y.key === "ArrowUp" && Vm(y.currentTarget, s);
  };
  return /* @__PURE__ */ d("div", { className: "w-full pl-1 pr-1", children: /* @__PURE__ */ k(
    "label",
    {
      "aria-label": t.name,
      className: E(
        r,
        "flex flex-row flex-wrap items-center gap-2 rounded-[10px] border p-2 hover:cursor-pointer",
        "focus-within:outline focus-within:outline-1 focus-within:-outline-offset-1 focus-within:outline-f1-border-selected-bold hover:bg-f1-background-hover",
        e && l ? "bg-f1-background-selected-bold/10 transition-colors dark:bg-f1-background-selected-bold/20" : ""
      ),
      children: [
        !u && /* @__PURE__ */ d(
          ti,
          {
            src: t.avatar,
            firstName: m,
            lastName: h,
            size: "xsmall"
          }
        ),
        /* @__PURE__ */ d("div", { className: "flex flex-1 flex-col", children: /* @__PURE__ */ d("div", { className: "flex flex-1 flex-row items-center gap-2 break-all", children: /* @__PURE__ */ d(
          B6,
          {
            text: t.name,
            search: a,
            searchKeys: t.searchKeys
          }
        ) }) }),
        /* @__PURE__ */ d(
          Ys,
          {
            "data-avatarname-navigator-element": "true",
            checked: e,
            disabled: c,
            onClick: p,
            onKeyDown: g,
            className: E(
              "pointer-events-none ml-auto h-[20px] w-[20px] rounded-xs border-[1px] data-[state=checked]:text-f1-foreground-inverse",
              l ? "opacity-0" : ""
            ),
            style: {
              backgroundColor: e ? "hsl(var(--selected-50))" : void 0,
              borderColor: e ? "hsl(var(--selected-50))" : void 0
            }
          }
        ),
        l && e && /* @__PURE__ */ d(
          me,
          {
            className: "text-f1-icon-selected",
            icon: Py,
            size: "md"
          }
        )
      ]
    }
  ) });
}, yu = ({
  groupView: t,
  expanded: e,
  search: n,
  entity: i,
  selected: r,
  partialSelected: a,
  onSelect: o,
  onRemove: s,
  onExpand: l,
  goToFirst: c,
  goToLast: u,
  isChild: f = !1,
  hideLine: m = !1,
  showGroupIcon: h = !1,
  singleSelector: p = !1,
  disabled: g = !1,
  hiddenAvatar: y = !1
}) => {
  var _, N;
  const [v, w] = q(!1);
  if (!t)
    return /* @__PURE__ */ d(
      VW,
      {
        marginLeft: f ? "ml-6" : "ml-0",
        entity: i,
        search: n,
        selected: r,
        onSelect: o,
        onRemove: s,
        singleSelector: p,
        goToFirst: c,
        goToLast: u,
        disabled: g,
        hiddenAvatar: y
      }
    );
  const x = ($) => {
    if ($.key === " ")
      $.preventDefault(), l(!e);
    else if ($.key === "Enter" && p)
      l(!e);
    else if ($.key === "Enter") {
      if (g) return;
      !r || a ? o(i) : r && s(i);
    } else $.key === "ArrowDown" ? zm($.currentTarget, c) : $.key === "ArrowUp" && Vm($.currentTarget, u);
  }, b = () => {
    if (v)
      l(!e), w(!1);
    else {
      if (g || p) return;
      r ? s(i) : o(i);
    }
  };
  if (!((_ = i.subItems) != null && _.length)) return null;
  const M = r || a;
  return /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ k("div", { className: "flex w-full flex-row flex-wrap items-center gap-0 rounded-md border pl-1 pr-1", children: [
      /* @__PURE__ */ d(
        ue,
        {
          round: !0,
          hideLabel: !0,
          icon: e ? AW : Ky,
          onClick: () => l(!e),
          label: e ? "Collapse" : "Expand",
          size: "sm",
          variant: "ghost",
          type: "button"
        }
      ),
      /* @__PURE__ */ k(
        "label",
        {
          "aria-label": i.name,
          onPointerDown: () => {
            w(!0);
          },
          className: "flex flex-1 flex-row items-center gap-2 rounded-[10px] border p-2 focus-within:outline focus-within:outline-1 focus-within:-outline-offset-1 focus-within:outline-f1-border-selected-bold hover:cursor-pointer hover:bg-f1-background-hover",
          children: [
            h && /* @__PURE__ */ d(
              me,
              {
                icon: IE,
                className: "rounded-xs bg-f1-foreground-secondary text-f1-foreground-inverse"
              }
            ),
            /* @__PURE__ */ k("div", { className: "flex flex-grow flex-row items-center gap-2 break-all", children: [
              /* @__PURE__ */ d(
                B6,
                {
                  semiBold: !0,
                  text: i.name,
                  search: n,
                  searchKeys: i.searchKeys
                }
              ),
              /* @__PURE__ */ d(Lo, { value: ((N = i.subItems) == null ? void 0 : N.length) ?? 0 })
            ] }),
            /* @__PURE__ */ d(
              Ys,
              {
                checked: M,
                disabled: g,
                onClick: b,
                onKeyDown: x,
                indeterminate: a,
                onPointerDown: ($) => {
                  $.stopPropagation(), w(!1);
                },
                "data-avatarname-navigator-element": "true",
                className: E(
                  "ml-auto h-[20px] w-[20px] rounded-xs border-[1px] data-[state=checked]:text-f1-foreground-inverse",
                  p ? "opacity-0" : ""
                ),
                style: {
                  backgroundColor: r ? "hsl(var(--selected-50))" : "hsl(var(--background))",
                  color: !r && a ? "hsl(var(--selected-50))" : void 0,
                  borderColor: M ? "hsl(var(--selected-50))" : void 0
                }
              }
            )
          ]
        }
      )
    ] }),
    !m && !e && /* @__PURE__ */ d("div", { className: "h-[1px] w-full bg-f1-border-secondary" })
  ] });
};
yu.displayName = "EntitySelectListItem";
const $w = ({
  label: t,
  onCreate: e,
  goToFirst: n,
  goToLast: i
}) => /* @__PURE__ */ d("div", { className: "w-full pl-1 pr-1", onKeyDown: (a) => {
  a.key === "ArrowDown" || a.key === "Tab" ? zm(a.currentTarget, n) : a.key === "ArrowUp" && Vm(a.currentTarget, i);
}, children: /* @__PURE__ */ k(
  "label",
  {
    "aria-label": t,
    className: E(
      "flex flex-row flex-wrap items-center gap-1.5 rounded-[10px] border px-1.5 py-1.5 hover:cursor-pointer",
      "focus-within:outline focus-within:outline-1 focus-within:-outline-offset-1 focus-within:outline-f1-border-selected-bold hover:bg-f1-background-hover",
      "select-none"
    ),
    children: [
      /* @__PURE__ */ d(
        ue,
        {
          hideLabel: !0,
          label: t,
          onClick: () => e(),
          icon: O5,
          round: !0,
          size: "sm",
          variant: "outline"
        }
      ),
      /* @__PURE__ */ d("div", { className: "flex flex-1 flex-col", children: /* @__PURE__ */ d("div", { className: "flex flex-1 flex-row items-center gap-2 break-all", children: /* @__PURE__ */ d("span", { className: E("line-clamp-1"), children: t }) }) })
    ]
  }
) });
var Gh = "rovingFocusGroup.onEntryFocus", HW = { bubbles: !1, cancelable: !0 }, Hm = "RovingFocusGroup", [Ap, q6, BW] = ic(Hm), [qW, Bm] = Wi(
  Hm,
  [BW]
), [GW, XW] = qW(Hm), G6 = S.forwardRef(
  (t, e) => /* @__PURE__ */ d(Ap.Provider, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(Ap.Slot, { scope: t.__scopeRovingFocusGroup, children: /* @__PURE__ */ d(YW, { ...t, ref: e }) }) })
);
G6.displayName = Hm;
var YW = S.forwardRef((t, e) => {
  const {
    __scopeRovingFocusGroup: n,
    orientation: i,
    loop: r = !1,
    dir: a,
    currentTabStopId: o,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...f
  } = t, m = S.useRef(null), h = st(e, m), p = Vd(a), [g = null, y] = Si({
    prop: o,
    defaultProp: s,
    onChange: l
  }), [v, w] = S.useState(!1), x = Wn(c), b = q6(n), M = S.useRef(!1), [_, N] = S.useState(0);
  return S.useEffect(() => {
    const $ = m.current;
    if ($)
      return $.addEventListener(Gh, x), () => $.removeEventListener(Gh, x);
  }, [x]), /* @__PURE__ */ d(
    GW,
    {
      scope: n,
      orientation: i,
      dir: p,
      loop: r,
      currentTabStopId: g,
      onItemFocus: S.useCallback(
        ($) => y($),
        [y]
      ),
      onItemShiftTab: S.useCallback(() => w(!0), []),
      onFocusableItemAdd: S.useCallback(
        () => N(($) => $ + 1),
        []
      ),
      onFocusableItemRemove: S.useCallback(
        () => N(($) => $ - 1),
        []
      ),
      children: /* @__PURE__ */ d(
        qe.div,
        {
          tabIndex: v || _ === 0 ? -1 : 0,
          "data-orientation": i,
          ...f,
          ref: h,
          style: { outline: "none", ...t.style },
          onMouseDown: ge(t.onMouseDown, () => {
            M.current = !0;
          }),
          onFocus: ge(t.onFocus, ($) => {
            const D = !M.current;
            if ($.target === $.currentTarget && D && !v) {
              const W = new CustomEvent(Gh, HW);
              if ($.currentTarget.dispatchEvent(W), !W.defaultPrevented) {
                const j = b().filter((B) => B.focusable), O = j.find((B) => B.active), I = j.find((B) => B.id === g), R = [O, I, ...j].filter(
                  Boolean
                ).map((B) => B.ref.current);
                K6(R, u);
              }
            }
            M.current = !1;
          }),
          onBlur: ge(t.onBlur, () => w(!1))
        }
      )
    }
  );
}), X6 = "RovingFocusGroupItem", Y6 = S.forwardRef(
  (t, e) => {
    const {
      __scopeRovingFocusGroup: n,
      focusable: i = !0,
      active: r = !1,
      tabStopId: a,
      ...o
    } = t, s = Ir(), l = a || s, c = XW(X6, n), u = c.currentTabStopId === l, f = q6(n), { onFocusableItemAdd: m, onFocusableItemRemove: h } = c;
    return S.useEffect(() => {
      if (i)
        return m(), () => h();
    }, [i, m, h]), /* @__PURE__ */ d(
      Ap.ItemSlot,
      {
        scope: n,
        id: l,
        focusable: i,
        active: r,
        children: /* @__PURE__ */ d(
          qe.span,
          {
            tabIndex: u ? 0 : -1,
            "data-orientation": c.orientation,
            ...o,
            ref: e,
            onMouseDown: ge(t.onMouseDown, (p) => {
              i ? c.onItemFocus(l) : p.preventDefault();
            }),
            onFocus: ge(t.onFocus, () => c.onItemFocus(l)),
            onKeyDown: ge(t.onKeyDown, (p) => {
              if (p.key === "Tab" && p.shiftKey) {
                c.onItemShiftTab();
                return;
              }
              if (p.target !== p.currentTarget) return;
              const g = JW(p, c.orientation, c.dir);
              if (g !== void 0) {
                if (p.metaKey || p.ctrlKey || p.altKey || p.shiftKey) return;
                p.preventDefault();
                let v = f().filter((w) => w.focusable).map((w) => w.ref.current);
                if (g === "last") v.reverse();
                else if (g === "prev" || g === "next") {
                  g === "prev" && v.reverse();
                  const w = v.indexOf(p.currentTarget);
                  v = c.loop ? QW(v, w + 1) : v.slice(w + 1);
                }
                setTimeout(() => K6(v));
              }
            })
          }
        )
      }
    );
  }
);
Y6.displayName = X6;
var KW = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function UW(t, e) {
  return e !== "rtl" ? t : t === "ArrowLeft" ? "ArrowRight" : t === "ArrowRight" ? "ArrowLeft" : t;
}
function JW(t, e, n) {
  const i = UW(t.key, n);
  if (!(e === "vertical" && ["ArrowLeft", "ArrowRight"].includes(i)) && !(e === "horizontal" && ["ArrowUp", "ArrowDown"].includes(i)))
    return KW[i];
}
function K6(t, e = !1) {
  const n = document.activeElement;
  for (const i of t)
    if (i === n || (i.focus({ preventScroll: e }), document.activeElement !== n)) return;
}
function QW(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
var U6 = G6, J6 = Y6, Lp = ["Enter", " "], ZW = ["ArrowDown", "PageUp", "Home"], Q6 = ["ArrowUp", "PageDown", "End"], eA = [...ZW, ...Q6], tA = {
  ltr: [...Lp, "ArrowRight"],
  rtl: [...Lp, "ArrowLeft"]
}, nA = {
  ltr: ["ArrowLeft"],
  rtl: ["ArrowRight"]
}, oc = "Menu", [dd, iA, rA] = ic(oc), [Oo, Z6] = Wi(oc, [
  rA,
  Pm,
  Bm
]), qm = Pm(), e_ = Bm(), [aA, Wo] = Oo(oc), [oA, sc] = Oo(oc), t_ = (t) => {
  const { __scopeMenu: e, open: n = !1, children: i, dir: r, onOpenChange: a, modal: o = !0 } = t, s = qm(e), [l, c] = S.useState(null), u = S.useRef(!1), f = Wn(a), m = Vd(r);
  return S.useEffect(() => {
    const h = () => {
      u.current = !0, document.addEventListener("pointerdown", p, { capture: !0, once: !0 }), document.addEventListener("pointermove", p, { capture: !0, once: !0 });
    }, p = () => u.current = !1;
    return document.addEventListener("keydown", h, { capture: !0 }), () => {
      document.removeEventListener("keydown", h, { capture: !0 }), document.removeEventListener("pointerdown", p, { capture: !0 }), document.removeEventListener("pointermove", p, { capture: !0 });
    };
  }, []), /* @__PURE__ */ d(F4, { ...s, children: /* @__PURE__ */ d(
    aA,
    {
      scope: e,
      open: n,
      onOpenChange: f,
      content: l,
      onContentChange: c,
      children: /* @__PURE__ */ d(
        oA,
        {
          scope: e,
          onClose: S.useCallback(() => f(!1), [f]),
          isUsingKeyboardRef: u,
          dir: m,
          modal: o,
          children: i
        }
      )
    }
  ) });
};
t_.displayName = oc;
var sA = "MenuAnchor", Uy = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = qm(n);
    return /* @__PURE__ */ d(z4, { ...r, ...i, ref: e });
  }
);
Uy.displayName = sA;
var Jy = "MenuPortal", [lA, n_] = Oo(Jy, {
  forceMount: void 0
}), i_ = (t) => {
  const { __scopeMenu: e, forceMount: n, children: i, container: r } = t, a = Wo(Jy, e);
  return /* @__PURE__ */ d(lA, { scope: e, forceMount: n, children: /* @__PURE__ */ d(Ji, { present: n || a.open, children: /* @__PURE__ */ d(V4, { asChild: !0, container: r, children: i }) }) });
};
i_.displayName = Jy;
var _i = "MenuContent", [dA, Qy] = Oo(_i), r_ = S.forwardRef(
  (t, e) => {
    const n = n_(_i, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, a = Wo(_i, t.__scopeMenu), o = sc(_i, t.__scopeMenu);
    return /* @__PURE__ */ d(dd.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ d(Ji, { present: i || a.open, children: /* @__PURE__ */ d(dd.Slot, { scope: t.__scopeMenu, children: o.modal ? /* @__PURE__ */ d(cA, { ...r, ref: e }) : /* @__PURE__ */ d(uA, { ...r, ref: e }) }) }) });
  }
), cA = S.forwardRef(
  (t, e) => {
    const n = Wo(_i, t.__scopeMenu), i = S.useRef(null), r = st(e, i);
    return S.useEffect(() => {
      const a = i.current;
      if (a) return H4(a);
    }, []), /* @__PURE__ */ d(
      Zy,
      {
        ...t,
        ref: r,
        trapFocus: n.open,
        disableOutsidePointerEvents: n.open,
        disableOutsideScroll: !0,
        onFocusOutside: ge(
          t.onFocusOutside,
          (a) => a.preventDefault(),
          { checkForDefaultPrevented: !1 }
        ),
        onDismiss: () => n.onOpenChange(!1)
      }
    );
  }
), uA = S.forwardRef((t, e) => {
  const n = Wo(_i, t.__scopeMenu);
  return /* @__PURE__ */ d(
    Zy,
    {
      ...t,
      ref: e,
      trapFocus: !1,
      disableOutsidePointerEvents: !1,
      disableOutsideScroll: !1,
      onDismiss: () => n.onOpenChange(!1)
    }
  );
}), Zy = S.forwardRef(
  (t, e) => {
    const {
      __scopeMenu: n,
      loop: i = !1,
      trapFocus: r,
      onOpenAutoFocus: a,
      onCloseAutoFocus: o,
      disableOutsidePointerEvents: s,
      onEntryFocus: l,
      onEscapeKeyDown: c,
      onPointerDownOutside: u,
      onFocusOutside: f,
      onInteractOutside: m,
      onDismiss: h,
      disableOutsideScroll: p,
      ...g
    } = t, y = Wo(_i, n), v = sc(_i, n), w = qm(n), x = e_(n), b = iA(n), [M, _] = S.useState(null), N = S.useRef(null), $ = st(e, N, y.onContentChange), D = S.useRef(0), W = S.useRef(""), j = S.useRef(0), O = S.useRef(null), I = S.useRef("right"), L = S.useRef(0), R = p ? q4 : S.Fragment, B = p ? { as: Bu, allowPinchZoom: !0 } : void 0, F = (K) => {
      var Y, oe;
      const ae = W.current + K, Q = b().filter((se) => !se.disabled), te = document.activeElement, be = (Y = Q.find((se) => se.ref.current === te)) == null ? void 0 : Y.textValue, Pe = Q.map((se) => se.textValue), We = _A(Pe, ae, be), $e = (oe = Q.find((se) => se.textValue === We)) == null ? void 0 : oe.ref.current;
      (function se(J) {
        W.current = J, window.clearTimeout(D.current), J !== "" && (D.current = window.setTimeout(() => se(""), 1e3));
      })(ae), $e && setTimeout(() => $e.focus());
    };
    S.useEffect(() => () => window.clearTimeout(D.current), []), B4();
    const z = S.useCallback((K) => {
      var Q, te;
      return I.current === ((Q = O.current) == null ? void 0 : Q.side) && CA(K, (te = O.current) == null ? void 0 : te.area);
    }, []);
    return /* @__PURE__ */ d(
      dA,
      {
        scope: n,
        searchRef: W,
        onItemEnter: S.useCallback(
          (K) => {
            z(K) && K.preventDefault();
          },
          [z]
        ),
        onItemLeave: S.useCallback(
          (K) => {
            var ae;
            z(K) || ((ae = N.current) == null || ae.focus(), _(null));
          },
          [z]
        ),
        onTriggerLeave: S.useCallback(
          (K) => {
            z(K) && K.preventDefault();
          },
          [z]
        ),
        pointerGraceTimerRef: j,
        onPointerGraceIntentChange: S.useCallback((K) => {
          O.current = K;
        }, []),
        children: /* @__PURE__ */ d(R, { ...B, children: /* @__PURE__ */ d(
          G4,
          {
            asChild: !0,
            trapped: r,
            onMountAutoFocus: ge(a, (K) => {
              var ae;
              K.preventDefault(), (ae = N.current) == null || ae.focus({ preventScroll: !0 });
            }),
            onUnmountAutoFocus: o,
            children: /* @__PURE__ */ d(
              Cy,
              {
                asChild: !0,
                disableOutsidePointerEvents: s,
                onEscapeKeyDown: c,
                onPointerDownOutside: u,
                onFocusOutside: f,
                onInteractOutside: m,
                onDismiss: h,
                children: /* @__PURE__ */ d(
                  U6,
                  {
                    asChild: !0,
                    ...x,
                    dir: v.dir,
                    orientation: "vertical",
                    loop: i,
                    currentTabStopId: M,
                    onCurrentTabStopIdChange: _,
                    onEntryFocus: ge(l, (K) => {
                      v.isUsingKeyboardRef.current || K.preventDefault();
                    }),
                    preventScrollOnEntryFocus: !0,
                    children: /* @__PURE__ */ d(
                      X4,
                      {
                        role: "menu",
                        "aria-orientation": "vertical",
                        "data-state": w_(y.open),
                        "data-radix-menu-content": "",
                        dir: v.dir,
                        ...w,
                        ...g,
                        ref: $,
                        style: { outline: "none", ...g.style },
                        onKeyDown: ge(g.onKeyDown, (K) => {
                          const Q = K.target.closest("[data-radix-menu-content]") === K.currentTarget, te = K.ctrlKey || K.altKey || K.metaKey, be = K.key.length === 1;
                          Q && (K.key === "Tab" && K.preventDefault(), !te && be && F(K.key));
                          const Pe = N.current;
                          if (K.target !== Pe || !eA.includes(K.key)) return;
                          K.preventDefault();
                          const $e = b().filter((Y) => !Y.disabled).map((Y) => Y.ref.current);
                          Q6.includes(K.key) && $e.reverse(), kA($e);
                        }),
                        onBlur: ge(t.onBlur, (K) => {
                          K.currentTarget.contains(K.target) || (window.clearTimeout(D.current), W.current = "");
                        }),
                        onPointerMove: ge(
                          t.onPointerMove,
                          cd((K) => {
                            const ae = K.target, Q = L.current !== K.clientX;
                            if (K.currentTarget.contains(ae) && Q) {
                              const te = K.clientX > L.current ? "right" : "left";
                              I.current = te, L.current = K.clientX;
                            }
                          })
                        )
                      }
                    )
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
r_.displayName = _i;
var fA = "MenuGroup", ev = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ d(qe.div, { role: "group", ...i, ref: e });
  }
);
ev.displayName = fA;
var mA = "MenuLabel", a_ = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ d(qe.div, { ...i, ref: e });
  }
);
a_.displayName = mA;
var Ju = "MenuItem", Dw = "menu.itemSelect", Gm = S.forwardRef(
  (t, e) => {
    const { disabled: n = !1, onSelect: i, ...r } = t, a = S.useRef(null), o = sc(Ju, t.__scopeMenu), s = Qy(Ju, t.__scopeMenu), l = st(e, a), c = S.useRef(!1), u = () => {
      const f = a.current;
      if (!n && f) {
        const m = new CustomEvent(Dw, { bubbles: !0, cancelable: !0 });
        f.addEventListener(Dw, (h) => i == null ? void 0 : i(h), { once: !0 }), Mp(f, m), m.defaultPrevented ? c.current = !1 : o.onClose();
      }
    };
    return /* @__PURE__ */ d(
      o_,
      {
        ...r,
        ref: l,
        disabled: n,
        onClick: ge(t.onClick, u),
        onPointerDown: (f) => {
          var m;
          (m = t.onPointerDown) == null || m.call(t, f), c.current = !0;
        },
        onPointerUp: ge(t.onPointerUp, (f) => {
          var m;
          c.current || (m = f.currentTarget) == null || m.click();
        }),
        onKeyDown: ge(t.onKeyDown, (f) => {
          const m = s.searchRef.current !== "";
          n || m && f.key === " " || Lp.includes(f.key) && (f.currentTarget.click(), f.preventDefault());
        })
      }
    );
  }
);
Gm.displayName = Ju;
var o_ = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, disabled: i = !1, textValue: r, ...a } = t, o = Qy(Ju, n), s = e_(n), l = S.useRef(null), c = st(e, l), [u, f] = S.useState(!1), [m, h] = S.useState("");
    return S.useEffect(() => {
      const p = l.current;
      p && h((p.textContent ?? "").trim());
    }, [a.children]), /* @__PURE__ */ d(
      dd.ItemSlot,
      {
        scope: n,
        disabled: i,
        textValue: r ?? m,
        children: /* @__PURE__ */ d(J6, { asChild: !0, ...s, focusable: !i, children: /* @__PURE__ */ d(
          qe.div,
          {
            role: "menuitem",
            "data-highlighted": u ? "" : void 0,
            "aria-disabled": i || void 0,
            "data-disabled": i ? "" : void 0,
            ...a,
            ref: c,
            onPointerMove: ge(
              t.onPointerMove,
              cd((p) => {
                i ? o.onItemLeave(p) : (o.onItemEnter(p), p.defaultPrevented || p.currentTarget.focus({ preventScroll: !0 }));
              })
            ),
            onPointerLeave: ge(
              t.onPointerLeave,
              cd((p) => o.onItemLeave(p))
            ),
            onFocus: ge(t.onFocus, () => f(!0)),
            onBlur: ge(t.onBlur, () => f(!1))
          }
        ) })
      }
    );
  }
), hA = "MenuCheckboxItem", s_ = S.forwardRef(
  (t, e) => {
    const { checked: n = !1, onCheckedChange: i, ...r } = t;
    return /* @__PURE__ */ d(f_, { scope: t.__scopeMenu, checked: n, children: /* @__PURE__ */ d(
      Gm,
      {
        role: "menuitemcheckbox",
        "aria-checked": Qu(n) ? "mixed" : n,
        ...r,
        ref: e,
        "data-state": nv(n),
        onSelect: ge(
          r.onSelect,
          () => i == null ? void 0 : i(Qu(n) ? !0 : !n),
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
s_.displayName = hA;
var l_ = "MenuRadioGroup", [pA, gA] = Oo(
  l_,
  { value: void 0, onValueChange: () => {
  } }
), d_ = S.forwardRef(
  (t, e) => {
    const { value: n, onValueChange: i, ...r } = t, a = Wn(i);
    return /* @__PURE__ */ d(pA, { scope: t.__scopeMenu, value: n, onValueChange: a, children: /* @__PURE__ */ d(ev, { ...r, ref: e }) });
  }
);
d_.displayName = l_;
var c_ = "MenuRadioItem", u_ = S.forwardRef(
  (t, e) => {
    const { value: n, ...i } = t, r = gA(c_, t.__scopeMenu), a = n === r.value;
    return /* @__PURE__ */ d(f_, { scope: t.__scopeMenu, checked: a, children: /* @__PURE__ */ d(
      Gm,
      {
        role: "menuitemradio",
        "aria-checked": a,
        ...i,
        ref: e,
        "data-state": nv(a),
        onSelect: ge(
          i.onSelect,
          () => {
            var o;
            return (o = r.onValueChange) == null ? void 0 : o.call(r, n);
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
u_.displayName = c_;
var tv = "MenuItemIndicator", [f_, yA] = Oo(
  tv,
  { checked: !1 }
), m_ = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, forceMount: i, ...r } = t, a = yA(tv, n);
    return /* @__PURE__ */ d(
      Ji,
      {
        present: i || Qu(a.checked) || a.checked === !0,
        children: /* @__PURE__ */ d(
          qe.span,
          {
            ...r,
            ref: e,
            "data-state": nv(a.checked)
          }
        )
      }
    );
  }
);
m_.displayName = tv;
var vA = "MenuSeparator", h_ = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t;
    return /* @__PURE__ */ d(
      qe.div,
      {
        role: "separator",
        "aria-orientation": "horizontal",
        ...i,
        ref: e
      }
    );
  }
);
h_.displayName = vA;
var bA = "MenuArrow", p_ = S.forwardRef(
  (t, e) => {
    const { __scopeMenu: n, ...i } = t, r = qm(n);
    return /* @__PURE__ */ d(Y4, { ...r, ...i, ref: e });
  }
);
p_.displayName = bA;
var wA = "MenuSub", [HXe, g_] = Oo(wA), Tl = "MenuSubTrigger", y_ = S.forwardRef(
  (t, e) => {
    const n = Wo(Tl, t.__scopeMenu), i = sc(Tl, t.__scopeMenu), r = g_(Tl, t.__scopeMenu), a = Qy(Tl, t.__scopeMenu), o = S.useRef(null), { pointerGraceTimerRef: s, onPointerGraceIntentChange: l } = a, c = { __scopeMenu: t.__scopeMenu }, u = S.useCallback(() => {
      o.current && window.clearTimeout(o.current), o.current = null;
    }, []);
    return S.useEffect(() => u, [u]), S.useEffect(() => {
      const f = s.current;
      return () => {
        window.clearTimeout(f), l(null);
      };
    }, [s, l]), /* @__PURE__ */ d(Uy, { asChild: !0, ...c, children: /* @__PURE__ */ d(
      o_,
      {
        id: r.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": n.open,
        "aria-controls": r.contentId,
        "data-state": w_(n.open),
        ...t,
        ref: Sy(e, r.onTriggerChange),
        onClick: (f) => {
          var m;
          (m = t.onClick) == null || m.call(t, f), !(t.disabled || f.defaultPrevented) && (f.currentTarget.focus(), n.open || n.onOpenChange(!0));
        },
        onPointerMove: ge(
          t.onPointerMove,
          cd((f) => {
            a.onItemEnter(f), !f.defaultPrevented && !t.disabled && !n.open && !o.current && (a.onPointerGraceIntentChange(null), o.current = window.setTimeout(() => {
              n.onOpenChange(!0), u();
            }, 100));
          })
        ),
        onPointerLeave: ge(
          t.onPointerLeave,
          cd((f) => {
            var h, p;
            u();
            const m = (h = n.content) == null ? void 0 : h.getBoundingClientRect();
            if (m) {
              const g = (p = n.content) == null ? void 0 : p.dataset.side, y = g === "right", v = y ? -5 : 5, w = m[y ? "left" : "right"], x = m[y ? "right" : "left"];
              a.onPointerGraceIntentChange({
                area: [
                  // Apply a bleed on clientX to ensure that our exit point is
                  // consistently within polygon bounds
                  { x: f.clientX + v, y: f.clientY },
                  { x: w, y: m.top },
                  { x, y: m.top },
                  { x, y: m.bottom },
                  { x: w, y: m.bottom }
                ],
                side: g
              }), window.clearTimeout(s.current), s.current = window.setTimeout(
                () => a.onPointerGraceIntentChange(null),
                300
              );
            } else {
              if (a.onTriggerLeave(f), f.defaultPrevented) return;
              a.onPointerGraceIntentChange(null);
            }
          })
        ),
        onKeyDown: ge(t.onKeyDown, (f) => {
          var h;
          const m = a.searchRef.current !== "";
          t.disabled || m && f.key === " " || tA[i.dir].includes(f.key) && (n.onOpenChange(!0), (h = n.content) == null || h.focus(), f.preventDefault());
        })
      }
    ) });
  }
);
y_.displayName = Tl;
var v_ = "MenuSubContent", b_ = S.forwardRef(
  (t, e) => {
    const n = n_(_i, t.__scopeMenu), { forceMount: i = n.forceMount, ...r } = t, a = Wo(_i, t.__scopeMenu), o = sc(_i, t.__scopeMenu), s = g_(v_, t.__scopeMenu), l = S.useRef(null), c = st(e, l);
    return /* @__PURE__ */ d(dd.Provider, { scope: t.__scopeMenu, children: /* @__PURE__ */ d(Ji, { present: i || a.open, children: /* @__PURE__ */ d(dd.Slot, { scope: t.__scopeMenu, children: /* @__PURE__ */ d(
      Zy,
      {
        id: s.contentId,
        "aria-labelledby": s.triggerId,
        ...r,
        ref: c,
        align: "start",
        side: o.dir === "rtl" ? "left" : "right",
        disableOutsidePointerEvents: !1,
        disableOutsideScroll: !1,
        trapFocus: !1,
        onOpenAutoFocus: (u) => {
          var f;
          o.isUsingKeyboardRef.current && ((f = l.current) == null || f.focus()), u.preventDefault();
        },
        onCloseAutoFocus: (u) => u.preventDefault(),
        onFocusOutside: ge(t.onFocusOutside, (u) => {
          u.target !== s.trigger && a.onOpenChange(!1);
        }),
        onEscapeKeyDown: ge(t.onEscapeKeyDown, (u) => {
          o.onClose(), u.preventDefault();
        }),
        onKeyDown: ge(t.onKeyDown, (u) => {
          var h;
          const f = u.currentTarget.contains(u.target), m = nA[o.dir].includes(u.key);
          f && m && (a.onOpenChange(!1), (h = s.trigger) == null || h.focus(), u.preventDefault());
        })
      }
    ) }) }) });
  }
);
b_.displayName = v_;
function w_(t) {
  return t ? "open" : "closed";
}
function Qu(t) {
  return t === "indeterminate";
}
function nv(t) {
  return Qu(t) ? "indeterminate" : t ? "checked" : "unchecked";
}
function kA(t) {
  const e = document.activeElement;
  for (const n of t)
    if (n === e || (n.focus(), document.activeElement !== e)) return;
}
function xA(t, e) {
  return t.map((n, i) => t[(e + i) % t.length]);
}
function _A(t, e, n) {
  const r = e.length > 1 && Array.from(e).every((c) => c === e[0]) ? e[0] : e, a = n ? t.indexOf(n) : -1;
  let o = xA(t, Math.max(a, 0));
  r.length === 1 && (o = o.filter((c) => c !== n));
  const l = o.find(
    (c) => c.toLowerCase().startsWith(r.toLowerCase())
  );
  return l !== n ? l : void 0;
}
function MA(t, e) {
  const { x: n, y: i } = t;
  let r = !1;
  for (let a = 0, o = e.length - 1; a < e.length; o = a++) {
    const s = e[a].x, l = e[a].y, c = e[o].x, u = e[o].y;
    l > i != u > i && n < (c - s) * (i - l) / (u - l) + s && (r = !r);
  }
  return r;
}
function CA(t, e) {
  if (!e) return !1;
  const n = { x: t.clientX, y: t.clientY };
  return MA(n, e);
}
function cd(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var PA = t_, SA = Uy, NA = i_, $A = r_, DA = ev, EA = a_, TA = Gm, OA = s_, WA = d_, AA = u_, LA = m_, IA = h_, RA = p_, jA = y_, FA = b_, iv = "DropdownMenu", [zA, BXe] = Wi(
  iv,
  [Z6]
), Vn = Z6(), [VA, k_] = zA(iv), x_ = (t) => {
  const {
    __scopeDropdownMenu: e,
    children: n,
    dir: i,
    open: r,
    defaultOpen: a,
    onOpenChange: o,
    modal: s = !0
  } = t, l = Vn(e), c = S.useRef(null), [u = !1, f] = Si({
    prop: r,
    defaultProp: a,
    onChange: o
  });
  return /* @__PURE__ */ d(
    VA,
    {
      scope: e,
      triggerId: Ir(),
      triggerRef: c,
      contentId: Ir(),
      open: u,
      onOpenChange: f,
      onOpenToggle: S.useCallback(() => f((m) => !m), [f]),
      modal: s,
      children: /* @__PURE__ */ d(PA, { ...l, open: u, onOpenChange: f, dir: i, modal: s, children: n })
    }
  );
};
x_.displayName = iv;
var __ = "DropdownMenuTrigger", M_ = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, disabled: i = !1, ...r } = t, a = k_(__, n), o = Vn(n);
    return /* @__PURE__ */ d(SA, { asChild: !0, ...o, children: /* @__PURE__ */ d(
      qe.button,
      {
        type: "button",
        id: a.triggerId,
        "aria-haspopup": "menu",
        "aria-expanded": a.open,
        "aria-controls": a.open ? a.contentId : void 0,
        "data-state": a.open ? "open" : "closed",
        "data-disabled": i ? "" : void 0,
        disabled: i,
        ...r,
        ref: Sy(e, a.triggerRef),
        onPointerDown: ge(t.onPointerDown, (s) => {
          !i && s.button === 0 && s.ctrlKey === !1 && (a.onOpenToggle(), a.open || s.preventDefault());
        }),
        onKeyDown: ge(t.onKeyDown, (s) => {
          i || (["Enter", " "].includes(s.key) && a.onOpenToggle(), s.key === "ArrowDown" && a.onOpenChange(!0), ["Enter", " ", "ArrowDown"].includes(s.key) && s.preventDefault());
        })
      }
    ) });
  }
);
M_.displayName = __;
var HA = "DropdownMenuPortal", C_ = (t) => {
  const { __scopeDropdownMenu: e, ...n } = t, i = Vn(e);
  return /* @__PURE__ */ d(NA, { ...i, ...n });
};
C_.displayName = HA;
var P_ = "DropdownMenuContent", S_ = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = k_(P_, n), a = Vn(n), o = S.useRef(!1);
    return /* @__PURE__ */ d(
      $A,
      {
        id: r.contentId,
        "aria-labelledby": r.triggerId,
        ...a,
        ...i,
        ref: e,
        onCloseAutoFocus: ge(t.onCloseAutoFocus, (s) => {
          var l;
          o.current || (l = r.triggerRef.current) == null || l.focus(), o.current = !1, s.preventDefault();
        }),
        onInteractOutside: ge(t.onInteractOutside, (s) => {
          const l = s.detail.originalEvent, c = l.button === 0 && l.ctrlKey === !0, u = l.button === 2 || c;
          (!r.modal || u) && (o.current = !0);
        }),
        style: {
          ...t.style,
          "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
          "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
          "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
          "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
          "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
        }
      }
    );
  }
);
S_.displayName = P_;
var BA = "DropdownMenuGroup", qA = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
    return /* @__PURE__ */ d(DA, { ...r, ...i, ref: e });
  }
);
qA.displayName = BA;
var GA = "DropdownMenuLabel", N_ = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
    return /* @__PURE__ */ d(EA, { ...r, ...i, ref: e });
  }
);
N_.displayName = GA;
var XA = "DropdownMenuItem", $_ = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
    return /* @__PURE__ */ d(TA, { ...r, ...i, ref: e });
  }
);
$_.displayName = XA;
var YA = "DropdownMenuCheckboxItem", D_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(OA, { ...r, ...i, ref: e });
});
D_.displayName = YA;
var KA = "DropdownMenuRadioGroup", UA = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(WA, { ...r, ...i, ref: e });
});
UA.displayName = KA;
var JA = "DropdownMenuRadioItem", E_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(AA, { ...r, ...i, ref: e });
});
E_.displayName = JA;
var QA = "DropdownMenuItemIndicator", T_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(LA, { ...r, ...i, ref: e });
});
T_.displayName = QA;
var ZA = "DropdownMenuSeparator", O_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(IA, { ...r, ...i, ref: e });
});
O_.displayName = ZA;
var eL = "DropdownMenuArrow", tL = S.forwardRef(
  (t, e) => {
    const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
    return /* @__PURE__ */ d(RA, { ...r, ...i, ref: e });
  }
);
tL.displayName = eL;
var nL = "DropdownMenuSubTrigger", W_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(jA, { ...r, ...i, ref: e });
});
W_.displayName = nL;
var iL = "DropdownMenuSubContent", A_ = S.forwardRef((t, e) => {
  const { __scopeDropdownMenu: n, ...i } = t, r = Vn(n);
  return /* @__PURE__ */ d(
    FA,
    {
      ...r,
      ...i,
      ref: e,
      style: {
        ...t.style,
        "--radix-dropdown-menu-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-dropdown-menu-content-available-width": "var(--radix-popper-available-width)",
        "--radix-dropdown-menu-content-available-height": "var(--radix-popper-available-height)",
        "--radix-dropdown-menu-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-dropdown-menu-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
A_.displayName = iL;
var rL = x_, aL = M_, L_ = C_, I_ = S_, R_ = N_, rv = $_, j_ = D_, F_ = E_, z_ = T_, V_ = O_, H_ = W_, B_ = A_;
const q_ = rL, G_ = aL, oL = L_, sL = S.forwardRef(({ className: t, inset: e, children: n, ...i }, r) => /* @__PURE__ */ k(
  H_,
  {
    ref: r,
    className: E(
      "flex cursor-default select-none items-center rounded-2xs px-2 py-1.5 text-sm outline-none focus:bg-f1-background-secondary data-[state=open]:bg-f1-background-secondary",
      e && "pl-8",
      t
    ),
    ...i,
    children: [
      n,
      /* @__PURE__ */ d(Ky, { className: "ml-auto h-4 w-4" })
    ]
  }
));
sL.displayName = H_.displayName;
const lL = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  B_,
  {
    ref: n,
    className: E(
      "z-50 min-w-[--radix-popper-anchor-width] overflow-hidden rounded-md border bg-f1-background text-f1-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...e
  }
));
lL.displayName = B_.displayName;
const av = S.forwardRef(({ className: t, sideOffset: e = 4, ...n }, i) => /* @__PURE__ */ d(L_, { children: /* @__PURE__ */ d(
  I_,
  {
    ref: i,
    sideOffset: e,
    className: E(
      "z-50 min-w-[--radix-popper-anchor-width] overflow-hidden rounded-md border border-solid border-f1-border-secondary bg-f1-background text-f1-foreground shadow-md data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      "origin-[var(--radix-dropdown-menu-content-transform-origin)]",
      t
    ),
    ...n
  }
) }));
av.displayName = I_.displayName;
const ov = S.forwardRef(({ className: t, inset: e, ...n }, i) => /* @__PURE__ */ d(
  rv,
  {
    ref: i,
    className: E(
      "relative flex cursor-default select-none items-center rounded py-2 pl-3 pr-5 text-base font-medium outline-none transition-colors after:absolute after:inset-x-1 after:inset-y-0 after:h-full after:rounded after:bg-f1-background-hover after:opacity-0 after:transition-opacity after:duration-75 after:content-[''] first:pt-3 first:after:top-1 first:after:h-[calc(100%-0.25rem)] last:pb-3 last:after:bottom-1 last:after:h-[calc(100%-0.25rem)] hover:after:opacity-100 focus:after:opacity-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      "focus:outline-none focus:ring-0 focus:ring-transparent",
      // Temporal fix for Gamma issue
      e && "pl-8",
      t
    ),
    ...n
  }
));
ov.displayName = rv.displayName;
const dL = S.forwardRef(({ className: t, children: e, checked: n, ...i }, r) => /* @__PURE__ */ k(
  j_,
  {
    ref: r,
    className: E(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-f1-background-secondary focus:text-f1-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    checked: n,
    ...i,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(z_, { children: /* @__PURE__ */ d(WW, { className: "h-4 w-4" }) }) }),
      e
    ]
  }
));
dL.displayName = j_.displayName;
const cL = S.forwardRef(({ className: t, children: e, ...n }, i) => /* @__PURE__ */ k(
  F_,
  {
    ref: i,
    className: E(
      "relative flex cursor-default select-none items-center rounded-xs py-1.5 pl-8 pr-2 text-sm outline-none transition-colors focus:bg-f1-background-secondary focus:text-f1-foreground data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      t
    ),
    ...n,
    children: [
      /* @__PURE__ */ d("span", { className: "absolute left-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ d(z_, { children: /* @__PURE__ */ d(RW, { className: "h-2 w-2 fill-current" }) }) }),
      e
    ]
  }
));
cL.displayName = F_.displayName;
const uL = S.forwardRef(({ className: t, inset: e, ...n }, i) => /* @__PURE__ */ d(
  R_,
  {
    ref: i,
    className: E(
      "px-2 py-1.5 text-sm font-semibold",
      e && "pl-8",
      t
    ),
    ...n
  }
));
uL.displayName = R_.displayName;
const sv = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  V_,
  {
    ref: n,
    className: E("-mx-1 my-1 h-px bg-f1-border-secondary", t),
    ...e
  }
));
sv.displayName = V_.displayName;
const Ip = ({ item: t }) => /* @__PURE__ */ k(Ee, { children: [
  t.avatar && /* @__PURE__ */ d(ni, { avatar: t.avatar, size: "xsmall" }),
  t.icon && /* @__PURE__ */ d(
    me,
    {
      icon: t.icon,
      size: "md",
      className: E("text-f1-icon", t.critical && "text-f1-icon-critical")
    }
  ),
  /* @__PURE__ */ k("div", { className: "flex flex-col items-start", children: [
    t.label,
    t.description && /* @__PURE__ */ d(
      "div",
      {
        className: E(
          "font-normal text-f1-foreground-secondary",
          t.critical && "text-f1-foreground-critical"
        ),
        children: t.description
      }
    )
  ] })
] }), fL = ({ item: t }) => {
  const {
    label: e,
    icon: n,
    avatar: i,
    description: r,
    href: a,
    critical: o,
    ...s
  } = t, l = E(
    "flex items-start gap-1.5 w-full",
    o && "text-f1-foreground-critical"
  );
  return /* @__PURE__ */ d(ov, { asChild: !0, className: l, children: a ? /* @__PURE__ */ d(
    _n,
    {
      href: a,
      className: E(
        l,
        "text-f1-foreground no-underline hover:cursor-pointer"
      ),
      ...s,
      children: /* @__PURE__ */ d(Ip, { item: t })
    }
  ) : /* @__PURE__ */ d("div", { ...s, className: l, children: /* @__PURE__ */ d(Ip, { item: t }) }) });
};
function lc({
  items: t,
  icon: e = Ma,
  align: n = "start",
  size: i,
  children: r,
  open: a,
  onOpenChange: o,
  ...s
}) {
  const [l, c] = q(!1), u = a !== void 0 && o !== void 0, f = u ? a : l;
  return /* @__PURE__ */ k(q_, { open: f, onOpenChange: u ? o : c, children: [
    /* @__PURE__ */ d(G_, { asChild: !0, children: r || /* @__PURE__ */ d(
      ue,
      {
        ...s,
        hideLabel: !0,
        icon: e,
        size: i,
        label: "...",
        round: !0,
        variant: "outline",
        pressed: f
      }
    ) }),
    /* @__PURE__ */ d(av, { align: n, children: t.map(
      (h, p) => h.type === "separator" ? /* @__PURE__ */ d(sv, {}, p) : /* @__PURE__ */ d(fL, { item: h }, p)
    ) })
  ] });
}
const ws = ({
  items: t,
  onClick: e,
  value: n,
  ...i
}) => {
  const r = et(), [a, o] = q(!1), s = ve(() => n || t[0].value, [n, t]), l = ve(
    () => t.find((f) => f.value === s),
    [s, t]
  ), c = () => {
    e(s, t.find((f) => f.value === s));
  }, u = ve(
    () => t.filter((f) => f.value !== s).map((f) => ({
      ...f,
      onClick: () => {
        e(f.value, f), o(!1);
      }
    })),
    [t, s, e]
  );
  return l && /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d(
    so,
    {
      onClick: c,
      icon: l.icon,
      label: l.label,
      "data-testid": "button-main",
      className: "flex-1",
      ...i,
      appendButton: /* @__PURE__ */ d(
        lc,
        {
          items: u,
          align: "end",
          open: a,
          onOpenChange: o,
          children: /* @__PURE__ */ d(
            so,
            {
              variant: i.variant,
              size: i.size,
              label: r.actions.more,
              icon: zn,
              hideLabel: !0,
              "data-testid": "button-menu",
              pressed: a
            }
          )
        }
      )
    }
  ) });
}, cl = ({ primaryAction: t, secondaryActions: e }) => {
  if (!e || e.length === 0)
    return /* @__PURE__ */ d(
      ue,
      {
        disabled: t.disabled,
        variant: t.variant,
        onClick: t.onClick,
        label: t.label,
        icon: t.icon,
        size: "sm"
      }
    );
  const n = [t, ...e ?? []].map((r) => ({
    label: r.label,
    value: r.label,
    icon: r.icon,
    critical: r.variant === "critical"
  })) || [], i = (r) => {
    var o;
    const a = [t, ...e ?? []].find(
      (s) => s.label === r
    );
    a && ((o = a.onClick) == null || o.call(a));
  };
  return /* @__PURE__ */ d(
    ws,
    {
      items: n,
      value: t.label,
      disabled: t.disabled,
      onClick: i,
      variant: "outline",
      size: "sm"
    }
  );
}, mL = ({
  actions: t,
  selectAllLabel: e,
  clearLabel: n,
  disabled: i,
  allVisibleSelected: r,
  anyVisibleSelected: a,
  loading: o,
  singleSelector: s,
  onSelectAll: l,
  onClear: c
}) => {
  const u = !s && (e || n), f = t && t.length > 0;
  if (!(!o && (!s && u || f))) return null;
  let h, p, g = l ? {
    label: e || "",
    onClick: l,
    variant: "outline",
    disabled: i || r
  } : void 0, y = c ? {
    label: n || "",
    onClick: c,
    variant: "ghost",
    disabled: i || !a
  } : void 0;
  return g || (g = y, y = void 0), f && u ? (h = /* @__PURE__ */ d(
    cl,
    {
      primaryAction: g,
      secondaryActions: y ? [y] : []
    }
  ), p = /* @__PURE__ */ d(
    cl,
    {
      primaryAction: t[0],
      secondaryActions: t.slice(1)
    }
  )) : f ? h = /* @__PURE__ */ d(
    cl,
    {
      primaryAction: t[0],
      secondaryActions: t.slice(1)
    }
  ) : u && (h = /* @__PURE__ */ d(cl, { primaryAction: g, secondaryActions: [] }), y && (p = /* @__PURE__ */ d(cl, { primaryAction: y, secondaryActions: [] }))), /* @__PURE__ */ d("footer", { className: "rounded-bl-xl border-0 border-r-[1px] border-t-[1px] border-solid border-f1-border-secondary bg-f1-background/30 backdrop-blur-2xl", children: /* @__PURE__ */ k("div", { className: "flex flex-1 justify-between p-2", children: [
    h,
    p
  ] }) });
}, hL = ({
  search: t,
  onSearch: e,
  searchPlaceholder: n,
  disabled: i = !1,
  goToFirst: r,
  goToLast: a
}) => /* @__PURE__ */ k("div", { className: "flex justify-between gap-1 rounded-[10px] border-[1px] border-solid border-f1-border px-2 py-[3px] transition-all focus-within:border-f1-border-hover hover:border-f1-border-hover", children: [
  /* @__PURE__ */ d(me, { icon: FW, size: "md" }),
  /* @__PURE__ */ d(
    "input",
    {
      disabled: i,
      onKeyDown: (s) => {
        s.key === "ArrowDown" ? (s.preventDefault(), s.stopPropagation(), zm(s.currentTarget, r)) : s.key === "ArrowUp" ? (s.preventDefault(), s.stopPropagation(), Vm(s.currentTarget, a)) : s.key === "Enter" && (s.preventDefault(), s.stopPropagation());
      },
      type: "text",
      className: "w-full border-none bg-transparent focus:outline-none",
      placeholder: n,
      value: t,
      onChange: (s) => e(s.target.value)
    }
  ),
  t && /* @__PURE__ */ d(
    me,
    {
      icon: vs,
      size: "md",
      onClick: () => e(""),
      className: "cursor-pointer text-f1-icon-secondary"
    }
  )
] }), Xh = 384, Yh = 36, pL = 37, Ew = 1, Tw = 200, Ow = '[data-avatarname-navigator-element="true"]', gL = ({
  groupView: t,
  entities: e,
  groups: n,
  selectedGroup: i,
  search: r,
  onSelect: a,
  onRemove: o,
  onSubItemRemove: s,
  onSubItemSelect: l,
  onClear: c,
  onSelectAll: u,
  onSearch: f,
  selectedEntities: m = [],
  onGroupChange: h,
  onToggleExpand: p,
  searchPlaceholder: g,
  selectAllLabel: y,
  clearLabel: v,
  notFoundTitle: w,
  notFoundSubtitle: x,
  className: b,
  actions: M,
  onCreate: _,
  onCreateLabel: N,
  singleSelector: $ = !1,
  loading: D = !1,
  disabled: W = !1,
  hiddenAvatar: j = !1
}) => {
  const O = H.useRef(null), I = ve(
    () => t ? e.reduce(
      (Y, oe) => {
        var se;
        return Y + (((se = oe.subItems) == null ? void 0 : se.length) ?? 0);
      },
      0
    ) : e.length,
    [e, t]
  ), L = Le(() => {
    setTimeout(() => {
      var Y;
      (Y = O.current) == null || Y.scrollTo({ top: 0 });
    }, Ew), setTimeout(() => {
      var oe;
      (oe = Array.from(
        document.querySelectorAll(Ow)
      )[0]) == null || oe.focus();
    }, Tw);
  }, []), R = Le(() => {
    setTimeout(() => {
      var Y, oe;
      (oe = O.current) == null || oe.scrollTo({ top: (Y = O.current) == null ? void 0 : Y.scrollHeight });
    }, Ew), setTimeout(() => {
      var oe;
      const Y = Array.from(
        document.querySelectorAll(Ow)
      );
      (oe = Y[Y.length - 1]) == null || oe.focus();
    }, Tw);
  }, []), B = ve(
    () => new Map(m.map((Y) => [Y.id, Y])),
    [m]
  ), F = Le(
    (Y) => {
      var De;
      const oe = B.get(Y.id);
      if (!t)
        return {
          selected: !!oe,
          partialSelected: !!oe
        };
      const se = (Y.subItems ?? []).filter(
        (_e) => {
          var ce;
          return (ce = oe == null ? void 0 : oe.subItems) == null ? void 0 : ce.some(
            (wt) => wt.subId === _e.subId
          );
        }
      ), J = (((De = Y.subItems) == null ? void 0 : De.length) ?? 0) === se.length, xe = !J && se.length > 0;
      return { selected: J, partialSelected: xe };
    },
    [t, B]
  ), z = Le(
    (Y) => {
      if (Y.index === 0 && _)
        return /* @__PURE__ */ d(
          $w,
          {
            label: N ?? "",
            onCreate: () => _ == null ? void 0 : _(r),
            goToFirst: L,
            goToLast: R
          }
        );
      const oe = _ ? Y.index - 1 : Y.index, se = e[oe], { selected: J, partialSelected: xe } = F(se);
      return /* @__PURE__ */ d(
        yu,
        {
          expanded: se.expanded ?? !1,
          onExpand: () => p(se, !0),
          search: r,
          groupView: t,
          entity: se,
          onSelect: a,
          onRemove: o,
          selected: J,
          partialSelected: xe,
          showGroupIcon: yL(n, i),
          singleSelector: $,
          goToFirst: L,
          goToLast: R,
          disabled: W,
          hiddenAvatar: j
        },
        se.id
      );
    },
    [
      _,
      N,
      W,
      e,
      F,
      L,
      R,
      t,
      n,
      j,
      o,
      a,
      p,
      r,
      i,
      $
    ]
  ), K = ve(() => t ? e.flatMap((Y) => {
    const oe = Fc(
      m ?? [],
      Y.id
    );
    return [
      {
        parent: null,
        subItem: {
          subId: Y.id,
          subName: Y.name,
          subAvatar: Y.avatar,
          expanded: Y.expanded ?? (oe == null ? void 0 : oe.expanded) ?? !1,
          subItems: Y.subItems,
          subSearchKeys: Y.searchKeys
        }
      },
      ...(Y.subItems ?? []).map((se) => ({
        parent: {
          ...Y,
          expanded: Y.expanded ?? (oe == null ? void 0 : oe.expanded) ?? !1
        },
        subItem: se
      }))
    ];
  }).filter(
    (Y) => (!Y.parent || Y.parent.expanded) && (!!Y.parent || !!Y.subItem.subItems && Y.subItem.subItems.length > 0)
  ) : e.map((Y) => ({
    parent: null,
    subItem: {
      subId: Y.id,
      subName: Y.name,
      subAvatar: Y.avatar,
      subSearchKeys: Y.searchKeys
    }
  })), [t, e, m]), ae = Le(
    (Y) => {
      var De, _e;
      if (Y.index === 0 && _)
        return /* @__PURE__ */ d(
          $w,
          {
            label: N ?? "",
            onCreate: () => _ == null ? void 0 : _(r),
            goToFirst: L,
            goToLast: R
          }
        );
      const oe = _ ? Y.index - 1 : Y.index, se = K[oe].parent, J = K[oe].subItem;
      if (!se) {
        const ce = {
          id: J.subId,
          name: J.subName,
          avatar: J.subAvatar,
          subItems: J.subItems,
          expanded: J.expanded,
          searchKeys: J.subSearchKeys
        }, wt = Fc(
          m,
          ce.id
        ), St = ((ce == null ? void 0 : ce.subItems) ?? []).filter(
          (V) => {
            var G;
            return (G = wt == null ? void 0 : wt.subItems) == null ? void 0 : G.some(
              (de) => de.subId === V.subId
            );
          }
        ), ze = (((De = ce.subItems) == null ? void 0 : De.length) ?? 0) === St.length, A = !ze && St.length > 0;
        return /* @__PURE__ */ d(
          yu,
          {
            groupView: !0,
            expanded: ce.expanded ?? !1,
            onExpand: (V) => p(ce, V),
            search: r,
            entity: ce,
            onSelect: a,
            onRemove: o,
            selected: ze,
            partialSelected: A,
            showGroupIcon: ((_e = n.find((V) => V.value === i)) == null ? void 0 : _e.groupType) === "team",
            singleSelector: $,
            goToFirst: L,
            goToLast: R,
            hideLine: Y.index === K.length - 1,
            disabled: W,
            hiddenAvatar: j
          }
        );
      }
      let xe = !!Fc(m, J.subId);
      if (!xe) {
        const ce = Fc(
          m,
          se.id
        );
        xe = !!((se == null ? void 0 : se.subItems) ?? []).filter(
          (St) => {
            var ze;
            return (ze = ce == null ? void 0 : ce.subItems) == null ? void 0 : ze.some(
              (A) => A.subId === St.subId
            );
          }
        ).find((St) => St.subId === J.subId);
      }
      return /* @__PURE__ */ d(
        yu,
        {
          expanded: !1,
          onExpand: () => null,
          search: r,
          groupView: !1,
          entity: {
            id: J.subId,
            name: J.subName,
            avatar: J.subAvatar,
            searchKeys: J.subSearchKeys
          },
          onSelect: () => {
            l(se, J);
          },
          onRemove: () => s(se, J),
          selected: !!xe,
          partialSelected: !1,
          singleSelector: $,
          goToFirst: L,
          goToLast: R,
          isChild: !0,
          hiddenAvatar: j
        }
      );
    },
    [
      K,
      m,
      r,
      $,
      L,
      R,
      a,
      o,
      n,
      W,
      p,
      i,
      l,
      s,
      j,
      _,
      N
    ]
  ), [Q, te] = ve(() => {
    if (!e.length)
      return [!1, !1];
    let Y = 0, oe = 0;
    if (!t)
      Y = e.length, oe = e.reduce(
        (xe, { id: De }) => xe + (B.has(De) ? 1 : 0),
        0
      );
    else {
      const xe = new Set(
        [...B.values()].flatMap(
          (De) => {
            var _e;
            return ((_e = De.subItems) == null ? void 0 : _e.map((ce) => ce.subId)) ?? [];
          }
        )
      );
      e.forEach((De) => {
        const _e = De.subItems ?? [];
        Y += _e.length, oe += _e.filter(
          (ce) => xe.has(ce.subId)
        ).length;
      });
    }
    const se = Y > 0 && oe === Y, J = oe > 0;
    return [se, J];
  }, [e, B, t]), be = K.length, Pe = !$ && (y || v), We = M && M.length > 0, $e = !D && (!$ && Pe || We);
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex w-full flex-col rounded-l-xl border-0",
        $ || D ? "rounded-r-xl" : "",
        b
      ),
      children: [
        /* @__PURE__ */ k(
          "header",
          {
            className: E(
              "flex h-[48px] justify-between gap-2 rounded-tl-xl border-0 border-b-[1px] border-r-[1px] border-solid border-f1-border-secondary bg-f1-background/30 p-2 backdrop-blur-2xl",
              $ || D ? "rounded-t-xl border-r-0" : ""
            ),
            children: [
              /* @__PURE__ */ d("div", { className: "flex-1", children: /* @__PURE__ */ d(
                hL,
                {
                  search: r,
                  onSearch: f,
                  searchPlaceholder: g,
                  goToFirst: L,
                  goToLast: R
                }
              ) }),
              n && n.length > 1 && /* @__PURE__ */ d("div", { className: "flex-1", children: /* @__PURE__ */ d(
                Ca,
                {
                  disabled: D,
                  onChange: h,
                  options: n,
                  value: i,
                  className: E(
                    "h-8 rounded-[10px] bg-transparent py-[5px]",
                    i === "all" ? "text-f1-foreground-secondary" : ""
                  )
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ k(
          "section",
          {
            className: E(
              "flex-grow-1 flex h-96 flex-col justify-start gap-1 border-0 border-r-[1px] border-solid border-f1-border-secondary bg-f1-background",
              $e ? "" : "rounded-b-xl border-r-0"
            ),
            children: [
              D && /* @__PURE__ */ d("div", { className: "flex h-full w-full flex-row items-center justify-center", children: /* @__PURE__ */ d(pc, {}) }),
              !D && !I && /* @__PURE__ */ k(
                "div",
                {
                  className: "absolute flex w-full flex-col items-center justify-center gap-0.5 p-5",
                  style: {
                    height: Xh
                  },
                  children: [
                    /* @__PURE__ */ d("span", { className: "text-lg font-medium", children: w }),
                    /* @__PURE__ */ d("span", { className: "text-center text-f1-foreground-secondary", children: x })
                  ]
                }
              ),
              !D && (!!I || _) && /* @__PURE__ */ d("div", { className: "h-full", children: t ? /* @__PURE__ */ d(
                Ku,
                {
                  height: Xh,
                  itemCount: be + (_ ? 1 : 0),
                  itemSize: (Y) => {
                    var se;
                    if (Y === 0 && _) return Yh;
                    const oe = _ ? Y - 1 : Y;
                    return ((se = K[oe]) == null ? void 0 : se.parent) === null ? pL : Yh;
                  },
                  renderer: ae,
                  ref: O
                }
              ) : /* @__PURE__ */ d(
                Ku,
                {
                  height: Xh,
                  itemCount: e.length + (_ ? 1 : 0),
                  itemSize: Yh,
                  renderer: z,
                  ref: O
                }
              ) })
            ]
          }
        ),
        /* @__PURE__ */ d(
          mL,
          {
            onSelectAll: u,
            onClear: c,
            singleSelector: $,
            totalFilteredEntities: I,
            allVisibleSelected: Q,
            anyVisibleSelected: te,
            selectAllLabel: y,
            clearLabel: v,
            disabled: W,
            actions: M
          }
        )
      ]
    }
  );
}, Fc = (t, e) => t.find((n) => n.id === e), yL = (t, e) => {
  var n;
  return ((n = t.find((i) => i.value === e)) == null ? void 0 : n.groupType) === "team";
}, vL = ({
  entity: t,
  onRemove: e,
  disabled: n = !1,
  hiddenAvatar: i = !1
}) => /* @__PURE__ */ d("div", { className: "pr-2 pt-1.5", children: /* @__PURE__ */ d(
  Aa,
  {
    className: E(
      "max-w-54 w-fit gap-1 text-ellipsis break-all border-[1px] border-solid border-f1-border-secondary py-[1px] pl-[1px]",
      "rounded-full",
      i ? "pl-2" : "pl-0"
    ),
    left: !i && /* @__PURE__ */ d(
      Xs,
      {
        src: t.subAvatar,
        name: t.subName,
        size: "xsmall",
        type: "rounded"
      }
    ),
    right: !n && /* @__PURE__ */ d(
      me,
      {
        icon: Rr,
        size: "sm",
        className: "cursor-pointer text-f1-icon-secondary",
        onClick: () => e == null ? void 0 : e(t)
      }
    ),
    text: t.subName
  }
) }), bL = ({
  groupView: t,
  onSubItemRemove: e,
  onRemove: n,
  selectedEntities: i,
  selectedLabel: r,
  disabled: a = !1,
  hiddenAvatar: o = !1
}) => {
  const s = ve(() => {
    const c = t ? i.flatMap(
      (f) => (f.subItems ?? []).map((m) => ({
        parent: f,
        subItem: m
      }))
    ) : i.map((f) => ({
      parent: null,
      subItem: {
        subId: f.id,
        subName: f.name,
        subAvatar: f.avatar
      }
    })), u = /* @__PURE__ */ new Set();
    return c.filter((f) => {
      const m = f.subItem.subId;
      return u.has(m) ? !1 : (u.add(m), !0);
    });
  }, [t, i]), l = s.length;
  return /* @__PURE__ */ k("div", { className: "w-full flex-col rounded-r-xl", children: [
    /* @__PURE__ */ d("div", { className: "flex h-[48px] rounded-tr-xl border-0 border-b-[1px] border-solid border-f1-border-secondary bg-f1-background/30 p-3 backdrop-blur-2xl", children: r && /* @__PURE__ */ k("span", { className: "my-auto text-f1-foreground-secondary", children: [
      l,
      " ",
      r
    ] }) }),
    /* @__PURE__ */ d("div", { className: "flex flex-col gap-3 rounded-br-xl bg-f1-background pb-0 pl-2", children: /* @__PURE__ */ d(
      Ku,
      {
        height: 425,
        itemCount: l,
        itemSize: 30,
        className: "overflow-x-hidden",
        renderer: (c) => {
          const u = s[c.index];
          return u ? /* @__PURE__ */ d(
            vL,
            {
              entity: u.subItem,
              disabled: a,
              hiddenAvatar: o,
              onRemove: () => u.parent ? e == null ? void 0 : e(u.parent, u.subItem) : n({
                id: u.subItem.subId,
                name: u.subItem.subName,
                avatar: u.subItem.subAvatar
              })
            }
          ) : /* @__PURE__ */ d(Ee, {});
        }
      }
    ) })
  ] });
}, wL = 500, Ww = 520, Aw = 210, Lw = ({
  groupView: t,
  onRemove: e,
  onSubItemRemove: n,
  selectedEntities: i,
  selectedLabel: r,
  width: a,
  singleSelector: o = !1,
  loading: s = !1,
  hiddenAvatar: l = !1,
  actions: c,
  onCreate: u,
  onCreateLabel: f,
  ...m
}) => {
  const h = (a ?? Ww) < wL, p = !s && !o && !h, g = a ?? Ww, y = p ? g - Aw : g;
  return /* @__PURE__ */ k(
    "div",
    {
      className: "relative overflow-hidden",
      style: {
        height: o && (!c || c.length === 0) ? "435px" : "473px",
        width: g
      },
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: "absolute right-0 top-0",
            style: {
              width: Aw + "px"
            },
            children: /* @__PURE__ */ d(
              bL,
              {
                groupView: t,
                onRemove: e,
                onSubItemRemove: n,
                selectedEntities: i ?? [],
                selectedLabel: r,
                disabled: m.disabled,
                hiddenAvatar: l
              }
            )
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: "absolute left-0",
            style: { width: y + 1 + "px" },
            children: /* @__PURE__ */ d(
              gL,
              {
                ...m,
                groupView: t,
                onRemove: e,
                onSubItemRemove: n,
                selectedEntities: i,
                singleSelector: o,
                loading: s,
                disabled: m.disabled,
                hiddenAvatar: l,
                actions: c,
                onCreate: u,
                onCreateLabel: f
              }
            )
          }
        )
      ]
    }
  );
}, kL = ({
  placeholder: t,
  selected: e,
  selectedEntities: n,
  disabled: i = !1,
  hiddenAvatar: r = !1
}) => {
  const a = ve(
    () => n.some(
      (s) => s.subItems && s.subItems.length > 0
    ),
    [n]
  ), o = ve(() => a ? n.flatMap(
    (s) => (s.subItems ?? []).map((l) => ({
      parent: s,
      subItem: l
    }))
  ) : n.map((s) => ({
    parent: null,
    subItem: {
      subId: s.id,
      subName: s.name,
      subAvatar: s.avatar
    }
  })), [a, n]);
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex cursor-pointer justify-between rounded border border-solid border-f1-border p-2",
        i ? "to-f1-background-secondary" : ""
      ),
      children: [
        /* @__PURE__ */ d("span", { className: "my-auto pl-1 pr-1 text-f1-foreground-secondary", children: o.length === 0 ? t : o.length === 1 ? r ? o[0].subItem.subName : /* @__PURE__ */ k("div", { className: "flex flex-row gap-2 p-0", children: [
          /* @__PURE__ */ d(
            ti,
            {
              firstName: o[0].subItem.subName,
              lastName: "",
              src: o[0].subItem.subAvatar,
              size: "xsmall"
            }
          ),
          /* @__PURE__ */ d("span", { children: o[0].subItem.subName })
        ] }) : o.length + " " + e }),
        /* @__PURE__ */ d("div", { className: "p-0.5", children: /* @__PURE__ */ d("div", { className: "h-[16px] w-[16px]", children: /* @__PURE__ */ d(
          me,
          {
            icon: zn,
            size: "sm",
            className: "rounded-2xs bg-f1-background-secondary p-0.5"
          }
        ) }) })
      ]
    }
  );
}, qXe = (t) => {
  const [e, n] = q(
    (t.alwaysOpen || t.defaultOpen) ?? !1
  ), i = (_) => {
    var N;
    n(_), (N = t.onOpenChange) == null || N.call(t, _);
  };
  le(() => {
    var _;
    t.defaultOpen && e && ((_ = t.onOpenChange) == null || _.call(t, !0));
  }, [t.defaultOpen]);
  const [r, a] = q(t.entities), [o, s] = q(""), [l, c] = t5("", 300), u = ve(
    () => t.entities.some(
      (_) => _.subItems && _.subItems.length > 0
    ),
    [t.entities]
  );
  function f(_) {
    if (t.singleSelector) {
      t.onSelect(_), n(!1);
      return;
    }
    const N = t.selectedEntities ?? [], $ = r.find((I) => I.id === _.id);
    if (!$)
      return;
    const D = new Set(
      ($.subItems ?? []).map((I) => I.subId)
    ), W = /* @__PURE__ */ new Set([$.id]);
    r.forEach((I) => {
      I.id !== $.id && (I.subItems ?? []).some(
        (R) => D.has(R.subId)
      ) && W.add(I.id);
    });
    const j = [...N];
    function O(I) {
      const L = j.findIndex((R) => R.id === I.id);
      L >= 0 ? j[L] = I : j.push(I);
    }
    W.forEach((I) => {
      var F;
      const L = r.find((z) => z.id === I);
      if (!L) return;
      const R = ((F = L.subItems) == null ? void 0 : F.filter(
        (z) => D.has(z.subId)
      )) ?? [], B = j.findIndex((z) => z.id === I);
      if (B >= 0) {
        const z = j[B].subItems ?? [], K = new Set(z.map((Q) => Q.subId)), ae = [
          ...z,
          ...R.filter((Q) => !K.has(Q.subId))
        ];
        O({
          ...L,
          subItems: ae
        });
      } else
        O({
          ...L,
          subItems: R
        });
    }), t.onSelect(j);
  }
  function m(_, N) {
    if (t.singleSelector)
      t.onSelect({ ..._, subItems: [{ ...N }] }), n(!1);
    else {
      const $ = t.selectedEntities ?? [], D = new Set($.map((O) => O.id)), W = new Map(
        $.map((O) => [O.id, O.subItems ?? []])
      );
      D.add(_.id), t.entities.forEach((O) => {
        var L;
        ((L = O.subItems) == null ? void 0 : L.some(
          (R) => R.subId === N.subId
        )) && D.add(O.id);
      });
      const j = [];
      t.entities.forEach((O) => {
        var I;
        if (D.has(O.id)) {
          let R = [...W.get(O.id) ?? []];
          ((I = O.subItems) == null ? void 0 : I.some(
            (z) => z.subId === N.subId
          )) && (R.some(
            (K) => K.subId === N.subId
          ) || R.push(N));
          const F = new Set(
            (O.subItems ?? []).map((z) => z.subId)
          );
          R = R.filter(
            (z) => F.has(z.subId)
          ), j.push({
            ...O,
            subItems: R
          });
        }
      }), t.onSelect(j);
    }
  }
  function h(_) {
    if (t.singleSelector) {
      t.onSelect(null);
      return;
    }
    let N = [];
    const $ = t.selectedEntities ?? [];
    if (u) {
      const D = r.find(
        (j) => j.id === _.id
      );
      if (!D)
        return;
      const W = new Set(
        (D.subItems ?? []).map((j) => j.subId)
      );
      for (const j of $) {
        const O = (j.subItems ?? []).filter(
          (I) => !W.has(I.subId)
        );
        O.length > 0 && N.push({
          ...j,
          subItems: O
        });
      }
    } else
      N = ($ ?? []).filter((D) => D.id !== _.id);
    t.onSelect(N);
  }
  function p(_, N) {
    var j;
    if (t.singleSelector) {
      t.onSelect(null);
      return;
    }
    const $ = t.selectedEntities ?? [], D = N.subId, W = [];
    for (const O of $) {
      const I = ((j = O.subItems) == null ? void 0 : j.filter((L) => L.subId !== D)) ?? [];
      I.length > 0 && W.push({
        ...O,
        subItems: I
      });
    }
    t.onSelect(W);
  }
  function g() {
    if (t.singleSelector) {
      t.onSelect(null);
      return;
    }
    const _ = t.selectedEntities ?? [];
    let N = [];
    if (u) {
      const $ = new Set(
        r.flatMap(
          (D) => (D.subItems ?? []).map((W) => W.subId)
        )
      );
      for (const D of _) {
        const W = (D.subItems ?? []).filter(
          (j) => !$.has(j.subId)
        );
        W.length > 0 && N.push({
          ...D,
          subItems: W
        });
      }
    } else {
      const $ = new Set(
        r.map((D) => D.id)
      );
      N = (_ ?? []).filter((D) => !$.has(D.id));
    }
    t.onSelect(N);
  }
  function y() {
    const _ = [...t.selectedEntities ?? []];
    r.forEach((N) => {
      const $ = _.find((D) => D.id === N.id);
      if (!$)
        _.push({
          ...N,
          subItems: N.subItems || []
        });
      else {
        const D = Array.from(
          /* @__PURE__ */ new Set([
            ...$.subItems ?? [],
            ...N.subItems ?? []
          ])
        );
        $.subItems = D;
      }
    }), t.singleSelector || t.onSelect(_);
  }
  const v = (_) => {
    s(_), c(_);
  }, w = (_, N) => {
    t.onItemExpandedChange(_.id, N), a(
      r.map(
        ($) => $.id === _.id ? { ...$, expanded: !_.expanded } : $
      )
    );
  };
  le(() => {
    if (!l) {
      a(t.entities);
      return;
    }
    if (u && !t.applySearchToGroup) {
      const N = t.entities.map(($) => {
        var j;
        const D = xL($, l), W = (j = $.subItems) == null ? void 0 : j.map((O) => ({
          ...O,
          score: Zu(
            l,
            O.subSearchKeys ?? [O.subName]
          )
        })).filter((O) => O.score < 1 / 0).sort((O, I) => O.score - I.score);
        return {
          ...$,
          score: D,
          expanded: $.expanded ?? ((W == null ? void 0 : W.length) ?? 0) > 0,
          subItems: W
        };
      }).filter(($) => $.score < 1 / 0).sort(($, D) => $.score - D.score);
      a(N);
    } else {
      const _ = t.entities.map((N) => {
        const $ = Zu(
          l,
          N.searchKeys ?? [N.name]
        );
        return { ...N, score: $ };
      }).filter((N) => N.score < 1 / 0).sort((N, $) => N.score - $.score);
      a(_);
    }
  }, [
    l,
    t.entities,
    t.applySearchToGroup,
    u,
    a
  ]);
  const x = Oe(null), [b, M] = q(0);
  return Zd(() => {
    const _ = () => {
      x.current && M(x.current.offsetWidth);
    };
    return _(), window.addEventListener("resize", _), () => window.removeEventListener("resize", _);
  }, []), t.alwaysOpen ? /* @__PURE__ */ d(
    "div",
    {
      ref: x,
      className: E(
        "scrollbar-macos relative overflow-auto rounded-xl border-[1px] border-solid border-f1-border-secondary bg-transparent p-0",
        t.width ? "w-fit" : "w-full"
      ),
      children: /* @__PURE__ */ d(
        Lw,
        {
          groupView: u,
          entities: r,
          groups: t.groups,
          onGroupChange: t.onGroupChange,
          selectedGroup: t.selectedGroup,
          onSelect: f,
          onRemove: h,
          onSubItemRemove: p,
          onSubItemSelect: m,
          onClear: g,
          onSelectAll: y,
          selectedEntities: t.selectedEntities ?? [],
          search: o,
          onSearch: v,
          onToggleExpand: w,
          searchPlaceholder: t.searchPlaceholder,
          selectAllLabel: t.selectAllLabel,
          clearLabel: t.clearLabel,
          selectedLabel: t.selectedLabel,
          singleSelector: t.singleSelector,
          loading: t.loading,
          notFoundTitle: t.notFoundTitle,
          notFoundSubtitle: t.notFoundSubtitle,
          width: t.width ?? b - 2,
          disabled: t.disabled,
          hiddenAvatar: t.hiddenAvatar,
          onCreate: t.onCreate,
          onCreateLabel: t.onCreateLabel
        }
      )
    }
  ) : /* @__PURE__ */ k($o, { ...t, onOpenChange: i, open: e, children: [
    /* @__PURE__ */ d(Do, { className: "w-full", disabled: t.disabled, children: t.children ? t.children : /* @__PURE__ */ d(
      kL,
      {
        placeholder: t.triggerPlaceholder,
        selected: t.triggerSelected,
        selectedEntities: t.selectedEntities ?? [],
        disabled: t.disabled,
        hiddenAvatar: t.hiddenAvatar
      }
    ) }),
    /* @__PURE__ */ d(
      Eo,
      {
        className: E(
          "scrollbar-macos relative w-full overflow-auto rounded-xl border-[1px] border-solid border-f1-border-secondary bg-transparent p-0"
        ),
        children: /* @__PURE__ */ d(
          Lw,
          {
            groupView: u,
            entities: r,
            groups: t.groups,
            onGroupChange: t.onGroupChange,
            selectedGroup: t.selectedGroup,
            onSelect: f,
            onRemove: h,
            onSubItemRemove: p,
            onSubItemSelect: m,
            onClear: g,
            onSelectAll: y,
            selectedEntities: t.selectedEntities ?? [],
            search: o,
            onSearch: v,
            onToggleExpand: w,
            searchPlaceholder: t.searchPlaceholder,
            selectAllLabel: t.selectAllLabel,
            clearLabel: t.clearLabel,
            selectedLabel: t.selectedLabel,
            singleSelector: t.singleSelector,
            loading: t.loading,
            notFoundTitle: t.notFoundTitle,
            notFoundSubtitle: t.notFoundSubtitle,
            width: t.width,
            disabled: t.disabled,
            hiddenAvatar: t.hiddenAvatar,
            actions: t.actions,
            onCreate: t.onCreate,
            onCreateLabel: t.onCreateLabel
          }
        )
      }
    )
  ] });
};
function Zu(t = "", e) {
  const n = t.trim().toLowerCase();
  for (const i of e)
    if (i.trim().toLowerCase().includes(n))
      return 1;
  return 1 / 0;
}
function xL(t, e) {
  var r;
  const n = Zu(e, t.searchKeys ?? [t.name]);
  let i = 1 / 0;
  return (r = t.subItems) != null && r.length && (i = t.subItems.reduce((a, o) => {
    const s = Zu(
      e,
      o.subSearchKeys ?? [o.subName]
    );
    return Math.min(a, s);
  }, 1 / 0)), Math.min(n, i);
}
const GXe = Fr, _L = /^(-?)([0-9]+)?(?:([\.,])([0-9]+)?)?$/;
function Iw(t, { maxDecimals: e }) {
  if (!t || t === "-")
    return {
      formattedValue: t ?? "",
      value: null
    };
  const n = t.match(_L);
  if (!n) return null;
  let [i, r, a, o, s] = n;
  e && ((s == null ? void 0 : s.length) ?? 0) > e ? s = s == null ? void 0 : s.slice(0, e) : e === 0 && (s = ""), a = (a == null ? void 0 : a.replace(/^0+(\d)/, (u, f) => f)) ?? "";
  const l = `${r}${a}${e !== 0 ? `${o ?? ""}${s ?? ""}` : ""}`, c = parseFloat(l.replace(",", "."));
  return {
    formattedValue: l,
    value: Number.isNaN(c) ? null : c
  };
}
const zc = (t, e, n) => new Intl.NumberFormat(e, {
  maximumFractionDigits: n,
  useGrouping: !1
}).format(t), XXe = X(
  function({ locale: e, value: n, maxDecimals: i, step: r, min: a, max: o, onChange: s, ...l }, c) {
    const [u, f] = q(
      () => n != null ? zc(n, e, i) : ""
    ), m = (g) => {
      const y = Iw(g, { maxDecimals: i });
      if (!y) return;
      const { formattedValue: v, value: w } = y;
      f(v), s == null || s(w);
    }, h = (g) => () => {
      if (!r) return;
      if (n == null)
        return m(zc(r ?? a ?? 0, e, i));
      const y = g === "increase" ? n + r : n - r;
      a != null && y < a || o != null && y > o || m(zc(y, e, i));
    }, p = () => r ? /* @__PURE__ */ k(
      "div",
      {
        className: "absolute right-2 top-0.5 hidden h-full flex-col group-focus-within:flex group-hover:flex",
        onClick: (g) => g.preventDefault(),
        children: [
          /* @__PURE__ */ d(
            "div",
            {
              onClick: h("increase"),
              className: "h-4 cursor-pointer",
              role: "button",
              children: /* @__PURE__ */ d(me, { size: "sm", icon: qs })
            }
          ),
          /* @__PURE__ */ d(
            "div",
            {
              onClick: h("decrease"),
              className: "h-4 cursor-pointer",
              role: "button",
              children: /* @__PURE__ */ d(me, { size: "sm", icon: zn })
            }
          )
        ]
      }
    ) : null;
    return le(() => {
      const g = Iw(u, { maxDecimals: i });
      n === void 0 || n == (g == null ? void 0 : g.value) || f(n ? zc(n, e, i) : "");
    }, [u, i, n, e]), /* @__PURE__ */ k("div", { className: "group relative", children: [
      /* @__PURE__ */ d(
        Fr,
        {
          type: "text",
          ref: c,
          value: u,
          inputMode: "decimal",
          className: "group-focus-within:pr-5 group-hover:pr-5",
          onChange: (g) => m(g.target.value),
          ...l
        }
      ),
      /* @__PURE__ */ d(p, {})
    ] });
  }
);
function ML(t, e, { checkForDefaultPrevented: n = !0 } = {}) {
  return function(r) {
    if (t == null || t(r), n === !1 || !r.defaultPrevented)
      return e == null ? void 0 : e(r);
  };
}
function Rw(t, e) {
  if (typeof t == "function")
    return t(e);
  t != null && (t.current = e);
}
function X_(...t) {
  return (e) => {
    let n = !1;
    const i = t.map((r) => {
      const a = Rw(r, e);
      return !n && typeof a == "function" && (n = !0), a;
    });
    if (n)
      return () => {
        for (let r = 0; r < i.length; r++) {
          const a = i[r];
          typeof a == "function" ? a() : Rw(t[r], null);
        }
      };
  };
}
function Y_(...t) {
  return S.useCallback(X_(...t), t);
}
function CL(t, e = []) {
  let n = [];
  function i(a, o) {
    const s = S.createContext(o), l = n.length;
    n = [...n, o];
    const c = (f) => {
      var v;
      const { scope: m, children: h, ...p } = f, g = ((v = m == null ? void 0 : m[t]) == null ? void 0 : v[l]) || s, y = S.useMemo(() => p, Object.values(p));
      return /* @__PURE__ */ d(g.Provider, { value: y, children: h });
    };
    c.displayName = a + "Provider";
    function u(f, m) {
      var g;
      const h = ((g = m == null ? void 0 : m[t]) == null ? void 0 : g[l]) || s, p = S.useContext(h);
      if (p) return p;
      if (o !== void 0) return o;
      throw new Error(`\`${f}\` must be used within \`${a}\``);
    }
    return [c, u];
  }
  const r = () => {
    const a = n.map((o) => S.createContext(o));
    return function(s) {
      const l = (s == null ? void 0 : s[t]) || a;
      return S.useMemo(
        () => ({ [`__scope${t}`]: { ...s, [t]: l } }),
        [s, l]
      );
    };
  };
  return r.scopeName = t, [i, PL(r, ...e)];
}
function PL(...t) {
  const e = t[0];
  if (t.length === 1) return e;
  const n = () => {
    const i = t.map((r) => ({
      useScope: r(),
      scopeName: r.scopeName
    }));
    return function(a) {
      const o = i.reduce((s, { useScope: l, scopeName: c }) => {
        const f = l(a)[`__scope${c}`];
        return { ...s, ...f };
      }, {});
      return S.useMemo(() => ({ [`__scope${e.scopeName}`]: o }), [o]);
    };
  };
  return n.scopeName = e.scopeName, n;
}
var K_ = globalThis != null && globalThis.document ? S.useLayoutEffect : () => {
}, SL = S[" useInsertionEffect ".trim().toString()] || K_;
function NL({
  prop: t,
  defaultProp: e,
  onChange: n = () => {
  },
  caller: i
}) {
  const [r, a, o] = $L({
    defaultProp: e,
    onChange: n
  }), s = t !== void 0, l = s ? t : r;
  {
    const u = S.useRef(t !== void 0);
    S.useEffect(() => {
      const f = u.current;
      f !== s && console.warn(
        `${i} is changing from ${f ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, i]);
  }
  const c = S.useCallback(
    (u) => {
      var f;
      if (s) {
        const m = DL(u) ? u(t) : u;
        m !== t && ((f = o.current) == null || f.call(o, m));
      } else
        a(u);
    },
    [s, t, a, o]
  );
  return [l, c];
}
function $L({
  defaultProp: t,
  onChange: e
}) {
  const [n, i] = S.useState(t), r = S.useRef(n), a = S.useRef(e);
  return SL(() => {
    a.current = e;
  }, [e]), S.useEffect(() => {
    var o;
    r.current !== n && ((o = a.current) == null || o.call(a, n), r.current = n);
  }, [n, r]), [n, i, a];
}
function DL(t) {
  return typeof t == "function";
}
function EL(t) {
  const e = S.useRef({ value: t, previous: t });
  return S.useMemo(() => (e.current.value !== t && (e.current.previous = e.current.value, e.current.value = t), e.current.previous), [t]);
}
function TL(t) {
  const [e, n] = S.useState(void 0);
  return K_(() => {
    if (t) {
      n({ width: t.offsetWidth, height: t.offsetHeight });
      const i = new ResizeObserver((r) => {
        if (!Array.isArray(r) || !r.length)
          return;
        const a = r[0];
        let o, s;
        if ("borderBoxSize" in a) {
          const l = a.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          o = c.inlineSize, s = c.blockSize;
        } else
          o = t.offsetWidth, s = t.offsetHeight;
        n({ width: o, height: s });
      });
      return i.observe(t, { box: "border-box" }), () => i.unobserve(t);
    } else
      n(void 0);
  }, [t]), e;
}
// @__NO_SIDE_EFFECTS__
function OL(t) {
  const e = /* @__PURE__ */ WL(t), n = S.forwardRef((i, r) => {
    const { children: a, ...o } = i, s = S.Children.toArray(a), l = s.find(LL);
    if (l) {
      const c = l.props.children, u = s.map((f) => f === l ? S.Children.count(c) > 1 ? S.Children.only(null) : S.isValidElement(c) ? c.props.children : null : f);
      return /* @__PURE__ */ d(e, { ...o, ref: r, children: S.isValidElement(c) ? S.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ d(e, { ...o, ref: r, children: a });
  });
  return n.displayName = `${t}.Slot`, n;
}
// @__NO_SIDE_EFFECTS__
function WL(t) {
  const e = S.forwardRef((n, i) => {
    const { children: r, ...a } = n;
    if (S.isValidElement(r)) {
      const o = RL(r), s = IL(a, r.props);
      return r.type !== S.Fragment && (s.ref = i ? X_(i, o) : o), S.cloneElement(r, s);
    }
    return S.Children.count(r) > 1 ? S.Children.only(null) : null;
  });
  return e.displayName = `${t}.SlotClone`, e;
}
var AL = Symbol("radix.slottable");
function LL(t) {
  return S.isValidElement(t) && typeof t.type == "function" && "__radixId" in t.type && t.type.__radixId === AL;
}
function IL(t, e) {
  const n = { ...e };
  for (const i in e) {
    const r = t[i], a = e[i];
    /^on[A-Z]/.test(i) ? r && a ? n[i] = (...s) => {
      a(...s), r(...s);
    } : r && (n[i] = r) : i === "style" ? n[i] = { ...r, ...a } : i === "className" && (n[i] = [r, a].filter(Boolean).join(" "));
  }
  return { ...t, ...n };
}
function RL(t) {
  var i, r;
  let e = (i = Object.getOwnPropertyDescriptor(t.props, "ref")) == null ? void 0 : i.get, n = e && "isReactWarning" in e && e.isReactWarning;
  return n ? t.ref : (e = (r = Object.getOwnPropertyDescriptor(t, "ref")) == null ? void 0 : r.get, n = e && "isReactWarning" in e && e.isReactWarning, n ? t.props.ref : t.props.ref || t.ref);
}
var jL = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], U_ = jL.reduce((t, e) => {
  const n = /* @__PURE__ */ OL(`Primitive.${e}`), i = S.forwardRef((r, a) => {
    const { asChild: o, ...s } = r, l = o ? n : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(l, { ...s, ref: a });
  });
  return i.displayName = `Primitive.${e}`, { ...t, [e]: i };
}, {}), Xm = "Switch", [FL, YXe] = CL(Xm), [zL, VL] = FL(Xm), J_ = S.forwardRef(
  (t, e) => {
    const {
      __scopeSwitch: n,
      name: i,
      checked: r,
      defaultChecked: a,
      required: o,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...f
    } = t, [m, h] = S.useState(null), p = Y_(e, (x) => h(x)), g = S.useRef(!1), y = m ? u || !!m.closest("form") : !0, [v, w] = NL({
      prop: r,
      defaultProp: a ?? !1,
      onChange: c,
      caller: Xm
    });
    return /* @__PURE__ */ k(zL, { scope: n, checked: v, disabled: s, children: [
      /* @__PURE__ */ d(
        U_.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": v,
          "aria-required": o,
          "data-state": t9(v),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...f,
          ref: p,
          onClick: ML(t.onClick, (x) => {
            w((b) => !b), y && (g.current = x.isPropagationStopped(), g.current || x.stopPropagation());
          })
        }
      ),
      y && /* @__PURE__ */ d(
        e9,
        {
          control: m,
          bubbles: !g.current,
          name: i,
          value: l,
          checked: v,
          required: o,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
J_.displayName = Xm;
var Q_ = "SwitchThumb", Z_ = S.forwardRef(
  (t, e) => {
    const { __scopeSwitch: n, ...i } = t, r = VL(Q_, n);
    return /* @__PURE__ */ d(
      U_.span,
      {
        "data-state": t9(r.checked),
        "data-disabled": r.disabled ? "" : void 0,
        ...i,
        ref: e
      }
    );
  }
);
Z_.displayName = Q_;
var HL = "SwitchBubbleInput", e9 = S.forwardRef(
  ({
    __scopeSwitch: t,
    control: e,
    checked: n,
    bubbles: i = !0,
    ...r
  }, a) => {
    const o = S.useRef(null), s = Y_(o, a), l = EL(n), c = TL(e);
    return S.useEffect(() => {
      const u = o.current;
      if (!u) return;
      const f = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        f,
        "checked"
      ).set;
      if (l !== n && h) {
        const p = new Event("click", { bubbles: i });
        h.call(u, n), u.dispatchEvent(p);
      }
    }, [l, n, i]), /* @__PURE__ */ d(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: n,
        ...r,
        tabIndex: -1,
        ref: s,
        style: {
          ...r.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
e9.displayName = HL;
function t9(t) {
  return t ? "checked" : "unchecked";
}
var n9 = J_, BL = Z_;
const i9 = S.forwardRef(({ className: t, disabled: e, hideLabel: n, ...i }, r) => {
  const a = Wa(), o = i.id || a;
  return /* @__PURE__ */ k("div", { className: "flex items-center", children: [
    /* @__PURE__ */ d(
      n9,
      {
        ...i,
        ref: r,
        id: o,
        name: o,
        "aria-label": i.title ?? "Switch",
        className: E(
          "relative h-5 w-[1.875rem] rounded-full bg-f1-border hover:bg-f1-border-hover data-[state=checked]:bg-f1-background-selected-bold",
          e && "cursor-not-allowed opacity-50",
          Ke(),
          t
        ),
        disabled: e,
        children: /* @__PURE__ */ d(
          BL,
          {
            className: E(
              "block h-4 w-4 translate-x-[0.125rem] rounded-full bg-f1-background transition-transform duration-300 data-[state=checked]:translate-x-[0.75rem]"
            )
          }
        )
      }
    ),
    i.title && !n && /* @__PURE__ */ d(
      "label",
      {
        htmlFor: o,
        className: E(
          "flex items-center justify-center pl-2.5 text-current",
          e && "cursor-not-allowed opacity-50 hover:cursor-not-allowed"
        ),
        children: i.title
      }
    )
  ] });
});
i9.displayName = n9.displayName;
function qL({
  title: t,
  onCheckedChange: e,
  id: n,
  disabled: i,
  checked: r = !1,
  value: a,
  hideLabel: o = !1,
  presentational: s = !1,
  ...l
}) {
  return /* @__PURE__ */ d(
    i9,
    {
      title: t,
      onCheckedChange: e,
      id: n,
      disabled: i,
      checked: r,
      value: a,
      hideLabel: o,
      tabIndex: s ? -1 : void 0,
      ...l
    }
  );
}
const r9 = S.forwardRef(
  ({ className: t, ...e }, n) => /* @__PURE__ */ d(
    "textarea",
    {
      className: E(
        "ring-offset-background focus-visible:ring-ring flex min-h-[80px] w-full rounded-sm border-2 border-solid border-f1-border bg-f1-background px-3 py-2 text-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-f1-foreground-secondary/60 hover:border-f1-border-hover focus-visible:border-f1-border-hover focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:bg-f1-background-secondary disabled:opacity-50",
        t
      ),
      ref: n,
      ...e
    }
  )
);
r9.displayName = "Textarea";
const KXe = ui(
  {
    name: "Textarea",
    type: "form"
  },
  r9
);
var GL = "Toggle", lv = S.forwardRef((t, e) => {
  const { pressed: n, defaultPressed: i = !1, onPressedChange: r, ...a } = t, [o = !1, s] = Si({
    prop: n,
    onChange: r,
    defaultProp: i
  });
  return /* @__PURE__ */ d(
    qe.button,
    {
      type: "button",
      "aria-pressed": o,
      "data-state": o ? "on" : "off",
      "data-disabled": t.disabled ? "" : void 0,
      ...a,
      ref: e,
      onClick: ge(t.onClick, () => {
        t.disabled || s(!o);
      })
    }
  );
});
lv.displayName = GL;
var a9 = lv, Ks = "ToggleGroup", [o9, UXe] = Wi(Ks, [
  Bm
]), s9 = Bm(), dv = H.forwardRef((t, e) => {
  const { type: n, ...i } = t;
  if (n === "single")
    return /* @__PURE__ */ d(XL, { ...i, ref: e });
  if (n === "multiple")
    return /* @__PURE__ */ d(YL, { ...i, ref: e });
  throw new Error(`Missing prop \`type\` expected on \`${Ks}\``);
});
dv.displayName = Ks;
var [l9, d9] = o9(Ks), XL = H.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: i,
    onValueChange: r = () => {
    },
    ...a
  } = t, [o, s] = Si({
    prop: n,
    defaultProp: i,
    onChange: r
  });
  return /* @__PURE__ */ d(
    l9,
    {
      scope: t.__scopeToggleGroup,
      type: "single",
      value: o ? [o] : [],
      onItemActivate: s,
      onItemDeactivate: H.useCallback(() => s(""), [s]),
      children: /* @__PURE__ */ d(c9, { ...a, ref: e })
    }
  );
}), YL = H.forwardRef((t, e) => {
  const {
    value: n,
    defaultValue: i,
    onValueChange: r = () => {
    },
    ...a
  } = t, [o = [], s] = Si({
    prop: n,
    defaultProp: i,
    onChange: r
  }), l = H.useCallback(
    (u) => s((f = []) => [...f, u]),
    [s]
  ), c = H.useCallback(
    (u) => s((f = []) => f.filter((m) => m !== u)),
    [s]
  );
  return /* @__PURE__ */ d(
    l9,
    {
      scope: t.__scopeToggleGroup,
      type: "multiple",
      value: o,
      onItemActivate: l,
      onItemDeactivate: c,
      children: /* @__PURE__ */ d(c9, { ...a, ref: e })
    }
  );
});
dv.displayName = Ks;
var [KL, UL] = o9(Ks), c9 = H.forwardRef(
  (t, e) => {
    const {
      __scopeToggleGroup: n,
      disabled: i = !1,
      rovingFocus: r = !0,
      orientation: a,
      dir: o,
      loop: s = !0,
      ...l
    } = t, c = s9(n), u = Vd(o), f = { role: "group", dir: u, ...l };
    return /* @__PURE__ */ d(KL, { scope: n, rovingFocus: r, disabled: i, children: r ? /* @__PURE__ */ d(
      U6,
      {
        asChild: !0,
        ...c,
        orientation: a,
        dir: u,
        loop: s,
        children: /* @__PURE__ */ d(qe.div, { ...f, ref: e })
      }
    ) : /* @__PURE__ */ d(qe.div, { ...f, ref: e }) });
  }
), ef = "ToggleGroupItem", u9 = H.forwardRef(
  (t, e) => {
    const n = d9(ef, t.__scopeToggleGroup), i = UL(ef, t.__scopeToggleGroup), r = s9(t.__scopeToggleGroup), a = n.value.includes(t.value), o = i.disabled || t.disabled, s = { ...t, pressed: a, disabled: o }, l = H.useRef(null);
    return i.rovingFocus ? /* @__PURE__ */ d(
      J6,
      {
        asChild: !0,
        ...r,
        focusable: !o,
        active: a,
        ref: l,
        children: /* @__PURE__ */ d(jw, { ...s, ref: e })
      }
    ) : /* @__PURE__ */ d(jw, { ...s, ref: e });
  }
);
u9.displayName = ef;
var jw = H.forwardRef(
  (t, e) => {
    const { __scopeToggleGroup: n, value: i, ...r } = t, a = d9(ef, n), o = { role: "radio", "aria-checked": t.pressed, "aria-pressed": void 0 }, s = a.type === "single" ? o : void 0;
    return /* @__PURE__ */ d(
      lv,
      {
        ...s,
        ...r,
        ref: e,
        onPressedChange: (l) => {
          l ? a.onItemActivate(i) : a.onItemDeactivate(i);
        }
      }
    );
  }
), f9 = dv, m9 = u9;
const h9 = It({
  base: E(
    "inline-flex items-center justify-center rounded-sm text-sm font-medium transition-colors hover:bg-f1-background-secondary hover:text-f1-foreground-secondary disabled:pointer-events-none disabled:opacity-50 data-[state=on]:bg-f1-background-secondary data-[state=on]:text-f1-foreground",
    Ke()
  ),
  variants: {
    variant: {
      default: "bg-transparent",
      outline: "border border-f1-border bg-transparent hover:bg-f1-background-secondary hover:text-f1-foreground"
    },
    size: {
      default: "h-10 px-3",
      sm: "h-9 px-2.5",
      lg: "h-11 px-5"
    }
  },
  defaultVariants: {
    variant: "default",
    size: "default"
  }
}), JL = S.forwardRef(({ className: t, variant: e, size: n, ...i }, r) => /* @__PURE__ */ d(
  a9,
  {
    ref: r,
    className: E(h9({ variant: e, size: n, className: t })),
    ...i
  }
));
JL.displayName = a9.displayName;
const p9 = S.createContext({
  size: "default",
  variant: "default"
}), g9 = S.forwardRef(({ className: t, variant: e, size: n, children: i, ...r }, a) => /* @__PURE__ */ d(
  f9,
  {
    ref: a,
    className: E("flex items-center justify-center gap-1.5", t),
    ...r,
    children: /* @__PURE__ */ d(p9.Provider, { value: { variant: e, size: n }, children: i })
  }
));
g9.displayName = f9.displayName;
const y9 = S.forwardRef(({ className: t, children: e, variant: n, size: i, ...r }, a) => {
  const o = S.useContext(p9);
  return /* @__PURE__ */ d(
    m9,
    {
      ref: a,
      className: E(
        h9({
          variant: o.variant || n,
          size: o.size || i
        }),
        t
      ),
      ...r,
      children: e
    }
  );
});
y9.displayName = m9.displayName;
var dc = (t) => t.type === "checkbox", no = (t) => t instanceof Date, On = (t) => t == null;
const v9 = (t) => typeof t == "object";
var Ht = (t) => !On(t) && !Array.isArray(t) && v9(t) && !no(t), b9 = (t) => Ht(t) && t.target ? dc(t.target) ? t.target.checked : t.target.value : t, QL = (t) => t.substring(0, t.search(/\.\d+(\.|$)/)) || t, w9 = (t, e) => t.has(QL(e)), ZL = (t) => {
  const e = t.constructor && t.constructor.prototype;
  return Ht(e) && e.hasOwnProperty("isPrototypeOf");
}, cv = typeof window < "u" && typeof window.HTMLElement < "u" && typeof document < "u";
function qn(t) {
  let e;
  const n = Array.isArray(t), i = typeof FileList < "u" ? t instanceof FileList : !1;
  if (t instanceof Date)
    e = new Date(t);
  else if (t instanceof Set)
    e = new Set(t);
  else if (!(cv && (t instanceof Blob || i)) && (n || Ht(t)))
    if (e = n ? [] : {}, !n && !ZL(t))
      e = t;
    else
      for (const r in t)
        t.hasOwnProperty(r) && (e[r] = qn(t[r]));
  else
    return t;
  return e;
}
var Ym = (t) => Array.isArray(t) ? t.filter(Boolean) : [], jt = (t) => t === void 0, pe = (t, e, n) => {
  if (!e || !Ht(t))
    return n;
  const i = Ym(e.split(/[,[\].]+?/)).reduce((r, a) => On(r) ? r : r[a], t);
  return jt(i) || i === t ? jt(t[e]) ? n : t[e] : i;
}, yi = (t) => typeof t == "boolean", uv = (t) => /^\w*$/.test(t), k9 = (t) => Ym(t.replace(/["|']|\]/g, "").split(/\.|\[/)), ot = (t, e, n) => {
  let i = -1;
  const r = uv(e) ? [e] : k9(e), a = r.length, o = a - 1;
  for (; ++i < a; ) {
    const s = r[i];
    let l = n;
    if (i !== o) {
      const c = t[s];
      l = Ht(c) || Array.isArray(c) ? c : isNaN(+r[i + 1]) ? {} : [];
    }
    if (s === "__proto__" || s === "constructor" || s === "prototype")
      return;
    t[s] = l, t = t[s];
  }
  return t;
};
const tf = {
  BLUR: "blur",
  FOCUS_OUT: "focusout",
  CHANGE: "change"
}, ji = {
  onBlur: "onBlur",
  onChange: "onChange",
  onSubmit: "onSubmit",
  onTouched: "onTouched",
  all: "all"
}, br = {
  max: "max",
  min: "min",
  maxLength: "maxLength",
  minLength: "minLength",
  pattern: "pattern",
  required: "required",
  validate: "validate"
}, x9 = H.createContext(null), cc = () => H.useContext(x9), eI = (t) => {
  const { children: e, ...n } = t;
  return H.createElement(x9.Provider, { value: n }, e);
};
var _9 = (t, e, n, i = !0) => {
  const r = {
    defaultValues: e._defaultValues
  };
  for (const a in t)
    Object.defineProperty(r, a, {
      get: () => {
        const o = a;
        return e._proxyFormState[o] !== ji.all && (e._proxyFormState[o] = !i || ji.all), n && (n[o] = !0), t[o];
      }
    });
  return r;
}, Gn = (t) => Ht(t) && !Object.keys(t).length, M9 = (t, e, n, i) => {
  n(t);
  const { name: r, ...a } = t;
  return Gn(a) || Object.keys(a).length >= Object.keys(e).length || Object.keys(a).find((o) => e[o] === (!i || ji.all));
}, Rl = (t) => Array.isArray(t) ? t : [t], C9 = (t, e, n) => !t || !e || t === e || Rl(t).some((i) => i && (n ? i === e : i.startsWith(e) || e.startsWith(i)));
function fv(t) {
  const e = H.useRef(t);
  e.current = t, H.useEffect(() => {
    const n = !t.disabled && e.current.subject && e.current.subject.subscribe({
      next: e.current.next
    });
    return () => {
      n && n.unsubscribe();
    };
  }, [t.disabled]);
}
function tI(t) {
  const e = cc(), { control: n = e.control, disabled: i, name: r, exact: a } = t || {}, [o, s] = H.useState(n._formState), l = H.useRef(!0), c = H.useRef({
    isDirty: !1,
    isLoading: !1,
    dirtyFields: !1,
    touchedFields: !1,
    validatingFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }), u = H.useRef(r);
  return u.current = r, fv({
    disabled: i,
    next: (f) => l.current && C9(u.current, f.name, a) && M9(f, c.current, n._updateFormState) && s({
      ...n._formState,
      ...f
    }),
    subject: n._subjects.state
  }), H.useEffect(() => (l.current = !0, c.current.isValid && n._updateValid(!0), () => {
    l.current = !1;
  }), [n]), H.useMemo(() => _9(o, n, c.current, !1), [o, n]);
}
var lr = (t) => typeof t == "string", P9 = (t, e, n, i, r) => lr(t) ? (i && e.watch.add(t), pe(n, t, r)) : Array.isArray(t) ? t.map((a) => (i && e.watch.add(a), pe(n, a))) : (i && (e.watchAll = !0), n);
function nI(t) {
  const e = cc(), { control: n = e.control, name: i, defaultValue: r, disabled: a, exact: o } = t || {}, s = H.useRef(i);
  s.current = i, fv({
    disabled: a,
    subject: n._subjects.values,
    next: (u) => {
      C9(s.current, u.name, o) && c(qn(P9(s.current, n._names, u.values || n._formValues, !1, r)));
    }
  });
  const [l, c] = H.useState(n._getWatch(i, r));
  return H.useEffect(() => n._removeUnmounted()), l;
}
function iI(t) {
  const e = cc(), { name: n, disabled: i, control: r = e.control, shouldUnregister: a } = t, o = w9(r._names.array, n), s = nI({
    control: r,
    name: n,
    defaultValue: pe(r._formValues, n, pe(r._defaultValues, n, t.defaultValue)),
    exact: !0
  }), l = tI({
    control: r,
    name: n,
    exact: !0
  }), c = H.useRef(r.register(n, {
    ...t.rules,
    value: s,
    ...yi(t.disabled) ? { disabled: t.disabled } : {}
  })), u = H.useMemo(() => Object.defineProperties({}, {
    invalid: {
      enumerable: !0,
      get: () => !!pe(l.errors, n)
    },
    isDirty: {
      enumerable: !0,
      get: () => !!pe(l.dirtyFields, n)
    },
    isTouched: {
      enumerable: !0,
      get: () => !!pe(l.touchedFields, n)
    },
    isValidating: {
      enumerable: !0,
      get: () => !!pe(l.validatingFields, n)
    },
    error: {
      enumerable: !0,
      get: () => pe(l.errors, n)
    }
  }), [l, n]), f = H.useMemo(() => ({
    name: n,
    value: s,
    ...yi(i) || l.disabled ? { disabled: l.disabled || i } : {},
    onChange: (m) => c.current.onChange({
      target: {
        value: b9(m),
        name: n
      },
      type: tf.CHANGE
    }),
    onBlur: () => c.current.onBlur({
      target: {
        value: pe(r._formValues, n),
        name: n
      },
      type: tf.BLUR
    }),
    ref: (m) => {
      const h = pe(r._fields, n);
      h && m && (h._f.ref = {
        focus: () => m.focus(),
        select: () => m.select(),
        setCustomValidity: (p) => m.setCustomValidity(p),
        reportValidity: () => m.reportValidity()
      });
    }
  }), [
    n,
    r._formValues,
    i,
    l.disabled,
    s,
    r._fields
  ]);
  return H.useEffect(() => {
    const m = r._options.shouldUnregister || a, h = (p, g) => {
      const y = pe(r._fields, p);
      y && y._f && (y._f.mount = g);
    };
    if (h(n, !0), m) {
      const p = qn(pe(r._options.defaultValues, n));
      ot(r._defaultValues, n, p), jt(pe(r._formValues, n)) && ot(r._formValues, n, p);
    }
    return !o && r.register(n), () => {
      (o ? m && !r._state.action : m) ? r.unregister(n) : h(n, !1);
    };
  }, [n, r, o, a]), H.useEffect(() => {
    r._updateDisabledField({
      disabled: i,
      fields: r._fields,
      name: n
    });
  }, [i, n, r]), H.useMemo(() => ({
    field: f,
    formState: l,
    fieldState: u
  }), [f, l, u]);
}
const rI = (t) => t.render(iI(t));
var S9 = (t, e, n, i, r) => e ? {
  ...n[t],
  types: {
    ...n[t] && n[t].types ? n[t].types : {},
    [i]: r || !0
  }
} : {}, Fw = (t) => ({
  isOnSubmit: !t || t === ji.onSubmit,
  isOnBlur: t === ji.onBlur,
  isOnChange: t === ji.onChange,
  isOnAll: t === ji.all,
  isOnTouch: t === ji.onTouched
}), zw = (t, e, n) => !n && (e.watchAll || e.watch.has(t) || [...e.watch].some((i) => t.startsWith(i) && /^\.\w+/.test(t.slice(i.length))));
const jl = (t, e, n, i) => {
  for (const r of n || Object.keys(t)) {
    const a = pe(t, r);
    if (a) {
      const { _f: o, ...s } = a;
      if (o) {
        if (o.refs && o.refs[0] && e(o.refs[0], r) && !i)
          return !0;
        if (o.ref && e(o.ref, o.name) && !i)
          return !0;
        if (jl(s, e))
          break;
      } else if (Ht(s) && jl(s, e))
        break;
    }
  }
};
var aI = (t, e, n) => {
  const i = Rl(pe(t, n));
  return ot(i, "root", e[n]), ot(t, n, i), t;
}, mv = (t) => t.type === "file", ar = (t) => typeof t == "function", nf = (t) => {
  if (!cv)
    return !1;
  const e = t ? t.ownerDocument : 0;
  return t instanceof (e && e.defaultView ? e.defaultView.HTMLElement : HTMLElement);
}, vu = (t) => lr(t), hv = (t) => t.type === "radio", rf = (t) => t instanceof RegExp;
const Vw = {
  value: !1,
  isValid: !1
}, Hw = { value: !0, isValid: !0 };
var N9 = (t) => {
  if (Array.isArray(t)) {
    if (t.length > 1) {
      const e = t.filter((n) => n && n.checked && !n.disabled).map((n) => n.value);
      return { value: e, isValid: !!e.length };
    }
    return t[0].checked && !t[0].disabled ? (
      // @ts-expect-error expected to work in the browser
      t[0].attributes && !jt(t[0].attributes.value) ? jt(t[0].value) || t[0].value === "" ? Hw : { value: t[0].value, isValid: !0 } : Hw
    ) : Vw;
  }
  return Vw;
};
const Bw = {
  isValid: !1,
  value: null
};
var $9 = (t) => Array.isArray(t) ? t.reduce((e, n) => n && n.checked && !n.disabled ? {
  isValid: !0,
  value: n.value
} : e, Bw) : Bw;
function qw(t, e, n = "validate") {
  if (vu(t) || Array.isArray(t) && t.every(vu) || yi(t) && !t)
    return {
      type: n,
      message: vu(t) ? t : "",
      ref: e
    };
}
var zo = (t) => Ht(t) && !rf(t) ? t : {
  value: t,
  message: ""
}, Gw = async (t, e, n, i, r, a) => {
  const { ref: o, refs: s, required: l, maxLength: c, minLength: u, min: f, max: m, pattern: h, validate: p, name: g, valueAsNumber: y, mount: v } = t._f, w = pe(n, g);
  if (!v || e.has(g))
    return {};
  const x = s ? s[0] : o, b = (O) => {
    r && x.reportValidity && (x.setCustomValidity(yi(O) ? "" : O || ""), x.reportValidity());
  }, M = {}, _ = hv(o), N = dc(o), $ = _ || N, D = (y || mv(o)) && jt(o.value) && jt(w) || nf(o) && o.value === "" || w === "" || Array.isArray(w) && !w.length, W = S9.bind(null, g, i, M), j = (O, I, L, R = br.maxLength, B = br.minLength) => {
    const F = O ? I : L;
    M[g] = {
      type: O ? R : B,
      message: F,
      ref: o,
      ...W(O ? R : B, F)
    };
  };
  if (a ? !Array.isArray(w) || !w.length : l && (!$ && (D || On(w)) || yi(w) && !w || N && !N9(s).isValid || _ && !$9(s).isValid)) {
    const { value: O, message: I } = vu(l) ? { value: !!l, message: l } : zo(l);
    if (O && (M[g] = {
      type: br.required,
      message: I,
      ref: x,
      ...W(br.required, I)
    }, !i))
      return b(I), M;
  }
  if (!D && (!On(f) || !On(m))) {
    let O, I;
    const L = zo(m), R = zo(f);
    if (!On(w) && !isNaN(w)) {
      const B = o.valueAsNumber || w && +w;
      On(L.value) || (O = B > L.value), On(R.value) || (I = B < R.value);
    } else {
      const B = o.valueAsDate || new Date(w), F = (ae) => /* @__PURE__ */ new Date((/* @__PURE__ */ new Date()).toDateString() + " " + ae), z = o.type == "time", K = o.type == "week";
      lr(L.value) && w && (O = z ? F(w) > F(L.value) : K ? w > L.value : B > new Date(L.value)), lr(R.value) && w && (I = z ? F(w) < F(R.value) : K ? w < R.value : B < new Date(R.value));
    }
    if ((O || I) && (j(!!O, L.message, R.message, br.max, br.min), !i))
      return b(M[g].message), M;
  }
  if ((c || u) && !D && (lr(w) || a && Array.isArray(w))) {
    const O = zo(c), I = zo(u), L = !On(O.value) && w.length > +O.value, R = !On(I.value) && w.length < +I.value;
    if ((L || R) && (j(L, O.message, I.message), !i))
      return b(M[g].message), M;
  }
  if (h && !D && lr(w)) {
    const { value: O, message: I } = zo(h);
    if (rf(O) && !w.match(O) && (M[g] = {
      type: br.pattern,
      message: I,
      ref: o,
      ...W(br.pattern, I)
    }, !i))
      return b(I), M;
  }
  if (p) {
    if (ar(p)) {
      const O = await p(w, n), I = qw(O, x);
      if (I && (M[g] = {
        ...I,
        ...W(br.validate, I.message)
      }, !i))
        return b(I.message), M;
    } else if (Ht(p)) {
      let O = {};
      for (const I in p) {
        if (!Gn(O) && !i)
          break;
        const L = qw(await p[I](w, n), x, I);
        L && (O = {
          ...L,
          ...W(I, L.message)
        }, b(L.message), i && (M[g] = O));
      }
      if (!Gn(O) && (M[g] = {
        ref: x,
        ...O
      }, !i))
        return M;
    }
  }
  return b(!0), M;
};
function oI(t, e) {
  const n = e.slice(0, -1).length;
  let i = 0;
  for (; i < n; )
    t = jt(t) ? i++ : t[e[i++]];
  return t;
}
function sI(t) {
  for (const e in t)
    if (t.hasOwnProperty(e) && !jt(t[e]))
      return !1;
  return !0;
}
function Jt(t, e) {
  const n = Array.isArray(e) ? e : uv(e) ? [e] : k9(e), i = n.length === 1 ? t : oI(t, n), r = n.length - 1, a = n[r];
  return i && delete i[a], r !== 0 && (Ht(i) && Gn(i) || Array.isArray(i) && sI(i)) && Jt(t, n.slice(0, -1)), t;
}
var Kh = () => {
  let t = [];
  return {
    get observers() {
      return t;
    },
    next: (r) => {
      for (const a of t)
        a.next && a.next(r);
    },
    subscribe: (r) => (t.push(r), {
      unsubscribe: () => {
        t = t.filter((a) => a !== r);
      }
    }),
    unsubscribe: () => {
      t = [];
    }
  };
}, Rp = (t) => On(t) || !v9(t);
function ra(t, e) {
  if (Rp(t) || Rp(e))
    return t === e;
  if (no(t) && no(e))
    return t.getTime() === e.getTime();
  const n = Object.keys(t), i = Object.keys(e);
  if (n.length !== i.length)
    return !1;
  for (const r of n) {
    const a = t[r];
    if (!i.includes(r))
      return !1;
    if (r !== "ref") {
      const o = e[r];
      if (no(a) && no(o) || Ht(a) && Ht(o) || Array.isArray(a) && Array.isArray(o) ? !ra(a, o) : a !== o)
        return !1;
    }
  }
  return !0;
}
var D9 = (t) => t.type === "select-multiple", lI = (t) => hv(t) || dc(t), Uh = (t) => nf(t) && t.isConnected, E9 = (t) => {
  for (const e in t)
    if (ar(t[e]))
      return !0;
  return !1;
};
function af(t, e = {}) {
  const n = Array.isArray(t);
  if (Ht(t) || n)
    for (const i in t)
      Array.isArray(t[i]) || Ht(t[i]) && !E9(t[i]) ? (e[i] = Array.isArray(t[i]) ? [] : {}, af(t[i], e[i])) : On(t[i]) || (e[i] = !0);
  return e;
}
function T9(t, e, n) {
  const i = Array.isArray(t);
  if (Ht(t) || i)
    for (const r in t)
      Array.isArray(t[r]) || Ht(t[r]) && !E9(t[r]) ? jt(e) || Rp(n[r]) ? n[r] = Array.isArray(t[r]) ? af(t[r], []) : { ...af(t[r]) } : T9(t[r], On(e) ? {} : e[r], n[r]) : n[r] = !ra(t[r], e[r]);
  return n;
}
var ul = (t, e) => T9(t, e, af(e)), O9 = (t, { valueAsNumber: e, valueAsDate: n, setValueAs: i }) => jt(t) ? t : e ? t === "" ? NaN : t && +t : n && lr(t) ? new Date(t) : i ? i(t) : t;
function Jh(t) {
  const e = t.ref;
  return mv(e) ? e.files : hv(e) ? $9(t.refs).value : D9(e) ? [...e.selectedOptions].map(({ value: n }) => n) : dc(e) ? N9(t.refs).value : O9(jt(e.value) ? t.ref.value : e.value, t);
}
var dI = (t, e, n, i) => {
  const r = {};
  for (const a of t) {
    const o = pe(e, a);
    o && ot(r, a, o._f);
  }
  return {
    criteriaMode: n,
    names: [...t],
    fields: r,
    shouldUseNativeValidation: i
  };
}, fl = (t) => jt(t) ? t : rf(t) ? t.source : Ht(t) ? rf(t.value) ? t.value.source : t.value : t;
const Xw = "AsyncFunction";
var cI = (t) => !!t && !!t.validate && !!(ar(t.validate) && t.validate.constructor.name === Xw || Ht(t.validate) && Object.values(t.validate).find((e) => e.constructor.name === Xw)), uI = (t) => t.mount && (t.required || t.min || t.max || t.maxLength || t.minLength || t.pattern || t.validate);
function Yw(t, e, n) {
  const i = pe(t, n);
  if (i || uv(n))
    return {
      error: i,
      name: n
    };
  const r = n.split(".");
  for (; r.length; ) {
    const a = r.join("."), o = pe(e, a), s = pe(t, a);
    if (o && !Array.isArray(o) && n !== a)
      return { name: n };
    if (s && s.type)
      return {
        name: a,
        error: s
      };
    r.pop();
  }
  return {
    name: n
  };
}
var fI = (t, e, n, i, r) => r.isOnAll ? !1 : !n && r.isOnTouch ? !(e || t) : (n ? i.isOnBlur : r.isOnBlur) ? !t : (n ? i.isOnChange : r.isOnChange) ? t : !0, mI = (t, e) => !Ym(pe(t, e)).length && Jt(t, e);
const hI = {
  mode: ji.onSubmit,
  reValidateMode: ji.onChange,
  shouldFocusError: !0
};
function pI(t = {}) {
  let e = {
    ...hI,
    ...t
  }, n = {
    submitCount: 0,
    isDirty: !1,
    isLoading: ar(e.defaultValues),
    isValidating: !1,
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    touchedFields: {},
    dirtyFields: {},
    validatingFields: {},
    errors: e.errors || {},
    disabled: e.disabled || !1
  }, i = {}, r = Ht(e.defaultValues) || Ht(e.values) ? qn(e.defaultValues || e.values) || {} : {}, a = e.shouldUnregister ? {} : qn(r), o = {
    action: !1,
    mount: !1,
    watch: !1
  }, s = {
    mount: /* @__PURE__ */ new Set(),
    disabled: /* @__PURE__ */ new Set(),
    unMount: /* @__PURE__ */ new Set(),
    array: /* @__PURE__ */ new Set(),
    watch: /* @__PURE__ */ new Set()
  }, l, c = 0;
  const u = {
    isDirty: !1,
    dirtyFields: !1,
    validatingFields: !1,
    touchedFields: !1,
    isValidating: !1,
    isValid: !1,
    errors: !1
  }, f = {
    values: Kh(),
    array: Kh(),
    state: Kh()
  }, m = Fw(e.mode), h = Fw(e.reValidateMode), p = e.criteriaMode === ji.all, g = (A) => (V) => {
    clearTimeout(c), c = setTimeout(A, V);
  }, y = async (A) => {
    if (!e.disabled && (u.isValid || A)) {
      const V = e.resolver ? Gn((await $()).errors) : await W(i, !0);
      V !== n.isValid && f.state.next({
        isValid: V
      });
    }
  }, v = (A, V) => {
    !e.disabled && (u.isValidating || u.validatingFields) && ((A || Array.from(s.mount)).forEach((G) => {
      G && (V ? ot(n.validatingFields, G, V) : Jt(n.validatingFields, G));
    }), f.state.next({
      validatingFields: n.validatingFields,
      isValidating: !Gn(n.validatingFields)
    }));
  }, w = (A, V = [], G, de, fe = !0, ne = !0) => {
    if (de && G && !e.disabled) {
      if (o.action = !0, ne && Array.isArray(pe(i, A))) {
        const Te = G(pe(i, A), de.argA, de.argB);
        fe && ot(i, A, Te);
      }
      if (ne && Array.isArray(pe(n.errors, A))) {
        const Te = G(pe(n.errors, A), de.argA, de.argB);
        fe && ot(n.errors, A, Te), mI(n.errors, A);
      }
      if (u.touchedFields && ne && Array.isArray(pe(n.touchedFields, A))) {
        const Te = G(pe(n.touchedFields, A), de.argA, de.argB);
        fe && ot(n.touchedFields, A, Te);
      }
      u.dirtyFields && (n.dirtyFields = ul(r, a)), f.state.next({
        name: A,
        isDirty: O(A, V),
        dirtyFields: n.dirtyFields,
        errors: n.errors,
        isValid: n.isValid
      });
    } else
      ot(a, A, V);
  }, x = (A, V) => {
    ot(n.errors, A, V), f.state.next({
      errors: n.errors
    });
  }, b = (A) => {
    n.errors = A, f.state.next({
      errors: n.errors,
      isValid: !1
    });
  }, M = (A, V, G, de) => {
    const fe = pe(i, A);
    if (fe) {
      const ne = pe(a, A, jt(G) ? pe(r, A) : G);
      jt(ne) || de && de.defaultChecked || V ? ot(a, A, V ? ne : Jh(fe._f)) : R(A, ne), o.mount && y();
    }
  }, _ = (A, V, G, de, fe) => {
    let ne = !1, Te = !1;
    const Ve = {
      name: A
    };
    if (!e.disabled) {
      const kt = !!(pe(i, A) && pe(i, A)._f && pe(i, A)._f.disabled);
      if (!G || de) {
        u.isDirty && (Te = n.isDirty, n.isDirty = Ve.isDirty = O(), ne = Te !== Ve.isDirty);
        const xt = kt || ra(pe(r, A), V);
        Te = !!(!kt && pe(n.dirtyFields, A)), xt || kt ? Jt(n.dirtyFields, A) : ot(n.dirtyFields, A, !0), Ve.dirtyFields = n.dirtyFields, ne = ne || u.dirtyFields && Te !== !xt;
      }
      if (G) {
        const xt = pe(n.touchedFields, A);
        xt || (ot(n.touchedFields, A, G), Ve.touchedFields = n.touchedFields, ne = ne || u.touchedFields && xt !== G);
      }
      ne && fe && f.state.next(Ve);
    }
    return ne ? Ve : {};
  }, N = (A, V, G, de) => {
    const fe = pe(n.errors, A), ne = u.isValid && yi(V) && n.isValid !== V;
    if (e.delayError && G ? (l = g(() => x(A, G)), l(e.delayError)) : (clearTimeout(c), l = null, G ? ot(n.errors, A, G) : Jt(n.errors, A)), (G ? !ra(fe, G) : fe) || !Gn(de) || ne) {
      const Te = {
        ...de,
        ...ne && yi(V) ? { isValid: V } : {},
        errors: n.errors,
        name: A
      };
      n = {
        ...n,
        ...Te
      }, f.state.next(Te);
    }
  }, $ = async (A) => {
    v(A, !0);
    const V = await e.resolver(a, e.context, dI(A || s.mount, i, e.criteriaMode, e.shouldUseNativeValidation));
    return v(A), V;
  }, D = async (A) => {
    const { errors: V } = await $(A);
    if (A)
      for (const G of A) {
        const de = pe(V, G);
        de ? ot(n.errors, G, de) : Jt(n.errors, G);
      }
    else
      n.errors = V;
    return V;
  }, W = async (A, V, G = {
    valid: !0
  }) => {
    for (const de in A) {
      const fe = A[de];
      if (fe) {
        const { _f: ne, ...Te } = fe;
        if (ne) {
          const Ve = s.array.has(ne.name), kt = fe._f && cI(fe._f);
          kt && u.validatingFields && v([de], !0);
          const xt = await Gw(fe, s.disabled, a, p, e.shouldUseNativeValidation && !V, Ve);
          if (kt && u.validatingFields && v([de]), xt[ne.name] && (G.valid = !1, V))
            break;
          !V && (pe(xt, ne.name) ? Ve ? aI(n.errors, xt, ne.name) : ot(n.errors, ne.name, xt[ne.name]) : Jt(n.errors, ne.name));
        }
        !Gn(Te) && await W(Te, V, G);
      }
    }
    return G.valid;
  }, j = () => {
    for (const A of s.unMount) {
      const V = pe(i, A);
      V && (V._f.refs ? V._f.refs.every((G) => !Uh(G)) : !Uh(V._f.ref)) && $e(A);
    }
    s.unMount = /* @__PURE__ */ new Set();
  }, O = (A, V) => !e.disabled && (A && V && ot(a, A, V), !ra(Q(), r)), I = (A, V, G) => P9(A, s, {
    ...o.mount ? a : jt(V) ? r : lr(A) ? { [A]: V } : V
  }, G, V), L = (A) => Ym(pe(o.mount ? a : r, A, e.shouldUnregister ? pe(r, A, []) : [])), R = (A, V, G = {}) => {
    const de = pe(i, A);
    let fe = V;
    if (de) {
      const ne = de._f;
      ne && (!ne.disabled && ot(a, A, O9(V, ne)), fe = nf(ne.ref) && On(V) ? "" : V, D9(ne.ref) ? [...ne.ref.options].forEach((Te) => Te.selected = fe.includes(Te.value)) : ne.refs ? dc(ne.ref) ? ne.refs.length > 1 ? ne.refs.forEach((Te) => (!Te.defaultChecked || !Te.disabled) && (Te.checked = Array.isArray(fe) ? !!fe.find((Ve) => Ve === Te.value) : fe === Te.value)) : ne.refs[0] && (ne.refs[0].checked = !!fe) : ne.refs.forEach((Te) => Te.checked = Te.value === fe) : mv(ne.ref) ? ne.ref.value = "" : (ne.ref.value = fe, ne.ref.type || f.values.next({
        name: A,
        values: { ...a }
      })));
    }
    (G.shouldDirty || G.shouldTouch) && _(A, fe, G.shouldTouch, G.shouldDirty, !0), G.shouldValidate && ae(A);
  }, B = (A, V, G) => {
    for (const de in V) {
      const fe = V[de], ne = `${A}.${de}`, Te = pe(i, ne);
      (s.array.has(A) || Ht(fe) || Te && !Te._f) && !no(fe) ? B(ne, fe, G) : R(ne, fe, G);
    }
  }, F = (A, V, G = {}) => {
    const de = pe(i, A), fe = s.array.has(A), ne = qn(V);
    ot(a, A, ne), fe ? (f.array.next({
      name: A,
      values: { ...a }
    }), (u.isDirty || u.dirtyFields) && G.shouldDirty && f.state.next({
      name: A,
      dirtyFields: ul(r, a),
      isDirty: O(A, ne)
    })) : de && !de._f && !On(ne) ? B(A, ne, G) : R(A, ne, G), zw(A, s) && f.state.next({ ...n }), f.values.next({
      name: o.mount ? A : void 0,
      values: { ...a }
    });
  }, z = async (A) => {
    o.mount = !0;
    const V = A.target;
    let G = V.name, de = !0;
    const fe = pe(i, G), ne = () => V.type ? Jh(fe._f) : b9(A), Te = (Ve) => {
      de = Number.isNaN(Ve) || no(Ve) && isNaN(Ve.getTime()) || ra(Ve, pe(a, G, Ve));
    };
    if (fe) {
      let Ve, kt;
      const xt = ne(), Zt = A.type === tf.BLUR || A.type === tf.FOCUS_OUT, dl = !uI(fe._f) && !e.resolver && !pe(n.errors, G) && !fe._f.deps || fI(Zt, pe(n.touchedFields, G), n.isSubmitted, h, m), Kr = zw(G, s, Zt);
      ot(a, G, xt), Zt ? (fe._f.onBlur && fe._f.onBlur(A), l && l(0)) : fe._f.onChange && fe._f.onChange(A);
      const Ga = _(G, xt, Zt, !1), vr = !Gn(Ga) || Kr;
      if (!Zt && f.values.next({
        name: G,
        type: A.type,
        values: { ...a }
      }), dl)
        return u.isValid && (e.mode === "onBlur" && Zt ? y() : Zt || y()), vr && f.state.next({ name: G, ...Kr ? {} : Ga });
      if (!Zt && Kr && f.state.next({ ...n }), e.resolver) {
        const { errors: Xa } = await $([G]);
        if (Te(xt), de) {
          const U = Yw(n.errors, i, G), Me = Yw(Xa, i, U.name || G);
          Ve = Me.error, G = Me.name, kt = Gn(Xa);
        }
      } else
        v([G], !0), Ve = (await Gw(fe, s.disabled, a, p, e.shouldUseNativeValidation))[G], v([G]), Te(xt), de && (Ve ? kt = !1 : u.isValid && (kt = await W(i, !0)));
      de && (fe._f.deps && ae(fe._f.deps), N(G, kt, Ve, Ga));
    }
  }, K = (A, V) => {
    if (pe(n.errors, V) && A.focus)
      return A.focus(), 1;
  }, ae = async (A, V = {}) => {
    let G, de;
    const fe = Rl(A);
    if (e.resolver) {
      const ne = await D(jt(A) ? A : fe);
      G = Gn(ne), de = A ? !fe.some((Te) => pe(ne, Te)) : G;
    } else A ? (de = (await Promise.all(fe.map(async (ne) => {
      const Te = pe(i, ne);
      return await W(Te && Te._f ? { [ne]: Te } : Te);
    }))).every(Boolean), !(!de && !n.isValid) && y()) : de = G = await W(i);
    return f.state.next({
      ...!lr(A) || u.isValid && G !== n.isValid ? {} : { name: A },
      ...e.resolver || !A ? { isValid: G } : {},
      errors: n.errors
    }), V.shouldFocus && !de && jl(i, K, A ? fe : s.mount), de;
  }, Q = (A) => {
    const V = {
      ...o.mount ? a : r
    };
    return jt(A) ? V : lr(A) ? pe(V, A) : A.map((G) => pe(V, G));
  }, te = (A, V) => ({
    invalid: !!pe((V || n).errors, A),
    isDirty: !!pe((V || n).dirtyFields, A),
    error: pe((V || n).errors, A),
    isValidating: !!pe(n.validatingFields, A),
    isTouched: !!pe((V || n).touchedFields, A)
  }), be = (A) => {
    A && Rl(A).forEach((V) => Jt(n.errors, V)), f.state.next({
      errors: A ? n.errors : {}
    });
  }, Pe = (A, V, G) => {
    const de = (pe(i, A, { _f: {} })._f || {}).ref, fe = pe(n.errors, A) || {}, { ref: ne, message: Te, type: Ve, ...kt } = fe;
    ot(n.errors, A, {
      ...kt,
      ...V,
      ref: de
    }), f.state.next({
      name: A,
      errors: n.errors,
      isValid: !1
    }), G && G.shouldFocus && de && de.focus && de.focus();
  }, We = (A, V) => ar(A) ? f.values.subscribe({
    next: (G) => A(I(void 0, V), G)
  }) : I(A, V, !0), $e = (A, V = {}) => {
    for (const G of A ? Rl(A) : s.mount)
      s.mount.delete(G), s.array.delete(G), V.keepValue || (Jt(i, G), Jt(a, G)), !V.keepError && Jt(n.errors, G), !V.keepDirty && Jt(n.dirtyFields, G), !V.keepTouched && Jt(n.touchedFields, G), !V.keepIsValidating && Jt(n.validatingFields, G), !e.shouldUnregister && !V.keepDefaultValue && Jt(r, G);
    f.values.next({
      values: { ...a }
    }), f.state.next({
      ...n,
      ...V.keepDirty ? { isDirty: O() } : {}
    }), !V.keepIsValid && y();
  }, Y = ({ disabled: A, name: V, field: G, fields: de }) => {
    (yi(A) && o.mount || A || s.disabled.has(V)) && (A ? s.disabled.add(V) : s.disabled.delete(V), _(V, Jh(G ? G._f : pe(de, V)._f), !1, !1, !0));
  }, oe = (A, V = {}) => {
    let G = pe(i, A);
    const de = yi(V.disabled) || yi(e.disabled);
    return ot(i, A, {
      ...G || {},
      _f: {
        ...G && G._f ? G._f : { ref: { name: A } },
        name: A,
        mount: !0,
        ...V
      }
    }), s.mount.add(A), G ? Y({
      field: G,
      disabled: yi(V.disabled) ? V.disabled : e.disabled,
      name: A
    }) : M(A, !0, V.value), {
      ...de ? { disabled: V.disabled || e.disabled } : {},
      ...e.progressive ? {
        required: !!V.required,
        min: fl(V.min),
        max: fl(V.max),
        minLength: fl(V.minLength),
        maxLength: fl(V.maxLength),
        pattern: fl(V.pattern)
      } : {},
      name: A,
      onChange: z,
      onBlur: z,
      ref: (fe) => {
        if (fe) {
          oe(A, V), G = pe(i, A);
          const ne = jt(fe.value) && fe.querySelectorAll && fe.querySelectorAll("input,select,textarea")[0] || fe, Te = lI(ne), Ve = G._f.refs || [];
          if (Te ? Ve.find((kt) => kt === ne) : ne === G._f.ref)
            return;
          ot(i, A, {
            _f: {
              ...G._f,
              ...Te ? {
                refs: [
                  ...Ve.filter(Uh),
                  ne,
                  ...Array.isArray(pe(r, A)) ? [{}] : []
                ],
                ref: { type: ne.type, name: A }
              } : { ref: ne }
            }
          }), M(A, !1, void 0, ne);
        } else
          G = pe(i, A, {}), G._f && (G._f.mount = !1), (e.shouldUnregister || V.shouldUnregister) && !(w9(s.array, A) && o.action) && s.unMount.add(A);
      }
    };
  }, se = () => e.shouldFocusError && jl(i, K, s.mount), J = (A) => {
    yi(A) && (f.state.next({ disabled: A }), jl(i, (V, G) => {
      const de = pe(i, G);
      de && (V.disabled = de._f.disabled || A, Array.isArray(de._f.refs) && de._f.refs.forEach((fe) => {
        fe.disabled = de._f.disabled || A;
      }));
    }, 0, !1));
  }, xe = (A, V) => async (G) => {
    let de;
    G && (G.preventDefault && G.preventDefault(), G.persist && G.persist());
    let fe = qn(a);
    if (s.disabled.size)
      for (const ne of s.disabled)
        ot(fe, ne, void 0);
    if (f.state.next({
      isSubmitting: !0
    }), e.resolver) {
      const { errors: ne, values: Te } = await $();
      n.errors = ne, fe = Te;
    } else
      await W(i);
    if (Jt(n.errors, "root"), Gn(n.errors)) {
      f.state.next({
        errors: {}
      });
      try {
        await A(fe, G);
      } catch (ne) {
        de = ne;
      }
    } else
      V && await V({ ...n.errors }, G), se(), setTimeout(se);
    if (f.state.next({
      isSubmitted: !0,
      isSubmitting: !1,
      isSubmitSuccessful: Gn(n.errors) && !de,
      submitCount: n.submitCount + 1,
      errors: n.errors
    }), de)
      throw de;
  }, De = (A, V = {}) => {
    pe(i, A) && (jt(V.defaultValue) ? F(A, qn(pe(r, A))) : (F(A, V.defaultValue), ot(r, A, qn(V.defaultValue))), V.keepTouched || Jt(n.touchedFields, A), V.keepDirty || (Jt(n.dirtyFields, A), n.isDirty = V.defaultValue ? O(A, qn(pe(r, A))) : O()), V.keepError || (Jt(n.errors, A), u.isValid && y()), f.state.next({ ...n }));
  }, _e = (A, V = {}) => {
    const G = A ? qn(A) : r, de = qn(G), fe = Gn(A), ne = fe ? r : de;
    if (V.keepDefaultValues || (r = G), !V.keepValues) {
      if (V.keepDirtyValues) {
        const Te = /* @__PURE__ */ new Set([
          ...s.mount,
          ...Object.keys(ul(r, a))
        ]);
        for (const Ve of Array.from(Te))
          pe(n.dirtyFields, Ve) ? ot(ne, Ve, pe(a, Ve)) : F(Ve, pe(ne, Ve));
      } else {
        if (cv && jt(A))
          for (const Te of s.mount) {
            const Ve = pe(i, Te);
            if (Ve && Ve._f) {
              const kt = Array.isArray(Ve._f.refs) ? Ve._f.refs[0] : Ve._f.ref;
              if (nf(kt)) {
                const xt = kt.closest("form");
                if (xt) {
                  xt.reset();
                  break;
                }
              }
            }
          }
        i = {};
      }
      a = e.shouldUnregister ? V.keepDefaultValues ? qn(r) : {} : qn(ne), f.array.next({
        values: { ...ne }
      }), f.values.next({
        values: { ...ne }
      });
    }
    s = {
      mount: V.keepDirtyValues ? s.mount : /* @__PURE__ */ new Set(),
      unMount: /* @__PURE__ */ new Set(),
      array: /* @__PURE__ */ new Set(),
      disabled: /* @__PURE__ */ new Set(),
      watch: /* @__PURE__ */ new Set(),
      watchAll: !1,
      focus: ""
    }, o.mount = !u.isValid || !!V.keepIsValid || !!V.keepDirtyValues, o.watch = !!e.shouldUnregister, f.state.next({
      submitCount: V.keepSubmitCount ? n.submitCount : 0,
      isDirty: fe ? !1 : V.keepDirty ? n.isDirty : !!(V.keepDefaultValues && !ra(A, r)),
      isSubmitted: V.keepIsSubmitted ? n.isSubmitted : !1,
      dirtyFields: fe ? {} : V.keepDirtyValues ? V.keepDefaultValues && a ? ul(r, a) : n.dirtyFields : V.keepDefaultValues && A ? ul(r, A) : V.keepDirty ? n.dirtyFields : {},
      touchedFields: V.keepTouched ? n.touchedFields : {},
      errors: V.keepErrors ? n.errors : {},
      isSubmitSuccessful: V.keepIsSubmitSuccessful ? n.isSubmitSuccessful : !1,
      isSubmitting: !1
    });
  }, ce = (A, V) => _e(ar(A) ? A(a) : A, V);
  return {
    control: {
      register: oe,
      unregister: $e,
      getFieldState: te,
      handleSubmit: xe,
      setError: Pe,
      _executeSchema: $,
      _getWatch: I,
      _getDirty: O,
      _updateValid: y,
      _removeUnmounted: j,
      _updateFieldArray: w,
      _updateDisabledField: Y,
      _getFieldArray: L,
      _reset: _e,
      _resetDefaultValues: () => ar(e.defaultValues) && e.defaultValues().then((A) => {
        ce(A, e.resetOptions), f.state.next({
          isLoading: !1
        });
      }),
      _updateFormState: (A) => {
        n = {
          ...n,
          ...A
        };
      },
      _disableForm: J,
      _subjects: f,
      _proxyFormState: u,
      _setErrors: b,
      get _fields() {
        return i;
      },
      get _formValues() {
        return a;
      },
      get _state() {
        return o;
      },
      set _state(A) {
        o = A;
      },
      get _defaultValues() {
        return r;
      },
      get _names() {
        return s;
      },
      set _names(A) {
        s = A;
      },
      get _formState() {
        return n;
      },
      set _formState(A) {
        n = A;
      },
      get _options() {
        return e;
      },
      set _options(A) {
        e = {
          ...e,
          ...A
        };
      }
    },
    trigger: ae,
    register: oe,
    handleSubmit: xe,
    watch: We,
    setValue: F,
    getValues: Q,
    reset: ce,
    resetField: De,
    clearErrors: be,
    unregister: $e,
    setError: Pe,
    setFocus: (A, V = {}) => {
      const G = pe(i, A), de = G && G._f;
      if (de) {
        const fe = de.refs ? de.refs[0] : de.ref;
        fe.focus && (fe.focus(), V.shouldSelect && ar(fe.select) && fe.select());
      }
    },
    getFieldState: te
  };
}
function gI(t = {}) {
  const e = H.useRef(void 0), n = H.useRef(void 0), [i, r] = H.useState({
    isDirty: !1,
    isValidating: !1,
    isLoading: ar(t.defaultValues),
    isSubmitted: !1,
    isSubmitting: !1,
    isSubmitSuccessful: !1,
    isValid: !1,
    submitCount: 0,
    dirtyFields: {},
    touchedFields: {},
    validatingFields: {},
    errors: t.errors || {},
    disabled: t.disabled || !1,
    defaultValues: ar(t.defaultValues) ? void 0 : t.defaultValues
  });
  e.current || (e.current = {
    ...pI(t),
    formState: i
  });
  const a = e.current.control;
  return a._options = t, fv({
    subject: a._subjects.state,
    next: (o) => {
      M9(o, a._proxyFormState, a._updateFormState, !0) && r({ ...a._formState });
    }
  }), H.useEffect(() => a._disableForm(t.disabled), [a, t.disabled]), H.useEffect(() => {
    if (a._proxyFormState.isDirty) {
      const o = a._getDirty();
      o !== i.isDirty && a._subjects.state.next({
        isDirty: o
      });
    }
  }, [a, i.isDirty]), H.useEffect(() => {
    t.values && !ra(t.values, n.current) ? (a._reset(t.values, a._options.resetOptions), n.current = t.values, r((o) => ({ ...o }))) : a._resetDefaultValues();
  }, [t.values, a]), H.useEffect(() => {
    t.errors && a._setErrors(t.errors);
  }, [t.errors, a]), H.useEffect(() => {
    a._state.mount || (a._updateValid(), a._state.mount = !0), a._state.watch && (a._state.watch = !1, a._subjects.state.next({ ...a._formState })), a._removeUnmounted();
  }), H.useEffect(() => {
    t.shouldUnregister && a._subjects.values.next({
      values: a._getWatch()
    });
  }, [t.shouldUnregister, a]), e.current.formState = _9(i, a), e.current;
}
const yI = eI, W9 = S.createContext(
  {}
), vI = ({
  ...t
}) => {
  const { formState: e } = cc();
  return /* @__PURE__ */ d(W9.Provider, { value: { name: t.name }, children: /* @__PURE__ */ d(rI, { ...t, disabled: e.isSubmitting }) });
}, Km = () => {
  const t = S.useContext(W9), e = S.useContext(A9), { getFieldState: n, formState: i } = cc(), r = n(t.name, i);
  if (!t)
    throw new Error("useFormField should be used within <FormField>");
  const { id: a } = e;
  return {
    id: a,
    name: t.name,
    formItemId: `${a}-form-item`,
    formDescriptionId: `${a}-form-item-description`,
    formMessageId: `${a}-form-item-message`,
    ...r
  };
}, A9 = S.createContext(
  {}
), L9 = S.forwardRef(({ className: t, ...e }, n) => {
  const i = S.useId();
  return /* @__PURE__ */ d(A9.Provider, { value: { id: i }, children: /* @__PURE__ */ d("div", { ref: n, className: E("space-y-2", t), ...e }) });
});
L9.displayName = "FormItem";
const I9 = S.forwardRef(({ className: t, ...e }, n) => {
  const { error: i, formItemId: r } = Km();
  return /* @__PURE__ */ d(
    A$,
    {
      ref: n,
      className: E(i && "text-f1-foreground-critical", t),
      htmlFor: r,
      ...e
    }
  );
});
I9.displayName = "FormLabel";
const R9 = S.forwardRef(({ ...t }, e) => {
  const { error: n, formItemId: i, formDescriptionId: r, formMessageId: a } = Km();
  return /* @__PURE__ */ d(
    Ny,
    {
      ref: e,
      id: i,
      "aria-describedby": n ? `${r} ${a}` : `${r}`,
      "aria-invalid": !!n,
      ...t
    }
  );
});
R9.displayName = "FormControl";
const j9 = S.forwardRef(({ className: t, ...e }, n) => {
  const { formDescriptionId: i } = Km();
  return /* @__PURE__ */ d(
    "p",
    {
      ref: n,
      id: i,
      className: E("text-sm text-f1-foreground-secondary", t),
      ...e
    }
  );
});
j9.displayName = "FormDescription";
const F9 = S.forwardRef(({ className: t, children: e, ...n }, i) => {
  const { error: r, formMessageId: a } = Km(), o = r ? String(r == null ? void 0 : r.message) : e;
  return o ? /* @__PURE__ */ d(
    "p",
    {
      ref: i,
      id: a,
      className: E(
        "text-sm font-medium text-f1-foreground-critical",
        t
      ),
      ...n,
      children: o
    }
  ) : null;
});
F9.displayName = "FormMessage";
function JXe({
  onSubmit: t,
  children: e,
  ...n
}) {
  const i = n.formState.errors.root;
  return /* @__PURE__ */ d(yI, { ...n, children: /* @__PURE__ */ k("form", { onSubmit: t, className: "flex flex-col gap-4", children: [
    i && /* @__PURE__ */ d("p", { className: "text-sm font-medium text-f1-foreground-critical", children: i.message }),
    e
  ] }) });
}
function QXe({
  submitLabel: t,
  form: e
}) {
  return /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
    ue,
    {
      type: "submit",
      label: t,
      loading: e.formState.isSubmitting
    }
  ) });
}
const ZXe = ({
  label: t,
  description: e,
  children: n,
  ...i
}) => /* @__PURE__ */ d(
  vI,
  {
    ...i,
    render: ({ field: r }) => /* @__PURE__ */ k(L9, { children: [
      /* @__PURE__ */ d(I9, { children: t }),
      /* @__PURE__ */ d(R9, { children: n(r) }),
      /* @__PURE__ */ d(j9, { children: e }),
      /* @__PURE__ */ d(F9, {})
    ] })
  }
), Kw = (t, e, n) => {
  if (t && "reportValidity" in t) {
    const i = pe(n, e);
    t.setCustomValidity(i && i.message || ""), t.reportValidity();
  }
}, z9 = (t, e) => {
  for (const n in e.fields) {
    const i = e.fields[n];
    i && i.ref && "reportValidity" in i.ref ? Kw(i.ref, n, t) : i.refs && i.refs.forEach((r) => Kw(r, n, t));
  }
}, bI = (t, e) => {
  e.shouldUseNativeValidation && z9(t, e);
  const n = {};
  for (const i in t) {
    const r = pe(e.fields, i), a = Object.assign(t[i] || {}, { ref: r && r.ref });
    if (wI(e.names || Object.keys(t), i)) {
      const o = Object.assign({}, pe(n, i));
      ot(o, "root", a), ot(n, i, o);
    } else ot(n, i, a);
  }
  return n;
}, wI = (t, e) => t.some((n) => n.startsWith(e + "."));
var kI = function(t, e) {
  for (var n = {}; t.length; ) {
    var i = t[0], r = i.code, a = i.message, o = i.path.join(".");
    if (!n[o]) if ("unionErrors" in i) {
      var s = i.unionErrors[0].errors[0];
      n[o] = { message: s.message, type: s.code };
    } else n[o] = { message: a, type: r };
    if ("unionErrors" in i && i.unionErrors.forEach(function(u) {
      return u.errors.forEach(function(f) {
        return t.push(f);
      });
    }), e) {
      var l = n[o].types, c = l && l[i.code];
      n[o] = S9(o, e, n, r, c ? [].concat(c, i.message) : i.message);
    }
    t.shift();
  }
  return n;
}, xI = function(t, e, n) {
  return n === void 0 && (n = {}), function(i, r, a) {
    try {
      return Promise.resolve(function(o, s) {
        try {
          var l = Promise.resolve(t[n.mode === "sync" ? "parse" : "parseAsync"](i, e)).then(function(c) {
            return a.shouldUseNativeValidation && z9({}, a), { errors: {}, values: n.raw ? i : c };
          });
        } catch (c) {
          return s(c);
        }
        return l && l.then ? l.then(void 0, s) : l;
      }(0, function(o) {
        if (function(s) {
          return Array.isArray(s == null ? void 0 : s.errors);
        }(o)) return { values: {}, errors: bI(kI(o.errors, !a.shouldUseNativeValidation && a.criteriaMode === "all"), a) };
        throw o;
      }));
    } catch (o) {
      return Promise.reject(o);
    }
  };
};
function eYe(t, e, n) {
  const i = gI({
    resolver: xI(t),
    mode: "onChange",
    ...e
  }), r = async (a) => {
    const o = await n(a);
    o.success || (Object.keys(o.errors).map((s) => {
      i.setError(s, {
        message: o.errors[s]
      });
    }), o.rootMessage && i.setError("root", {
      message: o.rootMessage
    }));
  };
  return {
    ...i,
    onSubmit: i.handleSubmit(r)
  };
}
function ke(t) {
  const e = Object.prototype.toString.call(t);
  return t instanceof Date || typeof t == "object" && e === "[object Date]" ? new t.constructor(+t) : typeof t == "number" || e === "[object Number]" || typeof t == "string" || e === "[object String]" ? new Date(t) : /* @__PURE__ */ new Date(NaN);
}
function ct(t, e) {
  return t instanceof Date ? new t.constructor(e) : new Date(e);
}
function Ct(t, e) {
  const n = ke(t);
  return isNaN(e) ? ct(t, NaN) : (e && n.setDate(n.getDate() + e), n);
}
function Et(t, e) {
  const n = ke(t);
  if (isNaN(e)) return ct(t, NaN);
  if (!e)
    return n;
  const i = n.getDate(), r = ct(t, n.getTime());
  r.setMonth(n.getMonth() + e + 1, 0);
  const a = r.getDate();
  return i >= a ? r : (n.setFullYear(
    r.getFullYear(),
    r.getMonth(),
    i
  ), n);
}
const pv = 6048e5, _I = 864e5, jp = 6e4, MI = 36e5, CI = 1e3, Uw = 525600, Jw = 43200, Qw = 1440;
let PI = {};
function Ra() {
  return PI;
}
function mn(t, e) {
  var s, l, c, u;
  const n = Ra(), i = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = ke(t), a = r.getDay(), o = (a < i ? 7 : 0) + a - i;
  return r.setDate(r.getDate() - o), r.setHours(0, 0, 0, 0), r;
}
function $i(t) {
  return mn(t, { weekStartsOn: 1 });
}
function V9(t) {
  const e = ke(t), n = e.getFullYear(), i = ct(t, 0);
  i.setFullYear(n + 1, 0, 4), i.setHours(0, 0, 0, 0);
  const r = $i(i), a = ct(t, 0);
  a.setFullYear(n, 0, 4), a.setHours(0, 0, 0, 0);
  const o = $i(a);
  return e.getTime() >= r.getTime() ? n + 1 : e.getTime() >= o.getTime() ? n : n - 1;
}
function Gi(t) {
  const e = ke(t);
  return e.setHours(0, 0, 0, 0), e;
}
function Pa(t) {
  const e = ke(t), n = new Date(
    Date.UTC(
      e.getFullYear(),
      e.getMonth(),
      e.getDate(),
      e.getHours(),
      e.getMinutes(),
      e.getSeconds(),
      e.getMilliseconds()
    )
  );
  return n.setUTCFullYear(e.getFullYear()), +t - +n;
}
function Vi(t, e) {
  const n = Gi(t), i = Gi(e), r = +n - Pa(n), a = +i - Pa(i);
  return Math.round((r - a) / _I);
}
function SI(t) {
  const e = V9(t), n = ct(t, 0);
  return n.setFullYear(e, 0, 4), n.setHours(0, 0, 0, 0), $i(n);
}
function Fp(t, e) {
  const n = e * 7;
  return Ct(t, n);
}
function zr(t, e) {
  return Et(t, e * 12);
}
function NI(t) {
  let e;
  return t.forEach(function(n) {
    const i = ke(n);
    (e === void 0 || e < i || isNaN(Number(i))) && (e = i);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function $I(t) {
  let e;
  return t.forEach((n) => {
    const i = ke(n);
    (!e || e > i || isNaN(+i)) && (e = i);
  }), e || /* @__PURE__ */ new Date(NaN);
}
function DI(t, e) {
  const n = ke(t), i = ke(e), r = n.getTime() - i.getTime();
  return r < 0 ? -1 : r > 0 ? 1 : r;
}
function gv(t) {
  return ct(t, Date.now());
}
function vn(t, e) {
  const n = Gi(t), i = Gi(e);
  return +n == +i;
}
function yv(t) {
  return t instanceof Date || typeof t == "object" && Object.prototype.toString.call(t) === "[object Date]";
}
function EI(t) {
  if (!yv(t) && typeof t != "number")
    return !1;
  const e = ke(t);
  return !isNaN(Number(e));
}
function ud(t, e) {
  const n = ke(t), i = ke(e), r = n.getFullYear() - i.getFullYear(), a = n.getMonth() - i.getMonth();
  return r * 12 + a;
}
function TI(t, e, n) {
  const i = mn(t, n), r = mn(e, n), a = +i - Pa(i), o = +r - Pa(r);
  return Math.round((a - o) / pv);
}
function H9(t, e) {
  const n = ke(t), i = ke(e), r = Zw(n, i), a = Math.abs(Vi(n, i));
  n.setDate(n.getDate() - r * a);
  const o = +(Zw(n, i) === -r), s = r * (a - o);
  return s === 0 ? 0 : s;
}
function Zw(t, e) {
  const n = t.getFullYear() - e.getFullYear() || t.getMonth() - e.getMonth() || t.getDate() - e.getDate() || t.getHours() - e.getHours() || t.getMinutes() - e.getMinutes() || t.getSeconds() - e.getSeconds() || t.getMilliseconds() - e.getMilliseconds();
  return n < 0 ? -1 : n > 0 ? 1 : n;
}
function OI(t) {
  return (e) => {
    const i = (t ? Math[t] : Math.trunc)(e);
    return i === 0 ? 0 : i;
  };
}
function uc(t) {
  const e = ke(t);
  return e.setHours(23, 59, 59, 999), e;
}
function Kn(t) {
  const e = ke(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(23, 59, 59, 999), e;
}
function is(t) {
  const e = ke(t), n = e.getMonth(), i = n - n % 3;
  return e.setMonth(i, 1), e.setHours(0, 0, 0, 0), e;
}
function ut(t) {
  const e = ke(t);
  return e.setDate(1), e.setHours(0, 0, 0, 0), e;
}
function la(t) {
  const e = ke(t), n = e.getFullYear();
  return e.setFullYear(n + 1, 0, 0), e.setHours(23, 59, 59, 999), e;
}
function ki(t) {
  const e = ke(t), n = ct(t, 0);
  return n.setFullYear(e.getFullYear(), 0, 1), n.setHours(0, 0, 0, 0), n;
}
function fd(t, e) {
  var s, l, c, u;
  const n = Ra(), i = (e == null ? void 0 : e.weekStartsOn) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.weekStartsOn) ?? n.weekStartsOn ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.weekStartsOn) ?? 0, r = ke(t), a = r.getDay(), o = (a < i ? -7 : 0) + 6 - (a - i);
  return r.setDate(r.getDate() + o), r.setHours(23, 59, 59, 999), r;
}
function fc(t) {
  return fd(t, { weekStartsOn: 1 });
}
function vv(t) {
  const e = ke(t), n = e.getMonth(), i = n - n % 3 + 3;
  return e.setMonth(i, 0), e.setHours(23, 59, 59, 999), e;
}
const WI = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "1 second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about 1 hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "1 hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "1 day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about 1 week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about 1 month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "1 month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about 1 year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "1 year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over 1 year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost 1 year",
    other: "almost {{count}} years"
  }
}, Ao = (t, e, n) => {
  let i;
  const r = WI[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
};
function T(t) {
  return (e = {}) => {
    const n = e.width ? String(e.width) : t.defaultWidth;
    return t.formats[n] || t.formats[t.defaultWidth];
  };
}
const AI = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, LI = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, II = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, RI = {
  date: T({
    formats: AI,
    defaultWidth: "full"
  }),
  time: T({
    formats: LI,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: II,
    defaultWidth: "full"
  })
}, jI = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, ja = (t, e, n, i) => jI[t];
function C(t) {
  return (e, n) => {
    const i = n != null && n.context ? String(n.context) : "standalone";
    let r;
    if (i === "formatting" && t.formattingValues) {
      const o = t.defaultFormattingWidth || t.defaultWidth, s = n != null && n.width ? String(n.width) : o;
      r = t.formattingValues[s] || t.formattingValues[o];
    } else {
      const o = t.defaultWidth, s = n != null && n.width ? String(n.width) : t.defaultWidth;
      r = t.values[s] || t.values[o];
    }
    const a = t.argumentCallback ? t.argumentCallback(e) : e;
    return r[a];
  };
}
const FI = {
  narrow: ["B", "A"],
  abbreviated: ["BC", "AD"],
  wide: ["Before Christ", "Anno Domini"]
}, zI = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1st quarter", "2nd quarter", "3rd quarter", "4th quarter"]
}, VI = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ],
  wide: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ]
}, HI = {
  narrow: ["S", "M", "T", "W", "T", "F", "S"],
  short: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
  abbreviated: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
  wide: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ]
}, BI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "morning",
    afternoon: "afternoon",
    evening: "evening",
    night: "night"
  }
}, qI = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mi",
    noon: "n",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnight",
    noon: "noon",
    morning: "in the morning",
    afternoon: "in the afternoon",
    evening: "in the evening",
    night: "at night"
  }
}, GI = (t, e) => {
  const n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "st";
      case 2:
        return n + "nd";
      case 3:
        return n + "rd";
    }
  return n + "th";
}, Fa = {
  ordinalNumber: GI,
  era: C({
    values: FI,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: zI,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: VI,
    defaultWidth: "wide"
  }),
  day: C({
    values: HI,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: BI,
    defaultWidth: "wide",
    formattingValues: qI,
    defaultFormattingWidth: "wide"
  })
};
function P(t) {
  return (e, n = {}) => {
    const i = n.width, r = i && t.matchPatterns[i] || t.matchPatterns[t.defaultMatchWidth], a = e.match(r);
    if (!a)
      return null;
    const o = a[0], s = i && t.parsePatterns[i] || t.parsePatterns[t.defaultParseWidth], l = Array.isArray(s) ? YI(s, (f) => f.test(o)) : (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      XI(s, (f) => f.test(o))
    );
    let c;
    c = t.valueCallback ? t.valueCallback(l) : l, c = n.valueCallback ? (
      // eslint-disable-next-line @typescript-eslint/no-explicit-any -- I challange you to fix the type
      n.valueCallback(c)
    ) : c;
    const u = e.slice(o.length);
    return { value: c, rest: u };
  };
}
function XI(t, e) {
  for (const n in t)
    if (Object.prototype.hasOwnProperty.call(t, n) && e(t[n]))
      return n;
}
function YI(t, e) {
  for (let n = 0; n < t.length; n++)
    if (e(t[n]))
      return n;
}
function he(t) {
  return (e, n = {}) => {
    const i = e.match(t.matchPattern);
    if (!i) return null;
    const r = i[0], a = e.match(t.parsePattern);
    if (!a) return null;
    let o = t.valueCallback ? t.valueCallback(a[0]) : a[0];
    o = n.valueCallback ? n.valueCallback(o) : o;
    const s = e.slice(r.length);
    return { value: o, rest: s };
  };
}
const KI = /^(\d+)(th|st|nd|rd)?/i, UI = /\d+/i, JI = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
}, QI = {
  any: [/^b/i, /^(a|c)/i]
}, ZI = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
}, eR = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tR = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
}, nR = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, iR = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
}, rR = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, aR = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, oR = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, za = {
  ordinalNumber: he({
    matchPattern: KI,
    parsePattern: UI,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: JI,
    defaultMatchWidth: "wide",
    parsePatterns: QI,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ZI,
    defaultMatchWidth: "wide",
    parsePatterns: eR,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: tR,
    defaultMatchWidth: "wide",
    parsePatterns: nR,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: iR,
    defaultMatchWidth: "wide",
    parsePatterns: rR,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: aR,
    defaultMatchWidth: "any",
    parsePatterns: oR,
    defaultParseWidth: "any"
  })
}, mc = {
  code: "en-US",
  formatDistance: Ao,
  formatLong: RI,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function sR(t) {
  const e = ke(t);
  return Vi(e, ki(e)) + 1;
}
function bv(t) {
  const e = ke(t), n = +$i(e) - +SI(e);
  return Math.round(n / pv) + 1;
}
function wv(t, e) {
  var u, f, m, h;
  const n = ke(t), i = n.getFullYear(), r = Ra(), a = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((f = (u = e == null ? void 0 : e.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? r.firstWeekContainsDate ?? ((h = (m = r.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = ct(t, 0);
  o.setFullYear(i + 1, 0, a), o.setHours(0, 0, 0, 0);
  const s = mn(o, e), l = ct(t, 0);
  l.setFullYear(i, 0, a), l.setHours(0, 0, 0, 0);
  const c = mn(l, e);
  return n.getTime() >= s.getTime() ? i + 1 : n.getTime() >= c.getTime() ? i : i - 1;
}
function lR(t, e) {
  var s, l, c, u;
  const n = Ra(), i = (e == null ? void 0 : e.firstWeekContainsDate) ?? ((l = (s = e == null ? void 0 : e.locale) == null ? void 0 : s.options) == null ? void 0 : l.firstWeekContainsDate) ?? n.firstWeekContainsDate ?? ((u = (c = n.locale) == null ? void 0 : c.options) == null ? void 0 : u.firstWeekContainsDate) ?? 1, r = wv(t, e), a = ct(t, 0);
  return a.setFullYear(r, 0, i), a.setHours(0, 0, 0, 0), mn(a, e);
}
function kv(t, e) {
  const n = ke(t), i = +mn(n, e) - +lR(n, e);
  return Math.round(i / pv) + 1;
}
function dt(t, e) {
  const n = t < 0 ? "-" : "", i = Math.abs(t).toString().padStart(e, "0");
  return n + i;
}
const Ur = {
  // Year
  y(t, e) {
    const n = t.getFullYear(), i = n > 0 ? n : 1 - n;
    return dt(e === "yy" ? i % 100 : i, e.length);
  },
  // Month
  M(t, e) {
    const n = t.getMonth();
    return e === "M" ? String(n + 1) : dt(n + 1, 2);
  },
  // Day of the month
  d(t, e) {
    return dt(t.getDate(), e.length);
  },
  // AM or PM
  a(t, e) {
    const n = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.toUpperCase();
      case "aaa":
        return n;
      case "aaaaa":
        return n[0];
      case "aaaa":
      default:
        return n === "am" ? "a.m." : "p.m.";
    }
  },
  // Hour [1-12]
  h(t, e) {
    return dt(t.getHours() % 12 || 12, e.length);
  },
  // Hour [0-23]
  H(t, e) {
    return dt(t.getHours(), e.length);
  },
  // Minute
  m(t, e) {
    return dt(t.getMinutes(), e.length);
  },
  // Second
  s(t, e) {
    return dt(t.getSeconds(), e.length);
  },
  // Fraction of second
  S(t, e) {
    const n = e.length, i = t.getMilliseconds(), r = Math.trunc(
      i * Math.pow(10, n - 3)
    );
    return dt(r, e.length);
  }
}, Vo = {
  midnight: "midnight",
  noon: "noon",
  morning: "morning",
  afternoon: "afternoon",
  evening: "evening",
  night: "night"
}, ek = {
  // Era
  G: function(t, e, n) {
    const i = t.getFullYear() > 0 ? 1 : 0;
    switch (e) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return n.era(i, { width: "abbreviated" });
      // A, B
      case "GGGGG":
        return n.era(i, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return n.era(i, { width: "wide" });
    }
  },
  // Year
  y: function(t, e, n) {
    if (e === "yo") {
      const i = t.getFullYear(), r = i > 0 ? i : 1 - i;
      return n.ordinalNumber(r, { unit: "year" });
    }
    return Ur.y(t, e);
  },
  // Local week-numbering year
  Y: function(t, e, n, i) {
    const r = wv(t, i), a = r > 0 ? r : 1 - r;
    if (e === "YY") {
      const o = a % 100;
      return dt(o, 2);
    }
    return e === "Yo" ? n.ordinalNumber(a, { unit: "year" }) : dt(a, e.length);
  },
  // ISO week-numbering year
  R: function(t, e) {
    const n = V9(t);
    return dt(n, e.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function(t, e) {
    const n = t.getFullYear();
    return dt(n, e.length);
  },
  // Quarter
  Q: function(t, e, n) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "Q":
        return String(i);
      // 01, 02, 03, 04
      case "QQ":
        return dt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return n.quarter(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return n.quarter(i, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone quarter
  q: function(t, e, n) {
    const i = Math.ceil((t.getMonth() + 1) / 3);
    switch (e) {
      // 1, 2, 3, 4
      case "q":
        return String(i);
      // 01, 02, 03, 04
      case "qq":
        return dt(i, 2);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return n.ordinalNumber(i, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return n.quarter(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return n.quarter(i, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return n.quarter(i, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // Month
  M: function(t, e, n) {
    const i = t.getMonth();
    switch (e) {
      case "M":
      case "MM":
        return Ur.M(t, e);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "MMM":
        return n.month(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // J, F, ..., D
      case "MMMMM":
        return n.month(i, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return n.month(i, { width: "wide", context: "formatting" });
    }
  },
  // Stand-alone month
  L: function(t, e, n) {
    const i = t.getMonth();
    switch (e) {
      // 1, 2, ..., 12
      case "L":
        return String(i + 1);
      // 01, 02, ..., 12
      case "LL":
        return dt(i + 1, 2);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return n.ordinalNumber(i + 1, { unit: "month" });
      // Jan, Feb, ..., Dec
      case "LLL":
        return n.month(i, {
          width: "abbreviated",
          context: "standalone"
        });
      // J, F, ..., D
      case "LLLLL":
        return n.month(i, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return n.month(i, { width: "wide", context: "standalone" });
    }
  },
  // Local week of year
  w: function(t, e, n, i) {
    const r = kv(t, i);
    return e === "wo" ? n.ordinalNumber(r, { unit: "week" }) : dt(r, e.length);
  },
  // ISO week of year
  I: function(t, e, n) {
    const i = bv(t);
    return e === "Io" ? n.ordinalNumber(i, { unit: "week" }) : dt(i, e.length);
  },
  // Day of the month
  d: function(t, e, n) {
    return e === "do" ? n.ordinalNumber(t.getDate(), { unit: "date" }) : Ur.d(t, e);
  },
  // Day of year
  D: function(t, e, n) {
    const i = sR(t);
    return e === "Do" ? n.ordinalNumber(i, { unit: "dayOfYear" }) : dt(i, e.length);
  },
  // Day of week
  E: function(t, e, n) {
    const i = t.getDay();
    switch (e) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "EEEEE":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "EEEE":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Local day of week
  e: function(t, e, n, i) {
    const r = t.getDay(), a = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case "e":
        return String(a);
      // Padded numerical value
      case "ee":
        return dt(a, 2);
      // 1st, 2nd, ..., 7th
      case "eo":
        return n.ordinalNumber(a, { unit: "day" });
      case "eee":
        return n.day(r, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "eeeee":
        return n.day(r, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return n.day(r, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "eeee":
      default:
        return n.day(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Stand-alone local day of week
  c: function(t, e, n, i) {
    const r = t.getDay(), a = (r - i.weekStartsOn + 8) % 7 || 7;
    switch (e) {
      // Numerical value (same as in `e`)
      case "c":
        return String(a);
      // Padded numerical value
      case "cc":
        return dt(a, e.length);
      // 1st, 2nd, ..., 7th
      case "co":
        return n.ordinalNumber(a, { unit: "day" });
      case "ccc":
        return n.day(r, {
          width: "abbreviated",
          context: "standalone"
        });
      // T
      case "ccccc":
        return n.day(r, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return n.day(r, {
          width: "short",
          context: "standalone"
        });
      // Tuesday
      case "cccc":
      default:
        return n.day(r, {
          width: "wide",
          context: "standalone"
        });
    }
  },
  // ISO day of week
  i: function(t, e, n) {
    const i = t.getDay(), r = i === 0 ? 7 : i;
    switch (e) {
      // 2
      case "i":
        return String(r);
      // 02
      case "ii":
        return dt(r, e.length);
      // 2nd
      case "io":
        return n.ordinalNumber(r, { unit: "day" });
      // Tue
      case "iii":
        return n.day(i, {
          width: "abbreviated",
          context: "formatting"
        });
      // T
      case "iiiii":
        return n.day(i, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "iiiiii":
        return n.day(i, {
          width: "short",
          context: "formatting"
        });
      // Tuesday
      case "iiii":
      default:
        return n.day(i, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM or PM
  a: function(t, e, n) {
    const r = t.getHours() / 12 >= 1 ? "pm" : "am";
    switch (e) {
      case "a":
      case "aa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "aaa":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "aaaaa":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // AM, PM, midnight, noon
  b: function(t, e, n) {
    const i = t.getHours();
    let r;
    switch (i === 12 ? r = Vo.noon : i === 0 ? r = Vo.midnight : r = i / 12 >= 1 ? "pm" : "am", e) {
      case "b":
      case "bb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "bbb":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        }).toLowerCase();
      case "bbbbb":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function(t, e, n) {
    const i = t.getHours();
    let r;
    switch (i >= 17 ? r = Vo.evening : i >= 12 ? r = Vo.afternoon : i >= 4 ? r = Vo.morning : r = Vo.night, e) {
      case "B":
      case "BB":
      case "BBB":
        return n.dayPeriod(r, {
          width: "abbreviated",
          context: "formatting"
        });
      case "BBBBB":
        return n.dayPeriod(r, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return n.dayPeriod(r, {
          width: "wide",
          context: "formatting"
        });
    }
  },
  // Hour [1-12]
  h: function(t, e, n) {
    if (e === "ho") {
      let i = t.getHours() % 12;
      return i === 0 && (i = 12), n.ordinalNumber(i, { unit: "hour" });
    }
    return Ur.h(t, e);
  },
  // Hour [0-23]
  H: function(t, e, n) {
    return e === "Ho" ? n.ordinalNumber(t.getHours(), { unit: "hour" }) : Ur.H(t, e);
  },
  // Hour [0-11]
  K: function(t, e, n) {
    const i = t.getHours() % 12;
    return e === "Ko" ? n.ordinalNumber(i, { unit: "hour" }) : dt(i, e.length);
  },
  // Hour [1-24]
  k: function(t, e, n) {
    let i = t.getHours();
    return i === 0 && (i = 24), e === "ko" ? n.ordinalNumber(i, { unit: "hour" }) : dt(i, e.length);
  },
  // Minute
  m: function(t, e, n) {
    return e === "mo" ? n.ordinalNumber(t.getMinutes(), { unit: "minute" }) : Ur.m(t, e);
  },
  // Second
  s: function(t, e, n) {
    return e === "so" ? n.ordinalNumber(t.getSeconds(), { unit: "second" }) : Ur.s(t, e);
  },
  // Fraction of second
  S: function(t, e) {
    return Ur.S(t, e);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function(t, e, n) {
    const i = t.getTimezoneOffset();
    if (i === 0)
      return "Z";
    switch (e) {
      // Hours and optional minutes
      case "X":
        return nk(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case "XXXX":
      case "XX":
        return Ja(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case "XXXXX":
      case "XXX":
      // Hours and minutes with `:` delimiter
      default:
        return Ja(i, ":");
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Hours and optional minutes
      case "x":
        return nk(i);
      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case "xxxx":
      case "xx":
        return Ja(i);
      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case "xxxxx":
      case "xxx":
      // Hours and minutes with `:` delimiter
      default:
        return Ja(i, ":");
    }
  },
  // Timezone (GMT)
  O: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "O":
      case "OO":
      case "OOO":
        return "GMT" + tk(i, ":");
      // Long
      case "OOOO":
      default:
        return "GMT" + Ja(i, ":");
    }
  },
  // Timezone (specific non-location)
  z: function(t, e, n) {
    const i = t.getTimezoneOffset();
    switch (e) {
      // Short
      case "z":
      case "zz":
      case "zzz":
        return "GMT" + tk(i, ":");
      // Long
      case "zzzz":
      default:
        return "GMT" + Ja(i, ":");
    }
  },
  // Seconds timestamp
  t: function(t, e, n) {
    const i = Math.trunc(t.getTime() / 1e3);
    return dt(i, e.length);
  },
  // Milliseconds timestamp
  T: function(t, e, n) {
    const i = t.getTime();
    return dt(i, e.length);
  }
};
function tk(t, e = "") {
  const n = t > 0 ? "-" : "+", i = Math.abs(t), r = Math.trunc(i / 60), a = i % 60;
  return a === 0 ? n + String(r) : n + String(r) + e + dt(a, 2);
}
function nk(t, e) {
  return t % 60 === 0 ? (t > 0 ? "-" : "+") + dt(Math.abs(t) / 60, 2) : Ja(t, e);
}
function Ja(t, e = "") {
  const n = t > 0 ? "-" : "+", i = Math.abs(t), r = dt(Math.trunc(i / 60), 2), a = dt(i % 60, 2);
  return n + r + e + a;
}
const ik = (t, e) => {
  switch (t) {
    case "P":
      return e.date({ width: "short" });
    case "PP":
      return e.date({ width: "medium" });
    case "PPP":
      return e.date({ width: "long" });
    case "PPPP":
    default:
      return e.date({ width: "full" });
  }
}, B9 = (t, e) => {
  switch (t) {
    case "p":
      return e.time({ width: "short" });
    case "pp":
      return e.time({ width: "medium" });
    case "ppp":
      return e.time({ width: "long" });
    case "pppp":
    default:
      return e.time({ width: "full" });
  }
}, dR = (t, e) => {
  const n = t.match(/(P+)(p+)?/) || [], i = n[1], r = n[2];
  if (!r)
    return ik(t, e);
  let a;
  switch (i) {
    case "P":
      a = e.dateTime({ width: "short" });
      break;
    case "PP":
      a = e.dateTime({ width: "medium" });
      break;
    case "PPP":
      a = e.dateTime({ width: "long" });
      break;
    case "PPPP":
    default:
      a = e.dateTime({ width: "full" });
      break;
  }
  return a.replace("{{date}}", ik(i, e)).replace("{{time}}", B9(r, e));
}, zp = {
  p: B9,
  P: dR
}, cR = /^D+$/, uR = /^Y+$/, fR = ["D", "DD", "YY", "YYYY"];
function q9(t) {
  return cR.test(t);
}
function G9(t) {
  return uR.test(t);
}
function Vp(t, e, n) {
  const i = mR(t, e, n);
  if (console.warn(i), fR.includes(t)) throw new RangeError(i);
}
function mR(t, e, n) {
  const i = t[0] === "Y" ? "years" : "days of the month";
  return `Use \`${t.toLowerCase()}\` instead of \`${t}\` (in \`${e}\`) for formatting ${i} to the input \`${n}\`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md`;
}
const hR = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, pR = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, gR = /^'([^]*?)'?$/, yR = /''/g, vR = /[a-zA-Z]/;
function ii(t, e, n) {
  var u, f, m, h, p, g, y, v;
  const i = Ra(), r = (n == null ? void 0 : n.locale) ?? i.locale ?? mc, a = (n == null ? void 0 : n.firstWeekContainsDate) ?? ((f = (u = n == null ? void 0 : n.locale) == null ? void 0 : u.options) == null ? void 0 : f.firstWeekContainsDate) ?? i.firstWeekContainsDate ?? ((h = (m = i.locale) == null ? void 0 : m.options) == null ? void 0 : h.firstWeekContainsDate) ?? 1, o = (n == null ? void 0 : n.weekStartsOn) ?? ((g = (p = n == null ? void 0 : n.locale) == null ? void 0 : p.options) == null ? void 0 : g.weekStartsOn) ?? i.weekStartsOn ?? ((v = (y = i.locale) == null ? void 0 : y.options) == null ? void 0 : v.weekStartsOn) ?? 0, s = ke(t);
  if (!EI(s))
    throw new RangeError("Invalid time value");
  let l = e.match(pR).map((w) => {
    const x = w[0];
    if (x === "p" || x === "P") {
      const b = zp[x];
      return b(w, r.formatLong);
    }
    return w;
  }).join("").match(hR).map((w) => {
    if (w === "''")
      return { isToken: !1, value: "'" };
    const x = w[0];
    if (x === "'")
      return { isToken: !1, value: bR(w) };
    if (ek[x])
      return { isToken: !0, value: w };
    if (x.match(vR))
      throw new RangeError(
        "Format string contains an unescaped latin alphabet character `" + x + "`"
      );
    return { isToken: !1, value: w };
  });
  r.localize.preprocessor && (l = r.localize.preprocessor(s, l));
  const c = {
    firstWeekContainsDate: a,
    weekStartsOn: o,
    locale: r
  };
  return l.map((w) => {
    if (!w.isToken) return w.value;
    const x = w.value;
    (!(n != null && n.useAdditionalWeekYearTokens) && G9(x) || !(n != null && n.useAdditionalDayOfYearTokens) && q9(x)) && Vp(x, e, String(t));
    const b = ek[x[0]];
    return b(s, x, r.localize, c);
  }).join("");
}
function bR(t) {
  const e = t.match(gR);
  return e ? e[1].replace(yR, "'") : t;
}
function wR(t, e, n) {
  const i = Ra(), r = (n == null ? void 0 : n.locale) ?? i.locale ?? mc, a = DI(t, e);
  if (isNaN(a))
    throw new RangeError("Invalid time value");
  const o = Object.assign({}, n, {
    addSuffix: n == null ? void 0 : n.addSuffix,
    comparison: a
  });
  let s, l;
  a > 0 ? (s = ke(e), l = ke(t)) : (s = ke(t), l = ke(e));
  const c = OI((n == null ? void 0 : n.roundingMethod) ?? "round"), u = l.getTime() - s.getTime(), f = u / jp, m = Pa(l) - Pa(s), h = (u - m) / jp, p = n == null ? void 0 : n.unit;
  let g;
  if (p ? g = p : f < 1 ? g = "second" : f < 60 ? g = "minute" : f < Qw ? g = "hour" : h < Jw ? g = "day" : h < Uw ? g = "month" : g = "year", g === "second") {
    const y = c(u / 1e3);
    return r.formatDistance("xSeconds", y, o);
  } else if (g === "minute") {
    const y = c(f);
    return r.formatDistance("xMinutes", y, o);
  } else if (g === "hour") {
    const y = c(f / 60);
    return r.formatDistance("xHours", y, o);
  } else if (g === "day") {
    const y = c(h / Qw);
    return r.formatDistance("xDays", y, o);
  } else if (g === "month") {
    const y = c(h / Jw);
    return y === 12 && p !== "month" ? r.formatDistance("xYears", 1, o) : r.formatDistance("xMonths", y, o);
  } else {
    const y = c(h / Uw);
    return r.formatDistance("xYears", y, o);
  }
}
function kR(t, e) {
  return wR(t, gv(t), e);
}
function xR(t) {
  const e = ke(t), n = e.getFullYear(), i = e.getMonth(), r = ct(t, 0);
  return r.setFullYear(n, i + 1, 0), r.setHours(0, 0, 0, 0), r.getDate();
}
function _R() {
  return Object.assign({}, Ra());
}
function MR(t) {
  let n = ke(t).getDay();
  return n === 0 && (n = 7), n;
}
function rk(t) {
  return ke(t).getMonth();
}
function CR(t) {
  return Math.trunc(+ke(t) / 1e3);
}
function PR(t) {
  const e = ke(t), n = e.getMonth();
  return e.setFullYear(e.getFullYear(), n + 1, 0), e.setHours(0, 0, 0, 0), e;
}
function SR(t, e) {
  return TI(
    PR(t),
    ut(t),
    e
  ) + 1;
}
function Mi(t, e) {
  const n = ke(t), i = ke(e);
  return n.getTime() > i.getTime();
}
function An(t, e) {
  const n = ke(t), i = ke(e);
  return +n < +i;
}
function of(t, e) {
  const n = ke(t), i = ke(e);
  return +n == +i;
}
function NR(t, e) {
  const n = e instanceof Date ? ct(e, 0) : new e(0);
  return n.setFullYear(
    t.getFullYear(),
    t.getMonth(),
    t.getDate()
  ), n.setHours(
    t.getHours(),
    t.getMinutes(),
    t.getSeconds(),
    t.getMilliseconds()
  ), n;
}
const $R = 10;
class X9 {
  constructor() {
    we(this, "subPriority", 0);
  }
  validate(e, n) {
    return !0;
  }
}
class DR extends X9 {
  constructor(e, n, i, r, a) {
    super(), this.value = e, this.validateValue = n, this.setValue = i, this.priority = r, a && (this.subPriority = a);
  }
  validate(e, n) {
    return this.validateValue(e, this.value, n);
  }
  set(e, n, i) {
    return this.setValue(e, n, this.value, i);
  }
}
class ER extends X9 {
  constructor() {
    super(...arguments);
    we(this, "priority", $R);
    we(this, "subPriority", -1);
  }
  set(n, i) {
    return i.timestampIsSet ? n : ct(n, NR(n, Date));
  }
}
class at {
  run(e, n, i, r) {
    const a = this.parse(e, n, i, r);
    return a ? {
      setter: new DR(
        a.value,
        this.validate,
        this.set,
        this.priority,
        this.subPriority
      ),
      rest: a.rest
    } : null;
  }
  validate(e, n, i) {
    return !0;
  }
}
class TR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 140);
    we(this, "incompatibleTokens", ["R", "u", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      // AD, BC
      case "G":
      case "GG":
      case "GGG":
        return r.era(n, { width: "abbreviated" }) || r.era(n, { width: "narrow" });
      // A, B
      case "GGGGG":
        return r.era(n, { width: "narrow" });
      // Anno Domini, Before Christ
      case "GGGG":
      default:
        return r.era(n, { width: "wide" }) || r.era(n, { width: "abbreviated" }) || r.era(n, { width: "narrow" });
    }
  }
  set(n, i, r) {
    return i.era = r, n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
const Ft = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59
  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999
  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/
  // 0 to 9999, -0 to -9999
}, or = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};
function zt(t, e) {
  return t && {
    value: e(t.value),
    rest: t.rest
  };
}
function Dt(t, e) {
  const n = e.match(t);
  return n ? {
    value: parseInt(n[0], 10),
    rest: e.slice(n[0].length)
  } : null;
}
function sr(t, e) {
  const n = e.match(t);
  if (!n)
    return null;
  if (n[0] === "Z")
    return {
      value: 0,
      rest: e.slice(1)
    };
  const i = n[1] === "+" ? 1 : -1, r = n[2] ? parseInt(n[2], 10) : 0, a = n[3] ? parseInt(n[3], 10) : 0, o = n[5] ? parseInt(n[5], 10) : 0;
  return {
    value: i * (r * MI + a * jp + o * CI),
    rest: e.slice(n[0].length)
  };
}
function Y9(t) {
  return Dt(Ft.anyDigitsSigned, t);
}
function At(t, e) {
  switch (t) {
    case 1:
      return Dt(Ft.singleDigit, e);
    case 2:
      return Dt(Ft.twoDigits, e);
    case 3:
      return Dt(Ft.threeDigits, e);
    case 4:
      return Dt(Ft.fourDigits, e);
    default:
      return Dt(new RegExp("^\\d{1," + t + "}"), e);
  }
}
function sf(t, e) {
  switch (t) {
    case 1:
      return Dt(Ft.singleDigitSigned, e);
    case 2:
      return Dt(Ft.twoDigitsSigned, e);
    case 3:
      return Dt(Ft.threeDigitsSigned, e);
    case 4:
      return Dt(Ft.fourDigitsSigned, e);
    default:
      return Dt(new RegExp("^-?\\d{1," + t + "}"), e);
  }
}
function xv(t) {
  switch (t) {
    case "morning":
      return 4;
    case "evening":
      return 17;
    case "pm":
    case "noon":
    case "afternoon":
      return 12;
    case "am":
    case "midnight":
    case "night":
    default:
      return 0;
  }
}
function K9(t, e) {
  const n = e > 0, i = n ? e : 1 - e;
  let r;
  if (i <= 50)
    r = t || 100;
  else {
    const a = i + 50, o = Math.trunc(a / 100) * 100, s = t >= a % 100;
    r = t + o - (s ? 100 : 0);
  }
  return n ? r : 1 - r;
}
function U9(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100 !== 0;
}
class OR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", ["Y", "R", "u", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, r) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: i === "yy"
    });
    switch (i) {
      case "y":
        return zt(At(4, n), a);
      case "yo":
        return zt(
          r.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return zt(At(i.length, n), a);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, r) {
    const a = n.getFullYear();
    if (r.isTwoDigitYear) {
      const s = K9(
        r.year,
        a
      );
      return n.setFullYear(s, 0, 1), n.setHours(0, 0, 0, 0), n;
    }
    const o = !("era" in i) || i.era === 1 ? r.year : 1 - r.year;
    return n.setFullYear(o, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class WR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const a = (o) => ({
      year: o,
      isTwoDigitYear: i === "YY"
    });
    switch (i) {
      case "Y":
        return zt(At(4, n), a);
      case "Yo":
        return zt(
          r.ordinalNumber(n, {
            unit: "year"
          }),
          a
        );
      default:
        return zt(At(i.length, n), a);
    }
  }
  validate(n, i) {
    return i.isTwoDigitYear || i.year > 0;
  }
  set(n, i, r, a) {
    const o = wv(n, a);
    if (r.isTwoDigitYear) {
      const l = K9(
        r.year,
        o
      );
      return n.setFullYear(
        l,
        0,
        a.firstWeekContainsDate
      ), n.setHours(0, 0, 0, 0), mn(n, a);
    }
    const s = !("era" in i) || i.era === 1 ? r.year : 1 - r.year;
    return n.setFullYear(s, 0, a.firstWeekContainsDate), n.setHours(0, 0, 0, 0), mn(n, a);
  }
}
class AR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", [
      "G",
      "y",
      "Y",
      "u",
      "Q",
      "q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i) {
    return sf(i === "R" ? 4 : i.length, n);
  }
  set(n, i, r) {
    const a = ct(n, 0);
    return a.setFullYear(r, 0, 4), a.setHours(0, 0, 0, 0), $i(a);
  }
}
class LR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 130);
    we(this, "incompatibleTokens", ["G", "y", "Y", "R", "w", "I", "i", "e", "c", "t", "T"]);
  }
  parse(n, i) {
    return sf(i === "u" ? 4 : i.length, n);
  }
  set(n, i, r) {
    return n.setFullYear(r, 0, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class IR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 120);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      // 1, 2, 3, 4
      case "Q":
      case "QQ":
        return At(i.length, n);
      // 1st, 2nd, 3rd, 4th
      case "Qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "QQQ":
        return r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "QQQQQ":
        return r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
      // 1st quarter, 2nd quarter, ...
      case "QQQQ":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "formatting"
        }) || r.quarter(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.quarter(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, r) {
    return n.setMonth((r - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class RR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 120);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      // 1, 2, 3, 4
      case "q":
      case "qq":
        return At(i.length, n);
      // 1st, 2nd, 3rd, 4th
      case "qo":
        return r.ordinalNumber(n, { unit: "quarter" });
      // Q1, Q2, Q3, Q4
      case "qqq":
        return r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case "qqqqq":
        return r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
      // 1st quarter, 2nd quarter, ...
      case "qqqq":
      default:
        return r.quarter(n, {
          width: "wide",
          context: "standalone"
        }) || r.quarter(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.quarter(n, {
          width: "narrow",
          context: "standalone"
        });
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 4;
  }
  set(n, i, r) {
    return n.setMonth((r - 1) * 3, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class jR extends at {
  constructor() {
    super(...arguments);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "L",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
    we(this, "priority", 110);
  }
  parse(n, i, r) {
    const a = (o) => o - 1;
    switch (i) {
      // 1, 2, ..., 12
      case "M":
        return zt(
          Dt(Ft.month, n),
          a
        );
      // 01, 02, ..., 12
      case "MM":
        return zt(At(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Mo":
        return zt(
          r.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "MMM":
        return r.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(n, { width: "narrow", context: "formatting" });
      // J, F, ..., D
      case "MMMMM":
        return r.month(n, {
          width: "narrow",
          context: "formatting"
        });
      // January, February, ..., December
      case "MMMM":
      default:
        return r.month(n, { width: "wide", context: "formatting" }) || r.month(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.month(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
  }
}
class FR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 110);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const a = (o) => o - 1;
    switch (i) {
      // 1, 2, ..., 12
      case "L":
        return zt(
          Dt(Ft.month, n),
          a
        );
      // 01, 02, ..., 12
      case "LL":
        return zt(At(2, n), a);
      // 1st, 2nd, ..., 12th
      case "Lo":
        return zt(
          r.ordinalNumber(n, {
            unit: "month"
          }),
          a
        );
      // Jan, Feb, ..., Dec
      case "LLL":
        return r.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(n, { width: "narrow", context: "standalone" });
      // J, F, ..., D
      case "LLLLL":
        return r.month(n, {
          width: "narrow",
          context: "standalone"
        });
      // January, February, ..., December
      case "LLLL":
      default:
        return r.month(n, { width: "wide", context: "standalone" }) || r.month(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.month(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.setMonth(r, 1), n.setHours(0, 0, 0, 0), n;
  }
}
function zR(t, e, n) {
  const i = ke(t), r = kv(i, n) - e;
  return i.setDate(i.getDate() - r * 7), i;
}
class VR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 100);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "i",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "w":
        return Dt(Ft.week, n);
      case "wo":
        return r.ordinalNumber(n, { unit: "week" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, r, a) {
    return mn(zR(n, r, a), a);
  }
}
function HR(t, e) {
  const n = ke(t), i = bv(n) - e;
  return n.setDate(n.getDate() - i * 7), n;
}
class BR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 100);
    we(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "I":
        return Dt(Ft.week, n);
      case "Io":
        return r.ordinalNumber(n, { unit: "week" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 53;
  }
  set(n, i, r) {
    return $i(HR(n, r));
  }
}
const qR = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31], GR = [
  31,
  29,
  31,
  30,
  31,
  30,
  31,
  31,
  30,
  31,
  30,
  31
];
class XR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "subPriority", 1);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "w",
      "I",
      "D",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "d":
        return Dt(Ft.date, n);
      case "do":
        return r.ordinalNumber(n, { unit: "date" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    const r = n.getFullYear(), a = U9(r), o = n.getMonth();
    return a ? i >= 1 && i <= GR[o] : i >= 1 && i <= qR[o];
  }
  set(n, i, r) {
    return n.setDate(r), n.setHours(0, 0, 0, 0), n;
  }
}
class YR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "subpriority", 1);
    we(this, "incompatibleTokens", [
      "Y",
      "R",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "I",
      "d",
      "E",
      "i",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    switch (i) {
      case "D":
      case "DD":
        return Dt(Ft.dayOfYear, n);
      case "Do":
        return r.ordinalNumber(n, { unit: "date" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    const r = n.getFullYear();
    return U9(r) ? i >= 1 && i <= 366 : i >= 1 && i <= 365;
  }
  set(n, i, r) {
    return n.setMonth(0, r), n.setHours(0, 0, 0, 0), n;
  }
}
function _v(t, e, n) {
  var f, m, h, p;
  const i = Ra(), r = (n == null ? void 0 : n.weekStartsOn) ?? ((m = (f = n == null ? void 0 : n.locale) == null ? void 0 : f.options) == null ? void 0 : m.weekStartsOn) ?? i.weekStartsOn ?? ((p = (h = i.locale) == null ? void 0 : h.options) == null ? void 0 : p.weekStartsOn) ?? 0, a = ke(t), o = a.getDay(), l = (e % 7 + 7) % 7, c = 7 - r, u = e < 0 || e > 6 ? e - (o + c) % 7 : (l + c) % 7 - (o + c) % 7;
  return Ct(a, u);
}
class KR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", ["D", "i", "e", "c", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      // Tue
      case "E":
      case "EE":
      case "EEE":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      // T
      case "EEEEE":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "EEEEEE":
        return r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "EEEE":
      default:
        return r.day(n, { width: "wide", context: "formatting" }) || r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, a) {
    return n = _v(n, r, a), n.setHours(0, 0, 0, 0), n;
  }
}
class UR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r, a) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (i) {
      // 3
      case "e":
      case "ee":
        return zt(At(i.length, n), o);
      // 3rd
      case "eo":
        return zt(
          r.ordinalNumber(n, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "eee":
        return r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      // T
      case "eeeee":
        return r.day(n, {
          width: "narrow",
          context: "formatting"
        });
      // Tu
      case "eeeeee":
        return r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
      // Tuesday
      case "eeee":
      default:
        return r.day(n, { width: "wide", context: "formatting" }) || r.day(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.day(n, { width: "short", context: "formatting" }) || r.day(n, { width: "narrow", context: "formatting" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, a) {
    return n = _v(n, r, a), n.setHours(0, 0, 0, 0), n;
  }
}
class JR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "R",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "I",
      "d",
      "D",
      "E",
      "i",
      "e",
      "t",
      "T"
    ]);
  }
  parse(n, i, r, a) {
    const o = (s) => {
      const l = Math.floor((s - 1) / 7) * 7;
      return (s + a.weekStartsOn + 6) % 7 + l;
    };
    switch (i) {
      // 3
      case "c":
      case "cc":
        return zt(At(i.length, n), o);
      // 3rd
      case "co":
        return zt(
          r.ordinalNumber(n, {
            unit: "day"
          }),
          o
        );
      // Tue
      case "ccc":
        return r.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
      // T
      case "ccccc":
        return r.day(n, {
          width: "narrow",
          context: "standalone"
        });
      // Tu
      case "cccccc":
        return r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
      // Tuesday
      case "cccc":
      default:
        return r.day(n, { width: "wide", context: "standalone" }) || r.day(n, {
          width: "abbreviated",
          context: "standalone"
        }) || r.day(n, { width: "short", context: "standalone" }) || r.day(n, { width: "narrow", context: "standalone" });
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 6;
  }
  set(n, i, r, a) {
    return n = _v(n, r, a), n.setHours(0, 0, 0, 0), n;
  }
}
function QR(t, e) {
  const n = ke(t), i = MR(n), r = e - i;
  return Ct(n, r);
}
class ZR extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 90);
    we(this, "incompatibleTokens", [
      "y",
      "Y",
      "u",
      "q",
      "Q",
      "M",
      "L",
      "w",
      "d",
      "D",
      "E",
      "e",
      "c",
      "t",
      "T"
    ]);
  }
  parse(n, i, r) {
    const a = (o) => o === 0 ? 7 : o;
    switch (i) {
      // 2
      case "i":
      case "ii":
        return At(i.length, n);
      // 2nd
      case "io":
        return r.ordinalNumber(n, { unit: "day" });
      // Tue
      case "iii":
        return zt(
          r.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // T
      case "iiiii":
        return zt(
          r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tu
      case "iiiiii":
        return zt(
          r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
      // Tuesday
      case "iiii":
      default:
        return zt(
          r.day(n, {
            width: "wide",
            context: "formatting"
          }) || r.day(n, {
            width: "abbreviated",
            context: "formatting"
          }) || r.day(n, {
            width: "short",
            context: "formatting"
          }) || r.day(n, {
            width: "narrow",
            context: "formatting"
          }),
          a
        );
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 7;
  }
  set(n, i, r) {
    return n = QR(n, r), n.setHours(0, 0, 0, 0), n;
  }
}
class ej extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["b", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "a":
      case "aa":
      case "aaa":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaaa":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "aaaa":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(xv(r), 0, 0, 0), n;
  }
}
class tj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["a", "B", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "b":
      case "bb":
      case "bbb":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbbb":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "bbbb":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(xv(r), 0, 0, 0), n;
  }
}
class nj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 80);
    we(this, "incompatibleTokens", ["a", "b", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "B":
      case "BB":
      case "BBB":
        return r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBBB":
        return r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
      case "BBBB":
      default:
        return r.dayPeriod(n, {
          width: "wide",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "abbreviated",
          context: "formatting"
        }) || r.dayPeriod(n, {
          width: "narrow",
          context: "formatting"
        });
    }
  }
  set(n, i, r) {
    return n.setHours(xv(r), 0, 0, 0), n;
  }
}
class ij extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["H", "K", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "h":
        return Dt(Ft.hour12h, n);
      case "ho":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 12;
  }
  set(n, i, r) {
    const a = n.getHours() >= 12;
    return a && r < 12 ? n.setHours(r + 12, 0, 0, 0) : !a && r === 12 ? n.setHours(0, 0, 0, 0) : n.setHours(r, 0, 0, 0), n;
  }
}
class rj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["a", "b", "h", "K", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "H":
        return Dt(Ft.hour23h, n);
      case "Ho":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 23;
  }
  set(n, i, r) {
    return n.setHours(r, 0, 0, 0), n;
  }
}
class aj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["h", "H", "k", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "K":
        return Dt(Ft.hour11h, n);
      case "Ko":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 11;
  }
  set(n, i, r) {
    return n.getHours() >= 12 && r < 12 ? n.setHours(r + 12, 0, 0, 0) : n.setHours(r, 0, 0, 0), n;
  }
}
class oj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 70);
    we(this, "incompatibleTokens", ["a", "b", "h", "H", "K", "t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "k":
        return Dt(Ft.hour24h, n);
      case "ko":
        return r.ordinalNumber(n, { unit: "hour" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 1 && i <= 24;
  }
  set(n, i, r) {
    const a = r <= 24 ? r % 24 : r;
    return n.setHours(a, 0, 0, 0), n;
  }
}
class sj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 60);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "m":
        return Dt(Ft.minute, n);
      case "mo":
        return r.ordinalNumber(n, { unit: "minute" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, r) {
    return n.setMinutes(r, 0, 0), n;
  }
}
class lj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 50);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i, r) {
    switch (i) {
      case "s":
        return Dt(Ft.second, n);
      case "so":
        return r.ordinalNumber(n, { unit: "second" });
      default:
        return At(i.length, n);
    }
  }
  validate(n, i) {
    return i >= 0 && i <= 59;
  }
  set(n, i, r) {
    return n.setSeconds(r, 0), n;
  }
}
class dj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 30);
    we(this, "incompatibleTokens", ["t", "T"]);
  }
  parse(n, i) {
    const r = (a) => Math.trunc(a * Math.pow(10, -i.length + 3));
    return zt(At(i.length, n), r);
  }
  set(n, i, r) {
    return n.setMilliseconds(r), n;
  }
}
class cj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 10);
    we(this, "incompatibleTokens", ["t", "T", "x"]);
  }
  parse(n, i) {
    switch (i) {
      case "X":
        return sr(
          or.basicOptionalMinutes,
          n
        );
      case "XX":
        return sr(or.basic, n);
      case "XXXX":
        return sr(
          or.basicOptionalSeconds,
          n
        );
      case "XXXXX":
        return sr(
          or.extendedOptionalSeconds,
          n
        );
      case "XXX":
      default:
        return sr(or.extended, n);
    }
  }
  set(n, i, r) {
    return i.timestampIsSet ? n : ct(
      n,
      n.getTime() - Pa(n) - r
    );
  }
}
class uj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 10);
    we(this, "incompatibleTokens", ["t", "T", "X"]);
  }
  parse(n, i) {
    switch (i) {
      case "x":
        return sr(
          or.basicOptionalMinutes,
          n
        );
      case "xx":
        return sr(or.basic, n);
      case "xxxx":
        return sr(
          or.basicOptionalSeconds,
          n
        );
      case "xxxxx":
        return sr(
          or.extendedOptionalSeconds,
          n
        );
      case "xxx":
      default:
        return sr(or.extended, n);
    }
  }
  set(n, i, r) {
    return i.timestampIsSet ? n : ct(
      n,
      n.getTime() - Pa(n) - r
    );
  }
}
class fj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 40);
    we(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Y9(n);
  }
  set(n, i, r) {
    return [ct(n, r * 1e3), { timestampIsSet: !0 }];
  }
}
class mj extends at {
  constructor() {
    super(...arguments);
    we(this, "priority", 20);
    we(this, "incompatibleTokens", "*");
  }
  parse(n) {
    return Y9(n);
  }
  set(n, i, r) {
    return [ct(n, r), { timestampIsSet: !0 }];
  }
}
const hj = {
  G: new TR(),
  y: new OR(),
  Y: new WR(),
  R: new AR(),
  u: new LR(),
  Q: new IR(),
  q: new RR(),
  M: new jR(),
  L: new FR(),
  w: new VR(),
  I: new BR(),
  d: new XR(),
  D: new YR(),
  E: new KR(),
  e: new UR(),
  c: new JR(),
  i: new ZR(),
  a: new ej(),
  b: new tj(),
  B: new nj(),
  h: new ij(),
  H: new rj(),
  K: new aj(),
  k: new oj(),
  m: new sj(),
  s: new lj(),
  S: new dj(),
  X: new cj(),
  x: new uj(),
  t: new fj(),
  T: new mj()
}, pj = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g, gj = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g, yj = /^'([^]*?)'?$/, vj = /''/g, bj = /\S/, wj = /[a-zA-Z]/;
function lf(t, e, n, i) {
  var g, y, v, w;
  const r = _R(), a = r.locale ?? mc, o = r.firstWeekContainsDate ?? ((y = (g = r.locale) == null ? void 0 : g.options) == null ? void 0 : y.firstWeekContainsDate) ?? 1, s = r.weekStartsOn ?? ((w = (v = r.locale) == null ? void 0 : v.options) == null ? void 0 : w.weekStartsOn) ?? 0;
  if (e === "")
    return t === "" ? ke(n) : ct(n, NaN);
  const l = {
    firstWeekContainsDate: o,
    weekStartsOn: s,
    locale: a
  }, c = [new ER()], u = e.match(gj).map((x) => {
    const b = x[0];
    if (b in zp) {
      const M = zp[b];
      return M(x, a.formatLong);
    }
    return x;
  }).join("").match(pj), f = [];
  for (let x of u) {
    G9(x) && Vp(x, e, t), q9(x) && Vp(x, e, t);
    const b = x[0], M = hj[b];
    if (M) {
      const { incompatibleTokens: _ } = M;
      if (Array.isArray(_)) {
        const $ = f.find(
          (D) => _.includes(D.token) || D.token === b
        );
        if ($)
          throw new RangeError(
            `The format string mustn't contain \`${$.fullToken}\` and \`${x}\` at the same time`
          );
      } else if (M.incompatibleTokens === "*" && f.length > 0)
        throw new RangeError(
          `The format string mustn't contain \`${x}\` and any other token at the same time`
        );
      f.push({ token: b, fullToken: x });
      const N = M.run(
        t,
        x,
        a.match,
        l
      );
      if (!N)
        return ct(n, NaN);
      c.push(N.setter), t = N.rest;
    } else {
      if (b.match(wj))
        throw new RangeError(
          "Format string contains an unescaped latin alphabet character `" + b + "`"
        );
      if (x === "''" ? x = "'" : b === "'" && (x = kj(x)), t.indexOf(x) === 0)
        t = t.slice(x.length);
      else
        return ct(n, NaN);
    }
  }
  if (t.length > 0 && bj.test(t))
    return ct(n, NaN);
  const m = c.map((x) => x.priority).sort((x, b) => b - x).filter((x, b, M) => M.indexOf(x) === b).map(
    (x) => c.filter((b) => b.priority === x).sort((b, M) => M.subPriority - b.subPriority)
  ).map((x) => x[0]);
  let h = ke(n);
  if (isNaN(h.getTime()))
    return ct(n, NaN);
  const p = {};
  for (const x of m) {
    if (!x.validate(h, l))
      return ct(n, NaN);
    const b = x.set(h, p, l);
    Array.isArray(b) ? (h = b[0], Object.assign(p, b[1])) : h = b;
  }
  return ct(n, h);
}
function kj(t) {
  return t.match(yj)[1].replace(vj, "'");
}
function Lt(t, e, n) {
  const i = mn(t, n), r = mn(e, n);
  return +i == +r;
}
function Um(t, e) {
  const n = ke(t), i = ke(e);
  return n.getFullYear() === i.getFullYear() && n.getMonth() === i.getMonth();
}
function J9(t, e) {
  const n = ke(t), i = ke(e);
  return n.getFullYear() === i.getFullYear();
}
function Q9(t) {
  return vn(t, gv(t));
}
function ks(t, e) {
  const n = +ke(t), [i, r] = [
    +ke(e.start),
    +ke(e.end)
  ].sort((a, o) => a - o);
  return n >= i && n <= r;
}
function lo(t, e) {
  return Ct(t, -e);
}
function Z9(t) {
  return vn(t, lo(gv(t), 1));
}
function Fl(t, e) {
  const n = ke(t), i = n.getFullYear(), r = n.getDate(), a = ct(t, 0);
  a.setFullYear(i, e, 15), a.setHours(0, 0, 0, 0);
  const o = xR(a);
  return n.setMonth(e, Math.min(r, o)), n;
}
function ak(t, e) {
  const n = ke(t);
  return isNaN(+n) ? ct(t, NaN) : (n.setFullYear(e), n);
}
function ml(t, e) {
  return Et(t, -e);
}
function ok(t, e) {
  return zr(t, -e);
}
function xj(t) {
  return ii(t, "p");
}
function sk(t) {
  return ii(t, "HH:mm");
}
function _j(t) {
  return ii(t, "LLL");
}
function Mj(t) {
  return t.getDate();
}
function lk(t, e = !0) {
  return kR(t, { addSuffix: e });
}
function eM(t, { yesterdayRelative: e = !0 } = {}) {
  return Q9(t) ? lk(t) : Z9(t) ? e ? lk(t) : ii(t, "p") : ii(t, "PPPp");
}
const Cj = (t, e) => {
  const n = {
    today: [],
    yesterday: [],
    lastWeek: [],
    lastMonth: []
  };
  return t.forEach((i) => {
    const r = i[e], a = Math.abs(H9(r, /* @__PURE__ */ new Date()));
    Q9(r) ? n.today.push(i) : Z9(r) ? n.yesterday.push(i) : a <= 7 ? n.lastWeek.push(i) : a <= 30 ? n.lastMonth.push(i) : n[r.getFullYear()] = [...n[r.getFullYear()] || [], i];
  }), n;
}, Pj = {
  sm: "size-6 rounded-sm",
  md: "size-9 rounded-md",
  lg: "size-10 rounded-lg"
}, df = ({ icon: t, size: e = "md", className: n }) => /* @__PURE__ */ d(
  "div",
  {
    className: E(
      "flex aspect-square items-center justify-center border border-solid border-f1-border-secondary",
      Pj[e],
      n
    ),
    children: /* @__PURE__ */ d(me, { icon: t, size: e, className: "text-f1-foreground-secondary" })
  }
);
df.displayName = "IconAvatar";
const Sj = ({
  id: t,
  createdAt: e,
  title: n,
  description: i,
  icon: r,
  category: a,
  isUnread: o = !1,
  onClick: s,
  onVisible: l
}) => {
  const { ref: c } = Cp({
    threshold: 0.1,
    onChange(m) {
      m && (l == null || l(t));
    }
  }), u = eM(e, {
    yesterdayRelative: !1
  });
  return /* @__PURE__ */ k(
    "div",
    {
      ref: c,
      className: "flex w-full cursor-pointer flex-row gap-2 rounded-lg p-2 pr-3 hover:bg-f1-background-hover focus:border-f1-border-secondary focus:outline focus:outline-1 focus:outline-offset-1 focus:outline-f1-border-selected-bold",
      onClick: () => {
        s(t);
      },
      children: [
        /* @__PURE__ */ d(df, { icon: r ?? x5 }),
        /* @__PURE__ */ k("div", { className: "flex-1", children: [
          /* @__PURE__ */ d(
            "p",
            {
              className: "line-clamp-2 font-medium text-f1-foreground",
              title: n,
              children: n
            }
          ),
          /* @__PURE__ */ d(
            "p",
            {
              className: "line-clamp-2 text-f1-foreground-secondary",
              title: i,
              children: i
            }
          ),
          /* @__PURE__ */ d("div", { className: "mt-1.5 flex flex-row", children: /* @__PURE__ */ d("p", { className: "text-f1-foreground-secondary", children: `${a} · ${u}` }) })
        ] }),
        /* @__PURE__ */ d("div", { className: "ml-1", children: o && /* @__PURE__ */ d("div", { className: "mt-1.5 size-2 rounded-full bg-f1-icon-accent" }) })
      ]
    }
  );
}, Nj = () => /* @__PURE__ */ k("div", { className: "flex w-full flex-row gap-2 rounded-lg p-2 pr-3", children: [
  /* @__PURE__ */ d(Ce, { className: "size-9 rounded-md" }),
  /* @__PURE__ */ k("div", { className: "flex-1", children: [
    /* @__PURE__ */ d(Ce, { className: "mb-1 h-5 w-full" }),
    /* @__PURE__ */ d(Ce, { className: "mb-1 h-4 w-full" }),
    /* @__PURE__ */ d(Ce, { className: "mb-1 h-4 w-full" }),
    /* @__PURE__ */ d(Ce, { className: "mt-1.5 h-4 w-1/3" })
  ] })
] }), Mv = Bt(Sj, Nj), tM = ({
  title: t,
  children: e
}) => /* @__PURE__ */ k("div", { children: [
  /* @__PURE__ */ d("div", { className: "pb-2 pl-2 pt-1", children: /* @__PURE__ */ d("p", { className: "text-sm font-medium text-f1-foreground-secondary", children: t }) }),
  /* @__PURE__ */ d("div", { className: "flex flex-col gap-1", children: e })
] }), $j = ({
  title: t,
  items: e,
  onClickItem: n,
  onItemVisible: i
}) => /* @__PURE__ */ d(tM, { title: t, children: e.map((r) => /* @__PURE__ */ d(
  Mv,
  {
    ...r,
    onClick: () => n(r.id),
    onVisible: i
  },
  r.id
)) }), Dj = ({
  title: t,
  numItems: e
}) => /* @__PURE__ */ d(tM, { title: t, children: Array.from({ length: e }).map((n, i) => /* @__PURE__ */ d(Mv.Skeleton, {}, i)) }), bu = Bt($j, Dj), Ej = 3, Tj = ["today", "yesterday", "lastWeek", "lastMonth"], Oj = (t) => I$(t, ([e]) => {
  const n = Tj.indexOf(e);
  return n === -1 ? -Number(e) : n - 4e3;
}), Hp = () => /* @__PURE__ */ d("div", { className: "-mx-2 h-px bg-f1-background-secondary" }), Wj = ({
  items: t,
  loadingMoreItems: e = !1,
  onClickItem: n,
  onEndReached: i,
  onEndReachedItemsThreshold: r = 5
}) => {
  const a = et(), o = Cj(t, "createdAt"), s = Object.values(o).slice().flatMap((u) => u.map((f) => f.id)).slice(-r), l = L$((u) => {
    s.includes(u) && (i == null || i());
  }, 1e3), c = Oj(
    Object.entries(o).filter(([u, f]) => !!f.length)
  );
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-2 p-2", children: [
    c.map(([u, f], m) => /* @__PURE__ */ k(H.Fragment, { children: [
      /* @__PURE__ */ d(
        bu,
        {
          title: u in a.date.groups ? a.date.groups[u] : u,
          items: f,
          onClickItem: n,
          onItemVisible: l
        }
      ),
      m !== c.length - 1 && /* @__PURE__ */ d(Hp, {})
    ] }, u)),
    e && new Array(Ej).fill(null).map((u, f) => /* @__PURE__ */ d(Mv.Skeleton, {}, f))
  ] });
}, Aj = () => {
  const t = et();
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-2 p-2", children: [
    /* @__PURE__ */ d(bu.Skeleton, { title: t.date.groups.today, numItems: 1 }),
    /* @__PURE__ */ d(Hp, {}),
    /* @__PURE__ */ d(
      bu.Skeleton,
      {
        title: t.date.groups.yesterday,
        numItems: 3
      }
    ),
    /* @__PURE__ */ d(Hp, {}),
    /* @__PURE__ */ d(
      bu.Skeleton,
      {
        title: t.date.groups.lastMonth,
        numItems: 5
      }
    )
  ] });
}, tYe = Bt(
  Wj,
  Aj
), Lj = It({
  base: "relative w-full rounded-xl bg-f1-background-secondary p-6 text-f1-foreground [&>svg+div]:translate-y-[-3px] [&>svg]:absolute [&>svg]:left-6 [&>svg]:top-6 [&>svg]:text-f1-foreground [&>svg~*]:pl-8",
  variants: {
    variant: {
      destructive: "bg-f1-background-critical [&>svg]:text-f1-icon-critical",
      positive: "bg-f1-background-positive [&>svg]:text-f1-icon-positive",
      warning: "bg-f1-background-warning [&>svg]:text-f1-icon-warning",
      info: "bg-f1-background-info [&>svg]:text-f1-icon-info"
    }
  },
  defaultVariants: {
    variant: "info"
  }
}), Ij = {
  destructive: jW,
  positive: IW,
  warning: zW,
  info: OW
}, nYe = ui(
  {
    name: "Alert",
    type: "info"
  },
  // eslint-disable-next-line react/display-name
  S.forwardRef(({ className: t, variant: e = "info", children: n, ...i }, r) => {
    const a = e ? Ij[e] : null;
    return /* @__PURE__ */ d(
      "div",
      {
        ref: r,
        role: "alert",
        className: E(Lj({ variant: e }), t),
        ...i,
        children: /* @__PURE__ */ k("div", { className: "flex flex-row", children: [
          a && /* @__PURE__ */ d("div", { className: "mr-2 flex h-6 items-center", children: /* @__PURE__ */ d(a, { size: 20 }) }),
          /* @__PURE__ */ d("div", { children: n })
        ] })
      }
    );
  })
), iYe = S.forwardRef(function({ className: e, ...n }, i) {
  return /* @__PURE__ */ d(
    "h5",
    {
      ref: i,
      className: E("mb-1 text-base font-medium tracking-tight", e),
      ...n
    }
  );
}), rYe = S.forwardRef(function({ className: e, ...n }, i) {
  return /* @__PURE__ */ d(
    "div",
    {
      ref: i,
      className: E("[&_p]:leading-relaxed", e),
      ...n
    }
  );
}), Rj = re.create(me), nM = ({
  count: t,
  totalItemsCount: e,
  isOpen: n
}) => {
  const i = et();
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex items-center gap-1 rounded py-1.5 pl-3 pr-2 text-base font-medium text-f1-foreground transition-colors hover:bg-f1-background-secondary",
        n && "bg-f1-background-secondary"
      ),
      children: [
        /* @__PURE__ */ k("span", { children: [
          t < e && "+",
          t
        ] }),
        /* @__PURE__ */ d("span", { children: i.actions.more }),
        /* @__PURE__ */ d("div", { className: "flex h-5 w-5 items-center justify-center after:absolute after:h-4 after:w-4 after:rounded-xs after:bg-f1-background-secondary after:content-['']", children: /* @__PURE__ */ d(
          Rj,
          {
            icon: zn,
            initial: { rotate: 0 },
            animate: { rotate: n ? 180 : 0 },
            size: "xs"
          }
        ) })
      ]
    }
  );
};
nM.displayName = "OverflowIndicator";
function jj(t, e) {
  const n = Oe(null), i = Oe(null), r = Oe(null), [a, o] = q({
    visibleItems: [],
    overflowItems: []
  }), [s, l] = q(!1);
  qu({
    ref: n,
    onResize: () => {
      h();
    }
  });
  const c = Le(
    (p, g, y) => g < y - 1 ? p + e : p,
    [e]
  ), u = Le(() => {
    if (!r.current) return [];
    const p = r.current.children, g = [];
    for (let y = 0; y < p.length; y++) {
      const v = p[y].getBoundingClientRect().width;
      g.push(v);
    }
    return g;
  }, []), f = Le(
    (p) => {
      let g = 0;
      for (let y = 0; y < p.length; y++)
        g += p[y], g = c(g, y, p.length);
      return g;
    },
    [c]
  ), m = Le(
    (p, g) => {
      let y = 0, v = 0;
      for (let w = 0; w < p.length; w++) {
        const x = v + p[w];
        if (x > g) break;
        v = x, v = c(
          v,
          w,
          p.length
        ), y++;
      }
      return y;
    },
    [c]
  ), h = Le(() => {
    var M;
    if (!n.current || t.length === 0) return;
    const p = n.current.clientWidth, g = ((M = i.current) == null ? void 0 : M.offsetWidth) || 60, y = u();
    if (f(y) <= p) {
      o({
        visibleItems: t,
        overflowItems: []
      });
      return;
    }
    const x = p - g - e, b = m(y, x);
    o(b === 0 ? {
      visibleItems: [],
      overflowItems: t
    } : {
      visibleItems: t.slice(0, b),
      overflowItems: t.slice(b)
    });
  }, [
    t,
    e,
    u,
    f,
    m
  ]);
  return le(() => {
    h();
  }, [h]), le(() => {
    l(!0);
  }, []), {
    containerRef: n,
    overflowButtonRef: i,
    measurementContainerRef: r,
    visibleItems: a.visibleItems,
    overflowItems: a.overflowItems,
    isInitialized: s
  };
}
const Jm = function({
  items: e,
  renderListItem: n,
  renderDropdownItem: i,
  overflowIndicatorWithPopover: r = !0,
  renderOverflowIndicator: a,
  forceShowingOverflowIndicator: o = !1,
  className: s = "",
  gap: l = 8
}) {
  const [c, u] = q(!1), f = Le((M) => {
    u(M);
  }, []), {
    containerRef: m,
    overflowButtonRef: h,
    measurementContainerRef: p,
    visibleItems: g,
    overflowItems: y,
    isInitialized: v
  } = jj(e, l), w = ve(
    () => /* @__PURE__ */ d(
      nM,
      {
        totalItemsCount: e.length,
        isOpen: c,
        count: y.length
      }
    ),
    [e.length, c, y.length]
  ), x = ve(() => v ? null : e.map((M, _) => /* @__PURE__ */ d(Ce, { className: "h-2 w-20 rounded-md" }, `placeholder-${_}`)), [e, v]), b = o || y.length > 0;
  return /* @__PURE__ */ k(
    "div",
    {
      ref: m,
      className: E("relative flex items-center", s),
      style: { gap: `${l}px` },
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            ref: p,
            "aria-hidden": "true",
            className: "pointer-events-none invisible absolute left-0 top-0 flex opacity-0",
            style: { gap: `${l}px` },
            "data-testid": "overflow-measurement-container",
            children: e.map((M, _) => /* @__PURE__ */ d("div", { "data-testid": "overflow-measurement-item", children: n(M, _, !1) }, `measure-${_}`))
          }
        ),
        /* @__PURE__ */ k(
          "div",
          {
            className: "flex items-center whitespace-nowrap",
            style: { gap: `${l}px` },
            "data-testid": "overflow-visible-container",
            children: [
              v && g.map((M, _) => /* @__PURE__ */ d(
                "div",
                {
                  className: "transition-all duration-150",
                  "data-testid": "overflow-visible-item",
                  children: n(M, _, !0)
                },
                `item-${_}`
              )),
              x
            ]
          }
        ),
        b && /* @__PURE__ */ d(Ee, { children: r ? /* @__PURE__ */ k($o, { open: c, onOpenChange: f, children: [
          /* @__PURE__ */ d(Do, { asChild: !0, children: /* @__PURE__ */ d(
            "button",
            {
              ref: h,
              className: E(
                "inline-flex flex-shrink-0 items-center",
                Ke()
              ),
              children: (a == null ? void 0 : a(y.length, c)) ?? w
            }
          ) }),
          /* @__PURE__ */ d(
            Eo,
            {
              className: "rounded-md border border-solid border-f1-border-secondary p-1 shadow-md",
              align: "end",
              children: /* @__PURE__ */ d("div", { className: "flex flex-col", children: y.map((M, _) => /* @__PURE__ */ d("div", { children: i(M, _) }, `overflow-item-${_}`)) })
            }
          )
        ] }) : (a == null ? void 0 : a(y.length, !1)) ?? w })
      ]
    }
  );
};
Jm.displayName = "OverflowList";
var Fj = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "span",
  "svg",
  "ul"
], Us = Fj.reduce((t, e) => {
  const n = S.forwardRef((i, r) => {
    const { asChild: a, ...o } = i, s = a ? Ny : e;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ d(s, { ...o, ref: r });
  });
  return n.displayName = `Primitive.${e}`, { ...t, [e]: n };
}, {});
function zj(t, e) {
  t && Ay.flushSync(() => t.dispatchEvent(e));
}
var Vj = "Arrow", iM = S.forwardRef((t, e) => {
  const { children: n, width: i = 10, height: r = 5, ...a } = t;
  return /* @__PURE__ */ d(
    Us.svg,
    {
      ...a,
      ref: e,
      width: i,
      height: r,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: t.asChild ? n : /* @__PURE__ */ d("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
iM.displayName = Vj;
var Hj = iM, Cv = "Popper", [rM, aM] = Wi(Cv), [Bj, oM] = rM(Cv), sM = (t) => {
  const { __scopePopper: e, children: n } = t, [i, r] = S.useState(null);
  return /* @__PURE__ */ d(Bj, { scope: e, anchor: i, onAnchorChange: r, children: n });
};
sM.displayName = Cv;
var lM = "PopperAnchor", dM = S.forwardRef(
  (t, e) => {
    const { __scopePopper: n, virtualRef: i, ...r } = t, a = oM(lM, n), o = S.useRef(null), s = st(e, o);
    return S.useEffect(() => {
      a.onAnchorChange((i == null ? void 0 : i.current) || o.current);
    }), i ? null : /* @__PURE__ */ d(Us.div, { ...r, ref: s });
  }
);
dM.displayName = lM;
var Pv = "PopperContent", [qj, Gj] = rM(Pv), cM = S.forwardRef(
  (t, e) => {
    var Y, oe, se, J, xe, De;
    const {
      __scopePopper: n,
      side: i = "bottom",
      sideOffset: r = 0,
      align: a = "center",
      alignOffset: o = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: f = "partial",
      hideWhenDetached: m = !1,
      updatePositionStrategy: h = "optimized",
      onPlaced: p,
      ...g
    } = t, y = oM(Pv, n), [v, w] = S.useState(null), x = st(e, (_e) => w(_e)), [b, M] = S.useState(null), _ = e5(b), N = (_ == null ? void 0 : _.width) ?? 0, $ = (_ == null ? void 0 : _.height) ?? 0, D = i + (a !== "center" ? "-" + a : ""), W = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, j = Array.isArray(c) ? c : [c], O = j.length > 0, I = {
      padding: W,
      boundary: j.filter(Yj),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: O
    }, { refs: L, floatingStyles: R, placement: B, isPositioned: F, middlewareData: z } = R$({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: D,
      whileElementsMounted: (..._e) => G$(..._e, {
        animationFrame: h === "always"
      }),
      elements: {
        reference: y.anchor
      },
      middleware: [
        j$({ mainAxis: r + $, alignmentAxis: o }),
        l && F$({
          mainAxis: !0,
          crossAxis: !1,
          limiter: f === "partial" ? q$() : void 0,
          ...I
        }),
        l && z$({ ...I }),
        V$({
          ...I,
          apply: ({ elements: _e, rects: ce, availableWidth: wt, availableHeight: St }) => {
            const { width: ze, height: A } = ce.reference, V = _e.floating.style;
            V.setProperty("--radix-popper-available-width", `${wt}px`), V.setProperty("--radix-popper-available-height", `${St}px`), V.setProperty("--radix-popper-anchor-width", `${ze}px`), V.setProperty("--radix-popper-anchor-height", `${A}px`);
          }
        }),
        b && H$({ element: b, padding: s }),
        Kj({ arrowWidth: N, arrowHeight: $ }),
        m && B$({ strategy: "referenceHidden", ...I })
      ]
    }), [K, ae] = mM(B), Q = Wn(p);
    xn(() => {
      F && (Q == null || Q());
    }, [F, Q]);
    const te = (Y = z.arrow) == null ? void 0 : Y.x, be = (oe = z.arrow) == null ? void 0 : oe.y, Pe = ((se = z.arrow) == null ? void 0 : se.centerOffset) !== 0, [We, $e] = S.useState();
    return xn(() => {
      v && $e(window.getComputedStyle(v).zIndex);
    }, [v]), /* @__PURE__ */ d(
      "div",
      {
        ref: L.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...R,
          transform: F ? R.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: We,
          "--radix-popper-transform-origin": [
            (J = z.transformOrigin) == null ? void 0 : J.x,
            (xe = z.transformOrigin) == null ? void 0 : xe.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...((De = z.hide) == null ? void 0 : De.referenceHidden) && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: t.dir,
        children: /* @__PURE__ */ d(
          qj,
          {
            scope: n,
            placedSide: K,
            onArrowChange: M,
            arrowX: te,
            arrowY: be,
            shouldHideArrow: Pe,
            children: /* @__PURE__ */ d(
              Us.div,
              {
                "data-side": K,
                "data-align": ae,
                ...g,
                ref: x,
                style: {
                  ...g.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: F ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
cM.displayName = Pv;
var uM = "PopperArrow", Xj = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, fM = S.forwardRef(function(e, n) {
  const { __scopePopper: i, ...r } = e, a = Gj(uM, i), o = Xj[a.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ d(
      "span",
      {
        ref: a.onArrowChange,
        style: {
          position: "absolute",
          left: a.arrowX,
          top: a.arrowY,
          [o]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[a.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[a.placedSide],
          visibility: a.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ d(
          Hj,
          {
            ...r,
            ref: n,
            style: {
              ...r.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
fM.displayName = uM;
function Yj(t) {
  return t !== null;
}
var Kj = (t) => ({
  name: "transformOrigin",
  options: t,
  fn(e) {
    var y, v, w;
    const { placement: n, rects: i, middlewareData: r } = e, o = ((y = r.arrow) == null ? void 0 : y.centerOffset) !== 0, s = o ? 0 : t.arrowWidth, l = o ? 0 : t.arrowHeight, [c, u] = mM(n), f = { start: "0%", center: "50%", end: "100%" }[u], m = (((v = r.arrow) == null ? void 0 : v.x) ?? 0) + s / 2, h = (((w = r.arrow) == null ? void 0 : w.y) ?? 0) + l / 2;
    let p = "", g = "";
    return c === "bottom" ? (p = o ? f : `${m}px`, g = `${-l}px`) : c === "top" ? (p = o ? f : `${m}px`, g = `${i.floating.height + l}px`) : c === "right" ? (p = `${-l}px`, g = o ? f : `${h}px`) : c === "left" && (p = `${i.floating.width + l}px`, g = o ? f : `${h}px`), { data: { x: p, y: g } };
  }
});
function mM(t) {
  const [e, n = "center"] = t.split("-");
  return [e, n];
}
var Uj = sM, Jj = dM, Qj = cM, Zj = fM, eF = "DismissableLayer", Bp = "dismissableLayer.update", tF = "dismissableLayer.pointerDownOutside", nF = "dismissableLayer.focusOutside", dk, hM = S.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), pM = S.forwardRef(
  (t, e) => {
    const {
      disableOutsidePointerEvents: n = !1,
      onEscapeKeyDown: i,
      onPointerDownOutside: r,
      onFocusOutside: a,
      onInteractOutside: o,
      onDismiss: s,
      ...l
    } = t, c = S.useContext(hM), [u, f] = S.useState(null), m = (u == null ? void 0 : u.ownerDocument) ?? (globalThis == null ? void 0 : globalThis.document), [, h] = S.useState({}), p = st(e, (N) => f(N)), g = Array.from(c.layers), [y] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), v = g.indexOf(y), w = u ? g.indexOf(u) : -1, x = c.layersWithOutsidePointerEventsDisabled.size > 0, b = w >= v, M = aF((N) => {
      const $ = N.target, D = [...c.branches].some((W) => W.contains($));
      !b || D || (r == null || r(N), o == null || o(N), N.defaultPrevented || s == null || s());
    }, m), _ = oF((N) => {
      const $ = N.target;
      [...c.branches].some((W) => W.contains($)) || (a == null || a(N), o == null || o(N), N.defaultPrevented || s == null || s());
    }, m);
    return X$((N) => {
      w === c.layers.size - 1 && (i == null || i(N), !N.defaultPrevented && s && (N.preventDefault(), s()));
    }, m), S.useEffect(() => {
      if (u)
        return n && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (dk = m.body.style.pointerEvents, m.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), ck(), () => {
          n && c.layersWithOutsidePointerEventsDisabled.size === 1 && (m.body.style.pointerEvents = dk);
        };
    }, [u, m, n, c]), S.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), ck());
    }, [u, c]), S.useEffect(() => {
      const N = () => h({});
      return document.addEventListener(Bp, N), () => document.removeEventListener(Bp, N);
    }, []), /* @__PURE__ */ d(
      Us.div,
      {
        ...l,
        ref: p,
        style: {
          pointerEvents: x ? b ? "auto" : "none" : void 0,
          ...t.style
        },
        onFocusCapture: ge(t.onFocusCapture, _.onFocusCapture),
        onBlurCapture: ge(t.onBlurCapture, _.onBlurCapture),
        onPointerDownCapture: ge(
          t.onPointerDownCapture,
          M.onPointerDownCapture
        )
      }
    );
  }
);
pM.displayName = eF;
var iF = "DismissableLayerBranch", rF = S.forwardRef((t, e) => {
  const n = S.useContext(hM), i = S.useRef(null), r = st(e, i);
  return S.useEffect(() => {
    const a = i.current;
    if (a)
      return n.branches.add(a), () => {
        n.branches.delete(a);
      };
  }, [n.branches]), /* @__PURE__ */ d(Us.div, { ...t, ref: r });
});
rF.displayName = iF;
function aF(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Wn(t), i = S.useRef(!1), r = S.useRef(() => {
  });
  return S.useEffect(() => {
    const a = (s) => {
      if (s.target && !i.current) {
        let l = function() {
          gM(
            tF,
            n,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (e.removeEventListener("click", r.current), r.current = l, e.addEventListener("click", r.current, { once: !0 })) : l();
      } else
        e.removeEventListener("click", r.current);
      i.current = !1;
    }, o = window.setTimeout(() => {
      e.addEventListener("pointerdown", a);
    }, 0);
    return () => {
      window.clearTimeout(o), e.removeEventListener("pointerdown", a), e.removeEventListener("click", r.current);
    };
  }, [e, n]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => i.current = !0
  };
}
function oF(t, e = globalThis == null ? void 0 : globalThis.document) {
  const n = Wn(t), i = S.useRef(!1);
  return S.useEffect(() => {
    const r = (a) => {
      a.target && !i.current && gM(nF, n, { originalEvent: a }, {
        discrete: !1
      });
    };
    return e.addEventListener("focusin", r), () => e.removeEventListener("focusin", r);
  }, [e, n]), {
    onFocusCapture: () => i.current = !0,
    onBlurCapture: () => i.current = !1
  };
}
function ck() {
  const t = new CustomEvent(Bp);
  document.dispatchEvent(t);
}
function gM(t, e, n, { discrete: i }) {
  const r = n.originalEvent.target, a = new CustomEvent(t, { bubbles: !1, cancelable: !0, detail: n });
  e && r.addEventListener(t, e, { once: !0 }), i ? zj(r, a) : r.dispatchEvent(a);
}
var Qh, Sv = "HoverCard", [yM, aYe] = Wi(Sv, [
  aM
]), Qm = aM(), [sF, Nv] = yM(Sv), vM = (t) => {
  const {
    __scopeHoverCard: e,
    children: n,
    open: i,
    defaultOpen: r,
    onOpenChange: a,
    openDelay: o = 700,
    closeDelay: s = 300
  } = t, l = Qm(e), c = S.useRef(0), u = S.useRef(0), f = S.useRef(!1), m = S.useRef(!1), [h = !1, p] = Si({
    prop: i,
    defaultProp: r,
    onChange: a
  }), g = S.useCallback(() => {
    clearTimeout(u.current), c.current = window.setTimeout(() => p(!0), o);
  }, [o, p]), y = S.useCallback(() => {
    clearTimeout(c.current), !f.current && !m.current && (u.current = window.setTimeout(() => p(!1), s));
  }, [s, p]), v = S.useCallback(() => p(!1), [p]);
  return S.useEffect(() => () => {
    clearTimeout(c.current), clearTimeout(u.current);
  }, []), /* @__PURE__ */ d(
    sF,
    {
      scope: e,
      open: h,
      onOpenChange: p,
      onOpen: g,
      onClose: y,
      onDismiss: v,
      hasSelectionRef: f,
      isPointerDownOnContentRef: m,
      children: /* @__PURE__ */ d(Uj, { ...l, children: n })
    }
  );
};
vM.displayName = Sv;
var bM = "HoverCardTrigger", wM = S.forwardRef(
  (t, e) => {
    const { __scopeHoverCard: n, ...i } = t, r = Nv(bM, n), a = Qm(n);
    return /* @__PURE__ */ d(Jj, { asChild: !0, ...a, children: /* @__PURE__ */ d(
      Us.a,
      {
        "data-state": r.open ? "open" : "closed",
        ...i,
        ref: e,
        onPointerEnter: ge(t.onPointerEnter, uf(r.onOpen)),
        onPointerLeave: ge(t.onPointerLeave, uf(r.onClose)),
        onFocus: ge(t.onFocus, r.onOpen),
        onBlur: ge(t.onBlur, r.onClose),
        onTouchStart: ge(t.onTouchStart, (o) => o.preventDefault())
      }
    ) });
  }
);
wM.displayName = bM;
var lF = "HoverCardPortal", [oYe, dF] = yM(lF, {
  forceMount: void 0
}), cf = "HoverCardContent", kM = S.forwardRef(
  (t, e) => {
    const n = dF(cf, t.__scopeHoverCard), { forceMount: i = n.forceMount, ...r } = t, a = Nv(cf, t.__scopeHoverCard);
    return /* @__PURE__ */ d(Ji, { present: i || a.open, children: /* @__PURE__ */ d(
      cF,
      {
        "data-state": a.open ? "open" : "closed",
        ...r,
        onPointerEnter: ge(t.onPointerEnter, uf(a.onOpen)),
        onPointerLeave: ge(t.onPointerLeave, uf(a.onClose)),
        ref: e
      }
    ) });
  }
);
kM.displayName = cf;
var cF = S.forwardRef((t, e) => {
  const {
    __scopeHoverCard: n,
    onEscapeKeyDown: i,
    onPointerDownOutside: r,
    onFocusOutside: a,
    onInteractOutside: o,
    ...s
  } = t, l = Nv(cf, n), c = Qm(n), u = S.useRef(null), f = st(e, u), [m, h] = S.useState(!1);
  return S.useEffect(() => {
    if (m) {
      const p = document.body;
      return Qh = p.style.userSelect || p.style.webkitUserSelect, p.style.userSelect = "none", p.style.webkitUserSelect = "none", () => {
        p.style.userSelect = Qh, p.style.webkitUserSelect = Qh;
      };
    }
  }, [m]), S.useEffect(() => {
    if (u.current) {
      const p = () => {
        h(!1), l.isPointerDownOnContentRef.current = !1, setTimeout(() => {
          var y;
          ((y = document.getSelection()) == null ? void 0 : y.toString()) !== "" && (l.hasSelectionRef.current = !0);
        });
      };
      return document.addEventListener("pointerup", p), () => {
        document.removeEventListener("pointerup", p), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !1;
      };
    }
  }, [l.isPointerDownOnContentRef, l.hasSelectionRef]), S.useEffect(() => {
    u.current && mF(u.current).forEach((g) => g.setAttribute("tabindex", "-1"));
  }), /* @__PURE__ */ d(
    pM,
    {
      asChild: !0,
      disableOutsidePointerEvents: !1,
      onInteractOutside: o,
      onEscapeKeyDown: i,
      onPointerDownOutside: r,
      onFocusOutside: ge(a, (p) => {
        p.preventDefault();
      }),
      onDismiss: l.onDismiss,
      children: /* @__PURE__ */ d(
        Qj,
        {
          ...c,
          ...s,
          onPointerDown: ge(s.onPointerDown, (p) => {
            p.currentTarget.contains(p.target) && h(!0), l.hasSelectionRef.current = !1, l.isPointerDownOnContentRef.current = !0;
          }),
          ref: f,
          style: {
            ...s.style,
            userSelect: m ? "text" : void 0,
            // Safari requires prefix
            WebkitUserSelect: m ? "text" : void 0,
            "--radix-hover-card-content-transform-origin": "var(--radix-popper-transform-origin)",
            "--radix-hover-card-content-available-width": "var(--radix-popper-available-width)",
            "--radix-hover-card-content-available-height": "var(--radix-popper-available-height)",
            "--radix-hover-card-trigger-width": "var(--radix-popper-anchor-width)",
            "--radix-hover-card-trigger-height": "var(--radix-popper-anchor-height)"
          }
        }
      )
    }
  );
}), uF = "HoverCardArrow", fF = S.forwardRef(
  (t, e) => {
    const { __scopeHoverCard: n, ...i } = t, r = Qm(n);
    return /* @__PURE__ */ d(Zj, { ...r, ...i, ref: e });
  }
);
fF.displayName = uF;
function uf(t) {
  return (e) => e.pointerType === "touch" ? void 0 : t();
}
function mF(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
var hF = vM, pF = wM, xM = kM;
const gF = hF, yF = pF, _M = S.forwardRef(({ className: t, align: e = "center", sideOffset: n = 4, ...i }, r) => /* @__PURE__ */ d(
  xM,
  {
    ref: r,
    align: e,
    sideOffset: n,
    className: E(
      "z-50 w-[200px] rounded bg-f1-background-bold font-medium text-f1-foreground-inverse outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2",
      t
    ),
    ...i
  }
));
_M.displayName = xM.displayName;
const vF = It({
  base: "flex shrink-0 items-center justify-center bg-f1-background-secondary font-medium text-f1-foreground-secondary",
  variants: {
    size: {
      xsmall: "h-5 w-5 rounded-xs text-sm",
      small: "h-6 min-w-6 rounded-sm px-1 text-sm",
      medium: "h-8 min-w-8 rounded px-1.5",
      large: "h-14 min-w-14 rounded-xl px-3 text-2xl",
      xlarge: "h-18 min-w-18 rounded-[20px] px-4 text-3xl"
    },
    type: {
      base: "",
      rounded: "!rounded-full"
    }
  },
  compoundVariants: [
    {
      size: "small",
      type: "rounded",
      className: "px-1.5"
    },
    {
      size: "medium",
      type: "rounded",
      className: "px-2"
    },
    {
      size: "large",
      type: "rounded",
      className: "px-4"
    },
    {
      size: "xlarge",
      type: "rounded",
      className: "px-5"
    }
  ],
  defaultVariants: {
    size: "medium",
    type: "base"
  }
}), uk = ({
  count: t,
  size: e = "medium",
  type: n = "base",
  list: i
}) => {
  const r = /* @__PURE__ */ d(
    "div",
    {
      className: E("cursor-default font-medium", vF({ size: e, type: n })),
      children: e === "xsmall" ? /* @__PURE__ */ d(me, { icon: Ma, size: "xs" }) : `+${t}`
    }
  );
  return i != null && i.length ? /* @__PURE__ */ k(gF, { children: [
    /* @__PURE__ */ d(yF, { asChild: !0, children: r }),
    /* @__PURE__ */ d(_M, { side: "top", children: /* @__PURE__ */ k(No, { className: "[*[data-state=visible]_div]:bg-f1-background flex max-h-[172px] flex-col", children: [
      i.map((a, o) => /* @__PURE__ */ k(
        "div",
        {
          className: "flex w-[180px] min-w-0 items-center gap-1.5 px-2 py-1 [&:first-child]:pt-2 [&:last-child]:pb-2",
          children: [
            /* @__PURE__ */ d("div", { className: "h-6 w-6 shrink-0", children: /* @__PURE__ */ d(ni, { avatar: a, size: "small" }) }),
            /* @__PURE__ */ d("div", { className: "min-w-0 flex-1 truncate font-semibold", children: a.type === "person" ? `${a.firstName} ${a.lastName}` : a.name })
          ]
        },
        o
      )),
      /* @__PURE__ */ d(
        $y,
        {
          orientation: "vertical",
          className: "[&_div]:bg-f1-background"
        }
      )
    ] }) })
  ] }) : r;
}, bF = It({
  base: "flex items-center",
  variants: {
    size: {
      xsmall: "-space-x-0.5",
      small: "-space-x-[3px]",
      medium: "-space-x-1",
      large: "-space-x-2",
      xlarge: "-space-x-3"
    }
  },
  defaultVariants: {
    size: "medium"
  }
}), wF = {
  base: {
    xlarge: "path('M2.17987 10.9202C0 15.1984 0 20.7989 0 32V40C0 51.201 0 56.8016 2.17987 61.0798C4.09734 64.843 7.15695 67.9027 10.9202 69.8201C15.1984 72 20.7989 72 32 72H40C51.201 72 56.8016 72 61.0798 69.8201C62.1088 69.2958 63.0852 68.6861 64 68C61.5691 66.1769 59.573 63.8141 58.1799 61.0798C56 56.8016 56 51.201 56 40V32C56 20.7989 56 15.1984 58.1799 10.9202C59.573 8.18594 61.5691 5.82314 64 3.99998C63.0852 3.31386 62.1088 2.70417 61.0798 2.17987C56.8016 0 51.201 0 40 0H32C20.799 0 15.1984 0 10.9202 2.17987C7.15695 4.09734 4.09734 7.15695 2.17987 10.9202Z')",
    large: "path('M1.7439 8.73615C0 12.1587 0 16.6392 0 25.6V30.4C0 39.3608 0 43.8413 1.7439 47.2638C3.27787 50.2744 5.72556 52.7221 8.73615 54.2561C12.1587 56 16.6392 56 25.6 56H30.4C39.3608 56 43.8413 56 47.2638 54.2561C48.2389 53.7593 49.1549 53.1666 50 52.49C48.2359 51.0776 46.781 49.2994 45.7439 47.2638C44 43.8413 44 39.3608 44 30.4V25.6C44 16.6392 44 12.1587 45.7439 8.73615C46.781 6.70063 48.2359 4.92243 50 3.50999C49.1549 2.83339 48.2389 2.24072 47.2638 1.7439C43.8413 0 39.3608 0 30.4 0H25.6C16.6392 0 12.1587 0 8.73615 1.7439C5.72556 3.27787 3.27787 5.72556 1.7439 8.73615Z')",
    medium: "path('M1.08993 5.46009C0 7.59921 0 10.3995 0 16C0 21.6005 0 24.4008 1.08993 26.5399C2.04867 28.4215 3.57847 29.9513 5.46009 30.9101C7.59921 32 10.3995 32 16 32C21.6005 32 24.4008 32 26.5399 30.9101C27.4506 30.446 28.279 29.8482 29 29.1414C28.2314 28.388 27.5846 27.5108 27.0899 26.5399C26 24.4008 26 21.6005 26 16C26 10.3995 26 7.59921 27.0899 5.46009C27.5846 4.48921 28.2314 3.612 29 2.85857C28.279 2.15181 27.4506 1.55398 26.5399 1.08993C24.4008 0 21.6005 0 16 0C10.3995 0 7.59921 0 5.46009 1.08993C3.57847 2.04867 2.04867 3.57847 1.08993 5.46009Z')",
    small: "path('M0.608964 4.93853C0 6.4087 0 8.27247 0 12C0 15.7275 0 17.5913 0.608964 19.0615C1.42092 21.0217 2.97831 22.5791 4.93853 23.391C6.4087 24 8.27247 24 12 24C15.7275 24 17.5913 24 19.0615 23.391C19.9729 23.0135 20.7972 22.4749 21.5 21.8095C20.6912 21.0438 20.0434 20.1103 19.609 19.0615C19 17.5913 19 15.7275 19 12C19 8.27247 19 6.4087 19.609 4.93853C20.0434 3.88971 20.6912 2.95622 21.5 2.19052C20.7972 1.52515 19.9729 0.986481 19.0615 0.608964C17.5913 0 15.7275 0 12 0C8.27247 0 6.4087 0 4.93853 0.608964C2.97831 1.42092 1.42092 2.97831 0.608964 4.93853Z')",
    xsmall: "path('M0.653961 3.27606C0 4.55953 0 6.23969 0 9.6V11.4C0 14.7603 0 16.4405 0.653961 17.7239C1.2292 18.8529 2.14708 19.7708 3.27606 20.346C4.55953 21 6.23969 21 9.6 21H10.4C13.7603 21 15.4405 21 16.7239 20.346C17.188 20.1096 17.6164 19.8152 18 19.4721C17.4504 18.9805 16.9927 18.3889 16.654 17.7239C16 16.4405 16 14.7603 16 11.4V9.6C16 6.23969 16 4.55953 16.654 3.27606C16.9927 2.61115 17.4504 2.01946 18 1.52786C17.6164 1.18476 17.188 0.890414 16.7239 0.653961C15.4405 0 13.7603 0 10.4 0H9.6C6.23969 0 4.55953 0 3.27606 0.653961C2.14708 1.2292 1.2292 2.14708 0.653961 3.27606Z')"
  },
  rounded: {
    xlarge: "path('M64 13.3707C58.9968 19.5536 56 27.4268 56 36C56 44.5732 58.9968 52.4464 64 58.6293C57.4002 66.7853 47.3091 72 36 72C16.1177 72 0 55.8823 0 36C0 16.1177 16.1177 0 36 0C47.3091 0 57.4002 5.21466 64 13.3707Z')",
    large: "path('M50 10.6776C46.2423 15.4435 44 21.4599 44 28C44 34.5401 46.2423 40.5565 50 45.3224C44.8727 51.8253 36.9239 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C36.9239 0 44.8727 4.17468 50 10.6776Z')",
    medium: "path('M29 6.67055C27.1119 9.29683 26 12.5186 26 16C26 19.4814 27.1119 22.7032 29 25.3295C26.0958 29.3692 21.3551 32 16 32C7.16344 32 0 24.8366 0 16C0 7.16344 7.16344 0 16 0C21.3551 0 26.0958 2.63083 29 6.67055Z')",
    small: "path('M21.3746 4.50813C19.1755 1.76008 15.7933 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C15.7933 24 19.1755 22.2399 21.3746 19.4919C19.8788 17.3743 19 14.7898 19 12C19 9.21023 19.8788 6.62571 21.3746 4.50813Z')",
    xsmall: "path('M18 4.19899C16.7442 5.95406 16 8.13577 16 10.5C16 12.8642 16.7442 15.0459 18 16.801C16.1755 19.3508 13.2712 21 10 21C4.47716 21 0 16.299 0 10.5C0 4.70102 4.47716 0 10 0C13.2712 0 16.1755 1.64923 18 4.19899Z')"
  }
}, Js = ({
  avatars: t,
  size: e = "medium",
  type: n,
  noTooltip: i = !1,
  remainingCount: r,
  max: a = 3,
  layout: o = "compact"
}) => {
  if (o === "fill")
    return /* @__PURE__ */ d(
      Jm,
      {
        items: t,
        renderListItem: (f) => {
          const m = f.type === "person" ? `${f.firstName} ${f.lastName}` : f.name;
          return /* @__PURE__ */ d(Kt, { label: m, children: /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(ni, { avatar: f, size: e }) }) });
        },
        renderDropdownItem: () => null,
        forceShowingOverflowIndicator: r !== void 0,
        renderOverflowIndicator: (f) => /* @__PURE__ */ d(
          uk,
          {
            count: (r ?? 0) + f,
            size: e,
            type: n === "person" ? "rounded" : "base",
            list: r ? void 0 : t.slice(t.length - f)
          }
        ),
        overflowIndicatorWithPopover: !1,
        className: "flex-1"
      }
    );
  const s = t.slice(0, a), l = t.slice(a), c = r ?? t.length - a, u = c > 0;
  return /* @__PURE__ */ k("div", { className: bF({ size: e }), children: [
    s.map((f, m) => {
      const h = f.type === "person" ? `${f.firstName} ${f.lastName}` : f.name, p = /* @__PURE__ */ d(
        "div",
        {
          className: "flex h-fit w-fit shrink-0 items-center justify-center",
          style: m !== t.length - 1 ? {
            clipPath: wF[n === "person" ? "rounded" : "base"][e]
          } : void 0,
          children: /* @__PURE__ */ d(ni, { avatar: f, size: e })
        }
      );
      return /* @__PURE__ */ d("div", { children: i ? p : /* @__PURE__ */ d(Kt, { label: h, children: p }) }, m);
    }),
    u && /* @__PURE__ */ d(
      uk,
      {
        count: c,
        size: e,
        type: n === "person" ? "rounded" : "base",
        list: i || r ? void 0 : l
      }
    )
  ] });
};
Js.displayName = "AvatarList";
const qp = ({ date: t }) => {
  const e = Mj(t), n = _j(t);
  return /* @__PURE__ */ k("div", { className: "flex h-10 w-10 flex-col items-center justify-center rounded border border-solid border-f1-border-secondary bg-f1-background-inverse-secondary", children: [
    /* @__PURE__ */ d("div", { className: "pt-0.5 text-xs font-semibold uppercase leading-3 text-f1-special-highlight dark:text-f1-foreground-inverse-secondary", children: n }),
    /* @__PURE__ */ d("div", { className: "flex items-center justify-center text-lg font-medium leading-tight text-f1-foreground", children: e })
  ] });
}, kF = {
  sm: "w-6 h-6 rounded-sm",
  md: "w-9 h-9 rounded-md",
  lg: "w-10 h-10 rounded-lg"
}, xF = {
  sm: "xs",
  md: "sm",
  lg: "md"
}, $v = ({ emoji: t, size: e = "md" }) => (new RegExp("^\\p{Emoji}\\uFE0F?$", "u").test(t) || (t = "🤔"), /* @__PURE__ */ d(
  "div",
  {
    className: E(
      "flex aspect-square items-center justify-center border border-solid border-f1-border-secondary bg-f1-background dark:bg-f1-background-inverse-secondary",
      kF[e]
    ),
    children: /* @__PURE__ */ d(Bd, { emoji: t, size: xF[e] })
  }
));
$v.displayName = "EmojiAvatar";
const Zh = {
  pdf: {
    type: "PDF",
    color: "text-f1-foreground-accent"
  },
  image: {
    type: "IMG",
    color: "text-f1-foreground-info"
  },
  doc: {
    type: "DOC",
    color: "text-f1-foreground-info"
  },
  excel: {
    type: "XLS",
    color: "text-f1-foreground-positive"
  },
  ppt: {
    type: "PPT",
    color: "text-f1-foreground-warning"
  },
  txt: {
    type: "TXT",
    color: "text-f1-foreground-secondary"
  },
  video: {
    type: "VID",
    color: "text-f1-foreground-info"
  },
  audio: {
    type: "AUD",
    color: "text-f1-foreground-accent"
  },
  archive: {
    type: "ZIP",
    color: "text-f1-foreground-warning"
  },
  csv: {
    type: "CSV",
    color: "text-f1-foreground-positive"
  },
  html: {
    type: "HTML",
    color: "text-f1-foreground-accent"
  },
  markdown: {
    type: "MD",
    color: "text-f1-foreground-secondary"
  },
  default: {
    type: "FILE",
    color: "text-f1-foreground"
  }
}, fk = {
  pdf: "pdf",
  image: "image",
  word: "doc",
  excel: "excel",
  powerpoint: "ppt",
  text: "txt",
  video: "video",
  audio: "audio",
  archive: "archive",
  csv: "csv",
  html: "html",
  markdown: "markdown",
  zip: "archive",
  rar: "archive",
  tar: "archive",
  gz: "archive",
  "7z": "archive"
}, mk = {
  // PDF
  pdf: "pdf",
  // Images
  jpg: "image",
  jpeg: "image",
  png: "image",
  gif: "image",
  svg: "image",
  // Word documents
  doc: "doc",
  docx: "doc",
  // Excel spreadsheets
  xls: "excel",
  xlsx: "excel",
  csv: "csv",
  // PowerPoint
  ppt: "ppt",
  pptx: "ppt",
  // Plain text
  txt: "txt",
  // Video
  mp4: "video",
  mov: "video",
  mkv: "video",
  avi: "video",
  webm: "video",
  // Audio
  mp3: "audio",
  wav: "audio",
  flac: "audio",
  ogg: "audio",
  // Archives
  zip: "archive",
  rar: "archive",
  tar: "archive",
  gz: "archive",
  "7z": "archive",
  // HTML
  html: "html",
  htm: "html",
  // Markdown
  md: "markdown",
  markdown: "markdown"
}, _F = (t) => {
  const e = t.type.toLowerCase(), n = Object.keys(fk).find(
    (r) => e.includes(r)
  );
  if (n)
    return Zh[fk[n]];
  const i = t.name.toLowerCase().split(".").pop();
  return i && mk[i] ? Zh[mk[i]] : Zh.default;
}, MM = X(
  ({ file: t, className: e, ...n }, i) => {
    const { type: r, color: a } = _F(t);
    return /* @__PURE__ */ d(
      qy,
      {
        ref: i,
        className: E("bg-f1-background", e),
        ...n,
        children: /* @__PURE__ */ d(Gy, { className: E("text-xs font-semibold", a), children: r })
      }
    );
  }
);
MM.displayName = "FileAvatar";
const MF = /* @__PURE__ */ JSON.parse('[{"id":"people","emojis":["grinning","smiley","smile","grin","laughing","sweat_smile","rolling_on_the_floor_laughing","joy","slightly_smiling_face","upside_down_face","melting_face","wink","blush","innocent","smiling_face_with_3_hearts","heart_eyes","star-struck","kissing_heart","kissing","relaxed","kissing_closed_eyes","kissing_smiling_eyes","smiling_face_with_tear","yum","stuck_out_tongue","stuck_out_tongue_winking_eye","zany_face","stuck_out_tongue_closed_eyes","money_mouth_face","hugging_face","face_with_hand_over_mouth","face_with_open_eyes_and_hand_over_mouth","face_with_peeking_eye","shushing_face","thinking_face","saluting_face","zipper_mouth_face","face_with_raised_eyebrow","neutral_face","expressionless","no_mouth","dotted_line_face","face_in_clouds","smirk","unamused","face_with_rolling_eyes","grimacing","face_exhaling","lying_face","relieved","pensive","sleepy","drooling_face","sleeping","mask","face_with_thermometer","face_with_head_bandage","nauseated_face","face_vomiting","sneezing_face","hot_face","cold_face","woozy_face","dizzy_face","face_with_spiral_eyes","exploding_head","face_with_cowboy_hat","partying_face","disguised_face","sunglasses","nerd_face","face_with_monocle","confused","face_with_diagonal_mouth","worried","slightly_frowning_face","white_frowning_face","open_mouth","hushed","astonished","flushed","pleading_face","face_holding_back_tears","frowning","anguished","fearful","cold_sweat","disappointed_relieved","cry","sob","scream","confounded","persevere","disappointed","sweat","weary","tired_face","yawning_face","triumph","rage","angry","face_with_symbols_on_mouth","smiling_imp","imp","skull","skull_and_crossbones","hankey","clown_face","japanese_ogre","japanese_goblin","ghost","alien","space_invader","robot_face","wave","raised_back_of_hand","raised_hand_with_fingers_splayed","hand","spock-hand","rightwards_hand","leftwards_hand","palm_down_hand","palm_up_hand","ok_hand","pinched_fingers","pinching_hand","v","crossed_fingers","hand_with_index_finger_and_thumb_crossed","i_love_you_hand_sign","the_horns","call_me_hand","point_left","point_right","point_up_2","middle_finger","point_down","point_up","index_pointing_at_the_viewer","+1","-1","fist","facepunch","left-facing_fist","right-facing_fist","clap","raised_hands","heart_hands","open_hands","palms_up_together","handshake","pray","writing_hand","nail_care","selfie","muscle","mechanical_arm","mechanical_leg","leg","foot","ear","ear_with_hearing_aid","nose","brain","anatomical_heart","lungs","tooth","bone","eyes","eye","tongue","lips","biting_lip","baby","child","boy","girl","adult","person_with_blond_hair","man","bearded_person","man_with_beard","woman_with_beard","red_haired_man","curly_haired_man","white_haired_man","bald_man","woman","red_haired_woman","red_haired_person","curly_haired_woman","curly_haired_person","white_haired_woman","white_haired_person","bald_woman","bald_person","blond-haired-woman","blond-haired-man","older_adult","older_man","older_woman","person_frowning","man-frowning","woman-frowning","person_with_pouting_face","man-pouting","woman-pouting","no_good","man-gesturing-no","woman-gesturing-no","ok_woman","man-gesturing-ok","woman-gesturing-ok","information_desk_person","man-tipping-hand","woman-tipping-hand","raising_hand","man-raising-hand","woman-raising-hand","deaf_person","deaf_man","deaf_woman","bow","man-bowing","woman-bowing","face_palm","man-facepalming","woman-facepalming","shrug","man-shrugging","woman-shrugging","health_worker","male-doctor","female-doctor","student","male-student","female-student","teacher","male-teacher","female-teacher","judge","male-judge","female-judge","farmer","male-farmer","female-farmer","cook","male-cook","female-cook","mechanic","male-mechanic","female-mechanic","factory_worker","male-factory-worker","female-factory-worker","office_worker","male-office-worker","female-office-worker","scientist","male-scientist","female-scientist","technologist","male-technologist","female-technologist","singer","male-singer","female-singer","artist","male-artist","female-artist","pilot","male-pilot","female-pilot","astronaut","male-astronaut","female-astronaut","firefighter","male-firefighter","female-firefighter","cop","male-police-officer","female-police-officer","sleuth_or_spy","male-detective","female-detective","guardsman","male-guard","female-guard","ninja","construction_worker","male-construction-worker","female-construction-worker","person_with_crown","prince","princess","man_with_turban","man-wearing-turban","woman-wearing-turban","man_with_gua_pi_mao","person_with_headscarf","person_in_tuxedo","man_in_tuxedo","woman_in_tuxedo","bride_with_veil","man_with_veil","woman_with_veil","pregnant_woman","pregnant_man","pregnant_person","breast-feeding","woman_feeding_baby","man_feeding_baby","person_feeding_baby","angel","santa","mrs_claus","mx_claus","superhero","male_superhero","female_superhero","supervillain","male_supervillain","female_supervillain","mage","male_mage","female_mage","fairy","male_fairy","female_fairy","vampire","male_vampire","female_vampire","merperson","merman","mermaid","elf","male_elf","female_elf","genie","male_genie","female_genie","zombie","male_zombie","female_zombie","troll","massage","man-getting-massage","woman-getting-massage","haircut","man-getting-haircut","woman-getting-haircut","walking","man-walking","woman-walking","standing_person","man_standing","woman_standing","kneeling_person","man_kneeling","woman_kneeling","person_with_probing_cane","man_with_probing_cane","woman_with_probing_cane","person_in_motorized_wheelchair","man_in_motorized_wheelchair","woman_in_motorized_wheelchair","person_in_manual_wheelchair","man_in_manual_wheelchair","woman_in_manual_wheelchair","runner","man-running","woman-running","dancer","man_dancing","man_in_business_suit_levitating","dancers","men-with-bunny-ears-partying","women-with-bunny-ears-partying","person_in_steamy_room","man_in_steamy_room","woman_in_steamy_room","person_climbing","man_climbing","woman_climbing","fencer","horse_racing","skier","snowboarder","golfer","man-golfing","woman-golfing","surfer","man-surfing","woman-surfing","rowboat","man-rowing-boat","woman-rowing-boat","swimmer","man-swimming","woman-swimming","person_with_ball","man-bouncing-ball","woman-bouncing-ball","weight_lifter","man-lifting-weights","woman-lifting-weights","bicyclist","man-biking","woman-biking","mountain_bicyclist","man-mountain-biking","woman-mountain-biking","person_doing_cartwheel","man-cartwheeling","woman-cartwheeling","wrestlers","man-wrestling","woman-wrestling","water_polo","man-playing-water-polo","woman-playing-water-polo","handball","man-playing-handball","woman-playing-handball","juggling","man-juggling","woman-juggling","person_in_lotus_position","man_in_lotus_position","woman_in_lotus_position","bath","sleeping_accommodation","people_holding_hands","two_women_holding_hands","man_and_woman_holding_hands","two_men_holding_hands","couplekiss","woman-kiss-man","man-kiss-man","woman-kiss-woman","couple_with_heart","woman-heart-man","man-heart-man","woman-heart-woman","family","man-woman-boy","man-woman-girl","man-woman-girl-boy","man-woman-boy-boy","man-woman-girl-girl","man-man-boy","man-man-girl","man-man-girl-boy","man-man-boy-boy","man-man-girl-girl","woman-woman-boy","woman-woman-girl","woman-woman-girl-boy","woman-woman-boy-boy","woman-woman-girl-girl","man-boy","man-boy-boy","man-girl","man-girl-boy","man-girl-girl","woman-boy","woman-boy-boy","woman-girl","woman-girl-boy","woman-girl-girl","speaking_head_in_silhouette","bust_in_silhouette","busts_in_silhouette","people_hugging","footprints","smiley_cat","smile_cat","joy_cat","heart_eyes_cat","smirk_cat","kissing_cat","scream_cat","crying_cat_face","pouting_cat","see_no_evil","hear_no_evil","speak_no_evil","love_letter","cupid","gift_heart","sparkling_heart","heartpulse","heartbeat","revolving_hearts","two_hearts","heart_decoration","heavy_heart_exclamation_mark_ornament","broken_heart","heart_on_fire","mending_heart","heart","orange_heart","yellow_heart","green_heart","blue_heart","purple_heart","brown_heart","black_heart","white_heart","kiss","100","anger","boom","dizzy","sweat_drops","dash","hole","speech_balloon","eye-in-speech-bubble","left_speech_bubble","right_anger_bubble","thought_balloon","zzz"]},{"id":"nature","emojis":["monkey_face","monkey","gorilla","orangutan","dog","dog2","guide_dog","service_dog","poodle","wolf","fox_face","raccoon","cat","cat2","black_cat","lion_face","tiger","tiger2","leopard","horse","racehorse","unicorn_face","zebra_face","deer","bison","cow","ox","water_buffalo","cow2","pig","pig2","boar","pig_nose","ram","sheep","goat","dromedary_camel","camel","llama","giraffe_face","elephant","mammoth","rhinoceros","hippopotamus","mouse","mouse2","rat","hamster","rabbit","rabbit2","chipmunk","beaver","hedgehog","bat","bear","polar_bear","koala","panda_face","sloth","otter","skunk","kangaroo","badger","feet","turkey","chicken","rooster","hatching_chick","baby_chick","hatched_chick","bird","penguin","dove_of_peace","eagle","duck","swan","owl","dodo","feather","flamingo","peacock","parrot","frog","crocodile","turtle","lizard","snake","dragon_face","dragon","sauropod","t-rex","whale","whale2","dolphin","seal","fish","tropical_fish","blowfish","shark","octopus","shell","coral","snail","butterfly","bug","ant","bee","beetle","ladybug","cricket","cockroach","spider","spider_web","scorpion","mosquito","fly","worm","microbe","bouquet","cherry_blossom","white_flower","lotus","rosette","rose","wilted_flower","hibiscus","sunflower","blossom","tulip","seedling","potted_plant","evergreen_tree","deciduous_tree","palm_tree","cactus","ear_of_rice","herb","shamrock","four_leaf_clover","maple_leaf","fallen_leaf","leaves","empty_nest","nest_with_eggs","mushroom"]},{"id":"foods","emojis":["grapes","melon","watermelon","tangerine","lemon","banana","pineapple","mango","apple","green_apple","pear","peach","cherries","strawberry","blueberries","kiwifruit","tomato","olive","coconut","avocado","eggplant","potato","carrot","corn","hot_pepper","bell_pepper","cucumber","leafy_green","broccoli","garlic","onion","peanuts","beans","chestnut","bread","croissant","baguette_bread","flatbread","pretzel","bagel","pancakes","waffle","cheese_wedge","meat_on_bone","poultry_leg","cut_of_meat","bacon","hamburger","fries","pizza","hotdog","sandwich","taco","burrito","tamale","stuffed_flatbread","falafel","egg","fried_egg","shallow_pan_of_food","stew","fondue","bowl_with_spoon","green_salad","popcorn","butter","salt","canned_food","bento","rice_cracker","rice_ball","rice","curry","ramen","spaghetti","sweet_potato","oden","sushi","fried_shrimp","fish_cake","moon_cake","dango","dumpling","fortune_cookie","takeout_box","crab","lobster","shrimp","squid","oyster","icecream","shaved_ice","ice_cream","doughnut","cookie","birthday","cake","cupcake","pie","chocolate_bar","candy","lollipop","custard","honey_pot","baby_bottle","glass_of_milk","coffee","teapot","tea","sake","champagne","wine_glass","cocktail","tropical_drink","beer","beers","clinking_glasses","tumbler_glass","pouring_liquid","cup_with_straw","bubble_tea","beverage_box","mate_drink","ice_cube","chopsticks","knife_fork_plate","fork_and_knife","spoon","hocho","jar","amphora"]},{"id":"activity","emojis":["jack_o_lantern","christmas_tree","fireworks","sparkler","firecracker","sparkles","balloon","tada","confetti_ball","tanabata_tree","bamboo","dolls","flags","wind_chime","rice_scene","red_envelope","ribbon","gift","reminder_ribbon","admission_tickets","ticket","medal","trophy","sports_medal","first_place_medal","second_place_medal","third_place_medal","soccer","baseball","softball","basketball","volleyball","football","rugby_football","tennis","flying_disc","bowling","cricket_bat_and_ball","field_hockey_stick_and_ball","ice_hockey_stick_and_puck","lacrosse","table_tennis_paddle_and_ball","badminton_racquet_and_shuttlecock","boxing_glove","martial_arts_uniform","goal_net","golf","ice_skate","fishing_pole_and_fish","diving_mask","running_shirt_with_sash","ski","sled","curling_stone","dart","yo-yo","kite","gun","8ball","crystal_ball","magic_wand","video_game","joystick","slot_machine","game_die","jigsaw","teddy_bear","pinata","mirror_ball","nesting_dolls","spades","hearts","diamonds","clubs","chess_pawn","black_joker","mahjong","flower_playing_cards","performing_arts","frame_with_picture","art","thread","sewing_needle","yarn","knot"]},{"id":"places","emojis":["earth_africa","earth_americas","earth_asia","globe_with_meridians","world_map","japan","compass","snow_capped_mountain","mountain","volcano","mount_fuji","camping","beach_with_umbrella","desert","desert_island","national_park","stadium","classical_building","building_construction","bricks","rock","wood","hut","house_buildings","derelict_house_building","house","house_with_garden","office","post_office","european_post_office","hospital","bank","hotel","love_hotel","convenience_store","school","department_store","factory","japanese_castle","european_castle","wedding","tokyo_tower","statue_of_liberty","church","mosque","hindu_temple","synagogue","shinto_shrine","kaaba","fountain","tent","foggy","night_with_stars","cityscape","sunrise_over_mountains","sunrise","city_sunset","city_sunrise","bridge_at_night","hotsprings","carousel_horse","playground_slide","ferris_wheel","roller_coaster","barber","circus_tent","steam_locomotive","railway_car","bullettrain_side","bullettrain_front","train2","metro","light_rail","station","tram","monorail","mountain_railway","train","bus","oncoming_bus","trolleybus","minibus","ambulance","fire_engine","police_car","oncoming_police_car","taxi","oncoming_taxi","car","oncoming_automobile","blue_car","pickup_truck","truck","articulated_lorry","tractor","racing_car","racing_motorcycle","motor_scooter","manual_wheelchair","motorized_wheelchair","auto_rickshaw","bike","scooter","skateboard","roller_skate","busstop","motorway","railway_track","oil_drum","fuelpump","wheel","rotating_light","traffic_light","vertical_traffic_light","octagonal_sign","construction","anchor","ring_buoy","boat","canoe","speedboat","passenger_ship","ferry","motor_boat","ship","airplane","small_airplane","airplane_departure","airplane_arriving","parachute","seat","helicopter","suspension_railway","mountain_cableway","aerial_tramway","satellite","rocket","flying_saucer","bellhop_bell","luggage","hourglass","hourglass_flowing_sand","watch","alarm_clock","stopwatch","timer_clock","mantelpiece_clock","clock12","clock1230","clock1","clock130","clock2","clock230","clock3","clock330","clock4","clock430","clock5","clock530","clock6","clock630","clock7","clock730","clock8","clock830","clock9","clock930","clock10","clock1030","clock11","clock1130","new_moon","waxing_crescent_moon","first_quarter_moon","moon","full_moon","waning_gibbous_moon","last_quarter_moon","waning_crescent_moon","crescent_moon","new_moon_with_face","first_quarter_moon_with_face","last_quarter_moon_with_face","thermometer","sunny","full_moon_with_face","sun_with_face","ringed_planet","star","star2","stars","milky_way","cloud","partly_sunny","thunder_cloud_and_rain","mostly_sunny","barely_sunny","partly_sunny_rain","rain_cloud","snow_cloud","lightning","tornado","fog","wind_blowing_face","cyclone","rainbow","closed_umbrella","umbrella","umbrella_with_rain_drops","umbrella_on_ground","zap","snowflake","snowman","snowman_without_snow","comet","fire","droplet","ocean"]},{"id":"objects","emojis":["eyeglasses","dark_sunglasses","goggles","lab_coat","safety_vest","necktie","shirt","jeans","scarf","gloves","coat","socks","dress","kimono","sari","one-piece_swimsuit","briefs","shorts","bikini","womans_clothes","purse","handbag","pouch","shopping_bags","school_satchel","thong_sandal","mans_shoe","athletic_shoe","hiking_boot","womans_flat_shoe","high_heel","sandal","ballet_shoes","boot","crown","womans_hat","tophat","mortar_board","billed_cap","military_helmet","helmet_with_white_cross","prayer_beads","lipstick","ring","gem","mute","speaker","sound","loud_sound","loudspeaker","mega","postal_horn","bell","no_bell","musical_score","musical_note","notes","studio_microphone","level_slider","control_knobs","microphone","headphones","radio","saxophone","accordion","guitar","musical_keyboard","trumpet","violin","banjo","drum_with_drumsticks","long_drum","iphone","calling","phone","telephone_receiver","pager","fax","battery","low_battery","electric_plug","computer","desktop_computer","printer","keyboard","three_button_mouse","trackball","minidisc","floppy_disk","cd","dvd","abacus","movie_camera","film_frames","film_projector","clapper","tv","camera","camera_with_flash","video_camera","vhs","mag","mag_right","candle","bulb","flashlight","izakaya_lantern","diya_lamp","notebook_with_decorative_cover","closed_book","book","green_book","blue_book","orange_book","books","notebook","ledger","page_with_curl","scroll","page_facing_up","newspaper","rolled_up_newspaper","bookmark_tabs","bookmark","label","moneybag","coin","yen","dollar","euro","pound","money_with_wings","credit_card","receipt","chart","email","e-mail","incoming_envelope","envelope_with_arrow","outbox_tray","inbox_tray","package","mailbox","mailbox_closed","mailbox_with_mail","mailbox_with_no_mail","postbox","ballot_box_with_ballot","pencil2","black_nib","lower_left_fountain_pen","lower_left_ballpoint_pen","lower_left_paintbrush","lower_left_crayon","memo","briefcase","file_folder","open_file_folder","card_index_dividers","date","calendar","spiral_note_pad","spiral_calendar_pad","card_index","chart_with_upwards_trend","chart_with_downwards_trend","bar_chart","clipboard","pushpin","round_pushpin","paperclip","linked_paperclips","straight_ruler","triangular_ruler","scissors","card_file_box","file_cabinet","wastebasket","lock","unlock","lock_with_ink_pen","closed_lock_with_key","key","old_key","hammer","axe","pick","hammer_and_pick","hammer_and_wrench","dagger_knife","crossed_swords","bomb","boomerang","bow_and_arrow","shield","carpentry_saw","wrench","screwdriver","nut_and_bolt","gear","compression","scales","probing_cane","link","chains","hook","toolbox","magnet","ladder","alembic","test_tube","petri_dish","dna","microscope","telescope","satellite_antenna","syringe","drop_of_blood","pill","adhesive_bandage","crutch","stethoscope","x-ray","door","elevator","mirror","window","bed","couch_and_lamp","chair","toilet","plunger","shower","bathtub","mouse_trap","razor","lotion_bottle","safety_pin","broom","basket","roll_of_paper","bucket","soap","bubbles","toothbrush","sponge","fire_extinguisher","shopping_trolley","smoking","coffin","headstone","funeral_urn","nazar_amulet","hamsa","moyai","placard","identification_card"]},{"id":"symbols","emojis":["atm","put_litter_in_its_place","potable_water","wheelchair","mens","womens","restroom","baby_symbol","wc","passport_control","customs","baggage_claim","left_luggage","warning","children_crossing","no_entry","no_entry_sign","no_bicycles","no_smoking","do_not_litter","non-potable_water","no_pedestrians","no_mobile_phones","underage","radioactive_sign","biohazard_sign","arrow_up","arrow_upper_right","arrow_right","arrow_lower_right","arrow_down","arrow_lower_left","arrow_left","arrow_upper_left","arrow_up_down","left_right_arrow","leftwards_arrow_with_hook","arrow_right_hook","arrow_heading_up","arrow_heading_down","arrows_clockwise","arrows_counterclockwise","back","end","on","soon","top","place_of_worship","atom_symbol","om_symbol","star_of_david","wheel_of_dharma","yin_yang","latin_cross","orthodox_cross","star_and_crescent","peace_symbol","menorah_with_nine_branches","six_pointed_star","aries","taurus","gemini","cancer","leo","virgo","libra","scorpius","sagittarius","capricorn","aquarius","pisces","ophiuchus","twisted_rightwards_arrows","repeat","repeat_one","arrow_forward","fast_forward","black_right_pointing_double_triangle_with_vertical_bar","black_right_pointing_triangle_with_double_vertical_bar","arrow_backward","rewind","black_left_pointing_double_triangle_with_vertical_bar","arrow_up_small","arrow_double_up","arrow_down_small","arrow_double_down","double_vertical_bar","black_square_for_stop","black_circle_for_record","eject","cinema","low_brightness","high_brightness","signal_strength","vibration_mode","mobile_phone_off","female_sign","male_sign","transgender_symbol","heavy_multiplication_x","heavy_plus_sign","heavy_minus_sign","heavy_division_sign","heavy_equals_sign","infinity","bangbang","interrobang","question","grey_question","grey_exclamation","exclamation","wavy_dash","currency_exchange","heavy_dollar_sign","medical_symbol","recycle","fleur_de_lis","trident","name_badge","beginner","o","white_check_mark","ballot_box_with_check","heavy_check_mark","x","negative_squared_cross_mark","curly_loop","loop","part_alternation_mark","eight_spoked_asterisk","eight_pointed_black_star","sparkle","copyright","registered","tm","hash","keycap_star","zero","one","two","three","four","five","six","seven","eight","nine","keycap_ten","capital_abcd","abcd","1234","symbols","abc","a","ab","b","cl","cool","free","information_source","id","m","new","ng","o2","ok","parking","sos","up","vs","koko","sa","u6708","u6709","u6307","ideograph_advantage","u5272","u7121","u7981","accept","u7533","u5408","u7a7a","congratulations","secret","u55b6","u6e80","red_circle","large_orange_circle","large_yellow_circle","large_green_circle","large_blue_circle","large_purple_circle","large_brown_circle","black_circle","white_circle","large_red_square","large_orange_square","large_yellow_square","large_green_square","large_blue_square","large_purple_square","large_brown_square","black_large_square","white_large_square","black_medium_square","white_medium_square","black_medium_small_square","white_medium_small_square","black_small_square","white_small_square","large_orange_diamond","large_blue_diamond","small_orange_diamond","small_blue_diamond","small_red_triangle","small_red_triangle_down","diamond_shape_with_a_dot_inside","radio_button","white_square_button","black_square_button"]},{"id":"flags","emojis":["checkered_flag","cn","crossed_flags","de","es","flag-ac","flag-ad","flag-ae","flag-af","flag-ag","flag-ai","flag-al","flag-am","flag-ao","flag-aq","flag-ar","flag-as","flag-at","flag-au","flag-aw","flag-ax","flag-az","flag-ba","flag-bb","flag-bd","flag-be","flag-bf","flag-bg","flag-bh","flag-bi","flag-bj","flag-bl","flag-bm","flag-bn","flag-bo","flag-bq","flag-br","flag-bs","flag-bt","flag-bv","flag-bw","flag-by","flag-bz","flag-ca","flag-cc","flag-cd","flag-cf","flag-cg","flag-ch","flag-ci","flag-ck","flag-cl","flag-cm","flag-co","flag-cp","flag-cr","flag-cu","flag-cv","flag-cw","flag-cx","flag-cy","flag-cz","flag-dg","flag-dj","flag-dk","flag-dm","flag-do","flag-dz","flag-ea","flag-ec","flag-ee","flag-eg","flag-eh","flag-england","flag-er","flag-et","flag-eu","flag-fi","flag-fj","flag-fk","flag-fm","flag-fo","flag-ga","flag-gd","flag-ge","flag-gf","flag-gg","flag-gh","flag-gi","flag-gl","flag-gm","flag-gn","flag-gp","flag-gq","flag-gr","flag-gs","flag-gt","flag-gu","flag-gw","flag-gy","flag-hk","flag-hm","flag-hn","flag-hr","flag-ht","flag-hu","flag-ic","flag-id","flag-ie","flag-il","flag-im","flag-in","flag-io","flag-iq","flag-ir","flag-is","flag-je","flag-jm","flag-jo","flag-ke","flag-kg","flag-kh","flag-ki","flag-km","flag-kn","flag-kp","flag-kw","flag-ky","flag-kz","flag-la","flag-lb","flag-lc","flag-li","flag-lk","flag-lr","flag-ls","flag-lt","flag-lu","flag-lv","flag-ly","flag-ma","flag-mc","flag-md","flag-me","flag-mf","flag-mg","flag-mh","flag-mk","flag-ml","flag-mm","flag-mn","flag-mo","flag-mp","flag-mq","flag-mr","flag-ms","flag-mt","flag-mu","flag-mv","flag-mw","flag-mx","flag-my","flag-mz","flag-na","flag-nc","flag-ne","flag-nf","flag-ng","flag-ni","flag-nl","flag-no","flag-np","flag-nr","flag-nu","flag-nz","flag-om","flag-pa","flag-pe","flag-pf","flag-pg","flag-ph","flag-pk","flag-pl","flag-pm","flag-pn","flag-pr","flag-ps","flag-pt","flag-pw","flag-py","flag-qa","flag-re","flag-ro","flag-rs","flag-rw","flag-sa","flag-sb","flag-sc","flag-scotland","flag-sd","flag-se","flag-sg","flag-sh","flag-si","flag-sj","flag-sk","flag-sl","flag-sm","flag-sn","flag-so","flag-sr","flag-ss","flag-st","flag-sv","flag-sx","flag-sy","flag-sz","flag-ta","flag-tc","flag-td","flag-tf","flag-tg","flag-th","flag-tj","flag-tk","flag-tl","flag-tm","flag-tn","flag-to","flag-tr","flag-tt","flag-tv","flag-tw","flag-tz","flag-ua","flag-ug","flag-um","flag-un","flag-uy","flag-uz","flag-va","flag-vc","flag-ve","flag-vg","flag-vi","flag-vn","flag-vu","flag-wales","flag-wf","flag-ws","flag-xk","flag-ye","flag-yt","flag-za","flag-zm","flag-zw","fr","gb","it","jp","kr","pirate_flag","rainbow-flag","ru","transgender_flag","triangular_flag_on_post","us","waving_black_flag","waving_white_flag"]}]'), CF = /* @__PURE__ */ JSON.parse(`{"100":{"id":"100","name":"Hundred Points","keywords":["100","score","perfect","numbers","century","exam","quiz","test","pass"],"skins":[{"unified":"1f4af","native":"💯","x":28,"y":7}],"version":1},"1234":{"id":"1234","name":"Input Numbers","keywords":["1234","blue","square","1","2","3","4"],"skins":[{"unified":"1f522","native":"🔢","x":29,"y":60}],"version":1},"grinning":{"id":"grinning","name":"Grinning Face","emoticons":[":D"],"keywords":["smile","happy","joy",":D","grin"],"skins":[{"unified":"1f600","native":"😀","x":32,"y":21}],"version":1},"smiley":{"id":"smiley","name":"Grinning Face with Big Eyes","emoticons":[":)","=)","=-)"],"keywords":["smiley","happy","joy","haha",":D",":)","smile","funny"],"skins":[{"unified":"1f603","native":"😃","x":32,"y":24}],"version":1},"smile":{"id":"smile","name":"Grinning Face with Smiling Eyes","emoticons":[":)","C:","c:",":D",":-D"],"keywords":["smile","happy","joy","funny","haha","laugh","like",":D",":)"],"skins":[{"unified":"1f604","native":"😄","x":32,"y":25}],"version":1},"grin":{"id":"grin","name":"Beaming Face with Smiling Eyes","keywords":["grin","happy","smile","joy","kawaii"],"skins":[{"unified":"1f601","native":"😁","x":32,"y":22}],"version":1},"laughing":{"id":"laughing","name":"Grinning Squinting Face","emoticons":[":>",":->"],"keywords":["laughing","satisfied","happy","joy","lol","haha","glad","XD","laugh"],"skins":[{"unified":"1f606","native":"😆","x":32,"y":27}],"version":1},"sweat_smile":{"id":"sweat_smile","name":"Grinning Face with Sweat","keywords":["smile","hot","happy","laugh","relief"],"skins":[{"unified":"1f605","native":"😅","x":32,"y":26}],"version":1},"rolling_on_the_floor_laughing":{"id":"rolling_on_the_floor_laughing","name":"Rolling on the Floor Laughing","keywords":["face","lol","haha","rofl"],"skins":[{"unified":"1f923","native":"🤣","x":40,"y":17}],"version":3},"joy":{"id":"joy","name":"Face with Tears of Joy","keywords":["cry","weep","happy","happytears","haha"],"skins":[{"unified":"1f602","native":"😂","x":32,"y":23}],"version":1},"slightly_smiling_face":{"id":"slightly_smiling_face","name":"Slightly Smiling Face","emoticons":[":)","(:",":-)"],"keywords":["smile"],"skins":[{"unified":"1f642","native":"🙂","x":33,"y":29}],"version":1},"upside_down_face":{"id":"upside_down_face","name":"Upside-Down Face","keywords":["upside","down","flipped","silly","smile"],"skins":[{"unified":"1f643","native":"🙃","x":33,"y":30}],"version":1},"melting_face":{"id":"melting_face","name":"Melting Face","keywords":["hot","heat"],"skins":[{"unified":"1fae0","native":"🫠","x":55,"y":30}],"version":14},"wink":{"id":"wink","name":"Winking Face","emoticons":[";)",";-)"],"keywords":["wink","happy","mischievous","secret",";)","smile","eye"],"skins":[{"unified":"1f609","native":"😉","x":32,"y":30}],"version":1},"blush":{"id":"blush","name":"Smiling Face with Smiling Eyes","emoticons":[":)"],"keywords":["blush","smile","happy","flushed","crush","embarrassed","shy","joy"],"skins":[{"unified":"1f60a","native":"😊","x":32,"y":31}],"version":1},"innocent":{"id":"innocent","name":"Smiling Face with Halo","keywords":["innocent","angel","heaven"],"skins":[{"unified":"1f607","native":"😇","x":32,"y":28}],"version":1},"smiling_face_with_3_hearts":{"id":"smiling_face_with_3_hearts","name":"Smiling Face with Hearts","keywords":["3","love","like","affection","valentines","infatuation","crush","adore"],"skins":[{"unified":"1f970","native":"🥰","x":43,"y":60}],"version":11},"heart_eyes":{"id":"heart_eyes","name":"Smiling Face with Heart-Eyes","keywords":["heart","eyes","love","like","affection","valentines","infatuation","crush"],"skins":[{"unified":"1f60d","native":"😍","x":32,"y":34}],"version":1},"star-struck":{"id":"star-struck","name":"Star-Struck","keywords":["star","struck","grinning","face","with","eyes","smile","starry"],"skins":[{"unified":"1f929","native":"🤩","x":40,"y":40}],"version":5},"kissing_heart":{"id":"kissing_heart","name":"Face Blowing a Kiss","emoticons":[":*",":-*"],"keywords":["kissing","heart","love","like","affection","valentines","infatuation"],"skins":[{"unified":"1f618","native":"😘","x":32,"y":45}],"version":1},"kissing":{"id":"kissing","name":"Kissing Face","keywords":["love","like","3","valentines","infatuation","kiss"],"skins":[{"unified":"1f617","native":"😗","x":32,"y":44}],"version":1},"relaxed":{"id":"relaxed","name":"Smiling Face","keywords":["relaxed","blush","massage","happiness"],"skins":[{"unified":"263a-fe0f","native":"☺️","x":57,"y":35}],"version":1},"kissing_closed_eyes":{"id":"kissing_closed_eyes","name":"Kissing Face with Closed Eyes","keywords":["love","like","affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f61a","native":"😚","x":32,"y":47}],"version":1},"kissing_smiling_eyes":{"id":"kissing_smiling_eyes","name":"Kissing Face with Smiling Eyes","keywords":["affection","valentines","infatuation","kiss"],"skins":[{"unified":"1f619","native":"😙","x":32,"y":46}],"version":1},"smiling_face_with_tear":{"id":"smiling_face_with_tear","name":"Smiling Face with Tear","keywords":["sad","cry","pretend"],"skins":[{"unified":"1f972","native":"🥲","x":44,"y":1}],"version":13},"yum":{"id":"yum","name":"Face Savoring Food","keywords":["yum","happy","joy","tongue","smile","silly","yummy","nom","delicious","savouring"],"skins":[{"unified":"1f60b","native":"😋","x":32,"y":32}],"version":1},"stuck_out_tongue":{"id":"stuck_out_tongue","name":"Face with Tongue","emoticons":[":p",":-p",":P",":-P",":b",":-b"],"keywords":["stuck","out","prank","childish","playful","mischievous","smile"],"skins":[{"unified":"1f61b","native":"😛","x":32,"y":48}],"version":1},"stuck_out_tongue_winking_eye":{"id":"stuck_out_tongue_winking_eye","name":"Winking Face with Tongue","emoticons":[";p",";-p",";b",";-b",";P",";-P"],"keywords":["stuck","out","eye","prank","childish","playful","mischievous","smile","wink"],"skins":[{"unified":"1f61c","native":"😜","x":32,"y":49}],"version":1},"zany_face":{"id":"zany_face","name":"Zany Face","keywords":["grinning","with","one","large","and","small","eye","goofy","crazy"],"skins":[{"unified":"1f92a","native":"🤪","x":40,"y":41}],"version":5},"stuck_out_tongue_closed_eyes":{"id":"stuck_out_tongue_closed_eyes","name":"Squinting Face with Tongue","keywords":["stuck","out","closed","eyes","prank","playful","mischievous","smile"],"skins":[{"unified":"1f61d","native":"😝","x":32,"y":50}],"version":1},"money_mouth_face":{"id":"money_mouth_face","name":"Money-Mouth Face","keywords":["money","mouth","rich","dollar"],"skins":[{"unified":"1f911","native":"🤑","x":39,"y":0}],"version":1},"hugging_face":{"id":"hugging_face","name":"Hugging Face","keywords":["smile","hug"],"skins":[{"unified":"1f917","native":"🤗","x":39,"y":6}],"version":1},"face_with_hand_over_mouth":{"id":"face_with_hand_over_mouth","name":"Face with Hand over Mouth","keywords":["smiling","eyes","and","covering","whoops","shock","surprise"],"skins":[{"unified":"1f92d","native":"🤭","x":40,"y":44}],"version":5},"face_with_open_eyes_and_hand_over_mouth":{"id":"face_with_open_eyes_and_hand_over_mouth","name":"Face with Open Eyes and Hand over Mouth","keywords":["silence","secret","shock","surprise"],"skins":[{"unified":"1fae2","native":"🫢","x":55,"y":32}],"version":14},"face_with_peeking_eye":{"id":"face_with_peeking_eye","name":"Face with Peeking Eye","keywords":["scared","frightening","embarrassing","shy"],"skins":[{"unified":"1fae3","native":"🫣","x":55,"y":33}],"version":14},"shushing_face":{"id":"shushing_face","name":"Shushing Face","keywords":["with","finger","covering","closed","lips","quiet","shhh"],"skins":[{"unified":"1f92b","native":"🤫","x":40,"y":42}],"version":5},"thinking_face":{"id":"thinking_face","name":"Thinking Face","keywords":["hmmm","think","consider"],"skins":[{"unified":"1f914","native":"🤔","x":39,"y":3}],"version":1},"saluting_face":{"id":"saluting_face","name":"Saluting Face","keywords":["respect","salute"],"skins":[{"unified":"1fae1","native":"🫡","x":55,"y":31}],"version":14},"zipper_mouth_face":{"id":"zipper_mouth_face","name":"Zipper-Mouth Face","keywords":["zipper","mouth","sealed","secret"],"skins":[{"unified":"1f910","native":"🤐","x":38,"y":60}],"version":1},"face_with_raised_eyebrow":{"id":"face_with_raised_eyebrow","name":"Face with Raised Eyebrow","keywords":["one","distrust","scepticism","disapproval","disbelief","surprise"],"skins":[{"unified":"1f928","native":"🤨","x":40,"y":39}],"version":5},"neutral_face":{"id":"neutral_face","name":"Neutral Face","emoticons":[":|",":-|"],"keywords":["indifference","meh",":",""],"skins":[{"unified":"1f610","native":"😐","x":32,"y":37}],"version":1},"expressionless":{"id":"expressionless","name":"Expressionless Face","emoticons":["-_-"],"keywords":["indifferent","-","","meh","deadpan"],"skins":[{"unified":"1f611","native":"😑","x":32,"y":38}],"version":1},"no_mouth":{"id":"no_mouth","name":"Face Without Mouth","keywords":["no","hellokitty"],"skins":[{"unified":"1f636","native":"😶","x":33,"y":17}],"version":1},"dotted_line_face":{"id":"dotted_line_face","name":"Dotted Line Face","keywords":["invisible","lonely","isolation","depression"],"skins":[{"unified":"1fae5","native":"🫥","x":55,"y":35}],"version":14},"face_in_clouds":{"id":"face_in_clouds","name":"Face in Clouds","keywords":["shower","steam","dream"],"skins":[{"unified":"1f636-200d-1f32b-fe0f","native":"😶‍🌫️","x":33,"y":16}],"version":13.1},"smirk":{"id":"smirk","name":"Smirking Face","keywords":["smirk","smile","mean","prank","smug","sarcasm"],"skins":[{"unified":"1f60f","native":"😏","x":32,"y":36}],"version":1},"unamused":{"id":"unamused","name":"Unamused Face","emoticons":[":("],"keywords":["indifference","bored","straight","serious","sarcasm","unimpressed","skeptical","dubious","side","eye"],"skins":[{"unified":"1f612","native":"😒","x":32,"y":39}],"version":1},"face_with_rolling_eyes":{"id":"face_with_rolling_eyes","name":"Face with Rolling Eyes","keywords":["eyeroll","frustrated"],"skins":[{"unified":"1f644","native":"🙄","x":33,"y":31}],"version":1},"grimacing":{"id":"grimacing","name":"Grimacing Face","keywords":["grimace","teeth"],"skins":[{"unified":"1f62c","native":"😬","x":33,"y":4}],"version":1},"face_exhaling":{"id":"face_exhaling","name":"Face Exhaling","keywords":["relieve","relief","tired","sigh"],"skins":[{"unified":"1f62e-200d-1f4a8","native":"😮‍💨","x":33,"y":6}],"version":13.1},"lying_face":{"id":"lying_face","name":"Lying Face","keywords":["lie","pinocchio"],"skins":[{"unified":"1f925","native":"🤥","x":40,"y":19}],"version":3},"relieved":{"id":"relieved","name":"Relieved Face","keywords":["relaxed","phew","massage","happiness"],"skins":[{"unified":"1f60c","native":"😌","x":32,"y":33}],"version":1},"pensive":{"id":"pensive","name":"Pensive Face","keywords":["sad","depressed","upset"],"skins":[{"unified":"1f614","native":"😔","x":32,"y":41}],"version":1},"sleepy":{"id":"sleepy","name":"Sleepy Face","keywords":["tired","rest","nap"],"skins":[{"unified":"1f62a","native":"😪","x":33,"y":2}],"version":1},"drooling_face":{"id":"drooling_face","name":"Drooling Face","keywords":[],"skins":[{"unified":"1f924","native":"🤤","x":40,"y":18}],"version":3},"sleeping":{"id":"sleeping","name":"Sleeping Face","keywords":["tired","sleepy","night","zzz"],"skins":[{"unified":"1f634","native":"😴","x":33,"y":13}],"version":1},"mask":{"id":"mask","name":"Face with Medical Mask","keywords":["sick","ill","disease","covid"],"skins":[{"unified":"1f637","native":"😷","x":33,"y":18}],"version":1},"face_with_thermometer":{"id":"face_with_thermometer","name":"Face with Thermometer","keywords":["sick","temperature","cold","fever","covid"],"skins":[{"unified":"1f912","native":"🤒","x":39,"y":1}],"version":1},"face_with_head_bandage":{"id":"face_with_head_bandage","name":"Face with Head-Bandage","keywords":["head","bandage","injured","clumsy","hurt"],"skins":[{"unified":"1f915","native":"🤕","x":39,"y":4}],"version":1},"nauseated_face":{"id":"nauseated_face","name":"Nauseated Face","keywords":["vomit","gross","green","sick","throw","up","ill"],"skins":[{"unified":"1f922","native":"🤢","x":40,"y":16}],"version":3},"face_vomiting":{"id":"face_vomiting","name":"Face Vomiting","keywords":["with","open","mouth","sick"],"skins":[{"unified":"1f92e","native":"🤮","x":40,"y":45}],"version":5},"sneezing_face":{"id":"sneezing_face","name":"Sneezing Face","keywords":["gesundheit","sneeze","sick","allergy"],"skins":[{"unified":"1f927","native":"🤧","x":40,"y":38}],"version":3},"hot_face":{"id":"hot_face","name":"Hot Face","keywords":["feverish","heat","red","sweating"],"skins":[{"unified":"1f975","native":"🥵","x":44,"y":4}],"version":11},"cold_face":{"id":"cold_face","name":"Cold Face","keywords":["blue","freezing","frozen","frostbite","icicles"],"skins":[{"unified":"1f976","native":"🥶","x":44,"y":5}],"version":11},"woozy_face":{"id":"woozy_face","name":"Woozy Face","keywords":["dizzy","intoxicated","tipsy","wavy"],"skins":[{"unified":"1f974","native":"🥴","x":44,"y":3}],"version":11},"dizzy_face":{"id":"dizzy_face","name":"Dizzy Face","keywords":["spent","unconscious","xox"],"skins":[{"unified":"1f635","native":"😵","x":33,"y":15}],"version":1},"face_with_spiral_eyes":{"id":"face_with_spiral_eyes","name":"Face with Spiral Eyes","keywords":["sick","ill","confused","nauseous","nausea"],"skins":[{"unified":"1f635-200d-1f4ab","native":"😵‍💫","x":33,"y":14}],"version":13.1},"exploding_head":{"id":"exploding_head","name":"Exploding Head","keywords":["shocked","face","with","mind","blown"],"skins":[{"unified":"1f92f","native":"🤯","x":40,"y":46}],"version":5},"face_with_cowboy_hat":{"id":"face_with_cowboy_hat","name":"Cowboy Hat Face","keywords":["with","cowgirl"],"skins":[{"unified":"1f920","native":"🤠","x":40,"y":14}],"version":3},"partying_face":{"id":"partying_face","name":"Partying Face","keywords":["celebration","woohoo"],"skins":[{"unified":"1f973","native":"🥳","x":44,"y":2}],"version":11},"disguised_face":{"id":"disguised_face","name":"Disguised Face","keywords":["pretent","brows","glasses","moustache"],"skins":[{"unified":"1f978","native":"🥸","x":44,"y":12}],"version":13},"sunglasses":{"id":"sunglasses","name":"Smiling Face with Sunglasses","emoticons":["8)"],"keywords":["cool","smile","summer","beach","sunglass"],"skins":[{"unified":"1f60e","native":"😎","x":32,"y":35}],"version":1},"nerd_face":{"id":"nerd_face","name":"Nerd Face","keywords":["nerdy","geek","dork"],"skins":[{"unified":"1f913","native":"🤓","x":39,"y":2}],"version":1},"face_with_monocle":{"id":"face_with_monocle","name":"Face with Monocle","keywords":["stuffy","wealthy"],"skins":[{"unified":"1f9d0","native":"🧐","x":47,"y":13}],"version":5},"confused":{"id":"confused","name":"Confused Face","emoticons":[":\\\\",":-\\\\",":/",":-/"],"keywords":["indifference","huh","weird","hmmm",":/"],"skins":[{"unified":"1f615","native":"😕","x":32,"y":42}],"version":1},"face_with_diagonal_mouth":{"id":"face_with_diagonal_mouth","name":"Face with Diagonal Mouth","keywords":["skeptic","confuse","frustrated","indifferent"],"skins":[{"unified":"1fae4","native":"🫤","x":55,"y":34}],"version":14},"worried":{"id":"worried","name":"Worried Face","keywords":["concern","nervous",":("],"skins":[{"unified":"1f61f","native":"😟","x":32,"y":52}],"version":1},"slightly_frowning_face":{"id":"slightly_frowning_face","name":"Slightly Frowning Face","keywords":["disappointed","sad","upset"],"skins":[{"unified":"1f641","native":"🙁","x":33,"y":28}],"version":1},"white_frowning_face":{"id":"white_frowning_face","name":"Frowning Face","keywords":["white","sad","upset","frown"],"skins":[{"unified":"2639-fe0f","native":"☹️","x":57,"y":34}],"version":1},"open_mouth":{"id":"open_mouth","name":"Face with Open Mouth","emoticons":[":o",":-o",":O",":-O"],"keywords":["surprise","impressed","wow","whoa",":O"],"skins":[{"unified":"1f62e","native":"😮","x":33,"y":7}],"version":1},"hushed":{"id":"hushed","name":"Hushed Face","keywords":["woo","shh"],"skins":[{"unified":"1f62f","native":"😯","x":33,"y":8}],"version":1},"astonished":{"id":"astonished","name":"Astonished Face","keywords":["xox","surprised","poisoned"],"skins":[{"unified":"1f632","native":"😲","x":33,"y":11}],"version":1},"flushed":{"id":"flushed","name":"Flushed Face","keywords":["blush","shy","flattered"],"skins":[{"unified":"1f633","native":"😳","x":33,"y":12}],"version":1},"pleading_face":{"id":"pleading_face","name":"Pleading Face","keywords":["begging","mercy","cry","tears","sad","grievance"],"skins":[{"unified":"1f97a","native":"🥺","x":44,"y":14}],"version":11},"face_holding_back_tears":{"id":"face_holding_back_tears","name":"Face Holding Back Tears","keywords":["touched","gratitude","cry"],"skins":[{"unified":"1f979","native":"🥹","x":44,"y":13}],"version":14},"frowning":{"id":"frowning","name":"Frowning Face with Open Mouth","keywords":["aw","what"],"skins":[{"unified":"1f626","native":"😦","x":32,"y":59}],"version":1},"anguished":{"id":"anguished","name":"Anguished Face","emoticons":["D:"],"keywords":["stunned","nervous"],"skins":[{"unified":"1f627","native":"😧","x":32,"y":60}],"version":1},"fearful":{"id":"fearful","name":"Fearful Face","keywords":["scared","terrified","nervous"],"skins":[{"unified":"1f628","native":"😨","x":33,"y":0}],"version":1},"cold_sweat":{"id":"cold_sweat","name":"Anxious Face with Sweat","keywords":["cold","nervous"],"skins":[{"unified":"1f630","native":"😰","x":33,"y":9}],"version":1},"disappointed_relieved":{"id":"disappointed_relieved","name":"Sad but Relieved Face","keywords":["disappointed","phew","sweat","nervous"],"skins":[{"unified":"1f625","native":"😥","x":32,"y":58}],"version":1},"cry":{"id":"cry","name":"Crying Face","emoticons":[":'("],"keywords":["cry","tears","sad","depressed","upset",":'("],"skins":[{"unified":"1f622","native":"😢","x":32,"y":55}],"version":1},"sob":{"id":"sob","name":"Loudly Crying Face","emoticons":[":'("],"keywords":["sob","cry","tears","sad","upset","depressed"],"skins":[{"unified":"1f62d","native":"😭","x":33,"y":5}],"version":1},"scream":{"id":"scream","name":"Face Screaming in Fear","keywords":["scream","munch","scared","omg"],"skins":[{"unified":"1f631","native":"😱","x":33,"y":10}],"version":1},"confounded":{"id":"confounded","name":"Confounded Face","keywords":["confused","sick","unwell","oops",":S"],"skins":[{"unified":"1f616","native":"😖","x":32,"y":43}],"version":1},"persevere":{"id":"persevere","name":"Persevering Face","keywords":["persevere","sick","no","upset","oops"],"skins":[{"unified":"1f623","native":"😣","x":32,"y":56}],"version":1},"disappointed":{"id":"disappointed","name":"Disappointed Face","emoticons":["):",":(",":-("],"keywords":["sad","upset","depressed",":("],"skins":[{"unified":"1f61e","native":"😞","x":32,"y":51}],"version":1},"sweat":{"id":"sweat","name":"Face with Cold Sweat","keywords":["downcast","hot","sad","tired","exercise"],"skins":[{"unified":"1f613","native":"😓","x":32,"y":40}],"version":1},"weary":{"id":"weary","name":"Weary Face","keywords":["tired","sleepy","sad","frustrated","upset"],"skins":[{"unified":"1f629","native":"😩","x":33,"y":1}],"version":1},"tired_face":{"id":"tired_face","name":"Tired Face","keywords":["sick","whine","upset","frustrated"],"skins":[{"unified":"1f62b","native":"😫","x":33,"y":3}],"version":1},"yawning_face":{"id":"yawning_face","name":"Yawning Face","keywords":["tired","sleepy"],"skins":[{"unified":"1f971","native":"🥱","x":44,"y":0}],"version":12},"triumph":{"id":"triumph","name":"Face with Look of Triumph","keywords":["steam","from","nose","gas","phew","proud","pride"],"skins":[{"unified":"1f624","native":"😤","x":32,"y":57}],"version":1},"rage":{"id":"rage","name":"Pouting Face","keywords":["rage","angry","mad","hate","despise"],"skins":[{"unified":"1f621","native":"😡","x":32,"y":54}],"version":1},"angry":{"id":"angry","name":"Angry Face","emoticons":[">:(",">:-("],"keywords":["mad","annoyed","frustrated"],"skins":[{"unified":"1f620","native":"😠","x":32,"y":53}],"version":1},"face_with_symbols_on_mouth":{"id":"face_with_symbols_on_mouth","name":"Face with Symbols on Mouth","keywords":["serious","covering","swearing","cursing","cussing","profanity","expletive"],"skins":[{"unified":"1f92c","native":"🤬","x":40,"y":43}],"version":5},"smiling_imp":{"id":"smiling_imp","name":"Smiling Face with Horns","keywords":["imp","devil"],"skins":[{"unified":"1f608","native":"😈","x":32,"y":29}],"version":1},"imp":{"id":"imp","name":"Imp","keywords":["angry","face","with","horns","devil"],"skins":[{"unified":"1f47f","native":"👿","x":25,"y":9}],"version":1},"skull":{"id":"skull","name":"Skull","keywords":["dead","skeleton","creepy","death"],"skins":[{"unified":"1f480","native":"💀","x":25,"y":10}],"version":1},"skull_and_crossbones":{"id":"skull_and_crossbones","name":"Skull and Crossbones","keywords":["poison","danger","deadly","scary","death","pirate","evil"],"skins":[{"unified":"2620-fe0f","native":"☠️","x":57,"y":26}],"version":1},"hankey":{"id":"hankey","name":"Pile of Poo","keywords":["hankey","poop","shit","shitface","fail","turd"],"skins":[{"unified":"1f4a9","native":"💩","x":27,"y":57}],"version":1},"clown_face":{"id":"clown_face","name":"Clown Face","keywords":[],"skins":[{"unified":"1f921","native":"🤡","x":40,"y":15}],"version":3},"japanese_ogre":{"id":"japanese_ogre","name":"Ogre","keywords":["japanese","monster","red","mask","halloween","scary","creepy","devil","demon"],"skins":[{"unified":"1f479","native":"👹","x":24,"y":59}],"version":1},"japanese_goblin":{"id":"japanese_goblin","name":"Goblin","keywords":["japanese","red","evil","mask","monster","scary","creepy"],"skins":[{"unified":"1f47a","native":"👺","x":24,"y":60}],"version":1},"ghost":{"id":"ghost","name":"Ghost","keywords":["halloween","spooky","scary"],"skins":[{"unified":"1f47b","native":"👻","x":25,"y":0}],"version":1},"alien":{"id":"alien","name":"Alien","keywords":["UFO","paul","weird","outer","space"],"skins":[{"unified":"1f47d","native":"👽","x":25,"y":7}],"version":1},"space_invader":{"id":"space_invader","name":"Alien Monster","keywords":["space","invader","game","arcade","play"],"skins":[{"unified":"1f47e","native":"👾","x":25,"y":8}],"version":1},"robot_face":{"id":"robot_face","name":"Robot","keywords":["face","computer","machine","bot"],"skins":[{"unified":"1f916","native":"🤖","x":39,"y":5}],"version":1},"smiley_cat":{"id":"smiley_cat","name":"Grinning Cat","keywords":["smiley","animal","cats","happy","smile"],"skins":[{"unified":"1f63a","native":"😺","x":33,"y":21}],"version":1},"smile_cat":{"id":"smile_cat","name":"Grinning Cat with Smiling Eyes","keywords":["smile","animal","cats"],"skins":[{"unified":"1f638","native":"😸","x":33,"y":19}],"version":1},"joy_cat":{"id":"joy_cat","name":"Cat with Tears of Joy","keywords":["animal","cats","haha","happy"],"skins":[{"unified":"1f639","native":"😹","x":33,"y":20}],"version":1},"heart_eyes_cat":{"id":"heart_eyes_cat","name":"Smiling Cat with Heart-Eyes","keywords":["heart","eyes","animal","love","like","affection","cats","valentines"],"skins":[{"unified":"1f63b","native":"😻","x":33,"y":22}],"version":1},"smirk_cat":{"id":"smirk_cat","name":"Cat with Wry Smile","keywords":["smirk","animal","cats"],"skins":[{"unified":"1f63c","native":"😼","x":33,"y":23}],"version":1},"kissing_cat":{"id":"kissing_cat","name":"Kissing Cat","keywords":["animal","cats","kiss"],"skins":[{"unified":"1f63d","native":"😽","x":33,"y":24}],"version":1},"scream_cat":{"id":"scream_cat","name":"Weary Cat","keywords":["scream","animal","cats","munch","scared"],"skins":[{"unified":"1f640","native":"🙀","x":33,"y":27}],"version":1},"crying_cat_face":{"id":"crying_cat_face","name":"Crying Cat","keywords":["face","animal","tears","weep","sad","cats","upset","cry"],"skins":[{"unified":"1f63f","native":"😿","x":33,"y":26}],"version":1},"pouting_cat":{"id":"pouting_cat","name":"Pouting Cat","keywords":["animal","cats"],"skins":[{"unified":"1f63e","native":"😾","x":33,"y":25}],"version":1},"see_no_evil":{"id":"see_no_evil","name":"See-No-Evil Monkey","keywords":["see","no","evil","animal","nature","haha"],"skins":[{"unified":"1f648","native":"🙈","x":34,"y":25}],"version":1},"hear_no_evil":{"id":"hear_no_evil","name":"Hear-No-Evil Monkey","keywords":["hear","no","evil","animal","nature"],"skins":[{"unified":"1f649","native":"🙉","x":34,"y":26}],"version":1},"speak_no_evil":{"id":"speak_no_evil","name":"Speak-No-Evil Monkey","keywords":["speak","no","evil","animal","nature","omg"],"skins":[{"unified":"1f64a","native":"🙊","x":34,"y":27}],"version":1},"love_letter":{"id":"love_letter","name":"Love Letter","keywords":["email","like","affection","envelope","valentines"],"skins":[{"unified":"1f48c","native":"💌","x":26,"y":39}],"version":1},"cupid":{"id":"cupid","name":"Heart with Arrow","keywords":["cupid","love","like","affection","valentines"],"skins":[{"unified":"1f498","native":"💘","x":27,"y":40}],"version":1},"gift_heart":{"id":"gift_heart","name":"Heart with Ribbon","keywords":["gift","love","valentines"],"skins":[{"unified":"1f49d","native":"💝","x":27,"y":45}],"version":1},"sparkling_heart":{"id":"sparkling_heart","name":"Sparkling Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f496","native":"💖","x":27,"y":38}],"version":1},"heartpulse":{"id":"heartpulse","name":"Growing Heart","keywords":["heartpulse","like","love","affection","valentines","pink"],"skins":[{"unified":"1f497","native":"💗","x":27,"y":39}],"version":1},"heartbeat":{"id":"heartbeat","name":"Beating Heart","keywords":["heartbeat","love","like","affection","valentines","pink"],"skins":[{"unified":"1f493","native":"💓","x":27,"y":35}],"version":1},"revolving_hearts":{"id":"revolving_hearts","name":"Revolving Hearts","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49e","native":"💞","x":27,"y":46}],"version":1},"two_hearts":{"id":"two_hearts","name":"Two Hearts","keywords":["love","like","affection","valentines","heart"],"skins":[{"unified":"1f495","native":"💕","x":27,"y":37}],"version":1},"heart_decoration":{"id":"heart_decoration","name":"Heart Decoration","keywords":["purple","square","love","like"],"skins":[{"unified":"1f49f","native":"💟","x":27,"y":47}],"version":1},"heavy_heart_exclamation_mark_ornament":{"id":"heavy_heart_exclamation_mark_ornament","name":"Heart Exclamation","keywords":["heavy","mark","ornament","decoration","love"],"skins":[{"unified":"2763-fe0f","native":"❣️","x":59,"y":38}],"version":1},"broken_heart":{"id":"broken_heart","name":"Broken Heart","emoticons":["</3"],"keywords":["sad","sorry","break","heartbreak"],"skins":[{"unified":"1f494","native":"💔","x":27,"y":36}],"version":1},"heart_on_fire":{"id":"heart_on_fire","name":"Heart on Fire","keywords":["passionate","enthusiastic"],"skins":[{"unified":"2764-fe0f-200d-1f525","native":"❤️‍🔥","x":59,"y":39}],"version":13.1},"mending_heart":{"id":"mending_heart","name":"Mending Heart","keywords":["broken","bandage","wounded"],"skins":[{"unified":"2764-fe0f-200d-1fa79","native":"❤️‍🩹","x":59,"y":40}],"version":13.1},"heart":{"id":"heart","name":"Red Heart","emoticons":["<3"],"keywords":["love","like","valentines"],"skins":[{"unified":"2764-fe0f","native":"❤️","x":59,"y":41}],"version":1},"orange_heart":{"id":"orange_heart","name":"Orange Heart","keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f9e1","native":"🧡","x":53,"y":17}],"version":5},"yellow_heart":{"id":"yellow_heart","name":"Yellow Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49b","native":"💛","x":27,"y":43}],"version":1},"green_heart":{"id":"green_heart","name":"Green Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49a","native":"💚","x":27,"y":42}],"version":1},"blue_heart":{"id":"blue_heart","name":"Blue Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f499","native":"💙","x":27,"y":41}],"version":1},"purple_heart":{"id":"purple_heart","name":"Purple Heart","emoticons":["<3"],"keywords":["love","like","affection","valentines"],"skins":[{"unified":"1f49c","native":"💜","x":27,"y":44}],"version":1},"brown_heart":{"id":"brown_heart","name":"Brown Heart","keywords":["coffee"],"skins":[{"unified":"1f90e","native":"🤎","x":38,"y":53}],"version":12},"black_heart":{"id":"black_heart","name":"Black Heart","keywords":["evil"],"skins":[{"unified":"1f5a4","native":"🖤","x":31,"y":56}],"version":3},"white_heart":{"id":"white_heart","name":"White Heart","keywords":["pure"],"skins":[{"unified":"1f90d","native":"🤍","x":38,"y":52}],"version":12},"kiss":{"id":"kiss","name":"Kiss Mark","keywords":["face","lips","love","like","affection","valentines"],"skins":[{"unified":"1f48b","native":"💋","x":26,"y":38}],"version":1},"anger":{"id":"anger","name":"Anger Symbol","keywords":["angry","mad"],"skins":[{"unified":"1f4a2","native":"💢","x":27,"y":50}],"version":1},"boom":{"id":"boom","name":"Collision","keywords":["boom","bomb","explode","explosion","blown"],"skins":[{"unified":"1f4a5","native":"💥","x":27,"y":53}],"version":1},"dizzy":{"id":"dizzy","name":"Dizzy","keywords":["star","sparkle","shoot","magic"],"skins":[{"unified":"1f4ab","native":"💫","x":28,"y":3}],"version":1},"sweat_drops":{"id":"sweat_drops","name":"Sweat Droplets","keywords":["drops","water","drip","oops"],"skins":[{"unified":"1f4a6","native":"💦","x":27,"y":54}],"version":1},"dash":{"id":"dash","name":"Dash Symbol","keywords":["dashing","away","wind","air","fast","shoo","fart","smoke","puff"],"skins":[{"unified":"1f4a8","native":"💨","x":27,"y":56}],"version":1},"hole":{"id":"hole","name":"Hole","keywords":["embarrassing"],"skins":[{"unified":"1f573-fe0f","native":"🕳️","x":30,"y":59}],"version":1},"speech_balloon":{"id":"speech_balloon","name":"Speech Balloon","keywords":["bubble","words","message","talk","chatting"],"skins":[{"unified":"1f4ac","native":"💬","x":28,"y":4}],"version":1},"eye-in-speech-bubble":{"id":"eye-in-speech-bubble","name":"Eye in Speech Bubble","keywords":["in-speech-bubble","info"],"skins":[{"unified":"1f441-fe0f-200d-1f5e8-fe0f","native":"👁️‍🗨️","x":11,"y":54}],"version":2},"left_speech_bubble":{"id":"left_speech_bubble","name":"Left Speech Bubble","keywords":["words","message","talk","chatting"],"skins":[{"unified":"1f5e8-fe0f","native":"🗨️","x":32,"y":12}],"version":2},"right_anger_bubble":{"id":"right_anger_bubble","name":"Right Anger Bubble","keywords":["caption","speech","thinking","mad"],"skins":[{"unified":"1f5ef-fe0f","native":"🗯️","x":32,"y":13}],"version":1},"thought_balloon":{"id":"thought_balloon","name":"Thought Balloon","keywords":["bubble","cloud","speech","thinking","dream"],"skins":[{"unified":"1f4ad","native":"💭","x":28,"y":5}],"version":1},"zzz":{"id":"zzz","name":"Zzz","keywords":["sleepy","tired","dream"],"skins":[{"unified":"1f4a4","native":"💤","x":27,"y":52}],"version":1},"wave":{"id":"wave","name":"Waving Hand","keywords":["wave","hands","gesture","goodbye","solong","farewell","hello","hi","palm"],"skins":[{"unified":"1f44b","native":"👋","x":12,"y":39},{"unified":"1f44b-1f3fb","native":"👋🏻","x":12,"y":40},{"unified":"1f44b-1f3fc","native":"👋🏼","x":12,"y":41},{"unified":"1f44b-1f3fd","native":"👋🏽","x":12,"y":42},{"unified":"1f44b-1f3fe","native":"👋🏾","x":12,"y":43},{"unified":"1f44b-1f3ff","native":"👋🏿","x":12,"y":44}],"version":1},"raised_back_of_hand":{"id":"raised_back_of_hand","name":"Raised Back of Hand","keywords":["fingers","backhand"],"skins":[{"unified":"1f91a","native":"🤚","x":39,"y":19},{"unified":"1f91a-1f3fb","native":"🤚🏻","x":39,"y":20},{"unified":"1f91a-1f3fc","native":"🤚🏼","x":39,"y":21},{"unified":"1f91a-1f3fd","native":"🤚🏽","x":39,"y":22},{"unified":"1f91a-1f3fe","native":"🤚🏾","x":39,"y":23},{"unified":"1f91a-1f3ff","native":"🤚🏿","x":39,"y":24}],"version":3},"raised_hand_with_fingers_splayed":{"id":"raised_hand_with_fingers_splayed","name":"Hand with Fingers Splayed","keywords":["raised","palm"],"skins":[{"unified":"1f590-fe0f","native":"🖐️","x":31,"y":38},{"unified":"1f590-1f3fb","native":"🖐🏻","x":31,"y":39},{"unified":"1f590-1f3fc","native":"🖐🏼","x":31,"y":40},{"unified":"1f590-1f3fd","native":"🖐🏽","x":31,"y":41},{"unified":"1f590-1f3fe","native":"🖐🏾","x":31,"y":42},{"unified":"1f590-1f3ff","native":"🖐🏿","x":31,"y":43}],"version":1},"hand":{"id":"hand","name":"Raised Hand","keywords":["fingers","stop","highfive","high","five","palm","ban"],"skins":[{"unified":"270b","native":"✋","x":59,"y":3},{"unified":"270b-1f3fb","native":"✋🏻","x":59,"y":4},{"unified":"270b-1f3fc","native":"✋🏼","x":59,"y":5},{"unified":"270b-1f3fd","native":"✋🏽","x":59,"y":6},{"unified":"270b-1f3fe","native":"✋🏾","x":59,"y":7},{"unified":"270b-1f3ff","native":"✋🏿","x":59,"y":8}],"version":1},"spock-hand":{"id":"spock-hand","name":"Vulcan Salute","keywords":["spock","hand","fingers","star","trek"],"skins":[{"unified":"1f596","native":"🖖","x":31,"y":50},{"unified":"1f596-1f3fb","native":"🖖🏻","x":31,"y":51},{"unified":"1f596-1f3fc","native":"🖖🏼","x":31,"y":52},{"unified":"1f596-1f3fd","native":"🖖🏽","x":31,"y":53},{"unified":"1f596-1f3fe","native":"🖖🏾","x":31,"y":54},{"unified":"1f596-1f3ff","native":"🖖🏿","x":31,"y":55}],"version":1},"rightwards_hand":{"id":"rightwards_hand","name":"Rightwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf1","native":"🫱","x":55,"y":45},{"unified":"1faf1-1f3fb","native":"🫱🏻","x":55,"y":46},{"unified":"1faf1-1f3fc","native":"🫱🏼","x":55,"y":47},{"unified":"1faf1-1f3fd","native":"🫱🏽","x":55,"y":48},{"unified":"1faf1-1f3fe","native":"🫱🏾","x":55,"y":49},{"unified":"1faf1-1f3ff","native":"🫱🏿","x":55,"y":50}],"version":14},"leftwards_hand":{"id":"leftwards_hand","name":"Leftwards Hand","keywords":["palm","offer"],"skins":[{"unified":"1faf2","native":"🫲","x":55,"y":51},{"unified":"1faf2-1f3fb","native":"🫲🏻","x":55,"y":52},{"unified":"1faf2-1f3fc","native":"🫲🏼","x":55,"y":53},{"unified":"1faf2-1f3fd","native":"🫲🏽","x":55,"y":54},{"unified":"1faf2-1f3fe","native":"🫲🏾","x":55,"y":55},{"unified":"1faf2-1f3ff","native":"🫲🏿","x":55,"y":56}],"version":14},"palm_down_hand":{"id":"palm_down_hand","name":"Palm Down Hand","keywords":["drop"],"skins":[{"unified":"1faf3","native":"🫳","x":55,"y":57},{"unified":"1faf3-1f3fb","native":"🫳🏻","x":55,"y":58},{"unified":"1faf3-1f3fc","native":"🫳🏼","x":55,"y":59},{"unified":"1faf3-1f3fd","native":"🫳🏽","x":55,"y":60},{"unified":"1faf3-1f3fe","native":"🫳🏾","x":56,"y":0},{"unified":"1faf3-1f3ff","native":"🫳🏿","x":56,"y":1}],"version":14},"palm_up_hand":{"id":"palm_up_hand","name":"Palm Up Hand","keywords":["lift","offer","demand"],"skins":[{"unified":"1faf4","native":"🫴","x":56,"y":2},{"unified":"1faf4-1f3fb","native":"🫴🏻","x":56,"y":3},{"unified":"1faf4-1f3fc","native":"🫴🏼","x":56,"y":4},{"unified":"1faf4-1f3fd","native":"🫴🏽","x":56,"y":5},{"unified":"1faf4-1f3fe","native":"🫴🏾","x":56,"y":6},{"unified":"1faf4-1f3ff","native":"🫴🏿","x":56,"y":7}],"version":14},"ok_hand":{"id":"ok_hand","name":"Ok Hand","keywords":["fingers","limbs","perfect","okay"],"skins":[{"unified":"1f44c","native":"👌","x":12,"y":45},{"unified":"1f44c-1f3fb","native":"👌🏻","x":12,"y":46},{"unified":"1f44c-1f3fc","native":"👌🏼","x":12,"y":47},{"unified":"1f44c-1f3fd","native":"👌🏽","x":12,"y":48},{"unified":"1f44c-1f3fe","native":"👌🏾","x":12,"y":49},{"unified":"1f44c-1f3ff","native":"👌🏿","x":12,"y":50}],"version":1},"pinched_fingers":{"id":"pinched_fingers","name":"Pinched Fingers","keywords":["size","tiny","small"],"skins":[{"unified":"1f90c","native":"🤌","x":38,"y":46},{"unified":"1f90c-1f3fb","native":"🤌🏻","x":38,"y":47},{"unified":"1f90c-1f3fc","native":"🤌🏼","x":38,"y":48},{"unified":"1f90c-1f3fd","native":"🤌🏽","x":38,"y":49},{"unified":"1f90c-1f3fe","native":"🤌🏾","x":38,"y":50},{"unified":"1f90c-1f3ff","native":"🤌🏿","x":38,"y":51}],"version":13},"pinching_hand":{"id":"pinching_hand","name":"Pinching Hand","keywords":["tiny","small","size"],"skins":[{"unified":"1f90f","native":"🤏","x":38,"y":54},{"unified":"1f90f-1f3fb","native":"🤏🏻","x":38,"y":55},{"unified":"1f90f-1f3fc","native":"🤏🏼","x":38,"y":56},{"unified":"1f90f-1f3fd","native":"🤏🏽","x":38,"y":57},{"unified":"1f90f-1f3fe","native":"🤏🏾","x":38,"y":58},{"unified":"1f90f-1f3ff","native":"🤏🏿","x":38,"y":59}],"version":12},"v":{"id":"v","name":"Victory Hand","keywords":["v","fingers","ohyeah","peace","two"],"skins":[{"unified":"270c-fe0f","native":"✌️","x":59,"y":9},{"unified":"270c-1f3fb","native":"✌🏻","x":59,"y":10},{"unified":"270c-1f3fc","native":"✌🏼","x":59,"y":11},{"unified":"270c-1f3fd","native":"✌🏽","x":59,"y":12},{"unified":"270c-1f3fe","native":"✌🏾","x":59,"y":13},{"unified":"270c-1f3ff","native":"✌🏿","x":59,"y":14}],"version":1},"crossed_fingers":{"id":"crossed_fingers","name":"Crossed Fingers","keywords":["hand","with","index","and","middle","good","lucky"],"skins":[{"unified":"1f91e","native":"🤞","x":40,"y":2},{"unified":"1f91e-1f3fb","native":"🤞🏻","x":40,"y":3},{"unified":"1f91e-1f3fc","native":"🤞🏼","x":40,"y":4},{"unified":"1f91e-1f3fd","native":"🤞🏽","x":40,"y":5},{"unified":"1f91e-1f3fe","native":"🤞🏾","x":40,"y":6},{"unified":"1f91e-1f3ff","native":"🤞🏿","x":40,"y":7}],"version":3},"hand_with_index_finger_and_thumb_crossed":{"id":"hand_with_index_finger_and_thumb_crossed","name":"Hand with Index Finger and Thumb Crossed","keywords":["heart","love","money","expensive"],"skins":[{"unified":"1faf0","native":"🫰","x":55,"y":39},{"unified":"1faf0-1f3fb","native":"🫰🏻","x":55,"y":40},{"unified":"1faf0-1f3fc","native":"🫰🏼","x":55,"y":41},{"unified":"1faf0-1f3fd","native":"🫰🏽","x":55,"y":42},{"unified":"1faf0-1f3fe","native":"🫰🏾","x":55,"y":43},{"unified":"1faf0-1f3ff","native":"🫰🏿","x":55,"y":44}],"version":14},"i_love_you_hand_sign":{"id":"i_love_you_hand_sign","name":"Love-You Gesture","keywords":["i","love","you","hand","sign","fingers"],"skins":[{"unified":"1f91f","native":"🤟","x":40,"y":8},{"unified":"1f91f-1f3fb","native":"🤟🏻","x":40,"y":9},{"unified":"1f91f-1f3fc","native":"🤟🏼","x":40,"y":10},{"unified":"1f91f-1f3fd","native":"🤟🏽","x":40,"y":11},{"unified":"1f91f-1f3fe","native":"🤟🏾","x":40,"y":12},{"unified":"1f91f-1f3ff","native":"🤟🏿","x":40,"y":13}],"version":5},"the_horns":{"id":"the_horns","name":"Sign of the Horns","keywords":["hand","fingers","evil","eye","rock","on"],"skins":[{"unified":"1f918","native":"🤘","x":39,"y":7},{"unified":"1f918-1f3fb","native":"🤘🏻","x":39,"y":8},{"unified":"1f918-1f3fc","native":"🤘🏼","x":39,"y":9},{"unified":"1f918-1f3fd","native":"🤘🏽","x":39,"y":10},{"unified":"1f918-1f3fe","native":"🤘🏾","x":39,"y":11},{"unified":"1f918-1f3ff","native":"🤘🏿","x":39,"y":12}],"version":1},"call_me_hand":{"id":"call_me_hand","name":"Call Me Hand","keywords":["hands","gesture","shaka"],"skins":[{"unified":"1f919","native":"🤙","x":39,"y":13},{"unified":"1f919-1f3fb","native":"🤙🏻","x":39,"y":14},{"unified":"1f919-1f3fc","native":"🤙🏼","x":39,"y":15},{"unified":"1f919-1f3fd","native":"🤙🏽","x":39,"y":16},{"unified":"1f919-1f3fe","native":"🤙🏾","x":39,"y":17},{"unified":"1f919-1f3ff","native":"🤙🏿","x":39,"y":18}],"version":3},"point_left":{"id":"point_left","name":"Backhand Index Pointing Left","keywords":["point","direction","fingers","hand"],"skins":[{"unified":"1f448","native":"👈","x":12,"y":21},{"unified":"1f448-1f3fb","native":"👈🏻","x":12,"y":22},{"unified":"1f448-1f3fc","native":"👈🏼","x":12,"y":23},{"unified":"1f448-1f3fd","native":"👈🏽","x":12,"y":24},{"unified":"1f448-1f3fe","native":"👈🏾","x":12,"y":25},{"unified":"1f448-1f3ff","native":"👈🏿","x":12,"y":26}],"version":1},"point_right":{"id":"point_right","name":"Backhand Index Pointing Right","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f449","native":"👉","x":12,"y":27},{"unified":"1f449-1f3fb","native":"👉🏻","x":12,"y":28},{"unified":"1f449-1f3fc","native":"👉🏼","x":12,"y":29},{"unified":"1f449-1f3fd","native":"👉🏽","x":12,"y":30},{"unified":"1f449-1f3fe","native":"👉🏾","x":12,"y":31},{"unified":"1f449-1f3ff","native":"👉🏿","x":12,"y":32}],"version":1},"point_up_2":{"id":"point_up_2","name":"Backhand Index Pointing Up","keywords":["point","2","fingers","hand","direction"],"skins":[{"unified":"1f446","native":"👆","x":12,"y":9},{"unified":"1f446-1f3fb","native":"👆🏻","x":12,"y":10},{"unified":"1f446-1f3fc","native":"👆🏼","x":12,"y":11},{"unified":"1f446-1f3fd","native":"👆🏽","x":12,"y":12},{"unified":"1f446-1f3fe","native":"👆🏾","x":12,"y":13},{"unified":"1f446-1f3ff","native":"👆🏿","x":12,"y":14}],"version":1},"middle_finger":{"id":"middle_finger","name":"Middle Finger","keywords":["reversed","hand","with","extended","fingers","rude","flipping"],"skins":[{"unified":"1f595","native":"🖕","x":31,"y":44},{"unified":"1f595-1f3fb","native":"🖕🏻","x":31,"y":45},{"unified":"1f595-1f3fc","native":"🖕🏼","x":31,"y":46},{"unified":"1f595-1f3fd","native":"🖕🏽","x":31,"y":47},{"unified":"1f595-1f3fe","native":"🖕🏾","x":31,"y":48},{"unified":"1f595-1f3ff","native":"🖕🏿","x":31,"y":49}],"version":1},"point_down":{"id":"point_down","name":"Backhand Index Pointing Down","keywords":["point","fingers","hand","direction"],"skins":[{"unified":"1f447","native":"👇","x":12,"y":15},{"unified":"1f447-1f3fb","native":"👇🏻","x":12,"y":16},{"unified":"1f447-1f3fc","native":"👇🏼","x":12,"y":17},{"unified":"1f447-1f3fd","native":"👇🏽","x":12,"y":18},{"unified":"1f447-1f3fe","native":"👇🏾","x":12,"y":19},{"unified":"1f447-1f3ff","native":"👇🏿","x":12,"y":20}],"version":1},"point_up":{"id":"point_up","name":"Index Pointing Up","keywords":["point","hand","fingers","direction"],"skins":[{"unified":"261d-fe0f","native":"☝️","x":57,"y":20},{"unified":"261d-1f3fb","native":"☝🏻","x":57,"y":21},{"unified":"261d-1f3fc","native":"☝🏼","x":57,"y":22},{"unified":"261d-1f3fd","native":"☝🏽","x":57,"y":23},{"unified":"261d-1f3fe","native":"☝🏾","x":57,"y":24},{"unified":"261d-1f3ff","native":"☝🏿","x":57,"y":25}],"version":1},"index_pointing_at_the_viewer":{"id":"index_pointing_at_the_viewer","name":"Index Pointing at the Viewer","keywords":["you","recruit"],"skins":[{"unified":"1faf5","native":"🫵","x":56,"y":8},{"unified":"1faf5-1f3fb","native":"🫵🏻","x":56,"y":9},{"unified":"1faf5-1f3fc","native":"🫵🏼","x":56,"y":10},{"unified":"1faf5-1f3fd","native":"🫵🏽","x":56,"y":11},{"unified":"1faf5-1f3fe","native":"🫵🏾","x":56,"y":12},{"unified":"1faf5-1f3ff","native":"🫵🏿","x":56,"y":13}],"version":14},"+1":{"id":"+1","name":"Thumbs Up","keywords":["+1","thumbsup","yes","awesome","good","agree","accept","cool","hand","like"],"skins":[{"unified":"1f44d","native":"👍","x":12,"y":51},{"unified":"1f44d-1f3fb","native":"👍🏻","x":12,"y":52},{"unified":"1f44d-1f3fc","native":"👍🏼","x":12,"y":53},{"unified":"1f44d-1f3fd","native":"👍🏽","x":12,"y":54},{"unified":"1f44d-1f3fe","native":"👍🏾","x":12,"y":55},{"unified":"1f44d-1f3ff","native":"👍🏿","x":12,"y":56}],"version":1},"-1":{"id":"-1","name":"Thumbs Down","keywords":["-1","thumbsdown","no","dislike","hand"],"skins":[{"unified":"1f44e","native":"👎","x":12,"y":57},{"unified":"1f44e-1f3fb","native":"👎🏻","x":12,"y":58},{"unified":"1f44e-1f3fc","native":"👎🏼","x":12,"y":59},{"unified":"1f44e-1f3fd","native":"👎🏽","x":12,"y":60},{"unified":"1f44e-1f3fe","native":"👎🏾","x":13,"y":0},{"unified":"1f44e-1f3ff","native":"👎🏿","x":13,"y":1}],"version":1},"fist":{"id":"fist","name":"Raised Fist","keywords":["fingers","hand","grasp"],"skins":[{"unified":"270a","native":"✊","x":58,"y":58},{"unified":"270a-1f3fb","native":"✊🏻","x":58,"y":59},{"unified":"270a-1f3fc","native":"✊🏼","x":58,"y":60},{"unified":"270a-1f3fd","native":"✊🏽","x":59,"y":0},{"unified":"270a-1f3fe","native":"✊🏾","x":59,"y":1},{"unified":"270a-1f3ff","native":"✊🏿","x":59,"y":2}],"version":1},"facepunch":{"id":"facepunch","name":"Oncoming Fist","keywords":["facepunch","punch","angry","violence","hit","attack","hand"],"skins":[{"unified":"1f44a","native":"👊","x":12,"y":33},{"unified":"1f44a-1f3fb","native":"👊🏻","x":12,"y":34},{"unified":"1f44a-1f3fc","native":"👊🏼","x":12,"y":35},{"unified":"1f44a-1f3fd","native":"👊🏽","x":12,"y":36},{"unified":"1f44a-1f3fe","native":"👊🏾","x":12,"y":37},{"unified":"1f44a-1f3ff","native":"👊🏿","x":12,"y":38}],"version":1},"left-facing_fist":{"id":"left-facing_fist","name":"Left-Facing Fist","keywords":["left","facing","hand","fistbump"],"skins":[{"unified":"1f91b","native":"🤛","x":39,"y":25},{"unified":"1f91b-1f3fb","native":"🤛🏻","x":39,"y":26},{"unified":"1f91b-1f3fc","native":"🤛🏼","x":39,"y":27},{"unified":"1f91b-1f3fd","native":"🤛🏽","x":39,"y":28},{"unified":"1f91b-1f3fe","native":"🤛🏾","x":39,"y":29},{"unified":"1f91b-1f3ff","native":"🤛🏿","x":39,"y":30}],"version":3},"right-facing_fist":{"id":"right-facing_fist","name":"Right-Facing Fist","keywords":["right","facing","hand","fistbump"],"skins":[{"unified":"1f91c","native":"🤜","x":39,"y":31},{"unified":"1f91c-1f3fb","native":"🤜🏻","x":39,"y":32},{"unified":"1f91c-1f3fc","native":"🤜🏼","x":39,"y":33},{"unified":"1f91c-1f3fd","native":"🤜🏽","x":39,"y":34},{"unified":"1f91c-1f3fe","native":"🤜🏾","x":39,"y":35},{"unified":"1f91c-1f3ff","native":"🤜🏿","x":39,"y":36}],"version":3},"clap":{"id":"clap","name":"Clapping Hands","keywords":["clap","praise","applause","congrats","yay"],"skins":[{"unified":"1f44f","native":"👏","x":13,"y":2},{"unified":"1f44f-1f3fb","native":"👏🏻","x":13,"y":3},{"unified":"1f44f-1f3fc","native":"👏🏼","x":13,"y":4},{"unified":"1f44f-1f3fd","native":"👏🏽","x":13,"y":5},{"unified":"1f44f-1f3fe","native":"👏🏾","x":13,"y":6},{"unified":"1f44f-1f3ff","native":"👏🏿","x":13,"y":7}],"version":1},"raised_hands":{"id":"raised_hands","name":"Raising Hands","keywords":["raised","gesture","hooray","yea","celebration"],"skins":[{"unified":"1f64c","native":"🙌","x":34,"y":46},{"unified":"1f64c-1f3fb","native":"🙌🏻","x":34,"y":47},{"unified":"1f64c-1f3fc","native":"🙌🏼","x":34,"y":48},{"unified":"1f64c-1f3fd","native":"🙌🏽","x":34,"y":49},{"unified":"1f64c-1f3fe","native":"🙌🏾","x":34,"y":50},{"unified":"1f64c-1f3ff","native":"🙌🏿","x":34,"y":51}],"version":1},"heart_hands":{"id":"heart_hands","name":"Heart Hands","keywords":["love","appreciation","support"],"skins":[{"unified":"1faf6","native":"🫶","x":56,"y":14},{"unified":"1faf6-1f3fb","native":"🫶🏻","x":56,"y":15},{"unified":"1faf6-1f3fc","native":"🫶🏼","x":56,"y":16},{"unified":"1faf6-1f3fd","native":"🫶🏽","x":56,"y":17},{"unified":"1faf6-1f3fe","native":"🫶🏾","x":56,"y":18},{"unified":"1faf6-1f3ff","native":"🫶🏿","x":56,"y":19}],"version":14},"open_hands":{"id":"open_hands","name":"Open Hands","keywords":["fingers","butterfly"],"skins":[{"unified":"1f450","native":"👐","x":13,"y":8},{"unified":"1f450-1f3fb","native":"👐🏻","x":13,"y":9},{"unified":"1f450-1f3fc","native":"👐🏼","x":13,"y":10},{"unified":"1f450-1f3fd","native":"👐🏽","x":13,"y":11},{"unified":"1f450-1f3fe","native":"👐🏾","x":13,"y":12},{"unified":"1f450-1f3ff","native":"👐🏿","x":13,"y":13}],"version":1},"palms_up_together":{"id":"palms_up_together","name":"Palms Up Together","keywords":["hands","gesture","cupped","prayer"],"skins":[{"unified":"1f932","native":"🤲","x":40,"y":59},{"unified":"1f932-1f3fb","native":"🤲🏻","x":40,"y":60},{"unified":"1f932-1f3fc","native":"🤲🏼","x":41,"y":0},{"unified":"1f932-1f3fd","native":"🤲🏽","x":41,"y":1},{"unified":"1f932-1f3fe","native":"🤲🏾","x":41,"y":2},{"unified":"1f932-1f3ff","native":"🤲🏿","x":41,"y":3}],"version":5},"handshake":{"id":"handshake","name":"Handshake","keywords":["agreement","shake"],"skins":[{"unified":"1f91d","native":"🤝","x":39,"y":37},{"unified":"1f91d-1f3fb","native":"🤝🏻","x":39,"y":38},{"unified":"1f91d-1f3fc","native":"🤝🏼","x":39,"y":39},{"unified":"1f91d-1f3fd","native":"🤝🏽","x":39,"y":40},{"unified":"1f91d-1f3fe","native":"🤝🏾","x":39,"y":41},{"unified":"1f91d-1f3ff","native":"🤝🏿","x":39,"y":42}],"version":3},"pray":{"id":"pray","name":"Folded Hands","keywords":["pray","please","hope","wish","namaste","highfive","high","five","thank","you","thanks","appreciate"],"skins":[{"unified":"1f64f","native":"🙏","x":35,"y":27},{"unified":"1f64f-1f3fb","native":"🙏🏻","x":35,"y":28},{"unified":"1f64f-1f3fc","native":"🙏🏼","x":35,"y":29},{"unified":"1f64f-1f3fd","native":"🙏🏽","x":35,"y":30},{"unified":"1f64f-1f3fe","native":"🙏🏾","x":35,"y":31},{"unified":"1f64f-1f3ff","native":"🙏🏿","x":35,"y":32}],"version":1},"writing_hand":{"id":"writing_hand","name":"Writing Hand","keywords":["lower","left","ballpoint","pen","stationery","write","compose"],"skins":[{"unified":"270d-fe0f","native":"✍️","x":59,"y":15},{"unified":"270d-1f3fb","native":"✍🏻","x":59,"y":16},{"unified":"270d-1f3fc","native":"✍🏼","x":59,"y":17},{"unified":"270d-1f3fd","native":"✍🏽","x":59,"y":18},{"unified":"270d-1f3fe","native":"✍🏾","x":59,"y":19},{"unified":"270d-1f3ff","native":"✍🏿","x":59,"y":20}],"version":1},"nail_care":{"id":"nail_care","name":"Nail Polish","keywords":["care","beauty","manicure","finger","fashion"],"skins":[{"unified":"1f485","native":"💅","x":25,"y":54},{"unified":"1f485-1f3fb","native":"💅🏻","x":25,"y":55},{"unified":"1f485-1f3fc","native":"💅🏼","x":25,"y":56},{"unified":"1f485-1f3fd","native":"💅🏽","x":25,"y":57},{"unified":"1f485-1f3fe","native":"💅🏾","x":25,"y":58},{"unified":"1f485-1f3ff","native":"💅🏿","x":25,"y":59}],"version":1},"selfie":{"id":"selfie","name":"Selfie","keywords":["camera","phone"],"skins":[{"unified":"1f933","native":"🤳","x":41,"y":4},{"unified":"1f933-1f3fb","native":"🤳🏻","x":41,"y":5},{"unified":"1f933-1f3fc","native":"🤳🏼","x":41,"y":6},{"unified":"1f933-1f3fd","native":"🤳🏽","x":41,"y":7},{"unified":"1f933-1f3fe","native":"🤳🏾","x":41,"y":8},{"unified":"1f933-1f3ff","native":"🤳🏿","x":41,"y":9}],"version":3},"muscle":{"id":"muscle","name":"Flexed Biceps","keywords":["muscle","arm","flex","hand","summer","strong"],"skins":[{"unified":"1f4aa","native":"💪","x":27,"y":58},{"unified":"1f4aa-1f3fb","native":"💪🏻","x":27,"y":59},{"unified":"1f4aa-1f3fc","native":"💪🏼","x":27,"y":60},{"unified":"1f4aa-1f3fd","native":"💪🏽","x":28,"y":0},{"unified":"1f4aa-1f3fe","native":"💪🏾","x":28,"y":1},{"unified":"1f4aa-1f3ff","native":"💪🏿","x":28,"y":2}],"version":1},"mechanical_arm":{"id":"mechanical_arm","name":"Mechanical Arm","keywords":["accessibility"],"skins":[{"unified":"1f9be","native":"🦾","x":46,"y":5}],"version":12},"mechanical_leg":{"id":"mechanical_leg","name":"Mechanical Leg","keywords":["accessibility"],"skins":[{"unified":"1f9bf","native":"🦿","x":46,"y":6}],"version":12},"leg":{"id":"leg","name":"Leg","keywords":["kick","limb"],"skins":[{"unified":"1f9b5","native":"🦵","x":45,"y":8},{"unified":"1f9b5-1f3fb","native":"🦵🏻","x":45,"y":9},{"unified":"1f9b5-1f3fc","native":"🦵🏼","x":45,"y":10},{"unified":"1f9b5-1f3fd","native":"🦵🏽","x":45,"y":11},{"unified":"1f9b5-1f3fe","native":"🦵🏾","x":45,"y":12},{"unified":"1f9b5-1f3ff","native":"🦵🏿","x":45,"y":13}],"version":11},"foot":{"id":"foot","name":"Foot","keywords":["kick","stomp"],"skins":[{"unified":"1f9b6","native":"🦶","x":45,"y":14},{"unified":"1f9b6-1f3fb","native":"🦶🏻","x":45,"y":15},{"unified":"1f9b6-1f3fc","native":"🦶🏼","x":45,"y":16},{"unified":"1f9b6-1f3fd","native":"🦶🏽","x":45,"y":17},{"unified":"1f9b6-1f3fe","native":"🦶🏾","x":45,"y":18},{"unified":"1f9b6-1f3ff","native":"🦶🏿","x":45,"y":19}],"version":11},"ear":{"id":"ear","name":"Ear","keywords":["face","hear","sound","listen"],"skins":[{"unified":"1f442","native":"👂","x":11,"y":56},{"unified":"1f442-1f3fb","native":"👂🏻","x":11,"y":57},{"unified":"1f442-1f3fc","native":"👂🏼","x":11,"y":58},{"unified":"1f442-1f3fd","native":"👂🏽","x":11,"y":59},{"unified":"1f442-1f3fe","native":"👂🏾","x":11,"y":60},{"unified":"1f442-1f3ff","native":"👂🏿","x":12,"y":0}],"version":1},"ear_with_hearing_aid":{"id":"ear_with_hearing_aid","name":"Ear with Hearing Aid","keywords":["accessibility"],"skins":[{"unified":"1f9bb","native":"🦻","x":45,"y":58},{"unified":"1f9bb-1f3fb","native":"🦻🏻","x":45,"y":59},{"unified":"1f9bb-1f3fc","native":"🦻🏼","x":45,"y":60},{"unified":"1f9bb-1f3fd","native":"🦻🏽","x":46,"y":0},{"unified":"1f9bb-1f3fe","native":"🦻🏾","x":46,"y":1},{"unified":"1f9bb-1f3ff","native":"🦻🏿","x":46,"y":2}],"version":12},"nose":{"id":"nose","name":"Nose","keywords":["smell","sniff"],"skins":[{"unified":"1f443","native":"👃","x":12,"y":1},{"unified":"1f443-1f3fb","native":"👃🏻","x":12,"y":2},{"unified":"1f443-1f3fc","native":"👃🏼","x":12,"y":3},{"unified":"1f443-1f3fd","native":"👃🏽","x":12,"y":4},{"unified":"1f443-1f3fe","native":"👃🏾","x":12,"y":5},{"unified":"1f443-1f3ff","native":"👃🏿","x":12,"y":6}],"version":1},"brain":{"id":"brain","name":"Brain","keywords":["smart","intelligent"],"skins":[{"unified":"1f9e0","native":"🧠","x":53,"y":16}],"version":5},"anatomical_heart":{"id":"anatomical_heart","name":"Anatomical Heart","keywords":["health","heartbeat"],"skins":[{"unified":"1fac0","native":"🫀","x":54,"y":56}],"version":13},"lungs":{"id":"lungs","name":"Lungs","keywords":["breathe"],"skins":[{"unified":"1fac1","native":"🫁","x":54,"y":57}],"version":13},"tooth":{"id":"tooth","name":"Tooth","keywords":["teeth","dentist"],"skins":[{"unified":"1f9b7","native":"🦷","x":45,"y":20}],"version":11},"bone":{"id":"bone","name":"Bone","keywords":["skeleton"],"skins":[{"unified":"1f9b4","native":"🦴","x":45,"y":7}],"version":11},"eyes":{"id":"eyes","name":"Eyes","keywords":["look","watch","stalk","peek","see"],"skins":[{"unified":"1f440","native":"👀","x":11,"y":53}],"version":1},"eye":{"id":"eye","name":"Eye","keywords":["face","look","see","watch","stare"],"skins":[{"unified":"1f441-fe0f","native":"👁️","x":11,"y":55}],"version":1},"tongue":{"id":"tongue","name":"Tongue","keywords":["mouth","playful"],"skins":[{"unified":"1f445","native":"👅","x":12,"y":8}],"version":1},"lips":{"id":"lips","name":"Mouth","keywords":["lips","kiss"],"skins":[{"unified":"1f444","native":"👄","x":12,"y":7}],"version":1},"biting_lip":{"id":"biting_lip","name":"Biting Lip","keywords":["flirt","sexy","pain","worry"],"skins":[{"unified":"1fae6","native":"🫦","x":55,"y":36}],"version":14},"baby":{"id":"baby","name":"Baby","keywords":["child","boy","girl","toddler"],"skins":[{"unified":"1f476","native":"👶","x":24,"y":29},{"unified":"1f476-1f3fb","native":"👶🏻","x":24,"y":30},{"unified":"1f476-1f3fc","native":"👶🏼","x":24,"y":31},{"unified":"1f476-1f3fd","native":"👶🏽","x":24,"y":32},{"unified":"1f476-1f3fe","native":"👶🏾","x":24,"y":33},{"unified":"1f476-1f3ff","native":"👶🏿","x":24,"y":34}],"version":1},"child":{"id":"child","name":"Child","keywords":["gender","neutral","young"],"skins":[{"unified":"1f9d2","native":"🧒","x":50,"y":13},{"unified":"1f9d2-1f3fb","native":"🧒🏻","x":50,"y":14},{"unified":"1f9d2-1f3fc","native":"🧒🏼","x":50,"y":15},{"unified":"1f9d2-1f3fd","native":"🧒🏽","x":50,"y":16},{"unified":"1f9d2-1f3fe","native":"🧒🏾","x":50,"y":17},{"unified":"1f9d2-1f3ff","native":"🧒🏿","x":50,"y":18}],"version":5},"boy":{"id":"boy","name":"Boy","keywords":["man","male","guy","teenager"],"skins":[{"unified":"1f466","native":"👦","x":13,"y":35},{"unified":"1f466-1f3fb","native":"👦🏻","x":13,"y":36},{"unified":"1f466-1f3fc","native":"👦🏼","x":13,"y":37},{"unified":"1f466-1f3fd","native":"👦🏽","x":13,"y":38},{"unified":"1f466-1f3fe","native":"👦🏾","x":13,"y":39},{"unified":"1f466-1f3ff","native":"👦🏿","x":13,"y":40}],"version":1},"girl":{"id":"girl","name":"Girl","keywords":["female","woman","teenager"],"skins":[{"unified":"1f467","native":"👧","x":13,"y":41},{"unified":"1f467-1f3fb","native":"👧🏻","x":13,"y":42},{"unified":"1f467-1f3fc","native":"👧🏼","x":13,"y":43},{"unified":"1f467-1f3fd","native":"👧🏽","x":13,"y":44},{"unified":"1f467-1f3fe","native":"👧🏾","x":13,"y":45},{"unified":"1f467-1f3ff","native":"👧🏿","x":13,"y":46}],"version":1},"adult":{"id":"adult","name":"Adult","keywords":["person","gender","neutral"],"skins":[{"unified":"1f9d1","native":"🧑","x":50,"y":7},{"unified":"1f9d1-1f3fb","native":"🧑🏻","x":50,"y":8},{"unified":"1f9d1-1f3fc","native":"🧑🏼","x":50,"y":9},{"unified":"1f9d1-1f3fd","native":"🧑🏽","x":50,"y":10},{"unified":"1f9d1-1f3fe","native":"🧑🏾","x":50,"y":11},{"unified":"1f9d1-1f3ff","native":"🧑🏿","x":50,"y":12}],"version":5},"person_with_blond_hair":{"id":"person_with_blond_hair","name":"Person Blond Hair","keywords":["with","hairstyle"],"skins":[{"unified":"1f471","native":"👱","x":23,"y":48},{"unified":"1f471-1f3fb","native":"👱🏻","x":23,"y":49},{"unified":"1f471-1f3fc","native":"👱🏼","x":23,"y":50},{"unified":"1f471-1f3fd","native":"👱🏽","x":23,"y":51},{"unified":"1f471-1f3fe","native":"👱🏾","x":23,"y":52},{"unified":"1f471-1f3ff","native":"👱🏿","x":23,"y":53}],"version":1},"man":{"id":"man","name":"Man","keywords":["mustache","father","dad","guy","classy","sir","moustache"],"skins":[{"unified":"1f468","native":"👨","x":17,"y":14},{"unified":"1f468-1f3fb","native":"👨🏻","x":17,"y":15},{"unified":"1f468-1f3fc","native":"👨🏼","x":17,"y":16},{"unified":"1f468-1f3fd","native":"👨🏽","x":17,"y":17},{"unified":"1f468-1f3fe","native":"👨🏾","x":17,"y":18},{"unified":"1f468-1f3ff","native":"👨🏿","x":17,"y":19}],"version":1},"bearded_person":{"id":"bearded_person","name":"Person Beard","keywords":["bearded","man","bewhiskered"],"skins":[{"unified":"1f9d4","native":"🧔","x":50,"y":37},{"unified":"1f9d4-1f3fb","native":"🧔🏻","x":50,"y":38},{"unified":"1f9d4-1f3fc","native":"🧔🏼","x":50,"y":39},{"unified":"1f9d4-1f3fd","native":"🧔🏽","x":50,"y":40},{"unified":"1f9d4-1f3fe","native":"🧔🏾","x":50,"y":41},{"unified":"1f9d4-1f3ff","native":"🧔🏿","x":50,"y":42}],"version":5},"man_with_beard":{"id":"man_with_beard","name":"Man: Beard","keywords":["man","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2642-fe0f","native":"🧔‍♂️","x":50,"y":31},{"unified":"1f9d4-1f3fb-200d-2642-fe0f","native":"🧔🏻‍♂️","x":50,"y":32},{"unified":"1f9d4-1f3fc-200d-2642-fe0f","native":"🧔🏼‍♂️","x":50,"y":33},{"unified":"1f9d4-1f3fd-200d-2642-fe0f","native":"🧔🏽‍♂️","x":50,"y":34},{"unified":"1f9d4-1f3fe-200d-2642-fe0f","native":"🧔🏾‍♂️","x":50,"y":35},{"unified":"1f9d4-1f3ff-200d-2642-fe0f","native":"🧔🏿‍♂️","x":50,"y":36}],"version":13.1},"woman_with_beard":{"id":"woman_with_beard","name":"Woman: Beard","keywords":["woman","with","facial","hair"],"skins":[{"unified":"1f9d4-200d-2640-fe0f","native":"🧔‍♀️","x":50,"y":25},{"unified":"1f9d4-1f3fb-200d-2640-fe0f","native":"🧔🏻‍♀️","x":50,"y":26},{"unified":"1f9d4-1f3fc-200d-2640-fe0f","native":"🧔🏼‍♀️","x":50,"y":27},{"unified":"1f9d4-1f3fd-200d-2640-fe0f","native":"🧔🏽‍♀️","x":50,"y":28},{"unified":"1f9d4-1f3fe-200d-2640-fe0f","native":"🧔🏾‍♀️","x":50,"y":29},{"unified":"1f9d4-1f3ff-200d-2640-fe0f","native":"🧔🏿‍♀️","x":50,"y":30}],"version":13.1},"red_haired_man":{"id":"red_haired_man","name":"Man: Red Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b0","native":"👨‍🦰","x":15,"y":30},{"unified":"1f468-1f3fb-200d-1f9b0","native":"👨🏻‍🦰","x":15,"y":31},{"unified":"1f468-1f3fc-200d-1f9b0","native":"👨🏼‍🦰","x":15,"y":32},{"unified":"1f468-1f3fd-200d-1f9b0","native":"👨🏽‍🦰","x":15,"y":33},{"unified":"1f468-1f3fe-200d-1f9b0","native":"👨🏾‍🦰","x":15,"y":34},{"unified":"1f468-1f3ff-200d-1f9b0","native":"👨🏿‍🦰","x":15,"y":35}],"version":11},"curly_haired_man":{"id":"curly_haired_man","name":"Man: Curly Hair","keywords":["haired","man","hairstyle"],"skins":[{"unified":"1f468-200d-1f9b1","native":"👨‍🦱","x":15,"y":36},{"unified":"1f468-1f3fb-200d-1f9b1","native":"👨🏻‍🦱","x":15,"y":37},{"unified":"1f468-1f3fc-200d-1f9b1","native":"👨🏼‍🦱","x":15,"y":38},{"unified":"1f468-1f3fd-200d-1f9b1","native":"👨🏽‍🦱","x":15,"y":39},{"unified":"1f468-1f3fe-200d-1f9b1","native":"👨🏾‍🦱","x":15,"y":40},{"unified":"1f468-1f3ff-200d-1f9b1","native":"👨🏿‍🦱","x":15,"y":41}],"version":11},"white_haired_man":{"id":"white_haired_man","name":"Man: White Hair","keywords":["haired","man","old","elder"],"skins":[{"unified":"1f468-200d-1f9b3","native":"👨‍🦳","x":15,"y":48},{"unified":"1f468-1f3fb-200d-1f9b3","native":"👨🏻‍🦳","x":15,"y":49},{"unified":"1f468-1f3fc-200d-1f9b3","native":"👨🏼‍🦳","x":15,"y":50},{"unified":"1f468-1f3fd-200d-1f9b3","native":"👨🏽‍🦳","x":15,"y":51},{"unified":"1f468-1f3fe-200d-1f9b3","native":"👨🏾‍🦳","x":15,"y":52},{"unified":"1f468-1f3ff-200d-1f9b3","native":"👨🏿‍🦳","x":15,"y":53}],"version":11},"bald_man":{"id":"bald_man","name":"Man: Bald","keywords":["man","hairless"],"skins":[{"unified":"1f468-200d-1f9b2","native":"👨‍🦲","x":15,"y":42},{"unified":"1f468-1f3fb-200d-1f9b2","native":"👨🏻‍🦲","x":15,"y":43},{"unified":"1f468-1f3fc-200d-1f9b2","native":"👨🏼‍🦲","x":15,"y":44},{"unified":"1f468-1f3fd-200d-1f9b2","native":"👨🏽‍🦲","x":15,"y":45},{"unified":"1f468-1f3fe-200d-1f9b2","native":"👨🏾‍🦲","x":15,"y":46},{"unified":"1f468-1f3ff-200d-1f9b2","native":"👨🏿‍🦲","x":15,"y":47}],"version":11},"woman":{"id":"woman","name":"Woman","keywords":["female","girls","lady"],"skins":[{"unified":"1f469","native":"👩","x":21,"y":34},{"unified":"1f469-1f3fb","native":"👩🏻","x":21,"y":35},{"unified":"1f469-1f3fc","native":"👩🏼","x":21,"y":36},{"unified":"1f469-1f3fd","native":"👩🏽","x":21,"y":37},{"unified":"1f469-1f3fe","native":"👩🏾","x":21,"y":38},{"unified":"1f469-1f3ff","native":"👩🏿","x":21,"y":39}],"version":1},"red_haired_woman":{"id":"red_haired_woman","name":"Woman: Red Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b0","native":"👩‍🦰","x":18,"y":59},{"unified":"1f469-1f3fb-200d-1f9b0","native":"👩🏻‍🦰","x":18,"y":60},{"unified":"1f469-1f3fc-200d-1f9b0","native":"👩🏼‍🦰","x":19,"y":0},{"unified":"1f469-1f3fd-200d-1f9b0","native":"👩🏽‍🦰","x":19,"y":1},{"unified":"1f469-1f3fe-200d-1f9b0","native":"👩🏾‍🦰","x":19,"y":2},{"unified":"1f469-1f3ff-200d-1f9b0","native":"👩🏿‍🦰","x":19,"y":3}],"version":11},"red_haired_person":{"id":"red_haired_person","name":"Person: Red Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b0","native":"🧑‍🦰","x":49,"y":14},{"unified":"1f9d1-1f3fb-200d-1f9b0","native":"🧑🏻‍🦰","x":49,"y":15},{"unified":"1f9d1-1f3fc-200d-1f9b0","native":"🧑🏼‍🦰","x":49,"y":16},{"unified":"1f9d1-1f3fd-200d-1f9b0","native":"🧑🏽‍🦰","x":49,"y":17},{"unified":"1f9d1-1f3fe-200d-1f9b0","native":"🧑🏾‍🦰","x":49,"y":18},{"unified":"1f9d1-1f3ff-200d-1f9b0","native":"🧑🏿‍🦰","x":49,"y":19}],"version":12.1},"curly_haired_woman":{"id":"curly_haired_woman","name":"Woman: Curly Hair","keywords":["haired","woman","hairstyle"],"skins":[{"unified":"1f469-200d-1f9b1","native":"👩‍🦱","x":19,"y":4},{"unified":"1f469-1f3fb-200d-1f9b1","native":"👩🏻‍🦱","x":19,"y":5},{"unified":"1f469-1f3fc-200d-1f9b1","native":"👩🏼‍🦱","x":19,"y":6},{"unified":"1f469-1f3fd-200d-1f9b1","native":"👩🏽‍🦱","x":19,"y":7},{"unified":"1f469-1f3fe-200d-1f9b1","native":"👩🏾‍🦱","x":19,"y":8},{"unified":"1f469-1f3ff-200d-1f9b1","native":"👩🏿‍🦱","x":19,"y":9}],"version":11},"curly_haired_person":{"id":"curly_haired_person","name":"Person: Curly Hair","keywords":["haired","person","hairstyle"],"skins":[{"unified":"1f9d1-200d-1f9b1","native":"🧑‍🦱","x":49,"y":20},{"unified":"1f9d1-1f3fb-200d-1f9b1","native":"🧑🏻‍🦱","x":49,"y":21},{"unified":"1f9d1-1f3fc-200d-1f9b1","native":"🧑🏼‍🦱","x":49,"y":22},{"unified":"1f9d1-1f3fd-200d-1f9b1","native":"🧑🏽‍🦱","x":49,"y":23},{"unified":"1f9d1-1f3fe-200d-1f9b1","native":"🧑🏾‍🦱","x":49,"y":24},{"unified":"1f9d1-1f3ff-200d-1f9b1","native":"🧑🏿‍🦱","x":49,"y":25}],"version":12.1},"white_haired_woman":{"id":"white_haired_woman","name":"Woman: White Hair","keywords":["haired","woman","old","elder"],"skins":[{"unified":"1f469-200d-1f9b3","native":"👩‍🦳","x":19,"y":16},{"unified":"1f469-1f3fb-200d-1f9b3","native":"👩🏻‍🦳","x":19,"y":17},{"unified":"1f469-1f3fc-200d-1f9b3","native":"👩🏼‍🦳","x":19,"y":18},{"unified":"1f469-1f3fd-200d-1f9b3","native":"👩🏽‍🦳","x":19,"y":19},{"unified":"1f469-1f3fe-200d-1f9b3","native":"👩🏾‍🦳","x":19,"y":20},{"unified":"1f469-1f3ff-200d-1f9b3","native":"👩🏿‍🦳","x":19,"y":21}],"version":11},"white_haired_person":{"id":"white_haired_person","name":"Person: White Hair","keywords":["haired","person","elder","old"],"skins":[{"unified":"1f9d1-200d-1f9b3","native":"🧑‍🦳","x":49,"y":32},{"unified":"1f9d1-1f3fb-200d-1f9b3","native":"🧑🏻‍🦳","x":49,"y":33},{"unified":"1f9d1-1f3fc-200d-1f9b3","native":"🧑🏼‍🦳","x":49,"y":34},{"unified":"1f9d1-1f3fd-200d-1f9b3","native":"🧑🏽‍🦳","x":49,"y":35},{"unified":"1f9d1-1f3fe-200d-1f9b3","native":"🧑🏾‍🦳","x":49,"y":36},{"unified":"1f9d1-1f3ff-200d-1f9b3","native":"🧑🏿‍🦳","x":49,"y":37}],"version":12.1},"bald_woman":{"id":"bald_woman","name":"Woman: Bald","keywords":["woman","hairless"],"skins":[{"unified":"1f469-200d-1f9b2","native":"👩‍🦲","x":19,"y":10},{"unified":"1f469-1f3fb-200d-1f9b2","native":"👩🏻‍🦲","x":19,"y":11},{"unified":"1f469-1f3fc-200d-1f9b2","native":"👩🏼‍🦲","x":19,"y":12},{"unified":"1f469-1f3fd-200d-1f9b2","native":"👩🏽‍🦲","x":19,"y":13},{"unified":"1f469-1f3fe-200d-1f9b2","native":"👩🏾‍🦲","x":19,"y":14},{"unified":"1f469-1f3ff-200d-1f9b2","native":"👩🏿‍🦲","x":19,"y":15}],"version":11},"bald_person":{"id":"bald_person","name":"Person: Bald","keywords":["person","hairless"],"skins":[{"unified":"1f9d1-200d-1f9b2","native":"🧑‍🦲","x":49,"y":26},{"unified":"1f9d1-1f3fb-200d-1f9b2","native":"🧑🏻‍🦲","x":49,"y":27},{"unified":"1f9d1-1f3fc-200d-1f9b2","native":"🧑🏼‍🦲","x":49,"y":28},{"unified":"1f9d1-1f3fd-200d-1f9b2","native":"🧑🏽‍🦲","x":49,"y":29},{"unified":"1f9d1-1f3fe-200d-1f9b2","native":"🧑🏾‍🦲","x":49,"y":30},{"unified":"1f9d1-1f3ff-200d-1f9b2","native":"🧑🏿‍🦲","x":49,"y":31}],"version":12.1},"blond-haired-woman":{"id":"blond-haired-woman","name":"Woman: Blond Hair","keywords":["haired-woman","woman","female","girl","blonde","person"],"skins":[{"unified":"1f471-200d-2640-fe0f","native":"👱‍♀️","x":23,"y":36},{"unified":"1f471-1f3fb-200d-2640-fe0f","native":"👱🏻‍♀️","x":23,"y":37},{"unified":"1f471-1f3fc-200d-2640-fe0f","native":"👱🏼‍♀️","x":23,"y":38},{"unified":"1f471-1f3fd-200d-2640-fe0f","native":"👱🏽‍♀️","x":23,"y":39},{"unified":"1f471-1f3fe-200d-2640-fe0f","native":"👱🏾‍♀️","x":23,"y":40},{"unified":"1f471-1f3ff-200d-2640-fe0f","native":"👱🏿‍♀️","x":23,"y":41}],"version":4},"blond-haired-man":{"id":"blond-haired-man","name":"Man: Blond Hair","keywords":["haired-man","man","male","boy","blonde","guy","person"],"skins":[{"unified":"1f471-200d-2642-fe0f","native":"👱‍♂️","x":23,"y":42},{"unified":"1f471-1f3fb-200d-2642-fe0f","native":"👱🏻‍♂️","x":23,"y":43},{"unified":"1f471-1f3fc-200d-2642-fe0f","native":"👱🏼‍♂️","x":23,"y":44},{"unified":"1f471-1f3fd-200d-2642-fe0f","native":"👱🏽‍♂️","x":23,"y":45},{"unified":"1f471-1f3fe-200d-2642-fe0f","native":"👱🏾‍♂️","x":23,"y":46},{"unified":"1f471-1f3ff-200d-2642-fe0f","native":"👱🏿‍♂️","x":23,"y":47}],"version":4},"older_adult":{"id":"older_adult","name":"Older Adult","keywords":["person","human","elder","senior","gender","neutral"],"skins":[{"unified":"1f9d3","native":"🧓","x":50,"y":19},{"unified":"1f9d3-1f3fb","native":"🧓🏻","x":50,"y":20},{"unified":"1f9d3-1f3fc","native":"🧓🏼","x":50,"y":21},{"unified":"1f9d3-1f3fd","native":"🧓🏽","x":50,"y":22},{"unified":"1f9d3-1f3fe","native":"🧓🏾","x":50,"y":23},{"unified":"1f9d3-1f3ff","native":"🧓🏿","x":50,"y":24}],"version":5},"older_man":{"id":"older_man","name":"Old Man","keywords":["older","human","male","men","elder","senior"],"skins":[{"unified":"1f474","native":"👴","x":24,"y":17},{"unified":"1f474-1f3fb","native":"👴🏻","x":24,"y":18},{"unified":"1f474-1f3fc","native":"👴🏼","x":24,"y":19},{"unified":"1f474-1f3fd","native":"👴🏽","x":24,"y":20},{"unified":"1f474-1f3fe","native":"👴🏾","x":24,"y":21},{"unified":"1f474-1f3ff","native":"👴🏿","x":24,"y":22}],"version":1},"older_woman":{"id":"older_woman","name":"Old Woman","keywords":["older","human","female","women","lady","elder","senior"],"skins":[{"unified":"1f475","native":"👵","x":24,"y":23},{"unified":"1f475-1f3fb","native":"👵🏻","x":24,"y":24},{"unified":"1f475-1f3fc","native":"👵🏼","x":24,"y":25},{"unified":"1f475-1f3fd","native":"👵🏽","x":24,"y":26},{"unified":"1f475-1f3fe","native":"👵🏾","x":24,"y":27},{"unified":"1f475-1f3ff","native":"👵🏿","x":24,"y":28}],"version":1},"person_frowning":{"id":"person_frowning","name":"Person Frowning","keywords":["worried"],"skins":[{"unified":"1f64d","native":"🙍","x":35,"y":3},{"unified":"1f64d-1f3fb","native":"🙍🏻","x":35,"y":4},{"unified":"1f64d-1f3fc","native":"🙍🏼","x":35,"y":5},{"unified":"1f64d-1f3fd","native":"🙍🏽","x":35,"y":6},{"unified":"1f64d-1f3fe","native":"🙍🏾","x":35,"y":7},{"unified":"1f64d-1f3ff","native":"🙍🏿","x":35,"y":8}],"version":1},"man-frowning":{"id":"man-frowning","name":"Man Frowning","keywords":["male","boy","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2642-fe0f","native":"🙍‍♂️","x":34,"y":58},{"unified":"1f64d-1f3fb-200d-2642-fe0f","native":"🙍🏻‍♂️","x":34,"y":59},{"unified":"1f64d-1f3fc-200d-2642-fe0f","native":"🙍🏼‍♂️","x":34,"y":60},{"unified":"1f64d-1f3fd-200d-2642-fe0f","native":"🙍🏽‍♂️","x":35,"y":0},{"unified":"1f64d-1f3fe-200d-2642-fe0f","native":"🙍🏾‍♂️","x":35,"y":1},{"unified":"1f64d-1f3ff-200d-2642-fe0f","native":"🙍🏿‍♂️","x":35,"y":2}],"version":4},"woman-frowning":{"id":"woman-frowning","name":"Woman Frowning","keywords":["female","girl","sad","depressed","discouraged","unhappy"],"skins":[{"unified":"1f64d-200d-2640-fe0f","native":"🙍‍♀️","x":34,"y":52},{"unified":"1f64d-1f3fb-200d-2640-fe0f","native":"🙍🏻‍♀️","x":34,"y":53},{"unified":"1f64d-1f3fc-200d-2640-fe0f","native":"🙍🏼‍♀️","x":34,"y":54},{"unified":"1f64d-1f3fd-200d-2640-fe0f","native":"🙍🏽‍♀️","x":34,"y":55},{"unified":"1f64d-1f3fe-200d-2640-fe0f","native":"🙍🏾‍♀️","x":34,"y":56},{"unified":"1f64d-1f3ff-200d-2640-fe0f","native":"🙍🏿‍♀️","x":34,"y":57}],"version":4},"person_with_pouting_face":{"id":"person_with_pouting_face","name":"Person Pouting","keywords":["with","face","upset"],"skins":[{"unified":"1f64e","native":"🙎","x":35,"y":21},{"unified":"1f64e-1f3fb","native":"🙎🏻","x":35,"y":22},{"unified":"1f64e-1f3fc","native":"🙎🏼","x":35,"y":23},{"unified":"1f64e-1f3fd","native":"🙎🏽","x":35,"y":24},{"unified":"1f64e-1f3fe","native":"🙎🏾","x":35,"y":25},{"unified":"1f64e-1f3ff","native":"🙎🏿","x":35,"y":26}],"version":1},"man-pouting":{"id":"man-pouting","name":"Man Pouting","keywords":["male","boy"],"skins":[{"unified":"1f64e-200d-2642-fe0f","native":"🙎‍♂️","x":35,"y":15},{"unified":"1f64e-1f3fb-200d-2642-fe0f","native":"🙎🏻‍♂️","x":35,"y":16},{"unified":"1f64e-1f3fc-200d-2642-fe0f","native":"🙎🏼‍♂️","x":35,"y":17},{"unified":"1f64e-1f3fd-200d-2642-fe0f","native":"🙎🏽‍♂️","x":35,"y":18},{"unified":"1f64e-1f3fe-200d-2642-fe0f","native":"🙎🏾‍♂️","x":35,"y":19},{"unified":"1f64e-1f3ff-200d-2642-fe0f","native":"🙎🏿‍♂️","x":35,"y":20}],"version":4},"woman-pouting":{"id":"woman-pouting","name":"Woman Pouting","keywords":["female","girl"],"skins":[{"unified":"1f64e-200d-2640-fe0f","native":"🙎‍♀️","x":35,"y":9},{"unified":"1f64e-1f3fb-200d-2640-fe0f","native":"🙎🏻‍♀️","x":35,"y":10},{"unified":"1f64e-1f3fc-200d-2640-fe0f","native":"🙎🏼‍♀️","x":35,"y":11},{"unified":"1f64e-1f3fd-200d-2640-fe0f","native":"🙎🏽‍♀️","x":35,"y":12},{"unified":"1f64e-1f3fe-200d-2640-fe0f","native":"🙎🏾‍♀️","x":35,"y":13},{"unified":"1f64e-1f3ff-200d-2640-fe0f","native":"🙎🏿‍♀️","x":35,"y":14}],"version":4},"no_good":{"id":"no_good","name":"Person Gesturing No","keywords":["good","decline"],"skins":[{"unified":"1f645","native":"🙅","x":33,"y":44},{"unified":"1f645-1f3fb","native":"🙅🏻","x":33,"y":45},{"unified":"1f645-1f3fc","native":"🙅🏼","x":33,"y":46},{"unified":"1f645-1f3fd","native":"🙅🏽","x":33,"y":47},{"unified":"1f645-1f3fe","native":"🙅🏾","x":33,"y":48},{"unified":"1f645-1f3ff","native":"🙅🏿","x":33,"y":49}],"version":1},"man-gesturing-no":{"id":"man-gesturing-no","name":"Man Gesturing No","keywords":["gesturing-no","male","boy","nope"],"skins":[{"unified":"1f645-200d-2642-fe0f","native":"🙅‍♂️","x":33,"y":38},{"unified":"1f645-1f3fb-200d-2642-fe0f","native":"🙅🏻‍♂️","x":33,"y":39},{"unified":"1f645-1f3fc-200d-2642-fe0f","native":"🙅🏼‍♂️","x":33,"y":40},{"unified":"1f645-1f3fd-200d-2642-fe0f","native":"🙅🏽‍♂️","x":33,"y":41},{"unified":"1f645-1f3fe-200d-2642-fe0f","native":"🙅🏾‍♂️","x":33,"y":42},{"unified":"1f645-1f3ff-200d-2642-fe0f","native":"🙅🏿‍♂️","x":33,"y":43}],"version":4},"woman-gesturing-no":{"id":"woman-gesturing-no","name":"Woman Gesturing No","keywords":["gesturing-no","female","girl","nope"],"skins":[{"unified":"1f645-200d-2640-fe0f","native":"🙅‍♀️","x":33,"y":32},{"unified":"1f645-1f3fb-200d-2640-fe0f","native":"🙅🏻‍♀️","x":33,"y":33},{"unified":"1f645-1f3fc-200d-2640-fe0f","native":"🙅🏼‍♀️","x":33,"y":34},{"unified":"1f645-1f3fd-200d-2640-fe0f","native":"🙅🏽‍♀️","x":33,"y":35},{"unified":"1f645-1f3fe-200d-2640-fe0f","native":"🙅🏾‍♀️","x":33,"y":36},{"unified":"1f645-1f3ff-200d-2640-fe0f","native":"🙅🏿‍♀️","x":33,"y":37}],"version":4},"ok_woman":{"id":"ok_woman","name":"Person Gesturing Ok","keywords":["woman","agree"],"skins":[{"unified":"1f646","native":"🙆","x":34,"y":1},{"unified":"1f646-1f3fb","native":"🙆🏻","x":34,"y":2},{"unified":"1f646-1f3fc","native":"🙆🏼","x":34,"y":3},{"unified":"1f646-1f3fd","native":"🙆🏽","x":34,"y":4},{"unified":"1f646-1f3fe","native":"🙆🏾","x":34,"y":5},{"unified":"1f646-1f3ff","native":"🙆🏿","x":34,"y":6}],"version":1},"man-gesturing-ok":{"id":"man-gesturing-ok","name":"Man Gesturing Ok","keywords":["gesturing-ok","men","boy","male","blue","human"],"skins":[{"unified":"1f646-200d-2642-fe0f","native":"🙆‍♂️","x":33,"y":56},{"unified":"1f646-1f3fb-200d-2642-fe0f","native":"🙆🏻‍♂️","x":33,"y":57},{"unified":"1f646-1f3fc-200d-2642-fe0f","native":"🙆🏼‍♂️","x":33,"y":58},{"unified":"1f646-1f3fd-200d-2642-fe0f","native":"🙆🏽‍♂️","x":33,"y":59},{"unified":"1f646-1f3fe-200d-2642-fe0f","native":"🙆🏾‍♂️","x":33,"y":60},{"unified":"1f646-1f3ff-200d-2642-fe0f","native":"🙆🏿‍♂️","x":34,"y":0}],"version":4},"woman-gesturing-ok":{"id":"woman-gesturing-ok","name":"Woman Gesturing Ok","keywords":["gesturing-ok","women","girl","female","pink","human"],"skins":[{"unified":"1f646-200d-2640-fe0f","native":"🙆‍♀️","x":33,"y":50},{"unified":"1f646-1f3fb-200d-2640-fe0f","native":"🙆🏻‍♀️","x":33,"y":51},{"unified":"1f646-1f3fc-200d-2640-fe0f","native":"🙆🏼‍♀️","x":33,"y":52},{"unified":"1f646-1f3fd-200d-2640-fe0f","native":"🙆🏽‍♀️","x":33,"y":53},{"unified":"1f646-1f3fe-200d-2640-fe0f","native":"🙆🏾‍♀️","x":33,"y":54},{"unified":"1f646-1f3ff-200d-2640-fe0f","native":"🙆🏿‍♀️","x":33,"y":55}],"version":4},"information_desk_person":{"id":"information_desk_person","name":"Person Tipping Hand","keywords":["information","desk"],"skins":[{"unified":"1f481","native":"💁","x":25,"y":23},{"unified":"1f481-1f3fb","native":"💁🏻","x":25,"y":24},{"unified":"1f481-1f3fc","native":"💁🏼","x":25,"y":25},{"unified":"1f481-1f3fd","native":"💁🏽","x":25,"y":26},{"unified":"1f481-1f3fe","native":"💁🏾","x":25,"y":27},{"unified":"1f481-1f3ff","native":"💁🏿","x":25,"y":28}],"version":1},"man-tipping-hand":{"id":"man-tipping-hand","name":"Man Tipping Hand","keywords":["tipping-hand","male","boy","human","information"],"skins":[{"unified":"1f481-200d-2642-fe0f","native":"💁‍♂️","x":25,"y":17},{"unified":"1f481-1f3fb-200d-2642-fe0f","native":"💁🏻‍♂️","x":25,"y":18},{"unified":"1f481-1f3fc-200d-2642-fe0f","native":"💁🏼‍♂️","x":25,"y":19},{"unified":"1f481-1f3fd-200d-2642-fe0f","native":"💁🏽‍♂️","x":25,"y":20},{"unified":"1f481-1f3fe-200d-2642-fe0f","native":"💁🏾‍♂️","x":25,"y":21},{"unified":"1f481-1f3ff-200d-2642-fe0f","native":"💁🏿‍♂️","x":25,"y":22}],"version":4},"woman-tipping-hand":{"id":"woman-tipping-hand","name":"Woman Tipping Hand","keywords":["tipping-hand","female","girl","human","information"],"skins":[{"unified":"1f481-200d-2640-fe0f","native":"💁‍♀️","x":25,"y":11},{"unified":"1f481-1f3fb-200d-2640-fe0f","native":"💁🏻‍♀️","x":25,"y":12},{"unified":"1f481-1f3fc-200d-2640-fe0f","native":"💁🏼‍♀️","x":25,"y":13},{"unified":"1f481-1f3fd-200d-2640-fe0f","native":"💁🏽‍♀️","x":25,"y":14},{"unified":"1f481-1f3fe-200d-2640-fe0f","native":"💁🏾‍♀️","x":25,"y":15},{"unified":"1f481-1f3ff-200d-2640-fe0f","native":"💁🏿‍♀️","x":25,"y":16}],"version":4},"raising_hand":{"id":"raising_hand","name":"Person Raising Hand","keywords":["question"],"skins":[{"unified":"1f64b","native":"🙋","x":34,"y":40},{"unified":"1f64b-1f3fb","native":"🙋🏻","x":34,"y":41},{"unified":"1f64b-1f3fc","native":"🙋🏼","x":34,"y":42},{"unified":"1f64b-1f3fd","native":"🙋🏽","x":34,"y":43},{"unified":"1f64b-1f3fe","native":"🙋🏾","x":34,"y":44},{"unified":"1f64b-1f3ff","native":"🙋🏿","x":34,"y":45}],"version":1},"man-raising-hand":{"id":"man-raising-hand","name":"Man Raising Hand","keywords":["raising-hand","male","boy"],"skins":[{"unified":"1f64b-200d-2642-fe0f","native":"🙋‍♂️","x":34,"y":34},{"unified":"1f64b-1f3fb-200d-2642-fe0f","native":"🙋🏻‍♂️","x":34,"y":35},{"unified":"1f64b-1f3fc-200d-2642-fe0f","native":"🙋🏼‍♂️","x":34,"y":36},{"unified":"1f64b-1f3fd-200d-2642-fe0f","native":"🙋🏽‍♂️","x":34,"y":37},{"unified":"1f64b-1f3fe-200d-2642-fe0f","native":"🙋🏾‍♂️","x":34,"y":38},{"unified":"1f64b-1f3ff-200d-2642-fe0f","native":"🙋🏿‍♂️","x":34,"y":39}],"version":4},"woman-raising-hand":{"id":"woman-raising-hand","name":"Woman Raising Hand","keywords":["raising-hand","female","girl"],"skins":[{"unified":"1f64b-200d-2640-fe0f","native":"🙋‍♀️","x":34,"y":28},{"unified":"1f64b-1f3fb-200d-2640-fe0f","native":"🙋🏻‍♀️","x":34,"y":29},{"unified":"1f64b-1f3fc-200d-2640-fe0f","native":"🙋🏼‍♀️","x":34,"y":30},{"unified":"1f64b-1f3fd-200d-2640-fe0f","native":"🙋🏽‍♀️","x":34,"y":31},{"unified":"1f64b-1f3fe-200d-2640-fe0f","native":"🙋🏾‍♀️","x":34,"y":32},{"unified":"1f64b-1f3ff-200d-2640-fe0f","native":"🙋🏿‍♀️","x":34,"y":33}],"version":4},"deaf_person":{"id":"deaf_person","name":"Deaf Person","keywords":["accessibility"],"skins":[{"unified":"1f9cf","native":"🧏","x":47,"y":7},{"unified":"1f9cf-1f3fb","native":"🧏🏻","x":47,"y":8},{"unified":"1f9cf-1f3fc","native":"🧏🏼","x":47,"y":9},{"unified":"1f9cf-1f3fd","native":"🧏🏽","x":47,"y":10},{"unified":"1f9cf-1f3fe","native":"🧏🏾","x":47,"y":11},{"unified":"1f9cf-1f3ff","native":"🧏🏿","x":47,"y":12}],"version":12},"deaf_man":{"id":"deaf_man","name":"Deaf Man","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2642-fe0f","native":"🧏‍♂️","x":47,"y":1},{"unified":"1f9cf-1f3fb-200d-2642-fe0f","native":"🧏🏻‍♂️","x":47,"y":2},{"unified":"1f9cf-1f3fc-200d-2642-fe0f","native":"🧏🏼‍♂️","x":47,"y":3},{"unified":"1f9cf-1f3fd-200d-2642-fe0f","native":"🧏🏽‍♂️","x":47,"y":4},{"unified":"1f9cf-1f3fe-200d-2642-fe0f","native":"🧏🏾‍♂️","x":47,"y":5},{"unified":"1f9cf-1f3ff-200d-2642-fe0f","native":"🧏🏿‍♂️","x":47,"y":6}],"version":12},"deaf_woman":{"id":"deaf_woman","name":"Deaf Woman","keywords":["accessibility"],"skins":[{"unified":"1f9cf-200d-2640-fe0f","native":"🧏‍♀️","x":46,"y":56},{"unified":"1f9cf-1f3fb-200d-2640-fe0f","native":"🧏🏻‍♀️","x":46,"y":57},{"unified":"1f9cf-1f3fc-200d-2640-fe0f","native":"🧏🏼‍♀️","x":46,"y":58},{"unified":"1f9cf-1f3fd-200d-2640-fe0f","native":"🧏🏽‍♀️","x":46,"y":59},{"unified":"1f9cf-1f3fe-200d-2640-fe0f","native":"🧏🏾‍♀️","x":46,"y":60},{"unified":"1f9cf-1f3ff-200d-2640-fe0f","native":"🧏🏿‍♀️","x":47,"y":0}],"version":12},"bow":{"id":"bow","name":"Person Bowing","keywords":["bow","respectiful"],"skins":[{"unified":"1f647","native":"🙇","x":34,"y":19},{"unified":"1f647-1f3fb","native":"🙇🏻","x":34,"y":20},{"unified":"1f647-1f3fc","native":"🙇🏼","x":34,"y":21},{"unified":"1f647-1f3fd","native":"🙇🏽","x":34,"y":22},{"unified":"1f647-1f3fe","native":"🙇🏾","x":34,"y":23},{"unified":"1f647-1f3ff","native":"🙇🏿","x":34,"y":24}],"version":1},"man-bowing":{"id":"man-bowing","name":"Man Bowing","keywords":["male","boy"],"skins":[{"unified":"1f647-200d-2642-fe0f","native":"🙇‍♂️","x":34,"y":13},{"unified":"1f647-1f3fb-200d-2642-fe0f","native":"🙇🏻‍♂️","x":34,"y":14},{"unified":"1f647-1f3fc-200d-2642-fe0f","native":"🙇🏼‍♂️","x":34,"y":15},{"unified":"1f647-1f3fd-200d-2642-fe0f","native":"🙇🏽‍♂️","x":34,"y":16},{"unified":"1f647-1f3fe-200d-2642-fe0f","native":"🙇🏾‍♂️","x":34,"y":17},{"unified":"1f647-1f3ff-200d-2642-fe0f","native":"🙇🏿‍♂️","x":34,"y":18}],"version":4},"woman-bowing":{"id":"woman-bowing","name":"Woman Bowing","keywords":["female","girl"],"skins":[{"unified":"1f647-200d-2640-fe0f","native":"🙇‍♀️","x":34,"y":7},{"unified":"1f647-1f3fb-200d-2640-fe0f","native":"🙇🏻‍♀️","x":34,"y":8},{"unified":"1f647-1f3fc-200d-2640-fe0f","native":"🙇🏼‍♀️","x":34,"y":9},{"unified":"1f647-1f3fd-200d-2640-fe0f","native":"🙇🏽‍♀️","x":34,"y":10},{"unified":"1f647-1f3fe-200d-2640-fe0f","native":"🙇🏾‍♀️","x":34,"y":11},{"unified":"1f647-1f3ff-200d-2640-fe0f","native":"🙇🏿‍♀️","x":34,"y":12}],"version":4},"face_palm":{"id":"face_palm","name":"Face Palm","keywords":["person","facepalming","disappointed"],"skins":[{"unified":"1f926","native":"🤦","x":40,"y":32},{"unified":"1f926-1f3fb","native":"🤦🏻","x":40,"y":33},{"unified":"1f926-1f3fc","native":"🤦🏼","x":40,"y":34},{"unified":"1f926-1f3fd","native":"🤦🏽","x":40,"y":35},{"unified":"1f926-1f3fe","native":"🤦🏾","x":40,"y":36},{"unified":"1f926-1f3ff","native":"🤦🏿","x":40,"y":37}],"version":3},"man-facepalming":{"id":"man-facepalming","name":"Man Facepalming","keywords":["male","boy","disbelief"],"skins":[{"unified":"1f926-200d-2642-fe0f","native":"🤦‍♂️","x":40,"y":26},{"unified":"1f926-1f3fb-200d-2642-fe0f","native":"🤦🏻‍♂️","x":40,"y":27},{"unified":"1f926-1f3fc-200d-2642-fe0f","native":"🤦🏼‍♂️","x":40,"y":28},{"unified":"1f926-1f3fd-200d-2642-fe0f","native":"🤦🏽‍♂️","x":40,"y":29},{"unified":"1f926-1f3fe-200d-2642-fe0f","native":"🤦🏾‍♂️","x":40,"y":30},{"unified":"1f926-1f3ff-200d-2642-fe0f","native":"🤦🏿‍♂️","x":40,"y":31}],"version":4},"woman-facepalming":{"id":"woman-facepalming","name":"Woman Facepalming","keywords":["female","girl","disbelief"],"skins":[{"unified":"1f926-200d-2640-fe0f","native":"🤦‍♀️","x":40,"y":20},{"unified":"1f926-1f3fb-200d-2640-fe0f","native":"🤦🏻‍♀️","x":40,"y":21},{"unified":"1f926-1f3fc-200d-2640-fe0f","native":"🤦🏼‍♀️","x":40,"y":22},{"unified":"1f926-1f3fd-200d-2640-fe0f","native":"🤦🏽‍♀️","x":40,"y":23},{"unified":"1f926-1f3fe-200d-2640-fe0f","native":"🤦🏾‍♀️","x":40,"y":24},{"unified":"1f926-1f3ff-200d-2640-fe0f","native":"🤦🏿‍♀️","x":40,"y":25}],"version":4},"shrug":{"id":"shrug","name":"Shrug","keywords":["person","shrugging","regardless"],"skins":[{"unified":"1f937","native":"🤷","x":41,"y":52},{"unified":"1f937-1f3fb","native":"🤷🏻","x":41,"y":53},{"unified":"1f937-1f3fc","native":"🤷🏼","x":41,"y":54},{"unified":"1f937-1f3fd","native":"🤷🏽","x":41,"y":55},{"unified":"1f937-1f3fe","native":"🤷🏾","x":41,"y":56},{"unified":"1f937-1f3ff","native":"🤷🏿","x":41,"y":57}],"version":3},"man-shrugging":{"id":"man-shrugging","name":"Man Shrugging","keywords":["male","boy","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2642-fe0f","native":"🤷‍♂️","x":41,"y":46},{"unified":"1f937-1f3fb-200d-2642-fe0f","native":"🤷🏻‍♂️","x":41,"y":47},{"unified":"1f937-1f3fc-200d-2642-fe0f","native":"🤷🏼‍♂️","x":41,"y":48},{"unified":"1f937-1f3fd-200d-2642-fe0f","native":"🤷🏽‍♂️","x":41,"y":49},{"unified":"1f937-1f3fe-200d-2642-fe0f","native":"🤷🏾‍♂️","x":41,"y":50},{"unified":"1f937-1f3ff-200d-2642-fe0f","native":"🤷🏿‍♂️","x":41,"y":51}],"version":4},"woman-shrugging":{"id":"woman-shrugging","name":"Woman Shrugging","keywords":["female","girl","confused","indifferent","doubt"],"skins":[{"unified":"1f937-200d-2640-fe0f","native":"🤷‍♀️","x":41,"y":40},{"unified":"1f937-1f3fb-200d-2640-fe0f","native":"🤷🏻‍♀️","x":41,"y":41},{"unified":"1f937-1f3fc-200d-2640-fe0f","native":"🤷🏼‍♀️","x":41,"y":42},{"unified":"1f937-1f3fd-200d-2640-fe0f","native":"🤷🏽‍♀️","x":41,"y":43},{"unified":"1f937-1f3fe-200d-2640-fe0f","native":"🤷🏾‍♀️","x":41,"y":44},{"unified":"1f937-1f3ff-200d-2640-fe0f","native":"🤷🏿‍♀️","x":41,"y":45}],"version":4},"health_worker":{"id":"health_worker","name":"Health Worker","keywords":["hospital"],"skins":[{"unified":"1f9d1-200d-2695-fe0f","native":"🧑‍⚕️","x":49,"y":50},{"unified":"1f9d1-1f3fb-200d-2695-fe0f","native":"🧑🏻‍⚕️","x":49,"y":51},{"unified":"1f9d1-1f3fc-200d-2695-fe0f","native":"🧑🏼‍⚕️","x":49,"y":52},{"unified":"1f9d1-1f3fd-200d-2695-fe0f","native":"🧑🏽‍⚕️","x":49,"y":53},{"unified":"1f9d1-1f3fe-200d-2695-fe0f","native":"🧑🏾‍⚕️","x":49,"y":54},{"unified":"1f9d1-1f3ff-200d-2695-fe0f","native":"🧑🏿‍⚕️","x":49,"y":55}],"version":12.1},"male-doctor":{"id":"male-doctor","name":"Man Health Worker","keywords":["male","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f468-200d-2695-fe0f","native":"👨‍⚕️","x":16,"y":5},{"unified":"1f468-1f3fb-200d-2695-fe0f","native":"👨🏻‍⚕️","x":16,"y":6},{"unified":"1f468-1f3fc-200d-2695-fe0f","native":"👨🏼‍⚕️","x":16,"y":7},{"unified":"1f468-1f3fd-200d-2695-fe0f","native":"👨🏽‍⚕️","x":16,"y":8},{"unified":"1f468-1f3fe-200d-2695-fe0f","native":"👨🏾‍⚕️","x":16,"y":9},{"unified":"1f468-1f3ff-200d-2695-fe0f","native":"👨🏿‍⚕️","x":16,"y":10}],"version":4},"female-doctor":{"id":"female-doctor","name":"Woman Health Worker","keywords":["female","doctor","nurse","therapist","healthcare","human"],"skins":[{"unified":"1f469-200d-2695-fe0f","native":"👩‍⚕️","x":19,"y":34},{"unified":"1f469-1f3fb-200d-2695-fe0f","native":"👩🏻‍⚕️","x":19,"y":35},{"unified":"1f469-1f3fc-200d-2695-fe0f","native":"👩🏼‍⚕️","x":19,"y":36},{"unified":"1f469-1f3fd-200d-2695-fe0f","native":"👩🏽‍⚕️","x":19,"y":37},{"unified":"1f469-1f3fe-200d-2695-fe0f","native":"👩🏾‍⚕️","x":19,"y":38},{"unified":"1f469-1f3ff-200d-2695-fe0f","native":"👩🏿‍⚕️","x":19,"y":39}],"version":4},"student":{"id":"student","name":"Student","keywords":["learn"],"skins":[{"unified":"1f9d1-200d-1f393","native":"🧑‍🎓","x":47,"y":38},{"unified":"1f9d1-1f3fb-200d-1f393","native":"🧑🏻‍🎓","x":47,"y":39},{"unified":"1f9d1-1f3fc-200d-1f393","native":"🧑🏼‍🎓","x":47,"y":40},{"unified":"1f9d1-1f3fd-200d-1f393","native":"🧑🏽‍🎓","x":47,"y":41},{"unified":"1f9d1-1f3fe-200d-1f393","native":"🧑🏾‍🎓","x":47,"y":42},{"unified":"1f9d1-1f3ff-200d-1f393","native":"🧑🏿‍🎓","x":47,"y":43}],"version":12.1},"male-student":{"id":"male-student","name":"Man Student","keywords":["male","graduate","human"],"skins":[{"unified":"1f468-200d-1f393","native":"👨‍🎓","x":14,"y":4},{"unified":"1f468-1f3fb-200d-1f393","native":"👨🏻‍🎓","x":14,"y":5},{"unified":"1f468-1f3fc-200d-1f393","native":"👨🏼‍🎓","x":14,"y":6},{"unified":"1f468-1f3fd-200d-1f393","native":"👨🏽‍🎓","x":14,"y":7},{"unified":"1f468-1f3fe-200d-1f393","native":"👨🏾‍🎓","x":14,"y":8},{"unified":"1f468-1f3ff-200d-1f393","native":"👨🏿‍🎓","x":14,"y":9}],"version":4},"female-student":{"id":"female-student","name":"Woman Student","keywords":["female","graduate","human"],"skins":[{"unified":"1f469-200d-1f393","native":"👩‍🎓","x":17,"y":38},{"unified":"1f469-1f3fb-200d-1f393","native":"👩🏻‍🎓","x":17,"y":39},{"unified":"1f469-1f3fc-200d-1f393","native":"👩🏼‍🎓","x":17,"y":40},{"unified":"1f469-1f3fd-200d-1f393","native":"👩🏽‍🎓","x":17,"y":41},{"unified":"1f469-1f3fe-200d-1f393","native":"👩🏾‍🎓","x":17,"y":42},{"unified":"1f469-1f3ff-200d-1f393","native":"👩🏿‍🎓","x":17,"y":43}],"version":4},"teacher":{"id":"teacher","name":"Teacher","keywords":["professor"],"skins":[{"unified":"1f9d1-200d-1f3eb","native":"🧑‍🏫","x":47,"y":56},{"unified":"1f9d1-1f3fb-200d-1f3eb","native":"🧑🏻‍🏫","x":47,"y":57},{"unified":"1f9d1-1f3fc-200d-1f3eb","native":"🧑🏼‍🏫","x":47,"y":58},{"unified":"1f9d1-1f3fd-200d-1f3eb","native":"🧑🏽‍🏫","x":47,"y":59},{"unified":"1f9d1-1f3fe-200d-1f3eb","native":"🧑🏾‍🏫","x":47,"y":60},{"unified":"1f9d1-1f3ff-200d-1f3eb","native":"🧑🏿‍🏫","x":48,"y":0}],"version":12.1},"male-teacher":{"id":"male-teacher","name":"Man Teacher","keywords":["male","instructor","professor","human"],"skins":[{"unified":"1f468-200d-1f3eb","native":"👨‍🏫","x":14,"y":22},{"unified":"1f468-1f3fb-200d-1f3eb","native":"👨🏻‍🏫","x":14,"y":23},{"unified":"1f468-1f3fc-200d-1f3eb","native":"👨🏼‍🏫","x":14,"y":24},{"unified":"1f468-1f3fd-200d-1f3eb","native":"👨🏽‍🏫","x":14,"y":25},{"unified":"1f468-1f3fe-200d-1f3eb","native":"👨🏾‍🏫","x":14,"y":26},{"unified":"1f468-1f3ff-200d-1f3eb","native":"👨🏿‍🏫","x":14,"y":27}],"version":4},"female-teacher":{"id":"female-teacher","name":"Woman Teacher","keywords":["female","instructor","professor","human"],"skins":[{"unified":"1f469-200d-1f3eb","native":"👩‍🏫","x":17,"y":56},{"unified":"1f469-1f3fb-200d-1f3eb","native":"👩🏻‍🏫","x":17,"y":57},{"unified":"1f469-1f3fc-200d-1f3eb","native":"👩🏼‍🏫","x":17,"y":58},{"unified":"1f469-1f3fd-200d-1f3eb","native":"👩🏽‍🏫","x":17,"y":59},{"unified":"1f469-1f3fe-200d-1f3eb","native":"👩🏾‍🏫","x":17,"y":60},{"unified":"1f469-1f3ff-200d-1f3eb","native":"👩🏿‍🏫","x":18,"y":0}],"version":4},"judge":{"id":"judge","name":"Judge","keywords":["law"],"skins":[{"unified":"1f9d1-200d-2696-fe0f","native":"🧑‍⚖️","x":49,"y":56},{"unified":"1f9d1-1f3fb-200d-2696-fe0f","native":"🧑🏻‍⚖️","x":49,"y":57},{"unified":"1f9d1-1f3fc-200d-2696-fe0f","native":"🧑🏼‍⚖️","x":49,"y":58},{"unified":"1f9d1-1f3fd-200d-2696-fe0f","native":"🧑🏽‍⚖️","x":49,"y":59},{"unified":"1f9d1-1f3fe-200d-2696-fe0f","native":"🧑🏾‍⚖️","x":49,"y":60},{"unified":"1f9d1-1f3ff-200d-2696-fe0f","native":"🧑🏿‍⚖️","x":50,"y":0}],"version":12.1},"male-judge":{"id":"male-judge","name":"Man Judge","keywords":["male","justice","court","human"],"skins":[{"unified":"1f468-200d-2696-fe0f","native":"👨‍⚖️","x":16,"y":11},{"unified":"1f468-1f3fb-200d-2696-fe0f","native":"👨🏻‍⚖️","x":16,"y":12},{"unified":"1f468-1f3fc-200d-2696-fe0f","native":"👨🏼‍⚖️","x":16,"y":13},{"unified":"1f468-1f3fd-200d-2696-fe0f","native":"👨🏽‍⚖️","x":16,"y":14},{"unified":"1f468-1f3fe-200d-2696-fe0f","native":"👨🏾‍⚖️","x":16,"y":15},{"unified":"1f468-1f3ff-200d-2696-fe0f","native":"👨🏿‍⚖️","x":16,"y":16}],"version":4},"female-judge":{"id":"female-judge","name":"Woman Judge","keywords":["female","justice","court","human"],"skins":[{"unified":"1f469-200d-2696-fe0f","native":"👩‍⚖️","x":19,"y":40},{"unified":"1f469-1f3fb-200d-2696-fe0f","native":"👩🏻‍⚖️","x":19,"y":41},{"unified":"1f469-1f3fc-200d-2696-fe0f","native":"👩🏼‍⚖️","x":19,"y":42},{"unified":"1f469-1f3fd-200d-2696-fe0f","native":"👩🏽‍⚖️","x":19,"y":43},{"unified":"1f469-1f3fe-200d-2696-fe0f","native":"👩🏾‍⚖️","x":19,"y":44},{"unified":"1f469-1f3ff-200d-2696-fe0f","native":"👩🏿‍⚖️","x":19,"y":45}],"version":4},"farmer":{"id":"farmer","name":"Farmer","keywords":["crops"],"skins":[{"unified":"1f9d1-200d-1f33e","native":"🧑‍🌾","x":47,"y":14},{"unified":"1f9d1-1f3fb-200d-1f33e","native":"🧑🏻‍🌾","x":47,"y":15},{"unified":"1f9d1-1f3fc-200d-1f33e","native":"🧑🏼‍🌾","x":47,"y":16},{"unified":"1f9d1-1f3fd-200d-1f33e","native":"🧑🏽‍🌾","x":47,"y":17},{"unified":"1f9d1-1f3fe-200d-1f33e","native":"🧑🏾‍🌾","x":47,"y":18},{"unified":"1f9d1-1f3ff-200d-1f33e","native":"🧑🏿‍🌾","x":47,"y":19}],"version":12.1},"male-farmer":{"id":"male-farmer","name":"Man Farmer","keywords":["male","rancher","gardener","human"],"skins":[{"unified":"1f468-200d-1f33e","native":"👨‍🌾","x":13,"y":47},{"unified":"1f468-1f3fb-200d-1f33e","native":"👨🏻‍🌾","x":13,"y":48},{"unified":"1f468-1f3fc-200d-1f33e","native":"👨🏼‍🌾","x":13,"y":49},{"unified":"1f468-1f3fd-200d-1f33e","native":"👨🏽‍🌾","x":13,"y":50},{"unified":"1f468-1f3fe-200d-1f33e","native":"👨🏾‍🌾","x":13,"y":51},{"unified":"1f468-1f3ff-200d-1f33e","native":"👨🏿‍🌾","x":13,"y":52}],"version":4},"female-farmer":{"id":"female-farmer","name":"Woman Farmer","keywords":["female","rancher","gardener","human"],"skins":[{"unified":"1f469-200d-1f33e","native":"👩‍🌾","x":17,"y":20},{"unified":"1f469-1f3fb-200d-1f33e","native":"👩🏻‍🌾","x":17,"y":21},{"unified":"1f469-1f3fc-200d-1f33e","native":"👩🏼‍🌾","x":17,"y":22},{"unified":"1f469-1f3fd-200d-1f33e","native":"👩🏽‍🌾","x":17,"y":23},{"unified":"1f469-1f3fe-200d-1f33e","native":"👩🏾‍🌾","x":17,"y":24},{"unified":"1f469-1f3ff-200d-1f33e","native":"👩🏿‍🌾","x":17,"y":25}],"version":4},"cook":{"id":"cook","name":"Cook","keywords":["food","kitchen","culinary"],"skins":[{"unified":"1f9d1-200d-1f373","native":"🧑‍🍳","x":47,"y":20},{"unified":"1f9d1-1f3fb-200d-1f373","native":"🧑🏻‍🍳","x":47,"y":21},{"unified":"1f9d1-1f3fc-200d-1f373","native":"🧑🏼‍🍳","x":47,"y":22},{"unified":"1f9d1-1f3fd-200d-1f373","native":"🧑🏽‍🍳","x":47,"y":23},{"unified":"1f9d1-1f3fe-200d-1f373","native":"🧑🏾‍🍳","x":47,"y":24},{"unified":"1f9d1-1f3ff-200d-1f373","native":"🧑🏿‍🍳","x":47,"y":25}],"version":12.1},"male-cook":{"id":"male-cook","name":"Man Cook","keywords":["male","chef","human"],"skins":[{"unified":"1f468-200d-1f373","native":"👨‍🍳","x":13,"y":53},{"unified":"1f468-1f3fb-200d-1f373","native":"👨🏻‍🍳","x":13,"y":54},{"unified":"1f468-1f3fc-200d-1f373","native":"👨🏼‍🍳","x":13,"y":55},{"unified":"1f468-1f3fd-200d-1f373","native":"👨🏽‍🍳","x":13,"y":56},{"unified":"1f468-1f3fe-200d-1f373","native":"👨🏾‍🍳","x":13,"y":57},{"unified":"1f468-1f3ff-200d-1f373","native":"👨🏿‍🍳","x":13,"y":58}],"version":4},"female-cook":{"id":"female-cook","name":"Woman Cook","keywords":["female","chef","human"],"skins":[{"unified":"1f469-200d-1f373","native":"👩‍🍳","x":17,"y":26},{"unified":"1f469-1f3fb-200d-1f373","native":"👩🏻‍🍳","x":17,"y":27},{"unified":"1f469-1f3fc-200d-1f373","native":"👩🏼‍🍳","x":17,"y":28},{"unified":"1f469-1f3fd-200d-1f373","native":"👩🏽‍🍳","x":17,"y":29},{"unified":"1f469-1f3fe-200d-1f373","native":"👩🏾‍🍳","x":17,"y":30},{"unified":"1f469-1f3ff-200d-1f373","native":"👩🏿‍🍳","x":17,"y":31}],"version":4},"mechanic":{"id":"mechanic","name":"Mechanic","keywords":["worker","technician"],"skins":[{"unified":"1f9d1-200d-1f527","native":"🧑‍🔧","x":48,"y":19},{"unified":"1f9d1-1f3fb-200d-1f527","native":"🧑🏻‍🔧","x":48,"y":20},{"unified":"1f9d1-1f3fc-200d-1f527","native":"🧑🏼‍🔧","x":48,"y":21},{"unified":"1f9d1-1f3fd-200d-1f527","native":"🧑🏽‍🔧","x":48,"y":22},{"unified":"1f9d1-1f3fe-200d-1f527","native":"🧑🏾‍🔧","x":48,"y":23},{"unified":"1f9d1-1f3ff-200d-1f527","native":"🧑🏿‍🔧","x":48,"y":24}],"version":12.1},"male-mechanic":{"id":"male-mechanic","name":"Man Mechanic","keywords":["male","plumber","human","wrench"],"skins":[{"unified":"1f468-200d-1f527","native":"👨‍🔧","x":15,"y":0},{"unified":"1f468-1f3fb-200d-1f527","native":"👨🏻‍🔧","x":15,"y":1},{"unified":"1f468-1f3fc-200d-1f527","native":"👨🏼‍🔧","x":15,"y":2},{"unified":"1f468-1f3fd-200d-1f527","native":"👨🏽‍🔧","x":15,"y":3},{"unified":"1f468-1f3fe-200d-1f527","native":"👨🏾‍🔧","x":15,"y":4},{"unified":"1f468-1f3ff-200d-1f527","native":"👨🏿‍🔧","x":15,"y":5}],"version":4},"female-mechanic":{"id":"female-mechanic","name":"Woman Mechanic","keywords":["female","plumber","human","wrench"],"skins":[{"unified":"1f469-200d-1f527","native":"👩‍🔧","x":18,"y":29},{"unified":"1f469-1f3fb-200d-1f527","native":"👩🏻‍🔧","x":18,"y":30},{"unified":"1f469-1f3fc-200d-1f527","native":"👩🏼‍🔧","x":18,"y":31},{"unified":"1f469-1f3fd-200d-1f527","native":"👩🏽‍🔧","x":18,"y":32},{"unified":"1f469-1f3fe-200d-1f527","native":"👩🏾‍🔧","x":18,"y":33},{"unified":"1f469-1f3ff-200d-1f527","native":"👩🏿‍🔧","x":18,"y":34}],"version":4},"factory_worker":{"id":"factory_worker","name":"Factory Worker","keywords":["labor"],"skins":[{"unified":"1f9d1-200d-1f3ed","native":"🧑‍🏭","x":48,"y":1},{"unified":"1f9d1-1f3fb-200d-1f3ed","native":"🧑🏻‍🏭","x":48,"y":2},{"unified":"1f9d1-1f3fc-200d-1f3ed","native":"🧑🏼‍🏭","x":48,"y":3},{"unified":"1f9d1-1f3fd-200d-1f3ed","native":"🧑🏽‍🏭","x":48,"y":4},{"unified":"1f9d1-1f3fe-200d-1f3ed","native":"🧑🏾‍🏭","x":48,"y":5},{"unified":"1f9d1-1f3ff-200d-1f3ed","native":"🧑🏿‍🏭","x":48,"y":6}],"version":12.1},"male-factory-worker":{"id":"male-factory-worker","name":"Man Factory Worker","keywords":["male","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f468-200d-1f3ed","native":"👨‍🏭","x":14,"y":28},{"unified":"1f468-1f3fb-200d-1f3ed","native":"👨🏻‍🏭","x":14,"y":29},{"unified":"1f468-1f3fc-200d-1f3ed","native":"👨🏼‍🏭","x":14,"y":30},{"unified":"1f468-1f3fd-200d-1f3ed","native":"👨🏽‍🏭","x":14,"y":31},{"unified":"1f468-1f3fe-200d-1f3ed","native":"👨🏾‍🏭","x":14,"y":32},{"unified":"1f468-1f3ff-200d-1f3ed","native":"👨🏿‍🏭","x":14,"y":33}],"version":4},"female-factory-worker":{"id":"female-factory-worker","name":"Woman Factory Worker","keywords":["female","factory-worker","assembly","industrial","human"],"skins":[{"unified":"1f469-200d-1f3ed","native":"👩‍🏭","x":18,"y":1},{"unified":"1f469-1f3fb-200d-1f3ed","native":"👩🏻‍🏭","x":18,"y":2},{"unified":"1f469-1f3fc-200d-1f3ed","native":"👩🏼‍🏭","x":18,"y":3},{"unified":"1f469-1f3fd-200d-1f3ed","native":"👩🏽‍🏭","x":18,"y":4},{"unified":"1f469-1f3fe-200d-1f3ed","native":"👩🏾‍🏭","x":18,"y":5},{"unified":"1f469-1f3ff-200d-1f3ed","native":"👩🏿‍🏭","x":18,"y":6}],"version":4},"office_worker":{"id":"office_worker","name":"Office Worker","keywords":["business"],"skins":[{"unified":"1f9d1-200d-1f4bc","native":"🧑‍💼","x":48,"y":13},{"unified":"1f9d1-1f3fb-200d-1f4bc","native":"🧑🏻‍💼","x":48,"y":14},{"unified":"1f9d1-1f3fc-200d-1f4bc","native":"🧑🏼‍💼","x":48,"y":15},{"unified":"1f9d1-1f3fd-200d-1f4bc","native":"🧑🏽‍💼","x":48,"y":16},{"unified":"1f9d1-1f3fe-200d-1f4bc","native":"🧑🏾‍💼","x":48,"y":17},{"unified":"1f9d1-1f3ff-200d-1f4bc","native":"🧑🏿‍💼","x":48,"y":18}],"version":12.1},"male-office-worker":{"id":"male-office-worker","name":"Man Office Worker","keywords":["male","office-worker","business","manager","human"],"skins":[{"unified":"1f468-200d-1f4bc","native":"👨‍💼","x":14,"y":55},{"unified":"1f468-1f3fb-200d-1f4bc","native":"👨🏻‍💼","x":14,"y":56},{"unified":"1f468-1f3fc-200d-1f4bc","native":"👨🏼‍💼","x":14,"y":57},{"unified":"1f468-1f3fd-200d-1f4bc","native":"👨🏽‍💼","x":14,"y":58},{"unified":"1f468-1f3fe-200d-1f4bc","native":"👨🏾‍💼","x":14,"y":59},{"unified":"1f468-1f3ff-200d-1f4bc","native":"👨🏿‍💼","x":14,"y":60}],"version":4},"female-office-worker":{"id":"female-office-worker","name":"Woman Office Worker","keywords":["female","office-worker","business","manager","human"],"skins":[{"unified":"1f469-200d-1f4bc","native":"👩‍💼","x":18,"y":23},{"unified":"1f469-1f3fb-200d-1f4bc","native":"👩🏻‍💼","x":18,"y":24},{"unified":"1f469-1f3fc-200d-1f4bc","native":"👩🏼‍💼","x":18,"y":25},{"unified":"1f469-1f3fd-200d-1f4bc","native":"👩🏽‍💼","x":18,"y":26},{"unified":"1f469-1f3fe-200d-1f4bc","native":"👩🏾‍💼","x":18,"y":27},{"unified":"1f469-1f3ff-200d-1f4bc","native":"👩🏿‍💼","x":18,"y":28}],"version":4},"scientist":{"id":"scientist","name":"Scientist","keywords":["chemistry"],"skins":[{"unified":"1f9d1-200d-1f52c","native":"🧑‍🔬","x":48,"y":25},{"unified":"1f9d1-1f3fb-200d-1f52c","native":"🧑🏻‍🔬","x":48,"y":26},{"unified":"1f9d1-1f3fc-200d-1f52c","native":"🧑🏼‍🔬","x":48,"y":27},{"unified":"1f9d1-1f3fd-200d-1f52c","native":"🧑🏽‍🔬","x":48,"y":28},{"unified":"1f9d1-1f3fe-200d-1f52c","native":"🧑🏾‍🔬","x":48,"y":29},{"unified":"1f9d1-1f3ff-200d-1f52c","native":"🧑🏿‍🔬","x":48,"y":30}],"version":12.1},"male-scientist":{"id":"male-scientist","name":"Man Scientist","keywords":["male","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f468-200d-1f52c","native":"👨‍🔬","x":15,"y":6},{"unified":"1f468-1f3fb-200d-1f52c","native":"👨🏻‍🔬","x":15,"y":7},{"unified":"1f468-1f3fc-200d-1f52c","native":"👨🏼‍🔬","x":15,"y":8},{"unified":"1f468-1f3fd-200d-1f52c","native":"👨🏽‍🔬","x":15,"y":9},{"unified":"1f468-1f3fe-200d-1f52c","native":"👨🏾‍🔬","x":15,"y":10},{"unified":"1f468-1f3ff-200d-1f52c","native":"👨🏿‍🔬","x":15,"y":11}],"version":4},"female-scientist":{"id":"female-scientist","name":"Woman Scientist","keywords":["female","biologist","chemist","engineer","physicist","human"],"skins":[{"unified":"1f469-200d-1f52c","native":"👩‍🔬","x":18,"y":35},{"unified":"1f469-1f3fb-200d-1f52c","native":"👩🏻‍🔬","x":18,"y":36},{"unified":"1f469-1f3fc-200d-1f52c","native":"👩🏼‍🔬","x":18,"y":37},{"unified":"1f469-1f3fd-200d-1f52c","native":"👩🏽‍🔬","x":18,"y":38},{"unified":"1f469-1f3fe-200d-1f52c","native":"👩🏾‍🔬","x":18,"y":39},{"unified":"1f469-1f3ff-200d-1f52c","native":"👩🏿‍🔬","x":18,"y":40}],"version":4},"technologist":{"id":"technologist","name":"Technologist","keywords":["computer"],"skins":[{"unified":"1f9d1-200d-1f4bb","native":"🧑‍💻","x":48,"y":7},{"unified":"1f9d1-1f3fb-200d-1f4bb","native":"🧑🏻‍💻","x":48,"y":8},{"unified":"1f9d1-1f3fc-200d-1f4bb","native":"🧑🏼‍💻","x":48,"y":9},{"unified":"1f9d1-1f3fd-200d-1f4bb","native":"🧑🏽‍💻","x":48,"y":10},{"unified":"1f9d1-1f3fe-200d-1f4bb","native":"🧑🏾‍💻","x":48,"y":11},{"unified":"1f9d1-1f3ff-200d-1f4bb","native":"🧑🏿‍💻","x":48,"y":12}],"version":12.1},"male-technologist":{"id":"male-technologist","name":"Man Technologist","keywords":["male","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f468-200d-1f4bb","native":"👨‍💻","x":14,"y":49},{"unified":"1f468-1f3fb-200d-1f4bb","native":"👨🏻‍💻","x":14,"y":50},{"unified":"1f468-1f3fc-200d-1f4bb","native":"👨🏼‍💻","x":14,"y":51},{"unified":"1f468-1f3fd-200d-1f4bb","native":"👨🏽‍💻","x":14,"y":52},{"unified":"1f468-1f3fe-200d-1f4bb","native":"👨🏾‍💻","x":14,"y":53},{"unified":"1f468-1f3ff-200d-1f4bb","native":"👨🏿‍💻","x":14,"y":54}],"version":4},"female-technologist":{"id":"female-technologist","name":"Woman Technologist","keywords":["female","coder","developer","engineer","programmer","software","human","laptop","computer"],"skins":[{"unified":"1f469-200d-1f4bb","native":"👩‍💻","x":18,"y":17},{"unified":"1f469-1f3fb-200d-1f4bb","native":"👩🏻‍💻","x":18,"y":18},{"unified":"1f469-1f3fc-200d-1f4bb","native":"👩🏼‍💻","x":18,"y":19},{"unified":"1f469-1f3fd-200d-1f4bb","native":"👩🏽‍💻","x":18,"y":20},{"unified":"1f469-1f3fe-200d-1f4bb","native":"👩🏾‍💻","x":18,"y":21},{"unified":"1f469-1f3ff-200d-1f4bb","native":"👩🏿‍💻","x":18,"y":22}],"version":4},"singer":{"id":"singer","name":"Singer","keywords":["song","artist","performer"],"skins":[{"unified":"1f9d1-200d-1f3a4","native":"🧑‍🎤","x":47,"y":44},{"unified":"1f9d1-1f3fb-200d-1f3a4","native":"🧑🏻‍🎤","x":47,"y":45},{"unified":"1f9d1-1f3fc-200d-1f3a4","native":"🧑🏼‍🎤","x":47,"y":46},{"unified":"1f9d1-1f3fd-200d-1f3a4","native":"🧑🏽‍🎤","x":47,"y":47},{"unified":"1f9d1-1f3fe-200d-1f3a4","native":"🧑🏾‍🎤","x":47,"y":48},{"unified":"1f9d1-1f3ff-200d-1f3a4","native":"🧑🏿‍🎤","x":47,"y":49}],"version":12.1},"male-singer":{"id":"male-singer","name":"Man Singer","keywords":["male","rockstar","entertainer","human"],"skins":[{"unified":"1f468-200d-1f3a4","native":"👨‍🎤","x":14,"y":10},{"unified":"1f468-1f3fb-200d-1f3a4","native":"👨🏻‍🎤","x":14,"y":11},{"unified":"1f468-1f3fc-200d-1f3a4","native":"👨🏼‍🎤","x":14,"y":12},{"unified":"1f468-1f3fd-200d-1f3a4","native":"👨🏽‍🎤","x":14,"y":13},{"unified":"1f468-1f3fe-200d-1f3a4","native":"👨🏾‍🎤","x":14,"y":14},{"unified":"1f468-1f3ff-200d-1f3a4","native":"👨🏿‍🎤","x":14,"y":15}],"version":4},"female-singer":{"id":"female-singer","name":"Woman Singer","keywords":["female","rockstar","entertainer","human"],"skins":[{"unified":"1f469-200d-1f3a4","native":"👩‍🎤","x":17,"y":44},{"unified":"1f469-1f3fb-200d-1f3a4","native":"👩🏻‍🎤","x":17,"y":45},{"unified":"1f469-1f3fc-200d-1f3a4","native":"👩🏼‍🎤","x":17,"y":46},{"unified":"1f469-1f3fd-200d-1f3a4","native":"👩🏽‍🎤","x":17,"y":47},{"unified":"1f469-1f3fe-200d-1f3a4","native":"👩🏾‍🎤","x":17,"y":48},{"unified":"1f469-1f3ff-200d-1f3a4","native":"👩🏿‍🎤","x":17,"y":49}],"version":4},"artist":{"id":"artist","name":"Artist","keywords":["painting","draw","creativity"],"skins":[{"unified":"1f9d1-200d-1f3a8","native":"🧑‍🎨","x":47,"y":50},{"unified":"1f9d1-1f3fb-200d-1f3a8","native":"🧑🏻‍🎨","x":47,"y":51},{"unified":"1f9d1-1f3fc-200d-1f3a8","native":"🧑🏼‍🎨","x":47,"y":52},{"unified":"1f9d1-1f3fd-200d-1f3a8","native":"🧑🏽‍🎨","x":47,"y":53},{"unified":"1f9d1-1f3fe-200d-1f3a8","native":"🧑🏾‍🎨","x":47,"y":54},{"unified":"1f9d1-1f3ff-200d-1f3a8","native":"🧑🏿‍🎨","x":47,"y":55}],"version":12.1},"male-artist":{"id":"male-artist","name":"Man Artist","keywords":["male","painter","human"],"skins":[{"unified":"1f468-200d-1f3a8","native":"👨‍🎨","x":14,"y":16},{"unified":"1f468-1f3fb-200d-1f3a8","native":"👨🏻‍🎨","x":14,"y":17},{"unified":"1f468-1f3fc-200d-1f3a8","native":"👨🏼‍🎨","x":14,"y":18},{"unified":"1f468-1f3fd-200d-1f3a8","native":"👨🏽‍🎨","x":14,"y":19},{"unified":"1f468-1f3fe-200d-1f3a8","native":"👨🏾‍🎨","x":14,"y":20},{"unified":"1f468-1f3ff-200d-1f3a8","native":"👨🏿‍🎨","x":14,"y":21}],"version":4},"female-artist":{"id":"female-artist","name":"Woman Artist","keywords":["female","painter","human"],"skins":[{"unified":"1f469-200d-1f3a8","native":"👩‍🎨","x":17,"y":50},{"unified":"1f469-1f3fb-200d-1f3a8","native":"👩🏻‍🎨","x":17,"y":51},{"unified":"1f469-1f3fc-200d-1f3a8","native":"👩🏼‍🎨","x":17,"y":52},{"unified":"1f469-1f3fd-200d-1f3a8","native":"👩🏽‍🎨","x":17,"y":53},{"unified":"1f469-1f3fe-200d-1f3a8","native":"👩🏾‍🎨","x":17,"y":54},{"unified":"1f469-1f3ff-200d-1f3a8","native":"👩🏿‍🎨","x":17,"y":55}],"version":4},"pilot":{"id":"pilot","name":"Pilot","keywords":["fly","plane","airplane"],"skins":[{"unified":"1f9d1-200d-2708-fe0f","native":"🧑‍✈️","x":50,"y":1},{"unified":"1f9d1-1f3fb-200d-2708-fe0f","native":"🧑🏻‍✈️","x":50,"y":2},{"unified":"1f9d1-1f3fc-200d-2708-fe0f","native":"🧑🏼‍✈️","x":50,"y":3},{"unified":"1f9d1-1f3fd-200d-2708-fe0f","native":"🧑🏽‍✈️","x":50,"y":4},{"unified":"1f9d1-1f3fe-200d-2708-fe0f","native":"🧑🏾‍✈️","x":50,"y":5},{"unified":"1f9d1-1f3ff-200d-2708-fe0f","native":"🧑🏿‍✈️","x":50,"y":6}],"version":12.1},"male-pilot":{"id":"male-pilot","name":"Man Pilot","keywords":["male","aviator","plane","human"],"skins":[{"unified":"1f468-200d-2708-fe0f","native":"👨‍✈️","x":16,"y":17},{"unified":"1f468-1f3fb-200d-2708-fe0f","native":"👨🏻‍✈️","x":16,"y":18},{"unified":"1f468-1f3fc-200d-2708-fe0f","native":"👨🏼‍✈️","x":16,"y":19},{"unified":"1f468-1f3fd-200d-2708-fe0f","native":"👨🏽‍✈️","x":16,"y":20},{"unified":"1f468-1f3fe-200d-2708-fe0f","native":"👨🏾‍✈️","x":16,"y":21},{"unified":"1f468-1f3ff-200d-2708-fe0f","native":"👨🏿‍✈️","x":16,"y":22}],"version":4},"female-pilot":{"id":"female-pilot","name":"Woman Pilot","keywords":["female","aviator","plane","human"],"skins":[{"unified":"1f469-200d-2708-fe0f","native":"👩‍✈️","x":19,"y":46},{"unified":"1f469-1f3fb-200d-2708-fe0f","native":"👩🏻‍✈️","x":19,"y":47},{"unified":"1f469-1f3fc-200d-2708-fe0f","native":"👩🏼‍✈️","x":19,"y":48},{"unified":"1f469-1f3fd-200d-2708-fe0f","native":"👩🏽‍✈️","x":19,"y":49},{"unified":"1f469-1f3fe-200d-2708-fe0f","native":"👩🏾‍✈️","x":19,"y":50},{"unified":"1f469-1f3ff-200d-2708-fe0f","native":"👩🏿‍✈️","x":19,"y":51}],"version":4},"astronaut":{"id":"astronaut","name":"Astronaut","keywords":["outerspace"],"skins":[{"unified":"1f9d1-200d-1f680","native":"🧑‍🚀","x":48,"y":31},{"unified":"1f9d1-1f3fb-200d-1f680","native":"🧑🏻‍🚀","x":48,"y":32},{"unified":"1f9d1-1f3fc-200d-1f680","native":"🧑🏼‍🚀","x":48,"y":33},{"unified":"1f9d1-1f3fd-200d-1f680","native":"🧑🏽‍🚀","x":48,"y":34},{"unified":"1f9d1-1f3fe-200d-1f680","native":"🧑🏾‍🚀","x":48,"y":35},{"unified":"1f9d1-1f3ff-200d-1f680","native":"🧑🏿‍🚀","x":48,"y":36}],"version":12.1},"male-astronaut":{"id":"male-astronaut","name":"Man Astronaut","keywords":["male","space","rocket","human"],"skins":[{"unified":"1f468-200d-1f680","native":"👨‍🚀","x":15,"y":12},{"unified":"1f468-1f3fb-200d-1f680","native":"👨🏻‍🚀","x":15,"y":13},{"unified":"1f468-1f3fc-200d-1f680","native":"👨🏼‍🚀","x":15,"y":14},{"unified":"1f468-1f3fd-200d-1f680","native":"👨🏽‍🚀","x":15,"y":15},{"unified":"1f468-1f3fe-200d-1f680","native":"👨🏾‍🚀","x":15,"y":16},{"unified":"1f468-1f3ff-200d-1f680","native":"👨🏿‍🚀","x":15,"y":17}],"version":4},"female-astronaut":{"id":"female-astronaut","name":"Woman Astronaut","keywords":["female","space","rocket","human"],"skins":[{"unified":"1f469-200d-1f680","native":"👩‍🚀","x":18,"y":41},{"unified":"1f469-1f3fb-200d-1f680","native":"👩🏻‍🚀","x":18,"y":42},{"unified":"1f469-1f3fc-200d-1f680","native":"👩🏼‍🚀","x":18,"y":43},{"unified":"1f469-1f3fd-200d-1f680","native":"👩🏽‍🚀","x":18,"y":44},{"unified":"1f469-1f3fe-200d-1f680","native":"👩🏾‍🚀","x":18,"y":45},{"unified":"1f469-1f3ff-200d-1f680","native":"👩🏿‍🚀","x":18,"y":46}],"version":4},"firefighter":{"id":"firefighter","name":"Firefighter","keywords":["fire"],"skins":[{"unified":"1f9d1-200d-1f692","native":"🧑‍🚒","x":48,"y":37},{"unified":"1f9d1-1f3fb-200d-1f692","native":"🧑🏻‍🚒","x":48,"y":38},{"unified":"1f9d1-1f3fc-200d-1f692","native":"🧑🏼‍🚒","x":48,"y":39},{"unified":"1f9d1-1f3fd-200d-1f692","native":"🧑🏽‍🚒","x":48,"y":40},{"unified":"1f9d1-1f3fe-200d-1f692","native":"🧑🏾‍🚒","x":48,"y":41},{"unified":"1f9d1-1f3ff-200d-1f692","native":"🧑🏿‍🚒","x":48,"y":42}],"version":12.1},"male-firefighter":{"id":"male-firefighter","name":"Man Firefighter","keywords":["male","fireman","human"],"skins":[{"unified":"1f468-200d-1f692","native":"👨‍🚒","x":15,"y":18},{"unified":"1f468-1f3fb-200d-1f692","native":"👨🏻‍🚒","x":15,"y":19},{"unified":"1f468-1f3fc-200d-1f692","native":"👨🏼‍🚒","x":15,"y":20},{"unified":"1f468-1f3fd-200d-1f692","native":"👨🏽‍🚒","x":15,"y":21},{"unified":"1f468-1f3fe-200d-1f692","native":"👨🏾‍🚒","x":15,"y":22},{"unified":"1f468-1f3ff-200d-1f692","native":"👨🏿‍🚒","x":15,"y":23}],"version":4},"female-firefighter":{"id":"female-firefighter","name":"Woman Firefighter","keywords":["female","fireman","human"],"skins":[{"unified":"1f469-200d-1f692","native":"👩‍🚒","x":18,"y":47},{"unified":"1f469-1f3fb-200d-1f692","native":"👩🏻‍🚒","x":18,"y":48},{"unified":"1f469-1f3fc-200d-1f692","native":"👩🏼‍🚒","x":18,"y":49},{"unified":"1f469-1f3fd-200d-1f692","native":"👩🏽‍🚒","x":18,"y":50},{"unified":"1f469-1f3fe-200d-1f692","native":"👩🏾‍🚒","x":18,"y":51},{"unified":"1f469-1f3ff-200d-1f692","native":"👩🏿‍🚒","x":18,"y":52}],"version":4},"cop":{"id":"cop","name":"Police Officer","keywords":["cop"],"skins":[{"unified":"1f46e","native":"👮","x":23,"y":9},{"unified":"1f46e-1f3fb","native":"👮🏻","x":23,"y":10},{"unified":"1f46e-1f3fc","native":"👮🏼","x":23,"y":11},{"unified":"1f46e-1f3fd","native":"👮🏽","x":23,"y":12},{"unified":"1f46e-1f3fe","native":"👮🏾","x":23,"y":13},{"unified":"1f46e-1f3ff","native":"👮🏿","x":23,"y":14}],"version":1},"male-police-officer":{"id":"male-police-officer","name":"Man Police Officer","keywords":["male","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2642-fe0f","native":"👮‍♂️","x":23,"y":3},{"unified":"1f46e-1f3fb-200d-2642-fe0f","native":"👮🏻‍♂️","x":23,"y":4},{"unified":"1f46e-1f3fc-200d-2642-fe0f","native":"👮🏼‍♂️","x":23,"y":5},{"unified":"1f46e-1f3fd-200d-2642-fe0f","native":"👮🏽‍♂️","x":23,"y":6},{"unified":"1f46e-1f3fe-200d-2642-fe0f","native":"👮🏾‍♂️","x":23,"y":7},{"unified":"1f46e-1f3ff-200d-2642-fe0f","native":"👮🏿‍♂️","x":23,"y":8}],"version":4},"female-police-officer":{"id":"female-police-officer","name":"Woman Police Officer","keywords":["female","police-officer","law","legal","enforcement","arrest","911"],"skins":[{"unified":"1f46e-200d-2640-fe0f","native":"👮‍♀️","x":22,"y":58},{"unified":"1f46e-1f3fb-200d-2640-fe0f","native":"👮🏻‍♀️","x":22,"y":59},{"unified":"1f46e-1f3fc-200d-2640-fe0f","native":"👮🏼‍♀️","x":22,"y":60},{"unified":"1f46e-1f3fd-200d-2640-fe0f","native":"👮🏽‍♀️","x":23,"y":0},{"unified":"1f46e-1f3fe-200d-2640-fe0f","native":"👮🏾‍♀️","x":23,"y":1},{"unified":"1f46e-1f3ff-200d-2640-fe0f","native":"👮🏿‍♀️","x":23,"y":2}],"version":4},"sleuth_or_spy":{"id":"sleuth_or_spy","name":"Detective","keywords":["sleuth","or","spy","human"],"skins":[{"unified":"1f575-fe0f","native":"🕵️","x":31,"y":17},{"unified":"1f575-1f3fb","native":"🕵🏻","x":31,"y":18},{"unified":"1f575-1f3fc","native":"🕵🏼","x":31,"y":19},{"unified":"1f575-1f3fd","native":"🕵🏽","x":31,"y":20},{"unified":"1f575-1f3fe","native":"🕵🏾","x":31,"y":21},{"unified":"1f575-1f3ff","native":"🕵🏿","x":31,"y":22}],"version":1},"male-detective":{"id":"male-detective","name":"Man Detective","keywords":["male","crime"],"skins":[{"unified":"1f575-fe0f-200d-2642-fe0f","native":"🕵️‍♂️","x":31,"y":11},{"unified":"1f575-1f3fb-200d-2642-fe0f","native":"🕵🏻‍♂️","x":31,"y":12},{"unified":"1f575-1f3fc-200d-2642-fe0f","native":"🕵🏼‍♂️","x":31,"y":13},{"unified":"1f575-1f3fd-200d-2642-fe0f","native":"🕵🏽‍♂️","x":31,"y":14},{"unified":"1f575-1f3fe-200d-2642-fe0f","native":"🕵🏾‍♂️","x":31,"y":15},{"unified":"1f575-1f3ff-200d-2642-fe0f","native":"🕵🏿‍♂️","x":31,"y":16}],"version":4},"female-detective":{"id":"female-detective","name":"Woman Detective","keywords":["female","human","spy"],"skins":[{"unified":"1f575-fe0f-200d-2640-fe0f","native":"🕵️‍♀️","x":31,"y":5},{"unified":"1f575-1f3fb-200d-2640-fe0f","native":"🕵🏻‍♀️","x":31,"y":6},{"unified":"1f575-1f3fc-200d-2640-fe0f","native":"🕵🏼‍♀️","x":31,"y":7},{"unified":"1f575-1f3fd-200d-2640-fe0f","native":"🕵🏽‍♀️","x":31,"y":8},{"unified":"1f575-1f3fe-200d-2640-fe0f","native":"🕵🏾‍♀️","x":31,"y":9},{"unified":"1f575-1f3ff-200d-2640-fe0f","native":"🕵🏿‍♀️","x":31,"y":10}],"version":4},"guardsman":{"id":"guardsman","name":"Guard","keywords":["guardsman","protect"],"skins":[{"unified":"1f482","native":"💂","x":25,"y":41},{"unified":"1f482-1f3fb","native":"💂🏻","x":25,"y":42},{"unified":"1f482-1f3fc","native":"💂🏼","x":25,"y":43},{"unified":"1f482-1f3fd","native":"💂🏽","x":25,"y":44},{"unified":"1f482-1f3fe","native":"💂🏾","x":25,"y":45},{"unified":"1f482-1f3ff","native":"💂🏿","x":25,"y":46}],"version":1},"male-guard":{"id":"male-guard","name":"Man Guard","keywords":["male","uk","gb","british","guy","royal"],"skins":[{"unified":"1f482-200d-2642-fe0f","native":"💂‍♂️","x":25,"y":35},{"unified":"1f482-1f3fb-200d-2642-fe0f","native":"💂🏻‍♂️","x":25,"y":36},{"unified":"1f482-1f3fc-200d-2642-fe0f","native":"💂🏼‍♂️","x":25,"y":37},{"unified":"1f482-1f3fd-200d-2642-fe0f","native":"💂🏽‍♂️","x":25,"y":38},{"unified":"1f482-1f3fe-200d-2642-fe0f","native":"💂🏾‍♂️","x":25,"y":39},{"unified":"1f482-1f3ff-200d-2642-fe0f","native":"💂🏿‍♂️","x":25,"y":40}],"version":4},"female-guard":{"id":"female-guard","name":"Woman Guard","keywords":["female","uk","gb","british","royal"],"skins":[{"unified":"1f482-200d-2640-fe0f","native":"💂‍♀️","x":25,"y":29},{"unified":"1f482-1f3fb-200d-2640-fe0f","native":"💂🏻‍♀️","x":25,"y":30},{"unified":"1f482-1f3fc-200d-2640-fe0f","native":"💂🏼‍♀️","x":25,"y":31},{"unified":"1f482-1f3fd-200d-2640-fe0f","native":"💂🏽‍♀️","x":25,"y":32},{"unified":"1f482-1f3fe-200d-2640-fe0f","native":"💂🏾‍♀️","x":25,"y":33},{"unified":"1f482-1f3ff-200d-2640-fe0f","native":"💂🏿‍♀️","x":25,"y":34}],"version":4},"ninja":{"id":"ninja","name":"Ninja","keywords":["ninjutsu","skills","japanese"],"skins":[{"unified":"1f977","native":"🥷","x":44,"y":6},{"unified":"1f977-1f3fb","native":"🥷🏻","x":44,"y":7},{"unified":"1f977-1f3fc","native":"🥷🏼","x":44,"y":8},{"unified":"1f977-1f3fd","native":"🥷🏽","x":44,"y":9},{"unified":"1f977-1f3fe","native":"🥷🏾","x":44,"y":10},{"unified":"1f977-1f3ff","native":"🥷🏿","x":44,"y":11}],"version":13},"construction_worker":{"id":"construction_worker","name":"Construction Worker","keywords":["labor","build"],"skins":[{"unified":"1f477","native":"👷","x":24,"y":47},{"unified":"1f477-1f3fb","native":"👷🏻","x":24,"y":48},{"unified":"1f477-1f3fc","native":"👷🏼","x":24,"y":49},{"unified":"1f477-1f3fd","native":"👷🏽","x":24,"y":50},{"unified":"1f477-1f3fe","native":"👷🏾","x":24,"y":51},{"unified":"1f477-1f3ff","native":"👷🏿","x":24,"y":52}],"version":1},"male-construction-worker":{"id":"male-construction-worker","name":"Man Construction Worker","keywords":["male","construction-worker","human","wip","guy","build","labor"],"skins":[{"unified":"1f477-200d-2642-fe0f","native":"👷‍♂️","x":24,"y":41},{"unified":"1f477-1f3fb-200d-2642-fe0f","native":"👷🏻‍♂️","x":24,"y":42},{"unified":"1f477-1f3fc-200d-2642-fe0f","native":"👷🏼‍♂️","x":24,"y":43},{"unified":"1f477-1f3fd-200d-2642-fe0f","native":"👷🏽‍♂️","x":24,"y":44},{"unified":"1f477-1f3fe-200d-2642-fe0f","native":"👷🏾‍♂️","x":24,"y":45},{"unified":"1f477-1f3ff-200d-2642-fe0f","native":"👷🏿‍♂️","x":24,"y":46}],"version":4},"female-construction-worker":{"id":"female-construction-worker","name":"Woman Construction Worker","keywords":["female","construction-worker","human","wip","build","labor"],"skins":[{"unified":"1f477-200d-2640-fe0f","native":"👷‍♀️","x":24,"y":35},{"unified":"1f477-1f3fb-200d-2640-fe0f","native":"👷🏻‍♀️","x":24,"y":36},{"unified":"1f477-1f3fc-200d-2640-fe0f","native":"👷🏼‍♀️","x":24,"y":37},{"unified":"1f477-1f3fd-200d-2640-fe0f","native":"👷🏽‍♀️","x":24,"y":38},{"unified":"1f477-1f3fe-200d-2640-fe0f","native":"👷🏾‍♀️","x":24,"y":39},{"unified":"1f477-1f3ff-200d-2640-fe0f","native":"👷🏿‍♀️","x":24,"y":40}],"version":4},"person_with_crown":{"id":"person_with_crown","name":"Person with Crown","keywords":["royalty","power"],"skins":[{"unified":"1fac5","native":"🫅","x":55,"y":10},{"unified":"1fac5-1f3fb","native":"🫅🏻","x":55,"y":11},{"unified":"1fac5-1f3fc","native":"🫅🏼","x":55,"y":12},{"unified":"1fac5-1f3fd","native":"🫅🏽","x":55,"y":13},{"unified":"1fac5-1f3fe","native":"🫅🏾","x":55,"y":14},{"unified":"1fac5-1f3ff","native":"🫅🏿","x":55,"y":15}],"version":14},"prince":{"id":"prince","name":"Prince","keywords":["boy","man","male","crown","royal","king"],"skins":[{"unified":"1f934","native":"🤴","x":41,"y":10},{"unified":"1f934-1f3fb","native":"🤴🏻","x":41,"y":11},{"unified":"1f934-1f3fc","native":"🤴🏼","x":41,"y":12},{"unified":"1f934-1f3fd","native":"🤴🏽","x":41,"y":13},{"unified":"1f934-1f3fe","native":"🤴🏾","x":41,"y":14},{"unified":"1f934-1f3ff","native":"🤴🏿","x":41,"y":15}],"version":3},"princess":{"id":"princess","name":"Princess","keywords":["girl","woman","female","blond","crown","royal","queen"],"skins":[{"unified":"1f478","native":"👸","x":24,"y":53},{"unified":"1f478-1f3fb","native":"👸🏻","x":24,"y":54},{"unified":"1f478-1f3fc","native":"👸🏼","x":24,"y":55},{"unified":"1f478-1f3fd","native":"👸🏽","x":24,"y":56},{"unified":"1f478-1f3fe","native":"👸🏾","x":24,"y":57},{"unified":"1f478-1f3ff","native":"👸🏿","x":24,"y":58}],"version":1},"man_with_turban":{"id":"man_with_turban","name":"Man with Turban","keywords":["person","wearing","headdress"],"skins":[{"unified":"1f473","native":"👳","x":24,"y":11},{"unified":"1f473-1f3fb","native":"👳🏻","x":24,"y":12},{"unified":"1f473-1f3fc","native":"👳🏼","x":24,"y":13},{"unified":"1f473-1f3fd","native":"👳🏽","x":24,"y":14},{"unified":"1f473-1f3fe","native":"👳🏾","x":24,"y":15},{"unified":"1f473-1f3ff","native":"👳🏿","x":24,"y":16}],"version":1},"man-wearing-turban":{"id":"man-wearing-turban","name":"Man Wearing Turban","keywords":["wearing-turban","male","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2642-fe0f","native":"👳‍♂️","x":24,"y":5},{"unified":"1f473-1f3fb-200d-2642-fe0f","native":"👳🏻‍♂️","x":24,"y":6},{"unified":"1f473-1f3fc-200d-2642-fe0f","native":"👳🏼‍♂️","x":24,"y":7},{"unified":"1f473-1f3fd-200d-2642-fe0f","native":"👳🏽‍♂️","x":24,"y":8},{"unified":"1f473-1f3fe-200d-2642-fe0f","native":"👳🏾‍♂️","x":24,"y":9},{"unified":"1f473-1f3ff-200d-2642-fe0f","native":"👳🏿‍♂️","x":24,"y":10}],"version":4},"woman-wearing-turban":{"id":"woman-wearing-turban","name":"Woman Wearing Turban","keywords":["wearing-turban","female","indian","hinduism","arabs"],"skins":[{"unified":"1f473-200d-2640-fe0f","native":"👳‍♀️","x":23,"y":60},{"unified":"1f473-1f3fb-200d-2640-fe0f","native":"👳🏻‍♀️","x":24,"y":0},{"unified":"1f473-1f3fc-200d-2640-fe0f","native":"👳🏼‍♀️","x":24,"y":1},{"unified":"1f473-1f3fd-200d-2640-fe0f","native":"👳🏽‍♀️","x":24,"y":2},{"unified":"1f473-1f3fe-200d-2640-fe0f","native":"👳🏾‍♀️","x":24,"y":3},{"unified":"1f473-1f3ff-200d-2640-fe0f","native":"👳🏿‍♀️","x":24,"y":4}],"version":4},"man_with_gua_pi_mao":{"id":"man_with_gua_pi_mao","name":"Man with Gua Pi Mao","keywords":["skullcap","male","boy","chinese"],"skins":[{"unified":"1f472","native":"👲","x":23,"y":54},{"unified":"1f472-1f3fb","native":"👲🏻","x":23,"y":55},{"unified":"1f472-1f3fc","native":"👲🏼","x":23,"y":56},{"unified":"1f472-1f3fd","native":"👲🏽","x":23,"y":57},{"unified":"1f472-1f3fe","native":"👲🏾","x":23,"y":58},{"unified":"1f472-1f3ff","native":"👲🏿","x":23,"y":59}],"version":1},"person_with_headscarf":{"id":"person_with_headscarf","name":"Woman with Headscarf","keywords":["person","female","hijab","mantilla","tichel"],"skins":[{"unified":"1f9d5","native":"🧕","x":50,"y":43},{"unified":"1f9d5-1f3fb","native":"🧕🏻","x":50,"y":44},{"unified":"1f9d5-1f3fc","native":"🧕🏼","x":50,"y":45},{"unified":"1f9d5-1f3fd","native":"🧕🏽","x":50,"y":46},{"unified":"1f9d5-1f3fe","native":"🧕🏾","x":50,"y":47},{"unified":"1f9d5-1f3ff","native":"🧕🏿","x":50,"y":48}],"version":5},"person_in_tuxedo":{"id":"person_in_tuxedo","name":"Man in Tuxedo","keywords":["person","couple","marriage","wedding","groom"],"skins":[{"unified":"1f935","native":"🤵","x":41,"y":28},{"unified":"1f935-1f3fb","native":"🤵🏻","x":41,"y":29},{"unified":"1f935-1f3fc","native":"🤵🏼","x":41,"y":30},{"unified":"1f935-1f3fd","native":"🤵🏽","x":41,"y":31},{"unified":"1f935-1f3fe","native":"🤵🏾","x":41,"y":32},{"unified":"1f935-1f3ff","native":"🤵🏿","x":41,"y":33}],"version":3},"man_in_tuxedo":{"id":"man_in_tuxedo","name":"Man in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2642-fe0f","native":"🤵‍♂️","x":41,"y":22},{"unified":"1f935-1f3fb-200d-2642-fe0f","native":"🤵🏻‍♂️","x":41,"y":23},{"unified":"1f935-1f3fc-200d-2642-fe0f","native":"🤵🏼‍♂️","x":41,"y":24},{"unified":"1f935-1f3fd-200d-2642-fe0f","native":"🤵🏽‍♂️","x":41,"y":25},{"unified":"1f935-1f3fe-200d-2642-fe0f","native":"🤵🏾‍♂️","x":41,"y":26},{"unified":"1f935-1f3ff-200d-2642-fe0f","native":"🤵🏿‍♂️","x":41,"y":27}],"version":13},"woman_in_tuxedo":{"id":"woman_in_tuxedo","name":"Woman in Tuxedo","keywords":["formal","fashion"],"skins":[{"unified":"1f935-200d-2640-fe0f","native":"🤵‍♀️","x":41,"y":16},{"unified":"1f935-1f3fb-200d-2640-fe0f","native":"🤵🏻‍♀️","x":41,"y":17},{"unified":"1f935-1f3fc-200d-2640-fe0f","native":"🤵🏼‍♀️","x":41,"y":18},{"unified":"1f935-1f3fd-200d-2640-fe0f","native":"🤵🏽‍♀️","x":41,"y":19},{"unified":"1f935-1f3fe-200d-2640-fe0f","native":"🤵🏾‍♀️","x":41,"y":20},{"unified":"1f935-1f3ff-200d-2640-fe0f","native":"🤵🏿‍♀️","x":41,"y":21}],"version":13},"bride_with_veil":{"id":"bride_with_veil","name":"Bride with Veil","keywords":["couple","marriage","wedding","woman"],"skins":[{"unified":"1f470","native":"👰","x":23,"y":30},{"unified":"1f470-1f3fb","native":"👰🏻","x":23,"y":31},{"unified":"1f470-1f3fc","native":"👰🏼","x":23,"y":32},{"unified":"1f470-1f3fd","native":"👰🏽","x":23,"y":33},{"unified":"1f470-1f3fe","native":"👰🏾","x":23,"y":34},{"unified":"1f470-1f3ff","native":"👰🏿","x":23,"y":35}],"version":1},"man_with_veil":{"id":"man_with_veil","name":"Man with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2642-fe0f","native":"👰‍♂️","x":23,"y":24},{"unified":"1f470-1f3fb-200d-2642-fe0f","native":"👰🏻‍♂️","x":23,"y":25},{"unified":"1f470-1f3fc-200d-2642-fe0f","native":"👰🏼‍♂️","x":23,"y":26},{"unified":"1f470-1f3fd-200d-2642-fe0f","native":"👰🏽‍♂️","x":23,"y":27},{"unified":"1f470-1f3fe-200d-2642-fe0f","native":"👰🏾‍♂️","x":23,"y":28},{"unified":"1f470-1f3ff-200d-2642-fe0f","native":"👰🏿‍♂️","x":23,"y":29}],"version":13},"woman_with_veil":{"id":"woman_with_veil","name":"Woman with Veil","keywords":["wedding","marriage"],"skins":[{"unified":"1f470-200d-2640-fe0f","native":"👰‍♀️","x":23,"y":18},{"unified":"1f470-1f3fb-200d-2640-fe0f","native":"👰🏻‍♀️","x":23,"y":19},{"unified":"1f470-1f3fc-200d-2640-fe0f","native":"👰🏼‍♀️","x":23,"y":20},{"unified":"1f470-1f3fd-200d-2640-fe0f","native":"👰🏽‍♀️","x":23,"y":21},{"unified":"1f470-1f3fe-200d-2640-fe0f","native":"👰🏾‍♀️","x":23,"y":22},{"unified":"1f470-1f3ff-200d-2640-fe0f","native":"👰🏿‍♀️","x":23,"y":23}],"version":13},"pregnant_woman":{"id":"pregnant_woman","name":"Pregnant Woman","keywords":["baby"],"skins":[{"unified":"1f930","native":"🤰","x":40,"y":47},{"unified":"1f930-1f3fb","native":"🤰🏻","x":40,"y":48},{"unified":"1f930-1f3fc","native":"🤰🏼","x":40,"y":49},{"unified":"1f930-1f3fd","native":"🤰🏽","x":40,"y":50},{"unified":"1f930-1f3fe","native":"🤰🏾","x":40,"y":51},{"unified":"1f930-1f3ff","native":"🤰🏿","x":40,"y":52}],"version":3},"pregnant_man":{"id":"pregnant_man","name":"Pregnant Man","keywords":["baby","belly"],"skins":[{"unified":"1fac3","native":"🫃","x":54,"y":59},{"unified":"1fac3-1f3fb","native":"🫃🏻","x":54,"y":60},{"unified":"1fac3-1f3fc","native":"🫃🏼","x":55,"y":0},{"unified":"1fac3-1f3fd","native":"🫃🏽","x":55,"y":1},{"unified":"1fac3-1f3fe","native":"🫃🏾","x":55,"y":2},{"unified":"1fac3-1f3ff","native":"🫃🏿","x":55,"y":3}],"version":14},"pregnant_person":{"id":"pregnant_person","name":"Pregnant Person","keywords":["baby","belly"],"skins":[{"unified":"1fac4","native":"🫄","x":55,"y":4},{"unified":"1fac4-1f3fb","native":"🫄🏻","x":55,"y":5},{"unified":"1fac4-1f3fc","native":"🫄🏼","x":55,"y":6},{"unified":"1fac4-1f3fd","native":"🫄🏽","x":55,"y":7},{"unified":"1fac4-1f3fe","native":"🫄🏾","x":55,"y":8},{"unified":"1fac4-1f3ff","native":"🫄🏿","x":55,"y":9}],"version":14},"breast-feeding":{"id":"breast-feeding","name":"Breast-Feeding","keywords":["breast","feeding","nursing","baby"],"skins":[{"unified":"1f931","native":"🤱","x":40,"y":53},{"unified":"1f931-1f3fb","native":"🤱🏻","x":40,"y":54},{"unified":"1f931-1f3fc","native":"🤱🏼","x":40,"y":55},{"unified":"1f931-1f3fd","native":"🤱🏽","x":40,"y":56},{"unified":"1f931-1f3fe","native":"🤱🏾","x":40,"y":57},{"unified":"1f931-1f3ff","native":"🤱🏿","x":40,"y":58}],"version":5},"woman_feeding_baby":{"id":"woman_feeding_baby","name":"Woman Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f469-200d-1f37c","native":"👩‍🍼","x":17,"y":32},{"unified":"1f469-1f3fb-200d-1f37c","native":"👩🏻‍🍼","x":17,"y":33},{"unified":"1f469-1f3fc-200d-1f37c","native":"👩🏼‍🍼","x":17,"y":34},{"unified":"1f469-1f3fd-200d-1f37c","native":"👩🏽‍🍼","x":17,"y":35},{"unified":"1f469-1f3fe-200d-1f37c","native":"👩🏾‍🍼","x":17,"y":36},{"unified":"1f469-1f3ff-200d-1f37c","native":"👩🏿‍🍼","x":17,"y":37}],"version":13},"man_feeding_baby":{"id":"man_feeding_baby","name":"Man Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f468-200d-1f37c","native":"👨‍🍼","x":13,"y":59},{"unified":"1f468-1f3fb-200d-1f37c","native":"👨🏻‍🍼","x":13,"y":60},{"unified":"1f468-1f3fc-200d-1f37c","native":"👨🏼‍🍼","x":14,"y":0},{"unified":"1f468-1f3fd-200d-1f37c","native":"👨🏽‍🍼","x":14,"y":1},{"unified":"1f468-1f3fe-200d-1f37c","native":"👨🏾‍🍼","x":14,"y":2},{"unified":"1f468-1f3ff-200d-1f37c","native":"👨🏿‍🍼","x":14,"y":3}],"version":13},"person_feeding_baby":{"id":"person_feeding_baby","name":"Person Feeding Baby","keywords":["birth","food"],"skins":[{"unified":"1f9d1-200d-1f37c","native":"🧑‍🍼","x":47,"y":26},{"unified":"1f9d1-1f3fb-200d-1f37c","native":"🧑🏻‍🍼","x":47,"y":27},{"unified":"1f9d1-1f3fc-200d-1f37c","native":"🧑🏼‍🍼","x":47,"y":28},{"unified":"1f9d1-1f3fd-200d-1f37c","native":"🧑🏽‍🍼","x":47,"y":29},{"unified":"1f9d1-1f3fe-200d-1f37c","native":"🧑🏾‍🍼","x":47,"y":30},{"unified":"1f9d1-1f3ff-200d-1f37c","native":"🧑🏿‍🍼","x":47,"y":31}],"version":13},"angel":{"id":"angel","name":"Baby Angel","keywords":["heaven","wings","halo"],"skins":[{"unified":"1f47c","native":"👼","x":25,"y":1},{"unified":"1f47c-1f3fb","native":"👼🏻","x":25,"y":2},{"unified":"1f47c-1f3fc","native":"👼🏼","x":25,"y":3},{"unified":"1f47c-1f3fd","native":"👼🏽","x":25,"y":4},{"unified":"1f47c-1f3fe","native":"👼🏾","x":25,"y":5},{"unified":"1f47c-1f3ff","native":"👼🏿","x":25,"y":6}],"version":1},"santa":{"id":"santa","name":"Santa Claus","keywords":["festival","man","male","xmas","father","christmas"],"skins":[{"unified":"1f385","native":"🎅","x":7,"y":8},{"unified":"1f385-1f3fb","native":"🎅🏻","x":7,"y":9},{"unified":"1f385-1f3fc","native":"🎅🏼","x":7,"y":10},{"unified":"1f385-1f3fd","native":"🎅🏽","x":7,"y":11},{"unified":"1f385-1f3fe","native":"🎅🏾","x":7,"y":12},{"unified":"1f385-1f3ff","native":"🎅🏿","x":7,"y":13}],"version":1},"mrs_claus":{"id":"mrs_claus","name":"Mrs. Claus","keywords":["mrs","mother","christmas","woman","female","xmas"],"skins":[{"unified":"1f936","native":"🤶","x":41,"y":34},{"unified":"1f936-1f3fb","native":"🤶🏻","x":41,"y":35},{"unified":"1f936-1f3fc","native":"🤶🏼","x":41,"y":36},{"unified":"1f936-1f3fd","native":"🤶🏽","x":41,"y":37},{"unified":"1f936-1f3fe","native":"🤶🏾","x":41,"y":38},{"unified":"1f936-1f3ff","native":"🤶🏿","x":41,"y":39}],"version":3},"mx_claus":{"id":"mx_claus","name":"Mx Claus","keywords":["christmas"],"skins":[{"unified":"1f9d1-200d-1f384","native":"🧑‍🎄","x":47,"y":32},{"unified":"1f9d1-1f3fb-200d-1f384","native":"🧑🏻‍🎄","x":47,"y":33},{"unified":"1f9d1-1f3fc-200d-1f384","native":"🧑🏼‍🎄","x":47,"y":34},{"unified":"1f9d1-1f3fd-200d-1f384","native":"🧑🏽‍🎄","x":47,"y":35},{"unified":"1f9d1-1f3fe-200d-1f384","native":"🧑🏾‍🎄","x":47,"y":36},{"unified":"1f9d1-1f3ff-200d-1f384","native":"🧑🏿‍🎄","x":47,"y":37}],"version":13},"superhero":{"id":"superhero","name":"Superhero","keywords":["marvel"],"skins":[{"unified":"1f9b8","native":"🦸","x":45,"y":33},{"unified":"1f9b8-1f3fb","native":"🦸🏻","x":45,"y":34},{"unified":"1f9b8-1f3fc","native":"🦸🏼","x":45,"y":35},{"unified":"1f9b8-1f3fd","native":"🦸🏽","x":45,"y":36},{"unified":"1f9b8-1f3fe","native":"🦸🏾","x":45,"y":37},{"unified":"1f9b8-1f3ff","native":"🦸🏿","x":45,"y":38}],"version":11},"male_superhero":{"id":"male_superhero","name":"Man Superhero","keywords":["male","good","hero","superpowers"],"skins":[{"unified":"1f9b8-200d-2642-fe0f","native":"🦸‍♂️","x":45,"y":27},{"unified":"1f9b8-1f3fb-200d-2642-fe0f","native":"🦸🏻‍♂️","x":45,"y":28},{"unified":"1f9b8-1f3fc-200d-2642-fe0f","native":"🦸🏼‍♂️","x":45,"y":29},{"unified":"1f9b8-1f3fd-200d-2642-fe0f","native":"🦸🏽‍♂️","x":45,"y":30},{"unified":"1f9b8-1f3fe-200d-2642-fe0f","native":"🦸🏾‍♂️","x":45,"y":31},{"unified":"1f9b8-1f3ff-200d-2642-fe0f","native":"🦸🏿‍♂️","x":45,"y":32}],"version":11},"female_superhero":{"id":"female_superhero","name":"Woman Superhero","keywords":["female","good","heroine","superpowers"],"skins":[{"unified":"1f9b8-200d-2640-fe0f","native":"🦸‍♀️","x":45,"y":21},{"unified":"1f9b8-1f3fb-200d-2640-fe0f","native":"🦸🏻‍♀️","x":45,"y":22},{"unified":"1f9b8-1f3fc-200d-2640-fe0f","native":"🦸🏼‍♀️","x":45,"y":23},{"unified":"1f9b8-1f3fd-200d-2640-fe0f","native":"🦸🏽‍♀️","x":45,"y":24},{"unified":"1f9b8-1f3fe-200d-2640-fe0f","native":"🦸🏾‍♀️","x":45,"y":25},{"unified":"1f9b8-1f3ff-200d-2640-fe0f","native":"🦸🏿‍♀️","x":45,"y":26}],"version":11},"supervillain":{"id":"supervillain","name":"Supervillain","keywords":["marvel"],"skins":[{"unified":"1f9b9","native":"🦹","x":45,"y":51},{"unified":"1f9b9-1f3fb","native":"🦹🏻","x":45,"y":52},{"unified":"1f9b9-1f3fc","native":"🦹🏼","x":45,"y":53},{"unified":"1f9b9-1f3fd","native":"🦹🏽","x":45,"y":54},{"unified":"1f9b9-1f3fe","native":"🦹🏾","x":45,"y":55},{"unified":"1f9b9-1f3ff","native":"🦹🏿","x":45,"y":56}],"version":11},"male_supervillain":{"id":"male_supervillain","name":"Man Supervillain","keywords":["male","evil","bad","criminal","hero","superpowers"],"skins":[{"unified":"1f9b9-200d-2642-fe0f","native":"🦹‍♂️","x":45,"y":45},{"unified":"1f9b9-1f3fb-200d-2642-fe0f","native":"🦹🏻‍♂️","x":45,"y":46},{"unified":"1f9b9-1f3fc-200d-2642-fe0f","native":"🦹🏼‍♂️","x":45,"y":47},{"unified":"1f9b9-1f3fd-200d-2642-fe0f","native":"🦹🏽‍♂️","x":45,"y":48},{"unified":"1f9b9-1f3fe-200d-2642-fe0f","native":"🦹🏾‍♂️","x":45,"y":49},{"unified":"1f9b9-1f3ff-200d-2642-fe0f","native":"🦹🏿‍♂️","x":45,"y":50}],"version":11},"female_supervillain":{"id":"female_supervillain","name":"Woman Supervillain","keywords":["female","evil","bad","criminal","heroine","superpowers"],"skins":[{"unified":"1f9b9-200d-2640-fe0f","native":"🦹‍♀️","x":45,"y":39},{"unified":"1f9b9-1f3fb-200d-2640-fe0f","native":"🦹🏻‍♀️","x":45,"y":40},{"unified":"1f9b9-1f3fc-200d-2640-fe0f","native":"🦹🏼‍♀️","x":45,"y":41},{"unified":"1f9b9-1f3fd-200d-2640-fe0f","native":"🦹🏽‍♀️","x":45,"y":42},{"unified":"1f9b9-1f3fe-200d-2640-fe0f","native":"🦹🏾‍♀️","x":45,"y":43},{"unified":"1f9b9-1f3ff-200d-2640-fe0f","native":"🦹🏿‍♀️","x":45,"y":44}],"version":11},"mage":{"id":"mage","name":"Mage","keywords":["magic"],"skins":[{"unified":"1f9d9","native":"🧙","x":51,"y":54},{"unified":"1f9d9-1f3fb","native":"🧙🏻","x":51,"y":55},{"unified":"1f9d9-1f3fc","native":"🧙🏼","x":51,"y":56},{"unified":"1f9d9-1f3fd","native":"🧙🏽","x":51,"y":57},{"unified":"1f9d9-1f3fe","native":"🧙🏾","x":51,"y":58},{"unified":"1f9d9-1f3ff","native":"🧙🏿","x":51,"y":59}],"version":5},"male_mage":{"id":"male_mage","name":"Man Mage","keywords":["male","sorcerer"],"skins":[{"unified":"1f9d9-200d-2642-fe0f","native":"🧙‍♂️","x":51,"y":48},{"unified":"1f9d9-1f3fb-200d-2642-fe0f","native":"🧙🏻‍♂️","x":51,"y":49},{"unified":"1f9d9-1f3fc-200d-2642-fe0f","native":"🧙🏼‍♂️","x":51,"y":50},{"unified":"1f9d9-1f3fd-200d-2642-fe0f","native":"🧙🏽‍♂️","x":51,"y":51},{"unified":"1f9d9-1f3fe-200d-2642-fe0f","native":"🧙🏾‍♂️","x":51,"y":52},{"unified":"1f9d9-1f3ff-200d-2642-fe0f","native":"🧙🏿‍♂️","x":51,"y":53}],"version":5},"female_mage":{"id":"female_mage","name":"Woman Mage","keywords":["female","witch"],"skins":[{"unified":"1f9d9-200d-2640-fe0f","native":"🧙‍♀️","x":51,"y":42},{"unified":"1f9d9-1f3fb-200d-2640-fe0f","native":"🧙🏻‍♀️","x":51,"y":43},{"unified":"1f9d9-1f3fc-200d-2640-fe0f","native":"🧙🏼‍♀️","x":51,"y":44},{"unified":"1f9d9-1f3fd-200d-2640-fe0f","native":"🧙🏽‍♀️","x":51,"y":45},{"unified":"1f9d9-1f3fe-200d-2640-fe0f","native":"🧙🏾‍♀️","x":51,"y":46},{"unified":"1f9d9-1f3ff-200d-2640-fe0f","native":"🧙🏿‍♀️","x":51,"y":47}],"version":5},"fairy":{"id":"fairy","name":"Fairy","keywords":["wings","magical"],"skins":[{"unified":"1f9da","native":"🧚","x":52,"y":11},{"unified":"1f9da-1f3fb","native":"🧚🏻","x":52,"y":12},{"unified":"1f9da-1f3fc","native":"🧚🏼","x":52,"y":13},{"unified":"1f9da-1f3fd","native":"🧚🏽","x":52,"y":14},{"unified":"1f9da-1f3fe","native":"🧚🏾","x":52,"y":15},{"unified":"1f9da-1f3ff","native":"🧚🏿","x":52,"y":16}],"version":5},"male_fairy":{"id":"male_fairy","name":"Man Fairy","keywords":["male"],"skins":[{"unified":"1f9da-200d-2642-fe0f","native":"🧚‍♂️","x":52,"y":5},{"unified":"1f9da-1f3fb-200d-2642-fe0f","native":"🧚🏻‍♂️","x":52,"y":6},{"unified":"1f9da-1f3fc-200d-2642-fe0f","native":"🧚🏼‍♂️","x":52,"y":7},{"unified":"1f9da-1f3fd-200d-2642-fe0f","native":"🧚🏽‍♂️","x":52,"y":8},{"unified":"1f9da-1f3fe-200d-2642-fe0f","native":"🧚🏾‍♂️","x":52,"y":9},{"unified":"1f9da-1f3ff-200d-2642-fe0f","native":"🧚🏿‍♂️","x":52,"y":10}],"version":5},"female_fairy":{"id":"female_fairy","name":"Woman Fairy","keywords":["female"],"skins":[{"unified":"1f9da-200d-2640-fe0f","native":"🧚‍♀️","x":51,"y":60},{"unified":"1f9da-1f3fb-200d-2640-fe0f","native":"🧚🏻‍♀️","x":52,"y":0},{"unified":"1f9da-1f3fc-200d-2640-fe0f","native":"🧚🏼‍♀️","x":52,"y":1},{"unified":"1f9da-1f3fd-200d-2640-fe0f","native":"🧚🏽‍♀️","x":52,"y":2},{"unified":"1f9da-1f3fe-200d-2640-fe0f","native":"🧚🏾‍♀️","x":52,"y":3},{"unified":"1f9da-1f3ff-200d-2640-fe0f","native":"🧚🏿‍♀️","x":52,"y":4}],"version":5},"vampire":{"id":"vampire","name":"Vampire","keywords":["blood","twilight"],"skins":[{"unified":"1f9db","native":"🧛","x":52,"y":29},{"unified":"1f9db-1f3fb","native":"🧛🏻","x":52,"y":30},{"unified":"1f9db-1f3fc","native":"🧛🏼","x":52,"y":31},{"unified":"1f9db-1f3fd","native":"🧛🏽","x":52,"y":32},{"unified":"1f9db-1f3fe","native":"🧛🏾","x":52,"y":33},{"unified":"1f9db-1f3ff","native":"🧛🏿","x":52,"y":34}],"version":5},"male_vampire":{"id":"male_vampire","name":"Man Vampire","keywords":["male","dracula"],"skins":[{"unified":"1f9db-200d-2642-fe0f","native":"🧛‍♂️","x":52,"y":23},{"unified":"1f9db-1f3fb-200d-2642-fe0f","native":"🧛🏻‍♂️","x":52,"y":24},{"unified":"1f9db-1f3fc-200d-2642-fe0f","native":"🧛🏼‍♂️","x":52,"y":25},{"unified":"1f9db-1f3fd-200d-2642-fe0f","native":"🧛🏽‍♂️","x":52,"y":26},{"unified":"1f9db-1f3fe-200d-2642-fe0f","native":"🧛🏾‍♂️","x":52,"y":27},{"unified":"1f9db-1f3ff-200d-2642-fe0f","native":"🧛🏿‍♂️","x":52,"y":28}],"version":5},"female_vampire":{"id":"female_vampire","name":"Woman Vampire","keywords":["female"],"skins":[{"unified":"1f9db-200d-2640-fe0f","native":"🧛‍♀️","x":52,"y":17},{"unified":"1f9db-1f3fb-200d-2640-fe0f","native":"🧛🏻‍♀️","x":52,"y":18},{"unified":"1f9db-1f3fc-200d-2640-fe0f","native":"🧛🏼‍♀️","x":52,"y":19},{"unified":"1f9db-1f3fd-200d-2640-fe0f","native":"🧛🏽‍♀️","x":52,"y":20},{"unified":"1f9db-1f3fe-200d-2640-fe0f","native":"🧛🏾‍♀️","x":52,"y":21},{"unified":"1f9db-1f3ff-200d-2640-fe0f","native":"🧛🏿‍♀️","x":52,"y":22}],"version":5},"merperson":{"id":"merperson","name":"Merperson","keywords":["sea"],"skins":[{"unified":"1f9dc","native":"🧜","x":52,"y":47},{"unified":"1f9dc-1f3fb","native":"🧜🏻","x":52,"y":48},{"unified":"1f9dc-1f3fc","native":"🧜🏼","x":52,"y":49},{"unified":"1f9dc-1f3fd","native":"🧜🏽","x":52,"y":50},{"unified":"1f9dc-1f3fe","native":"🧜🏾","x":52,"y":51},{"unified":"1f9dc-1f3ff","native":"🧜🏿","x":52,"y":52}],"version":5},"merman":{"id":"merman","name":"Merman","keywords":["man","male","triton"],"skins":[{"unified":"1f9dc-200d-2642-fe0f","native":"🧜‍♂️","x":52,"y":41},{"unified":"1f9dc-1f3fb-200d-2642-fe0f","native":"🧜🏻‍♂️","x":52,"y":42},{"unified":"1f9dc-1f3fc-200d-2642-fe0f","native":"🧜🏼‍♂️","x":52,"y":43},{"unified":"1f9dc-1f3fd-200d-2642-fe0f","native":"🧜🏽‍♂️","x":52,"y":44},{"unified":"1f9dc-1f3fe-200d-2642-fe0f","native":"🧜🏾‍♂️","x":52,"y":45},{"unified":"1f9dc-1f3ff-200d-2642-fe0f","native":"🧜🏿‍♂️","x":52,"y":46}],"version":5},"mermaid":{"id":"mermaid","name":"Mermaid","keywords":["woman","female","merwoman","ariel"],"skins":[{"unified":"1f9dc-200d-2640-fe0f","native":"🧜‍♀️","x":52,"y":35},{"unified":"1f9dc-1f3fb-200d-2640-fe0f","native":"🧜🏻‍♀️","x":52,"y":36},{"unified":"1f9dc-1f3fc-200d-2640-fe0f","native":"🧜🏼‍♀️","x":52,"y":37},{"unified":"1f9dc-1f3fd-200d-2640-fe0f","native":"🧜🏽‍♀️","x":52,"y":38},{"unified":"1f9dc-1f3fe-200d-2640-fe0f","native":"🧜🏾‍♀️","x":52,"y":39},{"unified":"1f9dc-1f3ff-200d-2640-fe0f","native":"🧜🏿‍♀️","x":52,"y":40}],"version":5},"elf":{"id":"elf","name":"Elf","keywords":["magical"],"skins":[{"unified":"1f9dd","native":"🧝","x":53,"y":4},{"unified":"1f9dd-1f3fb","native":"🧝🏻","x":53,"y":5},{"unified":"1f9dd-1f3fc","native":"🧝🏼","x":53,"y":6},{"unified":"1f9dd-1f3fd","native":"🧝🏽","x":53,"y":7},{"unified":"1f9dd-1f3fe","native":"🧝🏾","x":53,"y":8},{"unified":"1f9dd-1f3ff","native":"🧝🏿","x":53,"y":9}],"version":5},"male_elf":{"id":"male_elf","name":"Man Elf","keywords":["male"],"skins":[{"unified":"1f9dd-200d-2642-fe0f","native":"🧝‍♂️","x":52,"y":59},{"unified":"1f9dd-1f3fb-200d-2642-fe0f","native":"🧝🏻‍♂️","x":52,"y":60},{"unified":"1f9dd-1f3fc-200d-2642-fe0f","native":"🧝🏼‍♂️","x":53,"y":0},{"unified":"1f9dd-1f3fd-200d-2642-fe0f","native":"🧝🏽‍♂️","x":53,"y":1},{"unified":"1f9dd-1f3fe-200d-2642-fe0f","native":"🧝🏾‍♂️","x":53,"y":2},{"unified":"1f9dd-1f3ff-200d-2642-fe0f","native":"🧝🏿‍♂️","x":53,"y":3}],"version":5},"female_elf":{"id":"female_elf","name":"Woman Elf","keywords":["female"],"skins":[{"unified":"1f9dd-200d-2640-fe0f","native":"🧝‍♀️","x":52,"y":53},{"unified":"1f9dd-1f3fb-200d-2640-fe0f","native":"🧝🏻‍♀️","x":52,"y":54},{"unified":"1f9dd-1f3fc-200d-2640-fe0f","native":"🧝🏼‍♀️","x":52,"y":55},{"unified":"1f9dd-1f3fd-200d-2640-fe0f","native":"🧝🏽‍♀️","x":52,"y":56},{"unified":"1f9dd-1f3fe-200d-2640-fe0f","native":"🧝🏾‍♀️","x":52,"y":57},{"unified":"1f9dd-1f3ff-200d-2640-fe0f","native":"🧝🏿‍♀️","x":52,"y":58}],"version":5},"genie":{"id":"genie","name":"Genie","keywords":["magical","wishes"],"skins":[{"unified":"1f9de","native":"🧞","x":53,"y":12}],"version":5},"male_genie":{"id":"male_genie","name":"Man Genie","keywords":["male"],"skins":[{"unified":"1f9de-200d-2642-fe0f","native":"🧞‍♂️","x":53,"y":11}],"version":5},"female_genie":{"id":"female_genie","name":"Woman Genie","keywords":["female"],"skins":[{"unified":"1f9de-200d-2640-fe0f","native":"🧞‍♀️","x":53,"y":10}],"version":5},"zombie":{"id":"zombie","name":"Zombie","keywords":["dead"],"skins":[{"unified":"1f9df","native":"🧟","x":53,"y":15}],"version":5},"male_zombie":{"id":"male_zombie","name":"Man Zombie","keywords":["male","dracula","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2642-fe0f","native":"🧟‍♂️","x":53,"y":14}],"version":5},"female_zombie":{"id":"female_zombie","name":"Woman Zombie","keywords":["female","undead","walking","dead"],"skins":[{"unified":"1f9df-200d-2640-fe0f","native":"🧟‍♀️","x":53,"y":13}],"version":5},"troll":{"id":"troll","name":"Troll","keywords":["mystical","monster"],"skins":[{"unified":"1f9cc","native":"🧌","x":46,"y":19}],"version":14},"massage":{"id":"massage","name":"Face Massage","keywords":["person","getting","relax"],"skins":[{"unified":"1f486","native":"💆","x":26,"y":11},{"unified":"1f486-1f3fb","native":"💆🏻","x":26,"y":12},{"unified":"1f486-1f3fc","native":"💆🏼","x":26,"y":13},{"unified":"1f486-1f3fd","native":"💆🏽","x":26,"y":14},{"unified":"1f486-1f3fe","native":"💆🏾","x":26,"y":15},{"unified":"1f486-1f3ff","native":"💆🏿","x":26,"y":16}],"version":1},"man-getting-massage":{"id":"man-getting-massage","name":"Man Getting Massage","keywords":["getting-massage","male","boy","head"],"skins":[{"unified":"1f486-200d-2642-fe0f","native":"💆‍♂️","x":26,"y":5},{"unified":"1f486-1f3fb-200d-2642-fe0f","native":"💆🏻‍♂️","x":26,"y":6},{"unified":"1f486-1f3fc-200d-2642-fe0f","native":"💆🏼‍♂️","x":26,"y":7},{"unified":"1f486-1f3fd-200d-2642-fe0f","native":"💆🏽‍♂️","x":26,"y":8},{"unified":"1f486-1f3fe-200d-2642-fe0f","native":"💆🏾‍♂️","x":26,"y":9},{"unified":"1f486-1f3ff-200d-2642-fe0f","native":"💆🏿‍♂️","x":26,"y":10}],"version":4},"woman-getting-massage":{"id":"woman-getting-massage","name":"Woman Getting Massage","keywords":["getting-massage","female","girl","head"],"skins":[{"unified":"1f486-200d-2640-fe0f","native":"💆‍♀️","x":25,"y":60},{"unified":"1f486-1f3fb-200d-2640-fe0f","native":"💆🏻‍♀️","x":26,"y":0},{"unified":"1f486-1f3fc-200d-2640-fe0f","native":"💆🏼‍♀️","x":26,"y":1},{"unified":"1f486-1f3fd-200d-2640-fe0f","native":"💆🏽‍♀️","x":26,"y":2},{"unified":"1f486-1f3fe-200d-2640-fe0f","native":"💆🏾‍♀️","x":26,"y":3},{"unified":"1f486-1f3ff-200d-2640-fe0f","native":"💆🏿‍♀️","x":26,"y":4}],"version":4},"haircut":{"id":"haircut","name":"Haircut","keywords":["person","getting","hairstyle"],"skins":[{"unified":"1f487","native":"💇","x":26,"y":29},{"unified":"1f487-1f3fb","native":"💇🏻","x":26,"y":30},{"unified":"1f487-1f3fc","native":"💇🏼","x":26,"y":31},{"unified":"1f487-1f3fd","native":"💇🏽","x":26,"y":32},{"unified":"1f487-1f3fe","native":"💇🏾","x":26,"y":33},{"unified":"1f487-1f3ff","native":"💇🏿","x":26,"y":34}],"version":1},"man-getting-haircut":{"id":"man-getting-haircut","name":"Man Getting Haircut","keywords":["getting-haircut","male","boy"],"skins":[{"unified":"1f487-200d-2642-fe0f","native":"💇‍♂️","x":26,"y":23},{"unified":"1f487-1f3fb-200d-2642-fe0f","native":"💇🏻‍♂️","x":26,"y":24},{"unified":"1f487-1f3fc-200d-2642-fe0f","native":"💇🏼‍♂️","x":26,"y":25},{"unified":"1f487-1f3fd-200d-2642-fe0f","native":"💇🏽‍♂️","x":26,"y":26},{"unified":"1f487-1f3fe-200d-2642-fe0f","native":"💇🏾‍♂️","x":26,"y":27},{"unified":"1f487-1f3ff-200d-2642-fe0f","native":"💇🏿‍♂️","x":26,"y":28}],"version":4},"woman-getting-haircut":{"id":"woman-getting-haircut","name":"Woman Getting Haircut","keywords":["getting-haircut","female","girl"],"skins":[{"unified":"1f487-200d-2640-fe0f","native":"💇‍♀️","x":26,"y":17},{"unified":"1f487-1f3fb-200d-2640-fe0f","native":"💇🏻‍♀️","x":26,"y":18},{"unified":"1f487-1f3fc-200d-2640-fe0f","native":"💇🏼‍♀️","x":26,"y":19},{"unified":"1f487-1f3fd-200d-2640-fe0f","native":"💇🏽‍♀️","x":26,"y":20},{"unified":"1f487-1f3fe-200d-2640-fe0f","native":"💇🏾‍♀️","x":26,"y":21},{"unified":"1f487-1f3ff-200d-2640-fe0f","native":"💇🏿‍♀️","x":26,"y":22}],"version":4},"walking":{"id":"walking","name":"Pedestrian","keywords":["walking","person","move"],"skins":[{"unified":"1f6b6","native":"🚶","x":37,"y":28},{"unified":"1f6b6-1f3fb","native":"🚶🏻","x":37,"y":29},{"unified":"1f6b6-1f3fc","native":"🚶🏼","x":37,"y":30},{"unified":"1f6b6-1f3fd","native":"🚶🏽","x":37,"y":31},{"unified":"1f6b6-1f3fe","native":"🚶🏾","x":37,"y":32},{"unified":"1f6b6-1f3ff","native":"🚶🏿","x":37,"y":33}],"version":1},"man-walking":{"id":"man-walking","name":"Man Walking","keywords":["human","feet","steps"],"skins":[{"unified":"1f6b6-200d-2642-fe0f","native":"🚶‍♂️","x":37,"y":22},{"unified":"1f6b6-1f3fb-200d-2642-fe0f","native":"🚶🏻‍♂️","x":37,"y":23},{"unified":"1f6b6-1f3fc-200d-2642-fe0f","native":"🚶🏼‍♂️","x":37,"y":24},{"unified":"1f6b6-1f3fd-200d-2642-fe0f","native":"🚶🏽‍♂️","x":37,"y":25},{"unified":"1f6b6-1f3fe-200d-2642-fe0f","native":"🚶🏾‍♂️","x":37,"y":26},{"unified":"1f6b6-1f3ff-200d-2642-fe0f","native":"🚶🏿‍♂️","x":37,"y":27}],"version":4},"woman-walking":{"id":"woman-walking","name":"Woman Walking","keywords":["human","feet","steps","female"],"skins":[{"unified":"1f6b6-200d-2640-fe0f","native":"🚶‍♀️","x":37,"y":16},{"unified":"1f6b6-1f3fb-200d-2640-fe0f","native":"🚶🏻‍♀️","x":37,"y":17},{"unified":"1f6b6-1f3fc-200d-2640-fe0f","native":"🚶🏼‍♀️","x":37,"y":18},{"unified":"1f6b6-1f3fd-200d-2640-fe0f","native":"🚶🏽‍♀️","x":37,"y":19},{"unified":"1f6b6-1f3fe-200d-2640-fe0f","native":"🚶🏾‍♀️","x":37,"y":20},{"unified":"1f6b6-1f3ff-200d-2640-fe0f","native":"🚶🏿‍♀️","x":37,"y":21}],"version":4},"standing_person":{"id":"standing_person","name":"Standing Person","keywords":["still"],"skins":[{"unified":"1f9cd","native":"🧍","x":46,"y":32},{"unified":"1f9cd-1f3fb","native":"🧍🏻","x":46,"y":33},{"unified":"1f9cd-1f3fc","native":"🧍🏼","x":46,"y":34},{"unified":"1f9cd-1f3fd","native":"🧍🏽","x":46,"y":35},{"unified":"1f9cd-1f3fe","native":"🧍🏾","x":46,"y":36},{"unified":"1f9cd-1f3ff","native":"🧍🏿","x":46,"y":37}],"version":12},"man_standing":{"id":"man_standing","name":"Man Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2642-fe0f","native":"🧍‍♂️","x":46,"y":26},{"unified":"1f9cd-1f3fb-200d-2642-fe0f","native":"🧍🏻‍♂️","x":46,"y":27},{"unified":"1f9cd-1f3fc-200d-2642-fe0f","native":"🧍🏼‍♂️","x":46,"y":28},{"unified":"1f9cd-1f3fd-200d-2642-fe0f","native":"🧍🏽‍♂️","x":46,"y":29},{"unified":"1f9cd-1f3fe-200d-2642-fe0f","native":"🧍🏾‍♂️","x":46,"y":30},{"unified":"1f9cd-1f3ff-200d-2642-fe0f","native":"🧍🏿‍♂️","x":46,"y":31}],"version":12},"woman_standing":{"id":"woman_standing","name":"Woman Standing","keywords":["still"],"skins":[{"unified":"1f9cd-200d-2640-fe0f","native":"🧍‍♀️","x":46,"y":20},{"unified":"1f9cd-1f3fb-200d-2640-fe0f","native":"🧍🏻‍♀️","x":46,"y":21},{"unified":"1f9cd-1f3fc-200d-2640-fe0f","native":"🧍🏼‍♀️","x":46,"y":22},{"unified":"1f9cd-1f3fd-200d-2640-fe0f","native":"🧍🏽‍♀️","x":46,"y":23},{"unified":"1f9cd-1f3fe-200d-2640-fe0f","native":"🧍🏾‍♀️","x":46,"y":24},{"unified":"1f9cd-1f3ff-200d-2640-fe0f","native":"🧍🏿‍♀️","x":46,"y":25}],"version":12},"kneeling_person":{"id":"kneeling_person","name":"Kneeling Person","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce","native":"🧎","x":46,"y":50},{"unified":"1f9ce-1f3fb","native":"🧎🏻","x":46,"y":51},{"unified":"1f9ce-1f3fc","native":"🧎🏼","x":46,"y":52},{"unified":"1f9ce-1f3fd","native":"🧎🏽","x":46,"y":53},{"unified":"1f9ce-1f3fe","native":"🧎🏾","x":46,"y":54},{"unified":"1f9ce-1f3ff","native":"🧎🏿","x":46,"y":55}],"version":12},"man_kneeling":{"id":"man_kneeling","name":"Man Kneeling","keywords":["pray","respectful"],"skins":[{"unified":"1f9ce-200d-2642-fe0f","native":"🧎‍♂️","x":46,"y":44},{"unified":"1f9ce-1f3fb-200d-2642-fe0f","native":"🧎🏻‍♂️","x":46,"y":45},{"unified":"1f9ce-1f3fc-200d-2642-fe0f","native":"🧎🏼‍♂️","x":46,"y":46},{"unified":"1f9ce-1f3fd-200d-2642-fe0f","native":"🧎🏽‍♂️","x":46,"y":47},{"unified":"1f9ce-1f3fe-200d-2642-fe0f","native":"🧎🏾‍♂️","x":46,"y":48},{"unified":"1f9ce-1f3ff-200d-2642-fe0f","native":"🧎🏿‍♂️","x":46,"y":49}],"version":12},"woman_kneeling":{"id":"woman_kneeling","name":"Woman Kneeling","keywords":["respectful","pray"],"skins":[{"unified":"1f9ce-200d-2640-fe0f","native":"🧎‍♀️","x":46,"y":38},{"unified":"1f9ce-1f3fb-200d-2640-fe0f","native":"🧎🏻‍♀️","x":46,"y":39},{"unified":"1f9ce-1f3fc-200d-2640-fe0f","native":"🧎🏼‍♀️","x":46,"y":40},{"unified":"1f9ce-1f3fd-200d-2640-fe0f","native":"🧎🏽‍♀️","x":46,"y":41},{"unified":"1f9ce-1f3fe-200d-2640-fe0f","native":"🧎🏾‍♀️","x":46,"y":42},{"unified":"1f9ce-1f3ff-200d-2640-fe0f","native":"🧎🏿‍♀️","x":46,"y":43}],"version":12},"person_with_probing_cane":{"id":"person_with_probing_cane","name":"Person with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f9d1-200d-1f9af","native":"🧑‍🦯","x":49,"y":8},{"unified":"1f9d1-1f3fb-200d-1f9af","native":"🧑🏻‍🦯","x":49,"y":9},{"unified":"1f9d1-1f3fc-200d-1f9af","native":"🧑🏼‍🦯","x":49,"y":10},{"unified":"1f9d1-1f3fd-200d-1f9af","native":"🧑🏽‍🦯","x":49,"y":11},{"unified":"1f9d1-1f3fe-200d-1f9af","native":"🧑🏾‍🦯","x":49,"y":12},{"unified":"1f9d1-1f3ff-200d-1f9af","native":"🧑🏿‍🦯","x":49,"y":13}],"version":12.1},"man_with_probing_cane":{"id":"man_with_probing_cane","name":"Man with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f468-200d-1f9af","native":"👨‍🦯","x":15,"y":24},{"unified":"1f468-1f3fb-200d-1f9af","native":"👨🏻‍🦯","x":15,"y":25},{"unified":"1f468-1f3fc-200d-1f9af","native":"👨🏼‍🦯","x":15,"y":26},{"unified":"1f468-1f3fd-200d-1f9af","native":"👨🏽‍🦯","x":15,"y":27},{"unified":"1f468-1f3fe-200d-1f9af","native":"👨🏾‍🦯","x":15,"y":28},{"unified":"1f468-1f3ff-200d-1f9af","native":"👨🏿‍🦯","x":15,"y":29}],"version":12},"woman_with_probing_cane":{"id":"woman_with_probing_cane","name":"Woman with White Cane","keywords":["probing","blind"],"skins":[{"unified":"1f469-200d-1f9af","native":"👩‍🦯","x":18,"y":53},{"unified":"1f469-1f3fb-200d-1f9af","native":"👩🏻‍🦯","x":18,"y":54},{"unified":"1f469-1f3fc-200d-1f9af","native":"👩🏼‍🦯","x":18,"y":55},{"unified":"1f469-1f3fd-200d-1f9af","native":"👩🏽‍🦯","x":18,"y":56},{"unified":"1f469-1f3fe-200d-1f9af","native":"👩🏾‍🦯","x":18,"y":57},{"unified":"1f469-1f3ff-200d-1f9af","native":"👩🏿‍🦯","x":18,"y":58}],"version":12},"person_in_motorized_wheelchair":{"id":"person_in_motorized_wheelchair","name":"Person in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bc","native":"🧑‍🦼","x":49,"y":38},{"unified":"1f9d1-1f3fb-200d-1f9bc","native":"🧑🏻‍🦼","x":49,"y":39},{"unified":"1f9d1-1f3fc-200d-1f9bc","native":"🧑🏼‍🦼","x":49,"y":40},{"unified":"1f9d1-1f3fd-200d-1f9bc","native":"🧑🏽‍🦼","x":49,"y":41},{"unified":"1f9d1-1f3fe-200d-1f9bc","native":"🧑🏾‍🦼","x":49,"y":42},{"unified":"1f9d1-1f3ff-200d-1f9bc","native":"🧑🏿‍🦼","x":49,"y":43}],"version":12.1},"man_in_motorized_wheelchair":{"id":"man_in_motorized_wheelchair","name":"Man in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bc","native":"👨‍🦼","x":15,"y":54},{"unified":"1f468-1f3fb-200d-1f9bc","native":"👨🏻‍🦼","x":15,"y":55},{"unified":"1f468-1f3fc-200d-1f9bc","native":"👨🏼‍🦼","x":15,"y":56},{"unified":"1f468-1f3fd-200d-1f9bc","native":"👨🏽‍🦼","x":15,"y":57},{"unified":"1f468-1f3fe-200d-1f9bc","native":"👨🏾‍🦼","x":15,"y":58},{"unified":"1f468-1f3ff-200d-1f9bc","native":"👨🏿‍🦼","x":15,"y":59}],"version":12},"woman_in_motorized_wheelchair":{"id":"woman_in_motorized_wheelchair","name":"Woman in Motorized Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bc","native":"👩‍🦼","x":19,"y":22},{"unified":"1f469-1f3fb-200d-1f9bc","native":"👩🏻‍🦼","x":19,"y":23},{"unified":"1f469-1f3fc-200d-1f9bc","native":"👩🏼‍🦼","x":19,"y":24},{"unified":"1f469-1f3fd-200d-1f9bc","native":"👩🏽‍🦼","x":19,"y":25},{"unified":"1f469-1f3fe-200d-1f9bc","native":"👩🏾‍🦼","x":19,"y":26},{"unified":"1f469-1f3ff-200d-1f9bc","native":"👩🏿‍🦼","x":19,"y":27}],"version":12},"person_in_manual_wheelchair":{"id":"person_in_manual_wheelchair","name":"Person in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f9d1-200d-1f9bd","native":"🧑‍🦽","x":49,"y":44},{"unified":"1f9d1-1f3fb-200d-1f9bd","native":"🧑🏻‍🦽","x":49,"y":45},{"unified":"1f9d1-1f3fc-200d-1f9bd","native":"🧑🏼‍🦽","x":49,"y":46},{"unified":"1f9d1-1f3fd-200d-1f9bd","native":"🧑🏽‍🦽","x":49,"y":47},{"unified":"1f9d1-1f3fe-200d-1f9bd","native":"🧑🏾‍🦽","x":49,"y":48},{"unified":"1f9d1-1f3ff-200d-1f9bd","native":"🧑🏿‍🦽","x":49,"y":49}],"version":12.1},"man_in_manual_wheelchair":{"id":"man_in_manual_wheelchair","name":"Man in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f468-200d-1f9bd","native":"👨‍🦽","x":15,"y":60},{"unified":"1f468-1f3fb-200d-1f9bd","native":"👨🏻‍🦽","x":16,"y":0},{"unified":"1f468-1f3fc-200d-1f9bd","native":"👨🏼‍🦽","x":16,"y":1},{"unified":"1f468-1f3fd-200d-1f9bd","native":"👨🏽‍🦽","x":16,"y":2},{"unified":"1f468-1f3fe-200d-1f9bd","native":"👨🏾‍🦽","x":16,"y":3},{"unified":"1f468-1f3ff-200d-1f9bd","native":"👨🏿‍🦽","x":16,"y":4}],"version":12},"woman_in_manual_wheelchair":{"id":"woman_in_manual_wheelchair","name":"Woman in Manual Wheelchair","keywords":["disability","accessibility"],"skins":[{"unified":"1f469-200d-1f9bd","native":"👩‍🦽","x":19,"y":28},{"unified":"1f469-1f3fb-200d-1f9bd","native":"👩🏻‍🦽","x":19,"y":29},{"unified":"1f469-1f3fc-200d-1f9bd","native":"👩🏼‍🦽","x":19,"y":30},{"unified":"1f469-1f3fd-200d-1f9bd","native":"👩🏽‍🦽","x":19,"y":31},{"unified":"1f469-1f3fe-200d-1f9bd","native":"👩🏾‍🦽","x":19,"y":32},{"unified":"1f469-1f3ff-200d-1f9bd","native":"👩🏿‍🦽","x":19,"y":33}],"version":12},"runner":{"id":"runner","name":"Runner","keywords":["running","person","move"],"skins":[{"unified":"1f3c3","native":"🏃","x":8,"y":26},{"unified":"1f3c3-1f3fb","native":"🏃🏻","x":8,"y":27},{"unified":"1f3c3-1f3fc","native":"🏃🏼","x":8,"y":28},{"unified":"1f3c3-1f3fd","native":"🏃🏽","x":8,"y":29},{"unified":"1f3c3-1f3fe","native":"🏃🏾","x":8,"y":30},{"unified":"1f3c3-1f3ff","native":"🏃🏿","x":8,"y":31}],"version":1},"man-running":{"id":"man-running","name":"Man Running","keywords":["walking","exercise","race"],"skins":[{"unified":"1f3c3-200d-2642-fe0f","native":"🏃‍♂️","x":8,"y":20},{"unified":"1f3c3-1f3fb-200d-2642-fe0f","native":"🏃🏻‍♂️","x":8,"y":21},{"unified":"1f3c3-1f3fc-200d-2642-fe0f","native":"🏃🏼‍♂️","x":8,"y":22},{"unified":"1f3c3-1f3fd-200d-2642-fe0f","native":"🏃🏽‍♂️","x":8,"y":23},{"unified":"1f3c3-1f3fe-200d-2642-fe0f","native":"🏃🏾‍♂️","x":8,"y":24},{"unified":"1f3c3-1f3ff-200d-2642-fe0f","native":"🏃🏿‍♂️","x":8,"y":25}],"version":4},"woman-running":{"id":"woman-running","name":"Woman Running","keywords":["walking","exercise","race","female"],"skins":[{"unified":"1f3c3-200d-2640-fe0f","native":"🏃‍♀️","x":8,"y":14},{"unified":"1f3c3-1f3fb-200d-2640-fe0f","native":"🏃🏻‍♀️","x":8,"y":15},{"unified":"1f3c3-1f3fc-200d-2640-fe0f","native":"🏃🏼‍♀️","x":8,"y":16},{"unified":"1f3c3-1f3fd-200d-2640-fe0f","native":"🏃🏽‍♀️","x":8,"y":17},{"unified":"1f3c3-1f3fe-200d-2640-fe0f","native":"🏃🏾‍♀️","x":8,"y":18},{"unified":"1f3c3-1f3ff-200d-2640-fe0f","native":"🏃🏿‍♀️","x":8,"y":19}],"version":4},"dancer":{"id":"dancer","name":"Dancer","keywords":["woman","dancing","female","girl","fun"],"skins":[{"unified":"1f483","native":"💃","x":25,"y":47},{"unified":"1f483-1f3fb","native":"💃🏻","x":25,"y":48},{"unified":"1f483-1f3fc","native":"💃🏼","x":25,"y":49},{"unified":"1f483-1f3fd","native":"💃🏽","x":25,"y":50},{"unified":"1f483-1f3fe","native":"💃🏾","x":25,"y":51},{"unified":"1f483-1f3ff","native":"💃🏿","x":25,"y":52}],"version":1},"man_dancing":{"id":"man_dancing","name":"Man Dancing","keywords":["male","boy","fun","dancer"],"skins":[{"unified":"1f57a","native":"🕺","x":31,"y":27},{"unified":"1f57a-1f3fb","native":"🕺🏻","x":31,"y":28},{"unified":"1f57a-1f3fc","native":"🕺🏼","x":31,"y":29},{"unified":"1f57a-1f3fd","native":"🕺🏽","x":31,"y":30},{"unified":"1f57a-1f3fe","native":"🕺🏾","x":31,"y":31},{"unified":"1f57a-1f3ff","native":"🕺🏿","x":31,"y":32}],"version":3},"man_in_business_suit_levitating":{"id":"man_in_business_suit_levitating","name":"Person in Suit Levitating","keywords":["man","business","levitate","hover","jump"],"skins":[{"unified":"1f574-fe0f","native":"🕴️","x":30,"y":60},{"unified":"1f574-1f3fb","native":"🕴🏻","x":31,"y":0},{"unified":"1f574-1f3fc","native":"🕴🏼","x":31,"y":1},{"unified":"1f574-1f3fd","native":"🕴🏽","x":31,"y":2},{"unified":"1f574-1f3fe","native":"🕴🏾","x":31,"y":3},{"unified":"1f574-1f3ff","native":"🕴🏿","x":31,"y":4}],"version":1},"dancers":{"id":"dancers","name":"Woman with Bunny Ears","keywords":["dancers","people","perform","costume"],"skins":[{"unified":"1f46f","native":"👯","x":23,"y":17}],"version":1},"men-with-bunny-ears-partying":{"id":"men-with-bunny-ears-partying","name":"Men with Bunny Ears","keywords":["with-bunny-ears-partying","man","male","boys"],"skins":[{"unified":"1f46f-200d-2642-fe0f","native":"👯‍♂️","x":23,"y":16}],"version":4},"women-with-bunny-ears-partying":{"id":"women-with-bunny-ears-partying","name":"Women with Bunny Ears","keywords":["with-bunny-ears-partying","woman","female","girls"],"skins":[{"unified":"1f46f-200d-2640-fe0f","native":"👯‍♀️","x":23,"y":15}],"version":4},"person_in_steamy_room":{"id":"person_in_steamy_room","name":"Person in Steamy Room","keywords":["relax","spa"],"skins":[{"unified":"1f9d6","native":"🧖","x":51,"y":0},{"unified":"1f9d6-1f3fb","native":"🧖🏻","x":51,"y":1},{"unified":"1f9d6-1f3fc","native":"🧖🏼","x":51,"y":2},{"unified":"1f9d6-1f3fd","native":"🧖🏽","x":51,"y":3},{"unified":"1f9d6-1f3fe","native":"🧖🏾","x":51,"y":4},{"unified":"1f9d6-1f3ff","native":"🧖🏿","x":51,"y":5}],"version":5},"man_in_steamy_room":{"id":"man_in_steamy_room","name":"Man in Steamy Room","keywords":["male","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2642-fe0f","native":"🧖‍♂️","x":50,"y":55},{"unified":"1f9d6-1f3fb-200d-2642-fe0f","native":"🧖🏻‍♂️","x":50,"y":56},{"unified":"1f9d6-1f3fc-200d-2642-fe0f","native":"🧖🏼‍♂️","x":50,"y":57},{"unified":"1f9d6-1f3fd-200d-2642-fe0f","native":"🧖🏽‍♂️","x":50,"y":58},{"unified":"1f9d6-1f3fe-200d-2642-fe0f","native":"🧖🏾‍♂️","x":50,"y":59},{"unified":"1f9d6-1f3ff-200d-2642-fe0f","native":"🧖🏿‍♂️","x":50,"y":60}],"version":5},"woman_in_steamy_room":{"id":"woman_in_steamy_room","name":"Woman in Steamy Room","keywords":["female","spa","steamroom","sauna"],"skins":[{"unified":"1f9d6-200d-2640-fe0f","native":"🧖‍♀️","x":50,"y":49},{"unified":"1f9d6-1f3fb-200d-2640-fe0f","native":"🧖🏻‍♀️","x":50,"y":50},{"unified":"1f9d6-1f3fc-200d-2640-fe0f","native":"🧖🏼‍♀️","x":50,"y":51},{"unified":"1f9d6-1f3fd-200d-2640-fe0f","native":"🧖🏽‍♀️","x":50,"y":52},{"unified":"1f9d6-1f3fe-200d-2640-fe0f","native":"🧖🏾‍♀️","x":50,"y":53},{"unified":"1f9d6-1f3ff-200d-2640-fe0f","native":"🧖🏿‍♀️","x":50,"y":54}],"version":5},"person_climbing":{"id":"person_climbing","name":"Person Climbing","keywords":["sport"],"skins":[{"unified":"1f9d7","native":"🧗","x":51,"y":18},{"unified":"1f9d7-1f3fb","native":"🧗🏻","x":51,"y":19},{"unified":"1f9d7-1f3fc","native":"🧗🏼","x":51,"y":20},{"unified":"1f9d7-1f3fd","native":"🧗🏽","x":51,"y":21},{"unified":"1f9d7-1f3fe","native":"🧗🏾","x":51,"y":22},{"unified":"1f9d7-1f3ff","native":"🧗🏿","x":51,"y":23}],"version":5},"man_climbing":{"id":"man_climbing","name":"Man Climbing","keywords":["sports","hobby","male","rock"],"skins":[{"unified":"1f9d7-200d-2642-fe0f","native":"🧗‍♂️","x":51,"y":12},{"unified":"1f9d7-1f3fb-200d-2642-fe0f","native":"🧗🏻‍♂️","x":51,"y":13},{"unified":"1f9d7-1f3fc-200d-2642-fe0f","native":"🧗🏼‍♂️","x":51,"y":14},{"unified":"1f9d7-1f3fd-200d-2642-fe0f","native":"🧗🏽‍♂️","x":51,"y":15},{"unified":"1f9d7-1f3fe-200d-2642-fe0f","native":"🧗🏾‍♂️","x":51,"y":16},{"unified":"1f9d7-1f3ff-200d-2642-fe0f","native":"🧗🏿‍♂️","x":51,"y":17}],"version":5},"woman_climbing":{"id":"woman_climbing","name":"Woman Climbing","keywords":["sports","hobby","female","rock"],"skins":[{"unified":"1f9d7-200d-2640-fe0f","native":"🧗‍♀️","x":51,"y":6},{"unified":"1f9d7-1f3fb-200d-2640-fe0f","native":"🧗🏻‍♀️","x":51,"y":7},{"unified":"1f9d7-1f3fc-200d-2640-fe0f","native":"🧗🏼‍♀️","x":51,"y":8},{"unified":"1f9d7-1f3fd-200d-2640-fe0f","native":"🧗🏽‍♀️","x":51,"y":9},{"unified":"1f9d7-1f3fe-200d-2640-fe0f","native":"🧗🏾‍♀️","x":51,"y":10},{"unified":"1f9d7-1f3ff-200d-2640-fe0f","native":"🧗🏿‍♀️","x":51,"y":11}],"version":5},"fencer":{"id":"fencer","name":"Fencer","keywords":["person","fencing","sports","sword"],"skins":[{"unified":"1f93a","native":"🤺","x":42,"y":33}],"version":3},"horse_racing":{"id":"horse_racing","name":"Horse Racing","keywords":["animal","betting","competition","gambling","luck"],"skins":[{"unified":"1f3c7","native":"🏇","x":8,"y":52},{"unified":"1f3c7-1f3fb","native":"🏇🏻","x":8,"y":53},{"unified":"1f3c7-1f3fc","native":"🏇🏼","x":8,"y":54},{"unified":"1f3c7-1f3fd","native":"🏇🏽","x":8,"y":55},{"unified":"1f3c7-1f3fe","native":"🏇🏾","x":8,"y":56},{"unified":"1f3c7-1f3ff","native":"🏇🏿","x":8,"y":57}],"version":1},"skier":{"id":"skier","name":"Skier","keywords":["sports","winter","snow"],"skins":[{"unified":"26f7-fe0f","native":"⛷️","x":58,"y":32}],"version":1},"snowboarder":{"id":"snowboarder","name":"Snowboarder","keywords":["sports","winter"],"skins":[{"unified":"1f3c2","native":"🏂","x":8,"y":8},{"unified":"1f3c2-1f3fb","native":"🏂🏻","x":8,"y":9},{"unified":"1f3c2-1f3fc","native":"🏂🏼","x":8,"y":10},{"unified":"1f3c2-1f3fd","native":"🏂🏽","x":8,"y":11},{"unified":"1f3c2-1f3fe","native":"🏂🏾","x":8,"y":12},{"unified":"1f3c2-1f3ff","native":"🏂🏿","x":8,"y":13}],"version":1},"golfer":{"id":"golfer","name":"Person Golfing","keywords":["golfer","sports","business"],"skins":[{"unified":"1f3cc-fe0f","native":"🏌️","x":9,"y":47},{"unified":"1f3cc-1f3fb","native":"🏌🏻","x":9,"y":48},{"unified":"1f3cc-1f3fc","native":"🏌🏼","x":9,"y":49},{"unified":"1f3cc-1f3fd","native":"🏌🏽","x":9,"y":50},{"unified":"1f3cc-1f3fe","native":"🏌🏾","x":9,"y":51},{"unified":"1f3cc-1f3ff","native":"🏌🏿","x":9,"y":52}],"version":1},"man-golfing":{"id":"man-golfing","name":"Man Golfing","keywords":["sport"],"skins":[{"unified":"1f3cc-fe0f-200d-2642-fe0f","native":"🏌️‍♂️","x":9,"y":41},{"unified":"1f3cc-1f3fb-200d-2642-fe0f","native":"🏌🏻‍♂️","x":9,"y":42},{"unified":"1f3cc-1f3fc-200d-2642-fe0f","native":"🏌🏼‍♂️","x":9,"y":43},{"unified":"1f3cc-1f3fd-200d-2642-fe0f","native":"🏌🏽‍♂️","x":9,"y":44},{"unified":"1f3cc-1f3fe-200d-2642-fe0f","native":"🏌🏾‍♂️","x":9,"y":45},{"unified":"1f3cc-1f3ff-200d-2642-fe0f","native":"🏌🏿‍♂️","x":9,"y":46}],"version":4},"woman-golfing":{"id":"woman-golfing","name":"Woman Golfing","keywords":["sports","business","female"],"skins":[{"unified":"1f3cc-fe0f-200d-2640-fe0f","native":"🏌️‍♀️","x":9,"y":35},{"unified":"1f3cc-1f3fb-200d-2640-fe0f","native":"🏌🏻‍♀️","x":9,"y":36},{"unified":"1f3cc-1f3fc-200d-2640-fe0f","native":"🏌🏼‍♀️","x":9,"y":37},{"unified":"1f3cc-1f3fd-200d-2640-fe0f","native":"🏌🏽‍♀️","x":9,"y":38},{"unified":"1f3cc-1f3fe-200d-2640-fe0f","native":"🏌🏾‍♀️","x":9,"y":39},{"unified":"1f3cc-1f3ff-200d-2640-fe0f","native":"🏌🏿‍♀️","x":9,"y":40}],"version":4},"surfer":{"id":"surfer","name":"Surfer","keywords":["person","surfing","sport","sea"],"skins":[{"unified":"1f3c4","native":"🏄","x":8,"y":44},{"unified":"1f3c4-1f3fb","native":"🏄🏻","x":8,"y":45},{"unified":"1f3c4-1f3fc","native":"🏄🏼","x":8,"y":46},{"unified":"1f3c4-1f3fd","native":"🏄🏽","x":8,"y":47},{"unified":"1f3c4-1f3fe","native":"🏄🏾","x":8,"y":48},{"unified":"1f3c4-1f3ff","native":"🏄🏿","x":8,"y":49}],"version":1},"man-surfing":{"id":"man-surfing","name":"Man Surfing","keywords":["sports","ocean","sea","summer","beach"],"skins":[{"unified":"1f3c4-200d-2642-fe0f","native":"🏄‍♂️","x":8,"y":38},{"unified":"1f3c4-1f3fb-200d-2642-fe0f","native":"🏄🏻‍♂️","x":8,"y":39},{"unified":"1f3c4-1f3fc-200d-2642-fe0f","native":"🏄🏼‍♂️","x":8,"y":40},{"unified":"1f3c4-1f3fd-200d-2642-fe0f","native":"🏄🏽‍♂️","x":8,"y":41},{"unified":"1f3c4-1f3fe-200d-2642-fe0f","native":"🏄🏾‍♂️","x":8,"y":42},{"unified":"1f3c4-1f3ff-200d-2642-fe0f","native":"🏄🏿‍♂️","x":8,"y":43}],"version":4},"woman-surfing":{"id":"woman-surfing","name":"Woman Surfing","keywords":["sports","ocean","sea","summer","beach","female"],"skins":[{"unified":"1f3c4-200d-2640-fe0f","native":"🏄‍♀️","x":8,"y":32},{"unified":"1f3c4-1f3fb-200d-2640-fe0f","native":"🏄🏻‍♀️","x":8,"y":33},{"unified":"1f3c4-1f3fc-200d-2640-fe0f","native":"🏄🏼‍♀️","x":8,"y":34},{"unified":"1f3c4-1f3fd-200d-2640-fe0f","native":"🏄🏽‍♀️","x":8,"y":35},{"unified":"1f3c4-1f3fe-200d-2640-fe0f","native":"🏄🏾‍♀️","x":8,"y":36},{"unified":"1f3c4-1f3ff-200d-2640-fe0f","native":"🏄🏿‍♀️","x":8,"y":37}],"version":4},"rowboat":{"id":"rowboat","name":"Rowboat","keywords":["person","rowing","boat","sport","move"],"skins":[{"unified":"1f6a3","native":"🚣","x":36,"y":19},{"unified":"1f6a3-1f3fb","native":"🚣🏻","x":36,"y":20},{"unified":"1f6a3-1f3fc","native":"🚣🏼","x":36,"y":21},{"unified":"1f6a3-1f3fd","native":"🚣🏽","x":36,"y":22},{"unified":"1f6a3-1f3fe","native":"🚣🏾","x":36,"y":23},{"unified":"1f6a3-1f3ff","native":"🚣🏿","x":36,"y":24}],"version":1},"man-rowing-boat":{"id":"man-rowing-boat","name":"Man Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship"],"skins":[{"unified":"1f6a3-200d-2642-fe0f","native":"🚣‍♂️","x":36,"y":13},{"unified":"1f6a3-1f3fb-200d-2642-fe0f","native":"🚣🏻‍♂️","x":36,"y":14},{"unified":"1f6a3-1f3fc-200d-2642-fe0f","native":"🚣🏼‍♂️","x":36,"y":15},{"unified":"1f6a3-1f3fd-200d-2642-fe0f","native":"🚣🏽‍♂️","x":36,"y":16},{"unified":"1f6a3-1f3fe-200d-2642-fe0f","native":"🚣🏾‍♂️","x":36,"y":17},{"unified":"1f6a3-1f3ff-200d-2642-fe0f","native":"🚣🏿‍♂️","x":36,"y":18}],"version":4},"woman-rowing-boat":{"id":"woman-rowing-boat","name":"Woman Rowing Boat","keywords":["rowing-boat","sports","hobby","water","ship","female"],"skins":[{"unified":"1f6a3-200d-2640-fe0f","native":"🚣‍♀️","x":36,"y":7},{"unified":"1f6a3-1f3fb-200d-2640-fe0f","native":"🚣🏻‍♀️","x":36,"y":8},{"unified":"1f6a3-1f3fc-200d-2640-fe0f","native":"🚣🏼‍♀️","x":36,"y":9},{"unified":"1f6a3-1f3fd-200d-2640-fe0f","native":"🚣🏽‍♀️","x":36,"y":10},{"unified":"1f6a3-1f3fe-200d-2640-fe0f","native":"🚣🏾‍♀️","x":36,"y":11},{"unified":"1f6a3-1f3ff-200d-2640-fe0f","native":"🚣🏿‍♀️","x":36,"y":12}],"version":4},"swimmer":{"id":"swimmer","name":"Swimmer","keywords":["person","swimming","sport","pool"],"skins":[{"unified":"1f3ca","native":"🏊","x":9,"y":11},{"unified":"1f3ca-1f3fb","native":"🏊🏻","x":9,"y":12},{"unified":"1f3ca-1f3fc","native":"🏊🏼","x":9,"y":13},{"unified":"1f3ca-1f3fd","native":"🏊🏽","x":9,"y":14},{"unified":"1f3ca-1f3fe","native":"🏊🏾","x":9,"y":15},{"unified":"1f3ca-1f3ff","native":"🏊🏿","x":9,"y":16}],"version":1},"man-swimming":{"id":"man-swimming","name":"Man Swimming","keywords":["sports","exercise","human","athlete","water","summer"],"skins":[{"unified":"1f3ca-200d-2642-fe0f","native":"🏊‍♂️","x":9,"y":5},{"unified":"1f3ca-1f3fb-200d-2642-fe0f","native":"🏊🏻‍♂️","x":9,"y":6},{"unified":"1f3ca-1f3fc-200d-2642-fe0f","native":"🏊🏼‍♂️","x":9,"y":7},{"unified":"1f3ca-1f3fd-200d-2642-fe0f","native":"🏊🏽‍♂️","x":9,"y":8},{"unified":"1f3ca-1f3fe-200d-2642-fe0f","native":"🏊🏾‍♂️","x":9,"y":9},{"unified":"1f3ca-1f3ff-200d-2642-fe0f","native":"🏊🏿‍♂️","x":9,"y":10}],"version":4},"woman-swimming":{"id":"woman-swimming","name":"Woman Swimming","keywords":["sports","exercise","human","athlete","water","summer","female"],"skins":[{"unified":"1f3ca-200d-2640-fe0f","native":"🏊‍♀️","x":8,"y":60},{"unified":"1f3ca-1f3fb-200d-2640-fe0f","native":"🏊🏻‍♀️","x":9,"y":0},{"unified":"1f3ca-1f3fc-200d-2640-fe0f","native":"🏊🏼‍♀️","x":9,"y":1},{"unified":"1f3ca-1f3fd-200d-2640-fe0f","native":"🏊🏽‍♀️","x":9,"y":2},{"unified":"1f3ca-1f3fe-200d-2640-fe0f","native":"🏊🏾‍♀️","x":9,"y":3},{"unified":"1f3ca-1f3ff-200d-2640-fe0f","native":"🏊🏿‍♀️","x":9,"y":4}],"version":4},"person_with_ball":{"id":"person_with_ball","name":"Person Bouncing Ball","keywords":["with","sports","human"],"skins":[{"unified":"26f9-fe0f","native":"⛹️","x":58,"y":46},{"unified":"26f9-1f3fb","native":"⛹🏻","x":58,"y":47},{"unified":"26f9-1f3fc","native":"⛹🏼","x":58,"y":48},{"unified":"26f9-1f3fd","native":"⛹🏽","x":58,"y":49},{"unified":"26f9-1f3fe","native":"⛹🏾","x":58,"y":50},{"unified":"26f9-1f3ff","native":"⛹🏿","x":58,"y":51}],"version":1},"man-bouncing-ball":{"id":"man-bouncing-ball","name":"Man Bouncing Ball","keywords":["bouncing-ball","sport"],"skins":[{"unified":"26f9-fe0f-200d-2642-fe0f","native":"⛹️‍♂️","x":58,"y":40},{"unified":"26f9-1f3fb-200d-2642-fe0f","native":"⛹🏻‍♂️","x":58,"y":41},{"unified":"26f9-1f3fc-200d-2642-fe0f","native":"⛹🏼‍♂️","x":58,"y":42},{"unified":"26f9-1f3fd-200d-2642-fe0f","native":"⛹🏽‍♂️","x":58,"y":43},{"unified":"26f9-1f3fe-200d-2642-fe0f","native":"⛹🏾‍♂️","x":58,"y":44},{"unified":"26f9-1f3ff-200d-2642-fe0f","native":"⛹🏿‍♂️","x":58,"y":45}],"version":4},"woman-bouncing-ball":{"id":"woman-bouncing-ball","name":"Woman Bouncing Ball","keywords":["bouncing-ball","sports","human","female"],"skins":[{"unified":"26f9-fe0f-200d-2640-fe0f","native":"⛹️‍♀️","x":58,"y":34},{"unified":"26f9-1f3fb-200d-2640-fe0f","native":"⛹🏻‍♀️","x":58,"y":35},{"unified":"26f9-1f3fc-200d-2640-fe0f","native":"⛹🏼‍♀️","x":58,"y":36},{"unified":"26f9-1f3fd-200d-2640-fe0f","native":"⛹🏽‍♀️","x":58,"y":37},{"unified":"26f9-1f3fe-200d-2640-fe0f","native":"⛹🏾‍♀️","x":58,"y":38},{"unified":"26f9-1f3ff-200d-2640-fe0f","native":"⛹🏿‍♀️","x":58,"y":39}],"version":4},"weight_lifter":{"id":"weight_lifter","name":"Person Lifting Weights","keywords":["weight","lifter","sports","training","exercise"],"skins":[{"unified":"1f3cb-fe0f","native":"🏋️","x":9,"y":29},{"unified":"1f3cb-1f3fb","native":"🏋🏻","x":9,"y":30},{"unified":"1f3cb-1f3fc","native":"🏋🏼","x":9,"y":31},{"unified":"1f3cb-1f3fd","native":"🏋🏽","x":9,"y":32},{"unified":"1f3cb-1f3fe","native":"🏋🏾","x":9,"y":33},{"unified":"1f3cb-1f3ff","native":"🏋🏿","x":9,"y":34}],"version":1},"man-lifting-weights":{"id":"man-lifting-weights","name":"Man Lifting Weights","keywords":["lifting-weights","sport"],"skins":[{"unified":"1f3cb-fe0f-200d-2642-fe0f","native":"🏋️‍♂️","x":9,"y":23},{"unified":"1f3cb-1f3fb-200d-2642-fe0f","native":"🏋🏻‍♂️","x":9,"y":24},{"unified":"1f3cb-1f3fc-200d-2642-fe0f","native":"🏋🏼‍♂️","x":9,"y":25},{"unified":"1f3cb-1f3fd-200d-2642-fe0f","native":"🏋🏽‍♂️","x":9,"y":26},{"unified":"1f3cb-1f3fe-200d-2642-fe0f","native":"🏋🏾‍♂️","x":9,"y":27},{"unified":"1f3cb-1f3ff-200d-2642-fe0f","native":"🏋🏿‍♂️","x":9,"y":28}],"version":4},"woman-lifting-weights":{"id":"woman-lifting-weights","name":"Woman Lifting Weights","keywords":["lifting-weights","sports","training","exercise","female"],"skins":[{"unified":"1f3cb-fe0f-200d-2640-fe0f","native":"🏋️‍♀️","x":9,"y":17},{"unified":"1f3cb-1f3fb-200d-2640-fe0f","native":"🏋🏻‍♀️","x":9,"y":18},{"unified":"1f3cb-1f3fc-200d-2640-fe0f","native":"🏋🏼‍♀️","x":9,"y":19},{"unified":"1f3cb-1f3fd-200d-2640-fe0f","native":"🏋🏽‍♀️","x":9,"y":20},{"unified":"1f3cb-1f3fe-200d-2640-fe0f","native":"🏋🏾‍♀️","x":9,"y":21},{"unified":"1f3cb-1f3ff-200d-2640-fe0f","native":"🏋🏿‍♀️","x":9,"y":22}],"version":4},"bicyclist":{"id":"bicyclist","name":"Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b4","native":"🚴","x":36,"y":53},{"unified":"1f6b4-1f3fb","native":"🚴🏻","x":36,"y":54},{"unified":"1f6b4-1f3fc","native":"🚴🏼","x":36,"y":55},{"unified":"1f6b4-1f3fd","native":"🚴🏽","x":36,"y":56},{"unified":"1f6b4-1f3fe","native":"🚴🏾","x":36,"y":57},{"unified":"1f6b4-1f3ff","native":"🚴🏿","x":36,"y":58}],"version":1},"man-biking":{"id":"man-biking","name":"Man Biking","keywords":["sports","bike","exercise","hipster"],"skins":[{"unified":"1f6b4-200d-2642-fe0f","native":"🚴‍♂️","x":36,"y":47},{"unified":"1f6b4-1f3fb-200d-2642-fe0f","native":"🚴🏻‍♂️","x":36,"y":48},{"unified":"1f6b4-1f3fc-200d-2642-fe0f","native":"🚴🏼‍♂️","x":36,"y":49},{"unified":"1f6b4-1f3fd-200d-2642-fe0f","native":"🚴🏽‍♂️","x":36,"y":50},{"unified":"1f6b4-1f3fe-200d-2642-fe0f","native":"🚴🏾‍♂️","x":36,"y":51},{"unified":"1f6b4-1f3ff-200d-2642-fe0f","native":"🚴🏿‍♂️","x":36,"y":52}],"version":4},"woman-biking":{"id":"woman-biking","name":"Woman Biking","keywords":["sports","bike","exercise","hipster","female"],"skins":[{"unified":"1f6b4-200d-2640-fe0f","native":"🚴‍♀️","x":36,"y":41},{"unified":"1f6b4-1f3fb-200d-2640-fe0f","native":"🚴🏻‍♀️","x":36,"y":42},{"unified":"1f6b4-1f3fc-200d-2640-fe0f","native":"🚴🏼‍♀️","x":36,"y":43},{"unified":"1f6b4-1f3fd-200d-2640-fe0f","native":"🚴🏽‍♀️","x":36,"y":44},{"unified":"1f6b4-1f3fe-200d-2640-fe0f","native":"🚴🏾‍♀️","x":36,"y":45},{"unified":"1f6b4-1f3ff-200d-2640-fe0f","native":"🚴🏿‍♀️","x":36,"y":46}],"version":4},"mountain_bicyclist":{"id":"mountain_bicyclist","name":"Mountain Bicyclist","keywords":["person","biking","sport","move"],"skins":[{"unified":"1f6b5","native":"🚵","x":37,"y":10},{"unified":"1f6b5-1f3fb","native":"🚵🏻","x":37,"y":11},{"unified":"1f6b5-1f3fc","native":"🚵🏼","x":37,"y":12},{"unified":"1f6b5-1f3fd","native":"🚵🏽","x":37,"y":13},{"unified":"1f6b5-1f3fe","native":"🚵🏾","x":37,"y":14},{"unified":"1f6b5-1f3ff","native":"🚵🏿","x":37,"y":15}],"version":1},"man-mountain-biking":{"id":"man-mountain-biking","name":"Man Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike"],"skins":[{"unified":"1f6b5-200d-2642-fe0f","native":"🚵‍♂️","x":37,"y":4},{"unified":"1f6b5-1f3fb-200d-2642-fe0f","native":"🚵🏻‍♂️","x":37,"y":5},{"unified":"1f6b5-1f3fc-200d-2642-fe0f","native":"🚵🏼‍♂️","x":37,"y":6},{"unified":"1f6b5-1f3fd-200d-2642-fe0f","native":"🚵🏽‍♂️","x":37,"y":7},{"unified":"1f6b5-1f3fe-200d-2642-fe0f","native":"🚵🏾‍♂️","x":37,"y":8},{"unified":"1f6b5-1f3ff-200d-2642-fe0f","native":"🚵🏿‍♂️","x":37,"y":9}],"version":4},"woman-mountain-biking":{"id":"woman-mountain-biking","name":"Woman Mountain Biking","keywords":["mountain-biking","transportation","sports","human","race","bike","female"],"skins":[{"unified":"1f6b5-200d-2640-fe0f","native":"🚵‍♀️","x":36,"y":59},{"unified":"1f6b5-1f3fb-200d-2640-fe0f","native":"🚵🏻‍♀️","x":36,"y":60},{"unified":"1f6b5-1f3fc-200d-2640-fe0f","native":"🚵🏼‍♀️","x":37,"y":0},{"unified":"1f6b5-1f3fd-200d-2640-fe0f","native":"🚵🏽‍♀️","x":37,"y":1},{"unified":"1f6b5-1f3fe-200d-2640-fe0f","native":"🚵🏾‍♀️","x":37,"y":2},{"unified":"1f6b5-1f3ff-200d-2640-fe0f","native":"🚵🏿‍♀️","x":37,"y":3}],"version":4},"person_doing_cartwheel":{"id":"person_doing_cartwheel","name":"Person Cartwheeling","keywords":["doing","cartwheel","sport","gymnastic"],"skins":[{"unified":"1f938","native":"🤸","x":42,"y":9},{"unified":"1f938-1f3fb","native":"🤸🏻","x":42,"y":10},{"unified":"1f938-1f3fc","native":"🤸🏼","x":42,"y":11},{"unified":"1f938-1f3fd","native":"🤸🏽","x":42,"y":12},{"unified":"1f938-1f3fe","native":"🤸🏾","x":42,"y":13},{"unified":"1f938-1f3ff","native":"🤸🏿","x":42,"y":14}],"version":3},"man-cartwheeling":{"id":"man-cartwheeling","name":"Man Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2642-fe0f","native":"🤸‍♂️","x":42,"y":3},{"unified":"1f938-1f3fb-200d-2642-fe0f","native":"🤸🏻‍♂️","x":42,"y":4},{"unified":"1f938-1f3fc-200d-2642-fe0f","native":"🤸🏼‍♂️","x":42,"y":5},{"unified":"1f938-1f3fd-200d-2642-fe0f","native":"🤸🏽‍♂️","x":42,"y":6},{"unified":"1f938-1f3fe-200d-2642-fe0f","native":"🤸🏾‍♂️","x":42,"y":7},{"unified":"1f938-1f3ff-200d-2642-fe0f","native":"🤸🏿‍♂️","x":42,"y":8}],"version":4},"woman-cartwheeling":{"id":"woman-cartwheeling","name":"Woman Cartwheeling","keywords":["gymnastics"],"skins":[{"unified":"1f938-200d-2640-fe0f","native":"🤸‍♀️","x":41,"y":58},{"unified":"1f938-1f3fb-200d-2640-fe0f","native":"🤸🏻‍♀️","x":41,"y":59},{"unified":"1f938-1f3fc-200d-2640-fe0f","native":"🤸🏼‍♀️","x":41,"y":60},{"unified":"1f938-1f3fd-200d-2640-fe0f","native":"🤸🏽‍♀️","x":42,"y":0},{"unified":"1f938-1f3fe-200d-2640-fe0f","native":"🤸🏾‍♀️","x":42,"y":1},{"unified":"1f938-1f3ff-200d-2640-fe0f","native":"🤸🏿‍♀️","x":42,"y":2}],"version":4},"wrestlers":{"id":"wrestlers","name":"Wrestlers","keywords":["people","wrestling","sport"],"skins":[{"unified":"1f93c","native":"🤼","x":42,"y":36}],"version":3},"man-wrestling":{"id":"man-wrestling","name":"Men Wrestling","keywords":["man","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2642-fe0f","native":"🤼‍♂️","x":42,"y":35}],"version":4},"woman-wrestling":{"id":"woman-wrestling","name":"Women Wrestling","keywords":["woman","sports","wrestlers"],"skins":[{"unified":"1f93c-200d-2640-fe0f","native":"🤼‍♀️","x":42,"y":34}],"version":4},"water_polo":{"id":"water_polo","name":"Water Polo","keywords":["person","playing","sport"],"skins":[{"unified":"1f93d","native":"🤽","x":42,"y":49},{"unified":"1f93d-1f3fb","native":"🤽🏻","x":42,"y":50},{"unified":"1f93d-1f3fc","native":"🤽🏼","x":42,"y":51},{"unified":"1f93d-1f3fd","native":"🤽🏽","x":42,"y":52},{"unified":"1f93d-1f3fe","native":"🤽🏾","x":42,"y":53},{"unified":"1f93d-1f3ff","native":"🤽🏿","x":42,"y":54}],"version":3},"man-playing-water-polo":{"id":"man-playing-water-polo","name":"Man Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2642-fe0f","native":"🤽‍♂️","x":42,"y":43},{"unified":"1f93d-1f3fb-200d-2642-fe0f","native":"🤽🏻‍♂️","x":42,"y":44},{"unified":"1f93d-1f3fc-200d-2642-fe0f","native":"🤽🏼‍♂️","x":42,"y":45},{"unified":"1f93d-1f3fd-200d-2642-fe0f","native":"🤽🏽‍♂️","x":42,"y":46},{"unified":"1f93d-1f3fe-200d-2642-fe0f","native":"🤽🏾‍♂️","x":42,"y":47},{"unified":"1f93d-1f3ff-200d-2642-fe0f","native":"🤽🏿‍♂️","x":42,"y":48}],"version":4},"woman-playing-water-polo":{"id":"woman-playing-water-polo","name":"Woman Playing Water Polo","keywords":["playing-water-polo","sports","pool"],"skins":[{"unified":"1f93d-200d-2640-fe0f","native":"🤽‍♀️","x":42,"y":37},{"unified":"1f93d-1f3fb-200d-2640-fe0f","native":"🤽🏻‍♀️","x":42,"y":38},{"unified":"1f93d-1f3fc-200d-2640-fe0f","native":"🤽🏼‍♀️","x":42,"y":39},{"unified":"1f93d-1f3fd-200d-2640-fe0f","native":"🤽🏽‍♀️","x":42,"y":40},{"unified":"1f93d-1f3fe-200d-2640-fe0f","native":"🤽🏾‍♀️","x":42,"y":41},{"unified":"1f93d-1f3ff-200d-2640-fe0f","native":"🤽🏿‍♀️","x":42,"y":42}],"version":4},"handball":{"id":"handball","name":"Handball","keywords":["person","playing","sport"],"skins":[{"unified":"1f93e","native":"🤾","x":43,"y":6},{"unified":"1f93e-1f3fb","native":"🤾🏻","x":43,"y":7},{"unified":"1f93e-1f3fc","native":"🤾🏼","x":43,"y":8},{"unified":"1f93e-1f3fd","native":"🤾🏽","x":43,"y":9},{"unified":"1f93e-1f3fe","native":"🤾🏾","x":43,"y":10},{"unified":"1f93e-1f3ff","native":"🤾🏿","x":43,"y":11}],"version":3},"man-playing-handball":{"id":"man-playing-handball","name":"Man Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2642-fe0f","native":"🤾‍♂️","x":43,"y":0},{"unified":"1f93e-1f3fb-200d-2642-fe0f","native":"🤾🏻‍♂️","x":43,"y":1},{"unified":"1f93e-1f3fc-200d-2642-fe0f","native":"🤾🏼‍♂️","x":43,"y":2},{"unified":"1f93e-1f3fd-200d-2642-fe0f","native":"🤾🏽‍♂️","x":43,"y":3},{"unified":"1f93e-1f3fe-200d-2642-fe0f","native":"🤾🏾‍♂️","x":43,"y":4},{"unified":"1f93e-1f3ff-200d-2642-fe0f","native":"🤾🏿‍♂️","x":43,"y":5}],"version":4},"woman-playing-handball":{"id":"woman-playing-handball","name":"Woman Playing Handball","keywords":["playing-handball","sports"],"skins":[{"unified":"1f93e-200d-2640-fe0f","native":"🤾‍♀️","x":42,"y":55},{"unified":"1f93e-1f3fb-200d-2640-fe0f","native":"🤾🏻‍♀️","x":42,"y":56},{"unified":"1f93e-1f3fc-200d-2640-fe0f","native":"🤾🏼‍♀️","x":42,"y":57},{"unified":"1f93e-1f3fd-200d-2640-fe0f","native":"🤾🏽‍♀️","x":42,"y":58},{"unified":"1f93e-1f3fe-200d-2640-fe0f","native":"🤾🏾‍♀️","x":42,"y":59},{"unified":"1f93e-1f3ff-200d-2640-fe0f","native":"🤾🏿‍♀️","x":42,"y":60}],"version":4},"juggling":{"id":"juggling","name":"Juggling","keywords":["person","performance","balance"],"skins":[{"unified":"1f939","native":"🤹","x":42,"y":27},{"unified":"1f939-1f3fb","native":"🤹🏻","x":42,"y":28},{"unified":"1f939-1f3fc","native":"🤹🏼","x":42,"y":29},{"unified":"1f939-1f3fd","native":"🤹🏽","x":42,"y":30},{"unified":"1f939-1f3fe","native":"🤹🏾","x":42,"y":31},{"unified":"1f939-1f3ff","native":"🤹🏿","x":42,"y":32}],"version":3},"man-juggling":{"id":"man-juggling","name":"Man Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2642-fe0f","native":"🤹‍♂️","x":42,"y":21},{"unified":"1f939-1f3fb-200d-2642-fe0f","native":"🤹🏻‍♂️","x":42,"y":22},{"unified":"1f939-1f3fc-200d-2642-fe0f","native":"🤹🏼‍♂️","x":42,"y":23},{"unified":"1f939-1f3fd-200d-2642-fe0f","native":"🤹🏽‍♂️","x":42,"y":24},{"unified":"1f939-1f3fe-200d-2642-fe0f","native":"🤹🏾‍♂️","x":42,"y":25},{"unified":"1f939-1f3ff-200d-2642-fe0f","native":"🤹🏿‍♂️","x":42,"y":26}],"version":4},"woman-juggling":{"id":"woman-juggling","name":"Woman Juggling","keywords":["juggle","balance","skill","multitask"],"skins":[{"unified":"1f939-200d-2640-fe0f","native":"🤹‍♀️","x":42,"y":15},{"unified":"1f939-1f3fb-200d-2640-fe0f","native":"🤹🏻‍♀️","x":42,"y":16},{"unified":"1f939-1f3fc-200d-2640-fe0f","native":"🤹🏼‍♀️","x":42,"y":17},{"unified":"1f939-1f3fd-200d-2640-fe0f","native":"🤹🏽‍♀️","x":42,"y":18},{"unified":"1f939-1f3fe-200d-2640-fe0f","native":"🤹🏾‍♀️","x":42,"y":19},{"unified":"1f939-1f3ff-200d-2640-fe0f","native":"🤹🏿‍♀️","x":42,"y":20}],"version":4},"person_in_lotus_position":{"id":"person_in_lotus_position","name":"Person in Lotus Position","keywords":["meditate"],"skins":[{"unified":"1f9d8","native":"🧘","x":51,"y":36},{"unified":"1f9d8-1f3fb","native":"🧘🏻","x":51,"y":37},{"unified":"1f9d8-1f3fc","native":"🧘🏼","x":51,"y":38},{"unified":"1f9d8-1f3fd","native":"🧘🏽","x":51,"y":39},{"unified":"1f9d8-1f3fe","native":"🧘🏾","x":51,"y":40},{"unified":"1f9d8-1f3ff","native":"🧘🏿","x":51,"y":41}],"version":5},"man_in_lotus_position":{"id":"man_in_lotus_position","name":"Man in Lotus Position","keywords":["male","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2642-fe0f","native":"🧘‍♂️","x":51,"y":30},{"unified":"1f9d8-1f3fb-200d-2642-fe0f","native":"🧘🏻‍♂️","x":51,"y":31},{"unified":"1f9d8-1f3fc-200d-2642-fe0f","native":"🧘🏼‍♂️","x":51,"y":32},{"unified":"1f9d8-1f3fd-200d-2642-fe0f","native":"🧘🏽‍♂️","x":51,"y":33},{"unified":"1f9d8-1f3fe-200d-2642-fe0f","native":"🧘🏾‍♂️","x":51,"y":34},{"unified":"1f9d8-1f3ff-200d-2642-fe0f","native":"🧘🏿‍♂️","x":51,"y":35}],"version":5},"woman_in_lotus_position":{"id":"woman_in_lotus_position","name":"Woman in Lotus Position","keywords":["female","meditation","yoga","serenity","zen","mindfulness"],"skins":[{"unified":"1f9d8-200d-2640-fe0f","native":"🧘‍♀️","x":51,"y":24},{"unified":"1f9d8-1f3fb-200d-2640-fe0f","native":"🧘🏻‍♀️","x":51,"y":25},{"unified":"1f9d8-1f3fc-200d-2640-fe0f","native":"🧘🏼‍♀️","x":51,"y":26},{"unified":"1f9d8-1f3fd-200d-2640-fe0f","native":"🧘🏽‍♀️","x":51,"y":27},{"unified":"1f9d8-1f3fe-200d-2640-fe0f","native":"🧘🏾‍♀️","x":51,"y":28},{"unified":"1f9d8-1f3ff-200d-2640-fe0f","native":"🧘🏿‍♀️","x":51,"y":29}],"version":5},"bath":{"id":"bath","name":"Bath","keywords":["person","taking","clean","shower","bathroom"],"skins":[{"unified":"1f6c0","native":"🛀","x":37,"y":43},{"unified":"1f6c0-1f3fb","native":"🛀🏻","x":37,"y":44},{"unified":"1f6c0-1f3fc","native":"🛀🏼","x":37,"y":45},{"unified":"1f6c0-1f3fd","native":"🛀🏽","x":37,"y":46},{"unified":"1f6c0-1f3fe","native":"🛀🏾","x":37,"y":47},{"unified":"1f6c0-1f3ff","native":"🛀🏿","x":37,"y":48}],"version":1},"sleeping_accommodation":{"id":"sleeping_accommodation","name":"Person in Bed","keywords":["sleeping","accommodation","rest"],"skins":[{"unified":"1f6cc","native":"🛌","x":37,"y":55},{"unified":"1f6cc-1f3fb","native":"🛌🏻","x":37,"y":56},{"unified":"1f6cc-1f3fc","native":"🛌🏼","x":37,"y":57},{"unified":"1f6cc-1f3fd","native":"🛌🏽","x":37,"y":58},{"unified":"1f6cc-1f3fe","native":"🛌🏾","x":37,"y":59},{"unified":"1f6cc-1f3ff","native":"🛌🏿","x":37,"y":60}],"version":1},"people_holding_hands":{"id":"people_holding_hands","name":"People Holding Hands","keywords":["friendship"],"skins":[{"unified":"1f9d1-200d-1f91d-200d-1f9d1","native":"🧑‍🤝‍🧑","x":48,"y":43},{"unified":"1f9d1-1f3fb-200d-1f91d-200d-1f9d1-1f3fb","native":"🧑🏻‍🤝‍🧑🏻","x":48,"y":44},{"unified":"1f9d1-1f3fc-200d-1f91d-200d-1f9d1-1f3fc","native":"🧑🏼‍🤝‍🧑🏼","x":48,"y":50},{"unified":"1f9d1-1f3fd-200d-1f91d-200d-1f9d1-1f3fd","native":"🧑🏽‍🤝‍🧑🏽","x":48,"y":56},{"unified":"1f9d1-1f3fe-200d-1f91d-200d-1f9d1-1f3fe","native":"🧑🏾‍🤝‍🧑🏾","x":49,"y":1},{"unified":"1f9d1-1f3ff-200d-1f91d-200d-1f9d1-1f3ff","native":"🧑🏿‍🤝‍🧑🏿","x":49,"y":7}],"version":12},"two_women_holding_hands":{"id":"two_women_holding_hands","name":"Women Holding Hands","keywords":["two","pair","friendship","couple","love","like","female","people","human"],"skins":[{"unified":"1f46d","native":"👭","x":22,"y":32},{"unified":"1f46d-1f3fb","native":"👭🏻","x":22,"y":33},{"unified":"1f46d-1f3fc","native":"👭🏼","x":22,"y":34},{"unified":"1f46d-1f3fd","native":"👭🏽","x":22,"y":35},{"unified":"1f46d-1f3fe","native":"👭🏾","x":22,"y":36},{"unified":"1f46d-1f3ff","native":"👭🏿","x":22,"y":37}],"version":1},"man_and_woman_holding_hands":{"id":"man_and_woman_holding_hands","name":"Man and Woman Holding Hands","keywords":["couple","pair","people","human","love","date","dating","like","affection","valentines","marriage"],"skins":[{"unified":"1f46b","native":"👫","x":21,"y":41},{"unified":"1f46b-1f3fb","native":"👫🏻","x":21,"y":42},{"unified":"1f46b-1f3fc","native":"👫🏼","x":21,"y":43},{"unified":"1f46b-1f3fd","native":"👫🏽","x":21,"y":44},{"unified":"1f46b-1f3fe","native":"👫🏾","x":21,"y":45},{"unified":"1f46b-1f3ff","native":"👫🏿","x":21,"y":46}],"version":1},"two_men_holding_hands":{"id":"two_men_holding_hands","name":"Men Holding Hands","keywords":["two","pair","couple","love","like","bromance","friendship","people","human"],"skins":[{"unified":"1f46c","native":"👬","x":22,"y":6},{"unified":"1f46c-1f3fb","native":"👬🏻","x":22,"y":7},{"unified":"1f46c-1f3fc","native":"👬🏼","x":22,"y":8},{"unified":"1f46c-1f3fd","native":"👬🏽","x":22,"y":9},{"unified":"1f46c-1f3fe","native":"👬🏾","x":22,"y":10},{"unified":"1f46c-1f3ff","native":"👬🏿","x":22,"y":11}],"version":1},"couplekiss":{"id":"couplekiss","name":"Kiss","keywords":["couplekiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f48f","native":"💏","x":26,"y":42},{"unified":"1f48f-1f3fb","native":"💏🏻","x":26,"y":43},{"unified":"1f48f-1f3fc","native":"💏🏼","x":26,"y":44},{"unified":"1f48f-1f3fd","native":"💏🏽","x":26,"y":45},{"unified":"1f48f-1f3fe","native":"💏🏾","x":26,"y":46},{"unified":"1f48f-1f3ff","native":"💏🏿","x":26,"y":47}],"version":1},"woman-kiss-man":{"id":"woman-kiss-man","name":"Kiss: Woman, Man","keywords":["woman","kiss-man","kiss","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"👩‍❤️‍💋‍👨","x":20,"y":43},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"👩🏻‍❤️‍💋‍👨🏻","x":20,"y":44},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"👩🏼‍❤️‍💋‍👨🏼","x":20,"y":50},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"👩🏽‍❤️‍💋‍👨🏽","x":20,"y":56},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"👩🏾‍❤️‍💋‍👨🏾","x":21,"y":1},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"👩🏿‍❤️‍💋‍👨🏿","x":21,"y":7}],"version":2},"man-kiss-man":{"id":"man-kiss-man","name":"Kiss: Man, Man","keywords":["kiss-man","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f48b-200d-1f468","native":"👨‍❤️‍💋‍👨","x":16,"y":49},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fb","native":"👨🏻‍❤️‍💋‍👨🏻","x":16,"y":50},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fc","native":"👨🏼‍❤️‍💋‍👨🏼","x":16,"y":56},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fd","native":"👨🏽‍❤️‍💋‍👨🏽","x":17,"y":1},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3fe","native":"👨🏾‍❤️‍💋‍👨🏾","x":17,"y":7},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f468-1f3ff","native":"👨🏿‍❤️‍💋‍👨🏿","x":17,"y":13}],"version":2},"woman-kiss-woman":{"id":"woman-kiss-woman","name":"Kiss: Woman, Woman","keywords":["kiss-woman","kiss","pair","valentines","love","like","dating","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f48b-200d-1f469","native":"👩‍❤️‍💋‍👩","x":21,"y":8},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fb","native":"👩🏻‍❤️‍💋‍👩🏻","x":21,"y":9},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fc","native":"👩🏼‍❤️‍💋‍👩🏼","x":21,"y":15},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fd","native":"👩🏽‍❤️‍💋‍👩🏽","x":21,"y":21},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3fe","native":"👩🏾‍❤️‍💋‍👩🏾","x":21,"y":27},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f48b-200d-1f469-1f3ff","native":"👩🏿‍❤️‍💋‍👩🏿","x":21,"y":33}],"version":2},"couple_with_heart":{"id":"couple_with_heart","name":"Couple with Heart","keywords":["pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f491","native":"💑","x":27,"y":8},{"unified":"1f491-1f3fb","native":"💑🏻","x":27,"y":9},{"unified":"1f491-1f3fc","native":"💑🏼","x":27,"y":10},{"unified":"1f491-1f3fd","native":"💑🏽","x":27,"y":11},{"unified":"1f491-1f3fe","native":"💑🏾","x":27,"y":12},{"unified":"1f491-1f3ff","native":"💑🏿","x":27,"y":13}],"version":1},"woman-heart-man":{"id":"woman-heart-man","name":"Couple with Heart: Woman, Man","keywords":["woman","heart-man","heart","love"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f468","native":"👩‍❤️‍👨","x":19,"y":52},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"👩🏻‍❤️‍👨🏻","x":19,"y":53},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"👩🏼‍❤️‍👨🏼","x":19,"y":59},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"👩🏽‍❤️‍👨🏽","x":20,"y":4},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"👩🏾‍❤️‍👨🏾","x":20,"y":10},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"👩🏿‍❤️‍👨🏿","x":20,"y":16}],"version":2},"man-heart-man":{"id":"man-heart-man","name":"Couple with Heart: Man, Man","keywords":["heart-man","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f468-200d-2764-fe0f-200d-1f468","native":"👨‍❤️‍👨","x":16,"y":23},{"unified":"1f468-1f3fb-200d-2764-fe0f-200d-1f468-1f3fb","native":"👨🏻‍❤️‍👨🏻","x":16,"y":24},{"unified":"1f468-1f3fc-200d-2764-fe0f-200d-1f468-1f3fc","native":"👨🏼‍❤️‍👨🏼","x":16,"y":30},{"unified":"1f468-1f3fd-200d-2764-fe0f-200d-1f468-1f3fd","native":"👨🏽‍❤️‍👨🏽","x":16,"y":36},{"unified":"1f468-1f3fe-200d-2764-fe0f-200d-1f468-1f3fe","native":"👨🏾‍❤️‍👨🏾","x":16,"y":42},{"unified":"1f468-1f3ff-200d-2764-fe0f-200d-1f468-1f3ff","native":"👨🏿‍❤️‍👨🏿","x":16,"y":48}],"version":2},"woman-heart-woman":{"id":"woman-heart-woman","name":"Couple with Heart: Woman, Woman","keywords":["heart-woman","heart","pair","love","like","affection","human","dating","valentines","marriage"],"skins":[{"unified":"1f469-200d-2764-fe0f-200d-1f469","native":"👩‍❤️‍👩","x":20,"y":17},{"unified":"1f469-1f3fb-200d-2764-fe0f-200d-1f469-1f3fb","native":"👩🏻‍❤️‍👩🏻","x":20,"y":18},{"unified":"1f469-1f3fc-200d-2764-fe0f-200d-1f469-1f3fc","native":"👩🏼‍❤️‍👩🏼","x":20,"y":24},{"unified":"1f469-1f3fd-200d-2764-fe0f-200d-1f469-1f3fd","native":"👩🏽‍❤️‍👩🏽","x":20,"y":30},{"unified":"1f469-1f3fe-200d-2764-fe0f-200d-1f469-1f3fe","native":"👩🏾‍❤️‍👩🏾","x":20,"y":36},{"unified":"1f469-1f3ff-200d-2764-fe0f-200d-1f469-1f3ff","native":"👩🏿‍❤️‍👩🏿","x":20,"y":42}],"version":2},"family":{"id":"family","name":"Family","keywords":["home","parents","child","mom","dad","father","mother","people","human"],"skins":[{"unified":"1f46a","native":"👪","x":21,"y":40}],"version":1},"man-woman-boy":{"id":"man-woman-boy","name":"Family: Man, Woman, Boy","keywords":["man","woman-boy","family","woman","love"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466","native":"👨‍👩‍👦","x":14,"y":44}],"version":2},"man-woman-girl":{"id":"man-woman-girl","name":"Family: Man, Woman, Girl","keywords":["man","woman-girl","family","woman","home","parents","people","human","child"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467","native":"👨‍👩‍👧","x":14,"y":46}],"version":2},"man-woman-girl-boy":{"id":"man-woman-girl-boy","name":"Family: Man, Woman, Girl, Boy","keywords":["man","woman-girl-boy","family","woman","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f466","native":"👨‍👩‍👧‍👦","x":14,"y":47}],"version":2},"man-woman-boy-boy":{"id":"man-woman-boy-boy","name":"Family: Man, Woman, Boy, Boy","keywords":["man","woman-boy-boy","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f466-200d-1f466","native":"👨‍👩‍👦‍👦","x":14,"y":45}],"version":2},"man-woman-girl-girl":{"id":"man-woman-girl-girl","name":"Family: Man, Woman, Girl, Girl","keywords":["man","woman-girl-girl","family","woman","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f469-200d-1f467-200d-1f467","native":"👨‍👩‍👧‍👧","x":14,"y":48}],"version":2},"man-man-boy":{"id":"man-man-boy","name":"Family: Man, Man, Boy","keywords":["man","man-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466","native":"👨‍👨‍👦","x":14,"y":39}],"version":2},"man-man-girl":{"id":"man-man-girl","name":"Family: Man, Man, Girl","keywords":["man","man-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467","native":"👨‍👨‍👧","x":14,"y":41}],"version":2},"man-man-girl-boy":{"id":"man-man-girl-boy","name":"Family: Man, Man, Girl, Boy","keywords":["man","man-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f466","native":"👨‍👨‍👧‍👦","x":14,"y":42}],"version":2},"man-man-boy-boy":{"id":"man-man-boy-boy","name":"Family: Man, Man, Boy, Boy","keywords":["man","man-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f466-200d-1f466","native":"👨‍👨‍👦‍👦","x":14,"y":40}],"version":2},"man-man-girl-girl":{"id":"man-man-girl-girl","name":"Family: Man, Man, Girl, Girl","keywords":["man","man-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f468-200d-1f468-200d-1f467-200d-1f467","native":"👨‍👨‍👧‍👧","x":14,"y":43}],"version":2},"woman-woman-boy":{"id":"woman-woman-boy","name":"Family: Woman, Woman, Boy","keywords":["woman","woman-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466","native":"👩‍👩‍👦","x":18,"y":12}],"version":2},"woman-woman-girl":{"id":"woman-woman-girl","name":"Family: Woman, Woman, Girl","keywords":["woman","woman-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467","native":"👩‍👩‍👧","x":18,"y":14}],"version":2},"woman-woman-girl-boy":{"id":"woman-woman-girl-boy","name":"Family: Woman, Woman, Girl, Boy","keywords":["woman","woman-girl-boy","family","girl","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f466","native":"👩‍👩‍👧‍👦","x":18,"y":15}],"version":2},"woman-woman-boy-boy":{"id":"woman-woman-boy-boy","name":"Family: Woman, Woman, Boy, Boy","keywords":["woman","woman-boy-boy","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f466-200d-1f466","native":"👩‍👩‍👦‍👦","x":18,"y":13}],"version":2},"woman-woman-girl-girl":{"id":"woman-woman-girl-girl","name":"Family: Woman, Woman, Girl, Girl","keywords":["woman","woman-girl-girl","family","home","parents","people","human","children"],"skins":[{"unified":"1f469-200d-1f469-200d-1f467-200d-1f467","native":"👩‍👩‍👧‍👧","x":18,"y":16}],"version":2},"man-boy":{"id":"man-boy","name":"Family: Man, Boy","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f466","native":"👨‍👦","x":14,"y":35}],"version":4},"man-boy-boy":{"id":"man-boy-boy","name":"Family: Man, Boy, Boy","keywords":["man","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f466-200d-1f466","native":"👨‍👦‍👦","x":14,"y":34}],"version":4},"man-girl":{"id":"man-girl","name":"Family: Man, Girl","keywords":["man","family","home","parent","people","human","child"],"skins":[{"unified":"1f468-200d-1f467","native":"👨‍👧","x":14,"y":38}],"version":4},"man-girl-boy":{"id":"man-girl-boy","name":"Family: Man, Girl, Boy","keywords":["man","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f466","native":"👨‍👧‍👦","x":14,"y":36}],"version":4},"man-girl-girl":{"id":"man-girl-girl","name":"Family: Man, Girl, Girl","keywords":["man","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f468-200d-1f467-200d-1f467","native":"👨‍👧‍👧","x":14,"y":37}],"version":4},"woman-boy":{"id":"woman-boy","name":"Family: Woman, Boy","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f466","native":"👩‍👦","x":18,"y":8}],"version":4},"woman-boy-boy":{"id":"woman-boy-boy","name":"Family: Woman, Boy, Boy","keywords":["woman","boy-boy","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f466-200d-1f466","native":"👩‍👦‍👦","x":18,"y":7}],"version":4},"woman-girl":{"id":"woman-girl","name":"Family: Woman, Girl","keywords":["woman","family","home","parent","people","human","child"],"skins":[{"unified":"1f469-200d-1f467","native":"👩‍👧","x":18,"y":11}],"version":4},"woman-girl-boy":{"id":"woman-girl-boy","name":"Family: Woman, Girl, Boy","keywords":["woman","girl-boy","family","girl","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f466","native":"👩‍👧‍👦","x":18,"y":9}],"version":4},"woman-girl-girl":{"id":"woman-girl-girl","name":"Family: Woman, Girl, Girl","keywords":["woman","girl-girl","family","home","parent","people","human","children"],"skins":[{"unified":"1f469-200d-1f467-200d-1f467","native":"👩‍👧‍👧","x":18,"y":10}],"version":4},"speaking_head_in_silhouette":{"id":"speaking_head_in_silhouette","name":"Speaking Head","keywords":["in","silhouette","user","person","human","sing","say","talk"],"skins":[{"unified":"1f5e3-fe0f","native":"🗣️","x":32,"y":11}],"version":1},"bust_in_silhouette":{"id":"bust_in_silhouette","name":"Bust in Silhouette","keywords":["user","person","human"],"skins":[{"unified":"1f464","native":"👤","x":13,"y":33}],"version":1},"busts_in_silhouette":{"id":"busts_in_silhouette","name":"Busts in Silhouette","keywords":["user","person","human","group","team"],"skins":[{"unified":"1f465","native":"👥","x":13,"y":34}],"version":1},"people_hugging":{"id":"people_hugging","name":"People Hugging","keywords":["care"],"skins":[{"unified":"1fac2","native":"🫂","x":54,"y":58}],"version":13},"footprints":{"id":"footprints","name":"Footprints","keywords":["feet","tracking","walking","beach"],"skins":[{"unified":"1f463","native":"👣","x":13,"y":32}],"version":1},"monkey_face":{"id":"monkey_face","name":"Monkey Face","emoticons":[":o)"],"keywords":["animal","nature","circus"],"skins":[{"unified":"1f435","native":"🐵","x":11,"y":41}],"version":1},"monkey":{"id":"monkey","name":"Monkey","keywords":["animal","nature","banana","circus"],"skins":[{"unified":"1f412","native":"🐒","x":11,"y":4}],"version":1},"gorilla":{"id":"gorilla","name":"Gorilla","keywords":["animal","nature","circus"],"skins":[{"unified":"1f98d","native":"🦍","x":44,"y":33}],"version":3},"orangutan":{"id":"orangutan","name":"Orangutan","keywords":["animal"],"skins":[{"unified":"1f9a7","native":"🦧","x":44,"y":59}],"version":12},"dog":{"id":"dog","name":"Dog Face","keywords":["animal","friend","nature","woof","puppy","pet","faithful"],"skins":[{"unified":"1f436","native":"🐶","x":11,"y":42}],"version":1},"dog2":{"id":"dog2","name":"Dog","keywords":["dog2","animal","nature","friend","doge","pet","faithful"],"skins":[{"unified":"1f415","native":"🐕","x":11,"y":8}],"version":1},"guide_dog":{"id":"guide_dog","name":"Guide Dog","keywords":["animal","blind"],"skins":[{"unified":"1f9ae","native":"🦮","x":45,"y":5}],"version":12},"service_dog":{"id":"service_dog","name":"Service Dog","keywords":["blind","animal"],"skins":[{"unified":"1f415-200d-1f9ba","native":"🐕‍🦺","x":11,"y":7}],"version":12},"poodle":{"id":"poodle","name":"Poodle","keywords":["dog","animal","101","nature","pet"],"skins":[{"unified":"1f429","native":"🐩","x":11,"y":29}],"version":1},"wolf":{"id":"wolf","name":"Wolf","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43a","native":"🐺","x":11,"y":46}],"version":1},"fox_face":{"id":"fox_face","name":"Fox","keywords":["face","animal","nature"],"skins":[{"unified":"1f98a","native":"🦊","x":44,"y":30}],"version":3},"raccoon":{"id":"raccoon","name":"Raccoon","keywords":["animal","nature"],"skins":[{"unified":"1f99d","native":"🦝","x":44,"y":49}],"version":11},"cat":{"id":"cat","name":"Cat Face","keywords":["animal","meow","nature","pet","kitten"],"skins":[{"unified":"1f431","native":"🐱","x":11,"y":37}],"version":1},"cat2":{"id":"cat2","name":"Cat","keywords":["cat2","animal","meow","pet","cats"],"skins":[{"unified":"1f408","native":"🐈","x":10,"y":55}],"version":1},"black_cat":{"id":"black_cat","name":"Black Cat","keywords":["superstition","luck"],"skins":[{"unified":"1f408-200d-2b1b","native":"🐈‍⬛","x":10,"y":54}],"version":13},"lion_face":{"id":"lion_face","name":"Lion","keywords":["face","animal","nature"],"skins":[{"unified":"1f981","native":"🦁","x":44,"y":21}],"version":1},"tiger":{"id":"tiger","name":"Tiger Face","keywords":["animal","cat","danger","wild","nature","roar"],"skins":[{"unified":"1f42f","native":"🐯","x":11,"y":35}],"version":1},"tiger2":{"id":"tiger2","name":"Tiger","keywords":["tiger2","animal","nature","roar"],"skins":[{"unified":"1f405","native":"🐅","x":10,"y":51}],"version":1},"leopard":{"id":"leopard","name":"Leopard","keywords":["animal","nature"],"skins":[{"unified":"1f406","native":"🐆","x":10,"y":52}],"version":1},"horse":{"id":"horse","name":"Horse Face","keywords":["animal","brown","nature"],"skins":[{"unified":"1f434","native":"🐴","x":11,"y":40}],"version":1},"racehorse":{"id":"racehorse","name":"Horse","keywords":["racehorse","animal","gamble","luck"],"skins":[{"unified":"1f40e","native":"🐎","x":11,"y":0}],"version":1},"unicorn_face":{"id":"unicorn_face","name":"Unicorn","keywords":["face","animal","nature","mystical"],"skins":[{"unified":"1f984","native":"🦄","x":44,"y":24}],"version":1},"zebra_face":{"id":"zebra_face","name":"Zebra","keywords":["face","animal","nature","stripes","safari"],"skins":[{"unified":"1f993","native":"🦓","x":44,"y":39}],"version":5},"deer":{"id":"deer","name":"Deer","keywords":["animal","nature","horns","venison"],"skins":[{"unified":"1f98c","native":"🦌","x":44,"y":32}],"version":3},"bison":{"id":"bison","name":"Bison","keywords":["ox"],"skins":[{"unified":"1f9ac","native":"🦬","x":45,"y":3}],"version":13},"cow":{"id":"cow","name":"Cow Face","keywords":["beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f42e","native":"🐮","x":11,"y":34}],"version":1},"ox":{"id":"ox","name":"Ox","keywords":["animal","cow","beef"],"skins":[{"unified":"1f402","native":"🐂","x":10,"y":48}],"version":1},"water_buffalo":{"id":"water_buffalo","name":"Water Buffalo","keywords":["animal","nature","ox","cow"],"skins":[{"unified":"1f403","native":"🐃","x":10,"y":49}],"version":1},"cow2":{"id":"cow2","name":"Cow","keywords":["cow2","beef","ox","animal","nature","moo","milk"],"skins":[{"unified":"1f404","native":"🐄","x":10,"y":50}],"version":1},"pig":{"id":"pig","name":"Pig Face","keywords":["animal","oink","nature"],"skins":[{"unified":"1f437","native":"🐷","x":11,"y":43}],"version":1},"pig2":{"id":"pig2","name":"Pig","keywords":["pig2","animal","nature"],"skins":[{"unified":"1f416","native":"🐖","x":11,"y":9}],"version":1},"boar":{"id":"boar","name":"Boar","keywords":["animal","nature"],"skins":[{"unified":"1f417","native":"🐗","x":11,"y":10}],"version":1},"pig_nose":{"id":"pig_nose","name":"Pig Nose","keywords":["animal","oink"],"skins":[{"unified":"1f43d","native":"🐽","x":11,"y":50}],"version":1},"ram":{"id":"ram","name":"Ram","keywords":["animal","sheep","nature"],"skins":[{"unified":"1f40f","native":"🐏","x":11,"y":1}],"version":1},"sheep":{"id":"sheep","name":"Ewe","keywords":["sheep","animal","nature","wool","shipit"],"skins":[{"unified":"1f411","native":"🐑","x":11,"y":3}],"version":1},"goat":{"id":"goat","name":"Goat","keywords":["animal","nature"],"skins":[{"unified":"1f410","native":"🐐","x":11,"y":2}],"version":1},"dromedary_camel":{"id":"dromedary_camel","name":"Camel","keywords":["dromedary","animal","hot","desert","hump"],"skins":[{"unified":"1f42a","native":"🐪","x":11,"y":30}],"version":1},"camel":{"id":"camel","name":"Bactrian Camel","keywords":["two","hump","animal","nature","hot","desert"],"skins":[{"unified":"1f42b","native":"🐫","x":11,"y":31}],"version":1},"llama":{"id":"llama","name":"Llama","keywords":["animal","nature","alpaca"],"skins":[{"unified":"1f999","native":"🦙","x":44,"y":45}],"version":11},"giraffe_face":{"id":"giraffe_face","name":"Giraffe","keywords":["face","animal","nature","spots","safari"],"skins":[{"unified":"1f992","native":"🦒","x":44,"y":38}],"version":5},"elephant":{"id":"elephant","name":"Elephant","keywords":["animal","nature","nose","th","circus"],"skins":[{"unified":"1f418","native":"🐘","x":11,"y":11}],"version":1},"mammoth":{"id":"mammoth","name":"Mammoth","keywords":["elephant","tusks"],"skins":[{"unified":"1f9a3","native":"🦣","x":44,"y":55}],"version":13},"rhinoceros":{"id":"rhinoceros","name":"Rhinoceros","keywords":["animal","nature","horn"],"skins":[{"unified":"1f98f","native":"🦏","x":44,"y":35}],"version":3},"hippopotamus":{"id":"hippopotamus","name":"Hippopotamus","keywords":["animal","nature"],"skins":[{"unified":"1f99b","native":"🦛","x":44,"y":47}],"version":11},"mouse":{"id":"mouse","name":"Mouse Face","keywords":["animal","nature","cheese","wedge","rodent"],"skins":[{"unified":"1f42d","native":"🐭","x":11,"y":33}],"version":1},"mouse2":{"id":"mouse2","name":"Mouse","keywords":["mouse2","animal","nature","rodent"],"skins":[{"unified":"1f401","native":"🐁","x":10,"y":47}],"version":1},"rat":{"id":"rat","name":"Rat","keywords":["animal","mouse","rodent"],"skins":[{"unified":"1f400","native":"🐀","x":10,"y":46}],"version":1},"hamster":{"id":"hamster","name":"Hamster","keywords":["animal","nature"],"skins":[{"unified":"1f439","native":"🐹","x":11,"y":45}],"version":1},"rabbit":{"id":"rabbit","name":"Rabbit Face","keywords":["animal","nature","pet","spring","magic","bunny"],"skins":[{"unified":"1f430","native":"🐰","x":11,"y":36}],"version":1},"rabbit2":{"id":"rabbit2","name":"Rabbit","keywords":["rabbit2","animal","nature","pet","magic","spring"],"skins":[{"unified":"1f407","native":"🐇","x":10,"y":53}],"version":1},"chipmunk":{"id":"chipmunk","name":"Chipmunk","keywords":["animal","nature","rodent","squirrel"],"skins":[{"unified":"1f43f-fe0f","native":"🐿️","x":11,"y":52}],"version":1},"beaver":{"id":"beaver","name":"Beaver","keywords":["animal","rodent"],"skins":[{"unified":"1f9ab","native":"🦫","x":45,"y":2}],"version":13},"hedgehog":{"id":"hedgehog","name":"Hedgehog","keywords":["animal","nature","spiny"],"skins":[{"unified":"1f994","native":"🦔","x":44,"y":40}],"version":5},"bat":{"id":"bat","name":"Bat","keywords":["animal","nature","blind","vampire"],"skins":[{"unified":"1f987","native":"🦇","x":44,"y":27}],"version":3},"bear":{"id":"bear","name":"Bear","keywords":["animal","nature","wild"],"skins":[{"unified":"1f43b","native":"🐻","x":11,"y":48}],"version":1},"polar_bear":{"id":"polar_bear","name":"Polar Bear","keywords":["animal","arctic"],"skins":[{"unified":"1f43b-200d-2744-fe0f","native":"🐻‍❄️","x":11,"y":47}],"version":13},"koala":{"id":"koala","name":"Koala","keywords":["animal","nature"],"skins":[{"unified":"1f428","native":"🐨","x":11,"y":28}],"version":1},"panda_face":{"id":"panda_face","name":"Panda","keywords":["face","animal","nature"],"skins":[{"unified":"1f43c","native":"🐼","x":11,"y":49}],"version":1},"sloth":{"id":"sloth","name":"Sloth","keywords":["animal"],"skins":[{"unified":"1f9a5","native":"🦥","x":44,"y":57}],"version":12},"otter":{"id":"otter","name":"Otter","keywords":["animal"],"skins":[{"unified":"1f9a6","native":"🦦","x":44,"y":58}],"version":12},"skunk":{"id":"skunk","name":"Skunk","keywords":["animal"],"skins":[{"unified":"1f9a8","native":"🦨","x":44,"y":60}],"version":12},"kangaroo":{"id":"kangaroo","name":"Kangaroo","keywords":["animal","nature","australia","joey","hop","marsupial"],"skins":[{"unified":"1f998","native":"🦘","x":44,"y":44}],"version":11},"badger":{"id":"badger","name":"Badger","keywords":["animal","nature","honey"],"skins":[{"unified":"1f9a1","native":"🦡","x":44,"y":53}],"version":11},"feet":{"id":"feet","name":"Paw Prints","keywords":["feet","animal","tracking","footprints","dog","cat","pet"],"skins":[{"unified":"1f43e","native":"🐾","x":11,"y":51}],"version":1},"turkey":{"id":"turkey","name":"Turkey","keywords":["animal","bird"],"skins":[{"unified":"1f983","native":"🦃","x":44,"y":23}],"version":1},"chicken":{"id":"chicken","name":"Chicken","keywords":["animal","cluck","nature","bird"],"skins":[{"unified":"1f414","native":"🐔","x":11,"y":6}],"version":1},"rooster":{"id":"rooster","name":"Rooster","keywords":["animal","nature","chicken"],"skins":[{"unified":"1f413","native":"🐓","x":11,"y":5}],"version":1},"hatching_chick":{"id":"hatching_chick","name":"Hatching Chick","keywords":["animal","chicken","egg","born","baby","bird"],"skins":[{"unified":"1f423","native":"🐣","x":11,"y":22}],"version":1},"baby_chick":{"id":"baby_chick","name":"Baby Chick","keywords":["animal","chicken","bird"],"skins":[{"unified":"1f424","native":"🐤","x":11,"y":23}],"version":1},"hatched_chick":{"id":"hatched_chick","name":"Front-Facing Baby Chick","keywords":["hatched","front","facing","animal","chicken","bird"],"skins":[{"unified":"1f425","native":"🐥","x":11,"y":24}],"version":1},"bird":{"id":"bird","name":"Bird","keywords":["animal","nature","fly","tweet","spring"],"skins":[{"unified":"1f426","native":"🐦","x":11,"y":26}],"version":1},"penguin":{"id":"penguin","name":"Penguin","keywords":["animal","nature"],"skins":[{"unified":"1f427","native":"🐧","x":11,"y":27}],"version":1},"dove_of_peace":{"id":"dove_of_peace","name":"Dove","keywords":["of","peace","animal","bird"],"skins":[{"unified":"1f54a-fe0f","native":"🕊️","x":30,"y":28}],"version":1},"eagle":{"id":"eagle","name":"Eagle","keywords":["animal","nature","bird"],"skins":[{"unified":"1f985","native":"🦅","x":44,"y":25}],"version":3},"duck":{"id":"duck","name":"Duck","keywords":["animal","nature","bird","mallard"],"skins":[{"unified":"1f986","native":"🦆","x":44,"y":26}],"version":3},"swan":{"id":"swan","name":"Swan","keywords":["animal","nature","bird"],"skins":[{"unified":"1f9a2","native":"🦢","x":44,"y":54}],"version":11},"owl":{"id":"owl","name":"Owl","keywords":["animal","nature","bird","hoot"],"skins":[{"unified":"1f989","native":"🦉","x":44,"y":29}],"version":3},"dodo":{"id":"dodo","name":"Dodo","keywords":["animal","bird"],"skins":[{"unified":"1f9a4","native":"🦤","x":44,"y":56}],"version":13},"feather":{"id":"feather","name":"Feather","keywords":["bird","fly"],"skins":[{"unified":"1fab6","native":"🪶","x":54,"y":47}],"version":13},"flamingo":{"id":"flamingo","name":"Flamingo","keywords":["animal"],"skins":[{"unified":"1f9a9","native":"🦩","x":45,"y":0}],"version":12},"peacock":{"id":"peacock","name":"Peacock","keywords":["animal","nature","peahen","bird"],"skins":[{"unified":"1f99a","native":"🦚","x":44,"y":46}],"version":11},"parrot":{"id":"parrot","name":"Parrot","keywords":["animal","nature","bird","pirate","talk"],"skins":[{"unified":"1f99c","native":"🦜","x":44,"y":48}],"version":11},"frog":{"id":"frog","name":"Frog","keywords":["animal","nature","croak","toad"],"skins":[{"unified":"1f438","native":"🐸","x":11,"y":44}],"version":1},"crocodile":{"id":"crocodile","name":"Crocodile","keywords":["animal","nature","reptile","lizard","alligator"],"skins":[{"unified":"1f40a","native":"🐊","x":10,"y":57}],"version":1},"turtle":{"id":"turtle","name":"Turtle","keywords":["animal","slow","nature","tortoise"],"skins":[{"unified":"1f422","native":"🐢","x":11,"y":21}],"version":1},"lizard":{"id":"lizard","name":"Lizard","keywords":["animal","nature","reptile"],"skins":[{"unified":"1f98e","native":"🦎","x":44,"y":34}],"version":3},"snake":{"id":"snake","name":"Snake","keywords":["animal","evil","nature","hiss","python"],"skins":[{"unified":"1f40d","native":"🐍","x":10,"y":60}],"version":1},"dragon_face":{"id":"dragon_face","name":"Dragon Face","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f432","native":"🐲","x":11,"y":38}],"version":1},"dragon":{"id":"dragon","name":"Dragon","keywords":["animal","myth","nature","chinese","green"],"skins":[{"unified":"1f409","native":"🐉","x":10,"y":56}],"version":1},"sauropod":{"id":"sauropod","name":"Sauropod","keywords":["animal","nature","dinosaur","brachiosaurus","brontosaurus","diplodocus","extinct"],"skins":[{"unified":"1f995","native":"🦕","x":44,"y":41}],"version":5},"t-rex":{"id":"t-rex","name":"T-Rex","keywords":["t","rex","animal","nature","dinosaur","tyrannosaurus","extinct"],"skins":[{"unified":"1f996","native":"🦖","x":44,"y":42}],"version":5},"whale":{"id":"whale","name":"Spouting Whale","keywords":["animal","nature","sea","ocean"],"skins":[{"unified":"1f433","native":"🐳","x":11,"y":39}],"version":1},"whale2":{"id":"whale2","name":"Whale","keywords":["whale2","animal","nature","sea","ocean"],"skins":[{"unified":"1f40b","native":"🐋","x":10,"y":58}],"version":1},"dolphin":{"id":"dolphin","name":"Dolphin","keywords":["flipper","animal","nature","fish","sea","ocean","fins","beach"],"skins":[{"unified":"1f42c","native":"🐬","x":11,"y":32}],"version":1},"seal":{"id":"seal","name":"Seal","keywords":["animal","creature","sea"],"skins":[{"unified":"1f9ad","native":"🦭","x":45,"y":4}],"version":13},"fish":{"id":"fish","name":"Fish","keywords":["animal","food","nature"],"skins":[{"unified":"1f41f","native":"🐟","x":11,"y":18}],"version":1},"tropical_fish":{"id":"tropical_fish","name":"Tropical Fish","keywords":["animal","swim","ocean","beach","nemo"],"skins":[{"unified":"1f420","native":"🐠","x":11,"y":19}],"version":1},"blowfish":{"id":"blowfish","name":"Blowfish","keywords":["animal","nature","food","sea","ocean"],"skins":[{"unified":"1f421","native":"🐡","x":11,"y":20}],"version":1},"shark":{"id":"shark","name":"Shark","keywords":["animal","nature","fish","sea","ocean","jaws","fins","beach"],"skins":[{"unified":"1f988","native":"🦈","x":44,"y":28}],"version":3},"octopus":{"id":"octopus","name":"Octopus","keywords":["animal","creature","ocean","sea","nature","beach"],"skins":[{"unified":"1f419","native":"🐙","x":11,"y":12}],"version":1},"shell":{"id":"shell","name":"Spiral Shell","keywords":["nature","sea","beach"],"skins":[{"unified":"1f41a","native":"🐚","x":11,"y":13}],"version":1},"coral":{"id":"coral","name":"Coral","keywords":["ocean","sea","reef"],"skins":[{"unified":"1fab8","native":"🪸","x":54,"y":49}],"version":14},"snail":{"id":"snail","name":"Snail","keywords":["slow","animal","shell"],"skins":[{"unified":"1f40c","native":"🐌","x":10,"y":59}],"version":1},"butterfly":{"id":"butterfly","name":"Butterfly","keywords":["animal","insect","nature","caterpillar"],"skins":[{"unified":"1f98b","native":"🦋","x":44,"y":31}],"version":3},"bug":{"id":"bug","name":"Bug","keywords":["animal","insect","nature","worm"],"skins":[{"unified":"1f41b","native":"🐛","x":11,"y":14}],"version":1},"ant":{"id":"ant","name":"Ant","keywords":["animal","insect","nature","bug"],"skins":[{"unified":"1f41c","native":"🐜","x":11,"y":15}],"version":1},"bee":{"id":"bee","name":"Honeybee","keywords":["bee","animal","insect","nature","bug","spring","honey"],"skins":[{"unified":"1f41d","native":"🐝","x":11,"y":16}],"version":1},"beetle":{"id":"beetle","name":"Beetle","keywords":["insect"],"skins":[{"unified":"1fab2","native":"🪲","x":54,"y":43}],"version":13},"ladybug":{"id":"ladybug","name":"Lady Beetle","keywords":["ladybug","animal","insect","nature"],"skins":[{"unified":"1f41e","native":"🐞","x":11,"y":17}],"version":1},"cricket":{"id":"cricket","name":"Cricket","keywords":["animal","chirp"],"skins":[{"unified":"1f997","native":"🦗","x":44,"y":43}],"version":5},"cockroach":{"id":"cockroach","name":"Cockroach","keywords":["insect","pests"],"skins":[{"unified":"1fab3","native":"🪳","x":54,"y":44}],"version":13},"spider":{"id":"spider","name":"Spider","keywords":["animal","arachnid"],"skins":[{"unified":"1f577-fe0f","native":"🕷️","x":31,"y":24}],"version":1},"spider_web":{"id":"spider_web","name":"Spider Web","keywords":["animal","insect","arachnid","silk"],"skins":[{"unified":"1f578-fe0f","native":"🕸️","x":31,"y":25}],"version":1},"scorpion":{"id":"scorpion","name":"Scorpion","keywords":["animal","arachnid"],"skins":[{"unified":"1f982","native":"🦂","x":44,"y":22}],"version":1},"mosquito":{"id":"mosquito","name":"Mosquito","keywords":["animal","nature","insect","malaria"],"skins":[{"unified":"1f99f","native":"🦟","x":44,"y":51}],"version":11},"fly":{"id":"fly","name":"Fly","keywords":["insect"],"skins":[{"unified":"1fab0","native":"🪰","x":54,"y":41}],"version":13},"worm":{"id":"worm","name":"Worm","keywords":["animal"],"skins":[{"unified":"1fab1","native":"🪱","x":54,"y":42}],"version":13},"microbe":{"id":"microbe","name":"Microbe","keywords":["amoeba","bacteria","germs","virus","covid"],"skins":[{"unified":"1f9a0","native":"🦠","x":44,"y":52}],"version":11},"bouquet":{"id":"bouquet","name":"Bouquet","keywords":["flowers","nature","spring"],"skins":[{"unified":"1f490","native":"💐","x":27,"y":7}],"version":1},"cherry_blossom":{"id":"cherry_blossom","name":"Cherry Blossom","keywords":["nature","plant","spring","flower"],"skins":[{"unified":"1f338","native":"🌸","x":5,"y":53}],"version":1},"white_flower":{"id":"white_flower","name":"White Flower","keywords":["japanese","spring"],"skins":[{"unified":"1f4ae","native":"💮","x":28,"y":6}],"version":1},"lotus":{"id":"lotus","name":"Lotus","keywords":["flower","calm","meditation"],"skins":[{"unified":"1fab7","native":"🪷","x":54,"y":48}],"version":14},"rosette":{"id":"rosette","name":"Rosette","keywords":["flower","decoration","military"],"skins":[{"unified":"1f3f5-fe0f","native":"🏵️","x":10,"y":36}],"version":1},"rose":{"id":"rose","name":"Rose","keywords":["flowers","valentines","love","spring"],"skins":[{"unified":"1f339","native":"🌹","x":5,"y":54}],"version":1},"wilted_flower":{"id":"wilted_flower","name":"Wilted Flower","keywords":["plant","nature","rose"],"skins":[{"unified":"1f940","native":"🥀","x":43,"y":13}],"version":3},"hibiscus":{"id":"hibiscus","name":"Hibiscus","keywords":["plant","vegetable","flowers","beach"],"skins":[{"unified":"1f33a","native":"🌺","x":5,"y":55}],"version":1},"sunflower":{"id":"sunflower","name":"Sunflower","keywords":["nature","plant","fall"],"skins":[{"unified":"1f33b","native":"🌻","x":5,"y":56}],"version":1},"blossom":{"id":"blossom","name":"Blossom","keywords":["nature","flowers","yellow"],"skins":[{"unified":"1f33c","native":"🌼","x":5,"y":57}],"version":1},"tulip":{"id":"tulip","name":"Tulip","keywords":["flowers","plant","nature","summer","spring"],"skins":[{"unified":"1f337","native":"🌷","x":5,"y":52}],"version":1},"seedling":{"id":"seedling","name":"Seedling","keywords":["plant","nature","grass","lawn","spring"],"skins":[{"unified":"1f331","native":"🌱","x":5,"y":46}],"version":1},"potted_plant":{"id":"potted_plant","name":"Potted Plant","keywords":["greenery","house"],"skins":[{"unified":"1fab4","native":"🪴","x":54,"y":45}],"version":13},"evergreen_tree":{"id":"evergreen_tree","name":"Evergreen Tree","keywords":["plant","nature"],"skins":[{"unified":"1f332","native":"🌲","x":5,"y":47}],"version":1},"deciduous_tree":{"id":"deciduous_tree","name":"Deciduous Tree","keywords":["plant","nature"],"skins":[{"unified":"1f333","native":"🌳","x":5,"y":48}],"version":1},"palm_tree":{"id":"palm_tree","name":"Palm Tree","keywords":["plant","vegetable","nature","summer","beach","mojito","tropical"],"skins":[{"unified":"1f334","native":"🌴","x":5,"y":49}],"version":1},"cactus":{"id":"cactus","name":"Cactus","keywords":["vegetable","plant","nature"],"skins":[{"unified":"1f335","native":"🌵","x":5,"y":50}],"version":1},"ear_of_rice":{"id":"ear_of_rice","name":"Ear of Rice","keywords":["sheaf","nature","plant"],"skins":[{"unified":"1f33e","native":"🌾","x":5,"y":59}],"version":1},"herb":{"id":"herb","name":"Herb","keywords":["vegetable","plant","medicine","weed","grass","lawn"],"skins":[{"unified":"1f33f","native":"🌿","x":5,"y":60}],"version":1},"shamrock":{"id":"shamrock","name":"Shamrock","keywords":["vegetable","plant","nature","irish","clover"],"skins":[{"unified":"2618-fe0f","native":"☘️","x":57,"y":19}],"version":1},"four_leaf_clover":{"id":"four_leaf_clover","name":"Four Leaf Clover","keywords":["vegetable","plant","nature","lucky","irish"],"skins":[{"unified":"1f340","native":"🍀","x":6,"y":0}],"version":1},"maple_leaf":{"id":"maple_leaf","name":"Maple Leaf","keywords":["nature","plant","vegetable","ca","fall"],"skins":[{"unified":"1f341","native":"🍁","x":6,"y":1}],"version":1},"fallen_leaf":{"id":"fallen_leaf","name":"Fallen Leaf","keywords":["nature","plant","vegetable","leaves"],"skins":[{"unified":"1f342","native":"🍂","x":6,"y":2}],"version":1},"leaves":{"id":"leaves","name":"Leaf Fluttering in Wind","keywords":["leaves","nature","plant","tree","vegetable","grass","lawn","spring"],"skins":[{"unified":"1f343","native":"🍃","x":6,"y":3}],"version":1},"empty_nest":{"id":"empty_nest","name":"Empty Nest","keywords":["bird"],"skins":[{"unified":"1fab9","native":"🪹","x":54,"y":50}],"version":14},"nest_with_eggs":{"id":"nest_with_eggs","name":"Nest with Eggs","keywords":["bird"],"skins":[{"unified":"1faba","native":"🪺","x":54,"y":51}],"version":14},"mushroom":{"id":"mushroom","name":"Mushroom","keywords":["plant","vegetable"],"skins":[{"unified":"1f344","native":"🍄","x":6,"y":4}],"version":1},"grapes":{"id":"grapes","name":"Grapes","keywords":["fruit","food","wine"],"skins":[{"unified":"1f347","native":"🍇","x":6,"y":7}],"version":1},"melon":{"id":"melon","name":"Melon","keywords":["fruit","nature","food"],"skins":[{"unified":"1f348","native":"🍈","x":6,"y":8}],"version":1},"watermelon":{"id":"watermelon","name":"Watermelon","keywords":["fruit","food","picnic","summer"],"skins":[{"unified":"1f349","native":"🍉","x":6,"y":9}],"version":1},"tangerine":{"id":"tangerine","name":"Tangerine","keywords":["food","fruit","nature","orange"],"skins":[{"unified":"1f34a","native":"🍊","x":6,"y":10}],"version":1},"lemon":{"id":"lemon","name":"Lemon","keywords":["fruit","nature"],"skins":[{"unified":"1f34b","native":"🍋","x":6,"y":11}],"version":1},"banana":{"id":"banana","name":"Banana","keywords":["fruit","food","monkey"],"skins":[{"unified":"1f34c","native":"🍌","x":6,"y":12}],"version":1},"pineapple":{"id":"pineapple","name":"Pineapple","keywords":["fruit","nature","food"],"skins":[{"unified":"1f34d","native":"🍍","x":6,"y":13}],"version":1},"mango":{"id":"mango","name":"Mango","keywords":["fruit","food","tropical"],"skins":[{"unified":"1f96d","native":"🥭","x":43,"y":57}],"version":11},"apple":{"id":"apple","name":"Red Apple","keywords":["fruit","mac","school"],"skins":[{"unified":"1f34e","native":"🍎","x":6,"y":14}],"version":1},"green_apple":{"id":"green_apple","name":"Green Apple","keywords":["fruit","nature"],"skins":[{"unified":"1f34f","native":"🍏","x":6,"y":15}],"version":1},"pear":{"id":"pear","name":"Pear","keywords":["fruit","nature","food"],"skins":[{"unified":"1f350","native":"🍐","x":6,"y":16}],"version":1},"peach":{"id":"peach","name":"Peach","keywords":["fruit","nature","food"],"skins":[{"unified":"1f351","native":"🍑","x":6,"y":17}],"version":1},"cherries":{"id":"cherries","name":"Cherries","keywords":["food","fruit"],"skins":[{"unified":"1f352","native":"🍒","x":6,"y":18}],"version":1},"strawberry":{"id":"strawberry","name":"Strawberry","keywords":["fruit","food","nature"],"skins":[{"unified":"1f353","native":"🍓","x":6,"y":19}],"version":1},"blueberries":{"id":"blueberries","name":"Blueberries","keywords":["fruit"],"skins":[{"unified":"1fad0","native":"🫐","x":55,"y":18}],"version":13},"kiwifruit":{"id":"kiwifruit","name":"Kiwifruit","keywords":["kiwi","fruit","food"],"skins":[{"unified":"1f95d","native":"🥝","x":43,"y":41}],"version":3},"tomato":{"id":"tomato","name":"Tomato","keywords":["fruit","vegetable","nature","food"],"skins":[{"unified":"1f345","native":"🍅","x":6,"y":5}],"version":1},"olive":{"id":"olive","name":"Olive","keywords":["fruit"],"skins":[{"unified":"1fad2","native":"🫒","x":55,"y":20}],"version":13},"coconut":{"id":"coconut","name":"Coconut","keywords":["fruit","nature","food","palm"],"skins":[{"unified":"1f965","native":"🥥","x":43,"y":49}],"version":5},"avocado":{"id":"avocado","name":"Avocado","keywords":["fruit","food"],"skins":[{"unified":"1f951","native":"🥑","x":43,"y":29}],"version":3},"eggplant":{"id":"eggplant","name":"Eggplant","keywords":["vegetable","nature","food","aubergine"],"skins":[{"unified":"1f346","native":"🍆","x":6,"y":6}],"version":1},"potato":{"id":"potato","name":"Potato","keywords":["food","tuber","vegatable","starch"],"skins":[{"unified":"1f954","native":"🥔","x":43,"y":32}],"version":3},"carrot":{"id":"carrot","name":"Carrot","keywords":["vegetable","food","orange"],"skins":[{"unified":"1f955","native":"🥕","x":43,"y":33}],"version":3},"corn":{"id":"corn","name":"Ear of Corn","keywords":["food","vegetable","plant"],"skins":[{"unified":"1f33d","native":"🌽","x":5,"y":58}],"version":1},"hot_pepper":{"id":"hot_pepper","name":"Hot Pepper","keywords":["food","spicy","chilli","chili"],"skins":[{"unified":"1f336-fe0f","native":"🌶️","x":5,"y":51}],"version":1},"bell_pepper":{"id":"bell_pepper","name":"Bell Pepper","keywords":["fruit","plant"],"skins":[{"unified":"1fad1","native":"🫑","x":55,"y":19}],"version":13},"cucumber":{"id":"cucumber","name":"Cucumber","keywords":["fruit","food","pickle"],"skins":[{"unified":"1f952","native":"🥒","x":43,"y":30}],"version":3},"leafy_green":{"id":"leafy_green","name":"Leafy Green","keywords":["food","vegetable","plant","bok","choy","cabbage","kale","lettuce"],"skins":[{"unified":"1f96c","native":"🥬","x":43,"y":56}],"version":11},"broccoli":{"id":"broccoli","name":"Broccoli","keywords":["fruit","food","vegetable"],"skins":[{"unified":"1f966","native":"🥦","x":43,"y":50}],"version":5},"garlic":{"id":"garlic","name":"Garlic","keywords":["food","spice","cook"],"skins":[{"unified":"1f9c4","native":"🧄","x":46,"y":11}],"version":12},"onion":{"id":"onion","name":"Onion","keywords":["cook","food","spice"],"skins":[{"unified":"1f9c5","native":"🧅","x":46,"y":12}],"version":12},"peanuts":{"id":"peanuts","name":"Peanuts","keywords":["food","nut"],"skins":[{"unified":"1f95c","native":"🥜","x":43,"y":40}],"version":3},"beans":{"id":"beans","name":"Beans","keywords":["food"],"skins":[{"unified":"1fad8","native":"🫘","x":55,"y":26}],"version":14},"chestnut":{"id":"chestnut","name":"Chestnut","keywords":["food","squirrel"],"skins":[{"unified":"1f330","native":"🌰","x":5,"y":45}],"version":1},"bread":{"id":"bread","name":"Bread","keywords":["food","wheat","breakfast","toast"],"skins":[{"unified":"1f35e","native":"🍞","x":6,"y":30}],"version":1},"croissant":{"id":"croissant","name":"Croissant","keywords":["food","bread","french"],"skins":[{"unified":"1f950","native":"🥐","x":43,"y":28}],"version":3},"baguette_bread":{"id":"baguette_bread","name":"Baguette Bread","keywords":["food","french","france","bakery"],"skins":[{"unified":"1f956","native":"🥖","x":43,"y":34}],"version":3},"flatbread":{"id":"flatbread","name":"Flatbread","keywords":["flour","food","bakery"],"skins":[{"unified":"1fad3","native":"🫓","x":55,"y":21}],"version":13},"pretzel":{"id":"pretzel","name":"Pretzel","keywords":["food","bread","twisted","germany","bakery"],"skins":[{"unified":"1f968","native":"🥨","x":43,"y":52}],"version":5},"bagel":{"id":"bagel","name":"Bagel","keywords":["food","bread","bakery","schmear","jewish"],"skins":[{"unified":"1f96f","native":"🥯","x":43,"y":59}],"version":11},"pancakes":{"id":"pancakes","name":"Pancakes","keywords":["food","breakfast","flapjacks","hotcakes","brunch"],"skins":[{"unified":"1f95e","native":"🥞","x":43,"y":42}],"version":3},"waffle":{"id":"waffle","name":"Waffle","keywords":["food","breakfast","brunch"],"skins":[{"unified":"1f9c7","native":"🧇","x":46,"y":14}],"version":12},"cheese_wedge":{"id":"cheese_wedge","name":"Cheese Wedge","keywords":["food","chadder","swiss"],"skins":[{"unified":"1f9c0","native":"🧀","x":46,"y":7}],"version":1},"meat_on_bone":{"id":"meat_on_bone","name":"Meat on Bone","keywords":["good","food","drumstick"],"skins":[{"unified":"1f356","native":"🍖","x":6,"y":22}],"version":1},"poultry_leg":{"id":"poultry_leg","name":"Poultry Leg","keywords":["food","meat","drumstick","bird","chicken","turkey"],"skins":[{"unified":"1f357","native":"🍗","x":6,"y":23}],"version":1},"cut_of_meat":{"id":"cut_of_meat","name":"Cut of Meat","keywords":["food","cow","chop","lambchop","porkchop"],"skins":[{"unified":"1f969","native":"🥩","x":43,"y":53}],"version":5},"bacon":{"id":"bacon","name":"Bacon","keywords":["food","breakfast","pork","pig","meat","brunch"],"skins":[{"unified":"1f953","native":"🥓","x":43,"y":31}],"version":3},"hamburger":{"id":"hamburger","name":"Hamburger","keywords":["meat","fast","food","beef","cheeseburger","mcdonalds","burger","king"],"skins":[{"unified":"1f354","native":"🍔","x":6,"y":20}],"version":1},"fries":{"id":"fries","name":"French Fries","keywords":["chips","snack","fast","food","potato"],"skins":[{"unified":"1f35f","native":"🍟","x":6,"y":31}],"version":1},"pizza":{"id":"pizza","name":"Pizza","keywords":["food","party","italy"],"skins":[{"unified":"1f355","native":"🍕","x":6,"y":21}],"version":1},"hotdog":{"id":"hotdog","name":"Hot Dog","keywords":["hotdog","food","frankfurter","america"],"skins":[{"unified":"1f32d","native":"🌭","x":5,"y":42}],"version":1},"sandwich":{"id":"sandwich","name":"Sandwich","keywords":["food","lunch","bread","toast","bakery"],"skins":[{"unified":"1f96a","native":"🥪","x":43,"y":54}],"version":5},"taco":{"id":"taco","name":"Taco","keywords":["food","mexican"],"skins":[{"unified":"1f32e","native":"🌮","x":5,"y":43}],"version":1},"burrito":{"id":"burrito","name":"Burrito","keywords":["food","mexican"],"skins":[{"unified":"1f32f","native":"🌯","x":5,"y":44}],"version":1},"tamale":{"id":"tamale","name":"Tamale","keywords":["food","masa"],"skins":[{"unified":"1fad4","native":"🫔","x":55,"y":22}],"version":13},"stuffed_flatbread":{"id":"stuffed_flatbread","name":"Stuffed Flatbread","keywords":["food","gyro","mediterranean"],"skins":[{"unified":"1f959","native":"🥙","x":43,"y":37}],"version":3},"falafel":{"id":"falafel","name":"Falafel","keywords":["food","mediterranean"],"skins":[{"unified":"1f9c6","native":"🧆","x":46,"y":13}],"version":12},"egg":{"id":"egg","name":"Egg","keywords":["food","chicken","breakfast"],"skins":[{"unified":"1f95a","native":"🥚","x":43,"y":38}],"version":3},"fried_egg":{"id":"fried_egg","name":"Cooking","keywords":["fried","egg","food","breakfast","kitchen","skillet"],"skins":[{"unified":"1f373","native":"🍳","x":6,"y":51}],"version":1},"shallow_pan_of_food":{"id":"shallow_pan_of_food","name":"Shallow Pan of Food","keywords":["cooking","casserole","paella","skillet"],"skins":[{"unified":"1f958","native":"🥘","x":43,"y":36}],"version":3},"stew":{"id":"stew","name":"Pot of Food","keywords":["stew","meat","soup","hot"],"skins":[{"unified":"1f372","native":"🍲","x":6,"y":50}],"version":1},"fondue":{"id":"fondue","name":"Fondue","keywords":["cheese","pot","food"],"skins":[{"unified":"1fad5","native":"🫕","x":55,"y":23}],"version":13},"bowl_with_spoon":{"id":"bowl_with_spoon","name":"Bowl with Spoon","keywords":["food","breakfast","cereal","oatmeal","porridge"],"skins":[{"unified":"1f963","native":"🥣","x":43,"y":47}],"version":5},"green_salad":{"id":"green_salad","name":"Green Salad","keywords":["food","healthy","lettuce","vegetable"],"skins":[{"unified":"1f957","native":"🥗","x":43,"y":35}],"version":3},"popcorn":{"id":"popcorn","name":"Popcorn","keywords":["food","movie","theater","films","snack","drama"],"skins":[{"unified":"1f37f","native":"🍿","x":7,"y":2}],"version":1},"butter":{"id":"butter","name":"Butter","keywords":["food","cook"],"skins":[{"unified":"1f9c8","native":"🧈","x":46,"y":15}],"version":12},"salt":{"id":"salt","name":"Salt","keywords":["condiment","shaker"],"skins":[{"unified":"1f9c2","native":"🧂","x":46,"y":9}],"version":11},"canned_food":{"id":"canned_food","name":"Canned Food","keywords":["soup","tomatoes"],"skins":[{"unified":"1f96b","native":"🥫","x":43,"y":55}],"version":5},"bento":{"id":"bento","name":"Bento Box","keywords":["food","japanese","lunch"],"skins":[{"unified":"1f371","native":"🍱","x":6,"y":49}],"version":1},"rice_cracker":{"id":"rice_cracker","name":"Rice Cracker","keywords":["food","japanese","snack"],"skins":[{"unified":"1f358","native":"🍘","x":6,"y":24}],"version":1},"rice_ball":{"id":"rice_ball","name":"Rice Ball","keywords":["food","japanese"],"skins":[{"unified":"1f359","native":"🍙","x":6,"y":25}],"version":1},"rice":{"id":"rice","name":"Cooked Rice","keywords":["food","asian"],"skins":[{"unified":"1f35a","native":"🍚","x":6,"y":26}],"version":1},"curry":{"id":"curry","name":"Curry Rice","keywords":["food","spicy","hot","indian"],"skins":[{"unified":"1f35b","native":"🍛","x":6,"y":27}],"version":1},"ramen":{"id":"ramen","name":"Steaming Bowl","keywords":["ramen","food","japanese","noodle","chopsticks"],"skins":[{"unified":"1f35c","native":"🍜","x":6,"y":28}],"version":1},"spaghetti":{"id":"spaghetti","name":"Spaghetti","keywords":["food","italian","pasta","noodle"],"skins":[{"unified":"1f35d","native":"🍝","x":6,"y":29}],"version":1},"sweet_potato":{"id":"sweet_potato","name":"Roasted Sweet Potato","keywords":["food","nature","plant"],"skins":[{"unified":"1f360","native":"🍠","x":6,"y":32}],"version":1},"oden":{"id":"oden","name":"Oden","keywords":["food","japanese"],"skins":[{"unified":"1f362","native":"🍢","x":6,"y":34}],"version":1},"sushi":{"id":"sushi","name":"Sushi","keywords":["food","fish","japanese","rice"],"skins":[{"unified":"1f363","native":"🍣","x":6,"y":35}],"version":1},"fried_shrimp":{"id":"fried_shrimp","name":"Fried Shrimp","keywords":["food","animal","appetizer","summer"],"skins":[{"unified":"1f364","native":"🍤","x":6,"y":36}],"version":1},"fish_cake":{"id":"fish_cake","name":"Fish Cake with Swirl","keywords":["food","japan","sea","beach","narutomaki","pink","kamaboko","surimi","ramen"],"skins":[{"unified":"1f365","native":"🍥","x":6,"y":37}],"version":1},"moon_cake":{"id":"moon_cake","name":"Moon Cake","keywords":["food","autumn","dessert"],"skins":[{"unified":"1f96e","native":"🥮","x":43,"y":58}],"version":11},"dango":{"id":"dango","name":"Dango","keywords":["food","dessert","sweet","japanese","barbecue","meat"],"skins":[{"unified":"1f361","native":"🍡","x":6,"y":33}],"version":1},"dumpling":{"id":"dumpling","name":"Dumpling","keywords":["food","empanada","pierogi","potsticker","gyoza"],"skins":[{"unified":"1f95f","native":"🥟","x":43,"y":43}],"version":5},"fortune_cookie":{"id":"fortune_cookie","name":"Fortune Cookie","keywords":["food","prophecy","dessert"],"skins":[{"unified":"1f960","native":"🥠","x":43,"y":44}],"version":5},"takeout_box":{"id":"takeout_box","name":"Takeout Box","keywords":["food","leftovers"],"skins":[{"unified":"1f961","native":"🥡","x":43,"y":45}],"version":5},"crab":{"id":"crab","name":"Crab","keywords":["animal","crustacean"],"skins":[{"unified":"1f980","native":"🦀","x":44,"y":20}],"version":1},"lobster":{"id":"lobster","name":"Lobster","keywords":["animal","nature","bisque","claws","seafood"],"skins":[{"unified":"1f99e","native":"🦞","x":44,"y":50}],"version":11},"shrimp":{"id":"shrimp","name":"Shrimp","keywords":["animal","ocean","nature","seafood"],"skins":[{"unified":"1f990","native":"🦐","x":44,"y":36}],"version":3},"squid":{"id":"squid","name":"Squid","keywords":["animal","nature","ocean","sea"],"skins":[{"unified":"1f991","native":"🦑","x":44,"y":37}],"version":3},"oyster":{"id":"oyster","name":"Oyster","keywords":["food"],"skins":[{"unified":"1f9aa","native":"🦪","x":45,"y":1}],"version":12},"icecream":{"id":"icecream","name":"Soft Ice Cream","keywords":["icecream","food","hot","dessert","summer"],"skins":[{"unified":"1f366","native":"🍦","x":6,"y":38}],"version":1},"shaved_ice":{"id":"shaved_ice","name":"Shaved Ice","keywords":["hot","dessert","summer"],"skins":[{"unified":"1f367","native":"🍧","x":6,"y":39}],"version":1},"ice_cream":{"id":"ice_cream","name":"Ice Cream","keywords":["food","hot","dessert"],"skins":[{"unified":"1f368","native":"🍨","x":6,"y":40}],"version":1},"doughnut":{"id":"doughnut","name":"Doughnut","keywords":["food","dessert","snack","sweet","donut"],"skins":[{"unified":"1f369","native":"🍩","x":6,"y":41}],"version":1},"cookie":{"id":"cookie","name":"Cookie","keywords":["food","snack","oreo","chocolate","sweet","dessert"],"skins":[{"unified":"1f36a","native":"🍪","x":6,"y":42}],"version":1},"birthday":{"id":"birthday","name":"Birthday Cake","keywords":["food","dessert"],"skins":[{"unified":"1f382","native":"🎂","x":7,"y":5}],"version":1},"cake":{"id":"cake","name":"Shortcake","keywords":["cake","food","dessert"],"skins":[{"unified":"1f370","native":"🍰","x":6,"y":48}],"version":1},"cupcake":{"id":"cupcake","name":"Cupcake","keywords":["food","dessert","bakery","sweet"],"skins":[{"unified":"1f9c1","native":"🧁","x":46,"y":8}],"version":11},"pie":{"id":"pie","name":"Pie","keywords":["food","dessert","pastry"],"skins":[{"unified":"1f967","native":"🥧","x":43,"y":51}],"version":5},"chocolate_bar":{"id":"chocolate_bar","name":"Chocolate Bar","keywords":["food","snack","dessert","sweet"],"skins":[{"unified":"1f36b","native":"🍫","x":6,"y":43}],"version":1},"candy":{"id":"candy","name":"Candy","keywords":["snack","dessert","sweet","lolly"],"skins":[{"unified":"1f36c","native":"🍬","x":6,"y":44}],"version":1},"lollipop":{"id":"lollipop","name":"Lollipop","keywords":["food","snack","candy","sweet"],"skins":[{"unified":"1f36d","native":"🍭","x":6,"y":45}],"version":1},"custard":{"id":"custard","name":"Custard","keywords":["dessert","food"],"skins":[{"unified":"1f36e","native":"🍮","x":6,"y":46}],"version":1},"honey_pot":{"id":"honey_pot","name":"Honey Pot","keywords":["bees","sweet","kitchen"],"skins":[{"unified":"1f36f","native":"🍯","x":6,"y":47}],"version":1},"baby_bottle":{"id":"baby_bottle","name":"Baby Bottle","keywords":["food","container","milk"],"skins":[{"unified":"1f37c","native":"🍼","x":6,"y":60}],"version":1},"glass_of_milk":{"id":"glass_of_milk","name":"Glass of Milk","keywords":["beverage","drink","cow"],"skins":[{"unified":"1f95b","native":"🥛","x":43,"y":39}],"version":3},"coffee":{"id":"coffee","name":"Hot Beverage","keywords":["coffee","caffeine","latte","espresso","mug"],"skins":[{"unified":"2615","native":"☕","x":57,"y":18}],"version":1},"teapot":{"id":"teapot","name":"Teapot","keywords":["drink","hot"],"skins":[{"unified":"1fad6","native":"🫖","x":55,"y":24}],"version":13},"tea":{"id":"tea","name":"Teacup Without Handle","keywords":["tea","drink","bowl","breakfast","green","british"],"skins":[{"unified":"1f375","native":"🍵","x":6,"y":53}],"version":1},"sake":{"id":"sake","name":"Sake","keywords":["wine","drink","drunk","beverage","japanese","alcohol","booze"],"skins":[{"unified":"1f376","native":"🍶","x":6,"y":54}],"version":1},"champagne":{"id":"champagne","name":"Bottle with Popping Cork","keywords":["champagne","drink","wine","celebration"],"skins":[{"unified":"1f37e","native":"🍾","x":7,"y":1}],"version":1},"wine_glass":{"id":"wine_glass","name":"Wine Glass","keywords":["drink","beverage","drunk","alcohol","booze"],"skins":[{"unified":"1f377","native":"🍷","x":6,"y":55}],"version":1},"cocktail":{"id":"cocktail","name":"Cocktail Glass","keywords":["drink","drunk","alcohol","beverage","booze","mojito"],"skins":[{"unified":"1f378","native":"🍸","x":6,"y":56}],"version":1},"tropical_drink":{"id":"tropical_drink","name":"Tropical Drink","keywords":["beverage","cocktail","summer","beach","alcohol","booze","mojito"],"skins":[{"unified":"1f379","native":"🍹","x":6,"y":57}],"version":1},"beer":{"id":"beer","name":"Beer Mug","keywords":["relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37a","native":"🍺","x":6,"y":58}],"version":1},"beers":{"id":"beers","name":"Clinking Beer Mugs","keywords":["beers","relax","beverage","drink","drunk","party","pub","summer","alcohol","booze"],"skins":[{"unified":"1f37b","native":"🍻","x":6,"y":59}],"version":1},"clinking_glasses":{"id":"clinking_glasses","name":"Clinking Glasses","keywords":["beverage","drink","party","alcohol","celebrate","cheers","wine","champagne","toast"],"skins":[{"unified":"1f942","native":"🥂","x":43,"y":15}],"version":3},"tumbler_glass":{"id":"tumbler_glass","name":"Tumbler Glass","keywords":["drink","beverage","drunk","alcohol","liquor","booze","bourbon","scotch","whisky","shot"],"skins":[{"unified":"1f943","native":"🥃","x":43,"y":16}],"version":3},"pouring_liquid":{"id":"pouring_liquid","name":"Pouring Liquid","keywords":["cup","water"],"skins":[{"unified":"1fad7","native":"🫗","x":55,"y":25}],"version":14},"cup_with_straw":{"id":"cup_with_straw","name":"Cup with Straw","keywords":["drink","soda"],"skins":[{"unified":"1f964","native":"🥤","x":43,"y":48}],"version":5},"bubble_tea":{"id":"bubble_tea","name":"Bubble Tea","keywords":["taiwan","boba","milk","straw"],"skins":[{"unified":"1f9cb","native":"🧋","x":46,"y":18}],"version":13},"beverage_box":{"id":"beverage_box","name":"Beverage Box","keywords":["drink"],"skins":[{"unified":"1f9c3","native":"🧃","x":46,"y":10}],"version":12},"mate_drink":{"id":"mate_drink","name":"Mate","keywords":["drink","tea","beverage"],"skins":[{"unified":"1f9c9","native":"🧉","x":46,"y":16}],"version":12},"ice_cube":{"id":"ice_cube","name":"Ice","keywords":["cube","water","cold"],"skins":[{"unified":"1f9ca","native":"🧊","x":46,"y":17}],"version":12},"chopsticks":{"id":"chopsticks","name":"Chopsticks","keywords":["food"],"skins":[{"unified":"1f962","native":"🥢","x":43,"y":46}],"version":5},"knife_fork_plate":{"id":"knife_fork_plate","name":"Fork and Knife with Plate","keywords":["food","eat","meal","lunch","dinner","restaurant"],"skins":[{"unified":"1f37d-fe0f","native":"🍽️","x":7,"y":0}],"version":1},"fork_and_knife":{"id":"fork_and_knife","name":"Fork and Knife","keywords":["cutlery","kitchen"],"skins":[{"unified":"1f374","native":"🍴","x":6,"y":52}],"version":1},"spoon":{"id":"spoon","name":"Spoon","keywords":["cutlery","kitchen","tableware"],"skins":[{"unified":"1f944","native":"🥄","x":43,"y":17}],"version":3},"hocho":{"id":"hocho","name":"Hocho","keywords":["knife","kitchen","blade","cutlery","weapon"],"skins":[{"unified":"1f52a","native":"🔪","x":30,"y":7}],"version":1},"jar":{"id":"jar","name":"Jar","keywords":["container","sauce"],"skins":[{"unified":"1fad9","native":"🫙","x":55,"y":27}],"version":14},"amphora":{"id":"amphora","name":"Amphora","keywords":["vase","jar"],"skins":[{"unified":"1f3fa","native":"🏺","x":10,"y":40}],"version":1},"earth_africa":{"id":"earth_africa","name":"Earth Globe Europe-Africa","keywords":["africa","showing","europe","world","international"],"skins":[{"unified":"1f30d","native":"🌍","x":5,"y":12}],"version":1},"earth_americas":{"id":"earth_americas","name":"Earth Globe Americas","keywords":["showing","world","USA","international"],"skins":[{"unified":"1f30e","native":"🌎","x":5,"y":13}],"version":1},"earth_asia":{"id":"earth_asia","name":"Earth Globe Asia-Australia","keywords":["asia","showing","australia","world","east","international"],"skins":[{"unified":"1f30f","native":"🌏","x":5,"y":14}],"version":1},"globe_with_meridians":{"id":"globe_with_meridians","name":"Globe with Meridians","keywords":["earth","international","world","internet","interweb","i18n"],"skins":[{"unified":"1f310","native":"🌐","x":5,"y":15}],"version":1},"world_map":{"id":"world_map","name":"World Map","keywords":["location","direction"],"skins":[{"unified":"1f5fa-fe0f","native":"🗺️","x":32,"y":15}],"version":1},"japan":{"id":"japan","name":"Map of Japan","keywords":["nation","country","japanese","asia"],"skins":[{"unified":"1f5fe","native":"🗾","x":32,"y":19}],"version":1},"compass":{"id":"compass","name":"Compass","keywords":["magnetic","navigation","orienteering"],"skins":[{"unified":"1f9ed","native":"🧭","x":53,"y":29}],"version":11},"snow_capped_mountain":{"id":"snow_capped_mountain","name":"Snow-Capped Mountain","keywords":["snow","capped","photo","nature","environment","winter","cold"],"skins":[{"unified":"1f3d4-fe0f","native":"🏔️","x":9,"y":60}],"version":1},"mountain":{"id":"mountain","name":"Mountain","keywords":["photo","nature","environment"],"skins":[{"unified":"26f0-fe0f","native":"⛰️","x":58,"y":26}],"version":1},"volcano":{"id":"volcano","name":"Volcano","keywords":["photo","nature","disaster"],"skins":[{"unified":"1f30b","native":"🌋","x":5,"y":10}],"version":1},"mount_fuji":{"id":"mount_fuji","name":"Mount Fuji","keywords":["photo","mountain","nature","japanese"],"skins":[{"unified":"1f5fb","native":"🗻","x":32,"y":16}],"version":1},"camping":{"id":"camping","name":"Camping","keywords":["photo","outdoors","tent"],"skins":[{"unified":"1f3d5-fe0f","native":"🏕️","x":10,"y":0}],"version":1},"beach_with_umbrella":{"id":"beach_with_umbrella","name":"Beach with Umbrella","keywords":["weather","summer","sunny","sand","mojito"],"skins":[{"unified":"1f3d6-fe0f","native":"🏖️","x":10,"y":1}],"version":1},"desert":{"id":"desert","name":"Desert","keywords":["photo","warm","saharah"],"skins":[{"unified":"1f3dc-fe0f","native":"🏜️","x":10,"y":7}],"version":1},"desert_island":{"id":"desert_island","name":"Desert Island","keywords":["photo","tropical","mojito"],"skins":[{"unified":"1f3dd-fe0f","native":"🏝️","x":10,"y":8}],"version":1},"national_park":{"id":"national_park","name":"National Park","keywords":["photo","environment","nature"],"skins":[{"unified":"1f3de-fe0f","native":"🏞️","x":10,"y":9}],"version":1},"stadium":{"id":"stadium","name":"Stadium","keywords":["photo","place","sports","concert","venue"],"skins":[{"unified":"1f3df-fe0f","native":"🏟️","x":10,"y":10}],"version":1},"classical_building":{"id":"classical_building","name":"Classical Building","keywords":["art","culture","history"],"skins":[{"unified":"1f3db-fe0f","native":"🏛️","x":10,"y":6}],"version":1},"building_construction":{"id":"building_construction","name":"Building Construction","keywords":["wip","working","progress"],"skins":[{"unified":"1f3d7-fe0f","native":"🏗️","x":10,"y":2}],"version":1},"bricks":{"id":"bricks","name":"Brick","keywords":["bricks"],"skins":[{"unified":"1f9f1","native":"🧱","x":53,"y":33}],"version":11},"rock":{"id":"rock","name":"Rock","keywords":["stone"],"skins":[{"unified":"1faa8","native":"🪨","x":54,"y":33}],"version":13},"wood":{"id":"wood","name":"Wood","keywords":["nature","timber","trunk"],"skins":[{"unified":"1fab5","native":"🪵","x":54,"y":46}],"version":13},"hut":{"id":"hut","name":"Hut","keywords":["house","structure"],"skins":[{"unified":"1f6d6","native":"🛖","x":38,"y":7}],"version":13},"house_buildings":{"id":"house_buildings","name":"Houses","keywords":["house","buildings","photo"],"skins":[{"unified":"1f3d8-fe0f","native":"🏘️","x":10,"y":3}],"version":1},"derelict_house_building":{"id":"derelict_house_building","name":"Derelict House","keywords":["building","abandon","evict","broken"],"skins":[{"unified":"1f3da-fe0f","native":"🏚️","x":10,"y":5}],"version":1},"house":{"id":"house","name":"House","keywords":["building","home"],"skins":[{"unified":"1f3e0","native":"🏠","x":10,"y":11}],"version":1},"house_with_garden":{"id":"house_with_garden","name":"House with Garden","keywords":["home","plant","nature"],"skins":[{"unified":"1f3e1","native":"🏡","x":10,"y":12}],"version":1},"office":{"id":"office","name":"Office Building","keywords":["bureau","work"],"skins":[{"unified":"1f3e2","native":"🏢","x":10,"y":13}],"version":1},"post_office":{"id":"post_office","name":"Japanese Post Office","keywords":["building","envelope","communication"],"skins":[{"unified":"1f3e3","native":"🏣","x":10,"y":14}],"version":1},"european_post_office":{"id":"european_post_office","name":"Post Office","keywords":["european","building","email"],"skins":[{"unified":"1f3e4","native":"🏤","x":10,"y":15}],"version":1},"hospital":{"id":"hospital","name":"Hospital","keywords":["building","health","surgery","doctor"],"skins":[{"unified":"1f3e5","native":"🏥","x":10,"y":16}],"version":1},"bank":{"id":"bank","name":"Bank","keywords":["building","money","sales","cash","business","enterprise"],"skins":[{"unified":"1f3e6","native":"🏦","x":10,"y":17}],"version":1},"hotel":{"id":"hotel","name":"Hotel","keywords":["building","accomodation","checkin"],"skins":[{"unified":"1f3e8","native":"🏨","x":10,"y":19}],"version":1},"love_hotel":{"id":"love_hotel","name":"Love Hotel","keywords":["like","affection","dating"],"skins":[{"unified":"1f3e9","native":"🏩","x":10,"y":20}],"version":1},"convenience_store":{"id":"convenience_store","name":"Convenience Store","keywords":["building","shopping","groceries"],"skins":[{"unified":"1f3ea","native":"🏪","x":10,"y":21}],"version":1},"school":{"id":"school","name":"School","keywords":["building","student","education","learn","teach"],"skins":[{"unified":"1f3eb","native":"🏫","x":10,"y":22}],"version":1},"department_store":{"id":"department_store","name":"Department Store","keywords":["building","shopping","mall"],"skins":[{"unified":"1f3ec","native":"🏬","x":10,"y":23}],"version":1},"factory":{"id":"factory","name":"Factory","keywords":["building","industry","pollution","smoke"],"skins":[{"unified":"1f3ed","native":"🏭","x":10,"y":24}],"version":1},"japanese_castle":{"id":"japanese_castle","name":"Japanese Castle","keywords":["photo","building"],"skins":[{"unified":"1f3ef","native":"🏯","x":10,"y":26}],"version":1},"european_castle":{"id":"european_castle","name":"Castle","keywords":["european","building","royalty","history"],"skins":[{"unified":"1f3f0","native":"🏰","x":10,"y":27}],"version":1},"wedding":{"id":"wedding","name":"Wedding","keywords":["love","like","affection","couple","marriage","bride","groom"],"skins":[{"unified":"1f492","native":"💒","x":27,"y":34}],"version":1},"tokyo_tower":{"id":"tokyo_tower","name":"Tokyo Tower","keywords":["photo","japanese"],"skins":[{"unified":"1f5fc","native":"🗼","x":32,"y":17}],"version":1},"statue_of_liberty":{"id":"statue_of_liberty","name":"Statue of Liberty","keywords":["american","newyork"],"skins":[{"unified":"1f5fd","native":"🗽","x":32,"y":18}],"version":1},"church":{"id":"church","name":"Church","keywords":["building","religion","christ"],"skins":[{"unified":"26ea","native":"⛪","x":58,"y":25}],"version":1},"mosque":{"id":"mosque","name":"Mosque","keywords":["islam","worship","minaret"],"skins":[{"unified":"1f54c","native":"🕌","x":30,"y":30}],"version":1},"hindu_temple":{"id":"hindu_temple","name":"Hindu Temple","keywords":["religion"],"skins":[{"unified":"1f6d5","native":"🛕","x":38,"y":6}],"version":12},"synagogue":{"id":"synagogue","name":"Synagogue","keywords":["judaism","worship","temple","jewish"],"skins":[{"unified":"1f54d","native":"🕍","x":30,"y":31}],"version":1},"shinto_shrine":{"id":"shinto_shrine","name":"Shinto Shrine","keywords":["temple","japan","kyoto"],"skins":[{"unified":"26e9-fe0f","native":"⛩️","x":58,"y":24}],"version":1},"kaaba":{"id":"kaaba","name":"Kaaba","keywords":["mecca","mosque","islam"],"skins":[{"unified":"1f54b","native":"🕋","x":30,"y":29}],"version":1},"fountain":{"id":"fountain","name":"Fountain","keywords":["photo","summer","water","fresh"],"skins":[{"unified":"26f2","native":"⛲","x":58,"y":28}],"version":1},"tent":{"id":"tent","name":"Tent","keywords":["photo","camping","outdoors"],"skins":[{"unified":"26fa","native":"⛺","x":58,"y":52}],"version":1},"foggy":{"id":"foggy","name":"Foggy","keywords":["photo","mountain"],"skins":[{"unified":"1f301","native":"🌁","x":5,"y":0}],"version":1},"night_with_stars":{"id":"night_with_stars","name":"Night with Stars","keywords":["evening","city","downtown"],"skins":[{"unified":"1f303","native":"🌃","x":5,"y":2}],"version":1},"cityscape":{"id":"cityscape","name":"Cityscape","keywords":["photo","night","life","urban"],"skins":[{"unified":"1f3d9-fe0f","native":"🏙️","x":10,"y":4}],"version":1},"sunrise_over_mountains":{"id":"sunrise_over_mountains","name":"Sunrise over Mountains","keywords":["view","vacation","photo"],"skins":[{"unified":"1f304","native":"🌄","x":5,"y":3}],"version":1},"sunrise":{"id":"sunrise","name":"Sunrise","keywords":["morning","view","vacation","photo"],"skins":[{"unified":"1f305","native":"🌅","x":5,"y":4}],"version":1},"city_sunset":{"id":"city_sunset","name":"Cityscape at Dusk","keywords":["city","sunset","photo","evening","sky","buildings"],"skins":[{"unified":"1f306","native":"🌆","x":5,"y":5}],"version":1},"city_sunrise":{"id":"city_sunrise","name":"Sunset","keywords":["city","sunrise","photo","good","morning","dawn"],"skins":[{"unified":"1f307","native":"🌇","x":5,"y":6}],"version":1},"bridge_at_night":{"id":"bridge_at_night","name":"Bridge at Night","keywords":["photo","sanfrancisco"],"skins":[{"unified":"1f309","native":"🌉","x":5,"y":8}],"version":1},"hotsprings":{"id":"hotsprings","name":"Hot Springs","keywords":["hotsprings","bath","warm","relax"],"skins":[{"unified":"2668-fe0f","native":"♨️","x":57,"y":55}],"version":1},"carousel_horse":{"id":"carousel_horse","name":"Carousel Horse","keywords":["photo","carnival"],"skins":[{"unified":"1f3a0","native":"🎠","x":7,"y":35}],"version":1},"playground_slide":{"id":"playground_slide","name":"Playground Slide","keywords":["fun","park"],"skins":[{"unified":"1f6dd","native":"🛝","x":38,"y":10}],"version":14},"ferris_wheel":{"id":"ferris_wheel","name":"Ferris Wheel","keywords":["photo","carnival","londoneye"],"skins":[{"unified":"1f3a1","native":"🎡","x":7,"y":36}],"version":1},"roller_coaster":{"id":"roller_coaster","name":"Roller Coaster","keywords":["carnival","playground","photo","fun"],"skins":[{"unified":"1f3a2","native":"🎢","x":7,"y":37}],"version":1},"barber":{"id":"barber","name":"Barber Pole","keywords":["hair","salon","style"],"skins":[{"unified":"1f488","native":"💈","x":26,"y":35}],"version":1},"circus_tent":{"id":"circus_tent","name":"Circus Tent","keywords":["festival","carnival","party"],"skins":[{"unified":"1f3aa","native":"🎪","x":7,"y":45}],"version":1},"steam_locomotive":{"id":"steam_locomotive","name":"Locomotive","keywords":["steam","transportation","vehicle","train"],"skins":[{"unified":"1f682","native":"🚂","x":35,"y":35}],"version":1},"railway_car":{"id":"railway_car","name":"Railway Car","keywords":["transportation","vehicle"],"skins":[{"unified":"1f683","native":"🚃","x":35,"y":36}],"version":1},"bullettrain_side":{"id":"bullettrain_side","name":"High-Speed Train","keywords":["bullettrain","side","high","speed","transportation","vehicle"],"skins":[{"unified":"1f684","native":"🚄","x":35,"y":37}],"version":1},"bullettrain_front":{"id":"bullettrain_front","name":"Bullet Train","keywords":["bullettrain","front","transportation","vehicle","speed","fast","public","travel"],"skins":[{"unified":"1f685","native":"🚅","x":35,"y":38}],"version":1},"train2":{"id":"train2","name":"Train","keywords":["train2","transportation","vehicle"],"skins":[{"unified":"1f686","native":"🚆","x":35,"y":39}],"version":1},"metro":{"id":"metro","name":"Metro","keywords":["transportation","blue","square","mrt","underground","tube"],"skins":[{"unified":"1f687","native":"🚇","x":35,"y":40}],"version":1},"light_rail":{"id":"light_rail","name":"Light Rail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f688","native":"🚈","x":35,"y":41}],"version":1},"station":{"id":"station","name":"Station","keywords":["transportation","vehicle","public"],"skins":[{"unified":"1f689","native":"🚉","x":35,"y":42}],"version":1},"tram":{"id":"tram","name":"Tram","keywords":["transportation","vehicle"],"skins":[{"unified":"1f68a","native":"🚊","x":35,"y":43}],"version":1},"monorail":{"id":"monorail","name":"Monorail","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69d","native":"🚝","x":36,"y":1}],"version":1},"mountain_railway":{"id":"mountain_railway","name":"Mountain Railway","keywords":["transportation","vehicle"],"skins":[{"unified":"1f69e","native":"🚞","x":36,"y":2}],"version":1},"train":{"id":"train","name":"Tram Car","keywords":["train","transportation","vehicle","carriage","public","travel"],"skins":[{"unified":"1f68b","native":"🚋","x":35,"y":44}],"version":1},"bus":{"id":"bus","name":"Bus","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f68c","native":"🚌","x":35,"y":45}],"version":1},"oncoming_bus":{"id":"oncoming_bus","name":"Oncoming Bus","keywords":["vehicle","transportation"],"skins":[{"unified":"1f68d","native":"🚍","x":35,"y":46}],"version":1},"trolleybus":{"id":"trolleybus","name":"Trolleybus","keywords":["bart","transportation","vehicle"],"skins":[{"unified":"1f68e","native":"🚎","x":35,"y":47}],"version":1},"minibus":{"id":"minibus","name":"Minibus","keywords":["vehicle","car","transportation"],"skins":[{"unified":"1f690","native":"🚐","x":35,"y":49}],"version":1},"ambulance":{"id":"ambulance","name":"Ambulance","keywords":["health","911","hospital"],"skins":[{"unified":"1f691","native":"🚑","x":35,"y":50}],"version":1},"fire_engine":{"id":"fire_engine","name":"Fire Engine","keywords":["transportation","cars","vehicle"],"skins":[{"unified":"1f692","native":"🚒","x":35,"y":51}],"version":1},"police_car":{"id":"police_car","name":"Police Car","keywords":["vehicle","cars","transportation","law","legal","enforcement"],"skins":[{"unified":"1f693","native":"🚓","x":35,"y":52}],"version":1},"oncoming_police_car":{"id":"oncoming_police_car","name":"Oncoming Police Car","keywords":["vehicle","law","legal","enforcement","911"],"skins":[{"unified":"1f694","native":"🚔","x":35,"y":53}],"version":1},"taxi":{"id":"taxi","name":"Taxi","keywords":["uber","vehicle","cars","transportation"],"skins":[{"unified":"1f695","native":"🚕","x":35,"y":54}],"version":1},"oncoming_taxi":{"id":"oncoming_taxi","name":"Oncoming Taxi","keywords":["vehicle","cars","uber"],"skins":[{"unified":"1f696","native":"🚖","x":35,"y":55}],"version":1},"car":{"id":"car","name":"Automobile","keywords":["car","red","transportation","vehicle"],"skins":[{"unified":"1f697","native":"🚗","x":35,"y":56}],"version":1},"oncoming_automobile":{"id":"oncoming_automobile","name":"Oncoming Automobile","keywords":["car","vehicle","transportation"],"skins":[{"unified":"1f698","native":"🚘","x":35,"y":57}],"version":1},"blue_car":{"id":"blue_car","name":"Recreational Vehicle","keywords":["blue","car","sport","utility","transportation"],"skins":[{"unified":"1f699","native":"🚙","x":35,"y":58}],"version":1},"pickup_truck":{"id":"pickup_truck","name":"Pickup Truck","keywords":["car","transportation"],"skins":[{"unified":"1f6fb","native":"🛻","x":38,"y":31}],"version":13},"truck":{"id":"truck","name":"Delivery Truck","keywords":["cars","transportation"],"skins":[{"unified":"1f69a","native":"🚚","x":35,"y":59}],"version":1},"articulated_lorry":{"id":"articulated_lorry","name":"Articulated Lorry","keywords":["vehicle","cars","transportation","express"],"skins":[{"unified":"1f69b","native":"🚛","x":35,"y":60}],"version":1},"tractor":{"id":"tractor","name":"Tractor","keywords":["vehicle","car","farming","agriculture"],"skins":[{"unified":"1f69c","native":"🚜","x":36,"y":0}],"version":1},"racing_car":{"id":"racing_car","name":"Racing Car","keywords":["sports","race","fast","formula","f1"],"skins":[{"unified":"1f3ce-fe0f","native":"🏎️","x":9,"y":54}],"version":1},"racing_motorcycle":{"id":"racing_motorcycle","name":"Motorcycle","keywords":["racing","race","sports","fast"],"skins":[{"unified":"1f3cd-fe0f","native":"🏍️","x":9,"y":53}],"version":1},"motor_scooter":{"id":"motor_scooter","name":"Motor Scooter","keywords":["vehicle","vespa","sasha"],"skins":[{"unified":"1f6f5","native":"🛵","x":38,"y":25}],"version":3},"manual_wheelchair":{"id":"manual_wheelchair","name":"Manual Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bd","native":"🦽","x":46,"y":4}],"version":12},"motorized_wheelchair":{"id":"motorized_wheelchair","name":"Motorized Wheelchair","keywords":["accessibility"],"skins":[{"unified":"1f9bc","native":"🦼","x":46,"y":3}],"version":12},"auto_rickshaw":{"id":"auto_rickshaw","name":"Auto Rickshaw","keywords":["move","transportation"],"skins":[{"unified":"1f6fa","native":"🛺","x":38,"y":30}],"version":12},"bike":{"id":"bike","name":"Bicycle","keywords":["bike","sports","exercise","hipster"],"skins":[{"unified":"1f6b2","native":"🚲","x":36,"y":39}],"version":1},"scooter":{"id":"scooter","name":"Scooter","keywords":["kick","vehicle","razor"],"skins":[{"unified":"1f6f4","native":"🛴","x":38,"y":24}],"version":3},"skateboard":{"id":"skateboard","name":"Skateboard","keywords":["board"],"skins":[{"unified":"1f6f9","native":"🛹","x":38,"y":29}],"version":11},"roller_skate":{"id":"roller_skate","name":"Roller Skate","keywords":["footwear","sports"],"skins":[{"unified":"1f6fc","native":"🛼","x":38,"y":32}],"version":13},"busstop":{"id":"busstop","name":"Bus Stop","keywords":["busstop","transportation","wait"],"skins":[{"unified":"1f68f","native":"🚏","x":35,"y":48}],"version":1},"motorway":{"id":"motorway","name":"Motorway","keywords":["road","cupertino","interstate","highway"],"skins":[{"unified":"1f6e3-fe0f","native":"🛣️","x":38,"y":16}],"version":1},"railway_track":{"id":"railway_track","name":"Railway Track","keywords":["train","transportation"],"skins":[{"unified":"1f6e4-fe0f","native":"🛤️","x":38,"y":17}],"version":1},"oil_drum":{"id":"oil_drum","name":"Oil Drum","keywords":["barrell"],"skins":[{"unified":"1f6e2-fe0f","native":"🛢️","x":38,"y":15}],"version":1},"fuelpump":{"id":"fuelpump","name":"Fuel Pump","keywords":["fuelpump","gas","station","petroleum"],"skins":[{"unified":"26fd","native":"⛽","x":58,"y":53}],"version":1},"wheel":{"id":"wheel","name":"Wheel","keywords":["car","transport"],"skins":[{"unified":"1f6de","native":"🛞","x":38,"y":11}],"version":14},"rotating_light":{"id":"rotating_light","name":"Police Car Light","keywords":["rotating","ambulance","911","emergency","alert","error","pinged","law","legal"],"skins":[{"unified":"1f6a8","native":"🚨","x":36,"y":29}],"version":1},"traffic_light":{"id":"traffic_light","name":"Horizontal Traffic Light","keywords":["transportation","signal"],"skins":[{"unified":"1f6a5","native":"🚥","x":36,"y":26}],"version":1},"vertical_traffic_light":{"id":"vertical_traffic_light","name":"Vertical Traffic Light","keywords":["transportation","driving"],"skins":[{"unified":"1f6a6","native":"🚦","x":36,"y":27}],"version":1},"octagonal_sign":{"id":"octagonal_sign","name":"Stop Sign","keywords":["octagonal"],"skins":[{"unified":"1f6d1","native":"🛑","x":38,"y":4}],"version":3},"construction":{"id":"construction","name":"Construction","keywords":["wip","progress","caution","warning"],"skins":[{"unified":"1f6a7","native":"🚧","x":36,"y":28}],"version":1},"anchor":{"id":"anchor","name":"Anchor","keywords":["ship","ferry","sea","boat"],"skins":[{"unified":"2693","native":"⚓","x":57,"y":60}],"version":1},"ring_buoy":{"id":"ring_buoy","name":"Ring Buoy","keywords":["life","saver","preserver"],"skins":[{"unified":"1f6df","native":"🛟","x":38,"y":12}],"version":14},"boat":{"id":"boat","name":"Sailboat","keywords":["boat","ship","summer","transportation","water","sailing"],"skins":[{"unified":"26f5","native":"⛵","x":58,"y":31}],"version":1},"canoe":{"id":"canoe","name":"Canoe","keywords":["boat","paddle","water","ship"],"skins":[{"unified":"1f6f6","native":"🛶","x":38,"y":26}],"version":3},"speedboat":{"id":"speedboat","name":"Speedboat","keywords":["ship","transportation","vehicle","summer"],"skins":[{"unified":"1f6a4","native":"🚤","x":36,"y":25}],"version":1},"passenger_ship":{"id":"passenger_ship","name":"Passenger Ship","keywords":["yacht","cruise","ferry"],"skins":[{"unified":"1f6f3-fe0f","native":"🛳️","x":38,"y":23}],"version":1},"ferry":{"id":"ferry","name":"Ferry","keywords":["boat","ship","yacht"],"skins":[{"unified":"26f4-fe0f","native":"⛴️","x":58,"y":30}],"version":1},"motor_boat":{"id":"motor_boat","name":"Motor Boat","keywords":["ship"],"skins":[{"unified":"1f6e5-fe0f","native":"🛥️","x":38,"y":18}],"version":1},"ship":{"id":"ship","name":"Ship","keywords":["transportation","titanic","deploy"],"skins":[{"unified":"1f6a2","native":"🚢","x":36,"y":6}],"version":1},"airplane":{"id":"airplane","name":"Airplane","keywords":["vehicle","transportation","flight","fly"],"skins":[{"unified":"2708-fe0f","native":"✈️","x":58,"y":56}],"version":1},"small_airplane":{"id":"small_airplane","name":"Small Airplane","keywords":["flight","transportation","fly","vehicle"],"skins":[{"unified":"1f6e9-fe0f","native":"🛩️","x":38,"y":19}],"version":1},"airplane_departure":{"id":"airplane_departure","name":"Airplane Departure","keywords":["airport","flight","landing"],"skins":[{"unified":"1f6eb","native":"🛫","x":38,"y":20}],"version":1},"airplane_arriving":{"id":"airplane_arriving","name":"Airplane Arrival","keywords":["arriving","airport","flight","boarding"],"skins":[{"unified":"1f6ec","native":"🛬","x":38,"y":21}],"version":1},"parachute":{"id":"parachute","name":"Parachute","keywords":["fly","glide"],"skins":[{"unified":"1fa82","native":"🪂","x":54,"y":2}],"version":12},"seat":{"id":"seat","name":"Seat","keywords":["sit","airplane","transport","bus","flight","fly"],"skins":[{"unified":"1f4ba","native":"💺","x":28,"y":18}],"version":1},"helicopter":{"id":"helicopter","name":"Helicopter","keywords":["transportation","vehicle","fly"],"skins":[{"unified":"1f681","native":"🚁","x":35,"y":34}],"version":1},"suspension_railway":{"id":"suspension_railway","name":"Suspension Railway","keywords":["vehicle","transportation"],"skins":[{"unified":"1f69f","native":"🚟","x":36,"y":3}],"version":1},"mountain_cableway":{"id":"mountain_cableway","name":"Mountain Cableway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a0","native":"🚠","x":36,"y":4}],"version":1},"aerial_tramway":{"id":"aerial_tramway","name":"Aerial Tramway","keywords":["transportation","vehicle","ski"],"skins":[{"unified":"1f6a1","native":"🚡","x":36,"y":5}],"version":1},"satellite":{"id":"satellite","name":"Satellite","keywords":["communication","gps","orbit","spaceflight","NASA","ISS"],"skins":[{"unified":"1f6f0-fe0f","native":"🛰️","x":38,"y":22}],"version":1},"rocket":{"id":"rocket","name":"Rocket","keywords":["launch","ship","staffmode","NASA","outer","space","fly"],"skins":[{"unified":"1f680","native":"🚀","x":35,"y":33}],"version":1},"flying_saucer":{"id":"flying_saucer","name":"Flying Saucer","keywords":["transportation","vehicle","ufo"],"skins":[{"unified":"1f6f8","native":"🛸","x":38,"y":28}],"version":5},"bellhop_bell":{"id":"bellhop_bell","name":"Bellhop Bell","keywords":["service"],"skins":[{"unified":"1f6ce-fe0f","native":"🛎️","x":38,"y":1}],"version":1},"luggage":{"id":"luggage","name":"Luggage","keywords":["packing","travel"],"skins":[{"unified":"1f9f3","native":"🧳","x":53,"y":35}],"version":11},"hourglass":{"id":"hourglass","name":"Hourglass","keywords":["done","time","clock","oldschool","limit","exam","quiz","test"],"skins":[{"unified":"231b","native":"⌛","x":56,"y":45}],"version":1},"hourglass_flowing_sand":{"id":"hourglass_flowing_sand","name":"Hourglass Not Done","keywords":["flowing","sand","oldschool","time","countdown"],"skins":[{"unified":"23f3","native":"⏳","x":56,"y":58}],"version":1},"watch":{"id":"watch","name":"Watch","keywords":["time","accessories"],"skins":[{"unified":"231a","native":"⌚","x":56,"y":44}],"version":1},"alarm_clock":{"id":"alarm_clock","name":"Alarm Clock","keywords":["time","wake"],"skins":[{"unified":"23f0","native":"⏰","x":56,"y":55}],"version":1},"stopwatch":{"id":"stopwatch","name":"Stopwatch","keywords":["time","deadline"],"skins":[{"unified":"23f1-fe0f","native":"⏱️","x":56,"y":56}],"version":1},"timer_clock":{"id":"timer_clock","name":"Timer Clock","keywords":["alarm"],"skins":[{"unified":"23f2-fe0f","native":"⏲️","x":56,"y":57}],"version":1},"mantelpiece_clock":{"id":"mantelpiece_clock","name":"Mantelpiece Clock","keywords":["time"],"skins":[{"unified":"1f570-fe0f","native":"🕰️","x":30,"y":58}],"version":1},"clock12":{"id":"clock12","name":"Twelve O’clock","keywords":["clock12","o","clock","12","00:00","0000","12:00","1200","time","noon","midnight","midday","late","early","schedule"],"skins":[{"unified":"1f55b","native":"🕛","x":30,"y":44}],"version":1},"clock1230":{"id":"clock1230","name":"Twelve-Thirty","keywords":["clock1230","twelve","thirty","00:30","0030","12:30","1230","time","late","early","schedule"],"skins":[{"unified":"1f567","native":"🕧","x":30,"y":56}],"version":1},"clock1":{"id":"clock1","name":"One O’clock","keywords":["clock1","o","clock","1","1:00","100","13:00","1300","time","late","early","schedule"],"skins":[{"unified":"1f550","native":"🕐","x":30,"y":33}],"version":1},"clock130":{"id":"clock130","name":"One-Thirty","keywords":["clock130","one","thirty","1:30","130","13:30","1330","time","late","early","schedule"],"skins":[{"unified":"1f55c","native":"🕜","x":30,"y":45}],"version":1},"clock2":{"id":"clock2","name":"Two O’clock","keywords":["clock2","o","clock","2","2:00","200","14:00","1400","time","late","early","schedule"],"skins":[{"unified":"1f551","native":"🕑","x":30,"y":34}],"version":1},"clock230":{"id":"clock230","name":"Two-Thirty","keywords":["clock230","two","thirty","2:30","230","14:30","1430","time","late","early","schedule"],"skins":[{"unified":"1f55d","native":"🕝","x":30,"y":46}],"version":1},"clock3":{"id":"clock3","name":"Three O’clock","keywords":["clock3","o","clock","3","3:00","300","15:00","1500","time","late","early","schedule"],"skins":[{"unified":"1f552","native":"🕒","x":30,"y":35}],"version":1},"clock330":{"id":"clock330","name":"Three-Thirty","keywords":["clock330","three","thirty","3:30","330","15:30","1530","time","late","early","schedule"],"skins":[{"unified":"1f55e","native":"🕞","x":30,"y":47}],"version":1},"clock4":{"id":"clock4","name":"Four O’clock","keywords":["clock4","o","clock","4","4:00","400","16:00","1600","time","late","early","schedule"],"skins":[{"unified":"1f553","native":"🕓","x":30,"y":36}],"version":1},"clock430":{"id":"clock430","name":"Four-Thirty","keywords":["clock430","four","thirty","4:30","430","16:30","1630","time","late","early","schedule"],"skins":[{"unified":"1f55f","native":"🕟","x":30,"y":48}],"version":1},"clock5":{"id":"clock5","name":"Five O’clock","keywords":["clock5","o","clock","5","5:00","500","17:00","1700","time","late","early","schedule"],"skins":[{"unified":"1f554","native":"🕔","x":30,"y":37}],"version":1},"clock530":{"id":"clock530","name":"Five-Thirty","keywords":["clock530","five","thirty","5:30","530","17:30","1730","time","late","early","schedule"],"skins":[{"unified":"1f560","native":"🕠","x":30,"y":49}],"version":1},"clock6":{"id":"clock6","name":"Six O’clock","keywords":["clock6","o","clock","6","6:00","600","18:00","1800","time","late","early","schedule","dawn","dusk"],"skins":[{"unified":"1f555","native":"🕕","x":30,"y":38}],"version":1},"clock630":{"id":"clock630","name":"Six-Thirty","keywords":["clock630","six","thirty","6:30","630","18:30","1830","time","late","early","schedule"],"skins":[{"unified":"1f561","native":"🕡","x":30,"y":50}],"version":1},"clock7":{"id":"clock7","name":"Seven O’clock","keywords":["clock7","o","clock","7","7:00","700","19:00","1900","time","late","early","schedule"],"skins":[{"unified":"1f556","native":"🕖","x":30,"y":39}],"version":1},"clock730":{"id":"clock730","name":"Seven-Thirty","keywords":["clock730","seven","thirty","7:30","730","19:30","1930","time","late","early","schedule"],"skins":[{"unified":"1f562","native":"🕢","x":30,"y":51}],"version":1},"clock8":{"id":"clock8","name":"Eight O’clock","keywords":["clock8","o","clock","8","8:00","800","20:00","2000","time","late","early","schedule"],"skins":[{"unified":"1f557","native":"🕗","x":30,"y":40}],"version":1},"clock830":{"id":"clock830","name":"Eight-Thirty","keywords":["clock830","eight","thirty","8:30","830","20:30","2030","time","late","early","schedule"],"skins":[{"unified":"1f563","native":"🕣","x":30,"y":52}],"version":1},"clock9":{"id":"clock9","name":"Nine O’clock","keywords":["clock9","o","clock","9","9:00","900","21:00","2100","time","late","early","schedule"],"skins":[{"unified":"1f558","native":"🕘","x":30,"y":41}],"version":1},"clock930":{"id":"clock930","name":"Nine-Thirty","keywords":["clock930","nine","thirty","9:30","930","21:30","2130","time","late","early","schedule"],"skins":[{"unified":"1f564","native":"🕤","x":30,"y":53}],"version":1},"clock10":{"id":"clock10","name":"Ten O’clock","keywords":["clock10","o","clock","10","10:00","1000","22:00","2200","time","late","early","schedule"],"skins":[{"unified":"1f559","native":"🕙","x":30,"y":42}],"version":1},"clock1030":{"id":"clock1030","name":"Ten-Thirty","keywords":["clock1030","ten","thirty","10:30","1030","22:30","2230","time","late","early","schedule"],"skins":[{"unified":"1f565","native":"🕥","x":30,"y":54}],"version":1},"clock11":{"id":"clock11","name":"Eleven O’clock","keywords":["clock11","o","clock","11","11:00","1100","23:00","2300","time","late","early","schedule"],"skins":[{"unified":"1f55a","native":"🕚","x":30,"y":43}],"version":1},"clock1130":{"id":"clock1130","name":"Eleven-Thirty","keywords":["clock1130","eleven","thirty","11:30","1130","23:30","2330","time","late","early","schedule"],"skins":[{"unified":"1f566","native":"🕦","x":30,"y":55}],"version":1},"new_moon":{"id":"new_moon","name":"New Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f311","native":"🌑","x":5,"y":16}],"version":1},"waxing_crescent_moon":{"id":"waxing_crescent_moon","name":"Waxing Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f312","native":"🌒","x":5,"y":17}],"version":1},"first_quarter_moon":{"id":"first_quarter_moon","name":"First Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f313","native":"🌓","x":5,"y":18}],"version":1},"moon":{"id":"moon","name":"Waxing Gibbous Moon","keywords":["nature","night","sky","gray","twilight","planet","space","evening","sleep"],"skins":[{"unified":"1f314","native":"🌔","x":5,"y":19}],"version":1},"full_moon":{"id":"full_moon","name":"Full Moon","keywords":["nature","yellow","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f315","native":"🌕","x":5,"y":20}],"version":1},"waning_gibbous_moon":{"id":"waning_gibbous_moon","name":"Waning Gibbous Moon","keywords":["nature","twilight","planet","space","night","evening","sleep","waxing"],"skins":[{"unified":"1f316","native":"🌖","x":5,"y":21}],"version":1},"last_quarter_moon":{"id":"last_quarter_moon","name":"Last Quarter Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f317","native":"🌗","x":5,"y":22}],"version":1},"waning_crescent_moon":{"id":"waning_crescent_moon","name":"Waning Crescent Moon","keywords":["nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f318","native":"🌘","x":5,"y":23}],"version":1},"crescent_moon":{"id":"crescent_moon","name":"Crescent Moon","keywords":["night","sleep","sky","evening","magic"],"skins":[{"unified":"1f319","native":"🌙","x":5,"y":24}],"version":1},"new_moon_with_face":{"id":"new_moon_with_face","name":"New Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31a","native":"🌚","x":5,"y":25}],"version":1},"first_quarter_moon_with_face":{"id":"first_quarter_moon_with_face","name":"First Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31b","native":"🌛","x":5,"y":26}],"version":1},"last_quarter_moon_with_face":{"id":"last_quarter_moon_with_face","name":"Last Quarter Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31c","native":"🌜","x":5,"y":27}],"version":1},"thermometer":{"id":"thermometer","name":"Thermometer","keywords":["weather","temperature","hot","cold"],"skins":[{"unified":"1f321-fe0f","native":"🌡️","x":5,"y":32}],"version":1},"sunny":{"id":"sunny","name":"Sun","keywords":["sunny","weather","nature","brightness","summer","beach","spring"],"skins":[{"unified":"2600-fe0f","native":"☀️","x":57,"y":10}],"version":1},"full_moon_with_face":{"id":"full_moon_with_face","name":"Full Moon Face","keywords":["with","nature","twilight","planet","space","night","evening","sleep"],"skins":[{"unified":"1f31d","native":"🌝","x":5,"y":28}],"version":1},"sun_with_face":{"id":"sun_with_face","name":"Sun with Face","keywords":["nature","morning","sky"],"skins":[{"unified":"1f31e","native":"🌞","x":5,"y":29}],"version":1},"ringed_planet":{"id":"ringed_planet","name":"Ringed Planet","keywords":["outerspace"],"skins":[{"unified":"1fa90","native":"🪐","x":54,"y":9}],"version":12},"star":{"id":"star","name":"Star","keywords":["night","yellow"],"skins":[{"unified":"2b50","native":"⭐","x":59,"y":55}],"version":1},"star2":{"id":"star2","name":"Glowing Star","keywords":["star2","night","sparkle","awesome","good","magic"],"skins":[{"unified":"1f31f","native":"🌟","x":5,"y":30}],"version":1},"stars":{"id":"stars","name":"Shooting Star","keywords":["stars","night","photo"],"skins":[{"unified":"1f320","native":"🌠","x":5,"y":31}],"version":1},"milky_way":{"id":"milky_way","name":"Milky Way","keywords":["photo","space","stars"],"skins":[{"unified":"1f30c","native":"🌌","x":5,"y":11}],"version":1},"cloud":{"id":"cloud","name":"Cloud","keywords":["weather","sky"],"skins":[{"unified":"2601-fe0f","native":"☁️","x":57,"y":11}],"version":1},"partly_sunny":{"id":"partly_sunny","name":"Sun Behind Cloud","keywords":["partly","sunny","weather","nature","cloudy","morning","fall","spring"],"skins":[{"unified":"26c5","native":"⛅","x":58,"y":17}],"version":1},"thunder_cloud_and_rain":{"id":"thunder_cloud_and_rain","name":"Cloud with Lightning and Rain","keywords":["thunder","weather"],"skins":[{"unified":"26c8-fe0f","native":"⛈️","x":58,"y":18}],"version":1},"mostly_sunny":{"id":"mostly_sunny","name":"Sun Behind Small Cloud","keywords":["mostly","sunny","weather"],"skins":[{"unified":"1f324-fe0f","native":"🌤️","x":5,"y":33}],"version":1},"barely_sunny":{"id":"barely_sunny","name":"Sun Behind Large Cloud","keywords":["barely","sunny","weather"],"skins":[{"unified":"1f325-fe0f","native":"🌥️","x":5,"y":34}],"version":1},"partly_sunny_rain":{"id":"partly_sunny_rain","name":"Sun Behind Rain Cloud","keywords":["partly","sunny","weather"],"skins":[{"unified":"1f326-fe0f","native":"🌦️","x":5,"y":35}],"version":1},"rain_cloud":{"id":"rain_cloud","name":"Cloud with Rain","keywords":["weather"],"skins":[{"unified":"1f327-fe0f","native":"🌧️","x":5,"y":36}],"version":1},"snow_cloud":{"id":"snow_cloud","name":"Cloud with Snow","keywords":["weather"],"skins":[{"unified":"1f328-fe0f","native":"🌨️","x":5,"y":37}],"version":1},"lightning":{"id":"lightning","name":"Cloud with Lightning","keywords":["weather","thunder"],"skins":[{"unified":"1f329-fe0f","native":"🌩️","x":5,"y":38}],"version":1},"tornado":{"id":"tornado","name":"Tornado","keywords":["cloud","weather","cyclone","twister"],"skins":[{"unified":"1f32a-fe0f","native":"🌪️","x":5,"y":39}],"version":1},"fog":{"id":"fog","name":"Fog","keywords":["weather"],"skins":[{"unified":"1f32b-fe0f","native":"🌫️","x":5,"y":40}],"version":1},"wind_blowing_face":{"id":"wind_blowing_face","name":"Wind Face","keywords":["blowing","gust","air"],"skins":[{"unified":"1f32c-fe0f","native":"🌬️","x":5,"y":41}],"version":1},"cyclone":{"id":"cyclone","name":"Cyclone","keywords":["weather","swirl","blue","cloud","vortex","spiral","whirlpool","spin","tornado","hurricane","typhoon"],"skins":[{"unified":"1f300","native":"🌀","x":4,"y":60}],"version":1},"rainbow":{"id":"rainbow","name":"Rainbow","keywords":["nature","happy","unicorn","face","photo","sky","spring"],"skins":[{"unified":"1f308","native":"🌈","x":5,"y":7}],"version":1},"closed_umbrella":{"id":"closed_umbrella","name":"Closed Umbrella","keywords":["weather","rain","drizzle"],"skins":[{"unified":"1f302","native":"🌂","x":5,"y":1}],"version":1},"umbrella":{"id":"umbrella","name":"Umbrella","keywords":["weather","spring"],"skins":[{"unified":"2602-fe0f","native":"☂️","x":57,"y":12}],"version":1},"umbrella_with_rain_drops":{"id":"umbrella_with_rain_drops","name":"Umbrella with Rain Drops","keywords":["rainy","weather","spring"],"skins":[{"unified":"2614","native":"☔","x":57,"y":17}],"version":1},"umbrella_on_ground":{"id":"umbrella_on_ground","name":"Umbrella on Ground","keywords":["weather","summer"],"skins":[{"unified":"26f1-fe0f","native":"⛱️","x":58,"y":27}],"version":1},"zap":{"id":"zap","name":"High Voltage","keywords":["zap","thunder","weather","lightning","bolt","fast"],"skins":[{"unified":"26a1","native":"⚡","x":58,"y":8}],"version":1},"snowflake":{"id":"snowflake","name":"Snowflake","keywords":["winter","season","cold","weather","christmas","xmas"],"skins":[{"unified":"2744-fe0f","native":"❄️","x":59,"y":30}],"version":1},"snowman":{"id":"snowman","name":"Snowman","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"2603-fe0f","native":"☃️","x":57,"y":13}],"version":1},"snowman_without_snow":{"id":"snowman_without_snow","name":"Snowman Without Snow","keywords":["winter","season","cold","weather","christmas","xmas","frozen"],"skins":[{"unified":"26c4","native":"⛄","x":58,"y":16}],"version":1},"comet":{"id":"comet","name":"Comet","keywords":["space"],"skins":[{"unified":"2604-fe0f","native":"☄️","x":57,"y":14}],"version":1},"fire":{"id":"fire","name":"Fire","keywords":["hot","cook","flame"],"skins":[{"unified":"1f525","native":"🔥","x":30,"y":2}],"version":1},"droplet":{"id":"droplet","name":"Droplet","keywords":["water","drip","faucet","spring"],"skins":[{"unified":"1f4a7","native":"💧","x":27,"y":55}],"version":1},"ocean":{"id":"ocean","name":"Water Wave","keywords":["ocean","sea","nature","tsunami","disaster"],"skins":[{"unified":"1f30a","native":"🌊","x":5,"y":9}],"version":1},"jack_o_lantern":{"id":"jack_o_lantern","name":"Jack-O-Lantern","keywords":["jack","o","lantern","halloween","light","pumpkin","creepy","fall"],"skins":[{"unified":"1f383","native":"🎃","x":7,"y":6}],"version":1},"christmas_tree":{"id":"christmas_tree","name":"Christmas Tree","keywords":["festival","vacation","december","xmas","celebration"],"skins":[{"unified":"1f384","native":"🎄","x":7,"y":7}],"version":1},"fireworks":{"id":"fireworks","name":"Fireworks","keywords":["photo","festival","carnival","congratulations"],"skins":[{"unified":"1f386","native":"🎆","x":7,"y":14}],"version":1},"sparkler":{"id":"sparkler","name":"Sparkler","keywords":["stars","night","shine"],"skins":[{"unified":"1f387","native":"🎇","x":7,"y":15}],"version":1},"firecracker":{"id":"firecracker","name":"Firecracker","keywords":["dynamite","boom","explode","explosion","explosive"],"skins":[{"unified":"1f9e8","native":"🧨","x":53,"y":24}],"version":11},"sparkles":{"id":"sparkles","name":"Sparkles","keywords":["stars","shine","shiny","cool","awesome","good","magic"],"skins":[{"unified":"2728","native":"✨","x":59,"y":27}],"version":1},"balloon":{"id":"balloon","name":"Balloon","keywords":["party","celebration","birthday","circus"],"skins":[{"unified":"1f388","native":"🎈","x":7,"y":16}],"version":1},"tada":{"id":"tada","name":"Party Popper","keywords":["tada","congratulations","birthday","magic","circus","celebration"],"skins":[{"unified":"1f389","native":"🎉","x":7,"y":17}],"version":1},"confetti_ball":{"id":"confetti_ball","name":"Confetti Ball","keywords":["festival","party","birthday","circus"],"skins":[{"unified":"1f38a","native":"🎊","x":7,"y":18}],"version":1},"tanabata_tree":{"id":"tanabata_tree","name":"Tanabata Tree","keywords":["plant","nature","branch","summer","bamboo","wish","star","festival","tanzaku"],"skins":[{"unified":"1f38b","native":"🎋","x":7,"y":19}],"version":1},"bamboo":{"id":"bamboo","name":"Pine Decoration","keywords":["bamboo","japanese","plant","nature","vegetable","panda","new","years"],"skins":[{"unified":"1f38d","native":"🎍","x":7,"y":21}],"version":1},"dolls":{"id":"dolls","name":"Japanese Dolls","keywords":["toy","kimono"],"skins":[{"unified":"1f38e","native":"🎎","x":7,"y":22}],"version":1},"flags":{"id":"flags","name":"Carp Streamer","keywords":["flags","fish","japanese","koinobori","banner"],"skins":[{"unified":"1f38f","native":"🎏","x":7,"y":23}],"version":1},"wind_chime":{"id":"wind_chime","name":"Wind Chime","keywords":["nature","ding","spring","bell"],"skins":[{"unified":"1f390","native":"🎐","x":7,"y":24}],"version":1},"rice_scene":{"id":"rice_scene","name":"Moon Viewing Ceremony","keywords":["rice","scene","photo","japan","asia","tsukimi"],"skins":[{"unified":"1f391","native":"🎑","x":7,"y":25}],"version":1},"red_envelope":{"id":"red_envelope","name":"Red Envelope","keywords":["gift"],"skins":[{"unified":"1f9e7","native":"🧧","x":53,"y":23}],"version":11},"ribbon":{"id":"ribbon","name":"Ribbon","keywords":["decoration","pink","girl","bowtie"],"skins":[{"unified":"1f380","native":"🎀","x":7,"y":3}],"version":1},"gift":{"id":"gift","name":"Wrapped Gift","keywords":["present","birthday","christmas","xmas"],"skins":[{"unified":"1f381","native":"🎁","x":7,"y":4}],"version":1},"reminder_ribbon":{"id":"reminder_ribbon","name":"Reminder Ribbon","keywords":["sports","cause","support","awareness"],"skins":[{"unified":"1f397-fe0f","native":"🎗️","x":7,"y":29}],"version":1},"admission_tickets":{"id":"admission_tickets","name":"Admission Tickets","keywords":["sports","concert","entrance"],"skins":[{"unified":"1f39f-fe0f","native":"🎟️","x":7,"y":34}],"version":1},"ticket":{"id":"ticket","name":"Ticket","keywords":["event","concert","pass"],"skins":[{"unified":"1f3ab","native":"🎫","x":7,"y":46}],"version":1},"medal":{"id":"medal","name":"Military Medal","keywords":["award","winning","army"],"skins":[{"unified":"1f396-fe0f","native":"🎖️","x":7,"y":28}],"version":1},"trophy":{"id":"trophy","name":"Trophy","keywords":["win","award","contest","place","ftw","ceremony"],"skins":[{"unified":"1f3c6","native":"🏆","x":8,"y":51}],"version":1},"sports_medal":{"id":"sports_medal","name":"Sports Medal","keywords":["award","winning"],"skins":[{"unified":"1f3c5","native":"🏅","x":8,"y":50}],"version":1},"first_place_medal":{"id":"first_place_medal","name":"1st Place Medal","keywords":["first","award","winning"],"skins":[{"unified":"1f947","native":"🥇","x":43,"y":19}],"version":3},"second_place_medal":{"id":"second_place_medal","name":"2nd Place Medal","keywords":["second","award"],"skins":[{"unified":"1f948","native":"🥈","x":43,"y":20}],"version":3},"third_place_medal":{"id":"third_place_medal","name":"3rd Place Medal","keywords":["third","award"],"skins":[{"unified":"1f949","native":"🥉","x":43,"y":21}],"version":3},"soccer":{"id":"soccer","name":"Soccer Ball","keywords":["sports","football"],"skins":[{"unified":"26bd","native":"⚽","x":58,"y":14}],"version":1},"baseball":{"id":"baseball","name":"Baseball","keywords":["sports","balls"],"skins":[{"unified":"26be","native":"⚾","x":58,"y":15}],"version":1},"softball":{"id":"softball","name":"Softball","keywords":["sports","balls"],"skins":[{"unified":"1f94e","native":"🥎","x":43,"y":26}],"version":11},"basketball":{"id":"basketball","name":"Basketball","keywords":["sports","balls","NBA"],"skins":[{"unified":"1f3c0","native":"🏀","x":8,"y":6}],"version":1},"volleyball":{"id":"volleyball","name":"Volleyball","keywords":["sports","balls"],"skins":[{"unified":"1f3d0","native":"🏐","x":9,"y":56}],"version":1},"football":{"id":"football","name":"American Football","keywords":["sports","balls","NFL"],"skins":[{"unified":"1f3c8","native":"🏈","x":8,"y":58}],"version":1},"rugby_football":{"id":"rugby_football","name":"Rugby Football","keywords":["sports","team"],"skins":[{"unified":"1f3c9","native":"🏉","x":8,"y":59}],"version":1},"tennis":{"id":"tennis","name":"Tennis","keywords":["sports","balls","green"],"skins":[{"unified":"1f3be","native":"🎾","x":8,"y":4}],"version":1},"flying_disc":{"id":"flying_disc","name":"Flying Disc","keywords":["sports","frisbee","ultimate"],"skins":[{"unified":"1f94f","native":"🥏","x":43,"y":27}],"version":11},"bowling":{"id":"bowling","name":"Bowling","keywords":["sports","fun","play"],"skins":[{"unified":"1f3b3","native":"🎳","x":7,"y":54}],"version":1},"cricket_bat_and_ball":{"id":"cricket_bat_and_ball","name":"Cricket Game","keywords":["bat","and","ball","sports"],"skins":[{"unified":"1f3cf","native":"🏏","x":9,"y":55}],"version":1},"field_hockey_stick_and_ball":{"id":"field_hockey_stick_and_ball","name":"Field Hockey","keywords":["stick","and","ball","sports"],"skins":[{"unified":"1f3d1","native":"🏑","x":9,"y":57}],"version":1},"ice_hockey_stick_and_puck":{"id":"ice_hockey_stick_and_puck","name":"Ice Hockey","keywords":["stick","and","puck","sports"],"skins":[{"unified":"1f3d2","native":"🏒","x":9,"y":58}],"version":1},"lacrosse":{"id":"lacrosse","name":"Lacrosse","keywords":["sports","ball","stick"],"skins":[{"unified":"1f94d","native":"🥍","x":43,"y":25}],"version":11},"table_tennis_paddle_and_ball":{"id":"table_tennis_paddle_and_ball","name":"Ping Pong","keywords":["table","tennis","paddle","and","ball","sports","pingpong"],"skins":[{"unified":"1f3d3","native":"🏓","x":9,"y":59}],"version":1},"badminton_racquet_and_shuttlecock":{"id":"badminton_racquet_and_shuttlecock","name":"Badminton","keywords":["racquet","and","shuttlecock","sports"],"skins":[{"unified":"1f3f8","native":"🏸","x":10,"y":38}],"version":1},"boxing_glove":{"id":"boxing_glove","name":"Boxing Glove","keywords":["sports","fighting"],"skins":[{"unified":"1f94a","native":"🥊","x":43,"y":22}],"version":3},"martial_arts_uniform":{"id":"martial_arts_uniform","name":"Martial Arts Uniform","keywords":["judo","karate","taekwondo"],"skins":[{"unified":"1f94b","native":"🥋","x":43,"y":23}],"version":3},"goal_net":{"id":"goal_net","name":"Goal Net","keywords":["sports"],"skins":[{"unified":"1f945","native":"🥅","x":43,"y":18}],"version":3},"golf":{"id":"golf","name":"Flag in Hole","keywords":["golf","sports","business","summer"],"skins":[{"unified":"26f3","native":"⛳","x":58,"y":29}],"version":1},"ice_skate":{"id":"ice_skate","name":"Ice Skate","keywords":["sports"],"skins":[{"unified":"26f8-fe0f","native":"⛸️","x":58,"y":33}],"version":1},"fishing_pole_and_fish":{"id":"fishing_pole_and_fish","name":"Fishing Pole","keywords":["and","fish","food","hobby","summer"],"skins":[{"unified":"1f3a3","native":"🎣","x":7,"y":38}],"version":1},"diving_mask":{"id":"diving_mask","name":"Diving Mask","keywords":["sport","ocean"],"skins":[{"unified":"1f93f","native":"🤿","x":43,"y":12}],"version":12},"running_shirt_with_sash":{"id":"running_shirt_with_sash","name":"Running Shirt","keywords":["with","sash","play","pageant"],"skins":[{"unified":"1f3bd","native":"🎽","x":8,"y":3}],"version":1},"ski":{"id":"ski","name":"Skis","keywords":["ski","sports","winter","cold","snow"],"skins":[{"unified":"1f3bf","native":"🎿","x":8,"y":5}],"version":1},"sled":{"id":"sled","name":"Sled","keywords":["sleigh","luge","toboggan"],"skins":[{"unified":"1f6f7","native":"🛷","x":38,"y":27}],"version":5},"curling_stone":{"id":"curling_stone","name":"Curling Stone","keywords":["sports"],"skins":[{"unified":"1f94c","native":"🥌","x":43,"y":24}],"version":5},"dart":{"id":"dart","name":"Bullseye","keywords":["dart","direct","hit","game","play","bar","target"],"skins":[{"unified":"1f3af","native":"🎯","x":7,"y":50}],"version":1},"yo-yo":{"id":"yo-yo","name":"Yo-Yo","keywords":["yo","toy"],"skins":[{"unified":"1fa80","native":"🪀","x":54,"y":0}],"version":12},"kite":{"id":"kite","name":"Kite","keywords":["wind","fly"],"skins":[{"unified":"1fa81","native":"🪁","x":54,"y":1}],"version":12},"gun":{"id":"gun","name":"Pistol","keywords":["gun","violence","weapon","revolver"],"skins":[{"unified":"1f52b","native":"🔫","x":30,"y":8}],"version":1},"8ball":{"id":"8ball","name":"Billiards","keywords":["8ball","pool","8","ball","hobby","game","luck","magic"],"skins":[{"unified":"1f3b1","native":"🎱","x":7,"y":52}],"version":1},"crystal_ball":{"id":"crystal_ball","name":"Crystal Ball","keywords":["disco","party","magic","circus","fortune","teller"],"skins":[{"unified":"1f52e","native":"🔮","x":30,"y":11}],"version":1},"magic_wand":{"id":"magic_wand","name":"Magic Wand","keywords":["supernature","power"],"skins":[{"unified":"1fa84","native":"🪄","x":54,"y":4}],"version":13},"video_game":{"id":"video_game","name":"Video Game","keywords":["play","console","PS4","controller"],"skins":[{"unified":"1f3ae","native":"🎮","x":7,"y":49}],"version":1},"joystick":{"id":"joystick","name":"Joystick","keywords":["game","play"],"skins":[{"unified":"1f579-fe0f","native":"🕹️","x":31,"y":26}],"version":1},"slot_machine":{"id":"slot_machine","name":"Slot Machine","keywords":["bet","gamble","vegas","fruit","luck","casino"],"skins":[{"unified":"1f3b0","native":"🎰","x":7,"y":51}],"version":1},"game_die":{"id":"game_die","name":"Game Die","keywords":["dice","random","tabletop","play","luck"],"skins":[{"unified":"1f3b2","native":"🎲","x":7,"y":53}],"version":1},"jigsaw":{"id":"jigsaw","name":"Puzzle Piece","keywords":["jigsaw","interlocking"],"skins":[{"unified":"1f9e9","native":"🧩","x":53,"y":25}],"version":11},"teddy_bear":{"id":"teddy_bear","name":"Teddy Bear","keywords":["plush","stuffed"],"skins":[{"unified":"1f9f8","native":"🧸","x":53,"y":40}],"version":11},"pinata":{"id":"pinata","name":"Pinata","keywords":["mexico","candy","celebration"],"skins":[{"unified":"1fa85","native":"🪅","x":54,"y":5}],"version":13},"mirror_ball":{"id":"mirror_ball","name":"Mirror Ball","keywords":["disco","dance","party"],"skins":[{"unified":"1faa9","native":"🪩","x":54,"y":34}],"version":14},"nesting_dolls":{"id":"nesting_dolls","name":"Nesting Dolls","keywords":["matryoshka","toy"],"skins":[{"unified":"1fa86","native":"🪆","x":54,"y":6}],"version":13},"spades":{"id":"spades","name":"Spade Suit","keywords":["spades","poker","cards","suits","magic"],"skins":[{"unified":"2660-fe0f","native":"♠️","x":57,"y":51}],"version":1},"hearts":{"id":"hearts","name":"Heart Suit","keywords":["hearts","poker","cards","magic","suits"],"skins":[{"unified":"2665-fe0f","native":"♥️","x":57,"y":53}],"version":1},"diamonds":{"id":"diamonds","name":"Diamond Suit","keywords":["diamonds","poker","cards","magic","suits"],"skins":[{"unified":"2666-fe0f","native":"♦️","x":57,"y":54}],"version":1},"clubs":{"id":"clubs","name":"Club Suit","keywords":["clubs","poker","cards","magic","suits"],"skins":[{"unified":"2663-fe0f","native":"♣️","x":57,"y":52}],"version":1},"chess_pawn":{"id":"chess_pawn","name":"Chess Pawn","keywords":["expendable"],"skins":[{"unified":"265f-fe0f","native":"♟️","x":57,"y":50}],"version":11},"black_joker":{"id":"black_joker","name":"Joker","keywords":["black","poker","cards","game","play","magic"],"skins":[{"unified":"1f0cf","native":"🃏","x":0,"y":15}],"version":1},"mahjong":{"id":"mahjong","name":"Mahjong Red Dragon","keywords":["game","play","chinese","kanji"],"skins":[{"unified":"1f004","native":"🀄","x":0,"y":14}],"version":1},"flower_playing_cards":{"id":"flower_playing_cards","name":"Flower Playing Cards","keywords":["game","sunset","red"],"skins":[{"unified":"1f3b4","native":"🎴","x":7,"y":55}],"version":1},"performing_arts":{"id":"performing_arts","name":"Performing Arts","keywords":["acting","theater","drama"],"skins":[{"unified":"1f3ad","native":"🎭","x":7,"y":48}],"version":1},"frame_with_picture":{"id":"frame_with_picture","name":"Framed Picture","keywords":["frame","with","photography"],"skins":[{"unified":"1f5bc-fe0f","native":"🖼️","x":32,"y":0}],"version":1},"art":{"id":"art","name":"Artist Palette","keywords":["art","design","paint","draw","colors"],"skins":[{"unified":"1f3a8","native":"🎨","x":7,"y":43}],"version":1},"thread":{"id":"thread","name":"Thread","keywords":["needle","sewing","spool","string"],"skins":[{"unified":"1f9f5","native":"🧵","x":53,"y":37}],"version":11},"sewing_needle":{"id":"sewing_needle","name":"Sewing Needle","keywords":["stitches"],"skins":[{"unified":"1faa1","native":"🪡","x":54,"y":26}],"version":13},"yarn":{"id":"yarn","name":"Yarn","keywords":["ball","crochet","knit"],"skins":[{"unified":"1f9f6","native":"🧶","x":53,"y":38}],"version":11},"knot":{"id":"knot","name":"Knot","keywords":["rope","scout"],"skins":[{"unified":"1faa2","native":"🪢","x":54,"y":27}],"version":13},"eyeglasses":{"id":"eyeglasses","name":"Glasses","keywords":["eyeglasses","fashion","accessories","eyesight","nerdy","dork","geek"],"skins":[{"unified":"1f453","native":"👓","x":13,"y":16}],"version":1},"dark_sunglasses":{"id":"dark_sunglasses","name":"Sunglasses","keywords":["dark","face","cool","accessories"],"skins":[{"unified":"1f576-fe0f","native":"🕶️","x":31,"y":23}],"version":1},"goggles":{"id":"goggles","name":"Goggles","keywords":["eyes","protection","safety"],"skins":[{"unified":"1f97d","native":"🥽","x":44,"y":17}],"version":11},"lab_coat":{"id":"lab_coat","name":"Lab Coat","keywords":["doctor","experiment","scientist","chemist"],"skins":[{"unified":"1f97c","native":"🥼","x":44,"y":16}],"version":11},"safety_vest":{"id":"safety_vest","name":"Safety Vest","keywords":["protection"],"skins":[{"unified":"1f9ba","native":"🦺","x":45,"y":57}],"version":12},"necktie":{"id":"necktie","name":"Necktie","keywords":["shirt","suitup","formal","fashion","cloth","business"],"skins":[{"unified":"1f454","native":"👔","x":13,"y":17}],"version":1},"shirt":{"id":"shirt","name":"T-Shirt","keywords":["shirt","tshirt","t","fashion","cloth","casual","tee"],"skins":[{"unified":"1f455","native":"👕","x":13,"y":18}],"version":1},"jeans":{"id":"jeans","name":"Jeans","keywords":["fashion","shopping"],"skins":[{"unified":"1f456","native":"👖","x":13,"y":19}],"version":1},"scarf":{"id":"scarf","name":"Scarf","keywords":["neck","winter","clothes"],"skins":[{"unified":"1f9e3","native":"🧣","x":53,"y":19}],"version":5},"gloves":{"id":"gloves","name":"Gloves","keywords":["hands","winter","clothes"],"skins":[{"unified":"1f9e4","native":"🧤","x":53,"y":20}],"version":5},"coat":{"id":"coat","name":"Coat","keywords":["jacket"],"skins":[{"unified":"1f9e5","native":"🧥","x":53,"y":21}],"version":5},"socks":{"id":"socks","name":"Socks","keywords":["stockings","clothes"],"skins":[{"unified":"1f9e6","native":"🧦","x":53,"y":22}],"version":5},"dress":{"id":"dress","name":"Dress","keywords":["clothes","fashion","shopping"],"skins":[{"unified":"1f457","native":"👗","x":13,"y":20}],"version":1},"kimono":{"id":"kimono","name":"Kimono","keywords":["dress","fashion","women","female","japanese"],"skins":[{"unified":"1f458","native":"👘","x":13,"y":21}],"version":1},"sari":{"id":"sari","name":"Sari","keywords":["dress"],"skins":[{"unified":"1f97b","native":"🥻","x":44,"y":15}],"version":12},"one-piece_swimsuit":{"id":"one-piece_swimsuit","name":"One-Piece Swimsuit","keywords":["one","piece","fashion"],"skins":[{"unified":"1fa71","native":"🩱","x":53,"y":49}],"version":12},"briefs":{"id":"briefs","name":"Briefs","keywords":["clothing"],"skins":[{"unified":"1fa72","native":"🩲","x":53,"y":50}],"version":12},"shorts":{"id":"shorts","name":"Shorts","keywords":["clothing"],"skins":[{"unified":"1fa73","native":"🩳","x":53,"y":51}],"version":12},"bikini":{"id":"bikini","name":"Bikini","keywords":["swimming","female","woman","girl","fashion","beach","summer"],"skins":[{"unified":"1f459","native":"👙","x":13,"y":22}],"version":1},"womans_clothes":{"id":"womans_clothes","name":"Womans Clothes","keywords":["woman","s","fashion","shopping","bags","female"],"skins":[{"unified":"1f45a","native":"👚","x":13,"y":23}],"version":1},"purse":{"id":"purse","name":"Purse","keywords":["fashion","accessories","money","sales","shopping"],"skins":[{"unified":"1f45b","native":"👛","x":13,"y":24}],"version":1},"handbag":{"id":"handbag","name":"Handbag","keywords":["fashion","accessory","accessories","shopping"],"skins":[{"unified":"1f45c","native":"👜","x":13,"y":25}],"version":1},"pouch":{"id":"pouch","name":"Pouch","keywords":["clutch","bag","accessories","shopping"],"skins":[{"unified":"1f45d","native":"👝","x":13,"y":26}],"version":1},"shopping_bags":{"id":"shopping_bags","name":"Shopping Bags","keywords":["mall","buy","purchase"],"skins":[{"unified":"1f6cd-fe0f","native":"🛍️","x":38,"y":0}],"version":1},"school_satchel":{"id":"school_satchel","name":"Backpack","keywords":["school","satchel","student","education","bag"],"skins":[{"unified":"1f392","native":"🎒","x":7,"y":26}],"version":1},"thong_sandal":{"id":"thong_sandal","name":"Thong Sandal","keywords":["footwear","summer"],"skins":[{"unified":"1fa74","native":"🩴","x":53,"y":52}],"version":13},"mans_shoe":{"id":"mans_shoe","name":"Mans Shoe","keywords":["man","s","fashion","male"],"skins":[{"unified":"1f45e","native":"👞","x":13,"y":27}],"version":1},"athletic_shoe":{"id":"athletic_shoe","name":"Running Shoe","keywords":["athletic","shoes","sports","sneakers"],"skins":[{"unified":"1f45f","native":"👟","x":13,"y":28}],"version":1},"hiking_boot":{"id":"hiking_boot","name":"Hiking Boot","keywords":["backpacking","camping"],"skins":[{"unified":"1f97e","native":"🥾","x":44,"y":18}],"version":11},"womans_flat_shoe":{"id":"womans_flat_shoe","name":"Flat Shoe","keywords":["womans","ballet","slip","on","slipper"],"skins":[{"unified":"1f97f","native":"🥿","x":44,"y":19}],"version":11},"high_heel":{"id":"high_heel","name":"High-Heeled Shoe","keywords":["high","heel","heeled","fashion","shoes","female","pumps","stiletto"],"skins":[{"unified":"1f460","native":"👠","x":13,"y":29}],"version":1},"sandal":{"id":"sandal","name":"Womans Sandal","keywords":["woman","s","shoes","fashion","flip","flops"],"skins":[{"unified":"1f461","native":"👡","x":13,"y":30}],"version":1},"ballet_shoes":{"id":"ballet_shoes","name":"Ballet Shoes","keywords":["dance"],"skins":[{"unified":"1fa70","native":"🩰","x":53,"y":48}],"version":12},"boot":{"id":"boot","name":"Womans Boots","keywords":["boot","woman","s","shoes","fashion"],"skins":[{"unified":"1f462","native":"👢","x":13,"y":31}],"version":1},"crown":{"id":"crown","name":"Crown","keywords":["king","kod","leader","royalty","lord"],"skins":[{"unified":"1f451","native":"👑","x":13,"y":14}],"version":1},"womans_hat":{"id":"womans_hat","name":"Womans Hat","keywords":["woman","s","fashion","accessories","female","lady","spring"],"skins":[{"unified":"1f452","native":"👒","x":13,"y":15}],"version":1},"tophat":{"id":"tophat","name":"Top Hat","keywords":["tophat","magic","gentleman","classy","circus"],"skins":[{"unified":"1f3a9","native":"🎩","x":7,"y":44}],"version":1},"mortar_board":{"id":"mortar_board","name":"Graduation Cap","keywords":["mortar","board","school","college","degree","university","hat","legal","learn","education"],"skins":[{"unified":"1f393","native":"🎓","x":7,"y":27}],"version":1},"billed_cap":{"id":"billed_cap","name":"Billed Cap","keywords":["baseball"],"skins":[{"unified":"1f9e2","native":"🧢","x":53,"y":18}],"version":5},"military_helmet":{"id":"military_helmet","name":"Military Helmet","keywords":["army","protection"],"skins":[{"unified":"1fa96","native":"🪖","x":54,"y":15}],"version":13},"helmet_with_white_cross":{"id":"helmet_with_white_cross","name":"Rescue Worker’s Helmet","keywords":["with","white","cross","worker","s","construction","build"],"skins":[{"unified":"26d1-fe0f","native":"⛑️","x":58,"y":21}],"version":1},"prayer_beads":{"id":"prayer_beads","name":"Prayer Beads","keywords":["dhikr","religious"],"skins":[{"unified":"1f4ff","native":"📿","x":29,"y":25}],"version":1},"lipstick":{"id":"lipstick","name":"Lipstick","keywords":["female","girl","fashion","woman"],"skins":[{"unified":"1f484","native":"💄","x":25,"y":53}],"version":1},"ring":{"id":"ring","name":"Ring","keywords":["wedding","propose","marriage","valentines","diamond","fashion","jewelry","gem","engagement"],"skins":[{"unified":"1f48d","native":"💍","x":26,"y":40}],"version":1},"gem":{"id":"gem","name":"Gem Stone","keywords":["blue","ruby","diamond","jewelry"],"skins":[{"unified":"1f48e","native":"💎","x":26,"y":41}],"version":1},"mute":{"id":"mute","name":"Muted Speaker","keywords":["mute","sound","volume","silence","quiet"],"skins":[{"unified":"1f507","native":"🔇","x":29,"y":33}],"version":1},"speaker":{"id":"speaker","name":"Speaker","keywords":["low","volume","sound","silence","broadcast"],"skins":[{"unified":"1f508","native":"🔈","x":29,"y":34}],"version":1},"sound":{"id":"sound","name":"Speaker Medium Volume","keywords":["sound","broadcast"],"skins":[{"unified":"1f509","native":"🔉","x":29,"y":35}],"version":1},"loud_sound":{"id":"loud_sound","name":"Speaker High Volume","keywords":["loud","sound","noise","noisy","broadcast"],"skins":[{"unified":"1f50a","native":"🔊","x":29,"y":36}],"version":1},"loudspeaker":{"id":"loudspeaker","name":"Loudspeaker","keywords":["volume","sound"],"skins":[{"unified":"1f4e2","native":"📢","x":28,"y":58}],"version":1},"mega":{"id":"mega","name":"Megaphone","keywords":["mega","sound","speaker","volume"],"skins":[{"unified":"1f4e3","native":"📣","x":28,"y":59}],"version":1},"postal_horn":{"id":"postal_horn","name":"Postal Horn","keywords":["instrument","music"],"skins":[{"unified":"1f4ef","native":"📯","x":29,"y":10}],"version":1},"bell":{"id":"bell","name":"Bell","keywords":["sound","notification","christmas","xmas","chime"],"skins":[{"unified":"1f514","native":"🔔","x":29,"y":46}],"version":1},"no_bell":{"id":"no_bell","name":"Bell with Slash","keywords":["no","sound","volume","mute","quiet","silent"],"skins":[{"unified":"1f515","native":"🔕","x":29,"y":47}],"version":1},"musical_score":{"id":"musical_score","name":"Musical Score","keywords":["treble","clef","compose"],"skins":[{"unified":"1f3bc","native":"🎼","x":8,"y":2}],"version":1},"musical_note":{"id":"musical_note","name":"Musical Note","keywords":["score","tone","sound"],"skins":[{"unified":"1f3b5","native":"🎵","x":7,"y":56}],"version":1},"notes":{"id":"notes","name":"Musical Notes","keywords":["music","score"],"skins":[{"unified":"1f3b6","native":"🎶","x":7,"y":57}],"version":1},"studio_microphone":{"id":"studio_microphone","name":"Studio Microphone","keywords":["sing","recording","artist","talkshow"],"skins":[{"unified":"1f399-fe0f","native":"🎙️","x":7,"y":30}],"version":1},"level_slider":{"id":"level_slider","name":"Level Slider","keywords":["scale"],"skins":[{"unified":"1f39a-fe0f","native":"🎚️","x":7,"y":31}],"version":1},"control_knobs":{"id":"control_knobs","name":"Control Knobs","keywords":["dial"],"skins":[{"unified":"1f39b-fe0f","native":"🎛️","x":7,"y":32}],"version":1},"microphone":{"id":"microphone","name":"Microphone","keywords":["sound","music","PA","sing","talkshow"],"skins":[{"unified":"1f3a4","native":"🎤","x":7,"y":39}],"version":1},"headphones":{"id":"headphones","name":"Headphone","keywords":["headphones","music","score","gadgets"],"skins":[{"unified":"1f3a7","native":"🎧","x":7,"y":42}],"version":1},"radio":{"id":"radio","name":"Radio","keywords":["communication","music","podcast","program"],"skins":[{"unified":"1f4fb","native":"📻","x":29,"y":22}],"version":1},"saxophone":{"id":"saxophone","name":"Saxophone","keywords":["music","instrument","jazz","blues"],"skins":[{"unified":"1f3b7","native":"🎷","x":7,"y":58}],"version":1},"accordion":{"id":"accordion","name":"Accordion","keywords":["music"],"skins":[{"unified":"1fa97","native":"🪗","x":54,"y":16}],"version":13},"guitar":{"id":"guitar","name":"Guitar","keywords":["music","instrument"],"skins":[{"unified":"1f3b8","native":"🎸","x":7,"y":59}],"version":1},"musical_keyboard":{"id":"musical_keyboard","name":"Musical Keyboard","keywords":["piano","instrument","compose"],"skins":[{"unified":"1f3b9","native":"🎹","x":7,"y":60}],"version":1},"trumpet":{"id":"trumpet","name":"Trumpet","keywords":["music","brass"],"skins":[{"unified":"1f3ba","native":"🎺","x":8,"y":0}],"version":1},"violin":{"id":"violin","name":"Violin","keywords":["music","instrument","orchestra","symphony"],"skins":[{"unified":"1f3bb","native":"🎻","x":8,"y":1}],"version":1},"banjo":{"id":"banjo","name":"Banjo","keywords":["music","instructment"],"skins":[{"unified":"1fa95","native":"🪕","x":54,"y":14}],"version":12},"drum_with_drumsticks":{"id":"drum_with_drumsticks","name":"Drum","keywords":["with","drumsticks","music","instrument","snare"],"skins":[{"unified":"1f941","native":"🥁","x":43,"y":14}],"version":3},"long_drum":{"id":"long_drum","name":"Long Drum","keywords":["music"],"skins":[{"unified":"1fa98","native":"🪘","x":54,"y":17}],"version":13},"iphone":{"id":"iphone","name":"Mobile Phone","keywords":["iphone","technology","apple","gadgets","dial"],"skins":[{"unified":"1f4f1","native":"📱","x":29,"y":12}],"version":1},"calling":{"id":"calling","name":"Mobile Phone with Arrow","keywords":["calling","iphone","incoming"],"skins":[{"unified":"1f4f2","native":"📲","x":29,"y":13}],"version":1},"phone":{"id":"phone","name":"Telephone","keywords":["phone","technology","communication","dial"],"skins":[{"unified":"260e-fe0f","native":"☎️","x":57,"y":15}],"version":1},"telephone_receiver":{"id":"telephone_receiver","name":"Telephone Receiver","keywords":["technology","communication","dial"],"skins":[{"unified":"1f4de","native":"📞","x":28,"y":54}],"version":1},"pager":{"id":"pager","name":"Pager","keywords":["bbcall","oldschool","90s"],"skins":[{"unified":"1f4df","native":"📟","x":28,"y":55}],"version":1},"fax":{"id":"fax","name":"Fax Machine","keywords":["communication","technology"],"skins":[{"unified":"1f4e0","native":"📠","x":28,"y":56}],"version":1},"battery":{"id":"battery","name":"Battery","keywords":["power","energy","sustain"],"skins":[{"unified":"1f50b","native":"🔋","x":29,"y":37}],"version":1},"low_battery":{"id":"low_battery","name":"Low Battery","keywords":["drained","dead"],"skins":[{"unified":"1faab","native":"🪫","x":54,"y":36}],"version":14},"electric_plug":{"id":"electric_plug","name":"Electric Plug","keywords":["charger","power"],"skins":[{"unified":"1f50c","native":"🔌","x":29,"y":38}],"version":1},"computer":{"id":"computer","name":"Laptop","keywords":["computer","technology","screen","display","monitor"],"skins":[{"unified":"1f4bb","native":"💻","x":28,"y":19}],"version":1},"desktop_computer":{"id":"desktop_computer","name":"Desktop Computer","keywords":["technology","computing","screen"],"skins":[{"unified":"1f5a5-fe0f","native":"🖥️","x":31,"y":57}],"version":1},"printer":{"id":"printer","name":"Printer","keywords":["paper","ink"],"skins":[{"unified":"1f5a8-fe0f","native":"🖨️","x":31,"y":58}],"version":1},"keyboard":{"id":"keyboard","name":"Keyboard","keywords":["technology","computer","type","input","text"],"skins":[{"unified":"2328-fe0f","native":"⌨️","x":56,"y":46}],"version":1},"three_button_mouse":{"id":"three_button_mouse","name":"Computer Mouse","keywords":["three","button","click"],"skins":[{"unified":"1f5b1-fe0f","native":"🖱️","x":31,"y":59}],"version":1},"trackball":{"id":"trackball","name":"Trackball","keywords":["technology","trackpad"],"skins":[{"unified":"1f5b2-fe0f","native":"🖲️","x":31,"y":60}],"version":1},"minidisc":{"id":"minidisc","name":"Minidisc","keywords":["computer","disk","technology","record","data","90s"],"skins":[{"unified":"1f4bd","native":"💽","x":28,"y":21}],"version":1},"floppy_disk":{"id":"floppy_disk","name":"Floppy Disk","keywords":["oldschool","technology","save","90s","80s"],"skins":[{"unified":"1f4be","native":"💾","x":28,"y":22}],"version":1},"cd":{"id":"cd","name":"Optical Disc","keywords":["cd","disk","technology","dvd","90s"],"skins":[{"unified":"1f4bf","native":"💿","x":28,"y":23}],"version":1},"dvd":{"id":"dvd","name":"Dvd","keywords":["cd","disk","disc"],"skins":[{"unified":"1f4c0","native":"📀","x":28,"y":24}],"version":1},"abacus":{"id":"abacus","name":"Abacus","keywords":["calculation"],"skins":[{"unified":"1f9ee","native":"🧮","x":53,"y":30}],"version":11},"movie_camera":{"id":"movie_camera","name":"Movie Camera","keywords":["film","record"],"skins":[{"unified":"1f3a5","native":"🎥","x":7,"y":40}],"version":1},"film_frames":{"id":"film_frames","name":"Film Frames","keywords":["movie"],"skins":[{"unified":"1f39e-fe0f","native":"🎞️","x":7,"y":33}],"version":1},"film_projector":{"id":"film_projector","name":"Film Projector","keywords":["video","tape","record","movie"],"skins":[{"unified":"1f4fd-fe0f","native":"📽️","x":29,"y":24}],"version":1},"clapper":{"id":"clapper","name":"Clapper Board","keywords":["movie","film","record"],"skins":[{"unified":"1f3ac","native":"🎬","x":7,"y":47}],"version":1},"tv":{"id":"tv","name":"Television","keywords":["tv","technology","program","oldschool","show"],"skins":[{"unified":"1f4fa","native":"📺","x":29,"y":21}],"version":1},"camera":{"id":"camera","name":"Camera","keywords":["gadgets","photography"],"skins":[{"unified":"1f4f7","native":"📷","x":29,"y":18}],"version":1},"camera_with_flash":{"id":"camera_with_flash","name":"Camera with Flash","keywords":["photography","gadgets"],"skins":[{"unified":"1f4f8","native":"📸","x":29,"y":19}],"version":1},"video_camera":{"id":"video_camera","name":"Video Camera","keywords":["film","record"],"skins":[{"unified":"1f4f9","native":"📹","x":29,"y":20}],"version":1},"vhs":{"id":"vhs","name":"Videocassette","keywords":["vhs","record","video","oldschool","90s","80s"],"skins":[{"unified":"1f4fc","native":"📼","x":29,"y":23}],"version":1},"mag":{"id":"mag","name":"Magnifying Glass Tilted Left","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50d","native":"🔍","x":29,"y":39}],"version":1},"mag_right":{"id":"mag_right","name":"Magnifying Glass Tilted Right","keywords":["mag","search","zoom","find","detective"],"skins":[{"unified":"1f50e","native":"🔎","x":29,"y":40}],"version":1},"candle":{"id":"candle","name":"Candle","keywords":["fire","wax"],"skins":[{"unified":"1f56f-fe0f","native":"🕯️","x":30,"y":57}],"version":1},"bulb":{"id":"bulb","name":"Light Bulb","keywords":["electricity","idea"],"skins":[{"unified":"1f4a1","native":"💡","x":27,"y":49}],"version":1},"flashlight":{"id":"flashlight","name":"Flashlight","keywords":["dark","camping","sight","night"],"skins":[{"unified":"1f526","native":"🔦","x":30,"y":3}],"version":1},"izakaya_lantern":{"id":"izakaya_lantern","name":"Izakaya Lantern","keywords":["red","paper","light","halloween","spooky"],"skins":[{"unified":"1f3ee","native":"🏮","x":10,"y":25}],"version":1},"diya_lamp":{"id":"diya_lamp","name":"Diya Lamp","keywords":["lighting"],"skins":[{"unified":"1fa94","native":"🪔","x":54,"y":13}],"version":12},"notebook_with_decorative_cover":{"id":"notebook_with_decorative_cover","name":"Notebook with Decorative Cover","keywords":["classroom","notes","record","paper","study"],"skins":[{"unified":"1f4d4","native":"📔","x":28,"y":44}],"version":1},"closed_book":{"id":"closed_book","name":"Closed Book","keywords":["read","library","knowledge","textbook","learn"],"skins":[{"unified":"1f4d5","native":"📕","x":28,"y":45}],"version":1},"book":{"id":"book","name":"Open Book","keywords":["read","library","knowledge","literature","learn","study"],"skins":[{"unified":"1f4d6","native":"📖","x":28,"y":46}],"version":1},"green_book":{"id":"green_book","name":"Green Book","keywords":["read","library","knowledge","study"],"skins":[{"unified":"1f4d7","native":"📗","x":28,"y":47}],"version":1},"blue_book":{"id":"blue_book","name":"Blue Book","keywords":["read","library","knowledge","learn","study"],"skins":[{"unified":"1f4d8","native":"📘","x":28,"y":48}],"version":1},"orange_book":{"id":"orange_book","name":"Orange Book","keywords":["read","library","knowledge","textbook","study"],"skins":[{"unified":"1f4d9","native":"📙","x":28,"y":49}],"version":1},"books":{"id":"books","name":"Books","keywords":["literature","library","study"],"skins":[{"unified":"1f4da","native":"📚","x":28,"y":50}],"version":1},"notebook":{"id":"notebook","name":"Notebook","keywords":["stationery","record","notes","paper","study"],"skins":[{"unified":"1f4d3","native":"📓","x":28,"y":43}],"version":1},"ledger":{"id":"ledger","name":"Ledger","keywords":["notes","paper"],"skins":[{"unified":"1f4d2","native":"📒","x":28,"y":42}],"version":1},"page_with_curl":{"id":"page_with_curl","name":"Page with Curl","keywords":["documents","office","paper"],"skins":[{"unified":"1f4c3","native":"📃","x":28,"y":27}],"version":1},"scroll":{"id":"scroll","name":"Scroll","keywords":["documents","ancient","history","paper"],"skins":[{"unified":"1f4dc","native":"📜","x":28,"y":52}],"version":1},"page_facing_up":{"id":"page_facing_up","name":"Page Facing Up","keywords":["documents","office","paper","information"],"skins":[{"unified":"1f4c4","native":"📄","x":28,"y":28}],"version":1},"newspaper":{"id":"newspaper","name":"Newspaper","keywords":["press","headline"],"skins":[{"unified":"1f4f0","native":"📰","x":29,"y":11}],"version":1},"rolled_up_newspaper":{"id":"rolled_up_newspaper","name":"Rolled-Up Newspaper","keywords":["rolled","up","press","headline"],"skins":[{"unified":"1f5de-fe0f","native":"🗞️","x":32,"y":9}],"version":1},"bookmark_tabs":{"id":"bookmark_tabs","name":"Bookmark Tabs","keywords":["favorite","save","order","tidy"],"skins":[{"unified":"1f4d1","native":"📑","x":28,"y":41}],"version":1},"bookmark":{"id":"bookmark","name":"Bookmark","keywords":["favorite","label","save"],"skins":[{"unified":"1f516","native":"🔖","x":29,"y":48}],"version":1},"label":{"id":"label","name":"Label","keywords":["sale","tag"],"skins":[{"unified":"1f3f7-fe0f","native":"🏷️","x":10,"y":37}],"version":1},"moneybag":{"id":"moneybag","name":"Money Bag","keywords":["moneybag","dollar","payment","coins","sale"],"skins":[{"unified":"1f4b0","native":"💰","x":28,"y":8}],"version":1},"coin":{"id":"coin","name":"Coin","keywords":["money","currency"],"skins":[{"unified":"1fa99","native":"🪙","x":54,"y":18}],"version":13},"yen":{"id":"yen","name":"Yen Banknote","keywords":["money","sales","japanese","dollar","currency"],"skins":[{"unified":"1f4b4","native":"💴","x":28,"y":12}],"version":1},"dollar":{"id":"dollar","name":"Dollar Banknote","keywords":["money","sales","bill","currency"],"skins":[{"unified":"1f4b5","native":"💵","x":28,"y":13}],"version":1},"euro":{"id":"euro","name":"Euro Banknote","keywords":["money","sales","dollar","currency"],"skins":[{"unified":"1f4b6","native":"💶","x":28,"y":14}],"version":1},"pound":{"id":"pound","name":"Pound Banknote","keywords":["british","sterling","money","sales","bills","uk","england","currency"],"skins":[{"unified":"1f4b7","native":"💷","x":28,"y":15}],"version":1},"money_with_wings":{"id":"money_with_wings","name":"Money with Wings","keywords":["dollar","bills","payment","sale"],"skins":[{"unified":"1f4b8","native":"💸","x":28,"y":16}],"version":1},"credit_card":{"id":"credit_card","name":"Credit Card","keywords":["money","sales","dollar","bill","payment","shopping"],"skins":[{"unified":"1f4b3","native":"💳","x":28,"y":11}],"version":1},"receipt":{"id":"receipt","name":"Receipt","keywords":["accounting","expenses"],"skins":[{"unified":"1f9fe","native":"🧾","x":53,"y":46}],"version":11},"chart":{"id":"chart","name":"Chart Increasing with Yen","keywords":["green","square","graph","presentation","stats"],"skins":[{"unified":"1f4b9","native":"💹","x":28,"y":17}],"version":1},"email":{"id":"email","name":"Envelope","keywords":["email","letter","postal","inbox","communication"],"skins":[{"unified":"2709-fe0f","native":"✉️","x":58,"y":57}],"version":1},"e-mail":{"id":"e-mail","name":"E-Mail","keywords":["e","mail","communication","inbox"],"skins":[{"unified":"1f4e7","native":"📧","x":29,"y":2}],"version":1},"incoming_envelope":{"id":"incoming_envelope","name":"Incoming Envelope","keywords":["email","inbox"],"skins":[{"unified":"1f4e8","native":"📨","x":29,"y":3}],"version":1},"envelope_with_arrow":{"id":"envelope_with_arrow","name":"Envelope with Arrow","keywords":["email","communication"],"skins":[{"unified":"1f4e9","native":"📩","x":29,"y":4}],"version":1},"outbox_tray":{"id":"outbox_tray","name":"Outbox Tray","keywords":["inbox","email"],"skins":[{"unified":"1f4e4","native":"📤","x":28,"y":60}],"version":1},"inbox_tray":{"id":"inbox_tray","name":"Inbox Tray","keywords":["email","documents"],"skins":[{"unified":"1f4e5","native":"📥","x":29,"y":0}],"version":1},"package":{"id":"package","name":"Package","keywords":["mail","gift","cardboard","box","moving"],"skins":[{"unified":"1f4e6","native":"📦","x":29,"y":1}],"version":1},"mailbox":{"id":"mailbox","name":"Closed Mailbox with Raised Flag","keywords":["email","inbox","communication"],"skins":[{"unified":"1f4eb","native":"📫","x":29,"y":6}],"version":1},"mailbox_closed":{"id":"mailbox_closed","name":"Closed Mailbox with Lowered Flag","keywords":["email","communication","inbox"],"skins":[{"unified":"1f4ea","native":"📪","x":29,"y":5}],"version":1},"mailbox_with_mail":{"id":"mailbox_with_mail","name":"Open Mailbox with Raised Flag","keywords":["mail","email","inbox","communication"],"skins":[{"unified":"1f4ec","native":"📬","x":29,"y":7}],"version":1},"mailbox_with_no_mail":{"id":"mailbox_with_no_mail","name":"Open Mailbox with Lowered Flag","keywords":["no","mail","email","inbox"],"skins":[{"unified":"1f4ed","native":"📭","x":29,"y":8}],"version":1},"postbox":{"id":"postbox","name":"Postbox","keywords":["email","letter","envelope"],"skins":[{"unified":"1f4ee","native":"📮","x":29,"y":9}],"version":1},"ballot_box_with_ballot":{"id":"ballot_box_with_ballot","name":"Ballot Box with Ballot","keywords":["election","vote"],"skins":[{"unified":"1f5f3-fe0f","native":"🗳️","x":32,"y":14}],"version":1},"pencil2":{"id":"pencil2","name":"Pencil","keywords":["pencil2","stationery","write","paper","writing","school","study"],"skins":[{"unified":"270f-fe0f","native":"✏️","x":59,"y":21}],"version":1},"black_nib":{"id":"black_nib","name":"Black Nib","keywords":["pen","stationery","writing","write"],"skins":[{"unified":"2712-fe0f","native":"✒️","x":59,"y":22}],"version":1},"lower_left_fountain_pen":{"id":"lower_left_fountain_pen","name":"Fountain Pen","keywords":["lower","left","stationery","writing","write"],"skins":[{"unified":"1f58b-fe0f","native":"🖋️","x":31,"y":35}],"version":1},"lower_left_ballpoint_pen":{"id":"lower_left_ballpoint_pen","name":"Pen","keywords":["lower","left","ballpoint","stationery","writing","write"],"skins":[{"unified":"1f58a-fe0f","native":"🖊️","x":31,"y":34}],"version":1},"lower_left_paintbrush":{"id":"lower_left_paintbrush","name":"Paintbrush","keywords":["lower","left","drawing","creativity","art"],"skins":[{"unified":"1f58c-fe0f","native":"🖌️","x":31,"y":36}],"version":1},"lower_left_crayon":{"id":"lower_left_crayon","name":"Crayon","keywords":["lower","left","drawing","creativity"],"skins":[{"unified":"1f58d-fe0f","native":"🖍️","x":31,"y":37}],"version":1},"memo":{"id":"memo","name":"Memo","keywords":["pencil","write","documents","stationery","paper","writing","legal","exam","quiz","test","study","compose"],"skins":[{"unified":"1f4dd","native":"📝","x":28,"y":53}],"version":1},"briefcase":{"id":"briefcase","name":"Briefcase","keywords":["business","documents","work","law","legal","job","career"],"skins":[{"unified":"1f4bc","native":"💼","x":28,"y":20}],"version":1},"file_folder":{"id":"file_folder","name":"File Folder","keywords":["documents","business","office"],"skins":[{"unified":"1f4c1","native":"📁","x":28,"y":25}],"version":1},"open_file_folder":{"id":"open_file_folder","name":"Open File Folder","keywords":["documents","load"],"skins":[{"unified":"1f4c2","native":"📂","x":28,"y":26}],"version":1},"card_index_dividers":{"id":"card_index_dividers","name":"Card Index Dividers","keywords":["organizing","business","stationery"],"skins":[{"unified":"1f5c2-fe0f","native":"🗂️","x":32,"y":1}],"version":1},"date":{"id":"date","name":"Calendar","keywords":["date","schedule"],"skins":[{"unified":"1f4c5","native":"📅","x":28,"y":29}],"version":1},"calendar":{"id":"calendar","name":"Tear-off Calendar","keywords":["tear","off","schedule","date","planning"],"skins":[{"unified":"1f4c6","native":"📆","x":28,"y":30}],"version":1},"spiral_note_pad":{"id":"spiral_note_pad","name":"Spiral Notepad","keywords":["note","pad","memo","stationery"],"skins":[{"unified":"1f5d2-fe0f","native":"🗒️","x":32,"y":5}],"version":1},"spiral_calendar_pad":{"id":"spiral_calendar_pad","name":"Spiral Calendar","keywords":["pad","date","schedule","planning"],"skins":[{"unified":"1f5d3-fe0f","native":"🗓️","x":32,"y":6}],"version":1},"card_index":{"id":"card_index","name":"Card Index","keywords":["business","stationery"],"skins":[{"unified":"1f4c7","native":"📇","x":28,"y":31}],"version":1},"chart_with_upwards_trend":{"id":"chart_with_upwards_trend","name":"Chart Increasing","keywords":["with","upwards","trend","graph","presentation","stats","recovery","business","economics","money","sales","good","success"],"skins":[{"unified":"1f4c8","native":"📈","x":28,"y":32}],"version":1},"chart_with_downwards_trend":{"id":"chart_with_downwards_trend","name":"Chart Decreasing","keywords":["with","downwards","trend","graph","presentation","stats","recession","business","economics","money","sales","bad","failure"],"skins":[{"unified":"1f4c9","native":"📉","x":28,"y":33}],"version":1},"bar_chart":{"id":"bar_chart","name":"Bar Chart","keywords":["graph","presentation","stats"],"skins":[{"unified":"1f4ca","native":"📊","x":28,"y":34}],"version":1},"clipboard":{"id":"clipboard","name":"Clipboard","keywords":["stationery","documents"],"skins":[{"unified":"1f4cb","native":"📋","x":28,"y":35}],"version":1},"pushpin":{"id":"pushpin","name":"Pushpin","keywords":["stationery","mark","here"],"skins":[{"unified":"1f4cc","native":"📌","x":28,"y":36}],"version":1},"round_pushpin":{"id":"round_pushpin","name":"Round Pushpin","keywords":["stationery","location","map","here"],"skins":[{"unified":"1f4cd","native":"📍","x":28,"y":37}],"version":1},"paperclip":{"id":"paperclip","name":"Paperclip","keywords":["documents","stationery"],"skins":[{"unified":"1f4ce","native":"📎","x":28,"y":38}],"version":1},"linked_paperclips":{"id":"linked_paperclips","name":"Linked Paperclips","keywords":["documents","stationery"],"skins":[{"unified":"1f587-fe0f","native":"🖇️","x":31,"y":33}],"version":1},"straight_ruler":{"id":"straight_ruler","name":"Straight Ruler","keywords":["stationery","calculate","length","math","school","drawing","architect","sketch"],"skins":[{"unified":"1f4cf","native":"📏","x":28,"y":39}],"version":1},"triangular_ruler":{"id":"triangular_ruler","name":"Triangular Ruler","keywords":["stationery","math","architect","sketch"],"skins":[{"unified":"1f4d0","native":"📐","x":28,"y":40}],"version":1},"scissors":{"id":"scissors","name":"Scissors","keywords":["stationery","cut"],"skins":[{"unified":"2702-fe0f","native":"✂️","x":58,"y":54}],"version":1},"card_file_box":{"id":"card_file_box","name":"Card File Box","keywords":["business","stationery"],"skins":[{"unified":"1f5c3-fe0f","native":"🗃️","x":32,"y":2}],"version":1},"file_cabinet":{"id":"file_cabinet","name":"File Cabinet","keywords":["filing","organizing"],"skins":[{"unified":"1f5c4-fe0f","native":"🗄️","x":32,"y":3}],"version":1},"wastebasket":{"id":"wastebasket","name":"Wastebasket","keywords":["bin","trash","rubbish","garbage","toss"],"skins":[{"unified":"1f5d1-fe0f","native":"🗑️","x":32,"y":4}],"version":1},"lock":{"id":"lock","name":"Lock","keywords":["locked","security","password","padlock"],"skins":[{"unified":"1f512","native":"🔒","x":29,"y":44}],"version":1},"unlock":{"id":"unlock","name":"Unlocked","keywords":["unlock","privacy","security"],"skins":[{"unified":"1f513","native":"🔓","x":29,"y":45}],"version":1},"lock_with_ink_pen":{"id":"lock_with_ink_pen","name":"Locked with Pen","keywords":["lock","ink","security","secret"],"skins":[{"unified":"1f50f","native":"🔏","x":29,"y":41}],"version":1},"closed_lock_with_key":{"id":"closed_lock_with_key","name":"Locked with Key","keywords":["closed","lock","security","privacy"],"skins":[{"unified":"1f510","native":"🔐","x":29,"y":42}],"version":1},"key":{"id":"key","name":"Key","keywords":["lock","door","password"],"skins":[{"unified":"1f511","native":"🔑","x":29,"y":43}],"version":1},"old_key":{"id":"old_key","name":"Old Key","keywords":["lock","door","password"],"skins":[{"unified":"1f5dd-fe0f","native":"🗝️","x":32,"y":8}],"version":1},"hammer":{"id":"hammer","name":"Hammer","keywords":["tools","build","create"],"skins":[{"unified":"1f528","native":"🔨","x":30,"y":5}],"version":1},"axe":{"id":"axe","name":"Axe","keywords":["tool","chop","cut"],"skins":[{"unified":"1fa93","native":"🪓","x":54,"y":12}],"version":12},"pick":{"id":"pick","name":"Pick","keywords":["tools","dig"],"skins":[{"unified":"26cf-fe0f","native":"⛏️","x":58,"y":20}],"version":1},"hammer_and_pick":{"id":"hammer_and_pick","name":"Hammer and Pick","keywords":["tools","build","create"],"skins":[{"unified":"2692-fe0f","native":"⚒️","x":57,"y":59}],"version":1},"hammer_and_wrench":{"id":"hammer_and_wrench","name":"Hammer and Wrench","keywords":["tools","build","create"],"skins":[{"unified":"1f6e0-fe0f","native":"🛠️","x":38,"y":13}],"version":1},"dagger_knife":{"id":"dagger_knife","name":"Dagger","keywords":["knife","weapon"],"skins":[{"unified":"1f5e1-fe0f","native":"🗡️","x":32,"y":10}],"version":1},"crossed_swords":{"id":"crossed_swords","name":"Crossed Swords","keywords":["weapon"],"skins":[{"unified":"2694-fe0f","native":"⚔️","x":58,"y":0}],"version":1},"bomb":{"id":"bomb","name":"Bomb","keywords":["boom","explode","explosion","terrorism"],"skins":[{"unified":"1f4a3","native":"💣","x":27,"y":51}],"version":1},"boomerang":{"id":"boomerang","name":"Boomerang","keywords":["weapon"],"skins":[{"unified":"1fa83","native":"🪃","x":54,"y":3}],"version":13},"bow_and_arrow":{"id":"bow_and_arrow","name":"Bow and Arrow","keywords":["sports"],"skins":[{"unified":"1f3f9","native":"🏹","x":10,"y":39}],"version":1},"shield":{"id":"shield","name":"Shield","keywords":["protection","security"],"skins":[{"unified":"1f6e1-fe0f","native":"🛡️","x":38,"y":14}],"version":1},"carpentry_saw":{"id":"carpentry_saw","name":"Carpentry Saw","keywords":["cut","chop"],"skins":[{"unified":"1fa9a","native":"🪚","x":54,"y":19}],"version":13},"wrench":{"id":"wrench","name":"Wrench","keywords":["tools","diy","ikea","fix","maintainer"],"skins":[{"unified":"1f527","native":"🔧","x":30,"y":4}],"version":1},"screwdriver":{"id":"screwdriver","name":"Screwdriver","keywords":["tools"],"skins":[{"unified":"1fa9b","native":"🪛","x":54,"y":20}],"version":13},"nut_and_bolt":{"id":"nut_and_bolt","name":"Nut and Bolt","keywords":["handy","tools","fix"],"skins":[{"unified":"1f529","native":"🔩","x":30,"y":6}],"version":1},"gear":{"id":"gear","name":"Gear","keywords":["cog"],"skins":[{"unified":"2699-fe0f","native":"⚙️","x":58,"y":4}],"version":1},"compression":{"id":"compression","name":"Clamp","keywords":["compression","tool"],"skins":[{"unified":"1f5dc-fe0f","native":"🗜️","x":32,"y":7}],"version":1},"scales":{"id":"scales","name":"Balance Scale","keywords":["scales","law","fairness","weight"],"skins":[{"unified":"2696-fe0f","native":"⚖️","x":58,"y":2}],"version":1},"probing_cane":{"id":"probing_cane","name":"White Cane","keywords":["probing","accessibility"],"skins":[{"unified":"1f9af","native":"🦯","x":45,"y":6}],"version":12},"link":{"id":"link","name":"Link","keywords":["rings","url"],"skins":[{"unified":"1f517","native":"🔗","x":29,"y":49}],"version":1},"chains":{"id":"chains","name":"Chains","keywords":["lock","arrest"],"skins":[{"unified":"26d3-fe0f","native":"⛓️","x":58,"y":22}],"version":1},"hook":{"id":"hook","name":"Hook","keywords":["tools"],"skins":[{"unified":"1fa9d","native":"🪝","x":54,"y":22}],"version":13},"toolbox":{"id":"toolbox","name":"Toolbox","keywords":["tools","diy","fix","maintainer","mechanic"],"skins":[{"unified":"1f9f0","native":"🧰","x":53,"y":32}],"version":11},"magnet":{"id":"magnet","name":"Magnet","keywords":["attraction","magnetic"],"skins":[{"unified":"1f9f2","native":"🧲","x":53,"y":34}],"version":11},"ladder":{"id":"ladder","name":"Ladder","keywords":["tools"],"skins":[{"unified":"1fa9c","native":"🪜","x":54,"y":21}],"version":13},"alembic":{"id":"alembic","name":"Alembic","keywords":["distilling","science","experiment","chemistry"],"skins":[{"unified":"2697-fe0f","native":"⚗️","x":58,"y":3}],"version":1},"test_tube":{"id":"test_tube","name":"Test Tube","keywords":["chemistry","experiment","lab","science"],"skins":[{"unified":"1f9ea","native":"🧪","x":53,"y":26}],"version":11},"petri_dish":{"id":"petri_dish","name":"Petri Dish","keywords":["bacteria","biology","culture","lab"],"skins":[{"unified":"1f9eb","native":"🧫","x":53,"y":27}],"version":11},"dna":{"id":"dna","name":"Dna","keywords":["biologist","genetics","life"],"skins":[{"unified":"1f9ec","native":"🧬","x":53,"y":28}],"version":11},"microscope":{"id":"microscope","name":"Microscope","keywords":["laboratory","experiment","zoomin","science","study"],"skins":[{"unified":"1f52c","native":"🔬","x":30,"y":9}],"version":1},"telescope":{"id":"telescope","name":"Telescope","keywords":["stars","space","zoom","science","astronomy"],"skins":[{"unified":"1f52d","native":"🔭","x":30,"y":10}],"version":1},"satellite_antenna":{"id":"satellite_antenna","name":"Satellite Antenna","keywords":["communication","future","radio","space"],"skins":[{"unified":"1f4e1","native":"📡","x":28,"y":57}],"version":1},"syringe":{"id":"syringe","name":"Syringe","keywords":["health","hospital","drugs","blood","medicine","needle","doctor","nurse"],"skins":[{"unified":"1f489","native":"💉","x":26,"y":36}],"version":1},"drop_of_blood":{"id":"drop_of_blood","name":"Drop of Blood","keywords":["period","hurt","harm","wound"],"skins":[{"unified":"1fa78","native":"🩸","x":53,"y":56}],"version":12},"pill":{"id":"pill","name":"Pill","keywords":["health","medicine","doctor","pharmacy","drug"],"skins":[{"unified":"1f48a","native":"💊","x":26,"y":37}],"version":1},"adhesive_bandage":{"id":"adhesive_bandage","name":"Adhesive Bandage","keywords":["heal"],"skins":[{"unified":"1fa79","native":"🩹","x":53,"y":57}],"version":12},"crutch":{"id":"crutch","name":"Crutch","keywords":["accessibility","assist"],"skins":[{"unified":"1fa7c","native":"🩼","x":53,"y":60}],"version":14},"stethoscope":{"id":"stethoscope","name":"Stethoscope","keywords":["health"],"skins":[{"unified":"1fa7a","native":"🩺","x":53,"y":58}],"version":12},"x-ray":{"id":"x-ray","name":"X-Ray","keywords":["x","ray","skeleton","medicine"],"skins":[{"unified":"1fa7b","native":"🩻","x":53,"y":59}],"version":14},"door":{"id":"door","name":"Door","keywords":["house","entry","exit"],"skins":[{"unified":"1f6aa","native":"🚪","x":36,"y":31}],"version":1},"elevator":{"id":"elevator","name":"Elevator","keywords":["lift"],"skins":[{"unified":"1f6d7","native":"🛗","x":38,"y":8}],"version":13},"mirror":{"id":"mirror","name":"Mirror","keywords":["reflection"],"skins":[{"unified":"1fa9e","native":"🪞","x":54,"y":23}],"version":13},"window":{"id":"window","name":"Window","keywords":["scenery"],"skins":[{"unified":"1fa9f","native":"🪟","x":54,"y":24}],"version":13},"bed":{"id":"bed","name":"Bed","keywords":["sleep","rest"],"skins":[{"unified":"1f6cf-fe0f","native":"🛏️","x":38,"y":2}],"version":1},"couch_and_lamp":{"id":"couch_and_lamp","name":"Couch and Lamp","keywords":["read","chill"],"skins":[{"unified":"1f6cb-fe0f","native":"🛋️","x":37,"y":54}],"version":1},"chair":{"id":"chair","name":"Chair","keywords":["sit","furniture"],"skins":[{"unified":"1fa91","native":"🪑","x":54,"y":10}],"version":12},"toilet":{"id":"toilet","name":"Toilet","keywords":["restroom","wc","washroom","bathroom","potty"],"skins":[{"unified":"1f6bd","native":"🚽","x":37,"y":40}],"version":1},"plunger":{"id":"plunger","name":"Plunger","keywords":["toilet"],"skins":[{"unified":"1faa0","native":"🪠","x":54,"y":25}],"version":13},"shower":{"id":"shower","name":"Shower","keywords":["clean","water","bathroom"],"skins":[{"unified":"1f6bf","native":"🚿","x":37,"y":42}],"version":1},"bathtub":{"id":"bathtub","name":"Bathtub","keywords":["clean","shower","bathroom"],"skins":[{"unified":"1f6c1","native":"🛁","x":37,"y":49}],"version":1},"mouse_trap":{"id":"mouse_trap","name":"Mouse Trap","keywords":["cheese"],"skins":[{"unified":"1faa4","native":"🪤","x":54,"y":29}],"version":13},"razor":{"id":"razor","name":"Razor","keywords":["cut"],"skins":[{"unified":"1fa92","native":"🪒","x":54,"y":11}],"version":12},"lotion_bottle":{"id":"lotion_bottle","name":"Lotion Bottle","keywords":["moisturizer","sunscreen"],"skins":[{"unified":"1f9f4","native":"🧴","x":53,"y":36}],"version":11},"safety_pin":{"id":"safety_pin","name":"Safety Pin","keywords":["diaper"],"skins":[{"unified":"1f9f7","native":"🧷","x":53,"y":39}],"version":11},"broom":{"id":"broom","name":"Broom","keywords":["cleaning","sweeping","witch"],"skins":[{"unified":"1f9f9","native":"🧹","x":53,"y":41}],"version":11},"basket":{"id":"basket","name":"Basket","keywords":["laundry"],"skins":[{"unified":"1f9fa","native":"🧺","x":53,"y":42}],"version":11},"roll_of_paper":{"id":"roll_of_paper","name":"Roll of Paper","keywords":[],"skins":[{"unified":"1f9fb","native":"🧻","x":53,"y":43}],"version":11},"bucket":{"id":"bucket","name":"Bucket","keywords":["water","container"],"skins":[{"unified":"1faa3","native":"🪣","x":54,"y":28}],"version":13},"soap":{"id":"soap","name":"Soap","keywords":["bar","bathing","cleaning","lather"],"skins":[{"unified":"1f9fc","native":"🧼","x":53,"y":44}],"version":11},"bubbles":{"id":"bubbles","name":"Bubbles","keywords":["soap","fun","carbonation","sparkling"],"skins":[{"unified":"1fae7","native":"🫧","x":55,"y":37}],"version":14},"toothbrush":{"id":"toothbrush","name":"Toothbrush","keywords":["hygiene","dental"],"skins":[{"unified":"1faa5","native":"🪥","x":54,"y":30}],"version":13},"sponge":{"id":"sponge","name":"Sponge","keywords":["absorbing","cleaning","porous"],"skins":[{"unified":"1f9fd","native":"🧽","x":53,"y":45}],"version":11},"fire_extinguisher":{"id":"fire_extinguisher","name":"Fire Extinguisher","keywords":["quench"],"skins":[{"unified":"1f9ef","native":"🧯","x":53,"y":31}],"version":11},"shopping_trolley":{"id":"shopping_trolley","name":"Shopping Cart","keywords":["trolley"],"skins":[{"unified":"1f6d2","native":"🛒","x":38,"y":5}],"version":3},"smoking":{"id":"smoking","name":"Cigarette","keywords":["smoking","kills","tobacco","joint","smoke"],"skins":[{"unified":"1f6ac","native":"🚬","x":36,"y":33}],"version":1},"coffin":{"id":"coffin","name":"Coffin","keywords":["vampire","dead","die","death","rip","graveyard","cemetery","casket","funeral","box"],"skins":[{"unified":"26b0-fe0f","native":"⚰️","x":58,"y":12}],"version":1},"headstone":{"id":"headstone","name":"Headstone","keywords":["death","rip","grave"],"skins":[{"unified":"1faa6","native":"🪦","x":54,"y":31}],"version":13},"funeral_urn":{"id":"funeral_urn","name":"Funeral Urn","keywords":["dead","die","death","rip","ashes"],"skins":[{"unified":"26b1-fe0f","native":"⚱️","x":58,"y":13}],"version":1},"nazar_amulet":{"id":"nazar_amulet","name":"Nazar Amulet","keywords":["bead","charm"],"skins":[{"unified":"1f9ff","native":"🧿","x":53,"y":47}],"version":11},"hamsa":{"id":"hamsa","name":"Hamsa","keywords":["religion","protection"],"skins":[{"unified":"1faac","native":"🪬","x":54,"y":37}],"version":14},"moyai":{"id":"moyai","name":"Moai","keywords":["moyai","rock","easter","island"],"skins":[{"unified":"1f5ff","native":"🗿","x":32,"y":20}],"version":1},"placard":{"id":"placard","name":"Placard","keywords":["announcement"],"skins":[{"unified":"1faa7","native":"🪧","x":54,"y":32}],"version":13},"identification_card":{"id":"identification_card","name":"Identification Card","keywords":["document"],"skins":[{"unified":"1faaa","native":"🪪","x":54,"y":35}],"version":14},"atm":{"id":"atm","name":"Atm Sign","keywords":["money","sales","cash","blue","square","payment","bank"],"skins":[{"unified":"1f3e7","native":"🏧","x":10,"y":18}],"version":1},"put_litter_in_its_place":{"id":"put_litter_in_its_place","name":"Litter in Bin Sign","keywords":["put","its","place","blue","square","human","info"],"skins":[{"unified":"1f6ae","native":"🚮","x":36,"y":35}],"version":1},"potable_water":{"id":"potable_water","name":"Potable Water","keywords":["blue","square","liquid","restroom","cleaning","faucet"],"skins":[{"unified":"1f6b0","native":"🚰","x":36,"y":37}],"version":1},"wheelchair":{"id":"wheelchair","name":"Wheelchair Symbol","keywords":["blue","square","disabled","accessibility"],"skins":[{"unified":"267f","native":"♿","x":57,"y":58}],"version":1},"mens":{"id":"mens","name":"Men’s Room","keywords":["mens","men","s","toilet","restroom","wc","blue","square","gender","male"],"skins":[{"unified":"1f6b9","native":"🚹","x":37,"y":36}],"version":1},"womens":{"id":"womens","name":"Women’s Room","keywords":["womens","women","s","purple","square","woman","female","toilet","loo","restroom","gender"],"skins":[{"unified":"1f6ba","native":"🚺","x":37,"y":37}],"version":1},"restroom":{"id":"restroom","name":"Restroom","keywords":["blue","square","toilet","refresh","wc","gender"],"skins":[{"unified":"1f6bb","native":"🚻","x":37,"y":38}],"version":1},"baby_symbol":{"id":"baby_symbol","name":"Baby Symbol","keywords":["orange","square","child"],"skins":[{"unified":"1f6bc","native":"🚼","x":37,"y":39}],"version":1},"wc":{"id":"wc","name":"Water Closet","keywords":["wc","toilet","restroom","blue","square"],"skins":[{"unified":"1f6be","native":"🚾","x":37,"y":41}],"version":1},"passport_control":{"id":"passport_control","name":"Passport Control","keywords":["custom","blue","square"],"skins":[{"unified":"1f6c2","native":"🛂","x":37,"y":50}],"version":1},"customs":{"id":"customs","name":"Customs","keywords":["passport","border","blue","square"],"skins":[{"unified":"1f6c3","native":"🛃","x":37,"y":51}],"version":1},"baggage_claim":{"id":"baggage_claim","name":"Baggage Claim","keywords":["blue","square","airport","transport"],"skins":[{"unified":"1f6c4","native":"🛄","x":37,"y":52}],"version":1},"left_luggage":{"id":"left_luggage","name":"Left Luggage","keywords":["blue","square","travel"],"skins":[{"unified":"1f6c5","native":"🛅","x":37,"y":53}],"version":1},"warning":{"id":"warning","name":"Warning","keywords":["exclamation","wip","alert","error","problem","issue"],"skins":[{"unified":"26a0-fe0f","native":"⚠️","x":58,"y":7}],"version":1},"children_crossing":{"id":"children_crossing","name":"Children Crossing","keywords":["school","warning","danger","sign","driving","yellow","diamond"],"skins":[{"unified":"1f6b8","native":"🚸","x":37,"y":35}],"version":1},"no_entry":{"id":"no_entry","name":"No Entry","keywords":["limit","security","privacy","bad","denied","stop","circle"],"skins":[{"unified":"26d4","native":"⛔","x":58,"y":23}],"version":1},"no_entry_sign":{"id":"no_entry_sign","name":"Prohibited","keywords":["no","entry","sign","forbid","stop","limit","denied","disallow","circle"],"skins":[{"unified":"1f6ab","native":"🚫","x":36,"y":32}],"version":1},"no_bicycles":{"id":"no_bicycles","name":"No Bicycles","keywords":["cyclist","prohibited","circle"],"skins":[{"unified":"1f6b3","native":"🚳","x":36,"y":40}],"version":1},"no_smoking":{"id":"no_smoking","name":"No Smoking","keywords":["cigarette","blue","square","smell","smoke"],"skins":[{"unified":"1f6ad","native":"🚭","x":36,"y":34}],"version":1},"do_not_litter":{"id":"do_not_litter","name":"No Littering","keywords":["do","not","litter","trash","bin","garbage","circle"],"skins":[{"unified":"1f6af","native":"🚯","x":36,"y":36}],"version":1},"non-potable_water":{"id":"non-potable_water","name":"Non-Potable Water","keywords":["non","potable","drink","faucet","tap","circle"],"skins":[{"unified":"1f6b1","native":"🚱","x":36,"y":38}],"version":1},"no_pedestrians":{"id":"no_pedestrians","name":"No Pedestrians","keywords":["rules","crossing","walking","circle"],"skins":[{"unified":"1f6b7","native":"🚷","x":37,"y":34}],"version":1},"no_mobile_phones":{"id":"no_mobile_phones","name":"No Mobile Phones","keywords":["iphone","mute","circle"],"skins":[{"unified":"1f4f5","native":"📵","x":29,"y":16}],"version":1},"underage":{"id":"underage","name":"No One Under Eighteen","keywords":["underage","18","drink","pub","night","minor","circle"],"skins":[{"unified":"1f51e","native":"🔞","x":29,"y":56}],"version":1},"radioactive_sign":{"id":"radioactive_sign","name":"Radioactive","keywords":["sign","nuclear","danger"],"skins":[{"unified":"2622-fe0f","native":"☢️","x":57,"y":27}],"version":1},"biohazard_sign":{"id":"biohazard_sign","name":"Biohazard","keywords":["sign","danger"],"skins":[{"unified":"2623-fe0f","native":"☣️","x":57,"y":28}],"version":1},"arrow_up":{"id":"arrow_up","name":"Up Arrow","keywords":["blue","square","continue","top","direction"],"skins":[{"unified":"2b06-fe0f","native":"⬆️","x":59,"y":51}],"version":1},"arrow_upper_right":{"id":"arrow_upper_right","name":"Up-Right Arrow","keywords":["upper","right","up","blue","square","point","direction","diagonal","northeast"],"skins":[{"unified":"2197-fe0f","native":"↗️","x":56,"y":39}],"version":1},"arrow_right":{"id":"arrow_right","name":"Right Arrow","keywords":["blue","square","next"],"skins":[{"unified":"27a1-fe0f","native":"➡️","x":59,"y":45}],"version":1},"arrow_lower_right":{"id":"arrow_lower_right","name":"South East Arrow","keywords":["lower","right","down","blue","square","direction","diagonal","southeast"],"skins":[{"unified":"2198-fe0f","native":"↘️","x":56,"y":40}],"version":1},"arrow_down":{"id":"arrow_down","name":"Down Arrow","keywords":["blue","square","direction","bottom"],"skins":[{"unified":"2b07-fe0f","native":"⬇️","x":59,"y":52}],"version":1},"arrow_lower_left":{"id":"arrow_lower_left","name":"Down-Left Arrow","keywords":["lower","left","down","blue","square","direction","diagonal","southwest"],"skins":[{"unified":"2199-fe0f","native":"↙️","x":56,"y":41}],"version":1},"arrow_left":{"id":"arrow_left","name":"Left Arrow","keywords":["blue","square","previous","back"],"skins":[{"unified":"2b05-fe0f","native":"⬅️","x":59,"y":50}],"version":1},"arrow_upper_left":{"id":"arrow_upper_left","name":"Up-Left Arrow","keywords":["upper","left","up","blue","square","point","direction","diagonal","northwest"],"skins":[{"unified":"2196-fe0f","native":"↖️","x":56,"y":38}],"version":1},"arrow_up_down":{"id":"arrow_up_down","name":"Up Down Arrow","keywords":["blue","square","direction","way","vertical"],"skins":[{"unified":"2195-fe0f","native":"↕️","x":56,"y":37}],"version":1},"left_right_arrow":{"id":"left_right_arrow","name":"Left Right Arrow","keywords":["shape","direction","horizontal","sideways"],"skins":[{"unified":"2194-fe0f","native":"↔️","x":56,"y":36}],"version":1},"leftwards_arrow_with_hook":{"id":"leftwards_arrow_with_hook","name":"Right Arrow Curving Left","keywords":["leftwards","with","hook","back","return","blue","square","undo","enter"],"skins":[{"unified":"21a9-fe0f","native":"↩️","x":56,"y":42}],"version":1},"arrow_right_hook":{"id":"arrow_right_hook","name":"Left Arrow Curving Right","keywords":["hook","blue","square","return","rotate","direction"],"skins":[{"unified":"21aa-fe0f","native":"↪️","x":56,"y":43}],"version":1},"arrow_heading_up":{"id":"arrow_heading_up","name":"Right Arrow Curving Up","keywords":["heading","blue","square","direction","top"],"skins":[{"unified":"2934-fe0f","native":"⤴️","x":59,"y":48}],"version":1},"arrow_heading_down":{"id":"arrow_heading_down","name":"Right Arrow Curving Down","keywords":["heading","blue","square","direction","bottom"],"skins":[{"unified":"2935-fe0f","native":"⤵️","x":59,"y":49}],"version":1},"arrows_clockwise":{"id":"arrows_clockwise","name":"Clockwise Vertical Arrows","keywords":["sync","cycle","round","repeat"],"skins":[{"unified":"1f503","native":"🔃","x":29,"y":29}],"version":1},"arrows_counterclockwise":{"id":"arrows_counterclockwise","name":"Counterclockwise Arrows Button","keywords":["blue","square","sync","cycle"],"skins":[{"unified":"1f504","native":"🔄","x":29,"y":30}],"version":1},"back":{"id":"back","name":"Back Arrow","keywords":["words","return"],"skins":[{"unified":"1f519","native":"🔙","x":29,"y":51}],"version":1},"end":{"id":"end","name":"End Arrow","keywords":["words"],"skins":[{"unified":"1f51a","native":"🔚","x":29,"y":52}],"version":1},"on":{"id":"on","name":"On! Arrow","keywords":["on","words"],"skins":[{"unified":"1f51b","native":"🔛","x":29,"y":53}],"version":1},"soon":{"id":"soon","name":"Soon Arrow","keywords":["words"],"skins":[{"unified":"1f51c","native":"🔜","x":29,"y":54}],"version":1},"top":{"id":"top","name":"Top Arrow","keywords":["words","blue","square"],"skins":[{"unified":"1f51d","native":"🔝","x":29,"y":55}],"version":1},"place_of_worship":{"id":"place_of_worship","name":"Place of Worship","keywords":["religion","church","temple","prayer"],"skins":[{"unified":"1f6d0","native":"🛐","x":38,"y":3}],"version":1},"atom_symbol":{"id":"atom_symbol","name":"Atom Symbol","keywords":["science","physics","chemistry"],"skins":[{"unified":"269b-fe0f","native":"⚛️","x":58,"y":5}],"version":1},"om_symbol":{"id":"om_symbol","name":"Om","keywords":["symbol","hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"1f549-fe0f","native":"🕉️","x":30,"y":27}],"version":1},"star_of_david":{"id":"star_of_david","name":"Star of David","keywords":["judaism"],"skins":[{"unified":"2721-fe0f","native":"✡️","x":59,"y":26}],"version":1},"wheel_of_dharma":{"id":"wheel_of_dharma","name":"Wheel of Dharma","keywords":["hinduism","buddhism","sikhism","jainism"],"skins":[{"unified":"2638-fe0f","native":"☸️","x":57,"y":33}],"version":1},"yin_yang":{"id":"yin_yang","name":"Yin Yang","keywords":["balance"],"skins":[{"unified":"262f-fe0f","native":"☯️","x":57,"y":32}],"version":1},"latin_cross":{"id":"latin_cross","name":"Latin Cross","keywords":["christianity"],"skins":[{"unified":"271d-fe0f","native":"✝️","x":59,"y":25}],"version":1},"orthodox_cross":{"id":"orthodox_cross","name":"Orthodox Cross","keywords":["suppedaneum","religion"],"skins":[{"unified":"2626-fe0f","native":"☦️","x":57,"y":29}],"version":1},"star_and_crescent":{"id":"star_and_crescent","name":"Star and Crescent","keywords":["islam"],"skins":[{"unified":"262a-fe0f","native":"☪️","x":57,"y":30}],"version":1},"peace_symbol":{"id":"peace_symbol","name":"Peace Symbol","keywords":["hippie"],"skins":[{"unified":"262e-fe0f","native":"☮️","x":57,"y":31}],"version":1},"menorah_with_nine_branches":{"id":"menorah_with_nine_branches","name":"Menorah","keywords":["with","nine","branches","hanukkah","candles","jewish"],"skins":[{"unified":"1f54e","native":"🕎","x":30,"y":32}],"version":1},"six_pointed_star":{"id":"six_pointed_star","name":"Dotted Six-Pointed Star","keywords":["six","pointed","purple","square","religion","jewish","hexagram"],"skins":[{"unified":"1f52f","native":"🔯","x":30,"y":12}],"version":1},"aries":{"id":"aries","name":"Aries","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2648","native":"♈","x":57,"y":38}],"version":1},"taurus":{"id":"taurus","name":"Taurus","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2649","native":"♉","x":57,"y":39}],"version":1},"gemini":{"id":"gemini","name":"Gemini","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264a","native":"♊","x":57,"y":40}],"version":1},"cancer":{"id":"cancer","name":"Cancer","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264b","native":"♋","x":57,"y":41}],"version":1},"leo":{"id":"leo","name":"Leo","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264c","native":"♌","x":57,"y":42}],"version":1},"virgo":{"id":"virgo","name":"Virgo","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264d","native":"♍","x":57,"y":43}],"version":1},"libra":{"id":"libra","name":"Libra","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"264e","native":"♎","x":57,"y":44}],"version":1},"scorpius":{"id":"scorpius","name":"Scorpio","keywords":["scorpius","sign","zodiac","purple","square","astrology"],"skins":[{"unified":"264f","native":"♏","x":57,"y":45}],"version":1},"sagittarius":{"id":"sagittarius","name":"Sagittarius","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2650","native":"♐","x":57,"y":46}],"version":1},"capricorn":{"id":"capricorn","name":"Capricorn","keywords":["sign","zodiac","purple","square","astrology"],"skins":[{"unified":"2651","native":"♑","x":57,"y":47}],"version":1},"aquarius":{"id":"aquarius","name":"Aquarius","keywords":["sign","purple","square","zodiac","astrology"],"skins":[{"unified":"2652","native":"♒","x":57,"y":48}],"version":1},"pisces":{"id":"pisces","name":"Pisces","keywords":["purple","square","sign","zodiac","astrology"],"skins":[{"unified":"2653","native":"♓","x":57,"y":49}],"version":1},"ophiuchus":{"id":"ophiuchus","name":"Ophiuchus","keywords":["sign","purple","square","constellation","astrology"],"skins":[{"unified":"26ce","native":"⛎","x":58,"y":19}],"version":1},"twisted_rightwards_arrows":{"id":"twisted_rightwards_arrows","name":"Shuffle Tracks Button","keywords":["twisted","rightwards","arrows","blue","square","music","random"],"skins":[{"unified":"1f500","native":"🔀","x":29,"y":26}],"version":1},"repeat":{"id":"repeat","name":"Repeat Button","keywords":["loop","record"],"skins":[{"unified":"1f501","native":"🔁","x":29,"y":27}],"version":1},"repeat_one":{"id":"repeat_one","name":"Repeat Single Button","keywords":["one","blue","square","loop"],"skins":[{"unified":"1f502","native":"🔂","x":29,"y":28}],"version":1},"arrow_forward":{"id":"arrow_forward","name":"Play Button","keywords":["arrow","forward","blue","square","right","direction"],"skins":[{"unified":"25b6-fe0f","native":"▶️","x":57,"y":4}],"version":1},"fast_forward":{"id":"fast_forward","name":"Fast-Forward Button","keywords":["fast","forward","blue","square","play","speed","continue"],"skins":[{"unified":"23e9","native":"⏩","x":56,"y":48}],"version":1},"black_right_pointing_double_triangle_with_vertical_bar":{"id":"black_right_pointing_double_triangle_with_vertical_bar","name":"Next Track Button","keywords":["black","right","pointing","double","triangle","with","vertical","bar","forward","blue","square"],"skins":[{"unified":"23ed-fe0f","native":"⏭️","x":56,"y":52}],"version":1},"black_right_pointing_triangle_with_double_vertical_bar":{"id":"black_right_pointing_triangle_with_double_vertical_bar","name":"Play or Pause Button","keywords":["black","right","pointing","triangle","with","double","vertical","bar","blue","square"],"skins":[{"unified":"23ef-fe0f","native":"⏯️","x":56,"y":54}],"version":1},"arrow_backward":{"id":"arrow_backward","name":"Reverse Button","keywords":["arrow","backward","blue","square","left","direction"],"skins":[{"unified":"25c0-fe0f","native":"◀️","x":57,"y":5}],"version":1},"rewind":{"id":"rewind","name":"Fast Reverse Button","keywords":["rewind","play","blue","square"],"skins":[{"unified":"23ea","native":"⏪","x":56,"y":49}],"version":1},"black_left_pointing_double_triangle_with_vertical_bar":{"id":"black_left_pointing_double_triangle_with_vertical_bar","name":"Last Track Button","keywords":["black","left","pointing","double","triangle","with","vertical","bar","backward"],"skins":[{"unified":"23ee-fe0f","native":"⏮️","x":56,"y":53}],"version":1},"arrow_up_small":{"id":"arrow_up_small","name":"Upwards Button","keywords":["arrow","up","small","blue","square","triangle","direction","point","forward","top"],"skins":[{"unified":"1f53c","native":"🔼","x":30,"y":25}],"version":1},"arrow_double_up":{"id":"arrow_double_up","name":"Fast Up Button","keywords":["arrow","double","blue","square","direction","top"],"skins":[{"unified":"23eb","native":"⏫","x":56,"y":50}],"version":1},"arrow_down_small":{"id":"arrow_down_small","name":"Downwards Button","keywords":["arrow","down","small","blue","square","direction","bottom"],"skins":[{"unified":"1f53d","native":"🔽","x":30,"y":26}],"version":1},"arrow_double_down":{"id":"arrow_double_down","name":"Fast Down Button","keywords":["arrow","double","blue","square","direction","bottom"],"skins":[{"unified":"23ec","native":"⏬","x":56,"y":51}],"version":1},"double_vertical_bar":{"id":"double_vertical_bar","name":"Pause Button","keywords":["double","vertical","bar","blue","square"],"skins":[{"unified":"23f8-fe0f","native":"⏸️","x":56,"y":59}],"version":1},"black_square_for_stop":{"id":"black_square_for_stop","name":"Stop Button","keywords":["black","square","for","blue"],"skins":[{"unified":"23f9-fe0f","native":"⏹️","x":56,"y":60}],"version":1},"black_circle_for_record":{"id":"black_circle_for_record","name":"Record Button","keywords":["black","circle","for","blue","square"],"skins":[{"unified":"23fa-fe0f","native":"⏺️","x":57,"y":0}],"version":1},"eject":{"id":"eject","name":"Eject Button","keywords":["blue","square"],"skins":[{"unified":"23cf-fe0f","native":"⏏️","x":56,"y":47}],"version":1},"cinema":{"id":"cinema","name":"Cinema","keywords":["blue","square","record","film","movie","curtain","stage","theater"],"skins":[{"unified":"1f3a6","native":"🎦","x":7,"y":41}],"version":1},"low_brightness":{"id":"low_brightness","name":"Dim Button","keywords":["low","brightness","sun","afternoon","warm","summer"],"skins":[{"unified":"1f505","native":"🔅","x":29,"y":31}],"version":1},"high_brightness":{"id":"high_brightness","name":"Bright Button","keywords":["high","brightness","sun","light"],"skins":[{"unified":"1f506","native":"🔆","x":29,"y":32}],"version":1},"signal_strength":{"id":"signal_strength","name":"Antenna Bars","keywords":["signal","strength","blue","square","reception","phone","internet","connection","wifi","bluetooth"],"skins":[{"unified":"1f4f6","native":"📶","x":29,"y":17}],"version":1},"vibration_mode":{"id":"vibration_mode","name":"Vibration Mode","keywords":["orange","square","phone"],"skins":[{"unified":"1f4f3","native":"📳","x":29,"y":14}],"version":1},"mobile_phone_off":{"id":"mobile_phone_off","name":"Mobile Phone off","keywords":["mute","orange","square","silence","quiet"],"skins":[{"unified":"1f4f4","native":"📴","x":29,"y":15}],"version":1},"female_sign":{"id":"female_sign","name":"Female Sign","keywords":["woman","women","lady","girl"],"skins":[{"unified":"2640-fe0f","native":"♀️","x":57,"y":36}],"version":4},"male_sign":{"id":"male_sign","name":"Male Sign","keywords":["man","boy","men"],"skins":[{"unified":"2642-fe0f","native":"♂️","x":57,"y":37}],"version":4},"transgender_symbol":{"id":"transgender_symbol","name":"Transgender Symbol","keywords":["lgbtq"],"skins":[{"unified":"26a7-fe0f","native":"⚧️","x":58,"y":9}],"version":13},"heavy_multiplication_x":{"id":"heavy_multiplication_x","name":"Multiply","keywords":["heavy","multiplication","x","sign","math","calculation"],"skins":[{"unified":"2716-fe0f","native":"✖️","x":59,"y":24}],"version":1},"heavy_plus_sign":{"id":"heavy_plus_sign","name":"Plus","keywords":["heavy","sign","math","calculation","addition","more","increase"],"skins":[{"unified":"2795","native":"➕","x":59,"y":42}],"version":1},"heavy_minus_sign":{"id":"heavy_minus_sign","name":"Minus","keywords":["heavy","sign","math","calculation","subtract","less"],"skins":[{"unified":"2796","native":"➖","x":59,"y":43}],"version":1},"heavy_division_sign":{"id":"heavy_division_sign","name":"Divide","keywords":["heavy","division","sign","math","calculation"],"skins":[{"unified":"2797","native":"➗","x":59,"y":44}],"version":1},"heavy_equals_sign":{"id":"heavy_equals_sign","name":"Heavy Equals Sign","keywords":["math"],"skins":[{"unified":"1f7f0","native":"🟰","x":38,"y":45}],"version":14},"infinity":{"id":"infinity","name":"Infinity","keywords":["forever"],"skins":[{"unified":"267e-fe0f","native":"♾️","x":57,"y":57}],"version":11},"bangbang":{"id":"bangbang","name":"Double Exclamation Mark","keywords":["bangbang","surprise"],"skins":[{"unified":"203c-fe0f","native":"‼️","x":56,"y":32}],"version":1},"interrobang":{"id":"interrobang","name":"Exclamation Question Mark","keywords":["interrobang","wat","punctuation","surprise"],"skins":[{"unified":"2049-fe0f","native":"⁉️","x":56,"y":33}],"version":1},"question":{"id":"question","name":"Red Question Mark","keywords":["doubt","confused"],"skins":[{"unified":"2753","native":"❓","x":59,"y":34}],"version":1},"grey_question":{"id":"grey_question","name":"White Question Mark","keywords":["grey","doubts","gray","huh","confused"],"skins":[{"unified":"2754","native":"❔","x":59,"y":35}],"version":1},"grey_exclamation":{"id":"grey_exclamation","name":"White Exclamation Mark","keywords":["grey","surprise","punctuation","gray","wow","warning"],"skins":[{"unified":"2755","native":"❕","x":59,"y":36}],"version":1},"exclamation":{"id":"exclamation","name":"Red Exclamation Mark","keywords":["heavy","danger","surprise","punctuation","wow","warning"],"skins":[{"unified":"2757","native":"❗","x":59,"y":37}],"version":1},"wavy_dash":{"id":"wavy_dash","name":"Wavy Dash","keywords":["draw","line","moustache","mustache","squiggle","scribble"],"skins":[{"unified":"3030-fe0f","native":"〰️","x":59,"y":57}],"version":1},"currency_exchange":{"id":"currency_exchange","name":"Currency Exchange","keywords":["money","sales","dollar","travel"],"skins":[{"unified":"1f4b1","native":"💱","x":28,"y":9}],"version":1},"heavy_dollar_sign":{"id":"heavy_dollar_sign","name":"Heavy Dollar Sign","keywords":["money","sales","payment","currency","buck"],"skins":[{"unified":"1f4b2","native":"💲","x":28,"y":10}],"version":1},"medical_symbol":{"id":"medical_symbol","name":"Medical Symbol","keywords":["staff","of","aesculapius","health","hospital"],"skins":[{"unified":"2695-fe0f","native":"⚕️","x":58,"y":1}],"version":4},"recycle":{"id":"recycle","name":"Recycling Symbol","keywords":["recycle","arrow","environment","garbage","trash"],"skins":[{"unified":"267b-fe0f","native":"♻️","x":57,"y":56}],"version":1},"fleur_de_lis":{"id":"fleur_de_lis","name":"Fleur-De-Lis","keywords":["fleur","de","lis","decorative","scout"],"skins":[{"unified":"269c-fe0f","native":"⚜️","x":58,"y":6}],"version":1},"trident":{"id":"trident","name":"Trident Emblem","keywords":["weapon","spear"],"skins":[{"unified":"1f531","native":"🔱","x":30,"y":14}],"version":1},"name_badge":{"id":"name_badge","name":"Name Badge","keywords":["fire","forbid"],"skins":[{"unified":"1f4db","native":"📛","x":28,"y":51}],"version":1},"beginner":{"id":"beginner","name":"Japanese Symbol for Beginner","keywords":["badge","shield"],"skins":[{"unified":"1f530","native":"🔰","x":30,"y":13}],"version":1},"o":{"id":"o","name":"Hollow Red Circle","keywords":["o","round"],"skins":[{"unified":"2b55","native":"⭕","x":59,"y":56}],"version":1},"white_check_mark":{"id":"white_check_mark","name":"Check Mark Button","keywords":["white","green","square","ok","agree","vote","election","answer","tick"],"skins":[{"unified":"2705","native":"✅","x":58,"y":55}],"version":1},"ballot_box_with_check":{"id":"ballot_box_with_check","name":"Check Box with Check","keywords":["ballot","ok","agree","confirm","black","square","vote","election","yes","tick"],"skins":[{"unified":"2611-fe0f","native":"☑️","x":57,"y":16}],"version":1},"heavy_check_mark":{"id":"heavy_check_mark","name":"Check Mark","keywords":["heavy","ok","nike","answer","yes","tick"],"skins":[{"unified":"2714-fe0f","native":"✔️","x":59,"y":23}],"version":1},"x":{"id":"x","name":"Cross Mark","keywords":["x","no","delete","remove","cancel","red"],"skins":[{"unified":"274c","native":"❌","x":59,"y":32}],"version":1},"negative_squared_cross_mark":{"id":"negative_squared_cross_mark","name":"Cross Mark Button","keywords":["negative","squared","x","green","square","no","deny"],"skins":[{"unified":"274e","native":"❎","x":59,"y":33}],"version":1},"curly_loop":{"id":"curly_loop","name":"Curly Loop","keywords":["scribble","draw","shape","squiggle"],"skins":[{"unified":"27b0","native":"➰","x":59,"y":46}],"version":1},"loop":{"id":"loop","name":"Double Curly Loop","keywords":["tape","cassette"],"skins":[{"unified":"27bf","native":"➿","x":59,"y":47}],"version":1},"part_alternation_mark":{"id":"part_alternation_mark","name":"Part Alternation Mark","keywords":["graph","presentation","stats","business","economics","bad"],"skins":[{"unified":"303d-fe0f","native":"〽️","x":59,"y":58}],"version":1},"eight_spoked_asterisk":{"id":"eight_spoked_asterisk","name":"Eight Spoked Asterisk","keywords":["star","sparkle","green","square"],"skins":[{"unified":"2733-fe0f","native":"✳️","x":59,"y":28}],"version":1},"eight_pointed_black_star":{"id":"eight_pointed_black_star","name":"Eight-Pointed Star","keywords":["eight","pointed","black","orange","square","shape","polygon"],"skins":[{"unified":"2734-fe0f","native":"✴️","x":59,"y":29}],"version":1},"sparkle":{"id":"sparkle","name":"Sparkle","keywords":["stars","green","square","awesome","good","fireworks"],"skins":[{"unified":"2747-fe0f","native":"❇️","x":59,"y":31}],"version":1},"copyright":{"id":"copyright","name":"Copyright","keywords":["ip","license","circle","law","legal"],"skins":[{"unified":"00a9-fe0f","native":"©️","x":0,"y":12}],"version":1},"registered":{"id":"registered","name":"Registered","keywords":["alphabet","circle"],"skins":[{"unified":"00ae-fe0f","native":"®️","x":0,"y":13}],"version":1},"tm":{"id":"tm","name":"Trade Mark","keywords":["tm","trademark","brand","law","legal"],"skins":[{"unified":"2122-fe0f","native":"™️","x":56,"y":34}],"version":1},"hash":{"id":"hash","name":"Hash Key","keywords":["keycap","","symbol","blue","square","twitter"],"skins":[{"unified":"0023-fe0f-20e3","native":"#️⃣","x":0,"y":0}],"version":1},"keycap_star":{"id":"keycap_star","name":"Keycap: *","keywords":["keycap","star",""],"skins":[{"unified":"002a-fe0f-20e3","native":"*️⃣","x":0,"y":1}],"version":2},"zero":{"id":"zero","name":"Keycap 0","keywords":["zero","numbers","blue","square","null"],"skins":[{"unified":"0030-fe0f-20e3","native":"0️⃣","x":0,"y":2}],"version":1},"one":{"id":"one","name":"Keycap 1","keywords":["one","blue","square","numbers"],"skins":[{"unified":"0031-fe0f-20e3","native":"1️⃣","x":0,"y":3}],"version":1},"two":{"id":"two","name":"Keycap 2","keywords":["two","numbers","prime","blue","square"],"skins":[{"unified":"0032-fe0f-20e3","native":"2️⃣","x":0,"y":4}],"version":1},"three":{"id":"three","name":"Keycap 3","keywords":["three","numbers","prime","blue","square"],"skins":[{"unified":"0033-fe0f-20e3","native":"3️⃣","x":0,"y":5}],"version":1},"four":{"id":"four","name":"Keycap 4","keywords":["four","numbers","blue","square"],"skins":[{"unified":"0034-fe0f-20e3","native":"4️⃣","x":0,"y":6}],"version":1},"five":{"id":"five","name":"Keycap 5","keywords":["five","numbers","blue","square","prime"],"skins":[{"unified":"0035-fe0f-20e3","native":"5️⃣","x":0,"y":7}],"version":1},"six":{"id":"six","name":"Keycap 6","keywords":["six","numbers","blue","square"],"skins":[{"unified":"0036-fe0f-20e3","native":"6️⃣","x":0,"y":8}],"version":1},"seven":{"id":"seven","name":"Keycap 7","keywords":["seven","numbers","blue","square","prime"],"skins":[{"unified":"0037-fe0f-20e3","native":"7️⃣","x":0,"y":9}],"version":1},"eight":{"id":"eight","name":"Keycap 8","keywords":["eight","blue","square","numbers"],"skins":[{"unified":"0038-fe0f-20e3","native":"8️⃣","x":0,"y":10}],"version":1},"nine":{"id":"nine","name":"Keycap 9","keywords":["nine","blue","square","numbers"],"skins":[{"unified":"0039-fe0f-20e3","native":"9️⃣","x":0,"y":11}],"version":1},"keycap_ten":{"id":"keycap_ten","name":"Keycap 10","keywords":["ten","numbers","blue","square"],"skins":[{"unified":"1f51f","native":"🔟","x":29,"y":57}],"version":1},"capital_abcd":{"id":"capital_abcd","name":"Input Latin Uppercase","keywords":["capital","abcd","alphabet","words","blue","square"],"skins":[{"unified":"1f520","native":"🔠","x":29,"y":58}],"version":1},"abcd":{"id":"abcd","name":"Input Latin Lowercase","keywords":["abcd","blue","square","alphabet"],"skins":[{"unified":"1f521","native":"🔡","x":29,"y":59}],"version":1},"symbols":{"id":"symbols","name":"Input Symbols","keywords":["blue","square","music","note","ampersand","percent","glyphs","characters"],"skins":[{"unified":"1f523","native":"🔣","x":30,"y":0}],"version":1},"abc":{"id":"abc","name":"Input Latin Letters","keywords":["abc","blue","square","alphabet"],"skins":[{"unified":"1f524","native":"🔤","x":30,"y":1}],"version":1},"a":{"id":"a","name":"A Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f170-fe0f","native":"🅰️","x":0,"y":16}],"version":1},"ab":{"id":"ab","name":"Negative Squared Ab","keywords":["button","red","square","alphabet"],"skins":[{"unified":"1f18e","native":"🆎","x":0,"y":20}],"version":1},"b":{"id":"b","name":"B Button (blood Type)","keywords":["red","square","alphabet","letter"],"skins":[{"unified":"1f171-fe0f","native":"🅱️","x":0,"y":17}],"version":1},"cl":{"id":"cl","name":"Cl Button","keywords":["alphabet","words","red","square"],"skins":[{"unified":"1f191","native":"🆑","x":0,"y":21}],"version":1},"cool":{"id":"cool","name":"Cool Button","keywords":["words","blue","square"],"skins":[{"unified":"1f192","native":"🆒","x":0,"y":22}],"version":1},"free":{"id":"free","name":"Free Button","keywords":["blue","square","words"],"skins":[{"unified":"1f193","native":"🆓","x":0,"y":23}],"version":1},"information_source":{"id":"information_source","name":"Information","keywords":["source","blue","square","alphabet","letter"],"skins":[{"unified":"2139-fe0f","native":"ℹ️","x":56,"y":35}],"version":1},"id":{"id":"id","name":"Id Button","keywords":["purple","square","words"],"skins":[{"unified":"1f194","native":"🆔","x":0,"y":24}],"version":1},"m":{"id":"m","name":"Circled M","keywords":["alphabet","blue","circle","letter"],"skins":[{"unified":"24c2-fe0f","native":"Ⓜ️","x":57,"y":1}],"version":1},"new":{"id":"new","name":"New Button","keywords":["blue","square","words","start"],"skins":[{"unified":"1f195","native":"🆕","x":0,"y":25}],"version":1},"ng":{"id":"ng","name":"Ng Button","keywords":["blue","square","words","shape","icon"],"skins":[{"unified":"1f196","native":"🆖","x":0,"y":26}],"version":1},"o2":{"id":"o2","name":"O Button (blood Type)","keywords":["o2","alphabet","red","square","letter"],"skins":[{"unified":"1f17e-fe0f","native":"🅾️","x":0,"y":18}],"version":1},"ok":{"id":"ok","name":"Ok Button","keywords":["good","agree","yes","blue","square"],"skins":[{"unified":"1f197","native":"🆗","x":0,"y":27}],"version":1},"parking":{"id":"parking","name":"P Button","keywords":["parking","cars","blue","square","alphabet","letter"],"skins":[{"unified":"1f17f-fe0f","native":"🅿️","x":0,"y":19}],"version":1},"sos":{"id":"sos","name":"Sos Button","keywords":["help","red","square","words","emergency","911"],"skins":[{"unified":"1f198","native":"🆘","x":0,"y":28}],"version":1},"up":{"id":"up","name":"Up! Button","keywords":["up","blue","square","above","high"],"skins":[{"unified":"1f199","native":"🆙","x":0,"y":29}],"version":1},"vs":{"id":"vs","name":"Vs Button","keywords":["words","orange","square"],"skins":[{"unified":"1f19a","native":"🆚","x":0,"y":30}],"version":1},"koko":{"id":"koko","name":"Squared Katakana Koko","keywords":["japanese","here","button","blue","square","destination"],"skins":[{"unified":"1f201","native":"🈁","x":4,"y":45}],"version":1},"sa":{"id":"sa","name":"Squared Katakana Sa","keywords":["japanese","service","charge","button","blue","square"],"skins":[{"unified":"1f202-fe0f","native":"🈂️","x":4,"y":46}],"version":1},"u6708":{"id":"u6708","name":"Japanese “monthly Amount” Button","keywords":["u6708","monthly","amount","chinese","month","moon","orange","square","kanji"],"skins":[{"unified":"1f237-fe0f","native":"🈷️","x":4,"y":54}],"version":1},"u6709":{"id":"u6709","name":"Squared Cjk Unified Ideograph-6709","keywords":["u6709","japanese","not","free","of","charge","button","orange","square","chinese","have","kanji"],"skins":[{"unified":"1f236","native":"🈶","x":4,"y":53}],"version":1},"u6307":{"id":"u6307","name":"Japanese “reserved” Button","keywords":["u6307","reserved","chinese","point","green","square","kanji"],"skins":[{"unified":"1f22f","native":"🈯","x":4,"y":48}],"version":1},"ideograph_advantage":{"id":"ideograph_advantage","name":"Japanese “bargain” Button","keywords":["ideograph","advantage","bargain","chinese","kanji","obtain","get","circle"],"skins":[{"unified":"1f250","native":"🉐","x":4,"y":58}],"version":1},"u5272":{"id":"u5272","name":"Japanese “discount” Button","keywords":["u5272","discount","cut","divide","chinese","kanji","pink","square"],"skins":[{"unified":"1f239","native":"🈹","x":4,"y":56}],"version":1},"u7121":{"id":"u7121","name":"Japanese “free of Charge” Button","keywords":["u7121","free","charge","nothing","chinese","kanji","orange","square"],"skins":[{"unified":"1f21a","native":"🈚","x":4,"y":47}],"version":1},"u7981":{"id":"u7981","name":"Japanese “prohibited” Button","keywords":["u7981","prohibited","kanji","chinese","forbidden","limit","restricted","red","square"],"skins":[{"unified":"1f232","native":"🈲","x":4,"y":49}],"version":1},"accept":{"id":"accept","name":"Circled Ideograph Accept","keywords":["japanese","acceptable","button","ok","good","chinese","kanji","agree","yes","orange","circle"],"skins":[{"unified":"1f251","native":"🉑","x":4,"y":59}],"version":1},"u7533":{"id":"u7533","name":"Japanese “application” Button","keywords":["u7533","application","chinese","kanji","orange","square"],"skins":[{"unified":"1f238","native":"🈸","x":4,"y":55}],"version":1},"u5408":{"id":"u5408","name":"Japanese “passing Grade” Button","keywords":["u5408","passing","grade","chinese","join","kanji","red","square"],"skins":[{"unified":"1f234","native":"🈴","x":4,"y":51}],"version":1},"u7a7a":{"id":"u7a7a","name":"Japanese “vacancy” Button","keywords":["u7a7a","vacancy","kanji","chinese","empty","sky","blue","square"],"skins":[{"unified":"1f233","native":"🈳","x":4,"y":50}],"version":1},"congratulations":{"id":"congratulations","name":"Circled Ideograph Congratulation","keywords":["congratulations","japanese","button","chinese","kanji","red","circle"],"skins":[{"unified":"3297-fe0f","native":"㊗️","x":59,"y":59}],"version":1},"secret":{"id":"secret","name":"Circled Ideograph Secret","keywords":["japanese","button","privacy","chinese","sshh","kanji","red","circle"],"skins":[{"unified":"3299-fe0f","native":"㊙️","x":59,"y":60}],"version":1},"u55b6":{"id":"u55b6","name":"Squared Cjk Unified Ideograph-55b6","keywords":["u55b6","japanese","open","for","business","button","opening","hours","orange","square"],"skins":[{"unified":"1f23a","native":"🈺","x":4,"y":57}],"version":1},"u6e80":{"id":"u6e80","name":"Japanese “no Vacancy” Button","keywords":["u6e80","no","vacancy","full","chinese","red","square","kanji"],"skins":[{"unified":"1f235","native":"🈵","x":4,"y":52}],"version":1},"red_circle":{"id":"red_circle","name":"Red Circle","keywords":["shape","error","danger"],"skins":[{"unified":"1f534","native":"🔴","x":30,"y":17}],"version":1},"large_orange_circle":{"id":"large_orange_circle","name":"Orange Circle","keywords":["large","round"],"skins":[{"unified":"1f7e0","native":"🟠","x":38,"y":33}],"version":12},"large_yellow_circle":{"id":"large_yellow_circle","name":"Yellow Circle","keywords":["large","round"],"skins":[{"unified":"1f7e1","native":"🟡","x":38,"y":34}],"version":12},"large_green_circle":{"id":"large_green_circle","name":"Green Circle","keywords":["large","round"],"skins":[{"unified":"1f7e2","native":"🟢","x":38,"y":35}],"version":12},"large_blue_circle":{"id":"large_blue_circle","name":"Blue Circle","keywords":["large","shape","icon","button"],"skins":[{"unified":"1f535","native":"🔵","x":30,"y":18}],"version":1},"large_purple_circle":{"id":"large_purple_circle","name":"Purple Circle","keywords":["large","round"],"skins":[{"unified":"1f7e3","native":"🟣","x":38,"y":36}],"version":12},"large_brown_circle":{"id":"large_brown_circle","name":"Brown Circle","keywords":["large","round"],"skins":[{"unified":"1f7e4","native":"🟤","x":38,"y":37}],"version":12},"black_circle":{"id":"black_circle","name":"Black Circle","keywords":["shape","button","round"],"skins":[{"unified":"26ab","native":"⚫","x":58,"y":11}],"version":1},"white_circle":{"id":"white_circle","name":"White Circle","keywords":["shape","round"],"skins":[{"unified":"26aa","native":"⚪","x":58,"y":10}],"version":1},"large_red_square":{"id":"large_red_square","name":"Red Square","keywords":["large"],"skins":[{"unified":"1f7e5","native":"🟥","x":38,"y":38}],"version":12},"large_orange_square":{"id":"large_orange_square","name":"Orange Square","keywords":["large"],"skins":[{"unified":"1f7e7","native":"🟧","x":38,"y":40}],"version":12},"large_yellow_square":{"id":"large_yellow_square","name":"Yellow Square","keywords":["large"],"skins":[{"unified":"1f7e8","native":"🟨","x":38,"y":41}],"version":12},"large_green_square":{"id":"large_green_square","name":"Green Square","keywords":["large"],"skins":[{"unified":"1f7e9","native":"🟩","x":38,"y":42}],"version":12},"large_blue_square":{"id":"large_blue_square","name":"Blue Square","keywords":["large"],"skins":[{"unified":"1f7e6","native":"🟦","x":38,"y":39}],"version":12},"large_purple_square":{"id":"large_purple_square","name":"Purple Square","keywords":["large"],"skins":[{"unified":"1f7ea","native":"🟪","x":38,"y":43}],"version":12},"large_brown_square":{"id":"large_brown_square","name":"Brown Square","keywords":["large"],"skins":[{"unified":"1f7eb","native":"🟫","x":38,"y":44}],"version":12},"black_large_square":{"id":"black_large_square","name":"Black Large Square","keywords":["shape","icon","button"],"skins":[{"unified":"2b1b","native":"⬛","x":59,"y":53}],"version":1},"white_large_square":{"id":"white_large_square","name":"White Large Square","keywords":["shape","icon","stone","button"],"skins":[{"unified":"2b1c","native":"⬜","x":59,"y":54}],"version":1},"black_medium_square":{"id":"black_medium_square","name":"Black Medium Square","keywords":["shape","button","icon"],"skins":[{"unified":"25fc-fe0f","native":"◼️","x":57,"y":7}],"version":1},"white_medium_square":{"id":"white_medium_square","name":"White Medium Square","keywords":["shape","stone","icon"],"skins":[{"unified":"25fb-fe0f","native":"◻️","x":57,"y":6}],"version":1},"black_medium_small_square":{"id":"black_medium_small_square","name":"Black Medium Small Square","keywords":["icon","shape","button"],"skins":[{"unified":"25fe","native":"◾","x":57,"y":9}],"version":1},"white_medium_small_square":{"id":"white_medium_small_square","name":"White Medium Small Square","keywords":["shape","stone","icon","button"],"skins":[{"unified":"25fd","native":"◽","x":57,"y":8}],"version":1},"black_small_square":{"id":"black_small_square","name":"Black Small Square","keywords":["shape","icon"],"skins":[{"unified":"25aa-fe0f","native":"▪️","x":57,"y":2}],"version":1},"white_small_square":{"id":"white_small_square","name":"White Small Square","keywords":["shape","icon"],"skins":[{"unified":"25ab-fe0f","native":"▫️","x":57,"y":3}],"version":1},"large_orange_diamond":{"id":"large_orange_diamond","name":"Large Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f536","native":"🔶","x":30,"y":19}],"version":1},"large_blue_diamond":{"id":"large_blue_diamond","name":"Large Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f537","native":"🔷","x":30,"y":20}],"version":1},"small_orange_diamond":{"id":"small_orange_diamond","name":"Small Orange Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f538","native":"🔸","x":30,"y":21}],"version":1},"small_blue_diamond":{"id":"small_blue_diamond","name":"Small Blue Diamond","keywords":["shape","jewel","gem"],"skins":[{"unified":"1f539","native":"🔹","x":30,"y":22}],"version":1},"small_red_triangle":{"id":"small_red_triangle","name":"Red Triangle Pointed Up","keywords":["small","shape","direction","top"],"skins":[{"unified":"1f53a","native":"🔺","x":30,"y":23}],"version":1},"small_red_triangle_down":{"id":"small_red_triangle_down","name":"Red Triangle Pointed Down","keywords":["small","shape","direction","bottom"],"skins":[{"unified":"1f53b","native":"🔻","x":30,"y":24}],"version":1},"diamond_shape_with_a_dot_inside":{"id":"diamond_shape_with_a_dot_inside","name":"Diamond with a Dot","keywords":["shape","inside","jewel","blue","gem","crystal","fancy"],"skins":[{"unified":"1f4a0","native":"💠","x":27,"y":48}],"version":1},"radio_button":{"id":"radio_button","name":"Radio Button","keywords":["input","old","music","circle"],"skins":[{"unified":"1f518","native":"🔘","x":29,"y":50}],"version":1},"white_square_button":{"id":"white_square_button","name":"White Square Button","keywords":["shape","input"],"skins":[{"unified":"1f533","native":"🔳","x":30,"y":16}],"version":1},"black_square_button":{"id":"black_square_button","name":"Black Square Button","keywords":["shape","input","frame"],"skins":[{"unified":"1f532","native":"🔲","x":30,"y":15}],"version":1},"checkered_flag":{"id":"checkered_flag","name":"Chequered Flag","keywords":["checkered","contest","finishline","race","gokart"],"skins":[{"unified":"1f3c1","native":"🏁","x":8,"y":7}],"version":1},"triangular_flag_on_post":{"id":"triangular_flag_on_post","name":"Triangular Flag","keywords":["on","post","mark","milestone","place"],"skins":[{"unified":"1f6a9","native":"🚩","x":36,"y":30}],"version":1},"crossed_flags":{"id":"crossed_flags","name":"Crossed Flags","keywords":["japanese","nation","country","border"],"skins":[{"unified":"1f38c","native":"🎌","x":7,"y":20}],"version":1},"waving_black_flag":{"id":"waving_black_flag","name":"Black Flag","keywords":["waving","pirate"],"skins":[{"unified":"1f3f4","native":"🏴","x":10,"y":35}],"version":1},"waving_white_flag":{"id":"waving_white_flag","name":"White Flag","keywords":["waving","losing","loser","lost","surrender","give","up","fail"],"skins":[{"unified":"1f3f3-fe0f","native":"🏳️","x":10,"y":30}],"version":1},"rainbow-flag":{"id":"rainbow-flag","name":"Rainbow Flag","keywords":["pride","gay","lgbt","glbt","queer","homosexual","lesbian","bisexual","transgender"],"skins":[{"unified":"1f3f3-fe0f-200d-1f308","native":"🏳️‍🌈","x":10,"y":28}],"version":4},"transgender_flag":{"id":"transgender_flag","name":"Transgender Flag","keywords":["lgbtq"],"skins":[{"unified":"1f3f3-fe0f-200d-26a7-fe0f","native":"🏳️‍⚧️","x":10,"y":29}],"version":13},"pirate_flag":{"id":"pirate_flag","name":"Pirate Flag","keywords":["skull","crossbones","banner"],"skins":[{"unified":"1f3f4-200d-2620-fe0f","native":"🏴‍☠️","x":10,"y":31}],"version":11},"flag-ac":{"id":"flag-ac","name":"Ascension Island Flag","keywords":["ac"],"skins":[{"unified":"1f1e6-1f1e8","native":"🇦🇨","x":0,"y":31}],"version":2},"flag-ad":{"id":"flag-ad","name":"Andorra Flag","keywords":["ad","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1e9","native":"🇦🇩","x":0,"y":32}],"version":2},"flag-ae":{"id":"flag-ae","name":"United Arab Emirates Flag","keywords":["ae","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ea","native":"🇦🇪","x":0,"y":33}],"version":2},"flag-af":{"id":"flag-af","name":"Afghanistan Flag","keywords":["af","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1eb","native":"🇦🇫","x":0,"y":34}],"version":2},"flag-ag":{"id":"flag-ag","name":"Antigua & Barbuda Flag","keywords":["ag","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ec","native":"🇦🇬","x":0,"y":35}],"version":2},"flag-ai":{"id":"flag-ai","name":"Anguilla Flag","keywords":["ai","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ee","native":"🇦🇮","x":0,"y":36}],"version":2},"flag-al":{"id":"flag-al","name":"Albania Flag","keywords":["al","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f1","native":"🇦🇱","x":0,"y":37}],"version":2},"flag-am":{"id":"flag-am","name":"Armenia Flag","keywords":["am","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f2","native":"🇦🇲","x":0,"y":38}],"version":2},"flag-ao":{"id":"flag-ao","name":"Angola Flag","keywords":["ao","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f4","native":"🇦🇴","x":0,"y":39}],"version":2},"flag-aq":{"id":"flag-aq","name":"Antarctica Flag","keywords":["aq","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f6","native":"🇦🇶","x":0,"y":40}],"version":2},"flag-ar":{"id":"flag-ar","name":"Argentina Flag","keywords":["ar","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f7","native":"🇦🇷","x":0,"y":41}],"version":2},"flag-as":{"id":"flag-as","name":"American Samoa Flag","keywords":["as","ws","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f8","native":"🇦🇸","x":0,"y":42}],"version":2},"flag-at":{"id":"flag-at","name":"Austria Flag","keywords":["at","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1f9","native":"🇦🇹","x":0,"y":43}],"version":2},"flag-au":{"id":"flag-au","name":"Australia Flag","keywords":["au","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fa","native":"🇦🇺","x":0,"y":44}],"version":2},"flag-aw":{"id":"flag-aw","name":"Aruba Flag","keywords":["aw","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fc","native":"🇦🇼","x":0,"y":45}],"version":2},"flag-ax":{"id":"flag-ax","name":"Åland Islands Flag","keywords":["ax","aland","Aland","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1fd","native":"🇦🇽","x":0,"y":46}],"version":2},"flag-az":{"id":"flag-az","name":"Azerbaijan Flag","keywords":["az","nation","country","banner"],"skins":[{"unified":"1f1e6-1f1ff","native":"🇦🇿","x":0,"y":47}],"version":2},"flag-ba":{"id":"flag-ba","name":"Bosnia & Herzegovina Flag","keywords":["ba","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e6","native":"🇧🇦","x":0,"y":48}],"version":2},"flag-bb":{"id":"flag-bb","name":"Barbados Flag","keywords":["bb","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e7","native":"🇧🇧","x":0,"y":49}],"version":2},"flag-bd":{"id":"flag-bd","name":"Bangladesh Flag","keywords":["bd","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1e9","native":"🇧🇩","x":0,"y":50}],"version":2},"flag-be":{"id":"flag-be","name":"Belgium Flag","keywords":["be","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ea","native":"🇧🇪","x":0,"y":51}],"version":2},"flag-bf":{"id":"flag-bf","name":"Burkina Faso Flag","keywords":["bf","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1eb","native":"🇧🇫","x":0,"y":52}],"version":2},"flag-bg":{"id":"flag-bg","name":"Bulgaria Flag","keywords":["bg","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ec","native":"🇧🇬","x":0,"y":53}],"version":2},"flag-bh":{"id":"flag-bh","name":"Bahrain Flag","keywords":["bh","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ed","native":"🇧🇭","x":0,"y":54}],"version":2},"flag-bi":{"id":"flag-bi","name":"Burundi Flag","keywords":["bi","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ee","native":"🇧🇮","x":0,"y":55}],"version":2},"flag-bj":{"id":"flag-bj","name":"Benin Flag","keywords":["bj","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ef","native":"🇧🇯","x":0,"y":56}],"version":2},"flag-bl":{"id":"flag-bl","name":"St. Barthélemy Flag","keywords":["bl","st","barthelemy","saint","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f1","native":"🇧🇱","x":0,"y":57}],"version":2},"flag-bm":{"id":"flag-bm","name":"Bermuda Flag","keywords":["bm","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f2","native":"🇧🇲","x":0,"y":58}],"version":2},"flag-bn":{"id":"flag-bn","name":"Brunei Flag","keywords":["bn","darussalam","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f3","native":"🇧🇳","x":0,"y":59}],"version":2},"flag-bo":{"id":"flag-bo","name":"Bolivia Flag","keywords":["bo","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f4","native":"🇧🇴","x":0,"y":60}],"version":2},"flag-bq":{"id":"flag-bq","name":"Caribbean Netherlands Flag","keywords":["bq","bonaire","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f6","native":"🇧🇶","x":1,"y":0}],"version":2},"flag-br":{"id":"flag-br","name":"Brazil Flag","keywords":["br","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f7","native":"🇧🇷","x":1,"y":1}],"version":2},"flag-bs":{"id":"flag-bs","name":"Bahamas Flag","keywords":["bs","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f8","native":"🇧🇸","x":1,"y":2}],"version":2},"flag-bt":{"id":"flag-bt","name":"Bhutan Flag","keywords":["bt","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1f9","native":"🇧🇹","x":1,"y":3}],"version":2},"flag-bv":{"id":"flag-bv","name":"Bouvet Island Flag","keywords":["bv","norway"],"skins":[{"unified":"1f1e7-1f1fb","native":"🇧🇻","x":1,"y":4}],"version":2},"flag-bw":{"id":"flag-bw","name":"Botswana Flag","keywords":["bw","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fc","native":"🇧🇼","x":1,"y":5}],"version":2},"flag-by":{"id":"flag-by","name":"Belarus Flag","keywords":["by","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1fe","native":"🇧🇾","x":1,"y":6}],"version":2},"flag-bz":{"id":"flag-bz","name":"Belize Flag","keywords":["bz","nation","country","banner"],"skins":[{"unified":"1f1e7-1f1ff","native":"🇧🇿","x":1,"y":7}],"version":2},"flag-ca":{"id":"flag-ca","name":"Canada Flag","keywords":["ca","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e6","native":"🇨🇦","x":1,"y":8}],"version":2},"flag-cc":{"id":"flag-cc","name":"Cocos (keeling) Islands Flag","keywords":["cc","keeling","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e8","native":"🇨🇨","x":1,"y":9}],"version":2},"flag-cd":{"id":"flag-cd","name":"Congo - Kinshasa Flag","keywords":["cd","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1e9","native":"🇨🇩","x":1,"y":10}],"version":2},"flag-cf":{"id":"flag-cf","name":"Central African Republic Flag","keywords":["cf","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1eb","native":"🇨🇫","x":1,"y":11}],"version":2},"flag-cg":{"id":"flag-cg","name":"Congo - Brazzaville Flag","keywords":["cg","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ec","native":"🇨🇬","x":1,"y":12}],"version":2},"flag-ch":{"id":"flag-ch","name":"Switzerland Flag","keywords":["ch","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ed","native":"🇨🇭","x":1,"y":13}],"version":2},"flag-ci":{"id":"flag-ci","name":"Côte D’ivoire Flag","keywords":["ci","cote","d","ivoire","ivory","coast","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ee","native":"🇨🇮","x":1,"y":14}],"version":2},"flag-ck":{"id":"flag-ck","name":"Cook Islands Flag","keywords":["ck","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f0","native":"🇨🇰","x":1,"y":15}],"version":2},"flag-cl":{"id":"flag-cl","name":"Chile Flag","keywords":["cl","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f1","native":"🇨🇱","x":1,"y":16}],"version":2},"flag-cm":{"id":"flag-cm","name":"Cameroon Flag","keywords":["cm","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f2","native":"🇨🇲","x":1,"y":17}],"version":2},"cn":{"id":"cn","name":"China Flag","keywords":["cn","chinese","prc","country","nation","banner"],"skins":[{"unified":"1f1e8-1f1f3","native":"🇨🇳","x":1,"y":18}],"version":1},"flag-co":{"id":"flag-co","name":"Colombia Flag","keywords":["co","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f4","native":"🇨🇴","x":1,"y":19}],"version":2},"flag-cp":{"id":"flag-cp","name":"Clipperton Island Flag","keywords":["cp"],"skins":[{"unified":"1f1e8-1f1f5","native":"🇨🇵","x":1,"y":20}],"version":2},"flag-cr":{"id":"flag-cr","name":"Costa Rica Flag","keywords":["cr","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1f7","native":"🇨🇷","x":1,"y":21}],"version":2},"flag-cu":{"id":"flag-cu","name":"Cuba Flag","keywords":["cu","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fa","native":"🇨🇺","x":1,"y":22}],"version":2},"flag-cv":{"id":"flag-cv","name":"Cape Verde Flag","keywords":["cv","cabo","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fb","native":"🇨🇻","x":1,"y":23}],"version":2},"flag-cw":{"id":"flag-cw","name":"Curaçao Flag","keywords":["cw","curacao","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fc","native":"🇨🇼","x":1,"y":24}],"version":2},"flag-cx":{"id":"flag-cx","name":"Christmas Island Flag","keywords":["cx","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fd","native":"🇨🇽","x":1,"y":25}],"version":2},"flag-cy":{"id":"flag-cy","name":"Cyprus Flag","keywords":["cy","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1fe","native":"🇨🇾","x":1,"y":26}],"version":2},"flag-cz":{"id":"flag-cz","name":"Czechia Flag","keywords":["cz","nation","country","banner"],"skins":[{"unified":"1f1e8-1f1ff","native":"🇨🇿","x":1,"y":27}],"version":2},"de":{"id":"de","name":"Germany Flag","keywords":["de","german","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ea","native":"🇩🇪","x":1,"y":28}],"version":1},"flag-dg":{"id":"flag-dg","name":"Diego Garcia Flag","keywords":["dg"],"skins":[{"unified":"1f1e9-1f1ec","native":"🇩🇬","x":1,"y":29}],"version":2},"flag-dj":{"id":"flag-dj","name":"Djibouti Flag","keywords":["dj","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ef","native":"🇩🇯","x":1,"y":30}],"version":2},"flag-dk":{"id":"flag-dk","name":"Denmark Flag","keywords":["dk","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f0","native":"🇩🇰","x":1,"y":31}],"version":2},"flag-dm":{"id":"flag-dm","name":"Dominica Flag","keywords":["dm","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f2","native":"🇩🇲","x":1,"y":32}],"version":2},"flag-do":{"id":"flag-do","name":"Dominican Republic Flag","keywords":["do","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1f4","native":"🇩🇴","x":1,"y":33}],"version":2},"flag-dz":{"id":"flag-dz","name":"Algeria Flag","keywords":["dz","nation","country","banner"],"skins":[{"unified":"1f1e9-1f1ff","native":"🇩🇿","x":1,"y":34}],"version":2},"flag-ea":{"id":"flag-ea","name":"Ceuta & Melilla Flag","keywords":["ea"],"skins":[{"unified":"1f1ea-1f1e6","native":"🇪🇦","x":1,"y":35}],"version":2},"flag-ec":{"id":"flag-ec","name":"Ecuador Flag","keywords":["ec","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1e8","native":"🇪🇨","x":1,"y":36}],"version":2},"flag-ee":{"id":"flag-ee","name":"Estonia Flag","keywords":["ee","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ea","native":"🇪🇪","x":1,"y":37}],"version":2},"flag-eg":{"id":"flag-eg","name":"Egypt Flag","keywords":["eg","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ec","native":"🇪🇬","x":1,"y":38}],"version":2},"flag-eh":{"id":"flag-eh","name":"Western Sahara Flag","keywords":["eh","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1ed","native":"🇪🇭","x":1,"y":39}],"version":2},"flag-er":{"id":"flag-er","name":"Eritrea Flag","keywords":["er","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f7","native":"🇪🇷","x":1,"y":40}],"version":2},"es":{"id":"es","name":"Spain Flag","keywords":["es","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f8","native":"🇪🇸","x":1,"y":41}],"version":1},"flag-et":{"id":"flag-et","name":"Ethiopia Flag","keywords":["et","nation","country","banner"],"skins":[{"unified":"1f1ea-1f1f9","native":"🇪🇹","x":1,"y":42}],"version":2},"flag-eu":{"id":"flag-eu","name":"European Union Flag","keywords":["eu","banner"],"skins":[{"unified":"1f1ea-1f1fa","native":"🇪🇺","x":1,"y":43}],"version":2},"flag-fi":{"id":"flag-fi","name":"Finland Flag","keywords":["fi","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ee","native":"🇫🇮","x":1,"y":44}],"version":2},"flag-fj":{"id":"flag-fj","name":"Fiji Flag","keywords":["fj","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1ef","native":"🇫🇯","x":1,"y":45}],"version":2},"flag-fk":{"id":"flag-fk","name":"Falkland Islands Flag","keywords":["fk","malvinas","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f0","native":"🇫🇰","x":1,"y":46}],"version":2},"flag-fm":{"id":"flag-fm","name":"Micronesia Flag","keywords":["fm","federated","states","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f2","native":"🇫🇲","x":1,"y":47}],"version":2},"flag-fo":{"id":"flag-fo","name":"Faroe Islands Flag","keywords":["fo","nation","country","banner"],"skins":[{"unified":"1f1eb-1f1f4","native":"🇫🇴","x":1,"y":48}],"version":2},"fr":{"id":"fr","name":"France Flag","keywords":["fr","banner","nation","french","country"],"skins":[{"unified":"1f1eb-1f1f7","native":"🇫🇷","x":1,"y":49}],"version":1},"flag-ga":{"id":"flag-ga","name":"Gabon Flag","keywords":["ga","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e6","native":"🇬🇦","x":1,"y":50}],"version":2},"gb":{"id":"gb","name":"United Kingdom Flag","keywords":["gb","uk","great","britain","northern","ireland","nation","country","banner","british","UK","english","england","union","jack"],"skins":[{"unified":"1f1ec-1f1e7","native":"🇬🇧","x":1,"y":51}],"version":1},"flag-gd":{"id":"flag-gd","name":"Grenada Flag","keywords":["gd","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1e9","native":"🇬🇩","x":1,"y":52}],"version":2},"flag-ge":{"id":"flag-ge","name":"Georgia Flag","keywords":["ge","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ea","native":"🇬🇪","x":1,"y":53}],"version":2},"flag-gf":{"id":"flag-gf","name":"French Guiana Flag","keywords":["gf","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1eb","native":"🇬🇫","x":1,"y":54}],"version":2},"flag-gg":{"id":"flag-gg","name":"Guernsey Flag","keywords":["gg","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ec","native":"🇬🇬","x":1,"y":55}],"version":2},"flag-gh":{"id":"flag-gh","name":"Ghana Flag","keywords":["gh","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ed","native":"🇬🇭","x":1,"y":56}],"version":2},"flag-gi":{"id":"flag-gi","name":"Gibraltar Flag","keywords":["gi","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1ee","native":"🇬🇮","x":1,"y":57}],"version":2},"flag-gl":{"id":"flag-gl","name":"Greenland Flag","keywords":["gl","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f1","native":"🇬🇱","x":1,"y":58}],"version":2},"flag-gm":{"id":"flag-gm","name":"Gambia Flag","keywords":["gm","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f2","native":"🇬🇲","x":1,"y":59}],"version":2},"flag-gn":{"id":"flag-gn","name":"Guinea Flag","keywords":["gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f3","native":"🇬🇳","x":1,"y":60}],"version":2},"flag-gp":{"id":"flag-gp","name":"Guadeloupe Flag","keywords":["gp","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f5","native":"🇬🇵","x":2,"y":0}],"version":2},"flag-gq":{"id":"flag-gq","name":"Equatorial Guinea Flag","keywords":["gq","gn","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f6","native":"🇬🇶","x":2,"y":1}],"version":2},"flag-gr":{"id":"flag-gr","name":"Greece Flag","keywords":["gr","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f7","native":"🇬🇷","x":2,"y":2}],"version":2},"flag-gs":{"id":"flag-gs","name":"South Georgia & South Sandwich Islands Flag","keywords":["gs","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f8","native":"🇬🇸","x":2,"y":3}],"version":2},"flag-gt":{"id":"flag-gt","name":"Guatemala Flag","keywords":["gt","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1f9","native":"🇬🇹","x":2,"y":4}],"version":2},"flag-gu":{"id":"flag-gu","name":"Guam Flag","keywords":["gu","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fa","native":"🇬🇺","x":2,"y":5}],"version":2},"flag-gw":{"id":"flag-gw","name":"Guinea-Bissau Flag","keywords":["gw","guinea","bissau","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fc","native":"🇬🇼","x":2,"y":6}],"version":2},"flag-gy":{"id":"flag-gy","name":"Guyana Flag","keywords":["gy","nation","country","banner"],"skins":[{"unified":"1f1ec-1f1fe","native":"🇬🇾","x":2,"y":7}],"version":2},"flag-hk":{"id":"flag-hk","name":"Hong Kong Sar China Flag","keywords":["hk","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f0","native":"🇭🇰","x":2,"y":8}],"version":2},"flag-hm":{"id":"flag-hm","name":"Heard & Mcdonald Islands Flag","keywords":["hm"],"skins":[{"unified":"1f1ed-1f1f2","native":"🇭🇲","x":2,"y":9}],"version":2},"flag-hn":{"id":"flag-hn","name":"Honduras Flag","keywords":["hn","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f3","native":"🇭🇳","x":2,"y":10}],"version":2},"flag-hr":{"id":"flag-hr","name":"Croatia Flag","keywords":["hr","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f7","native":"🇭🇷","x":2,"y":11}],"version":2},"flag-ht":{"id":"flag-ht","name":"Haiti Flag","keywords":["ht","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1f9","native":"🇭🇹","x":2,"y":12}],"version":2},"flag-hu":{"id":"flag-hu","name":"Hungary Flag","keywords":["hu","nation","country","banner"],"skins":[{"unified":"1f1ed-1f1fa","native":"🇭🇺","x":2,"y":13}],"version":2},"flag-ic":{"id":"flag-ic","name":"Canary Islands Flag","keywords":["ic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e8","native":"🇮🇨","x":2,"y":14}],"version":2},"flag-id":{"id":"flag-id","name":"Indonesia Flag","keywords":["id","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1e9","native":"🇮🇩","x":2,"y":15}],"version":2},"flag-ie":{"id":"flag-ie","name":"Ireland Flag","keywords":["ie","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1ea","native":"🇮🇪","x":2,"y":16}],"version":2},"flag-il":{"id":"flag-il","name":"Israel Flag","keywords":["il","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f1","native":"🇮🇱","x":2,"y":17}],"version":2},"flag-im":{"id":"flag-im","name":"Isle of Man Flag","keywords":["im","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f2","native":"🇮🇲","x":2,"y":18}],"version":2},"flag-in":{"id":"flag-in","name":"India Flag","keywords":["in","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f3","native":"🇮🇳","x":2,"y":19}],"version":2},"flag-io":{"id":"flag-io","name":"British Indian Ocean Territory Flag","keywords":["io","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f4","native":"🇮🇴","x":2,"y":20}],"version":2},"flag-iq":{"id":"flag-iq","name":"Iraq Flag","keywords":["iq","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f6","native":"🇮🇶","x":2,"y":21}],"version":2},"flag-ir":{"id":"flag-ir","name":"Iran Flag","keywords":["ir","islamic","republic","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f7","native":"🇮🇷","x":2,"y":22}],"version":2},"flag-is":{"id":"flag-is","name":"Iceland Flag","keywords":["is","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f8","native":"🇮🇸","x":2,"y":23}],"version":2},"it":{"id":"it","name":"Italy Flag","keywords":["it","nation","country","banner"],"skins":[{"unified":"1f1ee-1f1f9","native":"🇮🇹","x":2,"y":24}],"version":1},"flag-je":{"id":"flag-je","name":"Jersey Flag","keywords":["je","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1ea","native":"🇯🇪","x":2,"y":25}],"version":2},"flag-jm":{"id":"flag-jm","name":"Jamaica Flag","keywords":["jm","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f2","native":"🇯🇲","x":2,"y":26}],"version":2},"flag-jo":{"id":"flag-jo","name":"Jordan Flag","keywords":["jo","nation","country","banner"],"skins":[{"unified":"1f1ef-1f1f4","native":"🇯🇴","x":2,"y":27}],"version":2},"jp":{"id":"jp","name":"Japan Flag","keywords":["jp","japanese","nation","country","banner","ja"],"skins":[{"unified":"1f1ef-1f1f5","native":"🇯🇵","x":2,"y":28}],"version":1},"flag-ke":{"id":"flag-ke","name":"Kenya Flag","keywords":["ke","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ea","native":"🇰🇪","x":2,"y":29}],"version":2},"flag-kg":{"id":"flag-kg","name":"Kyrgyzstan Flag","keywords":["kg","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ec","native":"🇰🇬","x":2,"y":30}],"version":2},"flag-kh":{"id":"flag-kh","name":"Cambodia Flag","keywords":["kh","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ed","native":"🇰🇭","x":2,"y":31}],"version":2},"flag-ki":{"id":"flag-ki","name":"Kiribati Flag","keywords":["ki","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ee","native":"🇰🇮","x":2,"y":32}],"version":2},"flag-km":{"id":"flag-km","name":"Comoros Flag","keywords":["km","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f2","native":"🇰🇲","x":2,"y":33}],"version":2},"flag-kn":{"id":"flag-kn","name":"St. Kitts & Nevis Flag","keywords":["kn","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f3","native":"🇰🇳","x":2,"y":34}],"version":2},"flag-kp":{"id":"flag-kp","name":"North Korea Flag","keywords":["kp","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f5","native":"🇰🇵","x":2,"y":35}],"version":2},"kr":{"id":"kr","name":"South Korea Flag","keywords":["kr","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1f7","native":"🇰🇷","x":2,"y":36}],"version":1},"flag-kw":{"id":"flag-kw","name":"Kuwait Flag","keywords":["kw","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fc","native":"🇰🇼","x":2,"y":37}],"version":2},"flag-ky":{"id":"flag-ky","name":"Cayman Islands Flag","keywords":["ky","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1fe","native":"🇰🇾","x":2,"y":38}],"version":2},"flag-kz":{"id":"flag-kz","name":"Kazakhstan Flag","keywords":["kz","nation","country","banner"],"skins":[{"unified":"1f1f0-1f1ff","native":"🇰🇿","x":2,"y":39}],"version":2},"flag-la":{"id":"flag-la","name":"Laos Flag","keywords":["la","lao","democratic","republic","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e6","native":"🇱🇦","x":2,"y":40}],"version":2},"flag-lb":{"id":"flag-lb","name":"Lebanon Flag","keywords":["lb","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e7","native":"🇱🇧","x":2,"y":41}],"version":2},"flag-lc":{"id":"flag-lc","name":"St. Lucia Flag","keywords":["lc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1e8","native":"🇱🇨","x":2,"y":42}],"version":2},"flag-li":{"id":"flag-li","name":"Liechtenstein Flag","keywords":["li","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1ee","native":"🇱🇮","x":2,"y":43}],"version":2},"flag-lk":{"id":"flag-lk","name":"Sri Lanka Flag","keywords":["lk","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f0","native":"🇱🇰","x":2,"y":44}],"version":2},"flag-lr":{"id":"flag-lr","name":"Liberia Flag","keywords":["lr","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f7","native":"🇱🇷","x":2,"y":45}],"version":2},"flag-ls":{"id":"flag-ls","name":"Lesotho Flag","keywords":["ls","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f8","native":"🇱🇸","x":2,"y":46}],"version":2},"flag-lt":{"id":"flag-lt","name":"Lithuania Flag","keywords":["lt","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1f9","native":"🇱🇹","x":2,"y":47}],"version":2},"flag-lu":{"id":"flag-lu","name":"Luxembourg Flag","keywords":["lu","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fa","native":"🇱🇺","x":2,"y":48}],"version":2},"flag-lv":{"id":"flag-lv","name":"Latvia Flag","keywords":["lv","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fb","native":"🇱🇻","x":2,"y":49}],"version":2},"flag-ly":{"id":"flag-ly","name":"Libya Flag","keywords":["ly","nation","country","banner"],"skins":[{"unified":"1f1f1-1f1fe","native":"🇱🇾","x":2,"y":50}],"version":2},"flag-ma":{"id":"flag-ma","name":"Morocco Flag","keywords":["ma","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e6","native":"🇲🇦","x":2,"y":51}],"version":2},"flag-mc":{"id":"flag-mc","name":"Monaco Flag","keywords":["mc","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e8","native":"🇲🇨","x":2,"y":52}],"version":2},"flag-md":{"id":"flag-md","name":"Moldova Flag","keywords":["md","republic","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1e9","native":"🇲🇩","x":2,"y":53}],"version":2},"flag-me":{"id":"flag-me","name":"Montenegro Flag","keywords":["me","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ea","native":"🇲🇪","x":2,"y":54}],"version":2},"flag-mf":{"id":"flag-mf","name":"St. Martin Flag","keywords":["mf","st"],"skins":[{"unified":"1f1f2-1f1eb","native":"🇲🇫","x":2,"y":55}],"version":2},"flag-mg":{"id":"flag-mg","name":"Madagascar Flag","keywords":["mg","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ec","native":"🇲🇬","x":2,"y":56}],"version":2},"flag-mh":{"id":"flag-mh","name":"Marshall Islands Flag","keywords":["mh","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ed","native":"🇲🇭","x":2,"y":57}],"version":2},"flag-mk":{"id":"flag-mk","name":"North Macedonia Flag","keywords":["mk","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f0","native":"🇲🇰","x":2,"y":58}],"version":2},"flag-ml":{"id":"flag-ml","name":"Mali Flag","keywords":["ml","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f1","native":"🇲🇱","x":2,"y":59}],"version":2},"flag-mm":{"id":"flag-mm","name":"Myanmar (burma) Flag","keywords":["mm","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f2","native":"🇲🇲","x":2,"y":60}],"version":2},"flag-mn":{"id":"flag-mn","name":"Mongolia Flag","keywords":["mn","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f3","native":"🇲🇳","x":3,"y":0}],"version":2},"flag-mo":{"id":"flag-mo","name":"Macao Sar China Flag","keywords":["mo","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f4","native":"🇲🇴","x":3,"y":1}],"version":2},"flag-mp":{"id":"flag-mp","name":"Northern Mariana Islands Flag","keywords":["mp","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f5","native":"🇲🇵","x":3,"y":2}],"version":2},"flag-mq":{"id":"flag-mq","name":"Martinique Flag","keywords":["mq","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f6","native":"🇲🇶","x":3,"y":3}],"version":2},"flag-mr":{"id":"flag-mr","name":"Mauritania Flag","keywords":["mr","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f7","native":"🇲🇷","x":3,"y":4}],"version":2},"flag-ms":{"id":"flag-ms","name":"Montserrat Flag","keywords":["ms","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f8","native":"🇲🇸","x":3,"y":5}],"version":2},"flag-mt":{"id":"flag-mt","name":"Malta Flag","keywords":["mt","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1f9","native":"🇲🇹","x":3,"y":6}],"version":2},"flag-mu":{"id":"flag-mu","name":"Mauritius Flag","keywords":["mu","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fa","native":"🇲🇺","x":3,"y":7}],"version":2},"flag-mv":{"id":"flag-mv","name":"Maldives Flag","keywords":["mv","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fb","native":"🇲🇻","x":3,"y":8}],"version":2},"flag-mw":{"id":"flag-mw","name":"Malawi Flag","keywords":["mw","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fc","native":"🇲🇼","x":3,"y":9}],"version":2},"flag-mx":{"id":"flag-mx","name":"Mexico Flag","keywords":["mx","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fd","native":"🇲🇽","x":3,"y":10}],"version":2},"flag-my":{"id":"flag-my","name":"Malaysia Flag","keywords":["my","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1fe","native":"🇲🇾","x":3,"y":11}],"version":2},"flag-mz":{"id":"flag-mz","name":"Mozambique Flag","keywords":["mz","nation","country","banner"],"skins":[{"unified":"1f1f2-1f1ff","native":"🇲🇿","x":3,"y":12}],"version":2},"flag-na":{"id":"flag-na","name":"Namibia Flag","keywords":["na","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e6","native":"🇳🇦","x":3,"y":13}],"version":2},"flag-nc":{"id":"flag-nc","name":"New Caledonia Flag","keywords":["nc","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1e8","native":"🇳🇨","x":3,"y":14}],"version":2},"flag-ne":{"id":"flag-ne","name":"Niger Flag","keywords":["ne","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ea","native":"🇳🇪","x":3,"y":15}],"version":2},"flag-nf":{"id":"flag-nf","name":"Norfolk Island Flag","keywords":["nf","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1eb","native":"🇳🇫","x":3,"y":16}],"version":2},"flag-ng":{"id":"flag-ng","name":"Nigeria Flag","keywords":["ng","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ec","native":"🇳🇬","x":3,"y":17}],"version":2},"flag-ni":{"id":"flag-ni","name":"Nicaragua Flag","keywords":["ni","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ee","native":"🇳🇮","x":3,"y":18}],"version":2},"flag-nl":{"id":"flag-nl","name":"Netherlands Flag","keywords":["nl","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f1","native":"🇳🇱","x":3,"y":19}],"version":2},"flag-no":{"id":"flag-no","name":"Norway Flag","keywords":["no","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f4","native":"🇳🇴","x":3,"y":20}],"version":2},"flag-np":{"id":"flag-np","name":"Nepal Flag","keywords":["np","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f5","native":"🇳🇵","x":3,"y":21}],"version":2},"flag-nr":{"id":"flag-nr","name":"Nauru Flag","keywords":["nr","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1f7","native":"🇳🇷","x":3,"y":22}],"version":2},"flag-nu":{"id":"flag-nu","name":"Niue Flag","keywords":["nu","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1fa","native":"🇳🇺","x":3,"y":23}],"version":2},"flag-nz":{"id":"flag-nz","name":"New Zealand Flag","keywords":["nz","nation","country","banner"],"skins":[{"unified":"1f1f3-1f1ff","native":"🇳🇿","x":3,"y":24}],"version":2},"flag-om":{"id":"flag-om","name":"Oman Flag","keywords":["om","symbol","nation","country","banner"],"skins":[{"unified":"1f1f4-1f1f2","native":"🇴🇲","x":3,"y":25}],"version":2},"flag-pa":{"id":"flag-pa","name":"Panama Flag","keywords":["pa","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1e6","native":"🇵🇦","x":3,"y":26}],"version":2},"flag-pe":{"id":"flag-pe","name":"Peru Flag","keywords":["pe","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ea","native":"🇵🇪","x":3,"y":27}],"version":2},"flag-pf":{"id":"flag-pf","name":"French Polynesia Flag","keywords":["pf","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1eb","native":"🇵🇫","x":3,"y":28}],"version":2},"flag-pg":{"id":"flag-pg","name":"Papua New Guinea Flag","keywords":["pg","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ec","native":"🇵🇬","x":3,"y":29}],"version":2},"flag-ph":{"id":"flag-ph","name":"Philippines Flag","keywords":["ph","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1ed","native":"🇵🇭","x":3,"y":30}],"version":2},"flag-pk":{"id":"flag-pk","name":"Pakistan Flag","keywords":["pk","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f0","native":"🇵🇰","x":3,"y":31}],"version":2},"flag-pl":{"id":"flag-pl","name":"Poland Flag","keywords":["pl","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f1","native":"🇵🇱","x":3,"y":32}],"version":2},"flag-pm":{"id":"flag-pm","name":"St. Pierre & Miquelon Flag","keywords":["pm","st","saint","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f2","native":"🇵🇲","x":3,"y":33}],"version":2},"flag-pn":{"id":"flag-pn","name":"Pitcairn Islands Flag","keywords":["pn","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f3","native":"🇵🇳","x":3,"y":34}],"version":2},"flag-pr":{"id":"flag-pr","name":"Puerto Rico Flag","keywords":["pr","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f7","native":"🇵🇷","x":3,"y":35}],"version":2},"flag-ps":{"id":"flag-ps","name":"Palestinian Territories Flag","keywords":["ps","palestine","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f8","native":"🇵🇸","x":3,"y":36}],"version":2},"flag-pt":{"id":"flag-pt","name":"Portugal Flag","keywords":["pt","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1f9","native":"🇵🇹","x":3,"y":37}],"version":2},"flag-pw":{"id":"flag-pw","name":"Palau Flag","keywords":["pw","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fc","native":"🇵🇼","x":3,"y":38}],"version":2},"flag-py":{"id":"flag-py","name":"Paraguay Flag","keywords":["py","nation","country","banner"],"skins":[{"unified":"1f1f5-1f1fe","native":"🇵🇾","x":3,"y":39}],"version":2},"flag-qa":{"id":"flag-qa","name":"Qatar Flag","keywords":["qa","nation","country","banner"],"skins":[{"unified":"1f1f6-1f1e6","native":"🇶🇦","x":3,"y":40}],"version":2},"flag-re":{"id":"flag-re","name":"Réunion Flag","keywords":["re","reunion","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1ea","native":"🇷🇪","x":3,"y":41}],"version":2},"flag-ro":{"id":"flag-ro","name":"Romania Flag","keywords":["ro","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f4","native":"🇷🇴","x":3,"y":42}],"version":2},"flag-rs":{"id":"flag-rs","name":"Serbia Flag","keywords":["rs","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1f8","native":"🇷🇸","x":3,"y":43}],"version":2},"ru":{"id":"ru","name":"Russia Flag","keywords":["ru","russian","federation","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fa","native":"🇷🇺","x":3,"y":44}],"version":1},"flag-rw":{"id":"flag-rw","name":"Rwanda Flag","keywords":["rw","nation","country","banner"],"skins":[{"unified":"1f1f7-1f1fc","native":"🇷🇼","x":3,"y":45}],"version":2},"flag-sa":{"id":"flag-sa","name":"Saudi Arabia Flag","keywords":["sa","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e6","native":"🇸🇦","x":3,"y":46}],"version":2},"flag-sb":{"id":"flag-sb","name":"Solomon Islands Flag","keywords":["sb","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e7","native":"🇸🇧","x":3,"y":47}],"version":2},"flag-sc":{"id":"flag-sc","name":"Seychelles Flag","keywords":["sc","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e8","native":"🇸🇨","x":3,"y":48}],"version":2},"flag-sd":{"id":"flag-sd","name":"Sudan Flag","keywords":["sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1e9","native":"🇸🇩","x":3,"y":49}],"version":2},"flag-se":{"id":"flag-se","name":"Sweden Flag","keywords":["se","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ea","native":"🇸🇪","x":3,"y":50}],"version":2},"flag-sg":{"id":"flag-sg","name":"Singapore Flag","keywords":["sg","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ec","native":"🇸🇬","x":3,"y":51}],"version":2},"flag-sh":{"id":"flag-sh","name":"St. Helena Flag","keywords":["sh","st","saint","ascension","tristan","cunha","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ed","native":"🇸🇭","x":3,"y":52}],"version":2},"flag-si":{"id":"flag-si","name":"Slovenia Flag","keywords":["si","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ee","native":"🇸🇮","x":3,"y":53}],"version":2},"flag-sj":{"id":"flag-sj","name":"Svalbard & Jan Mayen Flag","keywords":["sj"],"skins":[{"unified":"1f1f8-1f1ef","native":"🇸🇯","x":3,"y":54}],"version":2},"flag-sk":{"id":"flag-sk","name":"Slovakia Flag","keywords":["sk","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f0","native":"🇸🇰","x":3,"y":55}],"version":2},"flag-sl":{"id":"flag-sl","name":"Sierra Leone Flag","keywords":["sl","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f1","native":"🇸🇱","x":3,"y":56}],"version":2},"flag-sm":{"id":"flag-sm","name":"San Marino Flag","keywords":["sm","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f2","native":"🇸🇲","x":3,"y":57}],"version":2},"flag-sn":{"id":"flag-sn","name":"Senegal Flag","keywords":["sn","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f3","native":"🇸🇳","x":3,"y":58}],"version":2},"flag-so":{"id":"flag-so","name":"Somalia Flag","keywords":["so","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f4","native":"🇸🇴","x":3,"y":59}],"version":2},"flag-sr":{"id":"flag-sr","name":"Suriname Flag","keywords":["sr","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f7","native":"🇸🇷","x":3,"y":60}],"version":2},"flag-ss":{"id":"flag-ss","name":"South Sudan Flag","keywords":["ss","sd","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f8","native":"🇸🇸","x":4,"y":0}],"version":2},"flag-st":{"id":"flag-st","name":"São Tomé & Príncipe Flag","keywords":["st","sao","tome","principe","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1f9","native":"🇸🇹","x":4,"y":1}],"version":2},"flag-sv":{"id":"flag-sv","name":"El Salvador Flag","keywords":["sv","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fb","native":"🇸🇻","x":4,"y":2}],"version":2},"flag-sx":{"id":"flag-sx","name":"Sint Maarten Flag","keywords":["sx","dutch","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fd","native":"🇸🇽","x":4,"y":3}],"version":2},"flag-sy":{"id":"flag-sy","name":"Syria Flag","keywords":["sy","syrian","arab","republic","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1fe","native":"🇸🇾","x":4,"y":4}],"version":2},"flag-sz":{"id":"flag-sz","name":"Eswatini Flag","keywords":["sz","nation","country","banner"],"skins":[{"unified":"1f1f8-1f1ff","native":"🇸🇿","x":4,"y":5}],"version":2},"flag-ta":{"id":"flag-ta","name":"Tristan Da Cunha Flag","keywords":["ta"],"skins":[{"unified":"1f1f9-1f1e6","native":"🇹🇦","x":4,"y":6}],"version":2},"flag-tc":{"id":"flag-tc","name":"Turks & Caicos Islands Flag","keywords":["tc","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e8","native":"🇹🇨","x":4,"y":7}],"version":2},"flag-td":{"id":"flag-td","name":"Chad Flag","keywords":["td","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1e9","native":"🇹🇩","x":4,"y":8}],"version":2},"flag-tf":{"id":"flag-tf","name":"French Southern Territories Flag","keywords":["tf","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1eb","native":"🇹🇫","x":4,"y":9}],"version":2},"flag-tg":{"id":"flag-tg","name":"Togo Flag","keywords":["tg","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ec","native":"🇹🇬","x":4,"y":10}],"version":2},"flag-th":{"id":"flag-th","name":"Thailand Flag","keywords":["th","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ed","native":"🇹🇭","x":4,"y":11}],"version":2},"flag-tj":{"id":"flag-tj","name":"Tajikistan Flag","keywords":["tj","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ef","native":"🇹🇯","x":4,"y":12}],"version":2},"flag-tk":{"id":"flag-tk","name":"Tokelau Flag","keywords":["tk","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f0","native":"🇹🇰","x":4,"y":13}],"version":2},"flag-tl":{"id":"flag-tl","name":"Timor-Leste Flag","keywords":["tl","timor","leste","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f1","native":"🇹🇱","x":4,"y":14}],"version":2},"flag-tm":{"id":"flag-tm","name":"Turkmenistan Flag","keywords":["tm","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f2","native":"🇹🇲","x":4,"y":15}],"version":2},"flag-tn":{"id":"flag-tn","name":"Tunisia Flag","keywords":["tn","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f3","native":"🇹🇳","x":4,"y":16}],"version":2},"flag-to":{"id":"flag-to","name":"Tonga Flag","keywords":["to","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f4","native":"🇹🇴","x":4,"y":17}],"version":2},"flag-tr":{"id":"flag-tr","name":"Turkey Flag","keywords":["tr","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f7","native":"🇹🇷","x":4,"y":18}],"version":2},"flag-tt":{"id":"flag-tt","name":"Trinidad & Tobago Flag","keywords":["tt","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1f9","native":"🇹🇹","x":4,"y":19}],"version":2},"flag-tv":{"id":"flag-tv","name":"Tuvalu Flag","keywords":["tv","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fb","native":"🇹🇻","x":4,"y":20}],"version":2},"flag-tw":{"id":"flag-tw","name":"Taiwan Flag","keywords":["tw","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1fc","native":"🇹🇼","x":4,"y":21}],"version":2},"flag-tz":{"id":"flag-tz","name":"Tanzania Flag","keywords":["tz","united","republic","nation","country","banner"],"skins":[{"unified":"1f1f9-1f1ff","native":"🇹🇿","x":4,"y":22}],"version":2},"flag-ua":{"id":"flag-ua","name":"Ukraine Flag","keywords":["ua","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1e6","native":"🇺🇦","x":4,"y":23}],"version":2},"flag-ug":{"id":"flag-ug","name":"Uganda Flag","keywords":["ug","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ec","native":"🇺🇬","x":4,"y":24}],"version":2},"flag-um":{"id":"flag-um","name":"U.s. Outlying Islands Flag","keywords":["um","u","s"],"skins":[{"unified":"1f1fa-1f1f2","native":"🇺🇲","x":4,"y":25}],"version":2},"flag-un":{"id":"flag-un","name":"United Nations Flag","keywords":["un","banner"],"skins":[{"unified":"1f1fa-1f1f3","native":"🇺🇳","x":4,"y":26}],"version":4},"us":{"id":"us","name":"United States Flag","keywords":["us","america","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1f8","native":"🇺🇸","x":4,"y":27}],"version":1},"flag-uy":{"id":"flag-uy","name":"Uruguay Flag","keywords":["uy","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1fe","native":"🇺🇾","x":4,"y":28}],"version":2},"flag-uz":{"id":"flag-uz","name":"Uzbekistan Flag","keywords":["uz","nation","country","banner"],"skins":[{"unified":"1f1fa-1f1ff","native":"🇺🇿","x":4,"y":29}],"version":2},"flag-va":{"id":"flag-va","name":"Vatican City Flag","keywords":["va","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e6","native":"🇻🇦","x":4,"y":30}],"version":2},"flag-vc":{"id":"flag-vc","name":"St. Vincent & Grenadines Flag","keywords":["vc","st","saint","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1e8","native":"🇻🇨","x":4,"y":31}],"version":2},"flag-ve":{"id":"flag-ve","name":"Venezuela Flag","keywords":["ve","bolivarian","republic","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ea","native":"🇻🇪","x":4,"y":32}],"version":2},"flag-vg":{"id":"flag-vg","name":"British Virgin Islands Flag","keywords":["vg","bvi","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ec","native":"🇻🇬","x":4,"y":33}],"version":2},"flag-vi":{"id":"flag-vi","name":"U.s. Virgin Islands Flag","keywords":["vi","u","s","us","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1ee","native":"🇻🇮","x":4,"y":34}],"version":2},"flag-vn":{"id":"flag-vn","name":"Vietnam Flag","keywords":["vn","viet","nam","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1f3","native":"🇻🇳","x":4,"y":35}],"version":2},"flag-vu":{"id":"flag-vu","name":"Vanuatu Flag","keywords":["vu","nation","country","banner"],"skins":[{"unified":"1f1fb-1f1fa","native":"🇻🇺","x":4,"y":36}],"version":2},"flag-wf":{"id":"flag-wf","name":"Wallis & Futuna Flag","keywords":["wf","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1eb","native":"🇼🇫","x":4,"y":37}],"version":2},"flag-ws":{"id":"flag-ws","name":"Samoa Flag","keywords":["ws","nation","country","banner"],"skins":[{"unified":"1f1fc-1f1f8","native":"🇼🇸","x":4,"y":38}],"version":2},"flag-xk":{"id":"flag-xk","name":"Kosovo Flag","keywords":["xk","nation","country","banner"],"skins":[{"unified":"1f1fd-1f1f0","native":"🇽🇰","x":4,"y":39}],"version":2},"flag-ye":{"id":"flag-ye","name":"Yemen Flag","keywords":["ye","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1ea","native":"🇾🇪","x":4,"y":40}],"version":2},"flag-yt":{"id":"flag-yt","name":"Mayotte Flag","keywords":["yt","nation","country","banner"],"skins":[{"unified":"1f1fe-1f1f9","native":"🇾🇹","x":4,"y":41}],"version":2},"flag-za":{"id":"flag-za","name":"South Africa Flag","keywords":["za","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1e6","native":"🇿🇦","x":4,"y":42}],"version":2},"flag-zm":{"id":"flag-zm","name":"Zambia Flag","keywords":["zm","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1f2","native":"🇿🇲","x":4,"y":43}],"version":2},"flag-zw":{"id":"flag-zw","name":"Zimbabwe Flag","keywords":["zw","nation","country","banner"],"skins":[{"unified":"1f1ff-1f1fc","native":"🇿🇼","x":4,"y":44}],"version":2},"flag-england":{"id":"flag-england","name":"England Flag","keywords":["english"],"skins":[{"unified":"1f3f4-e0067-e0062-e0065-e006e-e0067-e007f","native":"🏴󠁧󠁢󠁥󠁮󠁧󠁿","x":10,"y":32}],"version":5},"flag-scotland":{"id":"flag-scotland","name":"Scotland Flag","keywords":["scottish"],"skins":[{"unified":"1f3f4-e0067-e0062-e0073-e0063-e0074-e007f","native":"🏴󠁧󠁢󠁳󠁣󠁴󠁿","x":10,"y":33}],"version":5},"flag-wales":{"id":"flag-wales","name":"Wales Flag","keywords":["welsh"],"skins":[{"unified":"1f3f4-e0067-e0062-e0077-e006c-e0073-e007f","native":"🏴󠁧󠁢󠁷󠁬󠁳󠁿","x":10,"y":34}],"version":5}}`), PF = { satisfied: "laughing", grinning_face_with_star_eyes: "star-struck", grinning_face_with_one_large_and_one_small_eye: "zany_face", smiling_face_with_smiling_eyes_and_hand_covering_mouth: "face_with_hand_over_mouth", face_with_finger_covering_closed_lips: "shushing_face", face_with_one_eyebrow_raised: "face_with_raised_eyebrow", face_with_open_mouth_vomiting: "face_vomiting", shocked_face_with_exploding_head: "exploding_head", serious_face_with_symbols_covering_mouth: "face_with_symbols_on_mouth", poop: "hankey", shit: "hankey", collision: "boom", raised_hand: "hand", hand_with_index_and_middle_fingers_crossed: "crossed_fingers", sign_of_the_horns: "the_horns", reversed_hand_with_middle_finger_extended: "middle_finger", thumbsup: "+1", thumbsdown: "-1", punch: "facepunch", mother_christmas: "mrs_claus", running: "runner", "man-with-bunny-ears-partying": "men-with-bunny-ears-partying", "woman-with-bunny-ears-partying": "women-with-bunny-ears-partying", women_holding_hands: "two_women_holding_hands", woman_and_man_holding_hands: "man_and_woman_holding_hands", couple: "man_and_woman_holding_hands", men_holding_hands: "two_men_holding_hands", paw_prints: "feet", flipper: "dolphin", honeybee: "bee", lady_beetle: "ladybug", cooking: "fried_egg", knife: "hocho", red_car: "car", sailboat: "boat", waxing_gibbous_moon: "moon", sun_small_cloud: "mostly_sunny", sun_behind_cloud: "barely_sunny", sun_behind_rain_cloud: "partly_sunny_rain", lightning_cloud: "lightning", tornado_cloud: "tornado", tshirt: "shirt", shoe: "mans_shoe", telephone: "phone", lantern: "izakaya_lantern", open_book: "book", envelope: "email", pencil: "memo", heavy_exclamation_mark: "exclamation", staff_of_aesculapius: "medical_symbol", "flag-cn": "cn", "flag-de": "de", "flag-es": "es", "flag-fr": "fr", uk: "gb", "flag-gb": "gb", "flag-it": "it", "flag-jp": "jp", "flag-kr": "kr", "flag-ru": "ru", "flag-us": "us" }, SF = { cols: 61, rows: 61 }, NF = {
  categories: MF,
  emojis: CF,
  aliases: PF,
  sheet: SF
};
function CM(t) {
  return t && t.__esModule ? t.default : t;
}
function hi(t, e, n) {
  return e in t ? Object.defineProperty(t, e, {
    value: n,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = n, t;
}
var Zm, Ie, PM, zl, SM, hk, ff = {}, NM = [], $F = /acit|ex(?:s|g|n|p|$)|rph|grid|ows|mnc|ntw|ine[ch]|zoo|^ord|itera/i;
function da(t, e) {
  for (var n in e) t[n] = e[n];
  return t;
}
function $M(t) {
  var e = t.parentNode;
  e && e.removeChild(t);
}
function Gp(t, e, n) {
  var i, r, a, o = {};
  for (a in e) a == "key" ? i = e[a] : a == "ref" ? r = e[a] : o[a] = e[a];
  if (arguments.length > 2 && (o.children = arguments.length > 3 ? Zm.call(arguments, 2) : n), typeof t == "function" && t.defaultProps != null) for (a in t.defaultProps) o[a] === void 0 && (o[a] = t.defaultProps[a]);
  return wu(t, o, i, r, null);
}
function wu(t, e, n, i, r) {
  var a = {
    type: t,
    props: e,
    key: n,
    ref: i,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: r ?? ++PM
  };
  return r == null && Ie.vnode != null && Ie.vnode(a), a;
}
function wr() {
  return {
    current: null
  };
}
function xs(t) {
  return t.children;
}
function cr(t, e) {
  this.props = t, this.context = e;
}
function _s(t, e) {
  if (e == null) return t.__ ? _s(t.__, t.__.__k.indexOf(t) + 1) : null;
  for (var n; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) return n.__e;
  return typeof t.type == "function" ? _s(t) : null;
}
function DM(t) {
  var e, n;
  if ((t = t.__) != null && t.__c != null) {
    for (t.__e = t.__c.base = null, e = 0; e < t.__k.length; e++) if ((n = t.__k[e]) != null && n.__e != null) {
      t.__e = t.__c.base = n.__e;
      break;
    }
    return DM(t);
  }
}
function pk(t) {
  (!t.__d && (t.__d = !0) && zl.push(t) && !mf.__r++ || hk !== Ie.debounceRendering) && ((hk = Ie.debounceRendering) || SM)(mf);
}
function mf() {
  for (var t; mf.__r = zl.length; ) t = zl.sort(function(e, n) {
    return e.__v.__b - n.__v.__b;
  }), zl = [], t.some(function(e) {
    var n, i, r, a, o, s;
    e.__d && (o = (a = (n = e).__v).__e, (s = n.__P) && (i = [], (r = da({}, a)).__v = a.__v + 1, Dv(s, a, r, n.__n, s.ownerSVGElement !== void 0, a.__h != null ? [
      o
    ] : null, i, o ?? _s(a), a.__h), WM(i, a), a.__e != o && DM(a)));
  });
}
function EM(t, e, n, i, r, a, o, s, l, c) {
  var u, f, m, h, p, g, y, v = i && i.__k || NM, w = v.length;
  for (n.__k = [], u = 0; u < e.length; u++) if ((h = n.__k[u] = (h = e[u]) == null || typeof h == "boolean" ? null : typeof h == "string" || typeof h == "number" || typeof h == "bigint" ? wu(null, h, null, null, h) : Array.isArray(h) ? wu(xs, {
    children: h
  }, null, null, null) : h.__b > 0 ? wu(h.type, h.props, h.key, null, h.__v) : h) != null) {
    if (h.__ = n, h.__b = n.__b + 1, (m = v[u]) === null || m && h.key == m.key && h.type === m.type) v[u] = void 0;
    else for (f = 0; f < w; f++) {
      if ((m = v[f]) && h.key == m.key && h.type === m.type) {
        v[f] = void 0;
        break;
      }
      m = null;
    }
    Dv(t, h, m = m || ff, r, a, o, s, l, c), p = h.__e, (f = h.ref) && m.ref != f && (y || (y = []), m.ref && y.push(m.ref, null, h), y.push(f, h.__c || p, h)), p != null ? (g == null && (g = p), typeof h.type == "function" && h.__k === m.__k ? h.__d = l = TM(h, l, t) : l = OM(t, h, m, v, p, l), typeof n.type == "function" && (n.__d = l)) : l && m.__e == l && l.parentNode != t && (l = _s(m));
  }
  for (n.__e = g, u = w; u--; ) v[u] != null && (typeof n.type == "function" && v[u].__e != null && v[u].__e == n.__d && (n.__d = _s(i, u + 1)), LM(v[u], v[u]));
  if (y) for (u = 0; u < y.length; u++) AM(y[u], y[++u], y[++u]);
}
function TM(t, e, n) {
  for (var i, r = t.__k, a = 0; r && a < r.length; a++) (i = r[a]) && (i.__ = t, e = typeof i.type == "function" ? TM(i, e, n) : OM(n, i, i, r, i.__e, e));
  return e;
}
function hf(t, e) {
  return e = e || [], t == null || typeof t == "boolean" || (Array.isArray(t) ? t.some(function(n) {
    hf(n, e);
  }) : e.push(t)), e;
}
function OM(t, e, n, i, r, a) {
  var o, s, l;
  if (e.__d !== void 0) o = e.__d, e.__d = void 0;
  else if (n == null || r != a || r.parentNode == null) e: if (a == null || a.parentNode !== t) t.appendChild(r), o = null;
  else {
    for (s = a, l = 0; (s = s.nextSibling) && l < i.length; l += 2) if (s == r) break e;
    t.insertBefore(r, a), o = a;
  }
  return o !== void 0 ? o : r.nextSibling;
}
function DF(t, e, n, i, r) {
  var a;
  for (a in n) a === "children" || a === "key" || a in e || pf(t, a, null, n[a], i);
  for (a in e) r && typeof e[a] != "function" || a === "children" || a === "key" || a === "value" || a === "checked" || n[a] === e[a] || pf(t, a, e[a], n[a], i);
}
function gk(t, e, n) {
  e[0] === "-" ? t.setProperty(e, n) : t[e] = n == null ? "" : typeof n != "number" || $F.test(e) ? n : n + "px";
}
function pf(t, e, n, i, r) {
  var a;
  e: if (e === "style")
    if (typeof n == "string") t.style.cssText = n;
    else {
      if (typeof i == "string" && (t.style.cssText = i = ""), i) for (e in i) n && e in n || gk(t.style, e, "");
      if (n) for (e in n) i && n[e] === i[e] || gk(t.style, e, n[e]);
    }
  else if (e[0] === "o" && e[1] === "n") a = e !== (e = e.replace(/Capture$/, "")), e = e.toLowerCase() in t ? e.toLowerCase().slice(2) : e.slice(2), t.l || (t.l = {}), t.l[e + a] = n, n ? i || t.addEventListener(e, a ? vk : yk, a) : t.removeEventListener(e, a ? vk : yk, a);
  else if (e !== "dangerouslySetInnerHTML") {
    if (r) e = e.replace(/xlink[H:h]/, "h").replace(/sName$/, "s");
    else if (e !== "href" && e !== "list" && e !== "form" && e !== "tabIndex" && e !== "download" && e in t) try {
      t[e] = n ?? "";
      break e;
    } catch {
    }
    typeof n == "function" || (n != null && (n !== !1 || e[0] === "a" && e[1] === "r") ? t.setAttribute(e, n) : t.removeAttribute(e));
  }
}
function yk(t) {
  this.l[t.type + !1](Ie.event ? Ie.event(t) : t);
}
function vk(t) {
  this.l[t.type + !0](Ie.event ? Ie.event(t) : t);
}
function Dv(t, e, n, i, r, a, o, s, l) {
  var c, u, f, m, h, p, g, y, v, w, x, b = e.type;
  if (e.constructor !== void 0) return null;
  n.__h != null && (l = n.__h, s = e.__e = n.__e, e.__h = null, a = [
    s
  ]), (c = Ie.__b) && c(e);
  try {
    e: if (typeof b == "function") {
      if (y = e.props, v = (c = b.contextType) && i[c.__c], w = c ? v ? v.props.value : c.__ : i, n.__c ? g = (u = e.__c = n.__c).__ = u.__E : ("prototype" in b && b.prototype.render ? e.__c = u = new b(y, w) : (e.__c = u = new cr(y, w), u.constructor = b, u.render = TF), v && v.sub(u), u.props = y, u.state || (u.state = {}), u.context = w, u.__n = i, f = u.__d = !0, u.__h = []), u.__s == null && (u.__s = u.state), b.getDerivedStateFromProps != null && (u.__s == u.state && (u.__s = da({}, u.__s)), da(u.__s, b.getDerivedStateFromProps(y, u.__s))), m = u.props, h = u.state, f) b.getDerivedStateFromProps == null && u.componentWillMount != null && u.componentWillMount(), u.componentDidMount != null && u.__h.push(u.componentDidMount);
      else {
        if (b.getDerivedStateFromProps == null && y !== m && u.componentWillReceiveProps != null && u.componentWillReceiveProps(y, w), !u.__e && u.shouldComponentUpdate != null && u.shouldComponentUpdate(y, u.__s, w) === !1 || e.__v === n.__v) {
          u.props = y, u.state = u.__s, e.__v !== n.__v && (u.__d = !1), u.__v = e, e.__e = n.__e, e.__k = n.__k, e.__k.forEach(function(M) {
            M && (M.__ = e);
          }), u.__h.length && o.push(u);
          break e;
        }
        u.componentWillUpdate != null && u.componentWillUpdate(y, u.__s, w), u.componentDidUpdate != null && u.__h.push(function() {
          u.componentDidUpdate(m, h, p);
        });
      }
      u.context = w, u.props = y, u.state = u.__s, (c = Ie.__r) && c(e), u.__d = !1, u.__v = e, u.__P = t, c = u.render(u.props, u.state, u.context), u.state = u.__s, u.getChildContext != null && (i = da(da({}, i), u.getChildContext())), f || u.getSnapshotBeforeUpdate == null || (p = u.getSnapshotBeforeUpdate(m, h)), x = c != null && c.type === xs && c.key == null ? c.props.children : c, EM(t, Array.isArray(x) ? x : [
        x
      ], e, n, i, r, a, o, s, l), u.base = e.__e, e.__h = null, u.__h.length && o.push(u), g && (u.__E = u.__ = null), u.__e = !1;
    } else a == null && e.__v === n.__v ? (e.__k = n.__k, e.__e = n.__e) : e.__e = EF(n.__e, e, n, i, r, a, o, l);
    (c = Ie.diffed) && c(e);
  } catch (M) {
    e.__v = null, (l || a != null) && (e.__e = s, e.__h = !!l, a[a.indexOf(s)] = null), Ie.__e(M, e, n);
  }
}
function WM(t, e) {
  Ie.__c && Ie.__c(e, t), t.some(function(n) {
    try {
      t = n.__h, n.__h = [], t.some(function(i) {
        i.call(n);
      });
    } catch (i) {
      Ie.__e(i, n.__v);
    }
  });
}
function EF(t, e, n, i, r, a, o, s) {
  var l, c, u, f = n.props, m = e.props, h = e.type, p = 0;
  if (h === "svg" && (r = !0), a != null) {
    for (; p < a.length; p++) if ((l = a[p]) && "setAttribute" in l == !!h && (h ? l.localName === h : l.nodeType === 3)) {
      t = l, a[p] = null;
      break;
    }
  }
  if (t == null) {
    if (h === null) return document.createTextNode(m);
    t = r ? document.createElementNS("http://www.w3.org/2000/svg", h) : document.createElement(h, m.is && m), a = null, s = !1;
  }
  if (h === null) f === m || s && t.data === m || (t.data = m);
  else {
    if (a = a && Zm.call(t.childNodes), c = (f = n.props || ff).dangerouslySetInnerHTML, u = m.dangerouslySetInnerHTML, !s) {
      if (a != null) for (f = {}, p = 0; p < t.attributes.length; p++) f[t.attributes[p].name] = t.attributes[p].value;
      (u || c) && (u && (c && u.__html == c.__html || u.__html === t.innerHTML) || (t.innerHTML = u && u.__html || ""));
    }
    if (DF(t, m, f, r, s), u) e.__k = [];
    else if (p = e.props.children, EM(t, Array.isArray(p) ? p : [
      p
    ], e, n, i, r && h !== "foreignObject", a, o, a ? a[0] : n.__k && _s(n, 0), s), a != null) for (p = a.length; p--; ) a[p] != null && $M(a[p]);
    s || ("value" in m && (p = m.value) !== void 0 && (p !== f.value || p !== t.value || h === "progress" && !p) && pf(t, "value", p, f.value, !1), "checked" in m && (p = m.checked) !== void 0 && p !== t.checked && pf(t, "checked", p, f.checked, !1));
  }
  return t;
}
function AM(t, e, n) {
  try {
    typeof t == "function" ? t(e) : t.current = e;
  } catch (i) {
    Ie.__e(i, n);
  }
}
function LM(t, e, n) {
  var i, r;
  if (Ie.unmount && Ie.unmount(t), (i = t.ref) && (i.current && i.current !== t.__e || AM(i, null, e)), (i = t.__c) != null) {
    if (i.componentWillUnmount) try {
      i.componentWillUnmount();
    } catch (a) {
      Ie.__e(a, e);
    }
    i.base = i.__P = null;
  }
  if (i = t.__k) for (r = 0; r < i.length; r++) i[r] && LM(i[r], e, typeof t.type != "function");
  n || t.__e == null || $M(t.__e), t.__e = t.__d = void 0;
}
function TF(t, e, n) {
  return this.constructor(t, n);
}
function IM(t, e, n) {
  var i, r, a;
  Ie.__ && Ie.__(t, e), r = (i = typeof n == "function") ? null : n && n.__k || e.__k, a = [], Dv(e, t = (!i && n || e).__k = Gp(xs, null, [
    t
  ]), r || ff, ff, e.ownerSVGElement !== void 0, !i && n ? [
    n
  ] : r ? null : e.firstChild ? Zm.call(e.childNodes) : null, a, !i && n ? n : r ? r.__e : e.firstChild, i), WM(a, t);
}
Zm = NM.slice, Ie = {
  __e: function(t, e) {
    for (var n, i, r; e = e.__; ) if ((n = e.__c) && !n.__) try {
      if ((i = n.constructor) && i.getDerivedStateFromError != null && (n.setState(i.getDerivedStateFromError(t)), r = n.__d), n.componentDidCatch != null && (n.componentDidCatch(t), r = n.__d), r) return n.__E = n;
    } catch (a) {
      t = a;
    }
    throw t;
  }
}, PM = 0, cr.prototype.setState = function(t, e) {
  var n;
  n = this.__s != null && this.__s !== this.state ? this.__s : this.__s = da({}, this.state), typeof t == "function" && (t = t(da({}, n), this.props)), t && da(n, t), t != null && this.__v && (e && this.__h.push(e), pk(this));
}, cr.prototype.forceUpdate = function(t) {
  this.__v && (this.__e = !0, t && this.__h.push(t), pk(this));
}, cr.prototype.render = xs, zl = [], SM = typeof Promise == "function" ? Promise.prototype.then.bind(Promise.resolve()) : setTimeout, mf.__r = 0;
var OF = 0;
function Z(t, e, n, i, r) {
  var a, o, s = {};
  for (o in e) o == "ref" ? a = e[o] : s[o] = e[o];
  var l = {
    type: t,
    props: s,
    key: n,
    ref: a,
    __k: null,
    __: null,
    __b: 0,
    __e: null,
    __d: void 0,
    __c: null,
    __h: null,
    constructor: void 0,
    __v: --OF,
    __source: i,
    __self: r
  };
  if (typeof t == "function" && (a = t.defaultProps)) for (o in a) s[o] === void 0 && (s[o] = a[o]);
  return Ie.vnode && Ie.vnode(l), l;
}
function WF(t, e) {
  try {
    window.localStorage[`emoji-mart.${t}`] = JSON.stringify(e);
  } catch {
  }
}
function AF(t) {
  try {
    const e = window.localStorage[`emoji-mart.${t}`];
    if (e) return JSON.parse(e);
  } catch {
  }
}
var va = {
  set: WF,
  get: AF
};
const e1 = /* @__PURE__ */ new Map(), LF = [
  {
    v: 15,
    emoji: "🫨"
  },
  {
    v: 14,
    emoji: "🫠"
  },
  {
    v: 13.1,
    emoji: "😶‍🌫️"
  },
  {
    v: 13,
    emoji: "🥸"
  },
  {
    v: 12.1,
    emoji: "🧑‍🦰"
  },
  {
    v: 12,
    emoji: "🥱"
  },
  {
    v: 11,
    emoji: "🥰"
  },
  {
    v: 5,
    emoji: "🤩"
  },
  {
    v: 4,
    emoji: "👱‍♀️"
  },
  {
    v: 3,
    emoji: "🤣"
  },
  {
    v: 2,
    emoji: "👋🏻"
  },
  {
    v: 1,
    emoji: "🙃"
  }
];
function IF() {
  for (const { v: t, emoji: e } of LF)
    if (RM(e)) return t;
}
function RF() {
  return !RM("🇨🇦");
}
function RM(t) {
  if (e1.has(t)) return e1.get(t);
  const e = jF(t);
  return e1.set(t, e), e;
}
const jF = (() => {
  let t = null;
  try {
    navigator.userAgent.includes("jsdom") || (t = document.createElement("canvas").getContext("2d", {
      willReadFrequently: !0
    }));
  } catch {
  }
  if (!t) return () => !1;
  const e = 25, n = 20, i = Math.floor(e / 2);
  return t.font = i + "px Arial, Sans-Serif", t.textBaseline = "top", t.canvas.width = n * 2, t.canvas.height = e, (r) => {
    t.clearRect(0, 0, n * 2, e), t.fillStyle = "#FF0000", t.fillText(r, 0, 22), t.fillStyle = "#0000FF", t.fillText(r, n, 22);
    const a = t.getImageData(0, 0, n, e).data, o = a.length;
    let s = 0;
    for (; s < o && !a[s + 3]; s += 4) ;
    if (s >= o) return !1;
    const l = n + s / 4 % n, c = Math.floor(s / 4 / n), u = t.getImageData(l, c, 1, 1).data;
    return !(a[s] !== u[0] || a[s + 2] !== u[2] || t.measureText(r).width >= n);
  };
})();
var bk = {
  latestVersion: IF,
  noCountryFlags: RF
};
const Xp = [
  "+1",
  "grinning",
  "kissing_heart",
  "heart_eyes",
  "laughing",
  "stuck_out_tongue_winking_eye",
  "sweat_smile",
  "joy",
  "scream",
  "disappointed",
  "unamused",
  "weary",
  "sob",
  "sunglasses",
  "heart"
];
let dn = null;
function FF(t) {
  dn || (dn = va.get("frequently") || {});
  const e = t.id || t;
  e && (dn[e] || (dn[e] = 0), dn[e] += 1, va.set("last", e), va.set("frequently", dn));
}
function zF({ maxFrequentRows: t, perLine: e }) {
  if (!t) return [];
  dn || (dn = va.get("frequently"));
  let n = [];
  if (!dn) {
    dn = {};
    for (let a in Xp.slice(0, e)) {
      const o = Xp[a];
      dn[o] = e - a, n.push(o);
    }
    return n;
  }
  const i = t * e, r = va.get("last");
  for (let a in dn) n.push(a);
  if (n.sort((a, o) => {
    const s = dn[o], l = dn[a];
    return s == l ? a.localeCompare(o) : s - l;
  }), n.length > i) {
    const a = n.slice(i);
    n = n.slice(0, i);
    for (let o of a)
      o != r && delete dn[o];
    r && n.indexOf(r) == -1 && (delete dn[n[n.length - 1]], n.splice(-1, 1, r)), va.set("frequently", dn);
  }
  return n;
}
var jM = {
  add: FF,
  get: zF,
  DEFAULTS: Xp
}, FM = {};
FM = JSON.parse('{"search":"Search","search_no_results_1":"Oh no!","search_no_results_2":"That emoji couldn’t be found","pick":"Pick an emoji…","add_custom":"Add custom emoji","categories":{"activity":"Activity","custom":"Custom","flags":"Flags","foods":"Food & Drink","frequent":"Frequently used","nature":"Animals & Nature","objects":"Objects","people":"Smileys & People","places":"Travel & Places","search":"Search Results","symbols":"Symbols"},"skins":{"1":"Default","2":"Light","3":"Medium-Light","4":"Medium","5":"Medium-Dark","6":"Dark","choose":"Choose default skin tone"}}');
var Dr = {
  autoFocus: {
    value: !1
  },
  dynamicWidth: {
    value: !1
  },
  emojiButtonColors: {
    value: null
  },
  emojiButtonRadius: {
    value: "100%"
  },
  emojiButtonSize: {
    value: 36
  },
  emojiSize: {
    value: 24
  },
  emojiVersion: {
    value: 15,
    choices: [
      1,
      2,
      3,
      4,
      5,
      11,
      12,
      12.1,
      13,
      13.1,
      14,
      15
    ]
  },
  exceptEmojis: {
    value: []
  },
  icons: {
    value: "auto",
    choices: [
      "auto",
      "outline",
      "solid"
    ]
  },
  locale: {
    value: "en",
    choices: [
      "en",
      "ar",
      "be",
      "cs",
      "de",
      "es",
      "fa",
      "fi",
      "fr",
      "hi",
      "it",
      "ja",
      "ko",
      "nl",
      "pl",
      "pt",
      "ru",
      "sa",
      "tr",
      "uk",
      "vi",
      "zh"
    ]
  },
  maxFrequentRows: {
    value: 4
  },
  navPosition: {
    value: "top",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  noCountryFlags: {
    value: !1
  },
  noResultsEmoji: {
    value: null
  },
  perLine: {
    value: 9
  },
  previewEmoji: {
    value: null
  },
  previewPosition: {
    value: "bottom",
    choices: [
      "top",
      "bottom",
      "none"
    ]
  },
  searchPosition: {
    value: "sticky",
    choices: [
      "sticky",
      "static",
      "none"
    ]
  },
  set: {
    value: "native",
    choices: [
      "native",
      "apple",
      "facebook",
      "google",
      "twitter"
    ]
  },
  skin: {
    value: 1,
    choices: [
      1,
      2,
      3,
      4,
      5,
      6
    ]
  },
  skinTonePosition: {
    value: "preview",
    choices: [
      "preview",
      "search",
      "none"
    ]
  },
  theme: {
    value: "auto",
    choices: [
      "auto",
      "light",
      "dark"
    ]
  },
  // Data
  categories: null,
  categoryIcons: null,
  custom: null,
  data: null,
  i18n: null,
  // Callbacks
  getImageURL: null,
  getSpritesheetURL: null,
  onAddCustomEmoji: null,
  onClickOutside: null,
  onEmojiSelect: null,
  // Deprecated
  stickySearch: {
    deprecated: !0,
    value: !0
  }
};
let pn = null, Je = null;
const t1 = {};
async function wk(t) {
  if (t1[t]) return t1[t];
  const n = await (await fetch(t)).json();
  return t1[t] = n, n;
}
let n1 = null, zM = null, VM = !1;
function eh(t, { caller: e } = {}) {
  return n1 || (n1 = new Promise((n) => {
    zM = n;
  })), t ? VF(t) : e && !VM && console.warn(`\`${e}\` requires data to be initialized first. Promise will be pending until \`init\` is called.`), n1;
}
async function VF(t) {
  VM = !0;
  let { emojiVersion: e, set: n, locale: i } = t;
  if (e || (e = Dr.emojiVersion.value), n || (n = Dr.set.value), i || (i = Dr.locale.value), Je)
    Je.categories = Je.categories.filter((l) => !l.name);
  else {
    Je = (typeof t.data == "function" ? await t.data() : t.data) || await wk(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/sets/${e}/${n}.json`), Je.emoticons = {}, Je.natives = {}, Je.categories.unshift({
      id: "frequent",
      emojis: []
    });
    for (const l in Je.aliases) {
      const c = Je.aliases[l], u = Je.emojis[c];
      u && (u.aliases || (u.aliases = []), u.aliases.push(l));
    }
    Je.originalCategories = Je.categories;
  }
  if (pn = (typeof t.i18n == "function" ? await t.i18n() : t.i18n) || (i == "en" ? /* @__PURE__ */ CM(FM) : await wk(`https://cdn.jsdelivr.net/npm/@emoji-mart/data@latest/i18n/${i}.json`)), t.custom) for (let l in t.custom) {
    l = parseInt(l);
    const c = t.custom[l], u = t.custom[l - 1];
    if (!(!c.emojis || !c.emojis.length)) {
      c.id || (c.id = `custom_${l + 1}`), c.name || (c.name = pn.categories.custom), u && !c.icon && (c.target = u.target || u), Je.categories.push(c);
      for (const f of c.emojis) Je.emojis[f.id] = f;
    }
  }
  t.categories && (Je.categories = Je.originalCategories.filter((l) => t.categories.indexOf(l.id) != -1).sort((l, c) => {
    const u = t.categories.indexOf(l.id), f = t.categories.indexOf(c.id);
    return u - f;
  }));
  let r = null, a = null;
  n == "native" && (r = bk.latestVersion(), a = t.noCountryFlags || bk.noCountryFlags());
  let o = Je.categories.length, s = !1;
  for (; o--; ) {
    const l = Je.categories[o];
    if (l.id == "frequent") {
      let { maxFrequentRows: f, perLine: m } = t;
      f = f >= 0 ? f : Dr.maxFrequentRows.value, m || (m = Dr.perLine.value), l.emojis = jM.get({
        maxFrequentRows: f,
        perLine: m
      });
    }
    if (!l.emojis || !l.emojis.length) {
      Je.categories.splice(o, 1);
      continue;
    }
    const { categoryIcons: c } = t;
    if (c) {
      const f = c[l.id];
      f && !l.icon && (l.icon = f);
    }
    let u = l.emojis.length;
    for (; u--; ) {
      const f = l.emojis[u], m = f.id ? f : Je.emojis[f], h = () => {
        l.emojis.splice(u, 1);
      };
      if (!m || t.exceptEmojis && t.exceptEmojis.includes(m.id)) {
        h();
        continue;
      }
      if (r && m.version > r) {
        h();
        continue;
      }
      if (a && l.id == "flags" && !XF.includes(m.id)) {
        h();
        continue;
      }
      if (!m.search) {
        if (s = !0, m.search = "," + [
          [
            m.id,
            !1
          ],
          [
            m.name,
            !0
          ],
          [
            m.keywords,
            !1
          ],
          [
            m.emoticons,
            !1
          ]
        ].map(([g, y]) => {
          if (g)
            return (Array.isArray(g) ? g : [
              g
            ]).map((v) => (y ? v.split(/[-|_|\s]+/) : [
              v
            ]).map((w) => w.toLowerCase())).flat();
        }).flat().filter((g) => g && g.trim()).join(","), m.emoticons) for (const g of m.emoticons)
          Je.emoticons[g] || (Je.emoticons[g] = m.id);
        let p = 0;
        for (const g of m.skins) {
          if (!g) continue;
          p++;
          const { native: y } = g;
          y && (Je.natives[y] = m.id, m.search += `,${y}`);
          const v = p == 1 ? "" : `:skin-tone-${p}:`;
          g.shortcodes = `:${m.id}:${v}`;
        }
      }
    }
  }
  s && cs.reset(), zM();
}
function HM(t, e, n) {
  t || (t = {});
  const i = {};
  for (let r in e) i[r] = BM(r, t, e, n);
  return i;
}
function BM(t, e, n, i) {
  const r = n[t];
  let a = i && i.getAttribute(t) || (e[t] != null && e[t] != null ? e[t] : null);
  return r && (a != null && r.value && typeof r.value != typeof a && (typeof r.value == "boolean" ? a = a != "false" : a = r.value.constructor(a)), r.transform && a && (a = r.transform(a)), (a == null || r.choices && r.choices.indexOf(a) == -1) && (a = r.value)), a;
}
const HF = /^(?:\:([^\:]+)\:)(?:\:skin-tone-(\d)\:)?$/;
let Yp = null;
function BF(t) {
  return t.id ? t : Je.emojis[t] || Je.emojis[Je.aliases[t]] || Je.emojis[Je.natives[t]];
}
function qF() {
  Yp = null;
}
async function GF(t, { maxResults: e, caller: n } = {}) {
  if (!t || !t.trim().length) return null;
  e || (e = 90), await eh(null, {
    caller: n || "SearchIndex.search"
  });
  const i = t.toLowerCase().replace(/(\w)-/, "$1 ").split(/[\s|,]+/).filter((s, l, c) => s.trim() && c.indexOf(s) == l);
  if (!i.length) return;
  let r = Yp || (Yp = Object.values(Je.emojis)), a, o;
  for (const s of i) {
    if (!r.length) break;
    a = [], o = {};
    for (const l of r) {
      if (!l.search) continue;
      const c = l.search.indexOf(`,${s}`);
      c != -1 && (a.push(l), o[l.id] || (o[l.id] = 0), o[l.id] += l.id == s ? 0 : c + 1);
    }
    r = a;
  }
  return a.length < 2 || (a.sort((s, l) => {
    const c = o[s.id], u = o[l.id];
    return c == u ? s.id.localeCompare(l.id) : c - u;
  }), a.length > e && (a = a.slice(0, e))), a;
}
var cs = {
  search: GF,
  get: BF,
  reset: qF,
  SHORTCODES_REGEX: HF
};
const XF = [
  "checkered_flag",
  "crossed_flags",
  "pirate_flag",
  "rainbow-flag",
  "transgender_flag",
  "triangular_flag_on_post",
  "waving_black_flag",
  "waving_white_flag"
];
function YF(t, e) {
  return Array.isArray(t) && Array.isArray(e) && t.length === e.length && t.every((n, i) => n == e[i]);
}
async function KF(t = 1) {
  for (let e in [
    ...Array(t).keys()
  ]) await new Promise(requestAnimationFrame);
}
function UF(t, { skinIndex: e = 0 } = {}) {
  const n = t.skins[e] || (e = 0, t.skins[e]), i = {
    id: t.id,
    name: t.name,
    native: n.native,
    unified: n.unified,
    keywords: t.keywords,
    shortcodes: n.shortcodes || t.shortcodes
  };
  return t.skins.length > 1 && (i.skin = e + 1), n.src && (i.src = n.src), t.aliases && t.aliases.length && (i.aliases = t.aliases), t.emoticons && t.emoticons.length && (i.emoticons = t.emoticons), i;
}
const JF = {
  activity: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ Z("path", {
        d: "M12 0C5.373 0 0 5.372 0 12c0 6.627 5.373 12 12 12 6.628 0 12-5.373 12-12 0-6.628-5.372-12-12-12m9.949 11H17.05c.224-2.527 1.232-4.773 1.968-6.113A9.966 9.966 0 0 1 21.949 11M13 11V2.051a9.945 9.945 0 0 1 4.432 1.564c-.858 1.491-2.156 4.22-2.392 7.385H13zm-2 0H8.961c-.238-3.165-1.536-5.894-2.393-7.385A9.95 9.95 0 0 1 11 2.051V11zm0 2v8.949a9.937 9.937 0 0 1-4.432-1.564c.857-1.492 2.155-4.221 2.393-7.385H11zm4.04 0c.236 3.164 1.534 5.893 2.392 7.385A9.92 9.92 0 0 1 13 21.949V13h2.04zM4.982 4.887C5.718 6.227 6.726 8.473 6.951 11h-4.9a9.977 9.977 0 0 1 2.931-6.113M2.051 13h4.9c-.226 2.527-1.233 4.771-1.969 6.113A9.972 9.972 0 0 1 2.051 13m16.967 6.113c-.735-1.342-1.744-3.586-1.968-6.113h4.899a9.961 9.961 0 0 1-2.931 6.113"
      })
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M16.17 337.5c0 44.98 7.565 83.54 13.98 107.9C35.22 464.3 50.46 496 174.9 496c9.566 0 19.59-.4707 29.84-1.271L17.33 307.3C16.53 317.6 16.17 327.7 16.17 337.5zM495.8 174.5c0-44.98-7.565-83.53-13.98-107.9c-4.688-17.54-18.34-31.23-36.04-35.95C435.5 27.91 392.9 16 337 16c-9.564 0-19.59 .4707-29.84 1.271l187.5 187.5C495.5 194.4 495.8 184.3 495.8 174.5zM26.77 248.8l236.3 236.3c142-36.1 203.9-150.4 222.2-221.1L248.9 26.87C106.9 62.96 45.07 177.2 26.77 248.8zM256 335.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L164.7 283.3C161.6 280.2 160 276.1 160 271.1c0-8.529 6.865-16 16-16c4.095 0 8.189 1.562 11.31 4.688l64.01 64C254.4 327.8 256 331.9 256 335.1zM304 287.1c0 9.141-7.474 16-16 16c-4.094 0-8.188-1.564-11.31-4.689L212.7 235.3C209.6 232.2 208 228.1 208 223.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01C302.5 279.8 304 283.9 304 287.1zM256 175.1c0-9.141 7.473-16 16-16c4.094 0 8.188 1.562 11.31 4.688l64.01 64.01c3.125 3.125 4.688 7.219 4.688 11.31c0 9.133-7.468 16-16 16c-4.094 0-8.189-1.562-11.31-4.688l-64.01-64.01C257.6 184.2 256 180.1 256 175.1z"
      })
    })
  },
  custom: /* @__PURE__ */ Z("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 448 512",
    children: /* @__PURE__ */ Z("path", {
      d: "M417.1 368c-5.937 10.27-16.69 16-27.75 16c-5.422 0-10.92-1.375-15.97-4.281L256 311.4V448c0 17.67-14.33 32-31.1 32S192 465.7 192 448V311.4l-118.3 68.29C68.67 382.6 63.17 384 57.75 384c-11.06 0-21.81-5.734-27.75-16c-8.828-15.31-3.594-34.88 11.72-43.72L159.1 256L41.72 187.7C26.41 178.9 21.17 159.3 29.1 144C36.63 132.5 49.26 126.7 61.65 128.2C65.78 128.7 69.88 130.1 73.72 132.3L192 200.6V64c0-17.67 14.33-32 32-32S256 46.33 256 64v136.6l118.3-68.29c3.838-2.213 7.939-3.539 12.07-4.051C398.7 126.7 411.4 132.5 417.1 144c8.828 15.31 3.594 34.88-11.72 43.72L288 256l118.3 68.28C421.6 333.1 426.8 352.7 417.1 368z"
    })
  }),
  flags: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ Z("path", {
        d: "M0 0l6.084 24H8L1.916 0zM21 5h-4l-1-4H4l3 12h3l1 4h13L21 5zM6.563 3h7.875l2 8H8.563l-2-8zm8.832 10l-2.856 1.904L12.063 13h3.332zM19 13l-1.5-6h1.938l2 8H16l3-2z"
      })
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M64 496C64 504.8 56.75 512 48 512h-32C7.25 512 0 504.8 0 496V32c0-17.75 14.25-32 32-32s32 14.25 32 32V496zM476.3 0c-6.365 0-13.01 1.35-19.34 4.233c-45.69 20.86-79.56 27.94-107.8 27.94c-59.96 0-94.81-31.86-163.9-31.87C160.9 .3055 131.6 4.867 96 15.75v350.5c32-9.984 59.87-14.1 84.85-14.1c73.63 0 124.9 31.78 198.6 31.78c31.91 0 68.02-5.971 111.1-23.09C504.1 355.9 512 344.4 512 332.1V30.73C512 11.1 495.3 0 476.3 0z"
      })
    })
  },
  foods: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ Z("path", {
        d: "M17 4.978c-1.838 0-2.876.396-3.68.934.513-1.172 1.768-2.934 4.68-2.934a1 1 0 0 0 0-2c-2.921 0-4.629 1.365-5.547 2.512-.064.078-.119.162-.18.244C11.73 1.838 10.798.023 9.207.023 8.579.022 7.85.306 7 .978 5.027 2.54 5.329 3.902 6.492 4.999 3.609 5.222 0 7.352 0 12.969c0 4.582 4.961 11.009 9 11.009 1.975 0 2.371-.486 3-1 .629.514 1.025 1 3 1 4.039 0 9-6.418 9-11 0-5.953-4.055-8-7-8M8.242 2.546c.641-.508.943-.523.965-.523.426.169.975 1.405 1.357 3.055-1.527-.629-2.741-1.352-2.98-1.846.059-.112.241-.356.658-.686M15 21.978c-1.08 0-1.21-.109-1.559-.402l-.176-.146c-.367-.302-.816-.452-1.266-.452s-.898.15-1.266.452l-.176.146c-.347.292-.477.402-1.557.402-2.813 0-7-5.389-7-9.009 0-5.823 4.488-5.991 5-5.991 1.939 0 2.484.471 3.387 1.251l.323.276a1.995 1.995 0 0 0 2.58 0l.323-.276c.902-.78 1.447-1.251 3.387-1.251.512 0 5 .168 5 6 0 3.617-4.187 9-7 9"
      })
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M481.9 270.1C490.9 279.1 496 291.3 496 304C496 316.7 490.9 328.9 481.9 337.9C472.9 346.9 460.7 352 448 352H64C51.27 352 39.06 346.9 30.06 337.9C21.06 328.9 16 316.7 16 304C16 291.3 21.06 279.1 30.06 270.1C39.06 261.1 51.27 256 64 256H448C460.7 256 472.9 261.1 481.9 270.1zM475.3 388.7C478.3 391.7 480 395.8 480 400V416C480 432.1 473.3 449.3 461.3 461.3C449.3 473.3 432.1 480 416 480H96C79.03 480 62.75 473.3 50.75 461.3C38.74 449.3 32 432.1 32 416V400C32 395.8 33.69 391.7 36.69 388.7C39.69 385.7 43.76 384 48 384H464C468.2 384 472.3 385.7 475.3 388.7zM50.39 220.8C45.93 218.6 42.03 215.5 38.97 211.6C35.91 207.7 33.79 203.2 32.75 198.4C31.71 193.5 31.8 188.5 32.99 183.7C54.98 97.02 146.5 32 256 32C365.5 32 457 97.02 479 183.7C480.2 188.5 480.3 193.5 479.2 198.4C478.2 203.2 476.1 207.7 473 211.6C469.1 215.5 466.1 218.6 461.6 220.8C457.2 222.9 452.3 224 447.3 224H64.67C59.73 224 54.84 222.9 50.39 220.8zM372.7 116.7C369.7 119.7 368 123.8 368 128C368 131.2 368.9 134.3 370.7 136.9C372.5 139.5 374.1 141.6 377.9 142.8C380.8 143.1 384 144.3 387.1 143.7C390.2 143.1 393.1 141.6 395.3 139.3C397.6 137.1 399.1 134.2 399.7 131.1C400.3 128 399.1 124.8 398.8 121.9C397.6 118.1 395.5 116.5 392.9 114.7C390.3 112.9 387.2 111.1 384 111.1C379.8 111.1 375.7 113.7 372.7 116.7V116.7zM244.7 84.69C241.7 87.69 240 91.76 240 96C240 99.16 240.9 102.3 242.7 104.9C244.5 107.5 246.1 109.6 249.9 110.8C252.8 111.1 256 112.3 259.1 111.7C262.2 111.1 265.1 109.6 267.3 107.3C269.6 105.1 271.1 102.2 271.7 99.12C272.3 96.02 271.1 92.8 270.8 89.88C269.6 86.95 267.5 84.45 264.9 82.7C262.3 80.94 259.2 79.1 256 79.1C251.8 79.1 247.7 81.69 244.7 84.69V84.69zM116.7 116.7C113.7 119.7 112 123.8 112 128C112 131.2 112.9 134.3 114.7 136.9C116.5 139.5 118.1 141.6 121.9 142.8C124.8 143.1 128 144.3 131.1 143.7C134.2 143.1 137.1 141.6 139.3 139.3C141.6 137.1 143.1 134.2 143.7 131.1C144.3 128 143.1 124.8 142.8 121.9C141.6 118.1 139.5 116.5 136.9 114.7C134.3 112.9 131.2 111.1 128 111.1C123.8 111.1 119.7 113.7 116.7 116.7L116.7 116.7z"
      })
    })
  },
  frequent: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ Z("path", {
          d: "M13 4h-2l-.001 7H9v2h2v2h2v-2h4v-2h-4z"
        }),
        /* @__PURE__ */ Z("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        })
      ]
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M256 512C114.6 512 0 397.4 0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512zM232 256C232 264 236 271.5 242.7 275.1L338.7 339.1C349.7 347.3 364.6 344.3 371.1 333.3C379.3 322.3 376.3 307.4 365.3 300L280 243.2V120C280 106.7 269.3 96 255.1 96C242.7 96 231.1 106.7 231.1 120L232 256z"
      })
    })
  },
  nature: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ Z("path", {
          d: "M15.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 15.5 8M8.5 8a1.5 1.5 0 1 0 .001 3.001A1.5 1.5 0 0 0 8.5 8"
        }),
        /* @__PURE__ */ Z("path", {
          d: "M18.933 0h-.027c-.97 0-2.138.787-3.018 1.497-1.274-.374-2.612-.51-3.887-.51-1.285 0-2.616.133-3.874.517C7.245.79 6.069 0 5.093 0h-.027C3.352 0 .07 2.67.002 7.026c-.039 2.479.276 4.238 1.04 5.013.254.258.882.677 1.295.882.191 3.177.922 5.238 2.536 6.38.897.637 2.187.949 3.2 1.102C8.04 20.6 8 20.795 8 21c0 1.773 2.35 3 4 3 1.648 0 4-1.227 4-3 0-.201-.038-.393-.072-.586 2.573-.385 5.435-1.877 5.925-7.587.396-.22.887-.568 1.104-.788.763-.774 1.079-2.534 1.04-5.013C23.929 2.67 20.646 0 18.933 0M3.223 9.135c-.237.281-.837 1.155-.884 1.238-.15-.41-.368-1.349-.337-3.291.051-3.281 2.478-4.972 3.091-5.031.256.015.731.27 1.265.646-1.11 1.171-2.275 2.915-2.352 5.125-.133.546-.398.858-.783 1.313M12 22c-.901 0-1.954-.693-2-1 0-.654.475-1.236 1-1.602V20a1 1 0 1 0 2 0v-.602c.524.365 1 .947 1 1.602-.046.307-1.099 1-2 1m3-3.48v.02a4.752 4.752 0 0 0-1.262-1.02c1.092-.516 2.239-1.334 2.239-2.217 0-1.842-1.781-2.195-3.977-2.195-2.196 0-3.978.354-3.978 2.195 0 .883 1.148 1.701 2.238 2.217A4.8 4.8 0 0 0 9 18.539v-.025c-1-.076-2.182-.281-2.973-.842-1.301-.92-1.838-3.045-1.853-6.478l.023-.041c.496-.826 1.49-1.45 1.804-3.102 0-2.047 1.357-3.631 2.362-4.522C9.37 3.178 10.555 3 11.948 3c1.447 0 2.685.192 3.733.57 1 .9 2.316 2.465 2.316 4.48.313 1.651 1.307 2.275 1.803 3.102.035.058.068.117.102.178-.059 5.967-1.949 7.01-4.902 7.19m6.628-8.202c-.037-.065-.074-.13-.113-.195a7.587 7.587 0 0 0-.739-.987c-.385-.455-.648-.768-.782-1.313-.076-2.209-1.241-3.954-2.353-5.124.531-.376 1.004-.63 1.261-.647.636.071 3.044 1.764 3.096 5.031.027 1.81-.347 3.218-.37 3.235"
        })
      ]
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 576 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M332.7 19.85C334.6 8.395 344.5 0 356.1 0C363.6 0 370.6 3.52 375.1 9.502L392 32H444.1C456.8 32 469.1 37.06 478.1 46.06L496 64H552C565.3 64 576 74.75 576 88V112C576 156.2 540.2 192 496 192H426.7L421.6 222.5L309.6 158.5L332.7 19.85zM448 64C439.2 64 432 71.16 432 80C432 88.84 439.2 96 448 96C456.8 96 464 88.84 464 80C464 71.16 456.8 64 448 64zM416 256.1V480C416 497.7 401.7 512 384 512H352C334.3 512 320 497.7 320 480V364.8C295.1 377.1 268.8 384 240 384C211.2 384 184 377.1 160 364.8V480C160 497.7 145.7 512 128 512H96C78.33 512 64 497.7 64 480V249.8C35.23 238.9 12.64 214.5 4.836 183.3L.9558 167.8C-3.331 150.6 7.094 133.2 24.24 128.1C41.38 124.7 58.76 135.1 63.05 152.2L66.93 167.8C70.49 182 83.29 191.1 97.97 191.1H303.8L416 256.1z"
      })
    })
  },
  objects: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ Z("path", {
          d: "M12 0a9 9 0 0 0-5 16.482V21s2.035 3 5 3 5-3 5-3v-4.518A9 9 0 0 0 12 0zm0 2c3.86 0 7 3.141 7 7s-3.14 7-7 7-7-3.141-7-7 3.14-7 7-7zM9 17.477c.94.332 1.946.523 3 .523s2.06-.19 3-.523v.834c-.91.436-1.925.689-3 .689a6.924 6.924 0 0 1-3-.69v-.833zm.236 3.07A8.854 8.854 0 0 0 12 21c.965 0 1.888-.167 2.758-.451C14.155 21.173 13.153 22 12 22c-1.102 0-2.117-.789-2.764-1.453z"
        }),
        /* @__PURE__ */ Z("path", {
          d: "M14.745 12.449h-.004c-.852-.024-1.188-.858-1.577-1.824-.421-1.061-.703-1.561-1.182-1.566h-.009c-.481 0-.783.497-1.235 1.537-.436.982-.801 1.811-1.636 1.791l-.276-.043c-.565-.171-.853-.691-1.284-1.794-.125-.313-.202-.632-.27-.913-.051-.213-.127-.53-.195-.634C7.067 9.004 7.039 9 6.99 9A1 1 0 0 1 7 7h.01c1.662.017 2.015 1.373 2.198 2.134.486-.981 1.304-2.058 2.797-2.075 1.531.018 2.28 1.153 2.731 2.141l.002-.008C14.944 8.424 15.327 7 16.979 7h.032A1 1 0 1 1 17 9h-.011c-.149.076-.256.474-.319.709a6.484 6.484 0 0 1-.311.951c-.429.973-.79 1.789-1.614 1.789"
        })
      ]
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 384 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M112.1 454.3c0 6.297 1.816 12.44 5.284 17.69l17.14 25.69c5.25 7.875 17.17 14.28 26.64 14.28h61.67c9.438 0 21.36-6.401 26.61-14.28l17.08-25.68c2.938-4.438 5.348-12.37 5.348-17.7L272 415.1h-160L112.1 454.3zM191.4 .0132C89.44 .3257 16 82.97 16 175.1c0 44.38 16.44 84.84 43.56 115.8c16.53 18.84 42.34 58.23 52.22 91.45c.0313 .25 .0938 .5166 .125 .7823h160.2c.0313-.2656 .0938-.5166 .125-.7823c9.875-33.22 35.69-72.61 52.22-91.45C351.6 260.8 368 220.4 368 175.1C368 78.61 288.9-.2837 191.4 .0132zM192 96.01c-44.13 0-80 35.89-80 79.1C112 184.8 104.8 192 96 192S80 184.8 80 176c0-61.76 50.25-111.1 112-111.1c8.844 0 16 7.159 16 16S200.8 96.01 192 96.01z"
      })
    })
  },
  people: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ Z("path", {
          d: "M12 0C5.373 0 0 5.373 0 12s5.373 12 12 12 12-5.373 12-12S18.627 0 12 0m0 22C6.486 22 2 17.514 2 12S6.486 2 12 2s10 4.486 10 10-4.486 10-10 10"
        }),
        /* @__PURE__ */ Z("path", {
          d: "M8 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 8 7M16 7a2 2 0 1 0-.001 3.999A2 2 0 0 0 16 7M15.232 15c-.693 1.195-1.87 2-3.349 2-1.477 0-2.655-.805-3.347-2H15m3-2H6a6 6 0 1 0 12 0"
        })
      ]
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M0 256C0 114.6 114.6 0 256 0C397.4 0 512 114.6 512 256C512 397.4 397.4 512 256 512C114.6 512 0 397.4 0 256zM256 432C332.1 432 396.2 382 415.2 314.1C419.1 300.4 407.8 288 393.6 288H118.4C104.2 288 92.92 300.4 96.76 314.1C115.8 382 179.9 432 256 432V432zM176.4 160C158.7 160 144.4 174.3 144.4 192C144.4 209.7 158.7 224 176.4 224C194 224 208.4 209.7 208.4 192C208.4 174.3 194 160 176.4 160zM336.4 224C354 224 368.4 209.7 368.4 192C368.4 174.3 354 160 336.4 160C318.7 160 304.4 174.3 304.4 192C304.4 209.7 318.7 224 336.4 224z"
      })
    })
  },
  places: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: [
        /* @__PURE__ */ Z("path", {
          d: "M6.5 12C5.122 12 4 13.121 4 14.5S5.122 17 6.5 17 9 15.879 9 14.5 7.878 12 6.5 12m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5M17.5 12c-1.378 0-2.5 1.121-2.5 2.5s1.122 2.5 2.5 2.5 2.5-1.121 2.5-2.5-1.122-2.5-2.5-2.5m0 3c-.275 0-.5-.225-.5-.5s.225-.5.5-.5.5.225.5.5-.225.5-.5.5"
        }),
        /* @__PURE__ */ Z("path", {
          d: "M22.482 9.494l-1.039-.346L21.4 9h.6c.552 0 1-.439 1-.992 0-.006-.003-.008-.003-.008H23c0-1-.889-2-1.984-2h-.642l-.731-1.717C19.262 3.012 18.091 2 16.764 2H7.236C5.909 2 4.738 3.012 4.357 4.283L3.626 6h-.642C1.889 6 1 7 1 8h.003S1 8.002 1 8.008C1 8.561 1.448 9 2 9h.6l-.043.148-1.039.346a2.001 2.001 0 0 0-1.359 2.097l.751 7.508a1 1 0 0 0 .994.901H3v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h6v1c0 1.103.896 2 2 2h2c1.104 0 2-.897 2-2v-1h1.096a.999.999 0 0 0 .994-.901l.751-7.508a2.001 2.001 0 0 0-1.359-2.097M6.273 4.857C6.402 4.43 6.788 4 7.236 4h9.527c.448 0 .834.43.963.857L19.313 9H4.688l1.585-4.143zM7 21H5v-1h2v1zm12 0h-2v-1h2v1zm2.189-3H2.811l-.662-6.607L3 11h18l.852.393L21.189 18z"
        })
      ]
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M39.61 196.8L74.8 96.29C88.27 57.78 124.6 32 165.4 32H346.6C387.4 32 423.7 57.78 437.2 96.29L472.4 196.8C495.6 206.4 512 229.3 512 256V448C512 465.7 497.7 480 480 480H448C430.3 480 416 465.7 416 448V400H96V448C96 465.7 81.67 480 64 480H32C14.33 480 0 465.7 0 448V256C0 229.3 16.36 206.4 39.61 196.8V196.8zM109.1 192H402.9L376.8 117.4C372.3 104.6 360.2 96 346.6 96H165.4C151.8 96 139.7 104.6 135.2 117.4L109.1 192zM96 256C78.33 256 64 270.3 64 288C64 305.7 78.33 320 96 320C113.7 320 128 305.7 128 288C128 270.3 113.7 256 96 256zM416 320C433.7 320 448 305.7 448 288C448 270.3 433.7 256 416 256C398.3 256 384 270.3 384 288C384 305.7 398.3 320 416 320z"
      })
    })
  },
  symbols: {
    outline: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 24 24",
      children: /* @__PURE__ */ Z("path", {
        d: "M0 0h11v2H0zM4 11h3V6h4V4H0v2h4zM15.5 17c1.381 0 2.5-1.116 2.5-2.493s-1.119-2.493-2.5-2.493S13 13.13 13 14.507 14.119 17 15.5 17m0-2.986c.276 0 .5.222.5.493 0 .272-.224.493-.5.493s-.5-.221-.5-.493.224-.493.5-.493M21.5 19.014c-1.381 0-2.5 1.116-2.5 2.493S20.119 24 21.5 24s2.5-1.116 2.5-2.493-1.119-2.493-2.5-2.493m0 2.986a.497.497 0 0 1-.5-.493c0-.271.224-.493.5-.493s.5.222.5.493a.497.497 0 0 1-.5.493M22 13l-9 9 1.513 1.5 8.99-9.009zM17 11c2.209 0 4-1.119 4-2.5V2s.985-.161 1.498.949C23.01 4.055 23 6 23 6s1-1.119 1-3.135C24-.02 21 0 21 0h-2v6.347A5.853 5.853 0 0 0 17 6c-2.209 0-4 1.119-4 2.5s1.791 2.5 4 2.5M10.297 20.482l-1.475-1.585a47.54 47.54 0 0 1-1.442 1.129c-.307-.288-.989-1.016-2.045-2.183.902-.836 1.479-1.466 1.729-1.892s.376-.871.376-1.336c0-.592-.273-1.178-.818-1.759-.546-.581-1.329-.871-2.349-.871-1.008 0-1.79.293-2.344.879-.556.587-.832 1.181-.832 1.784 0 .813.419 1.748 1.256 2.805-.847.614-1.444 1.208-1.794 1.784a3.465 3.465 0 0 0-.523 1.833c0 .857.308 1.56.924 2.107.616.549 1.423.823 2.42.823 1.173 0 2.444-.379 3.813-1.137L8.235 24h2.819l-2.09-2.383 1.333-1.135zm-6.736-6.389a1.02 1.02 0 0 1 .73-.286c.31 0 .559.085.747.254a.849.849 0 0 1 .283.659c0 .518-.419 1.112-1.257 1.784-.536-.651-.805-1.231-.805-1.742a.901.901 0 0 1 .302-.669M3.74 22c-.427 0-.778-.116-1.057-.349-.279-.232-.418-.487-.418-.766 0-.594.509-1.288 1.527-2.083.968 1.134 1.717 1.946 2.248 2.438-.921.507-1.686.76-2.3.76"
      })
    }),
    solid: /* @__PURE__ */ Z("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 512 512",
      children: /* @__PURE__ */ Z("path", {
        d: "M500.3 7.251C507.7 13.33 512 22.41 512 31.1V175.1C512 202.5 483.3 223.1 447.1 223.1C412.7 223.1 383.1 202.5 383.1 175.1C383.1 149.5 412.7 127.1 447.1 127.1V71.03L351.1 90.23V207.1C351.1 234.5 323.3 255.1 287.1 255.1C252.7 255.1 223.1 234.5 223.1 207.1C223.1 181.5 252.7 159.1 287.1 159.1V63.1C287.1 48.74 298.8 35.61 313.7 32.62L473.7 .6198C483.1-1.261 492.9 1.173 500.3 7.251H500.3zM74.66 303.1L86.5 286.2C92.43 277.3 102.4 271.1 113.1 271.1H174.9C185.6 271.1 195.6 277.3 201.5 286.2L213.3 303.1H239.1C266.5 303.1 287.1 325.5 287.1 351.1V463.1C287.1 490.5 266.5 511.1 239.1 511.1H47.1C21.49 511.1-.0019 490.5-.0019 463.1V351.1C-.0019 325.5 21.49 303.1 47.1 303.1H74.66zM143.1 359.1C117.5 359.1 95.1 381.5 95.1 407.1C95.1 434.5 117.5 455.1 143.1 455.1C170.5 455.1 191.1 434.5 191.1 407.1C191.1 381.5 170.5 359.1 143.1 359.1zM440.3 367.1H496C502.7 367.1 508.6 372.1 510.1 378.4C513.3 384.6 511.6 391.7 506.5 396L378.5 508C372.9 512.1 364.6 513.3 358.6 508.9C352.6 504.6 350.3 496.6 353.3 489.7L391.7 399.1H336C329.3 399.1 323.4 395.9 321 389.6C318.7 383.4 320.4 376.3 325.5 371.1L453.5 259.1C459.1 255 467.4 254.7 473.4 259.1C479.4 263.4 481.6 271.4 478.7 278.3L440.3 367.1zM116.7 219.1L19.85 119.2C-8.112 90.26-6.614 42.31 24.85 15.34C51.82-8.137 93.26-3.642 118.2 21.83L128.2 32.32L137.7 21.83C162.7-3.642 203.6-8.137 231.6 15.34C262.6 42.31 264.1 90.26 236.1 119.2L139.7 219.1C133.2 225.6 122.7 225.6 116.7 219.1H116.7z"
      })
    })
  }
}, QF = {
  loupe: /* @__PURE__ */ Z("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ Z("path", {
      d: "M12.9 14.32a8 8 0 1 1 1.41-1.41l5.35 5.33-1.42 1.42-5.33-5.34zM8 14A6 6 0 1 0 8 2a6 6 0 0 0 0 12z"
    })
  }),
  delete: /* @__PURE__ */ Z("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    children: /* @__PURE__ */ Z("path", {
      d: "M10 8.586L2.929 1.515 1.515 2.929 8.586 10l-7.071 7.071 1.414 1.414L10 11.414l7.071 7.071 1.414-1.414L11.414 10l7.071-7.071-1.414-1.414L10 8.586z"
    })
  })
};
var gf = {
  categories: JF,
  search: QF
};
function Kp(t) {
  let { id: e, skin: n, emoji: i } = t;
  if (t.shortcodes) {
    const s = t.shortcodes.match(cs.SHORTCODES_REGEX);
    s && (e = s[1], s[2] && (n = s[2]));
  }
  if (i || (i = cs.get(e || t.native)), !i) return t.fallback;
  const r = i.skins[n - 1] || i.skins[0], a = r.src || (t.set != "native" && !t.spritesheet ? typeof t.getImageURL == "function" ? t.getImageURL(t.set, r.unified) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${t.set}@15.0.1/img/${t.set}/64/${r.unified}.png` : void 0), o = typeof t.getSpritesheetURL == "function" ? t.getSpritesheetURL(t.set) : `https://cdn.jsdelivr.net/npm/emoji-datasource-${t.set}@15.0.1/img/${t.set}/sheets-256/64.png`;
  return /* @__PURE__ */ Z("span", {
    class: "emoji-mart-emoji",
    "data-emoji-set": t.set,
    children: a ? /* @__PURE__ */ Z("img", {
      style: {
        maxWidth: t.size || "1em",
        maxHeight: t.size || "1em",
        display: "inline-block"
      },
      alt: r.native || r.shortcodes,
      src: a
    }) : t.set == "native" ? /* @__PURE__ */ Z("span", {
      style: {
        fontSize: t.size,
        fontFamily: '"EmojiMart", "Segoe UI Emoji", "Segoe UI Symbol", "Segoe UI", "Apple Color Emoji", "Twemoji Mozilla", "Noto Color Emoji", "Android Emoji"'
      },
      children: r.native
    }) : /* @__PURE__ */ Z("span", {
      style: {
        display: "block",
        width: t.size,
        height: t.size,
        backgroundImage: `url(${o})`,
        backgroundSize: `${100 * Je.sheet.cols}% ${100 * Je.sheet.rows}%`,
        backgroundPosition: `${100 / (Je.sheet.cols - 1) * r.x}% ${100 / (Je.sheet.rows - 1) * r.y}%`
      }
    })
  });
}
const ZF = typeof window < "u" && window.HTMLElement ? window.HTMLElement : Object;
class qM extends ZF {
  static get observedAttributes() {
    return Object.keys(this.Props);
  }
  update(e = {}) {
    for (let n in e) this.attributeChangedCallback(n, null, e[n]);
  }
  attributeChangedCallback(e, n, i) {
    if (!this.component) return;
    const r = BM(e, {
      [e]: i
    }, this.constructor.Props, this);
    this.component.componentWillReceiveProps ? this.component.componentWillReceiveProps({
      [e]: r
    }) : (this.component.props[e] = r, this.component.forceUpdate());
  }
  disconnectedCallback() {
    this.disconnected = !0, this.component && this.component.unregister && this.component.unregister();
  }
  constructor(e = {}) {
    if (super(), this.props = e, e.parent || e.ref) {
      let n = null;
      const i = e.parent || (n = e.ref && e.ref.current);
      n && (n.innerHTML = ""), i && i.appendChild(this);
    }
  }
}
class ez extends qM {
  setShadow() {
    this.attachShadow({
      mode: "open"
    });
  }
  injectStyles(e) {
    if (!e) return;
    const n = document.createElement("style");
    n.textContent = e, this.shadowRoot.insertBefore(n, this.shadowRoot.firstChild);
  }
  constructor(e, { styles: n } = {}) {
    super(e), this.setShadow(), this.injectStyles(n);
  }
}
var GM = {
  fallback: "",
  id: "",
  native: "",
  shortcodes: "",
  size: {
    value: "",
    transform: (t) => /\D/.test(t) ? t : `${t}px`
  },
  // Shared
  set: Dr.set,
  skin: Dr.skin
};
class XM extends qM {
  async connectedCallback() {
    const e = HM(this.props, GM, this);
    e.element = this, e.ref = (n) => {
      this.component = n;
    }, await eh(), !this.disconnected && IM(/* @__PURE__ */ Z(Kp, {
      ...e
    }), this);
  }
  constructor(e) {
    super(e);
  }
}
hi(XM, "Props", GM);
typeof customElements < "u" && !customElements.get("em-emoji") && customElements.define("em-emoji", XM);
var kk, Up = [], xk = Ie.__b, _k = Ie.__r, Mk = Ie.diffed, Ck = Ie.__c, Pk = Ie.unmount;
function tz() {
  var t;
  for (Up.sort(function(e, n) {
    return e.__v.__b - n.__v.__b;
  }); t = Up.pop(); ) if (t.__P) try {
    t.__H.__h.forEach(ku), t.__H.__h.forEach(Jp), t.__H.__h = [];
  } catch (e) {
    t.__H.__h = [], Ie.__e(e, t.__v);
  }
}
Ie.__b = function(t) {
  xk && xk(t);
}, Ie.__r = function(t) {
  _k && _k(t);
  var e = t.__c.__H;
  e && (e.__h.forEach(ku), e.__h.forEach(Jp), e.__h = []);
}, Ie.diffed = function(t) {
  Mk && Mk(t);
  var e = t.__c;
  e && e.__H && e.__H.__h.length && (Up.push(e) !== 1 && kk === Ie.requestAnimationFrame || ((kk = Ie.requestAnimationFrame) || function(n) {
    var i, r = function() {
      clearTimeout(a), Sk && cancelAnimationFrame(i), setTimeout(n);
    }, a = setTimeout(r, 100);
    Sk && (i = requestAnimationFrame(r));
  })(tz));
}, Ie.__c = function(t, e) {
  e.some(function(n) {
    try {
      n.__h.forEach(ku), n.__h = n.__h.filter(function(i) {
        return !i.__ || Jp(i);
      });
    } catch (i) {
      e.some(function(r) {
        r.__h && (r.__h = []);
      }), e = [], Ie.__e(i, n.__v);
    }
  }), Ck && Ck(t, e);
}, Ie.unmount = function(t) {
  Pk && Pk(t);
  var e, n = t.__c;
  n && n.__H && (n.__H.__.forEach(function(i) {
    try {
      ku(i);
    } catch (r) {
      e = r;
    }
  }), e && Ie.__e(e, n.__v));
};
var Sk = typeof requestAnimationFrame == "function";
function ku(t) {
  var e = t.__c;
  typeof e == "function" && (t.__c = void 0, e());
}
function Jp(t) {
  t.__c = t.__();
}
function nz(t, e) {
  for (var n in e) t[n] = e[n];
  return t;
}
function Nk(t, e) {
  for (var n in t) if (n !== "__source" && !(n in e)) return !0;
  for (var i in e) if (i !== "__source" && t[i] !== e[i]) return !0;
  return !1;
}
function yf(t) {
  this.props = t;
}
(yf.prototype = new cr()).isPureReactComponent = !0, yf.prototype.shouldComponentUpdate = function(t, e) {
  return Nk(this.props, t) || Nk(this.state, e);
};
var $k = Ie.__b;
Ie.__b = function(t) {
  t.type && t.type.__f && t.ref && (t.props.ref = t.ref, t.ref = null), $k && $k(t);
};
var iz = Ie.__e;
Ie.__e = function(t, e, n) {
  if (t.then) {
    for (var i, r = e; r = r.__; ) if ((i = r.__c) && i.__c) return e.__e == null && (e.__e = n.__e, e.__k = n.__k), i.__c(t, e);
  }
  iz(t, e, n);
};
var Dk = Ie.unmount;
function i1() {
  this.__u = 0, this.t = null, this.__b = null;
}
function YM(t) {
  var e = t.__.__c;
  return e && e.__e && e.__e(t);
}
function Vc() {
  this.u = null, this.o = null;
}
Ie.unmount = function(t) {
  var e = t.__c;
  e && e.__R && e.__R(), e && t.__h === !0 && (t.type = null), Dk && Dk(t);
}, (i1.prototype = new cr()).__c = function(t, e) {
  var n = e.__c, i = this;
  i.t == null && (i.t = []), i.t.push(n);
  var r = YM(i.__v), a = !1, o = function() {
    a || (a = !0, n.__R = null, r ? r(s) : s());
  };
  n.__R = o;
  var s = function() {
    if (!--i.__u) {
      if (i.state.__e) {
        var c = i.state.__e;
        i.__v.__k[0] = function f(m, h, p) {
          return m && (m.__v = null, m.__k = m.__k && m.__k.map(function(g) {
            return f(g, h, p);
          }), m.__c && m.__c.__P === h && (m.__e && p.insertBefore(m.__e, m.__d), m.__c.__e = !0, m.__c.__P = p)), m;
        }(c, c.__c.__P, c.__c.__O);
      }
      var u;
      for (i.setState({
        __e: i.__b = null
      }); u = i.t.pop(); ) u.forceUpdate();
    }
  }, l = e.__h === !0;
  i.__u++ || l || i.setState({
    __e: i.__b = i.__v.__k[0]
  }), t.then(o, o);
}, i1.prototype.componentWillUnmount = function() {
  this.t = [];
}, i1.prototype.render = function(t, e) {
  if (this.__b) {
    if (this.__v.__k) {
      var n = document.createElement("div"), i = this.__v.__k[0].__c;
      this.__v.__k[0] = function a(o, s, l) {
        return o && (o.__c && o.__c.__H && (o.__c.__H.__.forEach(function(c) {
          typeof c.__c == "function" && c.__c();
        }), o.__c.__H = null), (o = nz({}, o)).__c != null && (o.__c.__P === l && (o.__c.__P = s), o.__c = null), o.__k = o.__k && o.__k.map(function(c) {
          return a(c, s, l);
        })), o;
      }(this.__b, n, i.__O = i.__P);
    }
    this.__b = null;
  }
  var r = e.__e && Gp(xs, null, t.fallback);
  return r && (r.__h = null), [
    Gp(xs, null, e.__e ? null : t.children),
    r
  ];
};
var Ek = function(t, e, n) {
  if (++n[1] === n[0] && t.o.delete(e), t.props.revealOrder && (t.props.revealOrder[0] !== "t" || !t.o.size)) for (n = t.u; n; ) {
    for (; n.length > 3; ) n.pop()();
    if (n[1] < n[0]) break;
    t.u = n = n[2];
  }
};
(Vc.prototype = new cr()).__e = function(t) {
  var e = this, n = YM(e.__v), i = e.o.get(t);
  return i[0]++, function(r) {
    var a = function() {
      e.props.revealOrder ? (i.push(r), Ek(e, t, i)) : r();
    };
    n ? n(a) : a();
  };
}, Vc.prototype.render = function(t) {
  this.u = null, this.o = /* @__PURE__ */ new Map();
  var e = hf(t.children);
  t.revealOrder && t.revealOrder[0] === "b" && e.reverse();
  for (var n = e.length; n--; ) this.o.set(e[n], this.u = [
    1,
    0,
    this.u
  ]);
  return t.children;
}, Vc.prototype.componentDidUpdate = Vc.prototype.componentDidMount = function() {
  var t = this;
  this.o.forEach(function(e, n) {
    Ek(t, n, e);
  });
};
var rz = typeof Symbol < "u" && Symbol.for && Symbol.for("react.element") || 60103, az = /^(?:accent|alignment|arabic|baseline|cap|clip(?!PathU)|color|dominant|fill|flood|font|glyph(?!R)|horiz|marker(?!H|W|U)|overline|paint|stop|strikethrough|stroke|text(?!L)|underline|unicode|units|v|vector|vert|word|writing|x(?!C))[A-Z]/, oz = typeof document < "u", sz = function(t) {
  return (typeof Symbol < "u" && typeof Symbol() == "symbol" ? /fil|che|rad/i : /fil|che|ra/i).test(t);
};
cr.prototype.isReactComponent = {}, [
  "componentWillMount",
  "componentWillReceiveProps",
  "componentWillUpdate"
].forEach(function(t) {
  Object.defineProperty(cr.prototype, t, {
    configurable: !0,
    get: function() {
      return this["UNSAFE_" + t];
    },
    set: function(e) {
      Object.defineProperty(this, t, {
        configurable: !0,
        writable: !0,
        value: e
      });
    }
  });
});
var Tk = Ie.event;
function lz() {
}
function dz() {
  return this.cancelBubble;
}
function cz() {
  return this.defaultPrevented;
}
Ie.event = function(t) {
  return Tk && (t = Tk(t)), t.persist = lz, t.isPropagationStopped = dz, t.isDefaultPrevented = cz, t.nativeEvent = t;
};
var Ok = {
  configurable: !0,
  get: function() {
    return this.class;
  }
}, Wk = Ie.vnode;
Ie.vnode = function(t) {
  var e = t.type, n = t.props, i = n;
  if (typeof e == "string") {
    var r = e.indexOf("-") === -1;
    for (var a in i = {}, n) {
      var o = n[a];
      oz && a === "children" && e === "noscript" || a === "value" && "defaultValue" in n && o == null || (a === "defaultValue" && "value" in n && n.value == null ? a = "value" : a === "download" && o === !0 ? o = "" : /ondoubleclick/i.test(a) ? a = "ondblclick" : /^onchange(textarea|input)/i.test(a + e) && !sz(n.type) ? a = "oninput" : /^onfocus$/i.test(a) ? a = "onfocusin" : /^onblur$/i.test(a) ? a = "onfocusout" : /^on(Ani|Tra|Tou|BeforeInp)/.test(a) ? a = a.toLowerCase() : r && az.test(a) ? a = a.replace(/[A-Z0-9]/, "-$&").toLowerCase() : o === null && (o = void 0), i[a] = o);
    }
    e == "select" && i.multiple && Array.isArray(i.value) && (i.value = hf(n.children).forEach(function(s) {
      s.props.selected = i.value.indexOf(s.props.value) != -1;
    })), e == "select" && i.defaultValue != null && (i.value = hf(n.children).forEach(function(s) {
      s.props.selected = i.multiple ? i.defaultValue.indexOf(s.props.value) != -1 : i.defaultValue == s.props.value;
    })), t.props = i, n.class != n.className && (Ok.enumerable = "className" in n, n.className != null && (i.class = n.className), Object.defineProperty(i, "className", Ok));
  }
  t.$$typeof = rz, Wk && Wk(t);
};
var Ak = Ie.__r;
Ie.__r = function(t) {
  Ak && Ak(t), t.__c;
};
const uz = {
  light: "outline",
  dark: "solid"
};
class fz extends yf {
  renderIcon(e) {
    const { icon: n } = e;
    if (n) {
      if (n.svg) return /* @__PURE__ */ Z("span", {
        class: "flex",
        dangerouslySetInnerHTML: {
          __html: n.svg
        }
      });
      if (n.src) return /* @__PURE__ */ Z("img", {
        src: n.src
      });
    }
    const i = gf.categories[e.id] || gf.categories.custom, r = this.props.icons == "auto" ? uz[this.props.theme] : this.props.icons;
    return i[r] || i;
  }
  render() {
    let e = null;
    return /* @__PURE__ */ Z("nav", {
      id: "nav",
      class: "padding",
      "data-position": this.props.position,
      dir: this.props.dir,
      children: /* @__PURE__ */ Z("div", {
        class: "flex relative",
        children: [
          this.categories.map((n, i) => {
            const r = n.name || pn.categories[n.id], a = !this.props.unfocused && n.id == this.state.categoryId;
            return a && (e = i), /* @__PURE__ */ Z("button", {
              "aria-label": r,
              "aria-selected": a || void 0,
              title: r,
              type: "button",
              class: "flex flex-grow flex-center",
              onMouseDown: (o) => o.preventDefault(),
              onClick: () => {
                this.props.onClick({
                  category: n,
                  i
                });
              },
              children: this.renderIcon(n)
            });
          }),
          /* @__PURE__ */ Z("div", {
            class: "bar",
            style: {
              width: `${100 / this.categories.length}%`,
              opacity: e == null ? 0 : 1,
              transform: this.props.dir === "rtl" ? `scaleX(-1) translateX(${e * 100}%)` : `translateX(${e * 100}%)`
            }
          })
        ]
      })
    });
  }
  constructor() {
    super(), this.categories = Je.categories.filter((e) => !e.target), this.state = {
      categoryId: this.categories[0].id
    };
  }
}
class mz extends yf {
  shouldComponentUpdate(e) {
    for (let n in e)
      if (n != "children" && e[n] != this.props[n])
        return !0;
    return !1;
  }
  render() {
    return this.props.children;
  }
}
const Hc = {
  rowsPerRender: 10
};
class hz extends cr {
  getInitialState(e = this.props) {
    return {
      skin: va.get("skin") || e.skin,
      theme: this.initTheme(e.theme)
    };
  }
  componentWillMount() {
    this.dir = pn.rtl ? "rtl" : "ltr", this.refs = {
      menu: wr(),
      navigation: wr(),
      scroll: wr(),
      search: wr(),
      searchInput: wr(),
      skinToneButton: wr(),
      skinToneRadio: wr()
    }, this.initGrid(), this.props.stickySearch == !1 && this.props.searchPosition == "sticky" && (console.warn("[EmojiMart] Deprecation warning: `stickySearch` has been renamed `searchPosition`."), this.props.searchPosition = "static");
  }
  componentDidMount() {
    if (this.register(), this.shadowRoot = this.base.parentNode, this.props.autoFocus) {
      const { searchInput: e } = this.refs;
      e.current && e.current.focus();
    }
  }
  componentWillReceiveProps(e) {
    this.nextState || (this.nextState = {});
    for (const n in e) this.nextState[n] = e[n];
    clearTimeout(this.nextStateTimer), this.nextStateTimer = setTimeout(() => {
      let n = !1;
      for (const r in this.nextState)
        this.props[r] = this.nextState[r], (r === "custom" || r === "categories") && (n = !0);
      delete this.nextState;
      const i = this.getInitialState();
      if (n) return this.reset(i);
      this.setState(i);
    });
  }
  componentWillUnmount() {
    this.unregister();
  }
  async reset(e = {}) {
    await eh(this.props), this.initGrid(), this.unobserve(), this.setState(e, () => {
      this.observeCategories(), this.observeRows();
    });
  }
  register() {
    document.addEventListener("click", this.handleClickOutside), this.observe();
  }
  unregister() {
    var e;
    document.removeEventListener("click", this.handleClickOutside), (e = this.darkMedia) == null || e.removeEventListener("change", this.darkMediaCallback), this.unobserve();
  }
  observe() {
    this.observeCategories(), this.observeRows();
  }
  unobserve({ except: e = [] } = {}) {
    Array.isArray(e) || (e = [
      e
    ]);
    for (const n of this.observers)
      e.includes(n) || n.disconnect();
    this.observers = [].concat(e);
  }
  initGrid() {
    const { categories: e } = Je;
    this.refs.categories = /* @__PURE__ */ new Map();
    const n = Je.categories.map((r) => r.id).join(",");
    this.navKey && this.navKey != n && this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0), this.navKey = n, this.grid = [], this.grid.setsize = 0;
    const i = (r, a) => {
      const o = [];
      o.__categoryId = a.id, o.__index = r.length, this.grid.push(o);
      const s = this.grid.length - 1, l = s % Hc.rowsPerRender ? {} : wr();
      return l.index = s, l.posinset = this.grid.setsize + 1, r.push(l), o;
    };
    for (let r of e) {
      const a = [];
      let o = i(a, r);
      for (let s of r.emojis)
        o.length == this.getPerLine() && (o = i(a, r)), this.grid.setsize += 1, o.push(s);
      this.refs.categories.set(r.id, {
        root: wr(),
        rows: a
      });
    }
  }
  initTheme(e) {
    if (e != "auto") return e;
    if (!this.darkMedia) {
      if (this.darkMedia = matchMedia("(prefers-color-scheme: dark)"), this.darkMedia.media.match(/^not/)) return "light";
      this.darkMedia.addEventListener("change", this.darkMediaCallback);
    }
    return this.darkMedia.matches ? "dark" : "light";
  }
  initDynamicPerLine(e = this.props) {
    if (!e.dynamicWidth) return;
    const { element: n, emojiButtonSize: i } = e, r = () => {
      const { width: o } = n.getBoundingClientRect();
      return Math.floor(o / i);
    }, a = new ResizeObserver(() => {
      this.unobserve({
        except: a
      }), this.setState({
        perLine: r()
      }, () => {
        this.initGrid(), this.forceUpdate(() => {
          this.observeCategories(), this.observeRows();
        });
      });
    });
    return a.observe(n), this.observers.push(a), r();
  }
  getPerLine() {
    return this.state.perLine || this.props.perLine;
  }
  getEmojiByPos([e, n]) {
    const i = this.state.searchResults || this.grid, r = i[e] && i[e][n];
    if (r)
      return cs.get(r);
  }
  observeCategories() {
    const e = this.refs.navigation.current;
    if (!e) return;
    const n = /* @__PURE__ */ new Map(), i = (o) => {
      o != e.state.categoryId && e.setState({
        categoryId: o
      });
    }, r = {
      root: this.refs.scroll.current,
      threshold: [
        0,
        1
      ]
    }, a = new IntersectionObserver((o) => {
      for (const l of o) {
        const c = l.target.dataset.id;
        n.set(c, l.intersectionRatio);
      }
      const s = [
        ...n
      ];
      for (const [l, c] of s) if (c) {
        i(l);
        break;
      }
    }, r);
    for (const { root: o } of this.refs.categories.values()) a.observe(o.current);
    this.observers.push(a);
  }
  observeRows() {
    const e = {
      ...this.state.visibleRows
    }, n = new IntersectionObserver((i) => {
      for (const r of i) {
        const a = parseInt(r.target.dataset.index);
        r.isIntersecting ? e[a] = !0 : delete e[a];
      }
      this.setState({
        visibleRows: e
      });
    }, {
      root: this.refs.scroll.current,
      rootMargin: `${this.props.emojiButtonSize * (Hc.rowsPerRender + 5)}px 0px ${this.props.emojiButtonSize * Hc.rowsPerRender}px`
    });
    for (const { rows: i } of this.refs.categories.values())
      for (const r of i) r.current && n.observe(r.current);
    this.observers.push(n);
  }
  preventDefault(e) {
    e.preventDefault();
  }
  unfocusSearch() {
    const e = this.refs.searchInput.current;
    e && e.blur();
  }
  navigate({ e, input: n, left: i, right: r, up: a, down: o }) {
    const s = this.state.searchResults || this.grid;
    if (!s.length) return;
    let [l, c] = this.state.pos;
    const u = (() => {
      if (l == 0 && c == 0 && !e.repeat && (i || a))
        return null;
      if (l == -1)
        return !e.repeat && (r || o) && n.selectionStart == n.value.length ? [
          0,
          0
        ] : null;
      if (i || r) {
        let f = s[l];
        const m = i ? -1 : 1;
        if (c += m, !f[c]) {
          if (l += m, f = s[l], !f)
            return l = i ? 0 : s.length - 1, c = i ? 0 : s[l].length - 1, [
              l,
              c
            ];
          c = i ? f.length - 1 : 0;
        }
        return [
          l,
          c
        ];
      }
      if (a || o) {
        l += a ? -1 : 1;
        const f = s[l];
        return f ? (f[c] || (c = f.length - 1), [
          l,
          c
        ]) : (l = a ? 0 : s.length - 1, c = a ? 0 : s[l].length - 1, [
          l,
          c
        ]);
      }
    })();
    if (u) e.preventDefault();
    else {
      this.state.pos[0] > -1 && this.setState({
        pos: [
          -1,
          -1
        ]
      });
      return;
    }
    this.setState({
      pos: u,
      keyboard: !0
    }, () => {
      this.scrollTo({
        row: u[0]
      });
    });
  }
  scrollTo({ categoryId: e, row: n }) {
    const i = this.state.searchResults || this.grid;
    if (!i.length) return;
    const r = this.refs.scroll.current, a = r.getBoundingClientRect();
    let o = 0;
    if (n >= 0 && (e = i[n].__categoryId), e && (o = (this.refs[e] || this.refs.categories.get(e).root).current.getBoundingClientRect().top - (a.top - r.scrollTop) + 1), n >= 0)
      if (!n) o = 0;
      else {
        const s = i[n].__index, l = o + s * this.props.emojiButtonSize, c = l + this.props.emojiButtonSize + this.props.emojiButtonSize * 0.88;
        if (l < r.scrollTop) o = l;
        else if (c > r.scrollTop + a.height) o = c - a.height;
        else return;
      }
    this.ignoreMouse(), r.scrollTop = o;
  }
  ignoreMouse() {
    this.mouseIsIgnored = !0, clearTimeout(this.ignoreMouseTimer), this.ignoreMouseTimer = setTimeout(() => {
      delete this.mouseIsIgnored;
    }, 100);
  }
  handleEmojiOver(e) {
    this.mouseIsIgnored || this.state.showSkins || this.setState({
      pos: e || [
        -1,
        -1
      ],
      keyboard: !1
    });
  }
  handleEmojiClick({ e, emoji: n, pos: i }) {
    if (this.props.onEmojiSelect && (!n && i && (n = this.getEmojiByPos(i)), n)) {
      const r = UF(n, {
        skinIndex: this.state.skin - 1
      });
      this.props.maxFrequentRows && jM.add(r, this.props), this.props.onEmojiSelect(r, e);
    }
  }
  closeSkins() {
    this.state.showSkins && (this.setState({
      showSkins: null,
      tempSkin: null
    }), this.base.removeEventListener("click", this.handleBaseClick), this.base.removeEventListener("keydown", this.handleBaseKeydown));
  }
  handleSkinMouseOver(e) {
    this.setState({
      tempSkin: e
    });
  }
  handleSkinClick(e) {
    this.ignoreMouse(), this.closeSkins(), this.setState({
      skin: e,
      tempSkin: null
    }), va.set("skin", e);
  }
  renderNav() {
    return /* @__PURE__ */ Z(fz, {
      ref: this.refs.navigation,
      icons: this.props.icons,
      theme: this.state.theme,
      dir: this.dir,
      unfocused: !!this.state.searchResults,
      position: this.props.navPosition,
      onClick: this.handleCategoryClick
    }, this.navKey);
  }
  renderPreview() {
    const e = this.getEmojiByPos(this.state.pos), n = this.state.searchResults && !this.state.searchResults.length;
    return /* @__PURE__ */ Z("div", {
      id: "preview",
      class: "flex flex-middle",
      dir: this.dir,
      "data-position": this.props.previewPosition,
      children: [
        /* @__PURE__ */ Z("div", {
          class: "flex flex-middle flex-grow",
          children: [
            /* @__PURE__ */ Z("div", {
              class: "flex flex-auto flex-middle flex-center",
              style: {
                height: this.props.emojiButtonSize,
                fontSize: this.props.emojiButtonSize
              },
              children: /* @__PURE__ */ Z(Kp, {
                emoji: e,
                id: n ? this.props.noResultsEmoji || "cry" : this.props.previewEmoji || (this.props.previewPosition == "top" ? "point_down" : "point_up"),
                set: this.props.set,
                size: this.props.emojiButtonSize,
                skin: this.state.tempSkin || this.state.skin,
                spritesheet: !0,
                getSpritesheetURL: this.props.getSpritesheetURL
              })
            }),
            /* @__PURE__ */ Z("div", {
              class: `margin-${this.dir[0]}`,
              children: e || n ? /* @__PURE__ */ Z("div", {
                class: `padding-${this.dir[2]} align-${this.dir[0]}`,
                children: [
                  /* @__PURE__ */ Z("div", {
                    class: "preview-title ellipsis",
                    children: e ? e.name : pn.search_no_results_1
                  }),
                  /* @__PURE__ */ Z("div", {
                    class: "preview-subtitle ellipsis color-c",
                    children: e ? e.skins[0].shortcodes : pn.search_no_results_2
                  })
                ]
              }) : /* @__PURE__ */ Z("div", {
                class: "preview-placeholder color-c",
                children: pn.pick
              })
            })
          ]
        }),
        !e && this.props.skinTonePosition == "preview" && this.renderSkinToneButton()
      ]
    });
  }
  renderEmojiButton(e, { pos: n, posinset: i, grid: r }) {
    const a = this.props.emojiButtonSize, o = this.state.tempSkin || this.state.skin, l = (e.skins[o - 1] || e.skins[0]).native, c = YF(this.state.pos, n), u = n.concat(e.id).join("");
    return /* @__PURE__ */ Z(mz, {
      selected: c,
      skin: o,
      size: a,
      children: /* @__PURE__ */ Z("button", {
        "aria-label": l,
        "aria-selected": c || void 0,
        "aria-posinset": i,
        "aria-setsize": r.setsize,
        "data-keyboard": this.state.keyboard,
        title: this.props.previewPosition == "none" ? e.name : void 0,
        type: "button",
        class: "flex flex-center flex-middle",
        tabindex: "-1",
        onClick: (f) => this.handleEmojiClick({
          e: f,
          emoji: e
        }),
        onMouseEnter: () => this.handleEmojiOver(n),
        onMouseLeave: () => this.handleEmojiOver(),
        style: {
          width: this.props.emojiButtonSize,
          height: this.props.emojiButtonSize,
          fontSize: this.props.emojiSize,
          lineHeight: 0
        },
        children: [
          /* @__PURE__ */ Z("div", {
            "aria-hidden": "true",
            class: "background",
            style: {
              borderRadius: this.props.emojiButtonRadius,
              backgroundColor: this.props.emojiButtonColors ? this.props.emojiButtonColors[(i - 1) % this.props.emojiButtonColors.length] : void 0
            }
          }),
          /* @__PURE__ */ Z(Kp, {
            emoji: e,
            set: this.props.set,
            size: this.props.emojiSize,
            skin: o,
            spritesheet: !0,
            getSpritesheetURL: this.props.getSpritesheetURL
          })
        ]
      })
    }, u);
  }
  renderSearch() {
    const e = this.props.previewPosition == "none" || this.props.skinTonePosition == "search";
    return /* @__PURE__ */ Z("div", {
      children: [
        /* @__PURE__ */ Z("div", {
          class: "spacer"
        }),
        /* @__PURE__ */ Z("div", {
          class: "flex flex-middle",
          children: [
            /* @__PURE__ */ Z("div", {
              class: "search relative flex-grow",
              children: [
                /* @__PURE__ */ Z("input", {
                  type: "search",
                  ref: this.refs.searchInput,
                  placeholder: pn.search,
                  onClick: this.handleSearchClick,
                  onInput: this.handleSearchInput,
                  onKeyDown: this.handleSearchKeyDown,
                  autoComplete: "off"
                }),
                /* @__PURE__ */ Z("span", {
                  class: "icon loupe flex",
                  children: gf.search.loupe
                }),
                this.state.searchResults && /* @__PURE__ */ Z("button", {
                  title: "Clear",
                  "aria-label": "Clear",
                  type: "button",
                  class: "icon delete flex",
                  onClick: this.clearSearch,
                  onMouseDown: this.preventDefault,
                  children: gf.search.delete
                })
              ]
            }),
            e && this.renderSkinToneButton()
          ]
        })
      ]
    });
  }
  renderSearchResults() {
    const { searchResults: e } = this.state;
    return e ? /* @__PURE__ */ Z("div", {
      class: "category",
      ref: this.refs.search,
      children: [
        /* @__PURE__ */ Z("div", {
          class: `sticky padding-small align-${this.dir[0]}`,
          children: pn.categories.search
        }),
        /* @__PURE__ */ Z("div", {
          children: e.length ? e.map((n, i) => /* @__PURE__ */ Z("div", {
            class: "flex",
            children: n.map((r, a) => this.renderEmojiButton(r, {
              pos: [
                i,
                a
              ],
              posinset: i * this.props.perLine + a + 1,
              grid: e
            }))
          })) : /* @__PURE__ */ Z("div", {
            class: `padding-small align-${this.dir[0]}`,
            children: this.props.onAddCustomEmoji && /* @__PURE__ */ Z("a", {
              onClick: this.props.onAddCustomEmoji,
              children: pn.add_custom
            })
          })
        })
      ]
    }) : null;
  }
  renderCategories() {
    const { categories: e } = Je, n = !!this.state.searchResults, i = this.getPerLine();
    return /* @__PURE__ */ Z("div", {
      style: {
        visibility: n ? "hidden" : void 0,
        display: n ? "none" : void 0,
        height: "100%"
      },
      children: e.map((r) => {
        const { root: a, rows: o } = this.refs.categories.get(r.id);
        return /* @__PURE__ */ Z("div", {
          "data-id": r.target ? r.target.id : r.id,
          class: "category",
          ref: a,
          children: [
            /* @__PURE__ */ Z("div", {
              class: `sticky padding-small align-${this.dir[0]}`,
              children: r.name || pn.categories[r.id]
            }),
            /* @__PURE__ */ Z("div", {
              class: "relative",
              style: {
                height: o.length * this.props.emojiButtonSize
              },
              children: o.map((s, l) => {
                const c = s.index - s.index % Hc.rowsPerRender, u = this.state.visibleRows[c], f = "current" in s ? s : void 0;
                if (!u && !f) return null;
                const m = l * i, h = m + i, p = r.emojis.slice(m, h);
                return p.length < i && p.push(...new Array(i - p.length)), /* @__PURE__ */ Z("div", {
                  "data-index": s.index,
                  ref: f,
                  class: "flex row",
                  style: {
                    top: l * this.props.emojiButtonSize
                  },
                  children: u && p.map((g, y) => {
                    if (!g) return /* @__PURE__ */ Z("div", {
                      style: {
                        width: this.props.emojiButtonSize,
                        height: this.props.emojiButtonSize
                      }
                    });
                    const v = cs.get(g);
                    return this.renderEmojiButton(v, {
                      pos: [
                        s.index,
                        y
                      ],
                      posinset: s.posinset + y,
                      grid: this.grid
                    });
                  })
                }, s.index);
              })
            })
          ]
        });
      })
    });
  }
  renderSkinToneButton() {
    return this.props.skinTonePosition == "none" ? null : /* @__PURE__ */ Z("div", {
      class: "flex flex-auto flex-center flex-middle",
      style: {
        position: "relative",
        width: this.props.emojiButtonSize,
        height: this.props.emojiButtonSize
      },
      children: /* @__PURE__ */ Z("button", {
        type: "button",
        ref: this.refs.skinToneButton,
        class: "skin-tone-button flex flex-auto flex-center flex-middle",
        "aria-selected": this.state.showSkins ? "" : void 0,
        "aria-label": pn.skins.choose,
        title: pn.skins.choose,
        onClick: this.openSkins,
        style: {
          width: this.props.emojiSize,
          height: this.props.emojiSize
        },
        children: /* @__PURE__ */ Z("span", {
          class: `skin-tone skin-tone-${this.state.skin}`
        })
      })
    });
  }
  renderLiveRegion() {
    const e = this.getEmojiByPos(this.state.pos), n = e ? e.name : "";
    return /* @__PURE__ */ Z("div", {
      "aria-live": "polite",
      class: "sr-only",
      children: n
    });
  }
  renderSkins() {
    const n = this.refs.skinToneButton.current.getBoundingClientRect(), i = this.base.getBoundingClientRect(), r = {};
    return this.dir == "ltr" ? r.right = i.right - n.right - 3 : r.left = n.left - i.left - 3, this.props.previewPosition == "bottom" && this.props.skinTonePosition == "preview" ? r.bottom = i.bottom - n.top + 6 : (r.top = n.bottom - i.top + 3, r.bottom = "auto"), /* @__PURE__ */ Z("div", {
      ref: this.refs.menu,
      role: "radiogroup",
      dir: this.dir,
      "aria-label": pn.skins.choose,
      class: "menu hidden",
      "data-position": r.top ? "top" : "bottom",
      style: r,
      children: [
        ...Array(6).keys()
      ].map((a) => {
        const o = a + 1, s = this.state.skin == o;
        return /* @__PURE__ */ Z("div", {
          children: [
            /* @__PURE__ */ Z("input", {
              type: "radio",
              name: "skin-tone",
              value: o,
              "aria-label": pn.skins[o],
              ref: s ? this.refs.skinToneRadio : null,
              defaultChecked: s,
              onChange: () => this.handleSkinMouseOver(o),
              onKeyDown: (l) => {
                (l.code == "Enter" || l.code == "Space" || l.code == "Tab") && (l.preventDefault(), this.handleSkinClick(o));
              }
            }),
            /* @__PURE__ */ Z("button", {
              "aria-hidden": "true",
              tabindex: "-1",
              onClick: () => this.handleSkinClick(o),
              onMouseEnter: () => this.handleSkinMouseOver(o),
              onMouseLeave: () => this.handleSkinMouseOver(),
              class: "option flex flex-grow flex-middle",
              children: [
                /* @__PURE__ */ Z("span", {
                  class: `skin-tone skin-tone-${o}`
                }),
                /* @__PURE__ */ Z("span", {
                  class: "margin-small-lr",
                  children: pn.skins[o]
                })
              ]
            })
          ]
        });
      })
    });
  }
  render() {
    const e = this.props.perLine * this.props.emojiButtonSize;
    return /* @__PURE__ */ Z("section", {
      id: "root",
      class: "flex flex-column",
      dir: this.dir,
      style: {
        width: this.props.dynamicWidth ? "100%" : `calc(${e}px + (var(--padding) + var(--sidebar-width)))`
      },
      "data-emoji-set": this.props.set,
      "data-theme": this.state.theme,
      "data-menu": this.state.showSkins ? "" : void 0,
      children: [
        this.props.previewPosition == "top" && this.renderPreview(),
        this.props.navPosition == "top" && this.renderNav(),
        this.props.searchPosition == "sticky" && /* @__PURE__ */ Z("div", {
          class: "padding-lr",
          children: this.renderSearch()
        }),
        /* @__PURE__ */ Z("div", {
          ref: this.refs.scroll,
          class: "scroll flex-grow padding-lr",
          children: /* @__PURE__ */ Z("div", {
            style: {
              width: this.props.dynamicWidth ? "100%" : e,
              height: "100%"
            },
            children: [
              this.props.searchPosition == "static" && this.renderSearch(),
              this.renderSearchResults(),
              this.renderCategories()
            ]
          })
        }),
        this.props.navPosition == "bottom" && this.renderNav(),
        this.props.previewPosition == "bottom" && this.renderPreview(),
        this.state.showSkins && this.renderSkins(),
        this.renderLiveRegion()
      ]
    });
  }
  constructor(e) {
    super(), hi(this, "darkMediaCallback", () => {
      this.props.theme == "auto" && this.setState({
        theme: this.darkMedia.matches ? "dark" : "light"
      });
    }), hi(this, "handleClickOutside", (n) => {
      const { element: i } = this.props;
      n.target != i && (this.state.showSkins && this.closeSkins(), this.props.onClickOutside && this.props.onClickOutside(n));
    }), hi(this, "handleBaseClick", (n) => {
      this.state.showSkins && (n.target.closest(".menu") || (n.preventDefault(), n.stopImmediatePropagation(), this.closeSkins()));
    }), hi(this, "handleBaseKeydown", (n) => {
      this.state.showSkins && n.key == "Escape" && (n.preventDefault(), n.stopImmediatePropagation(), this.closeSkins());
    }), hi(this, "handleSearchClick", () => {
      this.getEmojiByPos(this.state.pos) && this.setState({
        pos: [
          -1,
          -1
        ]
      });
    }), hi(this, "handleSearchInput", async () => {
      const n = this.refs.searchInput.current;
      if (!n) return;
      const { value: i } = n, r = await cs.search(i), a = () => {
        this.refs.scroll.current && (this.refs.scroll.current.scrollTop = 0);
      };
      if (!r) return this.setState({
        searchResults: r,
        pos: [
          -1,
          -1
        ]
      }, a);
      const o = n.selectionStart == n.value.length ? [
        0,
        0
      ] : [
        -1,
        -1
      ], s = [];
      s.setsize = r.length;
      let l = null;
      for (let c of r)
        (!s.length || l.length == this.getPerLine()) && (l = [], l.__categoryId = "search", l.__index = s.length, s.push(l)), l.push(c);
      this.ignoreMouse(), this.setState({
        searchResults: s,
        pos: o
      }, a);
    }), hi(this, "handleSearchKeyDown", (n) => {
      const i = n.currentTarget;
      switch (n.stopImmediatePropagation(), n.key) {
        case "ArrowLeft":
          this.navigate({
            e: n,
            input: i,
            left: !0
          });
          break;
        case "ArrowRight":
          this.navigate({
            e: n,
            input: i,
            right: !0
          });
          break;
        case "ArrowUp":
          this.navigate({
            e: n,
            input: i,
            up: !0
          });
          break;
        case "ArrowDown":
          this.navigate({
            e: n,
            input: i,
            down: !0
          });
          break;
        case "Enter":
          n.preventDefault(), this.handleEmojiClick({
            e: n,
            pos: this.state.pos
          });
          break;
        case "Escape":
          n.preventDefault(), this.state.searchResults ? this.clearSearch() : this.unfocusSearch();
          break;
      }
    }), hi(this, "clearSearch", () => {
      const n = this.refs.searchInput.current;
      n && (n.value = "", n.focus(), this.handleSearchInput());
    }), hi(this, "handleCategoryClick", ({ category: n, i }) => {
      this.scrollTo(i == 0 ? {
        row: -1
      } : {
        categoryId: n.id
      });
    }), hi(this, "openSkins", (n) => {
      const { currentTarget: i } = n, r = i.getBoundingClientRect();
      this.setState({
        showSkins: r
      }, async () => {
        await KF(2);
        const a = this.refs.menu.current;
        a && (a.classList.remove("hidden"), this.refs.skinToneRadio.current.focus(), this.base.addEventListener("click", this.handleBaseClick, !0), this.base.addEventListener("keydown", this.handleBaseKeydown, !0));
      });
    }), this.observers = [], this.state = {
      pos: [
        -1,
        -1
      ],
      perLine: this.initDynamicPerLine(e),
      visibleRows: {
        0: !0
      },
      ...this.getInitialState(e)
    };
  }
}
class Ev extends ez {
  async connectedCallback() {
    const e = HM(this.props, Dr, this);
    e.element = this, e.ref = (n) => {
      this.component = n;
    }, await eh(e), !this.disconnected && IM(/* @__PURE__ */ Z(hz, {
      ...e
    }), this.shadowRoot);
  }
  constructor(e) {
    super(e, {
      styles: /* @__PURE__ */ CM(KM)
    });
  }
}
hi(Ev, "Props", Dr);
typeof customElements < "u" && !customElements.get("em-emoji-picker") && customElements.define("em-emoji-picker", Ev);
var KM = {};
KM = `:host {
  width: min-content;
  height: 435px;
  min-height: 230px;
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
  --border-radius: 10px;
  --category-icon-size: 18px;
  --font-family: -apple-system, BlinkMacSystemFont, "Helvetica Neue", sans-serif;
  --font-size: 15px;
  --preview-placeholder-size: 21px;
  --preview-title-size: 1.1em;
  --preview-subtitle-size: .9em;
  --shadow-color: 0deg 0% 0%;
  --shadow: .3px .5px 2.7px hsl(var(--shadow-color) / .14), .4px .8px 1px -3.2px hsl(var(--shadow-color) / .14), 1px 2px 2.5px -4.5px hsl(var(--shadow-color) / .14);
  display: flex;
}

[data-theme="light"] {
  --em-rgb-color: var(--rgb-color, 34, 36, 39);
  --em-rgb-accent: var(--rgb-accent, 34, 102, 237);
  --em-rgb-background: var(--rgb-background, 255, 255, 255);
  --em-rgb-input: var(--rgb-input, 255, 255, 255);
  --em-color-border: var(--color-border, rgba(0, 0, 0, .05));
  --em-color-border-over: var(--color-border-over, rgba(0, 0, 0, .1));
}

[data-theme="dark"] {
  --em-rgb-color: var(--rgb-color, 222, 222, 221);
  --em-rgb-accent: var(--rgb-accent, 58, 130, 247);
  --em-rgb-background: var(--rgb-background, 21, 22, 23);
  --em-rgb-input: var(--rgb-input, 0, 0, 0);
  --em-color-border: var(--color-border, rgba(255, 255, 255, .1));
  --em-color-border-over: var(--color-border-over, rgba(255, 255, 255, .2));
}

#root {
  --color-a: rgb(var(--em-rgb-color));
  --color-b: rgba(var(--em-rgb-color), .65);
  --color-c: rgba(var(--em-rgb-color), .45);
  --padding: 12px;
  --padding-small: calc(var(--padding) / 2);
  --sidebar-width: 16px;
  --duration: 225ms;
  --duration-fast: 125ms;
  --duration-instant: 50ms;
  --easing: cubic-bezier(.4, 0, .2, 1);
  width: 100%;
  text-align: left;
  border-radius: var(--border-radius);
  background-color: rgb(var(--em-rgb-background));
  position: relative;
}

@media (prefers-reduced-motion) {
  #root {
    --duration: 0;
    --duration-fast: 0;
    --duration-instant: 0;
  }
}

#root[data-menu] button {
  cursor: auto;
}

#root[data-menu] .menu button {
  cursor: pointer;
}

:host, #root, input, button {
  color: rgb(var(--em-rgb-color));
  font-family: var(--font-family);
  font-size: var(--font-size);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  line-height: normal;
}

*, :before, :after {
  box-sizing: border-box;
  min-width: 0;
  margin: 0;
  padding: 0;
}

.relative {
  position: relative;
}

.flex {
  display: flex;
}

.flex-auto {
  flex: none;
}

.flex-center {
  justify-content: center;
}

.flex-column {
  flex-direction: column;
}

.flex-grow {
  flex: auto;
}

.flex-middle {
  align-items: center;
}

.flex-wrap {
  flex-wrap: wrap;
}

.padding {
  padding: var(--padding);
}

.padding-t {
  padding-top: var(--padding);
}

.padding-lr {
  padding-left: var(--padding);
  padding-right: var(--padding);
}

.padding-r {
  padding-right: var(--padding);
}

.padding-small {
  padding: var(--padding-small);
}

.padding-small-b {
  padding-bottom: var(--padding-small);
}

.padding-small-lr {
  padding-left: var(--padding-small);
  padding-right: var(--padding-small);
}

.margin {
  margin: var(--padding);
}

.margin-r {
  margin-right: var(--padding);
}

.margin-l {
  margin-left: var(--padding);
}

.margin-small-l {
  margin-left: var(--padding-small);
}

.margin-small-lr {
  margin-left: var(--padding-small);
  margin-right: var(--padding-small);
}

.align-l {
  text-align: left;
}

.align-r {
  text-align: right;
}

.color-a {
  color: var(--color-a);
}

.color-b {
  color: var(--color-b);
}

.color-c {
  color: var(--color-c);
}

.ellipsis {
  white-space: nowrap;
  max-width: 100%;
  width: auto;
  text-overflow: ellipsis;
  overflow: hidden;
}

.sr-only {
  width: 1px;
  height: 1px;
  position: absolute;
  top: auto;
  left: -10000px;
  overflow: hidden;
}

a {
  cursor: pointer;
  color: rgb(var(--em-rgb-accent));
}

a:hover {
  text-decoration: underline;
}

.spacer {
  height: 10px;
}

[dir="rtl"] .scroll {
  padding-left: 0;
  padding-right: var(--padding);
}

.scroll {
  padding-right: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

.scroll::-webkit-scrollbar {
  width: var(--sidebar-width);
  height: var(--sidebar-width);
}

.scroll::-webkit-scrollbar-track {
  border: 0;
}

.scroll::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}

.scroll::-webkit-scrollbar-corner {
  background-color: rgba(0, 0, 0, 0);
}

.scroll::-webkit-scrollbar-thumb {
  min-height: 20%;
  min-height: 65px;
  border: 4px solid rgb(var(--em-rgb-background));
  border-radius: 8px;
}

.scroll::-webkit-scrollbar-thumb:hover {
  background-color: var(--em-color-border-over) !important;
}

.scroll:hover::-webkit-scrollbar-thumb {
  background-color: var(--em-color-border);
}

.sticky {
  z-index: 1;
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  font-weight: 500;
  position: sticky;
  top: -1px;
}

[dir="rtl"] .search input[type="search"] {
  padding: 10px 2.2em 10px 2em;
}

[dir="rtl"] .search .loupe {
  left: auto;
  right: .7em;
}

[dir="rtl"] .search .delete {
  left: .7em;
  right: auto;
}

.search {
  z-index: 2;
  position: relative;
}

.search input, .search button {
  font-size: calc(var(--font-size)  - 1px);
}

.search input[type="search"] {
  width: 100%;
  background-color: var(--em-color-border);
  transition-duration: var(--duration);
  transition-property: background-color, box-shadow;
  transition-timing-function: var(--easing);
  border: 0;
  border-radius: 10px;
  outline: 0;
  padding: 10px 2em 10px 2.2em;
  display: block;
}

.search input[type="search"]::-ms-input-placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"]::placeholder {
  color: inherit;
  opacity: .6;
}

.search input[type="search"], .search input[type="search"]::-webkit-search-decoration, .search input[type="search"]::-webkit-search-cancel-button, .search input[type="search"]::-webkit-search-results-button, .search input[type="search"]::-webkit-search-results-decoration {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
}

.search input[type="search"]:focus {
  background-color: rgb(var(--em-rgb-input));
  box-shadow: inset 0 0 0 1px rgb(var(--em-rgb-accent)), 0 1px 3px rgba(65, 69, 73, .2);
}

.search .icon {
  z-index: 1;
  color: rgba(var(--em-rgb-color), .7);
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

.search .loupe {
  pointer-events: none;
  left: .7em;
}

.search .delete {
  right: .7em;
}

svg {
  fill: currentColor;
  width: 1em;
  height: 1em;
}

button {
  -webkit-appearance: none;
  -ms-appearance: none;
  appearance: none;
  cursor: pointer;
  color: currentColor;
  background-color: rgba(0, 0, 0, 0);
  border: 0;
}

#nav {
  z-index: 2;
  padding-top: 12px;
  padding-bottom: 12px;
  padding-right: var(--sidebar-width);
  position: relative;
}

#nav button {
  color: var(--color-b);
  transition: color var(--duration) var(--easing);
}

#nav button:hover {
  color: var(--color-a);
}

#nav svg, #nav img {
  width: var(--category-icon-size);
  height: var(--category-icon-size);
}

#nav[dir="rtl"] .bar {
  left: auto;
  right: 0;
}

#nav .bar {
  width: 100%;
  height: 3px;
  background-color: rgb(var(--em-rgb-accent));
  transition: transform var(--duration) var(--easing);
  border-radius: 3px 3px 0 0;
  position: absolute;
  bottom: -12px;
  left: 0;
}

#nav button[aria-selected] {
  color: rgb(var(--em-rgb-accent));
}

#preview {
  z-index: 2;
  padding: calc(var(--padding)  + 4px) var(--padding);
  padding-right: var(--sidebar-width);
  position: relative;
}

#preview .preview-placeholder {
  font-size: var(--preview-placeholder-size);
}

#preview .preview-title {
  font-size: var(--preview-title-size);
}

#preview .preview-subtitle {
  font-size: var(--preview-subtitle-size);
}

#nav:before, #preview:before {
  content: "";
  height: 2px;
  position: absolute;
  left: 0;
  right: 0;
}

#nav[data-position="top"]:before, #preview[data-position="top"]:before {
  background: linear-gradient(to bottom, var(--em-color-border), transparent);
  top: 100%;
}

#nav[data-position="bottom"]:before, #preview[data-position="bottom"]:before {
  background: linear-gradient(to top, var(--em-color-border), transparent);
  bottom: 100%;
}

.category:last-child {
  min-height: calc(100% + 1px);
}

.category button {
  font-family: -apple-system, BlinkMacSystemFont, Helvetica Neue, sans-serif;
  position: relative;
}

.category button > * {
  position: relative;
}

.category button .background {
  opacity: 0;
  background-color: var(--em-color-border);
  transition: opacity var(--duration-fast) var(--easing) var(--duration-instant);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}

.category button:hover .background {
  transition-duration: var(--duration-instant);
  transition-delay: 0s;
}

.category button[aria-selected] .background {
  opacity: 1;
}

.category button[data-keyboard] .background {
  transition: none;
}

.row {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
}

.skin-tone-button {
  border: 1px solid rgba(0, 0, 0, 0);
  border-radius: 100%;
}

.skin-tone-button:hover {
  border-color: var(--em-color-border);
}

.skin-tone-button:active .skin-tone {
  transform: scale(.85) !important;
}

.skin-tone-button .skin-tone {
  transition: transform var(--duration) var(--easing);
}

.skin-tone-button[aria-selected] {
  background-color: var(--em-color-border);
  border-top-color: rgba(0, 0, 0, .05);
  border-bottom-color: rgba(0, 0, 0, 0);
  border-left-width: 0;
  border-right-width: 0;
}

.skin-tone-button[aria-selected] .skin-tone {
  transform: scale(.9);
}

.menu {
  z-index: 2;
  white-space: nowrap;
  border: 1px solid var(--em-color-border);
  background-color: rgba(var(--em-rgb-background), .9);
  -webkit-backdrop-filter: blur(4px);
  backdrop-filter: blur(4px);
  transition-property: opacity, transform;
  transition-duration: var(--duration);
  transition-timing-function: var(--easing);
  border-radius: 10px;
  padding: 4px;
  position: absolute;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .05);
}

.menu.hidden {
  opacity: 0;
}

.menu[data-position="bottom"] {
  transform-origin: 100% 100%;
}

.menu[data-position="bottom"].hidden {
  transform: scale(.9)rotate(-3deg)translateY(5%);
}

.menu[data-position="top"] {
  transform-origin: 100% 0;
}

.menu[data-position="top"].hidden {
  transform: scale(.9)rotate(3deg)translateY(-5%);
}

.menu input[type="radio"] {
  clip: rect(0 0 0 0);
  width: 1px;
  height: 1px;
  border: 0;
  margin: 0;
  padding: 0;
  position: absolute;
  overflow: hidden;
}

.menu input[type="radio"]:checked + .option {
  box-shadow: 0 0 0 2px rgb(var(--em-rgb-accent));
}

.option {
  width: 100%;
  border-radius: 6px;
  padding: 4px 6px;
}

.option:hover {
  color: #fff;
  background-color: rgb(var(--em-rgb-accent));
}

.skin-tone {
  width: 16px;
  height: 16px;
  border-radius: 100%;
  display: inline-block;
  position: relative;
  overflow: hidden;
}

.skin-tone:after {
  content: "";
  mix-blend-mode: overlay;
  background: linear-gradient(rgba(255, 255, 255, .2), rgba(0, 0, 0, 0));
  border: 1px solid rgba(0, 0, 0, .8);
  border-radius: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 2px #fff;
}

.skin-tone-1 {
  background-color: #ffc93a;
}

.skin-tone-2 {
  background-color: #ffdab7;
}

.skin-tone-3 {
  background-color: #e7b98f;
}

.skin-tone-4 {
  background-color: #c88c61;
}

.skin-tone-5 {
  background-color: #a46134;
}

.skin-tone-6 {
  background-color: #5d4437;
}

[data-index] {
  justify-content: space-between;
}

[data-emoji-set="twitter"] .skin-tone:after {
  box-shadow: none;
  border-color: rgba(0, 0, 0, .5);
}

[data-emoji-set="twitter"] .skin-tone-1 {
  background-color: #fade72;
}

[data-emoji-set="twitter"] .skin-tone-2 {
  background-color: #f3dfd0;
}

[data-emoji-set="twitter"] .skin-tone-3 {
  background-color: #eed3a8;
}

[data-emoji-set="twitter"] .skin-tone-4 {
  background-color: #cfad8d;
}

[data-emoji-set="twitter"] .skin-tone-5 {
  background-color: #a8805d;
}

[data-emoji-set="twitter"] .skin-tone-6 {
  background-color: #765542;
}

[data-emoji-set="google"] .skin-tone:after {
  box-shadow: inset 0 0 2px 2px rgba(0, 0, 0, .4);
}

[data-emoji-set="google"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="google"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="google"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="google"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="google"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="google"] .skin-tone-6 {
  background-color: #61493f;
}

[data-emoji-set="facebook"] .skin-tone:after {
  border-color: rgba(0, 0, 0, .4);
  box-shadow: inset 0 -2px 3px #000, inset 0 1px 4px #fff;
}

[data-emoji-set="facebook"] .skin-tone-1 {
  background-color: #f5c748;
}

[data-emoji-set="facebook"] .skin-tone-2 {
  background-color: #f1d5aa;
}

[data-emoji-set="facebook"] .skin-tone-3 {
  background-color: #d4b48d;
}

[data-emoji-set="facebook"] .skin-tone-4 {
  background-color: #aa876b;
}

[data-emoji-set="facebook"] .skin-tone-5 {
  background-color: #916544;
}

[data-emoji-set="facebook"] .skin-tone-6 {
  background-color: #61493f;
}

`;
function pz(t) {
  const e = Oe(null), n = Oe(null);
  return n.current && n.current.update(t), le(() => (n.current = new Ev({
    ...t,
    ref: e
  }), () => {
    n.current = null;
  }), []), /* @__PURE__ */ H.createElement("div", {
    ref: e
  });
}
const gz = 36, yz = "10px", vz = 24, bz = 2;
function Tv({
  onSelect: t,
  locale: e = "en",
  size: n = "md",
  variant: i = "outline",
  lastEmojiReaction: r
}) {
  const [a, o] = q(!1);
  return /* @__PURE__ */ k($o, { open: a, onOpenChange: o, children: [
    /* @__PURE__ */ d(Do, { asChild: !0, children: /* @__PURE__ */ d(
      ue,
      {
        variant: i,
        label: "Add reaction",
        size: n,
        icon: r ? void 0 : L5,
        emoji: r,
        onClick: (s) => {
          s.preventDefault(), s.stopPropagation(), o((l) => !l);
        },
        hideLabel: !0
      }
    ) }),
    /* @__PURE__ */ d(
      Eo,
      {
        side: "bottom",
        align: "start",
        className: "w-fit border-none bg-transparent p-2 shadow-none",
        onClick: (s) => {
          s.preventDefault(), s.stopPropagation();
        },
        children: /* @__PURE__ */ d(
          pz,
          {
            data: NF,
            onEmojiSelect: (s) => {
              t == null || t(s.native), o(!1);
            },
            locale: e,
            icons: "outline",
            set: "twitter",
            theme: "light",
            emojiButtonSize: gz,
            emojiButtonRadius: yz,
            emojiSize: vz,
            maxFrequentRows: bz,
            skinTonePosition: "none",
            previewPosition: "none",
            searchPosition: "top",
            navPosition: "top",
            dynamicWidth: !0
          }
        )
      }
    )
  ] });
}
const wz = {
  birthday: "🎂",
  anniversary: "🎉",
  "first-day": "💼"
}, kz = {
  viridian: "bg-[hsl(theme(colors.viridian.50)_/_0.2)]",
  malibu: "bg-[hsl(theme(colors.malibu.50)_/_0.2)]",
  yellow: "bg-[hsl(theme(colors.yellow.50)_/_0.2)]",
  purple: "bg-[hsl(theme(colors.purple.50)_/_0.2)]",
  lilac: "bg-[hsl(theme(colors.lilac.50)_/_0.2)]",
  barbie: "bg-[hsl(theme(colors.barbie.50)_/_0.2)]",
  smoke: "bg-[hsl(theme(colors.smoke.50)_/_0.2)]",
  army: "bg-[hsl(theme(colors.army.50)_/_0.2)]",
  flubber: "bg-[hsl(theme(colors.flubber.50)_/_0.2)]",
  indigo: "bg-[hsl(theme(colors.indigo.50)_/_0.2)]",
  camel: "bg-[hsl(theme(colors.camel.50)_/_0.2)]"
};
function xz({
  firstName: t,
  lastName: e,
  src: n,
  canReact: i,
  lastEmojiReaction: r,
  onReactionSelect: a,
  pickerRef: o
}) {
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "relative h-32 w-full overflow-hidden rounded-md bg-f1-background",
        n ? "" : kz[A6(
          [t, e].join("")
        )]
      ),
      children: [
        n && /* @__PURE__ */ d(
          "div",
          {
            className: "absolute inset-0 bg-cover bg-center bg-no-repeat opacity-10",
            style: { backgroundImage: `url("${n}")` }
          }
        ),
        /* @__PURE__ */ d("div", { className: "relative flex h-full w-full items-center justify-center overflow-hidden rounded-md backdrop-blur", children: /* @__PURE__ */ k("div", { className: "relative h-fit w-fit", children: [
          /* @__PURE__ */ d(
            "div",
            {
              style: i ? {
                clipPath: "path('M69.6933 48.707C71.1842 44.7556 72 40.4731 72 36C72 16.1177 55.8823 0 36 0C16.1177 0 0 16.1177 0 36C0 55.8823 16.1177 72 36 72C40.4731 72 44.7556 71.1842 48.707 69.6933C48.6283 69.4953 48.5557 69.2942 48.4894 69.0902C48 67.5838 48 65.7226 48 62C48 58.2774 48 56.4162 48.4894 54.9098C49.4786 51.8655 51.8655 49.4786 54.9098 48.4894C56.4162 48 58.2774 48 62 48C65.7226 48 67.5838 48 69.0902 48.4894C69.2942 48.5557 69.4953 48.6283 69.6933 48.707')"
              } : {},
              children: /* @__PURE__ */ d(
                ti,
                {
                  src: n,
                  firstName: t,
                  lastName: e,
                  size: "xlarge"
                }
              )
            }
          ),
          i && /* @__PURE__ */ d(
            "div",
            {
              ref: o,
              className: E(
                "absolute -right-0.5",
                n ? "bottom-0.5" : "-bottom-[3px]"
              ),
              children: /* @__PURE__ */ d(
                Tv,
                {
                  lastEmojiReaction: r,
                  onSelect: a,
                  size: "sm",
                  variant: "neutral"
                }
              )
            }
          )
        ] }) })
      ]
    }
  );
}
function _z(t) {
  const e = Oe(null), n = Oe(), i = Le(() => {
    const a = e.current;
    if (!a) return;
    const o = Y$.create(a, {
      resize: !0,
      useWorker: !1
    }), s = ["9D76F3", "3FC495", "E61D46", "F6AF3D"], l = 0.1;
    n.current = setInterval(() => {
      o({
        particleCount: 1,
        angle: 90,
        spread: 45,
        origin: {
          x: l + Math.random() * (1 - l * 2),
          y: -0.1
        },
        gravity: 0.65,
        scalar: 1,
        ticks: 80,
        startVelocity: 1,
        disableForReducedMotion: t,
        colors: [
          s[Math.floor(Math.random() * s.length)]
        ]
      });
    }, 100);
  }, [t]), r = Le(() => {
    clearInterval(n.current);
  }, []);
  return { canvasRef: e, handleMouseEnter: i, handleMouseLeave: r };
}
const Mz = ({
  link: t,
  firstName: e,
  lastName: n,
  src: i,
  onClick: r,
  canReact: a = !0,
  lastEmojiReaction: o,
  onReactionSelect: s,
  type: l,
  typeLabel: c,
  date: u
}) => {
  const [f, m] = q(o), h = Oe(null);
  le(() => {
    m(o);
  }, [o]);
  const p = (b) => {
    m(b), s == null || s(b);
  }, g = Hd(), { canvasRef: y, handleMouseEnter: v, handleMouseLeave: w } = _z(g), x = Bd({
    emoji: wz[l],
    size: "sm"
  });
  return /* @__PURE__ */ k(
    _n,
    {
      href: t,
      onClick: r,
      className: E(
        "relative flex flex-col rounded-xl border border-solid border-f1-border-secondary bg-f1-background-inverse-secondary no-underline transition-shadow hover:shadow",
        Ke()
      ),
      onMouseEnter: g ? void 0 : v,
      onMouseLeave: g ? void 0 : w,
      children: [
        /* @__PURE__ */ d(
          "canvas",
          {
            ref: y,
            className: "pointer-events-none absolute inset-0 z-50 h-full w-full"
          }
        ),
        /* @__PURE__ */ d("div", { className: "basis-2/3 px-1 pt-1", children: /* @__PURE__ */ d(
          xz,
          {
            firstName: e,
            lastName: n,
            src: i,
            canReact: a,
            lastEmojiReaction: f,
            onReactionSelect: p,
            pickerRef: h
          }
        ) }),
        /* @__PURE__ */ k("div", { className: "flex basis-1/3 flex-row justify-between gap-2 p-3", children: [
          /* @__PURE__ */ k("div", { className: "flex min-w-0 flex-1 flex-col", children: [
            /* @__PURE__ */ k("div", { className: "truncate font-medium text-f1-foreground", children: [
              e,
              " ",
              n
            ] }),
            /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1.5 text-f1-foreground-secondary", children: [
              /* @__PURE__ */ d("span", { className: "truncate", children: c }),
              /* @__PURE__ */ d("span", { className: "shrink-0 leading-none", children: x })
            ] })
          ] }),
          /* @__PURE__ */ d("div", { className: "shrink-0", children: /* @__PURE__ */ d(qp, { date: u }) })
        ] })
      ]
    }
  );
}, Cz = () => /* @__PURE__ */ k(
  "div",
  {
    className: "bg-f1-background-inverse-secondar flex flex-col rounded-xl border border-solid border-f1-border-secondary",
    role: "status",
    "aria-busy": "true",
    "aria-live": "polite",
    children: [
      /* @__PURE__ */ d("div", { className: "basis-2/3 px-1 pt-1", children: /* @__PURE__ */ d(Ce, { className: "h-32 w-full rounded-lg" }) }),
      /* @__PURE__ */ d("div", { className: "flex basis-1/3 flex-row justify-between gap-2 p-3", children: /* @__PURE__ */ d("div", { className: "flex min-w-0 flex-1 flex-col", children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-2 py-1", children: [
        /* @__PURE__ */ d(Ce, { className: "h-3 w-2/3" }),
        /* @__PURE__ */ d(Ce, { className: "h-3 w-1/3" })
      ] }) }) })
    ]
  }
), sYe = Bt(Mz, Cz), lYe = ({
  title: t,
  subtitle: e,
  buttonLabel: n,
  onClick: i
}) => /* @__PURE__ */ k("div", { className: "flex w-full flex-col items-start justify-between gap-4 rounded-md bg-gradient-to-r from-[#F5A51C]/30 via-[#E51943]/30 to-[#5596F6]/30 px-3 py-3 ring-1 ring-inset ring-f1-border-secondary sm:flex-row sm:items-center sm:px-4", children: [
  /* @__PURE__ */ k("div", { className: "flex flex-col items-start gap-3 sm:flex-row sm:items-center", children: [
    /* @__PURE__ */ d(Sm, { module: "kudos", size: "lg" }),
    /* @__PURE__ */ k("div", { className: "flex flex-col", children: [
      /* @__PURE__ */ d("span", { className: "font-medium text-f1-foreground", children: t }),
      /* @__PURE__ */ d("span", { className: "text-f1-foreground-secondary", children: e })
    ] })
  ] }),
  /* @__PURE__ */ d("div", { className: "w-full sm:w-fit [&>div]:w-full", children: /* @__PURE__ */ d(ue, { label: n, variant: "outline", onClick: i }) })
] }), ba = (t, e, n) => {
  const i = document.createElement(t), [r, a] = Array.isArray(e) ? [void 0, e] : [e, n];
  return r && Object.assign(i, r), a == null || a.forEach((o) => i.appendChild(o)), i;
}, Pz = (t, e) => {
  var n;
  return e === "left" ? t.offsetLeft : (((n = t.offsetParent instanceof HTMLElement ? t.offsetParent : null) == null ? void 0 : n.offsetWidth) ?? 0) - t.offsetWidth - t.offsetLeft;
}, Sz = (t) => t.offsetWidth > 0 && t.offsetHeight > 0, Nz = (t, e) => {
  if (customElements.get(t) !== e)
    return customElements.define(t, e);
};
function $z(t, e, { reverse: n = !1 } = {}) {
  const i = t.length;
  for (let r = n ? i - 1 : 0; n ? r >= 0 : r < i; n ? r-- : r++)
    e(t[r], r);
}
function Dz(t, e, n, i) {
  const r = e.formatToParts(t);
  n && r.unshift({ type: "prefix", value: n }), i && r.push({ type: "suffix", value: i });
  const a = [], o = [], s = [], l = [], c = {}, u = (g) => `${g}:${c[g] = (c[g] ?? -1) + 1}`;
  let f = "", m = !1, h = !1;
  for (const g of r) {
    f += g.value;
    const y = g.type === "minusSign" || g.type === "plusSign" ? "sign" : g.type;
    y === "integer" ? (m = !0, o.push(...g.value.split("").map((v) => ({ type: y, value: parseInt(v) })))) : y === "group" ? o.push({ type: y, value: g.value }) : y === "decimal" ? (h = !0, s.push({ type: y, value: g.value, key: u(y) })) : y === "fraction" ? s.push(...g.value.split("").map((v) => ({
      type: y,
      value: parseInt(v),
      key: u(y),
      place: -1 - c[y]
    }))) : (m || h ? l : a).push({
      type: y,
      value: g.value,
      key: u(y)
    });
  }
  const p = [];
  for (let g = o.length - 1; g >= 0; g--) {
    const y = o[g];
    p.unshift(y.type === "integer" ? {
      ...y,
      key: u(y.type),
      place: c[y.type]
    } : {
      ...y,
      key: u(y.type)
    });
  }
  return {
    pre: a,
    integer: p,
    fraction: s,
    post: l,
    valueAsString: f,
    value: typeof t == "string" ? parseFloat(t) : t
  };
}
const Ez = String.raw, Tz = typeof CSS < "u" && CSS.supports && CSS.supports("animation-timing-function", "linear(1,2)"), Oz = typeof CSS < "u" && CSS.supports && CSS.supports("line-height", "mod(1,1)"), Lk = typeof matchMedia < "u" ? matchMedia("(prefers-reduced-motion: reduce)") : null, vf = "--_number-flow-d-opacity", Ov = "--_number-flow-d-width", bf = "--_number-flow-dx", Wv = "--_number-flow-d", Wz = (() => {
  try {
    return CSS.registerProperty({
      name: vf,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: bf,
      syntax: "<length>",
      inherits: !0,
      initialValue: "0px"
    }), CSS.registerProperty({
      name: Ov,
      syntax: "<number>",
      inherits: !1,
      initialValue: "0"
    }), CSS.registerProperty({
      name: Wv,
      syntax: "<number>",
      inherits: !0,
      initialValue: "0"
    }), !0;
  } catch {
    return !1;
  }
})(), Az = "var(--number-flow-char-height, 1em)", Zr = "var(--number-flow-mask-height, 0.25em)", r1 = `calc(${Zr} / 2)`, Qp = "var(--number-flow-mask-width, 0.5em)", Ya = `calc(${Qp} / var(--scale-x))`, Bc = "#000 0, transparent 71%", Ik = Ez`:host{display:inline-block;direction:ltr;white-space:nowrap;line-height:${Az} !important;isolation:isolate;}.number,.number__inner{display:inline-block;transform-origin:left top;}:host([data-will-change]) :is(.number,.number__inner,.section,.digit,.digit__num,.symbol){will-change:transform;}.number{--scale-x:calc(1 + var(${Ov}) / var(--width));transform:translateX(var(${bf})) scaleX(var(--scale-x));margin:0 calc(-1 * ${Qp});position:relative;z-index:-1;-webkit-mask-image:linear-gradient( to right,transparent 0,#000 ${Ya},#000 calc(100% - ${Ya}),transparent ),linear-gradient( to bottom,transparent 0,#000 ${Zr},#000 calc(100% - ${Zr}),transparent 100% ),radial-gradient(at bottom right,${Bc}),radial-gradient(at bottom left,${Bc}),radial-gradient(at top left,${Bc}),radial-gradient(at top right,${Bc});-webkit-mask-size:100% calc(100% - ${Zr} * 2),calc(100% - ${Ya} * 2) 100%,${Ya} ${Zr},${Ya} ${Zr},${Ya} ${Zr},${Ya} ${Zr};-webkit-mask-position:center,center,top left,top right,bottom right,bottom left;-webkit-mask-repeat:no-repeat;}.number__inner{padding:${r1} ${Qp};transform:scaleX(calc(1 / var(--scale-x))) translateX(calc(-1 * var(${bf})));}.section{display:inline-block;position:relative;isolation:isolate;}.section::after{content:'\200b';display:inline-block;padding:${r1} 0;}.section--justify-left{transform-origin:center left;}.section--justify-right{transform-origin:center right;}.section__exiting,.symbol__exiting{margin:0 !important;position:absolute !important;z-index:-1;}.digit{display:inline-block;position:relative;--c:var(--current) + var(${Wv});}.digit__num{display:inline-block;padding:${r1} 0;--offset-raw:mod(10 + var(--n) - mod(var(--c),10),10);--offset:calc(var(--offset-raw) - 10 * round(down,var(--offset-raw) / 5,1));--y:clamp(-100%,var(--offset) * 100%,100%);transform:translateY(var(--y));}.digit__num:not(.is-current){position:absolute;top:0;left:50%;transform:translateX(-50%) translateY(var(--y));}.digit:not(.is-spinning) .digit__num:not(.is-current){display:none;}.symbol{display:inline-block;position:relative;isolation:isolate;}.symbol__value{display:inline-block;mix-blend-mode:plus-lighter;white-space:pre;}.section--justify-left .symbol__exiting{left:0;}.section--justify-right .symbol__exiting{right:0;}.animate-presence{opacity:calc(1 + var(${vf}));}`, Lz = HTMLElement, Iz = (t, e) => t != null && e == null ? t : t == null && e != null ? e : t != null && e != null ? Math.max(t, e) : null, Rz = Oz && Tz && Wz;
var ca;
(function(t) {
  t[t.UP = 1] = "UP", t[t.DOWN = -1] = "DOWN", t[t.NONE = 0] = "NONE";
})(ca || (ca = {}));
let qc, UM = class extends Lz {
  constructor() {
    super(...arguments), this.transformTiming = this.constructor.defaultProps.transformTiming, this.spinTiming = this.constructor.defaultProps.spinTiming, this.opacityTiming = this.constructor.defaultProps.opacityTiming, this.respectMotionPreference = this.constructor.defaultProps.respectMotionPreference, this.trend = this.constructor.defaultProps.trend, this.continuous = this.constructor.defaultProps.continuous, this._animated = this.constructor.defaultProps.animated, this._created = !1, this._computedAnimated = this._animated, this.manual = !1;
  }
  get animated() {
    return this._animated;
  }
  set animated(e) {
    var n;
    this.animated !== e && (this._animated = e, (n = this.shadowRoot) == null || n.getAnimations().forEach((i) => i.finish()));
  }
  get created() {
    return this._created;
  }
  get computedTrend() {
    return this._computedTrend;
  }
  get startingPlace() {
    return this._startingPlace;
  }
  get computedAnimated() {
    return this._computedAnimated;
  }
  set data(e) {
    if (e == null)
      return;
    const { pre: n, integer: i, fraction: r, post: a, value: o } = e;
    if (this._created) {
      const s = this._data;
      if (this._data = e, this.trend === !0 ? this._computedTrend = Math.sign(o - s.value) : this.trend === "increasing" ? this._computedTrend = ca.UP : this.trend === "decreasing" ? this._computedTrend = ca.DOWN : this._computedTrend = ca.NONE, this._startingPlace = void 0, this._computedTrend !== ca.NONE && this.continuous) {
        const l = s.integer.concat(s.fraction).filter((m) => m.type === "integer" || m.type === "fraction"), c = e.integer.concat(e.fraction).filter((m) => m.type === "integer" || m.type === "fraction"), u = l.find((m) => !c.find((h) => h.place === m.place && h.value === m.value)), f = c.find((m) => !l.find((h) => m.place === h.place && m.value === h.value));
        this._startingPlace = Iz(u == null ? void 0 : u.place, f == null ? void 0 : f.place);
      }
      this._computedAnimated = Rz && this._animated && (!this.respectMotionPreference || !(Lk != null && Lk.matches)) && // https://github.com/barvian/number-flow/issues/9
      Sz(this), this.manual || this.willUpdate(), this._pre.update(n), this._num.update({ integer: i, fraction: r }), this._post.update(a), this.manual || this.didUpdate();
    } else {
      if (this._data = e, this.attachShadow({ mode: "open" }), typeof CSSStyleSheet < "u" && this.shadowRoot.adoptedStyleSheets)
        qc || (qc = new CSSStyleSheet(), qc.replaceSync(Ik)), this.shadowRoot.adoptedStyleSheets = [qc];
      else {
        const s = document.createElement("style");
        s.textContent = Ik, this.shadowRoot.appendChild(s);
      }
      this._pre = new jk(this, n, {
        justify: "right",
        part: "left"
      }), this.shadowRoot.appendChild(this._pre.el), this._num = new jz(this, i, r), this.shadowRoot.appendChild(this._num.el), this._post = new jk(this, a, {
        justify: "left",
        part: "right"
      }), this.shadowRoot.appendChild(this._post.el);
    }
    this._created = !0;
  }
  willUpdate() {
    this._pre.willUpdate(), this._num.willUpdate(), this._post.willUpdate();
  }
  didUpdate() {
    if (!this._computedAnimated)
      return;
    this._abortAnimationsFinish ? this._abortAnimationsFinish.abort() : this.dispatchEvent(new Event("animationsstart")), this._pre.didUpdate(), this._num.didUpdate(), this._post.didUpdate();
    const e = new AbortController();
    Promise.all(this.shadowRoot.getAnimations().map((n) => n.finished)).then(() => {
      e.signal.aborted || (this.dispatchEvent(new Event("animationsfinish")), this._abortAnimationsFinish = void 0);
    }), this._abortAnimationsFinish = e;
  }
};
UM.defaultProps = {
  transformTiming: {
    duration: 900,
    // Make sure to keep this minified:
    easing: "linear(0,.005,.019,.039,.066,.096,.129,.165,.202,.24,.278,.316,.354,.39,.426,.461,.494,.526,.557,.586,.614,.64,.665,.689,.711,.731,.751,.769,.786,.802,.817,.831,.844,.856,.867,.877,.887,.896,.904,.912,.919,.925,.931,.937,.942,.947,.951,.955,.959,.962,.965,.968,.971,.973,.976,.978,.98,.981,.983,.984,.986,.987,.988,.989,.99,.991,.992,.992,.993,.994,.994,.995,.995,.996,.996,.9963,.9967,.9969,.9972,.9975,.9977,.9979,.9981,.9982,.9984,.9985,.9987,.9988,.9989,1)"
  },
  spinTiming: void 0,
  opacityTiming: { duration: 450, easing: "ease-out" },
  animated: !0,
  trend: !0,
  continuous: !1,
  respectMotionPreference: !0
};
let jz = class {
  constructor(e, n, i, { className: r, ...a } = {}) {
    this.flow = e, this._integer = new Rk(e, n, {
      justify: "right",
      part: "integer"
    }), this._fraction = new Rk(e, i, {
      justify: "left",
      part: "fraction"
    }), this._inner = ba("span", {
      className: "number__inner"
    }, [this._integer.el, this._fraction.el]), this.el = ba("span", {
      ...a,
      part: "number",
      className: `number ${r ?? ""}`
    }, [this._inner]);
  }
  willUpdate() {
    this._prevWidth = this.el.offsetWidth, this._prevLeft = this.el.getBoundingClientRect().left, this._integer.willUpdate(), this._fraction.willUpdate();
  }
  update({ integer: e, fraction: n }) {
    this._integer.update(e), this._fraction.update(n);
  }
  didUpdate() {
    const e = this.el.getBoundingClientRect();
    this._integer.didUpdate(), this._fraction.didUpdate();
    const n = this._prevLeft - e.left, i = this.el.offsetWidth, r = this._prevWidth - i;
    this.el.style.setProperty("--width", String(i)), this.el.animate({
      [bf]: [`${n}px`, "0px"],
      [Ov]: [r, 0]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}, JM = class {
  constructor(e, n, { justify: i, className: r, ...a }, o) {
    this.flow = e, this.children = /* @__PURE__ */ new Map(), this.onCharRemove = (l) => () => {
      this.children.delete(l);
    }, this.justify = i;
    const s = n.map((l) => this.addChar(l).el);
    this.el = ba("span", {
      ...a,
      className: `section section--justify-${i} ${r ?? ""}`
    }, o ? o(s) : s);
  }
  addChar(e, { startDigitsAtZero: n = !1, ...i } = {}) {
    const r = e.type === "integer" || e.type === "fraction" ? new ZM(this, e.type, n ? 0 : e.value, e.place, {
      ...i,
      onRemove: this.onCharRemove(e.key)
    }) : new Fz(this, e.type, e.value, {
      ...i,
      onRemove: this.onCharRemove(e.key)
    });
    return this.children.set(e.key, r), r;
  }
  unpop(e) {
    e.el.classList.remove("section__exiting"), e.el.style.top = "", e.el.style[this.justify] = "";
  }
  pop(e) {
    e.forEach((n) => {
      n.el.style.top = `${n.el.offsetTop}px`, n.el.style[this.justify] = `${Pz(n.el, this.justify)}px`;
    }), e.forEach((n) => {
      n.el.classList.add("section__exiting"), n.present = !1;
    });
  }
  addNewAndUpdateExisting(e) {
    const n = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Map(), r = this.justify === "left", a = r ? "prepend" : "append";
    if ($z(e, (o) => {
      let s;
      this.children.has(o.key) ? (s = this.children.get(o.key), i.set(o, s), this.unpop(s), s.present = !0) : (s = this.addChar(o, { startDigitsAtZero: !0, animateIn: !0 }), n.set(o, s)), this.el[a](s.el);
    }, { reverse: r }), this.flow.computedAnimated) {
      const o = this.el.getBoundingClientRect();
      n.forEach((s) => {
        s.willUpdate(o);
      });
    }
    n.forEach((o, s) => {
      o.update(s.value);
    }), i.forEach((o, s) => {
      o.update(s.value);
    });
  }
  willUpdate() {
    const e = this.el.getBoundingClientRect();
    this._prevOffset = e[this.justify], this.children.forEach((n) => n.willUpdate(e));
  }
  didUpdate() {
    const e = this.el.getBoundingClientRect();
    this.children.forEach((r) => r.didUpdate(e));
    const n = e[this.justify], i = this._prevOffset - n;
    i && this.children.size && this.el.animate({
      transform: [`translateX(${i}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
  }
}, Rk = class extends JM {
  update(e) {
    const n = /* @__PURE__ */ new Map();
    this.children.forEach((i, r) => {
      e.find((a) => a.key === r) || n.set(r, i), this.unpop(i);
    }), this.addNewAndUpdateExisting(e), n.forEach((i) => {
      i instanceof ZM && i.update(0);
    }), this.pop(n);
  }
}, jk = class extends JM {
  update(e) {
    const n = /* @__PURE__ */ new Map();
    this.children.forEach((i, r) => {
      e.find((a) => a.key === r) || n.set(r, i);
    }), this.pop(n), this.addNewAndUpdateExisting(e);
  }
};
class Zp {
  constructor(e, n, { onRemove: i, animateIn: r = !1 } = {}) {
    this.flow = e, this.el = n, this._present = !0, this._remove = () => {
      var a;
      this.el.remove(), (a = this._onRemove) == null || a.call(this);
    }, this.el.classList.add("animate-presence"), this.flow.computedAnimated && r && this.el.animate({
      [vf]: [-0.9999, 0]
    }, {
      ...this.flow.opacityTiming,
      composite: "accumulate"
    }), this._onRemove = i;
  }
  get present() {
    return this._present;
  }
  set present(e) {
    if (this._present !== e) {
      if (this._present = e, !this.flow.computedAnimated) {
        e || this._remove();
        return;
      }
      this.el.style.setProperty("--_number-flow-d-opacity", e ? "0" : "-.999"), this.el.animate({
        [vf]: e ? [-0.9999, 0] : [0.999, 0]
      }, {
        ...this.flow.opacityTiming,
        composite: "accumulate"
      }), e ? this.flow.removeEventListener("animationsfinish", this._remove) : this.flow.addEventListener("animationsfinish", this._remove, {
        once: !0
      });
    }
  }
}
let QM = class extends Zp {
  constructor(e, n, i, r) {
    super(e.flow, i, r), this.section = e, this.value = n, this.el = i;
  }
}, ZM = class extends QM {
  constructor(e, n, i, r, a) {
    const o = Array.from({ length: 10 }).map((l, c) => {
      const u = ba("span", { className: `digit__num${c === i ? " is-current" : ""}` }, [document.createTextNode(String(c))]);
      return u.style.setProperty("--n", String(c)), u;
    }), s = ba("span", {
      part: `digit ${n}-digit`,
      className: "digit"
    }, o);
    s.style.setProperty("--current", String(i)), super(e, i, s, a), this.place = r, this._onAnimationsFinish = () => {
      this.el.classList.remove("is-spinning");
    }, this._numbers = o;
  }
  willUpdate(e) {
    const n = this.el.getBoundingClientRect();
    this._prevValue = this.value;
    const i = n[this.section.justify] - e[this.section.justify], r = n.width / 2;
    this._prevCenter = this.section.justify === "left" ? i + r : i - r;
  }
  update(e) {
    var n, i;
    (n = this._numbers[this.value]) == null || n.classList.remove("is-current"), this.el.style.setProperty("--current", String(e)), (i = this._numbers[e]) == null || i.classList.add("is-current"), this.value = e;
  }
  didUpdate(e) {
    const n = this.el.getBoundingClientRect(), i = n[this.section.justify] - e[this.section.justify], r = n.width / 2, a = this.section.justify === "left" ? i + r : i - r, o = this._prevCenter - a;
    o && this.el.animate({
      transform: [`translateX(${o}px)`, "none"]
    }, {
      ...this.flow.transformTiming,
      composite: "accumulate"
    });
    const s = this.diff;
    s && (this.el.classList.add("is-spinning"), this.el.animate({
      [Wv]: [-s, 0]
    }, {
      ...this.flow.spinTiming ?? this.flow.transformTiming,
      composite: "accumulate"
    }), this.flow.addEventListener("animationsfinish", this._onAnimationsFinish, { once: !0 }));
  }
  get diff() {
    let e = this.flow.computedTrend;
    const n = this.value - this._prevValue;
    return !n && this.flow.startingPlace != null && this.flow.startingPlace >= this.place ? 10 * e : (e || (e = Math.sign(n)), e === ca.DOWN && this.value > this._prevValue ? this.value - 10 - this._prevValue : e === ca.UP && this.value < this._prevValue ? 10 - this._prevValue + this.value : n);
  }
}, Fz = class extends QM {
  constructor(e, n, i, r) {
    const a = ba("span", {
      className: "symbol__value",
      textContent: i
    });
    super(e, i, ba("span", {
      part: n,
      className: "symbol"
    }, [a]), r), this.type = n, this._children = /* @__PURE__ */ new Map(), this._onChildRemove = (o) => () => {
      this._children.delete(o);
    }, this._children.set(i, new Zp(this.flow, a, {
      onRemove: this._onChildRemove(i)
    }));
  }
  willUpdate(e) {
    if (this.type === "decimal")
      return;
    const n = this.el.getBoundingClientRect();
    this._prevOffset = n[this.section.justify] - e[this.section.justify];
  }
  update(e) {
    if (this.value !== e) {
      const n = this._children.get(this.value);
      if (n.present = !1, n.el.classList.add("symbol__exiting"), this._children.has(e)) {
        const i = this._children.get(e);
        i.present = !0, i.el.classList.remove("symbol__exiting");
      } else {
        const i = ba("span", {
          className: "symbol__value",
          textContent: e
        });
        this.el.appendChild(i), this._children.set(e, new Zp(this.flow, i, {
          animateIn: !0,
          onRemove: this._onChildRemove(e)
        }));
      }
    }
    this.value = e;
  }
  didUpdate(e) {
    if (this.type === "decimal")
      return;
    const n = this.el.getBoundingClientRect()[this.section.justify] - e[this.section.justify], i = this._prevOffset - n;
    i && this.el.animate({
      transform: [`translateX(${i}px)`, "none"]
    }, { ...this.flow.transformTiming, composite: "accumulate" });
  }
};
var eC = (t) => {
  throw TypeError(t);
}, tC = (t, e, n) => e.has(t) || eC("Cannot " + n), Ii = (t, e, n) => (tC(t, e, "read from private field"), e.get(t)), zz = (t, e, n) => e.has(t) ? eC("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, n), Vz = (t, e, n, i) => (tC(t, e, "write to private field"), e.set(t, n), n), W4, Hz = parseInt((W4 = S.version.match(/^(\d+)\./)) == null ? void 0 : W4[1]), Av = Hz >= 19, Bz = ["data"], nC = class extends UM {
  attributeChangedCallback(t, e, n) {
    this[t] = JSON.parse(n);
  }
};
nC.observedAttributes = Av ? [] : Bz;
Nz("number-flow-react", nC);
var a1 = {}, qz = Av ? (t) => t : JSON.stringify;
function Fk(t) {
  const {
    transformTiming: e,
    spinTiming: n,
    opacityTiming: i,
    animated: r,
    respectMotionPreference: a,
    trend: o,
    continuous: s,
    ...l
  } = t;
  return [
    {
      transformTiming: e,
      spinTiming: n,
      opacityTiming: i,
      animated: r,
      respectMotionPreference: a,
      trend: o,
      continuous: s
    },
    l
  ];
}
var Hn, Gz = class extends S.Component {
  constructor(t) {
    super(t), zz(this, Hn), this.handleRef = this.handleRef.bind(this);
  }
  // Update the non-`data` props to avoid JSON serialization
  // Data needs to be set in render still:
  updateNonDataProps(t) {
    if (!Ii(this, Hn)) return;
    Ii(this, Hn).manual = !this.props.isolate;
    const [e] = Fk(this.props);
    Object.assign(
      Ii(this, Hn),
      Object.fromEntries(Object.entries(e).filter(([n, i]) => i != null))
    ), t != null && t.onAnimationsStart && Ii(this, Hn).removeEventListener("animationsstart", t.onAnimationsStart), this.props.onAnimationsStart && Ii(this, Hn).addEventListener("animationsstart", this.props.onAnimationsStart), t != null && t.onAnimationsFinish && Ii(this, Hn).removeEventListener(
      "animationsfinish",
      t.onAnimationsFinish
    ), this.props.onAnimationsFinish && Ii(this, Hn).addEventListener("animationsfinish", this.props.onAnimationsFinish);
  }
  componentDidMount() {
    this.updateNonDataProps(), Av && Ii(this, Hn) && (Ii(this, Hn).data = this.props.data);
  }
  getSnapshotBeforeUpdate(t) {
    var e;
    return this.updateNonDataProps(t), this.props.isolate || this.props.animated === !1 || t.data === this.props.data ? !1 : ((e = Ii(this, Hn)) == null || e.willUpdate(), !0);
  }
  componentDidUpdate(t, e, n) {
    var i;
    n && ((i = Ii(this, Hn)) == null || i.didUpdate());
  }
  handleRef(t) {
    this.props.innerRef && (this.props.innerRef.current = t), Vz(this, Hn, t);
  }
  render() {
    const [
      t,
      {
        innerRef: e,
        className: n,
        data: i,
        willChange: r,
        isolate: a,
        onAnimationsStart: o,
        onAnimationsFinish: s,
        ...l
      }
    ] = Fk(this.props);
    return (
      // @ts-expect-error missing types
      /* @__PURE__ */ S.createElement(
        "number-flow-react",
        {
          ref: this.handleRef,
          "data-will-change": r ? "" : void 0,
          class: n,
          "aria-label": i.valueAsString,
          ...l,
          role: "img",
          dangerouslySetInnerHTML: { __html: "" },
          suppressHydrationWarning: !0,
          data: qz(i)
        }
      )
    );
  }
};
Hn = /* @__PURE__ */ new WeakMap();
var Xz = S.forwardRef(function({ value: e, locales: n, format: i, prefix: r, suffix: a, ...o }, s) {
  S.useImperativeHandle(s, () => l.current, []);
  const l = S.useRef(), c = S.useMemo(() => n ? JSON.stringify(n) : "", [n]), u = S.useMemo(() => i ? JSON.stringify(i) : "", [i]), f = S.useMemo(() => {
    var h;
    const m = a1[h = `${c}:${u}`] ?? (a1[h] = new Intl.NumberFormat(
      n,
      i
    ));
    return Dz(e, m, r, a);
  }, [e, c, u, r, a]);
  return /* @__PURE__ */ S.createElement(Gz, { ...o, data: f, innerRef: l });
}), Lv = Xz;
function Yz({
  emoji: t,
  initialCount: e,
  hasReacted: n = !1,
  users: i,
  onInteraction: r
}) {
  const [a, o] = q(n), [s, l] = q(e), c = Oe(null), { fireEmojiConfetti: u } = K$(), f = (p, g) => {
    p.stopPropagation(), l(s + (a ? -1 : 1)), o(!a), r == null || r(g), a || u(g, c);
  }, m = (i == null ? void 0 : i.map((p) => p.name).join(", ")) || "", h = /* @__PURE__ */ k(
    ga,
    {
      ref: c,
      variant: "outline",
      size: "md",
      onClick: (p) => {
        f(p, t);
      },
      className: E(
        "flex items-center gap-1 font-medium leading-tight shadow-none transition-all active:scale-90 motion-reduce:transition-none motion-reduce:active:scale-100 [&>button]:mx-[-3px]",
        a && "border-f1-border-selected bg-f1-background-selected hover:border-f1-border-selected-bold"
      ),
      "aria-label": U$(t),
      children: [
        /* @__PURE__ */ d(Bd, { emoji: t, size: "md" }),
        /* @__PURE__ */ d(
          Lv,
          {
            value: s,
            spinTiming: {
              duration: 200,
              easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
            },
            className: E(
              "tabular-nums",
              a ? "text-f1-foreground-selected" : "text-f1-foreground"
            )
          }
        )
      ]
    }
  );
  return m ? /* @__PURE__ */ d(Kt, { label: m, children: h }) : h;
}
function Kz({ items: t, onInteraction: e, locale: n }) {
  return /* @__PURE__ */ k("div", { className: "flex flex-wrap gap-2", children: [
    /* @__PURE__ */ d(Tv, { onSelect: e, locale: n }),
    t.map((i) => /* @__PURE__ */ d(
      Yz,
      {
        emoji: i.emoji,
        initialCount: i.initialCount,
        hasReacted: i.hasReacted,
        users: i.users,
        onInteraction: e
      },
      i.emoji
    ))
  ] });
}
function Uz(t) {
  if (typeof document > "u") return;
  let e = document.head || document.getElementsByTagName("head")[0], n = document.createElement("style");
  n.type = "text/css", e.appendChild(n), n.styleSheet ? n.styleSheet.cssText = t : n.appendChild(document.createTextNode(t));
}
const iC = H.createContext({
  drawerRef: {
    current: null
  },
  overlayRef: {
    current: null
  },
  onPress: () => {
  },
  onRelease: () => {
  },
  onDrag: () => {
  },
  onNestedDrag: () => {
  },
  onNestedOpenChange: () => {
  },
  onNestedRelease: () => {
  },
  openProp: void 0,
  dismissible: !1,
  isOpen: !1,
  isDragging: !1,
  keyboardIsOpen: {
    current: !1
  },
  snapPointsOffset: null,
  snapPoints: null,
  handleOnly: !1,
  modal: !1,
  shouldFade: !1,
  activeSnapPoint: null,
  onOpenChange: () => {
  },
  setActiveSnapPoint: () => {
  },
  closeDrawer: () => {
  },
  direction: "bottom",
  shouldAnimate: {
    current: !0
  },
  shouldScaleBackground: !1,
  setBackgroundColorOnScale: !0,
  noBodyStyles: !1,
  container: null,
  autoFocus: !1
}), hc = () => {
  const t = H.useContext(iC);
  if (!t)
    throw new Error("useDrawerContext must be used within a Drawer.Root");
  return t;
};
Uz(`[data-vaul-drawer]{touch-action:none;will-change:transform;transition:transform .5s cubic-bezier(.32, .72, 0, 1);animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=open]{animation-name:slideFromBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=bottom][data-state=closed]{animation-name:slideToBottom}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=open]{animation-name:slideFromTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=top][data-state=closed]{animation-name:slideToTop}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=open]{animation-name:slideFromLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=left][data-state=closed]{animation-name:slideToLeft}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=open]{animation-name:slideFromRight}[data-vaul-drawer][data-vaul-snap-points=false][data-vaul-drawer-direction=right][data-state=closed]{animation-name:slideToRight}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--initial-transform,100%),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}[data-vaul-drawer][data-vaul-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--initial-transform,100%),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=top]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=bottom]{transform:translate3d(0,var(--snap-point-height,0),0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=left]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-drawer][data-vaul-delayed-snap-points=true][data-vaul-drawer-direction=right]{transform:translate3d(var(--snap-point-height,0),0,0)}[data-vaul-overlay][data-vaul-snap-points=false]{animation-duration:.5s;animation-timing-function:cubic-bezier(0.32,0.72,0,1)}[data-vaul-overlay][data-vaul-snap-points=false][data-state=open]{animation-name:fadeIn}[data-vaul-overlay][data-state=closed]{animation-name:fadeOut}[data-vaul-animate=false]{animation:none!important}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:0;transition:opacity .5s cubic-bezier(.32, .72, 0, 1)}[data-vaul-overlay][data-vaul-snap-points=true]{opacity:1}[data-vaul-drawer]:not([data-vaul-custom-container=true])::after{content:'';position:absolute;background:inherit;background-color:inherit}[data-vaul-drawer][data-vaul-drawer-direction=top]::after{top:initial;bottom:100%;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=bottom]::after{top:100%;bottom:initial;left:0;right:0;height:200%}[data-vaul-drawer][data-vaul-drawer-direction=left]::after{left:initial;right:100%;top:0;bottom:0;width:200%}[data-vaul-drawer][data-vaul-drawer-direction=right]::after{left:100%;right:initial;top:0;bottom:0;width:200%}[data-vaul-overlay][data-vaul-snap-points=true]:not([data-vaul-snap-points-overlay=true]):not(
[data-state=closed]
){opacity:0}[data-vaul-overlay][data-vaul-snap-points-overlay=true]{opacity:1}[data-vaul-handle]{display:block;position:relative;opacity:.7;background:#e2e2e4;margin-left:auto;margin-right:auto;height:5px;width:32px;border-radius:1rem;touch-action:pan-y}[data-vaul-handle]:active,[data-vaul-handle]:hover{opacity:1}[data-vaul-handle-hitarea]{position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);width:max(100%,2.75rem);height:max(100%,2.75rem);touch-action:inherit}@media (hover:hover) and (pointer:fine){[data-vaul-drawer]{user-select:none}}@media (pointer:fine){[data-vaul-handle-hitarea]:{width:100%;height:100%}}@keyframes fadeIn{from{opacity:0}to{opacity:1}}@keyframes fadeOut{to{opacity:0}}@keyframes slideFromBottom{from{transform:translate3d(0,var(--initial-transform,100%),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToBottom{to{transform:translate3d(0,var(--initial-transform,100%),0)}}@keyframes slideFromTop{from{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}to{transform:translate3d(0,0,0)}}@keyframes slideToTop{to{transform:translate3d(0,calc(var(--initial-transform,100%) * -1),0)}}@keyframes slideFromLeft{from{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToLeft{to{transform:translate3d(calc(var(--initial-transform,100%) * -1),0,0)}}@keyframes slideFromRight{from{transform:translate3d(var(--initial-transform,100%),0,0)}to{transform:translate3d(0,0,0)}}@keyframes slideToRight{to{transform:translate3d(var(--initial-transform,100%),0,0)}}`);
function Jz() {
  const t = navigator.userAgent;
  return typeof window < "u" && (/Firefox/.test(t) && /Mobile/.test(t) || // Android Firefox
  /FxiOS/.test(t));
}
function Qz() {
  return Iv(/^Mac/);
}
function Zz() {
  return Iv(/^iPhone/);
}
function zk() {
  return /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
}
function eV() {
  return Iv(/^iPad/) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Qz() && navigator.maxTouchPoints > 1;
}
function rC() {
  return Zz() || eV();
}
function Iv(t) {
  return typeof window < "u" && window.navigator != null ? t.test(window.navigator.platform) : void 0;
}
const tV = 24, nV = typeof window < "u" ? Zd : le;
function Vk(...t) {
  return (...e) => {
    for (let n of t)
      typeof n == "function" && n(...e);
  };
}
const o1 = typeof document < "u" && window.visualViewport;
function Hk(t) {
  let e = window.getComputedStyle(t);
  return /(auto|scroll)/.test(e.overflow + e.overflowX + e.overflowY);
}
function aC(t) {
  for (Hk(t) && (t = t.parentElement); t && !Hk(t); )
    t = t.parentElement;
  return t || document.scrollingElement || document.documentElement;
}
const iV = /* @__PURE__ */ new Set([
  "checkbox",
  "radio",
  "range",
  "color",
  "file",
  "image",
  "button",
  "submit",
  "reset"
]);
let Gc = 0, s1;
function rV(t = {}) {
  let { isDisabled: e } = t;
  nV(() => {
    if (!e)
      return Gc++, Gc === 1 && rC() && (s1 = aV()), () => {
        Gc--, Gc === 0 && (s1 == null || s1());
      };
  }, [
    e
  ]);
}
function aV() {
  let t, e = 0, n = (f) => {
    t = aC(f.target), !(t === document.documentElement && t === document.body) && (e = f.changedTouches[0].pageY);
  }, i = (f) => {
    if (!t || t === document.documentElement || t === document.body) {
      f.preventDefault();
      return;
    }
    let m = f.changedTouches[0].pageY, h = t.scrollTop, p = t.scrollHeight - t.clientHeight;
    p !== 0 && ((h <= 0 && m > e || h >= p && m < e) && f.preventDefault(), e = m);
  }, r = (f) => {
    let m = f.target;
    eg(m) && m !== document.activeElement && (f.preventDefault(), m.style.transform = "translateY(-2000px)", m.focus(), requestAnimationFrame(() => {
      m.style.transform = "";
    }));
  }, a = (f) => {
    let m = f.target;
    eg(m) && (m.style.transform = "translateY(-2000px)", requestAnimationFrame(() => {
      m.style.transform = "", o1 && (o1.height < window.innerHeight ? requestAnimationFrame(() => {
        Bk(m);
      }) : o1.addEventListener("resize", () => Bk(m), {
        once: !0
      }));
    }));
  }, o = () => {
    window.scrollTo(0, 0);
  }, s = window.pageXOffset, l = window.pageYOffset, c = Vk(oV(document.documentElement, "paddingRight", `${window.innerWidth - document.documentElement.clientWidth}px`));
  window.scrollTo(0, 0);
  let u = Vk(hl(document, "touchstart", n, {
    passive: !1,
    capture: !0
  }), hl(document, "touchmove", i, {
    passive: !1,
    capture: !0
  }), hl(document, "touchend", r, {
    passive: !1,
    capture: !0
  }), hl(document, "focus", a, !0), hl(window, "scroll", o));
  return () => {
    c(), u(), window.scrollTo(s, l);
  };
}
function oV(t, e, n) {
  let i = t.style[e];
  return t.style[e] = n, () => {
    t.style[e] = i;
  };
}
function hl(t, e, n, i) {
  return t.addEventListener(e, n, i), () => {
    t.removeEventListener(e, n, i);
  };
}
function Bk(t) {
  let e = document.scrollingElement || document.documentElement;
  for (; t && t !== e; ) {
    let n = aC(t);
    if (n !== document.documentElement && n !== document.body && n !== t) {
      let i = n.getBoundingClientRect().top, r = t.getBoundingClientRect().top, a = t.getBoundingClientRect().bottom;
      const o = n.getBoundingClientRect().bottom + tV;
      a > o && (n.scrollTop += r - i);
    }
    t = n.parentElement;
  }
}
function eg(t) {
  return t instanceof HTMLInputElement && !iV.has(t.type) || t instanceof HTMLTextAreaElement || t instanceof HTMLElement && t.isContentEditable;
}
function sV(t, e) {
  typeof t == "function" ? t(e) : t != null && (t.current = e);
}
function lV(...t) {
  return (e) => t.forEach((n) => sV(n, e));
}
function oC(...t) {
  return S.useCallback(lV(...t), t);
}
const sC = /* @__PURE__ */ new WeakMap();
function Qt(t, e, n = !1) {
  if (!t || !(t instanceof HTMLElement)) return;
  let i = {};
  Object.entries(e).forEach(([r, a]) => {
    if (r.startsWith("--")) {
      t.style.setProperty(r, a);
      return;
    }
    i[r] = t.style[r], t.style[r] = a;
  }), !n && sC.set(t, i);
}
function dV(t, e) {
  if (!t || !(t instanceof HTMLElement)) return;
  let n = sC.get(t);
  n && (t.style[e] = n[e]);
}
const Xt = (t) => {
  switch (t) {
    case "top":
    case "bottom":
      return !0;
    case "left":
    case "right":
      return !1;
    default:
      return t;
  }
};
function Xc(t, e) {
  if (!t)
    return null;
  const n = window.getComputedStyle(t), i = (
    // @ts-ignore
    n.transform || n.webkitTransform || n.mozTransform
  );
  let r = i.match(/^matrix3d\((.+)\)$/);
  return r ? parseFloat(r[1].split(", ")[Xt(e) ? 13 : 12]) : (r = i.match(/^matrix\((.+)\)$/), r ? parseFloat(r[1].split(", ")[Xt(e) ? 5 : 4]) : null);
}
function cV(t) {
  return 8 * (Math.log(t + 1) - 2);
}
function l1(t, e) {
  if (!t) return () => {
  };
  const n = t.style.cssText;
  return Object.assign(t.style, e), () => {
    t.style.cssText = n;
  };
}
function uV(...t) {
  return (...e) => {
    for (const n of t)
      typeof n == "function" && n(...e);
  };
}
const $t = {
  DURATION: 0.5,
  EASE: [
    0.32,
    0.72,
    0,
    1
  ]
}, lC = 0.4, fV = 0.25, mV = 100, dC = 8, Yc = 16, tg = 26, d1 = "vaul-dragging";
function cC(t) {
  const e = H.useRef(t);
  return H.useEffect(() => {
    e.current = t;
  }), H.useMemo(() => (...n) => e.current == null ? void 0 : e.current.call(e, ...n), []);
}
function hV({ defaultProp: t, onChange: e }) {
  const n = H.useState(t), [i] = n, r = H.useRef(i), a = cC(e);
  return H.useEffect(() => {
    r.current !== i && (a(i), r.current = i);
  }, [
    i,
    r,
    a
  ]), n;
}
function uC({ prop: t, defaultProp: e, onChange: n = () => {
} }) {
  const [i, r] = hV({
    defaultProp: e,
    onChange: n
  }), a = t !== void 0, o = a ? t : i, s = cC(n), l = H.useCallback((c) => {
    if (a) {
      const f = typeof c == "function" ? c(t) : c;
      f !== t && s(f);
    } else
      r(c);
  }, [
    a,
    t,
    r,
    s
  ]);
  return [
    o,
    l
  ];
}
function pV({ activeSnapPointProp: t, setActiveSnapPointProp: e, snapPoints: n, drawerRef: i, overlayRef: r, fadeFromIndex: a, onSnapPointChange: o, direction: s = "bottom", container: l, snapToSequentialPoint: c }) {
  const [u, f] = uC({
    prop: t,
    defaultProp: n == null ? void 0 : n[0],
    onChange: e
  }), [m, h] = H.useState(typeof window < "u" ? {
    innerWidth: window.innerWidth,
    innerHeight: window.innerHeight
  } : void 0);
  H.useEffect(() => {
    function N() {
      h({
        innerWidth: window.innerWidth,
        innerHeight: window.innerHeight
      });
    }
    return window.addEventListener("resize", N), () => window.removeEventListener("resize", N);
  }, []);
  const p = H.useMemo(() => u === (n == null ? void 0 : n[n.length - 1]) || null, [
    n,
    u
  ]), g = H.useMemo(() => {
    var N;
    return (N = n == null ? void 0 : n.findIndex(($) => $ === u)) != null ? N : null;
  }, [
    n,
    u
  ]), y = n && n.length > 0 && (a || a === 0) && !Number.isNaN(a) && n[a] === u || !n, v = H.useMemo(() => {
    const N = l ? {
      width: l.getBoundingClientRect().width,
      height: l.getBoundingClientRect().height
    } : typeof window < "u" ? {
      width: window.innerWidth,
      height: window.innerHeight
    } : {
      width: 0,
      height: 0
    };
    var $;
    return ($ = n == null ? void 0 : n.map((D) => {
      const W = typeof D == "string";
      let j = 0;
      if (W && (j = parseInt(D, 10)), Xt(s)) {
        const I = W ? j : m ? D * N.height : 0;
        return m ? s === "bottom" ? N.height - I : -N.height + I : I;
      }
      const O = W ? j : m ? D * N.width : 0;
      return m ? s === "right" ? N.width - O : -N.width + O : O;
    })) != null ? $ : [];
  }, [
    n,
    m,
    l
  ]), w = H.useMemo(() => g !== null ? v == null ? void 0 : v[g] : null, [
    v,
    g
  ]), x = H.useCallback((N) => {
    var $;
    const D = ($ = v == null ? void 0 : v.findIndex((W) => W === N)) != null ? $ : null;
    o(D), Qt(i.current, {
      transition: `transform ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      transform: Xt(s) ? `translate3d(0, ${N}px, 0)` : `translate3d(${N}px, 0, 0)`
    }), v && D !== v.length - 1 && a !== void 0 && D !== a && D < a ? Qt(r.current, {
      transition: `opacity ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      opacity: "0"
    }) : Qt(r.current, {
      transition: `opacity ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      opacity: "1"
    }), f(n == null ? void 0 : n[Math.max(D, 0)]);
  }, [
    i.current,
    n,
    v,
    a,
    r,
    f
  ]);
  H.useEffect(() => {
    if (u || t) {
      var N;
      const $ = (N = n == null ? void 0 : n.findIndex((D) => D === t || D === u)) != null ? N : -1;
      v && $ !== -1 && typeof v[$] == "number" && x(v[$]);
    }
  }, [
    u,
    t,
    n,
    v,
    x
  ]);
  function b({ draggedDistance: N, closeDrawer: $, velocity: D, dismissible: W }) {
    if (a === void 0) return;
    const j = s === "bottom" || s === "right" ? (w ?? 0) - N : (w ?? 0) + N, O = g === a - 1, I = g === 0, L = N > 0;
    if (O && Qt(r.current, {
      transition: `opacity ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`
    }), !c && D > 2 && !L) {
      W ? $() : x(v[0]);
      return;
    }
    if (!c && D > 2 && L && v && n) {
      x(v[n.length - 1]);
      return;
    }
    const R = v == null ? void 0 : v.reduce((F, z) => typeof F != "number" || typeof z != "number" ? F : Math.abs(z - j) < Math.abs(F - j) ? z : F), B = Xt(s) ? window.innerHeight : window.innerWidth;
    if (D > lC && Math.abs(N) < B * 0.4) {
      const F = L ? 1 : -1;
      if (F > 0 && p && n) {
        x(v[n.length - 1]);
        return;
      }
      if (I && F < 0 && W && $(), g === null) return;
      x(v[g + F]);
      return;
    }
    x(R);
  }
  function M({ draggedDistance: N }) {
    if (w === null) return;
    const $ = s === "bottom" || s === "right" ? w - N : w + N;
    (s === "bottom" || s === "right") && $ < v[v.length - 1] || (s === "top" || s === "left") && $ > v[v.length - 1] || Qt(i.current, {
      transform: Xt(s) ? `translate3d(0, ${$}px, 0)` : `translate3d(${$}px, 0, 0)`
    });
  }
  function _(N, $) {
    if (!n || typeof g != "number" || !v || a === void 0) return null;
    const D = g === a - 1;
    if (g >= a && $)
      return 0;
    if (D && !$) return 1;
    if (!y && !D) return null;
    const j = D ? g + 1 : g - 1, O = D ? v[j] - v[j - 1] : v[j + 1] - v[j], I = N / Math.abs(O);
    return D ? 1 - I : I;
  }
  return {
    isLastSnapPoint: p,
    activeSnapPoint: u,
    shouldFade: y,
    getPercentageDragged: _,
    setActiveSnapPoint: f,
    activeSnapPointIndex: g,
    onRelease: b,
    onDrag: M,
    snapPointsOffset: v
  };
}
const gV = () => () => {
};
function yV() {
  const { direction: t, isOpen: e, shouldScaleBackground: n, setBackgroundColorOnScale: i, noBodyStyles: r } = hc(), a = H.useRef(null), o = ve(() => document.body.style.backgroundColor, []);
  function s() {
    return (window.innerWidth - tg) / window.innerWidth;
  }
  H.useEffect(() => {
    if (e && n) {
      a.current && clearTimeout(a.current);
      const l = document.querySelector("[data-vaul-drawer-wrapper]") || document.querySelector("[vaul-drawer-wrapper]");
      if (!l) return;
      uV(i && !r ? l1(document.body, {
        background: "black"
      }) : gV, l1(l, {
        transformOrigin: Xt(t) ? "top" : "left",
        transitionProperty: "transform, border-radius",
        transitionDuration: `${$t.DURATION}s`,
        transitionTimingFunction: `cubic-bezier(${$t.EASE.join(",")})`
      }));
      const c = l1(l, {
        borderRadius: `${dC}px`,
        overflow: "hidden",
        ...Xt(t) ? {
          transform: `scale(${s()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`
        } : {
          transform: `scale(${s()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`
        }
      });
      return () => {
        c(), a.current = window.setTimeout(() => {
          o ? document.body.style.background = o : document.body.style.removeProperty("background");
        }, $t.DURATION * 1e3);
      };
    }
  }, [
    e,
    n,
    o
  ]);
}
let pl = null;
function vV({ isOpen: t, modal: e, nested: n, hasBeenOpened: i, preventScrollRestoration: r, noBodyStyles: a }) {
  const [o, s] = H.useState(() => typeof window < "u" ? window.location.href : ""), l = H.useRef(0), c = H.useCallback(() => {
    if (zk() && pl === null && t && !a) {
      pl = {
        position: document.body.style.position,
        top: document.body.style.top,
        left: document.body.style.left,
        height: document.body.style.height,
        right: "unset"
      };
      const { scrollX: f, innerHeight: m } = window;
      document.body.style.setProperty("position", "fixed", "important"), Object.assign(document.body.style, {
        top: `${-l.current}px`,
        left: `${-f}px`,
        right: "0px",
        height: "auto"
      }), window.setTimeout(() => window.requestAnimationFrame(() => {
        const h = m - window.innerHeight;
        h && l.current >= m && (document.body.style.top = `${-(l.current + h)}px`);
      }), 300);
    }
  }, [
    t
  ]), u = H.useCallback(() => {
    if (zk() && pl !== null && !a) {
      const f = -parseInt(document.body.style.top, 10), m = -parseInt(document.body.style.left, 10);
      Object.assign(document.body.style, pl), window.requestAnimationFrame(() => {
        if (r && o !== window.location.href) {
          s(window.location.href);
          return;
        }
        window.scrollTo(m, f);
      }), pl = null;
    }
  }, [
    o
  ]);
  return H.useEffect(() => {
    function f() {
      l.current = window.scrollY;
    }
    return f(), window.addEventListener("scroll", f), () => {
      window.removeEventListener("scroll", f);
    };
  }, []), H.useEffect(() => {
    if (e)
      return () => {
        typeof document > "u" || document.querySelector("[data-vaul-drawer]") || u();
      };
  }, [
    e,
    u
  ]), H.useEffect(() => {
    n || !i || (t ? (!window.matchMedia("(display-mode: standalone)").matches && c(), e || window.setTimeout(() => {
      u();
    }, 500)) : u());
  }, [
    t,
    i,
    o,
    e,
    n,
    c,
    u
  ]), {
    restorePositionSetting: u
  };
}
function bV({ open: t, onOpenChange: e, children: n, onDrag: i, onRelease: r, snapPoints: a, shouldScaleBackground: o = !1, setBackgroundColorOnScale: s = !0, closeThreshold: l = fV, scrollLockTimeout: c = mV, dismissible: u = !0, handleOnly: f = !1, fadeFromIndex: m = a && a.length - 1, activeSnapPoint: h, setActiveSnapPoint: p, fixed: g, modal: y = !0, onClose: v, nested: w, noBodyStyles: x = !1, direction: b = "bottom", defaultOpen: M = !1, disablePreventScroll: _ = !0, snapToSequentialPoint: N = !1, preventScrollRestoration: $ = !1, repositionInputs: D = !0, onAnimationEnd: W, container: j, autoFocus: O = !1 }) {
  var I, L;
  const [R = !1, B] = uC({
    defaultProp: M,
    prop: t,
    onChange: (Se) => {
      e == null || e(Se), !Se && !w && xt(), setTimeout(() => {
        W == null || W(Se);
      }, $t.DURATION * 1e3), Se && !y && typeof window < "u" && window.requestAnimationFrame(() => {
        document.body.style.pointerEvents = "auto";
      }), Se || (document.body.style.pointerEvents = "auto");
    }
  }), [F, z] = H.useState(!1), [K, ae] = H.useState(!1), [Q, te] = H.useState(!1), be = H.useRef(null), Pe = H.useRef(null), We = H.useRef(null), $e = H.useRef(null), Y = H.useRef(null), oe = H.useRef(!1), se = H.useRef(null), J = H.useRef(0), xe = H.useRef(!1), De = H.useRef(!M), _e = H.useRef(0), ce = H.useRef(null), wt = H.useRef(((I = ce.current) == null ? void 0 : I.getBoundingClientRect().height) || 0), St = H.useRef(((L = ce.current) == null ? void 0 : L.getBoundingClientRect().width) || 0), ze = H.useRef(0), A = H.useCallback((Se) => {
    a && Se === ne.length - 1 && (Pe.current = /* @__PURE__ */ new Date());
  }, []), { activeSnapPoint: V, activeSnapPointIndex: G, setActiveSnapPoint: de, onRelease: fe, snapPointsOffset: ne, onDrag: Te, shouldFade: Ve, getPercentageDragged: kt } = pV({
    snapPoints: a,
    activeSnapPointProp: h,
    setActiveSnapPointProp: p,
    drawerRef: ce,
    fadeFromIndex: m,
    overlayRef: be,
    onSnapPointChange: A,
    direction: b,
    container: j,
    snapToSequentialPoint: N
  });
  rV({
    isDisabled: !R || K || !y || Q || !F || !D || !_
  });
  const { restorePositionSetting: xt } = vV({
    isOpen: R,
    modal: y,
    nested: w ?? !1,
    hasBeenOpened: F,
    preventScrollRestoration: $,
    noBodyStyles: x
  });
  function Zt() {
    return (window.innerWidth - tg) / window.innerWidth;
  }
  function dl(Se) {
    var Be, tt;
    !u && !a || ce.current && !ce.current.contains(Se.target) || (wt.current = ((Be = ce.current) == null ? void 0 : Be.getBoundingClientRect().height) || 0, St.current = ((tt = ce.current) == null ? void 0 : tt.getBoundingClientRect().width) || 0, ae(!0), We.current = /* @__PURE__ */ new Date(), rC() && window.addEventListener("touchend", () => oe.current = !1, {
      once: !0
    }), Se.target.setPointerCapture(Se.pointerId), J.current = Xt(b) ? Se.pageY : Se.pageX);
  }
  function Kr(Se, Be) {
    var tt;
    let Ze = Se;
    const lt = (tt = window.getSelection()) == null ? void 0 : tt.toString(), en = ce.current ? Xc(ce.current, b) : null, Gt = /* @__PURE__ */ new Date();
    if (Ze.tagName === "SELECT" || Ze.hasAttribute("data-vaul-no-drag") || Ze.closest("[data-vaul-no-drag]"))
      return !1;
    if (b === "right" || b === "left")
      return !0;
    if (Pe.current && Gt.getTime() - Pe.current.getTime() < 500)
      return !1;
    if (en !== null && (b === "bottom" ? en > 0 : en < 0))
      return !0;
    if (lt && lt.length > 0)
      return !1;
    if (Y.current && Gt.getTime() - Y.current.getTime() < c && en === 0 || Be)
      return Y.current = Gt, !1;
    for (; Ze; ) {
      if (Ze.scrollHeight > Ze.clientHeight) {
        if (Ze.scrollTop !== 0)
          return Y.current = /* @__PURE__ */ new Date(), !1;
        if (Ze.getAttribute("role") === "dialog")
          return !0;
      }
      Ze = Ze.parentNode;
    }
    return !0;
  }
  function Ga(Se) {
    if (ce.current && K) {
      const Be = b === "bottom" || b === "right" ? 1 : -1, tt = (J.current - (Xt(b) ? Se.pageY : Se.pageX)) * Be, Ze = tt > 0, lt = a && !u && !Ze;
      if (lt && G === 0) return;
      const en = Math.abs(tt), Gt = document.querySelector("[data-vaul-drawer-wrapper]"), Cn = b === "bottom" || b === "top" ? wt.current : St.current;
      let ai = en / Cn;
      const Li = kt(en, Ze);
      if (Li !== null && (ai = Li), lt && ai >= 1 || !oe.current && !Kr(Se.target, Ze)) return;
      if (ce.current.classList.add(d1), oe.current = !0, Qt(ce.current, {
        transition: "none"
      }), Qt(be.current, {
        transition: "none"
      }), a && Te({
        draggedDistance: tt
      }), Ze && !a) {
        const Zi = cV(tt), Lc = Math.min(Zi * -1, 0) * Be;
        Qt(ce.current, {
          transform: Xt(b) ? `translate3d(0, ${Lc}px, 0)` : `translate3d(${Lc}px, 0, 0)`
        });
        return;
      }
      const oi = 1 - ai;
      if ((Ve || m && G === m - 1) && (i == null || i(Se, ai), Qt(be.current, {
        opacity: `${oi}`,
        transition: "none"
      }, !0)), Gt && be.current && o) {
        const Zi = Math.min(Zt() + ai * (1 - Zt()), 1), Lc = 8 - ai * 8, aw = Math.max(0, 14 - ai * 14);
        Qt(Gt, {
          borderRadius: `${Lc}px`,
          transform: Xt(b) ? `scale(${Zi}) translate3d(0, ${aw}px, 0)` : `scale(${Zi}) translate3d(${aw}px, 0, 0)`,
          transition: "none"
        }, !0);
      }
      if (!a) {
        const Zi = en * Be;
        Qt(ce.current, {
          transform: Xt(b) ? `translate3d(0, ${Zi}px, 0)` : `translate3d(${Zi}px, 0, 0)`
        });
      }
    }
  }
  H.useEffect(() => {
    window.requestAnimationFrame(() => {
      De.current = !0;
    });
  }, []), H.useEffect(() => {
    var Se;
    function Be() {
      if (!ce.current || !D) return;
      const tt = document.activeElement;
      if (eg(tt) || xe.current) {
        var Ze;
        const lt = ((Ze = window.visualViewport) == null ? void 0 : Ze.height) || 0, en = window.innerHeight;
        let Gt = en - lt;
        const Cn = ce.current.getBoundingClientRect().height || 0, ai = Cn > en * 0.8;
        ze.current || (ze.current = Cn);
        const Li = ce.current.getBoundingClientRect().top;
        if (Math.abs(_e.current - Gt) > 60 && (xe.current = !xe.current), a && a.length > 0 && ne && G) {
          const oi = ne[G] || 0;
          Gt += oi;
        }
        if (_e.current = Gt, Cn > lt || xe.current) {
          const oi = ce.current.getBoundingClientRect().height;
          let Zi = oi;
          oi > lt && (Zi = lt - (ai ? Li : tg)), g ? ce.current.style.height = `${oi - Math.max(Gt, 0)}px` : ce.current.style.height = `${Math.max(Zi, lt - Li)}px`;
        } else Jz() || (ce.current.style.height = `${ze.current}px`);
        a && a.length > 0 && !xe.current ? ce.current.style.bottom = "0px" : ce.current.style.bottom = `${Math.max(Gt, 0)}px`;
      }
    }
    return (Se = window.visualViewport) == null || Se.addEventListener("resize", Be), () => {
      var tt;
      return (tt = window.visualViewport) == null ? void 0 : tt.removeEventListener("resize", Be);
    };
  }, [
    G,
    a,
    ne
  ]);
  function vr(Se) {
    U(), v == null || v(), Se || B(!1), setTimeout(() => {
      a && de(a[0]);
    }, $t.DURATION * 1e3);
  }
  function Xa() {
    if (!ce.current) return;
    const Se = document.querySelector("[data-vaul-drawer-wrapper]"), Be = Xc(ce.current, b);
    Qt(ce.current, {
      transform: "translate3d(0, 0, 0)",
      transition: `transform ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`
    }), Qt(be.current, {
      transition: `opacity ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      opacity: "1"
    }), o && Be && Be > 0 && R && Qt(Se, {
      borderRadius: `${dC}px`,
      overflow: "hidden",
      ...Xt(b) ? {
        transform: `scale(${Zt()}) translate3d(0, calc(env(safe-area-inset-top) + 14px), 0)`,
        transformOrigin: "top"
      } : {
        transform: `scale(${Zt()}) translate3d(calc(env(safe-area-inset-top) + 14px), 0, 0)`,
        transformOrigin: "left"
      },
      transitionProperty: "transform, border-radius",
      transitionDuration: `${$t.DURATION}s`,
      transitionTimingFunction: `cubic-bezier(${$t.EASE.join(",")})`
    }, !0);
  }
  function U() {
    !K || !ce.current || (ce.current.classList.remove(d1), oe.current = !1, ae(!1), $e.current = /* @__PURE__ */ new Date());
  }
  function Me(Se) {
    if (!K || !ce.current) return;
    ce.current.classList.remove(d1), oe.current = !1, ae(!1), $e.current = /* @__PURE__ */ new Date();
    const Be = Xc(ce.current, b);
    if (!Se || !Kr(Se.target, !1) || !Be || Number.isNaN(Be) || We.current === null) return;
    const tt = $e.current.getTime() - We.current.getTime(), Ze = J.current - (Xt(b) ? Se.pageY : Se.pageX), lt = Math.abs(Ze) / tt;
    if (lt > 0.05 && (te(!0), setTimeout(() => {
      te(!1);
    }, 200)), a) {
      fe({
        draggedDistance: Ze * (b === "bottom" || b === "right" ? 1 : -1),
        closeDrawer: vr,
        velocity: lt,
        dismissible: u
      }), r == null || r(Se, !0);
      return;
    }
    if (b === "bottom" || b === "right" ? Ze > 0 : Ze < 0) {
      Xa(), r == null || r(Se, !0);
      return;
    }
    if (lt > lC) {
      vr(), r == null || r(Se, !1);
      return;
    }
    var en;
    const Gt = Math.min((en = ce.current.getBoundingClientRect().height) != null ? en : 0, window.innerHeight);
    var Cn;
    const ai = Math.min((Cn = ce.current.getBoundingClientRect().width) != null ? Cn : 0, window.innerWidth), Li = b === "left" || b === "right";
    if (Math.abs(Be) >= (Li ? ai : Gt) * l) {
      vr(), r == null || r(Se, !1);
      return;
    }
    r == null || r(Se, !0), Xa();
  }
  H.useEffect(() => (R && (Qt(document.documentElement, {
    scrollBehavior: "auto"
  }), Pe.current = /* @__PURE__ */ new Date()), () => {
    dV(document.documentElement, "scrollBehavior");
  }), [
    R
  ]);
  function Re(Se) {
    const Be = Se ? (window.innerWidth - Yc) / window.innerWidth : 1, tt = Se ? -16 : 0;
    se.current && window.clearTimeout(se.current), Qt(ce.current, {
      transition: `transform ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      transform: Xt(b) ? `scale(${Be}) translate3d(0, ${tt}px, 0)` : `scale(${Be}) translate3d(${tt}px, 0, 0)`
    }), !Se && ce.current && (se.current = setTimeout(() => {
      const Ze = Xc(ce.current, b);
      Qt(ce.current, {
        transition: "none",
        transform: Xt(b) ? `translate3d(0, ${Ze}px, 0)` : `translate3d(${Ze}px, 0, 0)`
      });
    }, 500));
  }
  function it(Se, Be) {
    if (Be < 0) return;
    const tt = (window.innerWidth - Yc) / window.innerWidth, Ze = tt + Be * (1 - tt), lt = -16 + Be * Yc;
    Qt(ce.current, {
      transform: Xt(b) ? `scale(${Ze}) translate3d(0, ${lt}px, 0)` : `scale(${Ze}) translate3d(${lt}px, 0, 0)`,
      transition: "none"
    });
  }
  function Qe(Se, Be) {
    const tt = Xt(b) ? window.innerHeight : window.innerWidth, Ze = Be ? (tt - Yc) / tt : 1, lt = Be ? -16 : 0;
    Be && Qt(ce.current, {
      transition: `transform ${$t.DURATION}s cubic-bezier(${$t.EASE.join(",")})`,
      transform: Xt(b) ? `scale(${Ze}) translate3d(0, ${lt}px, 0)` : `scale(${Ze}) translate3d(${lt}px, 0, 0)`
    });
  }
  return H.useEffect(() => {
    y || window.requestAnimationFrame(() => {
      document.body.style.pointerEvents = "auto";
    });
  }, [
    y
  ]), /* @__PURE__ */ H.createElement(Q$, {
    defaultOpen: M,
    onOpenChange: (Se) => {
      !u && !Se || (Se ? z(!0) : vr(!0), B(Se));
    },
    open: R
  }, /* @__PURE__ */ H.createElement(iC.Provider, {
    value: {
      activeSnapPoint: V,
      snapPoints: a,
      setActiveSnapPoint: de,
      drawerRef: ce,
      overlayRef: be,
      onOpenChange: e,
      onPress: dl,
      onRelease: Me,
      onDrag: Ga,
      dismissible: u,
      shouldAnimate: De,
      handleOnly: f,
      isOpen: R,
      isDragging: K,
      shouldFade: Ve,
      closeDrawer: vr,
      onNestedDrag: it,
      onNestedOpenChange: Re,
      onNestedRelease: Qe,
      keyboardIsOpen: xe,
      modal: y,
      snapPointsOffset: ne,
      activeSnapPointIndex: G,
      direction: b,
      shouldScaleBackground: o,
      setBackgroundColorOnScale: s,
      noBodyStyles: x,
      container: j,
      autoFocus: O
    }
  }, n));
}
const fC = /* @__PURE__ */ H.forwardRef(function({ ...t }, e) {
  const { overlayRef: n, snapPoints: i, onRelease: r, shouldFade: a, isOpen: o, modal: s, shouldAnimate: l } = hc(), c = oC(e, n), u = i && i.length > 0;
  if (!s)
    return null;
  const f = H.useCallback((m) => r(m), [
    r
  ]);
  return /* @__PURE__ */ H.createElement(Z$, {
    onMouseUp: f,
    ref: c,
    "data-vaul-overlay": "",
    "data-vaul-snap-points": o && u ? "true" : "false",
    "data-vaul-snap-points-overlay": o && a ? "true" : "false",
    "data-vaul-animate": l != null && l.current ? "true" : "false",
    ...t
  });
});
fC.displayName = "Drawer.Overlay";
const mC = /* @__PURE__ */ H.forwardRef(function({ onPointerDownOutside: t, style: e, onOpenAutoFocus: n, ...i }, r) {
  const { drawerRef: a, onPress: o, onRelease: s, onDrag: l, keyboardIsOpen: c, snapPointsOffset: u, activeSnapPointIndex: f, modal: m, isOpen: h, direction: p, snapPoints: g, container: y, handleOnly: v, shouldAnimate: w, autoFocus: x } = hc(), [b, M] = H.useState(!1), _ = oC(r, a), N = H.useRef(null), $ = H.useRef(null), D = H.useRef(!1), W = g && g.length > 0;
  yV();
  const j = (I, L, R = 0) => {
    if (D.current) return !0;
    const B = Math.abs(I.y), F = Math.abs(I.x), z = F > B, K = [
      "bottom",
      "right"
    ].includes(L) ? 1 : -1;
    if (L === "left" || L === "right") {
      if (!(I.x * K < 0) && F >= 0 && F <= R)
        return z;
    } else if (!(I.y * K < 0) && B >= 0 && B <= R)
      return !z;
    return D.current = !0, !0;
  };
  H.useEffect(() => {
    W && window.requestAnimationFrame(() => {
      M(!0);
    });
  }, []);
  function O(I) {
    N.current = null, D.current = !1, s(I);
  }
  return /* @__PURE__ */ H.createElement(tD, {
    "data-vaul-drawer-direction": p,
    "data-vaul-drawer": "",
    "data-vaul-delayed-snap-points": b ? "true" : "false",
    "data-vaul-snap-points": h && W ? "true" : "false",
    "data-vaul-custom-container": y ? "true" : "false",
    "data-vaul-animate": w != null && w.current ? "true" : "false",
    ...i,
    ref: _,
    style: u && u.length > 0 ? {
      "--snap-point-height": `${u[f ?? 0]}px`,
      ...e
    } : e,
    onPointerDown: (I) => {
      v || (i.onPointerDown == null || i.onPointerDown.call(i, I), N.current = {
        x: I.pageX,
        y: I.pageY
      }, o(I));
    },
    onOpenAutoFocus: (I) => {
      n == null || n(I), x || I.preventDefault();
    },
    onPointerDownOutside: (I) => {
      if (t == null || t(I), !m || I.defaultPrevented) {
        I.preventDefault();
        return;
      }
      c.current && (c.current = !1);
    },
    onFocusOutside: (I) => {
      if (!m) {
        I.preventDefault();
        return;
      }
    },
    onPointerMove: (I) => {
      if ($.current = I, v || (i.onPointerMove == null || i.onPointerMove.call(i, I), !N.current)) return;
      const L = I.pageY - N.current.y, R = I.pageX - N.current.x, B = I.pointerType === "touch" ? 10 : 2;
      j({
        x: R,
        y: L
      }, p, B) ? l(I) : (Math.abs(R) > B || Math.abs(L) > B) && (N.current = null);
    },
    onPointerUp: (I) => {
      i.onPointerUp == null || i.onPointerUp.call(i, I), N.current = null, D.current = !1, s(I);
    },
    onPointerOut: (I) => {
      i.onPointerOut == null || i.onPointerOut.call(i, I), O($.current);
    },
    onContextMenu: (I) => {
      i.onContextMenu == null || i.onContextMenu.call(i, I), $.current && O($.current);
    }
  });
});
mC.displayName = "Drawer.Content";
const wV = 250, kV = 120, xV = /* @__PURE__ */ H.forwardRef(function({ preventCycle: t = !1, children: e, ...n }, i) {
  const { closeDrawer: r, isDragging: a, snapPoints: o, activeSnapPoint: s, setActiveSnapPoint: l, dismissible: c, handleOnly: u, isOpen: f, onPress: m, onDrag: h } = hc(), p = H.useRef(null), g = H.useRef(!1);
  function y() {
    if (g.current) {
      x();
      return;
    }
    window.setTimeout(() => {
      v();
    }, kV);
  }
  function v() {
    if (a || t || g.current) {
      x();
      return;
    }
    if (x(), !o || o.length === 0) {
      c || r();
      return;
    }
    if (s === o[o.length - 1] && c) {
      r();
      return;
    }
    const M = o.findIndex((N) => N === s);
    if (M === -1) return;
    const _ = o[M + 1];
    l(_);
  }
  function w() {
    p.current = window.setTimeout(() => {
      g.current = !0;
    }, wV);
  }
  function x() {
    p.current && window.clearTimeout(p.current), g.current = !1;
  }
  return /* @__PURE__ */ H.createElement("div", {
    onClick: y,
    onPointerCancel: x,
    onPointerDown: (b) => {
      u && m(b), w();
    },
    onPointerMove: (b) => {
      u && h(b);
    },
    // onPointerUp is already handled by the content component
    ref: i,
    "data-vaul-drawer-visible": f ? "true" : "false",
    "data-vaul-handle": "",
    "aria-hidden": "true",
    ...n
  }, /* @__PURE__ */ H.createElement("span", {
    "data-vaul-handle-hitarea": "",
    "aria-hidden": "true"
  }, e));
});
xV.displayName = "Drawer.Handle";
function _V(t) {
  const e = hc(), { container: n = e.container, ...i } = t;
  return /* @__PURE__ */ H.createElement(eD, {
    container: n,
    ...i
  });
}
const yr = {
  Root: bV,
  Content: mC,
  Overlay: fC,
  Trigger: J$,
  Portal: _V,
  Title: nD,
  Description: iD
}, Rv = ({
  shouldScaleBackground: t = !0,
  ...e
}) => /* @__PURE__ */ d(
  yr.Root,
  {
    shouldScaleBackground: t,
    ...e
  }
);
Rv.displayName = "Drawer";
const MV = yr.Trigger, CV = yr.Portal, th = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  yr.Overlay,
  {
    ref: n,
    className: E("bg-black/80 fixed inset-0 z-50", t),
    ...e
  }
));
th.displayName = yr.Overlay.displayName;
const jv = S.forwardRef(({ className: t, children: e, ...n }, i) => /* @__PURE__ */ k(CV, { children: [
  /* @__PURE__ */ d(th, {}),
  /* @__PURE__ */ k(
    yr.Content,
    {
      ref: i,
      className: E(
        "bg-background fixed inset-x-0 bottom-0 z-50 mt-24 flex h-auto flex-col rounded-t-xl focus:outline-none",
        t
      ),
      ...n,
      children: [
        /* @__PURE__ */ d("div", { className: "mx-auto mt-2 h-1 w-8 rounded-full bg-f1-border" }),
        e
      ]
    }
  )
] }));
jv.displayName = "DrawerContent";
const ng = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  yr.Title,
  {
    ref: n,
    className: E(
      "text-lg font-semibold leading-none tracking-tight",
      t
    ),
    ...e
  }
));
ng.displayName = yr.Title.displayName;
const PV = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  yr.Description,
  {
    ref: n,
    className: E("text-muted-foreground text-sm", t),
    ...e
  }
));
PV.displayName = yr.Description.displayName;
const SV = [], In = (t) => {
  const { open: e, onOpenChange: n, ...i } = t, r = SV.reduce((a, o) => {
    const { [o]: s, ...l } = a;
    return l;
  }, i);
  return /* @__PURE__ */ d(
    lc,
    {
      ...r,
      open: e,
      onOpenChange: n,
      align: "end"
    }
  );
}, Fv = ({ items: t, children: e }) => {
  const [n, i] = q(!1);
  return /* @__PURE__ */ k(Rv, { open: n, onOpenChange: i, children: [
    /* @__PURE__ */ d(MV, { asChild: !0, children: e || /* @__PURE__ */ d(
      ue,
      {
        label: "Other actions",
        icon: Ma,
        variant: "outline",
        size: "lg",
        pressed: n
      }
    ) }),
    /* @__PURE__ */ d(th, { className: "bg-f1-background-overlay" }),
    /* @__PURE__ */ d(jv, { className: "bg-f1-background", children: /* @__PURE__ */ d("div", { className: "flex flex-col px-2 pb-3 pt-2", children: t.map(
      (r, a) => r.type === "separator" ? /* @__PURE__ */ d(
        "div",
        {
          className: "mx-[-8px] my-2 h-px w-[calc(100%+16px)] bg-f1-border-secondary"
        },
        `separator-${a}`
      ) : r.href ? /* @__PURE__ */ d(
        _n,
        {
          ...r,
          href: r.href,
          className: E(
            "flex w-full items-start gap-1.5",
            r.critical && "text-f1-foreground-critical",
            "text-f1-foreground no-underline hover:cursor-pointer"
          ),
          children: /* @__PURE__ */ d(Ip, { item: r })
        }
      ) : /* @__PURE__ */ k(
        "button",
        {
          onClick: () => {
            var o;
            (o = r.onClick) == null || o.call(r), i(!1);
          },
          className: "flex w-full items-center gap-2 p-3",
          children: [
            r.icon && /* @__PURE__ */ d(
              "span",
              {
                className: E(
                  "h-5 w-5 text-f1-icon",
                  r.critical && "text-f1-icon-critical"
                ),
                children: /* @__PURE__ */ d(me, { icon: r.icon, size: "md" })
              }
            ),
            /* @__PURE__ */ d(
              "span",
              {
                className: E(
                  "font-medium",
                  r.critical ? "text-f1-foreground-critical" : "text-f1-foreground"
                ),
                children: r.label
              }
            )
          ]
        },
        r.label
      )
    ) }) })
  ] });
}, qk = (t) => {
  t.stopPropagation();
}, NV = ({
  content: t,
  collapsed: e
}) => {
  const n = "FactorialOneTextEditor";
  return document.querySelectorAll(`.${n} a`).forEach((i) => {
    i.removeEventListener("click", qk), i.addEventListener("click", qk);
  }), /* @__PURE__ */ d(
    "div",
    {
      dangerouslySetInnerHTML: { __html: t },
      className: E(n, e && "line-clamp-5")
    }
  );
}, $V = () => /* @__PURE__ */ k("div", { className: "flex flex-col justify-around gap-3 py-2", children: [
  /* @__PURE__ */ d(Ce, { className: "h-2.5 w-1/2 rounded-2xs" }),
  /* @__PURE__ */ d(Ce, { className: "h-2.5 w-2/3 rounded-2xs" })
] }), hC = Bt(
  NV,
  $V
);
var pC = {
  white: {
    3: "0 0% 100% / 0.03",
    5: "0 0% 100% / 0.05",
    10: "0 0% 100% / 0.1",
    20: "0 0% 100% / 0.2",
    30: "0 0% 100% / 0.3",
    40: "0 0% 100% / 0.4",
    50: "0 0% 100% / 0.5",
    60: "0 0% 100% / 0.6",
    70: "0 0% 100% / 0.7",
    80: "0 0% 100% / 0.8",
    90: "0 0% 100% / 0.9",
    100: "0 0% 100%"
  },
  current: "currentColor",
  transparent: "transparent",
  grey: {
    0: "210 91% 22% / 0.02",
    5: "220 88% 17% / 0.04",
    10: "216 89% 18% / 0.06",
    20: "214 70% 20% / 0.1",
    30: "213 87% 15% / 0.14",
    40: "219 97% 15% / 0.37",
    50: "217 96% 11% / 0.61",
    60: "220 88% 10% / 0.82",
    70: "219 91% 8% / 0.88",
    80: "219 94% 7% / 0.9",
    90: "219 88% 6% / 0.92",
    100: "218 48% 10%",
    solid: {
      40: "219 18% 69%",
      50: "218 14% 45%"
    }
  },
  lilac: {
    50: "340 49% 60%",
    60: "341 34% 50%",
    70: "340 33% 41%"
  },
  barbie: {
    50: "331 84% 63%",
    60: "331 55% 53%",
    70: "330 49% 43%"
  },
  smoke: {
    50: "192 26% 54%",
    60: "192 22% 45%",
    70: "192 22% 37%"
  },
  army: {
    50: "162 44% 33%",
    60: "163 45% 28%",
    70: "162 44% 23%"
  },
  flubber: {
    50: "84 55% 53%",
    60: "84 48% 45%",
    70: "83 48% 33%"
  },
  indigo: {
    50: "239 91% 64%",
    60: "239 59% 54%",
    70: "239 51% 44%"
  },
  camel: {
    50: "25 46% 53%",
    60: "25 42% 44%",
    70: "25 42% 36%"
  },
  radical: {
    50: "348 80% 50%",
    60: "348 80% 42%",
    70: "347 80% 34%"
  },
  viridian: {
    50: "184 92% 35%",
    60: "184 92% 28%",
    70: "184 92% 24%"
  },
  orange: {
    50: "25 95% 53%",
    60: "24 69% 49%",
    70: "24 69% 40%"
  },
  red: {
    50: "5 100% 65%",
    60: "4 61% 49%",
    70: "3 71% 41%"
  },
  grass: {
    50: "160 84% 39%",
    60: "160 85% 33%",
    70: "161 84% 27%"
  },
  malibu: {
    50: "216 90% 65%",
    60: "216 59% 55%",
    70: "216 48% 44%"
  },
  yellow: {
    50: "38 92% 54%",
    60: "38 79% 45%",
    70: "38 80% 36%"
  },
  purple: {
    50: "258 88% 67%",
    60: "258 56% 56%",
    70: "258 43% 46%"
  },
  special: {
    highlight: "348 80% 50%"
  }
}, DV = {
  "special-highlight": "hsl(var(--special-highlight))"
};
const Gk = ({ tags: t, right: e }) => /* @__PURE__ */ d(
  "div",
  {
    className: E(
      "flex flex-1 flex-row items-center gap-1.5",
      e && "justify-end"
    ),
    children: t.map((n) => {
      const i = /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
        Ni,
        {
          icon: n.icon,
          additionalAccesibleText: `${n.label}: ${n.description}`
        }
      ) });
      return n.label || n.description ? /* @__PURE__ */ d(
        Kt,
        {
          label: n.label,
          description: n.description,
          children: i
        },
        n.label ?? n.description
      ) : i;
    })
  }
), ig = X(
  function({
    label: e,
    title: n,
    subtitle: i,
    description: r,
    color: a,
    isPending: o,
    leftTags: s,
    rightTags: l,
    fromDate: c,
    toDate: u,
    noBackground: f
  }, m) {
    return /* @__PURE__ */ k(
      "div",
      {
        ref: m,
        className: "relative flex flex-row items-stretch gap-2.5 overflow-hidden rounded-sm p-2",
        children: [
          !f && /* @__PURE__ */ k(Ee, { children: [
            /* @__PURE__ */ d(
              "div",
              {
                className: "absolute bottom-0 left-0 right-0 top-0 opacity-5",
                style: {
                  background: `${a}`
                }
              }
            ),
            /* @__PURE__ */ d(
              "div",
              {
                className: "absolute bottom-0 left-0 right-0 top-0 opacity-5",
                style: {
                  background: `linear-gradient(to right, ${a}, transparent)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ d(
            "div",
            {
              className: "min-h-10 min-w-1 rounded-2xs",
              style: o ? {
                backgroundImage: `repeating-linear-gradient(
              135deg,
              ${a} 0px,
              ${a} 4px, 
              transparent 4px, 
              transparent 5.5px
            )`
              } : {
                backgroundColor: a
              }
            }
          ),
          /* @__PURE__ */ k("div", { className: "z-10 flex flex-1 flex-col gap-2", children: [
            /* @__PURE__ */ k("div", { className: "flex flex-row items-start gap-2.5", children: [
              /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-0.5", children: [
                !!e && /* @__PURE__ */ d("p", { className: "line-clamp-1 text-sm text-f1-foreground-secondary", children: e }),
                /* @__PURE__ */ k("p", { className: "line-clamp-3 font-medium text-f1-foreground", children: [
                  n,
                  !!i && /* @__PURE__ */ d("span", { className: "pl-1 font-normal text-f1-foreground-secondary", children: `· ${i}` })
                ] }),
                /* @__PURE__ */ d("p", { className: "text-f1-foreground-secondary", children: r })
              ] }),
              /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
                c && /* @__PURE__ */ k(Ee, { children: [
                  /* @__PURE__ */ d(qp, { date: c }),
                  /* @__PURE__ */ d(
                    me,
                    {
                      icon: Oa,
                      size: "sm",
                      className: "text-f1-foreground-tertiary"
                    }
                  )
                ] }),
                u && /* @__PURE__ */ d(qp, { date: u })
              ] })
            ] }),
            (s || l) && /* @__PURE__ */ k("div", { className: "flex flex-row items-center justify-between", children: [
              s && /* @__PURE__ */ d(Gk, { tags: s }),
              l && /* @__PURE__ */ d(Gk, { tags: l, right: !0 })
            ] })
          ] })
        ]
      }
    );
  }
), EV = ({
  title: t,
  imageUrl: e,
  place: n,
  date: i
}) => {
  let r = xj(i);
  return n && (r = `${r} · ${n}`), /* @__PURE__ */ k("div", { className: "flex w-full flex-col gap-1 rounded-xl border border-solid border-f1-border-secondary bg-f1-background-inverse-secondary p-1 shadow", children: [
    e && /* @__PURE__ */ k("div", { className: "relative aspect-video w-full overflow-hidden rounded-md", children: [
      /* @__PURE__ */ d(
        "img",
        {
          src: e,
          role: "presentation",
          loading: "lazy",
          className: "aspect-video h-full w-full object-cover"
        }
      ),
      /* @__PURE__ */ d(Ce, { className: "absolute inset-0 h-full w-full" })
    ] }),
    /* @__PURE__ */ d(
      ig,
      {
        title: t,
        description: r,
        color: DV["special-highlight"],
        isPending: !1,
        toDate: i,
        noBackground: !0
      }
    )
  ] });
}, TV = () => /* @__PURE__ */ k(
  "div",
  {
    className: "flex w-full flex-col gap-1 rounded-xl border border-solid border-f1-border-secondary bg-f1-background-inverse-secondary p-1",
    role: "status",
    "aria-busy": "true",
    "aria-live": "polite",
    children: [
      /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(Ce, { className: "aspect-video h-full w-full rounded-lg" }) }),
      /* @__PURE__ */ k("div", { className: "flex h-full flex-row gap-3 p-2", children: [
        /* @__PURE__ */ d(Ce, { className: "w-1 shrink-0 self-stretch rounded-full" }),
        /* @__PURE__ */ k("div", { className: "flex grow flex-col gap-1.5 py-1", children: [
          /* @__PURE__ */ d(Ce, { className: "mt-px h-3 w-1/2" }),
          /* @__PURE__ */ d(Ce, { className: "mb-px h-3 w-1/4" })
        ] })
      ] })
    ]
  }
), gC = Bt(EV, TV), OV = /* @__PURE__ */ new Set(["avi", "mkv", "mov", "mpeg", "mp4", "webm", "wmv"]), WV = (t) => {
  if (!t) return !1;
  if (t.indexOf("//s3.") >= 0)
    return t.indexOf("response-content-type=video") >= 0;
  const n = (t == null ? void 0 : t.split(".")).at(-1);
  return !!n && OV.has(n);
}, AV = ({
  id: t,
  author: e,
  group: n,
  createdAt: i,
  title: r,
  description: a,
  onClick: o,
  mediaUrl: s,
  event: l,
  counters: c,
  reactions: u,
  inLabel: f,
  comment: m,
  dropdownItems: h,
  noReactionsButton: p = !1,
  noVideoPreload: g = !1
}) => {
  const y = [c.views, c.comments].filter(Boolean).join(" · "), v = eM(i), w = () => {
    o(t);
  }, x = (M) => {
    M.stopPropagation();
  }, b = e ? `${e.firstName} ${e.lastName}` : void 0;
  return /* @__PURE__ */ k(
    "div",
    {
      className: "flex w-full cursor-pointer flex-row gap-3 rounded-xl border border-solid border-transparent p-3 pt-2 hover:bg-f1-background-hover focus:border-f1-border-secondary focus:outline focus:outline-1 focus:outline-offset-1 focus:outline-f1-border-selected-bold md:pb-4 md:pt-3",
      onClick: w,
      children: [
        /* @__PURE__ */ d("div", { className: "hidden md:block", children: e ? /* @__PURE__ */ d(ns, { href: e.url, title: b, stopPropagation: !0, children: /* @__PURE__ */ d(
          ti,
          {
            firstName: e.firstName,
            lastName: e.lastName,
            src: e.avatarUrl
          }
        ) }) : /* @__PURE__ */ d(df, { icon: mw, className: "rounded-full" }) }),
        /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-3", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
            /* @__PURE__ */ k("div", { className: "flex flex-row justify-between", children: [
              /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row flex-wrap items-center gap-1", children: [
                e ? /* @__PURE__ */ k(Ee, { children: [
                  /* @__PURE__ */ d(
                    ns,
                    {
                      href: e.url,
                      className: "block md:hidden",
                      title: b,
                      stopPropagation: !0,
                      children: /* @__PURE__ */ d("span", { className: "flex items-center", children: /* @__PURE__ */ d(
                        ti,
                        {
                          firstName: e.firstName,
                          lastName: e.lastName,
                          src: e.avatarUrl,
                          size: "xsmall"
                        }
                      ) })
                    }
                  ),
                  /* @__PURE__ */ d(
                    ns,
                    {
                      href: e.url,
                      title: b,
                      className: "font-medium text-f1-foreground no-underline visited:text-f1-foreground",
                      stopPropagation: !0,
                      children: b
                    }
                  )
                ] }) : /* @__PURE__ */ d("div", { className: "block md:hidden", children: /* @__PURE__ */ d(
                  df,
                  {
                    icon: mw,
                    size: "sm",
                    className: "size-5 rounded-full"
                  }
                ) }),
                /* @__PURE__ */ d(
                  "span",
                  {
                    className: E(
                      "text-f1-foreground-secondary",
                      !e && "capitalize"
                    ),
                    children: f
                  }
                ),
                /* @__PURE__ */ d(
                  ns,
                  {
                    onClick: n.onClick,
                    title: n.title,
                    className: "font-medium text-f1-foreground no-underline visited:text-f1-foreground",
                    stopPropagation: !0,
                    children: n.title
                  }
                ),
                /* @__PURE__ */ d("span", { className: "hidden text-f1-foreground-secondary md:inline", children: "·" }),
                /* @__PURE__ */ d("span", { className: "text-f1-foreground-secondary", children: v })
              ] }),
              /* @__PURE__ */ k("div", { className: "flex flex-row gap-2", children: [
                /* @__PURE__ */ d("div", { className: "hidden flex-row gap-2 md:flex", children: (h == null ? void 0 : h.length) && /* @__PURE__ */ d(
                  In,
                  {
                    items: h,
                    icon: Ma,
                    size: "sm"
                  }
                ) }),
                /* @__PURE__ */ d("div", { className: "md:hidden", children: /* @__PURE__ */ d(
                  In,
                  {
                    items: [
                      {
                        label: m.label,
                        onClick: m.onClick
                      },
                      ...h ?? []
                    ],
                    icon: Ma,
                    size: "sm"
                  }
                ) })
              ] })
            ] }),
            /* @__PURE__ */ k("div", { className: "flex flex-col gap-1 text-f1-foreground", children: [
              /* @__PURE__ */ d("p", { className: "text-xl font-semibold", children: r }),
              a && /* @__PURE__ */ d(hC, { content: a, collapsed: !0 })
            ] })
          ] }),
          s && !l && /* @__PURE__ */ k("div", { className: "relative aspect-video overflow-hidden rounded-xl md:max-w-[480px]", children: [
            WV(s) ? /* @__PURE__ */ d(
              "video",
              {
                controls: !0,
                className: "h-full w-full object-cover",
                onClick: x,
                preload: g ? "none" : "auto",
                children: /* @__PURE__ */ d("source", { src: s })
              }
            ) : /* @__PURE__ */ d(
              "img",
              {
                src: s,
                role: "presentation",
                loading: "lazy",
                className: "aspect-video h-full w-full object-cover"
              }
            ),
            /* @__PURE__ */ d(Ce, { className: "absolute inset-0 -z-10 h-full w-full" })
          ] }),
          l && /* @__PURE__ */ d("div", { className: "w-full md:max-w-[480px]", children: /* @__PURE__ */ d(gC, { ...l }) }),
          /* @__PURE__ */ d("p", { className: "text-f1-foreground-secondary", children: y }),
          /* @__PURE__ */ k("div", { className: "flex flex-row gap-2.5", children: [
            !p && /* @__PURE__ */ d(
              ue,
              {
                label: m.label,
                onClick: m.onClick,
                variant: "outline",
                icon: eE,
                round: !0,
                hideLabel: !0
              }
            ),
            /* @__PURE__ */ d(
              Kz,
              {
                items: (u == null ? void 0 : u.items) ?? [],
                onInteraction: u == null ? void 0 : u.onInteraction
              }
            )
          ] })
        ] })
      ]
    }
  );
}, LV = ({
  withEvent: t,
  withImage: e
}) => /* @__PURE__ */ k("div", { className: "flex w-full cursor-wait flex-row gap-3 rounded-xl p-3 pt-2 md:pb-4 md:pt-3", children: [
  /* @__PURE__ */ d("div", { className: "hidden md:block", children: /* @__PURE__ */ d(Ce, { className: "aspect-square w-8 rounded-full" }) }),
  /* @__PURE__ */ k("div", { className: "w-full", children: [
    /* @__PURE__ */ k("div", { className: "flex h-6 flex-row items-center gap-2", children: [
      /* @__PURE__ */ d("div", { className: "md:hidden", children: /* @__PURE__ */ d(Ce, { className: "aspect-square w-4 rounded-full" }) }),
      /* @__PURE__ */ d(Ce, { className: "h-2.5 w-14 rounded-2xs" }),
      /* @__PURE__ */ d(Ce, { className: "h-2.5 w-18 rounded-2xs" })
    ] }),
    /* @__PURE__ */ d(Ce, { className: "mt-3.5 h-3.5 w-1/5 rounded-2xs" }),
    /* @__PURE__ */ d("div", { className: "mt-3", children: /* @__PURE__ */ d(hC.Skeleton, {}) }),
    e && !t && /* @__PURE__ */ d("div", { className: "mt-3 aspect-video w-full overflow-hidden rounded-xl md:w-2/3", children: /* @__PURE__ */ d(Ce, { className: "h-full w-full rounded-2xs" }) }),
    t && /* @__PURE__ */ d("div", { className: "mt-3 w-full md:w-2/3", children: /* @__PURE__ */ d(gC.Skeleton, {}) }),
    /* @__PURE__ */ k("div", { className: "mt-3 flex flex-row items-center gap-1 py-1", children: [
      /* @__PURE__ */ d(Ce, { className: "h-2.5 w-14 rounded-2xs" }),
      /* @__PURE__ */ d(Ce, { className: "h-2.5 w-14 rounded-2xs" })
    ] })
  ] })
] }), yYe = Bt(
  AV,
  LV
), IV = It({
  base: "inline-flex items-center justify-center whitespace-nowrap rounded-xs text-sm font-medium tabular-nums transition-all",
  variants: {
    size: {
      md: "min-w-5 p-0.5",
      sm: "min-w-4 px-0.5"
    },
    type: {
      default: "bg-f1-background-secondary outline outline-1 outline-f1-border",
      selected: "bg-f1-background-selected-bold text-f1-foreground-inverse",
      bold: "bg-f1-background-accent-bold text-f1-foreground-inverse"
    }
  },
  defaultVariants: {
    size: "md",
    type: "default"
  }
});
function Lo({ size: t, type: e, value: n, maxValue: i }) {
  const r = i && n > i ? `+${i}` : n;
  return /* @__PURE__ */ d("div", { className: E("text-f1-foreground", IV({ size: t, type: e })), children: r });
}
const vYe = Object.keys(pC), Qs = X(
  ({ text: t, ...e }, n) => {
    To(t, { disallowEmpty: !0 });
    const i = "color" in e && e.color ? `hsl(${pC[e.color][50]})` : "customColor" in e && e.customColor;
    return i ? /* @__PURE__ */ d(
      Aa,
      {
        ref: n,
        className: "border-[1px] border-solid border-f1-border-secondary",
        left: /* @__PURE__ */ d(
          "div",
          {
            className: "m-1 aspect-square w-2 rounded-full",
            style: {
              backgroundColor: i
            },
            "aria-hidden": !0
          }
        ),
        text: t
      }
    ) : null;
  }
);
Qs.displayName = "DotTag";
const Vr = X(
  ({ text: t, additionalAccesibleText: e, variant: n }, i) => (To(t, { disallowEmpty: !0 }), /* @__PURE__ */ d(
    Aa,
    {
      ref: i,
      className: E(
        {
          neutral: "bg-f1-background-secondary text-f1-foreground-secondary",
          info: "bg-f1-background-info text-f1-foreground-info",
          positive: "bg-f1-background-positive text-f1-foreground-positive",
          warning: "bg-f1-background-warning text-f1-foreground-warning",
          critical: "bg-f1-background-critical text-f1-foreground-critical"
        }[n]
      ),
      left: /* @__PURE__ */ d(
        "div",
        {
          className: E(
            "m-1 aspect-square w-2 rounded-full",
            {
              neutral: "bg-f1-icon",
              info: "bg-f1-icon-info",
              positive: "bg-f1-icon-positive",
              warning: "bg-f1-icon-warning",
              critical: "bg-f1-icon-critical"
            }[n]
          ),
          "aria-hidden": !0
        }
      ),
      additionalAccesibleText: e,
      text: t
    }
  ))
);
Vr.displayName = "StatusTag";
const RV = {
  warning: {
    icon: n5,
    iconColor: "text-f1-icon-warning",
    textColor: "text-f1-foreground-warning"
  },
  critical: {
    icon: Dy,
    iconColor: "text-f1-icon-critical",
    textColor: "text-f1-foreground-critical"
  }
};
function c1({
  item: t,
  collapse: e = !1
}) {
  const { value: n } = t;
  switch (n.type) {
    case "text":
      return /* @__PURE__ */ d("span", { children: n.content });
    case "avatar":
      return /* @__PURE__ */ k("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ d(ni, { avatar: n.variant, size: "xsmall" }),
        n.text && /* @__PURE__ */ d("span", { children: n.text })
      ] });
    case "status":
      return /* @__PURE__ */ d(Vr, { text: n.label, variant: n.variant });
    case "list":
      return /* @__PURE__ */ d(
        Js,
        {
          avatars: n.avatars,
          size: "xsmall",
          type: n.variant,
          max: 3
        }
      );
    case "data-list":
      return e ? /* @__PURE__ */ k("div", { className: "flex items-center justify-center gap-1 font-medium", children: [
        n.data[0],
        n.data.length > 1 && /* @__PURE__ */ k("span", { className: "tabular-nums text-f1-foreground-secondary", children: [
          "+",
          n.data.length - 1
        ] })
      ] }) : /* @__PURE__ */ d("div", { className: "flex flex-col gap-1.5", children: n.data.map((i) => /* @__PURE__ */ d("span", { children: i }, i)) });
    case "tag-list":
      return e ? /* @__PURE__ */ k("div", { className: "flex flex-wrap items-center justify-center gap-1 font-medium", children: [
        /* @__PURE__ */ d(Ni, { text: n.tags[0] }),
        n.tags.length > 1 && /* @__PURE__ */ k("span", { className: "tabular-nums text-f1-foreground-secondary", children: [
          "+",
          n.tags.length - 1
        ] })
      ] }) : /* @__PURE__ */ d(
        "div",
        {
          className: E(
            "flex flex-col gap-1 [&>div]:w-fit",
            n.tags.length > 1 && "-mt-[3px]"
          ),
          children: n.tags.map((i) => /* @__PURE__ */ d(Ni, { text: i }, i))
        }
      );
    case "dot-tag":
      return /* @__PURE__ */ d(Qs, { text: n.label, color: n.color });
    case "date": {
      if (n.icon === void 0)
        return /* @__PURE__ */ d("span", { children: n.formattedDate });
      const { icon: i, iconColor: r, textColor: a } = RV[n.icon];
      return /* @__PURE__ */ k("div", { className: "flex items-center justify-center gap-0.5 font-medium", children: [
        /* @__PURE__ */ d(me, { icon: i, className: r }),
        /* @__PURE__ */ d("span", { className: a, children: n.formattedDate })
      ] });
    }
  }
}
const jV = (t) => (t == null ? void 0 : t.type) !== "copy", FV = (t) => (t == null ? void 0 : t.type) === "copy";
function zV({ item: t }) {
  var s, l, c;
  const [e, n] = q(!1), i = t.value.type === "data-list" && t.value.data.length > 1 || t.value.type === "tag-list" && t.value.tags.length > 1, r = !!((s = t.actions) != null && s.length), a = r || i, o = (u, f) => {
    if (f)
      return f;
    let m;
    switch (u.type) {
      case "text":
        return u.content;
      case "avatar":
        return u.text;
      case "status":
      case "dot-tag":
        return u.label;
      case "date":
        return u.formattedDate;
      case "tag-list":
        return u.tags.join(", ");
      case "data-list":
        return u.data.join(", ");
      case "list":
        return "";
      default:
        return m = u, m;
    }
  };
  return /* @__PURE__ */ k("div", { className: "flex h-8 items-center gap-2", children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: E(
          "flex w-28 items-center gap-1 truncate text-f1-foreground-secondary md:w-fit",
          t.hideLabel && "md:hidden"
        ),
        children: [
          t.label,
          t.info && /* @__PURE__ */ d("div", { className: "flex h-4 w-4 items-center text-f1-foreground-tertiary hover:cursor-help", children: /* @__PURE__ */ d(
            Kt,
            {
              label: t.info.title,
              description: t.info.description,
              children: /* @__PURE__ */ d(me, { icon: Ey, size: "sm" })
            }
          ) })
        ]
      }
    ),
    /* @__PURE__ */ k(
      "div",
      {
        role: "button",
        tabIndex: a ? 0 : -1,
        onMouseEnter: () => a && n(!0),
        onMouseLeave: () => a && n(!1),
        onFocus: () => a && n(!0),
        onBlur: () => a && n(!1),
        className: "relative flex h-5 w-fit items-center hover:cursor-default",
        "aria-label": `${t.label} actions`,
        children: [
          /* @__PURE__ */ d(
            "div",
            {
              className: E(
                "hidden font-medium text-f1-foreground md:block",
                !r && "block"
              ),
              children: /* @__PURE__ */ d(c1, { item: t, collapse: !0 })
            }
          ),
          r && /* @__PURE__ */ d("div", { className: "w-full md:hidden", children: /* @__PURE__ */ d(
            Fv,
            {
              items: ((l = t.actions) == null ? void 0 : l.filter(jV).map((u) => ({
                label: u.label,
                icon: u.icon,
                onClick: u.onClick
              }))) ?? [],
              children: /* @__PURE__ */ d(c1, { item: t, collapse: !0 })
            }
          ) }),
          /* @__PURE__ */ d(Ue, { children: e && a && /* @__PURE__ */ k(
            re.div,
            {
              className: E(
                "absolute -left-1.5 -top-1.5 z-50 hidden max-h-[80vh] items-start justify-center gap-1.5 overflow-y-auto whitespace-nowrap rounded-sm bg-f1-background py-1 pl-1.5 shadow-md ring-1 ring-inset ring-f1-border-secondary md:flex",
                !i && "h-8 items-start",
                r ? "pr-1" : "pr-1.5"
              ),
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              exit: { opacity: 0 },
              transition: { duration: 0.1 },
              children: [
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: E(
                      "flex h-6 items-center font-medium text-f1-foreground",
                      i && "h-auto items-start pt-0.5"
                    ),
                    children: /* @__PURE__ */ d(c1, { item: t })
                  }
                ),
                r && /* @__PURE__ */ d(
                  re.div,
                  {
                    className: "flex gap-1",
                    initial: { x: -16 },
                    animate: { x: 0 },
                    exit: { x: -16 },
                    transition: { duration: 0.1 },
                    children: (c = t.actions) == null ? void 0 : c.map((u, f) => FV(u) ? /* @__PURE__ */ d(
                      rD,
                      {
                        valueToCopy: o(
                          t.value,
                          u.copyValue
                        )
                      },
                      `copy-${f}`
                    ) : /* @__PURE__ */ d(Kt, { label: u.label, children: /* @__PURE__ */ d(
                      ue,
                      {
                        size: "sm",
                        variant: "neutral",
                        round: !0,
                        label: u.label,
                        hideLabel: !0,
                        icon: u.icon,
                        onClick: u.onClick
                      },
                      `action-${f}`
                    ) }, `tooltip-${f}`))
                  }
                )
              ]
            }
          ) })
        ]
      }
    )
  ] });
}
const Xk = ec(function({ items: e }) {
  const n = e.filter((i) => typeof i == "object");
  return /* @__PURE__ */ d("div", { className: "flex flex-col items-start gap-x-3 gap-y-0 md:flex-row md:flex-wrap md:items-center", children: n.map((i, r) => /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d(zV, { item: i }, `item-${r}`),
    r < n.length - 1 && /* @__PURE__ */ d(
      "div",
      {
        className: "hidden h-4 w-[1px] bg-f1-border md:block"
      },
      `separator-${r}`
    )
  ] })) });
}), VV = ({ description: t }) => {
  const [e, n] = q(!1), [i, r] = q(!1), a = et(), o = Oe(null), s = Oe(null), l = qu({ ref: o }), c = qu({ ref: s });
  return le(() => {
    c.height && l.height && r(c.height > l.height);
  }, [c.height, l.height]), /* @__PURE__ */ k("div", { className: "flex max-w-[640px] flex-col gap-1", children: [
    /* @__PURE__ */ k(
      re.div,
      {
        initial: !1,
        animate: {
          height: e ? c.height ?? l.height : l.height ?? "3rem"
        },
        transition: {
          duration: i ? 0.15 : 0,
          ease: [0.165, 0.84, 0.44, 1]
        },
        className: E(
          e ? "overflow-y-scroll" : "overflow-clip",
          "relative max-h-80"
        ),
        children: [
          /* @__PURE__ */ d(
            "div",
            {
              ref: s,
              className: "pointer-events-none invisible absolute left-0 top-0 -z-10 text-lg text-f1-foreground-secondary",
              "aria-hidden": "true",
              children: t
            }
          ),
          /* @__PURE__ */ d(
            "div",
            {
              ref: o,
              className: E(
                "text-lg text-f1-foreground-secondary",
                !e && "line-clamp-2"
              ),
              children: t
            }
          )
        ]
      }
    ),
    (i || e) && /* @__PURE__ */ d(
      "button",
      {
        onClick: () => n((u) => !u),
        className: "relative w-fit font-medium text-f1-foreground after:absolute after:-bottom-0.5 after:left-0 after:right-0 after:h-[1.5px] after:bg-f1-border after:transition-all after:content-[''] hover:after:bg-f1-border-hover",
        children: e ? a.actions.showLess : a.actions.showAll
      }
    )
  ] });
}, u1 = (t) => t.isVisible !== !1, Kc = ec(function({
  tooltip: e,
  ...n
}) {
  if (e) {
    const i = n.disabled ? "span" : rd;
    return /* @__PURE__ */ d(Kt, { description: e, children: /* @__PURE__ */ d(i, { children: /* @__PURE__ */ d(ue, { ...n }) }) });
  }
  return /* @__PURE__ */ d(ue, { ...n });
}), Yk = ec(function({
  tooltip: e,
  ...n
}) {
  if (e) {
    const i = n.disabled ? "span" : rd;
    return /* @__PURE__ */ d(Kt, { description: e, children: /* @__PURE__ */ d(i, { children: /* @__PURE__ */ d(ws, { ...n }) }) });
  }
  return /* @__PURE__ */ d(ws, { ...n });
});
function HV({
  title: t,
  avatar: e,
  description: n,
  primaryAction: i,
  secondaryActions: r = [],
  otherActions: a = [],
  status: o,
  metadata: s = []
}) {
  const l = [
    o && {
      label: o.label,
      value: {
        type: "status",
        label: o.text,
        variant: o.variant
      },
      actions: o.actions,
      hideLabel: !0
    },
    ...s
  ], c = r.filter(u1), u = a.filter(u1), f = i && u1(i), m = c.length > 0, h = u.length > 0, p = (y) => !!y && "items" in y, g = (y) => !!y && "label" in y && !("items" in y);
  return /* @__PURE__ */ k("div", { className: "resource-header flex flex-col gap-3 px-6 pb-5 pt-3", children: [
    /* @__PURE__ */ k(
      "div",
      {
        className: E(
          "flex flex-col items-start justify-start gap-4 md:flex-row",
          !n && "md:items-center"
        ),
        children: [
          /* @__PURE__ */ k(
            "div",
            {
              className: E(
                "flex grow flex-col items-start justify-start gap-3 md:flex-row md:items-start",
                !n && "md:items-center"
              ),
              children: [
                e && /* @__PURE__ */ d("div", { className: "flex items-start", children: /* @__PURE__ */ d(
                  ni,
                  {
                    avatar: {
                      ...e.type === "generic" ? { ...e, type: "company" } : e
                    },
                    size: "large"
                  }
                ) }),
                /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
                  /* @__PURE__ */ d("span", { className: "text-2xl font-semibold text-f1-foreground", children: t }),
                  n && /* @__PURE__ */ d(VV, { description: n })
                ] })
              ]
            }
          ),
          l.length > 0 && /* @__PURE__ */ d("div", { className: "flex flex-wrap items-center gap-x-3 gap-y-1 md:hidden", children: /* @__PURE__ */ d(Xk, { items: l }) }),
          /* @__PURE__ */ k("div", { className: "flex w-full shrink-0 flex-col gap-x-2 gap-y-3 md:hidden", children: [
            f && g(i) && /* @__PURE__ */ d("div", { className: "w-full md:hidden [&>*]:w-full", children: /* @__PURE__ */ d(
              Kc,
              {
                label: i.label,
                onClick: i.onClick,
                variant: "default",
                icon: i.icon,
                size: "lg",
                disabled: i.disabled,
                tooltip: i.tooltip
              }
            ) }),
            f && p(i) && /* @__PURE__ */ d("div", { className: "w-full md:hidden [&>*]:w-full", children: /* @__PURE__ */ d(
              Yk,
              {
                items: i.items,
                onClick: i.onClick,
                variant: "default",
                value: i.value,
                size: "lg",
                disabled: i.disabled,
                tooltip: i.tooltip
              }
            ) }),
            c.map((y) => /* @__PURE__ */ d(rd, { children: /* @__PURE__ */ d("div", { className: "w-full md:hidden [&>*]:w-full [&>span]:block [&>span_div]:w-full", children: /* @__PURE__ */ d(
              Kc,
              {
                label: y.label,
                onClick: y.onClick,
                variant: y.variant ?? "outline",
                icon: y.icon,
                size: "lg",
                disabled: y.disabled,
                tooltip: y.tooltip
              }
            ) }) }, y.label)),
            u.length > 0 && /* @__PURE__ */ d("div", { className: "w-full [&>*]:w-full [&_button]:w-full", children: /* @__PURE__ */ d(Fv, { items: u }) })
          ] }),
          /* @__PURE__ */ k("div", { className: "-m-1 hidden w-fit shrink-0 flex-wrap items-center gap-x-2 gap-y-2 p-1 md:flex md:overflow-x-auto", children: [
            u.length > 0 && /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(In, { items: u }) }),
            c.map((y) => /* @__PURE__ */ d(rd, { children: /* @__PURE__ */ d("div", { className: "hidden md:block", children: /* @__PURE__ */ d(
              Kc,
              {
                label: y.label,
                onClick: y.onClick,
                variant: y.variant ?? "outline",
                icon: y.icon,
                disabled: y.disabled,
                tooltip: y.tooltip
              }
            ) }) }, y.label)),
            f && (m || h) && /* @__PURE__ */ d("div", { className: "mx-1 h-4 w-px bg-f1-background-secondary-hover" }),
            f && g(i) && /* @__PURE__ */ d("div", { className: "hidden md:block", children: /* @__PURE__ */ d(
              Kc,
              {
                label: i.label,
                onClick: i.onClick,
                variant: "default",
                icon: i.icon,
                disabled: i.disabled,
                tooltip: i.tooltip
              }
            ) }),
            f && p(i) && /* @__PURE__ */ d("div", { className: "hidden md:block", children: /* @__PURE__ */ d(
              Yk,
              {
                items: i.items,
                onClick: i.onClick,
                variant: "default",
                value: i.value,
                size: "md",
                disabled: i.disabled,
                tooltip: i.tooltip
              }
            ) })
          ] })
        ]
      }
    ),
    l.length > 0 && /* @__PURE__ */ d("div", { className: "hidden flex-wrap items-center gap-x-3 gap-y-1 md:block", children: /* @__PURE__ */ d(Xk, { items: l }) })
  ] });
}
const bYe = ({
  avatar: t,
  title: e,
  description: n,
  primaryAction: i,
  secondaryActions: r,
  otherActions: a,
  status: o,
  metadata: s
}) => /* @__PURE__ */ d(
  HV,
  {
    avatar: t,
    title: e,
    description: n,
    primaryAction: i,
    secondaryActions: r,
    otherActions: a,
    status: o,
    metadata: s
  }
), wYe = ({
  title: t,
  description: e,
  action: n,
  supportButton: i,
  separator: r
}) => {
  const a = i5();
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "border-1 flex flex-col justify-between gap-4 border-dashed border-transparent px-6 pb-5 pt-5 first:pb-0 first:pt-0 md:flex-row md:gap-2",
        a === "standard" && "-mx-6",
        r === "top" && "border-t-f1-border first:pt-5",
        r === "bottom" && "border-b-f1-border first:pb-5"
      ),
      children: [
        /* @__PURE__ */ k("div", { className: "flex grow flex-col gap-3", children: [
          /* @__PURE__ */ k("div", { className: "flex max-w-[640px] flex-col gap-1", children: [
            /* @__PURE__ */ d("h2", { className: "text-lg font-semibold text-f1-foreground", children: t }),
            /* @__PURE__ */ d("p", { className: "text-f1-foreground-secondary", children: e })
          ] }),
          i && /* @__PURE__ */ d("div", { className: "w-fit", children: /* @__PURE__ */ k(
            "a",
            {
              href: i.href,
              target: "_blank",
              rel: "noreferrer",
              className: E(
                "flex items-center gap-1 rounded-sm bg-f1-background-secondary px-2 py-0.5 text-base font-medium text-f1-foreground no-underline transition-colors hover:bg-f1-background-secondary-hover [&>svg]:text-f1-foreground-secondary",
                Ke()
              ),
              children: [
                i.label,
                /* @__PURE__ */ d(me, { icon: r5, size: "sm" })
              ]
            }
          ) })
        ] }),
        n && /* @__PURE__ */ k(Ee, { children: [
          /* @__PURE__ */ d("div", { className: "hidden md:block", children: /* @__PURE__ */ d(
            ue,
            {
              label: n.label,
              variant: n.variant ?? "outline",
              icon: n.icon,
              size: "md",
              onClick: n.onClick
            }
          ) }),
          /* @__PURE__ */ d("div", { className: "w-full md:hidden [&>button]:w-full", children: /* @__PURE__ */ d(
            ue,
            {
              label: n.label,
              variant: n.variant ?? "outline",
              icon: n.icon,
              size: "lg",
              onClick: n.onClick
            }
          ) })
        ] })
      ]
    }
  );
}, BV = It({
  base: "flex select-none items-center justify-center text-f1-foreground-secondary",
  variants: {
    size: {
      small: "h-4 w-4 [&_circle]:stroke-[4]",
      medium: "h-8 w-8 [&_circle]:stroke-[2.6]",
      large: "h-12 w-12 [&_circle]:stroke-2"
    }
  },
  defaultVariants: {
    size: "medium"
  }
});
function pc({ size: t, className: e }) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(BV({ size: t, className: e })),
      "aria-live": "polite",
      "aria-busy": !0,
      children: /* @__PURE__ */ k(
        "svg",
        {
          viewBox: "0 0 32 32",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg",
          className: "h-full w-full",
          children: [
            /* @__PURE__ */ d(
              "circle",
              {
                cx: "16",
                cy: "16",
                r: "12",
                className: "stroke-f1-background-secondary"
              }
            ),
            /* @__PURE__ */ d(
              re.circle,
              {
                cx: "16",
                cy: "16",
                r: "12",
                stroke: "currentColor",
                strokeLinecap: "round",
                strokeDasharray: "1 80",
                className: "opacity-50",
                initial: {
                  rotate: 0,
                  originX: "50%",
                  originY: "50%"
                },
                animate: {
                  rotate: [0, 450, 1080],
                  strokeDasharray: ["1 80", "60 40", "1 80"]
                },
                transition: {
                  duration: 2,
                  ease: "linear",
                  repeat: 1 / 0
                }
              }
            )
          ]
        }
      )
    }
  );
}
const qV = {
  info: a5,
  warning: n5,
  critical: Dy
}, gc = X(
  ({ text: t, level: e }, n) => (To(t, { disallowEmpty: !0 }), /* @__PURE__ */ d(
    Aa,
    {
      ref: n,
      className: E(
        "pl-0.5",
        {
          info: "bg-f1-background-info text-f1-foreground-info",
          warning: "bg-f1-background-warning text-f1-foreground-warning",
          critical: "bg-f1-background-critical text-f1-foreground-critical"
        }[e]
      ),
      left: /* @__PURE__ */ d(
        Cm,
        {
          icon: qV[e],
          size: "md",
          "aria-hidden": !0,
          className: E(
            {
              info: "text-f1-icon-info",
              warning: "text-f1-icon-warning",
              critical: "text-f1-icon-critical"
            }[e]
          )
        }
      ),
      text: t
    }
  ))
);
gc.displayName = "AlertTag";
const GV = {
  positive: Iy,
  negative: ad
}, yC = X(
  ({ text: t, status: e }, n) => (To(t, { disallowEmpty: !0 }), /* @__PURE__ */ d(
    Aa,
    {
      ref: n,
      className: E(
        {
          positive: "bg-f1-background-positive text-f1-foreground-positive",
          neutral: "bg-f1-background-secondary text-f1-foreground-secondary",
          negative: "bg-f1-background-critical text-f1-foreground-critical"
        }[e]
      ),
      left: e === "neutral" ? null : /* @__PURE__ */ d(
        Cm,
        {
          icon: GV[e],
          size: "sm",
          className: E(
            {
              positive: "text-f1-icon-positive",
              neutral: "text-f1-icon-secondary",
              negative: "text-f1-icon-critical"
            }[e]
          )
        }
      ),
      additionalAccesibleText: `${e} balance`,
      text: t
    }
  ))
);
yC.displayName = "BalanceTag";
const nh = X(
  ({ imageUrl: t, text: e, rounded: n = !1, onClick: i }, r) => (To(e, { disallowEmpty: !0 }), /* @__PURE__ */ d(
    Aa,
    {
      ref: r,
      className: E(
        "gap-1 border-[1px] border-solid border-f1-border-secondary py-[1px] pl-[1px]",
        n ? "rounded-full" : "rounded-[8px]"
      ),
      left: /* @__PURE__ */ d(
        "img",
        {
          src: t,
          "aria-hidden": !0,
          className: E(
            "h-[20px] w-[20x]",
            n ? "rounded-full" : "rounded-[6px]"
          )
        }
      ),
      text: e,
      onClick: i
    }
  ))
);
nh.displayName = "ImageTag";
const vC = X(
  ({ companyName: t, companyImageUrl: e, onClick: n }, i) => /* @__PURE__ */ d(
    nh,
    {
      ref: i,
      imageUrl: e,
      text: t,
      onClick: n
    }
  )
);
vC.displayName = "CompanyTag";
const bC = X(
  ({ name: t, avatarUrl: e, onClick: n }, i) => /* @__PURE__ */ d(
    nh,
    {
      ref: i,
      imageUrl: e,
      text: t,
      onClick: n,
      rounded: !0
    }
  )
);
bC.displayName = "PersonTag";
const wC = X(
  ({ teamName: t, teamImageUrl: e, onClick: n }, i) => /* @__PURE__ */ d(
    nh,
    {
      ref: i,
      imageUrl: e,
      text: t,
      onClick: n
    }
  )
);
wC.displayName = "TeamTag";
const XV = (t) => {
  const { type: e } = t;
  if (e === "dot") return /* @__PURE__ */ d(Qs, { ...t });
  if (e === "person") return /* @__PURE__ */ d(bC, { ...t });
  if (e === "team") return /* @__PURE__ */ d(wC, { ...t });
  if (e === "company") return /* @__PURE__ */ d(vC, { ...t });
  if (e === "alert") return /* @__PURE__ */ d(gc, { ...t });
  if (e === "status") return /* @__PURE__ */ d(Vr, { ...t });
  if (e === "balance") return /* @__PURE__ */ d(yC, { ...t });
}, rs = ({ tag: t }) => {
  const e = XV(t);
  return e || "Invalid tag type";
}, rg = ({ count: t, list: e }) => {
  const [n, i] = q(!1), r = /* @__PURE__ */ d(Ni, { text: `+${t}` });
  return e != null && e.length ? /* @__PURE__ */ k($o, { open: n, onOpenChange: i, children: [
    /* @__PURE__ */ d(Do, { asChild: !0, children: /* @__PURE__ */ d(
      "button",
      {
        className: E("inline-flex flex-shrink-0 items-center", Ke()),
        children: r
      }
    ) }),
    /* @__PURE__ */ d(
      Eo,
      {
        className: "rounded-md border border-solid border-f1-border-secondary p-1 shadow-md",
        align: "end",
        children: /* @__PURE__ */ k(No, { className: "[*[data-state=visible]_div]:bg-f1-background flex max-h-[172px] flex-col", children: [
          e.map((a, o) => /* @__PURE__ */ d(
            "div",
            {
              className: "flex w-[220px] min-w-0 items-center gap-1.5 px-2 py-1 [&:first-child]:pt-2 [&:last-child]:pb-2",
              children: a.description ? /* @__PURE__ */ d(Kt, { label: a.description, children: /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(rs, { tag: a }) }) }) : /* @__PURE__ */ d(rs, { tag: a })
            },
            o
          )),
          /* @__PURE__ */ d(
            $y,
            {
              orientation: "vertical",
              className: "[&_div]:bg-f1-background"
            }
          )
        ] })
      }
    )
  ] }) : r;
};
rg.displayName = "TagCounter";
const YV = It({
  base: "flex items-center gap-2"
}), kC = ({
  type: t,
  tags: e,
  max: n = 4,
  remainingCount: i,
  layout: r = "compact"
}) => {
  const a = e.map(
    (u) => ({ type: t, ...u })
  );
  if (r === "fill")
    return /* @__PURE__ */ d(
      Jm,
      {
        items: a,
        renderListItem: (u) => {
          const f = Kk(u);
          return f ? /* @__PURE__ */ d(Kt, { label: f, children: /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(rs, { tag: u }) }) }) : /* @__PURE__ */ d(rs, { tag: u });
        },
        renderDropdownItem: () => null,
        forceShowingOverflowIndicator: i !== void 0,
        renderOverflowIndicator: (u) => /* @__PURE__ */ d(
          rg,
          {
            count: (i ?? 0) + u,
            list: i ? void 0 : a.slice(a.length - u)
          }
        ),
        overflowIndicatorWithPopover: !1,
        className: "flex-1"
      }
    );
  const o = a.slice(0, n), s = a.slice(n), l = i ?? a.length - n, c = l > 0;
  return /* @__PURE__ */ k("div", { className: YV(), children: [
    o.map((u, f) => {
      const m = Kk(u);
      return m ? /* @__PURE__ */ d(Kt, { label: m, children: /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(rs, { tag: u }, f) }) }, f) : /* @__PURE__ */ d(rs, { tag: u }, f);
    }),
    c && /* @__PURE__ */ d(
      rg,
      {
        count: l,
        list: i ? void 0 : s
      }
    )
  ] });
}, Kk = (t) => {
  if ("description" in t && typeof t.description == "string")
    return t.description;
};
kC.displayName = "TagList";
const KV = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday"
], UV = X(
  function({ daysOfTheWeek: e = KV, activatedDays: n = [] }, i) {
    const r = n.map(
      (a) => `${a}-${e[a]}`
    );
    return /* @__PURE__ */ d(
      g9,
      {
        type: "multiple",
        value: r,
        disabled: !0,
        className: "flex justify-start",
        ref: i,
        children: e.map((a, o) => /* @__PURE__ */ d(
          y9,
          {
            "aria-label": a,
            value: `${o}-${a}`,
            className: "h-6 w-6 shrink-0 grow-0 basis-6 p-0 text-sm font-medium disabled:select-none disabled:bg-f1-background-tertiary disabled:text-f1-foreground-secondary disabled:opacity-100 disabled:data-[state=on]:border disabled:data-[state=on]:border-solid disabled:data-[state=on]:border-f1-border-selected disabled:data-[state=on]:bg-f1-background-selected disabled:data-[state=on]:text-f1-foreground-selected",
            children: a[0]
          },
          o
        ))
      }
    );
  }
), JV = 750, QV = ({ text: t, children: e }) => {
  const [n, i] = q(!1);
  le(() => {
    if (n) {
      const a = setTimeout(() => i(!1), JV);
      return () => clearTimeout(a);
    }
  }, [n]);
  const r = async () => {
    try {
      await navigator.clipboard.writeText(t), i(!0);
    } catch {
    }
  };
  return /* @__PURE__ */ k(
    "button",
    {
      type: "button",
      "aria-label": n ? "Copied!" : `Copy ${t}`,
      className: E(
        "group flex items-center gap-1.5 rounded p-1.5",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-f1-border-selected-bold",
        "transition-colors duration-300 hover:bg-f1-background-hover active:bg-f1-background-secondary-hover",
        n ? "hover:bg-f1-background-positive focus-visible:bg-f1-background-positive" : void 0
      ),
      onClick: r,
      children: [
        e,
        /* @__PURE__ */ k("div", { className: "grid", children: [
          /* @__PURE__ */ d(
            me,
            {
              icon: aD,
              size: "md",
              "aria-hidden": !0,
              className: E(
                "col-start-1 col-end-2 row-start-1 row-end-2",
                "opacity-0 transition-opacity duration-300",
                !n && "group-hover:opacity-100 group-focus-visible:opacity-100"
              )
            }
          ),
          /* @__PURE__ */ d(
            me,
            {
              icon: Py,
              size: "md",
              "aria-hidden": !0,
              className: E(
                "col-start-1 col-end-2 row-start-1 row-end-2",
                // place to the same cell
                "text-f1-icon-positive opacity-0 transition-opacity duration-300",
                n && "group-hover:opacity-100 group-focus-visible:opacity-100"
              )
            }
          )
        ] })
      ]
    }
  );
}, xC = ec(
  ({ children: t, className: e, ...n }) => /* @__PURE__ */ k(
    _n,
    {
      ...n,
      className: E(
        "text-inherit group flex items-center gap-1.5 rounded p-1.5 text-f1-foreground",
        "no-underline hover:bg-f1-background-hover focus-visible:outline focus-visible:outline-2 focus-visible:outline-f1-border-selected-bold active:bg-f1-background-secondary-hover",
        e
      ),
      children: [
        t,
        /* @__PURE__ */ d("div", { className: "grid", children: /* @__PURE__ */ d(
          me,
          {
            "aria-hidden": !0,
            icon: Oa,
            size: "md",
            className: "opacity-0 transition-opacity duration-300 group-hover:opacity-100 group-focus-visible:opacity-100 group-active:opacity-100"
          }
        ) })
      ]
    }
  )
);
xC.displayName = "NavigateAction";
const yc = X(
  (t, e) => {
    const {
      text: n,
      leftIcon: i,
      className: r,
      action: a = { type: "noop" }
    } = t;
    return /* @__PURE__ */ d(
      "li",
      {
        className: "flex rounded font-medium text-f1-foreground *:flex-1",
        ref: e,
        children: /* @__PURE__ */ k(
          ZV,
          {
            action: a,
            className: E("flex items-center gap-1.5 p-1.5", r),
            children: [
              i && (typeof i == "function" ? i({}) : /* @__PURE__ */ d(me, { icon: i, size: "md", "aria-hidden": "true" })),
              /* @__PURE__ */ d("div", { className: "line-clamp-5 flex-1 whitespace-pre-line text-left", children: n })
            ]
          }
        )
      }
    );
  }
);
yc.displayName = "ItemContainer";
const ZV = ({
  children: t,
  action: e,
  ...n
}) => {
  const i = e.type;
  switch (i) {
    case "copy":
      return /* @__PURE__ */ d(QV, { ...e, ...n, children: t });
    case "navigate":
      return /* @__PURE__ */ d(xC, { ...e, ...n, children: t });
    case "noop":
      return /* @__PURE__ */ d("div", { ...n, children: t });
    default:
      return i;
  }
}, _C = X(
  ({ children: t, label: e, isHorizontal: n = !1 }, i) => /* @__PURE__ */ k(
    "div",
    {
      className: E(
        n ? "flex min-h-12 flex-1 flex-col py-1.5 pl-3 pr-1.5 xs:flex-row" : "min-w-32 max-w-72"
      ),
      children: [
        e && /* @__PURE__ */ d(
          "p",
          {
            className: E(
              "px-1.5 text-f1-foreground-secondary",
              n ? "mt-1.5 w-44 xs:px-0" : "mb-0.5"
            ),
            children: e
          }
        ),
        /* @__PURE__ */ d("ul", { className: "flex flex-col justify-center gap-0.5", ref: i, children: t })
      ]
    }
  )
);
_C.displayName = "DataList";
const MC = X(
  ({ text: t, icon: e, action: n }, i) => /* @__PURE__ */ d(
    yc,
    {
      ref: i,
      text: t,
      leftIcon: e,
      action: ih(n, t)
    }
  )
);
MC.displayName = "DataList.Item";
const CC = X(
  ({ action: t, avatarUrl: e, firstName: n, lastName: i }, r) => {
    const a = `${n} ${i}`;
    return /* @__PURE__ */ d(
      yc,
      {
        ref: r,
        leftIcon: () => /* @__PURE__ */ d(
          ti,
          {
            size: "xsmall",
            src: e,
            firstName: n,
            lastName: i
          }
        ),
        text: a,
        action: ih(t, a)
      }
    );
  }
);
CC.displayName = "PersonItem";
const PC = X(
  ({ avatarUrl: t, name: e, action: n }, i) => /* @__PURE__ */ d(
    yc,
    {
      ref: i,
      leftIcon: () => /* @__PURE__ */ d(ac, { name: e, size: "xsmall", src: t }),
      text: e,
      action: ih(n, e)
    }
  )
);
PC.displayName = "CompanyItem";
const SC = X(
  ({ action: t, name: e }, n) => /* @__PURE__ */ d(
    yc,
    {
      ref: n,
      leftIcon: () => /* @__PURE__ */ d(Fm, { name: e, size: "xsmall" }),
      text: e,
      action: ih(t, e)
    }
  )
);
SC.displayName = "TeamItem";
const NC = X(
  ({ ...t }, e) => /* @__PURE__ */ d("li", { ref: e, className: "flex items-start pt-1", children: /* @__PURE__ */ d(Qs, { ...t }) })
);
NC.displayName = "DotTagItem";
const ih = (t, e) => t && t.type === "copy" ? { type: "copy", text: t.text ?? e } : t, Ko = Object.assign(_C, {
  Item: MC,
  CompanyItem: PC,
  PersonItem: CC,
  TeamItem: SC,
  DotTagItem: NC
}), eH = ({ content: t }) => /* @__PURE__ */ k(Ee, { children: [
  t.type === "weekdays" && /* @__PURE__ */ d("li", { className: "list-none px-1.5 py-1", children: /* @__PURE__ */ d(UV, { ...t }) }),
  t.type === "person" && /* @__PURE__ */ d(Ko.PersonItem, { ...t }),
  t.type === "item" && /* @__PURE__ */ d(Ko.Item, { ...t }),
  t.type === "team" && /* @__PURE__ */ d(Ko.TeamItem, { ...t }),
  t.type === "company" && /* @__PURE__ */ d(Ko.CompanyItem, { ...t }),
  t.type === "dot-tag" && /* @__PURE__ */ d(Ko.DotTagItem, { ...t })
] }), tH = X(
  function({ title: e, content: n, isHorizontal: i = !1, spacingAtTheBottom: r }, a) {
    const o = Array.isArray(n) ? n : [n];
    return /* @__PURE__ */ d(
      "div",
      {
        ref: a,
        className: E(
          "flex flex-col gap-0.5",
          r && !i && "pb-3",
          i && "xs:[&_ul>li]:p-0 [&_ul]:flex-1"
        ),
        children: /* @__PURE__ */ d(Ko, { label: e, isHorizontal: i, children: o.map((s, l) => /* @__PURE__ */ d(eH, { content: s }, l)) })
      }
    );
  }
), kYe = X(function({ title: e, tableView: n = !1, details: i }, r) {
  return /* @__PURE__ */ k("div", { ref: r, className: "flex flex-col gap-4", children: [
    !!e && /* @__PURE__ */ d("p", { className: "mb-1 pl-1.5 text-sm font-semibold text-f1-foreground-secondary", children: e.toLocaleUpperCase() }),
    /* @__PURE__ */ d(
      "div",
      {
        className: E(
          "flex flex-col",
          n ? "max-w-[580px] rounded-md border border-solid border-f1-border-secondary" : "gap-3"
        ),
        children: i == null ? void 0 : i.map((a, o) => /* @__PURE__ */ k(H.Fragment, { children: [
          /* @__PURE__ */ d(
            tH,
            {
              title: a.title,
              content: a.content,
              spacingAtTheBottom: a.spacingAtTheBottom,
              isHorizontal: n
            },
            a.title
          ),
          n && o !== i.length - 1 && /* @__PURE__ */ d("div", { className: "h-[1px] w-full bg-f1-border-secondary" })
        ] }, a.title))
      }
    )
  ] });
}), $C = H.forwardRef(({ person: t, onClick: e, ...n }, i) => {
  var a, o;
  const r = () => {
    e();
  };
  return /* @__PURE__ */ k(
    "div",
    {
      ref: i,
      className: E(
        "flex w-full flex-row flex-wrap items-center gap-2 rounded-md border p-2 hover:bg-f1-background-hover focus:outline focus:outline-1 focus:outline-offset-1 focus:outline-f1-border-selected-bold",
        n.withPointerCursor && "cursor-pointer"
      ),
      onClick: r,
      children: [
        /* @__PURE__ */ d(
          ti,
          {
            firstName: t.firstName,
            lastName: t.lastName,
            src: t.avatarUrl,
            badge: t.avatarBadge
          }
        ),
        /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row items-center gap-1", children: [
            /* @__PURE__ */ d("span", { className: "truncate font-medium", children: `${t.firstName} ${t.lastName}` }),
            n.info && /* @__PURE__ */ d(Kt, { label: n.info, children: /* @__PURE__ */ d(
              me,
              {
                icon: a5,
                size: "sm",
                className: "text-f1-icon-secondary"
              }
            ) })
          ] }),
          "bottomTags" in n && /* @__PURE__ */ d("div", { className: "-ml-1.5 flex flex-row items-center [&>div]:-mr-1", children: n.bottomTags.map((s, l) => /* @__PURE__ */ k(Ee, { children: [
            /* @__PURE__ */ d(
              Ni,
              {
                ...s,
                className: "text-f1-foreground-secondary",
                noBorder: !0
              },
              s.text
            ),
            l < n.bottomTags.length - 1 && /* @__PURE__ */ d("span", { children: "·" })
          ] })) }),
          "description" in n && n.description && /* @__PURE__ */ d("p", { className: "truncate text-f1-foreground-secondary", children: n.description })
        ] }),
        /* @__PURE__ */ k("div", { className: "flex flex-row items-center justify-between gap-2", children: [
          "rightTag" in n && n.rightTag && /* @__PURE__ */ d(Qs, { ...n.rightTag }),
          "actions" in n && /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row items-center justify-end gap-2", children: [
            ((a = n.actions) == null ? void 0 : a.primary) && /* @__PURE__ */ d(
              ue,
              {
                variant: "outline",
                onClick: n.actions.primary.onClick,
                label: n.actions.primary.label,
                icon: n.actions.primary.icon
              }
            ),
            ((o = n.actions) == null ? void 0 : o.secondary) && /* @__PURE__ */ d(
              ue,
              {
                variant: "outline",
                onClick: n.actions.secondary.onClick,
                label: "Secondary",
                icon: n.actions.secondary.icon,
                hideLabel: !0
              }
            )
          ] })
        ] })
      ]
    }
  );
}), nH = () => /* @__PURE__ */ k("div", { className: "flex w-full flex-row flex-wrap items-center gap-2 rounded-md border p-2 hover:bg-f1-background-hover focus:outline focus:outline-1 focus:outline-offset-1 focus:outline-f1-border-selected-bold", children: [
  /* @__PURE__ */ d(Ce, { className: "aspect-square w-8 rounded-full" }),
  /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-0.5", children: [
    /* @__PURE__ */ d(Ce, { className: "h-4" }),
    /* @__PURE__ */ d(Ce, { className: "h-4" })
  ] })
] });
$C.displayName = "OnePersonListItem";
const xYe = Bt(
  $C,
  nH
), DC = hn({
  open: !1,
  onClose: () => {
  },
  position: "center",
  shownBottomSheet: !1
}), Uk = ({
  isOpen: t,
  onClose: e,
  shownBottomSheet: n = !1,
  position: i,
  children: r
}) => /* @__PURE__ */ d(
  DC.Provider,
  {
    value: { open: t, onClose: e, position: i, shownBottomSheet: n },
    children: r
  }
), EC = () => Wt(DC), TC = () => o5("(max-width: 560px)", {
  initializeWithValue: !1
}), iH = ({
  asBottomSheetInMobile: t = !0,
  position: e = "center",
  onClose: n,
  isOpen: i,
  children: r
}) => {
  const [a, o] = q(i);
  le(() => {
    o(i);
  }, [i]);
  const s = (m) => {
    o(m), m || n();
  }, l = () => {
    o(!1), n();
  };
  if (TC() && t)
    return /* @__PURE__ */ d(
      Uk,
      {
        isOpen: a,
        onClose: l,
        position: e,
        shownBottomSheet: !0,
        children: /* @__PURE__ */ k(Rv, { open: a, onOpenChange: s, children: [
          /* @__PURE__ */ d(th, { className: "bg-f1-background-overlay" }),
          /* @__PURE__ */ d(jv, { className: "max-h-[95vh] bg-f1-background", children: r })
        ] })
      }
    );
  let u = "flex flex-col max-h-[620px] max-w-[680px] overflow-hidden";
  const f = e === "left" || e === "right";
  return f && (u = E(
    "w-full overflow-x-hidden flex flex-col absolute top-3 bottom-3 translate-y-0 translate-x-0 max-w-[539px] rounded-md border border-solid border-f1-border-secondary",
    e === "left" && "left-3",
    e === "right" && "left-auto right-3"
  )), /* @__PURE__ */ d(Uk, { isOpen: a, onClose: l, position: e, children: /* @__PURE__ */ d(s5, { open: a, onOpenChange: n, modal: e === "center", children: /* @__PURE__ */ d(
    l5,
    {
      withTraslateAnimation: !f,
      className: u,
      children: r
    }
  ) }) });
};
var Zs = "NavigationMenu", [zv, OC, rH] = ic(Zs), [ag, aH, oH] = ic(Zs), [Vv, _Ye] = Wi(
  Zs,
  [rH, oH]
), [sH, Ai] = Vv(Zs), [lH, dH] = Vv(Zs), WC = S.forwardRef(
  (t, e) => {
    const {
      __scopeNavigationMenu: n,
      value: i,
      onValueChange: r,
      defaultValue: a,
      delayDuration: o = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = t, [f, m] = S.useState(null), h = st(e, (D) => m(D)), p = Vd(c), g = S.useRef(0), y = S.useRef(0), v = S.useRef(0), [w, x] = S.useState(!0), [b = "", M] = Si({
      prop: i,
      onChange: (D) => {
        const W = D !== "", j = s > 0;
        W ? (window.clearTimeout(v.current), j && x(!1)) : (window.clearTimeout(v.current), v.current = window.setTimeout(
          () => x(!0),
          s
        )), r == null || r(D);
      },
      defaultProp: a
    }), _ = S.useCallback(() => {
      window.clearTimeout(y.current), y.current = window.setTimeout(() => M(""), 150);
    }, [M]), N = S.useCallback(
      (D) => {
        window.clearTimeout(y.current), M(D);
      },
      [M]
    ), $ = S.useCallback(
      (D) => {
        b === D ? window.clearTimeout(y.current) : g.current = window.setTimeout(() => {
          window.clearTimeout(y.current), M(D);
        }, o);
      },
      [b, M, o]
    );
    return S.useEffect(() => () => {
      window.clearTimeout(g.current), window.clearTimeout(y.current), window.clearTimeout(v.current);
    }, []), /* @__PURE__ */ d(
      LC,
      {
        scope: n,
        isRootMenu: !0,
        value: b,
        dir: p,
        orientation: l,
        rootNavigationMenu: f,
        onTriggerEnter: (D) => {
          window.clearTimeout(g.current), w ? $(D) : N(D);
        },
        onTriggerLeave: () => {
          window.clearTimeout(g.current), _();
        },
        onContentEnter: () => window.clearTimeout(y.current),
        onContentLeave: _,
        onItemSelect: (D) => {
          M((W) => W === D ? "" : D);
        },
        onItemDismiss: () => M(""),
        children: /* @__PURE__ */ d(
          qe.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: p,
            ...u,
            ref: h
          }
        )
      }
    );
  }
);
WC.displayName = Zs;
var AC = "NavigationMenuSub", cH = S.forwardRef(
  (t, e) => {
    const {
      __scopeNavigationMenu: n,
      value: i,
      onValueChange: r,
      defaultValue: a,
      orientation: o = "horizontal",
      ...s
    } = t, l = Ai(AC, n), [c = "", u] = Si({
      prop: i,
      onChange: r,
      defaultProp: a
    });
    return /* @__PURE__ */ d(
      LC,
      {
        scope: n,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: o,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (f) => u(f),
        onItemSelect: (f) => u(f),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ d(qe.div, { "data-orientation": o, ...s, ref: e })
      }
    );
  }
);
cH.displayName = AC;
var LC = (t) => {
  const {
    scope: e,
    isRootMenu: n,
    rootNavigationMenu: i,
    dir: r,
    orientation: a,
    children: o,
    value: s,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: f,
    onContentEnter: m,
    onContentLeave: h
  } = t, [p, g] = S.useState(null), [y, v] = S.useState(/* @__PURE__ */ new Map()), [w, x] = S.useState(null);
  return /* @__PURE__ */ d(
    sH,
    {
      scope: e,
      isRootMenu: n,
      rootNavigationMenu: i,
      value: s,
      previousValue: Fy(s),
      baseId: Ir(),
      dir: r,
      orientation: a,
      viewport: p,
      onViewportChange: g,
      indicatorTrack: w,
      onIndicatorTrackChange: x,
      onTriggerEnter: Wn(u),
      onTriggerLeave: Wn(f),
      onContentEnter: Wn(m),
      onContentLeave: Wn(h),
      onItemSelect: Wn(l),
      onItemDismiss: Wn(c),
      onViewportContentChange: S.useCallback((b, M) => {
        v((_) => (_.set(b, M), new Map(_)));
      }, []),
      onViewportContentRemove: S.useCallback((b) => {
        v((M) => M.has(b) ? (M.delete(b), new Map(M)) : M);
      }, []),
      children: /* @__PURE__ */ d(zv.Provider, { scope: e, children: /* @__PURE__ */ d(lH, { scope: e, items: y, children: o }) })
    }
  );
}, IC = "NavigationMenuList", RC = S.forwardRef(
  (t, e) => {
    const { __scopeNavigationMenu: n, ...i } = t, r = Ai(IC, n), a = /* @__PURE__ */ d(qe.ul, { "data-orientation": r.orientation, ...i, ref: e });
    return /* @__PURE__ */ d(qe.div, { style: { position: "relative" }, ref: r.onIndicatorTrackChange, children: /* @__PURE__ */ d(zv.Slot, { scope: n, children: r.isRootMenu ? /* @__PURE__ */ d(BC, { asChild: !0, children: a }) : a }) });
  }
);
RC.displayName = IC;
var jC = "NavigationMenuItem", [uH, FC] = Vv(jC), zC = S.forwardRef(
  (t, e) => {
    const { __scopeNavigationMenu: n, value: i, ...r } = t, a = Ir(), o = i || a || "LEGACY_REACT_AUTO_VALUE", s = S.useRef(null), l = S.useRef(null), c = S.useRef(null), u = S.useRef(() => {
    }), f = S.useRef(!1), m = S.useCallback((p = "start") => {
      if (s.current) {
        u.current();
        const g = sg(s.current);
        g.length && qv(p === "start" ? g : g.reverse());
      }
    }, []), h = S.useCallback(() => {
      if (s.current) {
        const p = sg(s.current);
        p.length && (u.current = xH(p));
      }
    }, []);
    return /* @__PURE__ */ d(
      uH,
      {
        scope: n,
        value: o,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: c,
        wasEscapeCloseRef: f,
        onEntryKeyDown: m,
        onFocusProxyEnter: m,
        onRootContentClose: h,
        onContentFocusOutside: h,
        children: /* @__PURE__ */ d(qe.li, { ...r, ref: e })
      }
    );
  }
);
zC.displayName = jC;
var og = "NavigationMenuTrigger", fH = S.forwardRef((t, e) => {
  const { __scopeNavigationMenu: n, disabled: i, ...r } = t, a = Ai(og, t.__scopeNavigationMenu), o = FC(og, t.__scopeNavigationMenu), s = S.useRef(null), l = st(s, o.triggerRef, e), c = GC(a.baseId, o.value), u = XC(a.baseId, o.value), f = S.useRef(!1), m = S.useRef(!1), h = o.value === a.value;
  return /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d(zv.ItemSlot, { scope: n, value: o.value, children: /* @__PURE__ */ d(qC, { asChild: !0, children: /* @__PURE__ */ d(
      qe.button,
      {
        id: c,
        disabled: i,
        "data-disabled": i ? "" : void 0,
        "data-state": Gv(h),
        "aria-expanded": h,
        "aria-controls": u,
        ...r,
        ref: l,
        onPointerEnter: ge(t.onPointerEnter, () => {
          m.current = !1, o.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: ge(
          t.onPointerMove,
          wf(() => {
            i || m.current || o.wasEscapeCloseRef.current || f.current || (a.onTriggerEnter(o.value), f.current = !0);
          })
        ),
        onPointerLeave: ge(
          t.onPointerLeave,
          wf(() => {
            i || (a.onTriggerLeave(), f.current = !1);
          })
        ),
        onClick: ge(t.onClick, () => {
          a.onItemSelect(o.value), m.current = h;
        }),
        onKeyDown: ge(t.onKeyDown, (p) => {
          const y = { horizontal: "ArrowDown", vertical: a.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[a.orientation];
          h && p.key === y && (o.onEntryKeyDown(), p.preventDefault());
        })
      }
    ) }) }),
    h && /* @__PURE__ */ k(Ee, { children: [
      /* @__PURE__ */ d(
        oD,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: o.focusProxyRef,
          onFocus: (p) => {
            const g = o.contentRef.current, y = p.relatedTarget, v = y === s.current, w = g == null ? void 0 : g.contains(y);
            (v || !w) && o.onFocusProxyEnter(v ? "start" : "end");
          }
        }
      ),
      a.viewport && /* @__PURE__ */ d("span", { "aria-owns": u })
    ] })
  ] });
});
fH.displayName = og;
var mH = "NavigationMenuLink", Jk = "navigationMenu.linkSelect", VC = S.forwardRef(
  (t, e) => {
    const { __scopeNavigationMenu: n, active: i, onSelect: r, ...a } = t;
    return /* @__PURE__ */ d(qC, { asChild: !0, children: /* @__PURE__ */ d(
      qe.a,
      {
        "data-active": i ? "" : void 0,
        "aria-current": i ? "page" : void 0,
        ...a,
        ref: e,
        onClick: ge(
          t.onClick,
          (o) => {
            const s = o.target, l = new CustomEvent(Jk, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(Jk, (c) => r == null ? void 0 : r(c), { once: !0 }), Mp(s, l), !l.defaultPrevented && !o.metaKey) {
              const c = new CustomEvent(xu, {
                bubbles: !0,
                cancelable: !0
              });
              Mp(s, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
VC.displayName = mH;
var Hv = "NavigationMenuIndicator", hH = S.forwardRef((t, e) => {
  const { forceMount: n, ...i } = t, r = Ai(Hv, t.__scopeNavigationMenu), a = !!r.value;
  return r.indicatorTrack ? Em.createPortal(
    /* @__PURE__ */ d(Ji, { present: n || a, children: /* @__PURE__ */ d(pH, { ...i, ref: e }) }),
    r.indicatorTrack
  ) : null;
});
hH.displayName = Hv;
var pH = S.forwardRef((t, e) => {
  const { __scopeNavigationMenu: n, ...i } = t, r = Ai(Hv, n), a = OC(n), [o, s] = S.useState(
    null
  ), [l, c] = S.useState(null), u = r.orientation === "horizontal", f = !!r.value;
  S.useEffect(() => {
    var g;
    const p = (g = a().find((y) => y.value === r.value)) == null ? void 0 : g.ref.current;
    p && s(p);
  }, [a, r.value]);
  const m = () => {
    o && c({
      size: u ? o.offsetWidth : o.offsetHeight,
      offset: u ? o.offsetLeft : o.offsetTop
    });
  };
  return lg(o, m), lg(r.indicatorTrack, m), l ? /* @__PURE__ */ d(
    qe.div,
    {
      "aria-hidden": !0,
      "data-state": f ? "visible" : "hidden",
      "data-orientation": r.orientation,
      ...i,
      ref: e,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...i.style
      }
    }
  ) : null;
}), Ms = "NavigationMenuContent", gH = S.forwardRef((t, e) => {
  const { forceMount: n, ...i } = t, r = Ai(Ms, t.__scopeNavigationMenu), a = FC(Ms, t.__scopeNavigationMenu), o = st(a.contentRef, e), s = a.value === r.value, l = {
    value: a.value,
    triggerRef: a.triggerRef,
    focusProxyRef: a.focusProxyRef,
    wasEscapeCloseRef: a.wasEscapeCloseRef,
    onContentFocusOutside: a.onContentFocusOutside,
    onRootContentClose: a.onRootContentClose,
    ...i
  };
  return r.viewport ? /* @__PURE__ */ d(yH, { forceMount: n, ...l, ref: o }) : /* @__PURE__ */ d(Ji, { present: n || s, children: /* @__PURE__ */ d(
    HC,
    {
      "data-state": Gv(s),
      ...l,
      ref: o,
      onPointerEnter: ge(t.onPointerEnter, r.onContentEnter),
      onPointerLeave: ge(
        t.onPointerLeave,
        wf(r.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && r.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
gH.displayName = Ms;
var yH = S.forwardRef((t, e) => {
  const n = Ai(Ms, t.__scopeNavigationMenu), { onViewportContentChange: i, onViewportContentRemove: r } = n;
  return xn(() => {
    i(t.value, {
      ref: e,
      ...t
    });
  }, [t, e, i]), xn(() => () => r(t.value), [t.value, r]), null;
}), xu = "navigationMenu.rootContentDismiss", HC = S.forwardRef((t, e) => {
  const {
    __scopeNavigationMenu: n,
    value: i,
    triggerRef: r,
    focusProxyRef: a,
    wasEscapeCloseRef: o,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...c
  } = t, u = Ai(Ms, n), f = S.useRef(null), m = st(f, e), h = GC(u.baseId, i), p = XC(u.baseId, i), g = OC(n), y = S.useRef(null), { onItemDismiss: v } = u;
  S.useEffect(() => {
    const x = f.current;
    if (u.isRootMenu && x) {
      const b = () => {
        var M;
        v(), s(), x.contains(document.activeElement) && ((M = r.current) == null || M.focus());
      };
      return x.addEventListener(xu, b), () => x.removeEventListener(xu, b);
    }
  }, [u.isRootMenu, t.value, r, v, s]);
  const w = S.useMemo(() => {
    const b = g().map((W) => W.value);
    u.dir === "rtl" && b.reverse();
    const M = b.indexOf(u.value), _ = b.indexOf(u.previousValue), N = i === u.value, $ = _ === b.indexOf(i);
    if (!N && !$) return y.current;
    const D = (() => {
      if (M !== _) {
        if (N && _ !== -1) return M > _ ? "from-end" : "from-start";
        if ($ && M !== -1) return M > _ ? "to-start" : "to-end";
      }
      return null;
    })();
    return y.current = D, D;
  }, [u.previousValue, u.value, u.dir, g, i]);
  return /* @__PURE__ */ d(BC, { asChild: !0, children: /* @__PURE__ */ d(
    Cy,
    {
      id: p,
      "aria-labelledby": h,
      "data-motion": w,
      "data-orientation": u.orientation,
      ...c,
      ref: m,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        var b;
        const x = new Event(xu, {
          bubbles: !0,
          cancelable: !0
        });
        (b = f.current) == null || b.dispatchEvent(x);
      },
      onFocusOutside: ge(t.onFocusOutside, (x) => {
        var M;
        l();
        const b = x.target;
        (M = u.rootNavigationMenu) != null && M.contains(b) && x.preventDefault();
      }),
      onPointerDownOutside: ge(t.onPointerDownOutside, (x) => {
        var N;
        const b = x.target, M = g().some(($) => {
          var D;
          return (D = $.ref.current) == null ? void 0 : D.contains(b);
        }), _ = u.isRootMenu && ((N = u.viewport) == null ? void 0 : N.contains(b));
        (M || _ || !u.isRootMenu) && x.preventDefault();
      }),
      onKeyDown: ge(t.onKeyDown, (x) => {
        var _;
        const b = x.altKey || x.ctrlKey || x.metaKey;
        if (x.key === "Tab" && !b) {
          const N = sg(x.currentTarget), $ = document.activeElement, D = N.findIndex((O) => O === $), j = x.shiftKey ? N.slice(0, D).reverse() : N.slice(D + 1, N.length);
          qv(j) ? x.preventDefault() : (_ = a.current) == null || _.focus();
        }
      }),
      onEscapeKeyDown: ge(t.onEscapeKeyDown, (x) => {
        o.current = !0;
      })
    }
  ) });
}), Bv = "NavigationMenuViewport", vH = S.forwardRef((t, e) => {
  const { forceMount: n, ...i } = t, a = !!Ai(Bv, t.__scopeNavigationMenu).value;
  return /* @__PURE__ */ d(Ji, { present: n || a, children: /* @__PURE__ */ d(bH, { ...i, ref: e }) });
});
vH.displayName = Bv;
var bH = S.forwardRef((t, e) => {
  const { __scopeNavigationMenu: n, children: i, ...r } = t, a = Ai(Bv, n), o = st(e, a.onViewportChange), s = dH(
    Ms,
    t.__scopeNavigationMenu
  ), [l, c] = S.useState(null), [u, f] = S.useState(null), m = l ? (l == null ? void 0 : l.width) + "px" : void 0, h = l ? (l == null ? void 0 : l.height) + "px" : void 0, p = !!a.value, g = p ? a.value : a.previousValue;
  return lg(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ d(
    qe.div,
    {
      "data-state": Gv(p),
      "data-orientation": a.orientation,
      ...r,
      ref: o,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !p && a.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": m,
        "--radix-navigation-menu-viewport-height": h,
        ...r.style
      },
      onPointerEnter: ge(t.onPointerEnter, a.onContentEnter),
      onPointerLeave: ge(t.onPointerLeave, wf(a.onContentLeave)),
      children: Array.from(s.items).map(([v, { ref: w, forceMount: x, ...b }]) => {
        const M = g === v;
        return /* @__PURE__ */ d(Ji, { present: x || M, children: /* @__PURE__ */ d(
          HC,
          {
            ...b,
            ref: Sy(w, (_) => {
              M && _ && f(_);
            })
          }
        ) }, v);
      })
    }
  );
}), wH = "FocusGroup", BC = S.forwardRef(
  (t, e) => {
    const { __scopeNavigationMenu: n, ...i } = t, r = Ai(wH, n);
    return /* @__PURE__ */ d(ag.Provider, { scope: n, children: /* @__PURE__ */ d(ag.Slot, { scope: n, children: /* @__PURE__ */ d(qe.div, { dir: r.dir, ...i, ref: e }) }) });
  }
), Qk = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], kH = "FocusGroupItem", qC = S.forwardRef(
  (t, e) => {
    const { __scopeNavigationMenu: n, ...i } = t, r = aH(n), a = Ai(kH, n);
    return /* @__PURE__ */ d(ag.ItemSlot, { scope: n, children: /* @__PURE__ */ d(
      qe.button,
      {
        ...i,
        ref: e,
        onKeyDown: ge(t.onKeyDown, (o) => {
          if (["Home", "End", ...Qk].includes(o.key)) {
            let l = r().map((f) => f.ref.current);
            if ([a.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(o.key) && l.reverse(), Qk.includes(o.key)) {
              const f = l.indexOf(o.currentTarget);
              l = l.slice(f + 1);
            }
            setTimeout(() => qv(l)), o.preventDefault();
          }
        })
      }
    ) });
  }
);
function sg(t) {
  const e = [], n = document.createTreeWalker(t, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (i) => {
      const r = i.tagName === "INPUT" && i.type === "hidden";
      return i.disabled || i.hidden || r ? NodeFilter.FILTER_SKIP : i.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; n.nextNode(); ) e.push(n.currentNode);
  return e;
}
function qv(t) {
  const e = document.activeElement;
  return t.some((n) => n === e ? !0 : (n.focus(), document.activeElement !== e));
}
function xH(t) {
  return t.forEach((e) => {
    e.dataset.tabindex = e.getAttribute("tabindex") || "", e.setAttribute("tabindex", "-1");
  }), () => {
    t.forEach((e) => {
      const n = e.dataset.tabindex;
      e.setAttribute("tabindex", n);
    });
  };
}
function lg(t, e) {
  const n = Wn(e);
  xn(() => {
    let i = 0;
    if (t) {
      const r = new ResizeObserver(() => {
        cancelAnimationFrame(i), i = window.requestAnimationFrame(n);
      });
      return r.observe(t), () => {
        window.cancelAnimationFrame(i), r.unobserve(t);
      };
    }
  }, [t, n]);
}
function Gv(t) {
  return t ? "open" : "closed";
}
function GC(t, e) {
  return `${t}-trigger-${e}`;
}
function XC(t, e) {
  return `${t}-content-${e}`;
}
function wf(t) {
  return (e) => e.pointerType === "mouse" ? t(e) : void 0;
}
var _H = WC, MH = RC, CH = zC, PH = VC;
function SH(t, e) {
  const { asChild: n, children: i } = t;
  if (!n)
    return typeof e == "function" ? e(i) : e;
  const r = S.Children.only(i);
  return S.cloneElement(r, {
    children: typeof e == "function" ? e(r.props.children) : e
  });
}
const NH = It({
  base: "relative flex items-center justify-start gap-1 overflow-x-auto whitespace-nowrap px-6 py-3 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden",
  variants: {
    secondary: {
      true: "bg-f1-foreground/[.02] dark:bg-f1-foreground/[.02]",
      false: "bg-f1-background-transparent pt-1"
    }
  },
  defaultVariants: {
    secondary: !1
  }
}), Xv = S.forwardRef(({ className: t, children: e, secondary: n, ...i }, r) => {
  const a = Wa();
  return /* @__PURE__ */ k(
    _H,
    {
      ref: r,
      ...i,
      asChild: !1,
      className: "relative",
      children: [
        /* @__PURE__ */ d("div", { className: "absolute inset-x-0 bottom-0 left-0 right-0 h-px bg-f1-border-secondary" }),
        /* @__PURE__ */ d(Wm, { id: a, children: /* @__PURE__ */ d(
          MH,
          {
            className: E(NH({ secondary: n }), t),
            children: e
          }
        ) })
      ]
    }
  );
});
Xv.displayName = "TabNavigation";
const $H = It({
  base: "flex items-center justify-center whitespace-nowrap rounded-md px-3 py-1.5 font-medium transition-all",
  variants: {
    secondary: {
      true: "group-hover:ring-f1-border group-data-[active=true]:bg-f1-background-inverse-secondary group-data-[active=true]:text-f1-foreground group-data-[active=true]:ring-f1-border",
      false: "bg-f1-background-transparent group-hover:bg-f1-background-tertiary group-hover:text-f1-foreground group-data-[active=true]:bg-f1-background-tertiary group-data-[active=true]:text-f1-foreground"
    },
    disabled: {
      true: "pointer-events-none text-f1-foreground-disabled"
    }
  },
  defaultVariants: {
    secondary: !1,
    disabled: !1
  }
}), DH = S.forwardRef(function({ asChild: e, disabled: n, active: i, className: r, children: a, secondary: o, ...s }, l) {
  return /* @__PURE__ */ d(CH, { className: "flex", children: /* @__PURE__ */ d(
    PH,
    {
      "data-active": i ? "true" : void 0,
      "aria-disabled": n || void 0,
      className: E(
        "group relative flex shrink-0 select-none items-center justify-center rounded-md no-underline focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-f1-ring focus-visible:ring-offset-1",
        n ? "pointer-events-none" : ""
      ),
      ref: l,
      onSelect: () => {
      },
      asChild: e,
      ...s,
      children: SH({ asChild: e, children: a }, (c) => /* @__PURE__ */ k(
        "span",
        {
          className: E(
            "text-f1-foreground-secondary ring-1 ring-inset ring-transparent",
            $H({ secondary: o, disabled: n }),
            r
          ),
          children: [
            c,
            i && !o && /* @__PURE__ */ d(
              re.div,
              {
                layoutId: "underline",
                className: "absolute inset-x-0 -bottom-3 h-px bg-f1-background-bold",
                transition: {
                  type: "spring",
                  bounce: 0.2,
                  duration: 0.5
                }
              }
            )
          ]
        }
      ))
    }
  ) });
}), EH = ({
  className: t
}) => /* @__PURE__ */ d("li", { className: "list-none", children: /* @__PURE__ */ d(
  Ce,
  {
    className: E(
      "mr-4 w-20 rounded-md py-1.5 ring-1 ring-inset ring-transparent",
      t
    ),
    children: " "
  }
) }), Ol = Bt(
  DH,
  EH
), TH = ({
  tabs: t,
  activeTabId: e,
  setActiveTabId: n,
  secondary: i = !1,
  embedded: r = !1
}) => {
  const a = t[0], [o, s] = q(
    e ?? ("id" in a ? a.id : void 0)
  );
  le(() => {
    o && (n == null || n(o));
  }, [n, o]);
  const { isActive: l } = $m(), c = r ? [t[0]] : t, f = [...c].sort(
    (m, h) => m.index ? 1 : h.index ? -1 : 0
  ).find(
    (m) => "href" in m ? l(m.href) : o === m.id
  );
  return /* @__PURE__ */ d(
    Xv,
    {
      secondary: i,
      asChild: !0,
      "aria-label": i ? "primary-navigation" : "secondary-navigation",
      children: c.length === 1 ? /* @__PURE__ */ d("li", { className: "flex h-8 items-center justify-center whitespace-nowrap text-lg font-medium text-f1-foreground", children: c[0].label }) : c.map(({ label: m, ...h }, p) => {
        const g = f && "href" in f && "href" in h ? f.href === h.href : "id" in h && o === h.id;
        return /* @__PURE__ */ d(
          Ol,
          {
            active: g,
            href: "href" in h ? h.href : void 0,
            onClick: () => {
              "id" in h && (s == null || s(h.id));
            },
            secondary: i,
            asChild: !0,
            children: /* @__PURE__ */ k(_n, { role: "link", ...h, children: [
              h.variant === "upsell" && /* @__PURE__ */ d(
                me,
                {
                  icon: sD,
                  size: "md",
                  className: "mr-1 text-[hsl(var(--promote-50))]"
                }
              ),
              m
            ] })
          },
          p
        );
      })
    }
  );
}, OH = ({
  secondary: t
}) => /* @__PURE__ */ k(
  Xv,
  {
    "aria-label": t ? "Secondary empty nav" : "Main empty nav",
    secondary: t,
    "aria-busy": "true",
    "aria-live": "polite",
    children: [
      /* @__PURE__ */ d(Ol.Skeleton, { className: "w-24" }),
      /* @__PURE__ */ d(Ol.Skeleton, { className: "w-20" }),
      /* @__PURE__ */ d(Ol.Skeleton, { className: "w-28" }),
      /* @__PURE__ */ d(Ol.Skeleton, { className: "w-20" })
    ]
  }
), WH = Bt(TH, OH), AH = ({
  tabs: t,
  activeTabId: e,
  setActiveTabId: n,
  withPadding: i = !1,
  children: r
}) => {
  const { position: a } = EC(), o = TC();
  return /* @__PURE__ */ k(Ee, { children: [
    t && /* @__PURE__ */ d("div", { className: "-mx-2", children: /* @__PURE__ */ d(
      WH,
      {
        tabs: t,
        activeTabId: e,
        setActiveTabId: n
      }
    ) }),
    /* @__PURE__ */ k(
      No,
      {
        className: E(
          "[*[data-state=visible]_div]:bg-f1-background flex flex-1 flex-col",
          "[&_.resource-header]:p-0 [&_.resource-header]:pr-1",
          i && "px-5 py-3",
          !o && a === "center" && "max-h-[512px]"
        ),
        children: [
          r,
          /* @__PURE__ */ d(
            $y,
            {
              orientation: "vertical",
              className: "[&_div]:bg-f1-background"
            }
          )
        ]
      }
    )
  ] });
}, LH = ({ children: t }) => /* @__PURE__ */ d("div", { className: "flex min-h-18 flex-row items-center justify-between border-x-0 border-b-0 border-t border-solid border-f1-border-secondary bg-f1-background p-5", children: t }), dg = X(({ ...t }, e) => /* @__PURE__ */ d("nav", { ref: e, "aria-label": "breadcrumb", ...t }));
dg.displayName = "Breadcrumb";
const Yv = X(({ className: t, children: e, ...n }, i) => {
  const r = Wa();
  return /* @__PURE__ */ d(
    "ol",
    {
      ref: i,
      className: E(
        "flex h-8 list-none flex-nowrap items-center text-f1-foreground-secondary",
        t
      ),
      ...n,
      children: /* @__PURE__ */ d(Wm, { id: r, children: /* @__PURE__ */ d(Ue, { initial: !1, children: e }) })
    }
  );
});
Yv.displayName = "BreadcrumbList";
const Kv = ({ className: t, ...e }) => /* @__PURE__ */ d(
  "li",
  {
    className: E("inline-flex items-center gap-0.5 pr-1", t),
    ...e
  }
);
Kv.displayName = "BreadcrumbItem";
const YC = X(({ asChild: t, className: e, ...n }, i) => /* @__PURE__ */ d(
  t ? Ny : _n,
  {
    ref: i,
    className: E(
      "rounded-sm px-1.5 py-0.5 font-medium text-f1-foreground no-underline transition-colors hover:bg-f1-background-secondary",
      e
    ),
    ...n
  }
));
YC.displayName = "BreadcrumbLink";
const KC = X(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "span",
  {
    ref: n,
    role: "link",
    "aria-disabled": "true",
    "aria-current": "page",
    className: E("truncate px-1.5 py-0.5 text-f1-foreground", t),
    ...e
  }
));
KC.displayName = "BreadcrumbPage";
const Uv = X((t, e) => /* @__PURE__ */ d(
  "span",
  {
    ref: e,
    role: "presentation",
    "aria-hidden": "true",
    className: "h-4 w-4 text-f1-icon-secondary",
    ...t,
    children: /* @__PURE__ */ d(Oa, {})
  }
));
Uv.displayName = "BreadcrumbSeparator";
const UC = X(({ className: t, items: e }, n) => /* @__PURE__ */ d(Kv, { ref: n, className: t, children: /* @__PURE__ */ k("div", { className: "flex items-center", children: [
  /* @__PURE__ */ d(Uv, {}),
  /* @__PURE__ */ d(lc, { items: e, children: /* @__PURE__ */ d("button", { className: "rounded-sm px-1.5 py-0.5 font-medium text-f1-foreground no-underline transition-colors hover:bg-f1-background-secondary", children: "..." }) })
] }) }));
UC.displayName = "CollapsedBreadcrumbItem";
const Jv = 50, IH = 120, kf = 8;
function RH(t, e) {
  const n = e.length;
  if (n <= 2) return n;
  const i = e[0];
  let r = t - i - kf, a = 0, o = 1;
  for (let s = n - 1; s > 0; s--) {
    const l = e[s];
    if (r < l)
      break;
    r -= l, a = s, o++;
  }
  if (o < n)
    for (r -= Jv; r < 0 && o > 1; )
      r += e[a], a++, o--;
  return Math.max(2, o);
}
function Zk(t = []) {
  switch (t.length) {
    case 0:
      return;
    case 1:
      return t[0] + kf;
    default:
      return t[0] + Jv + t[t.length - 1] + kf;
  }
}
function jH(t, e) {
  return IH * t + (e ? Jv : 0) + kf;
}
function FH(t, e, n = []) {
  if (!t) {
    const o = Math.min(e.length, 2);
    return {
      visibleCount: o,
      headItem: e[0] ?? null,
      tailItems: e.slice(e.length - 1),
      collapsedItems: e.slice(1, e.length - 1),
      isOnly: e.length === 1,
      minWidth: jH(
        o,
        e.length > 2
      )
    };
  }
  const i = e.length <= 2, r = n.map((o) => o.clientWidth);
  if (i)
    return {
      visibleCount: e.length,
      headItem: e[0] ?? null,
      tailItems: e.slice(1),
      collapsedItems: [],
      isOnly: e.length === 1,
      minWidth: Zk(r)
    };
  const a = RH(t, r);
  return {
    visibleCount: a,
    headItem: e[0] || null,
    tailItems: e.slice(
      Math.max(1, e.length - (a - 1))
    ),
    collapsedItems: e.slice(
      1,
      e.length - (a - 1)
    ),
    isOnly: e.length === 1,
    minWidth: Zk(r)
  };
}
function zH({ breadcrumbs: t, append: e }) {
  var l;
  const n = Oe(null), i = Oe(null), [, r] = $D(), [a, o] = q(null), s = ((a == null ? void 0 : a.collapsedItems) || []).length > 0;
  return Zd(() => {
    const c = n.current, u = i.current;
    if (!c || !u || u.children.length < t.length) return;
    const f = () => {
      var g;
      const h = ((g = n.current) == null ? void 0 : g.clientWidth) ?? null, p = Array.from(u.children);
      r(() => {
        const y = FH(
          h,
          t,
          p
        );
        o(y);
      });
    }, m = new ResizeObserver(f);
    return m.observe(c), f(), () => m.disconnect();
  }, [t, e]), !t.length || a && !a.headItem ? /* @__PURE__ */ d(dg, { ref: n, className: "w-full" }) : /* @__PURE__ */ k(
    dg,
    {
      ref: n,
      className: "w-full overflow-x-hidden",
      style: {
        minWidth: a == null ? void 0 : a.minWidth
      },
      children: [
        /* @__PURE__ */ d(
          "ol",
          {
            className: "invisible absolute -left-full",
            "aria-hidden": "true",
            ref: i,
            children: t.map((c, u) => /* @__PURE__ */ d(
              as,
              {
                item: c,
                isLast: u === t.length - 1,
                isFirst: u === 0,
                children: u === t.length - 1 ? e : void 0
              },
              c.id
            ))
          }
        ),
        a && a.headItem && /* @__PURE__ */ k(Yv, { children: [
          /* @__PURE__ */ d(
            as,
            {
              isOnly: a.isOnly,
              isFirst: !0,
              item: a.headItem,
              isLast: !1
            },
            `first-item-${a.headItem.id}`
          ),
          s && /* @__PURE__ */ k(Ee, { children: [
            /* @__PURE__ */ d(
              UC,
              {
                items: a.collapsedItems
              },
              "collapsed-items"
            ),
            a.tailItems.map((c, u) => /* @__PURE__ */ d(
              as,
              {
                item: c,
                isLast: u === a.tailItems.length - 1,
                isFirst: !1,
                children: u === a.tailItems.length - 1 ? e : void 0
              },
              c.id
            ))
          ] }),
          !s && /* @__PURE__ */ d(Ee, { children: a.tailItems.map((c, u) => /* @__PURE__ */ d(
            as,
            {
              item: c,
              isLast: u === a.tailItems.length - 1,
              isFirst: !1,
              children: u === a.tailItems.length - 1 ? e : void 0
            },
            c.id
          )) })
        ] })
      ]
    },
    `breadcrumb-${((l = t.at(-1)) == null ? void 0 : l.id) ?? 0}`
  );
}
function VH({
  options: t,
  defaultItem: e,
  ...n
}) {
  const [i, r] = q(!1), [a, o] = q([]), [s, l] = q(
    n.value || (e == null ? void 0 : e.value)
  ), [c, u] = q(!0), [f, m] = q(n.open), h = ve(() => a.find((b) => b.value === s), [a, s]), p = (b) => {
    var M;
    l(b), (M = n.onChange) == null || M.call(n, b);
  }, [g, y] = q(n.searchValue), v = async (b) => {
    var M;
    y(b), (M = n.onSearchChange) == null || M.call(n, b);
  };
  le(() => {
    (async (M) => {
      typeof t == "function" ? (r(!0), o(await t(M)), r(!1)) : o(t), u(!1);
    })(g);
  }, [t, g]);
  const w = (b) => {
    var M;
    m(b), (M = n.onOpenChange) == null || M.call(n, b);
  }, x = ve(() => (h == null ? void 0 : h.label) || (e == null ? void 0 : e.label) || n.placeholder || "Select", [h, e, n.placeholder]);
  return i && c ? /* @__PURE__ */ d(Ce, { className: "h-5 w-full", "data-testid": "skeleton" }) : /* @__PURE__ */ d(
    Ca,
    {
      ...n,
      options: a,
      onChange: p,
      onSearchChange: v,
      value: s,
      searchValue: g,
      onOpenChange: w,
      children: /* @__PURE__ */ k(
        "button",
        {
          className: "flex h-6 items-center justify-between rounded-sm border px-1.5 py-0.5 font-medium text-f1-foreground no-underline transition-colors hover:bg-f1-background-secondary",
          role: "combobox",
          "aria-label": x,
          children: [
            /* @__PURE__ */ d("span", { className: "block grow text-f1-foreground", children: x }),
            /* @__PURE__ */ d("div", { className: "ml-2", children: /* @__PURE__ */ d(
              re.div,
              {
                animate: { rotate: f ? 180 : 0 },
                className: "h-[16px] w-[16px]",
                children: /* @__PURE__ */ d(
                  me,
                  {
                    icon: zn,
                    size: "sm",
                    className: "rounded-2xs bg-f1-background-secondary p-0.5"
                  }
                )
              }
            ) })
          ]
        }
      )
    }
  );
}
const e2 = "one_sidebar_locked", JC = hn(void 0);
function vc() {
  const t = Wt(JC);
  return t === void 0 ? {
    isSmallScreen: !1,
    prevSidebarState: null,
    sidebarState: "locked",
    toggleSidebar: () => {
    }
  } : t;
}
function HH({ children: t }) {
  const { currentPath: e } = $m(), n = o5("(max-width: 900px)", {
    initializeWithValue: !0
  }), [i, r] = q(() => {
    const m = localStorage.getItem(e2);
    return m !== null ? !!m : !0;
  }), [a, o] = q(!1), [s, l] = q(
    null
  ), c = Le(() => {
    n && o(!a), r(!i);
  }, [n, a, i, r, o]), u = Le(
    (m) => {
      n || (m.clientX < 32 && o(!0), m.clientX > 280 && o(!1));
    },
    [n, o]
  ), f = ve(() => n ? a ? "unlocked" : "hidden" : !i && !a ? "hidden" : !i && a ? "unlocked" : "locked", [n, a, i]);
  return le(() => {
    o(!1);
  }, [e]), le(() => {
    localStorage.setItem(e2, i ? "1" : "");
  }, [i]), le(() => () => {
    l(f);
  }, [f]), /* @__PURE__ */ d(
    JC.Provider,
    {
      value: {
        isSmallScreen: n,
        sidebarState: f,
        toggleSidebar: c,
        prevSidebarState: s
      },
      children: /* @__PURE__ */ d("div", { onPointerMove: u, className: "h-screen w-screen", children: t })
    }
  );
}
const t2 = re.create(me), n2 = {
  initial: { scale: 1 },
  animate: { scale: 1 },
  exit: { scale: 0.5 },
  // Transition variants
  enterFromUnfavorite: { scale: 0.5 },
  enterFromFavorite: { scale: 0.8 }
}, BH = ({
  isMarked: t,
  onChange: e,
  label: n
}) => {
  const [i, r] = q(!1), a = () => {
    r(!0), e(!t);
  };
  return /* @__PURE__ */ d(Ue, { mode: "wait", children: /* @__PURE__ */ d(
    "button",
    {
      className: E(
        "flex h-6 w-6 items-center justify-center rounded",
        Ke()
      ),
      onClick: a,
      "aria-label": n,
      children: t ? /* @__PURE__ */ d(
        t2,
        {
          size: "sm",
          icon: vT,
          className: "text-[hsl(var(--promote-50))] outline-none",
          variants: n2,
          initial: i ? "enterFromUnfavorite" : "initial",
          animate: "animate",
          exit: "exit",
          transition: {
            ease: [0.175, 0.885, 0.27, 2]
          },
          "aria-hidden": "true",
          focusable: !1,
          tabIndex: -1
        },
        "favorite"
      ) : /* @__PURE__ */ d(
        t2,
        {
          size: "sm",
          whileTap: { scale: 0.8 },
          icon: gT,
          className: "outline-none",
          variants: n2,
          initial: i ? "enterFromFavorite" : "initial",
          "aria-hidden": "true",
          focusable: !1,
          tabIndex: -1,
          animate: "animate",
          exit: "exit",
          transition: {
            ease: [0, 0, 0.58, 1]
          }
        },
        "not-favorite"
      )
    }
  ) });
}, qH = ({
  currentModule: t,
  label: e,
  getUpdates: n,
  updatesPageUrl: i,
  emptyScreen: r,
  errorScreen: a,
  onOpenChange: o = () => {
  },
  onHeaderClick: s = () => {
  },
  onItemClick: l = () => {
  },
  hasUnread: c = !1,
  crossSelling: u
}) => {
  const [f, m] = q("idle"), [h, p] = q(null), [g, ...y] = h ?? [], [v, w] = q(!1);
  le(() => {
    p(null), m("idle");
  }, [t]);
  const x = Le(async () => {
    try {
      m("fetching");
      const b = await n();
      m("idle"), p(b);
    } catch {
      m("error");
    }
  }, [n]);
  return /* @__PURE__ */ k(
    q_,
    {
      open: v,
      onOpenChange: async (b) => {
        w(b), b && h === null && x(), o(b);
      },
      children: [
        /* @__PURE__ */ d(G_, { asChild: !0, children: /* @__PURE__ */ d(
          so,
          {
            variant: "outline",
            icon: $5,
            hideLabel: !0,
            round: !0,
            label: e,
            append: c && /* @__PURE__ */ d(Qv, { className: "absolute -right-0.5 -top-[1px]" })
          }
        ) }),
        /* @__PURE__ */ d(oL, { children: /* @__PURE__ */ k(
          av,
          {
            sideOffset: 8,
            collisionPadding: 20,
            align: "end",
            hideWhenDetached: !0,
            className: "min-h-auto flex max-h-[90vh] min-w-96 max-w-md flex-col",
            style: { maxHeight: "min(90vh, 760px)" },
            children: [
              /* @__PURE__ */ d(YH, { title: e, url: i, onClick: s }),
              f === "fetching" && /* @__PURE__ */ d(JH, {}),
              /* @__PURE__ */ k("div", { className: "scrollbar-macos flex-1 overflow-y-auto", children: [
                f === "idle" && h !== null && h.length === 0 && /* @__PURE__ */ d("div", { className: "p-2 pt-0", children: /* @__PURE__ */ d(KH, { ...r, buttonUrl: i }) }),
                f === "idle" && h !== null && h.length > 0 && /* @__PURE__ */ k("div", { className: "px-1", children: [
                  /* @__PURE__ */ d(
                    GH,
                    {
                      ...g,
                      onClick: l
                    }
                  ),
                  h.length > 1 && /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ d("div", { className: "pb-1", children: y.map((b, M) => /* @__PURE__ */ d(
                    XH,
                    {
                      ...b,
                      onClick: l
                    },
                    M
                  )) }) })
                ] }),
                f === "error" && /* @__PURE__ */ d("div", { className: "p-2 pt-0", children: /* @__PURE__ */ d(
                  UH,
                  {
                    ...a,
                    onClick: () => {
                      x();
                    }
                  }
                ) })
              ] }),
              f === "idle" && u && u.isVisible && /* @__PURE__ */ d(
                QH,
                {
                  isVisible: u.isVisible,
                  onClose: u.onClose,
                  crossSelling: u,
                  onDropdownClose: () => w(!1)
                }
              )
            ]
          }
        ) })
      ]
    }
  );
}, GH = ({
  title: t,
  href: e,
  mediaUrl: n,
  unread: i,
  updated: r,
  onClick: a
}) => {
  const o = "flex flex-col items-stretch w-full", s = n == null ? void 0 : n.includes(".mp4");
  return /* @__PURE__ */ d(
    rv,
    {
      onClick: a,
      asChild: !0,
      className: "relative flex cursor-default select-none items-center rounded-md px-1 text-base font-medium outline-none transition-colors after:absolute after:inset-x-1 after:inset-y-0 after:h-full after:rounded after:bg-f1-background-hover after:opacity-0 after:transition-opacity after:duration-75 after:content-[''] hover:cursor-pointer hover:after:opacity-100 focus:after:opacity-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      children: /* @__PURE__ */ k(
        _n,
        {
          href: e,
          target: "_blank",
          referrerPolicy: "no-referrer",
          rel: "noopener noreferrer",
          className: E(o, "text-f1-foreground no-underline"),
          children: [
            /* @__PURE__ */ d("div", { className: "px-1 pt-1", children: s ? /* @__PURE__ */ d("div", { className: "overflow-clip rounded border border-solid border-f1-border-secondary", children: /* @__PURE__ */ d(
              "video",
              {
                src: n,
                className: "block aspect-video w-full bg-f1-background-secondary object-contain object-center",
                autoPlay: !0,
                muted: !0,
                loop: !0,
                playsInline: !0
              }
            ) }) : /* @__PURE__ */ d("div", { className: "overflow-clip rounded border border-solid border-f1-border-secondary", children: /* @__PURE__ */ d(
              Z4,
              {
                fetchPriority: "high",
                src: n,
                className: "block aspect-video w-full bg-f1-background-secondary object-contain object-center"
              }
            ) }) }),
            /* @__PURE__ */ d("div", { className: "py-2 pl-2 pr-4", children: /* @__PURE__ */ k("div", { className: "flex items-start gap-4", children: [
              /* @__PURE__ */ k("div", { className: "flex-1 *:text-base", children: [
                /* @__PURE__ */ d("h3", { className: "font-medium", children: t }),
                /* @__PURE__ */ d("p", { className: "font-normal text-f1-foreground-secondary", children: r })
              ] }),
              i && /* @__PURE__ */ d(Qv, { className: "mt-1.5" })
            ] }) })
          ]
        }
      )
    }
  );
}, XH = ({
  title: t,
  href: e,
  updated: n,
  unread: i = !1,
  onClick: r
}) => {
  const a = E("flex flex-col items-stretch gap-3 w-full");
  return /* @__PURE__ */ d(ov, { asChild: !0, className: a, onClick: r, children: /* @__PURE__ */ d(
    _n,
    {
      href: e,
      target: "_blank",
      referrerPolicy: "no-referrer",
      rel: "noopener noreferrer",
      className: E(
        a,
        "text-f1-foreground no-underline hover:cursor-pointer"
      ),
      children: /* @__PURE__ */ k("div", { className: "flex items-start gap-4", children: [
        /* @__PURE__ */ k("div", { className: "flex-1 *:text-base", children: [
          /* @__PURE__ */ d("h3", { className: "text-pretty font-medium", children: t }),
          /* @__PURE__ */ d("p", { className: "font-normal text-f1-foreground-secondary", children: n })
        ] }),
        i && /* @__PURE__ */ d(Qv, { className: "mt-1.5" })
      ] })
    }
  ) });
}, YH = ({
  title: t,
  url: e,
  onClick: n
}) => /* @__PURE__ */ k(
  "a",
  {
    href: e,
    className: "flex items-center justify-between gap-4 px-4 pb-2 pt-3 text-f1-foreground no-underline visited:text-f1-foreground hover:text-f1-foreground",
    children: [
      /* @__PURE__ */ d("h2", { className: "text-base font-medium", children: t }),
      /* @__PURE__ */ d(
        ue,
        {
          variant: "outline",
          round: !0,
          size: "sm",
          icon: Oa,
          label: t,
          hideLabel: !0,
          onClick: n
        }
      )
    ]
  }
), QC = ({
  icon: t,
  button: e,
  title: n,
  description: i,
  iconWrapperClassName: r
}) => /* @__PURE__ */ d("div", { className: "w-[420px] rounded border border-solid border-f1-border-secondary bg-[hsl(var(--neutral-2))] p-12", children: /* @__PURE__ */ k("div", { className: "flex flex-col items-center gap-4", children: [
  /* @__PURE__ */ d(
    "div",
    {
      className: E(
        "grid size-14 place-items-center overflow-clip rounded border border-solid border-f1-border-secondary bg-f1-background-tertiary *:block",
        r
      ),
      children: t
    }
  ),
  /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-1 text-center *:text-base", children: [
    /* @__PURE__ */ d("h3", { className: "text-pretty font-medium", children: n }),
    /* @__PURE__ */ d("p", { className: "font-normal text-f1-foreground-secondary", children: i })
  ] }),
  e
] }) }), KH = ({
  title: t,
  buttonText: e,
  buttonUrl: n,
  description: i
}) => /* @__PURE__ */ d(
  QC,
  {
    title: t,
    description: i,
    icon: /* @__PURE__ */ d(me, { icon: $5, size: "lg", className: "block" }),
    button: /* @__PURE__ */ d(_n, { href: n, children: /* @__PURE__ */ d(ue, { label: e }) })
  }
), UH = ({
  title: t,
  description: e,
  buttonText: n,
  onClick: i
}) => /* @__PURE__ */ d(
  QC,
  {
    title: t,
    description: e,
    iconWrapperClassName: "text-f1-icon-critical bg-f1-background-critical border-f1-critical",
    icon: /* @__PURE__ */ d(me, { icon: Dy, size: "lg" }),
    button: /* @__PURE__ */ d(ue, { variant: "outline", label: n, onClick: i })
  }
), JH = () => /* @__PURE__ */ d(
  "div",
  {
    className: "flex flex-col",
    role: "status",
    "aria-busy": "true",
    "aria-live": "polite",
    children: /* @__PURE__ */ k("div", { className: "p-2", children: [
      /* @__PURE__ */ d(Ce, { className: "h-56 w-full rounded" }),
      /* @__PURE__ */ d("div", { className: "flex basis-1/3 flex-row justify-between gap-2 p-3", children: /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-2 py-1", children: [
        /* @__PURE__ */ d(Ce, { className: "h-3 w-2/3" }),
        /* @__PURE__ */ d(Ce, { className: "h-3 w-1/3" })
      ] }) }),
      /* @__PURE__ */ d("div", { className: "flex basis-1/3 flex-row justify-between gap-2 p-3", children: /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-2 py-1", children: [
        /* @__PURE__ */ d(Ce, { className: "h-3 w-2/3" }),
        /* @__PURE__ */ d(Ce, { className: "h-3 w-1/3" })
      ] }) })
    ] })
  }
), Qv = ({ className: t = "" }) => /* @__PURE__ */ d(
  "div",
  {
    "aria-hidden": "true",
    className: E("size-2 rounded bg-f1-background-selected-bold", t)
  }
), QH = ({
  isVisible: t,
  onClose: e,
  crossSelling: n,
  onDropdownClose: i
}) => {
  const [r, a] = q(t);
  le(() => {
    a(t);
  }, [t]);
  const o = () => {
    a(!1), e && e();
  }, s = (l) => {
    a(!1), i(), l && l();
  };
  return r && /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d(sv, {}),
    /* @__PURE__ */ k("div", { className: "px-1 pb-2", children: [
      /* @__PURE__ */ k("div", { className: "flex flex-row items-center justify-between px-3", children: [
        /* @__PURE__ */ d("p", { className: "text-balance pb-2 pt-2 text-sm font-medium text-f1-foreground-secondary", children: n == null ? void 0 : n.sectionTitle }),
        /* @__PURE__ */ d("div", { className: "relative z-10 h-6 w-6", children: /* @__PURE__ */ d(
          ue,
          {
            variant: "ghost",
            icon: Rr,
            size: "sm",
            hideLabel: !0,
            onClick: o,
            label: "Close"
          }
        ) })
      ] }),
      /* @__PURE__ */ d(
        lD,
        {
          columns: {
            default: 1
          },
          showDots: !0,
          showArrows: !1,
          children: n == null ? void 0 : n.products.map((l) => /* @__PURE__ */ d(
            dD,
            {
              ...l,
              isVisible: !0,
              trackVisibility: l.trackVisibility,
              onClick: () => s(l.onClick)
            },
            l.title
          ))
        }
      )
    ] })
  ] });
};
function i2({
  icon: t,
  href: e,
  label: n,
  disabled: i
}) {
  const r = Oe(null);
  return /* @__PURE__ */ d(
    _n,
    {
      href: e,
      title: n,
      "aria-label": n,
      disabled: i,
      ref: r,
      children: /* @__PURE__ */ d(
        ue,
        {
          size: "sm",
          variant: "outline",
          round: !0,
          label: n,
          icon: t,
          hideLabel: !0,
          disabled: i,
          onClick: (a) => {
            var o;
            a.preventDefault(), !i && ((o = r.current) == null || o.click());
          }
        }
      )
    }
  );
}
function MYe({
  module: t,
  statusTag: e = void 0,
  breadcrumbs: n = [],
  actions: i = [],
  embedded: r = !1,
  navigation: a,
  productUpdates: o,
  favorites: s
}) {
  var v, w, x, b;
  const { sidebarState: l, toggleSidebar: c } = vc(), u = [
    {
      id: t.href,
      label: t.name,
      href: t.href,
      icon: t.icon
    },
    ...n
  ], f = e && Object.keys(e).length !== 0, m = n.length > 0, h = !r && i.length > 0, p = !r && !!(o != null && o.isVisible), g = u[u.length - 1], y = m ? u[u.length - 2] : null;
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex items-center justify-between px-5 py-4 xs:px-6",
        r ? "h-12" : "h-16"
      ),
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-grow items-center", children: [
          /* @__PURE__ */ d(Ue, { children: !r && l !== "locked" && /* @__PURE__ */ d(
            re.div,
            {
              initial: { opacity: 0, width: 0 },
              animate: { opacity: 1, width: "auto" },
              exit: { opacity: 0, width: 0 },
              children: /* @__PURE__ */ d("div", { className: "mr-3", children: /* @__PURE__ */ d(
                ue,
                {
                  ref: (M) => {
                    M == null || M.focus();
                  },
                  variant: "ghost",
                  hideLabel: !0,
                  round: !0,
                  onClick: c,
                  label: "Open main menu",
                  icon: D5
                }
              ) })
            }
          ) }),
          /* @__PURE__ */ k(
            "div",
            {
              className: E(
                "flex flex-grow items-center gap-2",
                r && m && "justify-center"
              ),
              children: [
                r && m && y && !("loading" in y) && /* @__PURE__ */ d("div", { className: "absolute left-4", children: /* @__PURE__ */ d(_n, { href: y.href, children: /* @__PURE__ */ d(
                  ue,
                  {
                    variant: "ghost",
                    hideLabel: !0,
                    round: !0,
                    label: "Back",
                    icon: qd,
                    onClick: (M) => M.preventDefault()
                  }
                ) }) }),
                r && m ? /* @__PURE__ */ d("div", { className: "text-lg font-semibold text-f1-foreground", children: "loading" in g ? /* @__PURE__ */ d(Ce, { className: "h-4 w-24" }) : g.label }) : /* @__PURE__ */ d(
                  zH,
                  {
                    breadcrumbs: u,
                    append: s !== void 0 && /* @__PURE__ */ d(
                      BH,
                      {
                        label: s.label,
                        isMarked: s.isMarked,
                        onChange: s == null ? void 0 : s.onChange
                      }
                    )
                  },
                  u[0].id
                )
              ]
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "flex items-center gap-3", children: [
          !r && f && /* @__PURE__ */ d("div", { children: e.tooltip ? /* @__PURE__ */ d(Kt, { label: e.tooltip, children: /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
            Vr,
            {
              text: e.text,
              variant: e.variant,
              additionalAccesibleText: e.tooltip
            }
          ) }) }) : /* @__PURE__ */ d(Vr, { text: e.text, variant: e.variant }) }),
          !r && f && (a || h || p) && /* @__PURE__ */ d("div", { className: "h-4 w-px bg-f1-border-secondary" }),
          a && /* @__PURE__ */ k("div", { className: "flex items-center gap-3", children: [
            a.counter && /* @__PURE__ */ k("span", { className: "text-sm text-f1-foreground-secondary", children: [
              a.counter.current,
              "/",
              a.counter.total
            ] }),
            /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
              /* @__PURE__ */ d(
                i2,
                {
                  icon: qs,
                  label: ((v = a.previous) == null ? void 0 : v.title) || "Previous",
                  href: ((w = a.previous) == null ? void 0 : w.url) || "",
                  disabled: !a.previous
                }
              ),
              /* @__PURE__ */ d(
                i2,
                {
                  icon: zn,
                  label: ((x = a.next) == null ? void 0 : x.title) || "Next",
                  href: ((b = a.next) == null ? void 0 : b.url) || "",
                  disabled: !a.next
                }
              )
            ] })
          ] }),
          a && h && /* @__PURE__ */ d("div", { className: "h-4 w-px bg-f1-border-secondary" }),
          p && /* @__PURE__ */ d("div", { className: "items-right flex gap-2", children: /* @__PURE__ */ d(qH, { ...o, currentModule: t.name }) }),
          h && /* @__PURE__ */ d("div", { className: "items-right flex gap-2", children: i.map((M, _) => /* @__PURE__ */ d(ZH, { action: M }, _)) })
        ] })
      ]
    }
  );
}
function ZH({ action: t }) {
  const e = Oe(null);
  return "actions" in t ? /* @__PURE__ */ d(In, { items: t.actions, children: /* @__PURE__ */ d(
    ue,
    {
      size: "md",
      variant: "outline",
      label: t.label,
      icon: t.icon,
      hideLabel: !0
    }
  ) }) : /* @__PURE__ */ d(
    _n,
    {
      href: t.href,
      title: t.label,
      "aria-label": t.label,
      ref: e,
      children: /* @__PURE__ */ d(
        ue,
        {
          size: "md",
          variant: "outline",
          label: t.label,
          icon: t.icon,
          hideLabel: !0,
          onClick: (n) => {
            var i;
            n.preventDefault(), (i = e.current) == null || i.click();
          }
        }
      )
    }
  );
}
const ZC = X((t, e) => /* @__PURE__ */ d("div", { ref: e, className: "px-1.5", ...t, children: /* @__PURE__ */ d(Ce, { className: "h-4 w-24", "aria-hidden": "true" }) }));
ZC.displayName = "BreadcrumbSkeleton";
const as = X(({ item: t, isLast: e, isOnly: n = !1, isFirst: i = !1, children: r }, a) => /* @__PURE__ */ k(Kv, { ref: a, children: [
  !i && /* @__PURE__ */ d(Uv, {}),
  /* @__PURE__ */ d(
    eP,
    {
      item: t,
      isLast: e,
      isOnly: n,
      isFirst: i
    }
  ),
  r
] }, t.id));
as.displayName = "BreadcrumbItem";
const eP = X(
  ({ item: t, isLast: e, isOnly: n = !1, isFirst: i = !1 }, r) => {
    const a = "loading" in t && t.loading, o = a ? "loading" : "type" in t && t.type ? t.type : e || n ? "page" : "link", s = "module" in t ? t.module : void 0, l = "icon" in t ? t.icon : void 0, c = /* @__PURE__ */ k(
      re.div,
      {
        layoutId: `breadcrumb-${t.id}`,
        className: E(
          "flex items-center gap-2 px-1.5",
          i && "pl-0",
          n && "text-2xl font-semibold"
        ),
        transition: { duration: 0.15 },
        children: [
          !a && ("module" in t && t.module || "icon" in t && t.icon) && (n || i) && /* @__PURE__ */ d(
            Sm,
            {
              ...l ? { icon: l } : { module: s },
              size: n ? "lg" : "sm"
            }
          ),
          /* @__PURE__ */ d("span", { className: "truncate", children: !a && "label" in t ? t.label : "" })
        ]
      }
    ), u = {
      loading: /* @__PURE__ */ d(ZC, {}),
      select: "type" in t && t.type === "select" && /* @__PURE__ */ d(
        VH,
        {
          options: t.options,
          defaultItem: t.defaultItem,
          onChange: t.onChange,
          value: t.value,
          showSearchBox: t.searchbox
        }
      ),
      page: /* @__PURE__ */ d(KC, { "aria-hidden": "true", className: "p-0", children: c }),
      link: /* @__PURE__ */ d(YC, { asChild: !0, className: "p-0", children: /* @__PURE__ */ d(
        _n,
        {
          ..."href" in t && !("type" in t) ? t : {},
          className: "block",
          children: c
        }
      ) })
    };
    return /* @__PURE__ */ d(
      re.div,
      {
        ref: r,
        layout: !0,
        className: E(a && "max-w-40"),
        transition: { duration: 0.15 },
        children: u[o]
      }
    );
  }
);
eP.displayName = "BreadcrumbContent";
const eB = ({
  title: t,
  module: e,
  otherActions: n
}) => {
  const { onClose: i, shownBottomSheet: r, position: a } = EC(), o = E(
    "font-semibold text-f1-foreground",
    a === "center" ? "text-lg" : "text-xl"
  ), s = () => /* @__PURE__ */ d("div", { className: "h-4 w-px self-center bg-f1-background-secondary" }), l = (n == null ? void 0 : n.filter((f) => f.type !== "separator")) ?? [], c = () => !l.length || !n ? null : l.length <= 2 ? /* @__PURE__ */ d("div", { className: "flex flex-row gap-2", children: l.map((f) => /* @__PURE__ */ d(
    so,
    {
      variant: "outline",
      icon: f.icon,
      onClick: f.onClick,
      label: f.label,
      hideLabel: !0
    },
    f.label
  )) }) : /* @__PURE__ */ d(lc, { items: n }), u = () => e ? /* @__PURE__ */ d(Yv, { children: /* @__PURE__ */ d(
    as,
    {
      item: {
        id: e.id,
        label: e.label,
        href: e.href,
        module: e.id
      },
      isLast: !1,
      isFirst: !0
    }
  ) }) : null;
  return a === "right" && !r ? /* @__PURE__ */ k("div", { className: "flex flex-col gap-3 bg-f1-background p-5 pb-3", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row justify-between", children: [
      e ? /* @__PURE__ */ d(u, {}) : /* @__PURE__ */ d(c, {}),
      /* @__PURE__ */ k("div", { className: "flex flex-row gap-2", children: [
        e && /* @__PURE__ */ k(Ee, { children: [
          /* @__PURE__ */ d(c, {}),
          n && /* @__PURE__ */ d(s, {})
        ] }),
        /* @__PURE__ */ d(
          so,
          {
            variant: "outline",
            icon: Rr,
            onClick: i,
            label: "Close modal",
            hideLabel: !0
          }
        )
      ] })
    ] }),
    !!t && /* @__PURE__ */ d(Pp, { className: E(o, "text-2xl"), children: t })
  ] }) : /* @__PURE__ */ k("div", { className: "flex flex-col gap-3 bg-f1-background p-5 pb-3", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center justify-between", children: [
      r ? /* @__PURE__ */ d(Ee, { children: e ? /* @__PURE__ */ d(u, {}) : /* @__PURE__ */ d(ng, { className: o, children: t }) }) : !!t && /* @__PURE__ */ d(Pp, { className: o, children: t }),
      /* @__PURE__ */ k("div", { className: "flex flex-row gap-2", children: [
        /* @__PURE__ */ d(c, {}),
        n && /* @__PURE__ */ d(s, {}),
        /* @__PURE__ */ d(
          so,
          {
            variant: "outline",
            icon: Rr,
            onClick: i,
            label: "Close modal",
            hideLabel: !0
          }
        )
      ] })
    ] }),
    e && !!t && /* @__PURE__ */ d(ng, { className: o, children: t })
  ] });
}, Zv = iH;
Zv.Header = eB;
Zv.Content = AH;
Zv.Footer = LH;
function CYe({
  children: t,
  sidebar: e,
  banner: n
}) {
  return /* @__PURE__ */ d(HH, { children: /* @__PURE__ */ d(nB, { sidebar: e, banner: n, children: t }) });
}
const tB = ({ contentId: t }) => {
  const e = et();
  return /* @__PURE__ */ d(
    "a",
    {
      href: `#${t}`,
      className: Ke(
        "absolute z-50 -translate-y-[1000px] translate-x-4 rounded-md bg-f1-background px-4 py-2.5 text-base font-medium text-f1-foreground no-underline transition-transform duration-200 focus-visible:translate-y-4"
      ),
      children: e.actions.skipToContent
    }
  );
};
function nB({
  children: t,
  sidebar: e,
  banner: n
}) {
  const { sidebarState: i, toggleSidebar: r, isSmallScreen: a } = vc(), o = Hd();
  return /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ d(
    d5,
    {
      reducedMotion: o ? "always" : "never",
      transition: {
        ease: [0.25, 0.1, 0.25, 1],
        duration: o ? 0 : 0.2
      },
      children: /* @__PURE__ */ k("div", { className: "grid h-screen grid-cols-1 grid-rows-[auto_minmax(0,1fr)] items-stretch", children: [
        /* @__PURE__ */ d("div", { className: "col-[1/-1]", children: n }),
        /* @__PURE__ */ k("div", { className: "relative isolate flex h-full", children: [
          /* @__PURE__ */ d(Ue, { children: i === "unlocked" && /* @__PURE__ */ d(
            re.nav,
            {
              className: E("fixed inset-0 z-[5] bg-f1-background-bold", {
                hidden: !a
              }),
              initial: { opacity: 0 },
              animate: { opacity: 0.1 },
              exit: { opacity: 0 },
              transition: { duration: o ? 0 : 0.2 },
              onClick: r
            }
          ) }),
          /* @__PURE__ */ k(
            "div",
            {
              className: E(
                { "transition-all": !o },
                i === "locked" ? "w-[240px] shrink-0 pl-3" : "w-0"
              ),
              ref: (s) => {
                i === "hidden" ? s == null || s.setAttribute("inert", "") : s == null || s.removeAttribute("inert");
              },
              children: [
                /* @__PURE__ */ d(tB, { contentId: "content" }),
                e
              ]
            }
          ),
          /* @__PURE__ */ d(
            re.main,
            {
              id: "content",
              className: E(
                "relative flex max-w-full flex-1 overflow-auto xs:py-1 xs:pr-1",
                i === "locked" ? "pl-0" : "xs:pl-1"
              ),
              layout: !0,
              transition: {
                duration: o ? 0 : 0.3,
                type: "spring",
                stiffness: 300,
                damping: 30
              },
              children: t
            }
          )
        ] })
      ] })
    }
  ) });
}
const cg = {
  superNegative: vE,
  negative: fE,
  neutral: hE,
  positive: gE,
  superPositive: wE
}, ug = It({
  variants: {
    pulse: {
      superNegative: "text-[hsl(theme(colors.radical.50))]",
      negative: "text-[hsl(theme(colors.orange.50))]",
      neutral: "text-[hsl(theme(colors.yellow.50))]",
      positive: "text-[hsl(theme(colors.flubber.50))]",
      superPositive: "text-[hsl(theme(colors.grass.50))]"
    }
  }
}), tP = ({
  firstName: t,
  lastName: e,
  src: n,
  "aria-label": i,
  "aria-labelledby": r,
  pulse: a,
  onPulseClick: o
}) => {
  const s = et(), [l, c] = q(!a);
  return /* @__PURE__ */ d("div", { className: "relative h-14 w-14", children: /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !!l, children: l ? /* @__PURE__ */ d(
    re.div,
    {
      className: "relative h-14 w-14 rounded-full bg-f1-background-warning",
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.5 },
      transition: {
        scale: {
          type: "spring",
          stiffness: 290,
          damping: 15.1,
          mass: 1.4
        },
        opacity: {
          type: "linear",
          duration: 0.2
        }
      },
      children: /* @__PURE__ */ d(
        re.div,
        {
          initial: { opacity: 0, originX: 0.6, originY: 0.6 },
          animate: {
            rotate: [-15, 20, -15],
            opacity: 1
          },
          exit: { opacity: 0, scale: 0 },
          transition: {
            opacity: { duration: 0.4, ease: "easeOut" },
            scale: { duration: 0.4, ease: "easeOut" },
            rotate: {
              repeat: 1,
              duration: 0.5,
              ease: "easeInOut"
            }
          },
          onAnimationComplete: () => c(!1),
          className: "absolute inset-0 flex select-none items-center justify-center text-4xl",
          children: /* @__PURE__ */ d(Bd, { emoji: "👋", size: "md" })
        },
        "wave"
      )
    }
  ) : /* @__PURE__ */ k(
    re.div,
    {
      initial: { opacity: 0, scale: 0.5 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.5 },
      className: "relative",
      transition: {
        scale: {
          type: "spring",
          stiffness: 290,
          damping: 15.1,
          mass: 1.4
        },
        opacity: {
          type: "linear",
          duration: 0.2
        }
      },
      children: [
        /* @__PURE__ */ d(
          Xs,
          {
            type: "rounded",
            name: [t, e],
            src: n,
            size: "large",
            color: "random",
            "aria-label": i,
            "aria-labelledby": r
          }
        ),
        a ? /* @__PURE__ */ d("div", { className: "absolute -bottom-1 -right-1 inline-flex rounded-sm bg-f1-background", children: /* @__PURE__ */ d(
          ga,
          {
            variant: "neutral",
            size: "sm",
            onClick: (u) => {
              u.preventDefault(), u.stopPropagation(), o();
            },
            round: !0,
            "aria-label": s.actions.edit,
            children: /* @__PURE__ */ d(
              me,
              {
                icon: cg[a],
                className: ug({ pulse: a })
              }
            )
          }
        ) }) : /* @__PURE__ */ d(
          re.div,
          {
            initial: { opacity: 0, scale: 0.5 },
            animate: { opacity: 1, scale: 1 },
            exit: { opacity: 0, scale: 0.5 },
            transition: {
              opacity: { delay: 0.25 },
              scale: { delay: 0.25 }
            },
            className: "absolute -bottom-1 -right-1 rounded-sm bg-f1-background",
            children: /* @__PURE__ */ d(
              ue,
              {
                label: s.actions.add,
                variant: "neutral",
                size: "sm",
                icon: L5,
                onClick: (u) => {
                  u.preventDefault(), u.stopPropagation(), o();
                },
                hideLabel: !0
              }
            )
          },
          "reaction-button"
        )
      ]
    },
    "avatar"
  ) }) });
};
tP.displayName = "PulseAvatar";
const iB = It({
  base: "pointer-events-none absolute inset-0 h-screen max-h-[1000px] opacity-[0.08]",
  variants: {
    period: {
      morning: "bg-gradient-to-bl from-[#E51943] from-20% via-[#F97316] via-35% to-transparent to-50%",
      afternoon: "bg-gradient-to-bl from-[#5596F6] from-20% via-[#10B881] via-35% to-transparent to-50%",
      evening: "bg-gradient-to-bl from-[#3739A8] from-20% via-[#CB6687] via-35% to-transparent to-50%"
    }
  },
  defaultVariants: {
    period: "morning"
  }
});
function rB({
  children: t,
  header: e,
  period: n,
  embedded: i = !1
}) {
  const { sidebarState: r, toggleSidebar: a, isSmallScreen: o } = vc();
  return /* @__PURE__ */ k(
    "div",
    {
      className: `relative flex w-full flex-col overflow-hidden ${i ? "" : "xs:rounded-xl"} bg-f1-page shadow`,
      children: [
        /* @__PURE__ */ d("div", { className: iB({ period: n }) }),
        e && /* @__PURE__ */ d("div", { className: "@container", children: /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-2 px-5 py-4 @5xl:px-6", children: [
          (o || r === "hidden") && /* @__PURE__ */ d(
            ue,
            {
              variant: "ghost",
              onClick: a,
              label: "Open main menu",
              icon: D5,
              hideLabel: !0,
              round: !0
            }
          ),
          /* @__PURE__ */ k(
            "div",
            {
              className: E(
                "flex flex-row items-center",
                o ? "gap-1.5" : "gap-3"
              ),
              children: [
                e != null && e.onPulseClick ? /* @__PURE__ */ d(
                  tP,
                  {
                    src: e.employeeAvatar,
                    firstName: e.employeeFirstName,
                    lastName: e.employeeLastName,
                    pulse: e.pulse,
                    onPulseClick: e.onPulseClick
                  }
                ) : /* @__PURE__ */ d(
                  ti,
                  {
                    src: e.employeeAvatar,
                    firstName: e.employeeFirstName,
                    lastName: e.employeeLastName,
                    size: o ? "small" : e.description ? "large" : "medium"
                  }
                ),
                /* @__PURE__ */ k("div", { className: "flex flex-col", children: [
                  /* @__PURE__ */ d(
                    "p",
                    {
                      className: E(
                        o ? "text-lg" : "text-2xl",
                        "font-semibold text-f1-foreground"
                      ),
                      children: e.title
                    }
                  ),
                  e.description && /* @__PURE__ */ d(
                    "p",
                    {
                      className: E(
                        o ? "text-md" : "text-lg",
                        "text-f1-foreground-secondary"
                      ),
                      children: e.description
                    }
                  )
                ] })
              ]
            }
          )
        ] }) }),
        /* @__PURE__ */ d(
          "div",
          {
            className: E(
              "isolate flex w-full flex-1 flex-col overflow-y-auto overflow-x-hidden [&>*]:flex-1",
              o && "-mt-3"
            ),
            children: t
          }
        )
      ]
    }
  );
}
rB.displayName = "DaytimePage";
function aB(t) {
  return t.filter((e) => !!e.title).map(({ title: e, description: n, href: i, onClick: r, target: a }) => ({
    label: e,
    description: n,
    href: i,
    onClick: r ? () => r(void 0) : void 0
  }));
}
function PYe({ label: t, options: e, hasNewUpdate: n }) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: "fixed z-10",
      style: {
        bottom: "calc(8px + env(safe-area-inset-bottom))",
        right: "calc(8px + env(safe-area-inset-right))"
      },
      children: /* @__PURE__ */ d(In, { items: aB(e), children: /* @__PURE__ */ k(
        "button",
        {
          className: E(
            "relative flex h-6 w-6 items-center justify-center rounded-full bg-f1-background-bold text-f1-foreground-inverse shadow-md transition-all",
            Ke()
          ),
          "aria-label": t,
          children: [
            /* @__PURE__ */ d(me, { icon: W5, size: "sm" }),
            n && /* @__PURE__ */ d("div", { className: "absolute right-0.5 top-0.5 h-1.5 w-1.5 rounded-full bg-f1-background-critical-bold ring-2 ring-f1-background-critical" })
          ]
        }
      ) })
    }
  );
}
function oB({ children: t, header: e, embedded: n = !1 }) {
  return /* @__PURE__ */ k(
    "div",
    {
      className: `flex w-full flex-col overflow-hidden ${n ? "" : "xs:rounded-xl"} bg-f1-page ring-1 ring-inset ring-f1-border-secondary`,
      children: [
        e && /* @__PURE__ */ d("div", { className: "flex flex-col", children: e }),
        /* @__PURE__ */ d("div", { className: "isolate flex w-full flex-1 flex-col overflow-auto [&>*]:flex-1", children: t })
      ]
    }
  );
}
oB.displayName = "Page";
function sB({
  companies: t,
  selected: e,
  onChange: n,
  isLoading: i = !1,
  withNotification: r = !1,
  additionalOptions: a = []
}) {
  const o = ve(
    () => t.find((s) => s.id === e) || t[0],
    [t, e]
  );
  return i ? /* @__PURE__ */ k("div", { className: "flex w-fit items-center gap-2 p-1.5", children: [
    /* @__PURE__ */ d(Ce, { className: "size-6" }),
    /* @__PURE__ */ d(Ce, { className: "h-3 w-14" })
  ] }) : t.length + ((a == null ? void 0 : a.length) || 0) === 1 ? /* @__PURE__ */ d("div", { className: "p-1.5", style: { maxWidth: "168px" }, children: /* @__PURE__ */ d(
    r2,
    {
      company: o,
      withNotification: r
    }
  ) }) : /* @__PURE__ */ d(
    lB,
    {
      companies: t,
      selected: o,
      onChange: n,
      additionalOptions: a,
      children: /* @__PURE__ */ d(
        r2,
        {
          company: o,
          withNotification: r
        }
      )
    }
  );
}
const lB = ({
  companies: t,
  selected: e,
  onChange: n,
  children: i,
  additionalOptions: r = []
}) => {
  const [a, o] = q(!1), s = ve(
    () => [
      ...t.map((c) => ({
        value: c.id,
        label: c.name,
        avatar: {
          type: "company",
          name: c.name,
          src: c.logo,
          "aria-label": `${c.name} logo`
        }
      })),
      ...r.length ? [{ type: "separator" }] : [],
      ...r
    ],
    [t, r]
  ), l = (c) => {
    const u = r == null ? void 0 : r.find((f) => f.value === c);
    if (u != null && u.onClick) {
      u.onClick();
      return;
    }
    n(c);
  };
  return /* @__PURE__ */ d(
    Ca,
    {
      options: s,
      value: e.id,
      onChange: l,
      placeholder: "Select a company",
      open: a,
      onOpenChange: o,
      children: /* @__PURE__ */ k(
        "div",
        {
          className: E(
            "group flex w-fit max-w-full flex-nowrap items-center justify-center gap-1 rounded p-1.5 text-f1-foreground transition-colors hover:bg-f1-background-hover data-[state=open]:bg-f1-background-hover",
            Ke()
          ),
          tabIndex: 0,
          title: e == null ? void 0 : e.name,
          children: [
            i,
            /* @__PURE__ */ d("div", { className: "flex w-5 shrink-0 items-center justify-center", children: /* @__PURE__ */ d("div", { className: "flex h-3 w-3 items-center justify-center rounded-2xs bg-f1-background-secondary transition-all", children: /* @__PURE__ */ d(
              re.div,
              {
                animate: { rotate: a ? 180 : 0 },
                transition: { duration: 0.2 },
                className: "flex h-3 w-3 shrink-0 items-center justify-center text-f1-icon-bold",
                children: /* @__PURE__ */ d(me, { icon: zn, size: "xs" })
              }
            ) }) })
          ]
        }
      )
    }
  );
}, r2 = ({
  company: t,
  withNotification: e = !1
}) => {
  var n;
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex w-fit min-w-0 max-w-full items-center gap-2 rounded text-lg font-semibold text-f1-foreground transition-colors"
      ),
      children: [
        /* @__PURE__ */ d(
          ac,
          {
            name: (n = t == null ? void 0 : t.name) == null ? void 0 : n[0],
            src: t == null ? void 0 : t.logo,
            size: "small",
            badge: e ? { icon: M5, type: "highlight" } : void 0
          }
        ),
        /* @__PURE__ */ d("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ d("span", { className: "line-clamp-1", children: t == null ? void 0 : t.name }) })
      ]
    }
  );
}, a2 = (t, e) => {
  if (!t) return !1;
  if (e > 1) {
    const n = parseInt(window.getComputedStyle(t).lineHeight);
    return t.scrollHeight > n * e;
  }
  return t.scrollWidth > t.clientWidth;
}, nP = X(
  ({ children: t, className: e, lines: n, onHasEllipsisChange: i, ...r }, a) => (le(() => {
    if (!a || typeof a != "object") return;
    const o = a.current;
    if (!o) return;
    i(a2(o, n));
    const s = new ResizeObserver(() => {
      i(a2(o, n));
    });
    return s.observe(o), () => {
      s.disconnect();
    };
  }, [a, i, n]), /* @__PURE__ */ d(
    "span",
    {
      ref: a,
      className: E(
        "min-w-0 max-w-full overflow-hidden text-ellipsis",
        n > 1 ? `not-supports-[(-webkit-line-clamp:${n})]:whitespace-nowrap display-[-webkit-box] whitespace-normal line-clamp-${n}` : "block whitespace-nowrap",
        e
      ),
      ...r,
      children: t
    }
  ))
);
nP.displayName = "EllipsisWrapper";
const Cs = X(
  ({ className: t, lines: e = 1, children: n, noTooltip: i = !1, ...r }, a) => {
    const [o, s] = q(!1), l = Oe(null), c = a || l, u = ve(() => /* @__PURE__ */ d(
      nP,
      {
        ref: c,
        className: t,
        lines: e,
        onHasEllipsisChange: s,
        ...r,
        "data-testid": "one-ellipsis",
        children: n
      }
    ), [t, e, n, c]);
    return o && !i ? /* @__PURE__ */ d(K4, { children: /* @__PURE__ */ k(U4, { children: [
      /* @__PURE__ */ d(J4, { asChild: !0, children: /* @__PURE__ */ d("span", { className: "overflow-hidden", children: u }) }),
      /* @__PURE__ */ d(Q4, { className: "max-w-xl", children: n })
    ] }) }) : u;
  }
);
Cs.displayName = "OneEllipsis";
function SYe({
  user: t,
  options: e,
  showActivityButton: n = !1,
  activityButtonShortcut: i,
  onActivityButtonClick: r,
  onDropdownClick: a,
  hasActivityUpdates: o
}) {
  const s = et();
  return /* @__PURE__ */ k("div", { className: "flex flex-row items-center justify-between gap-1 p-3", children: [
    /* @__PURE__ */ d("div", { className: "min-w-0 flex-1", children: /* @__PURE__ */ d(In, { items: e, children: /* @__PURE__ */ k(
      "button",
      {
        className: E(
          "flex w-full max-w-full items-center gap-1.5 rounded p-1.5 font-medium transition-colors hover:bg-f1-background-secondary data-[state=open]:bg-f1-background-secondary",
          Ke("focus-visible:ring-inset")
        ),
        onClick: a,
        children: [
          /* @__PURE__ */ d(
            ti,
            {
              src: t.avatarUrl,
              firstName: t.firstName,
              lastName: t.lastName,
              size: "xsmall"
            }
          ),
          /* @__PURE__ */ d(Cs, { children: `${t.firstName} ${t.lastName}` })
        ]
      }
    ) }) }),
    n && /* @__PURE__ */ d(Kt, { label: s.notifications, shortcut: i, children: /* @__PURE__ */ k("div", { className: "relative", children: [
      /* @__PURE__ */ d(
        ue,
        {
          icon: x5,
          label: s.notifications,
          onClick: r,
          variant: "ghost",
          hideLabel: !0
        }
      ),
      o && /* @__PURE__ */ d("div", { className: "absolute -right-1 -top-1 rounded-full bg-f1-background", children: /* @__PURE__ */ d(Xy, { type: "highlight", size: "sm", icon: M5 }) })
    ] }) })
  ] });
}
function dB({ isExpanded: t }) {
  return /* @__PURE__ */ k(
    "svg",
    {
      width: "20",
      height: "20",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      className: "text-f1-icon-bold",
      children: [
        /* @__PURE__ */ d(
          "rect",
          {
            id: "container",
            x: "3.33325",
            y: "5",
            width: "13.3333",
            height: "10",
            rx: "3",
            strokeWidth: "1.3",
            className: "stroke-current"
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            id: "arrow",
            d: t ? "M10.417 10L14.167 10M10.417 10L12.0837 8.33337M10.417 10L12.0837 11.6667" : "M10.75 10L7 10M10.75 10L9.08333 8.33337M10.75 10L9.08333 11.6667",
            strokeWidth: "1.3",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            className: E(
              "translate-x-0 stroke-current transition-all duration-200 ease-out motion-reduce:transition-none",
              t ? "opacity-0 group-hover:-translate-x-1 group-hover:opacity-100" : "opacity-1 group-hover:translate-x-[3px]"
            )
          }
        ),
        /* @__PURE__ */ d(
          "path",
          {
            id: "line",
            d: "M7.5 5L7.5 15",
            strokeWidth: "1.3",
            strokeLinecap: "round",
            className: E(
              "stroke-current transition-all duration-200 ease-out motion-reduce:transition-none",
              t ? "translate-x-0 opacity-100 group-hover:-translate-x-0.5 group-hover:opacity-0" : "-translate-x-0.5 opacity-0 group-hover:translate-x-0 group-hover:opacity-100"
            )
          }
        )
      ]
    }
  );
}
function cB() {
  const { prevSidebarState: t, sidebarState: e, toggleSidebar: n, isSmallScreen: i } = vc(), r = Oe(null);
  return le(() => {
    var a;
    t === "hidden" && e === "locked" && ((a = r.current) == null || a.focus());
  }, [t, e]), /* @__PURE__ */ k(
    ga,
    {
      variant: "ghost",
      size: "md",
      round: !0,
      onClick: n,
      className: "group hover:bg-f1-background-hover",
      title: "Close Sidebar",
      ref: r,
      children: [
        /* @__PURE__ */ d("div", { className: E("hidden", { flex: !i }), children: /* @__PURE__ */ d(dB, { isExpanded: e === "locked" }) }),
        /* @__PURE__ */ d("div", { className: E("hidden", { flex: i }), children: /* @__PURE__ */ d(me, { icon: Rr, size: "md" }) })
      ]
    }
  );
}
function NYe({
  companies: t,
  selected: e,
  onChange: n,
  withNotification: i = !1,
  additionalOptions: r
}) {
  return /* @__PURE__ */ k("div", { className: "flex h-[72px] items-center justify-between gap-3 px-3", children: [
    /* @__PURE__ */ d(
      sB,
      {
        companies: t,
        selected: e,
        onChange: n,
        withNotification: i,
        additionalOptions: r
      }
    ),
    /* @__PURE__ */ d(cB, {})
  ] });
}
function uB() {
  const [t, e] = q(!1);
  return le(() => {
    e(window.matchMedia("(pointer: coarse)").matches);
  }, []), t;
}
var e0 = "Collapsible", [fB, $Ye] = Wi(e0), [mB, t0] = fB(e0), iP = S.forwardRef(
  (t, e) => {
    const {
      __scopeCollapsible: n,
      open: i,
      defaultOpen: r,
      disabled: a,
      onOpenChange: o,
      ...s
    } = t, [l = !1, c] = Si({
      prop: i,
      defaultProp: r,
      onChange: o
    });
    return /* @__PURE__ */ d(
      mB,
      {
        scope: n,
        disabled: a,
        contentId: Ir(),
        open: l,
        onOpenToggle: S.useCallback(() => c((u) => !u), [c]),
        children: /* @__PURE__ */ d(
          qe.div,
          {
            "data-state": i0(l),
            "data-disabled": a ? "" : void 0,
            ...s,
            ref: e
          }
        )
      }
    );
  }
);
iP.displayName = e0;
var rP = "CollapsibleTrigger", hB = S.forwardRef(
  (t, e) => {
    const { __scopeCollapsible: n, ...i } = t, r = t0(rP, n);
    return /* @__PURE__ */ d(
      qe.button,
      {
        type: "button",
        "aria-controls": r.contentId,
        "aria-expanded": r.open || !1,
        "data-state": i0(r.open),
        "data-disabled": r.disabled ? "" : void 0,
        disabled: r.disabled,
        ...i,
        ref: e,
        onClick: ge(t.onClick, r.onOpenToggle)
      }
    );
  }
);
hB.displayName = rP;
var n0 = "CollapsibleContent", aP = S.forwardRef(
  (t, e) => {
    const { forceMount: n, ...i } = t, r = t0(n0, t.__scopeCollapsible);
    return /* @__PURE__ */ d(Ji, { present: n || r.open, children: ({ present: a }) => /* @__PURE__ */ d(pB, { ...i, ref: e, present: a }) });
  }
);
aP.displayName = n0;
var pB = S.forwardRef((t, e) => {
  const { __scopeCollapsible: n, present: i, children: r, ...a } = t, o = t0(n0, n), [s, l] = S.useState(i), c = S.useRef(null), u = st(e, c), f = S.useRef(0), m = f.current, h = S.useRef(0), p = h.current, g = o.open || s, y = S.useRef(g), v = S.useRef(void 0);
  return S.useEffect(() => {
    const w = requestAnimationFrame(() => y.current = !1);
    return () => cancelAnimationFrame(w);
  }, []), xn(() => {
    const w = c.current;
    if (w) {
      v.current = v.current || {
        transitionDuration: w.style.transitionDuration,
        animationName: w.style.animationName
      }, w.style.transitionDuration = "0s", w.style.animationName = "none";
      const x = w.getBoundingClientRect();
      f.current = x.height, h.current = x.width, y.current || (w.style.transitionDuration = v.current.transitionDuration, w.style.animationName = v.current.animationName), l(i);
    }
  }, [o.open, i]), /* @__PURE__ */ d(
    qe.div,
    {
      "data-state": i0(o.open),
      "data-disabled": o.disabled ? "" : void 0,
      id: o.contentId,
      hidden: !g,
      ...a,
      ref: u,
      style: {
        "--radix-collapsible-content-height": m ? `${m}px` : void 0,
        "--radix-collapsible-content-width": p ? `${p}px` : void 0,
        ...t.style
      },
      children: g && r
    }
  );
});
function i0(t) {
  return t ? "open" : "closed";
}
var gB = iP;
const yB = gB, vB = aP, oP = hn(void 0);
function bB({ children: t }) {
  const [e, n] = q(!1), [i, r] = q(null);
  return /* @__PURE__ */ d(
    oP.Provider,
    {
      value: { isDragging: e, setIsDragging: n, draggedItemId: i, setDraggedItemId: r },
      children: t
    }
  );
}
function r0() {
  const t = Wt(oP);
  if (!t)
    throw new Error("useDragContext must be used within a DragProvider");
  return t;
}
const wB = ({
  item: t,
  active: e
}) => /* @__PURE__ */ k("div", { className: "flex w-full items-center justify-between", children: [
  /* @__PURE__ */ k("div", { className: "flex items-center gap-1.5 font-medium text-f1-foreground", children: [
    /* @__PURE__ */ d(
      me,
      {
        icon: t.icon,
        size: "md",
        className: E(
          "transition-colors",
          e ? "text-f1-icon-bold" : "text-f1-icon"
        )
      }
    ),
    /* @__PURE__ */ d("span", { children: t.label })
  ] }),
  t.badge && /* @__PURE__ */ d(Lo, { value: t.badge, size: "sm", type: "bold" })
] }), kB = ({ item: t }) => {
  const { isActive: e } = $m(), { label: n, icon: i, ...r } = t, a = e(r.href, { exact: r.exactMatch });
  return /* @__PURE__ */ d(
    _n,
    {
      ...r,
      className: E(
        "flex cursor-pointer items-center rounded py-1.5 pl-1.5 pr-2 no-underline transition-colors",
        Ke("focus-visible:ring-inset"),
        a ? "bg-f1-background-secondary text-f1-foreground" : "hover:bg-f1-background-secondary"
      ),
      children: /* @__PURE__ */ d(wB, { item: t, active: a })
    }
  );
}, xB = ({
  item: t,
  tooltip: e,
  dragConstraints: n,
  onRemove: i,
  index: r,
  total: a,
  onMove: o,
  onReorderFinish: s,
  isSortable: l = !0
}) => {
  const c = et(), { isDragging: u, setIsDragging: f, draggedItemId: m, setDraggedItemId: h } = r0(), { isActive: p } = $m(), g = p(t.href, { exact: t.exactMatch }), y = Oe(!1), [v, w] = q(!1), x = r === 0, b = r === a - 1, M = a === 1, _ = ve(() => {
    const O = [];
    return !M && !x && O.push({
      label: c.actions.moveUp,
      onClick: () => o == null ? void 0 : o(r, r - 1),
      icon: YE
    }), !M && !b && O.push({
      label: c.actions.moveDown,
      onClick: () => o == null ? void 0 : o(r, r + 1),
      icon: GE
    }), O.length > 0 && O.push({ type: "separator" }), O.push({
      label: c.favorites.remove,
      onClick: () => i == null ? void 0 : i(t),
      icon: tc,
      critical: !0
    }), O;
  }, [M, x, b, c, o, r, i, t]), N = () => {
    f(!0), w(!1), h(t.href || null), y.current = !0;
  }, $ = () => {
    f(!1), h(null), s(), setTimeout(() => {
      y.current = !1;
    }, 0);
  }, D = u && m === t.href, W = ve(
    () => E(
      "group relative cursor-pointer select-none list-none rounded backdrop-blur-sm active:cursor-grabbing",
      l && "touch-none",
      g ? "bg-f1-background-secondary text-f1-foreground" : "hover:bg-f1-background-secondary",
      v && "bg-f1-background-secondary",
      D && "bg-f1-background-secondary"
    ),
    [g, v, D, l]
  ), j = ve(() => /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-between px-1.5 py-1.5", children: /* @__PURE__ */ d(MB, { tooltip: e, children: /* @__PURE__ */ k(
      _n,
      {
        onClick: t.onClick,
        href: t.href,
        exactMatch: t.exactMatch,
        className: E(
          // w-[calc(100%-24px-2px)] - here 24px is the size of the dropdown button and 2 px is the gap
          "flex w-[calc(100%-24px-2px)] items-center gap-1.5 no-underline",
          D && "pointer-events-none"
        ),
        draggable: !1,
        children: [
          t.type === "icon" ? /* @__PURE__ */ d(
            me,
            {
              icon: t.icon,
              size: "md",
              className: E(
                "transition-colors",
                g ? "text-f1-icon-bold" : "text-f1-icon"
              )
            }
          ) : t.avatar ? /* @__PURE__ */ d(ni, { size: "xsmall", avatar: t.avatar }) : null,
          /* @__PURE__ */ d(
            Cs,
            {
              tag: "span",
              className: "line-clamp-1 font-medium text-f1-foreground",
              lines: 1,
              noTooltip: !!e,
              children: t.label
            }
          )
        ]
      }
    ) }) }),
    /* @__PURE__ */ d(
      "div",
      {
        className: E(
          "absolute inset-y-1 right-1 z-10 flex h-6 w-6 items-center justify-center rounded-sm opacity-0 transition-opacity duration-100 hover:bg-f1-background-secondary group-hover:opacity-100",
          v && "bg-f1-background-secondary opacity-100",
          D && "opacity-100"
        ),
        children: /* @__PURE__ */ d(
          In,
          {
            open: v,
            onOpenChange: w,
            items: _,
            children: /* @__PURE__ */ d("div", { className: "flex items-center justify-center", role: "list", children: /* @__PURE__ */ d(me, { icon: Ma, size: "sm" }) })
          }
        )
      }
    )
  ] }), [t, g, v, D, _, e]);
  return l ? /* @__PURE__ */ d(
    V5,
    {
      value: t,
      drag: "y",
      dragConstraints: n,
      dragElastic: 0.1,
      onDragStart: N,
      onDragEnd: $,
      className: W,
      whileDrag: {
        scale: 1.05
      },
      children: j
    }
  ) : /* @__PURE__ */ d("div", { className: W, children: j });
}, sP = ({
  title: t,
  isOpen: e = !0,
  isRoot: n,
  onCollapse: i,
  children: r,
  isDragging: a,
  wasDragging: o
}) => {
  const [s, l] = q(e), c = Hd(), u = () => {
    if (a || o != null && o.current) return;
    const f = !s;
    l(f), i == null || i(f);
  };
  return /* @__PURE__ */ d("div", { children: /* @__PURE__ */ k(yB, { open: s, children: [
    /* @__PURE__ */ d("div", { className: "group relative flex items-center", children: /* @__PURE__ */ k(
      "div",
      {
        className: E(
          "group relative flex w-full select-none items-center gap-1 rounded px-1.5 py-2 text-sm font-medium text-f1-foreground-secondary transition-colors hover:cursor-pointer hover:bg-f1-background-secondary",
          Ke("focus-visible:ring-inset"),
          n && "hidden"
        ),
        onClick: u,
        tabIndex: 0,
        onKeyDown: (f) => {
          (f.key === "Enter" || f.key === " ") && u();
        },
        children: [
          t,
          /* @__PURE__ */ d(
            re.div,
            {
              initial: !1,
              animate: { rotate: s ? 0 : -90 },
              transition: { duration: c ? 0 : 0.1 },
              className: "h-3 w-3",
              children: /* @__PURE__ */ d(
                me,
                {
                  icon: zn,
                  size: "xs",
                  className: "text-f1-icon-secondary"
                }
              )
            }
          )
        ]
      }
    ) }),
    /* @__PURE__ */ d(vB, { forceMount: !0, className: "flex flex-col gap-1", children: /* @__PURE__ */ d(
      re.div,
      {
        initial: !1,
        animate: {
          height: s ? "auto" : 0,
          opacity: s ? 1 : 0,
          visibility: s ? "visible" : "hidden"
        },
        transition: {
          duration: c ? 0 : 0.15,
          ease: [0.165, 0.84, 0.44, 1]
        },
        children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-0.5", children: r })
      }
    ) })
  ] }) });
}, f1 = ({
  category: t,
  isSortable: e = !1,
  dragConstraints: n,
  onCollapse: i,
  onDragEnd: r,
  currentOrder: a
}) => {
  const { isDragging: o, setIsDragging: s } = r0(), l = Oe(!1), c = jT(), u = () => {
    s(!0), l.current = !0;
  }, f = () => {
    s(!1), setTimeout(() => {
      l.current = !1, a && (r == null || r(a));
    }, 0);
  }, m = (p) => {
    !o && !l.current && (i == null || i(t, p));
  }, h = /* @__PURE__ */ d(
    sP,
    {
      title: t.title,
      isOpen: t.isOpen,
      isRoot: t.isRoot,
      onCollapse: m,
      isDragging: o,
      wasDragging: l,
      children: /* @__PURE__ */ d(
        "div",
        {
          className: E(
            "flex flex-col gap-0.5",
            o && !l.current && "pointer-events-none"
          ),
          children: t.items.map((p, g) => /* @__PURE__ */ d(kB, { item: p }, g))
        }
      )
    }
  );
  return e ? /* @__PURE__ */ d(
    V5,
    {
      id: t.id,
      value: t,
      dragConstraints: n,
      dragElastic: 0.1,
      dragControls: c,
      onDragStart: u,
      onDragEnd: f,
      layout: !0,
      layoutId: `category-${t.id}`,
      initial: { opacity: 1 },
      animate: { opacity: 1, scale: 1 },
      exit: {
        opacity: 0,
        scale: 0.95,
        filter: "blur(8px)"
      },
      transition: {
        opacity: { duration: 0.2, ease: "easeInOut" },
        filter: { duration: 0.1, ease: "easeInOut" },
        scale: {
          duration: 0.2,
          ease: [0.175, 0.885, 0.32, 1.275]
        },
        layout: { type: "spring", bounce: 0.1, damping: 15 }
      },
      whileDrag: {
        scale: 1.04,
        cursor: "grabbing",
        zIndex: 50,
        backdropFilter: "blur(4px)"
      },
      className: "relative",
      children: h
    }
  ) : h;
};
function DYe({
  tree: t,
  onCollapse: e,
  onSort: n,
  onFavoritesChange: i,
  favorites: r
}) {
  const a = Oe(null), o = t.filter(
    (p) => p.isSortable === !1
  ), [s, l] = q(
    t.filter((p) => p.isSortable !== !1)
  ), [c, u] = q(0), f = Le((p) => {
    l(p);
  }, []), m = Le(
    (p) => {
      n == null || n(p);
    },
    [n]
  ), h = uB();
  return /* @__PURE__ */ d(bB, { children: /* @__PURE__ */ d(Wm, { id: "sidebar-menu", children: /* @__PURE__ */ d(
    _B,
    {
      disableDragging: h,
      nonSortableItems: o,
      sortableItems: s,
      setSortableItems: f,
      containerRef: a,
      onCollapse: e,
      onDragEnd: m,
      favorites: r,
      onFavoritesChange: i,
      forceUpdate: () => u((p) => p + 1)
    },
    c
  ) }) });
}
function _B({
  nonSortableItems: t,
  sortableItems: e,
  setSortableItems: n,
  containerRef: i,
  onCollapse: r,
  onDragEnd: a,
  favorites: o = [],
  onFavoritesChange: s,
  forceUpdate: l,
  disableDragging: c = !1
}) {
  const u = et(), { isDragging: f } = r0(), m = t.some((L) => L.isRoot), h = t.filter((L) => !L.isRoot).length > 0, p = e.length > 0, g = Oe(null), [y, v] = q(o), w = o.length > 0;
  le(() => {
    JSON.stringify(o) !== JSON.stringify(y) && v(o);
  }, [o]);
  const x = (L) => {
    v(L);
  }, b = Le(
    (L) => {
      const R = y.filter((B) => B.href !== L.href);
      v(R), s == null || s(R);
    },
    [y, s]
  ), M = Le(
    (L, R) => {
      if (R < 0 || R >= y.length) return;
      const B = [...y], [F] = B.splice(L, 1);
      B.splice(R, 0, F), v(B), s == null || s(B);
    },
    [y, s]
  ), [_, N] = q(!1), $ = Oe(null);
  le(() => {
    e.length > 0 && !_ && (n([...e]), N(!0));
  }, [e, n, _]), le(() => {
    const L = () => {
      $.current !== null && window.clearTimeout($.current), $.current = window.setTimeout(() => {
        i.current && e.length > 0 && l();
      }, 50);
    };
    return window.addEventListener("resize", L), () => {
      window.removeEventListener("resize", L), $.current !== null && window.clearTimeout($.current);
    };
  }, [i, e, l]);
  const D = "flex flex-col gap-0.5", W = ve(
    () => y.reduce(
      (L, R, B) => (R.label in L || (L[R.label] = []), L[R.label].push(B), L),
      {}
    ),
    [y]
  ), j = ve(
    () => w && y.map((L, R) => /* @__PURE__ */ d(
      xB,
      {
        isSortable: !c,
        tooltip: (W[L.label] ?? []).length > 1 ? L.tooltip : void 0,
        item: L,
        dragConstraints: g,
        onRemove: b,
        index: R,
        total: y.length,
        onMove: M,
        onReorderFinish: () => {
          s == null || s(y);
        }
      },
      `${L.href}-${L.label}`
    )),
    [
      w,
      y,
      W,
      b,
      M,
      s,
      c
    ]
  ), O = "flex flex-col gap-3", I = ve(() => e.map((L) => /* @__PURE__ */ d(
    f1,
    {
      category: L,
      isSortable: !c,
      dragConstraints: i,
      onCollapse: r,
      onDragEnd: a,
      currentOrder: e
    },
    L.id
  )), [e, c, i, r, a]);
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "relative",
        f && "cursor-grabbing [&_*]:cursor-grabbing"
      ),
      children: [
        m && /* @__PURE__ */ d("div", { className: "flex w-full flex-col gap-3 bg-transparent px-3", children: t.filter((L) => L.isRoot).map((L, R) => /* @__PURE__ */ d(
          f1,
          {
            category: L,
            onCollapse: r
          },
          `fixed-${R}`
        )) }),
        w && /* @__PURE__ */ d("div", { className: "mt-3 flex w-full flex-col gap-3 bg-transparent px-3", children: /* @__PURE__ */ d(sP, { title: u.favorites.favorites, children: /* @__PURE__ */ d("div", { ref: g, children: c ? /* @__PURE__ */ d("div", { className: D, children: j }) : /* @__PURE__ */ d(
          bw,
          {
            axis: "y",
            values: y,
            onReorder: x,
            className: D,
            children: j
          }
        ) }) }) }),
        h && /* @__PURE__ */ d("div", { className: "mt-3 flex w-full flex-col gap-3 bg-transparent px-3", children: t.filter((L) => !L.isRoot).map((L, R) => /* @__PURE__ */ d(
          f1,
          {
            category: L,
            onCollapse: r
          },
          `fixed-${R}`
        )) }),
        p && /* @__PURE__ */ d(
          "div",
          {
            className: E(
              "mt-3 flex w-full flex-col gap-3 bg-transparent px-3 [&_li]:list-none"
            ),
            ref: i,
            children: c ? /* @__PURE__ */ d("div", { className: O, children: I }) : /* @__PURE__ */ d(
              bw,
              {
                axis: "y",
                values: e,
                onReorder: n,
                layoutScroll: !0,
                className: O,
                children: I
              }
            )
          }
        )
      ]
    }
  );
}
const MB = ({
  tooltip: t,
  children: e
}) => t ? /* @__PURE__ */ d(Kt, { description: t, children: e }) : e;
function EYe({
  onClick: t,
  placeholder: e,
  shortcut: n = ["cmd", "k"],
  ...i
}) {
  return /* @__PURE__ */ d("div", { className: "px-3", children: /* @__PURE__ */ k(
    "button",
    {
      onClick: t,
      className: E(
        "mb-[calc(0.75rem-1px)] flex w-full cursor-pointer items-center justify-between rounded bg-f1-background-inverse-secondary p-1.5 text-f1-foreground-secondary ring-1 ring-inset ring-f1-border-secondary transition-all hover:ring-f1-border-hover",
        Ke()
      ),
      type: "button",
      ...i,
      children: [
        /* @__PURE__ */ k("div", { className: "flex items-center gap-1", children: [
          /* @__PURE__ */ d(me, { icon: Om, size: "md" }),
          /* @__PURE__ */ d("span", { children: e })
        ] }),
        /* @__PURE__ */ d("div", { className: "hidden xs:block", children: /* @__PURE__ */ d(M6, { keys: n }) })
      ]
    }
  ) });
}
const o2 = ({ position: t }) => /* @__PURE__ */ d(
  re.div,
  {
    initial: { opacity: 0 },
    animate: { opacity: 0.5 },
    exit: { opacity: 0 },
    transition: { duration: 0.2, ease: "easeOut" },
    className: E(
      "pointer-events-none absolute inset-x-0 z-10 h-3 after:absolute after:inset-x-0 after:h-px after:bg-f1-background-bold after:opacity-[0.04] after:content-['']",
      t === "top" ? [
        "top-0",
        "bg-gradient-to-b from-f1-background-secondary to-transparent",
        "after:top-0"
      ] : [
        "bottom-0",
        "bg-gradient-to-t from-f1-background-secondary to-transparent",
        "after:bottom-0"
      ]
    )
  }
);
function TYe({
  header: t,
  body: e,
  footer: n,
  onFooterDropdownClick: i
}) {
  const { sidebarState: r, isSmallScreen: a } = vc(), o = Hd(), [s, l] = Cp({ threshold: 1 }), [c, u] = Cp({ threshold: 1 }), f = et(), m = {
    x: {
      ease: r !== "locked" ? a ? [0.25, 0.46, 0.45, 0.94] : [0.175, 0.885, 0.32, 1.1] : [0, 0, 0.58, 1],
      duration: o ? 0 : r !== "locked" && !a ? 0.3 : 0.2
    },
    top: { duration: o ? 0 : 0.1 },
    left: { duration: o ? 0 : 0.1 },
    default: { duration: o ? 0 : 0.2 }
  }, h = () => n ? DD(n) && i ? g5(
    n,
    {
      onDropdownClick: i
    }
  ) : n : null;
  return /* @__PURE__ */ k(
    re.aside,
    {
      initial: !1,
      "aria-label": f.navigation.sidebar,
      className: E(
        "absolute bottom-0 left-0 top-0 z-10 flex w-[var(--ds-sidebar-width)] flex-col transition-[background-color]",
        r === "locked" ? "h-full" : E(
          "shadow-lg ring-1 ring-f1-border-secondary backdrop-blur-2xl",
          a ? "h-full border-y-transparent border-l-transparent bg-f1-background/90" : "h-[calc(100%-16px)] bg-f1-background/60"
        )
      ),
      animate: {
        top: r === "locked" || a ? 0 : "8px",
        borderRadius: r === "locked" || a ? "0" : "12px",
        left: r === "locked" ? "0" : a ? 0 : "8px",
        x: r === "hidden" ? -260 : 0,
        opacity: r === "hidden" ? a ? 0.7 : 0 : 1,
        pointerEvents: r === "hidden" ? "none" : "auto"
      },
      transition: m,
      children: [
        /* @__PURE__ */ d("header", { className: "flex-shrink-0", children: t }),
        e && /* @__PURE__ */ k("nav", { className: "relative flex-grow overflow-y-hidden", children: [
          /* @__PURE__ */ k(No, { className: "h-full", children: [
            /* @__PURE__ */ d(
              "div",
              {
                ref: s,
                className: "h-px",
                "aria-hidden": "true"
              },
              "top-ref"
            ),
            /* @__PURE__ */ d("div", { className: "w-[var(--ds-sidebar-width)]", children: e }),
            /* @__PURE__ */ d(
              "div",
              {
                ref: c,
                className: "h-px",
                "aria-hidden": "true"
              },
              "bottom-ref"
            )
          ] }),
          /* @__PURE__ */ k(Ue, { children: [
            !l && /* @__PURE__ */ d(o2, { position: "top" }, "shadow-scroll-top"),
            !u && /* @__PURE__ */ d(o2, { position: "bottom" }, "shadow-scroll-bottom")
          ] })
        ] }),
        /* @__PURE__ */ d("footer", { className: "flex-shrink-0", children: h() })
      ]
    }
  );
}
const CB = It({
  base: "flex w-full flex-col items-start justify-between gap-4 rounded-md px-3 py-3 text-f1-foreground ring-1 ring-inset ring-f1-border-secondary sm:flex-row sm:items-center sm:px-4",
  variants: {
    variant: {
      info: "bg-f1-background-info",
      warning: "bg-f1-background-warning",
      critical: "bg-f1-background-critical"
    }
  },
  defaultVariants: {
    variant: "info"
  }
}), PB = It({
  variants: {
    variant: {
      info: "text-f1-foreground-info",
      warning: "text-f1-foreground-warning",
      critical: "text-f1-foreground-critical"
    }
  },
  defaultVariants: {
    variant: "info"
  }
}), SB = {
  info: "outline",
  warning: "promote",
  critical: "outline"
}, OYe = ({
  title: t,
  description: e,
  action: n,
  link: i,
  variant: r = "info"
}) => /* @__PURE__ */ d("div", { className: CB({ variant: r }), children: /* @__PURE__ */ k("div", { className: "flex flex-grow items-center justify-between gap-16", children: [
  /* @__PURE__ */ k("div", { className: "flex flex-row gap-4", children: [
    /* @__PURE__ */ d("div", { className: "h-6 w-6 flex-shrink-0", children: /* @__PURE__ */ d(Gd, { type: r }) }),
    /* @__PURE__ */ k("div", { className: "flex flex-col gap-0.5", children: [
      /* @__PURE__ */ d("h3", { className: PB({ variant: r }), children: t }),
      /* @__PURE__ */ d("p", { className: "text-base text-f1-foreground-secondary", children: e })
    ] })
  ] }),
  /* @__PURE__ */ k("div", { className: "flex flex-row justify-end gap-3", children: [
    i && /* @__PURE__ */ k(
      "a",
      {
        href: i.href,
        target: "_blank",
        rel: "noreferrer",
        className: E(
          "flex items-center gap-1 rounded-sm px-2 py-0.5 text-base font-medium text-f1-foreground no-underline transition-colors hover:bg-f1-background-secondary-hover [&>svg]:text-f1-foreground-secondary",
          Ke()
        ),
        children: [
          i.label,
          /* @__PURE__ */ d(Cm, { icon: r5, size: "sm" })
        ]
      }
    ),
    /* @__PURE__ */ d(
      ue,
      {
        label: n.label,
        variant: SB[r],
        onClick: n.onClick
      }
    )
  ] })
] }) }), NB = {
  waiting: "neutral",
  pending: "neutral",
  approved: "positive",
  rejected: "critical"
}, s2 = {
  approved: {
    icon: Nm,
    type: "positive",
    size: "sm"
  },
  rejected: {
    icon: Rr,
    type: "critical",
    size: "sm"
  }
}, $B = {
  icon: W5,
  type: "neutral",
  size: "sm"
}, DB = {
  positive: 4,
  highlight: 3,
  critical: 2,
  warning: 1,
  neutral: 0
}, EB = (t) => t in s2 ? s2[t] : $B;
function l2(t) {
  return DB[t ?? "neutral"] ?? 0;
}
const TB = ({
  title: t,
  approvalsRequired: e = 1,
  status: n,
  approvers: i
}) => {
  const r = et(), a = e === 1 ? r.approvals.requiredNumbers.one : r.approvals.requiredNumbers.other.replace(
    "{{count}}",
    e.toString()
  ), o = r.approvals.statuses[n], s = ve(() => i.map((l) => {
    const c = EB(l.status);
    return {
      firstName: l.firstName,
      lastName: l.lastName,
      src: l.avatar,
      badge: c,
      type: "person"
    };
  }).sort(
    (l, c) => {
      var u, f;
      return l2((u = c.badge) == null ? void 0 : u.type) - l2((f = l.badge) == null ? void 0 : f.type);
    }
  ), [i]);
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-3 pb-5 pl-4 pr-3 pt-3", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-row items-start justify-between", children: [
      /* @__PURE__ */ k("div", { children: [
        /* @__PURE__ */ d("p", { className: "font-medium text-f1-foreground", children: t }),
        /* @__PURE__ */ d("p", { className: "text-f1-foreground-secondary", children: a })
      ] }),
      /* @__PURE__ */ d(Vr, { text: o, variant: NB[n] })
    ] }),
    /* @__PURE__ */ d("div", { className: "w-full", children: /* @__PURE__ */ d(
      Js,
      {
        avatars: s,
        layout: "fill",
        type: "person",
        size: "medium"
      }
    ) })
  ] });
}, WYe = ({ steps: t }) => {
  const n = et().approvals.history, i = t.findIndex((r) => r.status === "pending");
  return /* @__PURE__ */ k("div", { className: "flex w-full flex-col gap-4", children: [
    /* @__PURE__ */ d("h2", { className: "mb-2 text-lg font-semibold text-f1-foreground", children: n }),
    /* @__PURE__ */ k("div", { className: "flex flex-row gap-4", children: [
      /* @__PURE__ */ d("div", { className: "mt-3.5 flex flex-col items-center", children: t.map((r, a) => /* @__PURE__ */ k("div", { className: "flex flex-col items-center", children: [
        /* @__PURE__ */ d(
          "div",
          {
            className: E(
              "flex size-5 items-center justify-center rounded-xs text-sm font-medium",
              a < i ? "bg-f1-background-selected-bold text-f1-foreground-inverse" : "border border-solid border-f1-border-secondary bg-f1-background-secondary text-f1-foreground"
            ),
            children: /* @__PURE__ */ d("span", { children: a + 1 })
          }
        ),
        a !== t.length - 1 && /* @__PURE__ */ d("div", { className: "h-[96px] w-px bg-f1-border-secondary" })
      ] }, r.title)) }),
      /* @__PURE__ */ d("div", { className: "flex w-full flex-col rounded-xl border border-solid border-f1-border-secondary", children: t.map((r, a) => /* @__PURE__ */ k(Ee, { children: [
        /* @__PURE__ */ d(
          TB,
          {
            title: r.title,
            approvalsRequired: r.approvalsRequired,
            status: r.status,
            approvers: r.approvers
          },
          r.title
        ),
        a !== t.length - 1 && /* @__PURE__ */ d("div", { className: "h-px w-full bg-f1-border-secondary" })
      ] })) })
    ] })
  ] });
}, OB = {
  lessThanXSeconds: {
    one: "minder as 'n sekonde",
    other: "minder as {{count}} sekondes"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekondes"
  },
  halfAMinute: "'n halwe minuut",
  lessThanXMinutes: {
    one: "minder as 'n minuut",
    other: "minder as {{count}} minute"
  },
  xMinutes: {
    one: "'n minuut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} ure"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} ure"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dae"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weke"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weke"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maande"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maande"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer as 1 jaar",
    other: "meer as {{count}} jaar"
  },
  almostXYears: {
    one: "byna 1 jaar",
    other: "byna {{count}} jaar"
  }
}, WB = (t, e, n) => {
  let i;
  const r = OB[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "oor " + i : i + " gelede" : i;
}, AB = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "yyyy/MM/dd"
}, LB = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, IB = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, RB = {
  date: T({
    formats: AB,
    defaultWidth: "full"
  }),
  time: T({
    formats: LB,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: IB,
    defaultWidth: "full"
  })
}, jB = {
  lastWeek: "'verlede' eeee 'om' p",
  yesterday: "'gister om' p",
  today: "'vandag om' p",
  tomorrow: "'môre om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, FB = (t, e, n, i) => jB[t], zB = {
  narrow: ["vC", "nC"],
  abbreviated: ["vC", "nC"],
  wide: ["voor Christus", "na Christus"]
}, VB = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ste kwartaal", "2de kwartaal", "3de kwartaal", "4de kwartaal"]
}, HB = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mrt",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Des"
  ],
  wide: [
    "Januarie",
    "Februarie",
    "Maart",
    "April",
    "Mei",
    "Junie",
    "Julie",
    "Augustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]
}, BB = {
  narrow: ["S", "M", "D", "W", "D", "V", "S"],
  short: ["So", "Ma", "Di", "Wo", "Do", "Vr", "Sa"],
  abbreviated: ["Son", "Maa", "Din", "Woe", "Don", "Vry", "Sat"],
  wide: [
    "Sondag",
    "Maandag",
    "Dinsdag",
    "Woensdag",
    "Donderdag",
    "Vrydag",
    "Saterdag"
  ]
}, qB = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "middaguur",
    morning: "oggend",
    afternoon: "middag",
    evening: "laat middag",
    night: "aand"
  }
}, GB = {
  narrow: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  abbreviated: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  },
  wide: {
    am: "vm",
    pm: "nm",
    midnight: "middernag",
    noon: "uur die middag",
    morning: "uur die oggend",
    afternoon: "uur die middag",
    evening: "uur die aand",
    night: "uur die aand"
  }
}, XB = (t) => {
  const e = Number(t), n = e % 100;
  if (n < 20)
    switch (n) {
      case 1:
      case 8:
        return e + "ste";
      default:
        return e + "de";
    }
  return e + "ste";
}, YB = {
  ordinalNumber: XB,
  era: C({
    values: zB,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: VB,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: HB,
    defaultWidth: "wide"
  }),
  day: C({
    values: BB,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: qB,
    defaultWidth: "wide",
    formattingValues: GB,
    defaultFormattingWidth: "wide"
  })
}, KB = /^(\d+)(ste|de)?/i, UB = /\d+/i, JB = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?C\.?)/,
  wide: /^((voor|na) Christus)/
}, QB = {
  any: [/^v/, /^n/]
}, ZB = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](st|d)e kwartaal/i
}, eq = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, tq = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(Jan|Feb|Mrt|Apr|Mei|Jun|Jul|Aug|Sep|Okt|Nov|Dec)\.?/i,
  wide: /^(Januarie|Februarie|Maart|April|Mei|Junie|Julie|Augustus|September|Oktober|November|Desember)/i
}, nq = {
  narrow: [
    /^J/i,
    /^F/i,
    /^M/i,
    /^A/i,
    /^M/i,
    /^J/i,
    /^J/i,
    /^A/i,
    /^S/i,
    /^O/i,
    /^N/i,
    /^D/i
  ],
  any: [
    /^Jan/i,
    /^Feb/i,
    /^Mrt/i,
    /^Apr/i,
    /^Mei/i,
    /^Jun/i,
    /^Jul/i,
    /^Aug/i,
    /^Sep/i,
    /^Okt/i,
    /^Nov/i,
    /^Dec/i
  ]
}, iq = {
  narrow: /^[smdwv]/i,
  short: /^(So|Ma|Di|Wo|Do|Vr|Sa)/i,
  abbreviated: /^(Son|Maa|Din|Woe|Don|Vry|Sat)/i,
  wide: /^(Sondag|Maandag|Dinsdag|Woensdag|Donderdag|Vrydag|Saterdag)/i
}, rq = {
  narrow: [/^S/i, /^M/i, /^D/i, /^W/i, /^D/i, /^V/i, /^S/i],
  any: [/^So/i, /^Ma/i, /^Di/i, /^Wo/i, /^Do/i, /^Vr/i, /^Sa/i]
}, aq = {
  any: /^(vm|nm|middernag|(?:uur )?die (oggend|middag|aand))/i
}, oq = {
  any: {
    am: /^vm/i,
    pm: /^nm/i,
    midnight: /^middernag/i,
    noon: /^middaguur/i,
    morning: /oggend/i,
    afternoon: /middag/i,
    evening: /laat middag/i,
    night: /aand/i
  }
}, sq = {
  ordinalNumber: he({
    matchPattern: KB,
    parsePattern: UB,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: JB,
    defaultMatchWidth: "wide",
    parsePatterns: QB,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ZB,
    defaultMatchWidth: "wide",
    parsePatterns: eq,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: tq,
    defaultMatchWidth: "wide",
    parsePatterns: nq,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: iq,
    defaultMatchWidth: "wide",
    parsePatterns: rq,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: aq,
    defaultMatchWidth: "any",
    parsePatterns: oq,
    defaultParseWidth: "any"
  })
}, lq = {
  code: "af",
  formatDistance: WB,
  formatLong: RB,
  formatRelative: FB,
  localize: YB,
  match: sq,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, dq = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانيتان",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتان",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريبا",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتان",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومان",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريبا",
    two: "أسبوعين تقريبا",
    threeToTen: "{{count}} أسابيع تقريبا",
    other: "{{count}} أسبوعا تقريبا"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعان",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوعا"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريبا",
    threeToTen: "{{count}} أشهر تقريبا",
    other: "{{count}} شهرا تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهران",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهرا"
  },
  aboutXYears: {
    one: "سنة واحدة تقريباً",
    two: "سنتين تقريبا",
    threeToTen: "{{count}} سنوات تقريباً",
    other: "{{count}} سنة تقريباً"
  },
  xYears: {
    one: "سنة واحد",
    two: "سنتان",
    threeToTen: "{{count}} سنوات",
    other: "{{count}} سنة"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنوات",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "ما يقارب سنة واحدة",
    two: "ما يقارب سنتين",
    threeToTen: "ما يقارب {{count}} سنوات",
    other: "ما يقارب {{count}} سنة"
  }
}, cq = (t, e, n) => {
  const i = dq[t];
  let r;
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : e === 2 ? r = i.two : e <= 10 ? r = i.threeToTen.replace("{{count}}", String(e)) : r = i.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "خلال " + r : "منذ " + r : r;
}, uq = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, fq = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, mq = {
  full: "{{date}} 'عند الساعة' {{time}}",
  long: "{{date}} 'عند الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, hq = {
  date: T({
    formats: uq,
    defaultWidth: "full"
  }),
  time: T({
    formats: fq,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: mq,
    defaultWidth: "full"
  })
}, pq = {
  lastWeek: "eeee 'الماضي عند الساعة' p",
  yesterday: "'الأمس عند الساعة' p",
  today: "'اليوم عند الساعة' p",
  tomorrow: "'غدا عند الساعة' p",
  nextWeek: "eeee 'القادم عند الساعة' p",
  other: "P"
}, gq = (t) => pq[t], yq = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, vq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, bq = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, wq = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, kq = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "المساء",
    night: "الليل",
    midnight: "منتصف الليل"
  }
}, xq = {
  narrow: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    morning: "في الصباح",
    noon: "الظهر",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل",
    midnight: "منتصف الليل"
  }
}, _q = (t) => String(t), Mq = {
  ordinalNumber: _q,
  era: C({
    values: yq,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: vq,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: bq,
    defaultWidth: "wide"
  }),
  day: C({
    values: wq,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: kq,
    defaultWidth: "wide",
    formattingValues: xq,
    defaultFormattingWidth: "wide"
  })
}, Cq = /^(\d+)(th|st|nd|rd)?/i, Pq = /\d+/i, Sq = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, Nq = {
  any: [/قبل/, /بعد/]
}, $q = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, Dq = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Eq = {
  narrow: /^[أيفمسند]/,
  abbreviated: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, Tq = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^يناير/i,
    /^فبراير/i,
    /^مارس/i,
    /^أبريل/i,
    /^مايو/i,
    /^يونيو/i,
    /^يوليو/i,
    /^أغسطس/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i
  ]
}, Oq = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, Wq = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, Aq = {
  narrow: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/,
  any: /^(ص|م|منتصف الليل|الظهر|بعد الظهر|في الصباح|في المساء|في الليل)/
}, Lq = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /منتصف الليل/,
    noon: /الظهر/,
    afternoon: /بعد الظهر/,
    morning: /في الصباح/,
    evening: /في المساء/,
    night: /في الليل/
  }
}, Iq = {
  ordinalNumber: he({
    matchPattern: Cq,
    parsePattern: Pq,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Sq,
    defaultMatchWidth: "wide",
    parsePatterns: Nq,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: $q,
    defaultMatchWidth: "wide",
    parsePatterns: Dq,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Eq,
    defaultMatchWidth: "wide",
    parsePatterns: Tq,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Oq,
    defaultMatchWidth: "wide",
    parsePatterns: Wq,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Aq,
    defaultMatchWidth: "any",
    parsePatterns: Lq,
    defaultParseWidth: "any"
  })
}, Rq = {
  code: "ar",
  formatDistance: cq,
  formatLong: hq,
  formatRelative: gq,
  localize: Mq,
  match: Iq,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
}, jq = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, Fq = (t, e, n) => {
  n = n || {};
  const i = jq[t];
  let r;
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : e === 2 ? r = i.two : e <= 10 ? r = i.threeToTen.replace("{{count}}", String(e)) : r = i.other.replace("{{count}}", String(e)), n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + r : "منذ " + r : r;
}, zq = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, Vq = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Hq = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Bq = {
  date: T({
    formats: zq,
    defaultWidth: "full"
  }),
  time: T({
    formats: Vq,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Hq,
    defaultWidth: "full"
  })
}, qq = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, Gq = (t, e, n, i) => qq[t], Xq = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, Yq = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, Kq = {
  narrow: ["ج", "ف", "م", "أ", "م", "ج", "ج", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "جانـ",
    "فيفـ",
    "مارس",
    "أفريل",
    "مايـ",
    "جوانـ",
    "جويـ",
    "أوت",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, Uq = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, Jq = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, Qq = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, Zq = (t) => String(t), eG = {
  ordinalNumber: Zq,
  era: C({
    values: Xq,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Yq,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: Kq,
    defaultWidth: "wide"
  }),
  day: C({
    values: Uq,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Jq,
    defaultWidth: "wide",
    formattingValues: Qq,
    defaultFormattingWidth: "wide"
  })
}, tG = /^(\d+)(th|st|nd|rd)?/i, nG = /\d+/i, iG = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, rG = {
  any: [/^قبل/i, /^بعد/i]
}, aG = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, oG = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, sG = {
  narrow: /^[جفمأسند]/i,
  abbreviated: /^(جان|فيف|مار|أفر|ماي|جوا|جوي|أوت|سبت|أكت|نوف|ديس)/i,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/i
}, lG = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^جان/i,
    /^فيف/i,
    /^مار/i,
    /^أفر/i,
    /^ماي/i,
    /^جوا/i,
    /^جوي/i,
    /^أوت/i,
    /^سبت/i,
    /^أكت/i,
    /^نوف/i,
    /^ديس/i
  ]
}, dG = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, cG = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, uG = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, fG = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, mG = {
  ordinalNumber: he({
    matchPattern: tG,
    parsePattern: nG,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: iG,
    defaultMatchWidth: "wide",
    parsePatterns: rG,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: aG,
    defaultMatchWidth: "wide",
    parsePatterns: oG,
    defaultParseWidth: "any",
    valueCallback: (t) => Number(t) + 1
  }),
  month: P({
    matchPatterns: sG,
    defaultMatchWidth: "wide",
    parsePatterns: lG,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: dG,
    defaultMatchWidth: "wide",
    parsePatterns: cG,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: uG,
    defaultMatchWidth: "any",
    parsePatterns: fG,
    defaultParseWidth: "any"
  })
}, hG = {
  code: "ar-DZ",
  formatDistance: Fq,
  formatLong: Bq,
  formatRelative: Gq,
  localize: eG,
  match: mG,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, pG = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من ثانيتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "ثانيتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "حوالي ساعة",
    two: "حوالي ساعتين",
    threeToTen: "حوالي {{count}} ساعات",
    other: "حوالي {{count}} ساعة"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "حوالي أسبوع",
    two: "حوالي أسبوعين",
    threeToTen: "حوالي {{count}} أسابيع",
    other: "حوالي {{count}} أسبوع"
  },
  xWeeks: {
    one: "أسبوع",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "حوالي شهر",
    two: "حوالي شهرين",
    threeToTen: "حوالي {{count}} أشهر",
    other: "حوالي {{count}} شهر"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "حوالي سنة",
    two: "حوالي سنتين",
    threeToTen: "حوالي {{count}} سنين",
    other: "حوالي {{count}} سنة"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من سنة",
    two: "أكثر من سنتين",
    threeToTen: "أكثر من {{count}} سنين",
    other: "أكثر من {{count}} سنة"
  },
  almostXYears: {
    one: "عام تقريبًا",
    two: "عامين تقريبًا",
    threeToTen: "{{count}} أعوام تقريبًا",
    other: "{{count}} عام تقريبًا"
  }
}, gG = (t, e, n) => {
  let i;
  const r = pG[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 ? i = r.two : e <= 10 ? i = r.threeToTen.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? `في خلال ${i}` : `منذ ${i}` : i;
}, yG = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "dd/MMM/y",
  short: "d/MM/y"
}, vG = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, bG = {
  full: "{{date}} 'الساعة' {{time}}",
  long: "{{date}} 'الساعة' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, wG = {
  date: T({
    formats: yG,
    defaultWidth: "full"
  }),
  time: T({
    formats: vG,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: bG,
    defaultWidth: "full"
  })
}, kG = {
  lastWeek: "eeee 'اللي جاي الساعة' p",
  yesterday: "'إمبارح الساعة' p",
  today: "'النهاردة الساعة' p",
  tomorrow: "'بكرة الساعة' p",
  nextWeek: "eeee 'الساعة' p",
  other: "P"
}, xG = (t, e, n, i) => kG[t], _G = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م", "ب.م"],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, MG = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, CG = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, PG = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, SG = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءً",
    night: "ليلاً"
  }
}, NG = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهراً",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    morning: "في الصباح",
    noon: "ظهراً",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, $G = (t, e) => String(t), DG = {
  ordinalNumber: $G,
  era: C({
    values: _G,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: MG,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: CG,
    defaultWidth: "wide"
  }),
  day: C({
    values: PG,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: SG,
    defaultWidth: "wide",
    formattingValues: NG,
    defaultFormattingWidth: "wide"
  })
}, EG = /^(\d+)/, TG = /\d+/i, OG = {
  narrow: /^(ق|ب)/g,
  abbreviated: /^(ق.م|ب.م)/g,
  wide: /^(قبل الميلاد|بعد الميلاد)/g
}, WG = {
  any: [/^ق/g, /^ب/g]
}, AG = {
  narrow: /^[1234]/,
  abbreviated: /^ر[1234]/,
  wide: /^الربع (الأول|الثاني|الثالث|الرابع)/
}, LG = {
  wide: [/الربع الأول/, /الربع الثاني/, /الربع الثالث/, /الربع الرابع/],
  any: [/1/, /2/, /3/, /4/]
}, IG = {
  narrow: /^(ي|ف|م|أ|س|ن|د)/,
  abbreviated: /^(ينا|فبر|مارس|أبريل|مايو|يونـ|يولـ|أغسـ|سبتـ|أكتـ|نوفـ|ديسـ)/,
  wide: /^(يناير|فبراير|مارس|أبريل|مايو|يونيو|يوليو|أغسطس|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, RG = {
  narrow: [
    /^ي/,
    /^ف/,
    /^م/,
    /^أ/,
    /^م/,
    /^ي/,
    /^ي/,
    /^أ/,
    /^س/,
    /^أ/,
    /^ن/,
    /^د/
  ],
  any: [
    /^ينا/,
    /^فبر/,
    /^مارس/,
    /^أبريل/,
    /^مايو/,
    /^يون/,
    /^يول/,
    /^أغس/,
    /^سبت/,
    /^أكت/,
    /^نوف/,
    /^ديس/
  ]
}, jG = {
  narrow: /^(ح|ن|ث|ر|خ|ج|س)/,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/
}, FG = {
  narrow: [/^ح/, /^ن/, /^ث/, /^ر/, /^خ/, /^ج/, /^س/],
  any: [/أحد/, /اثنين/, /ثلاثاء/, /أربعاء/, /خميس/, /جمعة/, /سبت/]
}, zG = {
  narrow: /^(ص|م|ن|ظ|في الصباح|بعد الظهر|في المساء|في الليل)/,
  abbreviated: /^(ص|م|نصف الليل|ظهراً|في الصباح|بعد الظهر|في المساء|في الليل)/,
  wide: /^(ص|م|نصف الليل|في الصباح|ظهراً|بعد الظهر|في المساء|في الليل)/,
  any: /^(ص|م|صباح|ظهر|مساء|ليل)/
}, VG = {
  any: {
    am: /^ص/,
    pm: /^م/,
    midnight: /^ن/,
    noon: /^ظ/,
    morning: /^ص/,
    afternoon: /^بعد/,
    evening: /^م/,
    night: /^ل/
  }
}, HG = {
  ordinalNumber: he({
    matchPattern: EG,
    parsePattern: TG,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: OG,
    defaultMatchWidth: "wide",
    parsePatterns: WG,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: AG,
    defaultMatchWidth: "wide",
    parsePatterns: LG,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: IG,
    defaultMatchWidth: "wide",
    parsePatterns: RG,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: jG,
    defaultMatchWidth: "wide",
    parsePatterns: FG,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: zG,
    defaultMatchWidth: "any",
    parsePatterns: VG,
    defaultParseWidth: "any"
  })
}, BG = {
  code: "ar-EG",
  formatDistance: gG,
  formatLong: wG,
  formatRelative: xG,
  localize: DG,
  match: HG,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, qG = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, GG = (t, e, n) => {
  n = n || {};
  const i = qG[t];
  let r;
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : e === 2 ? r = i.two : e <= 10 ? r = i.threeToTen.replace("{{count}}", String(e)) : r = i.other.replace("{{count}}", String(e)), n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + r : "منذ " + r : r;
}, XG = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, YG = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, KG = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, UG = {
  date: T({
    formats: XG,
    defaultWidth: "full"
  }),
  time: T({
    formats: YG,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: KG,
    defaultWidth: "full"
  })
}, JG = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, QG = (t, e, n, i) => JG[t], ZG = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, eX = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, tX = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "غ", "ش", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "ماي",
    "يونـ",
    "يولـ",
    "غشت",
    "شتنـ",
    "أكتـ",
    "نونـ",
    "دجنـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "ماي",
    "يونيو",
    "يوليوز",
    "غشت",
    "شتنبر",
    "أكتوبر",
    "نونبر",
    "دجنبر"
  ]
}, nX = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الإثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, iX = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, rX = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, aX = (t) => String(t), oX = {
  ordinalNumber: aX,
  era: C({
    values: ZG,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: eX,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: tX,
    defaultWidth: "wide"
  }),
  day: C({
    values: nX,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: iX,
    defaultWidth: "wide",
    formattingValues: rX,
    defaultFormattingWidth: "wide"
  })
}, sX = /^(\d+)(th|st|nd|rd)?/i, lX = /\d+/i, dX = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, cX = {
  any: [/^قبل/i, /^بعد/i]
}, uX = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, fX = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, mX = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|غش|شت|أك|ن|د)/i
}, hX = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^غ/i,
    /^ش/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ين/i,
    /^فب/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^غشت/i,
    /^ش/i,
    /^أك/i,
    /^ن/i,
    /^د/i
  ]
}, pX = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|إثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|إثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الإثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, gX = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الإثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^إث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, yX = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, vX = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, bX = {
  ordinalNumber: he({
    matchPattern: sX,
    parsePattern: lX,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: dX,
    defaultMatchWidth: "wide",
    parsePatterns: cX,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: uX,
    defaultMatchWidth: "wide",
    parsePatterns: fX,
    defaultParseWidth: "any",
    valueCallback: (t) => Number(t) + 1
  }),
  month: P({
    matchPatterns: mX,
    defaultMatchWidth: "wide",
    parsePatterns: hX,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: pX,
    defaultMatchWidth: "wide",
    parsePatterns: gX,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: yX,
    defaultMatchWidth: "any",
    parsePatterns: vX,
    defaultParseWidth: "any"
  })
}, wX = {
  code: "ar-MA",
  formatDistance: GG,
  formatLong: UG,
  formatRelative: QG,
  localize: oX,
  match: bX,
  options: {
    // Monday is 1
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, kX = {
  lessThanXSeconds: {
    one: "أقل من ثانية واحدة",
    two: "أقل من ثانتين",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية واحدة",
    two: "ثانتين",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نصف دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقائق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة واحدة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقائق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة واحدة تقريباً",
    two: "ساعتين تقريباً",
    threeToTen: "{{count}} ساعات تقريباً",
    other: "{{count}} ساعة تقريباً"
  },
  xHours: {
    one: "ساعة واحدة",
    two: "ساعتين",
    threeToTen: "{{count}} ساعات",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "يوم واحد",
    two: "يومين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "أسبوع واحد تقريباً",
    two: "أسبوعين تقريباً",
    threeToTen: "{{count}} أسابيع تقريباً",
    other: "{{count}} أسبوع تقريباً"
  },
  xWeeks: {
    one: "أسبوع واحد",
    two: "أسبوعين",
    threeToTen: "{{count}} أسابيع",
    other: "{{count}} أسبوع"
  },
  aboutXMonths: {
    one: "شهر واحد تقريباً",
    two: "شهرين تقريباً",
    threeToTen: "{{count}} أشهر تقريباً",
    other: "{{count}} شهر تقريباً"
  },
  xMonths: {
    one: "شهر واحد",
    two: "شهرين",
    threeToTen: "{{count}} أشهر",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  },
  xYears: {
    one: "عام واحد",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام واحد تقريباً",
    two: "عامين تقريباً",
    threeToTen: "{{count}} أعوام تقريباً",
    other: "{{count}} عام تقريباً"
  }
}, xX = (t, e, n) => {
  let i;
  const r = kX[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 ? i = r.two : e <= 10 ? i = r.threeToTen.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "في خلال " + i : "منذ " + i : i;
}, _X = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, MX = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, CX = {
  full: "{{date}} 'عند' {{time}}",
  long: "{{date}} 'عند' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, PX = {
  date: T({
    formats: _X,
    defaultWidth: "full"
  }),
  time: T({
    formats: MX,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: CX,
    defaultWidth: "full"
  })
}, SX = {
  lastWeek: "'أخر' eeee 'عند' p",
  yesterday: "'أمس عند' p",
  today: "'اليوم عند' p",
  tomorrow: "'غداً عند' p",
  nextWeek: "eeee 'عند' p",
  other: "P"
}, NX = (t, e, n, i) => SX[t], $X = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, DX = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, EX = {
  narrow: ["ي", "ف", "م", "أ", "م", "ي", "ي", "أ", "س", "أ", "ن", "د"],
  abbreviated: [
    "ينا",
    "فبر",
    "مارس",
    "أبريل",
    "مايو",
    "يونـ",
    "يولـ",
    "أغسـ",
    "سبتـ",
    "أكتـ",
    "نوفـ",
    "ديسـ"
  ],
  wide: [
    "يناير",
    "فبراير",
    "مارس",
    "أبريل",
    "مايو",
    "يونيو",
    "يوليو",
    "أغسطس",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, TX = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنـ", "ثلا", "أربـ", "خميـ", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, OX = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظهر",
    evening: "مساءاً",
    night: "ليلاً"
  }
}, WX = {
  narrow: {
    am: "ص",
    pm: "م",
    midnight: "ن",
    noon: "ظ",
    morning: "في الصباح",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "في الصباح",
    afternoon: "بعد الظهر",
    evening: "في المساء",
    night: "في الليل"
  },
  wide: {
    am: "ص",
    pm: "م",
    midnight: "نصف الليل",
    noon: "ظهر",
    morning: "صباحاً",
    afternoon: "بعد الظـهر",
    evening: "في المساء",
    night: "في الليل"
  }
}, AX = (t) => String(t), LX = {
  ordinalNumber: AX,
  era: C({
    values: $X,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: DX,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: EX,
    defaultWidth: "wide"
  }),
  day: C({
    values: TX,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: OX,
    defaultWidth: "wide",
    formattingValues: WX,
    defaultFormattingWidth: "wide"
  })
}, IX = /^(\d+)(th|st|nd|rd)?/i, RX = /\d+/i, jX = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?م\.?\s?|a\.?\s?d\.?|c\.?\s?)/i,
  wide: /^(قبل الميلاد|قبل الميلاد|بعد الميلاد|بعد الميلاد)/i
}, FX = {
  any: [/^قبل/i, /^بعد/i]
}, zX = {
  narrow: /^[1234]/i,
  abbreviated: /^ر[1234]/i,
  wide: /^الربع [1234]/i
}, VX = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HX = {
  narrow: /^[يفمأمسند]/i,
  abbreviated: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i,
  wide: /^(ين|ف|مار|أب|ماي|يون|يول|أغ|س|أك|ن|د)/i
}, BX = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ي/i,
    /^ي/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ين/i,
    /^ف/i,
    /^مار/i,
    /^أب/i,
    /^ماي/i,
    /^يون/i,
    /^يول/i,
    /^أغ/i,
    /^س/i,
    /^أك/i,
    /^ن/i,
    /^د/i
  ]
}, qX = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثن|ثلا|أرب|خمي|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, GX = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, XX = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
}, YX = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
}, KX = {
  ordinalNumber: he({
    matchPattern: IX,
    parsePattern: RX,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: jX,
    defaultMatchWidth: "wide",
    parsePatterns: FX,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: zX,
    defaultMatchWidth: "wide",
    parsePatterns: VX,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: HX,
    defaultMatchWidth: "wide",
    parsePatterns: BX,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: qX,
    defaultMatchWidth: "wide",
    parsePatterns: GX,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: XX,
    defaultMatchWidth: "any",
    parsePatterns: YX,
    defaultParseWidth: "any"
  })
}, UX = {
  code: "ar-SA",
  formatDistance: xX,
  formatLong: PX,
  formatRelative: NX,
  localize: LX,
  match: KX,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, JX = {
  lessThanXSeconds: {
    one: "أقل من ثانية",
    two: "أقل من زوز ثواني",
    threeToTen: "أقل من {{count}} ثواني",
    other: "أقل من {{count}} ثانية"
  },
  xSeconds: {
    one: "ثانية",
    two: "زوز ثواني",
    threeToTen: "{{count}} ثواني",
    other: "{{count}} ثانية"
  },
  halfAMinute: "نص دقيقة",
  lessThanXMinutes: {
    one: "أقل من دقيقة",
    two: "أقل من دقيقتين",
    threeToTen: "أقل من {{count}} دقايق",
    other: "أقل من {{count}} دقيقة"
  },
  xMinutes: {
    one: "دقيقة",
    two: "دقيقتين",
    threeToTen: "{{count}} دقايق",
    other: "{{count}} دقيقة"
  },
  aboutXHours: {
    one: "ساعة تقريب",
    two: "ساعتين تقريب",
    threeToTen: "{{count}} سوايع تقريب",
    other: "{{count}} ساعة تقريب"
  },
  xHours: {
    one: "ساعة",
    two: "ساعتين",
    threeToTen: "{{count}} سوايع",
    other: "{{count}} ساعة"
  },
  xDays: {
    one: "نهار",
    two: "نهارين",
    threeToTen: "{{count}} أيام",
    other: "{{count}} يوم"
  },
  aboutXWeeks: {
    one: "جمعة تقريب",
    two: "جمعتين تقريب",
    threeToTen: "{{count}} جماع تقريب",
    other: "{{count}} جمعة تقريب"
  },
  xWeeks: {
    one: "جمعة",
    two: "جمعتين",
    threeToTen: "{{count}} جماع",
    other: "{{count}} جمعة"
  },
  aboutXMonths: {
    one: "شهر تقريب",
    two: "شهرين تقريب",
    threeToTen: "{{count}} أشهرة تقريب",
    other: "{{count}} شهر تقريب"
  },
  xMonths: {
    one: "شهر",
    two: "شهرين",
    threeToTen: "{{count}} أشهرة",
    other: "{{count}} شهر"
  },
  aboutXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  },
  xYears: {
    one: "عام",
    two: "عامين",
    threeToTen: "{{count}} أعوام",
    other: "{{count}} عام"
  },
  overXYears: {
    one: "أكثر من عام",
    two: "أكثر من عامين",
    threeToTen: "أكثر من {{count}} أعوام",
    other: "أكثر من {{count}} عام"
  },
  almostXYears: {
    one: "عام تقريب",
    two: "عامين تقريب",
    threeToTen: "{{count}} أعوام تقريب",
    other: "{{count}} عام تقريب"
  }
}, QX = (t, e, n) => {
  const i = JX[t];
  let r;
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : e === 2 ? r = i.two : e <= 10 ? r = i.threeToTen.replace("{{count}}", String(e)) : r = i.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "في " + r : "عندو " + r : r;
}, ZX = {
  full: "EEEE، do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, eY = {
  full: "HH:mm:ss",
  long: "HH:mm:ss",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, tY = {
  full: "{{date}} 'مع' {{time}}",
  long: "{{date}} 'مع' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nY = {
  date: T({
    formats: ZX,
    defaultWidth: "full"
  }),
  time: T({
    formats: eY,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: tY,
    defaultWidth: "full"
  })
}, iY = {
  lastWeek: "eeee 'إلي فات مع' p",
  yesterday: "'البارح مع' p",
  today: "'اليوم مع' p",
  tomorrow: "'غدوة مع' p",
  nextWeek: "eeee 'الجمعة الجاية مع' p 'نهار'",
  other: "P"
}, rY = (t) => iY[t], aY = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل الميلاد", "بعد الميلاد"]
}, oY = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ر1", "ر2", "ر3", "ر4"],
  wide: ["الربع الأول", "الربع الثاني", "الربع الثالث", "الربع الرابع"]
}, sY = {
  narrow: ["د", "ن", "أ", "س", "أ", "ج", "ج", "م", "أ", "م", "ف", "ج"],
  abbreviated: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ],
  wide: [
    "جانفي",
    "فيفري",
    "مارس",
    "أفريل",
    "ماي",
    "جوان",
    "جويلية",
    "أوت",
    "سبتمبر",
    "أكتوبر",
    "نوفمبر",
    "ديسمبر"
  ]
}, lY = {
  narrow: ["ح", "ن", "ث", "ر", "خ", "ج", "س"],
  short: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  abbreviated: ["أحد", "اثنين", "ثلاثاء", "أربعاء", "خميس", "جمعة", "سبت"],
  wide: [
    "الأحد",
    "الاثنين",
    "الثلاثاء",
    "الأربعاء",
    "الخميس",
    "الجمعة",
    "السبت"
  ]
}, dY = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "الصباح",
    noon: "القايلة",
    afternoon: "بعد القايلة",
    evening: "العشية",
    night: "الليل",
    midnight: "نص الليل"
  }
}, cY = {
  narrow: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  abbreviated: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  },
  wide: {
    am: "ص",
    pm: "ع",
    morning: "في الصباح",
    noon: "في القايلة",
    afternoon: "بعد القايلة",
    evening: "في العشية",
    night: "في الليل",
    midnight: "نص الليل"
  }
}, uY = (t) => String(t), fY = {
  ordinalNumber: uY,
  era: C({
    values: aY,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: oY,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: sY,
    defaultWidth: "wide"
  }),
  day: C({
    values: lY,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: dY,
    defaultWidth: "wide",
    formattingValues: cY,
    defaultFormattingWidth: "wide"
  })
}, mY = /^(\d+)(th|st|nd|rd)?/i, hY = /\d+/i, pY = {
  narrow: /[قب]/,
  abbreviated: /[قب]\.م\./,
  wide: /(قبل|بعد) الميلاد/
}, gY = {
  any: [/قبل/, /بعد/]
}, yY = {
  narrow: /^[1234]/i,
  abbreviated: /ر[1234]/,
  wide: /الربع (الأول|الثاني|الثالث|الرابع)/
}, vY = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bY = {
  narrow: /^[جفمأسند]/,
  abbreviated: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/,
  wide: /^(جانفي|فيفري|مارس|أفريل|ماي|جوان|جويلية|أوت|سبتمبر|أكتوبر|نوفمبر|ديسمبر)/
}, wY = {
  narrow: [
    /^ج/i,
    /^ف/i,
    /^م/i,
    /^أ/i,
    /^م/i,
    /^ج/i,
    /^ج/i,
    /^أ/i,
    /^س/i,
    /^أ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^جانفي/i,
    /^فيفري/i,
    /^مارس/i,
    /^أفريل/i,
    /^ماي/i,
    /^جوان/i,
    /^جويلية/i,
    /^أوت/i,
    /^سبتمبر/i,
    /^أكتوبر/i,
    /^نوفمبر/i,
    /^ديسمبر/i
  ]
}, kY = {
  narrow: /^[حنثرخجس]/i,
  short: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  abbreviated: /^(أحد|اثنين|ثلاثاء|أربعاء|خميس|جمعة|سبت)/i,
  wide: /^(الأحد|الاثنين|الثلاثاء|الأربعاء|الخميس|الجمعة|السبت)/i
}, xY = {
  narrow: [/^ح/i, /^ن/i, /^ث/i, /^ر/i, /^خ/i, /^ج/i, /^س/i],
  wide: [
    /^الأحد/i,
    /^الاثنين/i,
    /^الثلاثاء/i,
    /^الأربعاء/i,
    /^الخميس/i,
    /^الجمعة/i,
    /^السبت/i
  ],
  any: [/^أح/i, /^اث/i, /^ث/i, /^أر/i, /^خ/i, /^ج/i, /^س/i]
}, _Y = {
  narrow: /^(ص|ع|ن ل|ل|(في|مع) (صباح|قايلة|عشية|ليل))/,
  any: /^([صع]|نص الليل|قايلة|(في|مع) (صباح|قايلة|عشية|ليل))/
}, MY = {
  any: {
    am: /^ص/,
    pm: /^ع/,
    midnight: /نص الليل/,
    noon: /قايلة/,
    afternoon: /بعد القايلة/,
    morning: /صباح/,
    evening: /عشية/,
    night: /ليل/
  }
}, CY = {
  ordinalNumber: he({
    matchPattern: mY,
    parsePattern: hY,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: pY,
    defaultMatchWidth: "wide",
    parsePatterns: gY,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: yY,
    defaultMatchWidth: "wide",
    parsePatterns: vY,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: bY,
    defaultMatchWidth: "wide",
    parsePatterns: wY,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: kY,
    defaultMatchWidth: "wide",
    parsePatterns: xY,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: _Y,
    defaultMatchWidth: "any",
    parsePatterns: MY,
    defaultParseWidth: "any"
  })
}, PY = {
  code: "ar-TN",
  formatDistance: QX,
  formatLong: nY,
  formatRelative: rY,
  localize: fY,
  match: CY,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, SY = {
  lessThanXSeconds: {
    one: "bir saniyədən az",
    other: "{{count}} bir saniyədən az"
  },
  xSeconds: {
    one: "1 saniyə",
    other: "{{count}} saniyə"
  },
  halfAMinute: "yarım dəqiqə",
  lessThanXMinutes: {
    one: "bir dəqiqədən az",
    other: "{{count}} bir dəqiqədən az"
  },
  xMinutes: {
    one: "bir dəqiqə",
    other: "{{count}} dəqiqə"
  },
  aboutXHours: {
    one: "təxminən 1 saat",
    other: "təxminən {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "təxminən 1 həftə",
    other: "təxminən {{count}} həftə"
  },
  xWeeks: {
    one: "1 həftə",
    other: "{{count}} həftə"
  },
  aboutXMonths: {
    one: "təxminən 1 ay",
    other: "təxminən {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "təxminən 1 il",
    other: "təxminən {{count}} il"
  },
  xYears: {
    one: "1 il",
    other: "{{count}} il"
  },
  overXYears: {
    one: "1 ildən çox",
    other: "{{count}} ildən çox"
  },
  almostXYears: {
    one: "demək olar ki 1 il",
    other: "demək olar ki {{count}} il"
  }
}, NY = (t, e, n) => {
  let i;
  const r = SY[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " sonra" : i + " əvvəl" : i;
}, $Y = {
  full: "EEEE, do MMMM y 'il'",
  long: "do MMMM y 'il'",
  medium: "d MMM y 'il'",
  short: "dd.MM.yyyy"
}, DY = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, EY = {
  full: "{{date}} {{time}} - 'də'",
  long: "{{date}} {{time}} - 'də'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, TY = {
  date: T({
    formats: $Y,
    defaultWidth: "full"
  }),
  time: T({
    formats: DY,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: EY,
    defaultWidth: "full"
  })
}, OY = {
  lastWeek: "'sonuncu' eeee p -'də'",
  yesterday: "'dünən' p -'də'",
  today: "'bugün' p -'də'",
  tomorrow: "'sabah' p -'də'",
  nextWeek: "eeee p -'də'",
  other: "P"
}, WY = (t, e, n, i) => OY[t], AY = {
  narrow: ["e.ə", "b.e"],
  abbreviated: ["e.ə", "b.e"],
  wide: ["eramızdan əvvəl", "bizim era"]
}, LY = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1ci kvartal", "2ci kvartal", "3cü kvartal", "4cü kvartal"]
}, IY = {
  narrow: ["Y", "F", "M", "A", "M", "İ", "İ", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "İyun",
    "İyul",
    "Avq",
    "Sen",
    "Okt",
    "Noy",
    "Dek"
  ],
  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "İyun",
    "İyul",
    "Avqust",
    "Sentyabr",
    "Oktyabr",
    "Noyabr",
    "Dekabr"
  ]
}, RY = {
  narrow: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  short: ["B.", "B.e", "Ç.a", "Ç.", "C.a", "C.", "Ş."],
  abbreviated: ["Baz", "Baz.e", "Çər.a", "Çər", "Cüm.a", "Cüm", "Şə"],
  wide: [
    "Bazar",
    "Bazar ertəsi",
    "Çərşənbə axşamı",
    "Çərşənbə",
    "Cümə axşamı",
    "Cümə",
    "Şənbə"
  ]
}, jY = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, FY = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gecəyarı",
    noon: "gün",
    morning: "səhər",
    afternoon: "gündüz",
    evening: "axşam",
    night: "gecə"
  }
}, gl = {
  1: "-inci",
  5: "-inci",
  8: "-inci",
  70: "-inci",
  80: "-inci",
  2: "-nci",
  7: "-nci",
  20: "-nci",
  50: "-nci",
  3: "-üncü",
  4: "-üncü",
  100: "-üncü",
  6: "-ncı",
  9: "-uncu",
  10: "-uncu",
  30: "-uncu",
  60: "-ıncı",
  90: "-ıncı"
}, zY = (t) => {
  if (t === 0)
    return t + "-ıncı";
  const e = t % 10, n = t % 100 - e, i = t >= 100 ? 100 : null;
  return gl[e] ? gl[e] : gl[n] ? gl[n] : i !== null ? gl[i] : "";
}, VY = (t, e) => {
  const n = Number(t), i = zY(n);
  return n + i;
}, HY = {
  ordinalNumber: VY,
  era: C({
    values: AY,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: LY,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: IY,
    defaultWidth: "wide"
  }),
  day: C({
    values: RY,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: jY,
    defaultWidth: "wide",
    formattingValues: FY,
    defaultFormattingWidth: "wide"
  })
}, BY = /^(\d+)(-?(ci|inci|nci|uncu|üncü|ncı))?/i, qY = /\d+/i, GY = {
  narrow: /^(b|a)$/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)$/i,
  wide: /^(bizim eradan əvvəl|bizim era)$/i
}, XY = {
  any: [/^b$/i, /^(a|c)$/i]
}, YY = {
  narrow: /^[1234]$/i,
  abbreviated: /^K[1234]$/i,
  wide: /^[1234](ci)? kvartal$/i
}, KY = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, UY = {
  narrow: /^[(?-i)yfmaisond]$/i,
  abbreviated: /^(Yan|Fev|Mar|Apr|May|İyun|İyul|Avq|Sen|Okt|Noy|Dek)$/i,
  wide: /^(Yanvar|Fevral|Mart|Aprel|May|İyun|İyul|Avgust|Sentyabr|Oktyabr|Noyabr|Dekabr)$/i
}, JY = {
  narrow: [
    /^[(?-i)y]$/i,
    /^[(?-i)f]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)m]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)i]$/i,
    /^[(?-i)a]$/i,
    /^[(?-i)s]$/i,
    /^[(?-i)o]$/i,
    /^[(?-i)n]$/i,
    /^[(?-i)d]$/i
  ],
  abbreviated: [
    /^Yan$/i,
    /^Fev$/i,
    /^Mar$/i,
    /^Apr$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avg$/i,
    /^Sen$/i,
    /^Okt$/i,
    /^Noy$/i,
    /^Dek$/i
  ],
  wide: [
    /^Yanvar$/i,
    /^Fevral$/i,
    /^Mart$/i,
    /^Aprel$/i,
    /^May$/i,
    /^İyun$/i,
    /^İyul$/i,
    /^Avgust$/i,
    /^Sentyabr$/i,
    /^Oktyabr$/i,
    /^Noyabr$/i,
    /^Dekabr$/i
  ]
}, QY = {
  narrow: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  short: /^(B\.|B\.e|Ç\.a|Ç\.|C\.a|C\.|Ş\.)$/i,
  abbreviated: /^(Baz\.e|Çər|Çər\.a|Cüm|Cüm\.a|Şə)$/i,
  wide: /^(Bazar|Bazar ertəsi|Çərşənbə axşamı|Çərşənbə|Cümə axşamı|Cümə|Şənbə)$/i
}, ZY = {
  narrow: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i
  ],
  abbreviated: [
    /^Baz$/i,
    /^Baz\.e$/i,
    /^Çər\.a$/i,
    /^Çər$/i,
    /^Cüm\.a$/i,
    /^Cüm$/i,
    /^Şə$/i
  ],
  wide: [
    /^Bazar$/i,
    /^Bazar ertəsi$/i,
    /^Çərşənbə axşamı$/i,
    /^Çərşənbə$/i,
    /^Cümə axşamı$/i,
    /^Cümə$/i,
    /^Şənbə$/i
  ],
  any: [
    /^B\.$/i,
    /^B\.e$/i,
    /^Ç\.a$/i,
    /^Ç\.$/i,
    /^C\.a$/i,
    /^C\.$/i,
    /^Ş\.$/i
  ]
}, eK = {
  narrow: /^(a|p|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i,
  any: /^(am|pm|a\.m\.|p\.m\.|AM|PM|gecəyarı|gün|səhər|gündüz|axşam|gecə)$/i
}, tK = {
  any: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /^gecəyarı$/i,
    noon: /^gün$/i,
    morning: /səhər$/i,
    afternoon: /gündüz$/i,
    evening: /axşam$/i,
    night: /gecə$/i
  }
}, nK = {
  ordinalNumber: he({
    matchPattern: BY,
    parsePattern: qY,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: GY,
    defaultMatchWidth: "wide",
    parsePatterns: XY,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: YY,
    defaultMatchWidth: "wide",
    parsePatterns: KY,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: UY,
    defaultMatchWidth: "wide",
    parsePatterns: JY,
    defaultParseWidth: "narrow"
  }),
  day: P({
    matchPatterns: QY,
    defaultMatchWidth: "wide",
    parsePatterns: ZY,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: eK,
    defaultMatchWidth: "any",
    parsePatterns: tK,
    defaultParseWidth: "any"
  })
}, iK = {
  code: "az",
  formatDistance: NY,
  formatLong: TY,
  formatRelative: WY,
  localize: HY,
  match: nK,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function yl(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  const n = e % 10, i = e % 100;
  return n === 1 && i !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (i < 10 || i > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function Pn(t) {
  return (e, n) => n && n.addSuffix ? n.comparison && n.comparison > 0 ? t.future ? yl(t.future, e) : "праз " + yl(t.regular, e) : t.past ? yl(t.past, e) : yl(t.regular, e) + " таму" : yl(t.regular, e);
}
const rK = (t, e) => e && e.addSuffix ? e.comparison && e.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны", aK = {
  lessThanXSeconds: Pn({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: Pn({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: rK,
  lessThanXMinutes: Pn({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: Pn({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: Pn({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: Pn({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: Pn({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: Pn({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў"
    }
  }),
  xWeeks: Pn({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў"
    }
  }),
  aboutXMonths: Pn({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: Pn({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: Pn({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: Pn({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: Pn({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: Pn({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, oK = (t, e, n) => (n = n || {}, aK[t](e, n)), sK = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, lK = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, dK = {
  any: "{{date}}, {{time}}"
}, cK = {
  date: T({
    formats: sK,
    defaultWidth: "full"
  }),
  time: T({
    formats: lK,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: dK,
    defaultWidth: "any"
  })
}, a0 = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацвер",
  "пятніцу",
  "суботу"
];
function uK(t) {
  const e = a0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + e + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + e + " а' p";
  }
}
function lP(t) {
  return "'у " + a0[t] + " а' p";
}
function fK(t) {
  const e = a0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + e + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + e + " а' p";
  }
}
const mK = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? lP(r) : uK(r);
}, hK = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? lP(r) : fK(r);
}, pK = {
  lastWeek: mK,
  yesterday: "'учора а' p",
  today: "'сёння а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: hK,
  other: "P"
}, gK = (t, e, n, i) => {
  const r = pK[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, yK = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, vK = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, bK = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "май",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж."
  ],
  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "май",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "снежань"
  ]
}, wK = {
  narrow: ["С", "Л", "С", "К", "М", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "мая",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "снеж."
  ],
  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "мая",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "снежня"
  ]
}, kK = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чац", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацвер",
    "пятніца",
    "субота"
  ]
}, xK = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, _K = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, MK = (t, e) => {
  const n = String(e == null ? void 0 : e.unit), i = Number(t);
  let r;
  return n === "date" ? r = "-га" : n === "hour" || n === "minute" || n === "second" ? r = "-я" : r = (i % 10 === 2 || i % 10 === 3) && i % 100 !== 12 && i % 100 !== 13 ? "-і" : "-ы", i + r;
}, CK = {
  ordinalNumber: MK,
  era: C({
    values: yK,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: vK,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: bK,
    defaultWidth: "wide",
    formattingValues: wK,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: kK,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: xK,
    defaultWidth: "any",
    formattingValues: _K,
    defaultFormattingWidth: "wide"
  })
}, PK = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, SK = /\d+/i, NK = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, $K = {
  any: [/^д/i, /^н/i]
}, DK = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, EK = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, TK = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|ма[йя]|чэрв|ліп|жн|вер|кастр|ліст|снеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|ма[йя]|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|снеж(ань|ня))/i
}, OK = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^м/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i
  ],
  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^ма/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i
  ]
}, WK = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцв|чац|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, AK = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, LK = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, IK = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, RK = {
  ordinalNumber: he({
    matchPattern: PK,
    parsePattern: SK,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: NK,
    defaultMatchWidth: "wide",
    parsePatterns: $K,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: DK,
    defaultMatchWidth: "wide",
    parsePatterns: EK,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: TK,
    defaultMatchWidth: "wide",
    parsePatterns: OK,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: WK,
    defaultMatchWidth: "wide",
    parsePatterns: AK,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: LK,
    defaultMatchWidth: "wide",
    parsePatterns: IK,
    defaultParseWidth: "any"
  })
}, jK = {
  code: "be",
  formatDistance: oK,
  formatLong: cK,
  formatRelative: gK,
  localize: CK,
  match: RK,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function vl(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  const n = e % 10, i = e % 100;
  return n === 1 && i !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (i < 10 || i > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function Sn(t) {
  return (e, n) => n && n.addSuffix ? n.comparison && n.comparison > 0 ? t.future ? vl(t.future, e) : "праз " + vl(t.regular, e) : t.past ? vl(t.past, e) : vl(t.regular, e) + " таму" : vl(t.regular, e);
}
const FK = (t, e) => e && e.addSuffix ? e.comparison && e.comparison > 0 ? "праз паўхвіліны" : "паўхвіліны таму" : "паўхвіліны", zK = {
  lessThanXSeconds: Sn({
    regular: {
      one: "менш за секунду",
      singularNominative: "менш за {{count}} секунду",
      singularGenitive: "менш за {{count}} секунды",
      pluralGenitive: "менш за {{count}} секунд"
    },
    future: {
      one: "менш, чым праз секунду",
      singularNominative: "менш, чым праз {{count}} секунду",
      singularGenitive: "менш, чым праз {{count}} секунды",
      pluralGenitive: "менш, чым праз {{count}} секунд"
    }
  }),
  xSeconds: Sn({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду таму",
      singularGenitive: "{{count}} секунды таму",
      pluralGenitive: "{{count}} секунд таму"
    },
    future: {
      singularNominative: "праз {{count}} секунду",
      singularGenitive: "праз {{count}} секунды",
      pluralGenitive: "праз {{count}} секунд"
    }
  }),
  halfAMinute: FK,
  lessThanXMinutes: Sn({
    regular: {
      one: "менш за хвіліну",
      singularNominative: "менш за {{count}} хвіліну",
      singularGenitive: "менш за {{count}} хвіліны",
      pluralGenitive: "менш за {{count}} хвілін"
    },
    future: {
      one: "менш, чым праз хвіліну",
      singularNominative: "менш, чым праз {{count}} хвіліну",
      singularGenitive: "менш, чым праз {{count}} хвіліны",
      pluralGenitive: "менш, чым праз {{count}} хвілін"
    }
  }),
  xMinutes: Sn({
    regular: {
      singularNominative: "{{count}} хвіліна",
      singularGenitive: "{{count}} хвіліны",
      pluralGenitive: "{{count}} хвілін"
    },
    past: {
      singularNominative: "{{count}} хвіліну таму",
      singularGenitive: "{{count}} хвіліны таму",
      pluralGenitive: "{{count}} хвілін таму"
    },
    future: {
      singularNominative: "праз {{count}} хвіліну",
      singularGenitive: "праз {{count}} хвіліны",
      pluralGenitive: "праз {{count}} хвілін"
    }
  }),
  aboutXHours: Sn({
    regular: {
      singularNominative: "каля {{count}} гадзіны",
      singularGenitive: "каля {{count}} гадзін",
      pluralGenitive: "каля {{count}} гадзін"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} гадзіну",
      singularGenitive: "прыблізна праз {{count}} гадзіны",
      pluralGenitive: "прыблізна праз {{count}} гадзін"
    }
  }),
  xHours: Sn({
    regular: {
      singularNominative: "{{count}} гадзіна",
      singularGenitive: "{{count}} гадзіны",
      pluralGenitive: "{{count}} гадзін"
    },
    past: {
      singularNominative: "{{count}} гадзіну таму",
      singularGenitive: "{{count}} гадзіны таму",
      pluralGenitive: "{{count}} гадзін таму"
    },
    future: {
      singularNominative: "праз {{count}} гадзіну",
      singularGenitive: "праз {{count}} гадзіны",
      pluralGenitive: "праз {{count}} гадзін"
    }
  }),
  xDays: Sn({
    regular: {
      singularNominative: "{{count}} дзень",
      singularGenitive: "{{count}} дні",
      pluralGenitive: "{{count}} дзён"
    }
  }),
  aboutXWeeks: Sn({
    regular: {
      singularNominative: "каля {{count}} тыдні",
      singularGenitive: "каля {{count}} тыдняў",
      pluralGenitive: "каля {{count}} тыдняў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} тыдзень",
      singularGenitive: "прыблізна праз {{count}} тыдні",
      pluralGenitive: "прыблізна праз {{count}} тыдняў"
    }
  }),
  xWeeks: Sn({
    regular: {
      singularNominative: "{{count}} тыдзень",
      singularGenitive: "{{count}} тыдні",
      pluralGenitive: "{{count}} тыдняў"
    }
  }),
  aboutXMonths: Sn({
    regular: {
      singularNominative: "каля {{count}} месяца",
      singularGenitive: "каля {{count}} месяцаў",
      pluralGenitive: "каля {{count}} месяцаў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} месяц",
      singularGenitive: "прыблізна праз {{count}} месяцы",
      pluralGenitive: "прыблізна праз {{count}} месяцаў"
    }
  }),
  xMonths: Sn({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяцы",
      pluralGenitive: "{{count}} месяцаў"
    }
  }),
  aboutXYears: Sn({
    regular: {
      singularNominative: "каля {{count}} года",
      singularGenitive: "каля {{count}} гадоў",
      pluralGenitive: "каля {{count}} гадоў"
    },
    future: {
      singularNominative: "прыблізна праз {{count}} год",
      singularGenitive: "прыблізна праз {{count}} гады",
      pluralGenitive: "прыблізна праз {{count}} гадоў"
    }
  }),
  xYears: Sn({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} гады",
      pluralGenitive: "{{count}} гадоў"
    }
  }),
  overXYears: Sn({
    regular: {
      singularNominative: "больш за {{count}} год",
      singularGenitive: "больш за {{count}} гады",
      pluralGenitive: "больш за {{count}} гадоў"
    },
    future: {
      singularNominative: "больш, чым праз {{count}} год",
      singularGenitive: "больш, чым праз {{count}} гады",
      pluralGenitive: "больш, чым праз {{count}} гадоў"
    }
  }),
  almostXYears: Sn({
    regular: {
      singularNominative: "амаль {{count}} год",
      singularGenitive: "амаль {{count}} гады",
      pluralGenitive: "амаль {{count}} гадоў"
    },
    future: {
      singularNominative: "амаль праз {{count}} год",
      singularGenitive: "амаль праз {{count}} гады",
      pluralGenitive: "амаль праз {{count}} гадоў"
    }
  })
}, VK = (t, e, n) => (n = n || {}, zK[t](e, n)), HK = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, BK = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, qK = {
  any: "{{date}}, {{time}}"
}, GK = {
  date: T({
    formats: HK,
    defaultWidth: "full"
  }),
  time: T({
    formats: BK,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: qK,
    defaultWidth: "any"
  })
}, o0 = [
  "нядзелю",
  "панядзелак",
  "аўторак",
  "сераду",
  "чацьвер",
  "пятніцу",
  "суботу"
];
function XK(t) {
  const e = o0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у мінулую " + e + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у мінулы " + e + " а' p";
  }
}
function dP(t) {
  return "'у " + o0[t] + " а' p";
}
function YK(t) {
  const e = o0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступную " + e + " а' p";
    case 1:
    case 2:
    case 4:
      return "'у наступны " + e + " а' p";
  }
}
const KK = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? dP(r) : XK(r);
}, UK = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? dP(r) : YK(r);
}, JK = {
  lastWeek: KK,
  yesterday: "'учора а' p",
  today: "'сёньня а' p",
  tomorrow: "'заўтра а' p",
  nextWeek: UK,
  other: "P"
}, QK = (t, e, n, i) => {
  const r = JK[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, ZK = {
  narrow: ["да н.э.", "н.э."],
  abbreviated: ["да н. э.", "н. э."],
  wide: ["да нашай эры", "нашай эры"]
}, eU = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ы кв.", "2-і кв.", "3-і кв.", "4-ы кв."],
  wide: ["1-ы квартал", "2-і квартал", "3-і квартал", "4-ы квартал"]
}, tU = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж."
  ],
  wide: [
    "студзень",
    "люты",
    "сакавік",
    "красавік",
    "травень",
    "чэрвень",
    "ліпень",
    "жнівень",
    "верасень",
    "кастрычнік",
    "лістапад",
    "сьнежань"
  ]
}, nU = {
  narrow: ["С", "Л", "С", "К", "Т", "Ч", "Л", "Ж", "В", "К", "Л", "С"],
  abbreviated: [
    "студз.",
    "лют.",
    "сак.",
    "крас.",
    "трав.",
    "чэрв.",
    "ліп.",
    "жн.",
    "вер.",
    "кастр.",
    "ліст.",
    "сьнеж."
  ],
  wide: [
    "студзеня",
    "лютага",
    "сакавіка",
    "красавіка",
    "траўня",
    "чэрвеня",
    "ліпеня",
    "жніўня",
    "верасня",
    "кастрычніка",
    "лістапада",
    "сьнежня"
  ]
}, iU = {
  narrow: ["Н", "П", "А", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "аў", "ср", "чц", "пт", "сб"],
  abbreviated: ["нядз", "пан", "аўт", "сер", "чаць", "пят", "суб"],
  wide: [
    "нядзеля",
    "панядзелак",
    "аўторак",
    "серада",
    "чацьвер",
    "пятніца",
    "субота"
  ]
}, rU = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дзень",
    evening: "веч.",
    night: "ноч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніца",
    afternoon: "дзень",
    evening: "вечар",
    night: "ноч"
  }
}, aU = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўн.",
    noon: "поўд.",
    morning: "ран.",
    afternoon: "дня",
    evening: "веч.",
    night: "ночы"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "поўнач",
    noon: "поўдзень",
    morning: "раніцы",
    afternoon: "дня",
    evening: "вечара",
    night: "ночы"
  }
}, oU = (t, e) => {
  const n = String(e == null ? void 0 : e.unit), i = Number(t);
  let r;
  return n === "date" ? r = "-га" : n === "hour" || n === "minute" || n === "second" ? r = "-я" : r = (i % 10 === 2 || i % 10 === 3) && i % 100 !== 12 && i % 100 !== 13 ? "-і" : "-ы", i + r;
}, sU = {
  ordinalNumber: oU,
  era: C({
    values: ZK,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: eU,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: tU,
    defaultWidth: "wide",
    formattingValues: nU,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: iU,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: rU,
    defaultWidth: "any",
    formattingValues: aU,
    defaultFormattingWidth: "wide"
  })
}, lU = /^(\d+)(-?(е|я|га|і|ы|ае|ая|яя|шы|гі|ці|ты|мы))?/i, dU = /\d+/i, cU = {
  narrow: /^((да )?н\.?\s?э\.?)/i,
  abbreviated: /^((да )?н\.?\s?э\.?)/i,
  wide: /^(да нашай эры|нашай эры|наша эра)/i
}, uU = {
  any: [/^д/i, /^н/i]
}, fU = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыі]?)? кв.?/i,
  wide: /^[1234](-?[ыі]?)? квартал/i
}, mU = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, hU = {
  narrow: /^[слкмчжв]/i,
  abbreviated: /^(студз|лют|сак|крас|тр(ав)?|чэрв|ліп|жн|вер|кастр|ліст|сьнеж)\.?/i,
  wide: /^(студзен[ья]|лют(ы|ага)|сакавіка?|красавіка?|тра(вень|ўня)|чэрвен[ья]|ліпен[ья]|жні(вень|ўня)|верас(ень|ня)|кастрычніка?|лістапада?|сьнеж(ань|ня))/i
}, pU = {
  narrow: [
    /^с/i,
    /^л/i,
    /^с/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^ж/i,
    /^в/i,
    /^к/i,
    /^л/i,
    /^с/i
  ],
  any: [
    /^ст/i,
    /^лю/i,
    /^са/i,
    /^кр/i,
    /^тр/i,
    /^ч/i,
    /^ліп/i,
    /^ж/i,
    /^в/i,
    /^ка/i,
    /^ліс/i,
    /^сн/i
  ]
}, gU = {
  narrow: /^[нпасч]/i,
  short: /^(нд|ня|пн|па|аў|ат|ср|се|чц|ча|пт|пя|сб|су)\.?/i,
  abbreviated: /^(нядз?|ндз|пнд|пан|аўт|срд|сер|чцьв|чаць|птн|пят|суб).?/i,
  wide: /^(нядзел[яі]|панядзел(ак|ка)|аўтор(ак|ка)|серад[аы]|чацьв(ер|ярга)|пятніц[аы]|субот[аы])/i
}, yU = {
  narrow: [/^н/i, /^п/i, /^а/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[ан]/i, /^а/i, /^с[ер]/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, vU = {
  narrow: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  abbreviated: /^([дп]п|поўн\.?|поўд\.?|ран\.?|дзень|дня|веч\.?|ночы?)/i,
  wide: /^([дп]п|поўнач|поўдзень|раніц[аы]|дзень|дня|вечара?|ночы?)/i
}, bU = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^поўн/i,
    noon: /^поўд/i,
    morning: /^р/i,
    afternoon: /^д[зн]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, wU = {
  ordinalNumber: he({
    matchPattern: lU,
    parsePattern: dU,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: cU,
    defaultMatchWidth: "wide",
    parsePatterns: uU,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: fU,
    defaultMatchWidth: "wide",
    parsePatterns: mU,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: hU,
    defaultMatchWidth: "wide",
    parsePatterns: pU,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: gU,
    defaultMatchWidth: "wide",
    parsePatterns: yU,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: vU,
    defaultMatchWidth: "wide",
    parsePatterns: bU,
    defaultParseWidth: "any"
  })
}, kU = {
  code: "be-tarask",
  formatDistance: VK,
  formatLong: GK,
  formatRelative: QK,
  localize: sU,
  match: wU,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, xU = {
  lessThanXSeconds: {
    one: "по-малко от секунда",
    other: "по-малко от {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половин минута",
  lessThanXMinutes: {
    one: "по-малко от минута",
    other: "по-малко от {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "около час",
    other: "около {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дни"
  },
  aboutXWeeks: {
    one: "около седмица",
    other: "около {{count}} седмици"
  },
  xWeeks: {
    one: "1 седмица",
    other: "{{count}} седмици"
  },
  aboutXMonths: {
    one: "около месец",
    other: "около {{count}} месеца"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеца"
  },
  aboutXYears: {
    one: "около година",
    other: "около {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "над година",
    other: "над {{count}} години"
  },
  almostXYears: {
    one: "почти година",
    other: "почти {{count}} години"
  }
}, _U = (t, e, n) => {
  let i;
  const r = xU[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "след " + i : "преди " + i : i;
}, MU = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, CU = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, PU = {
  any: "{{date}} {{time}}"
}, SU = {
  date: T({
    formats: MU,
    defaultWidth: "full"
  }),
  time: T({
    formats: CU,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: PU,
    defaultWidth: "any"
  })
}, s0 = [
  "неделя",
  "понеделник",
  "вторник",
  "сряда",
  "четвъртък",
  "петък",
  "събота"
];
function NU(t) {
  const e = s0[t];
  switch (t) {
    case 0:
    case 3:
    case 6:
      return "'миналата " + e + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'миналия " + e + " в' p";
  }
}
function cP(t) {
  const e = s0[t];
  return t === 2 ? "'във " + e + " в' p" : "'в " + e + " в' p";
}
function $U(t) {
  const e = s0[t];
  switch (t) {
    case 0:
    case 3:
    case 6:
      return "'следващата " + e + " в' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следващия " + e + " в' p";
  }
}
const DU = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? cP(r) : NU(r);
}, EU = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? cP(r) : $U(r);
}, TU = {
  lastWeek: DU,
  yesterday: "'вчера в' p",
  today: "'днес в' p",
  tomorrow: "'утре в' p",
  nextWeek: EU,
  other: "P"
}, OU = (t, e, n, i) => {
  const r = TU[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, WU = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["преди н. е.", "н. е."],
  wide: ["преди новата ера", "новата ера"]
}, AU = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-во тримес.", "2-ро тримес.", "3-то тримес.", "4-то тримес."],
  wide: [
    "1-во тримесечие",
    "2-ро тримесечие",
    "3-то тримесечие",
    "4-то тримесечие"
  ]
}, LU = {
  abbreviated: [
    "яну",
    "фев",
    "мар",
    "апр",
    "май",
    "юни",
    "юли",
    "авг",
    "сеп",
    "окт",
    "ное",
    "дек"
  ],
  wide: [
    "януари",
    "февруари",
    "март",
    "април",
    "май",
    "юни",
    "юли",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември"
  ]
}, IU = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вто", "сря", "чет", "пет", "съб"],
  wide: [
    "неделя",
    "понеделник",
    "вторник",
    "сряда",
    "четвъртък",
    "петък",
    "събота"
  ]
}, RU = {
  wide: {
    am: "преди обяд",
    pm: "след обяд",
    midnight: "в полунощ",
    noon: "на обяд",
    morning: "сутринта",
    afternoon: "следобед",
    evening: "вечерта",
    night: "през нощта"
  }
};
function jU(t) {
  return t === "year" || t === "week" || t === "minute" || t === "second";
}
function FU(t) {
  return t === "quarter";
}
function Ka(t, e, n, i, r) {
  const a = FU(e) ? r : jU(e) ? i : n;
  return t + "-" + a;
}
const zU = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  if (n === 0)
    return Ka(0, i, "ев", "ева", "ево");
  if (n % 1e3 === 0)
    return Ka(n, i, "ен", "на", "но");
  if (n % 100 === 0)
    return Ka(n, i, "тен", "тна", "тно");
  const r = n % 100;
  if (r > 20 || r < 10)
    switch (r % 10) {
      case 1:
        return Ka(n, i, "ви", "ва", "во");
      case 2:
        return Ka(n, i, "ри", "ра", "ро");
      case 7:
      case 8:
        return Ka(n, i, "ми", "ма", "мо");
    }
  return Ka(n, i, "ти", "та", "то");
}, VU = {
  ordinalNumber: zU,
  era: C({
    values: WU,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: AU,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: LU,
    defaultWidth: "wide"
  }),
  day: C({
    values: IU,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: RU,
    defaultWidth: "wide"
  })
}, HU = /^(\d+)(-?[врмт][аи]|-?т?(ен|на)|-?(ев|ева))?/i, BU = /\d+/i, qU = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(преди новата ера|новата ера|нова ера)/i
}, GU = {
  any: [/^п/i, /^н/i]
}, XU = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?o?)? тримес.?/i,
  wide: /^[1234](-?[врт]?о?)? тримесечие/i
}, YU = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, KU = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)/i,
  abbreviated: /^(нед|пон|вто|сря|чет|пет|съб)/i,
  wide: /^(неделя|понеделник|вторник|сряда|четвъртък|петък|събота)/i
}, UU = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[ъб]/i]
}, JU = {
  abbreviated: /^(яну|фев|мар|апр|май|юни|юли|авг|сеп|окт|ное|дек)/i,
  wide: /^(януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)/i
}, QU = {
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^юн/i,
    /^юл/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i
  ]
}, ZU = {
  any: /^(преди о|след о|в по|на о|през|веч|сут|следо)/i
}, eJ = {
  any: {
    am: /^преди о/i,
    pm: /^след о/i,
    midnight: /^в пол/i,
    noon: /^на об/i,
    morning: /^сут/i,
    afternoon: /^следо/i,
    evening: /^веч/i,
    night: /^през н/i
  }
}, tJ = {
  ordinalNumber: he({
    matchPattern: HU,
    parsePattern: BU,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: qU,
    defaultMatchWidth: "wide",
    parsePatterns: GU,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: XU,
    defaultMatchWidth: "wide",
    parsePatterns: YU,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: JU,
    defaultMatchWidth: "wide",
    parsePatterns: QU,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: KU,
    defaultMatchWidth: "wide",
    parsePatterns: UU,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ZU,
    defaultMatchWidth: "any",
    parsePatterns: eJ,
    defaultParseWidth: "any"
  })
}, nJ = {
  code: "bg",
  formatDistance: _U,
  formatLong: SU,
  formatRelative: OU,
  localize: VU,
  match: tJ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, iJ = {
  locale: {
    1: "১",
    2: "২",
    3: "৩",
    4: "৪",
    5: "৫",
    6: "৬",
    7: "৭",
    8: "৮",
    9: "৯",
    0: "০"
  }
}, rJ = {
  narrow: ["খ্রিঃপূঃ", "খ্রিঃ"],
  abbreviated: ["খ্রিঃপূর্ব", "খ্রিঃ"],
  wide: ["খ্রিস্টপূর্ব", "খ্রিস্টাব্দ"]
}, aJ = {
  narrow: ["১", "২", "৩", "৪"],
  abbreviated: ["১ত্রৈ", "২ত্রৈ", "৩ত্রৈ", "৪ত্রৈ"],
  wide: ["১ম ত্রৈমাসিক", "২য় ত্রৈমাসিক", "৩য় ত্রৈমাসিক", "৪র্থ ত্রৈমাসিক"]
}, oJ = {
  narrow: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে"
  ],
  abbreviated: [
    "জানু",
    "ফেব্রু",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্ট",
    "অক্টো",
    "নভে",
    "ডিসে"
  ],
  wide: [
    "জানুয়ারি",
    "ফেব্রুয়ারি",
    "মার্চ",
    "এপ্রিল",
    "মে",
    "জুন",
    "জুলাই",
    "আগস্ট",
    "সেপ্টেম্বর",
    "অক্টোবর",
    "নভেম্বর",
    "ডিসেম্বর"
  ]
}, sJ = {
  narrow: ["র", "সো", "ম", "বু", "বৃ", "শু", "শ"],
  short: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  abbreviated: ["রবি", "সোম", "মঙ্গল", "বুধ", "বৃহ", "শুক্র", "শনি"],
  wide: [
    "রবিবার",
    "সোমবার",
    "মঙ্গলবার",
    "বুধবার",
    "বৃহস্পতিবার ",
    "শুক্রবার",
    "শনিবার"
  ]
}, lJ = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
}, dJ = {
  narrow: {
    am: "পূ",
    pm: "অপ",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  abbreviated: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  },
  wide: {
    am: "পূর্বাহ্ন",
    pm: "অপরাহ্ন",
    midnight: "মধ্যরাত",
    noon: "মধ্যাহ্ন",
    morning: "সকাল",
    afternoon: "বিকাল",
    evening: "সন্ধ্যা",
    night: "রাত"
  }
};
function cJ(t, e) {
  if (t > 18 && t <= 31)
    return e + "শে";
  switch (t) {
    case 1:
      return e + "লা";
    case 2:
    case 3:
      return e + "রা";
    case 4:
      return e + "ঠা";
    default:
      return e + "ই";
  }
}
const uJ = (t, e) => {
  const n = Number(t), i = uP(n);
  if ((e == null ? void 0 : e.unit) === "date")
    return cJ(n, i);
  if (n > 10 || n === 0) return i + "তম";
  switch (n % 10) {
    case 2:
    case 3:
      return i + "য়";
    case 4:
      return i + "র্থ";
    case 6:
      return i + "ষ্ঠ";
    default:
      return i + "ম";
  }
};
function uP(t) {
  return t.toString().replace(/\d/g, function(e) {
    return iJ.locale[e];
  });
}
const fJ = {
  ordinalNumber: uJ,
  era: C({
    values: rJ,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: aJ,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: oJ,
    defaultWidth: "wide"
  }),
  day: C({
    values: sJ,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: lJ,
    defaultWidth: "wide",
    formattingValues: dJ,
    defaultFormattingWidth: "wide"
  })
}, mJ = {
  lessThanXSeconds: {
    one: "প্রায় ১ সেকেন্ড",
    other: "প্রায় {{count}} সেকেন্ড"
  },
  xSeconds: {
    one: "১ সেকেন্ড",
    other: "{{count}} সেকেন্ড"
  },
  halfAMinute: "আধ মিনিট",
  lessThanXMinutes: {
    one: "প্রায় ১ মিনিট",
    other: "প্রায় {{count}} মিনিট"
  },
  xMinutes: {
    one: "১ মিনিট",
    other: "{{count}} মিনিট"
  },
  aboutXHours: {
    one: "প্রায় ১ ঘন্টা",
    other: "প্রায় {{count}} ঘন্টা"
  },
  xHours: {
    one: "১ ঘন্টা",
    other: "{{count}} ঘন্টা"
  },
  xDays: {
    one: "১ দিন",
    other: "{{count}} দিন"
  },
  aboutXWeeks: {
    one: "প্রায় ১ সপ্তাহ",
    other: "প্রায় {{count}} সপ্তাহ"
  },
  xWeeks: {
    one: "১ সপ্তাহ",
    other: "{{count}} সপ্তাহ"
  },
  aboutXMonths: {
    one: "প্রায় ১ মাস",
    other: "প্রায় {{count}} মাস"
  },
  xMonths: {
    one: "১ মাস",
    other: "{{count}} মাস"
  },
  aboutXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  },
  xYears: {
    one: "১ বছর",
    other: "{{count}} বছর"
  },
  overXYears: {
    one: "১ বছরের বেশি",
    other: "{{count}} বছরের বেশি"
  },
  almostXYears: {
    one: "প্রায় ১ বছর",
    other: "প্রায় {{count}} বছর"
  }
}, hJ = (t, e, n) => {
  let i;
  const r = mJ[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", uP(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " এর মধ্যে" : i + " আগে" : i;
}, pJ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gJ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yJ = {
  full: "{{date}} {{time}} 'সময়'",
  long: "{{date}} {{time}} 'সময়'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vJ = {
  date: T({
    formats: pJ,
    defaultWidth: "full"
  }),
  time: T({
    formats: gJ,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: yJ,
    defaultWidth: "full"
  })
}, bJ = {
  lastWeek: "'গত' eeee 'সময়' p",
  yesterday: "'গতকাল' 'সময়' p",
  today: "'আজ' 'সময়' p",
  tomorrow: "'আগামীকাল' 'সময়' p",
  nextWeek: "eeee 'সময়' p",
  other: "P"
}, wJ = (t, e, n, i) => bJ[t], kJ = /^(\d+)(ম|য়|র্থ|ষ্ঠ|শে|ই|তম)?/i, xJ = /\d+/i, _J = {
  narrow: /^(খ্রিঃপূঃ|খ্রিঃ)/i,
  abbreviated: /^(খ্রিঃপূর্ব|খ্রিঃ)/i,
  wide: /^(খ্রিস্টপূর্ব|খ্রিস্টাব্দ)/i
}, MJ = {
  narrow: [/^খ্রিঃপূঃ/i, /^খ্রিঃ/i],
  abbreviated: [/^খ্রিঃপূর্ব/i, /^খ্রিঃ/i],
  wide: [/^খ্রিস্টপূর্ব/i, /^খ্রিস্টাব্দ/i]
}, CJ = {
  narrow: /^[১২৩৪]/i,
  abbreviated: /^[১২৩৪]ত্রৈ/i,
  wide: /^[১২৩৪](ম|য়|র্থ)? ত্রৈমাসিক/i
}, PJ = {
  any: [/১/i, /২/i, /৩/i, /৪/i]
}, SJ = {
  narrow: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  abbreviated: /^(জানু|ফেব্রু|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্ট|অক্টো|নভে|ডিসে)/i,
  wide: /^(জানুয়ারি|ফেব্রুয়ারি|মার্চ|এপ্রিল|মে|জুন|জুলাই|আগস্ট|সেপ্টেম্বর|অক্টোবর|নভেম্বর|ডিসেম্বর)/i
}, NJ = {
  any: [
    /^জানু/i,
    /^ফেব্রু/i,
    /^মার্চ/i,
    /^এপ্রিল/i,
    /^মে/i,
    /^জুন/i,
    /^জুলাই/i,
    /^আগস্ট/i,
    /^সেপ্ট/i,
    /^অক্টো/i,
    /^নভে/i,
    /^ডিসে/i
  ]
}, $J = {
  narrow: /^(র|সো|ম|বু|বৃ|শু|শ)+/i,
  short: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  abbreviated: /^(রবি|সোম|মঙ্গল|বুধ|বৃহ|শুক্র|শনি)+/i,
  wide: /^(রবিবার|সোমবার|মঙ্গলবার|বুধবার|বৃহস্পতিবার |শুক্রবার|শনিবার)+/i
}, DJ = {
  narrow: [/^র/i, /^সো/i, /^ম/i, /^বু/i, /^বৃ/i, /^শু/i, /^শ/i],
  short: [/^রবি/i, /^সোম/i, /^মঙ্গল/i, /^বুধ/i, /^বৃহ/i, /^শুক্র/i, /^শনি/i],
  abbreviated: [
    /^রবি/i,
    /^সোম/i,
    /^মঙ্গল/i,
    /^বুধ/i,
    /^বৃহ/i,
    /^শুক্র/i,
    /^শনি/i
  ],
  wide: [
    /^রবিবার/i,
    /^সোমবার/i,
    /^মঙ্গলবার/i,
    /^বুধবার/i,
    /^বৃহস্পতিবার /i,
    /^শুক্রবার/i,
    /^শনিবার/i
  ]
}, EJ = {
  narrow: /^(পূ|অপ|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  abbreviated: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i,
  wide: /^(পূর্বাহ্ন|অপরাহ্ন|মধ্যরাত|মধ্যাহ্ন|সকাল|বিকাল|সন্ধ্যা|রাত)/i
}, TJ = {
  any: {
    am: /^পূ/i,
    pm: /^অপ/i,
    midnight: /^মধ্যরাত/i,
    noon: /^মধ্যাহ্ন/i,
    morning: /সকাল/i,
    afternoon: /বিকাল/i,
    evening: /সন্ধ্যা/i,
    night: /রাত/i
  }
}, OJ = {
  ordinalNumber: he({
    matchPattern: kJ,
    parsePattern: xJ,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: _J,
    defaultMatchWidth: "wide",
    parsePatterns: MJ,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: CJ,
    defaultMatchWidth: "wide",
    parsePatterns: PJ,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: SJ,
    defaultMatchWidth: "wide",
    parsePatterns: NJ,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: $J,
    defaultMatchWidth: "wide",
    parsePatterns: DJ,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: EJ,
    defaultMatchWidth: "wide",
    parsePatterns: TJ,
    defaultParseWidth: "any"
  })
}, WJ = {
  code: "bn",
  formatDistance: hJ,
  formatLong: vJ,
  formatRelative: wJ,
  localize: fJ,
  match: OJ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, AJ = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 sedmicu",
      withPrepositionAgo: "oko 1 sedmicu",
      withPrepositionIn: "oko 1 sedmicu"
    },
    dual: "oko {{count}} sedmice",
    other: "oko {{count}} sedmice"
  },
  xWeeks: {
    one: {
      standalone: "1 sedmicu",
      withPrepositionAgo: "1 sedmicu",
      withPrepositionIn: "1 sedmicu"
    },
    dual: "{{count}} sedmice",
    other: "{{count}} sedmice"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, LJ = (t, e, n) => {
  let i;
  const r = AJ[t];
  return typeof r == "string" ? i = r : e === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i = r.one.withPrepositionIn : i = r.one.withPrepositionAgo : i = r.one.standalone : e % 10 > 1 && e % 10 < 5 && // if last digit is between 2 and 4
  String(e).substr(-2, 1) !== "1" ? i = r.dual.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + i : "prije " + i : i;
}, IJ = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, RJ = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, jJ = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, FJ = {
  date: T({
    formats: IJ,
    defaultWidth: "full"
  }),
  time: T({
    formats: RJ,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: jJ,
    defaultWidth: "full"
  })
}, zJ = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'prošle nedjelje u' p";
      case 3:
        return "'prošle srijede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'sljedeće nedjelje u' p";
      case 3:
        return "'sljedeću srijedu u' p";
      case 6:
        return "'sljedeću subotu u' p";
      default:
        return "'sljedeći' EEEE 'u' p";
    }
  },
  other: "P"
}, VJ = (t, e, n, i) => {
  const r = zJ[t];
  return typeof r == "function" ? r(e) : r;
}, HJ = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Prije Hrista", "Poslije Hrista"]
}, BJ = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, qJ = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, GJ = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "juni",
    "juli",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, XJ = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, YJ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, KJ = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "poslije podne",
    evening: "uveče",
    night: "noću"
  }
}, UJ = (t, e) => {
  const n = Number(t);
  return String(n) + ".";
}, JJ = {
  ordinalNumber: UJ,
  era: C({
    values: HJ,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: BJ,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: qJ,
    defaultWidth: "wide",
    formattingValues: GJ,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: XJ,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: YJ,
    defaultWidth: "wide",
    formattingValues: KJ,
    defaultFormattingWidth: "wide"
  })
}, QJ = /^(\d+)\./i, ZJ = /\d+/i, eQ = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Prije Hrista|prije nove ere|Poslije Hrista|nova era)/i
}, tQ = {
  any: [/^pr/i, /^(po|nova)/i]
}, nQ = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, iQ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, rQ = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(juni|juna)|(juli|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, aQ = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, oQ = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, sQ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, lQ = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|poslije podne|ujutru)/i
}, dQ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, cQ = {
  ordinalNumber: he({
    matchPattern: QJ,
    parsePattern: ZJ,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: eQ,
    defaultMatchWidth: "wide",
    parsePatterns: tQ,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: nQ,
    defaultMatchWidth: "wide",
    parsePatterns: iQ,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: rQ,
    defaultMatchWidth: "wide",
    parsePatterns: aQ,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: oQ,
    defaultMatchWidth: "wide",
    parsePatterns: sQ,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: lQ,
    defaultMatchWidth: "any",
    parsePatterns: dQ,
    defaultParseWidth: "any"
  })
}, uQ = {
  code: "bs",
  formatDistance: LJ,
  formatLong: FJ,
  formatRelative: VJ,
  localize: JJ,
  match: cQ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, fQ = {
  lessThanXSeconds: {
    one: "menys d'un segon",
    eleven: "menys d'onze segons",
    other: "menys de {{count}} segons"
  },
  xSeconds: {
    one: "1 segon",
    other: "{{count}} segons"
  },
  halfAMinute: "mig minut",
  lessThanXMinutes: {
    one: "menys d'un minut",
    eleven: "menys d'onze minuts",
    other: "menys de {{count}} minuts"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minuts"
  },
  aboutXHours: {
    one: "aproximadament una hora",
    other: "aproximadament {{count}} hores"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} hores"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dies"
  },
  aboutXWeeks: {
    one: "aproximadament una setmana",
    other: "aproximadament {{count}} setmanes"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanes"
  },
  aboutXMonths: {
    one: "aproximadament un mes",
    other: "aproximadament {{count}} mesos"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} mesos"
  },
  aboutXYears: {
    one: "aproximadament un any",
    other: "aproximadament {{count}} anys"
  },
  xYears: {
    one: "1 any",
    other: "{{count}} anys"
  },
  overXYears: {
    one: "més d'un any",
    eleven: "més d'onze anys",
    other: "més de {{count}} anys"
  },
  almostXYears: {
    one: "gairebé un any",
    other: "gairebé {{count}} anys"
  }
}, mQ = (t, e, n) => {
  let i;
  const r = fQ[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 11 && r.eleven ? i = r.eleven : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + i : "fa " + i : i;
}, hQ = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, pQ = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, gQ = {
  full: "{{date}} 'a les' {{time}}",
  long: "{{date}} 'a les' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, yQ = {
  date: T({
    formats: hQ,
    defaultWidth: "full"
  }),
  time: T({
    formats: pQ,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: gQ,
    defaultWidth: "full"
  })
}, vQ = {
  lastWeek: "'el' eeee 'passat a la' LT",
  yesterday: "'ahir a la' p",
  today: "'avui a la' p",
  tomorrow: "'demà a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, bQ = {
  lastWeek: "'el' eeee 'passat a les' p",
  yesterday: "'ahir a les' p",
  today: "'avui a les' p",
  tomorrow: "'demà a les' p",
  nextWeek: "eeee 'a les' p",
  other: "P"
}, wQ = (t, e, n, i) => e.getHours() !== 1 ? bQ[t] : vQ[t], kQ = {
  narrow: ["aC", "dC"],
  abbreviated: ["a. de C.", "d. de C."],
  wide: ["abans de Crist", "després de Crist"]
}, xQ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1r trimestre", "2n trimestre", "3r trimestre", "4t trimestre"]
}, _Q = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MG",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DS"
  ],
  /**
   * Les abreviatures dels mesos de l'any es formen seguint una de les normes generals de formació d'abreviatures.
   * S'escriu la primera síl·laba i les consonants de la síl·laba següent anteriors a la primera vocal.
   * Els mesos de març, maig i juny no s'abreugen perquè són paraules d'una sola síl·laba.
   */
  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "maig",
    "juny",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "des."
  ],
  wide: [
    "gener",
    "febrer",
    "març",
    "abril",
    "maig",
    "juny",
    "juliol",
    "agost",
    "setembre",
    "octubre",
    "novembre",
    "desembre"
  ]
}, MQ = {
  narrow: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dt.", "dm.", "dj.", "dv.", "ds."],
  wide: [
    "diumenge",
    "dilluns",
    "dimarts",
    "dimecres",
    "dijous",
    "divendres",
    "dissabte"
  ]
}, CQ = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mitjanit",
    noon: "migdia",
    morning: "matí",
    afternoon: "tarda",
    evening: "vespre",
    night: "nit"
  }
}, PQ = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "de la mitjanit",
    noon: "del migdia",
    morning: "del matí",
    afternoon: "de la tarda",
    evening: "del vespre",
    night: "de la nit"
  }
}, SQ = (t, e) => {
  const n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "r";
      case 2:
        return n + "n";
      case 3:
        return n + "r";
      case 4:
        return n + "t";
    }
  return n + "è";
}, NQ = {
  ordinalNumber: SQ,
  era: C({
    values: kQ,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: xQ,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: _Q,
    defaultWidth: "wide"
  }),
  day: C({
    values: MQ,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: CQ,
    defaultWidth: "wide",
    formattingValues: PQ,
    defaultFormattingWidth: "wide"
  })
}, $Q = /^(\d+)(è|r|n|r|t)?/i, DQ = /\d+/i, EQ = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a. de C.|d. de C.)/i,
  wide: /^(abans de Crist|despr[eé]s de Crist)/i
}, TQ = {
  narrow: [/^aC/i, /^dC/i],
  abbreviated: [/^(a. de C.)/i, /^(d. de C.)/i],
  wide: [/^(abans de Crist)/i, /^(despr[eé]s de Crist)/i]
}, OQ = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](è|r|n|r|t)? trimestre/i
}, WQ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, AQ = {
  narrow: /^(GN|FB|MÇ|AB|MG|JN|JL|AG|ST|OC|NV|DS)/i,
  abbreviated: /^(gen.|febr.|març|abr.|maig|juny|jul.|ag.|set.|oct.|nov.|des.)/i,
  wide: /^(gener|febrer|març|abril|maig|juny|juliol|agost|setembre|octubre|novembre|desembre)/i
}, LQ = {
  narrow: [
    /^GN/i,
    /^FB/i,
    /^MÇ/i,
    /^AB/i,
    /^MG/i,
    /^JN/i,
    /^JL/i,
    /^AG/i,
    /^ST/i,
    /^OC/i,
    /^NV/i,
    /^DS/i
  ],
  abbreviated: [
    /^gen./i,
    /^febr./i,
    /^març/i,
    /^abr./i,
    /^maig/i,
    /^juny/i,
    /^jul./i,
    /^ag./i,
    /^set./i,
    /^oct./i,
    /^nov./i,
    /^des./i
  ],
  wide: [
    /^gener/i,
    /^febrer/i,
    /^març/i,
    /^abril/i,
    /^maig/i,
    /^juny/i,
    /^juliol/i,
    /^agost/i,
    /^setembre/i,
    /^octubre/i,
    /^novembre/i,
    /^desembre/i
  ]
}, IQ = {
  narrow: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  short: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  abbreviated: /^(dg\.|dl\.|dt\.|dm\.|dj\.|dv\.|ds\.)/i,
  wide: /^(diumenge|dilluns|dimarts|dimecres|dijous|divendres|dissabte)/i
}, RQ = {
  narrow: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  abbreviated: [/^dg./i, /^dl./i, /^dt./i, /^dm./i, /^dj./i, /^dv./i, /^ds./i],
  wide: [
    /^diumenge/i,
    /^dilluns/i,
    /^dimarts/i,
    /^dimecres/i,
    /^dijous/i,
    /^divendres/i,
    /^disssabte/i
  ]
}, jQ = {
  narrow: /^(a|p|mn|md|(del|de la) (matí|tarda|vespre|nit))/i,
  abbreviated: /^([ap]\.?\s?m\.?|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i,
  wide: /^(ante meridiem|post meridiem|mitjanit|migdia|(del|de la) (matí|tarda|vespre|nit))/i
}, FQ = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mitjanit/i,
    noon: /^migdia/i,
    morning: /matí/i,
    afternoon: /tarda/i,
    evening: /vespre/i,
    night: /nit/i
  }
}, zQ = {
  ordinalNumber: he({
    matchPattern: $Q,
    parsePattern: DQ,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: EQ,
    defaultMatchWidth: "wide",
    parsePatterns: TQ,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: OQ,
    defaultMatchWidth: "wide",
    parsePatterns: WQ,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: AQ,
    defaultMatchWidth: "wide",
    parsePatterns: LQ,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: IQ,
    defaultMatchWidth: "wide",
    parsePatterns: RQ,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: jQ,
    defaultMatchWidth: "wide",
    parsePatterns: FQ,
    defaultParseWidth: "any"
  })
}, VQ = {
  code: "ca",
  formatDistance: mQ,
  formatLong: yQ,
  formatRelative: wQ,
  localize: NQ,
  match: zQ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, HQ = {
  lessThanXSeconds: {
    one: "کەمتر لە یەک چرکە",
    other: "کەمتر لە {{count}} چرکە"
  },
  xSeconds: {
    one: "1 چرکە",
    other: "{{count}} چرکە"
  },
  halfAMinute: "نیو کاتژمێر",
  lessThanXMinutes: {
    one: "کەمتر لە یەک خولەک",
    other: "کەمتر لە {{count}} خولەک"
  },
  xMinutes: {
    one: "1 خولەک",
    other: "{{count}} خولەک"
  },
  aboutXHours: {
    one: "دەوروبەری 1 کاتژمێر",
    other: "دەوروبەری {{count}} کاتژمێر"
  },
  xHours: {
    one: "1 کاتژمێر",
    other: "{{count}} کاتژمێر"
  },
  xDays: {
    one: "1 ڕۆژ",
    other: "{{count}} ژۆژ"
  },
  aboutXWeeks: {
    one: "دەوروبەری 1 هەفتە",
    other: "دوروبەری {{count}} هەفتە"
  },
  xWeeks: {
    one: "1 هەفتە",
    other: "{{count}} هەفتە"
  },
  aboutXMonths: {
    one: "داوروبەری 1 مانگ",
    other: "دەوروبەری {{count}} مانگ"
  },
  xMonths: {
    one: "1 مانگ",
    other: "{{count}} مانگ"
  },
  aboutXYears: {
    one: "دەوروبەری  1 ساڵ",
    other: "دەوروبەری {{count}} ساڵ"
  },
  xYears: {
    one: "1 ساڵ",
    other: "{{count}} ساڵ"
  },
  overXYears: {
    one: "زیاتر لە ساڵێک",
    other: "زیاتر لە {{count}} ساڵ"
  },
  almostXYears: {
    one: "بەنزیکەیی ساڵێک  ",
    other: "بەنزیکەیی {{count}} ساڵ"
  }
}, BQ = (t, e, n) => {
  let i;
  const r = HQ[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "لە ماوەی " + i + "دا" : i + "پێش ئێستا" : i;
}, qQ = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, GQ = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, XQ = {
  full: "{{date}} 'کاتژمێر' {{time}}",
  long: "{{date}} 'کاتژمێر' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, YQ = {
  date: T({
    formats: qQ,
    defaultWidth: "full"
  }),
  time: T({
    formats: GQ,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: XQ,
    defaultWidth: "full"
  })
}, KQ = {
  lastWeek: "'هەفتەی ڕابردوو' eeee 'کاتژمێر' p",
  yesterday: "'دوێنێ کاتژمێر' p",
  today: "'ئەمڕۆ کاتژمێر' p",
  tomorrow: "'بەیانی کاتژمێر' p",
  nextWeek: "eeee 'کاتژمێر' p",
  other: "P"
}, UQ = (t, e, n, i) => KQ[t], JQ = {
  narrow: ["پ", "د"],
  abbreviated: ["پ-ز", "د-ز"],
  wide: ["پێش زاین", "دوای زاین"]
}, QQ = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["چ1م", "چ2م", "چ3م", "چ4م"],
  wide: ["چارەگی یەکەم", "چارەگی دووەم", "چارەگی سێیەم", "چارەگی چوارەم"]
}, ZQ = {
  narrow: [
    "ک-د",
    "ش",
    "ئا",
    "ن",
    "م",
    "ح",
    "ت",
    "ئا",
    "ئە",
    "تش-ی",
    "تش-د",
    "ک-ی"
  ],
  abbreviated: [
    "کان-دوو",
    "شوب",
    "ئاد",
    "نیس",
    "مایس",
    "حوز",
    "تەم",
    "ئاب",
    "ئەل",
    "تش-یەک",
    "تش-دوو",
    "کان-یەک"
  ],
  wide: [
    "کانوونی دووەم",
    "شوبات",
    "ئادار",
    "نیسان",
    "مایس",
    "حوزەیران",
    "تەمموز",
    "ئاب",
    "ئەیلول",
    "تشرینی یەکەم",
    "تشرینی دووەم",
    "کانوونی یەکەم"
  ]
}, eZ = {
  narrow: ["ی-ش", "د-ش", "س-ش", "چ-ش", "پ-ش", "هە", "ش"],
  short: ["یە-شە", "دوو-شە", "سێ-شە", "چو-شە", "پێ-شە", "هەی", "شە"],
  abbreviated: [
    "یەک-شەم",
    "دوو-شەم",
    "سێ-شەم",
    "چوار-شەم",
    "پێنج-شەم",
    "هەینی",
    "شەمە"
  ],
  wide: [
    "یەک شەمە",
    "دوو شەمە",
    "سێ شەمە",
    "چوار شەمە",
    "پێنج شەمە",
    "هەینی",
    "شەمە"
  ]
}, tZ = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "بەیانی",
    afternoon: "دوای نیوەڕۆ",
    evening: "ئێوارە",
    night: "شەو"
  }
}, nZ = {
  narrow: {
    am: "پ",
    pm: "د",
    midnight: "ن-ش",
    noon: "ن",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  },
  abbreviated: {
    am: "پ-ن",
    pm: "د-ن",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  },
  wide: {
    am: "پێش نیوەڕۆ",
    pm: "دوای نیوەڕۆ",
    midnight: "نیوە شەو",
    noon: "نیوەڕۆ",
    morning: "لە بەیانیدا",
    afternoon: "لە دوای نیوەڕۆدا",
    evening: "لە ئێوارەدا",
    night: "لە شەودا"
  }
}, iZ = (t, e) => String(t), rZ = {
  ordinalNumber: iZ,
  era: C({
    values: JQ,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: QQ,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: ZQ,
    defaultWidth: "wide"
  }),
  day: C({
    values: eZ,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: tZ,
    defaultWidth: "wide",
    formattingValues: nZ,
    defaultFormattingWidth: "wide"
  })
}, aZ = /^(\d+)(th|st|nd|rd)?/i, oZ = /\d+/i, sZ = {
  narrow: /^(پ|د)/i,
  abbreviated: /^(پ-ز|د.ز)/i,
  wide: /^(پێش زاین| دوای زاین)/i
}, lZ = {
  any: [/^د/g, /^پ/g]
}, dZ = {
  narrow: /^[1234]/i,
  abbreviated: /^م[1234]چ/i,
  wide: /^(یەکەم|دووەم|سێیەم| چوارەم) (چارەگی)? quarter/i
}, cZ = {
  wide: [/چارەگی یەکەم/, /چارەگی دووەم/, /چارەگی سيیەم/, /چارەگی چوارەم/],
  any: [/1/i, /2/i, /3/i, /4/i]
}, uZ = {
  narrow: /^(ک-د|ش|ئا|ن|م|ح|ت|ئە|تش-ی|تش-د|ک-ی)/i,
  abbreviated: /^(کان-دوو|شوب|ئاد|نیس|مایس|حوز|تەم|ئاب|ئەل|تش-یەک|تش-دوو|کان-یەک)/i,
  wide: /^(کانوونی دووەم|شوبات|ئادار|نیسان|مایس|حوزەیران|تەمموز|ئاب|ئەیلول|تشرینی یەکەم|تشرینی دووەم|کانوونی یەکەم)/i
}, fZ = {
  narrow: [
    /^ک-د/i,
    /^ش/i,
    /^ئا/i,
    /^ن/i,
    /^م/i,
    /^ح/i,
    /^ت/i,
    /^ئا/i,
    /^ئە/i,
    /^تش-ی/i,
    /^تش-د/i,
    /^ک-ی/i
  ],
  any: [
    /^کان-دوو/i,
    /^شوب/i,
    /^ئاد/i,
    /^نیس/i,
    /^مایس/i,
    /^حوز/i,
    /^تەم/i,
    /^ئاب/i,
    /^ئەل/i,
    /^تش-یەک/i,
    /^تش-دوو/i,
    /^|کان-یەک/i
  ]
}, mZ = {
  narrow: /^(ش|ی|د|س|چ|پ|هە)/i,
  short: /^(یە-شە|دوو-شە|سێ-شە|چو-شە|پێ-شە|هە|شە)/i,
  abbreviated: /^(یەک-شەم|دوو-شەم|سێ-شەم|چوار-شەم|پێنخ-شەم|هەینی|شەمە)/i,
  wide: /^(یەک شەمە|دوو شەمە|سێ شەمە|چوار شەمە|پێنج شەمە|هەینی|شەمە)/i
}, hZ = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, pZ = {
  narrow: /^(پ|د|ن-ش|ن| (بەیانی|دوای نیوەڕۆ|ئێوارە|شەو))/i,
  abbreviated: /^(پ-ن|د-ن|نیوە شەو|نیوەڕۆ|بەیانی|دوای نیوەڕۆ|ئێوارە|شەو)/,
  wide: /^(پێش نیوەڕۆ|دوای نیوەڕۆ|نیوەڕۆ|نیوە شەو|لەبەیانیدا|لەدواینیوەڕۆدا|لە ئێوارەدا|لە شەودا)/,
  any: /^(پ|د|بەیانی|نیوەڕۆ|ئێوارە|شەو)/
}, gZ = {
  any: {
    am: /^د/i,
    pm: /^پ/i,
    midnight: /^ن-ش/i,
    noon: /^ن/i,
    morning: /بەیانی/i,
    afternoon: /دواینیوەڕۆ/i,
    evening: /ئێوارە/i,
    night: /شەو/i
  }
}, yZ = {
  ordinalNumber: he({
    matchPattern: aZ,
    parsePattern: oZ,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: sZ,
    defaultMatchWidth: "wide",
    parsePatterns: lZ,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: dZ,
    defaultMatchWidth: "wide",
    parsePatterns: cZ,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: uZ,
    defaultMatchWidth: "wide",
    parsePatterns: fZ,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: mZ,
    defaultMatchWidth: "wide",
    parsePatterns: hZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: pZ,
    defaultMatchWidth: "any",
    parsePatterns: gZ,
    defaultParseWidth: "any"
  })
}, vZ = {
  code: "ckb",
  formatDistance: BQ,
  formatLong: YQ,
  formatRelative: UQ,
  localize: rZ,
  match: yZ,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, bZ = {
  lessThanXSeconds: {
    one: {
      regular: "méně než 1 sekunda",
      past: "před méně než 1 sekundou",
      future: "za méně než 1 sekundu"
    },
    few: {
      regular: "méně než {{count}} sekundy",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekundy"
    },
    many: {
      regular: "méně než {{count}} sekund",
      past: "před méně než {{count}} sekundami",
      future: "za méně než {{count}} sekund"
    }
  },
  xSeconds: {
    one: {
      regular: "1 sekunda",
      past: "před 1 sekundou",
      future: "za 1 sekundu"
    },
    few: {
      regular: "{{count}} sekundy",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekundy"
    },
    many: {
      regular: "{{count}} sekund",
      past: "před {{count}} sekundami",
      future: "za {{count}} sekund"
    }
  },
  halfAMinute: {
    type: "other",
    other: {
      regular: "půl minuty",
      past: "před půl minutou",
      future: "za půl minuty"
    }
  },
  lessThanXMinutes: {
    one: {
      regular: "méně než 1 minuta",
      past: "před méně než 1 minutou",
      future: "za méně než 1 minutu"
    },
    few: {
      regular: "méně než {{count}} minuty",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minuty"
    },
    many: {
      regular: "méně než {{count}} minut",
      past: "před méně než {{count}} minutami",
      future: "za méně než {{count}} minut"
    }
  },
  xMinutes: {
    one: {
      regular: "1 minuta",
      past: "před 1 minutou",
      future: "za 1 minutu"
    },
    few: {
      regular: "{{count}} minuty",
      past: "před {{count}} minutami",
      future: "za {{count}} minuty"
    },
    many: {
      regular: "{{count}} minut",
      past: "před {{count}} minutami",
      future: "za {{count}} minut"
    }
  },
  aboutXHours: {
    one: {
      regular: "přibližně 1 hodina",
      past: "přibližně před 1 hodinou",
      future: "přibližně za 1 hodinu"
    },
    few: {
      regular: "přibližně {{count}} hodiny",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodiny"
    },
    many: {
      regular: "přibližně {{count}} hodin",
      past: "přibližně před {{count}} hodinami",
      future: "přibližně za {{count}} hodin"
    }
  },
  xHours: {
    one: {
      regular: "1 hodina",
      past: "před 1 hodinou",
      future: "za 1 hodinu"
    },
    few: {
      regular: "{{count}} hodiny",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodiny"
    },
    many: {
      regular: "{{count}} hodin",
      past: "před {{count}} hodinami",
      future: "za {{count}} hodin"
    }
  },
  xDays: {
    one: {
      regular: "1 den",
      past: "před 1 dnem",
      future: "za 1 den"
    },
    few: {
      regular: "{{count}} dny",
      past: "před {{count}} dny",
      future: "za {{count}} dny"
    },
    many: {
      regular: "{{count}} dní",
      past: "před {{count}} dny",
      future: "za {{count}} dní"
    }
  },
  aboutXWeeks: {
    one: {
      regular: "přibližně 1 týden",
      past: "přibližně před 1 týdnem",
      future: "přibližně za 1 týden"
    },
    few: {
      regular: "přibližně {{count}} týdny",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdny"
    },
    many: {
      regular: "přibližně {{count}} týdnů",
      past: "přibližně před {{count}} týdny",
      future: "přibližně za {{count}} týdnů"
    }
  },
  xWeeks: {
    one: {
      regular: "1 týden",
      past: "před 1 týdnem",
      future: "za 1 týden"
    },
    few: {
      regular: "{{count}} týdny",
      past: "před {{count}} týdny",
      future: "za {{count}} týdny"
    },
    many: {
      regular: "{{count}} týdnů",
      past: "před {{count}} týdny",
      future: "za {{count}} týdnů"
    }
  },
  aboutXMonths: {
    one: {
      regular: "přibližně 1 měsíc",
      past: "přibližně před 1 měsícem",
      future: "přibližně za 1 měsíc"
    },
    few: {
      regular: "přibližně {{count}} měsíce",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíce"
    },
    many: {
      regular: "přibližně {{count}} měsíců",
      past: "přibližně před {{count}} měsíci",
      future: "přibližně za {{count}} měsíců"
    }
  },
  xMonths: {
    one: {
      regular: "1 měsíc",
      past: "před 1 měsícem",
      future: "za 1 měsíc"
    },
    few: {
      regular: "{{count}} měsíce",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíce"
    },
    many: {
      regular: "{{count}} měsíců",
      past: "před {{count}} měsíci",
      future: "za {{count}} měsíců"
    }
  },
  aboutXYears: {
    one: {
      regular: "přibližně 1 rok",
      past: "přibližně před 1 rokem",
      future: "přibližně za 1 rok"
    },
    few: {
      regular: "přibližně {{count}} roky",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roky"
    },
    many: {
      regular: "přibližně {{count}} roků",
      past: "přibližně před {{count}} roky",
      future: "přibližně za {{count}} roků"
    }
  },
  xYears: {
    one: {
      regular: "1 rok",
      past: "před 1 rokem",
      future: "za 1 rok"
    },
    few: {
      regular: "{{count}} roky",
      past: "před {{count}} roky",
      future: "za {{count}} roky"
    },
    many: {
      regular: "{{count}} roků",
      past: "před {{count}} roky",
      future: "za {{count}} roků"
    }
  },
  overXYears: {
    one: {
      regular: "více než 1 rok",
      past: "před více než 1 rokem",
      future: "za více než 1 rok"
    },
    few: {
      regular: "více než {{count}} roky",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roky"
    },
    many: {
      regular: "více než {{count}} roků",
      past: "před více než {{count}} roky",
      future: "za více než {{count}} roků"
    }
  },
  almostXYears: {
    one: {
      regular: "skoro 1 rok",
      past: "skoro před 1 rokem",
      future: "skoro za 1 rok"
    },
    few: {
      regular: "skoro {{count}} roky",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roky"
    },
    many: {
      regular: "skoro {{count}} roků",
      past: "skoro před {{count}} roky",
      future: "skoro za {{count}} roků"
    }
  }
}, wZ = (t, e, n) => {
  let i;
  const r = bZ[t];
  r.type === "other" ? i = r.other : e === 1 ? i = r.one : e > 1 && e < 5 ? i = r.few : i = r.many;
  const a = (n == null ? void 0 : n.addSuffix) === !0, o = n == null ? void 0 : n.comparison;
  let s;
  return a && o === -1 ? s = i.past : a && o === 1 ? s = i.future : s = i.regular, s.replace("{{count}}", String(e));
}, kZ = {
  full: "EEEE, d. MMMM yyyy",
  long: "d. MMMM yyyy",
  medium: "d. M. yyyy",
  short: "dd.MM.yyyy"
}, xZ = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, _Z = {
  full: "{{date}} 'v' {{time}}",
  long: "{{date}} 'v' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, MZ = {
  date: T({
    formats: kZ,
    defaultWidth: "full"
  }),
  time: T({
    formats: xZ,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: _Z,
    defaultWidth: "full"
  })
}, CZ = [
  "neděli",
  "pondělí",
  "úterý",
  "středu",
  "čtvrtek",
  "pátek",
  "sobotu"
], PZ = {
  lastWeek: "'poslední' eeee 've' p",
  yesterday: "'včera v' p",
  today: "'dnes v' p",
  tomorrow: "'zítra v' p",
  nextWeek: (t) => {
    const e = t.getDay();
    return "'v " + CZ[e] + " o' p";
  },
  other: "P"
}, SZ = (t, e) => {
  const n = PZ[t];
  return typeof n == "function" ? n(e) : n;
}, NZ = {
  narrow: ["př. n. l.", "n. l."],
  abbreviated: ["př. n. l.", "n. l."],
  wide: ["před naším letopočtem", "našeho letopočtu"]
}, $Z = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"],
  wide: ["1. čtvrtletí", "2. čtvrtletí", "3. čtvrtletí", "4. čtvrtletí"]
}, DZ = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "leden",
    "únor",
    "březen",
    "duben",
    "květen",
    "červen",
    "červenec",
    "srpen",
    "září",
    "říjen",
    "listopad",
    "prosinec"
  ]
}, EZ = {
  narrow: ["L", "Ú", "B", "D", "K", "Č", "Č", "S", "Z", "Ř", "L", "P"],
  abbreviated: [
    "led",
    "úno",
    "bře",
    "dub",
    "kvě",
    "čvn",
    "čvc",
    "srp",
    "zář",
    "říj",
    "lis",
    "pro"
  ],
  wide: [
    "ledna",
    "února",
    "března",
    "dubna",
    "května",
    "června",
    "července",
    "srpna",
    "září",
    "října",
    "listopadu",
    "prosince"
  ]
}, TZ = {
  narrow: ["ne", "po", "út", "st", "čt", "pá", "so"],
  short: ["ne", "po", "út", "st", "čt", "pá", "so"],
  abbreviated: ["ned", "pon", "úte", "stř", "čtv", "pát", "sob"],
  wide: ["neděle", "pondělí", "úterý", "středa", "čtvrtek", "pátek", "sobota"]
}, OZ = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, WZ = {
  narrow: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  abbreviated: {
    am: "dop.",
    pm: "odp.",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "dopoledne",
    pm: "odpoledne",
    midnight: "půlnoc",
    noon: "poledne",
    morning: "ráno",
    afternoon: "odpoledne",
    evening: "večer",
    night: "noc"
  }
}, AZ = (t, e) => Number(t) + ".", LZ = {
  ordinalNumber: AZ,
  era: C({
    values: NZ,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: $Z,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: DZ,
    defaultWidth: "wide",
    formattingValues: EZ,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: TZ,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: OZ,
    defaultWidth: "wide",
    formattingValues: WZ,
    defaultFormattingWidth: "wide"
  })
}, IZ = /^(\d+)\.?/i, RZ = /\d+/i, jZ = {
  narrow: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(p[řr](\.|ed) Kr\.|p[řr](\.|ed) n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(p[řr](\.|ed) Kristem|p[řr](\.|ed) na[šs][íi]m letopo[čc]tem|po Kristu|na[šs]eho letopo[čc]tu)/i
}, FZ = {
  any: [/^p[řr]/i, /^(po|n)/i]
}, zZ = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\. [čc]tvrtlet[íi]/i,
  wide: /^[1234]\. [čc]tvrtlet[íi]/i
}, VZ = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, HZ = {
  narrow: /^[lúubdkčcszřrlp]/i,
  abbreviated: /^(led|[úu]no|b[řr]e|dub|kv[ěe]|[čc]vn|[čc]vc|srp|z[áa][řr]|[řr][íi]j|lis|pro)/i,
  wide: /^(leden|ledna|[úu]nora?|b[řr]ezen|b[řr]ezna|duben|dubna|kv[ěe]ten|kv[ěe]tna|[čc]erven(ec|ce)?|[čc]ervna|srpen|srpna|z[áa][řr][íi]|[řr][íi]jen|[řr][íi]jna|listopad(a|u)?|prosinec|prosince)/i
}, BZ = {
  narrow: [
    /^l/i,
    /^[úu]/i,
    /^b/i,
    /^d/i,
    /^k/i,
    /^[čc]/i,
    /^[čc]/i,
    /^s/i,
    /^z/i,
    /^[řr]/i,
    /^l/i,
    /^p/i
  ],
  any: [
    /^led/i,
    /^[úu]n/i,
    /^b[řr]e/i,
    /^dub/i,
    /^kv[ěe]/i,
    /^[čc]vn|[čc]erven(?!\w)|[čc]ervna/i,
    /^[čc]vc|[čc]erven(ec|ce)/i,
    /^srp/i,
    /^z[áa][řr]/i,
    /^[řr][íi]j/i,
    /^lis/i,
    /^pro/i
  ]
}, qZ = {
  narrow: /^[npuúsčps]/i,
  short: /^(ne|po|[úu]t|st|[čc]t|p[áa]|so)/i,
  abbreviated: /^(ned|pon|[úu]te|st[rř]|[čc]tv|p[áa]t|sob)/i,
  wide: /^(ned[ěe]le|pond[ěe]l[íi]|[úu]ter[ýy]|st[řr]eda|[čc]tvrtek|p[áa]tek|sobota)/i
}, GZ = {
  narrow: [/^n/i, /^p/i, /^[úu]/i, /^s/i, /^[čc]/i, /^p/i, /^s/i],
  any: [/^ne/i, /^po/i, /^[úu]t/i, /^st/i, /^[čc]t/i, /^p[áa]/i, /^so/i]
}, XZ = {
  any: /^dopoledne|dop\.?|odpoledne|odp\.?|p[ůu]lnoc|poledne|r[áa]no|odpoledne|ve[čc]er|(v )?noci?/i
}, YZ = {
  any: {
    am: /^dop/i,
    pm: /^odp/i,
    midnight: /^p[ůu]lnoc/i,
    noon: /^poledne/i,
    morning: /r[áa]no/i,
    afternoon: /odpoledne/i,
    evening: /ve[čc]er/i,
    night: /noc/i
  }
}, KZ = {
  ordinalNumber: he({
    matchPattern: IZ,
    parsePattern: RZ,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: jZ,
    defaultMatchWidth: "wide",
    parsePatterns: FZ,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: zZ,
    defaultMatchWidth: "wide",
    parsePatterns: VZ,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: HZ,
    defaultMatchWidth: "wide",
    parsePatterns: BZ,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: qZ,
    defaultMatchWidth: "wide",
    parsePatterns: GZ,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: XZ,
    defaultMatchWidth: "any",
    parsePatterns: YZ,
    defaultParseWidth: "any"
  })
}, UZ = {
  code: "cs",
  formatDistance: wZ,
  formatLong: MZ,
  formatRelative: SZ,
  localize: LZ,
  match: KZ,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, JZ = {
  lessThanXSeconds: {
    one: "llai na eiliad",
    other: "llai na {{count}} eiliad"
  },
  xSeconds: {
    one: "1 eiliad",
    other: "{{count}} eiliad"
  },
  halfAMinute: "hanner munud",
  lessThanXMinutes: {
    one: "llai na munud",
    two: "llai na 2 funud",
    other: "llai na {{count}} munud"
  },
  xMinutes: {
    one: "1 munud",
    two: "2 funud",
    other: "{{count}} munud"
  },
  aboutXHours: {
    one: "tua 1 awr",
    other: "tua {{count}} awr"
  },
  xHours: {
    one: "1 awr",
    other: "{{count}} awr"
  },
  xDays: {
    one: "1 diwrnod",
    two: "2 ddiwrnod",
    other: "{{count}} diwrnod"
  },
  aboutXWeeks: {
    one: "tua 1 wythnos",
    two: "tua pythefnos",
    other: "tua {{count}} wythnos"
  },
  xWeeks: {
    one: "1 wythnos",
    two: "pythefnos",
    other: "{{count}} wythnos"
  },
  aboutXMonths: {
    one: "tua 1 mis",
    two: "tua 2 fis",
    other: "tua {{count}} mis"
  },
  xMonths: {
    one: "1 mis",
    two: "2 fis",
    other: "{{count}} mis"
  },
  aboutXYears: {
    one: "tua 1 flwyddyn",
    two: "tua 2 flynedd",
    other: "tua {{count}} mlynedd"
  },
  xYears: {
    one: "1 flwyddyn",
    two: "2 flynedd",
    other: "{{count}} mlynedd"
  },
  overXYears: {
    one: "dros 1 flwyddyn",
    two: "dros 2 flynedd",
    other: "dros {{count}} mlynedd"
  },
  almostXYears: {
    one: "bron 1 flwyddyn",
    two: "bron 2 flynedd",
    other: "bron {{count}} mlynedd"
  }
}, QZ = (t, e, n) => {
  let i;
  const r = JZ[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 && r.two ? i = r.two : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "mewn " + i : i + " yn ôl" : i;
}, ZZ = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, eee = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, tee = {
  full: "{{date}} 'am' {{time}}",
  long: "{{date}} 'am' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, nee = {
  date: T({
    formats: ZZ,
    defaultWidth: "full"
  }),
  time: T({
    formats: eee,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: tee,
    defaultWidth: "full"
  })
}, iee = {
  lastWeek: "eeee 'diwethaf am' p",
  yesterday: "'ddoe am' p",
  today: "'heddiw am' p",
  tomorrow: "'yfory am' p",
  nextWeek: "eeee 'am' p",
  other: "P"
}, ree = (t, e, n, i) => iee[t], aee = {
  narrow: ["C", "O"],
  abbreviated: ["CC", "OC"],
  wide: ["Cyn Crist", "Ar ôl Crist"]
}, oee = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ch1", "Ch2", "Ch3", "Ch4"],
  wide: ["Chwarter 1af", "2ail chwarter", "3ydd chwarter", "4ydd chwarter"]
}, see = {
  narrow: ["I", "Ch", "Ma", "E", "Mi", "Me", "G", "A", "Md", "H", "T", "Rh"],
  abbreviated: [
    "Ion",
    "Chwe",
    "Maw",
    "Ebr",
    "Mai",
    "Meh",
    "Gor",
    "Aws",
    "Med",
    "Hyd",
    "Tach",
    "Rhag"
  ],
  wide: [
    "Ionawr",
    "Chwefror",
    "Mawrth",
    "Ebrill",
    "Mai",
    "Mehefin",
    "Gorffennaf",
    "Awst",
    "Medi",
    "Hydref",
    "Tachwedd",
    "Rhagfyr"
  ]
}, lee = {
  narrow: ["S", "Ll", "M", "M", "I", "G", "S"],
  short: ["Su", "Ll", "Ma", "Me", "Ia", "Gw", "Sa"],
  abbreviated: ["Sul", "Llun", "Maw", "Mer", "Iau", "Gwe", "Sad"],
  wide: [
    "dydd Sul",
    "dydd Llun",
    "dydd Mawrth",
    "dydd Mercher",
    "dydd Iau",
    "dydd Gwener",
    "dydd Sadwrn"
  ]
}, dee = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "bore",
    afternoon: "prynhawn",
    evening: "gyda'r nos",
    night: "nos"
  }
}, cee = {
  narrow: {
    am: "b",
    pm: "h",
    midnight: "hn",
    noon: "hd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  abbreviated: {
    am: "yb",
    pm: "yh",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  },
  wide: {
    am: "y.b.",
    pm: "y.h.",
    midnight: "hanner nos",
    noon: "hanner dydd",
    morning: "yn y bore",
    afternoon: "yn y prynhawn",
    evening: "gyda'r nos",
    night: "yn y nos"
  }
}, uee = (t, e) => {
  const n = Number(t);
  if (n < 20)
    switch (n) {
      case 0:
        return n + "fed";
      case 1:
        return n + "af";
      case 2:
        return n + "ail";
      case 3:
      case 4:
        return n + "ydd";
      case 5:
      case 6:
        return n + "ed";
      case 7:
      case 8:
      case 9:
      case 10:
      case 12:
      case 15:
      case 18:
        return n + "fed";
      case 11:
      case 13:
      case 14:
      case 16:
      case 17:
      case 19:
        return n + "eg";
    }
  else if (n >= 50 && n <= 60 || n === 80 || n >= 100)
    return n + "fed";
  return n + "ain";
}, fee = {
  ordinalNumber: uee,
  era: C({
    values: aee,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: oee,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: see,
    defaultWidth: "wide"
  }),
  day: C({
    values: lee,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: dee,
    defaultWidth: "wide",
    formattingValues: cee,
    defaultFormattingWidth: "wide"
  })
}, mee = /^(\d+)(af|ail|ydd|ed|fed|eg|ain)?/i, hee = /\d+/i, pee = {
  narrow: /^(c|o)/i,
  abbreviated: /^(c\.?\s?c\.?|o\.?\s?c\.?)/i,
  wide: /^(cyn christ|ar ôl crist|ar ol crist)/i
}, gee = {
  wide: [/^c/i, /^(ar ôl crist|ar ol crist)/i],
  any: [/^c/i, /^o/i]
}, yee = {
  narrow: /^[1234]/i,
  abbreviated: /^ch[1234]/i,
  wide: /^(chwarter 1af)|([234](ail|ydd)? chwarter)/i
}, vee = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, bee = {
  narrow: /^(i|ch|m|e|g|a|h|t|rh)/i,
  abbreviated: /^(ion|chwe|maw|ebr|mai|meh|gor|aws|med|hyd|tach|rhag)/i,
  wide: /^(ionawr|chwefror|mawrth|ebrill|mai|mehefin|gorffennaf|awst|medi|hydref|tachwedd|rhagfyr)/i
}, wee = {
  narrow: [
    /^i/i,
    /^ch/i,
    /^m/i,
    /^e/i,
    /^m/i,
    /^m/i,
    /^g/i,
    /^a/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^rh/i
  ],
  any: [
    /^io/i,
    /^ch/i,
    /^maw/i,
    /^e/i,
    /^mai/i,
    /^meh/i,
    /^g/i,
    /^a/i,
    /^med/i,
    /^h/i,
    /^t/i,
    /^rh/i
  ]
}, kee = {
  narrow: /^(s|ll|m|i|g)/i,
  short: /^(su|ll|ma|me|ia|gw|sa)/i,
  abbreviated: /^(sul|llun|maw|mer|iau|gwe|sad)/i,
  wide: /^dydd (sul|llun|mawrth|mercher|iau|gwener|sadwrn)/i
}, xee = {
  narrow: [/^s/i, /^ll/i, /^m/i, /^m/i, /^i/i, /^g/i, /^s/i],
  wide: [
    /^dydd su/i,
    /^dydd ll/i,
    /^dydd ma/i,
    /^dydd me/i,
    /^dydd i/i,
    /^dydd g/i,
    /^dydd sa/i
  ],
  any: [/^su/i, /^ll/i, /^ma/i, /^me/i, /^i/i, /^g/i, /^sa/i]
}, _ee = {
  narrow: /^(b|h|hn|hd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i,
  any: /^(y\.?\s?[bh]\.?|hanner nos|hanner dydd|(yn y|y|yr|gyda'r) (bore|prynhawn|nos|hwyr))/i
}, Mee = {
  any: {
    am: /^b|(y\.?\s?b\.?)/i,
    pm: /^h|(y\.?\s?h\.?)|(yr hwyr)/i,
    midnight: /^hn|hanner nos/i,
    noon: /^hd|hanner dydd/i,
    morning: /bore/i,
    afternoon: /prynhawn/i,
    evening: /^gyda'r nos$/i,
    night: /blah/i
  }
}, Cee = {
  ordinalNumber: he({
    matchPattern: mee,
    parsePattern: hee,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: pee,
    defaultMatchWidth: "wide",
    parsePatterns: gee,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: yee,
    defaultMatchWidth: "wide",
    parsePatterns: vee,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: bee,
    defaultMatchWidth: "wide",
    parsePatterns: wee,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: kee,
    defaultMatchWidth: "wide",
    parsePatterns: xee,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: _ee,
    defaultMatchWidth: "any",
    parsePatterns: Mee,
    defaultParseWidth: "any"
  })
}, Pee = {
  code: "cy",
  formatDistance: QZ,
  formatLong: nee,
  formatRelative: ree,
  localize: fee,
  match: Cee,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, See = {
  lessThanXSeconds: {
    one: "mindre end ét sekund",
    other: "mindre end {{count}} sekunder"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "ét halvt minut",
  lessThanXMinutes: {
    one: "mindre end ét minut",
    other: "mindre end {{count}} minutter"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "cirka 1 time",
    other: "cirka {{count}} timer"
  },
  xHours: {
    one: "1 time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dage"
  },
  aboutXWeeks: {
    one: "cirka 1 uge",
    other: "cirka {{count}} uger"
  },
  xWeeks: {
    one: "1 uge",
    other: "{{count}} uger"
  },
  aboutXMonths: {
    one: "cirka 1 måned",
    other: "cirka {{count}} måneder"
  },
  xMonths: {
    one: "1 måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "cirka 1 år",
    other: "cirka {{count}} år"
  },
  xYears: {
    one: "1 år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over 1 år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "næsten 1 år",
    other: "næsten {{count}} år"
  }
}, Nee = (t, e, n) => {
  let i;
  const r = See[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + i : i + " siden" : i;
}, $ee = {
  full: "EEEE 'den' d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd/MM/y"
}, Dee = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Eee = {
  full: "{{date}} 'kl'. {{time}}",
  long: "{{date}} 'kl'. {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Tee = {
  date: T({
    formats: $ee,
    defaultWidth: "full"
  }),
  time: T({
    formats: Dee,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Eee,
    defaultWidth: "full"
  })
}, Oee = {
  lastWeek: "'sidste' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "'på' eeee 'kl.' p",
  other: "P"
}, Wee = (t, e, n, i) => Oee[t], Aee = {
  narrow: ["fvt", "vt"],
  abbreviated: ["f.v.t.", "v.t."],
  wide: ["før vesterlandsk tidsregning", "vesterlandsk tidsregning"]
}, Lee = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. kvt.", "2. kvt.", "3. kvt.", "4. kvt."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Iee = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marts",
    "april",
    "maj",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, Ree = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn.", "man.", "tir.", "ons.", "tor.", "fre.", "lør."],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, jee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "morgen",
    afternoon: "eftermiddag",
    evening: "aften",
    night: "nat"
  }
}, Fee = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnat",
    noon: "middag",
    morning: "om morgenen",
    afternoon: "om eftermiddagen",
    evening: "om aftenen",
    night: "om natten"
  }
}, zee = (t, e) => Number(t) + ".", Vee = {
  ordinalNumber: zee,
  era: C({
    values: Aee,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Lee,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Iee,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ree,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: jee,
    defaultWidth: "wide",
    formattingValues: Fee,
    defaultFormattingWidth: "wide"
  })
}, Hee = /^(\d+)(\.)?/i, Bee = /\d+/i, qee = {
  narrow: /^(fKr|fvt|eKr|vt)/i,
  abbreviated: /^(f\.Kr\.?|f\.v\.t\.?|e\.Kr\.?|v\.t\.)/i,
  wide: /^(f.Kr.|før vesterlandsk tidsregning|e.Kr.|vesterlandsk tidsregning)/i
}, Gee = {
  any: [/^f/i, /^(v|e)/i]
}, Xee = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]. kvt\./i,
  wide: /^[1234]\.? kvartal/i
}, Yee = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Kee = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mar.|apr.|maj|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januar|februar|marts|april|maj|juni|juli|august|september|oktober|november|december)/i
}, Uee = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Jee = {
  narrow: /^[smtofl]/i,
  short: /^(søn.|man.|tir.|ons.|tor.|fre.|lør.)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Qee = {
  narrow: [/^s/i, /^m/i, /^t/i, /^o/i, /^t/i, /^f/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, Zee = {
  narrow: /^(a|p|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i,
  any: /^([ap]\.?\s?m\.?|midnat|middag|(om) (morgenen|eftermiddagen|aftenen|natten))/i
}, ete = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /midnat/i,
    noon: /middag/i,
    morning: /morgen/i,
    afternoon: /eftermiddag/i,
    evening: /aften/i,
    night: /nat/i
  }
}, tte = {
  ordinalNumber: he({
    matchPattern: Hee,
    parsePattern: Bee,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: qee,
    defaultMatchWidth: "wide",
    parsePatterns: Gee,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Xee,
    defaultMatchWidth: "wide",
    parsePatterns: Yee,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Kee,
    defaultMatchWidth: "wide",
    parsePatterns: Uee,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Jee,
    defaultMatchWidth: "wide",
    parsePatterns: Qee,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Zee,
    defaultMatchWidth: "any",
    parsePatterns: ete,
    defaultParseWidth: "any"
  })
}, nte = {
  code: "da",
  formatDistance: Nee,
  formatLong: Tee,
  formatRelative: Wee,
  localize: Vee,
  match: tte,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, d2 = {
  lessThanXSeconds: {
    standalone: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    },
    withPreposition: {
      one: "weniger als 1 Sekunde",
      other: "weniger als {{count}} Sekunden"
    }
  },
  xSeconds: {
    standalone: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    },
    withPreposition: {
      one: "1 Sekunde",
      other: "{{count}} Sekunden"
    }
  },
  halfAMinute: {
    standalone: "eine halbe Minute",
    withPreposition: "einer halben Minute"
  },
  lessThanXMinutes: {
    standalone: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    },
    withPreposition: {
      one: "weniger als 1 Minute",
      other: "weniger als {{count}} Minuten"
    }
  },
  xMinutes: {
    standalone: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    },
    withPreposition: {
      one: "1 Minute",
      other: "{{count}} Minuten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    },
    withPreposition: {
      one: "etwa 1 Stunde",
      other: "etwa {{count}} Stunden"
    }
  },
  xHours: {
    standalone: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    },
    withPreposition: {
      one: "1 Stunde",
      other: "{{count}} Stunden"
    }
  },
  xDays: {
    standalone: {
      one: "1 Tag",
      other: "{{count}} Tage"
    },
    withPreposition: {
      one: "1 Tag",
      other: "{{count}} Tagen"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    },
    withPreposition: {
      one: "etwa 1 Woche",
      other: "etwa {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "1 Woche",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monate"
    },
    withPreposition: {
      one: "etwa 1 Monat",
      other: "etwa {{count}} Monaten"
    }
  },
  xMonths: {
    standalone: {
      one: "1 Monat",
      other: "{{count}} Monate"
    },
    withPreposition: {
      one: "1 Monat",
      other: "{{count}} Monaten"
    }
  },
  aboutXYears: {
    standalone: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahre"
    },
    withPreposition: {
      one: "etwa 1 Jahr",
      other: "etwa {{count}} Jahren"
    }
  },
  xYears: {
    standalone: {
      one: "1 Jahr",
      other: "{{count}} Jahre"
    },
    withPreposition: {
      one: "1 Jahr",
      other: "{{count}} Jahren"
    }
  },
  overXYears: {
    standalone: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahre"
    },
    withPreposition: {
      one: "mehr als 1 Jahr",
      other: "mehr als {{count}} Jahren"
    }
  },
  almostXYears: {
    standalone: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahre"
    },
    withPreposition: {
      one: "fast 1 Jahr",
      other: "fast {{count}} Jahren"
    }
  }
}, fP = (t, e, n) => {
  let i;
  const r = n != null && n.addSuffix ? d2[t].withPreposition : d2[t].standalone;
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : "vor " + i : i;
}, ite = {
  full: "EEEE, do MMMM y",
  // Montag, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan. 2018
  short: "dd.MM.y"
  // 07.01.2018
}, rte = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ate = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, mP = {
  date: T({
    formats: ite,
    defaultWidth: "full"
  }),
  time: T({
    formats: rte,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: ate,
    defaultWidth: "full"
  })
}, ote = {
  lastWeek: "'letzten' eeee 'um' p",
  yesterday: "'gestern um' p",
  today: "'heute um' p",
  tomorrow: "'morgen um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, hP = (t, e, n, i) => ote[t], ste = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, lte = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, fg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, dte = {
  narrow: fg.narrow,
  abbreviated: [
    "Jan.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: fg.wide
}, cte = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, ute = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, fte = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, mte = (t) => Number(t) + ".", hte = {
  ordinalNumber: mte,
  era: C({
    values: ste,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: lte,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: fg,
    formattingValues: dte,
    defaultWidth: "wide"
  }),
  day: C({
    values: cte,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: ute,
    defaultWidth: "wide",
    formattingValues: fte,
    defaultFormattingWidth: "wide"
  })
}, pte = /^(\d+)(\.)?/i, gte = /\d+/i, yte = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(vor Christus|vor unserer Zeitrechnung|nach Christus|unserer Zeitrechnung)/i
}, vte = {
  any: [/^v/i, /^n/i]
}, bte = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, wte = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, kte = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(j[aä]n|feb|mär[z]?|apr|mai|jun[i]?|jul[i]?|aug|sep|okt|nov|dez)\.?/i,
  wide: /^(januar|februar|märz|april|mai|juni|juli|august|september|oktober|november|dezember)/i
}, xte = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^j[aä]/i,
    /^f/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, _te = {
  narrow: /^[smdmf]/i,
  short: /^(so|mo|di|mi|do|fr|sa)/i,
  abbreviated: /^(son?|mon?|die?|mit?|don?|fre?|sam?)\.?/i,
  wide: /^(sonntag|montag|dienstag|mittwoch|donnerstag|freitag|samstag)/i
}, Mte = {
  any: [/^so/i, /^mo/i, /^di/i, /^mi/i, /^do/i, /^f/i, /^sa/i]
}, Cte = {
  narrow: /^(vm\.?|nm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  abbreviated: /^(vorm\.?|nachm\.?|Mitternacht|Mittag|morgens|nachm\.?|abends|nachts)/i,
  wide: /^(vormittags|nachmittags|Mitternacht|Mittag|morgens|nachmittags|abends|nachts)/i
}, Pte = {
  any: {
    am: /^v/i,
    pm: /^n/i,
    midnight: /^Mitte/i,
    noon: /^Mitta/i,
    morning: /morgens/i,
    afternoon: /nachmittags/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /abends/i,
    night: /nachts/i
    // will never be matched. Night is matched by `pm`
  }
}, pP = {
  ordinalNumber: he({
    matchPattern: pte,
    parsePattern: gte,
    valueCallback: (t) => parseInt(t)
  }),
  era: P({
    matchPatterns: yte,
    defaultMatchWidth: "wide",
    parsePatterns: vte,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: bte,
    defaultMatchWidth: "wide",
    parsePatterns: wte,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: kte,
    defaultMatchWidth: "wide",
    parsePatterns: xte,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: _te,
    defaultMatchWidth: "wide",
    parsePatterns: Mte,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Cte,
    defaultMatchWidth: "wide",
    parsePatterns: Pte,
    defaultParseWidth: "any"
  })
}, Ste = {
  code: "de",
  formatDistance: fP,
  formatLong: mP,
  formatRelative: hP,
  localize: hte,
  match: pP,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Nte = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["vor Christus", "nach Christus"]
}, $te = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, mg = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jän",
    "Feb",
    "Mär",
    "Apr",
    "Mai",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Jänner",
    "Februar",
    "März",
    "April",
    "Mai",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, Dte = {
  narrow: mg.narrow,
  abbreviated: [
    "Jän.",
    "Feb.",
    "März",
    "Apr.",
    "Mai",
    "Juni",
    "Juli",
    "Aug.",
    "Sep.",
    "Okt.",
    "Nov.",
    "Dez."
  ],
  wide: mg.wide
}, Ete = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mo.", "Di.", "Mi.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonntag",
    "Montag",
    "Dienstag",
    "Mittwoch",
    "Donnerstag",
    "Freitag",
    "Samstag"
  ]
}, Tte = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachm.",
    evening: "Abend",
    night: "Nacht"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "Morgen",
    afternoon: "Nachmittag",
    evening: "Abend",
    night: "Nacht"
  }
}, Ote = {
  narrow: {
    am: "vm.",
    pm: "nm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachm.",
    evening: "abends",
    night: "nachts"
  },
  abbreviated: {
    am: "vorm.",
    pm: "nachm.",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  },
  wide: {
    am: "vormittags",
    pm: "nachmittags",
    midnight: "Mitternacht",
    noon: "Mittag",
    morning: "morgens",
    afternoon: "nachmittags",
    evening: "abends",
    night: "nachts"
  }
}, Wte = (t) => Number(t) + ".", Ate = {
  ordinalNumber: Wte,
  era: C({
    values: Nte,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: $te,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: mg,
    formattingValues: Dte,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ete,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Tte,
    defaultWidth: "wide",
    formattingValues: Ote,
    defaultFormattingWidth: "wide"
  })
}, Lte = {
  code: "de-AT",
  formatDistance: fP,
  formatLong: mP,
  formatRelative: hP,
  localize: Ate,
  match: pP,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ite = {
  lessThanXSeconds: {
    one: "λιγότερο από ένα δευτερόλεπτο",
    other: "λιγότερο από {{count}} δευτερόλεπτα"
  },
  xSeconds: {
    one: "1 δευτερόλεπτο",
    other: "{{count}} δευτερόλεπτα"
  },
  halfAMinute: "μισό λεπτό",
  lessThanXMinutes: {
    one: "λιγότερο από ένα λεπτό",
    other: "λιγότερο από {{count}} λεπτά"
  },
  xMinutes: {
    one: "1 λεπτό",
    other: "{{count}} λεπτά"
  },
  aboutXHours: {
    one: "περίπου 1 ώρα",
    other: "περίπου {{count}} ώρες"
  },
  xHours: {
    one: "1 ώρα",
    other: "{{count}} ώρες"
  },
  xDays: {
    one: "1 ημέρα",
    other: "{{count}} ημέρες"
  },
  aboutXWeeks: {
    one: "περίπου 1 εβδομάδα",
    other: "περίπου {{count}} εβδομάδες"
  },
  xWeeks: {
    one: "1 εβδομάδα",
    other: "{{count}} εβδομάδες"
  },
  aboutXMonths: {
    one: "περίπου 1 μήνας",
    other: "περίπου {{count}} μήνες"
  },
  xMonths: {
    one: "1 μήνας",
    other: "{{count}} μήνες"
  },
  aboutXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  },
  xYears: {
    one: "1 χρόνο",
    other: "{{count}} χρόνια"
  },
  overXYears: {
    one: "πάνω από 1 χρόνο",
    other: "πάνω από {{count}} χρόνια"
  },
  almostXYears: {
    one: "περίπου 1 χρόνο",
    other: "περίπου {{count}} χρόνια"
  }
}, Rte = (t, e, n) => {
  let i;
  const r = Ite[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "σε " + i : i + " πριν" : i;
}, jte = {
  full: "EEEE, d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "d/M/yy"
}, Fte = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, zte = {
  full: "{{date}} - {{time}}",
  long: "{{date}} - {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Vte = {
  date: T({
    formats: jte,
    defaultWidth: "full"
  }),
  time: T({
    formats: Fte,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: zte,
    defaultWidth: "full"
  })
}, Hte = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 6:
        return "'το προηγούμενο' eeee 'στις' p";
      default:
        return "'την προηγούμενη' eeee 'στις' p";
    }
  },
  yesterday: "'χθες στις' p",
  today: "'σήμερα στις' p",
  tomorrow: "'αύριο στις' p",
  nextWeek: "eeee 'στις' p",
  other: "P"
}, Bte = (t, e) => {
  const n = Hte[t];
  return typeof n == "function" ? n(e) : n;
}, qte = {
  narrow: ["πΧ", "μΧ"],
  abbreviated: ["π.Χ.", "μ.Χ."],
  wide: ["προ Χριστού", "μετά Χριστόν"]
}, Gte = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Τ1", "Τ2", "Τ3", "Τ4"],
  wide: ["1ο τρίμηνο", "2ο τρίμηνο", "3ο τρίμηνο", "4ο τρίμηνο"]
}, Xte = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μάρ",
    "Απρ",
    "Μάι",
    "Ιούν",
    "Ιούλ",
    "Αύγ",
    "Σεπ",
    "Οκτ",
    "Νοέ",
    "Δεκ"
  ],
  wide: [
    "Ιανουάριος",
    "Φεβρουάριος",
    "Μάρτιος",
    "Απρίλιος",
    "Μάιος",
    "Ιούνιος",
    "Ιούλιος",
    "Αύγουστος",
    "Σεπτέμβριος",
    "Οκτώβριος",
    "Νοέμβριος",
    "Δεκέμβριος"
  ]
}, Yte = {
  narrow: ["Ι", "Φ", "Μ", "Α", "Μ", "Ι", "Ι", "Α", "Σ", "Ο", "Ν", "Δ"],
  abbreviated: [
    "Ιαν",
    "Φεβ",
    "Μαρ",
    "Απρ",
    "Μαΐ",
    "Ιουν",
    "Ιουλ",
    "Αυγ",
    "Σεπ",
    "Οκτ",
    "Νοε",
    "Δεκ"
  ],
  wide: [
    "Ιανουαρίου",
    "Φεβρουαρίου",
    "Μαρτίου",
    "Απριλίου",
    "Μαΐου",
    "Ιουνίου",
    "Ιουλίου",
    "Αυγούστου",
    "Σεπτεμβρίου",
    "Οκτωβρίου",
    "Νοεμβρίου",
    "Δεκεμβρίου"
  ]
}, Kte = {
  narrow: ["Κ", "Δ", "T", "Τ", "Π", "Π", "Σ"],
  short: ["Κυ", "Δε", "Τρ", "Τε", "Πέ", "Πα", "Σά"],
  abbreviated: ["Κυρ", "Δευ", "Τρί", "Τετ", "Πέμ", "Παρ", "Σάβ"],
  wide: [
    "Κυριακή",
    "Δευτέρα",
    "Τρίτη",
    "Τετάρτη",
    "Πέμπτη",
    "Παρασκευή",
    "Σάββατο"
  ]
}, Ute = {
  narrow: {
    am: "πμ",
    pm: "μμ",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  abbreviated: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  },
  wide: {
    am: "π.μ.",
    pm: "μ.μ.",
    midnight: "μεσάνυχτα",
    noon: "μεσημέρι",
    morning: "πρωί",
    afternoon: "απόγευμα",
    evening: "βράδυ",
    night: "νύχτα"
  }
}, Jte = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  let r;
  return i === "year" || i === "month" ? r = "ος" : i === "week" || i === "dayOfYear" || i === "day" || i === "hour" || i === "date" ? r = "η" : r = "ο", n + r;
}, Qte = {
  ordinalNumber: Jte,
  era: C({
    values: qte,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Gte,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Xte,
    defaultWidth: "wide",
    formattingValues: Yte,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: Kte,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Ute,
    defaultWidth: "wide"
  })
}, Zte = /^(\d+)(ος|η|ο)?/i, ene = /\d+/i, tne = {
  narrow: /^(πΧ|μΧ)/i,
  abbreviated: /^(π\.?\s?χ\.?|π\.?\s?κ\.?\s?χ\.?|μ\.?\s?χ\.?|κ\.?\s?χ\.?)/i,
  wide: /^(προ Χριστο(ύ|υ)|πριν απ(ό|ο) την Κοιν(ή|η) Χρονολογ(ί|ι)α|μετ(ά|α) Χριστ(ό|ο)ν|Κοιν(ή|η) Χρονολογ(ί|ι)α)/i
}, nne = {
  any: [/^π/i, /^(μ|κ)/i]
}, ine = {
  narrow: /^[1234]/i,
  abbreviated: /^τ[1234]/i,
  wide: /^[1234]ο? τρ(ί|ι)μηνο/i
}, rne = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ane = {
  narrow: /^[ιφμαμιιασονδ]/i,
  abbreviated: /^(ιαν|φεβ|μ[άα]ρ|απρ|μ[άα][ιΐ]|ιο[ύυ]ν|ιο[ύυ]λ|α[ύυ]γ|σεπ|οκτ|νο[έε]|δεκ)/i,
  wide: /^(μ[άα][ιΐ]|α[ύυ]γο[υύ]στ)(ος|ου)|(ιανου[άα]ρ|φεβρου[άα]ρ|μ[άα]ρτ|απρ[ίι]λ|ιο[ύυ]ν|ιο[ύυ]λ|σεπτ[έε]μβρ|οκτ[ώω]βρ|νο[έε]μβρ|δεκ[έε]μβρ)(ιος|ίου)/i
}, one = {
  narrow: [
    /^ι/i,
    /^φ/i,
    /^μ/i,
    /^α/i,
    /^μ/i,
    /^ι/i,
    /^ι/i,
    /^α/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i
  ],
  any: [
    /^ια/i,
    /^φ/i,
    /^μ[άα]ρ/i,
    /^απ/i,
    /^μ[άα][ιΐ]/i,
    /^ιο[ύυ]ν/i,
    /^ιο[ύυ]λ/i,
    /^α[ύυ]/i,
    /^σ/i,
    /^ο/i,
    /^ν/i,
    /^δ/i
  ]
}, sne = {
  narrow: /^[κδτπσ]/i,
  short: /^(κυ|δε|τρ|τε|π[εέ]|π[αά]|σ[αά])/i,
  abbreviated: /^(κυρ|δευ|τρι|τετ|πεμ|παρ|σαβ)/i,
  wide: /^(κυριακ(ή|η)|δευτ(έ|ε)ρα|τρ(ί|ι)τη|τετ(ά|α)ρτη|π(έ|ε)μπτη|παρασκευ(ή|η)|σ(ά|α)ββατο)/i
}, lne = {
  narrow: [/^κ/i, /^δ/i, /^τ/i, /^τ/i, /^π/i, /^π/i, /^σ/i],
  any: [/^κ/i, /^δ/i, /^τρ/i, /^τε/i, /^π[εέ]/i, /^π[αά]/i, /^σ/i]
}, dne = {
  narrow: /^(πμ|μμ|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i,
  any: /^([πμ]\.?\s?μ\.?|μεσ(ά|α)νυχτα|μεσημ(έ|ε)ρι|πρω(ί|ι)|απ(ό|ο)γευμα|βρ(ά|α)δυ|ν(ύ|υ)χτα)/i
}, cne = {
  any: {
    am: /^πμ|π\.\s?μ\./i,
    pm: /^μμ|μ\.\s?μ\./i,
    midnight: /^μεσάν/i,
    noon: /^μεσημ(έ|ε)/i,
    morning: /πρω(ί|ι)/i,
    afternoon: /απ(ό|ο)γευμα/i,
    evening: /βρ(ά|α)δυ/i,
    night: /ν(ύ|υ)χτα/i
  }
}, une = {
  ordinalNumber: he({
    matchPattern: Zte,
    parsePattern: ene,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: tne,
    defaultMatchWidth: "wide",
    parsePatterns: nne,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ine,
    defaultMatchWidth: "wide",
    parsePatterns: rne,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: ane,
    defaultMatchWidth: "wide",
    parsePatterns: one,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: sne,
    defaultMatchWidth: "wide",
    parsePatterns: lne,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: dne,
    defaultMatchWidth: "any",
    parsePatterns: cne,
    defaultParseWidth: "any"
  })
}, fne = {
  code: "el",
  formatDistance: Rte,
  formatLong: Vte,
  formatRelative: Bte,
  localize: Qte,
  match: une,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, mne = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, hne = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, pne = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gne = {
  date: T({
    formats: mne,
    defaultWidth: "full"
  }),
  time: T({
    formats: hne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: pne,
    defaultWidth: "full"
  })
}, yne = {
  code: "en-AU",
  formatDistance: Ao,
  formatLong: gne,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, vne = {
  lessThanXSeconds: {
    one: "less than a second",
    other: "less than {{count}} seconds"
  },
  xSeconds: {
    one: "a second",
    other: "{{count}} seconds"
  },
  halfAMinute: "half a minute",
  lessThanXMinutes: {
    one: "less than a minute",
    other: "less than {{count}} minutes"
  },
  xMinutes: {
    one: "a minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "about an hour",
    other: "about {{count}} hours"
  },
  xHours: {
    one: "an hour",
    other: "{{count}} hours"
  },
  xDays: {
    one: "a day",
    other: "{{count}} days"
  },
  aboutXWeeks: {
    one: "about a week",
    other: "about {{count}} weeks"
  },
  xWeeks: {
    one: "a week",
    other: "{{count}} weeks"
  },
  aboutXMonths: {
    one: "about a month",
    other: "about {{count}} months"
  },
  xMonths: {
    one: "a month",
    other: "{{count}} months"
  },
  aboutXYears: {
    one: "about a year",
    other: "about {{count}} years"
  },
  xYears: {
    one: "a year",
    other: "{{count}} years"
  },
  overXYears: {
    one: "over a year",
    other: "over {{count}} years"
  },
  almostXYears: {
    one: "almost a year",
    other: "almost {{count}} years"
  }
}, bne = (t, e, n) => {
  let i;
  const r = vne[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in " + i : i + " ago" : i;
}, wne = {
  full: "EEEE, MMMM do, yyyy",
  long: "MMMM do, yyyy",
  medium: "MMM d, yyyy",
  short: "yyyy-MM-dd"
}, kne = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, xne = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _ne = {
  date: T({
    formats: wne,
    defaultWidth: "full"
  }),
  time: T({
    formats: kne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: xne,
    defaultWidth: "full"
  })
}, Mne = {
  code: "en-CA",
  formatDistance: bne,
  formatLong: _ne,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Cne = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Pne = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Sne = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, gP = {
  date: T({
    formats: Cne,
    defaultWidth: "full"
  }),
  time: T({
    formats: Pne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Sne,
    defaultWidth: "full"
  })
}, Nne = {
  code: "en-GB",
  formatDistance: Ao,
  formatLong: gP,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, $ne = {
  code: "en-IE",
  formatDistance: Ao,
  formatLong: gP,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Dne = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM, yyyy",
  medium: "d MMM, yyyy",
  short: "dd/MM/yyyy"
}, Ene = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Tne = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, One = {
  date: T({
    formats: Dne,
    defaultWidth: "full"
  }),
  time: T({
    formats: Ene,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Tne,
    defaultWidth: "full"
  })
}, Wne = {
  code: "en-IN",
  formatDistance: Ao,
  formatLong: One,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 1,
    // Monday is the first day of the week.
    firstWeekContainsDate: 4
    // The week that contains Jan 4th is the first week of the year.
  }
}, Ane = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, Lne = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Ine = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Rne = {
  date: T({
    formats: Ane,
    defaultWidth: "full"
  }),
  time: T({
    formats: Lne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Ine,
    defaultWidth: "full"
  })
}, jne = {
  code: "en-NZ",
  formatDistance: Ao,
  formatLong: Rne,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Fne = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "yyyy/MM/dd"
}, zne = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vne = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Hne = {
  date: T({
    formats: Fne,
    defaultWidth: "full"
  }),
  time: T({
    formats: zne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Vne,
    defaultWidth: "full"
  })
}, Bne = {
  code: "en-ZA",
  formatDistance: Ao,
  formatLong: Hne,
  formatRelative: ja,
  localize: Fa,
  match: za,
  options: {
    weekStartsOn: 0,
    // Sunday is the first day of the week.
    firstWeekContainsDate: 1
    // The week that contains Jan 1st is the first week of the year.
  }
}, qne = {
  lessThanXSeconds: {
    one: "malpli ol sekundo",
    other: "malpli ol {{count}} sekundoj"
  },
  xSeconds: {
    one: "1 sekundo",
    other: "{{count}} sekundoj"
  },
  halfAMinute: "duonminuto",
  lessThanXMinutes: {
    one: "malpli ol minuto",
    other: "malpli ol {{count}} minutoj"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutoj"
  },
  aboutXHours: {
    one: "proksimume 1 horo",
    other: "proksimume {{count}} horoj"
  },
  xHours: {
    one: "1 horo",
    other: "{{count}} horoj"
  },
  xDays: {
    one: "1 tago",
    other: "{{count}} tagoj"
  },
  aboutXMonths: {
    one: "proksimume 1 monato",
    other: "proksimume {{count}} monatoj"
  },
  xWeeks: {
    one: "1 semajno",
    other: "{{count}} semajnoj"
  },
  aboutXWeeks: {
    one: "proksimume 1 semajno",
    other: "proksimume {{count}} semajnoj"
  },
  xMonths: {
    one: "1 monato",
    other: "{{count}} monatoj"
  },
  aboutXYears: {
    one: "proksimume 1 jaro",
    other: "proksimume {{count}} jaroj"
  },
  xYears: {
    one: "1 jaro",
    other: "{{count}} jaroj"
  },
  overXYears: {
    one: "pli ol 1 jaro",
    other: "pli ol {{count}} jaroj"
  },
  almostXYears: {
    one: "preskaŭ 1 jaro",
    other: "preskaŭ {{count}} jaroj"
  }
}, Gne = (t, e, n) => {
  let i;
  const r = qne[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n != null && n.comparison && n.comparison > 0 ? "post " + i : "antaŭ " + i : i;
}, Xne = {
  full: "EEEE, do 'de' MMMM y",
  long: "y-MMMM-dd",
  medium: "y-MMM-dd",
  short: "yyyy-MM-dd"
}, Yne = {
  full: "Ho 'horo kaj' m:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Kne = {
  any: "{{date}} {{time}}"
}, Une = {
  date: T({
    formats: Xne,
    defaultWidth: "full"
  }),
  time: T({
    formats: Yne,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Kne,
    defaultWidth: "any"
  })
}, Jne = {
  lastWeek: "'pasinta' eeee 'je' p",
  yesterday: "'hieraŭ je' p",
  today: "'hodiaŭ je' p",
  tomorrow: "'morgaŭ je' p",
  nextWeek: "eeee 'je' p",
  other: "P"
}, Qne = (t, e, n, i) => Jne[t], Zne = {
  narrow: ["aK", "pK"],
  abbreviated: ["a.K.E.", "p.K.E."],
  wide: ["antaŭ Komuna Erao", "Komuna Erao"]
}, eie = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: [
    "1-a kvaronjaro",
    "2-a kvaronjaro",
    "3-a kvaronjaro",
    "4-a kvaronjaro"
  ]
}, tie = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "aŭg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januaro",
    "februaro",
    "marto",
    "aprilo",
    "majo",
    "junio",
    "julio",
    "aŭgusto",
    "septembro",
    "oktobro",
    "novembro",
    "decembro"
  ]
}, nie = {
  narrow: ["D", "L", "M", "M", "Ĵ", "V", "S"],
  short: ["di", "lu", "ma", "me", "ĵa", "ve", "sa"],
  abbreviated: ["dim", "lun", "mar", "mer", "ĵaŭ", "ven", "sab"],
  wide: [
    "dimanĉo",
    "lundo",
    "mardo",
    "merkredo",
    "ĵaŭdo",
    "vendredo",
    "sabato"
  ]
}, iie = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  abbreviated: {
    am: "a.t.m.",
    pm: "p.t.m.",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  },
  wide: {
    am: "antaŭtagmeze",
    pm: "posttagmeze",
    midnight: "noktomezo",
    noon: "tagmezo",
    morning: "matene",
    afternoon: "posttagmeze",
    evening: "vespere",
    night: "nokte"
  }
}, rie = (t) => Number(t) + "-a", aie = {
  ordinalNumber: rie,
  era: C({
    values: Zne,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: eie,
    defaultWidth: "wide",
    argumentCallback: function(t) {
      return Number(t) - 1;
    }
  }),
  month: C({
    values: tie,
    defaultWidth: "wide"
  }),
  day: C({
    values: nie,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: iie,
    defaultWidth: "wide"
  })
}, oie = /^(\d+)(-?a)?/i, sie = /\d+/i, lie = {
  narrow: /^([ap]k)/i,
  abbreviated: /^([ap]\.?\s?k\.?\s?e\.?)/i,
  wide: /^((antaǔ |post )?komuna erao)/i
}, die = {
  any: [/^a/i, /^[kp]/i]
}, cie = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](-?a)? kvaronjaro/i
}, uie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fie = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|a(ŭ|ux|uh|u)g|sep|okt|nov|dec)/i,
  wide: /^(januaro|februaro|marto|aprilo|majo|junio|julio|a(ŭ|ux|uh|u)gusto|septembro|oktobro|novembro|decembro)/i
}, mie = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^a(u|ŭ)/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, hie = {
  narrow: /^[dlmĵjvs]/i,
  short: /^(di|lu|ma|me|(ĵ|jx|jh|j)a|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)|ven|sab)/i,
  wide: /^(diman(ĉ|cx|ch|c)o|lundo|mardo|merkredo|(ĵ|jx|jh|j)a(ŭ|ux|uh|u)do|vendredo|sabato)/i
}, pie = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^(j|ĵ)/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^(j|ĵ)/i, /^v/i, /^s/i]
}, gie = {
  narrow: /^([ap]|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  abbreviated: /^([ap][.\s]?t[.\s]?m[.\s]?|(posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo])/i,
  wide: /^(anta(ŭ|ux)tagmez|posttagmez|noktomez|tagmez|maten|vesper|nokt)[eo]/i
}, yie = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^noktom/i,
    noon: /^t/i,
    morning: /^m/i,
    afternoon: /^posttagmeze/i,
    evening: /^v/i,
    night: /^n/i
  }
}, vie = {
  ordinalNumber: he({
    matchPattern: oie,
    parsePattern: sie,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: lie,
    defaultMatchWidth: "wide",
    parsePatterns: die,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: cie,
    defaultMatchWidth: "wide",
    parsePatterns: uie,
    defaultParseWidth: "any",
    valueCallback: function(t) {
      return t + 1;
    }
  }),
  month: P({
    matchPatterns: fie,
    defaultMatchWidth: "wide",
    parsePatterns: mie,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: hie,
    defaultMatchWidth: "wide",
    parsePatterns: pie,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: gie,
    defaultMatchWidth: "wide",
    parsePatterns: yie,
    defaultParseWidth: "any"
  })
}, bie = {
  code: "eo",
  formatDistance: Gne,
  formatLong: Une,
  formatRelative: Qne,
  localize: aie,
  match: vie,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, wie = {
  lessThanXSeconds: {
    one: "menos de un segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos de un minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "alrededor de 1 hora",
    other: "alrededor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "alrededor de 1 semana",
    other: "alrededor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "alrededor de 1 mes",
    other: "alrededor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "alrededor de 1 año",
    other: "alrededor de {{count}} años"
  },
  xYears: {
    one: "1 año",
    other: "{{count}} años"
  },
  overXYears: {
    one: "más de 1 año",
    other: "más de {{count}} años"
  },
  almostXYears: {
    one: "casi 1 año",
    other: "casi {{count}} años"
  }
}, kie = (t, e, n) => {
  let i;
  const r = wie[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + i : "hace " + i : i;
}, xie = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, _ie = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Mie = {
  full: "{{date}} 'a las' {{time}}",
  long: "{{date}} 'a las' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cie = {
  date: T({
    formats: xie,
    defaultWidth: "full"
  }),
  time: T({
    formats: _ie,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Mie,
    defaultWidth: "full"
  })
}, Pie = {
  lastWeek: "'el' eeee 'pasado a la' p",
  yesterday: "'ayer a la' p",
  today: "'hoy a la' p",
  tomorrow: "'mañana a la' p",
  nextWeek: "eeee 'a la' p",
  other: "P"
}, Sie = {
  lastWeek: "'el' eeee 'pasado a las' p",
  yesterday: "'ayer a las' p",
  today: "'hoy a las' p",
  tomorrow: "'mañana a las' p",
  nextWeek: "eeee 'a las' p",
  other: "P"
}, Nie = (t, e, n, i) => e.getHours() !== 1 ? Sie[t] : Pie[t], $ie = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "después de cristo"]
}, Die = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Eie = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "ene",
    "feb",
    "mar",
    "abr",
    "may",
    "jun",
    "jul",
    "ago",
    "sep",
    "oct",
    "nov",
    "dic"
  ],
  wide: [
    "enero",
    "febrero",
    "marzo",
    "abril",
    "mayo",
    "junio",
    "julio",
    "agosto",
    "septiembre",
    "octubre",
    "noviembre",
    "diciembre"
  ]
}, Tie = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "mi", "ju", "vi", "sá"],
  abbreviated: ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"],
  wide: [
    "domingo",
    "lunes",
    "martes",
    "miércoles",
    "jueves",
    "viernes",
    "sábado"
  ]
}, Oie = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "mañana",
    afternoon: "tarde",
    evening: "tarde",
    night: "noche"
  }
}, Wie = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoche",
    noon: "mediodia",
    morning: "de la mañana",
    afternoon: "de la tarde",
    evening: "de la tarde",
    night: "de la noche"
  }
}, Aie = (t, e) => Number(t) + "º", Lie = {
  ordinalNumber: Aie,
  era: C({
    values: $ie,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Die,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: Eie,
    defaultWidth: "wide"
  }),
  day: C({
    values: Tie,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Oie,
    defaultWidth: "wide",
    formattingValues: Wie,
    defaultFormattingWidth: "wide"
  })
}, Iie = /^(\d+)(º)?/i, Rie = /\d+/i, jie = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes de la era com[uú]n|despu[eé]s de cristo|era com[uú]n)/i
}, Fie = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes de la era com[uú]n)/i,
    /^(despu[eé]s de cristo|era com[uú]n)/i
  ]
}, zie = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Vie = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Hie = {
  narrow: /^[efmajsond]/i,
  abbreviated: /^(ene|feb|mar|abr|may|jun|jul|ago|sep|oct|nov|dic)/i,
  wide: /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i
}, Bie = {
  narrow: [
    /^e/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^en/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i
  ]
}, qie = {
  narrow: /^[dlmjvs]/i,
  short: /^(do|lu|ma|mi|ju|vi|s[áa])/i,
  abbreviated: /^(dom|lun|mar|mi[ée]|jue|vie|s[áa]b)/i,
  wide: /^(domingo|lunes|martes|mi[ée]rcoles|jueves|viernes|s[áa]bado)/i
}, Gie = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^mi/i, /^ju/i, /^vi/i, /^sa/i]
}, Xie = {
  narrow: /^(a|p|mn|md|(de la|a las) (mañana|tarde|noche))/i,
  any: /^([ap]\.?\s?m\.?|medianoche|mediodia|(de la|a las) (mañana|tarde|noche))/i
}, Yie = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañana/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noche/i
  }
}, Kie = {
  ordinalNumber: he({
    matchPattern: Iie,
    parsePattern: Rie,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: jie,
    defaultMatchWidth: "wide",
    parsePatterns: Fie,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: zie,
    defaultMatchWidth: "wide",
    parsePatterns: Vie,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Hie,
    defaultMatchWidth: "wide",
    parsePatterns: Bie,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: qie,
    defaultMatchWidth: "wide",
    parsePatterns: Gie,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Xie,
    defaultMatchWidth: "any",
    parsePatterns: Yie,
    defaultParseWidth: "any"
  })
}, Uie = {
  code: "es",
  formatDistance: kie,
  formatLong: Cie,
  formatRelative: Nie,
  localize: Lie,
  match: Kie,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, c2 = {
  lessThanXSeconds: {
    standalone: {
      one: "vähem kui üks sekund",
      other: "vähem kui {{count}} sekundit"
    },
    withPreposition: {
      one: "vähem kui ühe sekundi",
      other: "vähem kui {{count}} sekundi"
    }
  },
  xSeconds: {
    standalone: {
      one: "üks sekund",
      other: "{{count}} sekundit"
    },
    withPreposition: {
      one: "ühe sekundi",
      other: "{{count}} sekundi"
    }
  },
  halfAMinute: {
    standalone: "pool minutit",
    withPreposition: "poole minuti"
  },
  lessThanXMinutes: {
    standalone: {
      one: "vähem kui üks minut",
      other: "vähem kui {{count}} minutit"
    },
    withPreposition: {
      one: "vähem kui ühe minuti",
      other: "vähem kui {{count}} minuti"
    }
  },
  xMinutes: {
    standalone: {
      one: "üks minut",
      other: "{{count}} minutit"
    },
    withPreposition: {
      one: "ühe minuti",
      other: "{{count}} minuti"
    }
  },
  aboutXHours: {
    standalone: {
      one: "umbes üks tund",
      other: "umbes {{count}} tundi"
    },
    withPreposition: {
      one: "umbes ühe tunni",
      other: "umbes {{count}} tunni"
    }
  },
  xHours: {
    standalone: {
      one: "üks tund",
      other: "{{count}} tundi"
    },
    withPreposition: {
      one: "ühe tunni",
      other: "{{count}} tunni"
    }
  },
  xDays: {
    standalone: {
      one: "üks päev",
      other: "{{count}} päeva"
    },
    withPreposition: {
      one: "ühe päeva",
      other: "{{count}} päeva"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "umbes üks nädal",
      other: "umbes {{count}} nädalat"
    },
    withPreposition: {
      one: "umbes ühe nädala",
      other: "umbes {{count}} nädala"
    }
  },
  xWeeks: {
    standalone: {
      one: "üks nädal",
      other: "{{count}} nädalat"
    },
    withPreposition: {
      one: "ühe nädala",
      other: "{{count}} nädala"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "umbes üks kuu",
      other: "umbes {{count}} kuud"
    },
    withPreposition: {
      one: "umbes ühe kuu",
      other: "umbes {{count}} kuu"
    }
  },
  xMonths: {
    standalone: {
      one: "üks kuu",
      other: "{{count}} kuud"
    },
    withPreposition: {
      one: "ühe kuu",
      other: "{{count}} kuu"
    }
  },
  aboutXYears: {
    standalone: {
      one: "umbes üks aasta",
      other: "umbes {{count}} aastat"
    },
    withPreposition: {
      one: "umbes ühe aasta",
      other: "umbes {{count}} aasta"
    }
  },
  xYears: {
    standalone: {
      one: "üks aasta",
      other: "{{count}} aastat"
    },
    withPreposition: {
      one: "ühe aasta",
      other: "{{count}} aasta"
    }
  },
  overXYears: {
    standalone: {
      one: "rohkem kui üks aasta",
      other: "rohkem kui {{count}} aastat"
    },
    withPreposition: {
      one: "rohkem kui ühe aasta",
      other: "rohkem kui {{count}} aasta"
    }
  },
  almostXYears: {
    standalone: {
      one: "peaaegu üks aasta",
      other: "peaaegu {{count}} aastat"
    },
    withPreposition: {
      one: "peaaegu ühe aasta",
      other: "peaaegu {{count}} aasta"
    }
  }
}, Jie = (t, e, n) => {
  const i = n != null && n.addSuffix ? c2[t].withPreposition : c2[t].standalone;
  let r;
  return typeof i == "string" ? r = i : e === 1 ? r = i.one : r = i.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? r + " pärast" : r + " eest" : r;
}, Qie = {
  full: "EEEE, d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Zie = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ere = {
  full: "{{date}} 'kell' {{time}}",
  long: "{{date}} 'kell' {{time}}",
  medium: "{{date}}. {{time}}",
  short: "{{date}}. {{time}}"
}, tre = {
  date: T({
    formats: Qie,
    defaultWidth: "full"
  }),
  time: T({
    formats: Zie,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: ere,
    defaultWidth: "full"
  })
}, nre = {
  lastWeek: "'eelmine' eeee 'kell' p",
  yesterday: "'eile kell' p",
  today: "'täna kell' p",
  tomorrow: "'homme kell' p",
  nextWeek: "'järgmine' eeee 'kell' p",
  other: "P"
}, ire = (t, e, n, i) => nre[t], rre = {
  narrow: ["e.m.a", "m.a.j"],
  abbreviated: ["e.m.a", "m.a.j"],
  wide: ["enne meie ajaarvamist", "meie ajaarvamise järgi"]
}, are = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, u2 = {
  narrow: ["J", "V", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jaan",
    "veebr",
    "märts",
    "apr",
    "mai",
    "juuni",
    "juuli",
    "aug",
    "sept",
    "okt",
    "nov",
    "dets"
  ],
  wide: [
    "jaanuar",
    "veebruar",
    "märts",
    "aprill",
    "mai",
    "juuni",
    "juuli",
    "august",
    "september",
    "oktoober",
    "november",
    "detsember"
  ]
}, f2 = {
  narrow: ["P", "E", "T", "K", "N", "R", "L"],
  short: ["P", "E", "T", "K", "N", "R", "L"],
  abbreviated: [
    "pühap.",
    "esmasp.",
    "teisip.",
    "kolmap.",
    "neljap.",
    "reede.",
    "laup."
  ],
  wide: [
    "pühapäev",
    "esmaspäev",
    "teisipäev",
    "kolmapäev",
    "neljapäev",
    "reede",
    "laupäev"
  ]
}, ore = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "kesköö",
    noon: "keskpäev",
    morning: "hommik",
    afternoon: "pärastlõuna",
    evening: "õhtu",
    night: "öö"
  }
}, sre = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "keskööl",
    noon: "keskpäeval",
    morning: "hommikul",
    afternoon: "pärastlõunal",
    evening: "õhtul",
    night: "öösel"
  }
}, lre = (t, e) => Number(t) + ".", dre = {
  ordinalNumber: lre,
  era: C({
    values: rre,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: are,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: u2,
    defaultWidth: "wide",
    formattingValues: u2,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: f2,
    defaultWidth: "wide",
    formattingValues: f2,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: ore,
    defaultWidth: "wide",
    formattingValues: sre,
    defaultFormattingWidth: "wide"
  })
}, cre = /^\d+\./i, ure = /\d+/i, fre = {
  narrow: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  abbreviated: /^(e\.m\.a|m\.a\.j|eKr|pKr)/i,
  wide: /^(enne meie ajaarvamist|meie ajaarvamise järgi|enne Kristust|pärast Kristust)/i
}, mre = {
  any: [/^e/i, /^(m|p)/i]
}, hre = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, pre = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, gre = {
  narrow: /^[jvmasond]/i,
  abbreviated: /^(jaan|veebr|märts|apr|mai|juuni|juuli|aug|sept|okt|nov|dets)/i,
  wide: /^(jaanuar|veebruar|märts|aprill|mai|juuni|juuli|august|september|oktoober|november|detsember)/i
}, yre = {
  narrow: [
    /^j/i,
    /^v/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^v/i,
    /^mär/i,
    /^ap/i,
    /^mai/i,
    /^juun/i,
    /^juul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, vre = {
  narrow: /^[petknrl]/i,
  short: /^[petknrl]/i,
  abbreviated: /^(püh?|esm?|tei?|kolm?|nel?|ree?|laup?)\.?/i,
  wide: /^(pühapäev|esmaspäev|teisipäev|kolmapäev|neljapäev|reede|laupäev)/i
}, bre = {
  any: [/^p/i, /^e/i, /^t/i, /^k/i, /^n/i, /^r/i, /^l/i]
}, wre = {
  any: /^(am|pm|keskööl?|keskpäev(al)?|hommik(ul)?|pärastlõunal?|õhtul?|öö(sel)?)/i
}, kre = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^keskö/i,
    noon: /^keskp/i,
    morning: /hommik/i,
    afternoon: /pärastlõuna/i,
    evening: /õhtu/i,
    night: /öö/i
  }
}, xre = {
  ordinalNumber: he({
    matchPattern: cre,
    parsePattern: ure,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: fre,
    defaultMatchWidth: "wide",
    parsePatterns: mre,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: hre,
    defaultMatchWidth: "wide",
    parsePatterns: pre,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: gre,
    defaultMatchWidth: "wide",
    parsePatterns: yre,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: vre,
    defaultMatchWidth: "wide",
    parsePatterns: bre,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: wre,
    defaultMatchWidth: "any",
    parsePatterns: kre,
    defaultParseWidth: "any"
  })
}, _re = {
  code: "et",
  formatDistance: Jie,
  formatLong: tre,
  formatRelative: ire,
  localize: dre,
  match: xre,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Mre = {
  lessThanXSeconds: {
    one: "segundo bat baino gutxiago",
    other: "{{count}} segundo baino gutxiago"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundo"
  },
  halfAMinute: "minutu erdi",
  lessThanXMinutes: {
    one: "minutu bat baino gutxiago",
    other: "{{count}} minutu baino gutxiago"
  },
  xMinutes: {
    one: "1 minutu",
    other: "{{count}} minutu"
  },
  aboutXHours: {
    one: "1 ordu gutxi gorabehera",
    other: "{{count}} ordu gutxi gorabehera"
  },
  xHours: {
    one: "1 ordu",
    other: "{{count}} ordu"
  },
  xDays: {
    one: "1 egun",
    other: "{{count}} egun"
  },
  aboutXWeeks: {
    one: "aste 1 inguru",
    other: "{{count}} aste inguru"
  },
  xWeeks: {
    one: "1 aste",
    other: "{{count}} astean"
  },
  aboutXMonths: {
    one: "1 hilabete gutxi gorabehera",
    other: "{{count}} hilabete gutxi gorabehera"
  },
  xMonths: {
    one: "1 hilabete",
    other: "{{count}} hilabete"
  },
  aboutXYears: {
    one: "1 urte gutxi gorabehera",
    other: "{{count}} urte gutxi gorabehera"
  },
  xYears: {
    one: "1 urte",
    other: "{{count}} urte"
  },
  overXYears: {
    one: "1 urte baino gehiago",
    other: "{{count}} urte baino gehiago"
  },
  almostXYears: {
    one: "ia 1 urte",
    other: "ia {{count}} urte"
  }
}, Cre = (t, e, n) => {
  let i;
  const r = Mre[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + i : "duela " + i : i;
}, Pre = {
  full: "EEEE, y'ko' MMMM'ren' d'a' y'ren'",
  long: "y'ko' MMMM'ren' d'a'",
  medium: "y MMM d",
  short: "yy/MM/dd"
}, Sre = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Nre = {
  full: "{{date}} 'tan' {{time}}",
  long: "{{date}} 'tan' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, $re = {
  date: T({
    formats: Pre,
    defaultWidth: "full"
  }),
  time: T({
    formats: Sre,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Nre,
    defaultWidth: "full"
  })
}, Dre = {
  lastWeek: "'joan den' eeee, LT",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, Ere = {
  lastWeek: "'joan den' eeee, p",
  yesterday: "'atzo,' p",
  today: "'gaur,' p",
  tomorrow: "'bihar,' p",
  nextWeek: "eeee, p",
  other: "P"
}, Tre = (t, e) => e.getHours() !== 1 ? Ere[t] : Dre[t], Ore = {
  narrow: ["k.a.", "k.o."],
  abbreviated: ["k.a.", "k.o."],
  wide: ["kristo aurretik", "kristo ondoren"]
}, Wre = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1H", "2H", "3H", "4H"],
  wide: [
    "1. hiruhilekoa",
    "2. hiruhilekoa",
    "3. hiruhilekoa",
    "4. hiruhilekoa"
  ]
}, Are = {
  narrow: ["u", "o", "m", "a", "m", "e", "u", "a", "i", "u", "a", "a"],
  abbreviated: [
    "urt",
    "ots",
    "mar",
    "api",
    "mai",
    "eka",
    "uzt",
    "abu",
    "ira",
    "urr",
    "aza",
    "abe"
  ],
  wide: [
    "urtarrila",
    "otsaila",
    "martxoa",
    "apirila",
    "maiatza",
    "ekaina",
    "uztaila",
    "abuztua",
    "iraila",
    "urria",
    "azaroa",
    "abendua"
  ]
}, Lre = {
  narrow: ["i", "a", "a", "a", "o", "o", "l"],
  short: ["ig", "al", "as", "az", "og", "or", "lr"],
  abbreviated: ["iga", "ast", "ast", "ast", "ost", "ost", "lar"],
  wide: [
    "igandea",
    "astelehena",
    "asteartea",
    "asteazkena",
    "osteguna",
    "ostirala",
    "larunbata"
  ]
}, Ire = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goiza",
    afternoon: "arratsaldea",
    evening: "arratsaldea",
    night: "gaua"
  }
}, Rre = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "ge",
    noon: "eg",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gauerdia",
    noon: "eguerdia",
    morning: "goizean",
    afternoon: "arratsaldean",
    evening: "arratsaldean",
    night: "gauean"
  }
}, jre = (t, e) => Number(t) + ".", Fre = {
  ordinalNumber: jre,
  era: C({
    values: Ore,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Wre,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Are,
    defaultWidth: "wide"
  }),
  day: C({
    values: Lre,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Ire,
    defaultWidth: "wide",
    formattingValues: Rre,
    defaultFormattingWidth: "wide"
  })
}, zre = /^(\d+)(.)?/i, Vre = /\d+/i, Hre = {
  narrow: /^(k.a.|k.o.)/i,
  abbreviated: /^(k.a.|k.o.)/i,
  wide: /^(kristo aurretik|kristo ondoren)/i
}, Bre = {
  narrow: [/^k.a./i, /^k.o./i],
  abbreviated: [/^(k.a.)/i, /^(k.o.)/i],
  wide: [/^(kristo aurretik)/i, /^(kristo ondoren)/i]
}, qre = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]H/i,
  wide: /^[1234](.)? hiruhilekoa/i
}, Gre = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Xre = {
  narrow: /^[uomaei]/i,
  abbreviated: /^(urt|ots|mar|api|mai|eka|uzt|abu|ira|urr|aza|abe)/i,
  wide: /^(urtarrila|otsaila|martxoa|apirila|maiatza|ekaina|uztaila|abuztua|iraila|urria|azaroa|abendua)/i
}, Yre = {
  narrow: [
    /^u/i,
    /^o/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^e/i,
    /^u/i,
    /^a/i,
    /^i/i,
    /^u/i,
    /^a/i,
    /^a/i
  ],
  any: [
    /^urt/i,
    /^ots/i,
    /^mar/i,
    /^api/i,
    /^mai/i,
    /^eka/i,
    /^uzt/i,
    /^abu/i,
    /^ira/i,
    /^urr/i,
    /^aza/i,
    /^abe/i
  ]
}, Kre = {
  narrow: /^[iaol]/i,
  short: /^(ig|al|as|az|og|or|lr)/i,
  abbreviated: /^(iga|ast|ast|ast|ost|ost|lar)/i,
  wide: /^(igandea|astelehena|asteartea|asteazkena|osteguna|ostirala|larunbata)/i
}, Ure = {
  narrow: [/^i/i, /^a/i, /^a/i, /^a/i, /^o/i, /^o/i, /^l/i],
  short: [/^ig/i, /^al/i, /^as/i, /^az/i, /^og/i, /^or/i, /^lr/i],
  abbreviated: [/^iga/i, /^ast/i, /^ast/i, /^ast/i, /^ost/i, /^ost/i, /^lar/i],
  wide: [
    /^igandea/i,
    /^astelehena/i,
    /^asteartea/i,
    /^asteazkena/i,
    /^osteguna/i,
    /^ostirala/i,
    /^larunbata/i
  ]
}, Jre = {
  narrow: /^(a|p|ge|eg|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i,
  any: /^([ap]\.?\s?m\.?|gauerdia|eguerdia|((goiza|goizean)|arratsaldea|(gaua|gauean)))/i
}, Qre = {
  narrow: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^ge/i,
    noon: /^eg/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  },
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^gauerdia/i,
    noon: /^eguerdia/i,
    morning: /goiz/i,
    afternoon: /arratsaldea/i,
    evening: /arratsaldea/i,
    night: /gau/i
  }
}, Zre = {
  ordinalNumber: he({
    matchPattern: zre,
    parsePattern: Vre,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Hre,
    defaultMatchWidth: "wide",
    parsePatterns: Bre,
    defaultParseWidth: "wide"
  }),
  quarter: P({
    matchPatterns: qre,
    defaultMatchWidth: "wide",
    parsePatterns: Gre,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Xre,
    defaultMatchWidth: "wide",
    parsePatterns: Yre,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Kre,
    defaultMatchWidth: "wide",
    parsePatterns: Ure,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: Jre,
    defaultMatchWidth: "any",
    parsePatterns: Qre,
    defaultParseWidth: "any"
  })
}, eae = {
  code: "eu",
  formatDistance: Cre,
  formatLong: $re,
  formatRelative: Tre,
  localize: Fre,
  match: Zre,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, tae = {
  lessThanXSeconds: {
    one: "کمتر از یک ثانیه",
    other: "کمتر از {{count}} ثانیه"
  },
  xSeconds: {
    one: "1 ثانیه",
    other: "{{count}} ثانیه"
  },
  halfAMinute: "نیم دقیقه",
  lessThanXMinutes: {
    one: "کمتر از یک دقیقه",
    other: "کمتر از {{count}} دقیقه"
  },
  xMinutes: {
    one: "1 دقیقه",
    other: "{{count}} دقیقه"
  },
  aboutXHours: {
    one: "حدود 1 ساعت",
    other: "حدود {{count}} ساعت"
  },
  xHours: {
    one: "1 ساعت",
    other: "{{count}} ساعت"
  },
  xDays: {
    one: "1 روز",
    other: "{{count}} روز"
  },
  aboutXWeeks: {
    one: "حدود 1 هفته",
    other: "حدود {{count}} هفته"
  },
  xWeeks: {
    one: "1 هفته",
    other: "{{count}} هفته"
  },
  aboutXMonths: {
    one: "حدود 1 ماه",
    other: "حدود {{count}} ماه"
  },
  xMonths: {
    one: "1 ماه",
    other: "{{count}} ماه"
  },
  aboutXYears: {
    one: "حدود 1 سال",
    other: "حدود {{count}} سال"
  },
  xYears: {
    one: "1 سال",
    other: "{{count}} سال"
  },
  overXYears: {
    one: "بیشتر از 1 سال",
    other: "بیشتر از {{count}} سال"
  },
  almostXYears: {
    one: "نزدیک 1 سال",
    other: "نزدیک {{count}} سال"
  }
}, nae = (t, e, n) => {
  let i;
  const r = tae[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "در " + i : i + " قبل" : i;
}, iae = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "yyyy/MM/dd"
}, rae = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, aae = {
  full: "{{date}} 'در' {{time}}",
  long: "{{date}} 'در' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, oae = {
  date: T({
    formats: iae,
    defaultWidth: "full"
  }),
  time: T({
    formats: rae,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: aae,
    defaultWidth: "full"
  })
}, sae = {
  lastWeek: "eeee 'گذشته در' p",
  yesterday: "'دیروز در' p",
  today: "'امروز در' p",
  tomorrow: "'فردا در' p",
  nextWeek: "eeee 'در' p",
  other: "P"
}, lae = (t, e, n, i) => sae[t], dae = {
  narrow: ["ق", "ب"],
  abbreviated: ["ق.م.", "ب.م."],
  wide: ["قبل از میلاد", "بعد از میلاد"]
}, cae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["س‌م1", "س‌م2", "س‌م3", "س‌م4"],
  wide: ["سه‌ماهه 1", "سه‌ماهه 2", "سه‌ماهه 3", "سه‌ماهه 4"]
}, uae = {
  narrow: ["ژ", "ف", "م", "آ", "م", "ج", "ج", "آ", "س", "ا", "ن", "د"],
  abbreviated: [
    "ژانـ",
    "فور",
    "مارس",
    "آپر",
    "می",
    "جون",
    "جولـ",
    "آگو",
    "سپتـ",
    "اکتـ",
    "نوامـ",
    "دسامـ"
  ],
  wide: [
    "ژانویه",
    "فوریه",
    "مارس",
    "آپریل",
    "می",
    "جون",
    "جولای",
    "آگوست",
    "سپتامبر",
    "اکتبر",
    "نوامبر",
    "دسامبر"
  ]
}, fae = {
  narrow: ["ی", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["1ش", "2ش", "3ش", "4ش", "5ش", "ج", "ش"],
  abbreviated: [
    "یکشنبه",
    "دوشنبه",
    "سه‌شنبه",
    "چهارشنبه",
    "پنجشنبه",
    "جمعه",
    "شنبه"
  ],
  wide: ["یکشنبه", "دوشنبه", "سه‌شنبه", "چهارشنبه", "پنجشنبه", "جمعه", "شنبه"]
}, mae = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, hae = {
  narrow: {
    am: "ق",
    pm: "ب",
    midnight: "ن",
    noon: "ظ",
    morning: "ص",
    afternoon: "ب.ظ.",
    evening: "ع",
    night: "ش"
  },
  abbreviated: {
    am: "ق.ظ.",
    pm: "ب.ظ.",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  },
  wide: {
    am: "قبل‌ازظهر",
    pm: "بعدازظهر",
    midnight: "نیمه‌شب",
    noon: "ظهر",
    morning: "صبح",
    afternoon: "بعدازظهر",
    evening: "عصر",
    night: "شب"
  }
}, pae = (t, e) => String(t), gae = {
  ordinalNumber: pae,
  era: C({
    values: dae,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: cae,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: uae,
    defaultWidth: "wide"
  }),
  day: C({
    values: fae,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: mae,
    defaultWidth: "wide",
    formattingValues: hae,
    defaultFormattingWidth: "wide"
  })
}, yae = /^(\d+)(th|st|nd|rd)?/i, vae = /\d+/i, bae = {
  narrow: /^(ق|ب)/i,
  abbreviated: /^(ق\.?\s?م\.?|ق\.?\s?د\.?\s?م\.?|م\.?\s?|د\.?\s?م\.?)/i,
  wide: /^(قبل از میلاد|قبل از دوران مشترک|میلادی|دوران مشترک|بعد از میلاد)/i
}, wae = {
  any: [/^قبل/i, /^بعد/i]
}, kae = {
  narrow: /^[1234]/i,
  abbreviated: /^س‌م[1234]/i,
  wide: /^سه‌ماهه [1234]/i
}, xae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _ae = {
  narrow: /^[جژفمآاماسند]/i,
  abbreviated: /^(جنو|ژانـ|ژانویه|فوریه|فور|مارس|آوریل|آپر|مه|می|ژوئن|جون|جول|جولـ|ژوئیه|اوت|آگو|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نوامـ|دسامبر|دسامـ|دسم)/i,
  wide: /^(ژانویه|جنوری|فبروری|فوریه|مارچ|مارس|آپریل|اپریل|ایپریل|آوریل|مه|می|ژوئن|جون|جولای|ژوئیه|آگست|اگست|آگوست|اوت|سپتمبر|سپتامبر|اکتبر|اکتوبر|نوامبر|نومبر|دسامبر|دسمبر)/i
}, Mae = {
  narrow: [
    /^(ژ|ج)/i,
    /^ف/i,
    /^م/i,
    /^(آ|ا)/i,
    /^م/i,
    /^(ژ|ج)/i,
    /^(ج|ژ)/i,
    /^(آ|ا)/i,
    /^س/i,
    /^ا/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^ژا/i,
    /^ف/i,
    /^ما/i,
    /^آپ/i,
    /^(می|مه)/i,
    /^(ژوئن|جون)/i,
    /^(ژوئی|جول)/i,
    /^(اوت|آگ)/i,
    /^س/i,
    /^(اوک|اک)/i,
    /^ن/i,
    /^د/i
  ]
}, Cae = {
  narrow: /^[شیدسچپج]/i,
  short: /^(ش|ج|1ش|2ش|3ش|4ش|5ش)/i,
  abbreviated: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i,
  wide: /^(یکشنبه|دوشنبه|سه‌شنبه|چهارشنبه|پنج‌شنبه|جمعه|شنبه)/i
}, Pae = {
  narrow: [/^ی/i, /^دو/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [
    /^(ی|1ش|یکشنبه)/i,
    /^(د|2ش|دوشنبه)/i,
    /^(س|3ش|سه‌شنبه)/i,
    /^(چ|4ش|چهارشنبه)/i,
    /^(پ|5ش|پنجشنبه)/i,
    /^(ج|جمعه)/i,
    /^(ش|شنبه)/i
  ]
}, Sae = {
  narrow: /^(ب|ق|ن|ظ|ص|ب.ظ.|ع|ش)/i,
  abbreviated: /^(ق.ظ.|ب.ظ.|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i,
  wide: /^(قبل‌ازظهر|نیمه‌شب|ظهر|صبح|بعدازظهر|عصر|شب)/i
}, Nae = {
  any: {
    am: /^(ق|ق.ظ.|قبل‌ازظهر)/i,
    pm: /^(ب|ب.ظ.|بعدازظهر)/i,
    midnight: /^(‌نیمه‌شب|ن)/i,
    noon: /^(ظ|ظهر)/i,
    morning: /(ص|صبح)/i,
    afternoon: /(ب|ب.ظ.|بعدازظهر)/i,
    evening: /(ع|عصر)/i,
    night: /(ش|شب)/i
  }
}, $ae = {
  ordinalNumber: he({
    matchPattern: yae,
    parsePattern: vae,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: bae,
    defaultMatchWidth: "wide",
    parsePatterns: wae,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: kae,
    defaultMatchWidth: "wide",
    parsePatterns: xae,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: _ae,
    defaultMatchWidth: "wide",
    parsePatterns: Mae,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Cae,
    defaultMatchWidth: "wide",
    parsePatterns: Pae,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Sae,
    defaultMatchWidth: "wide",
    parsePatterns: Nae,
    defaultParseWidth: "any"
  })
}, Dae = {
  code: "fa-IR",
  formatDistance: nae,
  formatLong: oae,
  formatRelative: lae,
  localize: gae,
  match: $ae,
  options: {
    weekStartsOn: 6,
    firstWeekContainsDate: 1
  }
};
function m2(t) {
  return t.replace(/sekuntia?/, "sekunnin");
}
function h2(t) {
  return t.replace(/minuuttia?/, "minuutin");
}
function p2(t) {
  return t.replace(/tuntia?/, "tunnin");
}
function Eae(t) {
  return t.replace(/päivää?/, "päivän");
}
function g2(t) {
  return t.replace(/(viikko|viikkoa)/, "viikon");
}
function y2(t) {
  return t.replace(/(kuukausi|kuukautta)/, "kuukauden");
}
function Uc(t) {
  return t.replace(/(vuosi|vuotta)/, "vuoden");
}
const Tae = {
  lessThanXSeconds: {
    one: "alle sekunti",
    other: "alle {{count}} sekuntia",
    futureTense: m2
  },
  xSeconds: {
    one: "sekunti",
    other: "{{count}} sekuntia",
    futureTense: m2
  },
  halfAMinute: {
    one: "puoli minuuttia",
    other: "puoli minuuttia",
    futureTense: (t) => "puolen minuutin"
  },
  lessThanXMinutes: {
    one: "alle minuutti",
    other: "alle {{count}} minuuttia",
    futureTense: h2
  },
  xMinutes: {
    one: "minuutti",
    other: "{{count}} minuuttia",
    futureTense: h2
  },
  aboutXHours: {
    one: "noin tunti",
    other: "noin {{count}} tuntia",
    futureTense: p2
  },
  xHours: {
    one: "tunti",
    other: "{{count}} tuntia",
    futureTense: p2
  },
  xDays: {
    one: "päivä",
    other: "{{count}} päivää",
    futureTense: Eae
  },
  aboutXWeeks: {
    one: "noin viikko",
    other: "noin {{count}} viikkoa",
    futureTense: g2
  },
  xWeeks: {
    one: "viikko",
    other: "{{count}} viikkoa",
    futureTense: g2
  },
  aboutXMonths: {
    one: "noin kuukausi",
    other: "noin {{count}} kuukautta",
    futureTense: y2
  },
  xMonths: {
    one: "kuukausi",
    other: "{{count}} kuukautta",
    futureTense: y2
  },
  aboutXYears: {
    one: "noin vuosi",
    other: "noin {{count}} vuotta",
    futureTense: Uc
  },
  xYears: {
    one: "vuosi",
    other: "{{count}} vuotta",
    futureTense: Uc
  },
  overXYears: {
    one: "yli vuosi",
    other: "yli {{count}} vuotta",
    futureTense: Uc
  },
  almostXYears: {
    one: "lähes vuosi",
    other: "lähes {{count}} vuotta",
    futureTense: Uc
  }
}, Oae = (t, e, n) => {
  const i = Tae[t], r = e === 1 ? i.one : i.other.replace("{{count}}", String(e));
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i.futureTense(r) + " kuluttua" : r + " sitten" : r;
}, Wae = {
  full: "eeee d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "d.M.y"
}, Aae = {
  full: "HH.mm.ss zzzz",
  long: "HH.mm.ss z",
  medium: "HH.mm.ss",
  short: "HH.mm"
}, Lae = {
  full: "{{date}} 'klo' {{time}}",
  long: "{{date}} 'klo' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Iae = {
  date: T({
    formats: Wae,
    defaultWidth: "full"
  }),
  time: T({
    formats: Aae,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Lae,
    defaultWidth: "full"
  })
}, Rae = {
  lastWeek: "'viime' eeee 'klo' p",
  yesterday: "'eilen klo' p",
  today: "'tänään klo' p",
  tomorrow: "'huomenna klo' p",
  nextWeek: "'ensi' eeee 'klo' p",
  other: "P"
}, jae = (t, e, n, i) => Rae[t], Fae = {
  narrow: ["eaa.", "jaa."],
  abbreviated: ["eaa.", "jaa."],
  wide: ["ennen ajanlaskun alkua", "jälkeen ajanlaskun alun"]
}, zae = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartaali", "2. kvartaali", "3. kvartaali", "4. kvartaali"]
}, hg = {
  narrow: ["T", "H", "M", "H", "T", "K", "H", "E", "S", "L", "M", "J"],
  abbreviated: [
    "tammi",
    "helmi",
    "maalis",
    "huhti",
    "touko",
    "kesä",
    "heinä",
    "elo",
    "syys",
    "loka",
    "marras",
    "joulu"
  ],
  wide: [
    "tammikuu",
    "helmikuu",
    "maaliskuu",
    "huhtikuu",
    "toukokuu",
    "kesäkuu",
    "heinäkuu",
    "elokuu",
    "syyskuu",
    "lokakuu",
    "marraskuu",
    "joulukuu"
  ]
}, Vae = {
  narrow: hg.narrow,
  abbreviated: hg.abbreviated,
  wide: [
    "tammikuuta",
    "helmikuuta",
    "maaliskuuta",
    "huhtikuuta",
    "toukokuuta",
    "kesäkuuta",
    "heinäkuuta",
    "elokuuta",
    "syyskuuta",
    "lokakuuta",
    "marraskuuta",
    "joulukuuta"
  ]
}, _u = {
  narrow: ["S", "M", "T", "K", "T", "P", "L"],
  short: ["su", "ma", "ti", "ke", "to", "pe", "la"],
  abbreviated: ["sunn.", "maan.", "tiis.", "kesk.", "torst.", "perj.", "la"],
  wide: [
    "sunnuntai",
    "maanantai",
    "tiistai",
    "keskiviikko",
    "torstai",
    "perjantai",
    "lauantai"
  ]
}, Hae = {
  narrow: _u.narrow,
  short: _u.short,
  abbreviated: _u.abbreviated,
  wide: [
    "sunnuntaina",
    "maanantaina",
    "tiistaina",
    "keskiviikkona",
    "torstaina",
    "perjantaina",
    "lauantaina"
  ]
}, Bae = {
  narrow: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  abbreviated: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyö",
    noon: "keskipäivä",
    morning: "ap",
    afternoon: "ip",
    evening: "illalla",
    night: "yöllä"
  },
  wide: {
    am: "ap",
    pm: "ip",
    midnight: "keskiyöllä",
    noon: "keskipäivällä",
    morning: "aamupäivällä",
    afternoon: "iltapäivällä",
    evening: "illalla",
    night: "yöllä"
  }
}, qae = (t, e) => Number(t) + ".", Gae = {
  ordinalNumber: qae,
  era: C({
    values: Fae,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: zae,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: hg,
    defaultWidth: "wide",
    formattingValues: Vae,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: _u,
    defaultWidth: "wide",
    formattingValues: Hae,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: Bae,
    defaultWidth: "wide"
  })
}, Xae = /^(\d+)(\.)/i, Yae = /\d+/i, Kae = {
  narrow: /^(e|j)/i,
  abbreviated: /^(eaa.|jaa.)/i,
  wide: /^(ennen ajanlaskun alkua|jälkeen ajanlaskun alun)/i
}, Uae = {
  any: [/^e/i, /^j/i]
}, Jae = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\.? kvartaali/i
}, Qae = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zae = {
  narrow: /^[thmkeslj]/i,
  abbreviated: /^(tammi|helmi|maalis|huhti|touko|kesä|heinä|elo|syys|loka|marras|joulu)/i,
  wide: /^(tammikuu|helmikuu|maaliskuu|huhtikuu|toukokuu|kesäkuu|heinäkuu|elokuu|syyskuu|lokakuu|marraskuu|joulukuu)(ta)?/i
}, eoe = {
  narrow: [
    /^t/i,
    /^h/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^k/i,
    /^h/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^m/i,
    /^j/i
  ],
  any: [
    /^ta/i,
    /^hel/i,
    /^maa/i,
    /^hu/i,
    /^to/i,
    /^k/i,
    /^hei/i,
    /^e/i,
    /^s/i,
    /^l/i,
    /^mar/i,
    /^j/i
  ]
}, toe = {
  narrow: /^[smtkpl]/i,
  short: /^(su|ma|ti|ke|to|pe|la)/i,
  abbreviated: /^(sunn.|maan.|tiis.|kesk.|torst.|perj.|la)/i,
  wide: /^(sunnuntai|maanantai|tiistai|keskiviikko|torstai|perjantai|lauantai)(na)?/i
}, noe = {
  narrow: [/^s/i, /^m/i, /^t/i, /^k/i, /^t/i, /^p/i, /^l/i],
  any: [/^s/i, /^m/i, /^ti/i, /^k/i, /^to/i, /^p/i, /^l/i]
}, ioe = {
  narrow: /^(ap|ip|keskiyö|keskipäivä|aamupäivällä|iltapäivällä|illalla|yöllä)/i,
  any: /^(ap|ip|keskiyöllä|keskipäivällä|aamupäivällä|iltapäivällä|illalla|yöllä)/i
}, roe = {
  any: {
    am: /^ap/i,
    pm: /^ip/i,
    midnight: /^keskiyö/i,
    noon: /^keskipäivä/i,
    morning: /aamupäivällä/i,
    afternoon: /iltapäivällä/i,
    evening: /illalla/i,
    night: /yöllä/i
  }
}, aoe = {
  ordinalNumber: he({
    matchPattern: Xae,
    parsePattern: Yae,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Kae,
    defaultMatchWidth: "wide",
    parsePatterns: Uae,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Jae,
    defaultMatchWidth: "wide",
    parsePatterns: Qae,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Zae,
    defaultMatchWidth: "wide",
    parsePatterns: eoe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: toe,
    defaultMatchWidth: "wide",
    parsePatterns: noe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ioe,
    defaultMatchWidth: "any",
    parsePatterns: roe,
    defaultParseWidth: "any"
  })
}, ooe = {
  code: "fi",
  formatDistance: Oae,
  formatLong: Iae,
  formatRelative: jae,
  localize: Gae,
  match: aoe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, soe = {
  lessThanXSeconds: {
    one: "moins d’une seconde",
    other: "moins de {{count}} secondes"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} secondes"
  },
  halfAMinute: "30 secondes",
  lessThanXMinutes: {
    one: "moins d’une minute",
    other: "moins de {{count}} minutes"
  },
  xMinutes: {
    one: "1 minute",
    other: "{{count}} minutes"
  },
  aboutXHours: {
    one: "environ 1 heure",
    other: "environ {{count}} heures"
  },
  xHours: {
    one: "1 heure",
    other: "{{count}} heures"
  },
  xDays: {
    one: "1 jour",
    other: "{{count}} jours"
  },
  aboutXWeeks: {
    one: "environ 1 semaine",
    other: "environ {{count}} semaines"
  },
  xWeeks: {
    one: "1 semaine",
    other: "{{count}} semaines"
  },
  aboutXMonths: {
    one: "environ 1 mois",
    other: "environ {{count}} mois"
  },
  xMonths: {
    one: "1 mois",
    other: "{{count}} mois"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "plus d’un an",
    other: "plus de {{count}} ans"
  },
  almostXYears: {
    one: "presqu’un an",
    other: "presque {{count}} ans"
  }
}, l0 = (t, e, n) => {
  let i;
  const r = soe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dans " + i : "il y a " + i : i;
}, loe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, doe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, coe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, uoe = {
  date: T({
    formats: loe,
    defaultWidth: "full"
  }),
  time: T({
    formats: doe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: coe,
    defaultWidth: "full"
  })
}, foe = {
  lastWeek: "eeee 'dernier à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'prochain à' p",
  other: "P"
}, yP = (t, e, n, i) => foe[t], moe = {
  narrow: ["av. J.-C", "ap. J.-C"],
  abbreviated: ["av. J.-C", "ap. J.-C"],
  wide: ["avant Jésus-Christ", "après Jésus-Christ"]
}, hoe = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1er trim.", "2ème trim.", "3ème trim.", "4ème trim."],
  wide: ["1er trimestre", "2ème trimestre", "3ème trimestre", "4ème trimestre"]
}, poe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "févr.",
    "mars",
    "avr.",
    "mai",
    "juin",
    "juil.",
    "août",
    "sept.",
    "oct.",
    "nov.",
    "déc."
  ],
  wide: [
    "janvier",
    "février",
    "mars",
    "avril",
    "mai",
    "juin",
    "juillet",
    "août",
    "septembre",
    "octobre",
    "novembre",
    "décembre"
  ]
}, goe = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "lu", "ma", "me", "je", "ve", "sa"],
  abbreviated: ["dim.", "lun.", "mar.", "mer.", "jeu.", "ven.", "sam."],
  wide: [
    "dimanche",
    "lundi",
    "mardi",
    "mercredi",
    "jeudi",
    "vendredi",
    "samedi"
  ]
}, yoe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "soir",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "matin",
    afternoon: "après-midi",
    evening: "soir",
    night: "matin"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minuit",
    noon: "midi",
    morning: "du matin",
    afternoon: "de l’après-midi",
    evening: "du soir",
    night: "du matin"
  }
}, voe = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  if (n === 0) return "0";
  const r = ["year", "week", "hour", "minute", "second"];
  let a;
  return n === 1 ? a = i && r.includes(i) ? "ère" : "er" : a = "ème", n + a;
}, boe = ["MMM", "MMMM"], d0 = {
  preprocessor: (t, e) => t.getDate() === 1 || !e.some(
    (i) => i.isToken && boe.includes(i.value)
  ) ? e : e.map(
    (i) => i.isToken && i.value === "do" ? { isToken: !0, value: "d" } : i
  ),
  ordinalNumber: voe,
  era: C({
    values: moe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: hoe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: poe,
    defaultWidth: "wide"
  }),
  day: C({
    values: goe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: yoe,
    defaultWidth: "wide"
  })
}, woe = /^(\d+)(ième|ère|ème|er|e)?/i, koe = /\d+/i, xoe = {
  narrow: /^(av\.J\.C|ap\.J\.C|ap\.J\.-C)/i,
  abbreviated: /^(av\.J\.-C|av\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(avant Jésus-Christ|après Jésus-Christ)/i
}, _oe = {
  any: [/^av/i, /^ap/i]
}, Moe = {
  narrow: /^T?[1234]/i,
  abbreviated: /^[1234](er|ème|e)? trim\.?/i,
  wide: /^[1234](er|ème|e)? trimestre/i
}, Coe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Poe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|févr|mars|avr|mai|juin|juill|juil|août|sept|oct|nov|déc)\.?/i,
  wide: /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i
}, Soe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^av/i,
    /^ma/i,
    /^juin/i,
    /^juil/i,
    /^ao/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Noe = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|lu|ma|me|je|ve|sa)/i,
  abbreviated: /^(dim|lun|mar|mer|jeu|ven|sam)\.?/i,
  wide: /^(dimanche|lundi|mardi|mercredi|jeudi|vendredi|samedi)/i
}, $oe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^lu/i, /^ma/i, /^me/i, /^je/i, /^ve/i, /^sa/i]
}, Doe = {
  narrow: /^(a|p|minuit|midi|mat\.?|ap\.?m\.?|soir|nuit)/i,
  any: /^([ap]\.?\s?m\.?|du matin|de l'après[-\s]midi|du soir|de la nuit)/i
}, Eoe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /soir/i,
    night: /nuit/i
  }
}, c0 = {
  ordinalNumber: he({
    matchPattern: woe,
    parsePattern: koe,
    valueCallback: (t) => parseInt(t)
  }),
  era: P({
    matchPatterns: xoe,
    defaultMatchWidth: "wide",
    parsePatterns: _oe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Moe,
    defaultMatchWidth: "wide",
    parsePatterns: Coe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Poe,
    defaultMatchWidth: "wide",
    parsePatterns: Soe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Noe,
    defaultMatchWidth: "wide",
    parsePatterns: $oe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Doe,
    defaultMatchWidth: "any",
    parsePatterns: Eoe,
    defaultParseWidth: "any"
  })
}, Toe = {
  code: "fr",
  formatDistance: l0,
  formatLong: uoe,
  formatRelative: yP,
  localize: d0,
  match: c0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Ooe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "yy-MM-dd"
}, Woe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Aoe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Loe = {
  date: T({
    formats: Ooe,
    defaultWidth: "full"
  }),
  time: T({
    formats: Woe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Aoe,
    defaultWidth: "full"
  })
}, Ioe = {
  code: "fr-CA",
  formatDistance: l0,
  formatLong: Loe,
  formatRelative: yP,
  localize: d0,
  match: c0,
  // Unique for fr-CA
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Roe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, joe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Foe = {
  full: "{{date}} 'à' {{time}}",
  long: "{{date}} 'à' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zoe = {
  date: T({
    formats: Roe,
    defaultWidth: "full"
  }),
  time: T({
    formats: joe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Foe,
    defaultWidth: "full"
  })
}, Voe = {
  lastWeek: "eeee 'la semaine dernière à' p",
  yesterday: "'hier à' p",
  today: "'aujourd’hui à' p",
  tomorrow: "'demain à' p'",
  nextWeek: "eeee 'la semaine prochaine à' p",
  other: "P"
}, Hoe = (t, e, n, i) => Voe[t], Boe = {
  code: "fr-CH",
  formatDistance: l0,
  formatLong: zoe,
  formatRelative: Hoe,
  localize: d0,
  match: c0,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, qoe = {
  lessThanXSeconds: {
    one: "minder as 1 sekonde",
    other: "minder as {{count}} sekonden"
  },
  xSeconds: {
    one: "1 sekonde",
    other: "{{count}} sekonden"
  },
  halfAMinute: "oardel minút",
  lessThanXMinutes: {
    one: "minder as 1 minút",
    other: "minder as {{count}} minuten"
  },
  xMinutes: {
    one: "1 minút",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "sawat 1 oere",
    other: "sawat {{count}} oere"
  },
  xHours: {
    one: "1 oere",
    other: "{{count}} oere"
  },
  xDays: {
    one: "1 dei",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "sawat 1 wike",
    other: "sawat {{count}} wiken"
  },
  xWeeks: {
    one: "1 wike",
    other: "{{count}} wiken"
  },
  aboutXMonths: {
    one: "sawat 1 moanne",
    other: "sawat {{count}} moannen"
  },
  xMonths: {
    one: "1 moanne",
    other: "{{count}} moannen"
  },
  aboutXYears: {
    one: "sawat 1 jier",
    other: "sawat {{count}} jier"
  },
  xYears: {
    one: "1 jier",
    other: "{{count}} jier"
  },
  overXYears: {
    one: "mear as 1 jier",
    other: "mear as {{count}}s jier"
  },
  almostXYears: {
    one: "hast 1 jier",
    other: "hast {{count}} jier"
  }
}, Goe = (t, e, n) => {
  let i;
  const r = qoe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "oer " + i : i + " lyn" : i;
}, Xoe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, Yoe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Koe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Uoe = {
  date: T({
    formats: Xoe,
    defaultWidth: "full"
  }),
  time: T({
    formats: Yoe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Koe,
    defaultWidth: "full"
  })
}, Joe = {
  lastWeek: "'ôfrûne' eeee 'om' p",
  yesterday: "'juster om' p",
  today: "'hjoed om' p",
  tomorrow: "'moarn om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Qoe = (t, e, n, i) => Joe[t], Zoe = {
  narrow: ["f.K.", "n.K."],
  abbreviated: ["f.Kr.", "n.Kr."],
  wide: ["foar Kristus", "nei Kristus"]
}, ese = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e fearnsjier", "2e fearnsjier", "3e fearnsjier", "4e fearnsjier"]
}, tse = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mai.",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "jannewaris",
    "febrewaris",
    "maart",
    "april",
    "maaie",
    "juny",
    "july",
    "augustus",
    "septimber",
    "oktober",
    "novimber",
    "desimber"
  ]
}, nse = {
  narrow: ["s", "m", "t", "w", "t", "f", "s"],
  short: ["si", "mo", "ti", "wo", "to", "fr", "so"],
  abbreviated: ["snein", "moa", "tii", "woa", "ton", "fre", "sneon"],
  wide: [
    "snein",
    "moandei",
    "tiisdei",
    "woansdei",
    "tongersdei",
    "freed",
    "sneon"
  ]
}, ise = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "middei",
    morning: "moarns",
    afternoon: "middeis",
    evening: "jûns",
    night: "nachts"
  }
}, rse = (t, e) => Number(t) + "e", ase = {
  ordinalNumber: rse,
  era: C({
    values: Zoe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: ese,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: tse,
    defaultWidth: "wide"
  }),
  day: C({
    values: nse,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: ise,
    defaultWidth: "wide"
  })
}, ose = /^(\d+)e?/i, sse = /\d+/i, lse = {
  narrow: /^([fn]\.? ?K\.?)/,
  abbreviated: /^([fn]\. ?Kr\.?)/,
  wide: /^((foar|nei) Kristus)/
}, dse = {
  any: [/^f/, /^n/]
}, cse = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e fearnsjier/i
}, use = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, fse = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mai.|jun.|jul.|aug.|sep.|okt.|nov.|des.)/i,
  wide: /^(jannewaris|febrewaris|maart|april|maaie|juny|july|augustus|septimber|oktober|novimber|desimber)/i
}, mse = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^des/i
  ]
}, hse = {
  narrow: /^[smtwf]/i,
  short: /^(si|mo|ti|wo|to|fr|so)/i,
  abbreviated: /^(snein|moa|tii|woa|ton|fre|sneon)/i,
  wide: /^(snein|moandei|tiisdei|woansdei|tongersdei|freed|sneon)/i
}, pse = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^sn/i, /^mo/i, /^ti/i, /^wo/i, /^to/i, /^fr/i, /^sn/i]
}, gse = {
  any: /^(am|pm|middernacht|middeis|moarns|middei|jûns|nachts)/i
}, yse = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^middei/i,
    morning: /moarns/i,
    afternoon: /^middeis/i,
    evening: /jûns/i,
    night: /nachts/i
  }
}, vse = {
  ordinalNumber: he({
    matchPattern: ose,
    parsePattern: sse,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: lse,
    defaultMatchWidth: "wide",
    parsePatterns: dse,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: cse,
    defaultMatchWidth: "wide",
    parsePatterns: use,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: fse,
    defaultMatchWidth: "wide",
    parsePatterns: mse,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: hse,
    defaultMatchWidth: "wide",
    parsePatterns: pse,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: gse,
    defaultMatchWidth: "any",
    parsePatterns: yse,
    defaultParseWidth: "any"
  })
}, bse = {
  code: "fy",
  formatDistance: Goe,
  formatLong: Uoe,
  formatRelative: Qoe,
  localize: ase,
  match: vse,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, wse = {
  lessThanXSeconds: {
    one: "nas lugha na diog",
    other: "nas lugha na {{count}} diogan"
  },
  xSeconds: {
    one: "1 diog",
    two: "2 dhiog",
    twenty: "20 diog",
    other: "{{count}} diogan"
  },
  halfAMinute: "leth mhionaid",
  lessThanXMinutes: {
    one: "nas lugha na mionaid",
    other: "nas lugha na {{count}} mionaidean"
  },
  xMinutes: {
    one: "1 mionaid",
    two: "2 mhionaid",
    twenty: "20 mionaid",
    other: "{{count}} mionaidean"
  },
  aboutXHours: {
    one: "mu uair de thìde",
    other: "mu {{count}} uairean de thìde"
  },
  xHours: {
    one: "1 uair de thìde",
    two: "2 uair de thìde",
    twenty: "20 uair de thìde",
    other: "{{count}} uairean de thìde"
  },
  xDays: {
    one: "1 là",
    other: "{{count}} là"
  },
  aboutXWeeks: {
    one: "mu 1 seachdain",
    other: "mu {{count}} seachdainean"
  },
  xWeeks: {
    one: "1 seachdain",
    other: "{{count}} seachdainean"
  },
  aboutXMonths: {
    one: "mu mhìos",
    other: "mu {{count}} mìosan"
  },
  xMonths: {
    one: "1 mìos",
    other: "{{count}} mìosan"
  },
  aboutXYears: {
    one: "mu bhliadhna",
    other: "mu {{count}} bliadhnaichean"
  },
  xYears: {
    one: "1 bhliadhna",
    other: "{{count}} bliadhna"
  },
  overXYears: {
    one: "còrr is bliadhna",
    other: "còrr is {{count}} bliadhnaichean"
  },
  almostXYears: {
    one: "cha mhòr bliadhna",
    other: "cha mhòr {{count}} bliadhnaichean"
  }
}, kse = (t, e, n) => {
  let i;
  const r = wse[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 && r.two ? i = r.two : e === 20 && r.twenty ? i = r.twenty : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "ann an " + i : "o chionn " + i : i;
}, xse = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, _se = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Mse = {
  full: "{{date}} 'aig' {{time}}",
  long: "{{date}} 'aig' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Cse = {
  date: T({
    formats: xse,
    defaultWidth: "full"
  }),
  time: T({
    formats: _se,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Mse,
    defaultWidth: "full"
  })
}, Pse = {
  lastWeek: "'mu dheireadh' eeee 'aig' p",
  //FIX
  yesterday: "'an-dè aig' p",
  today: "'an-diugh aig' p",
  tomorrow: "'a-màireach aig' p",
  nextWeek: "eeee 'aig' p",
  other: "P"
}, Sse = (t, e, n, i) => Pse[t], Nse = {
  narrow: ["R", "A"],
  abbreviated: ["RC", "AD"],
  wide: ["ro Chrìosta", "anno domini"]
}, $se = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["C1", "C2", "C3", "C4"],
  wide: [
    "a' chiad chairteal",
    "an dàrna cairteal",
    "an treas cairteal",
    "an ceathramh cairteal"
  ]
}, Dse = {
  narrow: ["F", "G", "M", "G", "C", "Ò", "I", "L", "S", "D", "S", "D"],
  abbreviated: [
    "Faoi",
    "Gear",
    "Màrt",
    "Gibl",
    "Cèit",
    "Ògmh",
    "Iuch",
    "Lùn",
    "Sult",
    "Dàmh",
    "Samh",
    "Dùbh"
  ],
  wide: [
    "Am Faoilleach",
    "An Gearran",
    "Am Màrt",
    "An Giblean",
    "An Cèitean",
    "An t-Ògmhios",
    "An t-Iuchar",
    "An Lùnastal",
    "An t-Sultain",
    "An Dàmhair",
    "An t-Samhain",
    "An Dùbhlachd"
  ]
}, Ese = {
  narrow: ["D", "L", "M", "C", "A", "H", "S"],
  short: ["Dò", "Lu", "Mà", "Ci", "Ar", "Ha", "Sa"],
  abbreviated: ["Did", "Dil", "Dim", "Dic", "Dia", "Dih", "Dis"],
  wide: [
    "Didòmhnaich",
    "Diluain",
    "Dimàirt",
    "Diciadain",
    "Diardaoin",
    "Dihaoine",
    "Disathairne"
  ]
}, Tse = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "madainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "oidhche"
  }
}, Ose = {
  narrow: {
    am: "m",
    pm: "f",
    midnight: "m.o.",
    noon: "m.l.",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  abbreviated: {
    am: "M.",
    pm: "F.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  },
  wide: {
    am: "m.",
    pm: "f.",
    midnight: "meadhan oidhche",
    noon: "meadhan là",
    morning: "sa mhadainn",
    afternoon: "feasgar",
    evening: "feasgar",
    night: "air an oidhche"
  }
}, Wse = (t) => {
  const e = Number(t), n = e % 100;
  if (n > 20 || n < 10)
    switch (n % 10) {
      case 1:
        return e + "d";
      case 2:
        return e + "na";
    }
  return n === 12 ? e + "na" : e + "mh";
}, Ase = {
  ordinalNumber: Wse,
  era: C({
    values: Nse,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: $se,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Dse,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ese,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Tse,
    defaultWidth: "wide",
    formattingValues: Ose,
    defaultFormattingWidth: "wide"
  })
}, Lse = /^(\d+)(d|na|tr|mh)?/i, Ise = /\d+/i, Rse = {
  narrow: /^(r|a)/i,
  abbreviated: /^(r\.?\s?c\.?|r\.?\s?a\.?\s?c\.?|a\.?\s?d\.?|a\.?\s?c\.?)/i,
  wide: /^(ro Chrìosta|ron aois choitchinn|anno domini|aois choitcheann)/i
}, jse = {
  any: [/^b/i, /^(a|c)/i]
}, Fse = {
  narrow: /^[1234]/i,
  abbreviated: /^c[1234]/i,
  wide: /^[1234](cd|na|tr|mh)? cairteal/i
}, zse = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Vse = {
  narrow: /^[fgmcòilsd]/i,
  abbreviated: /^(faoi|gear|màrt|gibl|cèit|ògmh|iuch|lùn|sult|dàmh|samh|dùbh)/i,
  wide: /^(am faoilleach|an gearran|am màrt|an giblean|an cèitean|an t-Ògmhios|an t-Iuchar|an lùnastal|an t-Sultain|an dàmhair|an t-Samhain|an dùbhlachd)/i
}, Hse = {
  narrow: [
    /^f/i,
    /^g/i,
    /^m/i,
    /^g/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^s/i,
    /^d/i,
    /^s/i,
    /^d/i
  ],
  any: [
    /^fa/i,
    /^ge/i,
    /^mà/i,
    /^gi/i,
    /^c/i,
    /^ò/i,
    /^i/i,
    /^l/i,
    /^su/i,
    /^d/i,
    /^sa/i,
    /^d/i
  ]
}, Bse = {
  narrow: /^[dlmcahs]/i,
  short: /^(dò|lu|mà|ci|ar|ha|sa)/i,
  abbreviated: /^(did|dil|dim|dic|dia|dih|dis)/i,
  wide: /^(didòmhnaich|diluain|dimàirt|diciadain|diardaoin|dihaoine|disathairne)/i
}, qse = {
  narrow: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i],
  any: [/^d/i, /^l/i, /^m/i, /^c/i, /^a/i, /^h/i, /^s/i]
}, Gse = {
  narrow: /^(a|p|mi|n|(san|aig) (madainn|feasgar|feasgar|oidhche))/i,
  any: /^([ap]\.?\s?m\.?|meadhan oidhche|meadhan là|(san|aig) (madainn|feasgar|feasgar|oidhche))/i
}, Xse = {
  any: {
    am: /^m/i,
    pm: /^f/i,
    midnight: /^meadhan oidhche/i,
    noon: /^meadhan là/i,
    morning: /sa mhadainn/i,
    afternoon: /feasgar/i,
    evening: /feasgar/i,
    night: /air an oidhche/i
  }
}, Yse = {
  ordinalNumber: he({
    matchPattern: Lse,
    parsePattern: Ise,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Rse,
    defaultMatchWidth: "wide",
    parsePatterns: jse,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Fse,
    defaultMatchWidth: "wide",
    parsePatterns: zse,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Vse,
    defaultMatchWidth: "wide",
    parsePatterns: Hse,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Bse,
    defaultMatchWidth: "wide",
    parsePatterns: qse,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Gse,
    defaultMatchWidth: "any",
    parsePatterns: Xse,
    defaultParseWidth: "any"
  })
}, Kse = {
  code: "gd",
  formatDistance: kse,
  formatLong: Cse,
  formatRelative: Sse,
  localize: Ase,
  match: Yse,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, Use = {
  lessThanXSeconds: {
    one: "menos dun segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "medio minuto",
  lessThanXMinutes: {
    one: "menos dun minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "arredor dunha hora",
    other: "arredor de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 día",
    other: "{{count}} días"
  },
  aboutXWeeks: {
    one: "arredor dunha semana",
    other: "arredor de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "arredor de 1 mes",
    other: "arredor de {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "arredor dun ano",
    other: "arredor de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "máis dun ano",
    other: "máis de {{count}} anos"
  },
  almostXYears: {
    one: "case un ano",
    other: "case {{count}} anos"
  }
}, Jse = (t, e, n) => {
  let i;
  const r = Use[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "en " + i : "hai " + i : i;
}, Qse = {
  full: "EEEE, d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Zse = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ele = {
  full: "{{date}} 'ás' {{time}}",
  long: "{{date}} 'ás' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, tle = {
  date: T({
    formats: Qse,
    defaultWidth: "full"
  }),
  time: T({
    formats: Zse,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: ele,
    defaultWidth: "full"
  })
}, nle = {
  lastWeek: "'o' eeee 'pasado á' LT",
  yesterday: "'onte á' p",
  today: "'hoxe á' p",
  tomorrow: "'mañá á' p",
  nextWeek: "eeee 'á' p",
  other: "P"
}, ile = {
  lastWeek: "'o' eeee 'pasado ás' p",
  yesterday: "'onte ás' p",
  today: "'hoxe ás' p",
  tomorrow: "'mañá ás' p",
  nextWeek: "eeee 'ás' p",
  other: "P"
}, rle = (t, e, n, i) => e.getHours() !== 1 ? ile[t] : nle[t], ale = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "despois de cristo"]
}, ole = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, sle = {
  narrow: ["e", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "xan",
    "feb",
    "mar",
    "abr",
    "mai",
    "xun",
    "xul",
    "ago",
    "set",
    "out",
    "nov",
    "dec"
  ],
  wide: [
    "xaneiro",
    "febreiro",
    "marzo",
    "abril",
    "maio",
    "xuño",
    "xullo",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "decembro"
  ]
}, lle = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["do", "lu", "ma", "me", "xo", "ve", "sa"],
  abbreviated: ["dom", "lun", "mar", "mer", "xov", "ven", "sab"],
  wide: ["domingo", "luns", "martes", "mércores", "xoves", "venres", "sábado"]
}, dle = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "mañá",
    afternoon: "tarde",
    evening: "tardiña",
    night: "noite"
  }
}, cle = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "medianoite",
    noon: "mediodía",
    morning: "da mañá",
    afternoon: "da tarde",
    evening: "da tardiña",
    night: "da noite"
  }
}, ule = (t, e) => Number(t) + "º", fle = {
  ordinalNumber: ule,
  era: C({
    values: ale,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: ole,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: sle,
    defaultWidth: "wide"
  }),
  day: C({
    values: lle,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: dle,
    defaultWidth: "wide",
    formattingValues: cle,
    defaultFormattingWidth: "wide"
  })
}, mle = /^(\d+)(º)?/i, hle = /\d+/i, ple = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era com[uú]n|despois de cristo|era com[uú]n)/i
}, gle = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era com[uú]n)/i,
    /^(despois de cristo|era com[uú]n)/i
  ]
}, yle = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, vle = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ble = {
  narrow: /^[xfmasond]/i,
  abbreviated: /^(xan|feb|mar|abr|mai|xun|xul|ago|set|out|nov|dec)/i,
  wide: /^(xaneiro|febreiro|marzo|abril|maio|xuño|xullo|agosto|setembro|outubro|novembro|decembro)/i
}, wle = {
  narrow: [
    /^x/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^x/i,
    /^x/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^xan/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^xun/i,
    /^xul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dec/i
  ]
}, kle = {
  narrow: /^[dlmxvs]/i,
  short: /^(do|lu|ma|me|xo|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|xov|ven|sab)/i,
  wide: /^(domingo|luns|martes|m[eé]rcores|xoves|venres|s[áa]bado)/i
}, xle = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^x/i, /^v/i, /^s/i],
  any: [/^do/i, /^lu/i, /^ma/i, /^me/i, /^xo/i, /^ve/i, /^sa/i]
}, _le = {
  narrow: /^(a|p|mn|md|(da|[aá]s) (mañ[aá]|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|medianoite|mediod[ií]a|(da|[aá]s) (mañ[aá]|tarde|noite))/i
}, Mle = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /^md/i,
    morning: /mañ[aá]/i,
    afternoon: /tarde/i,
    evening: /tardiña/i,
    night: /noite/i
  }
}, Cle = {
  ordinalNumber: he({
    matchPattern: mle,
    parsePattern: hle,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: ple,
    defaultMatchWidth: "wide",
    parsePatterns: gle,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: yle,
    defaultMatchWidth: "wide",
    parsePatterns: vle,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: ble,
    defaultMatchWidth: "wide",
    parsePatterns: wle,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: kle,
    defaultMatchWidth: "wide",
    parsePatterns: xle,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: _le,
    defaultMatchWidth: "any",
    parsePatterns: Mle,
    defaultParseWidth: "any"
  })
}, Ple = {
  code: "gl",
  formatDistance: Jse,
  formatLong: tle,
  formatRelative: rle,
  localize: fle,
  match: Cle,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Sle = {
  lessThanXSeconds: {
    one: "હમણાં",
    // CLDR #1461
    other: "​આશરે {{count}} સેકંડ"
  },
  xSeconds: {
    one: "1 સેકંડ",
    other: "{{count}} સેકંડ"
  },
  halfAMinute: "અડધી મિનિટ",
  lessThanXMinutes: {
    one: "આ મિનિટ",
    // CLDR #1448
    other: "​આશરે {{count}} મિનિટ"
  },
  xMinutes: {
    one: "1 મિનિટ",
    other: "{{count}} મિનિટ"
  },
  aboutXHours: {
    one: "​આશરે 1 કલાક",
    other: "​આશરે {{count}} કલાક"
  },
  xHours: {
    one: "1 કલાક",
    other: "{{count}} કલાક"
  },
  xDays: {
    one: "1 દિવસ",
    other: "{{count}} દિવસ"
  },
  aboutXWeeks: {
    one: "આશરે 1 અઠવાડિયું",
    other: "આશરે {{count}} અઠવાડિયા"
  },
  xWeeks: {
    one: "1 અઠવાડિયું",
    other: "{{count}} અઠવાડિયા"
  },
  aboutXMonths: {
    one: "આશરે 1 મહિનો",
    other: "આશરે {{count}} મહિના"
  },
  xMonths: {
    one: "1 મહિનો",
    other: "{{count}} મહિના"
  },
  aboutXYears: {
    one: "આશરે 1 વર્ષ",
    other: "આશરે {{count}} વર્ષ"
  },
  xYears: {
    one: "1 વર્ષ",
    other: "{{count}} વર્ષ"
  },
  overXYears: {
    one: "1 વર્ષથી વધુ",
    other: "{{count}} વર્ષથી વધુ"
  },
  almostXYears: {
    one: "લગભગ 1 વર્ષ",
    other: "લગભગ {{count}} વર્ષ"
  }
}, Nle = (t, e, n) => {
  let i;
  const r = Sle[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "માં" : i + " પહેલાં" : i;
}, $le = {
  full: "EEEE, d MMMM, y",
  // CLDR #1825
  long: "d MMMM, y",
  // CLDR #1826
  medium: "d MMM, y",
  // CLDR #1827
  short: "d/M/yy"
  // CLDR #1828
}, Dle = {
  full: "hh:mm:ss a zzzz",
  // CLDR #1829
  long: "hh:mm:ss a z",
  // CLDR #1830
  medium: "hh:mm:ss a",
  // CLDR #1831
  short: "hh:mm a"
  // CLDR #1832
}, Ele = {
  full: "{{date}} {{time}}",
  // CLDR #1833
  long: "{{date}} {{time}}",
  // CLDR #1834
  medium: "{{date}} {{time}}",
  // CLDR #1835
  short: "{{date}} {{time}}"
  // CLDR #1836
}, Tle = {
  date: T({
    formats: $le,
    defaultWidth: "full"
  }),
  time: T({
    formats: Dle,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Ele,
    defaultWidth: "full"
  })
}, Ole = {
  lastWeek: "'પાછલા' eeee p",
  // CLDR #1384
  yesterday: "'ગઈકાલે' p",
  // CLDR #1409
  today: "'આજે' p",
  // CLDR #1410
  tomorrow: "'આવતીકાલે' p",
  // CLDR #1411
  nextWeek: "eeee p",
  // CLDR #1386
  other: "P"
}, Wle = (t, e, n, i) => Ole[t], Ale = {
  narrow: ["ઈસપૂ", "ઈસ"],
  abbreviated: ["ઈ.સ.પૂર્વે", "ઈ.સ."],
  wide: ["ઈસવીસન પૂર્વે", "ઈસવીસન"]
}, Lle = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1લો ત્રિમાસ", "2જો ત્રિમાસ", "3જો ત્રિમાસ", "4થો ત્રિમાસ"]
}, Ile = {
  narrow: ["જા", "ફે", "મા", "એ", "મે", "જૂ", "જુ", "ઓ", "સ", "ઓ", "ન", "ડિ"],
  abbreviated: [
    "જાન્યુ",
    "ફેબ્રુ",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઈ",
    "ઑગસ્ટ",
    "સપ્ટે",
    "ઓક્ટો",
    "નવે",
    "ડિસે"
  ],
  wide: [
    "જાન્યુઆરી",
    "ફેબ્રુઆરી",
    "માર્ચ",
    "એપ્રિલ",
    "મે",
    "જૂન",
    "જુલાઇ",
    "ઓગસ્ટ",
    "સપ્ટેમ્બર",
    "ઓક્ટોબર",
    "નવેમ્બર",
    "ડિસેમ્બર"
  ]
}, Rle = {
  narrow: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  short: ["ર", "સો", "મં", "બુ", "ગુ", "શુ", "શ"],
  abbreviated: ["રવિ", "સોમ", "મંગળ", "બુધ", "ગુરુ", "શુક્ર", "શનિ"],
  wide: [
    "રવિવાર",
    "સોમવાર",
    "મંગળવાર",
    "બુધવાર",
    "ગુરુવાર",
    "શુક્રવાર",
    "શનિવાર"
  ]
}, jle = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બ.",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, Fle = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "મ.રાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "​મધ્યરાત્રિ",
    noon: "બપોરે",
    morning: "સવારે",
    afternoon: "બપોરે",
    evening: "સાંજે",
    night: "રાત્રે"
  }
}, zle = (t, e) => String(t), Vle = {
  ordinalNumber: zle,
  era: C({
    values: Ale,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Lle,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Ile,
    defaultWidth: "wide"
  }),
  day: C({
    values: Rle,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: jle,
    defaultWidth: "wide",
    formattingValues: Fle,
    defaultFormattingWidth: "wide"
  })
}, Hle = /^(\d+)(લ|જ|થ|ઠ્ઠ|મ)?/i, Ble = /\d+/i, qle = {
  narrow: /^(ઈસપૂ|ઈસ)/i,
  abbreviated: /^(ઈ\.સ\.પૂર્વે|ઈ\.સ\.)/i,
  wide: /^(ઈસવીસન\sપૂર્વે|ઈસવીસન)/i
}, Gle = {
  any: [/^ઈસપૂ/i, /^ઈસ/i]
}, Xle = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](લો|જો|થો)? ત્રિમાસ/i
}, Yle = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Kle = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[જાફેમાએમેજૂજુઓસઓનડિ]/i,
  abbreviated: /^(જાન્યુ|ફેબ્રુ|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઈ|ઑગસ્ટ|સપ્ટે|ઓક્ટો|નવે|ડિસે)/i,
  wide: /^(જાન્યુઆરી|ફેબ્રુઆરી|માર્ચ|એપ્રિલ|મે|જૂન|જુલાઇ|ઓગસ્ટ|સપ્ટેમ્બર|ઓક્ટોબર|નવેમ્બર|ડિસેમ્બર)/i
}, Ule = {
  narrow: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i
  ],
  any: [
    /^જા/i,
    /^ફે/i,
    /^મા/i,
    /^એ/i,
    /^મે/i,
    /^જૂ/i,
    /^જુ/i,
    /^ઑગ/i,
    /^સ/i,
    /^ઓક્ટો/i,
    /^ન/i,
    /^ડિ/i
  ]
}, Jle = {
  narrow: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  short: /^(ર|સો|મં|બુ|ગુ|શુ|શ)/i,
  abbreviated: /^(રવિ|સોમ|મંગળ|બુધ|ગુરુ|શુક્ર|શનિ)/i,
  wide: /^(રવિવાર|સોમવાર|મંગળવાર|બુધવાર|ગુરુવાર|શુક્રવાર|શનિવાર)/i
}, Qle = {
  narrow: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i],
  any: [/^ર/i, /^સો/i, /^મં/i, /^બુ/i, /^ગુ/i, /^શુ/i, /^શ/i]
}, Zle = {
  narrow: /^(a|p|મ\.?|સ|બ|સાં|રા)/i,
  any: /^(a|p|મ\.?|સ|બ|સાં|રા)/i
}, ede = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^મ\.?/i,
    noon: /^બ/i,
    morning: /સ/i,
    afternoon: /બ/i,
    evening: /સાં/i,
    night: /રા/i
  }
}, tde = {
  ordinalNumber: he({
    matchPattern: Hle,
    parsePattern: Ble,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: qle,
    defaultMatchWidth: "wide",
    parsePatterns: Gle,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Xle,
    defaultMatchWidth: "wide",
    parsePatterns: Yle,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Kle,
    defaultMatchWidth: "wide",
    parsePatterns: Ule,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Jle,
    defaultMatchWidth: "wide",
    parsePatterns: Qle,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Zle,
    defaultMatchWidth: "any",
    parsePatterns: ede,
    defaultParseWidth: "any"
  })
}, nde = {
  code: "gu",
  formatDistance: Nle,
  formatLong: Tle,
  formatRelative: Wle,
  localize: Vle,
  match: tde,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, ide = {
  lessThanXSeconds: {
    one: "פחות משנייה",
    two: "פחות משתי שניות",
    other: "פחות מ־{{count}} שניות"
  },
  xSeconds: {
    one: "שנייה",
    two: "שתי שניות",
    other: "{{count}} שניות"
  },
  halfAMinute: "חצי דקה",
  lessThanXMinutes: {
    one: "פחות מדקה",
    two: "פחות משתי דקות",
    other: "פחות מ־{{count}} דקות"
  },
  xMinutes: {
    one: "דקה",
    two: "שתי דקות",
    other: "{{count}} דקות"
  },
  aboutXHours: {
    one: "כשעה",
    two: "כשעתיים",
    other: "כ־{{count}} שעות"
  },
  xHours: {
    one: "שעה",
    two: "שעתיים",
    other: "{{count}} שעות"
  },
  xDays: {
    one: "יום",
    two: "יומיים",
    other: "{{count}} ימים"
  },
  aboutXWeeks: {
    one: "כשבוע",
    two: "כשבועיים",
    other: "כ־{{count}} שבועות"
  },
  xWeeks: {
    one: "שבוע",
    two: "שבועיים",
    other: "{{count}} שבועות"
  },
  aboutXMonths: {
    one: "כחודש",
    two: "כחודשיים",
    other: "כ־{{count}} חודשים"
  },
  xMonths: {
    one: "חודש",
    two: "חודשיים",
    other: "{{count}} חודשים"
  },
  aboutXYears: {
    one: "כשנה",
    two: "כשנתיים",
    other: "כ־{{count}} שנים"
  },
  xYears: {
    one: "שנה",
    two: "שנתיים",
    other: "{{count}} שנים"
  },
  overXYears: {
    one: "יותר משנה",
    two: "יותר משנתיים",
    other: "יותר מ־{{count}} שנים"
  },
  almostXYears: {
    one: "כמעט שנה",
    two: "כמעט שנתיים",
    other: "כמעט {{count}} שנים"
  }
}, rde = (t, e, n) => {
  if (t === "xDays" && (n != null && n.addSuffix) && e <= 2)
    return n.comparison && n.comparison > 0 ? e === 1 ? "מחר" : "מחרתיים" : e === 1 ? "אתמול" : "שלשום";
  let i;
  const r = ide[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 ? i = r.two : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "בעוד " + i : "לפני " + i : i;
}, ade = {
  full: "EEEE, d בMMMM y",
  long: "d בMMMM y",
  medium: "d בMMM y",
  short: "d.M.y"
}, ode = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, sde = {
  full: "{{date}} 'בשעה' {{time}}",
  long: "{{date}} 'בשעה' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, lde = {
  date: T({
    formats: ade,
    defaultWidth: "full"
  }),
  time: T({
    formats: ode,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: sde,
    defaultWidth: "full"
  })
}, dde = {
  lastWeek: "eeee 'שעבר בשעה' p",
  yesterday: "'אתמול בשעה' p",
  today: "'היום בשעה' p",
  tomorrow: "'מחר בשעה' p",
  nextWeek: "eeee 'בשעה' p",
  other: "P"
}, cde = (t, e, n, i) => dde[t], ude = {
  narrow: ["לפנה״ס", "לספירה"],
  abbreviated: ["לפנה״ס", "לספירה"],
  wide: ["לפני הספירה", "לספירה"]
}, fde = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["רבעון 1", "רבעון 2", "רבעון 3", "רבעון 4"]
}, mde = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "ינו׳",
    "פבר׳",
    "מרץ",
    "אפר׳",
    "מאי",
    "יוני",
    "יולי",
    "אוג׳",
    "ספט׳",
    "אוק׳",
    "נוב׳",
    "דצמ׳"
  ],
  wide: [
    "ינואר",
    "פברואר",
    "מרץ",
    "אפריל",
    "מאי",
    "יוני",
    "יולי",
    "אוגוסט",
    "ספטמבר",
    "אוקטובר",
    "נובמבר",
    "דצמבר"
  ]
}, hde = {
  narrow: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  short: ["א׳", "ב׳", "ג׳", "ד׳", "ה׳", "ו׳", "ש׳"],
  abbreviated: [
    "יום א׳",
    "יום ב׳",
    "יום ג׳",
    "יום ד׳",
    "יום ה׳",
    "יום ו׳",
    "שבת"
  ],
  wide: [
    "יום ראשון",
    "יום שני",
    "יום שלישי",
    "יום רביעי",
    "יום חמישי",
    "יום שישי",
    "יום שבת"
  ]
}, pde = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בוקר",
    afternoon: "אחר הצהריים",
    evening: "ערב",
    night: "לילה"
  }
}, gde = {
  narrow: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "בצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  abbreviated: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  },
  wide: {
    am: "לפנה״צ",
    pm: "אחה״צ",
    midnight: "חצות",
    noon: "צהריים",
    morning: "בבוקר",
    afternoon: "אחר הצהריים",
    evening: "בערב",
    night: "בלילה"
  }
}, yde = (t, e) => {
  const n = Number(t);
  if (n <= 0 || n > 10) return String(n);
  const i = String(e == null ? void 0 : e.unit), r = ["year", "hour", "minute", "second"].indexOf(i) >= 0, a = [
    "ראשון",
    "שני",
    "שלישי",
    "רביעי",
    "חמישי",
    "שישי",
    "שביעי",
    "שמיני",
    "תשיעי",
    "עשירי"
  ], o = [
    "ראשונה",
    "שנייה",
    "שלישית",
    "רביעית",
    "חמישית",
    "שישית",
    "שביעית",
    "שמינית",
    "תשיעית",
    "עשירית"
  ], s = n - 1;
  return r ? o[s] : a[s];
}, vde = {
  ordinalNumber: yde,
  era: C({
    values: ude,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: fde,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: mde,
    defaultWidth: "wide"
  }),
  day: C({
    values: hde,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: pde,
    defaultWidth: "wide",
    formattingValues: gde,
    defaultFormattingWidth: "wide"
  })
}, bde = /^(\d+|(ראשון|שני|שלישי|רביעי|חמישי|שישי|שביעי|שמיני|תשיעי|עשירי|ראשונה|שנייה|שלישית|רביעית|חמישית|שישית|שביעית|שמינית|תשיעית|עשירית))/i, wde = /^(\d+|רא|שנ|של|רב|ח|שי|שב|שמ|ת|ע)/i, kde = {
  narrow: /^ל(ספירה|פנה״ס)/i,
  abbreviated: /^ל(ספירה|פנה״ס)/i,
  wide: /^ל(פני ה)?ספירה/i
}, xde = {
  any: [/^לפ/i, /^לס/i]
}, _de = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^רבעון [1234]/i
}, Mde = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Cde = {
  narrow: /^\d+/i,
  abbreviated: /^(ינו|פבר|מרץ|אפר|מאי|יוני|יולי|אוג|ספט|אוק|נוב|דצמ)׳?/i,
  wide: /^(ינואר|פברואר|מרץ|אפריל|מאי|יוני|יולי|אוגוסט|ספטמבר|אוקטובר|נובמבר|דצמבר)/i
}, Pde = {
  narrow: [
    /^1$/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ינ/i,
    /^פ/i,
    /^מר/i,
    /^אפ/i,
    /^מא/i,
    /^יונ/i,
    /^יול/i,
    /^אוג/i,
    /^ס/i,
    /^אוק/i,
    /^נ/i,
    /^ד/i
  ]
}, Sde = {
  narrow: /^[אבגדהוש]׳/i,
  short: /^[אבגדהוש]׳/i,
  abbreviated: /^(שבת|יום (א|ב|ג|ד|ה|ו)׳)/i,
  wide: /^יום (ראשון|שני|שלישי|רביעי|חמישי|שישי|שבת)/i
}, Nde = {
  abbreviated: [/א׳$/i, /ב׳$/i, /ג׳$/i, /ד׳$/i, /ה׳$/i, /ו׳$/i, /^ש/i],
  wide: [/ן$/i, /ני$/i, /לישי$/i, /עי$/i, /מישי$/i, /שישי$/i, /ת$/i],
  any: [/^א/i, /^ב/i, /^ג/i, /^ד/i, /^ה/i, /^ו/i, /^ש/i]
}, $de = {
  any: /^(אחר ה|ב)?(חצות|צהריים|בוקר|ערב|לילה|אחה״צ|לפנה״צ)/i
}, Dde = {
  any: {
    am: /^לפ/i,
    pm: /^אחה/i,
    midnight: /^ח/i,
    noon: /^צ/i,
    morning: /בוקר/i,
    afternoon: /בצ|אחר/i,
    evening: /ערב/i,
    night: /לילה/i
  }
}, Ede = ["רא", "שנ", "של", "רב", "ח", "שי", "שב", "שמ", "ת", "ע"], Tde = {
  ordinalNumber: he({
    matchPattern: bde,
    parsePattern: wde,
    valueCallback: (t) => {
      const e = parseInt(t, 10);
      return isNaN(e) ? Ede.indexOf(t) + 1 : e;
    }
  }),
  era: P({
    matchPatterns: kde,
    defaultMatchWidth: "wide",
    parsePatterns: xde,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: _de,
    defaultMatchWidth: "wide",
    parsePatterns: Mde,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Cde,
    defaultMatchWidth: "wide",
    parsePatterns: Pde,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Sde,
    defaultMatchWidth: "wide",
    parsePatterns: Nde,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: $de,
    defaultMatchWidth: "any",
    parsePatterns: Dde,
    defaultParseWidth: "any"
  })
}, Ode = {
  code: "he",
  formatDistance: rde,
  formatLong: lde,
  formatRelative: cde,
  localize: vde,
  match: Tde,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, vP = {
  locale: {
    1: "१",
    2: "२",
    3: "३",
    4: "४",
    5: "५",
    6: "६",
    7: "७",
    8: "८",
    9: "९",
    0: "०"
  },
  number: {
    "१": "1",
    "२": "2",
    "३": "3",
    "४": "4",
    "५": "5",
    "६": "6",
    "७": "7",
    "८": "8",
    "९": "9",
    "०": "0"
  }
}, Wde = {
  narrow: ["ईसा-पूर्व", "ईस्वी"],
  abbreviated: ["ईसा-पूर्व", "ईस्वी"],
  wide: ["ईसा-पूर्व", "ईसवी सन"]
}, Ade = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ति1", "ति2", "ति3", "ति4"],
  wide: ["पहली तिमाही", "दूसरी तिमाही", "तीसरी तिमाही", "चौथी तिमाही"]
}, Lde = {
  narrow: [
    "ज",
    "फ़",
    "मा",
    "अ",
    "मई",
    "जू",
    "जु",
    "अग",
    "सि",
    "अक्टू",
    "न",
    "दि"
  ],
  abbreviated: [
    "जन",
    "फ़र",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुल",
    "अग",
    "सित",
    "अक्टू",
    "नव",
    "दिस"
  ],
  wide: [
    "जनवरी",
    "फ़रवरी",
    "मार्च",
    "अप्रैल",
    "मई",
    "जून",
    "जुलाई",
    "अगस्त",
    "सितंबर",
    "अक्टूबर",
    "नवंबर",
    "दिसंबर"
  ]
}, Ide = {
  narrow: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  short: ["र", "सो", "मं", "बु", "गु", "शु", "श"],
  abbreviated: ["रवि", "सोम", "मंगल", "बुध", "गुरु", "शुक्र", "शनि"],
  wide: [
    "रविवार",
    "सोमवार",
    "मंगलवार",
    "बुधवार",
    "गुरुवार",
    "शुक्रवार",
    "शनिवार"
  ]
}, Rde = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, jde = {
  narrow: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  abbreviated: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  },
  wide: {
    am: "पूर्वाह्न",
    pm: "अपराह्न",
    midnight: "मध्यरात्रि",
    noon: "दोपहर",
    morning: "सुबह",
    afternoon: "दोपहर",
    evening: "शाम",
    night: "रात"
  }
}, Fde = (t, e) => {
  const n = Number(t);
  return bP(n);
};
function zde(t) {
  const e = t.toString().replace(/[१२३४५६७८९०]/g, function(n) {
    return vP.number[n];
  });
  return Number(e);
}
function bP(t) {
  return t.toString().replace(/\d/g, function(e) {
    return vP.locale[e];
  });
}
const Vde = {
  ordinalNumber: Fde,
  era: C({
    values: Wde,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Ade,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Lde,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ide,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Rde,
    defaultWidth: "wide",
    formattingValues: jde,
    defaultFormattingWidth: "wide"
  })
}, Hde = {
  lessThanXSeconds: {
    one: "१ सेकंड से कम",
    // CLDR #1310
    other: "{{count}} सेकंड से कम"
  },
  xSeconds: {
    one: "१ सेकंड",
    other: "{{count}} सेकंड"
  },
  halfAMinute: "आधा मिनट",
  lessThanXMinutes: {
    one: "१ मिनट से कम",
    other: "{{count}} मिनट से कम"
  },
  xMinutes: {
    one: "१ मिनट",
    // CLDR #1307
    other: "{{count}} मिनट"
  },
  aboutXHours: {
    one: "लगभग १ घंटा",
    other: "लगभग {{count}} घंटे"
  },
  xHours: {
    one: "१ घंटा",
    // CLDR #1304
    other: "{{count}} घंटे"
    // CLDR #4467
  },
  xDays: {
    one: "१ दिन",
    // CLDR #1286
    other: "{{count}} दिन"
  },
  aboutXWeeks: {
    one: "लगभग १ सप्ताह",
    other: "लगभग {{count}} सप्ताह"
  },
  xWeeks: {
    one: "१ सप्ताह",
    other: "{{count}} सप्ताह"
  },
  aboutXMonths: {
    one: "लगभग १ महीना",
    other: "लगभग {{count}} महीने"
  },
  xMonths: {
    one: "१ महीना",
    other: "{{count}} महीने"
  },
  aboutXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
    // CLDR #4823
  },
  xYears: {
    one: "१ वर्ष",
    other: "{{count}} वर्ष"
  },
  overXYears: {
    one: "१ वर्ष से अधिक",
    other: "{{count}} वर्ष से अधिक"
  },
  almostXYears: {
    one: "लगभग १ वर्ष",
    other: "लगभग {{count}} वर्ष"
  }
}, Bde = (t, e, n) => {
  let i;
  const r = Hde[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", bP(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "मे " : i + " पहले" : i;
}, qde = {
  full: "EEEE, do MMMM, y",
  // CLDR #1787
  long: "do MMMM, y",
  // CLDR #1788
  medium: "d MMM, y",
  // CLDR #1789
  short: "dd/MM/yyyy"
  // CLDR #1790
}, Gde = {
  full: "h:mm:ss a zzzz",
  // CLDR #1791
  long: "h:mm:ss a z",
  // CLDR #1792
  medium: "h:mm:ss a",
  // CLDR #1793
  short: "h:mm a"
  // CLDR #1794
}, Xde = {
  full: "{{date}} 'को' {{time}}",
  // CLDR #1795
  long: "{{date}} 'को' {{time}}",
  // CLDR #1796
  medium: "{{date}}, {{time}}",
  // CLDR #1797
  short: "{{date}}, {{time}}"
  // CLDR #1798
}, Yde = {
  date: T({
    formats: qde,
    defaultWidth: "full"
  }),
  time: T({
    formats: Gde,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Xde,
    defaultWidth: "full"
  })
}, Kde = {
  lastWeek: "'पिछले' eeee p",
  yesterday: "'कल' p",
  today: "'आज' p",
  tomorrow: "'कल' p",
  nextWeek: "eeee 'को' p",
  other: "P"
}, Ude = (t, e, n, i) => Kde[t], Jde = /^[०१२३४५६७८९]+/i, Qde = /^[०१२३४५६७८९]+/i, Zde = {
  narrow: /^(ईसा-पूर्व|ईस्वी)/i,
  abbreviated: /^(ईसा\.?\s?पूर्व\.?|ईसा\.?)/i,
  wide: /^(ईसा-पूर्व|ईसवी पूर्व|ईसवी सन|ईसवी)/i
}, ece = {
  any: [/^b/i, /^(a|c)/i]
}, tce = {
  narrow: /^[1234]/i,
  abbreviated: /^ति[1234]/i,
  wide: /^[1234](पहली|दूसरी|तीसरी|चौथी)? तिमाही/i
}, nce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ice = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[जफ़माअप्मईजूनजुअगसिअक्तनदि]/i,
  abbreviated: /^(जन|फ़र|मार्च|अप्|मई|जून|जुल|अग|सित|अक्तू|नव|दिस)/i,
  wide: /^(जनवरी|फ़रवरी|मार्च|अप्रैल|मई|जून|जुलाई|अगस्त|सितंबर|अक्तूबर|नवंबर|दिसंबर)/i
}, rce = {
  narrow: [
    /^ज/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^न/i,
    /^दि/i
  ],
  any: [
    /^जन/i,
    /^फ़/i,
    /^मा/i,
    /^अप्/i,
    /^मई/i,
    /^जू/i,
    /^जु/i,
    /^अग/i,
    /^सि/i,
    /^अक्तू/i,
    /^नव/i,
    /^दिस/i
  ]
}, ace = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[रविसोममंगलबुधगुरुशुक्रशनि]/i,
  short: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  abbreviated: /^(रवि|सोम|मंगल|बुध|गुरु|शुक्र|शनि)/i,
  wide: /^(रविवार|सोमवार|मंगलवार|बुधवार|गुरुवार|शुक्रवार|शनिवार)/i
}, oce = {
  narrow: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i],
  any: [/^रवि/i, /^सोम/i, /^मंगल/i, /^बुध/i, /^गुरु/i, /^शुक्र/i, /^शनि/i]
}, sce = {
  narrow: /^(पू|अ|म|द.\?|सु|दो|शा|रा)/i,
  any: /^(पूर्वाह्न|अपराह्न|म|द.\?|सु|दो|शा|रा)/i
}, lce = {
  any: {
    am: /^पूर्वाह्न/i,
    pm: /^अपराह्न/i,
    midnight: /^मध्य/i,
    noon: /^दो/i,
    morning: /सु/i,
    afternoon: /दो/i,
    evening: /शा/i,
    night: /रा/i
  }
}, dce = {
  ordinalNumber: he({
    matchPattern: Jde,
    parsePattern: Qde,
    valueCallback: zde
  }),
  era: P({
    matchPatterns: Zde,
    defaultMatchWidth: "wide",
    parsePatterns: ece,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: tce,
    defaultMatchWidth: "wide",
    parsePatterns: nce,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: ice,
    defaultMatchWidth: "wide",
    parsePatterns: rce,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: ace,
    defaultMatchWidth: "wide",
    parsePatterns: oce,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: sce,
    defaultMatchWidth: "any",
    parsePatterns: lce,
    defaultParseWidth: "any"
  })
}, cce = {
  code: "hi",
  formatDistance: Bde,
  formatLong: Yde,
  formatRelative: Ude,
  localize: Vde,
  match: dce,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 4
  }
}, uce = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 tjedan",
      withPrepositionAgo: "oko 1 tjedan",
      withPrepositionIn: "oko 1 tjedan"
    },
    dual: "oko {{count}} tjedna",
    other: "oko {{count}} tjedana"
  },
  xWeeks: {
    one: {
      standalone: "1 tjedan",
      withPrepositionAgo: "1 tjedan",
      withPrepositionIn: "1 tjedan"
    },
    dual: "{{count}} tjedna",
    other: "{{count}} tjedana"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mjesec",
      withPrepositionAgo: "oko 1 mjesec",
      withPrepositionIn: "oko 1 mjesec"
    },
    dual: "oko {{count}} mjeseca",
    other: "oko {{count}} mjeseci"
  },
  xMonths: {
    one: {
      standalone: "1 mjesec",
      withPrepositionAgo: "1 mjesec",
      withPrepositionIn: "1 mjesec"
    },
    dual: "{{count}} mjeseca",
    other: "{{count}} mjeseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, fce = (t, e, n) => {
  let i;
  const r = uce[t];
  return typeof r == "string" ? i = r : e === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i = r.one.withPrepositionIn : i = r.one.withPrepositionAgo : i = r.one.standalone : e % 10 > 1 && e % 10 < 5 && // if last digit is between 2 and 4
  String(e).substr(-2, 1) !== "1" ? i = r.dual.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + i : "prije " + i : i;
}, mce = {
  full: "EEEE, d. MMMM y.",
  long: "d. MMMM y.",
  medium: "d. MMM y.",
  short: "dd. MM. y."
}, hce = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, pce = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, gce = {
  date: T({
    formats: mce,
    defaultWidth: "full"
  }),
  time: T({
    formats: hce,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: pce,
    defaultWidth: "full"
  })
}, yce = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'prošlu nedjelju u' p";
      case 3:
        return "'prošlu srijedu u' p";
      case 6:
        return "'prošlu subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'jučer u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'iduću nedjelju u' p";
      case 3:
        return "'iduću srijedu u' p";
      case 6:
        return "'iduću subotu u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  other: "P"
}, vce = (t, e, n, i) => {
  const r = yce[t];
  return typeof r == "function" ? r(e) : r;
}, bce = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Kr.", "po. Kr."],
  wide: ["Prije Krista", "Poslije Krista"]
}, wce = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, kce = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro"
  ],
  wide: [
    "siječanj",
    "veljača",
    "ožujak",
    "travanj",
    "svibanj",
    "lipanj",
    "srpanj",
    "kolovoz",
    "rujan",
    "listopad",
    "studeni",
    "prosinac"
  ]
}, xce = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "sij",
    "velj",
    "ožu",
    "tra",
    "svi",
    "lip",
    "srp",
    "kol",
    "ruj",
    "lis",
    "stu",
    "pro"
  ],
  wide: [
    "siječnja",
    "veljače",
    "ožujka",
    "travnja",
    "svibnja",
    "lipnja",
    "srpnja",
    "kolovoza",
    "rujna",
    "listopada",
    "studenog",
    "prosinca"
  ]
}, _ce = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sri", "čet", "pet", "sub"],
  wide: [
    "nedjelja",
    "ponedjeljak",
    "utorak",
    "srijeda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, Mce = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, Cce = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "popodne",
    evening: "navečer",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutro",
    afternoon: "poslije podne",
    evening: "navečer",
    night: "noću"
  }
}, Pce = (t, e) => Number(t) + ".", Sce = {
  ordinalNumber: Pce,
  era: C({
    values: bce,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: wce,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: kce,
    defaultWidth: "wide",
    formattingValues: xce,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: _ce,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Cce,
    defaultWidth: "wide",
    formattingValues: Mce,
    defaultFormattingWidth: "wide"
  })
}, Nce = /^(\d+)\./i, $ce = /\d+/i, Dce = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Kr\.|po\.\s?Kr\.)/i,
  wide: /^(Prije Krista|prije nove ere|Poslije Krista|nova era)/i
}, Ece = {
  any: [/^pr/i, /^(po|nova)/i]
}, Tce = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, Oce = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Wce = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(sij|velj|(ožu|ozu)|tra|svi|lip|srp|kol|ruj|lis|stu|pro)/i,
  wide: /^((siječanj|siječnja|sijecanj|sijecnja)|(veljača|veljače|veljaca|veljace)|(ožujak|ožujka|ozujak|ozujka)|(travanj|travnja)|(svibanj|svibnja)|(lipanj|lipnja)|(srpanj|srpnja)|(kolovoz|kolovoza)|(rujan|rujna)|(listopad|listopada)|(studeni|studenog)|(prosinac|prosinca))/i
}, Ace = {
  narrow: [
    /1/i,
    /2/i,
    /3/i,
    /4/i,
    /5/i,
    /6/i,
    /7/i,
    /8/i,
    /9/i,
    /10/i,
    /11/i,
    /12/i
  ],
  abbreviated: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i
  ],
  wide: [
    /^sij/i,
    /^velj/i,
    /^(ožu|ozu)/i,
    /^tra/i,
    /^svi/i,
    /^lip/i,
    /^srp/i,
    /^kol/i,
    /^ruj/i,
    /^lis/i,
    /^stu/i,
    /^pro/i
  ]
}, Lce = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sri|(čet|cet)|pet|sub)/i,
  wide: /^(nedjelja|ponedjeljak|utorak|srijeda|(četvrtak|cetvrtak)|petak|subota)/i
}, Ice = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, Rce = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|navecer|navečer|noću|poslije podne|ujutro)/i
}, jce = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(poslije\s|po)+podne/i,
    evening: /(navece|naveče)/i,
    night: /(nocu|noću)/i
  }
}, Fce = {
  ordinalNumber: he({
    matchPattern: Nce,
    parsePattern: $ce,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Dce,
    defaultMatchWidth: "wide",
    parsePatterns: Ece,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Tce,
    defaultMatchWidth: "wide",
    parsePatterns: Oce,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Wce,
    defaultMatchWidth: "wide",
    parsePatterns: Ace,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: Lce,
    defaultMatchWidth: "wide",
    parsePatterns: Ice,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Rce,
    defaultMatchWidth: "any",
    parsePatterns: jce,
    defaultParseWidth: "any"
  })
}, zce = {
  code: "hr",
  formatDistance: fce,
  formatLong: gce,
  formatRelative: vce,
  localize: Sce,
  match: Fce,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Vce = {
  lessThanXSeconds: {
    one: "mwens pase yon segond",
    other: "mwens pase {{count}} segond"
  },
  xSeconds: {
    one: "1 segond",
    other: "{{count}} segond"
  },
  halfAMinute: "30 segond",
  lessThanXMinutes: {
    one: "mwens pase yon minit",
    other: "mwens pase {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "anviwon inè",
    other: "anviwon {{count}} è"
  },
  xHours: {
    one: "1 lè",
    other: "{{count}} lè"
  },
  xDays: {
    one: "1 jou",
    other: "{{count}} jou"
  },
  aboutXWeeks: {
    one: "anviwon 1 semèn",
    other: "anviwon {{count}} semèn"
  },
  xWeeks: {
    one: "1 semèn",
    other: "{{count}} semèn"
  },
  aboutXMonths: {
    one: "anviwon 1 mwa",
    other: "anviwon {{count}} mwa"
  },
  xMonths: {
    one: "1 mwa",
    other: "{{count}} mwa"
  },
  aboutXYears: {
    one: "anviwon 1 an",
    other: "anviwon {{count}} an"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} an"
  },
  overXYears: {
    one: "plis pase 1 an",
    other: "plis pase {{count}} an"
  },
  almostXYears: {
    one: "prèske 1 an",
    other: "prèske {{count}} an"
  }
}, Hce = (t, e, n) => {
  let i;
  const r = Vce[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "nan " + i : "sa fè " + i : i;
}, Bce = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, qce = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Gce = {
  full: "{{date}} 'nan lè' {{time}}",
  long: "{{date}} 'nan lè' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Xce = {
  date: T({
    formats: Bce,
    defaultWidth: "full"
  }),
  time: T({
    formats: qce,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Gce,
    defaultWidth: "full"
  })
}, Yce = {
  lastWeek: "eeee 'pase nan lè' p",
  yesterday: "'yè nan lè' p",
  today: "'jodi a' p",
  tomorrow: "'demen nan lè' p'",
  nextWeek: "eeee 'pwochen nan lè' p",
  other: "P"
}, Kce = (t, e, n, i) => Yce[t], Uce = {
  narrow: ["av. J.-K", "ap. J.-K"],
  abbreviated: ["av. J.-K", "ap. J.-K"],
  wide: ["anvan Jezi Kris", "apre Jezi Kris"]
}, Jce = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1ye trim.", "2yèm trim.", "3yèm trim.", "4yèm trim."],
  wide: ["1ye trimès", "2yèm trimès", "3yèm trimès", "4yèm trimès"]
}, Qce = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "fevr.",
    "mas",
    "avr.",
    "me",
    "jen",
    "jiyè",
    "out",
    "sept.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "janvye",
    "fevrye",
    "mas",
    "avril",
    "me",
    "jen",
    "jiyè",
    "out",
    "septanm",
    "oktòb",
    "novanm",
    "desanm"
  ]
}, Zce = {
  narrow: ["D", "L", "M", "M", "J", "V", "S"],
  short: ["di", "le", "ma", "mè", "je", "va", "sa"],
  abbreviated: ["dim.", "len.", "mad.", "mèk.", "jed.", "van.", "sam."],
  wide: ["dimanch", "lendi", "madi", "mèkredi", "jedi", "vandredi", "samdi"]
}, eue = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "mat.",
    afternoon: "ap.m.",
    evening: "swa",
    night: "mat."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "maten",
    afternoon: "aprèmidi",
    evening: "swa",
    night: "maten"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "minwit",
    noon: "midi",
    morning: "nan maten",
    afternoon: "nan aprèmidi",
    evening: "nan aswè",
    night: "nan maten"
  }
}, tue = (t, e) => {
  const n = Number(t);
  return n === 0 ? String(n) : n + (n === 1 ? "ye" : "yèm");
}, nue = {
  ordinalNumber: tue,
  era: C({
    values: Uce,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Jce,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Qce,
    defaultWidth: "wide"
  }),
  day: C({
    values: Zce,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: eue,
    defaultWidth: "wide"
  })
}, iue = /^(\d+)(ye|yèm)?/i, rue = /\d+/i, aue = {
  narrow: /^(av\.J\.K|ap\.J\.K|ap\.J\.-K)/i,
  abbreviated: /^(av\.J\.-K|av\.J-K|apr\.J\.-K|apr\.J-K|ap\.J-K)/i,
  wide: /^(avan Jezi Kris|apre Jezi Kris)/i
}, oue = {
  any: [/^av/i, /^ap/i]
}, sue = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](ye|yèm)? trimès/i
}, lue = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, due = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv|fevr|mas|avr|me|jen|jiyè|out|sept|okt|nov|des)\.?/i,
  wide: /^(janvye|fevrye|mas|avril|me|jen|jiyè|out|septanm|oktòb|novanm|desanm)/i
}, cue = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^av/i,
    /^me/i,
    /^je/i,
    /^ji/i,
    /^ou/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i
  ]
}, uue = {
  narrow: /^[lmjvsd]/i,
  short: /^(di|le|ma|me|je|va|sa)/i,
  abbreviated: /^(dim|len|mad|mèk|jed|van|sam)\.?/i,
  wide: /^(dimanch|lendi|madi|mèkredi|jedi|vandredi|samdi)/i
}, fue = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^di/i, /^le/i, /^ma/i, /^mè/i, /^je/i, /^va/i, /^sa/i]
}, mue = {
  narrow: /^(a|p|minwit|midi|mat\.?|ap\.?m\.?|swa)/i,
  any: /^([ap]\.?\s?m\.?|nan maten|nan aprèmidi|nan aswè)/i
}, hue = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^min/i,
    noon: /^mid/i,
    morning: /mat/i,
    afternoon: /ap/i,
    evening: /sw/i,
    night: /nwit/i
  }
}, pue = {
  ordinalNumber: he({
    matchPattern: iue,
    parsePattern: rue,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: aue,
    defaultMatchWidth: "wide",
    parsePatterns: oue,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: sue,
    defaultMatchWidth: "wide",
    parsePatterns: lue,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: due,
    defaultMatchWidth: "wide",
    parsePatterns: cue,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: uue,
    defaultMatchWidth: "wide",
    parsePatterns: fue,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: mue,
    defaultMatchWidth: "any",
    parsePatterns: hue,
    defaultParseWidth: "any"
  })
}, gue = {
  code: "ht",
  formatDistance: Hce,
  formatLong: Xce,
  formatRelative: Kce,
  localize: nue,
  match: pue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, yue = {
  about: "körülbelül",
  over: "több mint",
  almost: "majdnem",
  lessthan: "kevesebb mint"
}, vue = {
  xseconds: " másodperc",
  halfaminute: "fél perc",
  xminutes: " perc",
  xhours: " óra",
  xdays: " nap",
  xweeks: " hét",
  xmonths: " hónap",
  xyears: " év"
}, bue = {
  xseconds: {
    "-1": " másodperccel ezelőtt",
    1: " másodperc múlva",
    0: " másodperce"
  },
  halfaminute: {
    "-1": "fél perccel ezelőtt",
    1: "fél perc múlva",
    0: "fél perce"
  },
  xminutes: {
    "-1": " perccel ezelőtt",
    1: " perc múlva",
    0: " perce"
  },
  xhours: {
    "-1": " órával ezelőtt",
    1: " óra múlva",
    0: " órája"
  },
  xdays: {
    "-1": " nappal ezelőtt",
    1: " nap múlva",
    0: " napja"
  },
  xweeks: {
    "-1": " héttel ezelőtt",
    1: " hét múlva",
    0: " hete"
  },
  xmonths: {
    "-1": " hónappal ezelőtt",
    1: " hónap múlva",
    0: " hónapja"
  },
  xyears: {
    "-1": " évvel ezelőtt",
    1: " év múlva",
    0: " éve"
  }
}, wue = (t, e, n) => {
  const i = t.match(/about|over|almost|lessthan/i), r = i ? t.replace(i[0], "") : t, a = (n == null ? void 0 : n.addSuffix) === !0, o = r.toLowerCase(), s = (n == null ? void 0 : n.comparison) || 0, l = a ? bue[o][s] : vue[o];
  let c = o === "halfaminute" ? l : e + l;
  if (i) {
    const u = i[0].toLowerCase();
    c = yue[u] + " " + c;
  }
  return c;
}, kue = {
  full: "y. MMMM d., EEEE",
  long: "y. MMMM d.",
  medium: "y. MMM d.",
  short: "y. MM. dd."
}, xue = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, _ue = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Mue = {
  date: T({
    formats: kue,
    defaultWidth: "full"
  }),
  time: T({
    formats: xue,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: _ue,
    defaultWidth: "full"
  })
}, Cue = [
  "vasárnap",
  "hétfőn",
  "kedden",
  "szerdán",
  "csütörtökön",
  "pénteken",
  "szombaton"
];
function v2(t) {
  return (e) => {
    const n = Cue[e.getDay()];
    return `${t ? "" : "'múlt' "}'${n}' p'-kor'`;
  };
}
const Pue = {
  lastWeek: v2(!1),
  yesterday: "'tegnap' p'-kor'",
  today: "'ma' p'-kor'",
  tomorrow: "'holnap' p'-kor'",
  nextWeek: v2(!0),
  other: "P"
}, Sue = (t, e) => {
  const n = Pue[t];
  return typeof n == "function" ? n(e) : n;
}, Nue = {
  narrow: ["ie.", "isz."],
  abbreviated: ["i. e.", "i. sz."],
  wide: ["Krisztus előtt", "időszámításunk szerint"]
}, $ue = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. n.év", "2. n.év", "3. n.év", "4. n.év"],
  wide: ["1. negyedév", "2. negyedév", "3. negyedév", "4. negyedév"]
}, Due = {
  narrow: ["I.", "II.", "III.", "IV."],
  abbreviated: ["I. n.év", "II. n.év", "III. n.év", "IV. n.év"],
  wide: ["I. negyedév", "II. negyedév", "III. negyedév", "IV. negyedév"]
}, Eue = {
  narrow: ["J", "F", "M", "Á", "M", "J", "J", "A", "Sz", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "febr.",
    "márc.",
    "ápr.",
    "máj.",
    "jún.",
    "júl.",
    "aug.",
    "szept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "január",
    "február",
    "március",
    "április",
    "május",
    "június",
    "július",
    "augusztus",
    "szeptember",
    "október",
    "november",
    "december"
  ]
}, Tue = {
  narrow: ["V", "H", "K", "Sz", "Cs", "P", "Sz"],
  short: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  abbreviated: ["V", "H", "K", "Sze", "Cs", "P", "Szo"],
  wide: [
    "vasárnap",
    "hétfő",
    "kedd",
    "szerda",
    "csütörtök",
    "péntek",
    "szombat"
  ]
}, Oue = {
  narrow: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  abbreviated: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "du.",
    evening: "este",
    night: "éjjel"
  },
  wide: {
    am: "de.",
    pm: "du.",
    midnight: "éjfél",
    noon: "dél",
    morning: "reggel",
    afternoon: "délután",
    evening: "este",
    night: "éjjel"
  }
}, Wue = (t, e) => Number(t) + ".", Aue = {
  ordinalNumber: Wue,
  era: C({
    values: Nue,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: $ue,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1,
    formattingValues: Due,
    defaultFormattingWidth: "wide"
  }),
  month: C({
    values: Eue,
    defaultWidth: "wide"
  }),
  day: C({
    values: Tue,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Oue,
    defaultWidth: "wide"
  })
}, Lue = /^(\d+)\.?/i, Iue = /\d+/i, Rue = {
  narrow: /^(ie\.|isz\.)/i,
  abbreviated: /^(i\.\s?e\.?|b?\s?c\s?e|i\.\s?sz\.?)/i,
  wide: /^(Krisztus előtt|időszámításunk előtt|időszámításunk szerint|i\. sz\.)/i
}, jue = {
  narrow: [/ie/i, /isz/i],
  abbreviated: [/^(i\.?\s?e\.?|b\s?ce)/i, /^(i\.?\s?sz\.?|c\s?e)/i],
  any: [/előtt/i, /(szerint|i. sz.)/i]
}, Fue = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^[1234]?\.?\s?n\.év/i,
  wide: /^([1234]|I|II|III|IV)?\.?\s?negyedév/i
}, zue = {
  any: [/1|I$/i, /2|II$/i, /3|III/i, /4|IV/i]
}, Vue = {
  narrow: /^[jfmaásond]|sz/i,
  abbreviated: /^(jan\.?|febr\.?|márc\.?|ápr\.?|máj\.?|jún\.?|júl\.?|aug\.?|szept\.?|okt\.?|nov\.?|dec\.?)/i,
  wide: /^(január|február|március|április|május|június|július|augusztus|szeptember|október|november|december)/i
}, Hue = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a|á/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s|sz/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^már/i,
    /^áp/i,
    /^máj/i,
    /^jún/i,
    /^júl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Bue = {
  narrow: /^([vhkpc]|sz|cs|sz)/i,
  short: /^([vhkp]|sze|cs|szo)/i,
  abbreviated: /^([vhkp]|sze|cs|szo)/i,
  wide: /^(vasárnap|hétfő|kedd|szerda|csütörtök|péntek|szombat)/i
}, que = {
  narrow: [/^v/i, /^h/i, /^k/i, /^sz/i, /^c/i, /^p/i, /^sz/i],
  any: [/^v/i, /^h/i, /^k/i, /^sze/i, /^c/i, /^p/i, /^szo/i]
}, Gue = {
  any: /^((de|du)\.?|éjfél|délután|dél|reggel|este|éjjel)/i
}, Xue = {
  any: {
    am: /^de\.?/i,
    pm: /^du\.?/i,
    midnight: /^éjf/i,
    noon: /^dé/i,
    morning: /reg/i,
    afternoon: /^délu\.?/i,
    evening: /es/i,
    night: /éjj/i
  }
}, Yue = {
  ordinalNumber: he({
    matchPattern: Lue,
    parsePattern: Iue,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Rue,
    defaultMatchWidth: "wide",
    parsePatterns: jue,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Fue,
    defaultMatchWidth: "wide",
    parsePatterns: zue,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Vue,
    defaultMatchWidth: "wide",
    parsePatterns: Hue,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Bue,
    defaultMatchWidth: "wide",
    parsePatterns: que,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Gue,
    defaultMatchWidth: "any",
    parsePatterns: Xue,
    defaultParseWidth: "any"
  })
}, Kue = {
  code: "hu",
  formatDistance: wue,
  formatLong: Mue,
  formatRelative: Sue,
  localize: Aue,
  match: Yue,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Uue = {
  lessThanXSeconds: {
    one: "ավելի քիչ քան 1 վայրկյան",
    other: "ավելի քիչ քան {{count}} վայրկյան"
  },
  xSeconds: {
    one: "1 վայրկյան",
    other: "{{count}} վայրկյան"
  },
  halfAMinute: "կես րոպե",
  lessThanXMinutes: {
    one: "ավելի քիչ քան 1 րոպե",
    other: "ավելի քիչ քան {{count}} րոպե"
  },
  xMinutes: {
    one: "1 րոպե",
    other: "{{count}} րոպե"
  },
  aboutXHours: {
    one: "մոտ 1 ժամ",
    other: "մոտ {{count}} ժամ"
  },
  xHours: {
    one: "1 ժամ",
    other: "{{count}} ժամ"
  },
  xDays: {
    one: "1 օր",
    other: "{{count}} օր"
  },
  aboutXWeeks: {
    one: "մոտ 1 շաբաթ",
    other: "մոտ {{count}} շաբաթ"
  },
  xWeeks: {
    one: "1 շաբաթ",
    other: "{{count}} շաբաթ"
  },
  aboutXMonths: {
    one: "մոտ 1 ամիս",
    other: "մոտ {{count}} ամիս"
  },
  xMonths: {
    one: "1 ամիս",
    other: "{{count}} ամիս"
  },
  aboutXYears: {
    one: "մոտ 1 տարի",
    other: "մոտ {{count}} տարի"
  },
  xYears: {
    one: "1 տարի",
    other: "{{count}} տարի"
  },
  overXYears: {
    one: "ավելի քան 1 տարի",
    other: "ավելի քան {{count}} տարի"
  },
  almostXYears: {
    one: "համարյա 1 տարի",
    other: "համարյա {{count}} տարի"
  }
}, Jue = (t, e, n) => {
  let i;
  const r = Uue[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " հետո" : i + " առաջ" : i;
}, Que = {
  full: "d MMMM, y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd.MM.yyyy"
}, Zue = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, efe = {
  full: "{{date}} 'ժ․'{{time}}",
  long: "{{date}} 'ժ․'{{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, tfe = {
  date: T({
    formats: Que,
    defaultWidth: "full"
  }),
  time: T({
    formats: Zue,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: efe,
    defaultWidth: "full"
  })
}, nfe = {
  lastWeek: "'նախորդ' eeee p'֊ին'",
  yesterday: "'երեկ' p'֊ին'",
  today: "'այսօր' p'֊ին'",
  tomorrow: "'վաղը' p'֊ին'",
  nextWeek: "'հաջորդ' eeee p'֊ին'",
  other: "P"
}, ife = (t, e, n, i) => nfe[t], rfe = {
  narrow: ["Ք", "Մ"],
  abbreviated: ["ՔԱ", "ՄԹ"],
  wide: ["Քրիստոսից առաջ", "Մեր թվարկության"]
}, afe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Ք1", "Ք2", "Ք3", "Ք4"],
  wide: ["1֊ին քառորդ", "2֊րդ քառորդ", "3֊րդ քառորդ", "4֊րդ քառորդ"]
}, ofe = {
  narrow: ["Հ", "Փ", "Մ", "Ա", "Մ", "Հ", "Հ", "Օ", "Ս", "Հ", "Ն", "Դ"],
  abbreviated: [
    "հուն",
    "փետ",
    "մար",
    "ապր",
    "մայ",
    "հուն",
    "հուլ",
    "օգս",
    "սեպ",
    "հոկ",
    "նոյ",
    "դեկ"
  ],
  wide: [
    "հունվար",
    "փետրվար",
    "մարտ",
    "ապրիլ",
    "մայիս",
    "հունիս",
    "հուլիս",
    "օգոստոս",
    "սեպտեմբեր",
    "հոկտեմբեր",
    "նոյեմբեր",
    "դեկտեմբեր"
  ]
}, sfe = {
  narrow: ["Կ", "Ե", "Ե", "Չ", "Հ", "Ո", "Շ"],
  short: ["կր", "եր", "եք", "չք", "հգ", "ուր", "շբ"],
  abbreviated: ["կիր", "երկ", "երք", "չոր", "հնգ", "ուրբ", "շաբ"],
  wide: [
    "կիրակի",
    "երկուշաբթի",
    "երեքշաբթի",
    "չորեքշաբթի",
    "հինգշաբթի",
    "ուրբաթ",
    "շաբաթ"
  ]
}, lfe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշեր",
    noon: "կեսօր",
    morning: "առավոտ",
    afternoon: "ցերեկ",
    evening: "երեկո",
    night: "գիշեր"
  }
}, dfe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "կեսգշ",
    noon: "կեսօր",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "կեսգիշերին",
    noon: "կեսօրին",
    morning: "առավոտը",
    afternoon: "ցերեկը",
    evening: "երեկոյան",
    night: "գիշերը"
  }
}, cfe = (t, e) => {
  const n = Number(t), i = n % 100;
  return i < 10 && i % 10 === 1 ? n + "֊ին" : n + "֊րդ";
}, ufe = {
  ordinalNumber: cfe,
  era: C({
    values: rfe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: afe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: ofe,
    defaultWidth: "wide"
  }),
  day: C({
    values: sfe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: lfe,
    defaultWidth: "wide",
    formattingValues: dfe,
    defaultFormattingWidth: "wide"
  })
}, ffe = /^(\d+)((-|֊)?(ին|րդ))?/i, mfe = /\d+/i, hfe = {
  narrow: /^(Ք|Մ)/i,
  abbreviated: /^(Ք\.?\s?Ա\.?|Մ\.?\s?Թ\.?\s?Ա\.?|Մ\.?\s?Թ\.?|Ք\.?\s?Հ\.?)/i,
  wide: /^(քրիստոսից առաջ|մեր թվարկությունից առաջ|մեր թվարկության|քրիստոսից հետո)/i
}, pfe = {
  any: [/^ք/i, /^մ/i]
}, gfe = {
  narrow: /^[1234]/i,
  abbreviated: /^ք[1234]/i,
  wide: /^[1234]((-|֊)?(ին|րդ)) քառորդ/i
}, yfe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vfe = {
  narrow: /^[հփմաօսնդ]/i,
  abbreviated: /^(հուն|փետ|մար|ապր|մայ|հուն|հուլ|օգս|սեպ|հոկ|նոյ|դեկ)/i,
  wide: /^(հունվար|փետրվար|մարտ|ապրիլ|մայիս|հունիս|հուլիս|օգոստոս|սեպտեմբեր|հոկտեմբեր|նոյեմբեր|դեկտեմբեր)/i
}, bfe = {
  narrow: [
    /^հ/i,
    /^փ/i,
    /^մ/i,
    /^ա/i,
    /^մ/i,
    /^հ/i,
    /^հ/i,
    /^օ/i,
    /^ս/i,
    /^հ/i,
    /^ն/i,
    /^դ/i
  ],
  any: [
    /^հու/i,
    /^փ/i,
    /^մար/i,
    /^ա/i,
    /^մայ/i,
    /^հուն/i,
    /^հուլ/i,
    /^օ/i,
    /^ս/i,
    /^հոկ/i,
    /^ն/i,
    /^դ/i
  ]
}, wfe = {
  narrow: /^[եչհոշկ]/i,
  short: /^(կր|եր|եք|չք|հգ|ուր|շբ)/i,
  abbreviated: /^(կիր|երկ|երք|չոր|հնգ|ուրբ|շաբ)/i,
  wide: /^(կիրակի|երկուշաբթի|երեքշաբթի|չորեքշաբթի|հինգշաբթի|ուրբաթ|շաբաթ)/i
}, kfe = {
  narrow: [/^կ/i, /^ե/i, /^ե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  short: [/^կ/i, /^եր/i, /^եք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  abbreviated: [/^կ/i, /^երկ/i, /^երք/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i],
  wide: [/^կ/i, /^երկ/i, /^երե/i, /^չ/i, /^հ/i, /^(ո|Ո)/, /^շ/i]
}, xfe = {
  narrow: /^([ap]|կեսգշ|կեսօր|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i,
  any: /^([ap]\.?\s?m\.?|կեսգիշեր(ին)?|կեսօր(ին)?|(առավոտը?|ցերեկը?|երեկո(յան)?|գիշերը?))/i
}, _fe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /կեսգիշեր/i,
    noon: /կեսօր/i,
    morning: /առավոտ/i,
    afternoon: /ցերեկ/i,
    evening: /երեկո/i,
    night: /գիշեր/i
  }
}, Mfe = {
  ordinalNumber: he({
    matchPattern: ffe,
    parsePattern: mfe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: hfe,
    defaultMatchWidth: "wide",
    parsePatterns: pfe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: gfe,
    defaultMatchWidth: "wide",
    parsePatterns: yfe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: vfe,
    defaultMatchWidth: "wide",
    parsePatterns: bfe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: wfe,
    defaultMatchWidth: "wide",
    parsePatterns: kfe,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: xfe,
    defaultMatchWidth: "any",
    parsePatterns: _fe,
    defaultParseWidth: "any"
  })
}, Cfe = {
  code: "hy",
  formatDistance: Jue,
  formatLong: tfe,
  formatRelative: ife,
  localize: ufe,
  match: Mfe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Pfe = {
  lessThanXSeconds: {
    one: "kurang dari 1 detik",
    other: "kurang dari {{count}} detik"
  },
  xSeconds: {
    one: "1 detik",
    other: "{{count}} detik"
  },
  halfAMinute: "setengah menit",
  lessThanXMinutes: {
    one: "kurang dari 1 menit",
    other: "kurang dari {{count}} menit"
  },
  xMinutes: {
    one: "1 menit",
    other: "{{count}} menit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, Sfe = (t, e, n) => {
  let i;
  const r = Pfe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dalam waktu " + i : i + " yang lalu" : i;
}, Nfe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, $fe = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, Dfe = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Efe = {
  date: T({
    formats: Nfe,
    defaultWidth: "full"
  }),
  time: T({
    formats: $fe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Dfe,
    defaultWidth: "full"
  })
}, Tfe = {
  lastWeek: "eeee 'lalu pukul' p",
  yesterday: "'Kemarin pukul' p",
  today: "'Hari ini pukul' p",
  tomorrow: "'Besok pukul' p",
  nextWeek: "eeee 'pukul' p",
  other: "P"
}, Ofe = (t, e, n, i) => Tfe[t], Wfe = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masehi", "Masehi"]
}, Afe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["Kuartal ke-1", "Kuartal ke-2", "Kuartal ke-3", "Kuartal ke-4"]
}, Lfe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Agt",
    "Sep",
    "Okt",
    "Nov",
    "Des"
  ],
  wide: [
    "Januari",
    "Februari",
    "Maret",
    "April",
    "Mei",
    "Juni",
    "Juli",
    "Agustus",
    "September",
    "Oktober",
    "November",
    "Desember"
  ]
}, Ife = {
  narrow: ["M", "S", "S", "R", "K", "J", "S"],
  short: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  abbreviated: ["Min", "Sen", "Sel", "Rab", "Kam", "Jum", "Sab"],
  wide: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
}, Rfe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, jfe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "siang",
    evening: "sore",
    night: "malam"
  }
}, Ffe = (t, e) => "ke-" + Number(t), zfe = {
  ordinalNumber: Ffe,
  era: C({
    values: Wfe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Afe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Lfe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ife,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Rfe,
    defaultWidth: "wide",
    formattingValues: jfe,
    defaultFormattingWidth: "wide"
  })
}, Vfe = /^ke-(\d+)?/i, Hfe = /\d+/i, Bfe = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|s\.?\s?e\.?\s?u\.?|m\.?|e\.?\s?u\.?)/i,
  wide: /^(sebelum masehi|sebelum era umum|masehi|era umum)/i
}, qfe = {
  any: [/^s/i, /^(m|e)/i]
}, Gfe = {
  narrow: /^[1234]/i,
  abbreviated: /^K-?\s[1234]/i,
  wide: /^Kuartal ke-?\s?[1234]/i
}, Xfe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Yfe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|mei|jun|jul|agt|sep|okt|nov|des)/i,
  wide: /^(januari|februari|maret|april|mei|juni|juli|agustus|september|oktober|november|desember)/i
}, Kfe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Ufe = {
  narrow: /^[srkjm]/i,
  short: /^(min|sen|sel|rab|kam|jum|sab)/i,
  abbreviated: /^(min|sen|sel|rab|kam|jum|sab)/i,
  wide: /^(minggu|senin|selasa|rabu|kamis|jumat|sabtu)/i
}, Jfe = {
  narrow: [/^m/i, /^s/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^m/i, /^sen/i, /^sel/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, Qfe = {
  narrow: /^(a|p|tengah m|tengah h|(di(\swaktu)?) (pagi|siang|sore|malam))/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|(di(\swaktu)?) (pagi|siang|sore|malam))/i
}, Zfe = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pagi/i,
    afternoon: /siang/i,
    evening: /sore/i,
    night: /malam/i
  }
}, eme = {
  ordinalNumber: he({
    matchPattern: Vfe,
    parsePattern: Hfe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Bfe,
    defaultMatchWidth: "wide",
    parsePatterns: qfe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Gfe,
    defaultMatchWidth: "wide",
    parsePatterns: Xfe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Yfe,
    defaultMatchWidth: "wide",
    parsePatterns: Kfe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Ufe,
    defaultMatchWidth: "wide",
    parsePatterns: Jfe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Qfe,
    defaultMatchWidth: "any",
    parsePatterns: Zfe,
    defaultParseWidth: "any"
  })
}, tme = {
  code: "id",
  formatDistance: Sfe,
  formatLong: Efe,
  formatRelative: Ofe,
  localize: zfe,
  match: eme,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, nme = {
  lessThanXSeconds: {
    one: "minna en 1 sekúnda",
    other: "minna en {{count}} sekúndur"
  },
  xSeconds: {
    one: "1 sekúnda",
    other: "{{count}} sekúndur"
  },
  halfAMinute: "hálf mínúta",
  lessThanXMinutes: {
    one: "minna en 1 mínúta",
    other: "minna en {{count}} mínútur"
  },
  xMinutes: {
    one: "1 mínúta",
    other: "{{count}} mínútur"
  },
  aboutXHours: {
    one: "u.þ.b. 1 klukkustund",
    other: "u.þ.b. {{count}} klukkustundir"
  },
  xHours: {
    one: "1 klukkustund",
    other: "{{count}} klukkustundir"
  },
  xDays: {
    one: "1 dagur",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "um viku",
    other: "um {{count}} vikur"
  },
  xWeeks: {
    one: "1 viku",
    other: "{{count}} vikur"
  },
  aboutXMonths: {
    one: "u.þ.b. 1 mánuður",
    other: "u.þ.b. {{count}} mánuðir"
  },
  xMonths: {
    one: "1 mánuður",
    other: "{{count}} mánuðir"
  },
  aboutXYears: {
    one: "u.þ.b. 1 ár",
    other: "u.þ.b. {{count}} ár"
  },
  xYears: {
    one: "1 ár",
    other: "{{count}} ár"
  },
  overXYears: {
    one: "meira en 1 ár",
    other: "meira en {{count}} ár"
  },
  almostXYears: {
    one: "næstum 1 ár",
    other: "næstum {{count}} ár"
  }
}, ime = (t, e, n) => {
  let i;
  const r = nme[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "í " + i : i + " síðan" : i;
}, rme = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "d.MM.y"
}, ame = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ome = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, sme = {
  date: T({
    formats: rme,
    defaultWidth: "full"
  }),
  time: T({
    formats: ame,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: ome,
    defaultWidth: "full"
  })
}, lme = {
  lastWeek: "'síðasta' dddd 'kl.' p",
  yesterday: "'í gær kl.' p",
  today: "'í dag kl.' p",
  tomorrow: "'á morgun kl.' p",
  nextWeek: "dddd 'kl.' p",
  other: "P"
}, dme = (t, e, n, i) => lme[t], cme = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["fyrir Krist", "eftir Krist"]
}, ume = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1F", "2F", "3F", "4F"],
  wide: ["1. fjórðungur", "2. fjórðungur", "3. fjórðungur", "4. fjórðungur"]
}, fme = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "Á", "S", "Ó", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "sept.",
    "okt.",
    "nóv.",
    "des."
  ],
  wide: [
    "janúar",
    "febrúar",
    "mars",
    "apríl",
    "maí",
    "júní",
    "júlí",
    "ágúst",
    "september",
    "október",
    "nóvember",
    "desember"
  ]
}, mme = {
  narrow: ["S", "M", "Þ", "M", "F", "F", "L"],
  short: ["Su", "Má", "Þr", "Mi", "Fi", "Fö", "La"],
  abbreviated: ["sun.", "mán.", "þri.", "mið.", "fim.", "fös.", "lau."],
  wide: [
    "sunnudagur",
    "mánudagur",
    "þriðjudagur",
    "miðvikudagur",
    "fimmtudagur",
    "föstudagur",
    "laugardagur"
  ]
}, hme = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "miðnætti",
    noon: "hádegi",
    morning: "morgunn",
    afternoon: "síðdegi",
    evening: "kvöld",
    night: "nótt"
  }
}, pme = {
  narrow: {
    am: "f",
    pm: "e",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  abbreviated: {
    am: "f.h.",
    pm: "e.h.",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  },
  wide: {
    am: "fyrir hádegi",
    pm: "eftir hádegi",
    midnight: "á miðnætti",
    noon: "á hádegi",
    morning: "að morgni",
    afternoon: "síðdegis",
    evening: "um kvöld",
    night: "um nótt"
  }
}, gme = (t, e) => Number(t) + ".", yme = {
  ordinalNumber: gme,
  era: C({
    values: cme,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: ume,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: fme,
    defaultWidth: "wide"
  }),
  day: C({
    values: mme,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: hme,
    defaultWidth: "wide",
    formattingValues: pme,
    defaultFormattingWidth: "wide"
  })
}, vme = /^(\d+)(\.)?/i, bme = /\d+(\.)?/i, wme = {
  narrow: /^(f\.Kr\.|e\.Kr\.)/i,
  abbreviated: /^(f\.Kr\.|e\.Kr\.)/i,
  wide: /^(fyrir Krist|eftir Krist)/i
}, kme = {
  any: [/^(f\.Kr\.)/i, /^(e\.Kr\.)/i]
}, xme = {
  narrow: /^[1234]\.?/i,
  abbreviated: /^q[1234]\.?/i,
  wide: /^[1234]\.? fjórðungur/i
}, _me = {
  any: [/1\.?/i, /2\.?/i, /3\.?/i, /4\.?/i]
}, Mme = {
  narrow: /^[jfmásónd]/i,
  abbreviated: /^(jan\.|feb\.|mars\.|apríl\.|maí|júní|júlí|águst|sep\.|oct\.|nov\.|dec\.)/i,
  wide: /^(januar|febrúar|mars|apríl|maí|júní|júlí|águst|september|október|nóvember|desember)/i
}, Cme = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^á/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maí/i,
    /^jún/i,
    /^júl/i,
    /^áu/i,
    /^s/i,
    /^ó/i,
    /^n/i,
    /^d/i
  ]
}, Pme = {
  narrow: /^[smtwf]/i,
  short: /^(su|má|þr|mi|fi|fö|la)/i,
  abbreviated: /^(sun|mán|þri|mið|fim|fös|lau)\.?/i,
  wide: /^(sunnudagur|mánudagur|þriðjudagur|miðvikudagur|fimmtudagur|föstudagur|laugardagur)/i
}, Sme = {
  narrow: [/^s/i, /^m/i, /^þ/i, /^m/i, /^f/i, /^f/i, /^l/i],
  any: [/^su/i, /^má/i, /^þr/i, /^mi/i, /^fi/i, /^fö/i, /^la/i]
}, Nme = {
  narrow: /^(f|e|síðdegis|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i,
  any: /^(fyrir hádegi|eftir hádegi|[ef]\.?h\.?|síðdegis|morgunn|(á|að|um) (morgni|kvöld|nótt|miðnætti))/i
}, $me = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^mi/i,
    noon: /^há/i,
    morning: /morgunn/i,
    afternoon: /síðdegi/i,
    evening: /kvöld/i,
    night: /nótt/i
  }
}, Dme = {
  ordinalNumber: he({
    matchPattern: vme,
    parsePattern: bme,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: wme,
    defaultMatchWidth: "wide",
    parsePatterns: kme,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: xme,
    defaultMatchWidth: "wide",
    parsePatterns: _me,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Mme,
    defaultMatchWidth: "wide",
    parsePatterns: Cme,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Pme,
    defaultMatchWidth: "wide",
    parsePatterns: Sme,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Nme,
    defaultMatchWidth: "any",
    parsePatterns: $me,
    defaultParseWidth: "any"
  })
}, Eme = {
  code: "is",
  formatDistance: ime,
  formatLong: sme,
  formatRelative: dme,
  localize: yme,
  match: Dme,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Tme = {
  lessThanXSeconds: {
    one: "meno di un secondo",
    other: "meno di {{count}} secondi"
  },
  xSeconds: {
    one: "un secondo",
    other: "{{count}} secondi"
  },
  halfAMinute: "alcuni secondi",
  lessThanXMinutes: {
    one: "meno di un minuto",
    other: "meno di {{count}} minuti"
  },
  xMinutes: {
    one: "un minuto",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "circa un'ora",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "un'ora",
    other: "{{count}} ore"
  },
  xDays: {
    one: "un giorno",
    other: "{{count}} giorni"
  },
  aboutXWeeks: {
    one: "circa una settimana",
    other: "circa {{count}} settimane"
  },
  xWeeks: {
    one: "una settimana",
    other: "{{count}} settimane"
  },
  aboutXMonths: {
    one: "circa un mese",
    other: "circa {{count}} mesi"
  },
  xMonths: {
    one: "un mese",
    other: "{{count}} mesi"
  },
  aboutXYears: {
    one: "circa un anno",
    other: "circa {{count}} anni"
  },
  xYears: {
    one: "un anno",
    other: "{{count}} anni"
  },
  overXYears: {
    one: "più di un anno",
    other: "più di {{count}} anni"
  },
  almostXYears: {
    one: "quasi un anno",
    other: "quasi {{count}} anni"
  }
}, wP = (t, e, n) => {
  let i;
  const r = Tme[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "tra " + i : i + " fa" : i;
}, Ome = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, Wme = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Ame = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Lme = {
  date: T({
    formats: Ome,
    defaultWidth: "full"
  }),
  time: T({
    formats: Wme,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Ame,
    defaultWidth: "full"
  })
}, u0 = [
  "domenica",
  "lunedì",
  "martedì",
  "mercoledì",
  "giovedì",
  "venerdì",
  "sabato"
];
function Ime(t) {
  switch (t) {
    case 0:
      return "'domenica scorsa alle' p";
    default:
      return "'" + u0[t] + " scorso alle' p";
  }
}
function b2(t) {
  return "'" + u0[t] + " alle' p";
}
function Rme(t) {
  switch (t) {
    case 0:
      return "'domenica prossima alle' p";
    default:
      return "'" + u0[t] + " prossimo alle' p";
  }
}
const jme = {
  lastWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? b2(i) : Ime(i);
  },
  yesterday: "'ieri alle' p",
  today: "'oggi alle' p",
  tomorrow: "'domani alle' p",
  nextWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? b2(i) : Rme(i);
  },
  other: "P"
}, kP = (t, e, n, i) => {
  const r = jme[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, Fme = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["avanti Cristo", "dopo Cristo"]
}, zme = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Vme = {
  narrow: ["G", "F", "M", "A", "M", "G", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "gen",
    "feb",
    "mar",
    "apr",
    "mag",
    "giu",
    "lug",
    "ago",
    "set",
    "ott",
    "nov",
    "dic"
  ],
  wide: [
    "gennaio",
    "febbraio",
    "marzo",
    "aprile",
    "maggio",
    "giugno",
    "luglio",
    "agosto",
    "settembre",
    "ottobre",
    "novembre",
    "dicembre"
  ]
}, Hme = {
  narrow: ["D", "L", "M", "M", "G", "V", "S"],
  short: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  abbreviated: ["dom", "lun", "mar", "mer", "gio", "ven", "sab"],
  wide: [
    "domenica",
    "lunedì",
    "martedì",
    "mercoledì",
    "giovedì",
    "venerdì",
    "sabato"
  ]
}, Bme = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "mattina",
    afternoon: "pomeriggio",
    evening: "sera",
    night: "notte"
  }
}, qme = {
  narrow: {
    am: "m.",
    pm: "p.",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "mezzanotte",
    noon: "mezzogiorno",
    morning: "di mattina",
    afternoon: "del pomeriggio",
    evening: "di sera",
    night: "di notte"
  }
}, Gme = (t, e) => {
  const n = Number(t);
  return String(n);
}, xP = {
  ordinalNumber: Gme,
  era: C({
    values: Fme,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: zme,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Vme,
    defaultWidth: "wide"
  }),
  day: C({
    values: Hme,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Bme,
    defaultWidth: "wide",
    formattingValues: qme,
    defaultFormattingWidth: "wide"
  })
}, Xme = /^(\d+)(º)?/i, Yme = /\d+/i, Kme = {
  narrow: /^(aC|dC)/i,
  abbreviated: /^(a\.?\s?C\.?|a\.?\s?e\.?\s?v\.?|d\.?\s?C\.?|e\.?\s?v\.?)/i,
  wide: /^(avanti Cristo|avanti Era Volgare|dopo Cristo|Era Volgare)/i
}, Ume = {
  any: [/^a/i, /^(d|e)/i]
}, Jme = {
  narrow: /^[1234]/i,
  abbreviated: /^t[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, Qme = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Zme = {
  narrow: /^[gfmalsond]/i,
  abbreviated: /^(gen|feb|mar|apr|mag|giu|lug|ago|set|ott|nov|dic)/i,
  wide: /^(gennaio|febbraio|marzo|aprile|maggio|giugno|luglio|agosto|settembre|ottobre|novembre|dicembre)/i
}, ehe = {
  narrow: [
    /^g/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^g/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ge/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mag/i,
    /^gi/i,
    /^l/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, the = {
  narrow: /^[dlmgvs]/i,
  short: /^(do|lu|ma|me|gi|ve|sa)/i,
  abbreviated: /^(dom|lun|mar|mer|gio|ven|sab)/i,
  wide: /^(domenica|luned[i|ì]|marted[i|ì]|mercoled[i|ì]|gioved[i|ì]|venerd[i|ì]|sabato)/i
}, nhe = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^g/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^me/i, /^g/i, /^v/i, /^s/i]
}, ihe = {
  narrow: /^(a|m\.|p|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i,
  any: /^([ap]\.?\s?m\.?|mezzanotte|mezzogiorno|(di|del) (mattina|pomeriggio|sera|notte))/i
}, rhe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mezza/i,
    noon: /^mezzo/i,
    morning: /mattina/i,
    afternoon: /pomeriggio/i,
    evening: /sera/i,
    night: /notte/i
  }
}, _P = {
  ordinalNumber: he({
    matchPattern: Xme,
    parsePattern: Yme,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Kme,
    defaultMatchWidth: "wide",
    parsePatterns: Ume,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Jme,
    defaultMatchWidth: "wide",
    parsePatterns: Qme,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Zme,
    defaultMatchWidth: "wide",
    parsePatterns: ehe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: the,
    defaultMatchWidth: "wide",
    parsePatterns: nhe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: ihe,
    defaultMatchWidth: "any",
    parsePatterns: rhe,
    defaultParseWidth: "any"
  })
}, ahe = {
  code: "it",
  formatDistance: wP,
  formatLong: Lme,
  formatRelative: kP,
  localize: xP,
  match: _P,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, ohe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, she = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, lhe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, dhe = {
  date: T({
    formats: ohe,
    defaultWidth: "full"
  }),
  time: T({
    formats: she,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: lhe,
    defaultWidth: "full"
  })
}, che = {
  code: "it-CH",
  formatDistance: wP,
  formatLong: dhe,
  formatRelative: kP,
  localize: xP,
  match: _P,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, uhe = {
  lessThanXSeconds: {
    one: "1秒未満",
    other: "{{count}}秒未満",
    oneWithSuffix: "約1秒",
    otherWithSuffix: "約{{count}}秒"
  },
  xSeconds: {
    one: "1秒",
    other: "{{count}}秒"
  },
  halfAMinute: "30秒",
  lessThanXMinutes: {
    one: "1分未満",
    other: "{{count}}分未満",
    oneWithSuffix: "約1分",
    otherWithSuffix: "約{{count}}分"
  },
  xMinutes: {
    one: "1分",
    other: "{{count}}分"
  },
  aboutXHours: {
    one: "約1時間",
    other: "約{{count}}時間"
  },
  xHours: {
    one: "1時間",
    other: "{{count}}時間"
  },
  xDays: {
    one: "1日",
    other: "{{count}}日"
  },
  aboutXWeeks: {
    one: "約1週間",
    other: "約{{count}}週間"
  },
  xWeeks: {
    one: "1週間",
    other: "{{count}}週間"
  },
  aboutXMonths: {
    one: "約1か月",
    other: "約{{count}}か月"
  },
  xMonths: {
    one: "1か月",
    other: "{{count}}か月"
  },
  aboutXYears: {
    one: "約1年",
    other: "約{{count}}年"
  },
  xYears: {
    one: "1年",
    other: "{{count}}年"
  },
  overXYears: {
    one: "1年以上",
    other: "{{count}}年以上"
  },
  almostXYears: {
    one: "1年近く",
    other: "{{count}}年近く"
  }
}, fhe = (t, e, n) => {
  n = n || {};
  let i;
  const r = uhe[t];
  return typeof r == "string" ? i = r : e === 1 ? n.addSuffix && r.oneWithSuffix ? i = r.oneWithSuffix : i = r.one : n.addSuffix && r.otherWithSuffix ? i = r.otherWithSuffix.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n.addSuffix ? n.comparison && n.comparison > 0 ? i + "後" : i + "前" : i;
}, mhe = {
  full: "y年M月d日EEEE",
  long: "y年M月d日",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, hhe = {
  full: "H時mm分ss秒 zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, phe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, ghe = {
  date: T({
    formats: mhe,
    defaultWidth: "full"
  }),
  time: T({
    formats: hhe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: phe,
    defaultWidth: "full"
  })
}, yhe = {
  lastWeek: "先週のeeeeのp",
  yesterday: "昨日のp",
  today: "今日のp",
  tomorrow: "明日のp",
  nextWeek: "翌週のeeeeのp",
  other: "P"
}, vhe = (t, e, n, i) => yhe[t], bhe = {
  narrow: ["BC", "AC"],
  abbreviated: ["紀元前", "西暦"],
  wide: ["紀元前", "西暦"]
}, whe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["第1四半期", "第2四半期", "第3四半期", "第4四半期"]
}, khe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ]
}, xhe = {
  narrow: ["日", "月", "火", "水", "木", "金", "土"],
  short: ["日", "月", "火", "水", "木", "金", "土"],
  abbreviated: ["日", "月", "火", "水", "木", "金", "土"],
  wide: ["日曜日", "月曜日", "火曜日", "水曜日", "木曜日", "金曜日", "土曜日"]
}, _he = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, Mhe = {
  narrow: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  abbreviated: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  },
  wide: {
    am: "午前",
    pm: "午後",
    midnight: "深夜",
    noon: "正午",
    morning: "朝",
    afternoon: "午後",
    evening: "夜",
    night: "深夜"
  }
}, Che = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "year":
      return `${n}年`;
    case "quarter":
      return `第${n}四半期`;
    case "month":
      return `${n}月`;
    case "week":
      return `第${n}週`;
    case "date":
      return `${n}日`;
    case "hour":
      return `${n}時`;
    case "minute":
      return `${n}分`;
    case "second":
      return `${n}秒`;
    default:
      return `${n}`;
  }
}, Phe = {
  ordinalNumber: Che,
  era: C({
    values: bhe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: whe,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: khe,
    defaultWidth: "wide"
  }),
  day: C({
    values: xhe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: _he,
    defaultWidth: "wide",
    formattingValues: Mhe,
    defaultFormattingWidth: "wide"
  })
}, She = /^第?\d+(年|四半期|月|週|日|時|分|秒)?/i, Nhe = /\d+/i, $he = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(紀元[前後]|西暦)/i,
  wide: /^(紀元[前後]|西暦)/i
}, Dhe = {
  narrow: [/^B/i, /^A/i],
  any: [/^(紀元前)/i, /^(西暦|紀元後)/i]
}, Ehe = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^第[1234一二三四１２３４]四半期/i
}, The = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, Ohe = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])月/i,
  wide: /^([123456789]|1[012])月/i
}, Whe = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, Ahe = {
  narrow: /^[日月火水木金土]/,
  short: /^[日月火水木金土]/,
  abbreviated: /^[日月火水木金土]/,
  wide: /^[日月火水木金土]曜日/
}, Lhe = {
  any: [/^日/, /^月/, /^火/, /^水/, /^木/, /^金/, /^土/]
}, Ihe = {
  any: /^(AM|PM|午前|午後|正午|深夜|真夜中|夜|朝)/i
}, Rhe = {
  any: {
    am: /^(A|午前)/i,
    pm: /^(P|午後)/i,
    midnight: /^深夜|真夜中/i,
    noon: /^正午/i,
    morning: /^朝/i,
    afternoon: /^午後/i,
    evening: /^夜/i,
    night: /^深夜/i
  }
}, jhe = {
  ordinalNumber: he({
    matchPattern: She,
    parsePattern: Nhe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: $he,
    defaultMatchWidth: "wide",
    parsePatterns: Dhe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Ehe,
    defaultMatchWidth: "wide",
    parsePatterns: The,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Ohe,
    defaultMatchWidth: "wide",
    parsePatterns: Whe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Ahe,
    defaultMatchWidth: "wide",
    parsePatterns: Lhe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Ihe,
    defaultMatchWidth: "any",
    parsePatterns: Rhe,
    defaultParseWidth: "any"
  })
}, Fhe = {
  code: "ja",
  formatDistance: fhe,
  formatLong: ghe,
  formatRelative: vhe,
  localize: Phe,
  match: jhe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, zhe = {
  lessThanXSeconds: {
    one: "1びょうみまん",
    other: "{{count}}びょうみまん",
    oneWithSuffix: "やく1びょう",
    otherWithSuffix: "やく{{count}}びょう"
  },
  xSeconds: {
    one: "1びょう",
    other: "{{count}}びょう"
  },
  halfAMinute: "30びょう",
  lessThanXMinutes: {
    one: "1ぷんみまん",
    other: "{{count}}ふんみまん",
    oneWithSuffix: "やく1ぷん",
    otherWithSuffix: "やく{{count}}ふん"
  },
  xMinutes: {
    one: "1ぷん",
    other: "{{count}}ふん"
  },
  aboutXHours: {
    one: "やく1じかん",
    other: "やく{{count}}じかん"
  },
  xHours: {
    one: "1じかん",
    other: "{{count}}じかん"
  },
  xDays: {
    one: "1にち",
    other: "{{count}}にち"
  },
  aboutXWeeks: {
    one: "やく1しゅうかん",
    other: "やく{{count}}しゅうかん"
  },
  xWeeks: {
    one: "1しゅうかん",
    other: "{{count}}しゅうかん"
  },
  aboutXMonths: {
    one: "やく1かげつ",
    other: "やく{{count}}かげつ"
  },
  xMonths: {
    one: "1かげつ",
    other: "{{count}}かげつ"
  },
  aboutXYears: {
    one: "やく1ねん",
    other: "やく{{count}}ねん"
  },
  xYears: {
    one: "1ねん",
    other: "{{count}}ねん"
  },
  overXYears: {
    one: "1ねんいじょう",
    other: "{{count}}ねんいじょう"
  },
  almostXYears: {
    one: "1ねんちかく",
    other: "{{count}}ねんちかく"
  }
}, Vhe = (t, e, n) => {
  n = n || {};
  let i;
  const r = zhe[t];
  return typeof r == "string" ? i = r : e === 1 ? n.addSuffix && r.oneWithSuffix ? i = r.oneWithSuffix : i = r.one : n.addSuffix && r.otherWithSuffix ? i = r.otherWithSuffix.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n.addSuffix ? n.comparison && n.comparison > 0 ? i + "あと" : i + "まえ" : i;
}, Hhe = {
  full: "yねんMがつdにちEEEE",
  long: "yねんMがつdにち",
  medium: "y/MM/dd",
  short: "y/MM/dd"
}, Bhe = {
  full: "Hじmmふんssびょう zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, qhe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ghe = {
  date: T({
    formats: Hhe,
    defaultWidth: "full"
  }),
  time: T({
    formats: Bhe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: qhe,
    defaultWidth: "full"
  })
}, Xhe = {
  lastWeek: "せんしゅうのeeeeのp",
  yesterday: "きのうのp",
  today: "きょうのp",
  tomorrow: "あしたのp",
  nextWeek: "よくしゅうのeeeeのp",
  other: "P"
}, Yhe = (t, e, n, i) => Xhe[t], Khe = {
  narrow: ["BC", "AC"],
  abbreviated: ["きげんぜん", "せいれき"],
  wide: ["きげんぜん", "せいれき"]
}, Uhe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["だい1しはんき", "だい2しはんき", "だい3しはんき", "だい4しはんき"]
}, Jhe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ"
  ],
  wide: [
    "1がつ",
    "2がつ",
    "3がつ",
    "4がつ",
    "5がつ",
    "6がつ",
    "7がつ",
    "8がつ",
    "9がつ",
    "10がつ",
    "11がつ",
    "12がつ"
  ]
}, Qhe = {
  narrow: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  short: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  abbreviated: ["にち", "げつ", "か", "すい", "もく", "きん", "ど"],
  wide: [
    "にちようび",
    "げつようび",
    "かようび",
    "すいようび",
    "もくようび",
    "きんようび",
    "どようび"
  ]
}, Zhe = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, e1e = {
  narrow: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  abbreviated: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  },
  wide: {
    am: "ごぜん",
    pm: "ごご",
    midnight: "しんや",
    noon: "しょうご",
    morning: "あさ",
    afternoon: "ごご",
    evening: "よる",
    night: "しんや"
  }
}, t1e = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "year":
      return `${n}ねん`;
    case "quarter":
      return `だい${n}しはんき`;
    case "month":
      return `${n}がつ`;
    case "week":
      return `だい${n}しゅう`;
    case "date":
      return `${n}にち`;
    case "hour":
      return `${n}じ`;
    case "minute":
      return `${n}ふん`;
    case "second":
      return `${n}びょう`;
    default:
      return `${n}`;
  }
}, n1e = {
  ordinalNumber: t1e,
  era: C({
    values: Khe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Uhe,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: Jhe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Qhe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Zhe,
    defaultWidth: "wide",
    formattingValues: e1e,
    defaultFormattingWidth: "wide"
  })
}, i1e = /^だ?い?\d+(ねん|しはんき|がつ|しゅう|にち|じ|ふん|びょう)?/i, r1e = /\d+/i, a1e = {
  narrow: /^(B\.?C\.?|A\.?D\.?)/i,
  abbreviated: /^(きげん[前後]|せいれき)/i,
  wide: /^(きげん[前後]|せいれき)/i
}, o1e = {
  narrow: [/^B/i, /^A/i],
  any: [/^(きげんぜん)/i, /^(せいれき|きげんご)/i]
}, s1e = {
  narrow: /^[1234]/i,
  abbreviated: /^Q[1234]/i,
  wide: /^だい[1234一二三四１２３４]しはんき/i
}, l1e = {
  any: [/(1|一|１)/i, /(2|二|２)/i, /(3|三|３)/i, /(4|四|４)/i]
}, d1e = {
  narrow: /^([123456789]|1[012])/,
  abbreviated: /^([123456789]|1[012])がつ/i,
  wide: /^([123456789]|1[012])がつ/i
}, c1e = {
  any: [
    /^1\D/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, u1e = {
  narrow: /^(にち|げつ|か|すい|もく|きん|ど)/,
  short: /^(にち|げつ|か|すい|もく|きん|ど)/,
  abbreviated: /^(にち|げつ|か|すい|もく|きん|ど)/,
  wide: /^(にち|げつ|か|すい|もく|きん|ど)ようび/
}, f1e = {
  any: [/^にち/, /^げつ/, /^か/, /^すい/, /^もく/, /^きん/, /^ど/]
}, m1e = {
  any: /^(AM|PM|ごぜん|ごご|しょうご|しんや|まよなか|よる|あさ)/i
}, h1e = {
  any: {
    am: /^(A|ごぜん)/i,
    pm: /^(P|ごご)/i,
    midnight: /^しんや|まよなか/i,
    noon: /^しょうご/i,
    morning: /^あさ/i,
    afternoon: /^ごご/i,
    evening: /^よる/i,
    night: /^しんや/i
  }
}, p1e = {
  ordinalNumber: he({
    matchPattern: i1e,
    parsePattern: r1e,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: a1e,
    defaultMatchWidth: "wide",
    parsePatterns: o1e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: s1e,
    defaultMatchWidth: "wide",
    parsePatterns: l1e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: d1e,
    defaultMatchWidth: "wide",
    parsePatterns: c1e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: u1e,
    defaultMatchWidth: "wide",
    parsePatterns: f1e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: m1e,
    defaultMatchWidth: "any",
    parsePatterns: h1e,
    defaultParseWidth: "any"
  })
}, g1e = {
  code: "ja-Hira",
  formatDistance: Vhe,
  formatLong: Ghe,
  formatRelative: Yhe,
  localize: n1e,
  match: p1e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, y1e = {
  lessThanXSeconds: {
    past: "{{count}} წამზე ნაკლები ხნის წინ",
    present: "{{count}} წამზე ნაკლები",
    future: "{{count}} წამზე ნაკლებში"
  },
  xSeconds: {
    past: "{{count}} წამის წინ",
    present: "{{count}} წამი",
    future: "{{count}} წამში"
  },
  halfAMinute: {
    past: "ნახევარი წუთის წინ",
    present: "ნახევარი წუთი",
    future: "ნახევარი წუთში"
  },
  lessThanXMinutes: {
    past: "{{count}} წუთზე ნაკლები ხნის წინ",
    present: "{{count}} წუთზე ნაკლები",
    future: "{{count}} წუთზე ნაკლებში"
  },
  xMinutes: {
    past: "{{count}} წუთის წინ",
    present: "{{count}} წუთი",
    future: "{{count}} წუთში"
  },
  aboutXHours: {
    past: "დაახლოებით {{count}} საათის წინ",
    present: "დაახლოებით {{count}} საათი",
    future: "დაახლოებით {{count}} საათში"
  },
  xHours: {
    past: "{{count}} საათის წინ",
    present: "{{count}} საათი",
    future: "{{count}} საათში"
  },
  xDays: {
    past: "{{count}} დღის წინ",
    present: "{{count}} დღე",
    future: "{{count}} დღეში"
  },
  aboutXWeeks: {
    past: "დაახლოებით {{count}} კვირას წინ",
    present: "დაახლოებით {{count}} კვირა",
    future: "დაახლოებით {{count}} კვირაში"
  },
  xWeeks: {
    past: "{{count}} კვირას კვირა",
    present: "{{count}} კვირა",
    future: "{{count}} კვირაში"
  },
  aboutXMonths: {
    past: "დაახლოებით {{count}} თვის წინ",
    present: "დაახლოებით {{count}} თვე",
    future: "დაახლოებით {{count}} თვეში"
  },
  xMonths: {
    past: "{{count}} თვის წინ",
    present: "{{count}} თვე",
    future: "{{count}} თვეში"
  },
  aboutXYears: {
    past: "დაახლოებით {{count}} წლის წინ",
    present: "დაახლოებით {{count}} წელი",
    future: "დაახლოებით {{count}} წელში"
  },
  xYears: {
    past: "{{count}} წლის წინ",
    present: "{{count}} წელი",
    future: "{{count}} წელში"
  },
  overXYears: {
    past: "{{count}} წელზე მეტი ხნის წინ",
    present: "{{count}} წელზე მეტი",
    future: "{{count}} წელზე მეტი ხნის შემდეგ"
  },
  almostXYears: {
    past: "თითქმის {{count}} წლის წინ",
    present: "თითქმის {{count}} წელი",
    future: "თითქმის {{count}} წელში"
  }
}, v1e = (t, e, n) => {
  let i;
  const r = y1e[t];
  return typeof r == "string" ? i = r : n != null && n.addSuffix && n.comparison && n.comparison > 0 ? i = r.future.replace("{{count}}", String(e)) : n != null && n.addSuffix ? i = r.past.replace("{{count}}", String(e)) : i = r.present.replace("{{count}}", String(e)), i;
}, b1e = {
  full: "EEEE, do MMMM, y",
  long: "do, MMMM, y",
  medium: "d, MMM, y",
  short: "dd/MM/yyyy"
}, w1e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, k1e = {
  full: "{{date}} {{time}}'-ზე'",
  long: "{{date}} {{time}}'-ზე'",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, x1e = {
  date: T({
    formats: b1e,
    defaultWidth: "full"
  }),
  time: T({
    formats: w1e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: k1e,
    defaultWidth: "full"
  })
}, _1e = {
  lastWeek: "'წინა' eeee p'-ზე'",
  yesterday: "'გუშინ' p'-ზე'",
  today: "'დღეს' p'-ზე'",
  tomorrow: "'ხვალ' p'-ზე'",
  nextWeek: "'შემდეგი' eeee p'-ზე'",
  other: "P"
}, M1e = (t, e, n, i) => _1e[t], C1e = {
  narrow: ["ჩ.წ-მდე", "ჩ.წ"],
  abbreviated: ["ჩვ.წ-მდე", "ჩვ.წ"],
  wide: ["ჩვენს წელთაღრიცხვამდე", "ჩვენი წელთაღრიცხვით"]
}, P1e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ლი კვ", "2-ე კვ", "3-ე კვ", "4-ე კვ"],
  wide: ["1-ლი კვარტალი", "2-ე კვარტალი", "3-ე კვარტალი", "4-ე კვარტალი"]
}, S1e = {
  narrow: [
    "ია",
    "თე",
    "მა",
    "აპ",
    "მს",
    "ვნ",
    "ვლ",
    "აგ",
    "სე",
    "ოქ",
    "ნო",
    "დე"
  ],
  abbreviated: [
    "იან",
    "თებ",
    "მარ",
    "აპრ",
    "მაი",
    "ივნ",
    "ივლ",
    "აგვ",
    "სექ",
    "ოქტ",
    "ნოე",
    "დეკ"
  ],
  wide: [
    "იანვარი",
    "თებერვალი",
    "მარტი",
    "აპრილი",
    "მაისი",
    "ივნისი",
    "ივლისი",
    "აგვისტო",
    "სექტემბერი",
    "ოქტომბერი",
    "ნოემბერი",
    "დეკემბერი"
  ]
}, N1e = {
  narrow: ["კვ", "ორ", "სა", "ოთ", "ხუ", "პა", "შა"],
  short: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  abbreviated: ["კვი", "ორშ", "სამ", "ოთხ", "ხუთ", "პარ", "შაბ"],
  wide: [
    "კვირა",
    "ორშაბათი",
    "სამშაბათი",
    "ოთხშაბათი",
    "ხუთშაბათი",
    "პარასკევი",
    "შაბათი"
  ]
}, $1e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამე",
    noon: "შუადღე",
    morning: "დილა",
    afternoon: "საღამო",
    evening: "საღამო",
    night: "ღამე"
  }
}, D1e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "შუაღამით",
    noon: "შუადღისას",
    morning: "დილით",
    afternoon: "ნაშუადღევს",
    evening: "საღამოს",
    night: "ღამით"
  }
}, E1e = (t) => {
  const e = Number(t);
  return e === 1 ? e + "-ლი" : e + "-ე";
}, T1e = {
  ordinalNumber: E1e,
  era: C({
    values: C1e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: P1e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: S1e,
    defaultWidth: "wide"
  }),
  day: C({
    values: N1e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: $1e,
    defaultWidth: "wide",
    formattingValues: D1e,
    defaultFormattingWidth: "wide"
  })
}, O1e = /^(\d+)(-ლი|-ე)?/i, W1e = /\d+/i, A1e = {
  narrow: /^(ჩვ?\.წ)/i,
  abbreviated: /^(ჩვ?\.წ)/i,
  wide: /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე|ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
}, L1e = {
  any: [
    /^(ჩვენს წელთაღრიცხვამდე|ქრისტეშობამდე)/i,
    /^(ჩვენი წელთაღრიცხვით|ქრისტეშობიდან)/i
  ]
}, I1e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-(ლი|ე)? კვ/i,
  wide: /^[1234]-(ლი|ე)? კვარტალი/i
}, R1e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, j1e = {
  any: /^(ია|თე|მა|აპ|მს|ვნ|ვლ|აგ|სე|ოქ|ნო|დე)/i
}, F1e = {
  any: [
    /^ია/i,
    /^თ/i,
    /^მარ/i,
    /^აპ/i,
    /^მაი/i,
    /^ი?ვნ/i,
    /^ი?ვლ/i,
    /^აგ/i,
    /^ს/i,
    /^ო/i,
    /^ნ/i,
    /^დ/i
  ]
}, z1e = {
  narrow: /^(კვ|ორ|სა|ოთ|ხუ|პა|შა)/i,
  short: /^(კვი|ორშ|სამ|ოთხ|ხუთ|პარ|შაბ)/i,
  wide: /^(კვირა|ორშაბათი|სამშაბათი|ოთხშაბათი|ხუთშაბათი|პარასკევი|შაბათი)/i
}, V1e = {
  any: [/^კვ/i, /^ორ/i, /^სა/i, /^ოთ/i, /^ხუ/i, /^პა/i, /^შა/i]
}, H1e = {
  any: /^([ap]\.?\s?m\.?|შუაღ|დილ)/i
}, B1e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^შუაღ/i,
    noon: /^შუადღ/i,
    morning: /^დილ/i,
    afternoon: /ნაშუადღევს/i,
    evening: /საღამო/i,
    night: /ღამ/i
  }
}, q1e = {
  ordinalNumber: he({
    matchPattern: O1e,
    parsePattern: W1e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: A1e,
    defaultMatchWidth: "wide",
    parsePatterns: L1e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: I1e,
    defaultMatchWidth: "wide",
    parsePatterns: R1e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: j1e,
    defaultMatchWidth: "any",
    parsePatterns: F1e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: z1e,
    defaultMatchWidth: "wide",
    parsePatterns: V1e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: H1e,
    defaultMatchWidth: "any",
    parsePatterns: B1e,
    defaultParseWidth: "any"
  })
}, G1e = {
  code: "ka",
  formatDistance: v1e,
  formatLong: x1e,
  formatRelative: M1e,
  localize: T1e,
  match: q1e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, X1e = {
  lessThanXSeconds: {
    regular: {
      one: "1 секундтан аз",
      singularNominative: "{{count}} секундтан аз",
      singularGenitive: "{{count}} секундтан аз",
      pluralGenitive: "{{count}} секундтан аз"
    },
    future: {
      one: "бір секундтан кейін",
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  xSeconds: {
    regular: {
      singularNominative: "{{count}} секунд",
      singularGenitive: "{{count}} секунд",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунд бұрын",
      singularGenitive: "{{count}} секунд бұрын",
      pluralGenitive: "{{count}} секунд бұрын"
    },
    future: {
      singularNominative: "{{count}} секундтан кейін",
      singularGenitive: "{{count}} секундтан кейін",
      pluralGenitive: "{{count}} секундтан кейін"
    }
  },
  halfAMinute: (t) => t != null && t.addSuffix ? t.comparison && t.comparison > 0 ? "жарты минут ішінде" : "жарты минут бұрын" : "жарты минут",
  lessThanXMinutes: {
    regular: {
      one: "1 минуттан аз",
      singularNominative: "{{count}} минуттан аз",
      singularGenitive: "{{count}} минуттан аз",
      pluralGenitive: "{{count}} минуттан аз"
    },
    future: {
      one: "минуттан кем ",
      singularNominative: "{{count}} минуттан кем",
      singularGenitive: "{{count}} минуттан кем",
      pluralGenitive: "{{count}} минуттан кем"
    }
  },
  xMinutes: {
    regular: {
      singularNominative: "{{count}} минут",
      singularGenitive: "{{count}} минут",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минут бұрын",
      singularGenitive: "{{count}} минут бұрын",
      pluralGenitive: "{{count}} минут бұрын"
    },
    future: {
      singularNominative: "{{count}} минуттан кейін",
      singularGenitive: "{{count}} минуттан кейін",
      pluralGenitive: "{{count}} минуттан кейін"
    }
  },
  aboutXHours: {
    regular: {
      singularNominative: "шамамен {{count}} сағат",
      singularGenitive: "шамамен {{count}} сағат",
      pluralGenitive: "шамамен {{count}} сағат"
    },
    future: {
      singularNominative: "шамамен {{count}} сағаттан кейін",
      singularGenitive: "шамамен {{count}} сағаттан кейін",
      pluralGenitive: "шамамен {{count}} сағаттан кейін"
    }
  },
  xHours: {
    regular: {
      singularNominative: "{{count}} сағат",
      singularGenitive: "{{count}} сағат",
      pluralGenitive: "{{count}} сағат"
    }
  },
  xDays: {
    regular: {
      singularNominative: "{{count}} күн",
      singularGenitive: "{{count}} күн",
      pluralGenitive: "{{count}} күн"
    },
    future: {
      singularNominative: "{{count}} күннен кейін",
      singularGenitive: "{{count}} күннен кейін",
      pluralGenitive: "{{count}} күннен кейін"
    }
  },
  aboutXWeeks: {
    type: "weeks",
    one: "шамамен 1 апта",
    other: "шамамен {{count}} апта"
  },
  xWeeks: {
    type: "weeks",
    one: "1 апта",
    other: "{{count}} апта"
  },
  aboutXMonths: {
    regular: {
      singularNominative: "шамамен {{count}} ай",
      singularGenitive: "шамамен {{count}} ай",
      pluralGenitive: "шамамен {{count}} ай"
    },
    future: {
      singularNominative: "шамамен {{count}} айдан кейін",
      singularGenitive: "шамамен {{count}} айдан кейін",
      pluralGenitive: "шамамен {{count}} айдан кейін"
    }
  },
  xMonths: {
    regular: {
      singularNominative: "{{count}} ай",
      singularGenitive: "{{count}} ай",
      pluralGenitive: "{{count}} ай"
    }
  },
  aboutXYears: {
    regular: {
      singularNominative: "шамамен {{count}} жыл",
      singularGenitive: "шамамен {{count}} жыл",
      pluralGenitive: "шамамен {{count}} жыл"
    },
    future: {
      singularNominative: "шамамен {{count}} жылдан кейін",
      singularGenitive: "шамамен {{count}} жылдан кейін",
      pluralGenitive: "шамамен {{count}} жылдан кейін"
    }
  },
  xYears: {
    regular: {
      singularNominative: "{{count}} жыл",
      singularGenitive: "{{count}} жыл",
      pluralGenitive: "{{count}} жыл"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  },
  overXYears: {
    regular: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    },
    future: {
      singularNominative: "{{count}} жылдан астам",
      singularGenitive: "{{count}} жылдан астам",
      pluralGenitive: "{{count}} жылдан астам"
    }
  },
  almostXYears: {
    regular: {
      singularNominative: "{{count}} жылға жақын",
      singularGenitive: "{{count}} жылға жақын",
      pluralGenitive: "{{count}} жылға жақын"
    },
    future: {
      singularNominative: "{{count}} жылдан кейін",
      singularGenitive: "{{count}} жылдан кейін",
      pluralGenitive: "{{count}} жылдан кейін"
    }
  }
};
function bl(t, e) {
  if (t.one && e === 1) return t.one;
  const n = e % 10, i = e % 100;
  return n === 1 && i !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (i < 10 || i > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
const Y1e = (t, e, n) => {
  const i = X1e[t];
  return typeof i == "function" ? i(n) : i.type === "weeks" ? e === 1 ? i.one : i.other.replace("{{count}}", String(e)) : n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i.future ? bl(i.future, e) : bl(i.regular, e) + " кейін" : i.past ? bl(i.past, e) : bl(i.regular, e) + " бұрын" : bl(i.regular, e);
}, K1e = {
  full: "EEEE, do MMMM y 'ж.'",
  long: "do MMMM y 'ж.'",
  medium: "d MMM y 'ж.'",
  short: "dd.MM.yyyy"
}, U1e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, J1e = {
  any: "{{date}}, {{time}}"
}, Q1e = {
  date: T({
    formats: K1e,
    defaultWidth: "full"
  }),
  time: T({
    formats: U1e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: J1e,
    defaultWidth: "any"
  })
}, f0 = [
  "жексенбіде",
  "дүйсенбіде",
  "сейсенбіде",
  "сәрсенбіде",
  "бейсенбіде",
  "жұмада",
  "сенбіде"
];
function Z1e(t) {
  return "'өткен " + f0[t] + " сағат' p'-де'";
}
function w2(t) {
  return "'" + f0[t] + " сағат' p'-де'";
}
function epe(t) {
  return "'келесі " + f0[t] + " сағат' p'-де'";
}
const tpe = {
  lastWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? w2(i) : Z1e(i);
  },
  yesterday: "'кеше сағат' p'-де'",
  today: "'бүгін сағат' p'-де'",
  tomorrow: "'ертең сағат' p'-де'",
  nextWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? w2(i) : epe(i);
  },
  other: "P"
}, npe = (t, e, n, i) => {
  const r = tpe[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, ipe = {
  narrow: ["б.з.д.", "б.з."],
  abbreviated: ["б.з.д.", "б.з."],
  wide: ["біздің заманымызға дейін", "біздің заманымыз"]
}, rpe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ші тоқ.", "2-ші тоқ.", "3-ші тоқ.", "4-ші тоқ."],
  wide: ["1-ші тоқсан", "2-ші тоқсан", "3-ші тоқсан", "4-ші тоқсан"]
}, ape = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел"
  ],
  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан"
  ]
}, ope = {
  narrow: ["Қ", "А", "Н", "С", "М", "М", "Ш", "Т", "Қ", "Қ", "Қ", "Ж"],
  abbreviated: [
    "қаң",
    "ақп",
    "нау",
    "сәу",
    "мам",
    "мау",
    "шіл",
    "там",
    "қыр",
    "қаз",
    "қар",
    "жел"
  ],
  wide: [
    "қаңтар",
    "ақпан",
    "наурыз",
    "сәуір",
    "мамыр",
    "маусым",
    "шілде",
    "тамыз",
    "қыркүйек",
    "қазан",
    "қараша",
    "желтоқсан"
  ]
}, spe = {
  narrow: ["Ж", "Д", "С", "С", "Б", "Ж", "С"],
  short: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  abbreviated: ["жс", "дс", "сс", "ср", "бс", "жм", "сб"],
  wide: [
    "жексенбі",
    "дүйсенбі",
    "сейсенбі",
    "сәрсенбі",
    "бейсенбі",
    "жұма",
    "сенбі"
  ]
}, lpe = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасы",
    noon: "түс",
    morning: "таң",
    afternoon: "күндіз",
    evening: "кеш",
    night: "түн"
  }
}, dpe = {
  narrow: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түс",
    morning: "таң",
    afternoon: "күн",
    evening: "кеш",
    night: "түн"
  },
  wide: {
    am: "ТД",
    pm: "ТК",
    midnight: "түн ортасында",
    noon: "түсте",
    morning: "таңертең",
    afternoon: "күндіз",
    evening: "кеште",
    night: "түнде"
  }
}, m1 = {
  0: "-ші",
  1: "-ші",
  2: "-ші",
  3: "-ші",
  4: "-ші",
  5: "-ші",
  6: "-шы",
  7: "-ші",
  8: "-ші",
  9: "-шы",
  10: "-шы",
  20: "-шы",
  30: "-шы",
  40: "-шы",
  50: "-ші",
  60: "-шы",
  70: "-ші",
  80: "-ші",
  90: "-шы",
  100: "-ші"
}, cpe = (t, e) => {
  const n = Number(t), i = n % 10, r = n >= 100 ? 100 : null, a = m1[n] || m1[i] || r && m1[r] || "";
  return n + a;
}, upe = {
  ordinalNumber: cpe,
  era: C({
    values: ipe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: rpe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: ape,
    defaultWidth: "wide",
    formattingValues: ope,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: spe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: lpe,
    defaultWidth: "any",
    formattingValues: dpe,
    defaultFormattingWidth: "wide"
  })
}, fpe = /^(\d+)(-?(ші|шы))?/i, mpe = /\d+/i, hpe = {
  narrow: /^((б )?з\.?\s?д\.?)/i,
  abbreviated: /^((б )?з\.?\s?д\.?)/i,
  wide: /^(біздің заманымызға дейін|біздің заманымыз|біздің заманымыздан)/i
}, ppe = {
  any: [/^б/i, /^з/i]
}, gpe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?ші)? тоқ.?/i,
  wide: /^[1234](-?ші)? тоқсан/i
}, ype = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, vpe = {
  narrow: /^(қ|а|н|с|м|мау|ш|т|қыр|қаз|қар|ж)/i,
  abbreviated: /^(қаң|ақп|нау|сәу|мам|мау|шіл|там|қыр|қаз|қар|жел)/i,
  wide: /^(қаңтар|ақпан|наурыз|сәуір|мамыр|маусым|шілде|тамыз|қыркүйек|қазан|қараша|желтоқсан)/i
}, bpe = {
  narrow: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i
  ],
  abbreviated: [
    /^қаң/i,
    /^ақп/i,
    /^нау/i,
    /^сәу/i,
    /^мам/i,
    /^мау/i,
    /^шіл/i,
    /^там/i,
    /^қыр/i,
    /^қаз/i,
    /^қар/i,
    /^жел/i
  ],
  any: [
    /^қ/i,
    /^а/i,
    /^н/i,
    /^с/i,
    /^м/i,
    /^м/i,
    /^ш/i,
    /^т/i,
    /^қ/i,
    /^қ/i,
    /^қ/i,
    /^ж/i
  ]
}, wpe = {
  narrow: /^(ж|д|с|с|б|ж|с)/i,
  short: /^(жс|дс|сс|ср|бс|жм|сб)/i,
  wide: /^(жексенбі|дүйсенбі|сейсенбі|сәрсенбі|бейсенбі|жұма|сенбі)/i
}, kpe = {
  narrow: [/^ж/i, /^д/i, /^с/i, /^с/i, /^б/i, /^ж/i, /^с/i],
  short: [/^жс/i, /^дс/i, /^сс/i, /^ср/i, /^бс/i, /^жм/i, /^сб/i],
  any: [
    /^ж[ек]/i,
    /^д[үй]/i,
    /^сe[й]/i,
    /^сә[р]/i,
    /^б[ей]/i,
    /^ж[ұм]/i,
    /^се[н]/i
  ]
}, xpe = {
  narrow: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  wide: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i,
  any: /^Т\.?\s?[ДК]\.?|түн ортасында|((түсте|таңертең|таңда|таңертең|таңмен|таң|күндіз|күн|кеште|кеш|түнде|түн)\.?)/i
}, _pe = {
  any: {
    am: /^ТД/i,
    pm: /^ТК/i,
    midnight: /^түн орта/i,
    noon: /^күндіз/i,
    morning: /таң/i,
    afternoon: /түс/i,
    evening: /кеш/i,
    night: /түн/i
  }
}, Mpe = {
  ordinalNumber: he({
    matchPattern: fpe,
    parsePattern: mpe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: hpe,
    defaultMatchWidth: "wide",
    parsePatterns: ppe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: gpe,
    defaultMatchWidth: "wide",
    parsePatterns: ype,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: vpe,
    defaultMatchWidth: "wide",
    parsePatterns: bpe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: wpe,
    defaultMatchWidth: "wide",
    parsePatterns: kpe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: xpe,
    defaultMatchWidth: "wide",
    parsePatterns: _pe,
    defaultParseWidth: "any"
  })
}, Cpe = {
  code: "kk",
  formatDistance: Y1e,
  formatLong: Q1e,
  formatRelative: npe,
  localize: upe,
  match: Mpe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Ppe = {
  lessThanXSeconds: "តិចជាង {{count}} វិនាទី",
  xSeconds: "{{count}} វិនាទី",
  halfAMinute: "កន្លះនាទី",
  lessThanXMinutes: "តិចជាង {{count}} នាទី",
  xMinutes: "{{count}} នាទី",
  aboutXHours: "ប្រហែល {{count}} ម៉ោង",
  xHours: "{{count}} ម៉ោង",
  xDays: "{{count}} ថ្ងៃ",
  aboutXWeeks: "ប្រហែល {{count}} សប្តាហ៍",
  xWeeks: "{{count}} សប្តាហ៍",
  aboutXMonths: "ប្រហែល {{count}} ខែ",
  xMonths: "{{count}} ខែ",
  aboutXYears: "ប្រហែល {{count}} ឆ្នាំ",
  xYears: "{{count}} ឆ្នាំ",
  overXYears: "ជាង {{count}} ឆ្នាំ",
  almostXYears: "ជិត {{count}} ឆ្នាំ"
}, Spe = (t, e, n) => {
  let r = Ppe[t];
  return typeof e == "number" && (r = r.replace("{{count}}", e.toString())), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "ក្នុងរយៈពេល " + r : r + "មុន" : r;
}, Npe = {
  full: "EEEE do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, $pe = {
  full: "h:mm:ss a",
  long: "h:mm:ss a",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, Dpe = {
  full: "{{date}} 'ម៉ោង' {{time}}",
  long: "{{date}} 'ម៉ោង' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Epe = {
  date: T({
    formats: Npe,
    defaultWidth: "full"
  }),
  time: T({
    formats: $pe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Dpe,
    defaultWidth: "full"
  })
}, Tpe = {
  lastWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​មុនម៉ោង' p",
  yesterday: "'ម្សិលមិញនៅម៉ោង' p",
  today: "'ថ្ងៃនេះម៉ោង' p",
  tomorrow: "'ថ្ងៃស្អែកម៉ោង' p",
  nextWeek: "'ថ្ងៃ'eeee'ស​ប្តា​ហ៍​ក្រោយម៉ោង' p",
  other: "P"
}, Ope = (t, e, n, i) => Tpe[t], Wpe = {
  narrow: ["ម.គស", "គស"],
  abbreviated: ["មុនគ.ស", "គ.ស"],
  wide: ["មុនគ្រិស្តសករាជ", "នៃគ្រិស្តសករាជ"]
}, Ape = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ត្រីមាសទី 1", "ត្រីមាសទី 2", "ត្រីមាសទី 3", "ត្រីមាសទី 4"]
}, Lpe = {
  narrow: [
    "ម.ក",
    "ក.ម",
    "មិ",
    "ម.ស",
    "ឧ.ស",
    "ម.ថ",
    "ក.ដ",
    "សី",
    "កញ",
    "តុ",
    "វិ",
    "ធ"
  ],
  abbreviated: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ"
  ],
  wide: [
    "មករា",
    "កុម្ភៈ",
    "មីនា",
    "មេសា",
    "ឧសភា",
    "មិថុនា",
    "កក្កដា",
    "សីហា",
    "កញ្ញា",
    "តុលា",
    "វិច្ឆិកា",
    "ធ្នូ"
  ]
}, Ipe = {
  narrow: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  short: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  abbreviated: ["អា", "ច", "អ", "ព", "ព្រ", "សុ", "ស"],
  wide: ["អាទិត្យ", "ចន្ទ", "អង្គារ", "ពុធ", "ព្រហស្បតិ៍", "សុក្រ", "សៅរ៍"]
}, Rpe = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, jpe = {
  narrow: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  abbreviated: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  },
  wide: {
    am: "ព្រឹក",
    pm: "ល្ងាច",
    midnight: "​ពេលកណ្ដាលអធ្រាត្រ",
    noon: "ពេលថ្ងៃត្រង់",
    morning: "ពេលព្រឹក",
    afternoon: "ពេលរសៀល",
    evening: "ពេលល្ងាច",
    night: "ពេលយប់"
  }
}, Fpe = (t, e) => Number(t).toString(), zpe = {
  ordinalNumber: Fpe,
  era: C({
    values: Wpe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Ape,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Lpe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Ipe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Rpe,
    defaultWidth: "wide",
    formattingValues: jpe,
    defaultFormattingWidth: "wide"
  })
}, Vpe = /^(\d+)(th|st|nd|rd)?/i, Hpe = /\d+/i, Bpe = {
  narrow: /^(ម\.)?គស/i,
  abbreviated: /^(មុន)?គ\.ស/i,
  wide: /^(មុន|នៃ)គ្រិស្តសករាជ/i
}, qpe = {
  any: [/^(ម|មុន)គ\.?ស/i, /^(នៃ)?គ\.?ស/i]
}, Gpe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^(ត្រីមាស)(ទី)?\s?[1234]/i
}, Xpe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Ype = {
  narrow: /^(ម\.ក|ក\.ម|មិ|ម\.ស|ឧ\.ស|ម\.ថ|ក\.ដ|សី|កញ|តុ|វិ|ធ)/i,
  abbreviated: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i,
  wide: /^(មករា|កុម្ភៈ|មីនា|មេសា|ឧសភា|មិថុនា|កក្កដា|សីហា|កញ្ញា|តុលា|វិច្ឆិកា|ធ្នូ)/i
}, Kpe = {
  narrow: [
    /^ម\.ក/i,
    /^ក\.ម/i,
    /^មិ/i,
    /^ម\.ស/i,
    /^ឧ\.ស/i,
    /^ម\.ថ/i,
    /^ក\.ដ/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិ/i,
    /^ធ/i
  ],
  any: [
    /^មក/i,
    /^កុ/i,
    /^មីន/i,
    /^មេ/i,
    /^ឧស/i,
    /^មិថ/i,
    /^កក/i,
    /^សី/i,
    /^កញ/i,
    /^តុ/i,
    /^វិច/i,
    /^ធ/i
  ]
}, Upe = {
  narrow: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  short: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  abbreviated: /^(អា|ច|អ|ព|ព្រ|សុ|ស)/i,
  wide: /^(អាទិត្យ|ចន្ទ|អង្គារ|ពុធ|ព្រហស្បតិ៍|សុក្រ|សៅរ៍)/i
}, Jpe = {
  narrow: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^ស/i],
  any: [/^អា/i, /^ច/i, /^អ/i, /^ព/i, /^ព្រ/i, /^សុ/i, /^សៅ/i]
}, Qpe = {
  narrow: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i,
  any: /^(ព្រឹក|ល្ងាច|ពេលព្រឹក|ពេលថ្ងៃត្រង់|ពេលល្ងាច|ពេលរសៀល|ពេលយប់|ពេលកណ្ដាលអធ្រាត្រ)/i
}, Zpe = {
  any: {
    am: /^ព្រឹក/i,
    pm: /^ល្ងាច/i,
    midnight: /^ពេលកណ្ដាលអធ្រាត្រ/i,
    noon: /^ពេលថ្ងៃត្រង់/i,
    morning: /ពេលព្រឹក/i,
    afternoon: /ពេលរសៀល/i,
    evening: /ពេលល្ងាច/i,
    night: /ពេលយប់/i
  }
}, ege = {
  ordinalNumber: he({
    matchPattern: Vpe,
    parsePattern: Hpe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: Bpe,
    defaultMatchWidth: "wide",
    parsePatterns: qpe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Gpe,
    defaultMatchWidth: "wide",
    parsePatterns: Xpe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Ype,
    defaultMatchWidth: "wide",
    parsePatterns: Kpe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Upe,
    defaultMatchWidth: "wide",
    parsePatterns: Jpe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Qpe,
    defaultMatchWidth: "any",
    parsePatterns: Zpe,
    defaultParseWidth: "any"
  })
}, tge = {
  code: "km",
  formatDistance: Spe,
  formatLong: Epe,
  formatRelative: Ope,
  localize: zpe,
  match: ege,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, nge = {
  lessThanXSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "1 ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ಸೆಕೆಂಡ್‌ಗಿಂತ ಕಡಿಮೆ"
    }
  },
  xSeconds: {
    one: {
      default: "1 ಸೆಕೆಂಡ್",
      future: "1 ಸೆಕೆಂಡ್‌ನಲ್ಲಿ",
      past: "1 ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಸೆಕೆಂಡುಗಳು",
      future: "{{count}} ಸೆಕೆಂಡ್‌ಗಳಲ್ಲಿ",
      past: "{{count}} ಸೆಕೆಂಡ್ ಹಿಂದೆ"
    }
  },
  halfAMinute: {
    other: {
      default: "ಅರ್ಧ ನಿಮಿಷ",
      future: "ಅರ್ಧ ನಿಮಿಷದಲ್ಲಿ",
      past: "ಅರ್ಧ ನಿಮಿಷದ ಹಿಂದೆ"
    }
  },
  lessThanXMinutes: {
    one: {
      default: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "1 ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      future: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ",
      past: "{{count}} ನಿಮಿಷಕ್ಕಿಂತ ಕಡಿಮೆ"
    }
  },
  xMinutes: {
    one: {
      default: "1 ನಿಮಿಷ",
      future: "1 ನಿಮಿಷದಲ್ಲಿ",
      past: "1 ನಿಮಿಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ನಿಮಿಷಗಳು",
      future: "{{count}} ನಿಮಿಷಗಳಲ್ಲಿ",
      past: "{{count}} ನಿಮಿಷಗಳ ಹಿಂದೆ"
    }
  },
  aboutXHours: {
    one: {
      default: "ಸುಮಾರು 1 ಗಂಟೆ",
      future: "ಸುಮಾರು 1 ಗಂಟೆಯಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳು",
      future: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xHours: {
    one: {
      default: "1 ಗಂಟೆ",
      future: "1 ಗಂಟೆಯಲ್ಲಿ",
      past: "1 ಗಂಟೆ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ಗಂಟೆಗಳು",
      future: "{{count}} ಗಂಟೆಗಳಲ್ಲಿ",
      past: "{{count}} ಗಂಟೆಗಳ ಹಿಂದೆ"
    }
  },
  xDays: {
    one: {
      default: "1 ದಿನ",
      future: "1 ದಿನದಲ್ಲಿ",
      past: "1 ದಿನದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ದಿನಗಳು",
      future: "{{count}} ದಿನಗಳಲ್ಲಿ",
      past: "{{count}} ದಿನಗಳ ಹಿಂದೆ"
    }
  },
  // TODO
  // aboutXWeeks: {},
  // TODO
  // xWeeks: {},
  aboutXMonths: {
    one: {
      default: "ಸುಮಾರು 1 ತಿಂಗಳು",
      future: "ಸುಮಾರು 1 ತಿಂಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ತಿಂಗಳು",
      future: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  xMonths: {
    one: {
      default: "1 ತಿಂಗಳು",
      future: "1 ತಿಂಗಳಲ್ಲಿ",
      past: "1 ತಿಂಗಳ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ತಿಂಗಳು",
      future: "{{count}} ತಿಂಗಳುಗಳಲ್ಲಿ",
      past: "{{count}} ತಿಂಗಳುಗಳ ಹಿಂದೆ"
    }
  },
  aboutXYears: {
    one: {
      default: "ಸುಮಾರು 1 ವರ್ಷ",
      future: "ಸುಮಾರು 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಸುಮಾರು 1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "ಸುಮಾರು {{count}} ವರ್ಷಗಳು",
      future: "ಸುಮಾರು {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಸುಮಾರು {{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  xYears: {
    one: {
      default: "1 ವರ್ಷ",
      future: "1 ವರ್ಷದಲ್ಲಿ",
      past: "1 ವರ್ಷದ ಹಿಂದೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳು",
      future: "{{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "{{count}} ವರ್ಷಗಳ ಹಿಂದೆ"
    }
  },
  overXYears: {
    one: {
      default: "1 ವರ್ಷದ ಮೇಲೆ",
      future: "1 ವರ್ಷದ ಮೇಲೆ",
      past: "1 ವರ್ಷದ ಮೇಲೆ"
    },
    other: {
      default: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      future: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ",
      past: "{{count}} ವರ್ಷಗಳ ಮೇಲೆ"
    }
  },
  almostXYears: {
    one: {
      default: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      future: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ",
      past: "ಬಹುತೇಕ 1 ವರ್ಷದಲ್ಲಿ"
    },
    other: {
      default: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      future: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ",
      past: "ಬಹುತೇಕ {{count}} ವರ್ಷಗಳಲ್ಲಿ"
    }
  }
};
function k2(t, e) {
  return e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? t.future : t.past : t.default;
}
const ige = (t, e, n) => {
  let i;
  const r = nge[t];
  return r.one && e === 1 ? i = k2(r.one, n) : i = k2(r.other, n), i.replace("{{count}}", String(e));
}, rge = {
  full: "EEEE, MMMM d, y",
  // CLDR 1816
  long: "MMMM d, y",
  // CLDR 1817
  medium: "MMM d, y",
  // CLDR 1818
  short: "d/M/yy"
  // CLDR 1819
}, age = {
  full: "hh:mm:ss a zzzz",
  // CLDR 1820
  long: "hh:mm:ss a z",
  // CLDR 1821
  medium: "hh:mm:ss a",
  // CLDR 1822
  short: "hh:mm a"
  // CLDR 1823
}, oge = {
  full: "{{date}} {{time}}",
  // CLDR 1824
  long: "{{date}} {{time}}",
  // CLDR 1825
  medium: "{{date}} {{time}}",
  // CLDR 1826
  short: "{{date}} {{time}}"
  // CLDR 1827
}, sge = {
  date: T({
    formats: rge,
    defaultWidth: "full"
  }),
  time: T({
    formats: age,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: oge,
    defaultWidth: "full"
  })
}, lge = {
  lastWeek: "'ಕಳೆದ' eeee p 'ಕ್ಕೆ'",
  yesterday: "'ನಿನ್ನೆ' p 'ಕ್ಕೆ'",
  today: "'ಇಂದು' p 'ಕ್ಕೆ'",
  tomorrow: "'ನಾಳೆ' p 'ಕ್ಕೆ'",
  nextWeek: "eeee p 'ಕ್ಕೆ'",
  other: "P"
}, dge = (t, e, n, i) => lge[t], cge = {
  narrow: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  abbreviated: ["ಕ್ರಿ.ಪೂ", "ಕ್ರಿ.ಶ"],
  // CLDR #1618, #1620
  wide: ["ಕ್ರಿಸ್ತ ಪೂರ್ವ", "ಕ್ರಿಸ್ತ ಶಕ"]
  // CLDR #1614, #1616
}, uge = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["ತ್ರೈ 1", "ತ್ರೈ 2", "ತ್ರೈ 3", "ತ್ರೈ 4"],
  // CLDR #1630 - #1638
  wide: ["1ನೇ ತ್ರೈಮಾಸಿಕ", "2ನೇ ತ್ರೈಮಾಸಿಕ", "3ನೇ ತ್ರೈಮಾಸಿಕ", "4ನೇ ತ್ರೈಮಾಸಿಕ"]
  // CLDR #1622 - #1629
}, fge = {
  narrow: ["ಜ", "ಫೆ", "ಮಾ", "ಏ", "ಮೇ", "ಜೂ", "ಜು", "ಆ", "ಸೆ", "ಅ", "ನ", "ಡಿ"],
  abbreviated: [
    "ಜನ",
    "ಫೆಬ್ರ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿ",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗ",
    "ಸೆಪ್ಟೆಂ",
    "ಅಕ್ಟೋ",
    "ನವೆಂ",
    "ಡಿಸೆಂ"
  ],
  wide: [
    "ಜನವರಿ",
    "ಫೆಬ್ರವರಿ",
    "ಮಾರ್ಚ್",
    "ಏಪ್ರಿಲ್",
    "ಮೇ",
    "ಜೂನ್",
    "ಜುಲೈ",
    "ಆಗಸ್ಟ್",
    "ಸೆಪ್ಟೆಂಬರ್",
    "ಅಕ್ಟೋಬರ್",
    "ನವೆಂಬರ್",
    "ಡಿಸೆಂಬರ್"
  ]
}, mge = {
  narrow: ["ಭಾ", "ಸೋ", "ಮಂ", "ಬು", "ಗು", "ಶು", "ಶ"],
  short: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  abbreviated: ["ಭಾನು", "ಸೋಮ", "ಮಂಗಳ", "ಬುಧ", "ಗುರು", "ಶುಕ್ರ", "ಶನಿ"],
  wide: [
    "ಭಾನುವಾರ",
    "ಸೋಮವಾರ",
    "ಮಂಗಳವಾರ",
    "ಬುಧವಾರ",
    "ಗುರುವಾರ",
    "ಶುಕ್ರವಾರ",
    "ಶನಿವಾರ"
  ]
}, hge = {
  narrow: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾಹ್ನ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾಹ್ನ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, pge = {
  narrow: {
    am: "ಪೂ",
    pm: "ಅ",
    midnight: "ಮಧ್ಯರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  abbreviated: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  },
  wide: {
    am: "ಪೂರ್ವಾಹ್ನ",
    pm: "ಅಪರಾಹ್ನ",
    midnight: "ಮಧ್ಯ ರಾತ್ರಿ",
    noon: "ಮಧ್ಯಾನ್ಹ",
    morning: "ಬೆಳಗ್ಗೆ",
    afternoon: "ಮಧ್ಯಾನ್ಹ",
    evening: "ಸಂಜೆ",
    night: "ರಾತ್ರಿ"
  }
}, gge = (t, e) => Number(t) + "ನೇ", yge = {
  ordinalNumber: gge,
  era: C({
    values: cge,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: uge,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: fge,
    defaultWidth: "wide"
  }),
  day: C({
    values: mge,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: hge,
    defaultWidth: "wide",
    formattingValues: pge,
    defaultFormattingWidth: "wide"
  })
}, vge = /^(\d+)(ನೇ|ನೆ)?/i, bge = /\d+/i, wge = {
  narrow: /^(ಕ್ರಿ.ಪೂ|ಕ್ರಿ.ಶ)/i,
  abbreviated: /^(ಕ್ರಿ\.?\s?ಪೂ\.?|ಕ್ರಿ\.?\s?ಶ\.?|ಪ್ರ\.?\s?ಶ\.?)/i,
  wide: /^(ಕ್ರಿಸ್ತ ಪೂರ್ವ|ಕ್ರಿಸ್ತ ಶಕ|ಪ್ರಸಕ್ತ ಶಕ)/i
}, kge = {
  any: [/^ಪೂ/i, /^(ಶ|ಪ್ರ)/i]
}, xge = {
  narrow: /^[1234]/i,
  abbreviated: /^ತ್ರೈ[1234]|ತ್ರೈ [1234]| [1234]ತ್ರೈ/i,
  wide: /^[1234](ನೇ)? ತ್ರೈಮಾಸಿಕ/i
}, _ge = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Mge = {
  narrow: /^(ಜೂ|ಜು|ಜ|ಫೆ|ಮಾ|ಏ|ಮೇ|ಆ|ಸೆ|ಅ|ನ|ಡಿ)/i,
  abbreviated: /^(ಜನ|ಫೆಬ್ರ|ಮಾರ್ಚ್|ಏಪ್ರಿ|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗ|ಸೆಪ್ಟೆಂ|ಅಕ್ಟೋ|ನವೆಂ|ಡಿಸೆಂ)/i,
  wide: /^(ಜನವರಿ|ಫೆಬ್ರವರಿ|ಮಾರ್ಚ್|ಏಪ್ರಿಲ್|ಮೇ|ಜೂನ್|ಜುಲೈ|ಆಗಸ್ಟ್|ಸೆಪ್ಟೆಂಬರ್|ಅಕ್ಟೋಬರ್|ನವೆಂಬರ್|ಡಿಸೆಂಬರ್)/i
}, Cge = {
  narrow: [
    /^ಜ$/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂ/i,
    /^ಜು$/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i
  ],
  any: [
    /^ಜನ/i,
    /^ಫೆ/i,
    /^ಮಾ/i,
    /^ಏ/i,
    /^ಮೇ/i,
    /^ಜೂನ್/i,
    /^ಜುಲೈ/i,
    /^ಆ/i,
    /^ಸೆ/i,
    /^ಅ/i,
    /^ನ/i,
    /^ಡಿ/i
  ]
}, Pge = {
  narrow: /^(ಭಾ|ಸೋ|ಮ|ಬು|ಗು|ಶು|ಶ)/i,
  short: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  abbreviated: /^(ಭಾನು|ಸೋಮ|ಮಂಗಳ|ಬುಧ|ಗುರು|ಶುಕ್ರ|ಶನಿ)/i,
  wide: /^(ಭಾನುವಾರ|ಸೋಮವಾರ|ಮಂಗಳವಾರ|ಬುಧವಾರ|ಗುರುವಾರ|ಶುಕ್ರವಾರ|ಶನಿವಾರ)/i
}, Sge = {
  narrow: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i],
  any: [/^ಭಾ/i, /^ಸೋ/i, /^ಮ/i, /^ಬು/i, /^ಗು/i, /^ಶು/i, /^ಶ/i]
}, Nge = {
  narrow: /^(ಪೂ|ಅ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i,
  any: /^(ಪೂರ್ವಾಹ್ನ|ಅಪರಾಹ್ನ|ಮಧ್ಯರಾತ್ರಿ|ಮಧ್ಯಾನ್ಹ|ಬೆಳಗ್ಗೆ|ಸಂಜೆ|ರಾತ್ರಿ)/i
}, $ge = {
  any: {
    am: /^ಪೂ/i,
    pm: /^ಅ/i,
    midnight: /ಮಧ್ಯರಾತ್ರಿ/i,
    noon: /ಮಧ್ಯಾನ್ಹ/i,
    morning: /ಬೆಳಗ್ಗೆ/i,
    afternoon: /ಮಧ್ಯಾನ್ಹ/i,
    evening: /ಸಂಜೆ/i,
    night: /ರಾತ್ರಿ/i
  }
}, Dge = {
  ordinalNumber: he({
    matchPattern: vge,
    parsePattern: bge,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: wge,
    defaultMatchWidth: "wide",
    parsePatterns: kge,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: xge,
    defaultMatchWidth: "wide",
    parsePatterns: _ge,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Mge,
    defaultMatchWidth: "wide",
    parsePatterns: Cge,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Pge,
    defaultMatchWidth: "wide",
    parsePatterns: Sge,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Nge,
    defaultMatchWidth: "any",
    parsePatterns: $ge,
    defaultParseWidth: "any"
  })
}, Ege = {
  code: "kn",
  formatDistance: ige,
  formatLong: sge,
  formatRelative: dge,
  localize: yge,
  match: Dge,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Tge = {
  lessThanXSeconds: {
    one: "1초 미만",
    other: "{{count}}초 미만"
  },
  xSeconds: {
    one: "1초",
    other: "{{count}}초"
  },
  halfAMinute: "30초",
  lessThanXMinutes: {
    one: "1분 미만",
    other: "{{count}}분 미만"
  },
  xMinutes: {
    one: "1분",
    other: "{{count}}분"
  },
  aboutXHours: {
    one: "약 1시간",
    other: "약 {{count}}시간"
  },
  xHours: {
    one: "1시간",
    other: "{{count}}시간"
  },
  xDays: {
    one: "1일",
    other: "{{count}}일"
  },
  aboutXWeeks: {
    one: "약 1주",
    other: "약 {{count}}주"
  },
  xWeeks: {
    one: "1주",
    other: "{{count}}주"
  },
  aboutXMonths: {
    one: "약 1개월",
    other: "약 {{count}}개월"
  },
  xMonths: {
    one: "1개월",
    other: "{{count}}개월"
  },
  aboutXYears: {
    one: "약 1년",
    other: "약 {{count}}년"
  },
  xYears: {
    one: "1년",
    other: "{{count}}년"
  },
  overXYears: {
    one: "1년 이상",
    other: "{{count}}년 이상"
  },
  almostXYears: {
    one: "거의 1년",
    other: "거의 {{count}}년"
  }
}, Oge = (t, e, n) => {
  let i;
  const r = Tge[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " 후" : i + " 전" : i;
}, Wge = {
  full: "y년 M월 d일 EEEE",
  long: "y년 M월 d일",
  medium: "y.MM.dd",
  short: "y.MM.dd"
}, Age = {
  full: "a H시 mm분 ss초 zzzz",
  long: "a H:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Lge = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Ige = {
  date: T({
    formats: Wge,
    defaultWidth: "full"
  }),
  time: T({
    formats: Age,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Lge,
    defaultWidth: "full"
  })
}, Rge = {
  lastWeek: "'지난' eeee p",
  yesterday: "'어제' p",
  today: "'오늘' p",
  tomorrow: "'내일' p",
  nextWeek: "'다음' eeee p",
  other: "P"
}, jge = (t, e, n, i) => Rge[t], Fge = {
  narrow: ["BC", "AD"],
  abbreviated: ["BC", "AD"],
  wide: ["기원전", "서기"]
}, zge = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1분기", "2분기", "3분기", "4분기"]
}, Vge = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ],
  wide: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월"
  ]
}, Hge = {
  narrow: ["일", "월", "화", "수", "목", "금", "토"],
  short: ["일", "월", "화", "수", "목", "금", "토"],
  abbreviated: ["일", "월", "화", "수", "목", "금", "토"],
  wide: ["일요일", "월요일", "화요일", "수요일", "목요일", "금요일", "토요일"]
}, Bge = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, qge = {
  narrow: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  abbreviated: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  },
  wide: {
    am: "오전",
    pm: "오후",
    midnight: "자정",
    noon: "정오",
    morning: "아침",
    afternoon: "오후",
    evening: "저녁",
    night: "밤"
  }
}, Gge = (t, e) => {
  const n = Number(t);
  switch (String(e == null ? void 0 : e.unit)) {
    case "minute":
    case "second":
      return String(n);
    case "date":
      return n + "일";
    default:
      return n + "번째";
  }
}, Xge = {
  ordinalNumber: Gge,
  era: C({
    values: Fge,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: zge,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Vge,
    defaultWidth: "wide"
  }),
  day: C({
    values: Hge,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Bge,
    defaultWidth: "wide",
    formattingValues: qge,
    defaultFormattingWidth: "wide"
  })
}, Yge = /^(\d+)(일|번째)?/i, Kge = /\d+/i, Uge = {
  narrow: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(기원전|서기)/i
}, Jge = {
  any: [/^(bc|기원전)/i, /^(ad|서기)/i]
}, Qge = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]사?분기/i
}, Zge = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, eye = {
  narrow: /^(1[012]|[123456789])/,
  abbreviated: /^(1[012]|[123456789])월/i,
  wide: /^(1[012]|[123456789])월/i
}, tye = {
  any: [
    /^1월?$/,
    /^2/,
    /^3/,
    /^4/,
    /^5/,
    /^6/,
    /^7/,
    /^8/,
    /^9/,
    /^10/,
    /^11/,
    /^12/
  ]
}, nye = {
  narrow: /^[일월화수목금토]/,
  short: /^[일월화수목금토]/,
  abbreviated: /^[일월화수목금토]/,
  wide: /^[일월화수목금토]요일/
}, iye = {
  any: [/^일/, /^월/, /^화/, /^수/, /^목/, /^금/, /^토/]
}, rye = {
  any: /^(am|pm|오전|오후|자정|정오|아침|저녁|밤)/i
}, aye = {
  any: {
    am: /^(am|오전)/i,
    pm: /^(pm|오후)/i,
    midnight: /^자정/i,
    noon: /^정오/i,
    morning: /^아침/i,
    afternoon: /^오후/i,
    evening: /^저녁/i,
    night: /^밤/i
  }
}, oye = {
  ordinalNumber: he({
    matchPattern: Yge,
    parsePattern: Kge,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Uge,
    defaultMatchWidth: "wide",
    parsePatterns: Jge,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Qge,
    defaultMatchWidth: "wide",
    parsePatterns: Zge,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: eye,
    defaultMatchWidth: "wide",
    parsePatterns: tye,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: nye,
    defaultMatchWidth: "wide",
    parsePatterns: iye,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: rye,
    defaultMatchWidth: "any",
    parsePatterns: aye,
    defaultParseWidth: "any"
  })
}, sye = {
  code: "ko",
  formatDistance: Oge,
  formatLong: Ige,
  formatRelative: jge,
  localize: Xge,
  match: oye,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, lye = {
  lessThanXSeconds: {
    standalone: {
      one: "manner wéi eng Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    },
    withPreposition: {
      one: "manner wéi enger Sekonn",
      other: "manner wéi {{count}} Sekonnen"
    }
  },
  xSeconds: {
    standalone: {
      one: "eng Sekonn",
      other: "{{count}} Sekonnen"
    },
    withPreposition: {
      one: "enger Sekonn",
      other: "{{count}} Sekonnen"
    }
  },
  halfAMinute: {
    standalone: "eng hallef Minutt",
    withPreposition: "enger hallwer Minutt"
  },
  lessThanXMinutes: {
    standalone: {
      one: "manner wéi eng Minutt",
      other: "manner wéi {{count}} Minutten"
    },
    withPreposition: {
      one: "manner wéi enger Minutt",
      other: "manner wéi {{count}} Minutten"
    }
  },
  xMinutes: {
    standalone: {
      one: "eng Minutt",
      other: "{{count}} Minutten"
    },
    withPreposition: {
      one: "enger Minutt",
      other: "{{count}} Minutten"
    }
  },
  aboutXHours: {
    standalone: {
      one: "ongeféier eng Stonn",
      other: "ongeféier {{count}} Stonnen"
    },
    withPreposition: {
      one: "ongeféier enger Stonn",
      other: "ongeféier {{count}} Stonnen"
    }
  },
  xHours: {
    standalone: {
      one: "eng Stonn",
      other: "{{count}} Stonnen"
    },
    withPreposition: {
      one: "enger Stonn",
      other: "{{count}} Stonnen"
    }
  },
  xDays: {
    standalone: {
      one: "een Dag",
      other: "{{count}} Deeg"
    },
    withPreposition: {
      one: "engem Dag",
      other: "{{count}} Deeg"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "ongeféier eng Woch",
      other: "ongeféier {{count}} Wochen"
    },
    withPreposition: {
      one: "ongeféier enger Woche",
      other: "ongeféier {{count}} Wochen"
    }
  },
  xWeeks: {
    standalone: {
      one: "eng Woch",
      other: "{{count}} Wochen"
    },
    withPreposition: {
      one: "enger Woch",
      other: "{{count}} Wochen"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "ongeféier ee Mount",
      other: "ongeféier {{count}} Méint"
    },
    withPreposition: {
      one: "ongeféier engem Mount",
      other: "ongeféier {{count}} Méint"
    }
  },
  xMonths: {
    standalone: {
      one: "ee Mount",
      other: "{{count}} Méint"
    },
    withPreposition: {
      one: "engem Mount",
      other: "{{count}} Méint"
    }
  },
  aboutXYears: {
    standalone: {
      one: "ongeféier ee Joer",
      other: "ongeféier {{count}} Joer"
    },
    withPreposition: {
      one: "ongeféier engem Joer",
      other: "ongeféier {{count}} Joer"
    }
  },
  xYears: {
    standalone: {
      one: "ee Joer",
      other: "{{count}} Joer"
    },
    withPreposition: {
      one: "engem Joer",
      other: "{{count}} Joer"
    }
  },
  overXYears: {
    standalone: {
      one: "méi wéi ee Joer",
      other: "méi wéi {{count}} Joer"
    },
    withPreposition: {
      one: "méi wéi engem Joer",
      other: "méi wéi {{count}} Joer"
    }
  },
  almostXYears: {
    standalone: {
      one: "bal ee Joer",
      other: "bal {{count}} Joer"
    },
    withPreposition: {
      one: "bal engem Joer",
      other: "bal {{count}} Joer"
    }
  }
}, dye = ["d", "h", "n", "t", "z"], cye = ["a,", "e", "i", "o", "u"], uye = [0, 1, 2, 3, 8, 9], fye = [40, 50, 60, 70];
function x2(t) {
  const e = t.charAt(0).toLowerCase();
  if (cye.indexOf(e) != -1 || dye.indexOf(e) != -1)
    return !0;
  const n = t.split(" ")[0], i = parseInt(n);
  return !isNaN(i) && uye.indexOf(i % 10) != -1 && fye.indexOf(
    parseInt(n.substring(0, 2))
  ) == -1;
}
const mye = (t, e, n) => {
  let i;
  const r = lye[t], a = n != null && n.addSuffix ? r.withPreposition : r.standalone;
  return typeof a == "string" ? i = a : e === 1 ? i = a.one : i = a.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "a" + (x2(i) ? "n" : "") + " " + i : "viru" + (x2(i) ? "n" : "") + " " + i : i;
}, hye = {
  full: "EEEE, do MMMM y",
  // Méindeg, 7. Januar 2018
  long: "do MMMM y",
  // 7. Januar 2018
  medium: "do MMM y",
  // 7. Jan 2018
  short: "dd.MM.yy"
  // 07.01.18
}, pye = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, gye = {
  full: "{{date}} 'um' {{time}}",
  long: "{{date}} 'um' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, yye = {
  date: T({
    formats: hye,
    defaultWidth: "full"
  }),
  time: T({
    formats: pye,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: gye,
    defaultWidth: "full"
  })
}, vye = {
  lastWeek: (t) => {
    const e = t.getDay();
    let n = "'läschte";
    return (e === 2 || e === 4) && (n += "n"), n += "' eeee 'um' p", n;
  },
  yesterday: "'gëschter um' p",
  today: "'haut um' p",
  tomorrow: "'moien um' p",
  nextWeek: "eeee 'um' p",
  other: "P"
}, bye = (t, e, n, i) => {
  const r = vye[t];
  return typeof r == "function" ? r(e) : r;
}, wye = {
  narrow: ["v.Chr.", "n.Chr."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["viru Christus", "no Christus"]
}, kye = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. Quartal", "2. Quartal", "3. Quartal", "4. Quartal"]
}, xye = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mäe",
    "Abr",
    "Mee",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Okt",
    "Nov",
    "Dez"
  ],
  wide: [
    "Januar",
    "Februar",
    "Mäerz",
    "Abrëll",
    "Mee",
    "Juni",
    "Juli",
    "August",
    "September",
    "Oktober",
    "November",
    "Dezember"
  ]
}, _ye = {
  narrow: ["S", "M", "D", "M", "D", "F", "S"],
  short: ["So", "Mé", "Dë", "Më", "Do", "Fr", "Sa"],
  abbreviated: ["So.", "Mé.", "Dë.", "Më.", "Do.", "Fr.", "Sa."],
  wide: [
    "Sonndeg",
    "Méindeg",
    "Dënschdeg",
    "Mëttwoch",
    "Donneschdeg",
    "Freideg",
    "Samschdeg"
  ]
}, Mye = {
  narrow: {
    am: "mo.",
    pm: "nomë.",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "Mëtteg",
    morning: "Moien",
    afternoon: "Nomëtteg",
    evening: "Owend",
    night: "Nuecht"
  }
}, Cye = {
  narrow: {
    am: "mo.",
    pm: "nom.",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  abbreviated: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  },
  wide: {
    am: "moies",
    pm: "nomëttes",
    midnight: "Mëtternuecht",
    noon: "mëttes",
    morning: "moies",
    afternoon: "nomëttes",
    evening: "owes",
    night: "nuets"
  }
}, Pye = (t, e) => Number(t) + ".", Sye = {
  ordinalNumber: Pye,
  era: C({
    values: wye,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: kye,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: xye,
    defaultWidth: "wide"
  }),
  day: C({
    values: _ye,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Mye,
    defaultWidth: "wide",
    formattingValues: Cye,
    defaultFormattingWidth: "wide"
  })
}, Nye = /^(\d+)(\.)?/i, $ye = /\d+/i, Dye = {
  narrow: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  abbreviated: /^(v\.? ?Chr\.?|n\.? ?Chr\.?)/i,
  wide: /^(viru Christus|virun eiser Zäitrechnung|no Christus|eiser Zäitrechnung)/i
}, Eye = {
  any: [/^v/i, /^n/i]
}, Tye = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? Quartal/i
}, Oye = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Wye = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mäe|abr|mee|jun|jul|aug|sep|okt|nov|dez)/i,
  wide: /^(januar|februar|mäerz|abrëll|mee|juni|juli|august|september|oktober|november|dezember)/i
}, Aye = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mä/i,
    /^ab/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Lye = {
  narrow: /^[smdf]/i,
  short: /^(so|mé|dë|më|do|fr|sa)/i,
  abbreviated: /^(son?|méi?|dën?|mët?|don?|fre?|sam?)\.?/i,
  wide: /^(sonndeg|méindeg|dënschdeg|mëttwoch|donneschdeg|freideg|samschdeg)/i
}, Iye = {
  any: [/^so/i, /^mé/i, /^dë/i, /^më/i, /^do/i, /^f/i, /^sa/i]
}, Rye = {
  narrow: /^(mo\.?|nomë\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  abbreviated: /^(moi\.?|nomët\.?|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i,
  wide: /^(moies|nomëttes|Mëtternuecht|mëttes|moies|nomëttes|owes|nuets)/i
}, jye = {
  any: {
    am: /^m/i,
    pm: /^n/i,
    midnight: /^Mëtter/i,
    noon: /^mëttes/i,
    morning: /moies/i,
    afternoon: /nomëttes/i,
    // will never be matched. Afternoon is matched by `pm`
    evening: /owes/i,
    night: /nuets/i
    // will never be matched. Night is matched by `pm`
  }
}, Fye = {
  ordinalNumber: he({
    matchPattern: Nye,
    parsePattern: $ye,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Dye,
    defaultMatchWidth: "wide",
    parsePatterns: Eye,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Tye,
    defaultMatchWidth: "wide",
    parsePatterns: Oye,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Wye,
    defaultMatchWidth: "wide",
    parsePatterns: Aye,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Lye,
    defaultMatchWidth: "wide",
    parsePatterns: Iye,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Rye,
    defaultMatchWidth: "wide",
    parsePatterns: jye,
    defaultParseWidth: "any"
  })
}, zye = {
  code: "lb",
  formatDistance: mye,
  formatLong: yye,
  formatRelative: bye,
  localize: Sye,
  match: Fye,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, MP = {
  xseconds_other: "sekundė_sekundžių_sekundes",
  xminutes_one: "minutė_minutės_minutę",
  xminutes_other: "minutės_minučių_minutes",
  xhours_one: "valanda_valandos_valandą",
  xhours_other: "valandos_valandų_valandas",
  xdays_one: "diena_dienos_dieną",
  xdays_other: "dienos_dienų_dienas",
  xweeks_one: "savaitė_savaitės_savaitę",
  xweeks_other: "savaitės_savaičių_savaites",
  xmonths_one: "mėnuo_mėnesio_mėnesį",
  xmonths_other: "mėnesiai_mėnesių_mėnesius",
  xyears_one: "metai_metų_metus",
  xyears_other: "metai_metų_metus",
  about: "apie",
  over: "daugiau nei",
  almost: "beveik",
  lessthan: "mažiau nei"
}, _2 = (t, e, n, i) => e ? i ? "kelių sekundžių" : "kelias sekundes" : "kelios sekundės", Bn = (t, e, n, i) => e ? i ? aa(n)[1] : aa(n)[2] : aa(n)[0], Nn = (t, e, n, i) => {
  const r = t + " ";
  return t === 1 ? r + Bn(t, e, n, i) : e ? i ? r + aa(n)[1] : r + (M2(t) ? aa(n)[1] : aa(n)[2]) : r + (M2(t) ? aa(n)[1] : aa(n)[0]);
};
function M2(t) {
  return t % 10 === 0 || t > 10 && t < 20;
}
function aa(t) {
  return MP[t].split("_");
}
const Vye = {
  lessThanXSeconds: {
    one: _2,
    other: Nn
  },
  xSeconds: {
    one: _2,
    other: Nn
  },
  halfAMinute: "pusė minutės",
  lessThanXMinutes: {
    one: Bn,
    other: Nn
  },
  xMinutes: {
    one: Bn,
    other: Nn
  },
  aboutXHours: {
    one: Bn,
    other: Nn
  },
  xHours: {
    one: Bn,
    other: Nn
  },
  xDays: {
    one: Bn,
    other: Nn
  },
  aboutXWeeks: {
    one: Bn,
    other: Nn
  },
  xWeeks: {
    one: Bn,
    other: Nn
  },
  aboutXMonths: {
    one: Bn,
    other: Nn
  },
  xMonths: {
    one: Bn,
    other: Nn
  },
  aboutXYears: {
    one: Bn,
    other: Nn
  },
  xYears: {
    one: Bn,
    other: Nn
  },
  overXYears: {
    one: Bn,
    other: Nn
  },
  almostXYears: {
    one: Bn,
    other: Nn
  }
}, Hye = (t, e, n) => {
  const i = t.match(/about|over|almost|lessthan/i), r = i ? t.replace(i[0], "") : t, a = (n == null ? void 0 : n.comparison) !== void 0 && n.comparison > 0;
  let o;
  const s = Vye[t];
  if (typeof s == "string" ? o = s : e === 1 ? o = s.one(
    e,
    (n == null ? void 0 : n.addSuffix) === !0,
    r.toLowerCase() + "_one",
    a
  ) : o = s.other(
    e,
    (n == null ? void 0 : n.addSuffix) === !0,
    r.toLowerCase() + "_other",
    a
  ), i) {
    const l = i[0].toLowerCase();
    o = MP[l] + " " + o;
  }
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "po " + o : "prieš " + o : o;
}, Bye = {
  full: "y 'm'. MMMM d 'd'., EEEE",
  long: "y 'm'. MMMM d 'd'.",
  medium: "y-MM-dd",
  short: "y-MM-dd"
}, qye = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Gye = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Xye = {
  date: T({
    formats: Bye,
    defaultWidth: "full"
  }),
  time: T({
    formats: qye,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Gye,
    defaultWidth: "full"
  })
}, Yye = {
  lastWeek: "'Praėjusį' eeee p",
  yesterday: "'Vakar' p",
  today: "'Šiandien' p",
  tomorrow: "'Rytoj' p",
  nextWeek: "eeee p",
  other: "P"
}, Kye = (t, e, n, i) => Yye[t], Uye = {
  narrow: ["pr. Kr.", "po Kr."],
  abbreviated: ["pr. Kr.", "po Kr."],
  wide: ["prieš Kristų", "po Kristaus"]
}, Jye = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I ketv.", "II ketv.", "III ketv.", "IV ketv."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, Qye = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I k.", "II k.", "III k.", "IV k."],
  wide: ["I ketvirtis", "II ketvirtis", "III ketvirtis", "IV ketvirtis"]
}, Zye = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod."
  ],
  wide: [
    "sausis",
    "vasaris",
    "kovas",
    "balandis",
    "gegužė",
    "birželis",
    "liepa",
    "rugpjūtis",
    "rugsėjis",
    "spalis",
    "lapkritis",
    "gruodis"
  ]
}, eve = {
  narrow: ["S", "V", "K", "B", "G", "B", "L", "R", "R", "S", "L", "G"],
  abbreviated: [
    "saus.",
    "vas.",
    "kov.",
    "bal.",
    "geg.",
    "birž.",
    "liep.",
    "rugp.",
    "rugs.",
    "spal.",
    "lapkr.",
    "gruod."
  ],
  wide: [
    "sausio",
    "vasario",
    "kovo",
    "balandžio",
    "gegužės",
    "birželio",
    "liepos",
    "rugpjūčio",
    "rugsėjo",
    "spalio",
    "lapkričio",
    "gruodžio"
  ]
}, tve = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienis",
    "pirmadienis",
    "antradienis",
    "trečiadienis",
    "ketvirtadienis",
    "penktadienis",
    "šeštadienis"
  ]
}, nve = {
  narrow: ["S", "P", "A", "T", "K", "P", "Š"],
  short: ["Sk", "Pr", "An", "Tr", "Kt", "Pn", "Št"],
  abbreviated: ["sk", "pr", "an", "tr", "kt", "pn", "št"],
  wide: [
    "sekmadienį",
    "pirmadienį",
    "antradienį",
    "trečiadienį",
    "ketvirtadienį",
    "penktadienį",
    "šeštadienį"
  ]
}, ive = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "vidurdienis",
    morning: "rytas",
    afternoon: "diena",
    evening: "vakaras",
    night: "naktis"
  }
}, rve = {
  narrow: {
    am: "pr. p.",
    pm: "pop.",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  abbreviated: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  },
  wide: {
    am: "priešpiet",
    pm: "popiet",
    midnight: "vidurnaktis",
    noon: "perpiet",
    morning: "rytas",
    afternoon: "popietė",
    evening: "vakaras",
    night: "naktis"
  }
}, ave = (t, e) => Number(t) + "-oji", ove = {
  ordinalNumber: ave,
  era: C({
    values: Uye,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Jye,
    defaultWidth: "wide",
    formattingValues: Qye,
    defaultFormattingWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Zye,
    defaultWidth: "wide",
    formattingValues: eve,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: tve,
    defaultWidth: "wide",
    formattingValues: nve,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: ive,
    defaultWidth: "wide",
    formattingValues: rve,
    defaultFormattingWidth: "wide"
  })
}, sve = /^(\d+)(-oji)?/i, lve = /\d+/i, dve = {
  narrow: /^p(r|o)\.?\s?(kr\.?|me)/i,
  abbreviated: /^(pr\.\s?(kr\.|m\.\s?e\.)|po\s?kr\.|mūsų eroje)/i,
  wide: /^(prieš Kristų|prieš mūsų erą|po Kristaus|mūsų eroje)/i
}, cve = {
  wide: [/prieš/i, /(po|mūsų)/i],
  any: [/^pr/i, /^(po|m)/i]
}, uve = {
  narrow: /^([1234])/i,
  abbreviated: /^(I|II|III|IV)\s?ketv?\.?/i,
  wide: /^(I|II|III|IV)\s?ketvirtis/i
}, fve = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/I$/i, /II$/i, /III/i, /IV/i]
}, mve = {
  narrow: /^[svkbglr]/i,
  abbreviated: /^(saus\.|vas\.|kov\.|bal\.|geg\.|birž\.|liep\.|rugp\.|rugs\.|spal\.|lapkr\.|gruod\.)/i,
  wide: /^(sausi(s|o)|vasari(s|o)|kov(a|o)s|balandž?i(s|o)|gegužės?|birželi(s|o)|liep(a|os)|rugpjū(t|č)i(s|o)|rugsėj(is|o)|spali(s|o)|lapkri(t|č)i(s|o)|gruodž?i(s|o))/i
}, hve = {
  narrow: [
    /^s/i,
    /^v/i,
    /^k/i,
    /^b/i,
    /^g/i,
    /^b/i,
    /^l/i,
    /^r/i,
    /^r/i,
    /^s/i,
    /^l/i,
    /^g/i
  ],
  any: [
    /^saus/i,
    /^vas/i,
    /^kov/i,
    /^bal/i,
    /^geg/i,
    /^birž/i,
    /^liep/i,
    /^rugp/i,
    /^rugs/i,
    /^spal/i,
    /^lapkr/i,
    /^gruod/i
  ]
}, pve = {
  narrow: /^[spatkš]/i,
  short: /^(sk|pr|an|tr|kt|pn|št)/i,
  abbreviated: /^(sk|pr|an|tr|kt|pn|št)/i,
  wide: /^(sekmadien(is|į)|pirmadien(is|į)|antradien(is|į)|trečiadien(is|į)|ketvirtadien(is|į)|penktadien(is|į)|šeštadien(is|į))/i
}, gve = {
  narrow: [/^s/i, /^p/i, /^a/i, /^t/i, /^k/i, /^p/i, /^š/i],
  wide: [/^se/i, /^pi/i, /^an/i, /^tr/i, /^ke/i, /^pe/i, /^še/i],
  any: [/^sk/i, /^pr/i, /^an/i, /^tr/i, /^kt/i, /^pn/i, /^št/i]
}, yve = {
  narrow: /^(pr.\s?p.|pop.|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i,
  any: /^(priešpiet|popiet$|vidurnaktis|(vidurdienis|perpiet)|rytas|(diena|popietė)|vakaras|naktis)/i
}, vve = {
  narrow: {
    am: /^pr/i,
    pm: /^pop./i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  },
  any: {
    am: /^pr/i,
    pm: /^popiet$/i,
    midnight: /^vidurnaktis/i,
    noon: /^(vidurdienis|perp)/i,
    morning: /rytas/i,
    afternoon: /(die|popietė)/i,
    evening: /vakaras/i,
    night: /naktis/i
  }
}, bve = {
  ordinalNumber: he({
    matchPattern: sve,
    parsePattern: lve,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: dve,
    defaultMatchWidth: "wide",
    parsePatterns: cve,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: uve,
    defaultMatchWidth: "wide",
    parsePatterns: fve,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: mve,
    defaultMatchWidth: "wide",
    parsePatterns: hve,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: pve,
    defaultMatchWidth: "wide",
    parsePatterns: gve,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: yve,
    defaultMatchWidth: "any",
    parsePatterns: vve,
    defaultParseWidth: "any"
  })
}, wve = {
  code: "lt",
  formatDistance: Hye,
  formatLong: Xye,
  formatRelative: Kye,
  localize: ove,
  match: bve,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function $n(t) {
  return (e, n) => {
    if (e === 1)
      return n != null && n.addSuffix ? t.one[0].replace("{{time}}", t.one[2]) : t.one[0].replace("{{time}}", t.one[1]);
    {
      const i = e % 10 === 1 && e % 100 !== 11;
      return n != null && n.addSuffix ? t.other[0].replace("{{time}}", i ? t.other[3] : t.other[4]).replace("{{count}}", String(e)) : t.other[0].replace("{{time}}", i ? t.other[1] : t.other[2]).replace("{{count}}", String(e));
    }
  };
}
const kve = {
  lessThanXSeconds: $n({
    one: ["mazāk par {{time}}", "sekundi", "sekundi"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm"
    ]
  }),
  xSeconds: $n({
    one: ["1 {{time}}", "sekunde", "sekundes"],
    other: [
      "{{count}} {{time}}",
      "sekunde",
      "sekundes",
      "sekundes",
      "sekundēm"
    ]
  }),
  halfAMinute: (t, e) => e != null && e.addSuffix ? "pusminūtes" : "pusminūte",
  lessThanXMinutes: $n({
    one: ["mazāk par {{time}}", "minūti", "minūti"],
    other: [
      "mazāk nekā {{count}} {{time}}",
      "minūte",
      "minūtes",
      "minūtes",
      "minūtēm"
    ]
  }),
  xMinutes: $n({
    one: ["1 {{time}}", "minūte", "minūtes"],
    other: ["{{count}} {{time}}", "minūte", "minūtes", "minūtes", "minūtēm"]
  }),
  aboutXHours: $n({
    one: ["apmēram 1 {{time}}", "stunda", "stundas"],
    other: [
      "apmēram {{count}} {{time}}",
      "stunda",
      "stundas",
      "stundas",
      "stundām"
    ]
  }),
  xHours: $n({
    one: ["1 {{time}}", "stunda", "stundas"],
    other: ["{{count}} {{time}}", "stunda", "stundas", "stundas", "stundām"]
  }),
  xDays: $n({
    one: ["1 {{time}}", "diena", "dienas"],
    other: ["{{count}} {{time}}", "diena", "dienas", "dienas", "dienām"]
  }),
  aboutXWeeks: $n({
    one: ["apmēram 1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "apmēram {{count}} {{time}}",
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  xWeeks: $n({
    one: ["1 {{time}}", "nedēļa", "nedēļas"],
    other: [
      "{{count}} {{time}}",
      // TODO
      "nedēļa",
      "nedēļu",
      "nedēļas",
      "nedēļām"
    ]
  }),
  aboutXMonths: $n({
    one: ["apmēram 1 {{time}}", "mēnesis", "mēneša"],
    other: [
      "apmēram {{count}} {{time}}",
      "mēnesis",
      "mēneši",
      "mēneša",
      "mēnešiem"
    ]
  }),
  xMonths: $n({
    one: ["1 {{time}}", "mēnesis", "mēneša"],
    other: ["{{count}} {{time}}", "mēnesis", "mēneši", "mēneša", "mēnešiem"]
  }),
  aboutXYears: $n({
    one: ["apmēram 1 {{time}}", "gads", "gada"],
    other: ["apmēram {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  xYears: $n({
    one: ["1 {{time}}", "gads", "gada"],
    other: ["{{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  overXYears: $n({
    one: ["ilgāk par 1 {{time}}", "gadu", "gadu"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  }),
  almostXYears: $n({
    one: ["gandrīz 1 {{time}}", "gads", "gada"],
    other: ["vairāk nekā {{count}} {{time}}", "gads", "gadi", "gada", "gadiem"]
  })
}, xve = (t, e, n) => {
  const i = kve[t](e, n);
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "pēc " + i : "pirms " + i : i;
}, _ve = {
  full: "EEEE, y. 'gada' d. MMMM",
  long: "y. 'gada' d. MMMM",
  medium: "dd.MM.y.",
  short: "dd.MM.y."
}, Mve = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Cve = {
  full: "{{date}} 'plkst.' {{time}}",
  long: "{{date}} 'plkst.' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Pve = {
  date: T({
    formats: _ve,
    defaultWidth: "full"
  }),
  time: T({
    formats: Mve,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Cve,
    defaultWidth: "full"
  })
}, C2 = [
  "svētdienā",
  "pirmdienā",
  "otrdienā",
  "trešdienā",
  "ceturtdienā",
  "piektdienā",
  "sestdienā"
], Sve = {
  lastWeek: (t, e, n) => Lt(t, e, n) ? "eeee 'plkst.' p" : "'Pagājušā " + C2[t.getDay()] + " plkst.' p",
  yesterday: "'Vakar plkst.' p",
  today: "'Šodien plkst.' p",
  tomorrow: "'Rīt plkst.' p",
  nextWeek: (t, e, n) => Lt(t, e, n) ? "eeee 'plkst.' p" : "'Nākamajā " + C2[t.getDay()] + " plkst.' p",
  other: "P"
}, Nve = (t, e, n, i) => {
  const r = Sve[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, $ve = {
  narrow: ["p.m.ē", "m.ē"],
  abbreviated: ["p. m. ē.", "m. ē."],
  wide: ["pirms mūsu ēras", "mūsu ērā"]
}, Dve = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmais ceturksnis",
    "otrais ceturksnis",
    "trešais ceturksnis",
    "ceturtais ceturksnis"
  ]
}, Eve = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. cet.", "2. cet.", "3. cet.", "4. cet."],
  wide: [
    "pirmajā ceturksnī",
    "otrajā ceturksnī",
    "trešajā ceturksnī",
    "ceturtajā ceturksnī"
  ]
}, Tve = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "marts",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "janvāris",
    "februāris",
    "marts",
    "aprīlis",
    "maijs",
    "jūnijs",
    "jūlijs",
    "augusts",
    "septembris",
    "oktobris",
    "novembris",
    "decembris"
  ]
}, Ove = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "janv.",
    "febr.",
    "martā",
    "apr.",
    "maijs",
    "jūn.",
    "jūl.",
    "aug.",
    "sept.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "janvārī",
    "februārī",
    "martā",
    "aprīlī",
    "maijā",
    "jūnijā",
    "jūlijā",
    "augustā",
    "septembrī",
    "oktobrī",
    "novembrī",
    "decembrī"
  ]
}, Wve = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd."
  ],
  wide: [
    "svētdiena",
    "pirmdiena",
    "otrdiena",
    "trešdiena",
    "ceturtdiena",
    "piektdiena",
    "sestdiena"
  ]
}, Ave = {
  narrow: ["S", "P", "O", "T", "C", "P", "S"],
  short: ["Sv", "P", "O", "T", "C", "Pk", "S"],
  abbreviated: [
    "svētd.",
    "pirmd.",
    "otrd.",
    "trešd.",
    "ceturtd.",
    "piektd.",
    "sestd."
  ],
  wide: [
    "svētdienā",
    "pirmdienā",
    "otrdienā",
    "trešdienā",
    "ceturtdienā",
    "piektdienā",
    "sestdienā"
  ]
}, Lve = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "diena",
    evening: "vakars",
    night: "nakts"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rīts",
    afternoon: "pēcpusd.",
    evening: "vakars",
    night: "nakts"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnakts",
    noon: "pusdienlaiks",
    morning: "rīts",
    afternoon: "pēcpusdiena",
    evening: "vakars",
    night: "nakts"
  }
}, Ive = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "dienā",
    evening: "vakarā",
    night: "naktī"
  },
  abbreviated: {
    am: "am",
    pm: "pm",
    midnight: "pusn.",
    noon: "pusd.",
    morning: "rītā",
    afternoon: "pēcpusd.",
    evening: "vakarā",
    night: "naktī"
  },
  wide: {
    am: "am",
    pm: "pm",
    midnight: "pusnaktī",
    noon: "pusdienlaikā",
    morning: "rītā",
    afternoon: "pēcpusdienā",
    evening: "vakarā",
    night: "naktī"
  }
}, Rve = (t, e) => Number(t) + ".", jve = {
  ordinalNumber: Rve,
  era: C({
    values: $ve,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Dve,
    defaultWidth: "wide",
    formattingValues: Eve,
    defaultFormattingWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Tve,
    defaultWidth: "wide",
    formattingValues: Ove,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: Wve,
    defaultWidth: "wide",
    formattingValues: Ave,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: Lve,
    defaultWidth: "wide",
    formattingValues: Ive,
    defaultFormattingWidth: "wide"
  })
}, Fve = /^(\d+)\./i, zve = /\d+/i, Vve = {
  narrow: /^(p\.m\.ē|m\.ē)/i,
  abbreviated: /^(p\. m\. ē\.|m\. ē\.)/i,
  wide: /^(pirms mūsu ēras|mūsu ērā)/i
}, Hve = {
  any: [/^p/i, /^m/i]
}, Bve = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](\. cet\.)/i,
  wide: /^(pirma(is|jā)|otra(is|jā)|treša(is|jā)|ceturta(is|jā)) ceturksn(is|ī)/i
}, qve = {
  narrow: [/^1/i, /^2/i, /^3/i, /^4/i],
  abbreviated: [/^1/i, /^2/i, /^3/i, /^4/i],
  wide: [/^p/i, /^o/i, /^t/i, /^c/i]
}, Gve = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(janv\.|febr\.|marts|apr\.|maijs|jūn\.|jūl\.|aug\.|sept\.|okt\.|nov\.|dec\.)/i,
  wide: /^(janvār(is|ī)|februār(is|ī)|mart[sā]|aprīl(is|ī)|maij[sā]|jūnij[sā]|jūlij[sā]|august[sā]|septembr(is|ī)|oktobr(is|ī)|novembr(is|ī)|decembr(is|ī))/i
}, Xve = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jūn/i,
    /^jūl/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Yve = {
  narrow: /^[spotc]/i,
  short: /^(sv|pi|o|t|c|pk|s)/i,
  abbreviated: /^(svētd\.|pirmd\.|otrd.\|trešd\.|ceturtd\.|piektd\.|sestd\.)/i,
  wide: /^(svētdien(a|ā)|pirmdien(a|ā)|otrdien(a|ā)|trešdien(a|ā)|ceturtdien(a|ā)|piektdien(a|ā)|sestdien(a|ā))/i
}, Kve = {
  narrow: [/^s/i, /^p/i, /^o/i, /^t/i, /^c/i, /^p/i, /^s/i],
  any: [/^sv/i, /^pi/i, /^o/i, /^t/i, /^c/i, /^p/i, /^se/i]
}, Uve = {
  narrow: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|dien(a|ā)|vakar(s|ā)|nakt(s|ī))/,
  abbreviated: /^(am|pm|pusn\.|pusd\.|rīt(s|ā)|pēcpusd\.|vakar(s|ā)|nakt(s|ī))/,
  wide: /^(am|pm|pusnakt(s|ī)|pusdienlaik(s|ā)|rīt(s|ā)|pēcpusdien(a|ā)|vakar(s|ā)|nakt(s|ī))/i
}, Jve = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^pusn/i,
    noon: /^pusd/i,
    morning: /^r/i,
    afternoon: /^(d|pēc)/i,
    evening: /^v/i,
    night: /^n/i
  }
}, Qve = {
  ordinalNumber: he({
    matchPattern: Fve,
    parsePattern: zve,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Vve,
    defaultMatchWidth: "wide",
    parsePatterns: Hve,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Bve,
    defaultMatchWidth: "wide",
    parsePatterns: qve,
    defaultParseWidth: "wide",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Gve,
    defaultMatchWidth: "wide",
    parsePatterns: Xve,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Yve,
    defaultMatchWidth: "wide",
    parsePatterns: Kve,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Uve,
    defaultMatchWidth: "wide",
    parsePatterns: Jve,
    defaultParseWidth: "any"
  })
}, Zve = {
  code: "lv",
  formatDistance: xve,
  formatLong: Pve,
  formatRelative: Nve,
  localize: jve,
  match: Qve,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, e0e = {
  lessThanXSeconds: {
    one: "помалку од секунда",
    other: "помалку од {{count}} секунди"
  },
  xSeconds: {
    one: "1 секунда",
    other: "{{count}} секунди"
  },
  halfAMinute: "половина минута",
  lessThanXMinutes: {
    one: "помалку од минута",
    other: "помалку од {{count}} минути"
  },
  xMinutes: {
    one: "1 минута",
    other: "{{count}} минути"
  },
  aboutXHours: {
    one: "околу 1 час",
    other: "околу {{count}} часа"
  },
  xHours: {
    one: "1 час",
    other: "{{count}} часа"
  },
  xDays: {
    one: "1 ден",
    other: "{{count}} дена"
  },
  aboutXWeeks: {
    one: "околу 1 недела",
    other: "околу {{count}} месеци"
  },
  xWeeks: {
    one: "1 недела",
    other: "{{count}} недели"
  },
  aboutXMonths: {
    one: "околу 1 месец",
    other: "околу {{count}} недели"
  },
  xMonths: {
    one: "1 месец",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: "околу 1 година",
    other: "околу {{count}} години"
  },
  xYears: {
    one: "1 година",
    other: "{{count}} години"
  },
  overXYears: {
    one: "повеќе од 1 година",
    other: "повеќе од {{count}} години"
  },
  almostXYears: {
    one: "безмалку 1 година",
    other: "безмалку {{count}} години"
  }
}, t0e = (t, e, n) => {
  let i;
  const r = e0e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "за " + i : "пред " + i : i;
}, n0e = {
  full: "EEEE, dd MMMM yyyy",
  long: "dd MMMM yyyy",
  medium: "dd MMM yyyy",
  short: "dd/MM/yyyy"
}, i0e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "H:mm"
}, r0e = {
  any: "{{date}} {{time}}"
}, a0e = {
  date: T({
    formats: n0e,
    defaultWidth: "full"
  }),
  time: T({
    formats: i0e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: r0e,
    defaultWidth: "any"
  })
}, m0 = [
  "недела",
  "понеделник",
  "вторник",
  "среда",
  "четврток",
  "петок",
  "сабота"
];
function o0e(t) {
  const e = m0[t];
  switch (t) {
    case 0:
    case 3:
    case 6:
      return "'минатата " + e + " во' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'минатиот " + e + " во' p";
  }
}
function P2(t) {
  const e = m0[t];
  switch (t) {
    case 0:
    case 3:
    case 6:
      return "'ова " + e + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'овој " + e + " вo' p";
  }
}
function s0e(t) {
  const e = m0[t];
  switch (t) {
    case 0:
    case 3:
    case 6:
      return "'следната " + e + " вo' p";
    case 1:
    case 2:
    case 4:
    case 5:
      return "'следниот " + e + " вo' p";
  }
}
const l0e = {
  lastWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? P2(i) : o0e(i);
  },
  yesterday: "'вчера во' p",
  today: "'денес во' p",
  tomorrow: "'утре во' p",
  nextWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? P2(i) : s0e(i);
  },
  other: "P"
}, d0e = (t, e, n, i) => {
  const r = l0e[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, c0e = {
  narrow: ["пр.н.е.", "н.е."],
  abbreviated: ["пред н. е.", "н. е."],
  wide: ["пред нашата ера", "нашата ера"]
}, u0e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-ви кв.", "2-ри кв.", "3-ти кв.", "4-ти кв."],
  wide: ["1-ви квартал", "2-ри квартал", "3-ти квартал", "4-ти квартал"]
}, f0e = {
  abbreviated: [
    "јан",
    "фев",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "септ",
    "окт",
    "ноем",
    "дек"
  ],
  wide: [
    "јануари",
    "февруари",
    "март",
    "април",
    "мај",
    "јуни",
    "јули",
    "август",
    "септември",
    "октомври",
    "ноември",
    "декември"
  ]
}, m0e = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["не", "по", "вт", "ср", "че", "пе", "са"],
  abbreviated: ["нед", "пон", "вто", "сре", "чет", "пет", "саб"],
  wide: [
    "недела",
    "понеделник",
    "вторник",
    "среда",
    "четврток",
    "петок",
    "сабота"
  ]
}, h0e = {
  wide: {
    am: "претпладне",
    pm: "попладне",
    midnight: "полноќ",
    noon: "напладне",
    morning: "наутро",
    afternoon: "попладне",
    evening: "навечер",
    night: "ноќе"
  }
}, p0e = (t, e) => {
  const n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
        return n + "-ви";
      case 2:
        return n + "-ри";
      case 7:
      case 8:
        return n + "-ми";
    }
  return n + "-ти";
}, g0e = {
  ordinalNumber: p0e,
  era: C({
    values: c0e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: u0e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: f0e,
    defaultWidth: "wide"
  }),
  day: C({
    values: m0e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: h0e,
    defaultWidth: "wide"
  })
}, y0e = /^(\d+)(-?[врмт][и])?/i, v0e = /\d+/i, b0e = {
  narrow: /^((пр)?н\.?\s?е\.?)/i,
  abbreviated: /^((пр)?н\.?\s?е\.?)/i,
  wide: /^(пред нашата ера|нашата ера)/i
}, w0e = {
  any: [/^п/i, /^н/i]
}, k0e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[врт]?и?)? кв.?/i,
  wide: /^[1234](-?[врт]?и?)? квартал/i
}, x0e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _0e = {
  narrow: /^[нпвсч]/i,
  short: /^(не|по|вт|ср|че|пе|са)/i,
  abbreviated: /^(нед|пон|вто|сре|чет|пет|саб)/i,
  wide: /^(недела|понеделник|вторник|среда|четврток|петок|сабота)/i
}, M0e = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н[ед]/i, /^п[он]/i, /^вт/i, /^ср/i, /^ч[ет]/i, /^п[ет]/i, /^с[аб]/i]
}, C0e = {
  abbreviated: /^(јан|фев|мар|апр|мај|јун|јул|авг|сеп|окт|ноем|дек)/i,
  wide: /^(јануари|февруари|март|април|мај|јуни|јули|август|септември|октомври|ноември|декември)/i
}, P0e = {
  any: [
    /^ја/i,
    /^Ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^ав/i,
    /^се/i,
    /^окт/i,
    /^но/i,
    /^де/i
  ]
}, S0e = {
  any: /^(претп|попл|полноќ|утро|пладне|вечер|ноќ)/i
}, N0e = {
  any: {
    am: /претпладне/i,
    pm: /попладне/i,
    midnight: /полноќ/i,
    noon: /напладне/i,
    morning: /наутро/i,
    afternoon: /попладне/i,
    evening: /навечер/i,
    night: /ноќе/i
  }
}, $0e = {
  ordinalNumber: he({
    matchPattern: y0e,
    parsePattern: v0e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: b0e,
    defaultMatchWidth: "wide",
    parsePatterns: w0e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: k0e,
    defaultMatchWidth: "wide",
    parsePatterns: x0e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: C0e,
    defaultMatchWidth: "wide",
    parsePatterns: P0e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: _0e,
    defaultMatchWidth: "wide",
    parsePatterns: M0e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: S0e,
    defaultMatchWidth: "any",
    parsePatterns: N0e,
    defaultParseWidth: "any"
  })
}, D0e = {
  code: "mk",
  formatDistance: t0e,
  formatLong: a0e,
  formatRelative: d0e,
  localize: g0e,
  match: $0e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, E0e = {
  lessThanXSeconds: {
    one: "секунд хүрэхгүй",
    other: "{{count}} секунд хүрэхгүй"
  },
  xSeconds: {
    one: "1 секунд",
    other: "{{count}} секунд"
  },
  halfAMinute: "хагас минут",
  lessThanXMinutes: {
    one: "минут хүрэхгүй",
    other: "{{count}} минут хүрэхгүй"
  },
  xMinutes: {
    one: "1 минут",
    other: "{{count}} минут"
  },
  aboutXHours: {
    one: "ойролцоогоор 1 цаг",
    other: "ойролцоогоор {{count}} цаг"
  },
  xHours: {
    one: "1 цаг",
    other: "{{count}} цаг"
  },
  xDays: {
    one: "1 өдөр",
    other: "{{count}} өдөр"
  },
  aboutXWeeks: {
    one: "ойролцоогоор 1 долоо хоног",
    other: "ойролцоогоор {{count}} долоо хоног"
  },
  xWeeks: {
    one: "1 долоо хоног",
    other: "{{count}} долоо хоног"
  },
  aboutXMonths: {
    one: "ойролцоогоор 1 сар",
    other: "ойролцоогоор {{count}} сар"
  },
  xMonths: {
    one: "1 сар",
    other: "{{count}} сар"
  },
  aboutXYears: {
    one: "ойролцоогоор 1 жил",
    other: "ойролцоогоор {{count}} жил"
  },
  xYears: {
    one: "1 жил",
    other: "{{count}} жил"
  },
  overXYears: {
    one: "1 жил гаран",
    other: "{{count}} жил гаран"
  },
  almostXYears: {
    one: "бараг 1 жил",
    other: "бараг {{count}} жил"
  }
}, T0e = (t, e, n) => {
  let i;
  const r = E0e[t];
  if (typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix) {
    const a = i.split(" "), o = a.pop();
    switch (i = a.join(" "), o) {
      case "секунд":
        i += " секундийн";
        break;
      case "минут":
        i += " минутын";
        break;
      case "цаг":
        i += " цагийн";
        break;
      case "өдөр":
        i += " өдрийн";
        break;
      case "сар":
        i += " сарын";
        break;
      case "жил":
        i += " жилийн";
        break;
      case "хоног":
        i += " хоногийн";
        break;
      case "гаран":
        i += " гараны";
        break;
      case "хүрэхгүй":
        i += " хүрэхгүй хугацааны";
        break;
      default:
        i += o + "-н";
    }
    return n.comparison && n.comparison > 0 ? i + " дараа" : i + " өмнө";
  }
  return i;
}, O0e = {
  full: "y 'оны' MMMM'ын' d, EEEE 'гараг'",
  long: "y 'оны' MMMM'ын' d",
  medium: "y 'оны' MMM'ын' d",
  short: "y.MM.dd"
}, W0e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, A0e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, L0e = {
  date: T({
    formats: O0e,
    defaultWidth: "full"
  }),
  time: T({
    formats: W0e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: A0e,
    defaultWidth: "full"
  })
}, I0e = {
  lastWeek: "'өнгөрсөн' eeee 'гарагийн' p 'цагт'",
  yesterday: "'өчигдөр' p 'цагт'",
  today: "'өнөөдөр' p 'цагт'",
  tomorrow: "'маргааш' p 'цагт'",
  nextWeek: "'ирэх' eeee 'гарагийн' p 'цагт'",
  other: "P"
}, R0e = (t, e, n, i) => I0e[t], j0e = {
  narrow: ["НТӨ", "НТ"],
  abbreviated: ["НТӨ", "НТ"],
  wide: ["нийтийн тооллын өмнөх", "нийтийн тооллын"]
}, F0e = {
  narrow: ["I", "II", "III", "IV"],
  abbreviated: ["I улирал", "II улирал", "III улирал", "IV улирал"],
  wide: ["1-р улирал", "2-р улирал", "3-р улирал", "4-р улирал"]
}, z0e = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII"
  ],
  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар"
  ],
  wide: [
    "Нэгдүгээр сар",
    "Хоёрдугаар сар",
    "Гуравдугаар сар",
    "Дөрөвдүгээр сар",
    "Тавдугаар сар",
    "Зургаадугаар сар",
    "Долоодугаар сар",
    "Наймдугаар сар",
    "Есдүгээр сар",
    "Аравдугаар сар",
    "Арваннэгдүгээр сар",
    "Арван хоёрдугаар сар"
  ]
}, V0e = {
  narrow: [
    "I",
    "II",
    "III",
    "IV",
    "V",
    "VI",
    "VII",
    "VIII",
    "IX",
    "X",
    "XI",
    "XII"
  ],
  abbreviated: [
    "1-р сар",
    "2-р сар",
    "3-р сар",
    "4-р сар",
    "5-р сар",
    "6-р сар",
    "7-р сар",
    "8-р сар",
    "9-р сар",
    "10-р сар",
    "11-р сар",
    "12-р сар"
  ],
  wide: [
    "нэгдүгээр сар",
    "хоёрдугаар сар",
    "гуравдугаар сар",
    "дөрөвдүгээр сар",
    "тавдугаар сар",
    "зургаадугаар сар",
    "долоодугаар сар",
    "наймдугаар сар",
    "есдүгээр сар",
    "аравдугаар сар",
    "арваннэгдүгээр сар",
    "арван хоёрдугаар сар"
  ]
}, H0e = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["Ням", "Даваа", "Мягмар", "Лхагва", "Пүрэв", "Баасан", "Бямба"]
}, B0e = {
  narrow: ["Н", "Д", "М", "Л", "П", "Б", "Б"],
  short: ["Ня", "Да", "Мя", "Лх", "Пү", "Ба", "Бя"],
  abbreviated: ["Ням", "Дав", "Мяг", "Лха", "Пүр", "Баа", "Бям"],
  wide: ["ням", "даваа", "мягмар", "лхагва", "пүрэв", "баасан", "бямба"]
}, q0e = {
  narrow: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  abbreviated: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  },
  wide: {
    am: "ү.ө.",
    pm: "ү.х.",
    midnight: "шөнө дунд",
    noon: "үд дунд",
    morning: "өглөө",
    afternoon: "өдөр",
    evening: "орой",
    night: "шөнө"
  }
}, G0e = (t, e) => String(t), X0e = {
  ordinalNumber: G0e,
  era: C({
    values: j0e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: F0e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: z0e,
    defaultWidth: "wide",
    formattingValues: V0e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: H0e,
    defaultWidth: "wide",
    formattingValues: B0e,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: q0e,
    defaultWidth: "wide"
  })
}, Y0e = /\d+/i, K0e = /\d+/i, U0e = {
  narrow: /^(нтө|нт)/i,
  abbreviated: /^(нтө|нт)/i,
  wide: /^(нийтийн тооллын өмнө|нийтийн тооллын)/i
}, J0e = {
  any: [/^(нтө|нийтийн тооллын өмнө)/i, /^(нт|нийтийн тооллын)/i]
}, Q0e = {
  narrow: /^(iv|iii|ii|i)/i,
  abbreviated: /^(iv|iii|ii|i) улирал/i,
  wide: /^[1-4]-р улирал/i
}, Z0e = {
  any: [/^(i(\s|$)|1)/i, /^(ii(\s|$)|2)/i, /^(iii(\s|$)|3)/i, /^(iv(\s|$)|4)/i]
}, ebe = {
  narrow: /^(xii|xi|x|ix|viii|vii|vi|v|iv|iii|ii|i)/i,
  abbreviated: /^(1-р сар|2-р сар|3-р сар|4-р сар|5-р сар|6-р сар|7-р сар|8-р сар|9-р сар|10-р сар|11-р сар|12-р сар)/i,
  wide: /^(нэгдүгээр сар|хоёрдугаар сар|гуравдугаар сар|дөрөвдүгээр сар|тавдугаар сар|зургаадугаар сар|долоодугаар сар|наймдугаар сар|есдүгээр сар|аравдугаар сар|арван нэгдүгээр сар|арван хоёрдугаар сар)/i
}, tbe = {
  narrow: [
    /^i$/i,
    /^ii$/i,
    /^iii$/i,
    /^iv$/i,
    /^v$/i,
    /^vi$/i,
    /^vii$/i,
    /^viii$/i,
    /^ix$/i,
    /^x$/i,
    /^xi$/i,
    /^xii$/i
  ],
  any: [
    /^(1|нэгдүгээр)/i,
    /^(2|хоёрдугаар)/i,
    /^(3|гуравдугаар)/i,
    /^(4|дөрөвдүгээр)/i,
    /^(5|тавдугаар)/i,
    /^(6|зургаадугаар)/i,
    /^(7|долоодугаар)/i,
    /^(8|наймдугаар)/i,
    /^(9|есдүгээр)/i,
    /^(10|аравдугаар)/i,
    /^(11|арван нэгдүгээр)/i,
    /^(12|арван хоёрдугаар)/i
  ]
}, nbe = {
  narrow: /^[ндмлпбб]/i,
  short: /^(ня|да|мя|лх|пү|ба|бя)/i,
  abbreviated: /^(ням|дав|мяг|лха|пүр|баа|бям)/i,
  wide: /^(ням|даваа|мягмар|лхагва|пүрэв|баасан|бямба)/i
}, ibe = {
  narrow: [/^н/i, /^д/i, /^м/i, /^л/i, /^п/i, /^б/i, /^б/i],
  any: [/^ня/i, /^да/i, /^мя/i, /^лх/i, /^пү/i, /^ба/i, /^бя/i]
}, rbe = {
  narrow: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i,
  any: /^(ү\.ө\.|ү\.х\.|шөнө дунд|үд дунд|өглөө|өдөр|орой|шөнө)/i
}, abe = {
  any: {
    am: /^ү\.ө\./i,
    pm: /^ү\.х\./i,
    midnight: /^шөнө дунд/i,
    noon: /^үд дунд/i,
    morning: /өглөө/i,
    afternoon: /өдөр/i,
    evening: /орой/i,
    night: /шөнө/i
  }
}, obe = {
  ordinalNumber: he({
    matchPattern: Y0e,
    parsePattern: K0e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: U0e,
    defaultMatchWidth: "wide",
    parsePatterns: J0e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Q0e,
    defaultMatchWidth: "wide",
    parsePatterns: Z0e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: ebe,
    defaultMatchWidth: "wide",
    parsePatterns: tbe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: nbe,
    defaultMatchWidth: "wide",
    parsePatterns: ibe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: rbe,
    defaultMatchWidth: "any",
    parsePatterns: abe,
    defaultParseWidth: "any"
  })
}, sbe = {
  code: "mn",
  formatDistance: T0e,
  formatLong: L0e,
  formatRelative: R0e,
  localize: X0e,
  match: obe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, lbe = {
  lessThanXSeconds: {
    one: "kurang dari 1 saat",
    other: "kurang dari {{count}} saat"
  },
  xSeconds: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  halfAMinute: "setengah minit",
  lessThanXMinutes: {
    one: "kurang dari 1 minit",
    other: "kurang dari {{count}} minit"
  },
  xMinutes: {
    one: "1 minit",
    other: "{{count}} minit"
  },
  aboutXHours: {
    one: "sekitar 1 jam",
    other: "sekitar {{count}} jam"
  },
  xHours: {
    one: "1 jam",
    other: "{{count}} jam"
  },
  xDays: {
    one: "1 hari",
    other: "{{count}} hari"
  },
  aboutXWeeks: {
    one: "sekitar 1 minggu",
    other: "sekitar {{count}} minggu"
  },
  xWeeks: {
    one: "1 minggu",
    other: "{{count}} minggu"
  },
  aboutXMonths: {
    one: "sekitar 1 bulan",
    other: "sekitar {{count}} bulan"
  },
  xMonths: {
    one: "1 bulan",
    other: "{{count}} bulan"
  },
  aboutXYears: {
    one: "sekitar 1 tahun",
    other: "sekitar {{count}} tahun"
  },
  xYears: {
    one: "1 tahun",
    other: "{{count}} tahun"
  },
  overXYears: {
    one: "lebih dari 1 tahun",
    other: "lebih dari {{count}} tahun"
  },
  almostXYears: {
    one: "hampir 1 tahun",
    other: "hampir {{count}} tahun"
  }
}, dbe = (t, e, n) => {
  let i;
  const r = lbe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "dalam masa " + i : i + " yang lalu" : i;
}, cbe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "d/M/yyyy"
}, ube = {
  full: "HH.mm.ss",
  long: "HH.mm.ss",
  medium: "HH.mm",
  short: "HH.mm"
}, fbe = {
  full: "{{date}} 'pukul' {{time}}",
  long: "{{date}} 'pukul' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, mbe = {
  date: T({
    formats: cbe,
    defaultWidth: "full"
  }),
  time: T({
    formats: ube,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: fbe,
    defaultWidth: "full"
  })
}, hbe = {
  lastWeek: "eeee 'lepas pada jam' p",
  yesterday: "'Semalam pada jam' p",
  today: "'Hari ini pada jam' p",
  tomorrow: "'Esok pada jam' p",
  nextWeek: "eeee 'pada jam' p",
  other: "P"
}, pbe = (t, e, n, i) => hbe[t], gbe = {
  narrow: ["SM", "M"],
  abbreviated: ["SM", "M"],
  wide: ["Sebelum Masihi", "Masihi"]
}, ybe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["S1", "S2", "S3", "S4"],
  wide: ["Suku pertama", "Suku kedua", "Suku ketiga", "Suku keempat"]
}, vbe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "O", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Feb",
    "Mac",
    "Apr",
    "Mei",
    "Jun",
    "Jul",
    "Ogo",
    "Sep",
    "Okt",
    "Nov",
    "Dis"
  ],
  wide: [
    "Januari",
    "Februari",
    "Mac",
    "April",
    "Mei",
    "Jun",
    "Julai",
    "Ogos",
    "September",
    "Oktober",
    "November",
    "Disember"
  ]
}, bbe = {
  narrow: ["A", "I", "S", "R", "K", "J", "S"],
  short: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  abbreviated: ["Ahd", "Isn", "Sel", "Rab", "Kha", "Jum", "Sab"],
  wide: ["Ahad", "Isnin", "Selasa", "Rabu", "Khamis", "Jumaat", "Sabtu"]
}, wbe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tgh malam",
    noon: "tgh hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, kbe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "tengah malam",
    noon: "tengah hari",
    morning: "pagi",
    afternoon: "tengah hari",
    evening: "petang",
    night: "malam"
  }
}, xbe = (t, e) => "ke-" + Number(t), _be = {
  ordinalNumber: xbe,
  era: C({
    values: gbe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: ybe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: vbe,
    defaultWidth: "wide"
  }),
  day: C({
    values: bbe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: wbe,
    defaultWidth: "wide",
    formattingValues: kbe,
    defaultFormattingWidth: "wide"
  })
}, Mbe = /^ke-(\d+)?/i, Cbe = /petama|\d+/i, Pbe = {
  narrow: /^(sm|m)/i,
  abbreviated: /^(s\.?\s?m\.?|m\.?)/i,
  wide: /^(sebelum masihi|masihi)/i
}, Sbe = {
  any: [/^s/i, /^(m)/i]
}, Nbe = {
  narrow: /^[1234]/i,
  abbreviated: /^S[1234]/i,
  wide: /Suku (pertama|kedua|ketiga|keempat)/i
}, $be = {
  any: [/pertama|1/i, /kedua|2/i, /ketiga|3/i, /keempat|4/i]
}, Dbe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mac|apr|mei|jun|jul|ogo|sep|okt|nov|dis)/i,
  wide: /^(januari|februari|mac|april|mei|jun|julai|ogos|september|oktober|november|disember)/i
}, Ebe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^o/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^ma/i,
    /^ap/i,
    /^me/i,
    /^jun/i,
    /^jul/i,
    /^og/i,
    /^s/i,
    /^ok/i,
    /^n/i,
    /^d/i
  ]
}, Tbe = {
  narrow: /^[aisrkj]/i,
  short: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  abbreviated: /^(ahd|isn|sel|rab|kha|jum|sab)/i,
  wide: /^(ahad|isnin|selasa|rabu|khamis|jumaat|sabtu)/i
}, Obe = {
  narrow: [/^a/i, /^i/i, /^s/i, /^r/i, /^k/i, /^j/i, /^s/i],
  any: [/^a/i, /^i/i, /^se/i, /^r/i, /^k/i, /^j/i, /^sa/i]
}, Wbe = {
  narrow: /^(am|pm|tengah malam|tengah hari|pagi|petang|malam)/i,
  any: /^([ap]\.?\s?m\.?|tengah malam|tengah hari|pagi|petang|malam)/i
}, Abe = {
  any: {
    am: /^a/i,
    pm: /^pm/i,
    midnight: /^tengah m/i,
    noon: /^tengah h/i,
    morning: /pa/i,
    afternoon: /tengah h/i,
    evening: /pe/i,
    night: /m/i
  }
}, Lbe = {
  ordinalNumber: he({
    matchPattern: Mbe,
    parsePattern: Cbe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Pbe,
    defaultMatchWidth: "wide",
    parsePatterns: Sbe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Nbe,
    defaultMatchWidth: "wide",
    parsePatterns: $be,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Dbe,
    defaultMatchWidth: "wide",
    parsePatterns: Ebe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Tbe,
    defaultMatchWidth: "wide",
    parsePatterns: Obe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Wbe,
    defaultMatchWidth: "any",
    parsePatterns: Abe,
    defaultParseWidth: "any"
  })
}, Ibe = {
  code: "ms",
  formatDistance: dbe,
  formatLong: mbe,
  formatRelative: pbe,
  localize: _be,
  match: Lbe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, Rbe = {
  lessThanXSeconds: {
    one: "inqas minn sekonda",
    other: "inqas minn {{count}} sekondi"
  },
  xSeconds: {
    one: "sekonda",
    other: "{{count}} sekondi"
  },
  halfAMinute: "nofs minuta",
  lessThanXMinutes: {
    one: "inqas minn minuta",
    other: "inqas minn {{count}} minuti"
  },
  xMinutes: {
    one: "minuta",
    other: "{{count}} minuti"
  },
  aboutXHours: {
    one: "madwar siegħa",
    other: "madwar {{count}} siegħat"
  },
  xHours: {
    one: "siegħa",
    other: "{{count}} siegħat"
  },
  xDays: {
    one: "ġurnata",
    other: "{{count}} ġranet"
  },
  aboutXWeeks: {
    one: "madwar ġimgħa",
    other: "madwar {{count}} ġimgħat"
  },
  xWeeks: {
    one: "ġimgħa",
    other: "{{count}} ġimgħat"
  },
  aboutXMonths: {
    one: "madwar xahar",
    other: "madwar {{count}} xhur"
  },
  xMonths: {
    one: "xahar",
    other: "{{count}} xhur"
  },
  aboutXYears: {
    one: "madwar sena",
    two: "madwar sentejn",
    other: "madwar {{count}} snin"
  },
  xYears: {
    one: "sena",
    two: "sentejn",
    other: "{{count}} snin"
  },
  overXYears: {
    one: "aktar minn sena",
    two: "aktar minn sentejn",
    other: "aktar minn {{count}} snin"
  },
  almostXYears: {
    one: "kważi sena",
    two: "kważi sentejn",
    other: "kważi {{count}} snin"
  }
}, jbe = (t, e, n) => {
  let i;
  const r = Rbe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : e === 2 && r.two ? i = r.two : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "f'" + i : i + " ilu" : i;
}, Fbe = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd/MM/yyyy"
}, zbe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Vbe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Hbe = {
  date: T({
    formats: Fbe,
    defaultWidth: "full"
  }),
  time: T({
    formats: zbe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Vbe,
    defaultWidth: "full"
  })
}, Bbe = {
  lastWeek: "eeee 'li għadda' 'fil-'p",
  yesterday: "'Il-bieraħ fil-'p",
  today: "'Illum fil-'p",
  tomorrow: "'Għada fil-'p",
  nextWeek: "eeee 'fil-'p",
  other: "P"
}, qbe = (t, e, n, i) => Bbe[t], Gbe = {
  narrow: ["Q", "W"],
  abbreviated: ["QK", "WK"],
  wide: ["qabel Kristu", "wara Kristu"]
}, Xbe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1. kwart", "2. kwart", "3. kwart", "4. kwart"]
}, Ybe = {
  narrow: ["J", "F", "M", "A", "M", "Ġ", "L", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Jan",
    "Fra",
    "Mar",
    "Apr",
    "Mej",
    "Ġun",
    "Lul",
    "Aww",
    "Set",
    "Ott",
    "Nov",
    "Diċ"
  ],
  wide: [
    "Jannar",
    "Frar",
    "Marzu",
    "April",
    "Mejju",
    "Ġunju",
    "Lulju",
    "Awwissu",
    "Settembru",
    "Ottubru",
    "Novembru",
    "Diċembru"
  ]
}, Kbe = {
  narrow: ["Ħ", "T", "T", "E", "Ħ", "Ġ", "S"],
  short: ["Ħa", "Tn", "Tl", "Er", "Ħa", "Ġi", "Si"],
  abbreviated: ["Ħad", "Tne", "Tli", "Erb", "Ħam", "Ġim", "Sib"],
  wide: [
    "Il-Ħadd",
    "It-Tnejn",
    "It-Tlieta",
    "L-Erbgħa",
    "Il-Ħamis",
    "Il-Ġimgħa",
    "Is-Sibt"
  ]
}, Ube = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "nofsillejl",
    noon: "nofsinhar",
    morning: "għodwa",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "lejl"
  }
}, Jbe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "f'nofsillejl",
    noon: "f'nofsinhar",
    morning: "filgħodu",
    afternoon: "wara nofsinhar",
    evening: "filgħaxija",
    night: "billejl"
  }
}, Qbe = (t, e) => Number(t) + "º", Zbe = {
  ordinalNumber: Qbe,
  era: C({
    values: Gbe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Xbe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Ybe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Kbe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Ube,
    defaultWidth: "wide",
    formattingValues: Jbe,
    defaultFormattingWidth: "wide"
  })
}, ewe = /^(\d+)(º)?/i, twe = /\d+/i, nwe = {
  narrow: /^(q|w)/i,
  abbreviated: /^(q\.?\s?k\.?|b\.?\s?c\.?\s?e\.?|w\.?\s?k\.?)/i,
  wide: /^(qabel kristu|before common era|wara kristu|common era)/i
}, iwe = {
  any: [/^(q|b)/i, /^(w|c)/i]
}, rwe = {
  narrow: /^[1234]/i,
  abbreviated: /^k[1234]/i,
  wide: /^[1234](\.)? kwart/i
}, awe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, owe = {
  narrow: /^[jfmaglsond]/i,
  abbreviated: /^(jan|fra|mar|apr|mej|ġun|lul|aww|set|ott|nov|diċ)/i,
  wide: /^(jannar|frar|marzu|april|mejju|ġunju|lulju|awwissu|settembru|ottubru|novembru|diċembru)/i
}, swe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^ġ/i,
    /^l/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mej/i,
    /^ġ/i,
    /^l/i,
    /^aw/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, lwe = {
  narrow: /^[ħteġs]/i,
  short: /^(ħa|tn|tl|er|ħa|ġi|si)/i,
  abbreviated: /^(ħad|tne|tli|erb|ħam|ġim|sib)/i,
  wide: /^(il-ħadd|it-tnejn|it-tlieta|l-erbgħa|il-ħamis|il-ġimgħa|is-sibt)/i
}, dwe = {
  narrow: [/^ħ/i, /^t/i, /^t/i, /^e/i, /^ħ/i, /^ġ/i, /^s/i],
  any: [
    /^(il-)?ħad/i,
    /^(it-)?tn/i,
    /^(it-)?tl/i,
    /^(l-)?er/i,
    /^(il-)?ham/i,
    /^(il-)?ġi/i,
    /^(is-)?si/i
  ]
}, cwe = {
  narrow: /^(a|p|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i,
  any: /^([ap]\.?\s?m\.?|f'nofsillejl|f'nofsinhar|(ta') (għodwa|wara nofsinhar|filgħaxija|lejl))/i
}, uwe = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^f'nofsillejl/i,
    noon: /^f'nofsinhar/i,
    morning: /għodwa/i,
    afternoon: /wara(\s.*)nofsinhar/i,
    evening: /filgħaxija/i,
    night: /lejl/i
  }
}, fwe = {
  ordinalNumber: he({
    matchPattern: ewe,
    parsePattern: twe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: nwe,
    defaultMatchWidth: "wide",
    parsePatterns: iwe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: rwe,
    defaultMatchWidth: "wide",
    parsePatterns: awe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: owe,
    defaultMatchWidth: "wide",
    parsePatterns: swe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: lwe,
    defaultMatchWidth: "wide",
    parsePatterns: dwe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: cwe,
    defaultMatchWidth: "any",
    parsePatterns: uwe,
    defaultParseWidth: "any"
  })
}, mwe = {
  code: "mt",
  formatDistance: jbe,
  formatLong: Hbe,
  formatRelative: qbe,
  localize: Zbe,
  match: fwe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, hwe = {
  lessThanXSeconds: {
    one: "mindre enn ett sekund",
    other: "mindre enn {{count}} sekunder"
  },
  xSeconds: {
    one: "ett sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "et halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn ett minutt",
    other: "mindre enn {{count}} minutter"
  },
  xMinutes: {
    one: "ett minutt",
    other: "{{count}} minutter"
  },
  aboutXHours: {
    one: "omtrent en time",
    other: "omtrent {{count}} timer"
  },
  xHours: {
    one: "en time",
    other: "{{count}} timer"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dager"
  },
  aboutXWeeks: {
    one: "omtrent en uke",
    other: "omtrent {{count}} uker"
  },
  xWeeks: {
    one: "en uke",
    other: "{{count}} uker"
  },
  aboutXMonths: {
    one: "omtrent en måned",
    other: "omtrent {{count}} måneder"
  },
  xMonths: {
    one: "en måned",
    other: "{{count}} måneder"
  },
  aboutXYears: {
    one: "omtrent ett år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over ett år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten ett år",
    other: "nesten {{count}} år"
  }
}, pwe = (t, e, n) => {
  let i;
  const r = hwe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + i : i + " siden" : i;
}, gwe = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, ywe = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, vwe = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, bwe = {
  date: T({
    formats: gwe,
    defaultWidth: "full"
  }),
  time: T({
    formats: ywe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: vwe,
    defaultWidth: "full"
  })
}, wwe = {
  lastWeek: "'forrige' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgen kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, kwe = (t, e, n, i) => wwe[t], xwe = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, _we = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, Mwe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, Cwe = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sø", "ma", "ti", "on", "to", "fr", "lø"],
  abbreviated: ["søn", "man", "tir", "ons", "tor", "fre", "lør"],
  wide: [
    "søndag",
    "mandag",
    "tirsdag",
    "onsdag",
    "torsdag",
    "fredag",
    "lørdag"
  ]
}, Pwe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natten"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgenen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natten"
  }
}, Swe = (t, e) => Number(t) + ".", Nwe = {
  ordinalNumber: Swe,
  era: C({
    values: xwe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: _we,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Mwe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Cwe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Pwe,
    defaultWidth: "wide"
  })
}, $we = /^(\d+)\.?/i, Dwe = /\d+/i, Ewe = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, Twe = {
  any: [/^f/i, /^e/i]
}, Owe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, Wwe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, Awe = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, Lwe = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, Iwe = {
  narrow: /^[smtofl]/i,
  short: /^(sø|ma|ti|on|to|fr|lø)/i,
  abbreviated: /^(søn|man|tir|ons|tor|fre|lør)/i,
  wide: /^(søndag|mandag|tirsdag|onsdag|torsdag|fredag|lørdag)/i
}, Rwe = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, jwe = {
  narrow: /^(midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgenen|ettermiddagen|kvelden|natten))/i
}, Fwe = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgen/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, zwe = {
  ordinalNumber: he({
    matchPattern: $we,
    parsePattern: Dwe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Ewe,
    defaultMatchWidth: "wide",
    parsePatterns: Twe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Owe,
    defaultMatchWidth: "wide",
    parsePatterns: Wwe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Awe,
    defaultMatchWidth: "wide",
    parsePatterns: Lwe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Iwe,
    defaultMatchWidth: "wide",
    parsePatterns: Rwe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: jwe,
    defaultMatchWidth: "any",
    parsePatterns: Fwe,
    defaultParseWidth: "any"
  })
}, Vwe = {
  code: "nb",
  formatDistance: pwe,
  formatLong: bwe,
  formatRelative: kwe,
  localize: Nwe,
  match: zwe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Hwe = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, Bwe = (t, e, n) => {
  let i;
  const r = Hwe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + i : i + " geleden" : i;
}, qwe = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd-MM-y"
}, Gwe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Xwe = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, Ywe = {
  date: T({
    formats: qwe,
    defaultWidth: "full"
  }),
  time: T({
    formats: Gwe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Xwe,
    defaultWidth: "full"
  })
}, Kwe = {
  lastWeek: "'afgelopen' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Uwe = (t, e, n, i) => Kwe[t], Jwe = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Qwe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Zwe = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, eke = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, tke = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middaguur",
    morning: "'s ochtends",
    afternoon: "'s middags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, nke = (t, e) => Number(t) + "e", ike = {
  ordinalNumber: nke,
  era: C({
    values: Jwe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Qwe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Zwe,
    defaultWidth: "wide"
  }),
  day: C({
    values: eke,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: tke,
    defaultWidth: "wide"
  })
}, rke = /^(\d+)e?/i, ake = /\d+/i, oke = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, ske = {
  any: [/^v/, /^n/]
}, lke = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, dke = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, cke = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, uke = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, fke = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, mke = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, hke = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, pke = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, gke = {
  ordinalNumber: he({
    matchPattern: rke,
    parsePattern: ake,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: oke,
    defaultMatchWidth: "wide",
    parsePatterns: ske,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: lke,
    defaultMatchWidth: "wide",
    parsePatterns: dke,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: cke,
    defaultMatchWidth: "wide",
    parsePatterns: uke,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: fke,
    defaultMatchWidth: "wide",
    parsePatterns: mke,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: hke,
    defaultMatchWidth: "any",
    parsePatterns: pke,
    defaultParseWidth: "any"
  })
}, yke = {
  code: "nl",
  formatDistance: Bwe,
  formatLong: Ywe,
  formatRelative: Uwe,
  localize: ike,
  match: gke,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, vke = {
  lessThanXSeconds: {
    one: "minder dan een seconde",
    other: "minder dan {{count}} seconden"
  },
  xSeconds: {
    one: "1 seconde",
    other: "{{count}} seconden"
  },
  halfAMinute: "een halve minuut",
  lessThanXMinutes: {
    one: "minder dan een minuut",
    other: "minder dan {{count}} minuten"
  },
  xMinutes: {
    one: "een minuut",
    other: "{{count}} minuten"
  },
  aboutXHours: {
    one: "ongeveer 1 uur",
    other: "ongeveer {{count}} uur"
  },
  xHours: {
    one: "1 uur",
    other: "{{count}} uur"
  },
  xDays: {
    one: "1 dag",
    other: "{{count}} dagen"
  },
  aboutXWeeks: {
    one: "ongeveer 1 week",
    other: "ongeveer {{count}} weken"
  },
  xWeeks: {
    one: "1 week",
    other: "{{count}} weken"
  },
  aboutXMonths: {
    one: "ongeveer 1 maand",
    other: "ongeveer {{count}} maanden"
  },
  xMonths: {
    one: "1 maand",
    other: "{{count}} maanden"
  },
  aboutXYears: {
    one: "ongeveer 1 jaar",
    other: "ongeveer {{count}} jaar"
  },
  xYears: {
    one: "1 jaar",
    other: "{{count}} jaar"
  },
  overXYears: {
    one: "meer dan 1 jaar",
    other: "meer dan {{count}} jaar"
  },
  almostXYears: {
    one: "bijna 1 jaar",
    other: "bijna {{count}} jaar"
  }
}, bke = (t, e, n) => {
  let i;
  const r = vke[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "over " + i : i + " geleden" : i;
}, wke = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.y"
}, kke = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, xke = {
  full: "{{date}} 'om' {{time}}",
  long: "{{date}} 'om' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, _ke = {
  date: T({
    formats: wke,
    defaultWidth: "full"
  }),
  time: T({
    formats: kke,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: xke,
    defaultWidth: "full"
  })
}, Mke = {
  lastWeek: "'vorige' eeee 'om' p",
  yesterday: "'gisteren om' p",
  today: "'vandaag om' p",
  tomorrow: "'morgen om' p",
  nextWeek: "eeee 'om' p",
  other: "P"
}, Cke = (t, e, n, i) => Mke[t], Pke = {
  narrow: ["v.C.", "n.C."],
  abbreviated: ["v.Chr.", "n.Chr."],
  wide: ["voor Christus", "na Christus"]
}, Ske = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["K1", "K2", "K3", "K4"],
  wide: ["1e kwartaal", "2e kwartaal", "3e kwartaal", "4e kwartaal"]
}, Nke = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mrt.",
    "apr.",
    "mei",
    "jun.",
    "jul.",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "maart",
    "april",
    "mei",
    "juni",
    "juli",
    "augustus",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, $ke = {
  narrow: ["Z", "M", "D", "W", "D", "V", "Z"],
  short: ["zo", "ma", "di", "wo", "do", "vr", "za"],
  abbreviated: ["zon", "maa", "din", "woe", "don", "vri", "zat"],
  wide: [
    "zondag",
    "maandag",
    "dinsdag",
    "woensdag",
    "donderdag",
    "vrijdag",
    "zaterdag"
  ]
}, Dke = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "middernacht",
    noon: "het middag",
    morning: "'s ochtends",
    afternoon: "'s namiddags",
    evening: "'s avonds",
    night: "'s nachts"
  }
}, Eke = (t, e) => Number(t) + "e", Tke = {
  ordinalNumber: Eke,
  era: C({
    values: Pke,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Ske,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Nke,
    defaultWidth: "wide"
  }),
  day: C({
    values: $ke,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Dke,
    defaultWidth: "wide"
  })
}, Oke = /^(\d+)e?/i, Wke = /\d+/i, Ake = {
  narrow: /^([vn]\.? ?C\.?)/,
  abbreviated: /^([vn]\. ?Chr\.?)/,
  wide: /^((voor|na) Christus)/
}, Lke = {
  any: [/^v/, /^n/]
}, Ike = {
  narrow: /^[1234]/i,
  abbreviated: /^K[1234]/i,
  wide: /^[1234]e kwartaal/i
}, Rke = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, jke = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan.|feb.|mrt.|apr.|mei|jun.|jul.|aug.|sep.|okt.|nov.|dec.)/i,
  wide: /^(januari|februari|maart|april|mei|juni|juli|augustus|september|oktober|november|december)/i
}, Fke = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^jan/i,
    /^feb/i,
    /^m(r|a)/i,
    /^apr/i,
    /^mei/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^sep/i,
    /^okt/i,
    /^nov/i,
    /^dec/i
  ]
}, zke = {
  narrow: /^[zmdwv]/i,
  short: /^(zo|ma|di|wo|do|vr|za)/i,
  abbreviated: /^(zon|maa|din|woe|don|vri|zat)/i,
  wide: /^(zondag|maandag|dinsdag|woensdag|donderdag|vrijdag|zaterdag)/i
}, Vke = {
  narrow: [/^z/i, /^m/i, /^d/i, /^w/i, /^d/i, /^v/i, /^z/i],
  any: [/^zo/i, /^ma/i, /^di/i, /^wo/i, /^do/i, /^vr/i, /^za/i]
}, Hke = {
  any: /^(am|pm|middernacht|het middaguur|'s (ochtends|middags|avonds|nachts))/i
}, Bke = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /^middernacht/i,
    noon: /^het middaguur/i,
    morning: /ochtend/i,
    afternoon: /middag/i,
    evening: /avond/i,
    night: /nacht/i
  }
}, qke = {
  ordinalNumber: he({
    matchPattern: Oke,
    parsePattern: Wke,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Ake,
    defaultMatchWidth: "wide",
    parsePatterns: Lke,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Ike,
    defaultMatchWidth: "wide",
    parsePatterns: Rke,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: jke,
    defaultMatchWidth: "wide",
    parsePatterns: Fke,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: zke,
    defaultMatchWidth: "wide",
    parsePatterns: Vke,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Hke,
    defaultMatchWidth: "any",
    parsePatterns: Bke,
    defaultParseWidth: "any"
  })
}, Gke = {
  code: "nl-BE",
  formatDistance: bke,
  formatLong: _ke,
  formatRelative: Cke,
  localize: Tke,
  match: qke,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Xke = {
  lessThanXSeconds: {
    one: "mindre enn eitt sekund",
    other: "mindre enn {{count}} sekund"
  },
  xSeconds: {
    one: "eitt sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "eit halvt minutt",
  lessThanXMinutes: {
    one: "mindre enn eitt minutt",
    other: "mindre enn {{count}} minutt"
  },
  xMinutes: {
    one: "eitt minutt",
    other: "{{count}} minutt"
  },
  aboutXHours: {
    one: "omtrent ein time",
    other: "omtrent {{count}} timar"
  },
  xHours: {
    one: "ein time",
    other: "{{count}} timar"
  },
  xDays: {
    one: "ein dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "omtrent ei veke",
    other: "omtrent {{count}} veker"
  },
  xWeeks: {
    one: "ei veke",
    other: "{{count}} veker"
  },
  aboutXMonths: {
    one: "omtrent ein månad",
    other: "omtrent {{count}} månader"
  },
  xMonths: {
    one: "ein månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "omtrent eitt år",
    other: "omtrent {{count}} år"
  },
  xYears: {
    one: "eitt år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "over eitt år",
    other: "over {{count}} år"
  },
  almostXYears: {
    one: "nesten eitt år",
    other: "nesten {{count}} år"
  }
}, Yke = [
  "null",
  "ein",
  "to",
  "tre",
  "fire",
  "fem",
  "seks",
  "sju",
  "åtte",
  "ni",
  "ti",
  "elleve",
  "tolv"
], Kke = (t, e, n) => {
  let i;
  const r = Xke[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace(
    "{{count}}",
    e < 13 ? Yke[e] : String(e)
  ), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + i : i + " sidan" : i;
}, Uke = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. MMM y",
  short: "dd.MM.y"
}, Jke = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Qke = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Zke = {
  date: T({
    formats: Uke,
    defaultWidth: "full"
  }),
  time: T({
    formats: Jke,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Qke,
    defaultWidth: "full"
  })
}, e2e = {
  lastWeek: "'førre' eeee 'kl.' p",
  yesterday: "'i går kl.' p",
  today: "'i dag kl.' p",
  tomorrow: "'i morgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, t2e = (t, e, n, i) => e2e[t], n2e = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["før Kristus", "etter Kristus"]
}, i2e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, r2e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "mai",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "des."
  ],
  wide: [
    "januar",
    "februar",
    "mars",
    "april",
    "mai",
    "juni",
    "juli",
    "august",
    "september",
    "oktober",
    "november",
    "desember"
  ]
}, a2e = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["su", "må", "ty", "on", "to", "fr", "lau"],
  abbreviated: ["sun", "mån", "tys", "ons", "tor", "fre", "laur"],
  wide: [
    "sundag",
    "måndag",
    "tysdag",
    "onsdag",
    "torsdag",
    "fredag",
    "laurdag"
  ]
}, o2e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på etterm.",
    evening: "på kvelden",
    night: "på natta"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på ettermiddagen",
    evening: "på kvelden",
    night: "på natta"
  }
}, s2e = (t, e) => Number(t) + ".", l2e = {
  ordinalNumber: s2e,
  era: C({
    values: n2e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: i2e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: r2e,
    defaultWidth: "wide"
  }),
  day: C({
    values: a2e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: o2e,
    defaultWidth: "wide"
  })
}, d2e = /^(\d+)\.?/i, c2e = /\d+/i, u2e = {
  narrow: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|fvt\.?|e\.? ?Kr\.?|evt\.?)/i,
  wide: /^(før Kristus|før vår tid|etter Kristus|vår tid)/i
}, f2e = {
  any: [/^f/i, /^e/i]
}, m2e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartal/i
}, h2e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, p2e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mars?|apr|mai|juni?|juli?|aug|sep|okt|nov|des)\.?/i,
  wide: /^(januar|februar|mars|april|mai|juni|juli|august|september|oktober|november|desember)/i
}, g2e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^aug/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, y2e = {
  narrow: /^[smtofl]/i,
  short: /^(su|må|ty|on|to|fr|la)/i,
  abbreviated: /^(sun|mån|tys|ons|tor|fre|laur)/i,
  wide: /^(sundag|måndag|tysdag|onsdag|torsdag|fredag|laurdag)/i
}, v2e = {
  any: [/^s/i, /^m/i, /^ty/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, b2e = {
  narrow: /^(midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|midnatt|middag|(på) (morgonen|ettermiddagen|kvelden|natta))/i
}, w2e = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /ettermiddag/i,
    evening: /kveld/i,
    night: /natt/i
  }
}, k2e = {
  ordinalNumber: he({
    matchPattern: d2e,
    parsePattern: c2e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: u2e,
    defaultMatchWidth: "wide",
    parsePatterns: f2e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: m2e,
    defaultMatchWidth: "wide",
    parsePatterns: h2e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: p2e,
    defaultMatchWidth: "wide",
    parsePatterns: g2e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: y2e,
    defaultMatchWidth: "wide",
    parsePatterns: v2e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: b2e,
    defaultMatchWidth: "any",
    parsePatterns: w2e,
    defaultParseWidth: "any"
  })
}, x2e = {
  code: "nn",
  formatDistance: Kke,
  formatLong: Zke,
  formatRelative: t2e,
  localize: l2e,
  match: k2e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, _2e = {
  lessThanXSeconds: {
    one: "mens d’una segonda",
    other: "mens de {{count}} segondas"
  },
  xSeconds: {
    one: "1 segonda",
    other: "{{count}} segondas"
  },
  halfAMinute: "30 segondas",
  lessThanXMinutes: {
    one: "mens d’una minuta",
    other: "mens de {{count}} minutas"
  },
  xMinutes: {
    one: "1 minuta",
    other: "{{count}} minutas"
  },
  aboutXHours: {
    one: "environ 1 ora",
    other: "environ {{count}} oras"
  },
  xHours: {
    one: "1 ora",
    other: "{{count}} oras"
  },
  xDays: {
    one: "1 jorn",
    other: "{{count}} jorns"
  },
  aboutXWeeks: {
    one: "environ 1 setmana",
    other: "environ {{count}} setmanas"
  },
  xWeeks: {
    one: "1 setmana",
    other: "{{count}} setmanas"
  },
  aboutXMonths: {
    one: "environ 1 mes",
    other: "environ {{count}} meses"
  },
  xMonths: {
    one: "1 mes",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "environ 1 an",
    other: "environ {{count}} ans"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ans"
  },
  overXYears: {
    one: "mai d’un an",
    other: "mai de {{count}} ans"
  },
  almostXYears: {
    one: "gaireben un an",
    other: "gaireben {{count}} ans"
  }
}, M2e = (t, e, n) => {
  let i;
  const r = _2e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "d’aquí " + i : "fa " + i : i;
}, C2e = {
  full: "EEEE d 'de' MMMM y",
  long: "d 'de' MMMM y",
  medium: "d MMM y",
  short: "dd/MM/y"
}, P2e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, S2e = {
  full: "{{date}} 'a' {{time}}",
  long: "{{date}} 'a' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, N2e = {
  date: T({
    formats: C2e,
    defaultWidth: "full"
  }),
  time: T({
    formats: P2e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: S2e,
    defaultWidth: "full"
  })
}, $2e = {
  lastWeek: "eeee 'passat a' p",
  yesterday: "'ièr a' p",
  today: "'uèi a' p",
  tomorrow: "'deman a' p",
  nextWeek: "eeee 'a' p",
  other: "P"
}, D2e = (t, e, n, i) => $2e[t], E2e = {
  narrow: ["ab. J.C.", "apr. J.C."],
  abbreviated: ["ab. J.C.", "apr. J.C."],
  wide: ["abans Jèsus-Crist", "après Jèsus-Crist"]
}, T2e = {
  narrow: ["T1", "T2", "T3", "T4"],
  abbreviated: ["1èr trim.", "2nd trim.", "3en trim.", "4en trim."],
  wide: ["1èr trimèstre", "2nd trimèstre", "3en trimèstre", "4en trimèstre"]
}, O2e = {
  narrow: [
    "GN",
    "FB",
    "MÇ",
    "AB",
    "MA",
    "JN",
    "JL",
    "AG",
    "ST",
    "OC",
    "NV",
    "DC"
  ],
  abbreviated: [
    "gen.",
    "febr.",
    "març",
    "abr.",
    "mai",
    "junh",
    "jul.",
    "ag.",
    "set.",
    "oct.",
    "nov.",
    "dec."
  ],
  wide: [
    "genièr",
    "febrièr",
    "març",
    "abril",
    "mai",
    "junh",
    "julhet",
    "agost",
    "setembre",
    "octòbre",
    "novembre",
    "decembre"
  ]
}, W2e = {
  narrow: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  short: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  abbreviated: ["dg.", "dl.", "dm.", "dc.", "dj.", "dv.", "ds."],
  wide: [
    "dimenge",
    "diluns",
    "dimars",
    "dimècres",
    "dijòus",
    "divendres",
    "dissabte"
  ]
}, A2e = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "matin",
    afternoon: "aprèp-miègjorn",
    evening: "vèspre",
    night: "nuèch"
  }
}, L2e = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  },
  wide: {
    am: "ante meridiem",
    pm: "post meridiem",
    midnight: "mièjanuèch",
    noon: "miègjorn",
    morning: "del matin",
    afternoon: "de l’aprèp-miègjorn",
    evening: "del ser",
    night: "de la nuèch"
  }
}, I2e = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  let r;
  switch (n) {
    case 1:
      r = "èr";
      break;
    case 2:
      r = "nd";
      break;
    default:
      r = "en";
  }
  return (i === "year" || i === "week" || i === "hour" || i === "minute" || i === "second") && (r += "a"), n + r;
}, R2e = {
  ordinalNumber: I2e,
  era: C({
    values: E2e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: T2e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: O2e,
    defaultWidth: "wide"
  }),
  day: C({
    values: W2e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: A2e,
    defaultWidth: "wide",
    formattingValues: L2e,
    defaultFormattingWidth: "wide"
  })
}, j2e = /^(\d+)(èr|nd|en)?[a]?/i, F2e = /\d+/i, z2e = {
  narrow: /^(ab\.J\.C|apr\.J\.C|apr\.J\.-C)/i,
  abbreviated: /^(ab\.J\.-C|ab\.J-C|apr\.J\.-C|apr\.J-C|ap\.J-C)/i,
  wide: /^(abans Jèsus-Crist|après Jèsus-Crist)/i
}, V2e = {
  any: [/^ab/i, /^ap/i]
}, H2e = {
  narrow: /^T[1234]/i,
  abbreviated: /^[1234](èr|nd|en)? trim\.?/i,
  wide: /^[1234](èr|nd|en)? trimèstre/i
}, B2e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, q2e = {
  narrow: /^(GN|FB|MÇ|AB|MA|JN|JL|AG|ST|OC|NV|DC)/i,
  abbreviated: /^(gen|febr|març|abr|mai|junh|jul|ag|set|oct|nov|dec)\.?/i,
  wide: /^(genièr|febrièr|març|abril|mai|junh|julhet|agost|setembre|octòbre|novembre|decembre)/i
}, G2e = {
  any: [
    /^g/i,
    /^f/i,
    /^ma[r?]|MÇ/i,
    /^ab/i,
    /^ma[i?]/i,
    /^ju[n?]|JN/i,
    /^ju[l?]|JL/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, X2e = {
  narrow: /^d[glmcjvs]\.?/i,
  short: /^d[glmcjvs]\.?/i,
  abbreviated: /^d[glmcjvs]\.?/i,
  wide: /^(dimenge|diluns|dimars|dimècres|dijòus|divendres|dissabte)/i
}, Y2e = {
  narrow: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  short: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  abbreviated: [/^dg/i, /^dl/i, /^dm/i, /^dc/i, /^dj/i, /^dv/i, /^ds/i],
  any: [
    /^dg|dime/i,
    /^dl|dil/i,
    /^dm|dima/i,
    /^dc|dimè/i,
    /^dj|dij/i,
    /^dv|div/i,
    /^ds|dis/i
  ]
}, K2e = {
  any: /(^(a\.?m|p\.?m))|(ante meridiem|post meridiem)|((del |de la |de l’)(matin|aprèp-miègjorn|vèspre|ser|nuèch))/i
}, U2e = {
  any: {
    am: /(^a)|ante meridiem/i,
    pm: /(^p)|post meridiem/i,
    midnight: /^mièj/i,
    noon: /^mièg/i,
    morning: /matin/i,
    afternoon: /aprèp-miègjorn/i,
    evening: /vèspre|ser/i,
    night: /nuèch/i
  }
}, J2e = {
  ordinalNumber: he({
    matchPattern: j2e,
    parsePattern: F2e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: z2e,
    defaultMatchWidth: "wide",
    parsePatterns: V2e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: H2e,
    defaultMatchWidth: "wide",
    parsePatterns: B2e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: q2e,
    defaultMatchWidth: "wide",
    parsePatterns: G2e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: X2e,
    defaultMatchWidth: "wide",
    parsePatterns: Y2e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: K2e,
    defaultMatchWidth: "any",
    parsePatterns: U2e,
    defaultParseWidth: "any"
  })
}, Q2e = {
  code: "oc",
  formatDistance: M2e,
  formatLong: N2e,
  formatRelative: D2e,
  localize: R2e,
  match: J2e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Z2e = {
  lessThanXSeconds: {
    one: {
      regular: "mniej niż sekunda",
      past: "mniej niż sekundę",
      future: "mniej niż sekundę"
    },
    twoFour: "mniej niż {{count}} sekundy",
    other: "mniej niż {{count}} sekund"
  },
  xSeconds: {
    one: {
      regular: "sekunda",
      past: "sekundę",
      future: "sekundę"
    },
    twoFour: "{{count}} sekundy",
    other: "{{count}} sekund"
  },
  halfAMinute: {
    one: "pół minuty",
    twoFour: "pół minuty",
    other: "pół minuty"
  },
  lessThanXMinutes: {
    one: {
      regular: "mniej niż minuta",
      past: "mniej niż minutę",
      future: "mniej niż minutę"
    },
    twoFour: "mniej niż {{count}} minuty",
    other: "mniej niż {{count}} minut"
  },
  xMinutes: {
    one: {
      regular: "minuta",
      past: "minutę",
      future: "minutę"
    },
    twoFour: "{{count}} minuty",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: {
      regular: "około godziny",
      past: "około godziny",
      future: "około godzinę"
    },
    twoFour: "około {{count}} godziny",
    other: "około {{count}} godzin"
  },
  xHours: {
    one: {
      regular: "godzina",
      past: "godzinę",
      future: "godzinę"
    },
    twoFour: "{{count}} godziny",
    other: "{{count}} godzin"
  },
  xDays: {
    one: {
      regular: "dzień",
      past: "dzień",
      future: "1 dzień"
    },
    twoFour: "{{count}} dni",
    other: "{{count}} dni"
  },
  aboutXWeeks: {
    one: "około tygodnia",
    twoFour: "około {{count}} tygodni",
    other: "około {{count}} tygodni"
  },
  xWeeks: {
    one: "tydzień",
    twoFour: "{{count}} tygodnie",
    other: "{{count}} tygodni"
  },
  aboutXMonths: {
    one: "około miesiąc",
    twoFour: "około {{count}} miesiące",
    other: "około {{count}} miesięcy"
  },
  xMonths: {
    one: "miesiąc",
    twoFour: "{{count}} miesiące",
    other: "{{count}} miesięcy"
  },
  aboutXYears: {
    one: "około rok",
    twoFour: "około {{count}} lata",
    other: "około {{count}} lat"
  },
  xYears: {
    one: "rok",
    twoFour: "{{count}} lata",
    other: "{{count}} lat"
  },
  overXYears: {
    one: "ponad rok",
    twoFour: "ponad {{count}} lata",
    other: "ponad {{count}} lat"
  },
  almostXYears: {
    one: "prawie rok",
    twoFour: "prawie {{count}} lata",
    other: "prawie {{count}} lat"
  }
};
function exe(t, e) {
  if (e === 1)
    return t.one;
  const n = e % 100;
  if (n <= 20 && n > 10)
    return t.other;
  const i = n % 10;
  return i >= 2 && i <= 4 ? t.twoFour : t.other;
}
function h1(t, e, n) {
  const i = exe(t, e);
  return (typeof i == "string" ? i : i[n]).replace("{{count}}", String(e));
}
const txe = (t, e, n) => {
  const i = Z2e[t];
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + h1(i, e, "future") : h1(i, e, "past") + " temu" : h1(i, e, "regular");
}, nxe = {
  full: "EEEE, do MMMM y",
  long: "do MMMM y",
  medium: "do MMM y",
  short: "dd.MM.y"
}, ixe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, rxe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, axe = {
  date: T({
    formats: nxe,
    defaultWidth: "full"
  }),
  time: T({
    formats: ixe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: rxe,
    defaultWidth: "full"
  })
}, oxe = {
  masculine: "ostatni",
  feminine: "ostatnia"
}, sxe = {
  masculine: "ten",
  feminine: "ta"
}, lxe = {
  masculine: "następny",
  feminine: "następna"
}, dxe = {
  0: "feminine",
  1: "masculine",
  2: "masculine",
  3: "feminine",
  4: "masculine",
  5: "masculine",
  6: "feminine"
};
function S2(t, e, n, i) {
  let r;
  if (Lt(e, n, i))
    r = sxe;
  else if (t === "lastWeek")
    r = oxe;
  else if (t === "nextWeek")
    r = lxe;
  else
    throw new Error(`Cannot determine adjectives for token ${t}`);
  const a = e.getDay(), o = dxe[a];
  return `'${r[o]}' eeee 'o' p`;
}
const cxe = {
  lastWeek: S2,
  yesterday: "'wczoraj o' p",
  today: "'dzisiaj o' p",
  tomorrow: "'jutro o' p",
  nextWeek: S2,
  other: "P"
}, uxe = (t, e, n, i) => {
  const r = cxe[t];
  return typeof r == "function" ? r(t, e, n, i) : r;
}, fxe = {
  narrow: ["p.n.e.", "n.e."],
  abbreviated: ["p.n.e.", "n.e."],
  wide: ["przed naszą erą", "naszej ery"]
}, mxe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["I kw.", "II kw.", "III kw.", "IV kw."],
  wide: ["I kwartał", "II kwartał", "III kwartał", "IV kwartał"]
}, hxe = {
  narrow: ["S", "L", "M", "K", "M", "C", "L", "S", "W", "P", "L", "G"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru"
  ],
  wide: [
    "styczeń",
    "luty",
    "marzec",
    "kwiecień",
    "maj",
    "czerwiec",
    "lipiec",
    "sierpień",
    "wrzesień",
    "październik",
    "listopad",
    "grudzień"
  ]
}, pxe = {
  narrow: ["s", "l", "m", "k", "m", "c", "l", "s", "w", "p", "l", "g"],
  abbreviated: [
    "sty",
    "lut",
    "mar",
    "kwi",
    "maj",
    "cze",
    "lip",
    "sie",
    "wrz",
    "paź",
    "lis",
    "gru"
  ],
  wide: [
    "stycznia",
    "lutego",
    "marca",
    "kwietnia",
    "maja",
    "czerwca",
    "lipca",
    "sierpnia",
    "września",
    "października",
    "listopada",
    "grudnia"
  ]
}, gxe = {
  narrow: ["N", "P", "W", "Ś", "C", "P", "S"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota"
  ]
}, yxe = {
  narrow: ["n", "p", "w", "ś", "c", "p", "s"],
  short: ["nie", "pon", "wto", "śro", "czw", "pią", "sob"],
  abbreviated: ["niedz.", "pon.", "wt.", "śr.", "czw.", "pt.", "sob."],
  wide: [
    "niedziela",
    "poniedziałek",
    "wtorek",
    "środa",
    "czwartek",
    "piątek",
    "sobota"
  ]
}, vxe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "półn.",
    noon: "poł",
    morning: "rano",
    afternoon: "popoł.",
    evening: "wiecz.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "północ",
    noon: "południe",
    morning: "rano",
    afternoon: "popołudnie",
    evening: "wieczór",
    night: "noc"
  }
}, bxe = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "o półn.",
    noon: "w poł.",
    morning: "rano",
    afternoon: "po poł.",
    evening: "wiecz.",
    night: "w nocy"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o północy",
    noon: "w południe",
    morning: "rano",
    afternoon: "po południu",
    evening: "wieczorem",
    night: "w nocy"
  }
}, wxe = (t, e) => String(t), kxe = {
  ordinalNumber: wxe,
  era: C({
    values: fxe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: mxe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: hxe,
    defaultWidth: "wide",
    formattingValues: pxe,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: gxe,
    defaultWidth: "wide",
    formattingValues: yxe,
    defaultFormattingWidth: "wide"
  }),
  dayPeriod: C({
    values: vxe,
    defaultWidth: "wide",
    formattingValues: bxe,
    defaultFormattingWidth: "wide"
  })
}, xxe = /^(\d+)?/i, _xe = /\d+/i, Mxe = {
  narrow: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  abbreviated: /^(p\.?\s*n\.?\s*e\.?\s*|n\.?\s*e\.?\s*)/i,
  wide: /^(przed\s*nasz(ą|a)\s*er(ą|a)|naszej\s*ery)/i
}, Cxe = {
  any: [/^p/i, /^n/i]
}, Pxe = {
  narrow: /^[1234]/i,
  abbreviated: /^(I|II|III|IV)\s*kw\.?/i,
  wide: /^(I|II|III|IV)\s*kwarta(ł|l)/i
}, Sxe = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [/^I kw/i, /^II kw/i, /^III kw/i, /^IV kw/i]
}, Nxe = {
  narrow: /^[slmkcwpg]/i,
  abbreviated: /^(sty|lut|mar|kwi|maj|cze|lip|sie|wrz|pa(ź|z)|lis|gru)/i,
  wide: /^(stycznia|stycze(ń|n)|lutego|luty|marca|marzec|kwietnia|kwiecie(ń|n)|maja|maj|czerwca|czerwiec|lipca|lipiec|sierpnia|sierpie(ń|n)|wrze(ś|s)nia|wrzesie(ń|n)|pa(ź|z)dziernika|pa(ź|z)dziernik|listopada|listopad|grudnia|grudzie(ń|n))/i
}, $xe = {
  narrow: [
    /^s/i,
    /^l/i,
    /^m/i,
    /^k/i,
    /^m/i,
    /^c/i,
    /^l/i,
    /^s/i,
    /^w/i,
    /^p/i,
    /^l/i,
    /^g/i
  ],
  any: [
    /^st/i,
    /^lu/i,
    /^mar/i,
    /^k/i,
    /^maj/i,
    /^c/i,
    /^lip/i,
    /^si/i,
    /^w/i,
    /^p/i,
    /^lis/i,
    /^g/i
  ]
}, Dxe = {
  narrow: /^[npwścs]/i,
  short: /^(nie|pon|wto|(ś|s)ro|czw|pi(ą|a)|sob)/i,
  abbreviated: /^(niedz|pon|wt|(ś|s)r|czw|pt|sob)\.?/i,
  wide: /^(niedziela|poniedzia(ł|l)ek|wtorek|(ś|s)roda|czwartek|pi(ą|a)tek|sobota)/i
}, Exe = {
  narrow: [/^n/i, /^p/i, /^w/i, /^ś/i, /^c/i, /^p/i, /^s/i],
  abbreviated: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pt/i, /^so/i],
  any: [/^n/i, /^po/i, /^w/i, /^(ś|s)r/i, /^c/i, /^pi/i, /^so/i]
}, Txe = {
  narrow: /^(^a$|^p$|pó(ł|l)n\.?|o\s*pó(ł|l)n\.?|po(ł|l)\.?|w\s*po(ł|l)\.?|po\s*po(ł|l)\.?|rano|wiecz\.?|noc|w\s*nocy)/i,
  any: /^(am|pm|pó(ł|l)noc|o\s*pó(ł|l)nocy|po(ł|l)udnie|w\s*po(ł|l)udnie|popo(ł|l)udnie|po\s*po(ł|l)udniu|rano|wieczór|wieczorem|noc|w\s*nocy)/i
}, Oxe = {
  narrow: {
    am: /^a$/i,
    pm: /^p$/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  },
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /pó(ł|l)n/i,
    noon: /po(ł|l)/i,
    morning: /rano/i,
    afternoon: /po\s*po(ł|l)/i,
    evening: /wiecz/i,
    night: /noc/i
  }
}, Wxe = {
  ordinalNumber: he({
    matchPattern: xxe,
    parsePattern: _xe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: Mxe,
    defaultMatchWidth: "wide",
    parsePatterns: Cxe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Pxe,
    defaultMatchWidth: "wide",
    parsePatterns: Sxe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: Nxe,
    defaultMatchWidth: "wide",
    parsePatterns: $xe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: Dxe,
    defaultMatchWidth: "wide",
    parsePatterns: Exe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: Txe,
    defaultMatchWidth: "any",
    parsePatterns: Oxe,
    defaultParseWidth: "any"
  })
}, Axe = {
  code: "pl",
  formatDistance: txe,
  formatLong: axe,
  formatRelative: uxe,
  localize: kxe,
  match: Wxe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, Lxe = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "aproximadamente 1 hora",
    other: "aproximadamente {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "aproximadamente 1 semana",
    other: "aproximadamente {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "aproximadamente 1 mês",
    other: "aproximadamente {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "aproximadamente 1 ano",
    other: "aproximadamente {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, Ixe = (t, e, n) => {
  let i;
  const r = Lxe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "daqui a " + i : "há " + i : i;
}, Rxe = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d 'de' MMM 'de' y",
  short: "dd/MM/y"
}, jxe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, Fxe = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, zxe = {
  date: T({
    formats: Rxe,
    defaultWidth: "full"
  }),
  time: T({
    formats: jxe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: Fxe,
    defaultWidth: "full"
  })
}, Vxe = {
  lastWeek: (t) => {
    const e = t.getDay();
    return "'" + (e === 0 || e === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, Hxe = (t, e, n, i) => {
  const r = Vxe[t];
  return typeof r == "function" ? r(e) : r;
}, Bxe = {
  narrow: ["aC", "dC"],
  abbreviated: ["a.C.", "d.C."],
  wide: ["antes de Cristo", "depois de Cristo"]
}, qxe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, Gxe = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, Xxe = {
  narrow: ["d", "s", "t", "q", "q", "s", "s"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  abbreviated: ["dom", "seg", "ter", "qua", "qui", "sex", "sáb"],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, Yxe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "noite",
    night: "madrugada"
  }
}, Kxe = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da noite",
    night: "da madrugada"
  }
}, Uxe = (t, e) => Number(t) + "º", Jxe = {
  ordinalNumber: Uxe,
  era: C({
    values: Bxe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: qxe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Gxe,
    defaultWidth: "wide"
  }),
  day: C({
    values: Xxe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Yxe,
    defaultWidth: "wide",
    formattingValues: Kxe,
    defaultFormattingWidth: "wide"
  })
}, Qxe = /^(\d+)(º|ª)?/i, Zxe = /\d+/i, e3e = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|a\.?\s?e\.?\s?c\.?|d\.?\s?c\.?|e\.?\s?c\.?)/i,
  wide: /^(antes de cristo|antes da era comum|depois de cristo|era comum)/i
}, t3e = {
  any: [/^ac/i, /^dc/i],
  wide: [
    /^(antes de cristo|antes da era comum)/i,
    /^(depois de cristo|era comum)/i
  ]
}, n3e = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º|ª)? trimestre/i
}, i3e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, r3e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, a3e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ab/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ag/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, o3e = {
  narrow: /^[dstq]/i,
  short: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[áa]b)/i,
  wide: /^(domingo|segunda-?\s?feira|terça-?\s?feira|quarta-?\s?feira|quinta-?\s?feira|sexta-?\s?feira|s[áa]bado)/i
}, s3e = {
  narrow: [/^d/i, /^s/i, /^t/i, /^q/i, /^q/i, /^s/i, /^s/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[áa]/i]
}, l3e = {
  narrow: /^(a|p|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i,
  any: /^([ap]\.?\s?m\.?|meia-?\s?noite|meio-?\s?dia|(da) (manh[ãa]|tarde|noite|madrugada))/i
}, d3e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^meia/i,
    noon: /^meio/i,
    morning: /manh[ãa]/i,
    afternoon: /tarde/i,
    evening: /noite/i,
    night: /madrugada/i
  }
}, c3e = {
  ordinalNumber: he({
    matchPattern: Qxe,
    parsePattern: Zxe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: e3e,
    defaultMatchWidth: "wide",
    parsePatterns: t3e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: n3e,
    defaultMatchWidth: "wide",
    parsePatterns: i3e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: r3e,
    defaultMatchWidth: "wide",
    parsePatterns: a3e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: o3e,
    defaultMatchWidth: "wide",
    parsePatterns: s3e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: l3e,
    defaultMatchWidth: "any",
    parsePatterns: d3e,
    defaultParseWidth: "any"
  })
}, u3e = {
  code: "pt",
  formatDistance: Ixe,
  formatLong: zxe,
  formatRelative: Hxe,
  localize: Jxe,
  match: c3e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, f3e = {
  lessThanXSeconds: {
    one: "menos de um segundo",
    other: "menos de {{count}} segundos"
  },
  xSeconds: {
    one: "1 segundo",
    other: "{{count}} segundos"
  },
  halfAMinute: "meio minuto",
  lessThanXMinutes: {
    one: "menos de um minuto",
    other: "menos de {{count}} minutos"
  },
  xMinutes: {
    one: "1 minuto",
    other: "{{count}} minutos"
  },
  aboutXHours: {
    one: "cerca de 1 hora",
    other: "cerca de {{count}} horas"
  },
  xHours: {
    one: "1 hora",
    other: "{{count}} horas"
  },
  xDays: {
    one: "1 dia",
    other: "{{count}} dias"
  },
  aboutXWeeks: {
    one: "cerca de 1 semana",
    other: "cerca de {{count}} semanas"
  },
  xWeeks: {
    one: "1 semana",
    other: "{{count}} semanas"
  },
  aboutXMonths: {
    one: "cerca de 1 mês",
    other: "cerca de {{count}} meses"
  },
  xMonths: {
    one: "1 mês",
    other: "{{count}} meses"
  },
  aboutXYears: {
    one: "cerca de 1 ano",
    other: "cerca de {{count}} anos"
  },
  xYears: {
    one: "1 ano",
    other: "{{count}} anos"
  },
  overXYears: {
    one: "mais de 1 ano",
    other: "mais de {{count}} anos"
  },
  almostXYears: {
    one: "quase 1 ano",
    other: "quase {{count}} anos"
  }
}, m3e = (t, e, n) => {
  let i;
  const r = f3e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "em " + i : "há " + i : i;
}, h3e = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, p3e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, g3e = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, y3e = {
  date: T({
    formats: h3e,
    defaultWidth: "full"
  }),
  time: T({
    formats: p3e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: g3e,
    defaultWidth: "full"
  })
}, v3e = {
  lastWeek: (t) => {
    const e = t.getDay();
    return "'" + (e === 0 || e === 6 ? "último" : "última") + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: "P"
}, b3e = (t, e, n, i) => {
  const r = v3e[t];
  return typeof r == "function" ? r(e) : r;
}, w3e = {
  narrow: ["AC", "DC"],
  abbreviated: ["AC", "DC"],
  wide: ["antes de cristo", "depois de cristo"]
}, k3e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: ["1º trimestre", "2º trimestre", "3º trimestre", "4º trimestre"]
}, x3e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "fev",
    "mar",
    "abr",
    "mai",
    "jun",
    "jul",
    "ago",
    "set",
    "out",
    "nov",
    "dez"
  ],
  wide: [
    "janeiro",
    "fevereiro",
    "março",
    "abril",
    "maio",
    "junho",
    "julho",
    "agosto",
    "setembro",
    "outubro",
    "novembro",
    "dezembro"
  ]
}, _3e = {
  narrow: ["D", "S", "T", "Q", "Q", "S", "S"],
  short: ["dom", "seg", "ter", "qua", "qui", "sex", "sab"],
  abbreviated: [
    "domingo",
    "segunda",
    "terça",
    "quarta",
    "quinta",
    "sexta",
    "sábado"
  ],
  wide: [
    "domingo",
    "segunda-feira",
    "terça-feira",
    "quarta-feira",
    "quinta-feira",
    "sexta-feira",
    "sábado"
  ]
}, M3e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "manhã",
    afternoon: "tarde",
    evening: "tarde",
    night: "noite"
  }
}, C3e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "md",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "meia-noite",
    noon: "meio-dia",
    morning: "da manhã",
    afternoon: "da tarde",
    evening: "da tarde",
    night: "da noite"
  }
}, P3e = (t, e) => {
  const n = Number(t);
  return (e == null ? void 0 : e.unit) === "week" ? n + "ª" : n + "º";
}, S3e = {
  ordinalNumber: P3e,
  era: C({
    values: w3e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: k3e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: x3e,
    defaultWidth: "wide"
  }),
  day: C({
    values: _3e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: M3e,
    defaultWidth: "wide",
    formattingValues: C3e,
    defaultFormattingWidth: "wide"
  })
}, N3e = /^(\d+)[ºªo]?/i, $3e = /\d+/i, D3e = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
}, E3e = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
}, T3e = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
}, O3e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, W3e = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
}, A3e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^fev/i,
    /^mar/i,
    /^abr/i,
    /^mai/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^set/i,
    /^out/i,
    /^nov/i,
    /^dez/i
  ]
}, L3e = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
}, I3e = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
}, R3e = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
}, j3e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
}, F3e = {
  ordinalNumber: he({
    matchPattern: N3e,
    parsePattern: $3e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: D3e,
    defaultMatchWidth: "wide",
    parsePatterns: E3e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: T3e,
    defaultMatchWidth: "wide",
    parsePatterns: O3e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: W3e,
    defaultMatchWidth: "wide",
    parsePatterns: A3e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: L3e,
    defaultMatchWidth: "wide",
    parsePatterns: I3e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: R3e,
    defaultMatchWidth: "any",
    parsePatterns: j3e,
    defaultParseWidth: "any"
  })
}, z3e = {
  code: "pt-BR",
  formatDistance: m3e,
  formatLong: y3e,
  formatRelative: b3e,
  localize: S3e,
  match: F3e,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, V3e = {
  lessThanXSeconds: {
    one: "mai puțin de o secundă",
    other: "mai puțin de {{count}} secunde"
  },
  xSeconds: {
    one: "1 secundă",
    other: "{{count}} secunde"
  },
  halfAMinute: "jumătate de minut",
  lessThanXMinutes: {
    one: "mai puțin de un minut",
    other: "mai puțin de {{count}} minute"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minute"
  },
  aboutXHours: {
    one: "circa 1 oră",
    other: "circa {{count}} ore"
  },
  xHours: {
    one: "1 oră",
    other: "{{count}} ore"
  },
  xDays: {
    one: "1 zi",
    other: "{{count}} zile"
  },
  aboutXWeeks: {
    one: "circa o săptămână",
    other: "circa {{count}} săptămâni"
  },
  xWeeks: {
    one: "1 săptămână",
    other: "{{count}} săptămâni"
  },
  aboutXMonths: {
    one: "circa 1 lună",
    other: "circa {{count}} luni"
  },
  xMonths: {
    one: "1 lună",
    other: "{{count}} luni"
  },
  aboutXYears: {
    one: "circa 1 an",
    other: "circa {{count}} ani"
  },
  xYears: {
    one: "1 an",
    other: "{{count}} ani"
  },
  overXYears: {
    one: "peste 1 an",
    other: "peste {{count}} ani"
  },
  almostXYears: {
    one: "aproape 1 an",
    other: "aproape {{count}} ani"
  }
}, H3e = (t, e, n) => {
  let i;
  const r = V3e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "în " + i : i + " în urmă" : i;
}, B3e = {
  full: "EEEE, d MMMM yyyy",
  long: "d MMMM yyyy",
  medium: "d MMM yyyy",
  short: "dd.MM.yyyy"
}, q3e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, G3e = {
  full: "{{date}} 'la' {{time}}",
  long: "{{date}} 'la' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, X3e = {
  date: T({
    formats: B3e,
    defaultWidth: "full"
  }),
  time: T({
    formats: q3e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: G3e,
    defaultWidth: "full"
  })
}, Y3e = {
  lastWeek: "eeee 'trecută la' p",
  yesterday: "'ieri la' p",
  today: "'astăzi la' p",
  tomorrow: "'mâine la' p",
  nextWeek: "eeee 'viitoare la' p",
  other: "P"
}, K3e = (t, e, n, i) => Y3e[t], U3e = {
  narrow: ["Î", "D"],
  abbreviated: ["Î.d.C.", "D.C."],
  wide: ["Înainte de Cristos", "După Cristos"]
}, J3e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["T1", "T2", "T3", "T4"],
  wide: [
    "primul trimestru",
    "al doilea trimestru",
    "al treilea trimestru",
    "al patrulea trimestru"
  ]
}, Q3e = {
  narrow: ["I", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "ian",
    "feb",
    "mar",
    "apr",
    "mai",
    "iun",
    "iul",
    "aug",
    "sep",
    "oct",
    "noi",
    "dec"
  ],
  wide: [
    "ianuarie",
    "februarie",
    "martie",
    "aprilie",
    "mai",
    "iunie",
    "iulie",
    "august",
    "septembrie",
    "octombrie",
    "noiembrie",
    "decembrie"
  ]
}, Z3e = {
  narrow: ["d", "l", "m", "m", "j", "v", "s"],
  short: ["du", "lu", "ma", "mi", "jo", "vi", "sâ"],
  abbreviated: ["dum", "lun", "mar", "mie", "joi", "vin", "sâm"],
  wide: ["duminică", "luni", "marți", "miercuri", "joi", "vineri", "sâmbătă"]
}, e4e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "ami",
    morning: "dim",
    afternoon: "da",
    evening: "s",
    night: "n"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, t4e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "mn",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "miezul nopții",
    noon: "amiază",
    morning: "dimineață",
    afternoon: "după-amiază",
    evening: "seară",
    night: "noapte"
  }
}, n4e = (t, e) => String(t), i4e = {
  ordinalNumber: n4e,
  era: C({
    values: U3e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: J3e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: Q3e,
    defaultWidth: "wide"
  }),
  day: C({
    values: Z3e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: e4e,
    defaultWidth: "wide",
    formattingValues: t4e,
    defaultFormattingWidth: "wide"
  })
}, r4e = /^(\d+)?/i, a4e = /\d+/i, o4e = {
  narrow: /^(Î|D)/i,
  abbreviated: /^(Î\.?\s?d\.?\s?C\.?|Î\.?\s?e\.?\s?n\.?|D\.?\s?C\.?|e\.?\s?n\.?)/i,
  wide: /^(Înainte de Cristos|Înaintea erei noastre|După Cristos|Era noastră)/i
}, s4e = {
  any: [/^ÎC/i, /^DC/i],
  wide: [
    /^(Înainte de Cristos|Înaintea erei noastre)/i,
    /^(După Cristos|Era noastră)/i
  ]
}, l4e = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^trimestrul [1234]/i
}, d4e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, c4e = {
  narrow: /^[ifmaasond]/i,
  abbreviated: /^(ian|feb|mar|apr|mai|iun|iul|aug|sep|oct|noi|dec)/i,
  wide: /^(ianuarie|februarie|martie|aprilie|mai|iunie|iulie|august|septembrie|octombrie|noiembrie|decembrie)/i
}, u4e = {
  narrow: [
    /^i/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ia/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^mai/i,
    /^iun/i,
    /^iul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, f4e = {
  narrow: /^[dlmjvs]/i,
  short: /^(d|l|ma|mi|j|v|s)/i,
  abbreviated: /^(dum|lun|mar|mie|jo|vi|sâ)/i,
  wide: /^(duminica|luni|marţi|miercuri|joi|vineri|sâmbătă)/i
}, m4e = {
  narrow: [/^d/i, /^l/i, /^m/i, /^m/i, /^j/i, /^v/i, /^s/i],
  any: [/^d/i, /^l/i, /^ma/i, /^mi/i, /^j/i, /^v/i, /^s/i]
}, h4e = {
  narrow: /^(a|p|mn|a|(dimineaţa|după-amiaza|seara|noaptea))/i,
  any: /^([ap]\.?\s?m\.?|miezul nopții|amiaza|(dimineaţa|după-amiaza|seara|noaptea))/i
}, p4e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn/i,
    noon: /amiaza/i,
    morning: /dimineaţa/i,
    afternoon: /după-amiaza/i,
    evening: /seara/i,
    night: /noaptea/i
  }
}, g4e = {
  ordinalNumber: he({
    matchPattern: r4e,
    parsePattern: a4e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: o4e,
    defaultMatchWidth: "wide",
    parsePatterns: s4e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: l4e,
    defaultMatchWidth: "wide",
    parsePatterns: d4e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: c4e,
    defaultMatchWidth: "wide",
    parsePatterns: u4e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: f4e,
    defaultMatchWidth: "wide",
    parsePatterns: m4e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: h4e,
    defaultMatchWidth: "any",
    parsePatterns: p4e,
    defaultParseWidth: "any"
  })
}, y4e = {
  code: "ro",
  formatDistance: H3e,
  formatLong: X3e,
  formatRelative: K3e,
  localize: i4e,
  match: g4e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
};
function wl(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  const n = e % 10, i = e % 100;
  return n === 1 && i !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (i < 10 || i > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function Dn(t) {
  return (e, n) => n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? t.future ? wl(t.future, e) : "через " + wl(t.regular, e) : t.past ? wl(t.past, e) : wl(t.regular, e) + " назад" : wl(t.regular, e);
}
const v4e = {
  lessThanXSeconds: Dn({
    regular: {
      one: "меньше секунды",
      singularNominative: "меньше {{count}} секунды",
      singularGenitive: "меньше {{count}} секунд",
      pluralGenitive: "меньше {{count}} секунд"
    },
    future: {
      one: "меньше, чем через секунду",
      singularNominative: "меньше, чем через {{count}} секунду",
      singularGenitive: "меньше, чем через {{count}} секунды",
      pluralGenitive: "меньше, чем через {{count}} секунд"
    }
  }),
  xSeconds: Dn({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунды",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду назад",
      singularGenitive: "{{count}} секунды назад",
      pluralGenitive: "{{count}} секунд назад"
    },
    future: {
      singularNominative: "через {{count}} секунду",
      singularGenitive: "через {{count}} секунды",
      pluralGenitive: "через {{count}} секунд"
    }
  }),
  halfAMinute: (t, e) => e != null && e.addSuffix ? e.comparison && e.comparison > 0 ? "через полминуты" : "полминуты назад" : "полминуты",
  lessThanXMinutes: Dn({
    regular: {
      one: "меньше минуты",
      singularNominative: "меньше {{count}} минуты",
      singularGenitive: "меньше {{count}} минут",
      pluralGenitive: "меньше {{count}} минут"
    },
    future: {
      one: "меньше, чем через минуту",
      singularNominative: "меньше, чем через {{count}} минуту",
      singularGenitive: "меньше, чем через {{count}} минуты",
      pluralGenitive: "меньше, чем через {{count}} минут"
    }
  }),
  xMinutes: Dn({
    regular: {
      singularNominative: "{{count}} минута",
      singularGenitive: "{{count}} минуты",
      pluralGenitive: "{{count}} минут"
    },
    past: {
      singularNominative: "{{count}} минуту назад",
      singularGenitive: "{{count}} минуты назад",
      pluralGenitive: "{{count}} минут назад"
    },
    future: {
      singularNominative: "через {{count}} минуту",
      singularGenitive: "через {{count}} минуты",
      pluralGenitive: "через {{count}} минут"
    }
  }),
  aboutXHours: Dn({
    regular: {
      singularNominative: "около {{count}} часа",
      singularGenitive: "около {{count}} часов",
      pluralGenitive: "около {{count}} часов"
    },
    future: {
      singularNominative: "приблизительно через {{count}} час",
      singularGenitive: "приблизительно через {{count}} часа",
      pluralGenitive: "приблизительно через {{count}} часов"
    }
  }),
  xHours: Dn({
    regular: {
      singularNominative: "{{count}} час",
      singularGenitive: "{{count}} часа",
      pluralGenitive: "{{count}} часов"
    }
  }),
  xDays: Dn({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} дня",
      pluralGenitive: "{{count}} дней"
    }
  }),
  aboutXWeeks: Dn({
    regular: {
      singularNominative: "около {{count}} недели",
      singularGenitive: "около {{count}} недель",
      pluralGenitive: "около {{count}} недель"
    },
    future: {
      singularNominative: "приблизительно через {{count}} неделю",
      singularGenitive: "приблизительно через {{count}} недели",
      pluralGenitive: "приблизительно через {{count}} недель"
    }
  }),
  xWeeks: Dn({
    regular: {
      singularNominative: "{{count}} неделя",
      singularGenitive: "{{count}} недели",
      pluralGenitive: "{{count}} недель"
    }
  }),
  aboutXMonths: Dn({
    regular: {
      singularNominative: "около {{count}} месяца",
      singularGenitive: "около {{count}} месяцев",
      pluralGenitive: "около {{count}} месяцев"
    },
    future: {
      singularNominative: "приблизительно через {{count}} месяц",
      singularGenitive: "приблизительно через {{count}} месяца",
      pluralGenitive: "приблизительно через {{count}} месяцев"
    }
  }),
  xMonths: Dn({
    regular: {
      singularNominative: "{{count}} месяц",
      singularGenitive: "{{count}} месяца",
      pluralGenitive: "{{count}} месяцев"
    }
  }),
  aboutXYears: Dn({
    regular: {
      singularNominative: "около {{count}} года",
      singularGenitive: "около {{count}} лет",
      pluralGenitive: "около {{count}} лет"
    },
    future: {
      singularNominative: "приблизительно через {{count}} год",
      singularGenitive: "приблизительно через {{count}} года",
      pluralGenitive: "приблизительно через {{count}} лет"
    }
  }),
  xYears: Dn({
    regular: {
      singularNominative: "{{count}} год",
      singularGenitive: "{{count}} года",
      pluralGenitive: "{{count}} лет"
    }
  }),
  overXYears: Dn({
    regular: {
      singularNominative: "больше {{count}} года",
      singularGenitive: "больше {{count}} лет",
      pluralGenitive: "больше {{count}} лет"
    },
    future: {
      singularNominative: "больше, чем через {{count}} год",
      singularGenitive: "больше, чем через {{count}} года",
      pluralGenitive: "больше, чем через {{count}} лет"
    }
  }),
  almostXYears: Dn({
    regular: {
      singularNominative: "почти {{count}} год",
      singularGenitive: "почти {{count}} года",
      pluralGenitive: "почти {{count}} лет"
    },
    future: {
      singularNominative: "почти через {{count}} год",
      singularGenitive: "почти через {{count}} года",
      pluralGenitive: "почти через {{count}} лет"
    }
  })
}, b4e = (t, e, n) => v4e[t](e, n), w4e = {
  full: "EEEE, d MMMM y 'г.'",
  long: "d MMMM y 'г.'",
  medium: "d MMM y 'г.'",
  short: "dd.MM.y"
}, k4e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, x4e = {
  any: "{{date}}, {{time}}"
}, _4e = {
  date: T({
    formats: w4e,
    defaultWidth: "full"
  }),
  time: T({
    formats: k4e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: x4e,
    defaultWidth: "any"
  })
}, h0 = [
  "воскресенье",
  "понедельник",
  "вторник",
  "среду",
  "четверг",
  "пятницу",
  "субботу"
];
function M4e(t) {
  const e = h0[t];
  switch (t) {
    case 0:
      return "'в прошлое " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в прошлый " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в прошлую " + e + " в' p";
  }
}
function N2(t) {
  const e = h0[t];
  return t === 2 ? "'во " + e + " в' p" : "'в " + e + " в' p";
}
function C4e(t) {
  const e = h0[t];
  switch (t) {
    case 0:
      return "'в следующее " + e + " в' p";
    case 1:
    case 2:
    case 4:
      return "'в следующий " + e + " в' p";
    case 3:
    case 5:
    case 6:
      return "'в следующую " + e + " в' p";
  }
}
const P4e = {
  lastWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? N2(i) : M4e(i);
  },
  yesterday: "'вчера в' p",
  today: "'сегодня в' p",
  tomorrow: "'завтра в' p",
  nextWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? N2(i) : C4e(i);
  },
  other: "P"
}, S4e = (t, e, n, i) => {
  const r = P4e[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, N4e = {
  narrow: ["до н.э.", "н.э."],
  abbreviated: ["до н. э.", "н. э."],
  wide: ["до нашей эры", "нашей эры"]
}, $4e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, D4e = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "март",
    "апр.",
    "май",
    "июнь",
    "июль",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "январь",
    "февраль",
    "март",
    "апрель",
    "май",
    "июнь",
    "июль",
    "август",
    "сентябрь",
    "октябрь",
    "ноябрь",
    "декабрь"
  ]
}, E4e = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв.",
    "фев.",
    "мар.",
    "апр.",
    "мая",
    "июн.",
    "июл.",
    "авг.",
    "сент.",
    "окт.",
    "нояб.",
    "дек."
  ],
  wide: [
    "января",
    "февраля",
    "марта",
    "апреля",
    "мая",
    "июня",
    "июля",
    "августа",
    "сентября",
    "октября",
    "ноября",
    "декабря"
  ]
}, T4e = {
  narrow: ["В", "П", "В", "С", "Ч", "П", "С"],
  short: ["вс", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["вск", "пнд", "втр", "срд", "чтв", "птн", "суб"],
  wide: [
    "воскресенье",
    "понедельник",
    "вторник",
    "среда",
    "четверг",
    "пятница",
    "суббота"
  ]
}, O4e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утро",
    afternoon: "день",
    evening: "веч.",
    night: "ночь"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утро",
    afternoon: "день",
    evening: "вечер",
    night: "ночь"
  }
}, W4e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "полн.",
    noon: "полд.",
    morning: "утра",
    afternoon: "дня",
    evening: "веч.",
    night: "ночи"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "полночь",
    noon: "полдень",
    morning: "утра",
    afternoon: "дня",
    evening: "вечера",
    night: "ночи"
  }
}, A4e = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  let r;
  return i === "date" ? r = "-е" : i === "week" || i === "minute" || i === "second" ? r = "-я" : r = "-й", n + r;
}, L4e = {
  ordinalNumber: A4e,
  era: C({
    values: N4e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: $4e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: D4e,
    defaultWidth: "wide",
    formattingValues: E4e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: T4e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: O4e,
    defaultWidth: "any",
    formattingValues: W4e,
    defaultFormattingWidth: "wide"
  })
}, I4e = /^(\d+)(-?(е|я|й|ое|ье|ая|ья|ый|ой|ий|ый))?/i, R4e = /\d+/i, j4e = {
  narrow: /^((до )?н\.?\s?э\.?)/i,
  abbreviated: /^((до )?н\.?\s?э\.?)/i,
  wide: /^(до нашей эры|нашей эры|наша эра)/i
}, F4e = {
  any: [/^д/i, /^н/i]
}, z4e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[ыои]?й?)? кв.?/i,
  wide: /^[1234](-?[ыои]?й?)? квартал/i
}, V4e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, H4e = {
  narrow: /^[яфмаисонд]/i,
  abbreviated: /^(янв|фев|март?|апр|ма[йя]|июн[ья]?|июл[ья]?|авг|сент?|окт|нояб?|дек)\.?/i,
  wide: /^(январ[ья]|феврал[ья]|марта?|апрел[ья]|ма[йя]|июн[ья]|июл[ья]|августа?|сентябр[ья]|октябр[ья]|октябр[ья]|ноябр[ья]|декабр[ья])/i
}, B4e = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^я/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^ма[йя]/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, q4e = {
  narrow: /^[впсч]/i,
  short: /^(вс|во|пн|по|вт|ср|чт|че|пт|пя|сб|су)\.?/i,
  abbreviated: /^(вск|вос|пнд|пон|втр|вто|срд|сре|чтв|чет|птн|пят|суб).?/i,
  wide: /^(воскресень[ея]|понедельника?|вторника?|сред[аы]|четверга?|пятниц[аы]|суббот[аы])/i
}, G4e = {
  narrow: [/^в/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^в[ос]/i, /^п[он]/i, /^в/i, /^ср/i, /^ч/i, /^п[ят]/i, /^с[уб]/i]
}, X4e = {
  narrow: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  abbreviated: /^([дп]п|полн\.?|полд\.?|утр[оа]|день|дня|веч\.?|ноч[ьи])/i,
  wide: /^([дп]п|полночь|полдень|утр[оа]|день|дня|вечера?|ноч[ьи])/i
}, Y4e = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^полн/i,
    noon: /^полд/i,
    morning: /^у/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, K4e = {
  ordinalNumber: he({
    matchPattern: I4e,
    parsePattern: R4e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: j4e,
    defaultMatchWidth: "wide",
    parsePatterns: F4e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: z4e,
    defaultMatchWidth: "wide",
    parsePatterns: V4e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: H4e,
    defaultMatchWidth: "wide",
    parsePatterns: B4e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: q4e,
    defaultMatchWidth: "wide",
    parsePatterns: G4e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: X4e,
    defaultMatchWidth: "wide",
    parsePatterns: Y4e,
    defaultParseWidth: "any"
  })
}, U4e = {
  code: "ru",
  formatDistance: b4e,
  formatLong: _4e,
  formatRelative: S4e,
  localize: L4e,
  match: K4e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, J4e = {
  lessThanXSeconds: {
    one: "unnit go ovtta sekundda",
    other: "unnit go {{count}} sekundda"
  },
  xSeconds: {
    one: "sekundda",
    other: "{{count}} sekundda"
  },
  halfAMinute: "bealle minuhta",
  lessThanXMinutes: {
    one: "unnit go bealle minuhta",
    other: "unnit go {{count}} minuhta"
  },
  xMinutes: {
    one: "minuhta",
    other: "{{count}} minuhta"
  },
  aboutXHours: {
    one: "sullii ovtta diimmu",
    other: "sullii {{count}} diimmu"
  },
  xHours: {
    one: "diimmu",
    other: "{{count}} diimmu"
  },
  xDays: {
    one: "beaivvi",
    other: "{{count}} beaivvi"
  },
  aboutXWeeks: {
    one: "sullii ovtta vahku",
    other: "sullii {{count}} vahku"
  },
  xWeeks: {
    one: "vahku",
    other: "{{count}} vahku"
  },
  aboutXMonths: {
    one: "sullii ovtta mánu",
    other: "sullii {{count}} mánu"
  },
  xMonths: {
    one: "mánu",
    other: "{{count}} mánu"
  },
  aboutXYears: {
    one: "sullii ovtta jagi",
    other: "sullii {{count}} jagi"
  },
  xYears: {
    one: "jagi",
    other: "{{count}} jagi"
  },
  overXYears: {
    one: "guhkit go jagi",
    other: "guhkit go {{count}} jagi"
  },
  almostXYears: {
    one: "measta jagi",
    other: "measta {{count}} jagi"
  }
}, Q4e = (t, e, n) => {
  let i;
  const r = J4e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "geahčen " + i : i + " áigi" : i;
}, Z4e = {
  full: "EEEE MMMM d. 'b.' y",
  long: "MMMM d. 'b.' y",
  medium: "MMM d. 'b.' y",
  short: "dd.MM.y"
}, e5e = {
  full: "'dii.' HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, t5e = {
  full: "{{date}} 'dii.' {{time}}",
  long: "{{date}} 'dii.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, n5e = {
  date: T({
    formats: Z4e,
    defaultWidth: "full"
  }),
  time: T({
    formats: e5e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: t5e,
    defaultWidth: "full"
  })
}, i5e = {
  lastWeek: "'ovddit' eeee 'dii.' p",
  yesterday: "'ikte dii.' p",
  today: "'odne dii.' p",
  tomorrow: "'ihtin dii.' p",
  nextWeek: "EEEE 'dii.' p",
  other: "P"
}, r5e = (t, e, n, i) => i5e[t], a5e = {
  narrow: ["o.Kr.", "m.Kr."],
  abbreviated: ["o.Kr.", "m.Kr."],
  wide: ["ovdal Kristusa", "maŋŋel Kristusa"]
}, o5e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. kvartála", "2. kvartála", "3. kvartála", "4. kvartála"]
}, s5e = {
  narrow: ["O", "G", "N", "C", "M", "G", "S", "B", "Č", "G", "S", "J"],
  abbreviated: [
    "ođđa",
    "guov",
    "njuk",
    "cuo",
    "mies",
    "geas",
    "suoi",
    "borg",
    "čakč",
    "golg",
    "skáb",
    "juov"
  ],
  wide: [
    "ođđajagemánnu",
    "guovvamánnu",
    "njukčamánnu",
    "cuoŋománnu",
    "miessemánnu",
    "geassemánnu",
    "suoidnemánnu",
    "borgemánnu",
    "čakčamánnu",
    "golggotmánnu",
    "skábmamánnu",
    "juovlamánnu"
  ]
}, l5e = {
  narrow: ["S", "V", "M", "G", "D", "B", "L"],
  short: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  abbreviated: ["sotn", "vuos", "maŋ", "gask", "duor", "bear", "láv"],
  wide: [
    "sotnabeaivi",
    "vuossárga",
    "maŋŋebárga",
    "gaskavahkku",
    "duorastat",
    "bearjadat",
    "lávvardat"
  ]
}, d5e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "gaskaidja",
    noon: "gaskabeaivi",
    morning: "iđđes",
    afternoon: "maŋŋel gaska.",
    evening: "eahkes",
    night: "ihkku"
  },
  abbreviated: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeaivvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabea.",
    evening: "eahkes",
    night: "ihkku"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "gaskaidja",
    noon: "gaskabeavvi",
    morning: "iđđes",
    afternoon: "maŋŋel gaskabeaivvi",
    evening: "eahkes",
    night: "ihkku"
  }
}, c5e = (t, e) => Number(t) + ".", u5e = {
  ordinalNumber: c5e,
  era: C({
    values: a5e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: o5e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: s5e,
    defaultWidth: "wide"
  }),
  day: C({
    values: l5e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: d5e,
    defaultWidth: "wide"
  })
}, f5e = /^(\d+)\.?/i, m5e = /\d+/i, h5e = {
  narrow: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  abbreviated: /^(o\.? ?Kr\.?|m\.? ?Kr\.?)/i,
  wide: /^(ovdal Kristusa|ovdal min áiggi|maŋŋel Kristusa|min áigi)/i
}, p5e = {
  any: [/^o/i, /^m/i]
}, g5e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](\.)? kvartála/i
}, y5e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, v5e = {
  narrow: /^[ogncmsbčj]/i,
  abbreviated: /^(ođđa|guov|njuk|cuo|mies|geas|suoi|borg|čakč|golg|skáb|juov)\.?/i,
  wide: /^(ođđajagemánnu|guovvamánnu|njukčamánnu|cuoŋománnu|miessemánnu|geassemánnu|suoidnemánnu|borgemánnu|čakčamánnu|golggotmánnu|skábmamánnu|juovlamánnu)/i
}, b5e = {
  narrow: [
    /^o/i,
    /^g/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^g/i,
    /^s/i,
    /^b/i,
    /^č/i,
    /^g/i,
    /^s/i,
    /^j/i
  ],
  any: [
    /^o/i,
    /^gu/i,
    /^n/i,
    /^c/i,
    /^m/i,
    /^ge/i,
    /^su/i,
    /^b/i,
    /^č/i,
    /^go/i,
    /^sk/i,
    /^j/i
  ]
}, w5e = {
  narrow: /^[svmgdbl]/i,
  short: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  abbreviated: /^(sotn|vuos|maŋ|gask|duor|bear|láv)/i,
  wide: /^(sotnabeaivi|vuossárga|maŋŋebárga|gaskavahkku|duorastat|bearjadat|lávvardat)/i
}, k5e = {
  any: [/^s/i, /^v/i, /^m/i, /^g/i, /^d/i, /^b/i, /^l/i]
}, x5e = {
  narrow: /^(gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku)|[ap])/i,
  any: /^([ap]\.?\s?m\.?|gaskaidja|gaskabeaivvi|(på) (iđđes|maŋŋel gaskabeaivvi|eahkes|ihkku))/i
}, _5e = {
  any: {
    am: /^a(\.?\s?m\.?)?$/i,
    pm: /^p(\.?\s?m\.?)?$/i,
    midnight: /^gaskai/i,
    noon: /^gaskab/i,
    morning: /iđđes/i,
    afternoon: /maŋŋel gaskabeaivvi/i,
    evening: /eahkes/i,
    night: /ihkku/i
  }
}, M5e = {
  ordinalNumber: he({
    matchPattern: f5e,
    parsePattern: m5e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: h5e,
    defaultMatchWidth: "wide",
    parsePatterns: p5e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: g5e,
    defaultMatchWidth: "wide",
    parsePatterns: y5e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: v5e,
    defaultMatchWidth: "wide",
    parsePatterns: b5e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: w5e,
    defaultMatchWidth: "wide",
    parsePatterns: k5e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: x5e,
    defaultMatchWidth: "any",
    parsePatterns: _5e,
    defaultParseWidth: "any"
  })
}, C5e = {
  code: "se",
  formatDistance: Q4e,
  formatLong: n5e,
  formatRelative: r5e,
  localize: u5e,
  match: M5e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function P5e(t, e) {
  return e === 1 && t.one ? t.one : e >= 2 && e <= 4 && t.twoFour ? t.twoFour : t.other;
}
function p1(t, e, n) {
  return P5e(t, e)[n].replace("{{count}}", String(e));
}
function S5e(t) {
  return ["lessThan", "about", "over", "almost"].filter(
    function(n) {
      return !!t.match(new RegExp("^" + n));
    }
  )[0];
}
function g1(t) {
  let e = "";
  return t === "almost" && (e = "takmer"), t === "about" && (e = "približne"), e.length > 0 ? e + " " : "";
}
function y1(t) {
  let e = "";
  return t === "lessThan" && (e = "menej než"), t === "over" && (e = "viac než"), e.length > 0 ? e + " " : "";
}
function N5e(t) {
  return t.charAt(0).toLowerCase() + t.slice(1);
}
const $5e = {
  xSeconds: {
    one: {
      present: "sekunda",
      past: "sekundou",
      future: "sekundu"
    },
    twoFour: {
      present: "{{count}} sekundy",
      past: "{{count}} sekundami",
      future: "{{count}} sekundy"
    },
    other: {
      present: "{{count}} sekúnd",
      past: "{{count}} sekundami",
      future: "{{count}} sekúnd"
    }
  },
  halfAMinute: {
    other: {
      present: "pol minúty",
      past: "pol minútou",
      future: "pol minúty"
    }
  },
  xMinutes: {
    one: {
      present: "minúta",
      past: "minútou",
      future: "minútu"
    },
    twoFour: {
      present: "{{count}} minúty",
      past: "{{count}} minútami",
      future: "{{count}} minúty"
    },
    other: {
      present: "{{count}} minút",
      past: "{{count}} minútami",
      future: "{{count}} minút"
    }
  },
  xHours: {
    one: {
      present: "hodina",
      past: "hodinou",
      future: "hodinu"
    },
    twoFour: {
      present: "{{count}} hodiny",
      past: "{{count}} hodinami",
      future: "{{count}} hodiny"
    },
    other: {
      present: "{{count}} hodín",
      past: "{{count}} hodinami",
      future: "{{count}} hodín"
    }
  },
  xDays: {
    one: {
      present: "deň",
      past: "dňom",
      future: "deň"
    },
    twoFour: {
      present: "{{count}} dni",
      past: "{{count}} dňami",
      future: "{{count}} dni"
    },
    other: {
      present: "{{count}} dní",
      past: "{{count}} dňami",
      future: "{{count}} dní"
    }
  },
  xWeeks: {
    one: {
      present: "týždeň",
      past: "týždňom",
      future: "týždeň"
    },
    twoFour: {
      present: "{{count}} týždne",
      past: "{{count}} týždňami",
      future: "{{count}} týždne"
    },
    other: {
      present: "{{count}} týždňov",
      past: "{{count}} týždňami",
      future: "{{count}} týždňov"
    }
  },
  xMonths: {
    one: {
      present: "mesiac",
      past: "mesiacom",
      future: "mesiac"
    },
    twoFour: {
      present: "{{count}} mesiace",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiace"
    },
    other: {
      present: "{{count}} mesiacov",
      past: "{{count}} mesiacmi",
      future: "{{count}} mesiacov"
    }
  },
  xYears: {
    one: {
      present: "rok",
      past: "rokom",
      future: "rok"
    },
    twoFour: {
      present: "{{count}} roky",
      past: "{{count}} rokmi",
      future: "{{count}} roky"
    },
    other: {
      present: "{{count}} rokov",
      past: "{{count}} rokmi",
      future: "{{count}} rokov"
    }
  }
}, D5e = (t, e, n) => {
  const i = S5e(t) || "", r = N5e(t.substring(i.length)), a = $5e[r];
  return n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? g1(i) + "o " + y1(i) + p1(a, e, "future") : g1(i) + "pred " + y1(i) + p1(a, e, "past") : g1(i) + y1(i) + p1(a, e, "present");
}, E5e = {
  full: "EEEE d. MMMM y",
  long: "d. MMMM y",
  medium: "d. M. y",
  short: "d. M. y"
}, T5e = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, O5e = {
  full: "{{date}}, {{time}}",
  long: "{{date}}, {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}} {{time}}"
}, W5e = {
  date: T({
    formats: E5e,
    defaultWidth: "full"
  }),
  time: T({
    formats: T5e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: O5e,
    defaultWidth: "full"
  })
}, p0 = [
  "nedeľu",
  "pondelok",
  "utorok",
  "stredu",
  "štvrtok",
  "piatok",
  "sobotu"
];
function A5e(t) {
  const e = p0[t];
  switch (t) {
    case 0:
    /* Sun */
    case 3:
    /* Wed */
    case 6:
      return "'minulú " + e + " o' p";
    default:
      return "'minulý' eeee 'o' p";
  }
}
function $2(t) {
  const e = p0[t];
  return t === 4 ? "'vo' eeee 'o' p" : "'v " + e + " o' p";
}
function L5e(t) {
  const e = p0[t];
  switch (t) {
    case 0:
    /* Sun */
    case 4:
    /* Wed */
    case 6:
      return "'budúcu " + e + " o' p";
    default:
      return "'budúci' eeee 'o' p";
  }
}
const I5e = {
  lastWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? $2(i) : A5e(i);
  },
  yesterday: "'včera o' p",
  today: "'dnes o' p",
  tomorrow: "'zajtra o' p",
  nextWeek: (t, e, n) => {
    const i = t.getDay();
    return Lt(t, e, n) ? $2(i) : L5e(i);
  },
  other: "P"
}, R5e = (t, e, n, i) => {
  const r = I5e[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, j5e = {
  narrow: ["pred Kr.", "po Kr."],
  abbreviated: ["pred Kr.", "po Kr."],
  wide: ["pred Kristom", "po Kristovi"]
}, F5e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1. štvrťrok", "2. štvrťrok", "3. štvrťrok", "4. štvrťrok"]
}, z5e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "január",
    "február",
    "marec",
    "apríl",
    "máj",
    "jún",
    "júl",
    "august",
    "september",
    "október",
    "november",
    "december"
  ]
}, V5e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "máj",
    "jún",
    "júl",
    "aug",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januára",
    "februára",
    "marca",
    "apríla",
    "mája",
    "júna",
    "júla",
    "augusta",
    "septembra",
    "októbra",
    "novembra",
    "decembra"
  ]
}, H5e = {
  narrow: ["n", "p", "u", "s", "š", "p", "s"],
  short: ["ne", "po", "ut", "st", "št", "pi", "so"],
  abbreviated: ["ne", "po", "ut", "st", "št", "pi", "so"],
  wide: [
    "nedeľa",
    "pondelok",
    "utorok",
    "streda",
    "štvrtok",
    "piatok",
    "sobota"
  ]
}, B5e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "noc"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "poln.",
    noon: "pol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "noc"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "polnoc",
    noon: "poludnie",
    morning: "ráno",
    afternoon: "popoludnie",
    evening: "večer",
    night: "noc"
  }
}, q5e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "nap.",
    morning: "ráno",
    afternoon: "pop.",
    evening: "več.",
    night: "v n."
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "o poln.",
    noon: "napol.",
    morning: "ráno",
    afternoon: "popol.",
    evening: "večer",
    night: "v noci"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "o polnoci",
    noon: "napoludnie",
    morning: "ráno",
    afternoon: "popoludní",
    evening: "večer",
    night: "v noci"
  }
}, G5e = (t, e) => Number(t) + ".", X5e = {
  ordinalNumber: G5e,
  era: C({
    values: j5e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: F5e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: z5e,
    defaultWidth: "wide",
    formattingValues: V5e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: H5e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: B5e,
    defaultWidth: "wide",
    formattingValues: q5e,
    defaultFormattingWidth: "wide"
  })
}, Y5e = /^(\d+)\.?/i, K5e = /\d+/i, U5e = {
  narrow: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  abbreviated: /^(pred Kr\.|pred n\. l\.|po Kr\.|n\. l\.)/i,
  wide: /^(pred Kristom|pred na[šs][íi]m letopo[čc]tom|po Kristovi|n[áa][šs]ho letopo[čc]tu)/i
}, J5e = {
  any: [/^pr/i, /^(po|n)/i]
}, Q5e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]\. [šs]tvr[ťt]rok/i
}, Z5e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, e6e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|m[áa]j|j[úu]n|j[úu]l|aug|sep|okt|nov|dec)/i,
  wide: /^(janu[áa]ra?|febru[áa]ra?|(marec|marca)|apr[íi]la?|m[áa]ja?|j[úu]na?|j[úu]la?|augusta?|(september|septembra)|(okt[óo]ber|okt[óo]bra)|(november|novembra)|(december|decembra))/i
}, t6e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^m[áa]j/i,
    /^j[úu]n/i,
    /^j[úu]l/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, n6e = {
  narrow: /^[npusšp]/i,
  short: /^(ne|po|ut|st|št|pi|so)/i,
  abbreviated: /^(ne|po|ut|st|št|pi|so)/i,
  wide: /^(nede[ľl]a|pondelok|utorok|streda|[šs]tvrtok|piatok|sobota])/i
}, i6e = {
  narrow: [/^n/i, /^p/i, /^u/i, /^s/i, /^š/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^u/i, /^st/i, /^(št|stv)/i, /^pi/i, /^so/i]
}, r6e = {
  narrow: /^(am|pm|(o )?poln\.?|(nap\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]\.?|(v n\.?|noc))/i,
  abbreviated: /^(am|pm|(o )?poln\.?|(napol\.?|pol\.?)|r[áa]no|pop\.?|ve[čc]er|(v )?noci?)/i,
  any: /^(am|pm|(o )?polnoci?|(na)?poludnie|r[áa]no|popoludn(ie|í|i)|ve[čc]er|(v )?noci?)/i
}, a6e = {
  any: {
    am: /^am/i,
    pm: /^pm/i,
    midnight: /poln/i,
    noon: /^(nap|(na)?pol(\.|u))/i,
    morning: /^r[áa]no/i,
    afternoon: /^pop/i,
    evening: /^ve[čc]/i,
    night: /^(noc|v n\.)/i
  }
}, o6e = {
  ordinalNumber: he({
    matchPattern: Y5e,
    parsePattern: K5e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: U5e,
    defaultMatchWidth: "wide",
    parsePatterns: J5e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: Q5e,
    defaultMatchWidth: "wide",
    parsePatterns: Z5e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: e6e,
    defaultMatchWidth: "wide",
    parsePatterns: t6e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: n6e,
    defaultMatchWidth: "wide",
    parsePatterns: i6e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: r6e,
    defaultMatchWidth: "any",
    parsePatterns: a6e,
    defaultParseWidth: "any"
  })
}, s6e = {
  code: "sk",
  formatDistance: D5e,
  formatLong: W5e,
  formatRelative: R5e,
  localize: X5e,
  match: o6e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function l6e(t) {
  return t.one !== void 0;
}
const d6e = {
  lessThanXSeconds: {
    present: {
      one: "manj kot {{count}} sekunda",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    },
    past: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundama",
      few: "manj kot {{count}} sekundami",
      other: "manj kot {{count}} sekundami"
    },
    future: {
      one: "manj kot {{count}} sekundo",
      two: "manj kot {{count}} sekundi",
      few: "manj kot {{count}} sekunde",
      other: "manj kot {{count}} sekund"
    }
  },
  xSeconds: {
    present: {
      one: "{{count}} sekunda",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    },
    past: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundama",
      few: "{{count}} sekundami",
      other: "{{count}} sekundami"
    },
    future: {
      one: "{{count}} sekundo",
      two: "{{count}} sekundi",
      few: "{{count}} sekunde",
      other: "{{count}} sekund"
    }
  },
  halfAMinute: "pol minute",
  lessThanXMinutes: {
    present: {
      one: "manj kot {{count}} minuta",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    },
    past: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minutama",
      few: "manj kot {{count}} minutami",
      other: "manj kot {{count}} minutami"
    },
    future: {
      one: "manj kot {{count}} minuto",
      two: "manj kot {{count}} minuti",
      few: "manj kot {{count}} minute",
      other: "manj kot {{count}} minut"
    }
  },
  xMinutes: {
    present: {
      one: "{{count}} minuta",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    },
    past: {
      one: "{{count}} minuto",
      two: "{{count}} minutama",
      few: "{{count}} minutami",
      other: "{{count}} minutami"
    },
    future: {
      one: "{{count}} minuto",
      two: "{{count}} minuti",
      few: "{{count}} minute",
      other: "{{count}} minut"
    }
  },
  aboutXHours: {
    present: {
      one: "približno {{count}} ura",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    },
    past: {
      one: "približno {{count}} uro",
      two: "približno {{count}} urama",
      few: "približno {{count}} urami",
      other: "približno {{count}} urami"
    },
    future: {
      one: "približno {{count}} uro",
      two: "približno {{count}} uri",
      few: "približno {{count}} ure",
      other: "približno {{count}} ur"
    }
  },
  xHours: {
    present: {
      one: "{{count}} ura",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    },
    past: {
      one: "{{count}} uro",
      two: "{{count}} urama",
      few: "{{count}} urami",
      other: "{{count}} urami"
    },
    future: {
      one: "{{count}} uro",
      two: "{{count}} uri",
      few: "{{count}} ure",
      other: "{{count}} ur"
    }
  },
  xDays: {
    present: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    },
    past: {
      one: "{{count}} dnem",
      two: "{{count}} dnevoma",
      few: "{{count}} dnevi",
      other: "{{count}} dnevi"
    },
    future: {
      one: "{{count}} dan",
      two: "{{count}} dni",
      few: "{{count}} dni",
      other: "{{count}} dni"
    }
  },
  // no tenses for weeks?
  aboutXWeeks: {
    one: "približno {{count}} teden",
    two: "približno {{count}} tedna",
    few: "približno {{count}} tedne",
    other: "približno {{count}} tednov"
  },
  // no tenses for weeks?
  xWeeks: {
    one: "{{count}} teden",
    two: "{{count}} tedna",
    few: "{{count}} tedne",
    other: "{{count}} tednov"
  },
  aboutXMonths: {
    present: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    },
    past: {
      one: "približno {{count}} mesecem",
      two: "približno {{count}} mesecema",
      few: "približno {{count}} meseci",
      other: "približno {{count}} meseci"
    },
    future: {
      one: "približno {{count}} mesec",
      two: "približno {{count}} meseca",
      few: "približno {{count}} mesece",
      other: "približno {{count}} mesecev"
    }
  },
  xMonths: {
    present: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} meseci",
      other: "{{count}} mesecev"
    },
    past: {
      one: "{{count}} mesecem",
      two: "{{count}} mesecema",
      few: "{{count}} meseci",
      other: "{{count}} meseci"
    },
    future: {
      one: "{{count}} mesec",
      two: "{{count}} meseca",
      few: "{{count}} mesece",
      other: "{{count}} mesecev"
    }
  },
  aboutXYears: {
    present: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    },
    past: {
      one: "približno {{count}} letom",
      two: "približno {{count}} letoma",
      few: "približno {{count}} leti",
      other: "približno {{count}} leti"
    },
    future: {
      one: "približno {{count}} leto",
      two: "približno {{count}} leti",
      few: "približno {{count}} leta",
      other: "približno {{count}} let"
    }
  },
  xYears: {
    present: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    },
    past: {
      one: "{{count}} letom",
      two: "{{count}} letoma",
      few: "{{count}} leti",
      other: "{{count}} leti"
    },
    future: {
      one: "{{count}} leto",
      two: "{{count}} leti",
      few: "{{count}} leta",
      other: "{{count}} let"
    }
  },
  overXYears: {
    present: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    },
    past: {
      one: "več kot {{count}} letom",
      two: "več kot {{count}} letoma",
      few: "več kot {{count}} leti",
      other: "več kot {{count}} leti"
    },
    future: {
      one: "več kot {{count}} leto",
      two: "več kot {{count}} leti",
      few: "več kot {{count}} leta",
      other: "več kot {{count}} let"
    }
  },
  almostXYears: {
    present: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    },
    past: {
      one: "skoraj {{count}} letom",
      two: "skoraj {{count}} letoma",
      few: "skoraj {{count}} leti",
      other: "skoraj {{count}} leti"
    },
    future: {
      one: "skoraj {{count}} leto",
      two: "skoraj {{count}} leti",
      few: "skoraj {{count}} leta",
      other: "skoraj {{count}} let"
    }
  }
};
function c6e(t) {
  switch (t % 100) {
    case 1:
      return "one";
    case 2:
      return "two";
    case 3:
    case 4:
      return "few";
    default:
      return "other";
  }
}
const u6e = (t, e, n) => {
  let i = "", r = "present";
  n != null && n.addSuffix && (n.comparison && n.comparison > 0 ? (r = "future", i = "čez ") : (r = "past", i = "pred "));
  const a = d6e[t];
  if (typeof a == "string")
    i += a;
  else {
    const o = c6e(e);
    l6e(a) ? i += a[o].replace("{{count}}", String(e)) : i += a[r][o].replace("{{count}}", String(e));
  }
  return i;
}, f6e = {
  full: "EEEE, dd. MMMM y",
  long: "dd. MMMM y",
  medium: "d. MMM y",
  short: "d. MM. yy"
}, m6e = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, h6e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, p6e = {
  date: T({
    formats: f6e,
    defaultWidth: "full"
  }),
  time: T({
    formats: m6e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: h6e,
    defaultWidth: "full"
  })
}, g6e = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'prejšnjo nedeljo ob' p";
      case 3:
        return "'prejšnjo sredo ob' p";
      case 6:
        return "'prejšnjo soboto ob' p";
      default:
        return "'prejšnji' EEEE 'ob' p";
    }
  },
  yesterday: "'včeraj ob' p",
  today: "'danes ob' p",
  tomorrow: "'jutri ob' p",
  nextWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'naslednjo nedeljo ob' p";
      case 3:
        return "'naslednjo sredo ob' p";
      case 6:
        return "'naslednjo soboto ob' p";
      default:
        return "'naslednji' EEEE 'ob' p";
    }
  },
  other: "P"
}, y6e = (t, e, n, i) => {
  const r = g6e[t];
  return typeof r == "function" ? r(e) : r;
}, v6e = {
  narrow: ["pr. n. št.", "po n. št."],
  abbreviated: ["pr. n. št.", "po n. št."],
  wide: ["pred našim štetjem", "po našem štetju"]
}, b6e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1. čet.", "2. čet.", "3. čet.", "4. čet."],
  wide: ["1. četrtletje", "2. četrtletje", "3. četrtletje", "4. četrtletje"]
}, w6e = {
  narrow: ["j", "f", "m", "a", "m", "j", "j", "a", "s", "o", "n", "d"],
  abbreviated: [
    "jan.",
    "feb.",
    "mar.",
    "apr.",
    "maj",
    "jun.",
    "jul.",
    "avg.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januar",
    "februar",
    "marec",
    "april",
    "maj",
    "junij",
    "julij",
    "avgust",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, k6e = {
  narrow: ["n", "p", "t", "s", "č", "p", "s"],
  short: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  abbreviated: ["ned.", "pon.", "tor.", "sre.", "čet.", "pet.", "sob."],
  wide: [
    "nedelja",
    "ponedeljek",
    "torek",
    "sreda",
    "četrtek",
    "petek",
    "sobota"
  ]
}, x6e = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "j",
    afternoon: "p",
    evening: "v",
    night: "n"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "poln.",
    noon: "pold.",
    morning: "jut.",
    afternoon: "pop.",
    evening: "več.",
    night: "noč"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "polnoč",
    noon: "poldne",
    morning: "jutro",
    afternoon: "popoldne",
    evening: "večer",
    night: "noč"
  }
}, _6e = {
  narrow: {
    am: "d",
    pm: "p",
    midnight: "24.00",
    noon: "12.00",
    morning: "zj",
    afternoon: "p",
    evening: "zv",
    night: "po"
  },
  abbreviated: {
    am: "dop.",
    pm: "pop.",
    midnight: "opoln.",
    noon: "opold.",
    morning: "zjut.",
    afternoon: "pop.",
    evening: "zveč.",
    night: "ponoči"
  },
  wide: {
    am: "dop.",
    pm: "pop.",
    midnight: "opolnoči",
    noon: "opoldne",
    morning: "zjutraj",
    afternoon: "popoldan",
    evening: "zvečer",
    night: "ponoči"
  }
}, M6e = (t, e) => Number(t) + ".", C6e = {
  ordinalNumber: M6e,
  era: C({
    values: v6e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: b6e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: w6e,
    defaultWidth: "wide"
  }),
  day: C({
    values: k6e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: x6e,
    defaultWidth: "wide",
    formattingValues: _6e,
    defaultFormattingWidth: "wide"
  })
}, P6e = /^(\d+)\./i, S6e = /\d+/i, N6e = {
  abbreviated: /^(pr\. n\. št\.|po n\. št\.)/i,
  wide: /^(pred Kristusom|pred na[sš]im [sš]tetjem|po Kristusu|po na[sš]em [sš]tetju|na[sš]ega [sš]tetja)/i
}, $6e = {
  any: [/^pr/i, /^(po|na[sš]em)/i]
}, D6e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?[čc]et\.?/i,
  wide: /^[1234]\. [čc]etrtletje/i
}, E6e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, T6e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan\.|feb\.|mar\.|apr\.|maj|jun\.|jul\.|avg\.|sep\.|okt\.|nov\.|dec\.)/i,
  wide: /^(januar|februar|marec|april|maj|junij|julij|avgust|september|oktober|november|december)/i
}, O6e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  abbreviated: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  wide: [
    /^ja/i,
    /^fe/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, W6e = {
  narrow: /^[nptsčc]/i,
  short: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  abbreviated: /^(ned\.|pon\.|tor\.|sre\.|[cč]et\.|pet\.|sob\.)/i,
  wide: /^(nedelja|ponedeljek|torek|sreda|[cč]etrtek|petek|sobota)/i
}, A6e = {
  narrow: [/^n/i, /^p/i, /^t/i, /^s/i, /^[cč]/i, /^p/i, /^s/i],
  any: [/^n/i, /^po/i, /^t/i, /^sr/i, /^[cč]/i, /^pe/i, /^so/i]
}, L6e = {
  narrow: /^(d|po?|z?v|n|z?j|24\.00|12\.00)/i,
  any: /^(dop\.|pop\.|o?poln(\.|o[cč]i?)|o?pold(\.|ne)|z?ve[cč](\.|er)|(po)?no[cč]i?|popold(ne|an)|jut(\.|ro)|zjut(\.|raj))/i
}, I6e = {
  narrow: {
    am: /^d/i,
    pm: /^p/i,
    midnight: /^24/i,
    noon: /^12/i,
    morning: /^(z?j)/i,
    afternoon: /^p/i,
    evening: /^(z?v)/i,
    night: /^(n|po)/i
  },
  any: {
    am: /^dop\./i,
    pm: /^pop\./i,
    midnight: /^o?poln/i,
    noon: /^o?pold/i,
    morning: /j/i,
    afternoon: /^pop\./i,
    evening: /^z?ve/i,
    night: /(po)?no/i
  }
}, R6e = {
  ordinalNumber: he({
    matchPattern: P6e,
    parsePattern: S6e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: N6e,
    defaultMatchWidth: "wide",
    parsePatterns: $6e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: D6e,
    defaultMatchWidth: "wide",
    parsePatterns: E6e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: T6e,
    defaultMatchWidth: "wide",
    parsePatterns: O6e,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: W6e,
    defaultMatchWidth: "wide",
    parsePatterns: A6e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: L6e,
    defaultMatchWidth: "any",
    parsePatterns: I6e,
    defaultParseWidth: "any"
  })
}, j6e = {
  code: "sl",
  formatDistance: u6e,
  formatLong: p6e,
  formatRelative: y6e,
  localize: C6e,
  match: R6e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, F6e = {
  lessThanXSeconds: {
    one: "më pak se një sekondë",
    other: "më pak se {{count}} sekonda"
  },
  xSeconds: {
    one: "1 sekondë",
    other: "{{count}} sekonda"
  },
  halfAMinute: "gjysëm minuti",
  lessThanXMinutes: {
    one: "më pak se një minute",
    other: "më pak se {{count}} minuta"
  },
  xMinutes: {
    one: "1 minutë",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: "rreth 1 orë",
    other: "rreth {{count}} orë"
  },
  xHours: {
    one: "1 orë",
    other: "{{count}} orë"
  },
  xDays: {
    one: "1 ditë",
    other: "{{count}} ditë"
  },
  aboutXWeeks: {
    one: "rreth 1 javë",
    other: "rreth {{count}} javë"
  },
  xWeeks: {
    one: "1 javë",
    other: "{{count}} javë"
  },
  aboutXMonths: {
    one: "rreth 1 muaj",
    other: "rreth {{count}} muaj"
  },
  xMonths: {
    one: "1 muaj",
    other: "{{count}} muaj"
  },
  aboutXYears: {
    one: "rreth 1 vit",
    other: "rreth {{count}} vite"
  },
  xYears: {
    one: "1 vit",
    other: "{{count}} vite"
  },
  overXYears: {
    one: "mbi 1 vit",
    other: "mbi {{count}} vite"
  },
  almostXYears: {
    one: "pothuajse 1 vit",
    other: "pothuajse {{count}} vite"
  }
}, z6e = (t, e, n) => {
  let i;
  const r = F6e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "në " + i : i + " më parë" : i;
}, V6e = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, H6e = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, B6e = {
  full: "{{date}} 'në' {{time}}",
  long: "{{date}} 'në' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, q6e = {
  date: T({
    formats: V6e,
    defaultWidth: "full"
  }),
  time: T({
    formats: H6e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: B6e,
    defaultWidth: "full"
  })
}, G6e = {
  lastWeek: "'të' eeee 'e shkuar në' p",
  yesterday: "'dje në' p",
  today: "'sot në' p",
  tomorrow: "'nesër në' p",
  nextWeek: "eeee 'at' p",
  other: "P"
}, X6e = (t, e, n, i) => G6e[t], Y6e = {
  narrow: ["P", "M"],
  abbreviated: ["PK", "MK"],
  wide: ["Para Krishtit", "Mbas Krishtit"]
}, K6e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["4-mujori I", "4-mujori II", "4-mujori III", "4-mujori IV"]
}, U6e = {
  narrow: ["J", "S", "M", "P", "M", "Q", "K", "G", "S", "T", "N", "D"],
  abbreviated: [
    "Jan",
    "Shk",
    "Mar",
    "Pri",
    "Maj",
    "Qer",
    "Kor",
    "Gus",
    "Sht",
    "Tet",
    "Nën",
    "Dhj"
  ],
  wide: [
    "Janar",
    "Shkurt",
    "Mars",
    "Prill",
    "Maj",
    "Qershor",
    "Korrik",
    "Gusht",
    "Shtator",
    "Tetor",
    "Nëntor",
    "Dhjetor"
  ]
}, J6e = {
  narrow: ["D", "H", "M", "M", "E", "P", "S"],
  short: ["Di", "Hë", "Ma", "Më", "En", "Pr", "Sh"],
  abbreviated: ["Die", "Hën", "Mar", "Mër", "Enj", "Pre", "Sht"],
  wide: ["Dielë", "Hënë", "Martë", "Mërkurë", "Enjte", "Premte", "Shtunë"]
}, Q6e = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "mëngjes",
    afternoon: "dite",
    evening: "mbrëmje",
    night: "natë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnëtë",
    noon: "drek",
    morning: "mëngjes",
    afternoon: "mbasdite",
    evening: "mbrëmje",
    night: "natë"
  }
}, Z6e = {
  narrow: {
    am: "p",
    pm: "m",
    midnight: "m",
    noon: "d",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  abbreviated: {
    am: "PD",
    pm: "MD",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  },
  wide: {
    am: "p.d.",
    pm: "m.d.",
    midnight: "mesnatë",
    noon: "drek",
    morning: "në mëngjes",
    afternoon: "në mbasdite",
    evening: "në mbrëmje",
    night: "në mesnatë"
  }
}, e_e = (t, e) => {
  const n = Number(t);
  return (e == null ? void 0 : e.unit) === "hour" ? String(n) : n === 1 ? n + "-rë" : n === 4 ? n + "t" : n + "-të";
}, t_e = {
  ordinalNumber: e_e,
  era: C({
    values: Y6e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: K6e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: U6e,
    defaultWidth: "wide"
  }),
  day: C({
    values: J6e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: Q6e,
    defaultWidth: "wide",
    formattingValues: Z6e,
    defaultFormattingWidth: "wide"
  })
}, n_e = /^(\d+)(-rë|-të|t|)?/i, i_e = /\d+/i, r_e = {
  narrow: /^(p|m)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(para krishtit|mbas krishtit)/i
}, a_e = {
  any: [/^b/i, /^(p|m)/i]
}, o_e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234]-mujori (i{1,3}|iv)/i
}, s_e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, l_e = {
  narrow: /^[jsmpqkftnd]/i,
  abbreviated: /^(jan|shk|mar|pri|maj|qer|kor|gus|sht|tet|nën|dhj)/i,
  wide: /^(janar|shkurt|mars|prill|maj|qershor|korrik|gusht|shtator|tetor|nëntor|dhjetor)/i
}, d_e = {
  narrow: [
    /^j/i,
    /^s/i,
    /^m/i,
    /^p/i,
    /^m/i,
    /^q/i,
    /^k/i,
    /^g/i,
    /^s/i,
    /^t/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^shk/i,
    /^mar/i,
    /^pri/i,
    /^maj/i,
    /^qer/i,
    /^kor/i,
    /^gu/i,
    /^sht/i,
    /^tet/i,
    /^n/i,
    /^d/i
  ]
}, c_e = {
  narrow: /^[dhmeps]/i,
  short: /^(di|hë|ma|më|en|pr|sh)/i,
  abbreviated: /^(die|hën|mar|mër|enj|pre|sht)/i,
  wide: /^(dielë|hënë|martë|mërkurë|enjte|premte|shtunë)/i
}, u_e = {
  narrow: [/^d/i, /^h/i, /^m/i, /^m/i, /^e/i, /^p/i, /^s/i],
  any: [/^d/i, /^h/i, /^ma/i, /^më/i, /^e/i, /^p/i, /^s/i]
}, f_e = {
  narrow: /^(p|m|me|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i,
  any: /^([pm]\.?\s?d\.?|drek|në (mëngjes|mbasdite|mbrëmje|mesnatë))/i
}, m_e = {
  any: {
    am: /^p/i,
    pm: /^m/i,
    midnight: /^me/i,
    noon: /^dr/i,
    morning: /mëngjes/i,
    afternoon: /mbasdite/i,
    evening: /mbrëmje/i,
    night: /natë/i
  }
}, h_e = {
  ordinalNumber: he({
    matchPattern: n_e,
    parsePattern: i_e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: r_e,
    defaultMatchWidth: "wide",
    parsePatterns: a_e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: o_e,
    defaultMatchWidth: "wide",
    parsePatterns: s_e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: l_e,
    defaultMatchWidth: "wide",
    parsePatterns: d_e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: c_e,
    defaultMatchWidth: "wide",
    parsePatterns: u_e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: f_e,
    defaultMatchWidth: "any",
    parsePatterns: m_e,
    defaultParseWidth: "any"
  })
}, p_e = {
  code: "sq",
  formatDistance: z6e,
  formatLong: q6e,
  formatRelative: X6e,
  localize: t_e,
  match: h_e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, g_e = {
  lessThanXSeconds: {
    one: {
      standalone: "мање од 1 секунде",
      withPrepositionAgo: "мање од 1 секунде",
      withPrepositionIn: "мање од 1 секунду"
    },
    dual: "мање од {{count}} секунде",
    other: "мање од {{count}} секунди"
  },
  xSeconds: {
    one: {
      standalone: "1 секунда",
      withPrepositionAgo: "1 секунде",
      withPrepositionIn: "1 секунду"
    },
    dual: "{{count}} секунде",
    other: "{{count}} секунди"
  },
  halfAMinute: "пола минуте",
  lessThanXMinutes: {
    one: {
      standalone: "мање од 1 минуте",
      withPrepositionAgo: "мање од 1 минуте",
      withPrepositionIn: "мање од 1 минуту"
    },
    dual: "мање од {{count}} минуте",
    other: "мање од {{count}} минута"
  },
  xMinutes: {
    one: {
      standalone: "1 минута",
      withPrepositionAgo: "1 минуте",
      withPrepositionIn: "1 минуту"
    },
    dual: "{{count}} минуте",
    other: "{{count}} минута"
  },
  aboutXHours: {
    one: {
      standalone: "око 1 сат",
      withPrepositionAgo: "око 1 сат",
      withPrepositionIn: "око 1 сат"
    },
    dual: "око {{count}} сата",
    other: "око {{count}} сати"
  },
  xHours: {
    one: {
      standalone: "1 сат",
      withPrepositionAgo: "1 сат",
      withPrepositionIn: "1 сат"
    },
    dual: "{{count}} сата",
    other: "{{count}} сати"
  },
  xDays: {
    one: {
      standalone: "1 дан",
      withPrepositionAgo: "1 дан",
      withPrepositionIn: "1 дан"
    },
    dual: "{{count}} дана",
    other: "{{count}} дана"
  },
  aboutXWeeks: {
    one: {
      standalone: "око 1 недељу",
      withPrepositionAgo: "око 1 недељу",
      withPrepositionIn: "око 1 недељу"
    },
    dual: "око {{count}} недеље",
    other: "око {{count}} недеље"
  },
  xWeeks: {
    one: {
      standalone: "1 недељу",
      withPrepositionAgo: "1 недељу",
      withPrepositionIn: "1 недељу"
    },
    dual: "{{count}} недеље",
    other: "{{count}} недеље"
  },
  aboutXMonths: {
    one: {
      standalone: "око 1 месец",
      withPrepositionAgo: "око 1 месец",
      withPrepositionIn: "око 1 месец"
    },
    dual: "око {{count}} месеца",
    other: "око {{count}} месеци"
  },
  xMonths: {
    one: {
      standalone: "1 месец",
      withPrepositionAgo: "1 месец",
      withPrepositionIn: "1 месец"
    },
    dual: "{{count}} месеца",
    other: "{{count}} месеци"
  },
  aboutXYears: {
    one: {
      standalone: "око 1 годину",
      withPrepositionAgo: "око 1 годину",
      withPrepositionIn: "око 1 годину"
    },
    dual: "око {{count}} године",
    other: "око {{count}} година"
  },
  xYears: {
    one: {
      standalone: "1 година",
      withPrepositionAgo: "1 године",
      withPrepositionIn: "1 годину"
    },
    dual: "{{count}} године",
    other: "{{count}} година"
  },
  overXYears: {
    one: {
      standalone: "преко 1 годину",
      withPrepositionAgo: "преко 1 годину",
      withPrepositionIn: "преко 1 годину"
    },
    dual: "преко {{count}} године",
    other: "преко {{count}} година"
  },
  almostXYears: {
    one: {
      standalone: "готово 1 годину",
      withPrepositionAgo: "готово 1 годину",
      withPrepositionIn: "готово 1 годину"
    },
    dual: "готово {{count}} године",
    other: "готово {{count}} година"
  }
}, y_e = (t, e, n) => {
  let i;
  const r = g_e[t];
  return typeof r == "string" ? i = r : e === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i = r.one.withPrepositionIn : i = r.one.withPrepositionAgo : i = r.one.standalone : e % 10 > 1 && e % 10 < 5 && // if last digit is between 2 and 4
  String(e).substr(-2, 1) !== "1" ? i = r.dual.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "за " + i : "пре " + i : i;
}, v_e = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, b_e = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, w_e = {
  full: "{{date}} 'у' {{time}}",
  long: "{{date}} 'у' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, k_e = {
  date: T({
    formats: v_e,
    defaultWidth: "full"
  }),
  time: T({
    formats: b_e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: w_e,
    defaultWidth: "full"
  })
}, x_e = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'прошле недеље у' p";
      case 3:
        return "'прошле среде у' p";
      case 6:
        return "'прошле суботе у' p";
      default:
        return "'прошли' EEEE 'у' p";
    }
  },
  yesterday: "'јуче у' p",
  today: "'данас у' p",
  tomorrow: "'сутра у' p",
  nextWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'следеће недеље у' p";
      case 3:
        return "'следећу среду у' p";
      case 6:
        return "'следећу суботу у' p";
      default:
        return "'следећи' EEEE 'у' p";
    }
  },
  other: "P"
}, __e = (t, e, n, i) => {
  const r = x_e[t];
  return typeof r == "function" ? r(e) : r;
}, M_e = {
  narrow: ["пр.н.е.", "АД"],
  abbreviated: ["пр. Хр.", "по. Хр."],
  wide: ["Пре Христа", "После Христа"]
}, C_e = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. кв.", "2. кв.", "3. кв.", "4. кв."],
  wide: ["1. квартал", "2. квартал", "3. квартал", "4. квартал"]
}, P_e = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец"
  ],
  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар"
  ]
}, S_e = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "јан",
    "феб",
    "мар",
    "апр",
    "мај",
    "јун",
    "јул",
    "авг",
    "сеп",
    "окт",
    "нов",
    "дец"
  ],
  wide: [
    "јануар",
    "фебруар",
    "март",
    "април",
    "мај",
    "јун",
    "јул",
    "август",
    "септембар",
    "октобар",
    "новембар",
    "децембар"
  ]
}, N_e = {
  narrow: ["Н", "П", "У", "С", "Ч", "П", "С"],
  short: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  abbreviated: ["нед", "пон", "уто", "сре", "чет", "пет", "суб"],
  wide: [
    "недеља",
    "понедељак",
    "уторак",
    "среда",
    "четвртак",
    "петак",
    "субота"
  ]
}, $_e = {
  narrow: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "АМ",
    pm: "ПМ",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, D_e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "поподне",
    evening: "увече",
    night: "ноћу"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "поноћ",
    noon: "подне",
    morning: "ујутру",
    afternoon: "после подне",
    evening: "увече",
    night: "ноћу"
  }
}, E_e = (t, e) => Number(t) + ".", T_e = {
  ordinalNumber: E_e,
  era: C({
    values: M_e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: C_e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: P_e,
    defaultWidth: "wide",
    formattingValues: S_e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: N_e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: D_e,
    defaultWidth: "wide",
    formattingValues: $_e,
    defaultFormattingWidth: "wide"
  })
}, O_e = /^(\d+)\./i, W_e = /\d+/i, A_e = {
  narrow: /^(пр\.н\.е\.|АД)/i,
  abbreviated: /^(пр\.\s?Хр\.|по\.\s?Хр\.)/i,
  wide: /^(Пре Христа|пре нове ере|После Христа|нова ера)/i
}, L_e = {
  any: [/^пр/i, /^(по|нова)/i]
}, I_e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?кв\.?/i,
  wide: /^[1234]\. квартал/i
}, R_e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, j_e = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(јан|феб|мар|апр|мај|јун|јул|авг|сеп|окт|нов|дец)/i,
  wide: /^((јануар|јануара)|(фебруар|фебруара)|(март|марта)|(април|априла)|(мја|маја)|(јун|јуна)|(јул|јула)|(август|августа)|(септембар|септембра)|(октобар|октобра)|(новембар|новембра)|(децембар|децембра))/i
}, F_e = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ја/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^мај/i,
    /^јун/i,
    /^јул/i,
    /^авг/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, z_e = {
  narrow: /^[пусчн]/i,
  short: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  abbreviated: /^(нед|пон|уто|сре|чет|пет|суб)/i,
  wide: /^(недеља|понедељак|уторак|среда|четвртак|петак|субота)/i
}, V_e = {
  narrow: [/^п/i, /^у/i, /^с/i, /^ч/i, /^п/i, /^с/i, /^н/i],
  any: [/^нед/i, /^пон/i, /^уто/i, /^сре/i, /^чет/i, /^пет/i, /^суб/i]
}, H_e = {
  any: /^(ам|пм|поноћ|(по)?подне|увече|ноћу|после подне|ујутру)/i
}, B_e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^поно/i,
    noon: /^под/i,
    morning: /ујутру/i,
    afternoon: /(после\s|по)+подне/i,
    evening: /(увече)/i,
    night: /(ноћу)/i
  }
}, q_e = {
  ordinalNumber: he({
    matchPattern: O_e,
    parsePattern: W_e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: A_e,
    defaultMatchWidth: "wide",
    parsePatterns: L_e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: I_e,
    defaultMatchWidth: "wide",
    parsePatterns: R_e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: j_e,
    defaultMatchWidth: "wide",
    parsePatterns: F_e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: z_e,
    defaultMatchWidth: "wide",
    parsePatterns: V_e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: H_e,
    defaultMatchWidth: "any",
    parsePatterns: B_e,
    defaultParseWidth: "any"
  })
}, G_e = {
  code: "sr",
  formatDistance: y_e,
  formatLong: k_e,
  formatRelative: __e,
  localize: T_e,
  match: q_e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, X_e = {
  lessThanXSeconds: {
    one: {
      standalone: "manje od 1 sekunde",
      withPrepositionAgo: "manje od 1 sekunde",
      withPrepositionIn: "manje od 1 sekundu"
    },
    dual: "manje od {{count}} sekunde",
    other: "manje od {{count}} sekundi"
  },
  xSeconds: {
    one: {
      standalone: "1 sekunda",
      withPrepositionAgo: "1 sekunde",
      withPrepositionIn: "1 sekundu"
    },
    dual: "{{count}} sekunde",
    other: "{{count}} sekundi"
  },
  halfAMinute: "pola minute",
  lessThanXMinutes: {
    one: {
      standalone: "manje od 1 minute",
      withPrepositionAgo: "manje od 1 minute",
      withPrepositionIn: "manje od 1 minutu"
    },
    dual: "manje od {{count}} minute",
    other: "manje od {{count}} minuta"
  },
  xMinutes: {
    one: {
      standalone: "1 minuta",
      withPrepositionAgo: "1 minute",
      withPrepositionIn: "1 minutu"
    },
    dual: "{{count}} minute",
    other: "{{count}} minuta"
  },
  aboutXHours: {
    one: {
      standalone: "oko 1 sat",
      withPrepositionAgo: "oko 1 sat",
      withPrepositionIn: "oko 1 sat"
    },
    dual: "oko {{count}} sata",
    other: "oko {{count}} sati"
  },
  xHours: {
    one: {
      standalone: "1 sat",
      withPrepositionAgo: "1 sat",
      withPrepositionIn: "1 sat"
    },
    dual: "{{count}} sata",
    other: "{{count}} sati"
  },
  xDays: {
    one: {
      standalone: "1 dan",
      withPrepositionAgo: "1 dan",
      withPrepositionIn: "1 dan"
    },
    dual: "{{count}} dana",
    other: "{{count}} dana"
  },
  aboutXWeeks: {
    one: {
      standalone: "oko 1 nedelju",
      withPrepositionAgo: "oko 1 nedelju",
      withPrepositionIn: "oko 1 nedelju"
    },
    dual: "oko {{count}} nedelje",
    other: "oko {{count}} nedelje"
  },
  xWeeks: {
    one: {
      standalone: "1 nedelju",
      withPrepositionAgo: "1 nedelju",
      withPrepositionIn: "1 nedelju"
    },
    dual: "{{count}} nedelje",
    other: "{{count}} nedelje"
  },
  aboutXMonths: {
    one: {
      standalone: "oko 1 mesec",
      withPrepositionAgo: "oko 1 mesec",
      withPrepositionIn: "oko 1 mesec"
    },
    dual: "oko {{count}} meseca",
    other: "oko {{count}} meseci"
  },
  xMonths: {
    one: {
      standalone: "1 mesec",
      withPrepositionAgo: "1 mesec",
      withPrepositionIn: "1 mesec"
    },
    dual: "{{count}} meseca",
    other: "{{count}} meseci"
  },
  aboutXYears: {
    one: {
      standalone: "oko 1 godinu",
      withPrepositionAgo: "oko 1 godinu",
      withPrepositionIn: "oko 1 godinu"
    },
    dual: "oko {{count}} godine",
    other: "oko {{count}} godina"
  },
  xYears: {
    one: {
      standalone: "1 godina",
      withPrepositionAgo: "1 godine",
      withPrepositionIn: "1 godinu"
    },
    dual: "{{count}} godine",
    other: "{{count}} godina"
  },
  overXYears: {
    one: {
      standalone: "preko 1 godinu",
      withPrepositionAgo: "preko 1 godinu",
      withPrepositionIn: "preko 1 godinu"
    },
    dual: "preko {{count}} godine",
    other: "preko {{count}} godina"
  },
  almostXYears: {
    one: {
      standalone: "gotovo 1 godinu",
      withPrepositionAgo: "gotovo 1 godinu",
      withPrepositionIn: "gotovo 1 godinu"
    },
    dual: "gotovo {{count}} godine",
    other: "gotovo {{count}} godina"
  }
}, Y_e = (t, e, n) => {
  let i;
  const r = X_e[t];
  return typeof r == "string" ? i = r : e === 1 ? n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i = r.one.withPrepositionIn : i = r.one.withPrepositionAgo : i = r.one.standalone : e % 10 > 1 && e % 10 < 5 && // if last digit is between 2 and 4
  String(e).substr(-2, 1) !== "1" ? i = r.dual.replace("{{count}}", String(e)) : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "za " + i : "pre " + i : i;
}, K_e = {
  full: "EEEE, d. MMMM yyyy.",
  long: "d. MMMM yyyy.",
  medium: "d. MMM yy.",
  short: "dd. MM. yy."
}, U_e = {
  full: "HH:mm:ss (zzzz)",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, J_e = {
  full: "{{date}} 'u' {{time}}",
  long: "{{date}} 'u' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, Q_e = {
  date: T({
    formats: K_e,
    defaultWidth: "full"
  }),
  time: T({
    formats: U_e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: J_e,
    defaultWidth: "full"
  })
}, Z_e = {
  lastWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'prošle nedelje u' p";
      case 3:
        return "'prošle srede u' p";
      case 6:
        return "'prošle subote u' p";
      default:
        return "'prošli' EEEE 'u' p";
    }
  },
  yesterday: "'juče u' p",
  today: "'danas u' p",
  tomorrow: "'sutra u' p",
  nextWeek: (t) => {
    switch (t.getDay()) {
      case 0:
        return "'sledeće nedelje u' p";
      case 3:
        return "'sledeću sredu u' p";
      case 6:
        return "'sledeću subotu u' p";
      default:
        return "'sledeći' EEEE 'u' p";
    }
  },
  other: "P"
}, e9e = (t, e, n, i) => {
  const r = Z_e[t];
  return typeof r == "function" ? r(e) : r;
}, t9e = {
  narrow: ["pr.n.e.", "AD"],
  abbreviated: ["pr. Hr.", "po. Hr."],
  wide: ["Pre Hrista", "Posle Hrista"]
}, n9e = {
  narrow: ["1.", "2.", "3.", "4."],
  abbreviated: ["1. kv.", "2. kv.", "3. kv.", "4. kv."],
  wide: ["1. kvartal", "2. kvartal", "3. kvartal", "4. kvartal"]
}, i9e = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, r9e = {
  narrow: [
    "1.",
    "2.",
    "3.",
    "4.",
    "5.",
    "6.",
    "7.",
    "8.",
    "9.",
    "10.",
    "11.",
    "12."
  ],
  abbreviated: [
    "jan",
    "feb",
    "mar",
    "apr",
    "maj",
    "jun",
    "jul",
    "avg",
    "sep",
    "okt",
    "nov",
    "dec"
  ],
  wide: [
    "januar",
    "februar",
    "mart",
    "april",
    "maj",
    "jun",
    "jul",
    "avgust",
    "septembar",
    "oktobar",
    "novembar",
    "decembar"
  ]
}, a9e = {
  narrow: ["N", "P", "U", "S", "Č", "P", "S"],
  short: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  abbreviated: ["ned", "pon", "uto", "sre", "čet", "pet", "sub"],
  wide: [
    "nedelja",
    "ponedeljak",
    "utorak",
    "sreda",
    "četvrtak",
    "petak",
    "subota"
  ]
}, o9e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, s9e = {
  narrow: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "popodne",
    evening: "uveče",
    night: "noću"
  },
  wide: {
    am: "AM",
    pm: "PM",
    midnight: "ponoć",
    noon: "podne",
    morning: "ujutru",
    afternoon: "posle podne",
    evening: "uveče",
    night: "noću"
  }
}, l9e = (t, e) => Number(t) + ".", d9e = {
  ordinalNumber: l9e,
  era: C({
    values: t9e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: n9e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: i9e,
    defaultWidth: "wide",
    formattingValues: r9e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: a9e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: s9e,
    defaultWidth: "wide",
    formattingValues: o9e,
    defaultFormattingWidth: "wide"
  })
}, c9e = /^(\d+)\./i, u9e = /\d+/i, f9e = {
  narrow: /^(pr\.n\.e\.|AD)/i,
  abbreviated: /^(pr\.\s?Hr\.|po\.\s?Hr\.)/i,
  wide: /^(Pre Hrista|pre nove ere|Posle Hrista|nova era)/i
}, m9e = {
  any: [/^pr/i, /^(po|nova)/i]
}, h9e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]\.\s?kv\.?/i,
  wide: /^[1234]\. kvartal/i
}, p9e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, g9e = {
  narrow: /^(10|11|12|[123456789])\./i,
  abbreviated: /^(jan|feb|mar|apr|maj|jun|jul|avg|sep|okt|nov|dec)/i,
  wide: /^((januar|januara)|(februar|februara)|(mart|marta)|(april|aprila)|(maj|maja)|(jun|juna)|(jul|jula)|(avgust|avgusta)|(septembar|septembra)|(oktobar|oktobra)|(novembar|novembra)|(decembar|decembra))/i
}, y9e = {
  narrow: [
    /^1/i,
    /^2/i,
    /^3/i,
    /^4/i,
    /^5/i,
    /^6/i,
    /^7/i,
    /^8/i,
    /^9/i,
    /^10/i,
    /^11/i,
    /^12/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^avg/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, v9e = {
  narrow: /^[npusčc]/i,
  short: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  abbreviated: /^(ned|pon|uto|sre|(čet|cet)|pet|sub)/i,
  wide: /^(nedelja|ponedeljak|utorak|sreda|(četvrtak|cetvrtak)|petak|subota)/i
}, b9e = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
}, w9e = {
  any: /^(am|pm|ponoc|ponoć|(po)?podne|uvece|uveče|noću|posle podne|ujutru)/i
}, k9e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^pono/i,
    noon: /^pod/i,
    morning: /jutro/i,
    afternoon: /(posle\s|po)+podne/i,
    evening: /(uvece|uveče)/i,
    night: /(nocu|noću)/i
  }
}, x9e = {
  ordinalNumber: he({
    matchPattern: c9e,
    parsePattern: u9e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: f9e,
    defaultMatchWidth: "wide",
    parsePatterns: m9e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: h9e,
    defaultMatchWidth: "wide",
    parsePatterns: p9e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: g9e,
    defaultMatchWidth: "wide",
    parsePatterns: y9e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: v9e,
    defaultMatchWidth: "wide",
    parsePatterns: b9e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: w9e,
    defaultMatchWidth: "any",
    parsePatterns: k9e,
    defaultParseWidth: "any"
  })
}, _9e = {
  code: "sr-Latn",
  formatDistance: Y_e,
  formatLong: Q_e,
  formatRelative: e9e,
  localize: d9e,
  match: x9e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, M9e = {
  lessThanXSeconds: {
    one: "mindre än en sekund",
    other: "mindre än {{count}} sekunder"
  },
  xSeconds: {
    one: "en sekund",
    other: "{{count}} sekunder"
  },
  halfAMinute: "en halv minut",
  lessThanXMinutes: {
    one: "mindre än en minut",
    other: "mindre än {{count}} minuter"
  },
  xMinutes: {
    one: "en minut",
    other: "{{count}} minuter"
  },
  aboutXHours: {
    one: "ungefär en timme",
    other: "ungefär {{count}} timmar"
  },
  xHours: {
    one: "en timme",
    other: "{{count}} timmar"
  },
  xDays: {
    one: "en dag",
    other: "{{count}} dagar"
  },
  aboutXWeeks: {
    one: "ungefär en vecka",
    other: "ungefär {{count}} veckor"
  },
  xWeeks: {
    one: "en vecka",
    other: "{{count}} veckor"
  },
  aboutXMonths: {
    one: "ungefär en månad",
    other: "ungefär {{count}} månader"
  },
  xMonths: {
    one: "en månad",
    other: "{{count}} månader"
  },
  aboutXYears: {
    one: "ungefär ett år",
    other: "ungefär {{count}} år"
  },
  xYears: {
    one: "ett år",
    other: "{{count}} år"
  },
  overXYears: {
    one: "över ett år",
    other: "över {{count}} år"
  },
  almostXYears: {
    one: "nästan ett år",
    other: "nästan {{count}} år"
  }
}, C9e = [
  "noll",
  "en",
  "två",
  "tre",
  "fyra",
  "fem",
  "sex",
  "sju",
  "åtta",
  "nio",
  "tio",
  "elva",
  "tolv"
], P9e = (t, e, n) => {
  let i;
  const r = M9e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace(
    "{{count}}",
    e < 13 ? C9e[e] : String(e)
  ), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "om " + i : i + " sedan" : i;
}, S9e = {
  full: "EEEE d MMMM y",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "y-MM-dd"
}, N9e = {
  full: "'kl'. HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, $9e = {
  full: "{{date}} 'kl.' {{time}}",
  long: "{{date}} 'kl.' {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, D9e = {
  date: T({
    formats: S9e,
    defaultWidth: "full"
  }),
  time: T({
    formats: N9e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: $9e,
    defaultWidth: "full"
  })
}, E9e = {
  lastWeek: "'i' EEEE's kl.' p",
  yesterday: "'igår kl.' p",
  today: "'idag kl.' p",
  tomorrow: "'imorgon kl.' p",
  nextWeek: "EEEE 'kl.' p",
  other: "P"
}, T9e = (t, e, n, i) => E9e[t], O9e = {
  narrow: ["f.Kr.", "e.Kr."],
  abbreviated: ["f.Kr.", "e.Kr."],
  wide: ["före Kristus", "efter Kristus"]
}, W9e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["1:a kvartalet", "2:a kvartalet", "3:e kvartalet", "4:e kvartalet"]
}, A9e = {
  narrow: ["J", "F", "M", "A", "M", "J", "J", "A", "S", "O", "N", "D"],
  abbreviated: [
    "jan.",
    "feb.",
    "mars",
    "apr.",
    "maj",
    "juni",
    "juli",
    "aug.",
    "sep.",
    "okt.",
    "nov.",
    "dec."
  ],
  wide: [
    "januari",
    "februari",
    "mars",
    "april",
    "maj",
    "juni",
    "juli",
    "augusti",
    "september",
    "oktober",
    "november",
    "december"
  ]
}, L9e = {
  narrow: ["S", "M", "T", "O", "T", "F", "L"],
  short: ["sö", "må", "ti", "on", "to", "fr", "lö"],
  abbreviated: ["sön", "mån", "tis", "ons", "tors", "fre", "lör"],
  wide: ["söndag", "måndag", "tisdag", "onsdag", "torsdag", "fredag", "lördag"]
}, I9e = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "morg.",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  abbreviated: {
    am: "f.m.",
    pm: "e.m.",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "efterm.",
    evening: "kväll",
    night: "natt"
  },
  wide: {
    am: "förmiddag",
    pm: "eftermiddag",
    midnight: "midnatt",
    noon: "middag",
    morning: "morgon",
    afternoon: "eftermiddag",
    evening: "kväll",
    night: "natt"
  }
}, R9e = {
  narrow: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  abbreviated: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morg.",
    afternoon: "på efterm.",
    evening: "på kvällen",
    night: "på natten"
  },
  wide: {
    am: "fm",
    pm: "em",
    midnight: "midnatt",
    noon: "middag",
    morning: "på morgonen",
    afternoon: "på eftermiddagen",
    evening: "på kvällen",
    night: "på natten"
  }
}, j9e = (t, e) => {
  const n = Number(t), i = n % 100;
  if (i > 20 || i < 10)
    switch (i % 10) {
      case 1:
      case 2:
        return n + ":a";
    }
  return n + ":e";
}, F9e = {
  ordinalNumber: j9e,
  era: C({
    values: O9e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: W9e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: A9e,
    defaultWidth: "wide"
  }),
  day: C({
    values: L9e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: I9e,
    defaultWidth: "wide",
    formattingValues: R9e,
    defaultFormattingWidth: "wide"
  })
}, z9e = /^(\d+)(:a|:e)?/i, V9e = /\d+/i, H9e = {
  narrow: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  abbreviated: /^(f\.? ?Kr\.?|f\.? ?v\.? ?t\.?|e\.? ?Kr\.?|v\.? ?t\.?)/i,
  wide: /^(före Kristus|före vår tid|efter Kristus|vår tid)/i
}, B9e = {
  any: [/^f/i, /^[ev]/i]
}, q9e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](:a|:e)? kvartalet/i
}, G9e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, X9e = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar[s]?|apr|maj|jun[i]?|jul[i]?|aug|sep|okt|nov|dec)\.?/i,
  wide: /^(januari|februari|mars|april|maj|juni|juli|augusti|september|oktober|november|december)/i
}, Y9e = {
  narrow: [
    /^j/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^j/i,
    /^j/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ja/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^maj/i,
    /^jun/i,
    /^jul/i,
    /^au/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, K9e = {
  narrow: /^[smtofl]/i,
  short: /^(sö|må|ti|on|to|fr|lö)/i,
  abbreviated: /^(sön|mån|tis|ons|tors|fre|lör)/i,
  wide: /^(söndag|måndag|tisdag|onsdag|torsdag|fredag|lördag)/i
}, U9e = {
  any: [/^s/i, /^m/i, /^ti/i, /^o/i, /^to/i, /^f/i, /^l/i]
}, J9e = {
  any: /^([fe]\.?\s?m\.?|midn(att)?|midd(ag)?|(på) (morgonen|eftermiddagen|kvällen|natten))/i
}, Q9e = {
  any: {
    am: /^f/i,
    pm: /^e/i,
    midnight: /^midn/i,
    noon: /^midd/i,
    morning: /morgon/i,
    afternoon: /eftermiddag/i,
    evening: /kväll/i,
    night: /natt/i
  }
}, Z9e = {
  ordinalNumber: he({
    matchPattern: z9e,
    parsePattern: V9e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: H9e,
    defaultMatchWidth: "wide",
    parsePatterns: B9e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: q9e,
    defaultMatchWidth: "wide",
    parsePatterns: G9e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: X9e,
    defaultMatchWidth: "wide",
    parsePatterns: Y9e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: K9e,
    defaultMatchWidth: "wide",
    parsePatterns: U9e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: J9e,
    defaultMatchWidth: "any",
    parsePatterns: Q9e,
    defaultParseWidth: "any"
  })
}, eMe = {
  code: "sv",
  formatDistance: P9e,
  formatLong: D9e,
  formatRelative: T9e,
  localize: F9e,
  match: Z9e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
};
function tMe(t) {
  return t.one !== void 0;
}
const nMe = {
  lessThanXSeconds: {
    one: {
      default: "ஒரு வினாடிக்கு குறைவாக",
      in: "ஒரு வினாடிக்குள்",
      ago: "ஒரு வினாடிக்கு முன்பு"
    },
    other: {
      default: "{{count}} வினாடிகளுக்கு குறைவாக",
      in: "{{count}} வினாடிகளுக்குள்",
      ago: "{{count}} வினாடிகளுக்கு முன்பு"
    }
  },
  xSeconds: {
    one: {
      default: "1 வினாடி",
      in: "1 வினாடியில்",
      ago: "1 வினாடி முன்பு"
    },
    other: {
      default: "{{count}} விநாடிகள்",
      in: "{{count}} வினாடிகளில்",
      ago: "{{count}} விநாடிகளுக்கு முன்பு"
    }
  },
  halfAMinute: {
    default: "அரை நிமிடம்",
    in: "அரை நிமிடத்தில்",
    ago: "அரை நிமிடம் முன்பு"
  },
  lessThanXMinutes: {
    one: {
      default: "ஒரு நிமிடத்திற்கும் குறைவாக",
      in: "ஒரு நிமிடத்திற்குள்",
      ago: "ஒரு நிமிடத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்களுக்கும் குறைவாக",
      in: "{{count}} நிமிடங்களுக்குள்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  xMinutes: {
    one: {
      default: "1 நிமிடம்",
      in: "1 நிமிடத்தில்",
      ago: "1 நிமிடம் முன்பு"
    },
    other: {
      default: "{{count}} நிமிடங்கள்",
      in: "{{count}} நிமிடங்களில்",
      ago: "{{count}} நிமிடங்களுக்கு முன்பு"
    }
  },
  aboutXHours: {
    one: {
      default: "சுமார் 1 மணி நேரம்",
      in: "சுமார் 1 மணி நேரத்தில்",
      ago: "சுமார் 1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மணி நேரம்",
      in: "சுமார் {{count}} மணி நேரத்திற்கு முன்பு",
      ago: "சுமார் {{count}} மணி நேரத்தில்"
    }
  },
  xHours: {
    one: {
      default: "1 மணி நேரம்",
      in: "1 மணி நேரத்தில்",
      ago: "1 மணி நேரத்திற்கு முன்பு"
    },
    other: {
      default: "{{count}} மணி நேரம்",
      in: "{{count}} மணி நேரத்தில்",
      ago: "{{count}} மணி நேரத்திற்கு முன்பு"
    }
  },
  xDays: {
    one: {
      default: "1 நாள்",
      in: "1 நாளில்",
      ago: "1 நாள் முன்பு"
    },
    other: {
      default: "{{count}} நாட்கள்",
      in: "{{count}} நாட்களில்",
      ago: "{{count}} நாட்களுக்கு முன்பு"
    }
  },
  aboutXWeeks: {
    one: {
      default: "சுமார் 1 வாரம்",
      in: "சுமார் 1 வாரத்தில்",
      ago: "சுமார் 1 வாரம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} வாரங்கள்",
      in: "சுமார் {{count}} வாரங்களில்",
      ago: "சுமார் {{count}} வாரங்களுக்கு முன்பு"
    }
  },
  xWeeks: {
    one: {
      default: "1 வாரம்",
      in: "1 வாரத்தில்",
      ago: "1 வாரம் முன்பு"
    },
    other: {
      default: "{{count}} வாரங்கள்",
      in: "{{count}} வாரங்களில்",
      ago: "{{count}} வாரங்களுக்கு முன்பு"
    }
  },
  aboutXMonths: {
    one: {
      default: "சுமார் 1 மாதம்",
      in: "சுமார் 1 மாதத்தில்",
      ago: "சுமார் 1 மாதத்திற்கு முன்பு"
    },
    other: {
      default: "சுமார் {{count}} மாதங்கள்",
      in: "சுமார் {{count}} மாதங்களில்",
      ago: "சுமார் {{count}} மாதங்களுக்கு முன்பு"
    }
  },
  xMonths: {
    one: {
      default: "1 மாதம்",
      in: "1 மாதத்தில்",
      ago: "1 மாதம் முன்பு"
    },
    other: {
      default: "{{count}} மாதங்கள்",
      in: "{{count}} மாதங்களில்",
      ago: "{{count}} மாதங்களுக்கு முன்பு"
    }
  },
  aboutXYears: {
    one: {
      default: "சுமார் 1 வருடம்",
      in: "சுமார் 1 ஆண்டில்",
      ago: "சுமார் 1 வருடம் முன்பு"
    },
    other: {
      default: "சுமார் {{count}} ஆண்டுகள்",
      in: "சுமார் {{count}} ஆண்டுகளில்",
      ago: "சுமார் {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  xYears: {
    one: {
      default: "1 வருடம்",
      in: "1 ஆண்டில்",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகள்",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  overXYears: {
    one: {
      default: "1 வருடத்திற்கு மேல்",
      in: "1 வருடத்திற்கும் மேலாக",
      ago: "1 வருடம் முன்பு"
    },
    other: {
      default: "{{count}} ஆண்டுகளுக்கும் மேலாக",
      in: "{{count}} ஆண்டுகளில்",
      ago: "{{count}} ஆண்டுகளுக்கு முன்பு"
    }
  },
  almostXYears: {
    one: {
      default: "கிட்டத்தட்ட 1 வருடம்",
      in: "கிட்டத்தட்ட 1 ஆண்டில்",
      ago: "கிட்டத்தட்ட 1 வருடம் முன்பு"
    },
    other: {
      default: "கிட்டத்தட்ட {{count}} ஆண்டுகள்",
      in: "கிட்டத்தட்ட {{count}} ஆண்டுகளில்",
      ago: "கிட்டத்தட்ட {{count}} ஆண்டுகளுக்கு முன்பு"
    }
  }
}, iMe = (t, e, n) => {
  const i = n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? "in" : "ago" : "default", r = nMe[t];
  return tMe(r) ? e === 1 ? r.one[i] : r.other[i].replace("{{count}}", String(e)) : r[i];
}, rMe = {
  full: "EEEE, d MMMM, y",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "d/M/yy"
}, aMe = {
  full: "a h:mm:ss zzzz",
  long: "a h:mm:ss z",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, oMe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, sMe = {
  date: T({
    formats: rMe,
    defaultWidth: "full"
  }),
  time: T({
    formats: aMe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: oMe,
    defaultWidth: "full"
  })
}, lMe = {
  lastWeek: "'கடந்த' eeee p 'மணிக்கு'",
  yesterday: "'நேற்று ' p 'மணிக்கு'",
  today: "'இன்று ' p 'மணிக்கு'",
  tomorrow: "'நாளை ' p 'மணிக்கு'",
  nextWeek: "eeee p 'மணிக்கு'",
  other: "P"
}, dMe = (t, e, n, i) => lMe[t], cMe = {
  narrow: ["கி.மு.", "கி.பி."],
  abbreviated: ["கி.மு.", "கி.பி."],
  // CLDR #1624, #1626
  wide: ["கிறிஸ்துவுக்கு முன்", "அன்னோ டோமினி"]
  // CLDR #1620, #1622
}, uMe = {
  // CLDR #1644 - #1647
  narrow: ["1", "2", "3", "4"],
  // CLDR #1636 - #1639
  abbreviated: ["காலா.1", "காலா.2", "காலா.3", "காலா.4"],
  // CLDR #1628 - #1631
  wide: [
    "ஒன்றாம் காலாண்டு",
    "இரண்டாம் காலாண்டு",
    "மூன்றாம் காலாண்டு",
    "நான்காம் காலாண்டு"
  ]
}, fMe = {
  // CLDR #700 - #711
  narrow: ["ஜ", "பி", "மா", "ஏ", "மே", "ஜூ", "ஜூ", "ஆ", "செ", "அ", "ந", "டி"],
  // CLDR #1676 - #1687
  abbreviated: [
    "ஜன.",
    "பிப்.",
    "மார்.",
    "ஏப்.",
    "மே",
    "ஜூன்",
    "ஜூலை",
    "ஆக.",
    "செப்.",
    "அக்.",
    "நவ.",
    "டிச."
  ],
  // CLDR #1652 - #1663
  wide: [
    "ஜனவரி",
    // January
    "பிப்ரவரி",
    // February
    "மார்ச்",
    // March
    "ஏப்ரல்",
    // April
    "மே",
    // May
    "ஜூன்",
    // June
    "ஜூலை",
    // July
    "ஆகஸ்ட்",
    // August
    "செப்டம்பர்",
    // September
    "அக்டோபர்",
    // October
    "நவம்பர்",
    // November
    "டிசம்பர்"
    // December
  ]
}, mMe = {
  // CLDR #1766 - #1772
  narrow: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1752 - #1758
  short: ["ஞா", "தி", "செ", "பு", "வி", "வெ", "ச"],
  // CLDR #1738 - #1744
  abbreviated: ["ஞாயி.", "திங்.", "செவ்.", "புத.", "வியா.", "வெள்.", "சனி"],
  // CLDR #1724 - #1730
  wide: [
    "ஞாயிறு",
    // Sunday
    "திங்கள்",
    // Monday
    "செவ்வாய்",
    // Tuesday
    "புதன்",
    // Wednesday
    "வியாழன்",
    // Thursday
    "வெள்ளி",
    // Friday
    "சனி"
    // Saturday
  ]
}, hMe = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, pMe = {
  narrow: {
    am: "மு.ப",
    pm: "பி.ப",
    midnight: "நள்.",
    noon: "நண்.",
    morning: "கா.",
    afternoon: "மதி.",
    evening: "மா.",
    night: "இர."
  },
  abbreviated: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  },
  wide: {
    am: "முற்பகல்",
    pm: "பிற்பகல்",
    midnight: "நள்ளிரவு",
    noon: "நண்பகல்",
    morning: "காலை",
    afternoon: "மதியம்",
    evening: "மாலை",
    night: "இரவு"
  }
}, gMe = (t, e) => String(t), yMe = {
  ordinalNumber: gMe,
  era: C({
    values: cMe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: uMe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: fMe,
    defaultWidth: "wide"
  }),
  day: C({
    values: mMe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: hMe,
    defaultWidth: "wide",
    formattingValues: pMe,
    defaultFormattingWidth: "wide"
  })
}, vMe = /^(\d+)(வது)?/i, bMe = /\d+/i, wMe = {
  narrow: /^(கி.மு.|கி.பி.)/i,
  abbreviated: /^(கி\.?\s?மு\.?|கி\.?\s?பி\.?)/,
  wide: /^(கிறிஸ்துவுக்கு\sமுன்|அன்னோ\sடோமினி)/i
}, kMe = {
  any: [/கி\.?\s?மு\.?/, /கி\.?\s?பி\.?/]
}, xMe = {
  narrow: /^[1234]/i,
  abbreviated: /^காலா.[1234]/i,
  wide: /^(ஒன்றாம்|இரண்டாம்|மூன்றாம்|நான்காம்) காலாண்டு/i
}, _Me = {
  narrow: [/1/i, /2/i, /3/i, /4/i],
  any: [
    /(1|காலா.1|ஒன்றாம்)/i,
    /(2|காலா.2|இரண்டாம்)/i,
    /(3|காலா.3|மூன்றாம்)/i,
    /(4|காலா.4|நான்காம்)/i
  ]
}, MMe = {
  narrow: /^(ஜ|பி|மா|ஏ|மே|ஜூ|ஆ|செ|அ|ந|டி)$/i,
  abbreviated: /^(ஜன.|பிப்.|மார்.|ஏப்.|மே|ஜூன்|ஜூலை|ஆக.|செப்.|அக்.|நவ.|டிச.)/i,
  wide: /^(ஜனவரி|பிப்ரவரி|மார்ச்|ஏப்ரல்|மே|ஜூன்|ஜூலை|ஆகஸ்ட்|செப்டம்பர்|அக்டோபர்|நவம்பர்|டிசம்பர்)/i
}, CMe = {
  narrow: [
    /^ஜ$/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூ/i,
    /^ஜூ/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i
  ],
  any: [
    /^ஜன/i,
    /^பி/i,
    /^மா/i,
    /^ஏ/i,
    /^மே/i,
    /^ஜூன்/i,
    /^ஜூலை/i,
    /^ஆ/i,
    /^செ/i,
    /^அ/i,
    /^ந/i,
    /^டி/i
  ]
}, PMe = {
  narrow: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  short: /^(ஞா|தி|செ|பு|வி|வெ|ச)/i,
  abbreviated: /^(ஞாயி.|திங்.|செவ்.|புத.|வியா.|வெள்.|சனி)/i,
  wide: /^(ஞாயிறு|திங்கள்|செவ்வாய்|புதன்|வியாழன்|வெள்ளி|சனி)/i
}, SMe = {
  narrow: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i],
  any: [/^ஞா/i, /^தி/i, /^செ/i, /^பு/i, /^வி/i, /^வெ/i, /^ச/i]
}, NMe = {
  narrow: /^(மு.ப|பி.ப|நள்|நண்|காலை|மதியம்|மாலை|இரவு)/i,
  any: /^(மு.ப|பி.ப|முற்பகல்|பிற்பகல்|நள்ளிரவு|நண்பகல்|காலை|மதியம்|மாலை|இரவு)/i
}, $Me = {
  any: {
    am: /^மு/i,
    pm: /^பி/i,
    midnight: /^நள்/i,
    noon: /^நண்/i,
    morning: /காலை/i,
    afternoon: /மதியம்/i,
    evening: /மாலை/i,
    night: /இரவு/i
  }
}, DMe = {
  ordinalNumber: he({
    matchPattern: vMe,
    parsePattern: bMe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: wMe,
    defaultMatchWidth: "wide",
    parsePatterns: kMe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: xMe,
    defaultMatchWidth: "wide",
    parsePatterns: _Me,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: MMe,
    defaultMatchWidth: "wide",
    parsePatterns: CMe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: PMe,
    defaultMatchWidth: "wide",
    parsePatterns: SMe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: NMe,
    defaultMatchWidth: "any",
    parsePatterns: $Me,
    defaultParseWidth: "any"
  })
}, EMe = {
  code: "ta",
  formatDistance: iMe,
  formatLong: sMe,
  formatRelative: dMe,
  localize: yMe,
  match: DMe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, D2 = {
  lessThanXSeconds: {
    standalone: {
      one: "సెకను కన్నా తక్కువ",
      other: "{{count}} సెకన్ల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  xSeconds: {
    standalone: {
      one: "ఒక సెకను",
      // CLDR #1314
      other: "{{count}} సెకన్ల"
    },
    withPreposition: {
      one: "ఒక సెకను",
      other: "{{count}} సెకన్ల"
    }
  },
  halfAMinute: {
    standalone: "అర నిమిషం",
    withPreposition: "అర నిమిషం"
  },
  lessThanXMinutes: {
    standalone: {
      one: "ఒక నిమిషం కన్నా తక్కువ",
      other: "{{count}} నిమిషాల కన్నా తక్కువ"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      other: "{{count}} నిమిషాల"
    }
  },
  xMinutes: {
    standalone: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాలు"
    },
    withPreposition: {
      one: "ఒక నిమిషం",
      // CLDR #1311
      other: "{{count}} నిమిషాల"
    }
  },
  aboutXHours: {
    standalone: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటలు"
    },
    withPreposition: {
      one: "సుమారు ఒక గంట",
      other: "సుమారు {{count}} గంటల"
    }
  },
  xHours: {
    standalone: {
      one: "ఒక గంట",
      // CLDR #1308
      other: "{{count}} గంటలు"
    },
    withPreposition: {
      one: "ఒక గంట",
      other: "{{count}} గంటల"
    }
  },
  xDays: {
    standalone: {
      one: "ఒక రోజు",
      // CLDR #1292
      other: "{{count}} రోజులు"
    },
    withPreposition: {
      one: "ఒక రోజు",
      other: "{{count}} రోజుల"
    }
  },
  aboutXWeeks: {
    standalone: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక వారం",
      other: "సుమారు {{count}} వారాలల"
    }
  },
  xWeeks: {
    standalone: {
      one: "ఒక వారం",
      other: "{{count}} వారాలు"
    },
    withPreposition: {
      one: "ఒక వారం",
      other: "{{count}} వారాలల"
    }
  },
  aboutXMonths: {
    standalone: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలలు"
    },
    withPreposition: {
      one: "సుమారు ఒక నెల",
      other: "సుమారు {{count}} నెలల"
    }
  },
  xMonths: {
    standalone: {
      one: "ఒక నెల",
      // CLDR #1281
      other: "{{count}} నెలలు"
    },
    withPreposition: {
      one: "ఒక నెల",
      other: "{{count}} నెలల"
    }
  },
  aboutXYears: {
    standalone: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "సుమారు ఒక సంవత్సరం",
      other: "సుమారు {{count}} సంవత్సరాల"
    }
  },
  xYears: {
    standalone: {
      one: "ఒక సంవత్సరం",
      // CLDR #1275
      other: "{{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  overXYears: {
    standalone: {
      one: "ఒక సంవత్సరం పైగా",
      other: "{{count}} సంవత్సరాలకు పైగా"
    },
    withPreposition: {
      one: "ఒక సంవత్సరం",
      other: "{{count}} సంవత్సరాల"
    }
  },
  almostXYears: {
    standalone: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాలు"
    },
    withPreposition: {
      one: "దాదాపు ఒక సంవత్సరం",
      other: "దాదాపు {{count}} సంవత్సరాల"
    }
  }
}, TMe = (t, e, n) => {
  let i;
  const r = n != null && n.addSuffix ? D2[t].withPreposition : D2[t].standalone;
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "లో" : i + " క్రితం" : i;
}, OMe = {
  full: "d, MMMM y, EEEE",
  long: "d MMMM, y",
  medium: "d MMM, y",
  short: "dd-MM-yy"
}, WMe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, AMe = {
  full: "{{date}} {{time}}'కి'",
  long: "{{date}} {{time}}'కి'",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, LMe = {
  date: T({
    formats: OMe,
    defaultWidth: "full"
  }),
  time: T({
    formats: WMe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: AMe,
    defaultWidth: "full"
  })
}, IMe = {
  lastWeek: "'గత' eeee p",
  // CLDR #1384
  yesterday: "'నిన్న' p",
  // CLDR #1393
  today: "'ఈ రోజు' p",
  // CLDR #1394
  tomorrow: "'రేపు' p",
  // CLDR #1395
  nextWeek: "'తదుపరి' eeee p",
  // CLDR #1386
  other: "P"
}, RMe = (t, e, n, i) => IMe[t], jMe = {
  narrow: ["క్రీ.పూ.", "క్రీ.శ."],
  abbreviated: ["క్రీ.పూ.", "క్రీ.శ."],
  wide: ["క్రీస్తు పూర్వం", "క్రీస్తుశకం"]
}, FMe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["త్రై1", "త్రై2", "త్రై3", "త్రై4"],
  wide: ["1వ త్రైమాసికం", "2వ త్రైమాసికం", "3వ త్రైమాసికం", "4వ త్రైమాసికం"]
}, zMe = {
  narrow: ["జ", "ఫి", "మా", "ఏ", "మే", "జూ", "జు", "ఆ", "సె", "అ", "న", "డి"],
  abbreviated: [
    "జన",
    "ఫిబ్ర",
    "మార్చి",
    "ఏప్రి",
    "మే",
    "జూన్",
    "జులై",
    "ఆగ",
    "సెప్టెం",
    "అక్టో",
    "నవం",
    "డిసెం"
  ],
  wide: [
    "జనవరి",
    "ఫిబ్రవరి",
    "మార్చి",
    "ఏప్రిల్",
    "మే",
    "జూన్",
    "జులై",
    "ఆగస్టు",
    "సెప్టెంబర్",
    "అక్టోబర్",
    "నవంబర్",
    "డిసెంబర్"
  ]
}, VMe = {
  narrow: ["ఆ", "సో", "మ", "బు", "గు", "శు", "శ"],
  short: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  abbreviated: ["ఆది", "సోమ", "మంగళ", "బుధ", "గురు", "శుక్ర", "శని"],
  wide: [
    "ఆదివారం",
    "సోమవారం",
    "మంగళవారం",
    "బుధవారం",
    "గురువారం",
    "శుక్రవారం",
    "శనివారం"
  ]
}, HMe = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, BMe = {
  narrow: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  abbreviated: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  },
  wide: {
    am: "పూర్వాహ్నం",
    pm: "అపరాహ్నం",
    midnight: "అర్ధరాత్రి",
    noon: "మిట్టమధ్యాహ్నం",
    morning: "ఉదయం",
    afternoon: "మధ్యాహ్నం",
    evening: "సాయంత్రం",
    night: "రాత్రి"
  }
}, qMe = (t, e) => Number(t) + "వ", GMe = {
  ordinalNumber: qMe,
  era: C({
    values: jMe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: FMe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: zMe,
    defaultWidth: "wide"
  }),
  day: C({
    values: VMe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: HMe,
    defaultWidth: "wide",
    formattingValues: BMe,
    defaultFormattingWidth: "wide"
  })
}, XMe = /^(\d+)(వ)?/i, YMe = /\d+/i, KMe = {
  narrow: /^(క్రీ\.పూ\.|క్రీ\.శ\.)/i,
  abbreviated: /^(క్రీ\.?\s?పూ\.?|ప్ర\.?\s?శ\.?\s?పూ\.?|క్రీ\.?\s?శ\.?|సా\.?\s?శ\.?)/i,
  wide: /^(క్రీస్తు పూర్వం|ప్రస్తుత శకానికి పూర్వం|క్రీస్తు శకం|ప్రస్తుత శకం)/i
}, UMe = {
  any: [/^(పూ|శ)/i, /^సా/i]
}, JMe = {
  narrow: /^[1234]/i,
  abbreviated: /^త్రై[1234]/i,
  wide: /^[1234](వ)? త్రైమాసికం/i
}, QMe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, ZMe = {
  narrow: /^(జూ|జు|జ|ఫి|మా|ఏ|మే|ఆ|సె|అ|న|డి)/i,
  abbreviated: /^(జన|ఫిబ్ర|మార్చి|ఏప్రి|మే|జూన్|జులై|ఆగ|సెప్|అక్టో|నవ|డిసె)/i,
  wide: /^(జనవరి|ఫిబ్రవరి|మార్చి|ఏప్రిల్|మే|జూన్|జులై|ఆగస్టు|సెప్టెంబర్|అక్టోబర్|నవంబర్|డిసెంబర్)/i
}, eCe = {
  narrow: [
    /^జ/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూ/i,
    /^జు/i,
    /^ఆ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i
  ],
  any: [
    /^జన/i,
    /^ఫి/i,
    /^మా/i,
    /^ఏ/i,
    /^మే/i,
    /^జూన్/i,
    /^జులై/i,
    /^ఆగ/i,
    /^సె/i,
    /^అ/i,
    /^న/i,
    /^డి/i
  ]
}, tCe = {
  narrow: /^(ఆ|సో|మ|బు|గు|శు|శ)/i,
  short: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  abbreviated: /^(ఆది|సోమ|మం|బుధ|గురు|శుక్ర|శని)/i,
  wide: /^(ఆదివారం|సోమవారం|మంగళవారం|బుధవారం|గురువారం|శుక్రవారం|శనివారం)/i
}, nCe = {
  narrow: [/^ఆ/i, /^సో/i, /^మ/i, /^బు/i, /^గు/i, /^శు/i, /^శ/i],
  any: [/^ఆది/i, /^సోమ/i, /^మం/i, /^బుధ/i, /^గురు/i, /^శుక్ర/i, /^శని/i]
}, iCe = {
  narrow: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i,
  any: /^(పూర్వాహ్నం|అపరాహ్నం|అర్ధరాత్రి|మిట్టమధ్యాహ్నం|ఉదయం|మధ్యాహ్నం|సాయంత్రం|రాత్రి)/i
}, rCe = {
  any: {
    am: /^పూర్వాహ్నం/i,
    pm: /^అపరాహ్నం/i,
    midnight: /^అర్ధ/i,
    noon: /^మిట్ట/i,
    morning: /ఉదయం/i,
    afternoon: /మధ్యాహ్నం/i,
    evening: /సాయంత్రం/i,
    night: /రాత్రి/i
  }
}, aCe = {
  ordinalNumber: he({
    matchPattern: XMe,
    parsePattern: YMe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: KMe,
    defaultMatchWidth: "wide",
    parsePatterns: UMe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: JMe,
    defaultMatchWidth: "wide",
    parsePatterns: QMe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: ZMe,
    defaultMatchWidth: "wide",
    parsePatterns: eCe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: tCe,
    defaultMatchWidth: "wide",
    parsePatterns: nCe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: iCe,
    defaultMatchWidth: "any",
    parsePatterns: rCe,
    defaultParseWidth: "any"
  })
}, oCe = {
  code: "te",
  formatDistance: TMe,
  formatLong: LMe,
  formatRelative: RMe,
  localize: GMe,
  match: aCe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, sCe = {
  lessThanXSeconds: {
    one: "น้อยกว่า 1 วินาที",
    other: "น้อยกว่า {{count}} วินาที"
  },
  xSeconds: {
    one: "1 วินาที",
    other: "{{count}} วินาที"
  },
  halfAMinute: "ครึ่งนาที",
  lessThanXMinutes: {
    one: "น้อยกว่า 1 นาที",
    other: "น้อยกว่า {{count}} นาที"
  },
  xMinutes: {
    one: "1 นาที",
    other: "{{count}} นาที"
  },
  aboutXHours: {
    one: "ประมาณ 1 ชั่วโมง",
    other: "ประมาณ {{count}} ชั่วโมง"
  },
  xHours: {
    one: "1 ชั่วโมง",
    other: "{{count}} ชั่วโมง"
  },
  xDays: {
    one: "1 วัน",
    other: "{{count}} วัน"
  },
  aboutXWeeks: {
    one: "ประมาณ 1 สัปดาห์",
    other: "ประมาณ {{count}} สัปดาห์"
  },
  xWeeks: {
    one: "1 สัปดาห์",
    other: "{{count}} สัปดาห์"
  },
  aboutXMonths: {
    one: "ประมาณ 1 เดือน",
    other: "ประมาณ {{count}} เดือน"
  },
  xMonths: {
    one: "1 เดือน",
    other: "{{count}} เดือน"
  },
  aboutXYears: {
    one: "ประมาณ 1 ปี",
    other: "ประมาณ {{count}} ปี"
  },
  xYears: {
    one: "1 ปี",
    other: "{{count}} ปี"
  },
  overXYears: {
    one: "มากกว่า 1 ปี",
    other: "มากกว่า {{count}} ปี"
  },
  almostXYears: {
    one: "เกือบ 1 ปี",
    other: "เกือบ {{count}} ปี"
  }
}, lCe = (t, e, n) => {
  let i;
  const r = sCe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? t === "halfAMinute" ? "ใน" + i : "ใน " + i : i + "ที่ผ่านมา" : i;
}, dCe = {
  full: "วันEEEEที่ do MMMM y",
  long: "do MMMM y",
  medium: "d MMM y",
  short: "dd/MM/yyyy"
}, cCe = {
  full: "H:mm:ss น. zzzz",
  long: "H:mm:ss น. z",
  medium: "H:mm:ss น.",
  short: "H:mm น."
}, uCe = {
  full: "{{date}} 'เวลา' {{time}}",
  long: "{{date}} 'เวลา' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, fCe = {
  date: T({
    formats: dCe,
    defaultWidth: "full"
  }),
  time: T({
    formats: cCe,
    defaultWidth: "medium"
  }),
  dateTime: T({
    formats: uCe,
    defaultWidth: "full"
  })
}, mCe = {
  lastWeek: "eeee'ที่แล้วเวลา' p",
  yesterday: "'เมื่อวานนี้เวลา' p",
  today: "'วันนี้เวลา' p",
  tomorrow: "'พรุ่งนี้เวลา' p",
  nextWeek: "eeee 'เวลา' p",
  other: "P"
}, hCe = (t, e, n, i) => mCe[t], pCe = {
  narrow: ["B", "คศ"],
  abbreviated: ["BC", "ค.ศ."],
  wide: ["ปีก่อนคริสตกาล", "คริสต์ศักราช"]
}, gCe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["ไตรมาสแรก", "ไตรมาสที่สอง", "ไตรมาสที่สาม", "ไตรมาสที่สี่"]
}, yCe = {
  narrow: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  short: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  abbreviated: ["อา.", "จ.", "อ.", "พ.", "พฤ.", "ศ.", "ส."],
  wide: ["อาทิตย์", "จันทร์", "อังคาร", "พุธ", "พฤหัสบดี", "ศุกร์", "เสาร์"]
}, vCe = {
  narrow: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค."
  ],
  abbreviated: [
    "ม.ค.",
    "ก.พ.",
    "มี.ค.",
    "เม.ย.",
    "พ.ค.",
    "มิ.ย.",
    "ก.ค.",
    "ส.ค.",
    "ก.ย.",
    "ต.ค.",
    "พ.ย.",
    "ธ.ค."
  ],
  wide: [
    "มกราคม",
    "กุมภาพันธ์",
    "มีนาคม",
    "เมษายน",
    "พฤษภาคม",
    "มิถุนายน",
    "กรกฎาคม",
    "สิงหาคม",
    "กันยายน",
    "ตุลาคม",
    "พฤศจิกายน",
    "ธันวาคม"
  ]
}, bCe = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "เช้า",
    afternoon: "บ่าย",
    evening: "เย็น",
    night: "กลางคืน"
  }
}, wCe = {
  narrow: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  abbreviated: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  },
  wide: {
    am: "ก่อนเที่ยง",
    pm: "หลังเที่ยง",
    midnight: "เที่ยงคืน",
    noon: "เที่ยง",
    morning: "ตอนเช้า",
    afternoon: "ตอนกลางวัน",
    evening: "ตอนเย็น",
    night: "ตอนกลางคืน"
  }
}, kCe = (t, e) => String(t), xCe = {
  ordinalNumber: kCe,
  era: C({
    values: pCe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: gCe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: vCe,
    defaultWidth: "wide"
  }),
  day: C({
    values: yCe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: bCe,
    defaultWidth: "wide",
    formattingValues: wCe,
    defaultFormattingWidth: "wide"
  })
}, _Ce = /^\d+/i, MCe = /\d+/i, CCe = {
  narrow: /^([bB]|[aA]|คศ)/i,
  abbreviated: /^([bB]\.?\s?[cC]\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?|ค\.?ศ\.?)/i,
  wide: /^(ก่อนคริสตกาล|คริสต์ศักราช|คริสตกาล)/i
}, PCe = {
  any: [/^[bB]/i, /^(^[aA]|ค\.?ศ\.?|คริสตกาล|คริสต์ศักราช|)/i]
}, SCe = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^ไตรมาส(ที่)? ?[1234]/i
}, NCe = {
  any: [/(1|แรก|หนึ่ง)/i, /(2|สอง)/i, /(3|สาม)/i, /(4|สี่)/i]
}, $Ce = {
  narrow: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?)/i,
  abbreviated: /^(ม\.?ค\.?|ก\.?พ\.?|มี\.?ค\.?|เม\.?ย\.?|พ\.?ค\.?|มิ\.?ย\.?|ก\.?ค\.?|ส\.?ค\.?|ก\.?ย\.?|ต\.?ค\.?|พ\.?ย\.?|ธ\.?ค\.?')/i,
  wide: /^(มกราคม|กุมภาพันธ์|มีนาคม|เมษายน|พฤษภาคม|มิถุนายน|กรกฎาคม|สิงหาคม|กันยายน|ตุลาคม|พฤศจิกายน|ธันวาคม)/i
}, DCe = {
  wide: [
    /^มก/i,
    /^กุม/i,
    /^มี/i,
    /^เม/i,
    /^พฤษ/i,
    /^มิ/i,
    /^กรก/i,
    /^ส/i,
    /^กัน/i,
    /^ต/i,
    /^พฤศ/i,
    /^ธ/i
  ],
  any: [
    /^ม\.?ค\.?/i,
    /^ก\.?พ\.?/i,
    /^มี\.?ค\.?/i,
    /^เม\.?ย\.?/i,
    /^พ\.?ค\.?/i,
    /^มิ\.?ย\.?/i,
    /^ก\.?ค\.?/i,
    /^ส\.?ค\.?/i,
    /^ก\.?ย\.?/i,
    /^ต\.?ค\.?/i,
    /^พ\.?ย\.?/i,
    /^ธ\.?ค\.?/i
  ]
}, ECe = {
  narrow: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  short: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  abbreviated: /^(อา\.?|จ\.?|อ\.?|พฤ\.?|พ\.?|ศ\.?|ส\.?)/i,
  wide: /^(อาทิตย์|จันทร์|อังคาร|พุธ|พฤหัสบดี|ศุกร์|เสาร์)/i
}, TCe = {
  wide: [/^อา/i, /^จั/i, /^อั/i, /^พุธ/i, /^พฤ/i, /^ศ/i, /^เส/i],
  any: [/^อา/i, /^จ/i, /^อ/i, /^พ(?!ฤ)/i, /^พฤ/i, /^ศ/i, /^ส/i]
}, OCe = {
  any: /^(ก่อนเที่ยง|หลังเที่ยง|เที่ยงคืน|เที่ยง|(ตอน.*?)?.*(เที่ยง|เช้า|บ่าย|เย็น|กลางคืน))/i
}, WCe = {
  any: {
    am: /^ก่อนเที่ยง/i,
    pm: /^หลังเที่ยง/i,
    midnight: /^เที่ยงคืน/i,
    noon: /^เที่ยง/i,
    morning: /เช้า/i,
    afternoon: /บ่าย/i,
    evening: /เย็น/i,
    night: /กลางคืน/i
  }
}, ACe = {
  ordinalNumber: he({
    matchPattern: _Ce,
    parsePattern: MCe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: CCe,
    defaultMatchWidth: "wide",
    parsePatterns: PCe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: SCe,
    defaultMatchWidth: "wide",
    parsePatterns: NCe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: $Ce,
    defaultMatchWidth: "wide",
    parsePatterns: DCe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: ECe,
    defaultMatchWidth: "wide",
    parsePatterns: TCe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: OCe,
    defaultMatchWidth: "any",
    parsePatterns: WCe,
    defaultParseWidth: "any"
  })
}, LCe = {
  code: "th",
  formatDistance: lCe,
  formatLong: fCe,
  formatRelative: hCe,
  localize: xCe,
  match: ACe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, ICe = {
  lessThanXSeconds: {
    one: "bir saniyeden az",
    other: "{{count}} saniyeden az"
  },
  xSeconds: {
    one: "1 saniye",
    other: "{{count}} saniye"
  },
  halfAMinute: "yarım dakika",
  lessThanXMinutes: {
    one: "bir dakikadan az",
    other: "{{count}} dakikadan az"
  },
  xMinutes: {
    one: "1 dakika",
    other: "{{count}} dakika"
  },
  aboutXHours: {
    one: "yaklaşık 1 saat",
    other: "yaklaşık {{count}} saat"
  },
  xHours: {
    one: "1 saat",
    other: "{{count}} saat"
  },
  xDays: {
    one: "1 gün",
    other: "{{count}} gün"
  },
  aboutXWeeks: {
    one: "yaklaşık 1 hafta",
    other: "yaklaşık {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "yaklaşık 1 ay",
    other: "yaklaşık {{count}} ay"
  },
  xMonths: {
    one: "1 ay",
    other: "{{count}} ay"
  },
  aboutXYears: {
    one: "yaklaşık 1 yıl",
    other: "yaklaşık {{count}} yıl"
  },
  xYears: {
    one: "1 yıl",
    other: "{{count}} yıl"
  },
  overXYears: {
    one: "1 yıldan fazla",
    other: "{{count}} yıldan fazla"
  },
  almostXYears: {
    one: "neredeyse 1 yıl",
    other: "neredeyse {{count}} yıl"
  }
}, RCe = (t, e, n) => {
  let i;
  const r = ICe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", e.toString()), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " sonra" : i + " önce" : i;
}, jCe = {
  full: "d MMMM y EEEE",
  long: "d MMMM y",
  medium: "d MMM y",
  short: "dd.MM.yyyy"
}, FCe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, zCe = {
  full: "{{date}} 'saat' {{time}}",
  long: "{{date}} 'saat' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, VCe = {
  date: T({
    formats: jCe,
    defaultWidth: "full"
  }),
  time: T({
    formats: FCe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: zCe,
    defaultWidth: "full"
  })
}, HCe = {
  lastWeek: "'geçen hafta' eeee 'saat' p",
  yesterday: "'dün saat' p",
  today: "'bugün saat' p",
  tomorrow: "'yarın saat' p",
  nextWeek: "eeee 'saat' p",
  other: "P"
}, BCe = (t, e, n, i) => HCe[t], qCe = {
  narrow: ["MÖ", "MS"],
  abbreviated: ["MÖ", "MS"],
  wide: ["Milattan Önce", "Milattan Sonra"]
}, GCe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1Ç", "2Ç", "3Ç", "4Ç"],
  wide: ["İlk çeyrek", "İkinci Çeyrek", "Üçüncü çeyrek", "Son çeyrek"]
}, XCe = {
  narrow: ["O", "Ş", "M", "N", "M", "H", "T", "A", "E", "E", "K", "A"],
  abbreviated: [
    "Oca",
    "Şub",
    "Mar",
    "Nis",
    "May",
    "Haz",
    "Tem",
    "Ağu",
    "Eyl",
    "Eki",
    "Kas",
    "Ara"
  ],
  wide: [
    "Ocak",
    "Şubat",
    "Mart",
    "Nisan",
    "Mayıs",
    "Haziran",
    "Temmuz",
    "Ağustos",
    "Eylül",
    "Ekim",
    "Kasım",
    "Aralık"
  ]
}, YCe = {
  narrow: ["P", "P", "S", "Ç", "P", "C", "C"],
  short: ["Pz", "Pt", "Sa", "Ça", "Pe", "Cu", "Ct"],
  abbreviated: ["Paz", "Pzt", "Sal", "Çar", "Per", "Cum", "Cts"],
  wide: [
    "Pazar",
    "Pazartesi",
    "Salı",
    "Çarşamba",
    "Perşembe",
    "Cuma",
    "Cumartesi"
  ]
}, KCe = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  },
  wide: {
    am: "Ö.Ö.",
    pm: "Ö.S.",
    midnight: "gece yarısı",
    noon: "öğle",
    morning: "sabah",
    afternoon: "öğleden sonra",
    evening: "akşam",
    night: "gece"
  }
}, UCe = {
  narrow: {
    am: "öö",
    pm: "ös",
    midnight: "gy",
    noon: "ö",
    morning: "sa",
    afternoon: "ös",
    evening: "ak",
    night: "ge"
  },
  abbreviated: {
    am: "ÖÖ",
    pm: "ÖS",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  },
  wide: {
    am: "ö.ö.",
    pm: "ö.s.",
    midnight: "gece yarısı",
    noon: "öğlen",
    morning: "sabahleyin",
    afternoon: "öğleden sonra",
    evening: "akşamleyin",
    night: "geceleyin"
  }
}, JCe = (t, e) => Number(t) + ".", QCe = {
  ordinalNumber: JCe,
  era: C({
    values: qCe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: GCe,
    defaultWidth: "wide",
    argumentCallback: (t) => Number(t) - 1
  }),
  month: C({
    values: XCe,
    defaultWidth: "wide"
  }),
  day: C({
    values: YCe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: KCe,
    defaultWidth: "wide",
    formattingValues: UCe,
    defaultFormattingWidth: "wide"
  })
}, ZCe = /^(\d+)(\.)?/i, ePe = /\d+/i, tPe = {
  narrow: /^(mö|ms)/i,
  abbreviated: /^(mö|ms)/i,
  wide: /^(milattan önce|milattan sonra)/i
}, nPe = {
  any: [/(^mö|^milattan önce)/i, /(^ms|^milattan sonra)/i]
}, iPe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]ç/i,
  wide: /^((i|İ)lk|(i|İ)kinci|üçüncü|son) çeyrek/i
}, rPe = {
  any: [/1/i, /2/i, /3/i, /4/i],
  abbreviated: [/1ç/i, /2ç/i, /3ç/i, /4ç/i],
  wide: [
    /^(i|İ)lk çeyrek/i,
    /(i|İ)kinci çeyrek/i,
    /üçüncü çeyrek/i,
    /son çeyrek/i
  ]
}, aPe = {
  narrow: /^[oşmnhtaek]/i,
  abbreviated: /^(oca|şub|mar|nis|may|haz|tem|ağu|eyl|eki|kas|ara)/i,
  wide: /^(ocak|şubat|mart|nisan|mayıs|haziran|temmuz|ağustos|eylül|ekim|kasım|aralık)/i
}, oPe = {
  narrow: [
    /^o/i,
    /^ş/i,
    /^m/i,
    /^n/i,
    /^m/i,
    /^h/i,
    /^t/i,
    /^a/i,
    /^e/i,
    /^e/i,
    /^k/i,
    /^a/i
  ],
  any: [
    /^o/i,
    /^ş/i,
    /^mar/i,
    /^n/i,
    /^may/i,
    /^h/i,
    /^t/i,
    /^ağ/i,
    /^ey/i,
    /^ek/i,
    /^k/i,
    /^ar/i
  ]
}, sPe = {
  narrow: /^[psçc]/i,
  short: /^(pz|pt|sa|ça|pe|cu|ct)/i,
  abbreviated: /^(paz|pzt|sal|çar|per|cum|cts)/i,
  wide: /^(pazar(?!tesi)|pazartesi|salı|çarşamba|perşembe|cuma(?!rtesi)|cumartesi)/i
}, lPe = {
  narrow: [/^p/i, /^p/i, /^s/i, /^ç/i, /^p/i, /^c/i, /^c/i],
  any: [/^pz/i, /^pt/i, /^sa/i, /^ça/i, /^pe/i, /^cu/i, /^ct/i],
  wide: [
    /^pazar(?!tesi)/i,
    /^pazartesi/i,
    /^salı/i,
    /^çarşamba/i,
    /^perşembe/i,
    /^cuma(?!rtesi)/i,
    /^cumartesi/i
  ]
}, dPe = {
  narrow: /^(öö|ös|gy|ö|sa|ös|ak|ge)/i,
  any: /^(ö\.?\s?[ös]\.?|öğleden sonra|gece yarısı|öğle|(sabah|öğ|akşam|gece)(leyin))/i
}, cPe = {
  any: {
    am: /^ö\.?ö\.?/i,
    pm: /^ö\.?s\.?/i,
    midnight: /^(gy|gece yarısı)/i,
    noon: /^öğ/i,
    morning: /^sa/i,
    afternoon: /^öğleden sonra/i,
    evening: /^ak/i,
    night: /^ge/i
  }
}, uPe = {
  ordinalNumber: he({
    matchPattern: ZCe,
    parsePattern: ePe,
    valueCallback: function(t) {
      return parseInt(t, 10);
    }
  }),
  era: P({
    matchPatterns: tPe,
    defaultMatchWidth: "wide",
    parsePatterns: nPe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: iPe,
    defaultMatchWidth: "wide",
    parsePatterns: rPe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: aPe,
    defaultMatchWidth: "wide",
    parsePatterns: oPe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: sPe,
    defaultMatchWidth: "wide",
    parsePatterns: lPe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: dPe,
    defaultMatchWidth: "any",
    parsePatterns: cPe,
    defaultParseWidth: "any"
  })
}, fPe = {
  code: "tr",
  formatDistance: RCe,
  formatLong: VCe,
  formatRelative: BCe,
  localize: QCe,
  match: uPe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, mPe = {
  lessThanXSeconds: {
    one: "بىر سىكۇنت ئىچىدە",
    other: "سىكۇنت ئىچىدە {{count}}"
  },
  xSeconds: {
    one: "بىر سىكۇنت",
    other: "سىكۇنت {{count}}"
  },
  halfAMinute: "يىرىم مىنۇت",
  lessThanXMinutes: {
    one: "بىر مىنۇت ئىچىدە",
    other: "مىنۇت ئىچىدە {{count}}"
  },
  xMinutes: {
    one: "بىر مىنۇت",
    other: "مىنۇت {{count}}"
  },
  aboutXHours: {
    one: "تەخمىنەن بىر سائەت",
    other: "سائەت {{count}} تەخمىنەن"
  },
  xHours: {
    one: "بىر سائەت",
    other: "سائەت {{count}}"
  },
  xDays: {
    one: "بىر كۈن",
    other: "كۈن {{count}}"
  },
  aboutXWeeks: {
    one: "تەخمىنەن بىرھەپتە",
    other: "ھەپتە {{count}} تەخمىنەن"
  },
  xWeeks: {
    one: "بىرھەپتە",
    other: "ھەپتە {{count}}"
  },
  aboutXMonths: {
    one: "تەخمىنەن بىر ئاي",
    other: "ئاي {{count}} تەخمىنەن"
  },
  xMonths: {
    one: "بىر ئاي",
    other: "ئاي {{count}}"
  },
  aboutXYears: {
    one: "تەخمىنەن بىر يىل",
    other: "يىل {{count}} تەخمىنەن"
  },
  xYears: {
    one: "بىر يىل",
    other: "يىل {{count}}"
  },
  overXYears: {
    one: "بىر يىلدىن ئارتۇق",
    other: "يىلدىن ئارتۇق {{count}}"
  },
  almostXYears: {
    one: "ئاساسەن بىر يىل",
    other: "يىل {{count}} ئاساسەن"
  }
}, hPe = (t, e, n) => {
  let i;
  const r = mPe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i : i + " بولدى" : i;
}, pPe = {
  full: "EEEE, MMMM do, y",
  long: "MMMM do, y",
  medium: "MMM d, y",
  short: "MM/dd/yyyy"
}, gPe = {
  full: "h:mm:ss a zzzz",
  long: "h:mm:ss a z",
  medium: "h:mm:ss a",
  short: "h:mm a"
}, yPe = {
  full: "{{date}} 'دە' {{time}}",
  long: "{{date}} 'دە' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, vPe = {
  date: T({
    formats: pPe,
    defaultWidth: "full"
  }),
  time: T({
    formats: gPe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: yPe,
    defaultWidth: "full"
  })
}, bPe = {
  lastWeek: "'ئ‍ۆتكەن' eeee 'دە' p",
  yesterday: "'تۈنۈگۈن دە' p",
  today: "'بۈگۈن دە' p",
  tomorrow: "'ئەتە دە' p",
  nextWeek: "eeee 'دە' p",
  other: "P"
}, wPe = (t, e, n, i) => bPe[t], kPe = {
  narrow: ["ب", "ك"],
  abbreviated: ["ب", "ك"],
  wide: ["مىيلادىدىن بۇرۇن", "مىيلادىدىن كىيىن"]
}, xPe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1", "2", "3", "4"],
  wide: ["بىرىنجى چارەك", "ئىككىنجى چارەك", "ئۈچىنجى چارەك", "تۆتىنجى چارەك"]
}, _Pe = {
  narrow: ["ي", "ف", "م", "ا", "م", "ى", "ى", "ا", "س", "ۆ", "ن", "د"],
  abbreviated: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر"
  ],
  wide: [
    "يانۋار",
    "فېۋىرال",
    "مارت",
    "ئاپرىل",
    "ماي",
    "ئىيۇن",
    "ئىيول",
    "ئاۋغۇست",
    "سىنتەبىر",
    "ئۆكتەبىر",
    "نويابىر",
    "دىكابىر"
  ]
}, MPe = {
  narrow: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  short: ["ي", "د", "س", "چ", "پ", "ج", "ش"],
  abbreviated: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە"
  ],
  wide: [
    "يەكشەنبە",
    "دۈشەنبە",
    "سەيشەنبە",
    "چارشەنبە",
    "پەيشەنبە",
    "جۈمە",
    "شەنبە"
  ]
}, CPe = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەن",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشىم",
    night: "كىچە"
  }
}, PPe = {
  narrow: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  abbreviated: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  },
  wide: {
    am: "ئە",
    pm: "چ",
    midnight: "ك",
    noon: "چ",
    morning: "ئەتىگەندە",
    afternoon: "چۈشتىن كىيىن",
    evening: "ئاخشامدا",
    night: "كىچىدە"
  }
}, SPe = (t, e) => String(t), NPe = {
  ordinalNumber: SPe,
  era: C({
    values: kPe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: xPe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: _Pe,
    defaultWidth: "wide"
  }),
  day: C({
    values: MPe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: CPe,
    defaultWidth: "wide",
    formattingValues: PPe,
    defaultFormattingWidth: "wide"
  })
}, $Pe = /^(\d+)(th|st|nd|rd)?/i, DPe = /\d+/i, EPe = {
  narrow: /^(ب|ك)/i,
  wide: /^(مىيلادىدىن بۇرۇن|مىيلادىدىن كىيىن)/i
}, TPe = {
  any: [/^بۇرۇن/i, /^كىيىن/i]
}, OPe = {
  narrow: /^[1234]/i,
  abbreviated: /^چ[1234]/i,
  wide: /^چارەك [1234]/i
}, WPe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, APe = {
  // eslint-disable-next-line no-misleading-character-class
  narrow: /^[يفمئامئ‍ئاسۆند]/i,
  abbreviated: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i,
  wide: /^(يانۋار|فېۋىرال|مارت|ئاپرىل|ماي|ئىيۇن|ئىيول|ئاۋغۇست|سىنتەبىر|ئۆكتەبىر|نويابىر|دىكابىر)/i
}, LPe = {
  narrow: [
    /^ي/i,
    /^ف/i,
    /^م/i,
    /^ا/i,
    /^م/i,
    /^ى‍/i,
    /^ى‍/i,
    /^ا‍/i,
    /^س/i,
    /^ۆ/i,
    /^ن/i,
    /^د/i
  ],
  any: [
    /^يان/i,
    /^فېۋ/i,
    /^مار/i,
    /^ئاپ/i,
    /^ماي/i,
    /^ئىيۇن/i,
    /^ئىيول/i,
    /^ئاۋ/i,
    /^سىن/i,
    /^ئۆك/i,
    /^نوي/i,
    /^دىك/i
  ]
}, IPe = {
  narrow: /^[دسچپجشي]/i,
  short: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  abbreviated: /^(يە|دۈ|سە|چا|پە|جۈ|شە)/i,
  wide: /^(يەكشەنبە|دۈشەنبە|سەيشەنبە|چارشەنبە|پەيشەنبە|جۈمە|شەنبە)/i
}, RPe = {
  narrow: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i],
  any: [/^ي/i, /^د/i, /^س/i, /^چ/i, /^پ/i, /^ج/i, /^ش/i]
}, jPe = {
  narrow: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i,
  any: /^(ئە|چ|ك|چ|(دە|ئەتىگەن) ( ئە‍|چۈشتىن كىيىن|ئاخشىم|كىچە))/i
}, FPe = {
  any: {
    am: /^ئە/i,
    pm: /^چ/i,
    midnight: /^ك/i,
    noon: /^چ/i,
    morning: /ئەتىگەن/i,
    afternoon: /چۈشتىن كىيىن/i,
    evening: /ئاخشىم/i,
    night: /كىچە/i
  }
}, zPe = {
  ordinalNumber: he({
    matchPattern: $Pe,
    parsePattern: DPe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: EPe,
    defaultMatchWidth: "wide",
    parsePatterns: TPe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: OPe,
    defaultMatchWidth: "wide",
    parsePatterns: WPe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: APe,
    defaultMatchWidth: "wide",
    parsePatterns: LPe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: IPe,
    defaultMatchWidth: "wide",
    parsePatterns: RPe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: jPe,
    defaultMatchWidth: "any",
    parsePatterns: FPe,
    defaultParseWidth: "any"
  })
}, VPe = {
  code: "ug",
  formatDistance: hPe,
  formatLong: vPe,
  formatRelative: wPe,
  localize: NPe,
  match: zPe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
function kl(t, e) {
  if (t.one !== void 0 && e === 1)
    return t.one;
  const n = e % 10, i = e % 100;
  return n === 1 && i !== 11 ? t.singularNominative.replace("{{count}}", String(e)) : n >= 2 && n <= 4 && (i < 10 || i > 20) ? t.singularGenitive.replace("{{count}}", String(e)) : t.pluralGenitive.replace("{{count}}", String(e));
}
function En(t) {
  return (e, n) => n && n.addSuffix ? n.comparison && n.comparison > 0 ? t.future ? kl(t.future, e) : "за " + kl(t.regular, e) : t.past ? kl(t.past, e) : kl(t.regular, e) + " тому" : kl(t.regular, e);
}
const HPe = (t, e) => e && e.addSuffix ? e.comparison && e.comparison > 0 ? "за півхвилини" : "півхвилини тому" : "півхвилини", BPe = {
  lessThanXSeconds: En({
    regular: {
      one: "менше секунди",
      singularNominative: "менше {{count}} секунди",
      singularGenitive: "менше {{count}} секунд",
      pluralGenitive: "менше {{count}} секунд"
    },
    future: {
      one: "менше, ніж за секунду",
      singularNominative: "менше, ніж за {{count}} секунду",
      singularGenitive: "менше, ніж за {{count}} секунди",
      pluralGenitive: "менше, ніж за {{count}} секунд"
    }
  }),
  xSeconds: En({
    regular: {
      singularNominative: "{{count}} секунда",
      singularGenitive: "{{count}} секунди",
      pluralGenitive: "{{count}} секунд"
    },
    past: {
      singularNominative: "{{count}} секунду тому",
      singularGenitive: "{{count}} секунди тому",
      pluralGenitive: "{{count}} секунд тому"
    },
    future: {
      singularNominative: "за {{count}} секунду",
      singularGenitive: "за {{count}} секунди",
      pluralGenitive: "за {{count}} секунд"
    }
  }),
  halfAMinute: HPe,
  lessThanXMinutes: En({
    regular: {
      one: "менше хвилини",
      singularNominative: "менше {{count}} хвилини",
      singularGenitive: "менше {{count}} хвилин",
      pluralGenitive: "менше {{count}} хвилин"
    },
    future: {
      one: "менше, ніж за хвилину",
      singularNominative: "менше, ніж за {{count}} хвилину",
      singularGenitive: "менше, ніж за {{count}} хвилини",
      pluralGenitive: "менше, ніж за {{count}} хвилин"
    }
  }),
  xMinutes: En({
    regular: {
      singularNominative: "{{count}} хвилина",
      singularGenitive: "{{count}} хвилини",
      pluralGenitive: "{{count}} хвилин"
    },
    past: {
      singularNominative: "{{count}} хвилину тому",
      singularGenitive: "{{count}} хвилини тому",
      pluralGenitive: "{{count}} хвилин тому"
    },
    future: {
      singularNominative: "за {{count}} хвилину",
      singularGenitive: "за {{count}} хвилини",
      pluralGenitive: "за {{count}} хвилин"
    }
  }),
  aboutXHours: En({
    regular: {
      singularNominative: "близько {{count}} години",
      singularGenitive: "близько {{count}} годин",
      pluralGenitive: "близько {{count}} годин"
    },
    future: {
      singularNominative: "приблизно за {{count}} годину",
      singularGenitive: "приблизно за {{count}} години",
      pluralGenitive: "приблизно за {{count}} годин"
    }
  }),
  xHours: En({
    regular: {
      singularNominative: "{{count}} годину",
      singularGenitive: "{{count}} години",
      pluralGenitive: "{{count}} годин"
    }
  }),
  xDays: En({
    regular: {
      singularNominative: "{{count}} день",
      singularGenitive: "{{count}} днi",
      pluralGenitive: "{{count}} днів"
    }
  }),
  aboutXWeeks: En({
    regular: {
      singularNominative: "близько {{count}} тижня",
      singularGenitive: "близько {{count}} тижнів",
      pluralGenitive: "близько {{count}} тижнів"
    },
    future: {
      singularNominative: "приблизно за {{count}} тиждень",
      singularGenitive: "приблизно за {{count}} тижні",
      pluralGenitive: "приблизно за {{count}} тижнів"
    }
  }),
  xWeeks: En({
    regular: {
      singularNominative: "{{count}} тиждень",
      singularGenitive: "{{count}} тижні",
      pluralGenitive: "{{count}} тижнів"
    }
  }),
  aboutXMonths: En({
    regular: {
      singularNominative: "близько {{count}} місяця",
      singularGenitive: "близько {{count}} місяців",
      pluralGenitive: "близько {{count}} місяців"
    },
    future: {
      singularNominative: "приблизно за {{count}} місяць",
      singularGenitive: "приблизно за {{count}} місяці",
      pluralGenitive: "приблизно за {{count}} місяців"
    }
  }),
  xMonths: En({
    regular: {
      singularNominative: "{{count}} місяць",
      singularGenitive: "{{count}} місяці",
      pluralGenitive: "{{count}} місяців"
    }
  }),
  aboutXYears: En({
    regular: {
      singularNominative: "близько {{count}} року",
      singularGenitive: "близько {{count}} років",
      pluralGenitive: "близько {{count}} років"
    },
    future: {
      singularNominative: "приблизно за {{count}} рік",
      singularGenitive: "приблизно за {{count}} роки",
      pluralGenitive: "приблизно за {{count}} років"
    }
  }),
  xYears: En({
    regular: {
      singularNominative: "{{count}} рік",
      singularGenitive: "{{count}} роки",
      pluralGenitive: "{{count}} років"
    }
  }),
  overXYears: En({
    regular: {
      singularNominative: "більше {{count}} року",
      singularGenitive: "більше {{count}} років",
      pluralGenitive: "більше {{count}} років"
    },
    future: {
      singularNominative: "більше, ніж за {{count}} рік",
      singularGenitive: "більше, ніж за {{count}} роки",
      pluralGenitive: "більше, ніж за {{count}} років"
    }
  }),
  almostXYears: En({
    regular: {
      singularNominative: "майже {{count}} рік",
      singularGenitive: "майже {{count}} роки",
      pluralGenitive: "майже {{count}} років"
    },
    future: {
      singularNominative: "майже за {{count}} рік",
      singularGenitive: "майже за {{count}} роки",
      pluralGenitive: "майже за {{count}} років"
    }
  })
}, qPe = (t, e, n) => (n = n || {}, BPe[t](e, n)), GPe = {
  full: "EEEE, do MMMM y 'р.'",
  long: "do MMMM y 'р.'",
  medium: "d MMM y 'р.'",
  short: "dd.MM.y"
}, XPe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, YPe = {
  full: "{{date}} 'о' {{time}}",
  long: "{{date}} 'о' {{time}}",
  medium: "{{date}}, {{time}}",
  short: "{{date}}, {{time}}"
}, KPe = {
  date: T({
    formats: GPe,
    defaultWidth: "full"
  }),
  time: T({
    formats: XPe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: YPe,
    defaultWidth: "full"
  })
}, g0 = [
  "неділю",
  "понеділок",
  "вівторок",
  "середу",
  "четвер",
  "п’ятницю",
  "суботу"
];
function UPe(t) {
  const e = g0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у минулу " + e + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у минулий " + e + " о' p";
  }
}
function CP(t) {
  return "'у " + g0[t] + " о' p";
}
function JPe(t) {
  const e = g0[t];
  switch (t) {
    case 0:
    case 3:
    case 5:
    case 6:
      return "'у наступну " + e + " о' p";
    case 1:
    case 2:
    case 4:
      return "'у наступний " + e + " о' p";
  }
}
const QPe = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? CP(r) : UPe(r);
}, ZPe = (t, e, n) => {
  const i = ke(t), r = i.getDay();
  return Lt(i, e, n) ? CP(r) : JPe(r);
}, e8e = {
  lastWeek: QPe,
  yesterday: "'вчора о' p",
  today: "'сьогодні о' p",
  tomorrow: "'завтра о' p",
  nextWeek: ZPe,
  other: "P"
}, t8e = (t, e, n, i) => {
  const r = e8e[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, n8e = {
  narrow: ["до н.е.", "н.е."],
  abbreviated: ["до н. е.", "н. е."],
  wide: ["до нашої ери", "нашої ери"]
}, i8e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-й кв.", "2-й кв.", "3-й кв.", "4-й кв."],
  wide: ["1-й квартал", "2-й квартал", "3-й квартал", "4-й квартал"]
}, r8e = {
  // ДСТУ 3582:2013
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд."
  ],
  wide: [
    "січень",
    "лютий",
    "березень",
    "квітень",
    "травень",
    "червень",
    "липень",
    "серпень",
    "вересень",
    "жовтень",
    "листопад",
    "грудень"
  ]
}, a8e = {
  narrow: ["С", "Л", "Б", "К", "Т", "Ч", "Л", "С", "В", "Ж", "Л", "Г"],
  abbreviated: [
    "січ.",
    "лют.",
    "берез.",
    "квіт.",
    "трав.",
    "черв.",
    "лип.",
    "серп.",
    "верес.",
    "жовт.",
    "листоп.",
    "груд."
  ],
  wide: [
    "січня",
    "лютого",
    "березня",
    "квітня",
    "травня",
    "червня",
    "липня",
    "серпня",
    "вересня",
    "жовтня",
    "листопада",
    "грудня"
  ]
}, o8e = {
  narrow: ["Н", "П", "В", "С", "Ч", "П", "С"],
  short: ["нд", "пн", "вт", "ср", "чт", "пт", "сб"],
  abbreviated: ["нед", "пон", "вів", "сер", "чтв", "птн", "суб"],
  wide: [
    "неділя",
    "понеділок",
    "вівторок",
    "середа",
    "четвер",
    "п’ятниця",
    "субота"
  ]
}, s8e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранок",
    afternoon: "день",
    evening: "веч.",
    night: "ніч"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранок",
    afternoon: "день",
    evening: "вечір",
    night: "ніч"
  }
}, l8e = {
  narrow: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  abbreviated: {
    am: "ДП",
    pm: "ПП",
    midnight: "півн.",
    noon: "пол.",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  },
  wide: {
    am: "ДП",
    pm: "ПП",
    midnight: "північ",
    noon: "полудень",
    morning: "ранку",
    afternoon: "дня",
    evening: "веч.",
    night: "ночі"
  }
}, d8e = (t, e) => {
  const n = String(e == null ? void 0 : e.unit), i = Number(t);
  let r;
  return n === "date" ? i === 3 || i === 23 ? r = "-є" : r = "-е" : n === "minute" || n === "second" || n === "hour" ? r = "-а" : r = "-й", i + r;
}, c8e = {
  ordinalNumber: d8e,
  era: C({
    values: n8e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: i8e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: r8e,
    defaultWidth: "wide",
    formattingValues: a8e,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: o8e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: s8e,
    defaultWidth: "any",
    formattingValues: l8e,
    defaultFormattingWidth: "wide"
  })
}, u8e = /^(\d+)(-?(е|й|є|а|я))?/i, f8e = /\d+/i, m8e = {
  narrow: /^((до )?н\.?\s?е\.?)/i,
  abbreviated: /^((до )?н\.?\s?е\.?)/i,
  wide: /^(до нашої ери|нашої ери|наша ера)/i
}, h8e = {
  any: [/^д/i, /^н/i]
}, p8e = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234](-?[иі]?й?)? кв.?/i,
  wide: /^[1234](-?[иі]?й?)? квартал/i
}, g8e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, y8e = {
  narrow: /^[слбктчвжг]/i,
  abbreviated: /^(січ|лют|бер(ез)?|квіт|трав|черв|лип|серп|вер(ес)?|жовт|лис(топ)?|груд)\.?/i,
  wide: /^(січень|січня|лютий|лютого|березень|березня|квітень|квітня|травень|травня|червня|червень|липень|липня|серпень|серпня|вересень|вересня|жовтень|жовтня|листопад[а]?|грудень|грудня)/i
}, v8e = {
  narrow: [
    /^с/i,
    /^л/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^л/i,
    /^с/i,
    /^в/i,
    /^ж/i,
    /^л/i,
    /^г/i
  ],
  any: [
    /^сі/i,
    /^лю/i,
    /^б/i,
    /^к/i,
    /^т/i,
    /^ч/i,
    /^лип/i,
    /^се/i,
    /^в/i,
    /^ж/i,
    /^лис/i,
    /^г/i
  ]
}, b8e = {
  narrow: /^[нпвсч]/i,
  short: /^(нд|пн|вт|ср|чт|пт|сб)\.?/i,
  abbreviated: /^(нед|пон|вів|сер|че?тв|птн?|суб)\.?/i,
  wide: /^(неділ[яі]|понеділ[ок][ка]|вівтор[ок][ка]|серед[аи]|четвер(га)?|п\W*?ятниц[яі]|субот[аи])/i
}, w8e = {
  narrow: [/^н/i, /^п/i, /^в/i, /^с/i, /^ч/i, /^п/i, /^с/i],
  any: [/^н/i, /^п[он]/i, /^в/i, /^с[ер]/i, /^ч/i, /^п\W*?[ят]/i, /^с[уб]/i]
}, k8e = {
  narrow: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  abbreviated: /^([дп]п|півн\.?|пол\.?|ранок|ранку|день|дня|веч\.?|ніч|ночі)/i,
  wide: /^([дп]п|північ|полудень|ранок|ранку|день|дня|вечір|вечора|ніч|ночі)/i
}, x8e = {
  any: {
    am: /^дп/i,
    pm: /^пп/i,
    midnight: /^півн/i,
    noon: /^пол/i,
    morning: /^р/i,
    afternoon: /^д[ен]/i,
    evening: /^в/i,
    night: /^н/i
  }
}, _8e = {
  ordinalNumber: he({
    matchPattern: u8e,
    parsePattern: f8e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: m8e,
    defaultMatchWidth: "wide",
    parsePatterns: h8e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: p8e,
    defaultMatchWidth: "wide",
    parsePatterns: g8e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: y8e,
    defaultMatchWidth: "wide",
    parsePatterns: v8e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: b8e,
    defaultMatchWidth: "wide",
    parsePatterns: w8e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: k8e,
    defaultMatchWidth: "wide",
    parsePatterns: x8e,
    defaultParseWidth: "any"
  })
}, M8e = {
  code: "uk",
  formatDistance: qPe,
  formatLong: KPe,
  formatRelative: t8e,
  localize: c8e,
  match: _8e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, C8e = {
  lessThanXSeconds: {
    one: "sekunddan kam",
    other: "{{count}} sekunddan kam"
  },
  xSeconds: {
    one: "1 sekund",
    other: "{{count}} sekund"
  },
  halfAMinute: "yarim minut",
  lessThanXMinutes: {
    one: "bir minutdan kam",
    other: "{{count}} minutdan kam"
  },
  xMinutes: {
    one: "1 minut",
    other: "{{count}} minut"
  },
  aboutXHours: {
    one: "tahminan 1 soat",
    other: "tahminan {{count}} soat"
  },
  xHours: {
    one: "1 soat",
    other: "{{count}} soat"
  },
  xDays: {
    one: "1 kun",
    other: "{{count}} kun"
  },
  aboutXWeeks: {
    one: "tahminan 1 hafta",
    other: "tahminan {{count}} hafta"
  },
  xWeeks: {
    one: "1 hafta",
    other: "{{count}} hafta"
  },
  aboutXMonths: {
    one: "tahminan 1 oy",
    other: "tahminan {{count}} oy"
  },
  xMonths: {
    one: "1 oy",
    other: "{{count}} oy"
  },
  aboutXYears: {
    one: "tahminan 1 yil",
    other: "tahminan {{count}} yil"
  },
  xYears: {
    one: "1 yil",
    other: "{{count}} yil"
  },
  overXYears: {
    one: "1 yildan ko'p",
    other: "{{count}} yildan ko'p"
  },
  almostXYears: {
    one: "deyarli 1 yil",
    other: "deyarli {{count}} yil"
  }
}, P8e = (t, e, n) => {
  let i;
  const r = C8e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " dan keyin" : i + " oldin" : i;
}, S8e = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, N8e = {
  full: "h:mm:ss zzzz",
  long: "h:mm:ss z",
  medium: "h:mm:ss",
  short: "h:mm"
}, $8e = {
  any: "{{date}}, {{time}}"
}, D8e = {
  date: T({
    formats: S8e,
    defaultWidth: "full"
  }),
  time: T({
    formats: N8e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: $8e,
    defaultWidth: "any"
  })
}, E8e = {
  lastWeek: "'oldingi' eeee p 'da'",
  yesterday: "'kecha' p 'da'",
  today: "'bugun' p 'da'",
  tomorrow: "'ertaga' p 'da'",
  nextWeek: "eeee p 'da'",
  other: "P"
}, T8e = (t, e, n, i) => E8e[t], O8e = {
  narrow: ["M.A", "M."],
  abbreviated: ["M.A", "M."],
  wide: ["Miloddan Avvalgi", "Milodiy"]
}, W8e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["CH.1", "CH.2", "CH.3", "CH.4"],
  wide: ["1-chi chorak", "2-chi chorak", "3-chi chorak", "4-chi chorak"]
}, A8e = {
  narrow: ["Y", "F", "M", "A", "M", "I", "I", "A", "S", "O", "N", "D"],
  abbreviated: [
    "Yan",
    "Fev",
    "Mar",
    "Apr",
    "May",
    "Iyun",
    "Iyul",
    "Avg",
    "Sen",
    "Okt",
    "Noy",
    "Dek"
  ],
  wide: [
    "Yanvar",
    "Fevral",
    "Mart",
    "Aprel",
    "May",
    "Iyun",
    "Iyul",
    "Avgust",
    "Sentabr",
    "Oktabr",
    "Noyabr",
    "Dekabr"
  ]
}, L8e = {
  narrow: ["Y", "D", "S", "CH", "P", "J", "SH"],
  short: ["Ya", "Du", "Se", "Cho", "Pa", "Ju", "Sha"],
  abbreviated: ["Yak", "Dush", "Sesh", "Chor", "Pay", "Jum", "Shan"],
  wide: [
    "Yakshanba",
    "Dushanba",
    "Seshanba",
    "Chorshanba",
    "Payshanba",
    "Juma",
    "Shanba"
  ]
}, I8e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, R8e = {
  narrow: {
    am: "a",
    pm: "p",
    midnight: "y.t",
    noon: "p.",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  },
  wide: {
    am: "a.m.",
    pm: "p.m.",
    midnight: "yarim tun",
    noon: "peshin",
    morning: "ertalab",
    afternoon: "tushdan keyin",
    evening: "kechqurun",
    night: "tun"
  }
}, j8e = (t, e) => String(t), F8e = {
  ordinalNumber: j8e,
  era: C({
    values: O8e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: W8e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: A8e,
    defaultWidth: "wide"
  }),
  day: C({
    values: L8e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: I8e,
    defaultWidth: "wide",
    formattingValues: R8e,
    defaultFormattingWidth: "wide"
  })
}, z8e = /^(\d+)(chi)?/i, V8e = /\d+/i, H8e = {
  narrow: /^(m\.a|m\.)/i,
  abbreviated: /^(m\.a\.?\s?m\.?)/i,
  wide: /^(miloddan avval|miloddan keyin)/i
}, B8e = {
  any: [/^b/i, /^(a|c)/i]
}, q8e = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](chi)? chorak/i
}, G8e = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, X8e = {
  narrow: /^[yfmasond]/i,
  abbreviated: /^(yan|fev|mar|apr|may|iyun|iyul|avg|sen|okt|noy|dek)/i,
  wide: /^(yanvar|fevral|mart|aprel|may|iyun|iyul|avgust|sentabr|oktabr|noyabr|dekabr)/i
}, Y8e = {
  narrow: [
    /^y/i,
    /^f/i,
    /^m/i,
    /^a/i,
    /^m/i,
    /^i/i,
    /^i/i,
    /^a/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ],
  any: [
    /^ya/i,
    /^f/i,
    /^mar/i,
    /^ap/i,
    /^may/i,
    /^iyun/i,
    /^iyul/i,
    /^av/i,
    /^s/i,
    /^o/i,
    /^n/i,
    /^d/i
  ]
}, K8e = {
  narrow: /^[ydschj]/i,
  short: /^(ya|du|se|cho|pa|ju|sha)/i,
  abbreviated: /^(yak|dush|sesh|chor|pay|jum|shan)/i,
  wide: /^(yakshanba|dushanba|seshanba|chorshanba|payshanba|juma|shanba)/i
}, U8e = {
  narrow: [/^y/i, /^d/i, /^s/i, /^ch/i, /^p/i, /^j/i, /^sh/i],
  any: [/^ya/i, /^d/i, /^se/i, /^ch/i, /^p/i, /^j/i, /^sh/i]
}, J8e = {
  narrow: /^(a|p|y\.t|p| (ertalab|tushdan keyin|kechqurun|tun))/i,
  any: /^([ap]\.?\s?m\.?|yarim tun|peshin| (ertalab|tushdan keyin|kechqurun|tun))/i
}, Q8e = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^y\.t/i,
    noon: /^pe/i,
    morning: /ertalab/i,
    afternoon: /tushdan keyin/i,
    evening: /kechqurun/i,
    night: /tun/i
  }
}, Z8e = {
  ordinalNumber: he({
    matchPattern: z8e,
    parsePattern: V8e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: H8e,
    defaultMatchWidth: "wide",
    parsePatterns: B8e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: q8e,
    defaultMatchWidth: "wide",
    parsePatterns: G8e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: X8e,
    defaultMatchWidth: "wide",
    parsePatterns: Y8e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: K8e,
    defaultMatchWidth: "wide",
    parsePatterns: U8e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: J8e,
    defaultMatchWidth: "any",
    parsePatterns: Q8e,
    defaultParseWidth: "any"
  })
}, eSe = {
  code: "uz",
  formatDistance: P8e,
  formatLong: D8e,
  formatRelative: T8e,
  localize: F8e,
  match: Z8e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, tSe = {
  lessThanXSeconds: {
    one: "1 сониядан кам",
    other: "{{count}} сониядан кам"
  },
  xSeconds: {
    one: "1 сония",
    other: "{{count}} сония"
  },
  halfAMinute: "ярим дақиқа",
  lessThanXMinutes: {
    one: "1 дақиқадан кам",
    other: "{{count}} дақиқадан кам"
  },
  xMinutes: {
    one: "1 дақиқа",
    other: "{{count}} дақиқа"
  },
  aboutXHours: {
    one: "тахминан 1 соат",
    other: "тахминан {{count}} соат"
  },
  xHours: {
    one: "1 соат",
    other: "{{count}} соат"
  },
  xDays: {
    one: "1 кун",
    other: "{{count}} кун"
  },
  aboutXWeeks: {
    one: "тахминан 1 хафта",
    other: "тахминан {{count}} хафта"
  },
  xWeeks: {
    one: "1 хафта",
    other: "{{count}} хафта"
  },
  aboutXMonths: {
    one: "тахминан 1 ой",
    other: "тахминан {{count}} ой"
  },
  xMonths: {
    one: "1 ой",
    other: "{{count}} ой"
  },
  aboutXYears: {
    one: "тахминан 1 йил",
    other: "тахминан {{count}} йил"
  },
  xYears: {
    one: "1 йил",
    other: "{{count}} йил"
  },
  overXYears: {
    one: "1 йилдан кўп",
    other: "{{count}} йилдан кўп"
  },
  almostXYears: {
    one: "деярли 1 йил",
    other: "деярли {{count}} йил"
  }
}, nSe = (t, e, n) => {
  let i;
  const r = tSe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "дан кейин" : i + " олдин" : i;
}, iSe = {
  full: "EEEE, do MMMM, y",
  long: "do MMMM, y",
  medium: "d MMM, y",
  short: "dd/MM/yyyy"
}, rSe = {
  full: "H:mm:ss zzzz",
  long: "H:mm:ss z",
  medium: "H:mm:ss",
  short: "H:mm"
}, aSe = {
  any: "{{date}}, {{time}}"
}, oSe = {
  date: T({
    formats: iSe,
    defaultWidth: "full"
  }),
  time: T({
    formats: rSe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: aSe,
    defaultWidth: "any"
  })
}, sSe = {
  lastWeek: "'ўтган' eeee p 'да'",
  yesterday: "'кеча' p 'да'",
  today: "'бугун' p 'да'",
  tomorrow: "'эртага' p 'да'",
  nextWeek: "eeee p 'да'",
  other: "P"
}, lSe = (t, e, n, i) => sSe[t], dSe = {
  narrow: ["М.А", "М"],
  abbreviated: ["М.А", "М"],
  wide: ["Милоддан Аввалги", "Милодий"]
}, cSe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["1-чор.", "2-чор.", "3-чор.", "4-чор."],
  wide: ["1-чорак", "2-чорак", "3-чорак", "4-чорак"]
}, uSe = {
  narrow: ["Я", "Ф", "М", "А", "М", "И", "И", "А", "С", "О", "Н", "Д"],
  abbreviated: [
    "янв",
    "фев",
    "мар",
    "апр",
    "май",
    "июн",
    "июл",
    "авг",
    "сен",
    "окт",
    "ноя",
    "дек"
  ],
  wide: [
    "январ",
    "феврал",
    "март",
    "апрел",
    "май",
    "июн",
    "июл",
    "август",
    "сентабр",
    "октабр",
    "ноябр",
    "декабр"
  ]
}, fSe = {
  narrow: ["Я", "Д", "С", "Ч", "П", "Ж", "Ш"],
  short: ["як", "ду", "се", "чо", "па", "жу", "ша"],
  abbreviated: ["якш", "душ", "сеш", "чор", "пай", "жум", "шан"],
  wide: [
    "якшанба",
    "душанба",
    "сешанба",
    "чоршанба",
    "пайшанба",
    "жума",
    "шанба"
  ]
}, mSe = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, hSe = {
  any: {
    am: "П.О.",
    pm: "П.К.",
    midnight: "ярим тун",
    noon: "пешин",
    morning: "эрталаб",
    afternoon: "пешиндан кейин",
    evening: "кечаси",
    night: "тун"
  }
}, pSe = (t, e) => String(t), gSe = {
  ordinalNumber: pSe,
  era: C({
    values: dSe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: cSe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: uSe,
    defaultWidth: "wide"
  }),
  day: C({
    values: fSe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: mSe,
    defaultWidth: "any",
    formattingValues: hSe,
    defaultFormattingWidth: "any"
  })
}, ySe = /^(\d+)(чи)?/i, vSe = /\d+/i, bSe = {
  narrow: /^(м\.а|м\.)/i,
  abbreviated: /^(м\.а|м\.)/i,
  wide: /^(милоддан аввал|милоддан кейин)/i
}, wSe = {
  any: [/^м/i, /^а/i]
}, kSe = {
  narrow: /^[1234]/i,
  abbreviated: /^[1234]-чор./i,
  wide: /^[1234]-чорак/i
}, xSe = {
  any: [/1/i, /2/i, /3/i, /4/i]
}, _Se = {
  narrow: /^[яфмамииасонд]/i,
  abbreviated: /^(янв|фев|мар|апр|май|июн|июл|авг|сен|окт|ноя|дек)/i,
  wide: /^(январ|феврал|март|апрел|май|июн|июл|август|сентабр|октабр|ноябр|декабр)/i
}, MSe = {
  narrow: [
    /^я/i,
    /^ф/i,
    /^м/i,
    /^а/i,
    /^м/i,
    /^и/i,
    /^и/i,
    /^а/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ],
  any: [
    /^я/i,
    /^ф/i,
    /^мар/i,
    /^ап/i,
    /^май/i,
    /^июн/i,
    /^июл/i,
    /^ав/i,
    /^с/i,
    /^о/i,
    /^н/i,
    /^д/i
  ]
}, CSe = {
  narrow: /^[ядсчпжш]/i,
  short: /^(як|ду|се|чо|па|жу|ша)/i,
  abbreviated: /^(якш|душ|сеш|чор|пай|жум|шан)/i,
  wide: /^(якшанба|душанба|сешанба|чоршанба|пайшанба|жума|шанба)/i
}, PSe = {
  narrow: [/^я/i, /^д/i, /^с/i, /^ч/i, /^п/i, /^ж/i, /^ш/i],
  any: [/^як/i, /^ду/i, /^се/i, /^чор/i, /^пай/i, /^жу/i, /^шан/i]
}, SSe = {
  any: /^(п\.о\.|п\.к\.|ярим тун|пешиндан кейин|(эрталаб|пешиндан кейин|кечаси|тун))/i
}, NSe = {
  any: {
    am: /^п\.о\./i,
    pm: /^п\.к\./i,
    midnight: /^ярим тун/i,
    noon: /^пешиндан кейин/i,
    morning: /эрталаб/i,
    afternoon: /пешиндан кейин/i,
    evening: /кечаси/i,
    night: /тун/i
  }
}, $Se = {
  ordinalNumber: he({
    matchPattern: ySe,
    parsePattern: vSe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: bSe,
    defaultMatchWidth: "wide",
    parsePatterns: wSe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: kSe,
    defaultMatchWidth: "wide",
    parsePatterns: xSe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: _Se,
    defaultMatchWidth: "wide",
    parsePatterns: MSe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: CSe,
    defaultMatchWidth: "wide",
    parsePatterns: PSe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: SSe,
    defaultMatchWidth: "any",
    parsePatterns: NSe,
    defaultParseWidth: "any"
  })
}, DSe = {
  code: "uz-Cyrl",
  formatDistance: nSe,
  formatLong: oSe,
  formatRelative: lSe,
  localize: gSe,
  match: $Se,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, ESe = {
  lessThanXSeconds: {
    one: "dưới 1 giây",
    other: "dưới {{count}} giây"
  },
  xSeconds: {
    one: "1 giây",
    other: "{{count}} giây"
  },
  halfAMinute: "nửa phút",
  lessThanXMinutes: {
    one: "dưới 1 phút",
    other: "dưới {{count}} phút"
  },
  xMinutes: {
    one: "1 phút",
    other: "{{count}} phút"
  },
  aboutXHours: {
    one: "khoảng 1 giờ",
    other: "khoảng {{count}} giờ"
  },
  xHours: {
    one: "1 giờ",
    other: "{{count}} giờ"
  },
  xDays: {
    one: "1 ngày",
    other: "{{count}} ngày"
  },
  aboutXWeeks: {
    one: "khoảng 1 tuần",
    other: "khoảng {{count}} tuần"
  },
  xWeeks: {
    one: "1 tuần",
    other: "{{count}} tuần"
  },
  aboutXMonths: {
    one: "khoảng 1 tháng",
    other: "khoảng {{count}} tháng"
  },
  xMonths: {
    one: "1 tháng",
    other: "{{count}} tháng"
  },
  aboutXYears: {
    one: "khoảng 1 năm",
    other: "khoảng {{count}} năm"
  },
  xYears: {
    one: "1 năm",
    other: "{{count}} năm"
  },
  overXYears: {
    one: "hơn 1 năm",
    other: "hơn {{count}} năm"
  },
  almostXYears: {
    one: "gần 1 năm",
    other: "gần {{count}} năm"
  }
}, TSe = (t, e, n) => {
  let i;
  const r = ESe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + " nữa" : i + " trước" : i;
}, OSe = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017
  full: "EEEE, 'ngày' d MMMM 'năm' y",
  // ngày 25 tháng 08 năm 2017
  long: "'ngày' d MMMM 'năm' y",
  // 25 thg 08 năm 2017
  medium: "d MMM 'năm' y",
  // 25/08/2017
  short: "dd/MM/y"
}, WSe = {
  full: "HH:mm:ss zzzz",
  long: "HH:mm:ss z",
  medium: "HH:mm:ss",
  short: "HH:mm"
}, ASe = {
  // thứ Sáu, ngày 25 tháng 08 năm 2017 23:25:59
  full: "{{date}} {{time}}",
  // ngày 25 tháng 08 năm 2017 23:25
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, LSe = {
  date: T({
    formats: OSe,
    defaultWidth: "full"
  }),
  time: T({
    formats: WSe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: ASe,
    defaultWidth: "full"
  })
}, ISe = {
  lastWeek: "eeee 'tuần trước vào lúc' p",
  yesterday: "'hôm qua vào lúc' p",
  today: "'hôm nay vào lúc' p",
  tomorrow: "'ngày mai vào lúc' p",
  nextWeek: "eeee 'tới vào lúc' p",
  other: "P"
}, RSe = (t, e, n, i) => ISe[t], jSe = {
  narrow: ["TCN", "SCN"],
  abbreviated: ["trước CN", "sau CN"],
  wide: ["trước Công Nguyên", "sau Công Nguyên"]
}, FSe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  wide: ["Quý 1", "Quý 2", "Quý 3", "Quý 4"]
}, zSe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["Q1", "Q2", "Q3", "Q4"],
  // I notice many news outlet use this "quý II/2018"
  wide: ["quý I", "quý II", "quý III", "quý IV"]
}, VSe = {
  narrow: ["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"],
  abbreviated: [
    "Thg 1",
    "Thg 2",
    "Thg 3",
    "Thg 4",
    "Thg 5",
    "Thg 6",
    "Thg 7",
    "Thg 8",
    "Thg 9",
    "Thg 10",
    "Thg 11",
    "Thg 12"
  ],
  wide: [
    "Tháng Một",
    "Tháng Hai",
    "Tháng Ba",
    "Tháng Tư",
    "Tháng Năm",
    "Tháng Sáu",
    "Tháng Bảy",
    "Tháng Tám",
    "Tháng Chín",
    "Tháng Mười",
    "Tháng Mười Một",
    "Tháng Mười Hai"
  ]
}, HSe = {
  narrow: [
    "01",
    "02",
    "03",
    "04",
    "05",
    "06",
    "07",
    "08",
    "09",
    "10",
    "11",
    "12"
  ],
  abbreviated: [
    "thg 1",
    "thg 2",
    "thg 3",
    "thg 4",
    "thg 5",
    "thg 6",
    "thg 7",
    "thg 8",
    "thg 9",
    "thg 10",
    "thg 11",
    "thg 12"
  ],
  wide: [
    "tháng 01",
    "tháng 02",
    "tháng 03",
    "tháng 04",
    "tháng 05",
    "tháng 06",
    "tháng 07",
    "tháng 08",
    "tháng 09",
    "tháng 10",
    "tháng 11",
    "tháng 12"
  ]
}, BSe = {
  narrow: ["CN", "T2", "T3", "T4", "T5", "T6", "T7"],
  short: ["CN", "Th 2", "Th 3", "Th 4", "Th 5", "Th 6", "Th 7"],
  abbreviated: ["CN", "Thứ 2", "Thứ 3", "Thứ 4", "Thứ 5", "Thứ 6", "Thứ 7"],
  wide: [
    "Chủ Nhật",
    "Thứ Hai",
    "Thứ Ba",
    "Thứ Tư",
    "Thứ Năm",
    "Thứ Sáu",
    "Thứ Bảy"
  ]
}, qSe = {
  // narrow date period is extremely rare in Vietnamese
  // I used abbreviated form for noon, morning and afternoon
  // which are regconizable by Vietnamese, others cannot be any shorter
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  }
}, GSe = {
  narrow: {
    am: "am",
    pm: "pm",
    midnight: "nửa đêm",
    noon: "tr",
    morning: "sg",
    afternoon: "ch",
    evening: "tối",
    night: "đêm"
  },
  abbreviated: {
    am: "AM",
    pm: "PM",
    midnight: "nửa đêm",
    noon: "trưa",
    morning: "sáng",
    afternoon: "chiều",
    evening: "tối",
    night: "đêm"
  },
  wide: {
    am: "SA",
    pm: "CH",
    midnight: "nửa đêm",
    noon: "giữa trưa",
    morning: "vào buổi sáng",
    afternoon: "vào buổi chiều",
    evening: "vào buổi tối",
    night: "vào ban đêm"
  }
}, XSe = (t, e) => {
  const n = Number(t), i = e == null ? void 0 : e.unit;
  if (i === "quarter")
    switch (n) {
      case 1:
        return "I";
      case 2:
        return "II";
      case 3:
        return "III";
      case 4:
        return "IV";
    }
  else if (i === "day")
    switch (n) {
      case 1:
        return "thứ 2";
      // meaning 2nd day but it's the first day of the week :D
      case 2:
        return "thứ 3";
      // meaning 3rd day
      case 3:
        return "thứ 4";
      // meaning 4th day and so on
      case 4:
        return "thứ 5";
      case 5:
        return "thứ 6";
      case 6:
        return "thứ 7";
      case 7:
        return "chủ nhật";
    }
  else {
    if (i === "week")
      return n === 1 ? "thứ nhất" : "thứ " + n;
    if (i === "dayOfYear")
      return n === 1 ? "đầu tiên" : "thứ " + n;
  }
  return String(n);
}, YSe = {
  ordinalNumber: XSe,
  era: C({
    values: jSe,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: FSe,
    defaultWidth: "wide",
    formattingValues: zSe,
    defaultFormattingWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: VSe,
    defaultWidth: "wide",
    formattingValues: HSe,
    defaultFormattingWidth: "wide"
  }),
  day: C({
    values: BSe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: qSe,
    defaultWidth: "wide",
    formattingValues: GSe,
    defaultFormattingWidth: "wide"
  })
}, KSe = /^(\d+)/i, USe = /\d+/i, JSe = {
  narrow: /^(tcn|scn)/i,
  abbreviated: /^(trước CN|sau CN)/i,
  wide: /^(trước Công Nguyên|sau Công Nguyên)/i
}, QSe = {
  any: [/^t/i, /^s/i]
}, ZSe = {
  narrow: /^([1234]|i{1,3}v?)/i,
  abbreviated: /^q([1234]|i{1,3}v?)/i,
  wide: /^quý ([1234]|i{1,3}v?)/i
}, e7e = {
  any: [/(1|i)$/i, /(2|ii)$/i, /(3|iii)$/i, /(4|iv)$/i]
}, t7e = {
  // month number may contain leading 0, 'thg' prefix may have space, underscore or empty before number
  // note the order of '1' since it is a sub-string of '10', so must be lower priority
  narrow: /^(0?[2-9]|10|11|12|0?1)/i,
  // note the order of 'thg 1' since it is sub-string of 'thg 10', so must be lower priority
  abbreviated: /^thg[ _]?(0?[1-9](?!\d)|10|11|12)/i,
  // note the order of 'Mười' since it is sub-string of Mười Một, so must be lower priority
  wide: /^tháng ?(Một|Hai|Ba|Tư|Năm|Sáu|Bảy|Tám|Chín|Mười|Mười ?Một|Mười ?Hai|0?[1-9](?!\d)|10|11|12)/i
}, n7e = {
  narrow: [
    /0?1$/i,
    /0?2/i,
    /3/,
    /4/,
    /5/,
    /6/,
    /7/,
    /8/,
    /9/,
    /10/,
    /11/,
    /12/
  ],
  abbreviated: [
    /^thg[ _]?0?1(?!\d)/i,
    /^thg[ _]?0?2/i,
    /^thg[ _]?0?3/i,
    /^thg[ _]?0?4/i,
    /^thg[ _]?0?5/i,
    /^thg[ _]?0?6/i,
    /^thg[ _]?0?7/i,
    /^thg[ _]?0?8/i,
    /^thg[ _]?0?9/i,
    /^thg[ _]?10/i,
    /^thg[ _]?11/i,
    /^thg[ _]?12/i
  ],
  wide: [
    /^tháng ?(Một|0?1(?!\d))/i,
    /^tháng ?(Hai|0?2)/i,
    /^tháng ?(Ba|0?3)/i,
    /^tháng ?(Tư|0?4)/i,
    /^tháng ?(Năm|0?5)/i,
    /^tháng ?(Sáu|0?6)/i,
    /^tháng ?(Bảy|0?7)/i,
    /^tháng ?(Tám|0?8)/i,
    /^tháng ?(Chín|0?9)/i,
    /^tháng ?(Mười|10)/i,
    /^tháng ?(Mười ?Một|11)/i,
    /^tháng ?(Mười ?Hai|12)/i
  ]
}, i7e = {
  narrow: /^(CN|T2|T3|T4|T5|T6|T7)/i,
  short: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  abbreviated: /^(CN|Th ?2|Th ?3|Th ?4|Th ?5|Th ?6|Th ?7)/i,
  wide: /^(Chủ ?Nhật|Chúa ?Nhật|thứ ?Hai|thứ ?Ba|thứ ?Tư|thứ ?Năm|thứ ?Sáu|thứ ?Bảy)/i
}, r7e = {
  narrow: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  short: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  abbreviated: [/CN/i, /2/i, /3/i, /4/i, /5/i, /6/i, /7/i],
  wide: [/(Chủ|Chúa) ?Nhật/i, /Hai/i, /Ba/i, /Tư/i, /Năm/i, /Sáu/i, /Bảy/i]
}, a7e = {
  narrow: /^(a|p|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  abbreviated: /^(am|pm|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i,
  wide: /^(ch[^i]*|sa|nửa đêm|trưa|(giờ) (sáng|chiều|tối|đêm))/i
}, o7e = {
  any: {
    am: /^(a|sa)/i,
    pm: /^(p|ch[^i]*)/i,
    midnight: /nửa đêm/i,
    noon: /trưa/i,
    morning: /sáng/i,
    afternoon: /chiều/i,
    evening: /tối/i,
    night: /^đêm/i
  }
}, s7e = {
  ordinalNumber: he({
    matchPattern: KSe,
    parsePattern: USe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: JSe,
    defaultMatchWidth: "wide",
    parsePatterns: QSe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ZSe,
    defaultMatchWidth: "wide",
    parsePatterns: e7e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: t7e,
    defaultMatchWidth: "wide",
    parsePatterns: n7e,
    defaultParseWidth: "wide"
  }),
  day: P({
    matchPatterns: i7e,
    defaultMatchWidth: "wide",
    parsePatterns: r7e,
    defaultParseWidth: "wide"
  }),
  dayPeriod: P({
    matchPatterns: a7e,
    defaultMatchWidth: "wide",
    parsePatterns: o7e,
    defaultParseWidth: "any"
  })
}, l7e = {
  code: "vi",
  formatDistance: TSe,
  formatLong: LSe,
  formatRelative: RSe,
  localize: YSe,
  match: s7e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 1
  }
}, d7e = {
  lessThanXSeconds: {
    one: "不到 1 秒",
    other: "不到 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分钟",
  lessThanXMinutes: {
    one: "不到 1 分钟",
    other: "不到 {{count}} 分钟"
  },
  xMinutes: {
    one: "1 分钟",
    other: "{{count}} 分钟"
  },
  xHours: {
    one: "1 小时",
    other: "{{count}} 小时"
  },
  aboutXHours: {
    one: "大约 1 小时",
    other: "大约 {{count}} 小时"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大约 1 个星期",
    other: "大约 {{count}} 个星期"
  },
  xWeeks: {
    one: "1 个星期",
    other: "{{count}} 个星期"
  },
  aboutXMonths: {
    one: "大约 1 个月",
    other: "大约 {{count}} 个月"
  },
  xMonths: {
    one: "1 个月",
    other: "{{count}} 个月"
  },
  aboutXYears: {
    one: "大约 1 年",
    other: "大约 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超过 1 年",
    other: "超过 {{count}} 年"
  },
  almostXYears: {
    one: "将近 1 年",
    other: "将近 {{count}} 年"
  }
}, c7e = (t, e, n) => {
  let i;
  const r = d7e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "内" : i + "前" : i;
}, u7e = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, f7e = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, m7e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, h7e = {
  date: T({
    formats: u7e,
    defaultWidth: "full"
  }),
  time: T({
    formats: f7e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: m7e,
    defaultWidth: "full"
  })
};
function E2(t, e, n) {
  const i = "eeee p";
  return Lt(t, e, n) ? i : t.getTime() > e.getTime() ? "'下个'" + i : "'上个'" + i;
}
const p7e = {
  lastWeek: E2,
  // days before yesterday, maybe in this week or last week
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: E2,
  // days after tomorrow, maybe in this week or next week
  other: "PP p"
}, g7e = (t, e, n, i) => {
  const r = p7e[t];
  return typeof r == "function" ? r(e, n, i) : r;
}, y7e = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, v7e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, b7e = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, w7e = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, k7e = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, x7e = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜间"
  }
}, _7e = (t, e) => {
  const n = Number(t);
  switch (e == null ? void 0 : e.unit) {
    case "date":
      return n.toString() + "日";
    case "hour":
      return n.toString() + "时";
    case "minute":
      return n.toString() + "分";
    case "second":
      return n.toString() + "秒";
    default:
      return "第 " + n.toString();
  }
}, M7e = {
  ordinalNumber: _7e,
  era: C({
    values: y7e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: v7e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: b7e,
    defaultWidth: "wide"
  }),
  day: C({
    values: w7e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: k7e,
    defaultWidth: "wide",
    formattingValues: x7e,
    defaultFormattingWidth: "wide"
  })
}, C7e = /^(第\s*)?\d+(日|时|分|秒)?/i, P7e = /\d+/i, S7e = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, N7e = {
  any: [/^(前)/i, /^(公元)/i]
}, $7e = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻钟/i
}, D7e = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, E7e = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, T7e = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, O7e = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^周[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, W7e = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, A7e = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨|)/i
}, L7e = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, I7e = {
  ordinalNumber: he({
    matchPattern: C7e,
    parsePattern: P7e,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: S7e,
    defaultMatchWidth: "wide",
    parsePatterns: N7e,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: $7e,
    defaultMatchWidth: "wide",
    parsePatterns: D7e,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: E7e,
    defaultMatchWidth: "wide",
    parsePatterns: T7e,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: O7e,
    defaultMatchWidth: "wide",
    parsePatterns: W7e,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: A7e,
    defaultMatchWidth: "any",
    parsePatterns: L7e,
    defaultParseWidth: "any"
  })
}, R7e = {
  code: "zh-CN",
  formatDistance: c7e,
  formatLong: h7e,
  formatRelative: g7e,
  localize: M7e,
  match: I7e,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, j7e = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, F7e = (t, e, n) => {
  let i;
  const r = j7e[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "內" : i + "前" : i;
}, z7e = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, V7e = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, H7e = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, B7e = {
  date: T({
    formats: z7e,
    defaultWidth: "full"
  }),
  time: T({
    formats: V7e,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: H7e,
    defaultWidth: "full"
  })
}, q7e = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, G7e = (t, e, n, i) => q7e[t], X7e = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, Y7e = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一季", "第二季", "第三季", "第四季"],
  wide: ["第一季度", "第二季度", "第三季度", "第四季度"]
}, K7e = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, U7e = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, J7e = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, Q7e = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "午夜",
    noon: "晌",
    morning: "早",
    afternoon: "午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "午夜",
    noon: "中午",
    morning: "上午",
    afternoon: "下午",
    evening: "晚上",
    night: "夜晚"
  }
}, Z7e = (t, e) => {
  const n = Number(t);
  switch (e == null ? void 0 : e.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, eNe = {
  ordinalNumber: Z7e,
  era: C({
    values: X7e,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: Y7e,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: K7e,
    defaultWidth: "wide"
  }),
  day: C({
    values: U7e,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: J7e,
    defaultWidth: "wide",
    formattingValues: Q7e,
    defaultFormattingWidth: "wide"
  })
}, tNe = /^(第\s*)?\d+(日|時|分|秒)?/i, nNe = /\d+/i, iNe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, rNe = {
  any: [/^(前)/i, /^(公元)/i]
}, aNe = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]季/i,
  wide: /^第[一二三四]季度/i
}, oNe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, sNe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, lNe = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, dNe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, cNe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, uNe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, fNe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, mNe = {
  ordinalNumber: he({
    matchPattern: tNe,
    parsePattern: nNe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: iNe,
    defaultMatchWidth: "wide",
    parsePatterns: rNe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: aNe,
    defaultMatchWidth: "wide",
    parsePatterns: oNe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: sNe,
    defaultMatchWidth: "wide",
    parsePatterns: lNe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: dNe,
    defaultMatchWidth: "wide",
    parsePatterns: cNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: uNe,
    defaultMatchWidth: "any",
    parsePatterns: fNe,
    defaultParseWidth: "any"
  })
}, hNe = {
  code: "zh-HK",
  formatDistance: F7e,
  formatLong: B7e,
  formatRelative: G7e,
  localize: eNe,
  match: mNe,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
}, pNe = {
  lessThanXSeconds: {
    one: "少於 1 秒",
    other: "少於 {{count}} 秒"
  },
  xSeconds: {
    one: "1 秒",
    other: "{{count}} 秒"
  },
  halfAMinute: "半分鐘",
  lessThanXMinutes: {
    one: "少於 1 分鐘",
    other: "少於 {{count}} 分鐘"
  },
  xMinutes: {
    one: "1 分鐘",
    other: "{{count}} 分鐘"
  },
  xHours: {
    one: "1 小時",
    other: "{{count}} 小時"
  },
  aboutXHours: {
    one: "大約 1 小時",
    other: "大約 {{count}} 小時"
  },
  xDays: {
    one: "1 天",
    other: "{{count}} 天"
  },
  aboutXWeeks: {
    one: "大約 1 個星期",
    other: "大約 {{count}} 個星期"
  },
  xWeeks: {
    one: "1 個星期",
    other: "{{count}} 個星期"
  },
  aboutXMonths: {
    one: "大約 1 個月",
    other: "大約 {{count}} 個月"
  },
  xMonths: {
    one: "1 個月",
    other: "{{count}} 個月"
  },
  aboutXYears: {
    one: "大約 1 年",
    other: "大約 {{count}} 年"
  },
  xYears: {
    one: "1 年",
    other: "{{count}} 年"
  },
  overXYears: {
    one: "超過 1 年",
    other: "超過 {{count}} 年"
  },
  almostXYears: {
    one: "將近 1 年",
    other: "將近 {{count}} 年"
  }
}, gNe = (t, e, n) => {
  let i;
  const r = pNe[t];
  return typeof r == "string" ? i = r : e === 1 ? i = r.one : i = r.other.replace("{{count}}", String(e)), n != null && n.addSuffix ? n.comparison && n.comparison > 0 ? i + "內" : i + "前" : i;
}, yNe = {
  full: "y'年'M'月'd'日' EEEE",
  long: "y'年'M'月'd'日'",
  medium: "yyyy-MM-dd",
  short: "yy-MM-dd"
}, vNe = {
  full: "zzzz a h:mm:ss",
  long: "z a h:mm:ss",
  medium: "a h:mm:ss",
  short: "a h:mm"
}, bNe = {
  full: "{{date}} {{time}}",
  long: "{{date}} {{time}}",
  medium: "{{date}} {{time}}",
  short: "{{date}} {{time}}"
}, wNe = {
  date: T({
    formats: yNe,
    defaultWidth: "full"
  }),
  time: T({
    formats: vNe,
    defaultWidth: "full"
  }),
  dateTime: T({
    formats: bNe,
    defaultWidth: "full"
  })
}, kNe = {
  lastWeek: "'上個'eeee p",
  yesterday: "'昨天' p",
  today: "'今天' p",
  tomorrow: "'明天' p",
  nextWeek: "'下個'eeee p",
  other: "P"
}, xNe = (t, e, n, i) => kNe[t], _Ne = {
  narrow: ["前", "公元"],
  abbreviated: ["前", "公元"],
  wide: ["公元前", "公元"]
}, MNe = {
  narrow: ["1", "2", "3", "4"],
  abbreviated: ["第一刻", "第二刻", "第三刻", "第四刻"],
  wide: ["第一刻鐘", "第二刻鐘", "第三刻鐘", "第四刻鐘"]
}, CNe = {
  narrow: [
    "一",
    "二",
    "三",
    "四",
    "五",
    "六",
    "七",
    "八",
    "九",
    "十",
    "十一",
    "十二"
  ],
  abbreviated: [
    "1月",
    "2月",
    "3月",
    "4月",
    "5月",
    "6月",
    "7月",
    "8月",
    "9月",
    "10月",
    "11月",
    "12月"
  ],
  wide: [
    "一月",
    "二月",
    "三月",
    "四月",
    "五月",
    "六月",
    "七月",
    "八月",
    "九月",
    "十月",
    "十一月",
    "十二月"
  ]
}, PNe = {
  narrow: ["日", "一", "二", "三", "四", "五", "六"],
  short: ["日", "一", "二", "三", "四", "五", "六"],
  abbreviated: ["週日", "週一", "週二", "週三", "週四", "週五", "週六"],
  wide: ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"]
}, SNe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, NNe = {
  narrow: {
    am: "上",
    pm: "下",
    midnight: "凌晨",
    noon: "午",
    morning: "早",
    afternoon: "下午",
    evening: "晚",
    night: "夜"
  },
  abbreviated: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  },
  wide: {
    am: "上午",
    pm: "下午",
    midnight: "凌晨",
    noon: "中午",
    morning: "早晨",
    afternoon: "中午",
    evening: "晚上",
    night: "夜間"
  }
}, $Ne = (t, e) => {
  const n = Number(t);
  switch (e == null ? void 0 : e.unit) {
    case "date":
      return n + "日";
    case "hour":
      return n + "時";
    case "minute":
      return n + "分";
    case "second":
      return n + "秒";
    default:
      return "第 " + n;
  }
}, DNe = {
  ordinalNumber: $Ne,
  era: C({
    values: _Ne,
    defaultWidth: "wide"
  }),
  quarter: C({
    values: MNe,
    defaultWidth: "wide",
    argumentCallback: (t) => t - 1
  }),
  month: C({
    values: CNe,
    defaultWidth: "wide"
  }),
  day: C({
    values: PNe,
    defaultWidth: "wide"
  }),
  dayPeriod: C({
    values: SNe,
    defaultWidth: "wide",
    formattingValues: NNe,
    defaultFormattingWidth: "wide"
  })
}, ENe = /^(第\s*)?\d+(日|時|分|秒)?/i, TNe = /\d+/i, ONe = {
  narrow: /^(前)/i,
  abbreviated: /^(前)/i,
  wide: /^(公元前|公元)/i
}, WNe = {
  any: [/^(前)/i, /^(公元)/i]
}, ANe = {
  narrow: /^[1234]/i,
  abbreviated: /^第[一二三四]刻/i,
  wide: /^第[一二三四]刻鐘/i
}, LNe = {
  any: [/(1|一)/i, /(2|二)/i, /(3|三)/i, /(4|四)/i]
}, INe = {
  narrow: /^(一|二|三|四|五|六|七|八|九|十[二一])/i,
  abbreviated: /^(一|二|三|四|五|六|七|八|九|十[二一]|\d|1[12])月/i,
  wide: /^(一|二|三|四|五|六|七|八|九|十[二一])月/i
}, RNe = {
  narrow: [
    /^一/i,
    /^二/i,
    /^三/i,
    /^四/i,
    /^五/i,
    /^六/i,
    /^七/i,
    /^八/i,
    /^九/i,
    /^十(?!(一|二))/i,
    /^十一/i,
    /^十二/i
  ],
  any: [
    /^一|1/i,
    /^二|2/i,
    /^三|3/i,
    /^四|4/i,
    /^五|5/i,
    /^六|6/i,
    /^七|7/i,
    /^八|8/i,
    /^九|9/i,
    /^十(?!(一|二))|10/i,
    /^十一|11/i,
    /^十二|12/i
  ]
}, jNe = {
  narrow: /^[一二三四五六日]/i,
  short: /^[一二三四五六日]/i,
  abbreviated: /^週[一二三四五六日]/i,
  wide: /^星期[一二三四五六日]/i
}, FNe = {
  any: [/日/i, /一/i, /二/i, /三/i, /四/i, /五/i, /六/i]
}, zNe = {
  any: /^(上午?|下午?|午夜|[中正]午|早上?|下午|晚上?|凌晨)/i
}, VNe = {
  any: {
    am: /^上午?/i,
    pm: /^下午?/i,
    midnight: /^午夜/i,
    noon: /^[中正]午/i,
    morning: /^早上/i,
    afternoon: /^下午/i,
    evening: /^晚上?/i,
    night: /^凌晨/i
  }
}, HNe = {
  ordinalNumber: he({
    matchPattern: ENe,
    parsePattern: TNe,
    valueCallback: (t) => parseInt(t, 10)
  }),
  era: P({
    matchPatterns: ONe,
    defaultMatchWidth: "wide",
    parsePatterns: WNe,
    defaultParseWidth: "any"
  }),
  quarter: P({
    matchPatterns: ANe,
    defaultMatchWidth: "wide",
    parsePatterns: LNe,
    defaultParseWidth: "any",
    valueCallback: (t) => t + 1
  }),
  month: P({
    matchPatterns: INe,
    defaultMatchWidth: "wide",
    parsePatterns: RNe,
    defaultParseWidth: "any"
  }),
  day: P({
    matchPatterns: jNe,
    defaultMatchWidth: "wide",
    parsePatterns: FNe,
    defaultParseWidth: "any"
  }),
  dayPeriod: P({
    matchPatterns: zNe,
    defaultMatchWidth: "any",
    parsePatterns: VNe,
    defaultParseWidth: "any"
  })
}, BNe = {
  code: "zh-TW",
  formatDistance: gNe,
  formatLong: wNe,
  formatRelative: xNe,
  localize: DNe,
  match: HNe,
  options: {
    weekStartsOn: 1,
    firstWeekContainsDate: 4
  }
}, qNe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  af: lq,
  ar: Rq,
  arDZ: hG,
  arEG: BG,
  arMA: wX,
  arSA: UX,
  arTN: PY,
  az: iK,
  be: jK,
  beTarask: kU,
  bg: nJ,
  bn: WJ,
  bs: uQ,
  ca: VQ,
  ckb: vZ,
  cs: UZ,
  cy: Pee,
  da: nte,
  de: Ste,
  deAT: Lte,
  el: fne,
  enAU: yne,
  enCA: Mne,
  enGB: Nne,
  enIE: $ne,
  enIN: Wne,
  enNZ: jne,
  enUS: mc,
  enZA: Bne,
  eo: bie,
  es: Uie,
  et: _re,
  eu: eae,
  faIR: Dae,
  fi: ooe,
  fr: Toe,
  frCA: Ioe,
  frCH: Boe,
  fy: bse,
  gd: Kse,
  gl: Ple,
  gu: nde,
  he: Ode,
  hi: cce,
  hr: zce,
  ht: gue,
  hu: Kue,
  hy: Cfe,
  id: tme,
  is: Eme,
  it: ahe,
  itCH: che,
  ja: Fhe,
  jaHira: g1e,
  ka: G1e,
  kk: Cpe,
  km: tge,
  kn: Ege,
  ko: sye,
  lb: zye,
  lt: wve,
  lv: Zve,
  mk: D0e,
  mn: sbe,
  ms: Ibe,
  mt: mwe,
  nb: Vwe,
  nl: yke,
  nlBE: Gke,
  nn: x2e,
  oc: Q2e,
  pl: Axe,
  pt: u3e,
  ptBR: z3e,
  ro: y4e,
  ru: U4e,
  se: C5e,
  sk: s6e,
  sl: j6e,
  sq: p_e,
  sr: G_e,
  srLatn: _9e,
  sv: eMe,
  ta: EMe,
  te: oCe,
  th: LCe,
  tr: fPe,
  ug: VPe,
  uk: M8e,
  uz: eSe,
  uzCyrl: DSe,
  vi: l7e,
  zhCN: R7e,
  zhHK: hNe,
  zhTW: BNe
}, Symbol.toStringTag, { value: "Module" })), md = "→", pg = (t) => {
  const e = t.split("-")[0];
  return qNe[e];
}, y0 = (t) => {
  if (t instanceof Date)
    return { from: t };
  if (t != null)
    return t;
}, T2 = (t) => t == null ? !1 : t instanceof Date && !isNaN(t.getTime()), el = (t) => {
  if (t !== void 0) {
    if (typeof t == "string") {
      const [e, n] = t.split(/(?:\s+-\s+|\s+→\s+)/);
      return {
        from: e,
        to: n
      };
    }
    return t;
  }
}, O2 = (t, e) => ii(t, e), tl = (t, e) => {
  const n = y0(t);
  if (!n)
    return {
      from: "",
      to: void 0
    };
  const i = O2(n.from, e), r = n.to ? O2(n.to, e) : void 0;
  return {
    from: i,
    to: r && i !== r ? r : void 0
  };
}, bc = (t, e) => {
  const n = tl(t, e);
  if (!n)
    return "-";
  const { from: i, to: r } = n;
  return `${i}${r && i !== r ? ` ${md} ${r}` : ""}`;
};
function nl(t, e, n) {
  const i = y0(t);
  if (!i)
    return null;
  const { from: r, to: a } = i;
  return {
    from: e(r),
    to: n(a || r)
  };
}
const Hr = (t, e) => !e || An(t, e) || of(t, e), Br = (t, e) => !e || Mi(t, e) || of(t, e), PP = ({
  minDate: t,
  maxDate: e
}) => {
  const n = [];
  return t && n.push({ before: t }), e && n.push({ after: e }), n;
};
var je = function() {
  return je = Object.assign || function(e) {
    for (var n, i = 1, r = arguments.length; i < r; i++) {
      n = arguments[i];
      for (var a in n) Object.prototype.hasOwnProperty.call(n, a) && (e[a] = n[a]);
    }
    return e;
  }, je.apply(this, arguments);
};
function GNe(t, e) {
  var n = {};
  for (var i in t) Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var r = 0, i = Object.getOwnPropertySymbols(t); r < i.length; r++)
      e.indexOf(i[r]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[r]) && (n[i[r]] = t[i[r]]);
  return n;
}
function SP(t, e, n) {
  for (var i = 0, r = e.length, a; i < r; i++)
    (a || !(i in e)) && (a || (a = Array.prototype.slice.call(e, 0, i)), a[i] = e[i]);
  return t.concat(a || Array.prototype.slice.call(e));
}
function wc(t) {
  return t.mode === "multiple";
}
function kc(t) {
  return t.mode === "range";
}
function rh(t) {
  return t.mode === "single";
}
var XNe = {
  root: "rdp",
  multiple_months: "rdp-multiple_months",
  with_weeknumber: "rdp-with_weeknumber",
  vhidden: "rdp-vhidden",
  button_reset: "rdp-button_reset",
  button: "rdp-button",
  caption: "rdp-caption",
  caption_start: "rdp-caption_start",
  caption_end: "rdp-caption_end",
  caption_between: "rdp-caption_between",
  caption_label: "rdp-caption_label",
  caption_dropdowns: "rdp-caption_dropdowns",
  dropdown: "rdp-dropdown",
  dropdown_month: "rdp-dropdown_month",
  dropdown_year: "rdp-dropdown_year",
  dropdown_icon: "rdp-dropdown_icon",
  months: "rdp-months",
  month: "rdp-month",
  table: "rdp-table",
  tbody: "rdp-tbody",
  tfoot: "rdp-tfoot",
  head: "rdp-head",
  head_row: "rdp-head_row",
  head_cell: "rdp-head_cell",
  nav: "rdp-nav",
  nav_button: "rdp-nav_button",
  nav_button_previous: "rdp-nav_button_previous",
  nav_button_next: "rdp-nav_button_next",
  nav_icon: "rdp-nav_icon",
  row: "rdp-row",
  weeknumber: "rdp-weeknumber",
  cell: "rdp-cell",
  day: "rdp-day",
  day_today: "rdp-day_today",
  day_outside: "rdp-day_outside",
  day_selected: "rdp-day_selected",
  day_disabled: "rdp-day_disabled",
  day_hidden: "rdp-day_hidden",
  day_range_start: "rdp-day_range_start",
  day_range_end: "rdp-day_range_end",
  day_range_middle: "rdp-day_range_middle"
};
function YNe(t, e) {
  return ii(t, "LLLL y", e);
}
function KNe(t, e) {
  return ii(t, "d", e);
}
function UNe(t, e) {
  return ii(t, "LLLL", e);
}
function JNe(t) {
  return "".concat(t);
}
function QNe(t, e) {
  return ii(t, "cccccc", e);
}
function ZNe(t, e) {
  return ii(t, "yyyy", e);
}
var e$e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  formatCaption: YNe,
  formatDay: KNe,
  formatMonthCaption: UNe,
  formatWeekNumber: JNe,
  formatWeekdayName: QNe,
  formatYearCaption: ZNe
}), t$e = function(t, e, n) {
  return ii(t, "do MMMM (EEEE)", n);
}, n$e = function() {
  return "Month: ";
}, i$e = function() {
  return "Go to next month";
}, r$e = function() {
  return "Go to previous month";
}, a$e = function(t, e) {
  return ii(t, "cccc", e);
}, o$e = function(t) {
  return "Week n. ".concat(t);
}, s$e = function() {
  return "Year: ";
}, l$e = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  labelDay: t$e,
  labelMonthDropdown: n$e,
  labelNext: i$e,
  labelPrevious: r$e,
  labelWeekNumber: o$e,
  labelWeekday: a$e,
  labelYearDropdown: s$e
});
function d$e() {
  var t = "buttons", e = XNe, n = mc, i = {}, r = {}, a = 1, o = {}, s = /* @__PURE__ */ new Date();
  return {
    captionLayout: t,
    classNames: e,
    formatters: e$e,
    labels: l$e,
    locale: n,
    modifiersClassNames: i,
    modifiers: r,
    numberOfMonths: a,
    styles: o,
    today: s,
    mode: "default"
  };
}
function c$e(t) {
  var e = t.fromYear, n = t.toYear, i = t.fromMonth, r = t.toMonth, a = t.fromDate, o = t.toDate;
  return i ? a = ut(i) : e && (a = new Date(e, 0, 1)), r ? o = Kn(r) : n && (o = new Date(n, 11, 31)), {
    fromDate: a ? Gi(a) : void 0,
    toDate: o ? Gi(o) : void 0
  };
}
var NP = hn(void 0);
function u$e(t) {
  var e, n = t.initialProps, i = d$e(), r = c$e(n), a = r.fromDate, o = r.toDate, s = (e = n.captionLayout) !== null && e !== void 0 ? e : i.captionLayout;
  s !== "buttons" && (!a || !o) && (s = "buttons");
  var l;
  (rh(n) || wc(n) || kc(n)) && (l = n.onSelect);
  var c = je(je(je({}, i), n), { captionLayout: s, classNames: je(je({}, i.classNames), n.classNames), components: je({}, n.components), formatters: je(je({}, i.formatters), n.formatters), fromDate: a, labels: je(je({}, i.labels), n.labels), mode: n.mode || i.mode, modifiers: je(je({}, i.modifiers), n.modifiers), modifiersClassNames: je(je({}, i.modifiersClassNames), n.modifiersClassNames), onSelect: l, styles: je(je({}, i.styles), n.styles), toDate: o });
  return d(NP.Provider, { value: c, children: t.children });
}
function bt() {
  var t = Wt(NP);
  if (!t)
    throw new Error("useDayPicker must be used within a DayPickerProvider.");
  return t;
}
function $P(t) {
  var e = bt(), n = e.locale, i = e.classNames, r = e.styles, a = e.formatters.formatCaption;
  return d("div", { className: i.caption_label, style: r.caption_label, "aria-live": "polite", role: "presentation", id: t.id, children: a(t.displayMonth, { locale: n }) });
}
function f$e(t) {
  return d("svg", je({ width: "8px", height: "8px", viewBox: "0 0 120 120", "data-testid": "iconDropdown" }, t, { children: d("path", { d: "M4.22182541,48.2218254 C8.44222828,44.0014225 15.2388494,43.9273804 19.5496459,47.9996989 L19.7781746,48.2218254 L60,88.443 L100.221825,48.2218254 C104.442228,44.0014225 111.238849,43.9273804 115.549646,47.9996989 L115.778175,48.2218254 C119.998577,52.4422283 120.07262,59.2388494 116.000301,63.5496459 L115.778175,63.7781746 L67.7781746,111.778175 C63.5577717,115.998577 56.7611506,116.07262 52.4503541,112.000301 L52.2218254,111.778175 L4.22182541,63.7781746 C-0.0739418023,59.4824074 -0.0739418023,52.5175926 4.22182541,48.2218254 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function DP(t) {
  var e, n, i = t.onChange, r = t.value, a = t.children, o = t.caption, s = t.className, l = t.style, c = bt(), u = (n = (e = c.components) === null || e === void 0 ? void 0 : e.IconDropdown) !== null && n !== void 0 ? n : f$e;
  return k("div", { className: s, style: l, children: [d("span", { className: c.classNames.vhidden, children: t["aria-label"] }), d("select", { name: t.name, "aria-label": t["aria-label"], className: c.classNames.dropdown, style: c.styles.dropdown, value: r, onChange: i, children: a }), k("div", { className: c.classNames.caption_label, style: c.styles.caption_label, "aria-hidden": "true", children: [o, d(u, { className: c.classNames.dropdown_icon, style: c.styles.dropdown_icon })] })] });
}
function m$e(t) {
  var e, n = bt(), i = n.fromDate, r = n.toDate, a = n.styles, o = n.locale, s = n.formatters.formatMonthCaption, l = n.classNames, c = n.components, u = n.labels.labelMonthDropdown;
  if (!i)
    return d(Ee, {});
  if (!r)
    return d(Ee, {});
  var f = [];
  if (J9(i, r))
    for (var m = ut(i), h = i.getMonth(); h <= r.getMonth(); h++)
      f.push(Fl(m, h));
  else
    for (var m = ut(/* @__PURE__ */ new Date()), h = 0; h <= 11; h++)
      f.push(Fl(m, h));
  var p = function(y) {
    var v = Number(y.target.value), w = Fl(ut(t.displayMonth), v);
    t.onChange(w);
  }, g = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : DP;
  return d(g, { name: "months", "aria-label": u(), className: l.dropdown_month, style: a.dropdown_month, onChange: p, value: t.displayMonth.getMonth(), caption: s(t.displayMonth, { locale: o }), children: f.map(function(y) {
    return d("option", { value: y.getMonth(), children: s(y, { locale: o }) }, y.getMonth());
  }) });
}
function h$e(t) {
  var e, n = t.displayMonth, i = bt(), r = i.fromDate, a = i.toDate, o = i.locale, s = i.styles, l = i.classNames, c = i.components, u = i.formatters.formatYearCaption, f = i.labels.labelYearDropdown, m = [];
  if (!r)
    return d(Ee, {});
  if (!a)
    return d(Ee, {});
  for (var h = r.getFullYear(), p = a.getFullYear(), g = h; g <= p; g++)
    m.push(ak(ki(/* @__PURE__ */ new Date()), g));
  var y = function(w) {
    var x = ak(ut(n), Number(w.target.value));
    t.onChange(x);
  }, v = (e = c == null ? void 0 : c.Dropdown) !== null && e !== void 0 ? e : DP;
  return d(v, { name: "years", "aria-label": f(), className: l.dropdown_year, style: s.dropdown_year, onChange: y, value: n.getFullYear(), caption: u(n, { locale: o }), children: m.map(function(w) {
    return d("option", { value: w.getFullYear(), children: u(w, { locale: o }) }, w.getFullYear());
  }) });
}
function p$e(t, e) {
  var n = q(t), i = n[0], r = n[1], a = e === void 0 ? i : e;
  return [a, r];
}
function g$e(t) {
  var e = t.month, n = t.defaultMonth, i = t.today, r = e || n || i || /* @__PURE__ */ new Date(), a = t.toDate, o = t.fromDate, s = t.numberOfMonths, l = s === void 0 ? 1 : s;
  if (a && ud(a, r) < 0) {
    var c = -1 * (l - 1);
    r = Et(a, c);
  }
  return o && ud(r, o) < 0 && (r = o), ut(r);
}
function y$e() {
  var t = bt(), e = g$e(t), n = p$e(e, t.month), i = n[0], r = n[1], a = function(o) {
    var s;
    if (!t.disableNavigation) {
      var l = ut(o);
      r(l), (s = t.onMonthChange) === null || s === void 0 || s.call(t, l);
    }
  };
  return [i, a];
}
function v$e(t, e) {
  for (var n = e.reverseMonths, i = e.numberOfMonths, r = ut(t), a = ut(Et(r, i)), o = ud(a, r), s = [], l = 0; l < o; l++) {
    var c = Et(r, l);
    s.push(c);
  }
  return n && (s = s.reverse()), s;
}
function b$e(t, e) {
  if (!e.disableNavigation) {
    var n = e.toDate, i = e.pagedNavigation, r = e.numberOfMonths, a = r === void 0 ? 1 : r, o = i ? a : 1, s = ut(t);
    if (!n)
      return Et(s, o);
    var l = ud(n, t);
    if (!(l < a))
      return Et(s, o);
  }
}
function w$e(t, e) {
  if (!e.disableNavigation) {
    var n = e.fromDate, i = e.pagedNavigation, r = e.numberOfMonths, a = r === void 0 ? 1 : r, o = i ? a : 1, s = ut(t);
    if (!n)
      return Et(s, -o);
    var l = ud(s, n);
    if (!(l <= 0))
      return Et(s, -o);
  }
}
var EP = hn(void 0);
function k$e(t) {
  var e = bt(), n = y$e(), i = n[0], r = n[1], a = v$e(i, e), o = b$e(i, e), s = w$e(i, e), l = function(f) {
    return a.some(function(m) {
      return Um(f, m);
    });
  }, c = function(f, m) {
    l(f) || (m && An(f, m) ? r(Et(f, 1 + e.numberOfMonths * -1)) : r(f));
  }, u = {
    currentMonth: i,
    displayMonths: a,
    goToMonth: r,
    goToDate: c,
    previousMonth: s,
    nextMonth: o,
    isDateDisplayed: l
  };
  return d(EP.Provider, { value: u, children: t.children });
}
function xc() {
  var t = Wt(EP);
  if (!t)
    throw new Error("useNavigation must be used within a NavigationProvider");
  return t;
}
function W2(t) {
  var e, n = bt(), i = n.classNames, r = n.styles, a = n.components, o = xc().goToMonth, s = function(u) {
    o(Et(u, t.displayIndex ? -t.displayIndex : 0));
  }, l = (e = a == null ? void 0 : a.CaptionLabel) !== null && e !== void 0 ? e : $P, c = d(l, { id: t.id, displayMonth: t.displayMonth });
  return k("div", { className: i.caption_dropdowns, style: r.caption_dropdowns, children: [d("div", { className: i.vhidden, children: c }), d(m$e, { onChange: s, displayMonth: t.displayMonth }), d(h$e, { onChange: s, displayMonth: t.displayMonth })] });
}
function x$e(t) {
  return d("svg", je({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t, { children: d("path", { d: "M69.490332,3.34314575 C72.6145263,0.218951416 77.6798462,0.218951416 80.8040405,3.34314575 C83.8617626,6.40086786 83.9268205,11.3179931 80.9992143,14.4548388 L80.8040405,14.6568542 L35.461,60 L80.8040405,105.343146 C83.8617626,108.400868 83.9268205,113.317993 80.9992143,116.454839 L80.8040405,116.656854 C77.7463184,119.714576 72.8291931,119.779634 69.6923475,116.852028 L69.490332,116.656854 L18.490332,65.6568542 C15.4326099,62.5991321 15.367552,57.6820069 18.2951583,54.5451612 L18.490332,54.3431458 L69.490332,3.34314575 Z", fill: "currentColor", fillRule: "nonzero" }) }));
}
function _$e(t) {
  return d("svg", je({ width: "16px", height: "16px", viewBox: "0 0 120 120" }, t, { children: d("path", { d: "M49.8040405,3.34314575 C46.6798462,0.218951416 41.6145263,0.218951416 38.490332,3.34314575 C35.4326099,6.40086786 35.367552,11.3179931 38.2951583,14.4548388 L38.490332,14.6568542 L83.8333725,60 L38.490332,105.343146 C35.4326099,108.400868 35.367552,113.317993 38.2951583,116.454839 L38.490332,116.656854 C41.5480541,119.714576 46.4651794,119.779634 49.602025,116.852028 L49.8040405,116.656854 L100.804041,65.6568542 C103.861763,62.5991321 103.926821,57.6820069 100.999214,54.5451612 L100.804041,54.3431458 L49.8040405,3.34314575 Z", fill: "currentColor" }) }));
}
var xf = X(function(t, e) {
  var n = bt(), i = n.classNames, r = n.styles, a = [i.button_reset, i.button];
  t.className && a.push(t.className);
  var o = a.join(" "), s = je(je({}, r.button_reset), r.button);
  return t.style && Object.assign(s, t.style), d("button", je({}, t, { ref: e, type: "button", className: o, style: s }));
});
function M$e(t) {
  var e, n, i = bt(), r = i.dir, a = i.locale, o = i.classNames, s = i.styles, l = i.labels, c = l.labelPrevious, u = l.labelNext, f = i.components;
  if (!t.nextMonth && !t.previousMonth)
    return d(Ee, {});
  var m = c(t.previousMonth, { locale: a }), h = [
    o.nav_button,
    o.nav_button_previous
  ].join(" "), p = u(t.nextMonth, { locale: a }), g = [
    o.nav_button,
    o.nav_button_next
  ].join(" "), y = (e = f == null ? void 0 : f.IconRight) !== null && e !== void 0 ? e : _$e, v = (n = f == null ? void 0 : f.IconLeft) !== null && n !== void 0 ? n : x$e;
  return k("div", { className: o.nav, style: s.nav, children: [!t.hidePrevious && d(xf, { name: "previous-month", "aria-label": m, className: h, style: s.nav_button_previous, disabled: !t.previousMonth, onClick: t.onPreviousClick, children: r === "rtl" ? d(y, { className: o.nav_icon, style: s.nav_icon }) : d(v, { className: o.nav_icon, style: s.nav_icon }) }), !t.hideNext && d(xf, { name: "next-month", "aria-label": p, className: g, style: s.nav_button_next, disabled: !t.nextMonth, onClick: t.onNextClick, children: r === "rtl" ? d(v, { className: o.nav_icon, style: s.nav_icon }) : d(y, { className: o.nav_icon, style: s.nav_icon }) })] });
}
function A2(t) {
  var e = bt().numberOfMonths, n = xc(), i = n.previousMonth, r = n.nextMonth, a = n.goToMonth, o = n.displayMonths, s = o.findIndex(function(p) {
    return Um(t.displayMonth, p);
  }), l = s === 0, c = s === o.length - 1, u = e > 1 && (l || !c), f = e > 1 && (c || !l), m = function() {
    i && a(i);
  }, h = function() {
    r && a(r);
  };
  return d(M$e, { displayMonth: t.displayMonth, hideNext: u, hidePrevious: f, nextMonth: r, previousMonth: i, onPreviousClick: m, onNextClick: h });
}
function C$e(t) {
  var e, n = bt(), i = n.classNames, r = n.disableNavigation, a = n.styles, o = n.captionLayout, s = n.components, l = (e = s == null ? void 0 : s.CaptionLabel) !== null && e !== void 0 ? e : $P, c;
  return r ? c = d(l, { id: t.id, displayMonth: t.displayMonth }) : o === "dropdown" ? c = d(W2, { displayMonth: t.displayMonth, id: t.id }) : o === "dropdown-buttons" ? c = k(Ee, { children: [d(W2, { displayMonth: t.displayMonth, displayIndex: t.displayIndex, id: t.id }), d(A2, { displayMonth: t.displayMonth, displayIndex: t.displayIndex, id: t.id })] }) : c = k(Ee, { children: [d(l, { id: t.id, displayMonth: t.displayMonth, displayIndex: t.displayIndex }), d(A2, { displayMonth: t.displayMonth, id: t.id })] }), d("div", { className: i.caption, style: a.caption, children: c });
}
function P$e(t) {
  var e = bt(), n = e.footer, i = e.styles, r = e.classNames.tfoot;
  return n ? d("tfoot", { className: r, style: i.tfoot, children: d("tr", { children: d("td", { colSpan: 8, children: n }) }) }) : d(Ee, {});
}
function S$e(t, e, n) {
  for (var i = n ? $i(/* @__PURE__ */ new Date()) : mn(/* @__PURE__ */ new Date(), { locale: t, weekStartsOn: e }), r = [], a = 0; a < 7; a++) {
    var o = Ct(i, a);
    r.push(o);
  }
  return r;
}
function N$e() {
  var t = bt(), e = t.classNames, n = t.styles, i = t.showWeekNumber, r = t.locale, a = t.weekStartsOn, o = t.ISOWeek, s = t.formatters.formatWeekdayName, l = t.labels.labelWeekday, c = S$e(r, a, o);
  return k("tr", { style: n.head_row, className: e.head_row, children: [i && d("td", { style: n.head_cell, className: e.head_cell }), c.map(function(u, f) {
    return d("th", { scope: "col", className: e.head_cell, style: n.head_cell, "aria-label": l(u, { locale: r }), children: s(u, { locale: r }) }, f);
  })] });
}
function $$e() {
  var t, e = bt(), n = e.classNames, i = e.styles, r = e.components, a = (t = r == null ? void 0 : r.HeadRow) !== null && t !== void 0 ? t : N$e;
  return d("thead", { style: i.head, className: n.head, children: d(a, {}) });
}
function D$e(t) {
  var e = bt(), n = e.locale, i = e.formatters.formatDay;
  return d(Ee, { children: i(t.date, { locale: n }) });
}
var v0 = hn(void 0);
function E$e(t) {
  if (!wc(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        disabled: []
      }
    };
    return d(v0.Provider, { value: e, children: t.children });
  }
  return d(T$e, { initialProps: t.initialProps, children: t.children });
}
function T$e(t) {
  var e = t.initialProps, n = t.children, i = e.selected, r = e.min, a = e.max, o = function(c, u, f) {
    var m, h;
    (m = e.onDayClick) === null || m === void 0 || m.call(e, c, u, f);
    var p = !!(u.selected && r && (i == null ? void 0 : i.length) === r);
    if (!p) {
      var g = !!(!u.selected && a && (i == null ? void 0 : i.length) === a);
      if (!g) {
        var y = i ? SP([], i) : [];
        if (u.selected) {
          var v = y.findIndex(function(w) {
            return vn(c, w);
          });
          y.splice(v, 1);
        } else
          y.push(c);
        (h = e.onSelect) === null || h === void 0 || h.call(e, y, c, u, f);
      }
    }
  }, s = {
    disabled: []
  };
  i && s.disabled.push(function(c) {
    var u = a && i.length > a - 1, f = i.some(function(m) {
      return vn(m, c);
    });
    return !!(u && !f);
  });
  var l = {
    selected: i,
    onDayClick: o,
    modifiers: s
  };
  return d(v0.Provider, { value: l, children: n });
}
function b0() {
  var t = Wt(v0);
  if (!t)
    throw new Error("useSelectMultiple must be used within a SelectMultipleProvider");
  return t;
}
function O$e(t, e) {
  var n = e || {}, i = n.from, r = n.to;
  return i && r ? vn(r, t) && vn(i, t) ? void 0 : vn(r, t) ? { from: r, to: void 0 } : vn(i, t) ? void 0 : Mi(i, t) ? { from: t, to: r } : { from: i, to: t } : r ? Mi(t, r) ? { from: r, to: t } : { from: t, to: r } : i ? An(t, i) ? { from: t, to: i } : { from: i, to: t } : { from: t, to: void 0 };
}
var w0 = hn(void 0);
function W$e(t) {
  if (!kc(t.initialProps)) {
    var e = {
      selected: void 0,
      modifiers: {
        range_start: [],
        range_end: [],
        range_middle: [],
        disabled: []
      }
    };
    return d(w0.Provider, { value: e, children: t.children });
  }
  return d(A$e, { initialProps: t.initialProps, children: t.children });
}
function A$e(t) {
  var e = t.initialProps, n = t.children, i = e.selected, r = i || {}, a = r.from, o = r.to, s = e.min, l = e.max, c = function(h, p, g) {
    var y, v;
    (y = e.onDayClick) === null || y === void 0 || y.call(e, h, p, g);
    var w = O$e(h, i);
    (v = e.onSelect) === null || v === void 0 || v.call(e, w, h, p, g);
  }, u = {
    range_start: [],
    range_end: [],
    range_middle: [],
    disabled: []
  };
  if (a ? (u.range_start = [a], o ? (u.range_end = [o], vn(a, o) || (u.range_middle = [
    {
      after: a,
      before: o
    }
  ])) : u.range_end = [a]) : o && (u.range_start = [o], u.range_end = [o]), s && (a && !o && u.disabled.push({
    after: lo(a, s - 1),
    before: Ct(a, s - 1)
  }), a && o && u.disabled.push({
    after: a,
    before: Ct(a, s - 1)
  }), !a && o && u.disabled.push({
    after: lo(o, s - 1),
    before: Ct(o, s - 1)
  })), l) {
    if (a && !o && (u.disabled.push({
      before: Ct(a, -l + 1)
    }), u.disabled.push({
      after: Ct(a, l - 1)
    })), a && o) {
      var f = Vi(o, a) + 1, m = l - f;
      u.disabled.push({
        before: lo(a, m)
      }), u.disabled.push({
        after: Ct(o, m)
      });
    }
    !a && o && (u.disabled.push({
      before: Ct(o, -l + 1)
    }), u.disabled.push({
      after: Ct(o, l - 1)
    }));
  }
  return d(w0.Provider, { value: { selected: i, onDayClick: c, modifiers: u }, children: n });
}
function k0() {
  var t = Wt(w0);
  if (!t)
    throw new Error("useSelectRange must be used within a SelectRangeProvider");
  return t;
}
function Mu(t) {
  return Array.isArray(t) ? SP([], t) : t !== void 0 ? [t] : [];
}
function L$e(t) {
  var e = {};
  return Object.entries(t).forEach(function(n) {
    var i = n[0], r = n[1];
    e[i] = Mu(r);
  }), e;
}
var Xi;
(function(t) {
  t.Outside = "outside", t.Disabled = "disabled", t.Selected = "selected", t.Hidden = "hidden", t.Today = "today", t.RangeStart = "range_start", t.RangeEnd = "range_end", t.RangeMiddle = "range_middle";
})(Xi || (Xi = {}));
var I$e = Xi.Selected, kr = Xi.Disabled, R$e = Xi.Hidden, j$e = Xi.Today, v1 = Xi.RangeEnd, b1 = Xi.RangeMiddle, w1 = Xi.RangeStart, F$e = Xi.Outside;
function z$e(t, e, n) {
  var i, r = (i = {}, i[I$e] = Mu(t.selected), i[kr] = Mu(t.disabled), i[R$e] = Mu(t.hidden), i[j$e] = [t.today], i[v1] = [], i[b1] = [], i[w1] = [], i[F$e] = [], i);
  return t.fromDate && r[kr].push({ before: t.fromDate }), t.toDate && r[kr].push({ after: t.toDate }), wc(t) ? r[kr] = r[kr].concat(e.modifiers[kr]) : kc(t) && (r[kr] = r[kr].concat(n.modifiers[kr]), r[w1] = n.modifiers[w1], r[b1] = n.modifiers[b1], r[v1] = n.modifiers[v1]), r;
}
var TP = hn(void 0);
function V$e(t) {
  var e = bt(), n = b0(), i = k0(), r = z$e(e, n, i), a = L$e(e.modifiers), o = je(je({}, r), a);
  return d(TP.Provider, { value: o, children: t.children });
}
function OP() {
  var t = Wt(TP);
  if (!t)
    throw new Error("useModifiers must be used within a ModifiersProvider");
  return t;
}
function H$e(t) {
  return !!(t && typeof t == "object" && "before" in t && "after" in t);
}
function B$e(t) {
  return !!(t && typeof t == "object" && "from" in t);
}
function q$e(t) {
  return !!(t && typeof t == "object" && "after" in t);
}
function G$e(t) {
  return !!(t && typeof t == "object" && "before" in t);
}
function X$e(t) {
  return !!(t && typeof t == "object" && "dayOfWeek" in t);
}
function Y$e(t, e) {
  var n, i = e.from, r = e.to;
  if (i && r) {
    var a = Vi(r, i) < 0;
    a && (n = [r, i], i = n[0], r = n[1]);
    var o = Vi(t, i) >= 0 && Vi(r, t) >= 0;
    return o;
  }
  return r ? vn(r, t) : i ? vn(i, t) : !1;
}
function K$e(t) {
  return yv(t);
}
function U$e(t) {
  return Array.isArray(t) && t.every(yv);
}
function J$e(t, e) {
  return e.some(function(n) {
    if (typeof n == "boolean")
      return n;
    if (K$e(n))
      return vn(t, n);
    if (U$e(n))
      return n.includes(t);
    if (B$e(n))
      return Y$e(t, n);
    if (X$e(n))
      return n.dayOfWeek.includes(t.getDay());
    if (H$e(n)) {
      var i = Vi(n.before, t), r = Vi(n.after, t), a = i > 0, o = r < 0, s = Mi(n.before, n.after);
      return s ? o && a : a || o;
    }
    return q$e(n) ? Vi(t, n.after) > 0 : G$e(n) ? Vi(n.before, t) > 0 : typeof n == "function" ? n(t) : !1;
  });
}
function x0(t, e, n) {
  var i = Object.keys(e).reduce(function(a, o) {
    var s = e[o];
    return J$e(t, s) && a.push(o), a;
  }, []), r = {};
  return i.forEach(function(a) {
    return r[a] = !0;
  }), n && !Um(t, n) && (r.outside = !0), r;
}
function Q$e(t, e) {
  for (var n = ut(t[0]), i = Kn(t[t.length - 1]), r, a, o = n; o <= i; ) {
    var s = x0(o, e), l = !s.disabled && !s.hidden;
    if (!l) {
      o = Ct(o, 1);
      continue;
    }
    if (s.selected)
      return o;
    s.today && !a && (a = o), r || (r = o), o = Ct(o, 1);
  }
  return a || r;
}
var Z$e = 365;
function WP(t, e) {
  var n = e.moveBy, i = e.direction, r = e.context, a = e.modifiers, o = e.retry, s = o === void 0 ? { count: 0, lastFocused: t } : o, l = r.weekStartsOn, c = r.fromDate, u = r.toDate, f = r.locale, m = {
    day: Ct,
    week: Fp,
    month: Et,
    year: zr,
    startOfWeek: function(y) {
      return r.ISOWeek ? $i(y) : mn(y, { locale: f, weekStartsOn: l });
    },
    endOfWeek: function(y) {
      return r.ISOWeek ? fc(y) : fd(y, { locale: f, weekStartsOn: l });
    }
  }, h = m[n](t, i === "after" ? 1 : -1);
  i === "before" && c ? h = NI([c, h]) : i === "after" && u && (h = $I([u, h]));
  var p = !0;
  if (a) {
    var g = x0(h, a);
    p = !g.disabled && !g.hidden;
  }
  return p ? h : s.count > Z$e ? s.lastFocused : WP(h, {
    moveBy: n,
    direction: i,
    context: r,
    modifiers: a,
    retry: je(je({}, s), { count: s.count + 1 })
  });
}
var AP = hn(void 0);
function eDe(t) {
  var e = xc(), n = OP(), i = q(), r = i[0], a = i[1], o = q(), s = o[0], l = o[1], c = Q$e(e.displayMonths, n), u = r ?? (s && e.isDateDisplayed(s)) ? s : c, f = function() {
    l(r), a(void 0);
  }, m = function(y) {
    a(y);
  }, h = bt(), p = function(y, v) {
    if (r) {
      var w = WP(r, {
        moveBy: y,
        direction: v,
        context: h,
        modifiers: n
      });
      vn(r, w) || (e.goToDate(w, r), m(w));
    }
  }, g = {
    focusedDay: r,
    focusTarget: u,
    blur: f,
    focus: m,
    focusDayAfter: function() {
      return p("day", "after");
    },
    focusDayBefore: function() {
      return p("day", "before");
    },
    focusWeekAfter: function() {
      return p("week", "after");
    },
    focusWeekBefore: function() {
      return p("week", "before");
    },
    focusMonthBefore: function() {
      return p("month", "before");
    },
    focusMonthAfter: function() {
      return p("month", "after");
    },
    focusYearBefore: function() {
      return p("year", "before");
    },
    focusYearAfter: function() {
      return p("year", "after");
    },
    focusStartOfWeek: function() {
      return p("startOfWeek", "before");
    },
    focusEndOfWeek: function() {
      return p("endOfWeek", "after");
    }
  };
  return d(AP.Provider, { value: g, children: t.children });
}
function _0() {
  var t = Wt(AP);
  if (!t)
    throw new Error("useFocusContext must be used within a FocusProvider");
  return t;
}
function tDe(t, e) {
  var n = OP(), i = x0(t, n, e);
  return i;
}
var M0 = hn(void 0);
function nDe(t) {
  if (!rh(t.initialProps)) {
    var e = {
      selected: void 0
    };
    return d(M0.Provider, { value: e, children: t.children });
  }
  return d(iDe, { initialProps: t.initialProps, children: t.children });
}
function iDe(t) {
  var e = t.initialProps, n = t.children, i = function(a, o, s) {
    var l, c, u;
    if ((l = e.onDayClick) === null || l === void 0 || l.call(e, a, o, s), o.selected && !e.required) {
      (c = e.onSelect) === null || c === void 0 || c.call(e, void 0, a, o, s);
      return;
    }
    (u = e.onSelect) === null || u === void 0 || u.call(e, a, a, o, s);
  }, r = {
    selected: e.selected,
    onDayClick: i
  };
  return d(M0.Provider, { value: r, children: n });
}
function LP() {
  var t = Wt(M0);
  if (!t)
    throw new Error("useSelectSingle must be used within a SelectSingleProvider");
  return t;
}
function rDe(t, e) {
  var n = bt(), i = LP(), r = b0(), a = k0(), o = _0(), s = o.focusDayAfter, l = o.focusDayBefore, c = o.focusWeekAfter, u = o.focusWeekBefore, f = o.blur, m = o.focus, h = o.focusMonthBefore, p = o.focusMonthAfter, g = o.focusYearBefore, y = o.focusYearAfter, v = o.focusStartOfWeek, w = o.focusEndOfWeek, x = function(F) {
    var z, K, ae, Q;
    rh(n) ? (z = i.onDayClick) === null || z === void 0 || z.call(i, t, e, F) : wc(n) ? (K = r.onDayClick) === null || K === void 0 || K.call(r, t, e, F) : kc(n) ? (ae = a.onDayClick) === null || ae === void 0 || ae.call(a, t, e, F) : (Q = n.onDayClick) === null || Q === void 0 || Q.call(n, t, e, F);
  }, b = function(F) {
    var z;
    m(t), (z = n.onDayFocus) === null || z === void 0 || z.call(n, t, e, F);
  }, M = function(F) {
    var z;
    f(), (z = n.onDayBlur) === null || z === void 0 || z.call(n, t, e, F);
  }, _ = function(F) {
    var z;
    (z = n.onDayMouseEnter) === null || z === void 0 || z.call(n, t, e, F);
  }, N = function(F) {
    var z;
    (z = n.onDayMouseLeave) === null || z === void 0 || z.call(n, t, e, F);
  }, $ = function(F) {
    var z;
    (z = n.onDayPointerEnter) === null || z === void 0 || z.call(n, t, e, F);
  }, D = function(F) {
    var z;
    (z = n.onDayPointerLeave) === null || z === void 0 || z.call(n, t, e, F);
  }, W = function(F) {
    var z;
    (z = n.onDayTouchCancel) === null || z === void 0 || z.call(n, t, e, F);
  }, j = function(F) {
    var z;
    (z = n.onDayTouchEnd) === null || z === void 0 || z.call(n, t, e, F);
  }, O = function(F) {
    var z;
    (z = n.onDayTouchMove) === null || z === void 0 || z.call(n, t, e, F);
  }, I = function(F) {
    var z;
    (z = n.onDayTouchStart) === null || z === void 0 || z.call(n, t, e, F);
  }, L = function(F) {
    var z;
    (z = n.onDayKeyUp) === null || z === void 0 || z.call(n, t, e, F);
  }, R = function(F) {
    var z;
    switch (F.key) {
      case "ArrowLeft":
        F.preventDefault(), F.stopPropagation(), n.dir === "rtl" ? s() : l();
        break;
      case "ArrowRight":
        F.preventDefault(), F.stopPropagation(), n.dir === "rtl" ? l() : s();
        break;
      case "ArrowDown":
        F.preventDefault(), F.stopPropagation(), c();
        break;
      case "ArrowUp":
        F.preventDefault(), F.stopPropagation(), u();
        break;
      case "PageUp":
        F.preventDefault(), F.stopPropagation(), F.shiftKey ? g() : h();
        break;
      case "PageDown":
        F.preventDefault(), F.stopPropagation(), F.shiftKey ? y() : p();
        break;
      case "Home":
        F.preventDefault(), F.stopPropagation(), v();
        break;
      case "End":
        F.preventDefault(), F.stopPropagation(), w();
        break;
    }
    (z = n.onDayKeyDown) === null || z === void 0 || z.call(n, t, e, F);
  }, B = {
    onClick: x,
    onFocus: b,
    onBlur: M,
    onKeyDown: R,
    onKeyUp: L,
    onMouseEnter: _,
    onMouseLeave: N,
    onPointerEnter: $,
    onPointerLeave: D,
    onTouchCancel: W,
    onTouchEnd: j,
    onTouchMove: O,
    onTouchStart: I
  };
  return B;
}
function aDe() {
  var t = bt(), e = LP(), n = b0(), i = k0(), r = rh(t) ? e.selected : wc(t) ? n.selected : kc(t) ? i.selected : void 0;
  return r;
}
function oDe(t) {
  return Object.values(Xi).includes(t);
}
function sDe(t, e) {
  var n = [t.classNames.day];
  return Object.keys(e).forEach(function(i) {
    var r = t.modifiersClassNames[i];
    if (r)
      n.push(r);
    else if (oDe(i)) {
      var a = t.classNames["day_".concat(i)];
      a && n.push(a);
    }
  }), n;
}
function lDe(t, e) {
  var n = je({}, t.styles.day);
  return Object.keys(e).forEach(function(i) {
    var r;
    n = je(je({}, n), (r = t.modifiersStyles) === null || r === void 0 ? void 0 : r[i]);
  }), n;
}
function dDe(t, e, n) {
  var i, r, a, o = bt(), s = _0(), l = tDe(t, e), c = rDe(t, l), u = aDe(), f = !!(o.onDayClick || o.mode !== "default");
  le(function() {
    var _;
    l.outside || s.focusedDay && f && vn(s.focusedDay, t) && ((_ = n.current) === null || _ === void 0 || _.focus());
  }, [
    s.focusedDay,
    t,
    n,
    f,
    l.outside
  ]);
  var m = sDe(o, l).join(" "), h = lDe(o, l), p = !!(l.outside && !o.showOutsideDays || l.hidden), g = (a = (r = o.components) === null || r === void 0 ? void 0 : r.DayContent) !== null && a !== void 0 ? a : D$e, y = d(g, { date: t, displayMonth: e, activeModifiers: l }), v = {
    style: h,
    className: m,
    children: y,
    role: "gridcell"
  }, w = s.focusTarget && vn(s.focusTarget, t) && !l.outside, x = s.focusedDay && vn(s.focusedDay, t), b = je(je(je({}, v), (i = { disabled: l.disabled, role: "gridcell" }, i["aria-selected"] = l.selected, i.tabIndex = x || w ? 0 : -1, i)), c), M = {
    isButton: f,
    isHidden: p,
    activeModifiers: l,
    selectedDays: u,
    buttonProps: b,
    divProps: v
  };
  return M;
}
function cDe(t) {
  var e = Oe(null), n = dDe(t.date, t.displayMonth, e);
  return n.isHidden ? d("div", { role: "gridcell" }) : n.isButton ? d(xf, je({ name: "day", ref: e }, n.buttonProps)) : d("div", je({}, n.divProps));
}
function uDe(t) {
  var e = t.number, n = t.dates, i = bt(), r = i.onWeekNumberClick, a = i.styles, o = i.classNames, s = i.locale, l = i.labels.labelWeekNumber, c = i.formatters.formatWeekNumber, u = c(Number(e), { locale: s });
  if (!r)
    return d("span", { className: o.weeknumber, style: a.weeknumber, children: u });
  var f = l(Number(e), { locale: s }), m = function(h) {
    r(e, n, h);
  };
  return d(xf, { name: "week-number", "aria-label": f, className: o.weeknumber, style: a.weeknumber, onClick: m, children: u });
}
function fDe(t) {
  var e, n, i = bt(), r = i.styles, a = i.classNames, o = i.showWeekNumber, s = i.components, l = (e = s == null ? void 0 : s.Day) !== null && e !== void 0 ? e : cDe, c = (n = s == null ? void 0 : s.WeekNumber) !== null && n !== void 0 ? n : uDe, u;
  return o && (u = d("td", { className: a.cell, style: r.cell, children: d(c, { number: t.weekNumber, dates: t.dates }) })), k("tr", { className: a.row, style: r.row, children: [u, t.dates.map(function(f) {
    return d("td", { className: a.cell, style: r.cell, role: "presentation", children: d(l, { displayMonth: t.displayMonth, date: f }) }, CR(f));
  })] });
}
function L2(t, e, n) {
  for (var i = n != null && n.ISOWeek ? fc(e) : fd(e, n), r = n != null && n.ISOWeek ? $i(t) : mn(t, n), a = Vi(i, r), o = [], s = 0; s <= a; s++)
    o.push(Ct(r, s));
  var l = o.reduce(function(c, u) {
    var f = n != null && n.ISOWeek ? bv(u) : kv(u, n), m = c.find(function(h) {
      return h.weekNumber === f;
    });
    return m ? (m.dates.push(u), c) : (c.push({
      weekNumber: f,
      dates: [u]
    }), c);
  }, []);
  return l;
}
function mDe(t, e) {
  var n = L2(ut(t), Kn(t), e);
  if (e != null && e.useFixedWeeks) {
    var i = SR(t, e);
    if (i < 6) {
      var r = n[n.length - 1], a = r.dates[r.dates.length - 1], o = Fp(a, 6 - i), s = L2(Fp(a, 1), o, e);
      n.push.apply(n, s);
    }
  }
  return n;
}
function hDe(t) {
  var e, n, i, r = bt(), a = r.locale, o = r.classNames, s = r.styles, l = r.hideHead, c = r.fixedWeeks, u = r.components, f = r.weekStartsOn, m = r.firstWeekContainsDate, h = r.ISOWeek, p = mDe(t.displayMonth, {
    useFixedWeeks: !!c,
    ISOWeek: h,
    locale: a,
    weekStartsOn: f,
    firstWeekContainsDate: m
  }), g = (e = u == null ? void 0 : u.Head) !== null && e !== void 0 ? e : $$e, y = (n = u == null ? void 0 : u.Row) !== null && n !== void 0 ? n : fDe, v = (i = u == null ? void 0 : u.Footer) !== null && i !== void 0 ? i : P$e;
  return k("table", { id: t.id, className: o.table, style: s.table, role: "grid", "aria-labelledby": t["aria-labelledby"], children: [!l && d(g, {}), d("tbody", { className: o.tbody, style: s.tbody, children: p.map(function(w) {
    return d(y, { displayMonth: t.displayMonth, dates: w.dates, weekNumber: w.weekNumber }, w.weekNumber);
  }) }), d(v, { displayMonth: t.displayMonth })] });
}
function pDe() {
  return !!(typeof window < "u" && window.document && window.document.createElement);
}
var gDe = pDe() ? Zd : le, k1 = !1, yDe = 0;
function I2() {
  return "react-day-picker-".concat(++yDe);
}
function vDe(t) {
  var e, n = t ?? (k1 ? I2() : null), i = q(n), r = i[0], a = i[1];
  return gDe(function() {
    r === null && a(I2());
  }, []), le(function() {
    k1 === !1 && (k1 = !0);
  }, []), (e = t ?? r) !== null && e !== void 0 ? e : void 0;
}
function bDe(t) {
  var e, n, i = bt(), r = i.dir, a = i.classNames, o = i.styles, s = i.components, l = xc().displayMonths, c = vDe(i.id ? "".concat(i.id, "-").concat(t.displayIndex) : void 0), u = i.id ? "".concat(i.id, "-grid-").concat(t.displayIndex) : void 0, f = [a.month], m = o.month, h = t.displayIndex === 0, p = t.displayIndex === l.length - 1, g = !h && !p;
  r === "rtl" && (e = [h, p], p = e[0], h = e[1]), h && (f.push(a.caption_start), m = je(je({}, m), o.caption_start)), p && (f.push(a.caption_end), m = je(je({}, m), o.caption_end)), g && (f.push(a.caption_between), m = je(je({}, m), o.caption_between));
  var y = (n = s == null ? void 0 : s.Caption) !== null && n !== void 0 ? n : C$e;
  return k("div", { className: f.join(" "), style: m, children: [d(y, { id: c, displayMonth: t.displayMonth, displayIndex: t.displayIndex }), d(hDe, { id: u, "aria-labelledby": c, displayMonth: t.displayMonth })] }, t.displayIndex);
}
function wDe(t) {
  var e = bt(), n = e.classNames, i = e.styles;
  return d("div", { className: n.months, style: i.months, children: t.children });
}
function kDe(t) {
  var e, n, i = t.initialProps, r = bt(), a = _0(), o = xc(), s = q(!1), l = s[0], c = s[1];
  le(function() {
    r.initialFocus && a.focusTarget && (l || (a.focus(a.focusTarget), c(!0)));
  }, [
    r.initialFocus,
    l,
    a.focus,
    a.focusTarget,
    a
  ]);
  var u = [r.classNames.root, r.className];
  r.numberOfMonths > 1 && u.push(r.classNames.multiple_months), r.showWeekNumber && u.push(r.classNames.with_weeknumber);
  var f = je(je({}, r.styles.root), r.style), m = Object.keys(i).filter(function(p) {
    return p.startsWith("data-");
  }).reduce(function(p, g) {
    var y;
    return je(je({}, p), (y = {}, y[g] = i[g], y));
  }, {}), h = (n = (e = i.components) === null || e === void 0 ? void 0 : e.Months) !== null && n !== void 0 ? n : wDe;
  return d("div", je({ className: u.join(" "), style: f, dir: r.dir, id: r.id, nonce: i.nonce, title: i.title, lang: i.lang }, m, { children: d(h, { children: o.displayMonths.map(function(p, g) {
    return d(bDe, { displayIndex: g, displayMonth: p }, g);
  }) }) }));
}
function xDe(t) {
  var e = t.children, n = GNe(t, ["children"]);
  return d(u$e, { initialProps: n, children: d(k$e, { children: d(nDe, { initialProps: n, children: d(E$e, { initialProps: n, children: d(W$e, { initialProps: n, children: d(V$e, { children: d(eDe, { children: e }) }) }) }) }) }) });
}
function _De(t) {
  return d(xDe, je({}, t, { children: d(kDe, { initialProps: t }) }));
}
function _f({
  className: t,
  classNames: e,
  showOutsideDays: n = !0,
  ...i
}) {
  return /* @__PURE__ */ d(
    _De,
    {
      showOutsideDays: n,
      className: t,
      disabled: i.disabled,
      classNames: {
        months: "flex flex-col",
        caption: "hidden",
        nav: "space-x-1 flex items-center",
        nav_button_previous: "absolute left-1",
        nav_button_next: "absolute right-1",
        table: "w-full border-collapse",
        head_row: "flex items-center justify-between",
        head_cell: "text-f1-foreground-secondary rounded-xs w-full font-medium h-8 flex justify-center items-center",
        row: "flex w-full mt-2 items-center justify-between",
        cell: E(
          "rounded-md h-10 w-full text-center font-medium p-0 relative text-f1-foreground transition-all duration-100",
          "before:absolute before:inset-0 before:z-0 before:rounded-md before:bg-f1-background-selected-bold before:opacity-0 before:transition-all before:duration-100 before:content-[''] hover:before:bg-f1-background-selected-bold-hover before:pointer-events-none",
          "[&:has([aria-selected].day-range-start)]:before:opacity-100 [&:has([aria-selected].day-range-end)]:before:opacity-100",
          "[&:has([aria-selected].day-outside)]:bg-f1-background-selected focus-within:relative focus-within:z-20 [&:has([aria-selected].day-range-middle)]:rounded-none first:[&:has([aria-selected].day-range-middle)]:rounded-l-md last:[&:has([aria-selected].day-range-middle)]:rounded-r-md [&:has([aria-selected].day-range-start)]:rounded-r-none [&:has([aria-selected].day-range-end)]:rounded-l-none first:[&:has([aria-selected].day-range-end)]:rounded-r-md first:[&:has([aria-selected].day-range-end)]:rounded-l-md last:[&:has([aria-selected].day-range-start)]:rounded-l-md last:[&:has([aria-selected].day-range-start)]:rounded-r-md [&:has([aria-selected].day-range-start.day-range-end)]:rounded-md [&:has([aria-selected].day-range-middle)]:bg-f1-background-selected",
          "[&:has([aria-selected].day-range-start)]:bg-f1-background-selected [&:has([aria-selected].day-range-end)]:bg-f1-background-selected",
          "[&>span.rdp-weeknumber]:text-f1-foreground-secondary [&>span.rdp-weeknumber]:flex [&>span.rdp-weeknumber]:items-center [&>span.rdp-weeknumber]:justify-center [&>span.rdp-weeknumber]:w-full [&>span.rdp-weeknumber]:h-full [&>span.rdp-weeknumber]:text-sm [&>span.rdp-weeknumber]:font-normal",
          i.mode === "single" && "[&:has([aria-selected].day-selected)]:before:opacity-100",
          i.showWeekNumber && "[&:has([aria-selected].day-range-middle)]:bg-f1-background-selected-bold [&:has([aria-selected].day-range-start)]:bg-f1-background-selected-bold [&:has([aria-selected].day-range-end)]:bg-f1-background-selected-bold hover:before:bg-f1-background-selected-bold"
        ),
        day: "rounded-[inherit] h-10 w-10 p-0 aria-selected:opacity-100 z-20 relative",
        day_range_start: "day-range-start aria-selected:text-f1-foreground-inverse",
        day_range_end: "day-range-end aria-selected:text-f1-foreground-inverse",
        day_today: "relative after:absolute after:inset-x-0 after:bottom-1 after:z-20 after:mx-auto after:h-0.5 after:w-1.5 after:rounded-full after:bg-f1-background-selected-bold after:transition-colors after:duration-100 after:content-[''] after:pointer-events-none aria-selected:after:bg-f1-background",
        day_selected: E(
          "day-selected",
          i.mode === "single" && "aria-selected:text-f1-foreground-inverse"
        ),
        day_outside: "day-outside text-f1-foreground-secondary font-normal",
        day_disabled: "text-f1-foreground-disabled",
        day_range_middle: E(
          "day-range-middle aria-selected:text-f1-foreground-selected",
          i.showWeekNumber && "aria-selected:text-f1-foreground-inverse"
        ),
        day_hidden: "invisible",
        ...e
      },
      components: {
        IconLeft: () => /* @__PURE__ */ d(LW, { className: "h-4 w-4" }),
        IconRight: () => /* @__PURE__ */ d(Ky, { className: "h-4 w-4" })
      },
      ...i
    }
  );
}
_f.displayName = "Calendar";
function MDe({
  mode: t,
  selected: e,
  onSelect: n,
  month: i,
  onMonthChange: r,
  motionDirection: a = 1,
  minDate: o,
  maxDate: s
}) {
  const { locale: l } = c5(), c = PP({ minDate: o, maxDate: s }), u = {
    hidden: (f) => ({
      opacity: 0,
      x: f === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (f) => ({
      opacity: 0,
      x: f === 1 ? -40 : 40
    })
  };
  return t === "single" ? /* @__PURE__ */ d(
    Ue,
    {
      mode: "popLayout",
      initial: !1,
      custom: a,
      children: /* @__PURE__ */ d(
        re.div,
        {
          variants: u,
          custom: a,
          initial: "hidden",
          animate: "visible",
          exit: "exit",
          transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
          children: /* @__PURE__ */ d(
            _f,
            {
              mode: "single",
              disabled: c,
              selected: e,
              onSelect: n,
              month: i,
              locale: pg(l),
              weekStartsOn: 1
            }
          )
        },
        i.toISOString()
      )
    }
  ) : /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: a, children: /* @__PURE__ */ d(
    re.div,
    {
      variants: u,
      custom: a,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: /* @__PURE__ */ d(
        _f,
        {
          mode: "range",
          disabled: c,
          selected: e,
          onSelect: n,
          month: i,
          onMonthChange: r,
          locale: pg(l),
          weekStartsOn: 1
        },
        i.toISOString()
      )
    },
    i.toISOString()
  ) });
}
function Uo(t) {
  return nl(t, Gi, uc);
}
const x1 = (t, e) => ({
  from: Gi(Ct(t.from, e)),
  to: uc(Ct(t.to, e))
}), gg = {
  calendarView: "day",
  add: x1,
  getPrevNext: (t, e) => {
    const n = Uo(t);
    if (!n)
      return {
        prev: !1,
        next: !1
      };
    const { from: i, to: r } = n, { from: a, to: o } = x1({ from: i, to: r }, -1), { from: s, to: l } = x1({ from: i, to: r }, 1), c = e.min && Gi(e.min), u = e.max && uc(e.max);
    return {
      prev: Br(a, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) ? { from: s, to: l } : !1
    };
  },
  toRange: (t) => Uo(t),
  toRangeString: (t) => tl(t, "dd/MM/yyyy"),
  toString: (t) => bc(t, "dd/MM/yyyy"),
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim(), [s, l, c] = o.split(/[/.-]/);
      return new Date(Number(c), Number(l) - 1, Number(s));
    };
    return Uo({
      from: r(n),
      to: i ? r(i) : void 0
    });
  },
  navigate: (t, e) => Ct(t, e),
  navigateUIView: (t, e) => Et(t, e),
  getViewDateFromDate: (t) => ut(t),
  label: (t) => new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric"
  }).format(t),
  render: (t) => {
    const e = Uo(t.minDate), n = Uo(t.maxDate);
    return /* @__PURE__ */ d(
      MDe,
      {
        mode: t.mode,
        selected: t.selected,
        onSelect: t.onSelect,
        month: t.month,
        onMonthChange: t.onMonthChange,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
}, Ho = (t) => t < 6 ? 1 : 2, Jc = (t, e) => {
  const n = t === 1 ? 0 : 6, i = t === 1 ? 5 : 11, r = ut(new Date(e, n, 1)), a = Kn(new Date(e, i + 1, 0));
  return { from: r, to: a };
}, CDe = ({
  mode: t,
  selected: e,
  onSelect: n,
  year: i,
  minDate: r,
  maxDate: a,
  motionDirection: o = 1
}) => {
  const s = [1, 2], l = /* @__PURE__ */ new Date(), c = l.getFullYear(), u = Ho(l.getMonth()), f = Math.floor(i / 5) * 5, m = Array.from({ length: 5 }, (b, M) => f + M), h = (b) => !!(b && typeof b == "object" && ("from" in b || "to" in b)), p = (b, M) => {
    const _ = Jc(b, M);
    if (t === "single")
      n == null || n(_.from);
    else if (t === "range")
      if (!e || !h(e))
        n == null || n({
          from: _.from,
          to: void 0
        });
      else if (e && e.from && !e.to) {
        const N = e.from, $ = Ho(N.getMonth()), D = N.getFullYear();
        if ($ === b && D === M)
          n == null || n({
            from: _.from,
            to: _.to
          });
        else {
          const W = Jc($, D), j = An(W.from, _.from) ? W.from : _.from, O = Mi(W.to, _.to) ? W.to : _.to;
          n == null || n({
            from: j,
            to: O
          });
        }
      } else
        n == null || n({
          from: _.from,
          to: void 0
        });
  }, g = (b, M) => {
    if (!e) return !1;
    const _ = Jc(b, M);
    if (h(e)) {
      const N = e.from, $ = e.to;
      if (N && $)
        return ks(_.from, { start: N, end: $ }) || !!_.to && ks(_.to, { start: N, end: $ }) || An(_.from, N) && !!_.to && Mi(_.to, $);
      if (N)
        return Ho(N.getMonth()) === b && N.getFullYear() === M;
    } else {
      const N = e.getMonth();
      return Ho(N) === b && e.getFullYear() === M;
    }
    return !1;
  }, y = (b, M) => b === u && M === c, v = (b, M) => {
    if (!e || !h(e) || !e.from) return !1;
    const _ = e.from;
    return Ho(_.getMonth()) === b && _.getFullYear() === M;
  }, w = (b, M) => {
    if (!e || !h(e) || !e.to) return !1;
    const _ = e.to;
    return Ho(_.getMonth()) === b && _.getFullYear() === M;
  }, x = {
    hidden: (b) => ({
      opacity: 0,
      x: b === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (b) => ({
      opacity: 0,
      x: b === 1 ? -40 : 40
    })
  };
  return /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: o, children: /* @__PURE__ */ d(
    re.div,
    {
      className: "flex flex-col gap-4",
      custom: o,
      variants: x,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: m.map((b) => /* @__PURE__ */ k(
        "div",
        {
          className: "flex items-center justify-center gap-3 pl-1.5",
          children: [
            /* @__PURE__ */ d("div", { className: "text-medium text-right text-sm tabular-nums text-f1-foreground-secondary", children: b }),
            /* @__PURE__ */ d("div", { className: "flex flex-1", children: s.map((M) => {
              const _ = g(M, b), N = y(M, b), $ = v(M, b), D = w(M, b), W = Jc(M, b), j = r && An(W.from, r) || a && W.to && Mi(W.to, a);
              return /* @__PURE__ */ k(
                "button",
                {
                  onClick: () => p(M, b),
                  disabled: j,
                  className: E(
                    "relative isolate flex h-10 flex-1 items-center justify-center rounded-md p-2 tabular-nums",
                    "after:absolute after:inset-x-1 after:inset-y-0 after:z-0 after:rounded-md after:ring-1 after:ring-inset after:ring-f1-border-secondary after:transition-all after:duration-100 after:content-['']",
                    j && "cursor-not-allowed text-f1-foreground-secondary",
                    !j && "hover:after:bg-f1-background-hover",
                    Ke(),
                    ($ || D) && "after:inset-x-0",
                    _ && "after:bg-f1-background-selected-bold after:ring-0 hover:after:bg-f1-background-selected-bold-hover [&>span]:text-f1-foreground-inverse",
                    _ && !$ && !D && t === "range" && "rounded-none bg-f1-background-selected after:opacity-0 after:transition-none first:rounded-l-md last:rounded-r-md hover:bg-f1-background-selected [&>span]:text-f1-foreground-selected"
                  ),
                  children: [
                    $ && /* @__PURE__ */ d("div", { className: "absolute inset-y-0 right-0 z-0 w-1/2 bg-f1-background-selected" }),
                    D && /* @__PURE__ */ d("div", { className: "absolute inset-y-0 left-0 z-0 w-1/2 bg-f1-background-selected" }),
                    /* @__PURE__ */ k("span", { className: "z-10 font-medium", children: [
                      "H",
                      M
                    ] }),
                    N && /* @__PURE__ */ d(
                      "div",
                      {
                        className: E(
                          "absolute inset-x-0 bottom-1 z-20 mx-auto h-0.5 w-1.5 rounded-full bg-f1-background-selected-bold transition-colors duration-100",
                          _ && t === "single" && "bg-f1-background",
                          ($ || D) && "bg-f1-background",
                          !$ && !D && _ && t === "range" && "bg-f1-background-selected-bold"
                        )
                      }
                    )
                  ]
                },
                `${b}-H${M}`
              );
            }) })
          ]
        },
        b
      ))
    },
    i
  ) });
}, R2 = (t) => {
  const e = t.getMonth();
  return `H${Math.floor(e / 6) + 1} ${t.getFullYear()}`;
}, j2 = (t) => {
  const e = Jo(t);
  if (!e)
    return {
      from: "",
      to: void 0
    };
  const n = R2(e.from), i = e.to ? R2(e.to) : void 0;
  return {
    from: n,
    to: i && n !== i ? i : void 0
  };
}, _1 = (t, e) => ({
  from: ut(Et(t.from, e * 6)),
  to: Kn(Et(t.to, e * 6))
});
function Jo(t) {
  return nl(
    t,
    (e) => rk(e) < 5 ? ki(e) : ut(Fl(e, 6)),
    (e) => rk(e) < 6 ? Kn(Fl(e, 5)) : la(e)
  );
}
const PDe = {
  calendarView: "halfyear",
  add: _1,
  getPrevNext: (t, e) => {
    const n = Jo(t);
    if (!n)
      return { prev: !1, next: !1 };
    const { from: i, to: r } = n, { from: a, to: o } = _1({ from: i, to: r }, -1), { from: s, to: l } = _1({ from: i, to: r }, 1), c = e.min && ut(e.min), u = e.max && Kn(e.max);
    return {
      prev: Br(a, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) ? { from: s, to: l } : !1
    };
  },
  toRangeString: (t) => j2(t),
  toRange: (t) => Jo(t),
  toString: (t) => {
    const e = j2(t);
    if (!e)
      return "-";
    const { from: n, to: i } = e;
    return `${n}${i && n !== i ? ` ${md} ${i}` : ""}`;
  },
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim(), [s, l] = o.split(/\s+/), c = isNaN(Number(l)) ? (/* @__PURE__ */ new Date()).getFullYear() : +l, u = Number(s.replace(/[hH\s+]/g, "").trim());
      return new Date(c, (u - 1) * 6, 1);
    };
    return Jo({
      from: r(n),
      to: r(i || n)
    });
  },
  navigate: (t, e) => Et(t, e * 6),
  navigateUIView: (t, e) => zr(t, e * 5),
  label: (t) => {
    const e = Math.floor(t.getFullYear() / 5) * 5, n = e + 4;
    return `${e} ${md} ${n}`;
  },
  getViewDateFromDate: (t) => ki(t),
  render: (t) => {
    const e = Jo(t.minDate), n = Jo(t.maxDate);
    return /* @__PURE__ */ d(
      CDe,
      {
        mode: t.mode,
        year: t.viewDate.getFullYear(),
        selected: t.selected,
        onSelect: t.onSelect,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
};
function SDe({
  mode: t,
  selected: e,
  onSelect: n,
  year: i,
  motionDirection: r = 1,
  minDate: a,
  maxDate: o
}) {
  const s = et(), l = [
    { name: s.date.month.january, index: 0 },
    { name: s.date.month.february, index: 1 },
    { name: s.date.month.march, index: 2 },
    { name: s.date.month.april, index: 3 },
    { name: s.date.month.may, index: 4 },
    { name: s.date.month.june, index: 5 },
    { name: s.date.month.july, index: 6 },
    { name: s.date.month.august, index: 7 },
    { name: s.date.month.september, index: 8 },
    { name: s.date.month.october, index: 9 },
    { name: s.date.month.november, index: 10 },
    { name: s.date.month.december, index: 11 }
  ], c = /* @__PURE__ */ new Date(), u = (v) => !!(v && typeof v == "object" && ("from" in v || "to" in v)), f = (v) => {
    const w = new Date(i, v, 1), x = ut(w), b = Kn(w);
    if (t === "single")
      n == null || n({
        from: x,
        to: b
      });
    else if (t === "range")
      if (!e || !u(e))
        n == null || n({
          from: w,
          to: void 0
        });
      else if (e.from && !e.to) {
        const M = e.from;
        if (Um(M, w))
          n == null || n({
            from: ut(w),
            to: Kn(w)
          });
        else {
          const _ = An(M, w) ? M : w, N = An(M, w) ? w : M;
          n == null || n({
            from: ut(_),
            to: Kn(N)
          });
        }
      } else
        n == null || n({
          from: w,
          to: void 0
        });
  }, m = (v) => v === c.getMonth() && i === c.getFullYear(), h = (v) => {
    if (!e) return !1;
    if (u(e)) {
      if (e.from && e.to) {
        const w = new Date(i, v, 15);
        return ks(w, {
          start: e.from,
          end: e.to
        });
      } else if (e.from)
        return e.from.getMonth() === v && e.from.getFullYear() === i;
    } else
      return e.getMonth() === v && e.getFullYear() === i;
    return !1;
  }, p = (v) => !e || !u(e) || !e.from ? !1 : e.from.getMonth() === v && e.from.getFullYear() === i, g = (v) => !e || !u(e) || !e.to ? !1 : e.to.getMonth() === v && e.to.getFullYear() === i, y = {
    hidden: (v) => ({
      opacity: 0,
      x: v === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (v) => ({
      opacity: 0,
      x: v === 1 ? -40 : 40
    })
  };
  return /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: r, children: /* @__PURE__ */ d(
    re.div,
    {
      className: "grid grid-cols-3 gap-y-3",
      custom: r,
      variants: y,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: l.map((v) => {
        const w = m(v.index), x = h(v.index), b = p(v.index), M = g(v.index), _ = new Date(i, v.index, 1), N = ut(_), $ = Kn(_), D = a && An(N, a) || o && Mi($, o);
        return /* @__PURE__ */ k(
          "button",
          {
            type: "button",
            onClick: () => f(v.index),
            disabled: D,
            className: E(
              "relative isolate flex h-10 items-center justify-center rounded-md font-medium text-f1-foreground transition-colors duration-100 after:absolute after:inset-0 after:z-0 after:rounded-md after:bg-f1-background-selected-bold after:opacity-0 after:transition-all after:duration-100 after:content-['']",
              !D && "hover:bg-f1-background-hover hover:after:bg-f1-background-selected-bold-hover",
              D && "cursor-not-allowed text-f1-foreground-secondary",
              Ke(),
              x && t === "single" && "bg-f1-background-selected-bold after:opacity-100 hover:bg-f1-background-selected-bold-hover [&>span]:z-10 [&>span]:text-f1-foreground-inverse",
              x && t === "range" && "rounded-none bg-f1-background-selected hover:bg-f1-background-selected [&:nth-child(3n+1)]:rounded-s-md [&:nth-child(3n+3)]:rounded-e-md [&>span]:text-f1-foreground-selected",
              (b || M) && t === "range" && "rounded-none bg-f1-background-selected after:opacity-100 [&>span]:z-10 [&>span]:text-f1-foreground-inverse",
              b && t === "range" && M && "rounded-s-md",
              M && t === "range" && "rounded-e-md"
            ),
            children: [
              /* @__PURE__ */ d("span", { children: v.name }),
              w && /* @__PURE__ */ d(
                "div",
                {
                  className: E(
                    "absolute inset-x-0 bottom-1 z-20 mx-auto h-0.5 w-1.5 rounded-full bg-f1-background-selected-bold transition-colors duration-100",
                    x && t === "single" && "bg-f1-background",
                    (b || M) && "bg-f1-background",
                    !b && !M && x && t === "range" && "bg-f1-background-selected-bold"
                  )
                }
              )
            ]
          },
          v.index
        );
      })
    },
    i
  ) });
}
function xl(t) {
  return nl(t, ut, Kn);
}
const M1 = (t, e) => ({
  from: ut(Et(t.from, e)),
  to: Kn(Et(t.to, e))
}), NDe = {
  calendarView: "month",
  add: M1,
  getPrevNext: (t, e) => {
    const n = xl(t);
    if (!n)
      return { prev: !1, next: !1 };
    const { from: i, to: r } = n, { from: a, to: o } = M1({ from: i, to: r }, -1), { from: s, to: l } = M1({ from: i, to: r }, 1), c = e.min && ut(e.min), u = e.max && Kn(e.max);
    return {
      prev: Br(a, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) ? { from: s, to: l } : !1
    };
  },
  toRangeString: (t) => tl(t, "MM/yyyy"),
  toRange: (t) => xl(t),
  toString: (t) => bc(t, "MM/yyyy"),
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim(), [s, l] = o.split(/[/.-\s+]/), c = isNaN(Number(l)) ? (/* @__PURE__ */ new Date()).getFullYear() : +l, u = lf(s, "MMMM", (/* @__PURE__ */ new Date()).setFullYear(c)).getMonth() + 1 || lf(s, "MMM", (/* @__PURE__ */ new Date()).setFullYear(c)).getMonth() + 1 || Number(s);
      return new Date(Number(c), Number(u) - 1, 1);
    };
    return xl({
      from: r(n),
      to: i ? r(i) : void 0
    });
  },
  navigate: (t, e) => Et(t, e),
  navigateUIView: (t, e) => zr(t, e),
  label: (t) => /* @__PURE__ */ d(
    Lv,
    {
      format: {
        useGrouping: !1,
        maximumFractionDigits: 0
      },
      spinTiming: {
        duration: 150
      },
      value: t.getFullYear()
    }
  ),
  getViewDateFromDate: (t) => ut(t),
  render: (t) => {
    const e = xl(t.minDate), n = xl(t.maxDate);
    return /* @__PURE__ */ d(
      SDe,
      {
        mode: t.mode,
        year: t.viewDate.getFullYear(),
        selected: t.selected,
        onSelect: t.onSelect,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
}, Bo = (t) => Math.floor(t / 3) + 1, $De = (t) => t >= 1 && t <= 4 ? [0, 1, 2].map((e) => e + (t - 1) * 3) : [], Qc = (t, e) => {
  const n = $De(t), i = n[0], r = n[n.length - 1], a = new Date(e, i, 1), o = new Date(e, r + 1, 0);
  return { from: a, to: o };
}, DDe = ({
  mode: t,
  selected: e,
  onSelect: n,
  year: i,
  motionDirection: r = 1,
  minDate: a,
  maxDate: o
}) => {
  const s = [1, 2, 3, 4], l = /* @__PURE__ */ new Date(), c = l.getFullYear(), u = Bo(l.getMonth()), f = Math.floor(i / 5) * 5, m = Array.from({ length: 5 }, (b, M) => f + M), h = (b) => !!(b && typeof b == "object" && ("from" in b || "to" in b)), p = (b, M) => {
    const _ = Qc(b, M);
    if (t === "single")
      n == null || n(_.from);
    else if (t === "range")
      if (!e || !h(e))
        n == null || n({
          from: _.from,
          to: void 0
        });
      else if (e && e.from && !e.to) {
        const N = e.from, $ = Bo(N.getMonth()), D = N.getFullYear();
        if ($ === b && D === M)
          n == null || n({
            from: _.from,
            to: _.to
          });
        else {
          const W = Qc($, D), j = An(W.from, _.from) ? W.from : _.from, O = Mi(W.to, _.to) ? W.to : _.to;
          n == null || n({
            from: j,
            to: O
          });
        }
      } else
        n == null || n({
          from: _.from,
          to: void 0
        });
  }, g = (b, M) => {
    if (!e) return !1;
    const _ = Qc(b, M);
    if (!_.to) return !1;
    if (h(e)) {
      const N = e.from, $ = e.to;
      if (N && $)
        return ks(_.from, { start: N, end: $ }) || ks(_.to, { start: N, end: $ }) || An(_.from, N) && Mi(_.to, $);
      if (N)
        return Bo(N.getMonth()) === b && N.getFullYear() === M;
    } else {
      const N = e.getMonth();
      return Bo(N) === b && e.getFullYear() === M;
    }
    return !1;
  }, y = (b, M) => b === u && M === c, v = (b, M) => {
    if (!e || !h(e) || !e.from) return !1;
    const _ = e.from;
    return Bo(_.getMonth()) === b && _.getFullYear() === M;
  }, w = (b, M) => {
    if (!e || !h(e) || !e.to) return !1;
    const _ = e.to;
    return Bo(_.getMonth()) === b && _.getFullYear() === M;
  }, x = {
    hidden: (b) => ({
      opacity: 0,
      x: b === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (b) => ({
      opacity: 0,
      x: b === 1 ? -40 : 40
    })
  };
  return /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: r, children: /* @__PURE__ */ d(
    re.div,
    {
      className: "flex flex-col gap-4",
      custom: r,
      variants: x,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: m.map((b) => /* @__PURE__ */ k(
        "div",
        {
          className: "flex items-center justify-center gap-3 pl-1.5",
          children: [
            /* @__PURE__ */ d("div", { className: "text-medium text-right text-sm tabular-nums text-f1-foreground-secondary", children: b }),
            /* @__PURE__ */ d("div", { className: "flex flex-1", children: s.map((M) => {
              const _ = g(M, b), N = y(M, b), $ = v(M, b), D = w(M, b), W = Qc(M, b), j = a && An(W.from, a) || o && W.to && Mi(W.to, o);
              return /* @__PURE__ */ k(
                "button",
                {
                  onClick: () => p(M, b),
                  disabled: j,
                  className: E(
                    "relative isolate flex h-10 flex-1 items-center justify-center rounded-md p-2 tabular-nums",
                    "after:absolute after:inset-x-1 after:inset-y-0 after:z-0 after:rounded-md after:ring-1 after:ring-inset after:ring-f1-border-secondary after:transition-all after:duration-100 after:content-['']",
                    j && "cursor-not-allowed text-f1-foreground-secondary",
                    !j && "hover:after:bg-f1-background-hover",
                    Ke(),
                    ($ || D) && "after:inset-x-0",
                    _ && "after:bg-f1-background-selected-bold after:ring-0 hover:after:bg-f1-background-selected-bold-hover [&>span]:text-f1-foreground-inverse",
                    _ && !$ && !D && t === "range" && "rounded-none bg-f1-background-selected after:opacity-0 after:transition-none first:rounded-l-md last:rounded-r-md hover:bg-f1-background-selected [&>span]:text-f1-foreground-selected"
                  ),
                  children: [
                    $ && /* @__PURE__ */ d("div", { className: "absolute inset-y-0 right-0 z-0 w-1/2 bg-f1-background-selected" }),
                    D && /* @__PURE__ */ d("div", { className: "absolute inset-y-0 left-0 z-0 w-1/2 bg-f1-background-selected" }),
                    /* @__PURE__ */ k("span", { className: "z-10 font-medium", children: [
                      "Q",
                      M
                    ] }),
                    N && /* @__PURE__ */ d(
                      "div",
                      {
                        className: E(
                          "absolute inset-x-0 bottom-1 z-20 mx-auto h-0.5 w-1.5 rounded-full bg-f1-background-selected-bold transition-colors duration-100",
                          _ && t === "single" && "bg-f1-background",
                          ($ || D) && "bg-f1-background",
                          !$ && !D && _ && t === "range" && "bg-f1-background-selected-bold"
                        )
                      }
                    )
                  ]
                },
                `${b}-Q${M}`
              );
            }) })
          ]
        },
        b
      ))
    },
    i
  ) });
};
function _l(t) {
  return nl(t, is, vv);
}
const C1 = (t, e) => ({
  from: is(Et(t.from, e * 3)),
  to: vv(Et(t.to, e * 3))
}), EDe = {
  calendarView: "quarter",
  add: C1,
  getPrevNext: (t, e) => {
    const n = _l(t);
    if (!n)
      return { prev: !1, next: !1 };
    const { from: i, to: r } = n, { from: a, to: o } = C1({ from: i, to: r }, -1), { from: s, to: l } = C1({ from: i, to: r }, 1), c = e.min && is(e.min), u = e.max && vv(e.max);
    return {
      prev: Br(a, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) ? { from: s, to: l } : !1
    };
  },
  toRangeString: (t) => tl(t, "'Q'Q yyyy"),
  toRange: (t) => _l(t),
  toString: (t) => bc(t, "'Q'Q yyyy"),
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim(), [s, l] = o.split(/\s+/), c = isNaN(Number(l)) ? (/* @__PURE__ */ new Date()).getFullYear() : +l, u = Number(s.replace(/[qQ\s]/g, ""));
      return new Date(c, (u - 1) * 3, 1);
    };
    return _l({
      from: r(n),
      to: i ? r(i) : void 0
    });
  },
  navigate: (t, e) => is(Et(t, e * 3)),
  navigateUIView: (t, e) => is(zr(t, e * 5)),
  label: (t) => {
    const e = Math.floor(t.getFullYear() / 5) * 5, n = e + 4;
    return `${e} ${md} ${n}`;
  },
  getViewDateFromDate: (t) => is(t),
  render: (t) => {
    const e = _l(t.minDate), n = _l(t.maxDate);
    return /* @__PURE__ */ d(
      DDe,
      {
        mode: t.mode,
        year: t.viewDate.getFullYear(),
        selected: t.selected,
        onSelect: t.onSelect,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
}, P1 = (t, e) => ({
  from: Gi(Ct(t.from, e)),
  to: uc(Ct(t.to, e))
}), TDe = {
  calendarMode: "range",
  ...gg,
  add: P1,
  getPrevNext: (t, e) => {
    const n = Uo(t);
    if (!n)
      return {
        prev: !1,
        next: !1
      };
    const { from: i, to: r } = n, a = H9(r, i) + 1, { from: o, to: s } = P1({ from: i, to: r }, -a), { from: l, to: c } = P1({ from: i, to: r }, a), u = e.min && Gi(e.min), f = e.max && uc(e.max);
    return {
      prev: Br(o, u) ? { from: o, to: s } : !1,
      next: Hr(c, f) ? { from: l, to: c } : !1
    };
  },
  calendarView: "day",
  render: (t) => gg.render({ ...t, mode: "range" })
};
function ODe({
  selected: t,
  onSelect: e,
  month: n,
  onMonthChange: i,
  motionDirection: r = 1,
  minDate: a,
  maxDate: o
}) {
  const { locale: s } = c5(), l = {
    hidden: (m) => ({
      opacity: 0,
      x: m === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (m) => ({
      opacity: 0,
      x: m === 1 ? -40 : 40
    })
  }, c = (m, h) => {
    if (h.selected) {
      e == null || e(null);
      return;
    }
    const p = mn(m, { weekStartsOn: 1 }), g = fd(m, { weekStartsOn: 1 });
    e == null || e({
      from: p,
      to: g
    });
  }, u = t instanceof Date ? {
    from: mn(t, { weekStartsOn: 1 }),
    to: fd(t, { weekStartsOn: 1 })
  } : t || void 0, f = PP({ minDate: a, maxDate: o });
  return /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: r, children: /* @__PURE__ */ d(
    re.div,
    {
      variants: l,
      custom: r,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: /* @__PURE__ */ d(
        _f,
        {
          mode: "range",
          disabled: f,
          selected: u,
          onDayClick: c,
          month: n,
          onMonthChange: i,
          locale: pg(s),
          weekStartsOn: 1,
          showOutsideDays: !0,
          showWeekNumber: !0
        },
        n.toISOString()
      )
    },
    n.toISOString()
  ) });
}
function Ml(t) {
  return nl(t, $i, fc);
}
const S1 = (t, e) => ({
  from: $i(Ct(t.from, e * 7)),
  to: fc(Ct(t.to, e * 7))
}), WDe = {
  calendarView: "week",
  add: S1,
  getPrevNext: (t, e) => {
    const n = Ml(t);
    if (!n)
      return { prev: !1, next: !1 };
    const { from: i, to: r } = n, { from: a, to: o } = S1({ from: i, to: r }, -1), { from: s, to: l } = S1({ from: i, to: r }, 1), c = e.min && $i(e.min), u = e.max && fc(e.max);
    return {
      prev: Br(a, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) ? { from: s, to: l } : !1
    };
  },
  toRangeString: (t) => tl(t, "'W'I yyyy"),
  toRange: (t) => Ml(t),
  toString: (t) => bc(t, "'W'I yyyy"),
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim(), [s, l] = o.split(/\s+/), c = isNaN(Number(l)) ? (/* @__PURE__ */ new Date()).getFullYear() : +l, u = Number(s.replace(/[wW\s]/g, ""));
      return lf(`${u}`, "I", (/* @__PURE__ */ new Date()).setFullYear(c));
    };
    return Ml({
      from: r(n),
      to: i ? r(i) : void 0
    });
  },
  getViewDateFromDate: (t) => ut(t),
  navigate: (t, e) => Ct(t, e * 7),
  navigateUIView: (t, e) => Et(t, e),
  label: (t) => new Intl.DateTimeFormat("en-US", {
    month: "long",
    year: "numeric"
  }).format(t),
  render: (t) => {
    const e = Ml(t.minDate), n = Ml(t.maxDate);
    return /* @__PURE__ */ d(
      ODe,
      {
        selected: t.selected,
        onSelect: t.onSelect,
        month: t.month,
        onMonthChange: t.onMonthChange,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
};
function ADe({
  mode: t,
  selected: e,
  onSelect: n,
  decade: i,
  motionDirection: r = 1,
  minDate: a,
  maxDate: o
}) {
  const s = /* @__PURE__ */ new Date(), l = (w) => !!(w && typeof w == "object" && ("from" in w || "to" in w)), c = Math.floor(i / 10) * 10, u = [
    c - 1,
    ...Array.from({ length: 10 }, (w, x) => c + x),
    c + 10
  ], f = (w) => {
    const x = new Date(w, 0, 1);
    if (t === "single")
      n == null || n({
        from: ki(x),
        to: la(x)
      });
    else if (t === "range")
      if (!e || !l(e))
        n == null || n({
          from: x,
          to: void 0
        });
      else if (e && e.from && !e.to)
        if (J9(e.from, x))
          n == null || n({
            from: ki(e.from),
            to: la(e.from)
          });
        else {
          const b = An(e.from, x) ? e.from : x, M = An(e.from, x) ? x : e.from;
          n == null || n({
            from: ki(b),
            to: la(M)
          });
        }
      else
        n == null || n({
          from: x,
          to: void 0
        });
  }, m = (w) => {
    if (!e) return !1;
    if (l(e)) {
      if (e.from && e.to) {
        const x = new Date(w, 6, 1);
        return ks(x, {
          start: e.from,
          end: e.to
        });
      } else if (e.from)
        return e.from.getFullYear() === w;
    } else
      return e.getFullYear() === w;
    return !1;
  }, h = (w) => w === s.getFullYear(), p = (w) => !e || !l(e) || !e.from ? !1 : e.from.getFullYear() === w, g = (w) => !e || !l(e) || !e.to ? !1 : e.to.getFullYear() === w, y = (w) => w < c || w >= c + 10, v = {
    hidden: (w) => ({
      opacity: 0,
      x: w === 1 ? 40 : -40
    }),
    visible: { opacity: 1, x: 0 },
    exit: (w) => ({
      opacity: 0,
      x: w === 1 ? -40 : 40
    })
  };
  return /* @__PURE__ */ d(Ue, { mode: "popLayout", initial: !1, custom: r, children: /* @__PURE__ */ d(
    re.div,
    {
      className: "grid grid-cols-4 gap-y-3",
      custom: r,
      variants: v,
      initial: "hidden",
      animate: "visible",
      exit: "exit",
      transition: { duration: 0.15, ease: [0.455, 0.03, 0.515, 0.955] },
      children: u.map((w) => {
        const x = m(w), b = p(w), M = g(w), _ = y(w), N = h(w), $ = new Date(w, 0, 1), D = a && An(ki($), a) || o && Mi(la($), o);
        return /* @__PURE__ */ k(
          "button",
          {
            onClick: () => f(w),
            disabled: D,
            className: E(
              "relative isolate flex h-10 items-center justify-center rounded-md font-medium text-f1-foreground transition-colors duration-100 after:absolute after:inset-0 after:z-0 after:rounded-md after:bg-f1-background-selected-bold after:opacity-0 after:transition-all after:duration-100 after:content-['']",
              !D && "hover:bg-f1-background-hover hover:after:bg-f1-background-selected-bold-hover",
              D && "cursor-not-allowed text-f1-foreground-secondary",
              Ke(),
              _ && "[&>span]:font-normal [&>span]:text-f1-foreground-secondary",
              x && t === "single" && "bg-f1-background-selected-bold after:opacity-100 hover:bg-f1-background-selected-bold-hover [&>span]:z-10 [&>span]:text-f1-foreground-inverse [&>span]:opacity-100",
              x && t === "range" && "rounded-none bg-f1-background-selected hover:bg-f1-background-selected [&:nth-child(4n+1)]:rounded-s-md [&:nth-child(4n+4)]:rounded-e-md [&>span]:text-f1-foreground-selected [&>span]:opacity-100",
              (b || M) && t === "range" && "rounded-none bg-f1-background-selected after:opacity-100 [&>span]:z-10 [&>span]:text-f1-foreground-inverse [&>span]:opacity-100",
              b && t === "range" && M && "rounded-s-md",
              M && t === "range" && "rounded-e-md"
            ),
            children: [
              /* @__PURE__ */ d("span", { children: w }),
              N && /* @__PURE__ */ d(
                "div",
                {
                  className: E(
                    "absolute inset-x-0 bottom-1 z-20 mx-auto h-0.5 w-1.5 rounded-full bg-f1-background-selected-bold transition-colors duration-100",
                    x && t === "single" && "bg-f1-background",
                    (b || M) && "bg-f1-background",
                    !b && !M && x && t === "range" && "bg-f1-background-selected-bold"
                  )
                }
              )
            ]
          },
          w
        );
      })
    },
    i
  ) });
}
function Cl(t) {
  return nl(t, ki, la);
}
const N1 = (t, e) => ({
  from: ki(zr(t.from, e)),
  to: la(zr(t.to, e))
}), LDe = {
  calendarView: "year",
  add: N1,
  getPrevNext: (t, e) => {
    const n = Cl(t);
    if (!n)
      return { prev: !1, next: !1 };
    const { from: i, to: r } = n, { from: a, to: o } = N1({ from: i, to: r }, -1), { from: s, to: l } = N1({ from: i, to: r }, 1), c = e.min && ki(e.min), u = e.max && la(e.max);
    return {
      prev: Br(a, c) && Br(o, c) ? { from: a, to: o } : !1,
      next: Hr(l, u) && Hr(s, u) ? { from: s, to: l } : !1
    };
  },
  toRange: (t) => Cl(t),
  toRangeString: (t) => tl(t, "yyyy"),
  toString: (t) => bc(t, "yyyy"),
  fromString: (t) => {
    const e = el(t);
    if (!e)
      return null;
    const { from: n, to: i } = e, r = (a) => {
      const o = a.trim();
      return lf(o, "yyyy", /* @__PURE__ */ new Date());
    };
    return Cl({
      from: r(n),
      to: i ? r(i) : void 0
    });
  },
  getViewDateFromDate: (t) => ki(t),
  navigate: (t, e) => zr(t, e),
  navigateUIView: (t, e) => zr(t, e * 10),
  label: (t) => {
    const e = t.getFullYear() - t.getFullYear() % 10, n = e + 9;
    return `${e} ${md} ${n}`;
  },
  render: (t) => {
    const e = Cl(t.minDate), n = Cl(t.maxDate);
    return /* @__PURE__ */ d(
      ADe,
      {
        mode: t.mode,
        decade: t.viewDate.getFullYear(),
        selected: t.selected,
        onSelect: t.onSelect,
        motionDirection: t.motionDirection,
        minDate: e ? e.from : void 0,
        maxDate: n ? n.to : void 0
      }
    );
  }
}, _t = {
  day: gg,
  week: WDe,
  month: NDe,
  quarter: EDe,
  halfyear: PDe,
  year: LDe,
  range: TDe
}, IDe = (t) => {
  const e = _t[t];
  if (!e)
    throw new Error(
      `Granularity simple definition for view ${t} not found`
    );
  return {
    toRangeString: e.toRangeString,
    toString: e.toString
  };
}, RDe = (t) => {
  const e = _t[t];
  if (!e)
    throw new Error(`Granularity definition ${t} not found`);
  return e;
};
function IP({
  mode: t = "single",
  view: e = "month",
  onSelect: n,
  defaultMonth: i = /* @__PURE__ */ new Date(),
  defaultSelected: r = null,
  showNavigation: a = !0,
  showInput: o = !1,
  minDate: s,
  maxDate: l
}) {
  const c = et(), [u, f] = q(i), [m, h] = q(
    r
  ), [p, g] = q(1), y = ve(() => _t[e], [e]), v = Le(
    (O) => {
      h(O), _(y.toRangeString(O));
      const I = y.getViewDateFromDate(
        O instanceof Date ? O : (O == null ? void 0 : O.from) || (O == null ? void 0 : O.to) || /* @__PURE__ */ new Date()
      );
      I !== y.getViewDateFromDate(u) && f(I);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- only needs to be rebuilt when the granularity changes
    [y]
  );
  le(() => {
    v(r);
  }, [r, v]), le(() => {
  }, [r, v]);
  const w = (O) => {
    const I = y.navigateUIView(u, O);
    g(O), f(I);
  }, x = () => y.label(u), b = (O) => {
    O && (O = y.toRange(O), v(O), n == null || n(O));
  }, [M, _] = q({
    from: "",
    to: ""
  }), [N, $] = q({
    from: !1,
    to: !1
  }), D = (O) => {
    W(O, M);
  }, W = (O, I) => {
    const L = y.fromString(I), R = L && L[O] && !T2(L[O]);
    $((B) => ({
      ...B,
      [O]: R
    })), R || v(L);
  };
  le(() => {
    const O = y0(m), { from: I, to: L } = y.toRangeString(
      O || { from: /* @__PURE__ */ new Date(), to: void 0 }
    );
    _({
      from: I || "",
      to: L || ""
    });
  }, [y, m]);
  const j = (O, I) => {
    const L = M[O] ? y.fromString(M[O]) : void 0, R = L ? y.navigate(L.from, I) : void 0;
    if (T2(R)) {
      const B = {
        ...M,
        [O]: y.toRangeString(R).from
      };
      _(B), W(O, B);
    }
  };
  return /* @__PURE__ */ k("div", { className: "flex flex-col", children: [
    o && /* @__PURE__ */ k("div", { className: "mb-2 flex gap-2", children: [
      /* @__PURE__ */ d(
        Fr,
        {
          error: !!N.from,
          value: M.from,
          placeholder: t === "range" ? c.date.from : c.date.date,
          onBlur: () => D("from"),
          onKeyDown: (O) => {
            O.key === "Enter" && D("from"), (O.key === "ArrowUp" || O.key === "ArrowDown") && (O.preventDefault(), j("from", O.key === "ArrowDown" ? -1 : 1));
          },
          onChange: (O) => _({ ...M, from: O.target.value })
        }
      ),
      t === "range" && /* @__PURE__ */ d(
        Fr,
        {
          error: !!N.to,
          value: M.to,
          placeholder: c.date.to,
          onBlur: () => D("to"),
          onKeyDown: (O) => {
            O.key === "Enter" && D("to"), (O.key === "ArrowUp" || O.key === "ArrowDown") && (O.preventDefault(), j("to", O.key === "ArrowDown" ? -1 : 1));
          },
          onChange: (O) => _({ ...M, to: O.target.value })
        }
      )
    ] }),
    a && /* @__PURE__ */ k("div", { className: "flex items-center justify-between pb-3", children: [
      /* @__PURE__ */ d("div", { className: "text-lg font-medium text-f1-foreground", children: x() }),
      /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ d(
          ue,
          {
            onClick: () => w(-1),
            variant: "outline",
            label: c.navigation.previous,
            hideLabel: !0,
            round: !0,
            icon: qd,
            size: "sm"
          }
        ),
        /* @__PURE__ */ d(
          ue,
          {
            onClick: () => w(1),
            variant: "outline",
            label: c.navigation.next,
            hideLabel: !0,
            round: !0,
            icon: Oa,
            size: "sm"
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ d("div", { className: "relative", children: y.render({
      mode: t,
      selected: m,
      onSelect: b,
      month: u,
      onMonthChange: f,
      motionDirection: p,
      setViewDate: f,
      viewDate: u,
      minDate: s,
      maxDate: l
    }) })
  ] });
}
function Ps({
  title: t,
  onCheckedChange: e,
  id: n,
  disabled: i,
  indeterminate: r = !1,
  checked: a = !1,
  value: o,
  hideLabel: s = !1,
  presentational: l = !1,
  stopPropagation: c = !1,
  ...u
}) {
  return /* @__PURE__ */ d(
    Ys,
    {
      title: t,
      onCheckedChange: e,
      id: n,
      disabled: i,
      indeterminate: r,
      checked: a,
      value: o,
      hideLabel: s,
      tabIndex: l ? -1 : void 0,
      onClick: (f) => c && f.stopPropagation(),
      ...u
    }
  );
}
function jDe({ metadata: t }) {
  return /* @__PURE__ */ k("div", { className: "flex h-8 items-center gap-1.5 font-medium", children: [
    /* @__PURE__ */ d(me, { icon: t.icon, className: "text-f1-icon", size: "md" }),
    t.type === "text" && /* @__PURE__ */ d("div", { className: "text-f1-foreground", children: t.title }),
    t.type === "avatarList" && /* @__PURE__ */ d(
      Js,
      {
        avatars: t.avatars,
        max: t.max,
        size: "xsmall"
      }
    ),
    t.type === "status" && /* @__PURE__ */ d(Vr, { text: t.label, variant: t.status }),
    t.type === "user" && /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ d(
        ti,
        {
          size: "xsmall",
          firstName: t.firstName,
          lastName: t.lastName,
          src: t.src
        }
      ),
      /* @__PURE__ */ k("span", { className: "text-f1-foreground", children: [
        t.firstName,
        " ",
        t.lastName
      ] })
    ] }),
    t.type === "company" && /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ d(
        ac,
        {
          name: t.name,
          src: t.src,
          size: "xsmall"
        }
      ),
      /* @__PURE__ */ d("span", { className: "text-f1-foreground", children: t.name })
    ] }),
    t.type === "team" && /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
      /* @__PURE__ */ d(Fm, { name: t.name, src: t.src, size: "xsmall" }),
      /* @__PURE__ */ d("span", { className: "text-f1-foreground", children: t.name })
    ] }),
    t.type === "tag" && /* @__PURE__ */ d(Ni, { text: t.label, icon: t.tagIcon })
  ] });
}
function FDe({
  avatar: t,
  title: e,
  description: n,
  metadata: i,
  children: r,
  link: a,
  primaryAction: o,
  secondaryActions: s,
  otherActions: l,
  selectable: c = !1,
  selected: u = !1,
  onSelect: f,
  onClick: m
}) {
  const h = o || s && (s == null ? void 0 : s.length) > 0, p = l && l.length > 0, [g, y] = q(!1);
  return /* @__PURE__ */ k(
    Xd,
    {
      className: E(
        "group relative bg-f1-background shadow-none transition-all",
        (c || p) && !u && "hover:border-f1-border",
        a && "focus-within:border-f1-border-hover focus-within:shadow-md hover:border-f1-border-hover hover:shadow-md",
        u && "border-f1-border-selected bg-f1-background-selected-secondary"
      ),
      onClick: m,
      children: [
        a && /* @__PURE__ */ d(
          ns,
          {
            href: a,
            style: {
              zIndex: 1
            },
            className: E("z-1 absolute inset-0 block rounded-xl", Ke()),
            "aria-label": e
          }
        ),
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-2.5", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-row items-start justify-between gap-1", children: [
            /* @__PURE__ */ k(Yd, { className: "flex-col gap-0.5 p-0", children: [
              t && /* @__PURE__ */ d("div", { className: "mb-1.5 flex h-fit w-fit", children: /* @__PURE__ */ d(ni, { avatar: t, size: "medium" }) }),
              /* @__PURE__ */ d(Kd, { className: "flex flex-row justify-between gap-1 text-lg font-semibold text-f1-foreground", children: e }),
              n && /* @__PURE__ */ d(Ty, { className: "line-clamp-3 text-base text-f1-foreground-secondary", children: n })
            ] }),
            (p || c) && /* @__PURE__ */ k("div", { className: E("flex flex-row gap-2 [&>div]:z-[1]"), children: [
              p && /* @__PURE__ */ d(
                "div",
                {
                  className: E(
                    "flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100",
                    "focus-within:opacity-100",
                    g && "opacity-100"
                  ),
                  children: /* @__PURE__ */ d(
                    In,
                    {
                      items: l,
                      open: g,
                      onOpenChange: y,
                      children: /* @__PURE__ */ d(
                        "button",
                        {
                          className: E(
                            "flex h-6 w-6 items-center justify-center rounded-sm transition-colors hover:bg-f1-background-secondary",
                            g && "bg-f1-background-secondary",
                            Ke()
                          ),
                          "aria-label": "Other actions",
                          children: /* @__PURE__ */ d(me, { icon: Ma, size: "sm" })
                        }
                      )
                    }
                  )
                }
              ),
              c && /* @__PURE__ */ d(
                "div",
                {
                  className: E(
                    "flex items-center justify-center opacity-0 transition-opacity group-hover:opacity-100",
                    "focus-within:opacity-100",
                    u && "opacity-100",
                    g && "opacity-100"
                  ),
                  children: /* @__PURE__ */ d(
                    Ps,
                    {
                      title: e,
                      checked: u,
                      onCheckedChange: f,
                      hideLabel: !0
                    }
                  )
                }
              )
            ] })
          ] }),
          /* @__PURE__ */ k(Ud, { children: [
            i && /* @__PURE__ */ d("div", { className: "flex flex-col gap-0.5", children: i.map((v, w) => /* @__PURE__ */ d(jDe, { metadata: v }, w)) }),
            r
          ] })
        ] }),
        h && /* @__PURE__ */ k(
          u5,
          {
            className: E(
              "justify-between gap-2 [&>div]:z-[1]",
              "relative -mx-4 mt-4 border-0 border-t border-solid border-t-f1-border-secondary px-4 pt-4"
            ),
            children: [
              s && /* @__PURE__ */ d("div", { className: "flex gap-2", children: s.map((v, w) => /* @__PURE__ */ d(
                ue,
                {
                  label: v.label,
                  icon: v.icon,
                  hideLabel: w > 0,
                  round: w > 0,
                  variant: "outline",
                  onClick: v.onClick
                },
                w
              )) }),
              o && /* @__PURE__ */ d(
                ue,
                {
                  label: o.label,
                  icon: o.icon,
                  onClick: o.onClick
                }
              )
            ]
          }
        )
      ]
    }
  );
}
function RP({
  title: t,
  description: e,
  variant: n = "default",
  emoji: i,
  actions: r
}) {
  return /* @__PURE__ */ k("div", { className: "flex flex-col items-center justify-center gap-5 p-8", children: [
    n === "default" && /* @__PURE__ */ d($v, { emoji: i, size: "lg" }),
    n !== "default" && /* @__PURE__ */ d(Gd, { type: n, size: "lg" }),
    /* @__PURE__ */ k("div", { className: "flex flex-col items-center justify-center gap-0.5", children: [
      /* @__PURE__ */ d("p", { className: "text-center text-lg font-medium text-f1-foreground", children: t }),
      e && /* @__PURE__ */ d("p", { className: "max-w-96 text-center text-f1-foreground-secondary", children: e })
    ] }),
    r && /* @__PURE__ */ d("div", { className: "flex w-full flex-col items-center justify-center gap-2 sm:w-fit sm:flex-row sm:gap-3 [&>div]:w-full", children: r.map((a) => a.type === "upsell" ? /* @__PURE__ */ d(
      cD,
      {
        label: a.label,
        onRequest: () => Promise.resolve(a.onClick()),
        errorMessage: a.errorMessage,
        successMessage: a.successMessage,
        loadingState: a.loadingState,
        nextSteps: a.nextSteps,
        closeLabel: a.closeLabel
      },
      a.label
    ) : /* @__PURE__ */ d(
      ue,
      {
        label: a.label,
        variant: a.variant,
        onClick: a.onClick,
        icon: a.icon
      },
      a.label
    )) })
  ] });
}
const zDe = ({
  isOpen: t,
  primaryActions: e,
  secondaryActions: n = [],
  selectedNumber: i = void 0,
  onUnselect: r
}) => {
  const a = et(), o = i === 1 ? a.status.selected.singular : a.status.selected.plural, s = n.slice(0, 2), l = n.slice(2).map((c) => ({
    ...c,
    critical: c.critical || !1
  }));
  return /* @__PURE__ */ d(Ue, { children: t && /* @__PURE__ */ k(
    re.div,
    {
      initial: { opacity: 0, y: 32, filter: "blur(6px)" },
      animate: { opacity: 1, y: 0, filter: "blur(0px)" },
      exit: { opacity: 0, y: 32, filter: "blur(6px)" },
      transition: { ease: [0.175, 0.885, 0.32, 1.275], duration: 0.3 },
      className: "fixed bottom-2 left-2 right-2 z-50 flex h-fit w-[calc(100%-16px)] flex-col gap-2 rounded-xl bg-f1-background-inverse p-2 text-f1-foreground-inverse shadow-lg backdrop-blur-sm dark:bg-f1-background-inverse-secondary sm:bottom-5 sm:mx-auto sm:h-12 sm:w-max sm:flex-row sm:gap-8",
      children: [
        i && /* @__PURE__ */ k("div", { className: "dark flex h-8 w-full items-center justify-between gap-2 px-2 sm:h-auto sm:w-fit sm:justify-start sm:pl-2 sm:pr-0", children: [
          /* @__PURE__ */ k("span", { className: "font-medium tabular-nums", children: [
            /* @__PURE__ */ d(
              Lv,
              {
                value: i,
                spinTiming: {
                  duration: 200,
                  easing: "cubic-bezier(0.175, 0.885, 0.32, 1.275)"
                }
              }
            ),
            /* @__PURE__ */ k("span", { children: [
              " ",
              o
            ] })
          ] }),
          /* @__PURE__ */ d(
            ue,
            {
              variant: "outline",
              size: "sm",
              label: a.actions.unselect,
              onClick: r
            }
          )
        ] }),
        /* @__PURE__ */ k("div", { className: "dark", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-col items-center gap-2 sm:hidden [&_button]:w-full [&_div]:w-full", children: [
            /* @__PURE__ */ d(Fv, { items: n }),
            e.length > 1 ? /* @__PURE__ */ d(
              ws,
              {
                items: e.map((c) => ({
                  value: c.label,
                  label: c.label,
                  icon: c.icon,
                  critical: c.critical
                })),
                onClick: (c) => {
                  var f;
                  const u = e.find((m) => m.label === c);
                  (f = u == null ? void 0 : u.onClick) == null || f.call(u);
                },
                size: "lg"
              }
            ) : e.length === 1 ? /* @__PURE__ */ d(
              ue,
              {
                label: e[0].label,
                icon: e[0].icon,
                onClick: e[0].onClick,
                disabled: e[0].disabled,
                size: "lg"
              }
            ) : null
          ] }),
          /* @__PURE__ */ k("div", { className: "hidden items-center gap-2 sm:flex", children: [
            l.length > 0 && /* @__PURE__ */ d(In, { items: l }),
            s.slice().reverse().map((c) => /* @__PURE__ */ d(
              ue,
              {
                variant: c.critical ? "critical" : "outline",
                label: c.label,
                icon: c.icon,
                onClick: c.onClick,
                disabled: c.disabled
              },
              c.label
            )),
            e.length > 1 ? /* @__PURE__ */ d(
              ws,
              {
                items: e.map((c) => ({
                  value: c.label,
                  label: c.label,
                  icon: c.icon,
                  critical: c.critical
                })),
                onClick: (c) => {
                  var f;
                  const u = e.find((m) => m.label === c);
                  (f = u == null ? void 0 : u.onClick) == null || f.call(u);
                }
              }
            ) : e.length === 1 ? /* @__PURE__ */ d(
              ue,
              {
                label: e[0].label,
                icon: e[0].icon,
                onClick: e[0].onClick,
                disabled: e[0].disabled
              }
            ) : null
          ] })
        ] })
      ]
    }
  ) });
}, VDe = 2, HDe = (t) => t ? typeof t == "function" ? t() || [] : "actions" in t ? t.actions() || [] : [] : [], BDe = ({
  primaryActions: t,
  secondaryActions: e,
  otherActions: n
}) => {
  const i = t && [t] || [], r = (e || []).filter(
    (l) => l.type !== "separator"
  ), a = n || [], [o, s] = q(!1);
  return i.length === 0 && r.length === 0 && a.length === 0 ? null : /* @__PURE__ */ k("div", { className: "flex flex-row-reverse items-center gap-2", children: [
    i.map((l) => /* @__PURE__ */ d(
      ue,
      {
        size: "md",
        onClick: l.onClick,
        icon: l.icon,
        variant: "default",
        label: l.label
      },
      l.label
    )),
    r == null ? void 0 : r.map((l) => /* @__PURE__ */ d(
      ue,
      {
        size: "md",
        onClick: l.onClick,
        icon: l.icon,
        variant: "outline",
        hideLabel: l.hideLabelWhenExpanded,
        label: l.label
      },
      l.label
    )),
    a.length > 0 && /* @__PURE__ */ d(
      In,
      {
        items: a,
        align: "end",
        open: o,
        onOpenChange: s,
        children: /* @__PURE__ */ d(
          ue,
          {
            variant: "outline",
            icon: Tm,
            label: "Actions",
            hideLabel: !0,
            pressed: o
          }
        )
      }
    )
  ] });
};
function F2(t, e) {
  return {
    ...e,
    ...t
  };
}
const Ss = (t) => {
  const e = ZDe[t];
  if (!e)
    throw new Error(`Filter type ${t.toString()} not found`);
  return e;
};
function qDe({
  value: t,
  onChange: e,
  schema: n
}) {
  const i = {
    mode: "single",
    view: "day",
    ...n.options
  }, r = () => {
    e(void 0);
  };
  return /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d("div", { className: "space-y-4 overflow-x-hidden p-3", children: /* @__PURE__ */ d(
      IP,
      {
        defaultSelected: t || i.defaultSelected,
        onSelect: (a) => e(a ?? void 0),
        view: i.view,
        mode: i.mode,
        showInput: !0
      }
    ) }),
    /* @__PURE__ */ d("div", { className: "sticky bottom-0 left-0 right-0 z-20 flex items-center justify-end gap-2 border border-solid border-transparent border-t-f1-border-secondary bg-f1-background/80 p-2 backdrop-blur-[8px]", children: /* @__PURE__ */ d(
      ue,
      {
        variant: "ghost",
        label: "Clear",
        onClick: () => r(),
        disabled: !t,
        size: "sm"
      }
    ) })
  ] });
}
const GDe = (t, e) => !t || "from" in t && !t.from && e.schema.options.mode === "single" || "from" in t && !t.from && !t.to && e.schema.options.mode === "range", z2 = {
  mode: "single",
  view: "day"
}, XDe = {
  emptyValue: void 0,
  render: (t) => {
    const e = F2(t.schema.options, z2);
    return /* @__PURE__ */ d(qDe, { ...t, schema: { ...t.schema, options: e } });
  },
  isEmpty: GDe,
  chipLabel: (t, e) => {
    const n = F2(e.schema.options, z2);
    return IDe(n.view).toString(t);
  }
}, Cu = /* @__PURE__ */ new Map();
function jP(t) {
  return JSON.stringify(t);
}
async function FP(t, e, n = !1) {
  if (n && Cu.has(t))
    return Cu.get(t);
  const r = await (typeof e == "function" ? e : () => e)();
  return Cu.set(t, r), r;
}
function YDe(t) {
  const e = jP(t), [n, i] = q([]), [r, a] = q(!1), [o, s] = q(null), l = Le(
    async (c = !1) => {
      c && Cu.delete(e);
      try {
        a(!0), s(null);
        const u = await FP(
          e,
          t.options.options,
          t.options.cache
        );
        i(u);
      } catch (u) {
        s(
          u instanceof Error ? u : new Error("Failed to load options")
        );
      } finally {
        a(!1);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we are checking the schema values
    [JSON.stringify(t), e]
  );
  return le(() => {
    l();
  }, [l]), {
    options: n,
    isLoading: r,
    error: o,
    setOptions: i,
    loadOptions: l
  };
}
function KDe({
  schema: t,
  value: e,
  onChange: n
}) {
  const i = et(), [r, a] = q(""), { options: o, isLoading: s, error: l, loadOptions: c } = YDe({
    ...t,
    type: "in"
  });
  le(() => {
    a("");
  }, [t]);
  const u = ve(() => o.filter(
    (p) => p.label.toLowerCase().includes(r.toLowerCase())
  ), [o, r]);
  if (s)
    return /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-center py-4", children: /* @__PURE__ */ d(pc, { size: "small" }) });
  if (l)
    return /* @__PURE__ */ k("div", { className: "text-f1-foreground-destructive flex w-full flex-col items-center justify-center gap-2 py-4", children: [
      /* @__PURE__ */ d("p", { className: "text-sm", children: i.collections.filters.failedToLoadOptions }),
      /* @__PURE__ */ d(
        "button",
        {
          className: E(
            "text-f1-foreground-primary text-xs underline",
            Ke()
          ),
          onClick: () => {
            c(!0);
          },
          children: i.collections.filters.retry
        }
      )
    ] });
  if (o.length === 0)
    return /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-center py-4 text-sm text-f1-foreground-secondary", children: "No options available" });
  const f = o.length > 0 && !s, m = () => {
    const p = u.map((v) => v.value), y = [...e ?? []];
    p.forEach((v) => {
      y.includes(v) || y.push(v);
    }), n(y);
  }, h = () => {
    n([]);
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: "flex min-h-full w-full flex-col",
      role: "group",
      "aria-label": t.label,
      children: [
        f && /* @__PURE__ */ d("div", { className: "sticky left-0 right-0 top-0 rounded-tr-xl p-2 backdrop-blur-[8px]", children: /* @__PURE__ */ d(
          Fr,
          {
            type: "search",
            placeholder: "Search...",
            value: r,
            onChange: (p) => a(p.target.value),
            icon: Om,
            clearable: !0
          }
        ) }),
        /* @__PURE__ */ d("div", { className: "flex-1 overflow-y-auto px-2", children: u.map((p) => {
          const g = e.includes(p.value), y = `option-${String(p.value)}`;
          return /* @__PURE__ */ k(
            "div",
            {
              className: E(
                "flex w-full flex-1 cursor-pointer appearance-none items-center justify-between gap-1 rounded p-2 font-medium transition-colors hover:bg-f1-background-secondary",
                Ke()
              ),
              onClick: () => {
                n(
                  g ? e.filter((v) => v !== p.value) : [...e, p.value]
                );
              },
              children: [
                /* @__PURE__ */ d("span", { className: "max-w-[250px] flex-1 whitespace-nowrap", children: /* @__PURE__ */ d(Cs, { children: p.label }) }),
                /* @__PURE__ */ d(
                  Ps,
                  {
                    id: y,
                    title: p.label,
                    checked: g,
                    presentational: !0,
                    hideLabel: !0
                  }
                )
              ]
            },
            String(p.value)
          );
        }) }),
        /* @__PURE__ */ k("div", { className: "sticky bottom-0 left-0 right-0 flex items-center justify-between gap-2 border border-solid border-transparent border-t-f1-border-secondary bg-f1-background/80 p-2 backdrop-blur-[8px]", children: [
          /* @__PURE__ */ d(
            ue,
            {
              variant: "outline",
              label: "Select all",
              onClick: m,
              disabled: u.length === 0 || Array.isArray(e) && e.length === u.length,
              size: "sm"
            }
          ),
          /* @__PURE__ */ d(
            ue,
            {
              variant: "ghost",
              label: "Clear",
              onClick: h,
              disabled: !Array.isArray(e) || e.length === 0,
              size: "sm"
            }
          )
        ] })
      ]
    }
  );
}
const UDe = {
  emptyValue: [],
  isEmpty: (t) => (t || []).length === 0,
  render: (t) => /* @__PURE__ */ d(KDe, { ...t }),
  chipLabel: async (t, { schema: e }) => {
    const n = jP(e), i = await FP(
      n,
      e.options.options,
      e.options.cache
    ), r = t.map((l) => {
      const c = i.find((u) => u.value === l);
      return (c == null ? void 0 : c.label) ?? String(l);
    }), a = r[0], o = r.length - 1;
    return o > 0 ? `${a} +${o}` : `${a}`;
  }
};
function JDe({
  schema: t,
  value: e,
  onChange: n
}) {
  return /* @__PURE__ */ d("div", { className: "space-y-4 p-3", children: /* @__PURE__ */ d(
    Fr,
    {
      placeholder: `Search ${t.label.toLowerCase()}...`,
      value: e,
      onChange: (i) => n(i.target.value)
    }
  ) });
}
const QDe = {
  emptyValue: "",
  render: (t) => /* @__PURE__ */ d(JDe, { ...t }),
  isEmpty: (t) => (t ?? "").trim() === "",
  chipLabel: (t) => t
}, ZDe = {
  in: UDe,
  search: QDe,
  date: XDe
}, eEe = It({
  base: "flex items-center gap-1 rounded-full border border-solid border-f1-border px-2 py-0.5 font-medium",
  variants: {
    variant: {
      default: "",
      selected: "border-f1-border-selected bg-f1-background-selected-secondary text-f1-foreground-selected"
    }
  },
  defaultVariants: {
    variant: "default"
  }
}), tEe = ({
  label: t,
  variant: e,
  onClick: n,
  onClose: i,
  avatar: r,
  icon: a
}) => /* @__PURE__ */ k(
  "div",
  {
    className: E(
      eEe({ variant: e }),
      i && "pr-1.5",
      r && "pl-0.5",
      r && (r == null ? void 0 : r.type) !== "person" && "rounded-sm",
      a && !r && "pl-1.5",
      n && "cursor-pointer",
      n && Ke()
    ),
    onClick: n,
    onKeyDown: (o) => {
      (o.key === "Enter" || o.key === " ") && (n == null || n());
    },
    tabIndex: n ? 0 : void 0,
    children: [
      r && /* @__PURE__ */ d(ni, { avatar: r, size: "xsmall" }),
      /* @__PURE__ */ k("div", { className: "flex items-center gap-0.5", children: [
        a && /* @__PURE__ */ d(me, { icon: a, size: "sm", className: "text-f1-icon" }),
        t
      ] }),
      i && /* @__PURE__ */ d(
        "button",
        {
          type: "button",
          onClick: (o) => {
            o.stopPropagation(), i();
          },
          className: E(
            "-m-1 flex h-6 w-6 cursor-pointer items-center justify-center rounded-full [&_svg]:text-f1-icon-secondary [&_svg]:transition-colors [&_svg]:hover:text-f1-icon [&_svg]:focus:text-f1-icon",
            e === "selected" && "[&_svg]:text-f1-icon-selected [&_svg]:hover:text-f1-icon-selected-hover [&_svg]:focus:text-f1-icon-selected-hover",
            Ke()
          ),
          tabIndex: 0,
          "aria-label": "Close",
          children: /* @__PURE__ */ d(me, { icon: vs, size: "sm" })
        }
      )
    ]
  }
);
function nEe({
  filter: t,
  value: e,
  onSelect: n,
  onRemove: i
}) {
  const [r, a] = q(!0), o = Ss(t.type), [s, l] = q("");
  return le(() => {
    (async () => {
      if (e === void 0)
        return;
      a(!0);
      const u = o.chipLabel, f = await u(e, { schema: t });
      l(`${t.label}: ${f}`), a(!1);
    })();
  }, [e, o, t]), /* @__PURE__ */ d(
    re.div,
    {
      layout: !0,
      initial: { opacity: 0, scale: 0.8 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.8 },
      transition: { type: "spring", duration: 0.2 },
      children: r ? /* @__PURE__ */ d(Ce, { className: "h-5 w-[100px]" }) : /* @__PURE__ */ d(
        tEe,
        {
          variant: "selected",
          label: s,
          onClose: i,
          onClick: n
        }
      )
    }
  );
}
function iEe({
  schema: t,
  filters: e,
  onFilterSelect: n,
  onFilterRemove: i,
  onClearAll: r
}) {
  const a = et(), o = Object.keys(e).filter((s) => {
    const l = e[s];
    return t[s].type === "in" && Array.isArray(l) && l.length > 0 || !!l;
  });
  return o.length === 0 ? null : /* @__PURE__ */ k("div", { className: "mt-2 flex items-start justify-between gap-2", children: [
    /* @__PURE__ */ d("div", { className: "flex flex-wrap items-center gap-2", children: /* @__PURE__ */ d(Ue, { presenceAffectsLayout: !0, initial: !1, children: o.map((s) => {
      const l = t[s];
      if (!e[s])
        return null;
      const c = e[s];
      return Ss(l.type).isEmpty(c, {
        schema: l
      }) ? null : /* @__PURE__ */ d(
        nEe,
        {
          filter: l,
          value: c,
          onSelect: () => n(s),
          onRemove: () => i(s)
        },
        `filter-${String(s)}`
      );
    }) }) }),
    /* @__PURE__ */ d(
      ue,
      {
        variant: "ghost",
        label: a.actions.clear,
        size: "sm",
        onClick: r
      }
    )
  ] });
}
function rEe({
  selectedFilterKey: t,
  definition: e,
  tempFilters: n,
  onFilterChange: i
}) {
  if (!t) return null;
  const r = e[t], a = Ss(r.type);
  if (!a)
    throw new Error(`Filter type ${r.type} not found`);
  const o = n[t] || a.emptyValue;
  function s(l, c, u) {
    return Ss(l.type).render({ schema: l, value: c, onChange: u });
  }
  return /* @__PURE__ */ d("div", { className: "relative flex w-full flex-col gap-1", children: /* @__PURE__ */ d("div", { className: "relative flex h-full flex-col justify-between overflow-y-auto", children: s(
    r,
    o,
    (l) => i(t, l)
  ) }) });
}
function aEe({
  definition: t,
  tempFilters: e,
  selectedFilterKey: n,
  onFilterSelect: i
}) {
  return /* @__PURE__ */ d("div", { className: "w-[224px] shrink-0 border border-solid border-transparent border-r-f1-border-secondary", children: /* @__PURE__ */ d("div", { className: "flex h-full w-full flex-col gap-1 overflow-y-auto p-2", children: Object.entries(t).map(([r, a]) => {
    const o = Ss(a.type), s = e[r], l = o;
    return /* @__PURE__ */ d(
      "button",
      {
        className: E(
          "group relative flex w-full appearance-none items-center justify-between rounded px-2 py-1.5 font-medium transition-colors",
          "hover:bg-f1-background-secondary",
          n === r && "bg-f1-background-secondary",
          Ke()
        ),
        onClick: () => i(r),
        children: /* @__PURE__ */ k("div", { className: "flex items-center justify-start gap-2.5", children: [
          /* @__PURE__ */ d("span", { className: "line-clamp-1 w-fit text-left", children: a.label }),
          /* @__PURE__ */ d(Ue, { children: !l.isEmpty(s, {
            schema: a
          }) && /* @__PURE__ */ d(
            re.div,
            {
              className: "h-2 w-2 shrink-0 rounded-full bg-f1-background-selected-bold",
              initial: { opacity: 0, scale: 0.7 },
              animate: { opacity: 1, scale: 1 },
              exit: { opacity: 0, scale: 0.7 }
            }
          ) })
        ] })
      },
      r
    );
  }) }) });
}
function oEe({
  schema: t,
  filters: e,
  onChange: n,
  isOpen: i,
  onOpenChange: r,
  hideLabel: a
}) {
  const [o, s] = q(null), [l, c] = q(!1), u = et(), f = i ?? l, m = r ?? c, [h, p] = q(e);
  le(() => {
    p(e);
  }, [e]);
  const g = (w, x) => {
    p((b) => ({
      ...b,
      [w]: x
    }));
  }, y = () => {
    n(h), m(!1);
  };
  le(() => {
    var x;
    f && s((x = Object.entries(h).find(([b, M]) => !Ss(t[b].type).isEmpty(M, {
      schema: t[b]
    }))) == null ? void 0 : x[0]);
  }, [f]);
  const v = Wa();
  return /* @__PURE__ */ d("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ k($o, { open: f, onOpenChange: m, children: [
    /* @__PURE__ */ d(Do, { asChild: !0, children: /* @__PURE__ */ d(
      ue,
      {
        variant: "outline",
        label: u.filters.label,
        icon: xE,
        pressed: f,
        onClick: () => m(!f),
        hideLabel: a,
        round: a,
        "aria-controls": f ? v : void 0
      }
    ) }),
    /* @__PURE__ */ d(
      Eo,
      {
        className: "w-[544px] rounded-xl border border-solid border-f1-border-secondary p-0 shadow-md",
        align: "start",
        side: "bottom",
        "aria-id": v,
        children: /* @__PURE__ */ k("div", { className: "flex h-[min(448px,80vh)] flex-col", children: [
          /* @__PURE__ */ k("div", { className: "flex min-h-0 flex-1", children: [
            /* @__PURE__ */ d(
              aEe,
              {
                definition: t,
                tempFilters: h,
                selectedFilterKey: o,
                onFilterSelect: (w) => s(w)
              }
            ),
            o && /* @__PURE__ */ d(
              rEe,
              {
                selectedFilterKey: o,
                definition: t,
                tempFilters: h,
                onFilterChange: g
              }
            )
          ] }),
          /* @__PURE__ */ d("div", { className: "flex items-center justify-end gap-2 border border-solid border-transparent border-t-f1-border-secondary p-2", children: /* @__PURE__ */ d(
            ue,
            {
              onClick: y,
              label: u.filters.applyFilters
            }
          ) })
        ] })
      }
    )
  ] }) });
}
const sEe = ({ label: t, number: e, onClick: n, selected: i }) => /* @__PURE__ */ k(
  "label",
  {
    className: E(
      "flex cursor-default appearance-none items-center gap-2 rounded px-2.5 py-1.5 font-medium text-f1-foreground outline outline-1 outline-f1-border transition-all",
      n && "focus-within:ring-2 focus-within:ring-f1-border-selected focus-within:ring-offset-2",
      e && "pr-1.5",
      n && "cursor-pointer hover:outline-f1-border-hover",
      i && "bg-f1-background-selected-secondary text-f1-foreground-selected outline-f1-border-selected hover:outline-f1-border-selected"
    ),
    children: [
      /* @__PURE__ */ d(
        "input",
        {
          type: "checkbox",
          className: "sr-only",
          checked: i,
          onChange: () => n == null ? void 0 : n()
        }
      ),
      /* @__PURE__ */ d("span", { className: "whitespace-nowrap", children: t }),
      e && /* @__PURE__ */ d(Sp, { resolve: e, fallback: /* @__PURE__ */ d(Ce, { className: "h-4 w-4" }), children: (r) => r && /* @__PURE__ */ d(
        Lo,
        {
          value: r,
          type: i ? "selected" : "default"
        }
      ) })
    ]
  }
), lEe = ({
  presets: t,
  filters: e,
  onPresetsChange: n
}) => {
  const i = (a, o, s = !0) => {
    var c;
    const l = JSON.stringify(a.filter) === JSON.stringify(e);
    return /* @__PURE__ */ d(
      sEe,
      {
        label: a.label,
        selected: l,
        onClick: () => n == null ? void 0 : n(a.filter),
        "data-visible": s,
        number: ((c = a.itemsCount) == null ? void 0 : c.call(a, e)) ?? void 0
      },
      o
    );
  }, r = (a, o) => {
    const s = JSON.stringify(a.filter) === JSON.stringify(e);
    return /* @__PURE__ */ k(
      "button",
      {
        className: E(
          "flex w-full cursor-pointer items-center justify-between rounded-sm p-2 text-left font-medium text-f1-foreground hover:bg-f1-background-secondary",
          s && "bg-f1-background-selected hover:bg-f1-background-selected",
          Ke()
        ),
        onClick: () => n == null ? void 0 : n(a.filter),
        "data-visible": !0,
        children: [
          a.label,
          /* @__PURE__ */ d(
            Lo,
            {
              value: Object.keys(a.filter).length,
              type: s ? "selected" : "default"
            }
          )
        ]
      },
      o
    );
  };
  return t && t.length > 0 && /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d("div", { className: "mx-2 h-4 w-px bg-f1-background-secondary-hover" }) }),
    /* @__PURE__ */ d(
      Jm,
      {
        items: t,
        renderListItem: i,
        renderDropdownItem: r,
        className: "min-w-0 flex-1"
      }
    )
  ] });
}, ah = hn({
  schema: {},
  filters: {},
  presets: [],
  removeFilterValue: () => {
  },
  setFiltersValue: () => {
  },
  isFiltersOpen: !1,
  setIsFiltersOpen: () => {
  }
}), zP = ({
  filters: t,
  schema: e,
  children: n,
  ...i
}) => {
  const [r, a] = q(!1), [o, s] = q(t);
  le(() => {
    s(t);
  }, [JSON.stringify(t)]);
  const l = (u) => {
    const f = { ...o };
    delete f[u], s(f), i.onChange(f);
  }, c = (u) => {
    s(u), i.onChange(u);
  };
  return /* @__PURE__ */ d(
    ah.Provider,
    {
      value: {
        ...i,
        presets: i.presets,
        filters: o,
        schema: e,
        removeFilterValue: l,
        setFiltersValue: (u) => c(u),
        isFiltersOpen: r,
        setIsFiltersOpen: a
      },
      children: n
    }
  );
};
zP.displayName = "Filters.Root";
const VP = () => {
  const {
    schema: t,
    filters: e,
    isFiltersOpen: n,
    setIsFiltersOpen: i,
    setFiltersValue: r,
    presets: a
  } = Wt(ah);
  return t && /* @__PURE__ */ d(
    oEe,
    {
      schema: t,
      filters: e,
      onChange: r,
      onOpenChange: i,
      isOpen: n,
      hideLabel: !!a
    }
  );
};
VP.displayName = "Filters.Controls";
const HP = () => {
  const { presets: t, filters: e, setFiltersValue: n } = Wt(ah);
  return t && /* @__PURE__ */ d(
    lEe,
    {
      presets: t,
      filters: e,
      onPresetsChange: n
    }
  );
};
HP.displayName = "Filters.Presets";
const BP = () => {
  const {
    schema: t,
    filters: e,
    setIsFiltersOpen: n,
    removeFilterValue: i,
    setFiltersValue: r
  } = Wt(ah);
  return t && /* @__PURE__ */ d(
    iEe,
    {
      schema: t,
      filters: e,
      onFilterSelect: () => n(!0),
      onFilterRemove: i,
      onClearAll: () => r({})
    }
  );
};
BP.displayName = "Filters.ChipsList";
const dEe = (t, e, n) => {
  const i = _t[n];
  return i ? i.add(t, e) : { from: /* @__PURE__ */ new Date(), to: /* @__PURE__ */ new Date() };
};
function cEe({
  granularities: t,
  value: e,
  onChange: n
}) {
  const i = et(), r = (a) => {
    n(a);
  };
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ d("h6", { className: "text-sm font-medium", children: i.date.selectedBy }),
    /* @__PURE__ */ d(Rm, { value: e, onValueChange: r, asList: !0, children: /* @__PURE__ */ d(jm, { children: t.map((a) => {
      var o;
      return /* @__PURE__ */ d(ld, { value: a, children: ((o = i.date.granularities[a]) == null ? void 0 : o.label) || a }, a);
    }) }) })
  ] });
}
const V2 = "__custom__", uEe = (t, e) => {
  if (!(t != null && t.value)) return !1;
  const n = typeof e.value == "function" ? e.value() : e.value;
  return t.granularity !== e.granularity ? !1 : of(t.value.from, n.from) && (!t.value.to || !n.to || of(t.value.to, n.to));
}, fEe = ({ presets: t, ...e }) => {
  const [n, i] = q();
  return le(() => {
    if (e.date) {
      const a = Object.entries(t).find(
        ([o, s]) => uEe(e.date, s)
      );
      i(a ? a[0] : void 0);
    }
  }, [e.date, t]), /* @__PURE__ */ d(Rm, { asList: !0, value: n, onValueChange: (a) => {
    var o;
    i(a), (o = e.onSelect) == null || o.call(e, a);
  }, children: /* @__PURE__ */ k(jm, { children: [
    Object.entries(t).map(([a, o]) => /* @__PURE__ */ d(ld, { value: a, children: (o == null ? void 0 : o.label) || a }, a)),
    /* @__PURE__ */ d(Hy, {}),
    /* @__PURE__ */ d(ld, { value: V2, children: "Custom" }, V2)
  ] }) });
}, H2 = "__custom__";
function mEe({
  onSelect: t,
  defaultValue: e,
  presets: n = [],
  granularities: i = ["day"],
  children: r,
  compareTo: a,
  onCompareToChange: o,
  value: s,
  ...l
}) {
  const c = et(), [u, f] = q(
    s || e
  ), m = ve(
    () => (u == null ? void 0 : u.granularity) ?? "day",
    [u == null ? void 0 : u.granularity]
  ), h = ve(() => _t[m], [m]), p = ve(() => _t[m].calendarMode || "single", [m]), g = (O) => {
    y({
      value: h.toRange(O ?? void 0),
      granularity: m
    });
  }, y = (O) => {
    f(O), t == null || t(O);
  }, v = (O) => {
    var L;
    x(O === H2);
    const I = O ? n[+O] : void 0;
    I && (y({
      value: _t[I.granularity].toRange(
        typeof I.value == "function" ? I.value() : I.value
      ),
      granularity: I.granularity
    }), O !== H2 && ((L = l.onOpenChange) == null || L.call(l, !1)));
  }, [w, x] = q(!1), b = (O) => {
    y({
      value: u == null ? void 0 : u.value,
      granularity: O
    });
  }, M = ve(
    () => n.length > 0 && !w,
    [n, w]
  ), _ = () => {
    x(!1);
  }, N = ve(
    () => h.calendarView || "day",
    [h]
  ), [$, D] = q(void 0), W = ve(() => {
    const O = (a ?? {})[m] || [];
    if (!(u != null && u.value))
      return [];
    const I = u.value, L = O.map((R, B) => {
      const F = typeof R.value == "function" ? R.value(h.toRange(I)) : dEe(
        h.toRange(I),
        R.value.delta,
        R.value.units
      ), z = Array.isArray(F) ? F.map((K) => h.toString(K)).join(", ") : h.toString(F);
      return {
        label: R.label,
        value: B.toString(),
        description: z,
        dateValue: F
      };
    });
    return L.length === 0 ? [] : [
      {
        label: c.date.none,
        value: "none",
        description: "",
        dateValue: void 0
      },
      ...L
    ];
  }, [a, u, h, m]);
  le(() => {
    D("none");
  }, [u]);
  const j = (O) => {
    D(O), o == null || o(W[+O].dateValue);
  };
  return /* @__PURE__ */ k($o, { open: l.open, onOpenChange: l.onOpenChange, children: [
    /* @__PURE__ */ d(Do, { asChild: !0, children: r }),
    /* @__PURE__ */ d(Eo, { className: "w-full overflow-auto", align: "start", children: M ? /* @__PURE__ */ d(
      fEe,
      {
        presets: n,
        date: u,
        onSelect: v
      }
    ) : /* @__PURE__ */ k("div", { className: "flex gap-4", children: [
      (n.length > 0 || i.length > 1) && /* @__PURE__ */ k("div", { children: [
        n.length > 0 && /* @__PURE__ */ d(
          ue,
          {
            icon: qd,
            variant: "neutral",
            size: "sm",
            round: !0,
            hideLabel: !0,
            label: "Back",
            onClick: _
          }
        ),
        i.length > 1 && /* @__PURE__ */ d(
          cEe,
          {
            granularities: i,
            value: m,
            onChange: b
          }
        )
      ] }),
      /* @__PURE__ */ k("div", { className: "min-w-[300px] flex-1", children: [
        /* @__PURE__ */ d(
          IP,
          {
            showInput: !0,
            mode: p,
            view: N,
            onSelect: g,
            defaultSelected: u == null ? void 0 : u.value,
            minDate: l.minDate,
            maxDate: l.maxDate
          }
        ),
        W.length > 0 && /* @__PURE__ */ k("div", { className: "mt-4 flex flex-col gap-2", children: [
          /* @__PURE__ */ d("div", { className: "text-gray-500 text-sm", children: c.date.compareTo }),
          /* @__PURE__ */ d(
            Ca,
            {
              placeholder: c.date.compareTo,
              options: W.map((O) => ({
                label: O.label,
                value: O.value,
                description: O.description ?? ""
              })),
              onChange: j,
              value: $
            }
          )
        ] })
      ] })
    ] }) })
  ] });
}
const qP = X(
  ({
    value: t,
    onDateChange: e,
    disabled: n,
    error: i,
    className: r,
    highlighted: a,
    onClick: o,
    navigation: s,
    granularity: l,
    hideGoToCurrent: c,
    ...u
  }, f) => {
    var M;
    const m = et(), h = ve(() => !t || !t.value ? m.date.selectDate : _t[t.granularity].toString(t.value) ?? m.date.selectDate, [t, m.date.selectDate]), p = (_) => {
      _ && (e == null || e(_));
    }, g = ve(() => {
      var _;
      if (u.minDate)
        return (_ = l == null ? void 0 : l.toRange(u.minDate)) == null ? void 0 : _.from;
    }, [u.minDate, l]), y = ve(() => {
      var _;
      if (u.maxDate)
        return (_ = l == null ? void 0 : l.toRange(u.maxDate)) == null ? void 0 : _.to;
    }, [u.maxDate, l]), [v, w] = q(null);
    le(() => {
      w((l == null ? void 0 : l.toRange(/* @__PURE__ */ new Date())) ?? null);
      const _ = () => {
        const $ = (l == null ? void 0 : l.toRange(/* @__PURE__ */ new Date())) ?? null;
        $ && Br($.from, g) && Hr($.to || $.from, y) ? w($) : w(null);
      }, N = setInterval(() => {
        _();
      }, 6e4);
      return _(), () => clearInterval(N);
    }, [l, g, y]);
    const x = t != null && t.value ? l == null ? void 0 : l.getPrevNext(t == null ? void 0 : t.value, {
      min: g,
      max: y
    }) : void 0, b = () => {
      const _ = l == null ? void 0 : l.toRange(/* @__PURE__ */ new Date());
      _ && (e == null || e(_));
    };
    return /* @__PURE__ */ k(
      "div",
      {
        ref: f,
        className: E(
          "inline-flex cursor-auto appearance-none gap-1 rounded-md border-0 bg-f1-background px-1 ring-1 ring-inset ring-f1-border transition-all placeholder:text-f1-foreground-tertiary hover:ring-f1-border-hover",
          "[%>*] py-1",
          Ke("focus:ring-f1-border-hover"),
          n && "cursor-not-allowed bg-f1-background-secondary opacity-50",
          i && "ring-f1-border-critical-bold",
          r
        ),
        onClick: (_) => _.stopPropagation(),
        children: [
          s && /* @__PURE__ */ d(
            ue,
            {
              size: "sm",
              variant: "ghost",
              icon: qd,
              label: "Previous",
              hideLabel: !0,
              disabled: !(x != null && x.prev),
              onClick: () => p((x == null ? void 0 : x.prev) ?? !1)
            }
          ),
          /* @__PURE__ */ d(
            so,
            {
              size: "sm",
              variant: "ghost",
              label: h,
              onClick: o,
              disabled: n,
              className: E(a && "bg-f1-background-secondary-hover")
            }
          ),
          s && /* @__PURE__ */ d(
            ue,
            {
              variant: "ghost",
              icon: Oa,
              label: "Next",
              hideLabel: !0,
              size: "sm",
              disabled: !(x != null && x.next),
              onClick: () => p((x == null ? void 0 : x.next) ?? !1)
            }
          ),
          !c && v && /* @__PURE__ */ d("div", { className: "border-l-solid flex-1 border-[#f00]", children: /* @__PURE__ */ d(
            ue,
            {
              size: "sm",
              variant: "ghost",
              label: (M = m.date.granularities[(t == null ? void 0 : t.granularity) ?? "day"]) == null ? void 0 : M.currentDate,
              onClick: b
            }
          ) })
        ]
      }
    );
  }
);
qP.displayName = "DatePickerTrigger";
function hEe({
  onSelect: t,
  defaultValue: e,
  presets: n = [],
  granularities: i = ["day"],
  hideNavigation: r = !1,
  hideGoToCurrent: a = !1,
  compareTo: o,
  onCompareToChange: s,
  ...l
}) {
  const [c, u] = q(e), [f, m] = q(!1), h = ve(() => _t[(c == null ? void 0 : c.granularity) ?? "day"], [c == null ? void 0 : c.granularity]), p = (y) => {
    u(y), t == null || t(y);
  }, g = (y) => {
    p({
      value: h.toRange(y),
      granularity: (c == null ? void 0 : c.granularity) ?? "day"
    });
  };
  return /* @__PURE__ */ d(
    mEe,
    {
      onSelect: p,
      value: c,
      defaultValue: e,
      presets: n,
      granularities: i,
      minDate: l.minDate,
      maxDate: l.maxDate,
      open: f,
      onOpenChange: m,
      compareTo: o,
      onCompareToChange: s,
      children: /* @__PURE__ */ d(
        qP,
        {
          value: c,
          highlighted: f,
          navigation: !r,
          onDateChange: g,
          granularity: h,
          minDate: l.minDate,
          maxDate: l.maxDate,
          disabled: l.disabled,
          hideGoToCurrent: a,
          onClick: () => m(!0)
        }
      )
    }
  );
}
const AYe = {
  today: {
    label: "Today",
    granularity: "day",
    value: () => _t.day.toRange(/* @__PURE__ */ new Date())
  },
  yesterday: {
    label: "Yesterday",
    granularity: "day",
    value: () => _t.day.toRange(lo(/* @__PURE__ */ new Date(), 1))
  },
  last7Days: {
    label: "Last 7 days",
    granularity: "day",
    value: () => _t.day.toRange({
      from: lo(/* @__PURE__ */ new Date(), 7),
      to: /* @__PURE__ */ new Date()
    })
  },
  thisWeek: {
    label: "This week",
    granularity: "week",
    value: () => _t.week.toRange(/* @__PURE__ */ new Date())
  },
  lastWeek: {
    label: "Last week",
    granularity: "week",
    value: () => _t.week.toRange(lo(/* @__PURE__ */ new Date(), 7))
  },
  thisMonth: {
    label: "This month",
    granularity: "month",
    value: () => _t.month.toRange(/* @__PURE__ */ new Date())
  },
  lastMonth: {
    label: "Last month",
    granularity: "month",
    value: () => _t.month.toRange(ml(/* @__PURE__ */ new Date(), 1))
  },
  last3Months: {
    label: "Last 3 months",
    granularity: "month",
    value: () => _t.month.toRange(ml(/* @__PURE__ */ new Date(), 3))
  },
  last6Months: {
    label: "Last 6 months",
    granularity: "month",
    value: () => _t.month.toRange(ml(/* @__PURE__ */ new Date(), 6))
  },
  thisQuarter: {
    label: "This quarter",
    granularity: "quarter",
    value: () => _t.quarter.toRange(/* @__PURE__ */ new Date())
  },
  lastQuarter: {
    label: "Last quarter",
    granularity: "quarter",
    value: () => _t.quarter.toRange(ml(/* @__PURE__ */ new Date(), 3))
  },
  thisHalfYear: {
    label: "This half year",
    granularity: "halfyear",
    value: () => _t.halfyear.toRange(/* @__PURE__ */ new Date())
  },
  lastHalfYear: {
    label: "Last half year",
    granularity: "halfyear",
    value: () => _t.halfyear.toRange(ml(/* @__PURE__ */ new Date(), 6))
  },
  lastYear: {
    label: "Last year",
    granularity: "year",
    value: () => _t.year.toRange(ok(/* @__PURE__ */ new Date(), 1))
  },
  last3Years: {
    label: "Last 3 years",
    granularity: "year",
    value: () => _t.year.toRange(ok(/* @__PURE__ */ new Date(), 3))
  }
};
function pEe({
  filter: t,
  value: e,
  onChange: n
}) {
  const i = {
    granularity: "day",
    ...t
  }, r = Array.isArray(i.granularity) ? i.granularity : [i.granularity], a = RDe(
    e.granularity || r[0]
  );
  return /* @__PURE__ */ d("div", { className: "flex items-center gap-2", children: /* @__PURE__ */ d(
    hEe,
    {
      onSelect: (s) => {
        !s || !s.value || n({
          value: s.value,
          granularity: s.granularity,
          valueString: a.toString(s.value)
        });
      },
      defaultValue: e,
      granularities: r,
      minDate: i.min,
      maxDate: i.max,
      presets: i.presets,
      hideGoToCurrent: i.hideGoToCurrent
    }
  ) });
}
const gEe = (t) => "date" in t, yEe = {
  valueConverter: function(t, e) {
    const n = Array.isArray(e.granularity) ? e.granularity : [e.granularity], i = e.defaultGranularity || n[0] || "day";
    if (t || (t = /* @__PURE__ */ new Date()), gEe(t))
      return t;
    const r = _t[i];
    return {
      value: r.toRange(t),
      valueString: r.toString(t),
      granularity: i
    };
  },
  render: (t) => /* @__PURE__ */ d(pEe, { ...t })
}, GP = {
  "date-navigator": yEe
}, B2 = ({ loading: t }) => t ? /* @__PURE__ */ d(me, { icon: I5, className: "animate-spin" }) : /* @__PURE__ */ d(me, { icon: Om, className: "text" }), vEe = ({ value: t, onChange: e, loading: n = !1 }) => {
  const [i, r] = q(!1), a = Wa(), o = Oe(null), s = Oe(null), l = et(), c = () => {
    e(void 0), r(!1), s != null && s.current && (s.current.value = "");
  };
  uD(o, () => {
    i && r(!1);
  });
  const u = () => {
    i || (r(!0), setTimeout(() => {
      var m;
      (m = s.current) == null || m.focus();
    }, 0));
  }, f = (m) => {
    i ? m.key === "Escape" && (m.preventDefault(), c(), r(!1)) : (m.key === "Enter" || m.key === " ") && (m.preventDefault(), u());
  };
  return /* @__PURE__ */ d(Wm, { id: a, children: /* @__PURE__ */ d(
    d5,
    {
      transition: { duration: 0.2, ease: [0.175, 0.885, 0.32, 1.05] },
      children: /* @__PURE__ */ d(Ue, { children: /* @__PURE__ */ d(
        re.div,
        {
          layout: !0,
          ref: o,
          className: E(
            "relative flex h-8 w-fit min-w-8 max-w-[180px] items-center justify-center",
            (i || t) && "w-[180px]"
          ),
          children: i ? /* @__PURE__ */ d(
            re.div,
            {
              layout: !0,
              layoutId: "search-container",
              className: "absolute inset-0 h-8 w-full bg-f1-border p-px transition-colors focus-within:bg-f1-border-hover",
              style: { borderRadius: 12 },
              children: /* @__PURE__ */ k(
                re.div,
                {
                  layout: !0,
                  className: "relative flex h-full w-full items-center justify-between gap-1 overflow-hidden bg-f1-background pr-1.5",
                  style: { borderRadius: 11 },
                  children: [
                    /* @__PURE__ */ d(
                      re.div,
                      {
                        className: "absolute left-[5px] top-[5px] z-10 flex h-5 w-5 items-center justify-center text-f1-icon",
                        layoutId: "search-icon",
                        children: /* @__PURE__ */ d(B2, { loading: n }, "loading")
                      }
                    ),
                    /* @__PURE__ */ d(
                      re.input,
                      {
                        layout: !0,
                        ref: s,
                        type: "text",
                        value: t,
                        placeholder: l.actions.search,
                        onChange: (m) => e(m.target.value),
                        className: "h-full w-full appearance-none rounded border-none bg-f1-background py-2 pl-7 text-base text-f1-foreground",
                        initial: { opacity: 0 },
                        animate: { opacity: 1 },
                        exit: { opacity: 0 },
                        onKeyDown: f
                      }
                    ),
                    /* @__PURE__ */ d(
                      re.div,
                      {
                        tabIndex: 0,
                        className: E(
                          "flex h-5 w-5 items-center justify-center rounded-full",
                          Ke()
                        ),
                        onClick: (m) => {
                          m.stopPropagation(), c();
                        },
                        role: "button",
                        "aria-label": l.actions.clear,
                        children: /* @__PURE__ */ d(
                          me,
                          {
                            icon: vs,
                            className: "text-f1-icon-secondary transition-colors hover:text-f1-icon",
                            size: "md"
                          }
                        )
                      }
                    )
                  ]
                }
              )
            }
          ) : /* @__PURE__ */ d(
            re.div,
            {
              role: "button",
              "aria-label": l.actions.search,
              tabIndex: 0,
              layout: !0,
              layoutId: "search-container",
              className: E(
                "relative h-8 w-full bg-f1-border p-px transition-colors hover:bg-f1-border-hover",
                Ke()
              ),
              onClick: u,
              onKeyDown: f,
              style: { borderRadius: 10 },
              children: /* @__PURE__ */ k(
                re.div,
                {
                  layout: !0,
                  className: "relative flex h-full w-full items-center gap-1 overflow-hidden bg-f1-background",
                  style: { borderRadius: 9 },
                  children: [
                    /* @__PURE__ */ d(
                      re.div,
                      {
                        className: "absolute left-[5px] top-[5px] flex h-5 w-5 items-center justify-center text-f1-icon-bold",
                        layoutId: "search-icon",
                        children: /* @__PURE__ */ d(B2, { loading: n })
                      }
                    ),
                    t && /* @__PURE__ */ k("div", { className: "flex h-7 w-full items-center justify-between gap-1.5 overflow-hidden pr-1.5", children: [
                      /* @__PURE__ */ d(
                        re.div,
                        {
                          layout: !0,
                          className: "line-clamp-1 overflow-hidden py-2 pl-7",
                          children: t
                        }
                      ),
                      /* @__PURE__ */ d(
                        re.div,
                        {
                          tabIndex: 0,
                          className: E(
                            "flex h-5 w-5 items-center justify-center rounded-full",
                            Ke()
                          ),
                          onClick: (m) => {
                            m.stopPropagation(), c();
                          },
                          role: "button",
                          "aria-label": l.actions.clear,
                          children: /* @__PURE__ */ d(
                            me,
                            {
                              icon: vs,
                              className: "text-f1-icon-secondary transition-colors hover:text-f1-icon",
                              size: "md"
                            }
                          )
                        }
                      )
                    ] })
                  ]
                }
              )
            }
          )
        }
      ) })
    }
  ) });
}, $1 = "__no-grouping__", bEe = ({
  grouping: t,
  currentGrouping: e,
  onGroupingChange: n
}) => {
  const i = et(), r = [
    ...t.mandatory ? [] : [
      {
        label: i.collections.grouping.noGrouping,
        value: $1
      }
    ],
    ...Object.entries(t.groupBy || {}).filter(
      (a) => !!a[1]
    ).map(([a, o]) => ({
      label: o.name,
      value: a
    }))
  ];
  return /* @__PURE__ */ k("div", { className: "flex flex-col gap-0 pb-3", children: [
    /* @__PURE__ */ k("div", { className: "flex items-center gap-1 p-3 pb-2 text-sm font-medium text-f1-foreground-secondary", children: [
      /* @__PURE__ */ d("div", { className: "flex h-4 w-4 items-center justify-center text-f1-icon", children: /* @__PURE__ */ d(me, { icon: T5, size: "sm" }) }),
      i.collections.grouping.groupBy
    ] }),
    /* @__PURE__ */ k("div", { className: "flex items-center gap-2 px-3", children: [
      /* @__PURE__ */ d("div", { className: "shrink grow [&_button]:h-8 [&_button]:rounded", children: /* @__PURE__ */ d(
        Ca,
        {
          options: r,
          value: (e == null ? void 0 : e.field.toString()) ?? $1,
          onChange: (a) => n(
            a !== $1 ? {
              field: a,
              order: (e == null ? void 0 : e.order) ?? "asc"
            } : void 0
          )
        }
      ) }),
      (e == null ? void 0 : e.field) && /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
        ue,
        {
          hideLabel: !0,
          label: i.collections.grouping.toggleDirection,
          variant: "outline",
          icon: (e == null ? void 0 : e.order) === "asc" ? Iy : ad,
          onClick: () => n({
            field: e.field,
            order: e.order === "asc" ? "desc" : "asc"
          })
        }
      ) })
    ] })
  ] });
}, D1 = "__no-sorting__", wEe = ({
  currentSortings: t,
  sortings: e,
  onChange: n
}) => {
  const i = et(), r = [
    {
      label: i.collections.sorting.noSorting,
      value: D1
    },
    ...Object.entries(e || {}).map(([s, l]) => ({
      label: l.label,
      value: s
    }))
  ], [a, o] = q(t);
  return le(() => {
    o(t || {
      field: D1,
      order: "asc"
    });
  }, [JSON.stringify(t)]), /* @__PURE__ */ k("div", { className: "flex flex-col gap-0 pb-3", children: [
    /* @__PURE__ */ k("div", { className: "flex items-center gap-1 p-3 pb-2 text-sm font-medium text-f1-foreground-secondary", children: [
      /* @__PURE__ */ d("div", { className: "flex h-4 w-4 items-center justify-center text-f1-icon", children: /* @__PURE__ */ d(me, { icon: T5, size: "sm" }) }),
      i.collections.sorting.sortBy
    ] }),
    /* @__PURE__ */ k("div", { className: "flex items-center gap-2 px-3", children: [
      /* @__PURE__ */ d("div", { className: "shrink grow [&_button]:h-8 [&_button]:rounded", children: /* @__PURE__ */ d(
        Ca,
        {
          options: r,
          value: a == null ? void 0 : a.field,
          onChange: (s) => {
            s && n({
              field: s,
              order: (a == null ? void 0 : a.order) ?? "asc"
            });
          }
        }
      ) }),
      (a == null ? void 0 : a.field) !== D1 && /* @__PURE__ */ d("div", { children: /* @__PURE__ */ d(
        ue,
        {
          hideLabel: !0,
          label: i.collections.sorting.toggleDirection,
          variant: "outline",
          icon: (a == null ? void 0 : a.order) === "asc" ? Iy : ad,
          onClick: () => n({
            field: a == null ? void 0 : a.field,
            order: (a == null ? void 0 : a.order) === "asc" ? "desc" : "asc"
          })
        }
      ) })
    ] })
  ] });
}, kEe = ({
  open: t,
  className: e,
  onClick: n,
  disabled: i,
  size: r = "xs"
}) => /* @__PURE__ */ d(
  re.div,
  {
    animate: { rotate: t ? 180 : 0 },
    transition: { duration: 0.2 },
    className: E(
      "flex h-3 w-3 shrink-0 items-center justify-center",
      i && "cursor-not-allowed opacity-50",
      e
    ),
    onClick: n,
    children: /* @__PURE__ */ d(me, { icon: zn, size: r, role: "button" })
  }
), C0 = ({
  label: t,
  itemCount: e,
  open: n,
  onOpenChange: i,
  showOpenChange: r,
  selectable: a,
  select: o,
  onSelectChange: s,
  className: l
}) => {
  const [c, u] = q(n);
  le(() => {
    u(n);
  }, [n]);
  const f = () => {
    u(!c), i == null || i(!c);
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: E("pointer-events-auto flex items-center gap-2", l),
      onClick: f,
      children: [
        a && /* @__PURE__ */ d(
          Ps,
          {
            checked: !!o,
            indeterminate: o === "indeterminate",
            title: "Select all",
            hideLabel: !0,
            onCheckedChange: (m) => s == null ? void 0 : s(m),
            stopPropagation: !0
          }
        ),
        /* @__PURE__ */ d(Sp, { resolve: t, fallback: /* @__PURE__ */ d(Ce, { className: "h-4 w-24" }), children: (m) => /* @__PURE__ */ d("h6", { className: "text-base font-semibold text-f1-foreground", children: m }) }),
        /* @__PURE__ */ d(Sp, { resolve: e, fallback: /* @__PURE__ */ d(Ce, { className: "h-4 w-5" }), children: (m) => m !== void 0 && /* @__PURE__ */ d(Lo, { value: m }) }),
        r && /* @__PURE__ */ d("span", { className: "text-f1-icon-secondary", children: /* @__PURE__ */ d(kEe, { open: c, size: "sm" }) })
      ]
    }
  );
}, P0 = (t, e = []) => {
  const [n, i] = q({});
  return le(() => {
    const a = t.reduce(
      (o, s) => (o[s.key] = typeof e == "boolean" ? e : e.includes(s.key), o),
      {}
    );
    Object.values(a).length > 0 && i(a);
  }, [JSON.stringify(t), JSON.stringify(e)]), { openGroups: n, setGroupOpen: (a, o) => {
    i((s) => ({ ...s, [a]: o }));
  } };
}, xEe = {
  delay: 0.03,
  duration: 0.03,
  maxDelay: 20
}, XP = (t) => {
  const { delay: e, duration: n, maxDelay: i } = {
    ...xEe,
    ...t
  };
  return {
    hidden: { opacity: 0, y: -10 },
    // Start position for the animation
    visible: (r) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: Math.min(r * e, i),
        // Delay each row based on its index
        duration: n,
        // Duration of the animation
        type: "spring",
        // Use a spring type animation for a bounce effect
        stiffness: 100,
        // Spring stiffness, adjust for more/less bounce
        damping: 10
        // Spring damping, adjust to change how the bounce behaves
      }
    })
  };
};
function _Ee(t, e) {
  var n = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (n) return (n = n.call(t)).next.bind(n);
  if (Array.isArray(t) || (n = MEe(t)) || e) {
    n && (t = n);
    var i = 0;
    return function() {
      return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function MEe(t, e) {
  if (t) {
    if (typeof t == "string") return q2(t, e);
    var n = Object.prototype.toString.call(t).slice(8, -1);
    if (n === "Object" && t.constructor && (n = t.constructor.name), n === "Map" || n === "Set") return Array.from(t);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return q2(t, e);
  }
}
function q2(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var n = 0, i = new Array(e); n < e; n++)
    i[n] = t[n];
  return i;
}
function G2(t, e) {
  for (var n = 0; n < e.length; n++) {
    var i = e[n];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function S0(t, e, n) {
  return e && G2(t.prototype, e), n && G2(t, n), t;
}
var N0 = function() {
  return typeof Symbol == "function";
}, $0 = function(t) {
  return N0() && !!Symbol[t];
}, D0 = function(t) {
  return $0(t) ? Symbol[t] : "@@" + t;
};
N0() && !$0("observable") && (Symbol.observable = Symbol("observable"));
var CEe = D0("iterator"), yg = D0("observable"), YP = D0("species");
function Mf(t, e) {
  var n = t[e];
  if (n != null) {
    if (typeof n != "function") throw new TypeError(n + " is not a function");
    return n;
  }
}
function Pl(t) {
  var e = t.constructor;
  return e !== void 0 && (e = e[YP], e === null && (e = void 0)), e !== void 0 ? e : oh;
}
function PEe(t) {
  return t instanceof oh;
}
function Ns(t) {
  Ns.log ? Ns.log(t) : setTimeout(function() {
    throw t;
  });
}
function Pu(t) {
  Promise.resolve().then(function() {
    try {
      t();
    } catch (e) {
      Ns(e);
    }
  });
}
function KP(t) {
  var e = t._cleanup;
  if (e !== void 0 && (t._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var n = Mf(e, "unsubscribe");
        n && n.call(e);
      }
    } catch (i) {
      Ns(i);
    }
}
function vg(t) {
  t._observer = void 0, t._queue = void 0, t._state = "closed";
}
function SEe(t) {
  var e = t._queue;
  if (e) {
    t._queue = void 0, t._state = "ready";
    for (var n = 0; n < e.length && (UP(t, e[n].type, e[n].value), t._state !== "closed"); ++n)
      ;
  }
}
function UP(t, e, n) {
  t._state = "running";
  var i = t._observer;
  try {
    var r = Mf(i, e);
    switch (e) {
      case "next":
        r && r.call(i, n);
        break;
      case "error":
        if (vg(t), r) r.call(i, n);
        else throw n;
        break;
      case "complete":
        vg(t), r && r.call(i);
        break;
    }
  } catch (a) {
    Ns(a);
  }
  t._state === "closed" ? KP(t) : t._state === "running" && (t._state = "ready");
}
function E1(t, e, n) {
  if (t._state !== "closed") {
    if (t._state === "buffering") {
      t._queue.push({
        type: e,
        value: n
      });
      return;
    }
    if (t._state !== "ready") {
      t._state = "buffering", t._queue = [{
        type: e,
        value: n
      }], Pu(function() {
        return SEe(t);
      });
      return;
    }
    UP(t, e, n);
  }
}
var NEe = /* @__PURE__ */ function() {
  function t(n, i) {
    this._cleanup = void 0, this._observer = n, this._queue = void 0, this._state = "initializing";
    var r = new $Ee(this);
    try {
      this._cleanup = i.call(void 0, r);
    } catch (a) {
      r.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = t.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (vg(this), KP(this));
  }, S0(t, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), t;
}(), $Ee = /* @__PURE__ */ function() {
  function t(n) {
    this._subscription = n;
  }
  var e = t.prototype;
  return e.next = function(i) {
    E1(this._subscription, "next", i);
  }, e.error = function(i) {
    E1(this._subscription, "error", i);
  }, e.complete = function() {
    E1(this._subscription, "complete");
  }, S0(t, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), t;
}(), oh = /* @__PURE__ */ function() {
  function t(n) {
    if (!(this instanceof t)) throw new TypeError("Observable cannot be called as a function");
    if (typeof n != "function") throw new TypeError("Observable initializer must be a function");
    this._subscriber = n;
  }
  var e = t.prototype;
  return e.subscribe = function(i) {
    return (typeof i != "object" || i === null) && (i = {
      next: i,
      error: arguments[1],
      complete: arguments[2]
    }), new NEe(i, this._subscriber);
  }, e.forEach = function(i) {
    var r = this;
    return new Promise(function(a, o) {
      if (typeof i != "function") {
        o(new TypeError(i + " is not a function"));
        return;
      }
      function s() {
        l.unsubscribe(), a();
      }
      var l = r.subscribe({
        next: function(c) {
          try {
            i(c, s);
          } catch (u) {
            o(u), l.unsubscribe();
          }
        },
        error: o,
        complete: a
      });
    });
  }, e.map = function(i) {
    var r = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var a = Pl(this);
    return new a(function(o) {
      return r.subscribe({
        next: function(s) {
          try {
            s = i(s);
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, e.filter = function(i) {
    var r = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var a = Pl(this);
    return new a(function(o) {
      return r.subscribe({
        next: function(s) {
          try {
            if (!i(s)) return;
          } catch (l) {
            return o.error(l);
          }
          o.next(s);
        },
        error: function(s) {
          o.error(s);
        },
        complete: function() {
          o.complete();
        }
      });
    });
  }, e.reduce = function(i) {
    var r = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var a = Pl(this), o = arguments.length > 1, s = !1, l = arguments[1], c = l;
    return new a(function(u) {
      return r.subscribe({
        next: function(f) {
          var m = !s;
          if (s = !0, !m || o)
            try {
              c = i(c, f);
            } catch (h) {
              return u.error(h);
            }
          else
            c = f;
        },
        error: function(f) {
          u.error(f);
        },
        complete: function() {
          if (!s && !o) return u.error(new TypeError("Cannot reduce an empty sequence"));
          u.next(c), u.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var i = this, r = arguments.length, a = new Array(r), o = 0; o < r; o++)
      a[o] = arguments[o];
    var s = Pl(this);
    return new s(function(l) {
      var c, u = 0;
      function f(m) {
        c = m.subscribe({
          next: function(h) {
            l.next(h);
          },
          error: function(h) {
            l.error(h);
          },
          complete: function() {
            u === a.length ? (c = void 0, l.complete()) : f(s.from(a[u++]));
          }
        });
      }
      return f(i), function() {
        c && (c.unsubscribe(), c = void 0);
      };
    });
  }, e.flatMap = function(i) {
    var r = this;
    if (typeof i != "function") throw new TypeError(i + " is not a function");
    var a = Pl(this);
    return new a(function(o) {
      var s = [], l = r.subscribe({
        next: function(u) {
          if (i)
            try {
              u = i(u);
            } catch (m) {
              return o.error(m);
            }
          var f = a.from(u).subscribe({
            next: function(m) {
              o.next(m);
            },
            error: function(m) {
              o.error(m);
            },
            complete: function() {
              var m = s.indexOf(f);
              m >= 0 && s.splice(m, 1), c();
            }
          });
          s.push(f);
        },
        error: function(u) {
          o.error(u);
        },
        complete: function() {
          c();
        }
      });
      function c() {
        l.closed && s.length === 0 && o.complete();
      }
      return function() {
        s.forEach(function(u) {
          return u.unsubscribe();
        }), l.unsubscribe();
      };
    });
  }, e[yg] = function() {
    return this;
  }, t.from = function(i) {
    var r = typeof this == "function" ? this : t;
    if (i == null) throw new TypeError(i + " is not an object");
    var a = Mf(i, yg);
    if (a) {
      var o = a.call(i);
      if (Object(o) !== o) throw new TypeError(o + " is not an object");
      return PEe(o) && o.constructor === r ? o : new r(function(s) {
        return o.subscribe(s);
      });
    }
    if ($0("iterator") && (a = Mf(i, CEe), a))
      return new r(function(s) {
        Pu(function() {
          if (!s.closed) {
            for (var l = _Ee(a.call(i)), c; !(c = l()).done; ) {
              var u = c.value;
              if (s.next(u), s.closed) return;
            }
            s.complete();
          }
        });
      });
    if (Array.isArray(i))
      return new r(function(s) {
        Pu(function() {
          if (!s.closed) {
            for (var l = 0; l < i.length; ++l)
              if (s.next(i[l]), s.closed) return;
            s.complete();
          }
        });
      });
    throw new TypeError(i + " is not observable");
  }, t.of = function() {
    for (var i = arguments.length, r = new Array(i), a = 0; a < i; a++)
      r[a] = arguments[a];
    var o = typeof this == "function" ? this : t;
    return new o(function(s) {
      Pu(function() {
        if (!s.closed) {
          for (var l = 0; l < r.length; ++l)
            if (s.next(r[l]), s.closed) return;
          s.complete();
        }
      });
    });
  }, S0(t, null, [{
    key: YP,
    get: function() {
      return this;
    }
  }]), t;
}();
N0() && Object.defineProperty(oh, Symbol("extensions"), {
  value: {
    symbol: yg,
    hostReportError: Ns
  },
  configurable: !0
});
function DEe(t) {
  return new oh((e) => (e.next({
    loading: !0,
    error: null,
    data: null
  }), t.then((n) => {
    e.next({
      loading: !1,
      error: null,
      data: n
    }), e.complete();
  }).catch((n) => {
    e.next({
      loading: !1,
      error: n,
      data: null
    }), e.complete();
  }), () => {
  }));
}
const Vl = Symbol("groupId");
function EEe() {
  const [t, e] = q(!0), [n, i] = q([]), [r, a] = q(null);
  return {
    isInitialLoading: t,
    setIsInitialLoading: e,
    data: n,
    setData: i,
    error: r,
    setError: a
  };
}
function TEe() {
  const [t, e] = q(
    null
  );
  return { paginationInfo: t, setPaginationInfo: e };
}
function E0(t, { filters: e, onError: n } = {}) {
  const {
    dataAdapter: i,
    currentFilters: r,
    currentSortings: a,
    search: o,
    currentSearch: s,
    isLoading: l,
    setIsLoading: c,
    currentNavigationFilters: u,
    currentGrouping: f,
    grouping: m
  } = t, h = Oe(), {
    isInitialLoading: p,
    setIsInitialLoading: g,
    data: y,
    setData: v,
    error: w,
    setError: x
  } = EEe(), { paginationInfo: b, setPaginationInfo: M } = TEe(), [_, N] = q(void 0), [$, D] = q(!1), W = Oe(!1), j = ve(
    () => ({ ...r, ...e }),
    [r, e]
  ), O = ED(s), I = o != null && o.enabled ? o != null && o.sync ? s : O : void 0, [L, R] = q(void 0), B = Le(
    (te, be) => {
      const Pe = "summaries" in te ? te.summaries : void 0;
      R(Pe);
      let We = [];
      if ("records" in te) {
        We = te.records;
        const $e = i.paginationType;
        $e && ["pages", "infinite-scroll"].includes($e) && (M({
          total: te.total,
          perPage: te.perPage,
          type: $e,
          // Pages pagination
          ...$e === "pages" && {
            currentPage: "currentPage" in te ? te.currentPage : 1,
            pagesCount: "pagesCount" in te ? te.pagesCount : Math.ceil(te.total / te.perPage)
          },
          // Infinite scroll pagination
          ...$e === "infinite-scroll" && {
            cursor: "cursor" in te && te.cursor !== void 0 ? te.cursor : be ? String(te.perPage) : "0",
            hasMore: "hasMore" in te ? te.hasMore : y.length + te.records.length < te.total
          }
        }), N(te.total));
      } else
        We = te, N == null || N(te.length);
      v(
        be ? ($e) => {
          const Y = [...$e], oe = new Map(
            $e.filter((se) => "id" in se && !!se.id).map((se) => [se.id, se])
          );
          for (const se of We)
            if ("id" in se && se.id && oe.has(se.id)) {
              const J = Y.findIndex(
                (xe) => xe.id === se.id
              );
              J !== -1 ? Y[J] = se : Y.push(se);
            } else
              Y.push(se);
          return Y;
        } : We
      ), x(null), g(!1), c(!1), D(!1), W.current = !1;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't want to re-run this callback when data.length changes
    [
      v,
      i,
      M,
      x,
      g,
      c,
      D,
      N,
      R,
      W
    ]
  ), F = ve(() => {
    const te = y.map((be) => ({
      ...be,
      [Vl]: (f == null ? void 0 : f.field) && be[f.field] || void 0
    }));
    if (f && f.field && m && m.groupBy[f.field]) {
      const be = f5.groupBy(te, Vl);
      return {
        type: "grouped",
        records: te,
        groups: Object.entries(be).map(([Pe, We]) => {
          var $e, Y;
          return {
            key: Pe,
            label: m.groupBy[f.field].label(
              Pe,
              j
            ),
            itemCount: (Y = ($e = m.groupBy[f.field]) == null ? void 0 : $e.itemCount) == null ? void 0 : Y.call($e, Pe, j),
            records: We
          };
        })
      };
    }
    return { type: "flat", records: te };
  }, [y, f, m, j]), z = Le(
    (te) => {
      x({
        message: "Error fetching data",
        cause: te
      }), n == null || n({
        message: "Error fetching data",
        cause: te
      }), g(!1), c(!1), h.current = void 0;
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps -- we don't want to re-run this effect when the onError changes
    [x, g, c]
  ), K = Le(
    async ({
      filters: te,
      currentPage: be = 1,
      navigationFilters: Pe,
      appendMode: We = !1,
      cursor: $e = null
    }) => {
      try {
        let Y = function() {
          N(void 0);
          const ce = "perPage" in i && i.perPage !== void 0 ? i.perPage : 20;
          return i.paginationType === "pages" ? i.fetchData({
            ...se,
            pagination: { currentPage: be, perPage: ce }
          }) : i.paginationType === "infinite-scroll" ? i.fetchData({
            ...se,
            pagination: { cursor: $e, perPage: ce }
          }) : i.fetchData({
            ...se,
            pagination: {}
          });
        };
        h.current && (h.current(), h.current = void 0);
        const oe = [
          ...a ? [
            {
              field: a.field,
              order: a.order
            }
          ] : [],
          ...f ? [
            {
              field: f.field,
              order: f.order
            }
          ] : []
        ], se = {
          filters: te,
          search: I,
          sortings: oe,
          navigationFilters: Pe
        }, J = Y();
        if (!("then" in J || "subscribe" in J)) {
          B(J, We);
          return;
        }
        const De = ("subscribe" in J ? J : DEe(J)).subscribe({
          next: (_e) => {
            _e.loading ? c(!0) : _e.error ? z(_e.error) : _e.data && B(_e.data, We);
          },
          error: z,
          complete: () => {
            h.current = void 0;
          }
        });
        h.current = () => De.unsubscribe();
      } catch (Y) {
        z(Y);
      }
    },
    [
      z,
      i,
      a,
      f,
      I,
      B,
      c
    ]
  ), ae = Le(
    (te) => {
      JP(b) && (c(!0), K({
        filters: j,
        currentPage: te,
        navigationFilters: u
      }));
    },
    [
      K,
      j,
      c,
      b,
      u
    ]
  ), Q = Le(() => {
    if (!(!b || l)) {
      if (!sh(b)) {
        console.warn(
          "loadMore is only applicable for infinite-scroll pagination type"
        );
        return;
      }
      if (b.hasMore) {
        const te = b.cursor;
        D(!0), c(!0), W.current = !0, K({
          filters: j,
          navigationFilters: u,
          appendMode: !0,
          cursor: te
        });
      }
    }
  }, [
    K,
    l,
    j,
    b,
    u,
    c,
    D
  ]);
  return le(() => {
    if (!W.current) {
      c(!0);
      const te = i.paginationType === "infinite-scroll" ? 0 : 1;
      K({
        filters: j,
        currentPage: te,
        navigationFilters: u,
        cursor: i.paginationType === "infinite-scroll" ? "0" : null
        // Pass "0" as initial cursor
      });
    }
  }, [
    K,
    j,
    c,
    u,
    i.paginationType
  ]), le(() => () => {
    var te;
    (te = h.current) == null || te.call(h);
  }, []), {
    data: F,
    isInitialLoading: p,
    isLoading: l,
    isLoadingMore: $,
    error: w,
    paginationInfo: b,
    setPage: ae,
    loadMore: Q,
    totalItems: _,
    summaries: L
    // Add summaries to the return object
  };
}
function JP(t) {
  return t !== null && t.type === "pages";
}
function sh(t) {
  return t !== null && t.type === "infinite-scroll";
}
function T0(t, e, n, i, r) {
  var O, I;
  const a = t.type === "grouped", o = e !== null, [s, l] = q(
    /* @__PURE__ */ new Map()
  );
  le(() => {
    if (r) {
      if (a)
        for (const L of r.groups || []) {
          const R = t.groups.find(
            (B) => B.key === L.groupId
          );
          R && p(R, L.checked);
        }
      for (const L of r.items || []) {
        const R = t.records.find((B) => B.id === L.id);
        R && N(R, L.checked);
      }
    }
  }, [JSON.stringify(r), t.records]);
  const [c, u] = ve(() => {
    const L = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Map();
    for (const [B, F] of s.entries())
      F.checked ? L.set(B, F.item) : R.set(B, F.item);
    return [L, R];
  }, [s]), [f, m] = q(/* @__PURE__ */ new Map()), [h] = ve(() => {
    const L = /* @__PURE__ */ new Map(), R = /* @__PURE__ */ new Map();
    for (const [B, F] of f.entries())
      F.checked ? L.set(B, F.group) : R.set(B, F.group);
    return [L, R];
  }, [f]), p = (L, R) => {
    if (!a)
      return;
    const B = Array.isArray(L) ? L : [L], F = [
      ...B.flatMap((z) => z.records),
      ...Array.from(s.values()).filter(
        (z) => z.item[Vl] && B.some((K) => K.key === z.item[Vl])
      ).map((z) => z.item)
    ];
    N(F, R), m((z) => {
      const K = new Map(z);
      for (const ae of B)
        K.set(ae.key, { group: ae, checked: R });
      return K;
    });
  }, g = Le(() => {
    $(!1), l(/* @__PURE__ */ new Map());
  }, []), [y, v] = q({});
  le(() => {
    (async () => {
      if (!a)
        return {};
      const R = Object.fromEntries(
        await Promise.all(
          t.groups.map(async (B) => {
            const F = f.get(B.key), z = Array.from(s.values()).filter(
              (We) => We.item[Vl] === B.key
            ), K = o ? await B.itemCount || z.length : B.records.length, ae = z.filter(
              (We) => We.checked
            ).length, Q = z.filter(
              (We) => !We.checked
            ).length, te = K === ae - Q, be = ((F == null ? void 0 : F.checked) || te) && ae > 0, Pe = ae > 0 && !be || be && Q > 0;
            return [
              B.key,
              {
                checked: be || Pe,
                indeterminate: Pe,
                selectedCount: be && !Pe ? K : K - Q,
                unselectedCount: Q
              }
            ];
          })
        )
      );
      v(R);
    })();
  }, [a, a && t.groups, f, s]);
  const w = c.size, x = u.size, [b, M] = q(!1), _ = Le(() => {
    $(!1), m(/* @__PURE__ */ new Map()), l(/* @__PURE__ */ new Map());
  }, []), N = (L, R, B = !1) => {
    const F = Array.isArray(L) ? L : [L];
    let z = 0;
    for (const K of F) {
      const ae = n.selectable && n.selectable(K);
      if (ae === void 0 || B && s.has(ae))
        return;
      z++, s.set(ae, { item: K, checked: R });
    }
    z > 0 && l((K) => new Map(K));
  }, $ = (L) => {
    M(L), a ? p(
      Array.from(f.values()).map(({ group: R }) => R),
      L
    ) : N(
      Array.from(s.values()).map(({ item: R }) => R),
      L
    );
  }, D = ve(
    () => {
      var L;
      return e && w === e.total || !e && w === ((L = t.records) == null ? void 0 : L.length);
    },
    [e, w, (O = t.records) == null ? void 0 : O.length]
  ), W = ve(
    () => (b || D) && w > 0,
    [b, D, w]
  ), j = ve(
    () => w > 0 && !W || W && x > 0,
    [w, W, x]
  );
  return le(() => {
    _();
  }, [n.currentFilters]), le(() => {
    var L;
    if (a)
      for (const R of t.groups) {
        const B = ((L = y[R.key]) == null ? void 0 : L.checked) || W;
        f.has(R.key) || m((F) => {
          const z = new Map(F);
          return z.set(R.key, { group: R, checked: B }), z;
        }), N(R.records, B, !0);
      }
    else
      N(t.records, W, !0);
  }, [t, W, a]), le(() => {
    D && M(!0), w === 0 && M(!1);
  }, [D, w]), le(() => {
    var B;
    const R = ((e == null ? void 0 : e.total) ?? (((B = t.records) == null ? void 0 : B.length) || 0)) - x;
    i == null || i(
      {
        allSelected: x === 0 ? b : b ? "indeterminate" : !1,
        itemsStatus: Array.from(s.values()),
        groupsStatus: Object.fromEntries(
          Array.from(f.values()).map(({ group: F, checked: z }) => [
            F.key,
            !!z
          ])
        ),
        filters: n.currentFilters,
        selectedCount: R
      },
      g
    );
  }, [
    b,
    s,
    f,
    y,
    e == null ? void 0 : e.total,
    (I = t.records) == null ? void 0 : I.length
  ]), {
    selectedItems: c,
    selectedGroups: h,
    allSelectedStatus: {
      checked: b || j,
      indeterminate: j,
      selectedCount: w,
      unselectedCount: x
    },
    isAllSelected: W,
    isPartiallySelected: j,
    handleSelectItemChange: N,
    handleSelectAll: $,
    handleSelectGroupChange: p,
    groupAllSelectedStatus: y
  };
}
const QP = ({ className: t, ...e }) => /* @__PURE__ */ d(
  "nav",
  {
    role: "navigation",
    "aria-label": "pagination",
    className: E("flex w-full justify-center", t),
    ...e
  }
);
QP.displayName = "Pagination";
const ZP = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "div",
  {
    ref: n,
    className: E("flex list-none flex-row items-center gap-1", t),
    ...e
  }
));
ZP.displayName = "PaginationContent";
const Su = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d("div", { ref: n, className: E("", t), ...e }));
Su.displayName = "PaginationItem";
const lh = ({
  className: t,
  isActive: e,
  ...n
}) => /* @__PURE__ */ d(
  "a",
  {
    "aria-current": e ? "page" : void 0,
    className: E(
      "flex h-8 min-w-8 select-none items-center justify-center rounded px-1.5 font-medium text-f1-foreground-secondary transition-all hover:cursor-pointer hover:bg-f1-background-secondary-hover",
      e && "bg-f1-background-selected-bold font-semibold text-f1-foreground-inverse hover:bg-f1-background-selected-bold-hover",
      Ke(),
      t
    ),
    ...n
  }
);
lh.displayName = "PaginationLink";
const e8 = ({
  className: t,
  ...e
}) => /* @__PURE__ */ d(
  lh,
  {
    role: "button",
    "aria-label": "Go to previous page",
    className: E(
      "border border-solid border-f1-border hover:border-f1-border-hover hover:bg-f1-background",
      t
    ),
    ...e,
    children: /* @__PURE__ */ d(me, { icon: qd })
  }
);
e8.displayName = "PaginationPrevious";
const t8 = ({
  className: t,
  ...e
}) => /* @__PURE__ */ d(
  lh,
  {
    role: "button",
    "aria-label": "Go to next page",
    className: E(
      "border border-solid border-f1-border hover:border-f1-border-hover hover:bg-f1-background",
      t
    ),
    ...e,
    children: /* @__PURE__ */ d(me, { icon: Oa })
  }
);
t8.displayName = "PaginationNext";
const n8 = ({
  className: t,
  ...e
}) => /* @__PURE__ */ d(
  "span",
  {
    role: "presentation",
    "aria-hidden": !0,
    className: E("flex h-9 w-9 items-center justify-center", t),
    ...e,
    children: /* @__PURE__ */ d(me, { icon: Ma })
  }
);
n8.displayName = "PaginationEllipsis";
function OEe({
  totalPages: t,
  currentPage: e = 1,
  onPageChange: n,
  showControls: i = !0,
  ariaLabel: r = "Page navigation",
  visibleRange: a = 3,
  hasNextPage: o = !0,
  disabled: s = !1
}) {
  const l = t === 0, c = Le(
    (f) => {
      n && (l || f >= 1 && f <= t) && n(f);
    },
    [n, t, l]
  ), u = ve(() => {
    if (l) return [];
    const f = [];
    if (t <= 5)
      return Array.from({ length: t }, (g, y) => y + 1);
    f.push(1);
    const m = Math.floor(a / 2);
    let h = e - m, p = e + m;
    return e <= m + 2 ? (h = 2, p = h + a - 1, f.push(
      ...Array.from(
        { length: p - h + 1 },
        (g, y) => y + h
      )
    ), f.push("...")) : e >= t - m - 1 ? (h = t - a - 1, p = t - 1, f.push("..."), f.push(
      ...Array.from(
        { length: p - h + 1 },
        (g, y) => y + h
      )
    )) : (f.push("..."), f.push(
      ...Array.from({ length: a }, (g, y) => y + h)
    ), f.push("...")), f.push(t), f;
  }, [e, t, a, l]);
  return /* @__PURE__ */ d(QP, { children: /* @__PURE__ */ k(ZP, { role: "navigation", "aria-label": r, children: [
    i && /* @__PURE__ */ d(Su, { children: /* @__PURE__ */ d(
      e8,
      {
        "aria-disabled": e === 1 || s,
        tabIndex: e === 1 ? -1 : 0,
        className: E(
          !l && "mr-1",
          e === 1 || s ? "pointer-events-none opacity-50" : ""
        ),
        onClick: () => c(e - 1),
        onKeyDown: (f) => {
          f.key === "Enter" && c(e - 1);
        }
      }
    ) }),
    !l && u.map((f, m) => /* @__PURE__ */ d(
      Su,
      {
        className: E(
          "hidden sm:flex",
          f === e && "flex",
          s && "pointer-events-none opacity-50"
        ),
        children: f === "..." ? /* @__PURE__ */ d(n8, {}) : /* @__PURE__ */ d(
          lh,
          {
            "aria-current": f === e ? "page" : void 0,
            isActive: f === e,
            onClick: () => c(f),
            onKeyDown: (h) => {
              h.key === "Enter" && c(f);
            },
            tabIndex: 0,
            children: f
          }
        )
      },
      m
    )),
    i && /* @__PURE__ */ d(Su, { children: /* @__PURE__ */ d(
      t8,
      {
        "aria-disabled": (l ? !o : e === t) || s,
        tabIndex: l ? o ? 0 : -1 : e === t ? -1 : 0,
        className: E(
          !l && "ml-1",
          !l && e === t || !o && l || s ? "pointer-events-none opacity-50" : ""
        ),
        onClick: () => c(e + 1),
        onKeyDown: (f) => {
          f.key === "Enter" && c(e + 1);
        }
      }
    ) })
  ] }) });
}
const O0 = ({
  paginationInfo: t,
  setPage: e,
  className: n
}) => {
  const i = et();
  return JP(t) && /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex w-full items-center justify-between px-6",
        n
      ),
      children: [
        /* @__PURE__ */ d("span", { className: "shrink-0 text-f1-foreground-secondary", children: t.total > 0 && `${(t.currentPage - 1) * t.perPage + 1}-${Math.min(
          t.currentPage * t.perPage,
          t.total
        )} ${i.collections.visualizations.pagination.of} ${t.total}` }),
        /* @__PURE__ */ d("div", { className: "flex items-center", children: /* @__PURE__ */ d(
          OEe,
          {
            totalPages: t.pagesCount,
            currentPage: t.currentPage,
            onPageChange: e,
            disabled: t.pagesCount <= 1
          }
        ) })
      ]
    }
  );
}, WEe = (t) => /* @__PURE__ */ d(gc, { level: t.level, text: t.label });
function i8(t) {
  return typeof t == "object" && t !== null && "placeholder" in t && typeof t.placeholder == "string";
}
function dh(t, e) {
  return i8(t) ? typeof t == "object" && t !== null && e in t ? t[e] === void 0 : !0 : !1;
}
function ch(t, e) {
  if (t !== void 0 && typeof t != "object")
    return t;
  if (!t || typeof t != "object")
    return;
  const i = e in t ? t[e] : void 0, a = i8(t) ? t.placeholder : void 0;
  if (i !== void 0)
    return e === "date" && i !== null && typeof i == "object" && "getTime" in i ? new Date(i.getTime()) : i;
  if (a !== void 0)
    return a;
}
function AEe(t) {
  if (X2(t))
    try {
      return t.toLocaleDateString();
    } catch {
      return String(t);
    }
  const e = ch(t, "date");
  if (X2(e))
    try {
      return e.toLocaleDateString();
    } catch {
      return String(e);
    }
  else {
    if (typeof e == "string")
      return e;
    if (e != null)
      return String(e);
  }
  return "";
}
function X2(t) {
  return !!(t instanceof Date || t && typeof t == "object" && ("toLocaleDateString" in t || "getTime" in t));
}
const LEe = (t, e) => {
  const n = ch(t, "amount"), i = dh(t, "amount");
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(
        "text-f1-foreground",
        e.visualization === "table" && "text-right",
        i && "text-f1-foreground-secondary"
      ),
      children: n
    }
  );
}, IEe = (t) => /* @__PURE__ */ d(Js, { avatars: t.avatarList, size: "xsmall", max: t.max }), REe = (t) => /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ d(
    ni,
    {
      avatar: {
        type: "company",
        name: t.name,
        src: t.src
      },
      size: "xsmall"
    }
  ),
  /* @__PURE__ */ d("span", { className: "text-f1-foreground", children: t.name })
] }), jEe = (t) => {
  const e = AEe(t), n = dh(t, "date");
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(
        "text-f1-foreground",
        n && "text-f1-foreground-secondary"
      ),
      children: e
    }
  );
}, FEe = (t) => /* @__PURE__ */ d(Qs, { text: t.label, color: t.color }), zEe = (t) => /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ d(me, { icon: t.icon }),
  /* @__PURE__ */ d("span", { className: "text-f1-foreground", children: t.label })
] }), VEe = (t, e) => {
  const n = ch(t, "number"), i = dh(t, "number");
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(
        "text-f1-foreground",
        e.visualization === "table" && "text-right",
        i && "text-f1-foreground-secondary"
      ),
      children: n
    }
  );
}, HEe = (t) => /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ d(
    ni,
    {
      avatar: {
        type: "person",
        firstName: t.firstName,
        lastName: t.lastName,
        src: t.src,
        badge: t.badge
      },
      size: "xsmall"
    }
  ),
  /* @__PURE__ */ k("span", { className: "text-f1-foreground", children: [
    t.firstName,
    " ",
    t.lastName
  ] })
] }), BEe = (t) => /* @__PURE__ */ d(Vr, { variant: t.status, text: t.label }), qEe = (t) => /* @__PURE__ */ d(Ni, { text: t.label, icon: t.icon }), GEe = (t) => /* @__PURE__ */ d(kC, { type: t.type, tags: t.tags, max: t.max }), XEe = (t) => /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
  /* @__PURE__ */ d(
    ni,
    {
      avatar: {
        type: "team",
        name: t.name,
        src: t.src
      },
      size: "xsmall"
    }
  ),
  /* @__PURE__ */ d("span", { className: "text-f1-foreground", children: t.name })
] }), YEe = (t) => {
  const e = ch(t, "text"), n = dh(t, "text");
  return /* @__PURE__ */ d(
    "span",
    {
      className: E(
        "text-f1-foreground",
        n && "text-f1-foreground-secondary"
      ),
      children: e
    }
  );
}, KEe = {
  text: YEe,
  number: VEe,
  date: jEe,
  amount: LEe,
  avatarList: IEe,
  status: BEe,
  alertTag: WEe,
  person: HEe,
  company: REe,
  team: XEe,
  tag: qEe,
  dotTag: FEe,
  tagList: GEe,
  icon: zEe
}, UEe = (t) => t !== void 0 && typeof t == "object", W0 = (t, e, n) => {
  const i = e.render(t), { type: r, value: a } = UEe(i) ? i : {
    type: "text",
    value: i ?? "-"
  }, o = KEe[r];
  return o ? a === void 0 ? "-" : o(a, {
    visualization: n,
    property: e
  }) : `[Invalid ${r} renderer]`;
}, JEe = (t) => Math.ceil(t / 12) * 12, r8 = ({ children: t }) => /* @__PURE__ */ d("div", { className: "grid grid-cols-1 gap-4 px-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4", children: t }), Y2 = ({
  source: t,
  items: e,
  selectedItems: n,
  handleSelectItemChange: i,
  cardProperties: r,
  title: a,
  description: o,
  avatar: s
}) => {
  const l = (c, u) => W0(c, u, "card");
  return /* @__PURE__ */ d(r8, { children: e.map((c, u) => {
    const f = t.selectable ? t.selectable(c) : void 0, m = t.itemUrl ? t.itemUrl(c) : void 0, h = t.itemOnClick ? t.itemOnClick(c) : void 0, p = (t.itemActions ? t.itemActions(c) || [] : []).filter((x) => x.type !== "separator"), g = (p.filter(
      (x) => x.type === "other" || !x.type
    ) || []).map((x) => ({
      ...x,
      // Reconverts the type to DropdownItemObject
      type: "item"
    })), y = p.find((x) => x.type === "primary") || void 0, v = p.filter((x) => x.type === "secondary") || [], w = !!t.selectable && f !== void 0;
    return /* @__PURE__ */ d(
      re.div,
      {
        layout: !0,
        initial: "hidden",
        animate: "visible",
        exit: "hidden",
        custom: u,
        variants: XP({
          delay: 0.02,
          duration: 0.3
        }),
        children: /* @__PURE__ */ d(
          FDe,
          {
            title: a(c),
            selectable: w,
            description: o ? o(c) : void 0,
            avatar: s ? s(c) : void 0,
            selected: w && n.has(f),
            onSelect: (x) => i(c, x),
            secondaryActions: v,
            primaryAction: y,
            otherActions: g,
            onClick: h,
            link: m,
            children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-2", children: r.map((x) => /* @__PURE__ */ k("div", { children: [
              /* @__PURE__ */ d("div", { className: "text-muted-foreground text-sm font-medium", children: x.label }),
              /* @__PURE__ */ d("div", { className: "text-sm", children: l(c, x) })
            ] }, String(x.label))) })
          },
          u
        )
      },
      u
    );
  }) });
}, QEe = ({
  cardProperties: t,
  title: e,
  description: n,
  avatar: i,
  source: r,
  onSelectItems: a,
  onLoadData: o,
  onLoadError: s
}) => {
  var M, _;
  const l = ve(() => {
    if (r.dataAdapter.paginationType === "pages") {
      const N = r.dataAdapter.perPage, $ = JEe(N ?? 24);
      return {
        ...r.dataAdapter,
        perPage: $
      };
    }
    return r.dataAdapter;
  }, [r.dataAdapter]), { data: c, paginationInfo: u, setPage: f, isInitialLoading: m } = E0(
    {
      ...r,
      dataAdapter: l
    },
    {
      onError: (N) => {
        s(N);
      }
    }
  );
  le(() => {
    o({
      totalItems: (u == null ? void 0 : u.total) || c.records.length,
      filters: r.currentFilters,
      search: r.currentSearch,
      isInitialLoading: m,
      data: c.records
    });
  }, [u == null ? void 0 : u.total, c.records]);
  const {
    selectedItems: h,
    groupAllSelectedStatus: p,
    handleSelectItemChange: g,
    handleSelectGroupChange: y
  } = T0(
    c,
    u,
    r,
    a,
    r.defaultSelectedItems
  ), v = (M = r.grouping) == null ? void 0 : M.collapsible, w = (_ = r.grouping) == null ? void 0 : _.defaultOpenGroups, { openGroups: x, setGroupOpen: b } = P0(
    (c == null ? void 0 : c.type) === "grouped" ? c.groups : [],
    w
  );
  return /* @__PURE__ */ k("div", { className: "flex min-h-0 flex-1 flex-col gap-4", children: [
    /* @__PURE__ */ d("div", { className: "overflow-auto", children: m ? /* @__PURE__ */ d(r8, { children: Array.from({ length: 8 }).map((N, $) => /* @__PURE__ */ k(Xd, { children: [
      /* @__PURE__ */ d(Yd, { children: /* @__PURE__ */ d(Kd, { "aria-label": "Loading card", children: /* @__PURE__ */ d(Ce, { className: "h-4 w-3/4" }) }) }),
      /* @__PURE__ */ d(Ud, { className: "space-y-2", children: t.map((D) => /* @__PURE__ */ k("div", { className: "space-y-1", children: [
        /* @__PURE__ */ d(Ce, { className: "h-3 w-1/4" }),
        /* @__PURE__ */ d(Ce, { className: "h-3 w-1/2" })
      ] }, String(D.label))) })
    ] }, $)) }) : /* @__PURE__ */ k(Ee, { children: [
      (c == null ? void 0 : c.type) === "grouped" && c.groups.map((N) => {
        var $, D;
        return /* @__PURE__ */ k(Ee, { children: [
          /* @__PURE__ */ d(
            C0,
            {
              label: N.label,
              itemCount: N.itemCount,
              onOpenChange: (W) => b(N.key, W),
              open: x[N.key],
              selectable: !!r.selectable,
              showOpenChange: v,
              select: ($ = p[N.key]) != null && $.checked ? !0 : (D = p[N.key]) != null && D.indeterminate ? "indeterminate" : !1,
              onSelectChange: (W) => y(N, W),
              className: "px-6 pb-2 pt-4"
            }
          ),
          /* @__PURE__ */ d(Ue, { children: (!v || x[N.key]) && /* @__PURE__ */ d(
            Y2,
            {
              source: r,
              items: N.records,
              selectedItems: h,
              handleSelectItemChange: g,
              title: e,
              cardProperties: t,
              description: n,
              avatar: i
            },
            N.key
          ) })
        ] });
      }),
      (c == null ? void 0 : c.type) === "flat" && /* @__PURE__ */ d(
        Y2,
        {
          source: r,
          items: c.records,
          selectedItems: h,
          handleSelectItemChange: g,
          title: e,
          cardProperties: t,
          description: n,
          avatar: i
        }
      )
    ] }) }),
    /* @__PURE__ */ d(O0, { paginationInfo: u, setPage: f })
  ] });
}, a8 = (t, e, n, i) => {
  const r = Oe(null);
  return le(() => {
    if (!sh(t) || !t.hasMore)
      return;
    const a = r.current;
    if (!a) return;
    const o = new IntersectionObserver(
      (s) => {
        s[0].isIntersecting && !e && !n && i();
      },
      {
        root: null,
        // viewport
        rootMargin: "200px",
        threshold: 0.1
      }
    );
    return o.observe(a), () => {
      o.disconnect();
    };
  }, [t, n, i, e]), {
    loadingIndicatorRef: r
    // Ref to the loading indicator (that is also used as a trigger for the infinite scroll)
  };
}, o8 = (t, e) => (t && t(e) || []).filter(
  (n) => n.type === "separator" || n.enabled === void 0 || n.enabled
), bg = ({
  items: t,
  onOpenChange: e,
  align: n = "end",
  className: i
}) => {
  const [r, a] = q(!1);
  return !t || t.length === 0 ? null : /* @__PURE__ */ d("div", { className: E("pointer-events-auto", i), children: /* @__PURE__ */ d(
    In,
    {
      align: n,
      items: t.map((o) => o.type === "separator" ? o : {
        ...o,
        type: "item"
      }),
      open: r,
      onOpenChange: (o) => {
        a(o), e == null || e(o);
      },
      children: /* @__PURE__ */ d(
        ue,
        {
          icon: Tm,
          label: "Actions",
          hideLabel: !0,
          round: !0,
          variant: "ghost",
          pressed: r
        }
      )
    }
  ) });
}, ZEe = (t) => t && t.checked ? t.indeterminate ? "indeterminate" : !0 : !1, wg = (t) => (t || []).map((e) => e.type === "separator" ? e : {
  ...e,
  type: "item"
}), eTe = ({ title: t, avatar: e, description: n }) => /* @__PURE__ */ k("article", { className: "flex w-[calc(100%-72px)] min-w-40 flex-col items-start gap-3 md:w-full md:flex-row md:items-center md:gap-2", children: [
  e && /* @__PURE__ */ d(ni, { avatar: e, size: "medium" }),
  /* @__PURE__ */ k("div", { className: "flex flex-1 flex-col gap-0.5 md:gap-1", children: [
    /* @__PURE__ */ d("header", { children: /* @__PURE__ */ d("h3", { children: /* @__PURE__ */ d(Cs, { className: "text-base font-medium text-f1-foreground", children: t }) }) }),
    /* @__PURE__ */ d("aside", { children: n && n.length > 0 && /* @__PURE__ */ d("div", { className: "flex w-full flex-col text-base font-normal text-f1-foreground-secondary md:flex-row md:gap-1", children: n.map((i, r) => /* @__PURE__ */ k("div", { className: "flex min-w-0 gap-1", children: [
      /* @__PURE__ */ d(Cs, { children: i }),
      r < n.length - 1 && /* @__PURE__ */ d("span", { className: "hidden md:inline", children: " · " })
    ] }, r)) }) })
  ] })
] }), tTe = ({
  source: t,
  item: e,
  selectedItems: n,
  handleSelectItemChange: i,
  fields: r,
  itemDefinition: a
}) => {
  const o = (M, _) => W0(M, _, "table"), { actions: s } = et(), l = t.itemUrl ? t.itemUrl(e) : void 0, c = t.itemOnClick ? t.itemOnClick(e) : void 0, u = t.selectable ? t.selectable(e) : void 0, f = a(e), m = o8(t.itemActions, e), h = m.filter(
    (M) => M.type === "primary"
  ).slice(0, 2), p = wg(
    m.filter(
      (M) => M.type === "separator" || !h.includes(M)
    )
  ), g = wg([
    ...h,
    ...m.filter(
      (M) => M.type === "separator" || !h.includes(M)
    )
  ]), [y, v] = q(!1), [w, x] = q(null), b = (M) => {
    if (!M) {
      x(
        setTimeout(() => {
          v(!1);
        }, 100)
      );
      return;
    }
    w && (clearTimeout(w), x(null)), v(!0);
  };
  return /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "relative flex w-full flex-col justify-between gap-4 p-3 transition-colors md:flex-row md:p-2 md:pl-3 md:pr-4",
        "group after:absolute after:inset-y-0 after:-right-px after:z-10 after:hidden after:h-full after:w-10 after:bg-gradient-to-r after:from-transparent after:via-f1-background after:via-75% after:to-f1-background after:transition-all after:content-[''] hover:after:via-[#F5F6F8] hover:after:to-[#F5F6F8] dark:hover:after:via-[#192231] dark:hover:after:to-[#192231] md:after:block hover:md:bg-f1-background-hover",
        y && "md:bg-f1-background-hover"
      ),
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row items-center gap-2", children: [
          t.selectable && u !== void 0 && // z-10 is needed here to prevent the checkbox from not being selectable when itemHref is provided
          /* @__PURE__ */ d("div", { className: "z-10 hidden items-center justify-end md:flex", children: /* @__PURE__ */ d(
            Ps,
            {
              checked: n.has(u),
              onCheckedChange: (M) => i(e, M),
              title: `Select ${t.selectable(e)}`,
              hideLabel: !0
            }
          ) }),
          l && /* @__PURE__ */ d(ns, { href: l, className: "absolute inset-0 block", tabIndex: 0, children: /* @__PURE__ */ d("span", { className: "sr-only", children: s.view }) }),
          /* @__PURE__ */ d(
            eTe,
            {
              title: f.title,
              avatar: f.avatar,
              description: f.description
            }
          )
        ] }),
        /* @__PURE__ */ d("div", { className: "flex flex-col items-start md:flex-row md:items-center [&>div]:justify-end", children: (r || []).map((M) => /* @__PURE__ */ d("div", { onClick: c, children: /* @__PURE__ */ d("div", { className: "flex items-center justify-center px-0 py-1 md:p-3 [&>span]:whitespace-nowrap", children: o(e, M) }) }, String(M.label))) }),
        t.itemActions && /* @__PURE__ */ k(Ee, { children: [
          /* @__PURE__ */ k(
            "aside",
            {
              className: E(
                "absolute -right-px bottom-0 top-0 z-20 hidden items-center justify-end gap-2 py-2 pl-20 pr-3 opacity-0 transition-all group-hover:opacity-100 md:flex",
                "bg-gradient-to-l from-[#F5F6F8] from-0% dark:from-[#192231]",
                "via-[#F5F6F8] via-60% dark:via-[#192231]",
                "to-transparent to-100%",
                y ? "opacity-100" : "opacity-0"
              ),
              children: [
                h.map((M) => /* @__PURE__ */ d(
                  ue,
                  {
                    label: M.label,
                    variant: "outline",
                    onClick: M.onClick,
                    icon: M.icon
                  },
                  M.label
                )),
                /* @__PURE__ */ d(
                  bg,
                  {
                    align: "end",
                    items: p,
                    onOpenChange: b
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ d("div", { className: "absolute right-3 top-3 flex h-8 w-8 items-center justify-center md:hidden", children: /* @__PURE__ */ d(
            bg,
            {
              align: "end",
              items: g,
              onOpenChange: b
            }
          ) })
        ] }),
        t.selectable && u !== void 0 && /* @__PURE__ */ d(
          "div",
          {
            className: E(
              "absolute right-3 top-3 flex h-8 w-8 items-center justify-center md:hidden",
              t.itemActions && "right-12"
            ),
            children: /* @__PURE__ */ d(
              Ps,
              {
                checked: n.has(u),
                onCheckedChange: (M) => i(e, M),
                title: `Select ${t.selectable(e)}`,
                hideLabel: !0
              }
            )
          }
        )
      ]
    }
  );
}, K2 = ({
  source: t,
  items: e,
  selectedItems: n,
  handleSelectItemChange: i,
  fields: r,
  itemDefinition: a
}) => /* @__PURE__ */ d("div", { className: "flex flex-col overflow-hidden rounded-xl border border-solid border-f1-border-secondary [&>div:last-child]:border-b-transparent [&>div]:border [&>div]:border-solid [&>div]:border-transparent [&>div]:border-b-f1-border-secondary", children: e.map((o, s) => /* @__PURE__ */ d(
  tTe,
  {
    source: t,
    item: o,
    selectedItems: n,
    handleSelectItemChange: i,
    fields: r,
    itemDefinition: a
  },
  `row-${s}`
)) }), nTe = ({
  fields: t,
  itemDefinition: e,
  source: n,
  onSelectItems: i,
  onLoadData: r,
  onLoadError: a
}) => {
  var _, N;
  const {
    data: o,
    paginationInfo: s,
    setPage: l,
    isInitialLoading: c,
    isLoadingMore: u,
    loadMore: f
  } = E0(n, {
    onError: ($) => {
      a($);
    }
  });
  le(() => {
    r({
      totalItems: (s == null ? void 0 : s.total) || o.records.length,
      filters: n.currentFilters,
      search: n.currentSearch,
      isInitialLoading: c,
      data: o.records
    });
  }, [s == null ? void 0 : s.total, o.records]);
  const { isLoading: m } = n, { loadingIndicatorRef: h } = a8(
    s,
    m,
    u,
    f
  ), {
    selectedItems: p,
    groupAllSelectedStatus: g,
    handleSelectItemChange: y,
    handleSelectGroupChange: v
  } = T0(
    o,
    s,
    n,
    i,
    n.defaultSelectedItems
  ), w = (_ = n.grouping) == null ? void 0 : _.collapsible, x = (N = n.grouping) == null ? void 0 : N.defaultOpenGroups, { openGroups: b, setGroupOpen: M } = P0(
    (o == null ? void 0 : o.type) === "grouped" ? o.groups : [],
    x
  );
  return c ? /* @__PURE__ */ d("div", { className: "flex min-h-0 flex-1 flex-col gap-4 overflow-hidden rounded-xl border border-solid border-f1-border-secondary [&>div:last-child]:border-b-transparent [&>div]:border [&>div]:border-solid [&>div]:border-transparent [&>div]:border-b-f1-border-secondary", children: Array.from({ length: 10 }).map(($, D) => /* @__PURE__ */ k(
    "div",
    {
      className: "flex flex-col items-start gap-3 p-3 md:h-18 md:flex-row md:items-center md:justify-between md:gap-2",
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-2", children: [
          /* @__PURE__ */ d(Ce, { className: "h-4 w-28" }),
          /* @__PURE__ */ k("div", { className: "flex flex-col gap-2 md:flex-row", children: [
            /* @__PURE__ */ d(Ce, { className: "h-3 w-10" }),
            /* @__PURE__ */ d(Ce, { className: "h-3 w-10" })
          ] })
        ] }),
        /* @__PURE__ */ k("div", { className: "flex flex-col gap-2 md:flex-row", children: [
          /* @__PURE__ */ d(Ce, { className: "h-4 w-16" }),
          /* @__PURE__ */ d(Ce, { className: "h-4 w-16" }),
          /* @__PURE__ */ d(Ce, { className: "h-4 w-16" })
        ] })
      ]
    },
    D
  )) }) : (n.sortings || t.forEach(($) => {
    $.sorting && console.warn(
      "Sorting is defined on a property but no sortings are provided in the data source"
    );
  }), /* @__PURE__ */ k("div", { className: "flex max-h-full min-h-0 flex-1 flex-col gap-4 px-4 py-2", children: [
    /* @__PURE__ */ d(
      "div",
      {
        className: E(
          "flex min-h-0 flex-1 flex-col gap-2",
          m && "select-none opacity-50 transition-opacity"
        ),
        "aria-live": m ? "polite" : void 0,
        "aria-busy": m ? "true" : void 0,
        children: /* @__PURE__ */ k("div", { className: "min-h-0 flex-1 overflow-auto", children: [
          /* @__PURE__ */ d(Ue, { children: m && /* @__PURE__ */ d(
            re.div,
            {
              className: "absolute inset-0 flex cursor-progress items-center justify-center",
              initial: { opacity: 0 },
              animate: { opacity: 1 },
              exit: { opacity: 0 },
              children: /* @__PURE__ */ d(pc, {})
            }
          ) }),
          o.type === "grouped" && o.groups.map(($) => {
            var W, j;
            const D = $.itemCount;
            return /* @__PURE__ */ k(
              "div",
              {
                className: "flex flex-col gap-0 pt-2 first:pt-0",
                children: [
                  /* @__PURE__ */ d(
                    C0,
                    {
                      className: "cursor-pointer select-none rounded-md px-6 py-3 transition-colors hover:bg-f1-background-hover",
                      selectable: !!n.selectable,
                      select: (W = g[$.key]) != null && W.checked ? !0 : (j = g[$.key]) != null && j.indeterminate ? "indeterminate" : !1,
                      onSelectChange: (O) => v($, O),
                      showOpenChange: w,
                      label: $.label,
                      itemCount: D,
                      open: b[$.key],
                      onOpenChange: (O) => M($.key, O)
                    },
                    `group-header-${$.key}`
                  ),
                  /* @__PURE__ */ d(Ue, { children: (!w || b[$.key]) && /* @__PURE__ */ d(
                    re.div,
                    {
                      initial: { height: 0, opacity: 0 },
                      animate: { height: "auto", opacity: 1 },
                      exit: { height: 0, opacity: 0 },
                      transition: { duration: 0.1, ease: "easeInOut" },
                      className: "mt-0.5",
                      children: /* @__PURE__ */ d(
                        K2,
                        {
                          source: n,
                          items: $.records,
                          selectedItems: p,
                          handleSelectItemChange: y,
                          fields: t,
                          itemDefinition: e
                        },
                        `list-group-${$.key}`
                      )
                    }
                  ) })
                ]
              },
              `group-header-${$.key}`
            );
          }),
          (o == null ? void 0 : o.type) === "flat" && /* @__PURE__ */ d(
            K2,
            {
              source: n,
              items: o.records,
              selectedItems: p,
              handleSelectItemChange: y,
              fields: t,
              itemDefinition: e
            }
          ),
          sh(s) && s.hasMore && /* @__PURE__ */ d(
            "div",
            {
              ref: h,
              className: "h-10 w-full",
              "aria-hidden": "true"
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ d(O0, { paginationInfo: s, setPage: l })
  ] }));
}, A0 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d("div", { className: "relative w-full", children: /* @__PURE__ */ d(
  "table",
  {
    ref: n,
    className: E(
      "w-full caption-bottom border-spacing-0 border-0 border-none text-base",
      t
    ),
    ...e
  }
) }));
A0.displayName = "Table";
const s8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "thead",
  {
    ref: n,
    className: E(
      "relative min-h-10 [&_tr]:hover:bg-transparent",
      "before:absolute before:inset-x-0 before:top-0 before:h-px before:w-full before:bg-f1-border-secondary before:content-['']",
      t
    ),
    ...e
  }
));
s8.displayName = "TableHeader";
const l8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d("tbody", { ref: n, className: E("border-0", t), ...e }));
l8.displayName = "TableBody";
const d8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "tfoot",
  {
    ref: n,
    className: E(
      "bg-muted/50 border-t font-medium [&>tr]:last:border-b-0",
      t
    ),
    ...e
  }
));
d8.displayName = "TableFooter";
const c8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "tr",
  {
    ref: n,
    className: E(
      "group relative transition-colors after:absolute after:inset-x-0 after:bottom-0 after:h-px after:w-full after:bg-f1-border-secondary after:content-[''] hover:bg-f1-background-hover",
      t
    ),
    ...e
  }
));
c8.displayName = "TableRow";
const u8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "th",
  {
    ref: n,
    className: E(
      "relative px-3 py-2.5 text-left align-middle font-medium text-f1-foreground-secondary first:pl-6 last:pr-6",
      "after:pointer-events-none after:absolute after:inset-x-0 after:inset-y-1 after:rounded after:bg-transparent after:transition-colors after:content-[''] first:after:left-3 last:after:right-3 hover:after:bg-f1-background-hover",
      "[&:has([role=checkbox])]:px-2 [&:has([role=checkbox])]:hover:after:bg-transparent",
      t
    ),
    ...e
  }
));
u8.displayName = "TableHead";
const f8 = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "td",
  {
    ref: n,
    className: E(
      "relative h-[48px] whitespace-nowrap px-3 align-middle first:pl-6 last:pr-6",
      "[&:has([role=checkbox])]:px-2",
      t
    ),
    ...e
  }
));
f8.displayName = "TableCell";
const iTe = S.forwardRef(({ className: t, ...e }, n) => /* @__PURE__ */ d(
  "caption",
  {
    ref: n,
    className: E("text-muted-foreground mt-4 text-sm", t),
    ...e
  }
));
iTe.displayName = "TableCaption";
const L0 = hn(
  void 0
);
function m8() {
  const t = Wt(L0);
  if (!t)
    throw new Error("useTable must be used within a TableProvider");
  return t;
}
function h8({ children: t }) {
  return /* @__PURE__ */ d(l8, { children: t });
}
const rTe = {
  auto: void 0,
  fit: 1
}, aTe = (t) => typeof t == "number", p8 = (t) => aTe(t) ? t : rTe[t];
function ir({
  children: t,
  href: e,
  onClick: n,
  width: i = "auto",
  firstCell: r = !1,
  sticky: a,
  colSpan: o
}) {
  const { isScrolled: s, isScrolledRight: l } = m8(), { actions: c } = et(), u = (a == null ? void 0 : a.left) !== void 0, f = (a == null ? void 0 : a.right) !== void 0, m = u || f, h = a == null ? void 0 : a.left, p = a == null ? void 0 : a.right, g = p8(i);
  return /* @__PURE__ */ k(
    f8,
    {
      colSpan: o,
      className: E(
        r && "peer font-medium",
        m && s && "bg-f1-background before:absolute before:inset-0 before:z-[-1] before:h-[calc(100%-1px)] before:w-full before:bg-f1-background before:transition-all before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-px after:w-full after:bg-f1-border-secondary after:content-[''] group-hover:before:bg-f1-background-hover",
        m && "sticky z-10",
        f && "bg-f1-background before:absolute before:inset-0 before:z-[-1] before:h-[calc(100%-1px)] before:w-full before:bg-f1-background before:transition-all before:content-[''] after:absolute after:inset-x-0 after:bottom-0 after:h-px after:w-full after:bg-f1-border-secondary after:content-[''] group-hover:before:bg-f1-background-hover"
      ),
      style: {
        width: g,
        maxWidth: g,
        minWidth: g,
        left: h,
        right: p
      },
      children: [
        /* @__PURE__ */ d(Ue, { children: (u && s || f && l) && /* @__PURE__ */ d(
          re.div,
          {
            className: E(
              "absolute inset-y-0 h-full w-4 from-f1-foreground-secondary to-transparent",
              u && "-right-4 bg-gradient-to-r",
              f && "-left-4 bg-gradient-to-l"
            ),
            initial: { opacity: 0 },
            animate: { opacity: 0.1 },
            exit: { opacity: 0 }
          },
          "cell-shadow-gradient"
        ) }),
        /* @__PURE__ */ d(
          "div",
          {
            className: E(
              "[&:has([role=checkbox])]:relative [&:has([role=checkbox])]:z-[1]",
              "[&:has([type=button])]:relative [&:has([type=button])]:z-[1]",
              "[&:has(a)]:relative [&:has(a)]:z-[1]",
              "pointer-events-none"
            ),
            children: /* @__PURE__ */ d(
              "div",
              {
                className: (E(i !== "auto" && "overflow-hidden"), "relative z-[1]"),
                children: t
              }
            )
          }
        ),
        e && /* @__PURE__ */ d(
          _n,
          {
            href: e,
            className: "pointer-events-auto absolute inset-0 !z-0 block bg-[#00]",
            tabIndex: r ? void 0 : -1,
            children: /* @__PURE__ */ d("span", { className: "sr-only", children: c.view })
          }
        ),
        n && /* @__PURE__ */ d(
          "button",
          {
            type: "button",
            onClick: (y) => {
              y.stopPropagation(), n();
            },
            "data-testid": "table-cell-action-button",
            className: "table-cell-action-button absolute inset-0 !z-0 block",
            tabIndex: r ? void 0 : -1,
            onKeyDown: (y) => {
              (y.key === "Enter" || y.key === " ") && (y.preventDefault(), n());
            },
            children: /* @__PURE__ */ d("span", { className: "sr-only", children: c.view })
          }
        )
      ]
    }
  );
}
function Nu({
  children: t,
  width: e = "auto",
  sortState: n = "none",
  onSortClick: i,
  info: r,
  infoIcon: a = Ey,
  sticky: o,
  hidden: s = !1,
  align: l = "left"
}) {
  const { isScrolled: c, isScrolledRight: u } = m8(), f = (o == null ? void 0 : o.left) !== void 0, m = (o == null ? void 0 : o.right) !== void 0, h = f || m, p = (o == null ? void 0 : o.left) ?? 0, g = (o == null ? void 0 : o.right) ?? 0, y = i || r, v = /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex items-center whitespace-nowrap",
        y && "gap-1",
        l === "right" && "flex-row-reverse"
      ),
      children: [
        /* @__PURE__ */ d("div", { className: E("truncate", e !== "auto" && "overflow-hidden"), children: t }),
        y && /* @__PURE__ */ k("div", { className: "flex items-center", children: [
          r && /* @__PURE__ */ d("div", { className: "flex h-6 w-6 items-center justify-center text-f1-foreground-secondary", children: /* @__PURE__ */ d(Kt, { label: r, children: /* @__PURE__ */ d(
            "div",
            {
              className: E(
                "flex h-5 w-5 items-center justify-center rounded-xs",
                Ke()
              ),
              tabIndex: 0,
              children: /* @__PURE__ */ d(me, { icon: a, size: "sm" })
            }
          ) }) }),
          i && /* @__PURE__ */ d(
            re.button,
            {
              onClick: i,
              className: E(
                "relative h-5 w-5 rounded-xs p-1 text-f1-foreground-secondary opacity-0 transition-all focus-within:opacity-100 hover:bg-f1-background-hover group-hover:opacity-100",
                Ke()
              ),
              "aria-label": "Sort",
              whileTap: { scale: 0.8 },
              transition: { duration: 0.1 },
              children: /* @__PURE__ */ k(Ue, { children: [
                /* @__PURE__ */ d(
                  re.div,
                  {
                    className: "absolute left-1 top-1 flex h-3 w-3 items-center justify-center",
                    animate: {
                      rotate: n === "desc" ? 0 : 180,
                      x: n === "none" ? -3 : 0,
                      y: n === "none" ? -1 : 0,
                      scale: n === "none" ? 0.9 : 1
                    },
                    transition: {
                      duration: 0.2,
                      ease: [0.175, 0.885, 0.32, 1.275]
                    },
                    children: /* @__PURE__ */ d(me, { icon: ad, size: "xs" })
                  },
                  "sort-arrow"
                ),
                n === "none" && /* @__PURE__ */ d(
                  re.div,
                  {
                    className: "absolute left-1 top-1 flex h-3 w-3 items-center justify-center",
                    initial: { opacity: 0, x: 0, y: 0, scale: 0.9 },
                    animate: { opacity: 1, x: 3, y: 1, scale: 0.9 },
                    exit: { opacity: 0, x: 0, y: 0, scale: 0.9 },
                    transition: {
                      duration: 0.2,
                      ease: [0.175, 0.885, 0.32, 1.275]
                    },
                    children: /* @__PURE__ */ d(me, { icon: ad, size: "xs" })
                  },
                  "sort-arrow-secondary"
                )
              ] })
            }
          )
        ] })
      ]
    }
  ) }), w = p8(e);
  return /* @__PURE__ */ k(
    u8,
    {
      className: E(
        "group",
        "bg-f1-background",
        h && (c || u) && "relative bg-f1-background before:absolute before:inset-x-0 before:bottom-0 before:h-px before:w-full before:bg-f1-border-secondary before:content-['']",
        h && "sticky z-10",
        s && "after:hidden"
      ),
      tabIndex: o ? 0 : void 0,
      style: {
        width: w,
        maxWidth: w,
        minWidth: w,
        left: p,
        right: g
      },
      role: s ? "presentation" : void 0,
      "aria-sort": i ? n === "asc" ? "ascending" : n === "desc" ? "descending" : "none" : void 0,
      children: [
        /* @__PURE__ */ d("div", { className: "absolute inset-x-0 top-0 z-[1] h-px w-full bg-f1-border-secondary" }),
        /* @__PURE__ */ d(Ue, { children: (f && c || m && u) && /* @__PURE__ */ d(
          re.div,
          {
            className: E(
              "absolute inset-y-0 h-full w-4 from-f1-foreground-secondary to-transparent",
              f && "-right-4 bg-gradient-to-r",
              m && "-left-4 bg-gradient-to-l"
            ),
            initial: { opacity: 0 },
            animate: { opacity: 0.1 },
            exit: { opacity: 0 }
          },
          "shadow-gradient"
        ) }),
        !s && v
      ]
    }
  );
}
function g8({ children: t, sticky: e = !1 }) {
  return /* @__PURE__ */ d(s8, { className: E(e && "sticky top-0 z-20"), children: t });
}
const ua = X(
  ({ children: t, selected: e, className: n, sticky: i }, r) => /* @__PURE__ */ d(
    c8,
    {
      ref: r,
      className: E(
        e && "bg-f1-background-selected hover:bg-f1-background-selected",
        n,
        "relative before:pointer-events-none before:absolute before:inset-0 before:z-10 before:content-['']",
        "[&:has(.table-cell-action-button:focus)]:before:rounded-sm [&:has(.table-cell-action-button:focus)]:before:ring-1 [&:has(.table-cell-action-button:focus)]:before:ring-inset [&:has(.table-cell-action-button:focus)]:before:ring-f1-ring",
        "[&:has(a:focus)]:before:rounded-sm [&:has(a:focus)]:before:ring-1 [&:has(a:focus)]:before:ring-inset [&:has(a:focus)]:before:ring-f1-ring",
        i && "hover:bg-f1-background-hover! sticky top-10 z-50 bg-f1-background"
      ),
      children: t
    }
  )
);
ua.displayName = "TableRow";
function oTe({ children: t, loading: e = !1 }) {
  const [n, i] = q(!1), [r, a] = q(!1), o = Oe(null);
  return le(() => {
    const s = o.current;
    if (!s) return;
    const l = () => {
      i(s.scrollLeft > 0), a(
        s.scrollWidth - s.scrollLeft - s.clientWidth > 0
      );
    };
    return l(), s.addEventListener("scroll", l), () => {
      s.removeEventListener("scroll", l);
    };
  }, []), /* @__PURE__ */ d(
    L0.Provider,
    {
      value: { isScrolled: n, setIsScrolled: i, isScrolledRight: r, setIsScrolledRight: a },
      children: /* @__PURE__ */ k("div", { ref: o, className: "relative h-full w-full overflow-auto", children: [
        /* @__PURE__ */ d(
          A0,
          {
            className: E(e && "select-none opacity-50 transition-opacity"),
            "aria-live": e ? "polite" : void 0,
            "aria-busy": e ? "true" : void 0,
            children: t
          }
        ),
        /* @__PURE__ */ d(Ue, { children: e && /* @__PURE__ */ d(
          re.div,
          {
            className: "absolute inset-0 flex cursor-progress items-center justify-center",
            initial: { opacity: 0 },
            animate: { opacity: 1 },
            exit: { opacity: 0 },
            children: /* @__PURE__ */ d(pc, {})
          }
        ) })
      ] })
    }
  );
}
function sTe({ columns: t = 5 }) {
  return /* @__PURE__ */ d(
    L0.Provider,
    {
      value: {
        isScrolled: !1,
        setIsScrolled: () => {
        },
        isScrolledRight: !1,
        setIsScrolledRight: () => {
        }
      },
      children: /* @__PURE__ */ k(
        A0,
        {
          className: "cursor-progress",
          role: "presentation",
          "aria-hidden": "true",
          children: [
            /* @__PURE__ */ d(g8, { children: /* @__PURE__ */ d(ua, { children: Array.from({ length: t }).map((e, n) => /* @__PURE__ */ d(Nu, { children: /* @__PURE__ */ d(Ce, { className: "h-4 w-[80px]" }) }, `skeleton-header-${n}`)) }) }),
            /* @__PURE__ */ d(h8, { children: Array.from({ length: 5 }).map((e, n) => /* @__PURE__ */ d(ua, { children: Array.from({ length: t }).map((i, r) => /* @__PURE__ */ d(ir, { children: /* @__PURE__ */ d(Ce, { className: "h-4 w-[80px]" }) }, `skeleton-cell-${n}-${r}`)) }, `skeleton-row-${n}`)) })
          ]
        }
      )
    }
  );
}
const U2 = Bt(oTe, sTe);
function lTe({ children: t }) {
  return /* @__PURE__ */ d(
    d8,
    {
      className: E(
        "bg-f1-background-default sticky bottom-0 z-10 shadow-[0_-1px_0_0_var(--f1-border-secondary)]"
      ),
      children: t
    }
  );
}
const dTe = ({
  source: t,
  item: e,
  onCheckedChange: n,
  selectedItems: i,
  columns: r,
  frozenColumnsLeft: a,
  checkColumnWidth: o,
  index: s,
  groupIndex: l
}, c) => {
  const u = t.itemUrl ? t.itemUrl(e) : void 0, f = t.itemOnClick ? t.itemOnClick(e) : void 0, m = t.selectable ? t.selectable(e) : void 0, h = (y, v) => W0(y, v, "table"), p = `table-row-${l}-${s}`, g = o8(t.itemActions, e);
  return /* @__PURE__ */ k(ua, { ref: c, children: [
    t.selectable && /* @__PURE__ */ d(ir, { width: o, sticky: { left: 0 }, children: m !== void 0 && /* @__PURE__ */ d("div", { className: "pointer-events-auto flex items-center justify-end", children: /* @__PURE__ */ d(
      Ys,
      {
        checked: i.has(m),
        onCheckedChange: n,
        title: `Select ${t.selectable(e)}`,
        hideLabel: !0
      }
    ) }) }),
    r.map((y, v) => /* @__PURE__ */ d(
      ir,
      {
        firstCell: v === 0,
        href: u,
        onClick: f,
        width: y.width,
        sticky: v < a ? {
          left: r.slice(0, Math.max(0, v)).reduce(
            (w, x) => w + (x.width ?? 0),
            o
          )
        } : void 0,
        children: /* @__PURE__ */ d(
          "div",
          {
            className: E(
              y.align === "right" ? "justify-end" : "",
              "flex"
            ),
            children: h(e, y)
          }
        )
      },
      `table-cell-${l}-${s}-${v}`
    )),
    t.itemActions && /* @__PURE__ */ d(
      ir,
      {
        width: 68,
        sticky: {
          right: 0
        },
        href: u,
        onClick: f,
        children: /* @__PURE__ */ d(
          bg,
          {
            items: wg(g),
            className: "pointer-events-auto"
          }
        )
      },
      `table-cell-${l}-${s}-actions`
    )
  ] }, p);
}, J2 = X(dTe), cTe = ({
  columns: t,
  source: e,
  frozenColumns: n = 0,
  onSelectItems: i,
  onLoadData: r,
  onLoadError: a
}) => {
  var K, ae;
  const o = et(), [s] = q(
    () => re.create(
      J2
    )
  ), {
    data: l,
    paginationInfo: c,
    setPage: u,
    isInitialLoading: f,
    isLoadingMore: m,
    loadMore: h,
    summaries: p
  } = E0(
    e,
    {
      onError: (Q) => {
        a(Q);
      }
    }
  ), { currentSortings: g, setCurrentSortings: y, isLoading: v } = e, { loadingIndicatorRef: w } = a8(
    c,
    v,
    m,
    h
  );
  le(() => {
    r({
      totalItems: (c == null ? void 0 : c.total) || l.records.length,
      filters: e.currentFilters,
      search: e.currentSearch,
      isInitialLoading: f,
      data: l.records
    });
  }, [c == null ? void 0 : c.total, l.records]);
  const x = ve(() => n, [n]), {
    selectedItems: b,
    allSelectedStatus: M,
    groupAllSelectedStatus: _,
    handleSelectItemChange: N,
    handleSelectAll: $,
    handleSelectGroupChange: D
  } = T0(
    l,
    c,
    e,
    i,
    e.defaultSelectedItems
  ), W = ve(() => {
    var Q;
    return console.warn("summariesData", p), console.warn("source.summaries", e.summaries), !p || !e.summaries ? null : {
      data: p,
      sticky: !0,
      label: (Q = e.summaries) == null ? void 0 : Q.label
    };
  }, [p, e.summaries]), j = (Q, te, be) => {
    if (!(!Q || !te))
      return be === null ? "none" : be.field === Q ? be.order : "none";
  }, O = (Q) => {
    y(() => !g || g.field !== Q ? {
      field: Q,
      order: "asc"
    } : g.order === "asc" ? {
      field: Q,
      order: "desc"
    } : null);
  }, I = (K = e.grouping) == null ? void 0 : K.collapsible, L = (ae = e.grouping) == null ? void 0 : ae.defaultOpenGroups, { openGroups: R, setGroupOpen: B } = P0(
    (l == null ? void 0 : l.type) === "grouped" ? l.groups : [],
    L
  ), F = t.length + (e.itemActions ? 1 : 0) + (e.selectable ? 1 : 0);
  if (f)
    return /* @__PURE__ */ d(U2.Skeleton, { columns: F });
  e.sortings || t.forEach((Q) => {
    Q.sorting && console.warn(
      "Sorting is defined on a column but no sortings are provided in the data source"
    );
  });
  const z = e.selectable ? 52 : 0;
  return /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ k(U2, { loading: v, children: [
      /* @__PURE__ */ d(g8, { sticky: !0, children: /* @__PURE__ */ k(ua, { children: [
        e.selectable && /* @__PURE__ */ d(
          Nu,
          {
            width: z,
            sticky: { left: 0 },
            align: "right",
            children: /* @__PURE__ */ d("div", { className: "flex w-full items-center justify-end", children: /* @__PURE__ */ d(
              Ps,
              {
                checked: M.checked,
                indeterminate: M.indeterminate,
                onCheckedChange: $,
                title: "Select all",
                hideLabel: !0,
                disabled: (l == null ? void 0 : l.records.length) === 0
              }
            ) })
          }
        ),
        t.map(({ sorting: Q, label: te, ...be }, Pe) => /* @__PURE__ */ d(
          Nu,
          {
            sortState: j(
              Q,
              e.sortings,
              g
            ),
            width: be.width,
            align: be.align,
            sticky: Pe < x ? {
              left: t.slice(0, Math.max(0, Pe)).reduce(
                (We, $e) => We + ($e.width ?? 0),
                z
              )
            } : void 0,
            ...be,
            onSortClick: Q ? () => {
              Q && O(Q);
            } : void 0,
            children: te
          },
          `table-head-${Pe}`
        )),
        e.itemActions && /* @__PURE__ */ d(
          Nu,
          {
            width: 68,
            hidden: !0,
            sticky: {
              right: 0
            },
            children: o.collections.actions.actions
          },
          "actions"
        )
      ] }) }),
      /* @__PURE__ */ k(h8, { children: [
        (l == null ? void 0 : l.type) === "grouped" && l.groups.map((Q, te) => {
          const be = Q.itemCount;
          return /* @__PURE__ */ k(rd, { children: [
            /* @__PURE__ */ k(ua, { sticky: !0, children: [
              /* @__PURE__ */ d(
                ir,
                {
                  sticky: { left: 0 },
                  colSpan: (x || 1) + (e.selectable ? 1 : 0),
                  children: /* @__PURE__ */ d(
                    C0,
                    {
                      className: "px-4",
                      selectable: !!e.selectable,
                      select: ZEe(
                        _[Q.key]
                      ),
                      onSelectChange: (Pe) => D(Q, Pe),
                      showOpenChange: I,
                      label: Q.label,
                      itemCount: be,
                      open: R[Q.key],
                      onOpenChange: (Pe) => B(Q.key, Pe)
                    }
                  )
                }
              ),
              /* @__PURE__ */ d(
                ir,
                {
                  colSpan: t.length - (x || 1) + (e.selectable ? 1 : 0),
                  children: " "
                }
              )
            ] }, `group-header-${Q.key}`),
            /* @__PURE__ */ d(Ue, { children: s && (!I || R[Q.key]) && Q.records.map((Pe, We) => /* @__PURE__ */ d(
              s,
              {
                variants: XP(),
                initial: I ? "hidden" : "visible",
                animate: "visible",
                exit: "hidden",
                custom: We,
                layout: !0,
                source: e,
                item: Pe,
                index: We,
                groupIndex: te,
                onCheckedChange: ($e) => N(Pe, $e),
                selectedItems: b,
                columns: t,
                frozenColumnsLeft: x,
                checkColumnWidth: z
              },
              `row-${te}-${We}`
            )) }, `group-animate-${te}`)
          ] }, `group-${Q.key}`);
        }),
        (l == null ? void 0 : l.type) === "flat" && l.records.map((Q, te) => /* @__PURE__ */ d(
          J2,
          {
            groupIndex: 0,
            source: e,
            item: Q,
            index: te,
            onCheckedChange: (be) => N(Q, be),
            selectedItems: b,
            columns: t,
            frozenColumnsLeft: x,
            checkColumnWidth: z
          },
          `row-${te}`
        )),
        (c == null ? void 0 : c.type) === "infinite-scroll" && m && Array.from({ length: 5 }).map((Q, te) => /* @__PURE__ */ d(ua, { children: Array.from({ length: F }).map((be, Pe) => /* @__PURE__ */ d(ir, { children: /* @__PURE__ */ d(Ce, { className: "h-4 w-full" }) }, `skeleton-cell-${te}-${Pe}`)) }, `skeleton-row-${te}`)),
        sh(c) && c.hasMore && /* @__PURE__ */ d("tr", { children: /* @__PURE__ */ d(
          "td",
          {
            colSpan: t.length + (e.selectable ? 1 : 0),
            ref: w,
            className: "h-10 w-full",
            "aria-hidden": "true"
          }
        ) })
      ] }),
      W && /* @__PURE__ */ d(lTe, { children: /* @__PURE__ */ k(
        ua,
        {
          className: E(
            W.sticky && "sticky bottom-0 z-10 bg-f1-background shadow-[0_-1px_0_0_var(--f1-border-secondary)] hover:bg-f1-background",
            "font-medium"
          ),
          children: [
            e.selectable && /* @__PURE__ */ d(ir, { width: z, sticky: { left: 0 }, children: W.label && /* @__PURE__ */ d("div", { className: "font-medium text-f1-foreground-secondary", children: W.label }) }),
            t.map((Q, te) => {
              var be;
              return /* @__PURE__ */ d(
                ir,
                {
                  firstCell: te === 0,
                  width: Q.width,
                  sticky: te < x ? {
                    left: t.slice(0, Math.max(0, te)).reduce(
                      (Pe, We) => Pe + (We.width ?? 0),
                      z
                    )
                  } : void 0,
                  children: te === 0 && !e.selectable && W.label ? /* @__PURE__ */ d("div", { className: "font-medium text-f1-foreground-secondary", children: W.label }) : /* @__PURE__ */ d(
                    "div",
                    {
                      className: E(
                        Q.align === "right" ? "justify-end" : "",
                        "flex"
                      ),
                      children: Q.summary && e.summaries && ((be = e.summaries[Q.summary]) == null ? void 0 : be.type) === "sum" ? /* @__PURE__ */ k("div", { className: "flex gap-1", children: [
                        /* @__PURE__ */ d("span", { className: "text-f1-foreground-secondary", children: o.collections.summaries.types.sum }),
                        `${W.data[Q.summary]}`
                      ] }) : "-"
                    }
                  )
                },
                `summary-${String(Q.label)}`
              );
            }),
            e.itemActions && /* @__PURE__ */ d(
              ir,
              {
                width: 68,
                sticky: {
                  right: 0
                },
                children: ""
              },
              "summary-actions"
            )
          ]
        }
      ) })
    ] }),
    /* @__PURE__ */ d(
      O0,
      {
        paginationInfo: c,
        setPage: u,
        className: "pb-4"
      }
    )
  ] });
}, y8 = {
  table: {
    name: "Table",
    icon: xT,
    render: (t) => /* @__PURE__ */ d(
      cTe,
      {
        ...t
      }
    )
  },
  list: {
    name: "List",
    icon: Ry,
    render: (t) => /* @__PURE__ */ d(
      nTe,
      {
        ...t
      }
    )
  },
  card: {
    name: "Card",
    icon: OE,
    render: (t) => /* @__PURE__ */ d(
      QEe,
      {
        ...t
      }
    )
  }
}, uTe = ({
  visualization: t,
  source: e,
  onSelectItems: n,
  onLoadData: i,
  onLoadError: r
}) => {
  if (t.type === "custom")
    return t.component({
      source: e,
      onLoadData: i,
      onLoadError: r,
      onSelectItems: n
    });
  const a = y8[t.type];
  if (!a)
    throw new Error(`Visualization type ${t.type} not found`);
  return a.render({
    source: e,
    ...t.options,
    onSelectItems: n,
    onLoadData: i,
    onLoadError: r
  });
}, fTe = ({
  visualizations: t,
  currentVisualization: e,
  onVisualizationChange: n
}) => {
  const i = et(), r = (o) => {
    n(o);
  }, a = (o) => o.type === "custom" ? {
    icon: o.icon,
    label: o.label
  } : {
    icon: y8[o.type].icon,
    label: i.collections.visualizations[o.type]
  };
  return /* @__PURE__ */ d("div", { className: "grid grid-cols-2 p-2", children: t.map((o, s) => {
    const { icon: l, label: c } = a(o);
    return /* @__PURE__ */ k(
      "button",
      {
        className: E(
          "flex w-full flex-col items-center justify-center gap-1 rounded-sm p-2 font-medium text-f1-foreground-secondary transition-colors",
          e === s && "bg-f1-background-secondary text-f1-foreground",
          Ke()
        ),
        onClick: () => r(s),
        children: [
          /* @__PURE__ */ d(me, { icon: l }),
          c
        ]
      },
      o.type
    );
  }) });
}, mTe = ({
  visualizations: t,
  currentVisualization: e,
  onVisualizationChange: n,
  grouping: i,
  // summaries, // TODO: implement summaries selector
  currentGrouping: r,
  onGroupingChange: a,
  sortings: o,
  currentSortings: s,
  onSortingsChange: l
}) => {
  const c = i ? Object.keys(i.groupBy).length + (i.mandatory ? 1 : 0) : 0, u = t && t.length > 1 || c > 0, [f, m] = q(!1), h = (w) => {
    m(!1), n(w);
  }, p = (w) => {
    a(w);
  }, g = t && t.length > 1, y = i && c > 0, v = o && Object.keys(o).length > 0;
  return u && /* @__PURE__ */ d("div", { className: "flex gap-2", children: /* @__PURE__ */ k($o, { open: f, onOpenChange: m, children: [
    /* @__PURE__ */ d(Do, { asChild: !0, onClick: () => m(!f), children: /* @__PURE__ */ d(
      ue,
      {
        variant: "outline",
        label: "Filters",
        icon: cT,
        onClick: () => {
        },
        hideLabel: !0,
        round: !0,
        pressed: f
      }
    ) }),
    /* @__PURE__ */ d(
      Eo,
      {
        className: "flex w-[280px] flex-col gap-0 rounded-md border border-solid border-f1-border-secondary p-0",
        align: "end",
        sideOffset: 8,
        children: [
          g && /* @__PURE__ */ d(
            fTe,
            {
              visualizations: t,
              currentVisualization: e,
              onVisualizationChange: h
            },
            "visualization"
          ),
          y && /* @__PURE__ */ d(
            bEe,
            {
              grouping: i,
              currentGrouping: r,
              onGroupingChange: p
            },
            "grouping"
          ),
          v && /* @__PURE__ */ d(
            wEe,
            {
              currentSortings: s,
              onChange: l,
              sortings: o
            },
            "sorting"
          )
        ].filter(Boolean).map((w, x, b) => /* @__PURE__ */ k("div", { children: [
          w,
          x < b.length - 1 && /* @__PURE__ */ d("div", { className: "h-px w-full bg-f1-border-secondary" })
        ] }, x))
      }
    )
  ] }) });
}, hTe = (t = {}, e) => {
  const n = et(), i = {
    "no-data": {
      emoji: "📄",
      title: n.collections.emptyStates.noData.title,
      description: n.collections.emptyStates.noData.description
    },
    "no-results": {
      emoji: "🔍",
      title: n.collections.emptyStates.noResults.title,
      description: n.collections.emptyStates.noResults.description,
      actions: [
        {
          label: n.collections.emptyStates.noResults.clearFilters,
          onClick: e.clearFilters
        }
      ]
    },
    error: {
      title: n.collections.emptyStates.error.title,
      description: n.collections.emptyStates.error.description,
      actions: [
        {
          label: n.collections.emptyStates.error.retry,
          onClick: e.retry
        }
      ]
    }
  }, [r, a] = q(void 0);
  return { emptyState: r, setEmptyStateType: (s, l) => {
    if (!s) {
      a(void 0);
      return;
    }
    const c = t[s] ?? {}, u = i[s], f = {
      title: c.title ?? u.title,
      description: c.description ?? (s === "error" && l ? l : u.description),
      actions: c.actions ?? u.actions
    };
    a(s === "error" ? {
      ...f,
      variant: "critical"
    } : {
      ...f,
      emoji: c.emoji ?? u.emoji
    });
  } };
}, LYe = ({
  currentFilters: t = {},
  currentGrouping: e,
  filters: n,
  navigationFilters: i,
  search: r,
  defaultSorting: a,
  summaries: o,
  dataAdapter: s,
  grouping: l,
  ...c
}, u = []) => {
  const [f, m] = q(t), [h, p] = q(() => i ? Object.fromEntries(
    Object.entries(i).map(([L, R]) => {
      const B = GP[R.type];
      return [
        L,
        B.valueConverter ? B.valueConverter(R.defaultValue, R) : R.defaultValue
      ];
    })
  ) : {}), [g, y] = q(a || null), v = {
    sync: !1,
    ...r
  }, [w, x] = q(), [b, M] = t5(w, 200);
  le(() => {
    v.sync || M(w);
  }, [w, v.sync, M]);
  const _ = ve(() => n, u), N = ve(() => o, u), [$, D] = q(!1), W = ve(() => s, u), j = l != null && l.mandatory ? {
    field: Object.keys(
      l.groupBy
    )[0],
    order: "asc"
  } : void 0, [O, I] = q(e ?? j);
  if (l != null && l.mandatory && !(O != null && O.field))
    throw new Error("Grouping is mandatory but no grouping state is set");
  return {
    filters: _,
    currentFilters: f,
    setCurrentFilters: m,
    currentSortings: g,
    setCurrentSortings: y,
    summaries: N,
    search: r,
    currentSearch: w,
    setCurrentSearch: x,
    debouncedCurrentSearch: b,
    isLoading: $,
    setIsLoading: D,
    dataAdapter: W,
    navigationFilters: i,
    currentNavigationFilters: h,
    setCurrentNavigationFilters: p,
    setCurrentGrouping: I,
    currentGrouping: O,
    grouping: l,
    ...c
  };
}, pTe = re.create(me), IYe = ({
  source: t,
  visualizations: e,
  onSelectItems: n,
  onBulkAction: i,
  emptyStates: r,
  fullHeight: a
}) => {
  const {
    // Filters
    filters: o,
    currentFilters: s,
    setCurrentFilters: l,
    presets: c,
    // Navigation filter
    currentNavigationFilters: u,
    navigationFilters: f,
    setCurrentNavigationFilters: m,
    // Search
    search: h,
    currentSearch: p,
    setCurrentSearch: g,
    //
    isLoading: y,
    // Actions
    primaryActions: v,
    secondaryActions: w,
    // Summary
    totalItemSummary: x = (ze) => ze === void 0 ? `${ze} ${Y.collections.itemsCount}` : null,
    currentGrouping: b,
    setCurrentGrouping: M,
    grouping: _,
    currentSortings: N,
    setCurrentSortings: $,
    sortings: D
  } = t, [W, j] = q(0), O = ve(
    () => v && v(),
    [v]
  ), I = ve(
    () => HDe(w),
    [w]
  ), L = ve(
    () => Math.min(
      w && "expanded" in w && w.expanded || 0,
      VDe
    ),
    [w]
  ), R = ve(
    () => I.slice(0, L) || [],
    [I, L]
  ), B = ve(
    () => I.slice(L),
    [I, L]
  ), F = !!O || (I == null ? void 0 : I.length) > 0, [z, K] = q(void 0), ae = i5(), [Q, te] = q(void 0), [be, Pe] = q(!1), [We, $e] = q(0), Y = et(), oe = (ze, A) => {
    n == null || n(ze, A), Pe(
      !!ze.allSelected || ze.itemsStatus.some((de) => de.checked)
    ), $e(ze.selectedCount), K(() => A);
    const V = t.bulkActions ? t.bulkActions(ze) : void 0, G = (de) => ({
      ...de,
      onClick: () => {
        i == null || i(de.id, ze, A), de.keepSelection || A();
      }
    });
    te({
      primary: ((V == null ? void 0 : V.primary) || []).map(G),
      secondary: ((V == null ? void 0 : V.secondary) || []).map(G)
    });
  }, se = ve(() => [
    y,
    h == null ? void 0 : h.enabled,
    e && e.length > 1
  ].some(Boolean), [h, y, e]), [J, xe] = q(void 0), { emptyState: De, setEmptyStateType: _e } = hTe(r, {
    retry: () => {
      _e(!1), l({ ...s });
    },
    clearFilters: () => {
      _e(!1), l({});
    }
  }), ce = (ze, A, V) => ze === 0 ? Object.keys(A).length > 0 || V ? "no-results" : "no-data" : !1, wt = ({
    totalItems: ze,
    filters: A,
    isInitialLoading: V,
    search: G
  }) => {
    V || (xe(ze), _e(ce(ze, A, G)));
  }, St = (ze) => {
    _e(
      "error",
      ze.cause instanceof Error ? ze.cause.message : ze.message
    );
  };
  return le(() => {
    _e(!1);
  }, [
    s,
    p,
    u,
    t.dataAdapter
  ]), /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex flex-col gap-4",
        ae === "standard" && "-mx-6",
        a && "h-full"
      ),
      children: [
        (J !== void 0 && x(J) || f) && /* @__PURE__ */ k("div", { className: "border-f1-border-primary flex gap-4 px-6", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-1 flex-shrink gap-4 text-lg font-semibold", children: [
            y && J !== void 0 && x(J) && /* @__PURE__ */ d(Ce, { className: "h-5 w-24" }),
            !y && J !== void 0 && /* @__PURE__ */ d("div", { className: "flex h-5 items-center", children: x(J) })
          ] }),
          /* @__PURE__ */ d("div", { className: "flex flex-1 flex-shrink justify-end", children: f && Object.entries(f).map(([ze, A]) => GP[A.type].render({
            filter: A,
            value: u[ze],
            onChange: (G) => {
              m({
                ...u,
                [ze]: G
              });
            }
          })) })
        ] }),
        /* @__PURE__ */ d(
          "div",
          {
            className: E("flex flex-col gap-4 px-6", a && "max-h-full"),
            children: /* @__PURE__ */ k(
              zP,
              {
                schema: o,
                filters: s,
                presets: c,
                onChange: (ze) => l(ze),
                children: [
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: E(
                        "flex items-center justify-between gap-4",
                        !o && "justify-end"
                      ),
                      children: [
                        o && /* @__PURE__ */ k("div", { className: "flex min-w-0 flex-1 gap-1", children: [
                          /* @__PURE__ */ d(VP, {}),
                          /* @__PURE__ */ d(HP, {})
                        ] }),
                        /* @__PURE__ */ k("div", { className: "flex shrink-0 items-center gap-2", children: [
                          y && /* @__PURE__ */ d(
                            pTe,
                            {
                              initial: { opacity: 0 },
                              animate: { opacity: 1 },
                              exit: {
                                opacity: 0
                              },
                              size: "lg",
                              icon: I5,
                              className: "animate-spin"
                            }
                          ),
                          h && /* @__PURE__ */ d(vEe, { onChange: g, value: p }),
                          /* @__PURE__ */ d(
                            mTe,
                            {
                              visualizations: e,
                              currentVisualization: W,
                              onVisualizationChange: j,
                              grouping: _,
                              currentGrouping: b,
                              onGroupingChange: M,
                              sortings: D,
                              currentSortings: N,
                              onSortingsChange: $
                            }
                          ),
                          F && /* @__PURE__ */ k(Ee, { children: [
                            se && /* @__PURE__ */ d("div", { className: "mx-1 h-4 w-px bg-f1-background-secondary-hover" }),
                            /* @__PURE__ */ d(
                              BDe,
                              {
                                primaryActions: O,
                                secondaryActions: R,
                                otherActions: B
                              }
                            )
                          ] })
                        ] })
                      ]
                    }
                  ),
                  /* @__PURE__ */ d(BP, {})
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ d("div", { className: E(De && "hidden", a && "h-full"), children: /* @__PURE__ */ d(
          uTe,
          {
            visualization: e[W],
            source: t,
            onSelectItems: oe,
            onLoadData: wt,
            onLoadError: St
          }
        ) }),
        De ? /* @__PURE__ */ d("div", { className: "flex flex-1 flex-col items-center justify-center", children: /* @__PURE__ */ d(
          RP,
          {
            emoji: De.emoji,
            title: De.title,
            description: De.description,
            actions: De.actions
          }
        ) }) : /* @__PURE__ */ d(Ee, { children: (Q == null ? void 0 : Q.primary) && ((Q == null ? void 0 : Q.primary) || []).length > 0 && /* @__PURE__ */ d(
          zDe,
          {
            isOpen: be,
            selectedNumber: We,
            primaryActions: Q.primary,
            secondaryActions: Q == null ? void 0 : Q.secondary,
            onUnselect: () => z == null ? void 0 : z()
          }
        ) })
      ]
    }
  );
}, v8 = X(
  ({ header: t, actions: e, open: n, onClose: i }, r) => {
    const [a, o] = q(!1), s = Le(() => {
      o(!0);
      const l = setTimeout(() => {
        i == null || i(), o(!1);
      }, 200);
      return () => clearTimeout(l);
    }, [i]);
    return /* @__PURE__ */ d(
      s5,
      {
        open: n && !a,
        onOpenChange: (l) => !l && (s == null ? void 0 : s()),
        children: /* @__PURE__ */ k(
          l5,
          {
            ref: r,
            className: "bottom-3 top-auto max-w-[400px] translate-y-0 sm:bottom-auto sm:top-[50%] sm:translate-y-[-50%]",
            children: [
              /* @__PURE__ */ k(fD, { className: "flex flex-col gap-4 px-4 py-5", children: [
                /* @__PURE__ */ d(Gd, { type: t.type, size: "lg" }),
                /* @__PURE__ */ k("div", { className: "flex flex-col gap-0.5", children: [
                  /* @__PURE__ */ d(Pp, { className: "text-xl sm:text-lg", children: t.title }),
                  /* @__PURE__ */ d(mD, { className: "text-lg sm:text-base", children: t.description })
                ] })
              ] }),
              e && /* @__PURE__ */ k(hD, { className: "px-4 pb-4 pt-2 [&_div]:w-full", children: [
                /* @__PURE__ */ k("div", { className: "hidden sm:flex sm:flex-row sm:justify-between sm:gap-3", children: [
                  /* @__PURE__ */ d(ue, { variant: "outline", ...e.secondary }),
                  /* @__PURE__ */ d(
                    ue,
                    {
                      ...e.primary,
                      variant: e.primary.variant || "default"
                    }
                  )
                ] }),
                /* @__PURE__ */ k("div", { className: "flex flex-col-reverse gap-2 sm:hidden", children: [
                  /* @__PURE__ */ d(ue, { variant: "outline", ...e.secondary, size: "lg" }),
                  /* @__PURE__ */ d(
                    ue,
                    {
                      ...e.primary,
                      variant: e.primary.variant || "default",
                      size: "lg"
                    }
                  )
                ] })
              ] })
            ]
          }
        )
      }
    );
  }
);
v8.displayName = "Dialog";
const RYe = ui(
  {
    name: "Dialog",
    type: "info"
  },
  v8
);
function ln(t) {
  this.content = t;
}
ln.prototype = {
  constructor: ln,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, n) {
    var i = n && n != t ? this.remove(n) : this, r = i.find(t), a = i.content.slice();
    return r == -1 ? a.push(n || t, e) : (a[r + 1] = e, n && (a[r] = n)), new ln(a);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var n = this.content.slice();
    return n.splice(e, 2), new ln(n);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new ln([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var n = this.remove(t).content.slice();
    return n.push(t, e), new ln(n);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, n) {
    var i = this.remove(e), r = i.content.slice(), a = i.find(t);
    return r.splice(a == -1 ? r.length : a, 0, e, n), new ln(r);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = ln.from(t), t.size ? new ln(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = ln.from(t), t.size ? new ln(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = ln.from(t);
    for (var n = 0; n < t.content.length; n += 2)
      e = e.remove(t.content[n]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, n) {
      t[e] = n;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
ln.from = function(t) {
  if (t instanceof ln) return t;
  var e = [];
  if (t) for (var n in t) e.push(n, t[n]);
  return new ln(e);
};
function b8(t, e, n) {
  for (let i = 0; ; i++) {
    if (i == t.childCount || i == e.childCount)
      return t.childCount == e.childCount ? null : n;
    let r = t.child(i), a = e.child(i);
    if (r == a) {
      n += r.nodeSize;
      continue;
    }
    if (!r.sameMarkup(a))
      return n;
    if (r.isText && r.text != a.text) {
      for (let o = 0; r.text[o] == a.text[o]; o++)
        n++;
      return n;
    }
    if (r.content.size || a.content.size) {
      let o = b8(r.content, a.content, n + 1);
      if (o != null)
        return o;
    }
    n += r.nodeSize;
  }
}
function w8(t, e, n, i) {
  for (let r = t.childCount, a = e.childCount; ; ) {
    if (r == 0 || a == 0)
      return r == a ? null : { a: n, b: i };
    let o = t.child(--r), s = e.child(--a), l = o.nodeSize;
    if (o == s) {
      n -= l, i -= l;
      continue;
    }
    if (!o.sameMarkup(s))
      return { a: n, b: i };
    if (o.isText && o.text != s.text) {
      let c = 0, u = Math.min(o.text.length, s.text.length);
      for (; c < u && o.text[o.text.length - c - 1] == s.text[s.text.length - c - 1]; )
        c++, n--, i--;
      return { a: n, b: i };
    }
    if (o.content.size || s.content.size) {
      let c = w8(o.content, s.content, n - 1, i - 1);
      if (c)
        return c;
    }
    n -= l, i -= l;
  }
}
class ee {
  /**
  @internal
  */
  constructor(e, n) {
    if (this.content = e, this.size = n || 0, n == null)
      for (let i = 0; i < e.length; i++)
        this.size += e[i].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, n, i, r = 0, a) {
    for (let o = 0, s = 0; s < n; o++) {
      let l = this.content[o], c = s + l.nodeSize;
      if (c > e && i(l, r + s, a || null, o) !== !1 && l.content.size) {
        let u = s + 1;
        l.nodesBetween(Math.max(0, e - u), Math.min(l.content.size, n - u), i, r + u);
      }
      s = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, n, i, r) {
    let a = "", o = !0;
    return this.nodesBetween(e, n, (s, l) => {
      let c = s.isText ? s.text.slice(Math.max(e, l) - l, n - l) : s.isLeaf ? r ? typeof r == "function" ? r(s) : r : s.type.spec.leafText ? s.type.spec.leafText(s) : "" : "";
      s.isBlock && (s.isLeaf && c || s.isTextblock) && i && (o ? o = !1 : a += i), a += c;
    }, 0), a;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let n = this.lastChild, i = e.firstChild, r = this.content.slice(), a = 0;
    for (n.isText && n.sameMarkup(i) && (r[r.length - 1] = n.withText(n.text + i.text), a = 1); a < e.content.length; a++)
      r.push(e.content[a]);
    return new ee(r, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, n = this.size) {
    if (e == 0 && n == this.size)
      return this;
    let i = [], r = 0;
    if (n > e)
      for (let a = 0, o = 0; o < n; a++) {
        let s = this.content[a], l = o + s.nodeSize;
        l > e && ((o < e || l > n) && (s.isText ? s = s.cut(Math.max(0, e - o), Math.min(s.text.length, n - o)) : s = s.cut(Math.max(0, e - o - 1), Math.min(s.content.size, n - o - 1))), i.push(s), r += s.nodeSize), o = l;
      }
    return new ee(i, r);
  }
  /**
  @internal
  */
  cutByIndex(e, n) {
    return e == n ? ee.empty : e == 0 && n == this.content.length ? this : new ee(this.content.slice(e, n));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, n) {
    let i = this.content[e];
    if (i == n)
      return this;
    let r = this.content.slice(), a = this.size + n.nodeSize - i.nodeSize;
    return r[e] = n, new ee(r, a);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new ee([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new ee(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let n = 0; n < this.content.length; n++)
      if (!this.content[n].eq(e.content[n]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let n = this.content[e];
    if (!n)
      throw new RangeError("Index " + e + " out of range for " + this);
    return n;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let n = 0, i = 0; n < this.content.length; n++) {
      let r = this.content[n];
      e(r, i, n), i += r.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, n = 0) {
    return b8(this, e, n);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, n = this.size, i = e.size) {
    return w8(this, e, n, i);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e, n = -1) {
    if (e == 0)
      return Zc(0, e);
    if (e == this.size)
      return Zc(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let i = 0, r = 0; ; i++) {
      let a = this.child(i), o = r + a.nodeSize;
      if (o >= e)
        return o == e || n > 0 ? Zc(i + 1, o) : Zc(i, r);
      r = o;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return ee.empty;
    if (!Array.isArray(n))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new ee(n.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return ee.empty;
    let n, i = 0;
    for (let r = 0; r < e.length; r++) {
      let a = e[r];
      i += a.nodeSize, r && a.isText && e[r - 1].sameMarkup(a) ? (n || (n = e.slice(0, r)), n[n.length - 1] = a.withText(n[n.length - 1].text + a.text)) : n && n.push(a);
    }
    return new ee(n || e, i);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return ee.empty;
    if (e instanceof ee)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new ee([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
ee.empty = new ee([], 0);
const T1 = { index: 0, offset: 0 };
function Zc(t, e) {
  return T1.index = t, T1.offset = e, T1;
}
function Cf(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let n = Array.isArray(t);
  if (Array.isArray(e) != n)
    return !1;
  if (n) {
    if (t.length != e.length)
      return !1;
    for (let i = 0; i < t.length; i++)
      if (!Cf(t[i], e[i]))
        return !1;
  } else {
    for (let i in t)
      if (!(i in e) || !Cf(t[i], e[i]))
        return !1;
    for (let i in e)
      if (!(i in t))
        return !1;
  }
  return !0;
}
let pt = class kg {
  /**
  @internal
  */
  constructor(e, n) {
    this.type = e, this.attrs = n;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let n, i = !1;
    for (let r = 0; r < e.length; r++) {
      let a = e[r];
      if (this.eq(a))
        return e;
      if (this.type.excludes(a.type))
        n || (n = e.slice(0, r));
      else {
        if (a.type.excludes(this.type))
          return e;
        !i && a.type.rank > this.type.rank && (n || (n = e.slice(0, r)), n.push(this), i = !0), n && n.push(a);
      }
    }
    return n || (n = e.slice()), i || n.push(this), n;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return e.slice(0, n).concat(e.slice(n + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (this.eq(e[n]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Cf(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let i = e.marks[n.type];
    if (!i)
      throw new RangeError(`There is no mark type ${n.type} in this schema`);
    let r = i.create(n.attrs);
    return i.checkAttrs(r.attrs), r;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, n) {
    if (e == n)
      return !0;
    if (e.length != n.length)
      return !1;
    for (let i = 0; i < e.length; i++)
      if (!e[i].eq(n[i]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return kg.none;
    if (e instanceof kg)
      return [e];
    let n = e.slice();
    return n.sort((i, r) => i.type.rank - r.type.rank), n;
  }
};
pt.none = [];
class Pf extends Error {
}
class ye {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, n, i) {
    this.content = e, this.openStart = n, this.openEnd = i;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, n) {
    let i = x8(this.content, e + this.openStart, n);
    return i && new ye(i, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, n) {
    return new ye(k8(this.content, e + this.openStart, n + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      return ye.empty;
    let i = n.openStart || 0, r = n.openEnd || 0;
    if (typeof i != "number" || typeof r != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new ye(ee.fromJSON(e, n.content), i, r);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, n = !0) {
    let i = 0, r = 0;
    for (let a = e.firstChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.firstChild)
      i++;
    for (let a = e.lastChild; a && !a.isLeaf && (n || !a.type.spec.isolating); a = a.lastChild)
      r++;
    return new ye(e, i, r);
  }
}
ye.empty = new ye(ee.empty, 0, 0);
function k8(t, e, n) {
  let { index: i, offset: r } = t.findIndex(e), a = t.maybeChild(i), { index: o, offset: s } = t.findIndex(n);
  if (r == e || a.isText) {
    if (s != n && !t.child(o).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(n));
  }
  if (i != o)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(i, a.copy(k8(a.content, e - r - 1, n - r - 1)));
}
function x8(t, e, n, i) {
  let { index: r, offset: a } = t.findIndex(e), o = t.maybeChild(r);
  if (a == e || o.isText)
    return t.cut(0, e).append(n).append(t.cut(e));
  let s = x8(o.content, e - a - 1, n);
  return s && t.replaceChild(r, o.copy(s));
}
function gTe(t, e, n) {
  if (n.openStart > t.depth)
    throw new Pf("Inserted content deeper than insertion position");
  if (t.depth - n.openStart != e.depth - n.openEnd)
    throw new Pf("Inconsistent open depths");
  return _8(t, e, n, 0);
}
function _8(t, e, n, i) {
  let r = t.index(i), a = t.node(i);
  if (r == e.index(i) && i < t.depth - n.openStart) {
    let o = _8(t, e, n, i + 1);
    return a.copy(a.content.replaceChild(r, o));
  } else if (n.content.size)
    if (!n.openStart && !n.openEnd && t.depth == i && e.depth == i) {
      let o = t.parent, s = o.content;
      return uo(o, s.cut(0, t.parentOffset).append(n.content).append(s.cut(e.parentOffset)));
    } else {
      let { start: o, end: s } = yTe(n, t);
      return uo(a, C8(t, o, s, e, i));
    }
  else return uo(a, Sf(t, e, i));
}
function M8(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new Pf("Cannot join " + e.type.name + " onto " + t.type.name);
}
function xg(t, e, n) {
  let i = t.node(n);
  return M8(i, e.node(n)), i;
}
function co(t, e) {
  let n = e.length - 1;
  n >= 0 && t.isText && t.sameMarkup(e[n]) ? e[n] = t.withText(e[n].text + t.text) : e.push(t);
}
function Hl(t, e, n, i) {
  let r = (e || t).node(n), a = 0, o = e ? e.index(n) : r.childCount;
  t && (a = t.index(n), t.depth > n ? a++ : t.textOffset && (co(t.nodeAfter, i), a++));
  for (let s = a; s < o; s++)
    co(r.child(s), i);
  e && e.depth == n && e.textOffset && co(e.nodeBefore, i);
}
function uo(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function C8(t, e, n, i, r) {
  let a = t.depth > r && xg(t, e, r + 1), o = i.depth > r && xg(n, i, r + 1), s = [];
  return Hl(null, t, r, s), a && o && e.index(r) == n.index(r) ? (M8(a, o), co(uo(a, C8(t, e, n, i, r + 1)), s)) : (a && co(uo(a, Sf(t, e, r + 1)), s), Hl(e, n, r, s), o && co(uo(o, Sf(n, i, r + 1)), s)), Hl(i, null, r, s), new ee(s);
}
function Sf(t, e, n) {
  let i = [];
  if (Hl(null, t, n, i), t.depth > n) {
    let r = xg(t, e, n + 1);
    co(uo(r, Sf(t, e, n + 1)), i);
  }
  return Hl(e, null, n, i), new ee(i);
}
function yTe(t, e) {
  let n = e.depth - t.openStart, r = e.node(n).copy(t.content);
  for (let a = n - 1; a >= 0; a--)
    r = e.node(a).copy(ee.from(r));
  return {
    start: r.resolveNoCache(t.openStart + n),
    end: r.resolveNoCache(r.content.size - t.openEnd - n)
  };
}
class hd {
  /**
  @internal
  */
  constructor(e, n, i) {
    this.pos = e, this.path = n, this.parentOffset = i, this.depth = n.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, n = this.index(this.depth);
    if (n == e.childCount)
      return null;
    let i = this.pos - this.path[this.path.length - 1], r = e.child(n);
    return i ? e.child(n).cut(i) : r;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), n = this.pos - this.path[this.path.length - 1];
    return n ? this.parent.child(e).cut(0, n) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, n) {
    n = this.resolveDepth(n);
    let i = this.path[n * 3], r = n == 0 ? 0 : this.path[n * 3 - 1] + 1;
    for (let a = 0; a < e; a++)
      r += i.child(a).nodeSize;
    return r;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, n = this.index();
    if (e.content.size == 0)
      return pt.none;
    if (this.textOffset)
      return e.child(n).marks;
    let i = e.maybeChild(n - 1), r = e.maybeChild(n);
    if (!i) {
      let s = i;
      i = r, r = s;
    }
    let a = i.marks;
    for (var o = 0; o < a.length; o++)
      a[o].type.spec.inclusive === !1 && (!r || !a[o].isInSet(r.marks)) && (a = a[o--].removeFromSet(a));
    return a;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let n = this.parent.maybeChild(this.index());
    if (!n || !n.isInline)
      return null;
    let i = n.marks, r = e.parent.maybeChild(e.index());
    for (var a = 0; a < i.length; a++)
      i[a].type.spec.inclusive === !1 && (!r || !i[a].isInSet(r.marks)) && (i = i[a--].removeFromSet(i));
    return i;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let n = this.depth; n > 0; n--)
      if (this.start(n) <= e && this.end(n) >= e)
        return n;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, n) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let i = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); i >= 0; i--)
      if (e.pos <= this.end(i) && (!n || n(this.node(i))))
        return new pd(this, e, i);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let n = 1; n <= this.depth; n++)
      e += (e ? "/" : "") + this.node(n).type.name + "_" + this.index(n - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, n) {
    if (!(n >= 0 && n <= e.content.size))
      throw new RangeError("Position " + n + " out of range");
    let i = [], r = 0, a = n;
    for (let o = e; ; ) {
      let { index: s, offset: l } = o.content.findIndex(a), c = a - l;
      if (i.push(o, s, r + l), !c || (o = o.child(s), o.isText))
        break;
      a = c - 1, r += l + 1;
    }
    return new hd(n, i, a);
  }
  /**
  @internal
  */
  static resolveCached(e, n) {
    let i = Q2.get(e);
    if (i)
      for (let a = 0; a < i.elts.length; a++) {
        let o = i.elts[a];
        if (o.pos == n)
          return o;
      }
    else
      Q2.set(e, i = new vTe());
    let r = i.elts[i.i] = hd.resolve(e, n);
    return i.i = (i.i + 1) % bTe, r;
  }
}
class vTe {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const bTe = 12, Q2 = /* @__PURE__ */ new WeakMap();
class pd {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, n, i) {
    this.$from = e, this.$to = n, this.depth = i;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const wTe = /* @__PURE__ */ Object.create(null);
let wa = class _g {
  /**
  @internal
  */
  constructor(e, n, i, r = pt.none) {
    this.type = e, this.attrs = n, this.marks = r, this.content = i || ee.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, n, i, r = 0) {
    this.content.nodesBetween(e, n, i, r, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec^leafText) will be used.
  */
  textBetween(e, n, i, r) {
    return this.content.textBetween(e, n, i, r);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, n, i) {
    return this.type == e && Cf(this.attrs, n || e.defaultAttrs || wTe) && pt.sameSet(this.marks, i || pt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new _g(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new _g(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, n = this.content.size) {
    return e == 0 && n == this.content.size ? this : this.copy(this.content.cut(e, n));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, n = this.content.size, i = !1) {
    if (e == n)
      return ye.empty;
    let r = this.resolve(e), a = this.resolve(n), o = i ? 0 : r.sharedDepth(n), s = r.start(o), c = r.node(o).content.cut(r.pos - s, a.pos - s);
    return new ye(c, r.depth - o, a.depth - o);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, n, i) {
    return gTe(this.resolve(e), this.resolve(n), i);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let n = this; ; ) {
      let { index: i, offset: r } = n.content.findIndex(e);
      if (n = n.maybeChild(i), !n)
        return null;
      if (r == e || n.isText)
        return n;
      e -= r + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: n, offset: i } = this.content.findIndex(e);
    return { node: this.content.maybeChild(n), index: n, offset: i };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: n, offset: i } = this.content.findIndex(e);
    if (i < e)
      return { node: this.content.child(n), index: n, offset: i };
    let r = this.content.child(n - 1);
    return { node: r, index: n - 1, offset: i - r.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return hd.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return hd.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, n, i) {
    let r = !1;
    return n > e && this.nodesBetween(e, n, (a) => (i.isInSet(a.marks) && (r = !0), !r)), r;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), P8(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let n = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!n)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return n;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, n, i = ee.empty, r = 0, a = i.childCount) {
    let o = this.contentMatchAt(e).matchFragment(i, r, a), s = o && o.matchFragment(this.content, n);
    if (!s || !s.validEnd)
      return !1;
    for (let l = r; l < a; l++)
      if (!this.type.allowsMarks(i.child(l).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, n, i, r) {
    if (r && !this.type.allowsMarks(r))
      return !1;
    let a = this.contentMatchAt(e).matchType(i), o = a && a.matchFragment(this.content, n);
    return o ? o.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = pt.none;
    for (let n = 0; n < this.marks.length; n++) {
      let i = this.marks[n];
      i.type.checkAttrs(i.attrs), e = i.addToSet(e);
    }
    if (!pt.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((n) => n.type.name)}`);
    this.content.forEach((n) => n.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let n in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((n) => n.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, n) {
    if (!n)
      throw new RangeError("Invalid input for Node.fromJSON");
    let i;
    if (n.marks) {
      if (!Array.isArray(n.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      i = n.marks.map(e.markFromJSON);
    }
    if (n.type == "text") {
      if (typeof n.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(n.text, i);
    }
    let r = ee.fromJSON(e, n.content), a = e.nodeType(n.type).create(n.attrs, r, i);
    return a.type.checkAttrs(a.attrs), a;
  }
};
wa.prototype.text = void 0;
class Nf extends wa {
  /**
  @internal
  */
  constructor(e, n, i, r) {
    if (super(e, n, null, r), !i)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = i;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : P8(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, n) {
    return this.text.slice(e, n);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new Nf(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new Nf(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, n = this.text.length) {
    return e == 0 && n == this.text.length ? this : this.withText(this.text.slice(e, n));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
}
function P8(t, e) {
  for (let n = t.length - 1; n >= 0; n--)
    e = t[n].type.name + "(" + e + ")";
  return e;
}
class bo {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, n) {
    let i = new kTe(e, n);
    if (i.next == null)
      return bo.empty;
    let r = S8(i);
    i.next && i.err("Unexpected trailing text");
    let a = NTe(STe(r));
    return $Te(a, i), a;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let n = 0; n < this.next.length; n++)
      if (this.next[n].type == e)
        return this.next[n].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, n = 0, i = e.childCount) {
    let r = this;
    for (let a = n; r && a < i; a++)
      r = r.matchType(e.child(a).type);
    return r;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: n } = this.next[e];
      if (!(n.isText || n.hasRequiredAttrs()))
        return n;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let n = 0; n < this.next.length; n++)
      for (let i = 0; i < e.next.length; i++)
        if (this.next[n].type == e.next[i].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, n = !1, i = 0) {
    let r = [this];
    function a(o, s) {
      let l = o.matchFragment(e, i);
      if (l && (!n || l.validEnd))
        return ee.from(s.map((c) => c.createAndFill()));
      for (let c = 0; c < o.next.length; c++) {
        let { type: u, next: f } = o.next[c];
        if (!(u.isText || u.hasRequiredAttrs()) && r.indexOf(f) == -1) {
          r.push(f);
          let m = a(f, s.concat(u));
          if (m)
            return m;
        }
      }
      return null;
    }
    return a(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let i = 0; i < this.wrapCache.length; i += 2)
      if (this.wrapCache[i] == e)
        return this.wrapCache[i + 1];
    let n = this.computeWrapping(e);
    return this.wrapCache.push(e, n), n;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let n = /* @__PURE__ */ Object.create(null), i = [{ match: this, type: null, via: null }];
    for (; i.length; ) {
      let r = i.shift(), a = r.match;
      if (a.matchType(e)) {
        let o = [];
        for (let s = r; s.type; s = s.via)
          o.push(s.type);
        return o.reverse();
      }
      for (let o = 0; o < a.next.length; o++) {
        let { type: s, next: l } = a.next[o];
        !s.isLeaf && !s.hasRequiredAttrs() && !(s.name in n) && (!r.type || l.validEnd) && (i.push({ match: s.contentMatch, type: s, via: r }), n[s.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function n(i) {
      e.push(i);
      for (let r = 0; r < i.next.length; r++)
        e.indexOf(i.next[r].next) == -1 && n(i.next[r].next);
    }
    return n(this), e.map((i, r) => {
      let a = r + (i.validEnd ? "*" : " ") + " ";
      for (let o = 0; o < i.next.length; o++)
        a += (o ? ", " : "") + i.next[o].type.name + "->" + e.indexOf(i.next[o].next);
      return a;
    }).join(`
`);
  }
}
bo.empty = new bo(!0);
class kTe {
  constructor(e, n) {
    this.string = e, this.nodeTypes = n, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function S8(t) {
  let e = [];
  do
    e.push(xTe(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function xTe(t) {
  let e = [];
  do
    e.push(_Te(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function _Te(t) {
  let e = PTe(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = MTe(t, e);
    else
      break;
  return e;
}
function Z2(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function MTe(t, e) {
  let n = Z2(t), i = n;
  return t.eat(",") && (t.next != "}" ? i = Z2(t) : i = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: n, max: i, expr: e };
}
function CTe(t, e) {
  let n = t.nodeTypes, i = n[e];
  if (i)
    return [i];
  let r = [];
  for (let a in n) {
    let o = n[a];
    o.isInGroup(e) && r.push(o);
  }
  return r.length == 0 && t.err("No node type or group '" + e + "' found"), r;
}
function PTe(t) {
  if (t.eat("(")) {
    let e = S8(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = CTe(t, t.next).map((n) => (t.inline == null ? t.inline = n.isInline : t.inline != n.isInline && t.err("Mixing inline and block content"), { type: "name", value: n }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function STe(t) {
  let e = [[]];
  return r(a(t, 0), n()), e;
  function n() {
    return e.push([]) - 1;
  }
  function i(o, s, l) {
    let c = { term: l, to: s };
    return e[o].push(c), c;
  }
  function r(o, s) {
    o.forEach((l) => l.to = s);
  }
  function a(o, s) {
    if (o.type == "choice")
      return o.exprs.reduce((l, c) => l.concat(a(c, s)), []);
    if (o.type == "seq")
      for (let l = 0; ; l++) {
        let c = a(o.exprs[l], s);
        if (l == o.exprs.length - 1)
          return c;
        r(c, s = n());
      }
    else if (o.type == "star") {
      let l = n();
      return i(s, l), r(a(o.expr, l), l), [i(l)];
    } else if (o.type == "plus") {
      let l = n();
      return r(a(o.expr, s), l), r(a(o.expr, l), l), [i(l)];
    } else {
      if (o.type == "opt")
        return [i(s)].concat(a(o.expr, s));
      if (o.type == "range") {
        let l = s;
        for (let c = 0; c < o.min; c++) {
          let u = n();
          r(a(o.expr, l), u), l = u;
        }
        if (o.max == -1)
          r(a(o.expr, l), l);
        else
          for (let c = o.min; c < o.max; c++) {
            let u = n();
            i(l, u), r(a(o.expr, l), u), l = u;
          }
        return [i(l)];
      } else {
        if (o.type == "name")
          return [i(s, void 0, o.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function N8(t, e) {
  return e - t;
}
function ex(t, e) {
  let n = [];
  return i(e), n.sort(N8);
  function i(r) {
    let a = t[r];
    if (a.length == 1 && !a[0].term)
      return i(a[0].to);
    n.push(r);
    for (let o = 0; o < a.length; o++) {
      let { term: s, to: l } = a[o];
      !s && n.indexOf(l) == -1 && i(l);
    }
  }
}
function NTe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return n(ex(t, 0));
  function n(i) {
    let r = [];
    i.forEach((o) => {
      t[o].forEach(({ term: s, to: l }) => {
        if (!s)
          return;
        let c;
        for (let u = 0; u < r.length; u++)
          r[u][0] == s && (c = r[u][1]);
        ex(t, l).forEach((u) => {
          c || r.push([s, c = []]), c.indexOf(u) == -1 && c.push(u);
        });
      });
    });
    let a = e[i.join(",")] = new bo(i.indexOf(t.length - 1) > -1);
    for (let o = 0; o < r.length; o++) {
      let s = r[o][1].sort(N8);
      a.next.push({ type: r[o][0], next: e[s.join(",")] || n(s) });
    }
    return a;
  }
}
function $Te(t, e) {
  for (let n = 0, i = [t]; n < i.length; n++) {
    let r = i[n], a = !r.validEnd, o = [];
    for (let s = 0; s < r.next.length; s++) {
      let { type: l, next: c } = r.next[s];
      o.push(l.name), a && !(l.isText || l.hasRequiredAttrs()) && (a = !1), i.indexOf(c) == -1 && i.push(c);
    }
    a && e.err("Only non-generatable nodes (" + o.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function $8(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let i = t[n];
    if (!i.hasDefault)
      return null;
    e[n] = i.default;
  }
  return e;
}
function D8(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  for (let i in t) {
    let r = e && e[i];
    if (r === void 0) {
      let a = t[i];
      if (a.hasDefault)
        r = a.default;
      else
        throw new RangeError("No value supplied for attribute " + i);
    }
    n[i] = r;
  }
  return n;
}
function E8(t, e, n, i) {
  for (let r in e)
    if (!(r in t))
      throw new RangeError(`Unsupported attribute ${r} for ${n} of type ${r}`);
  for (let r in t) {
    let a = t[r];
    a.validate && a.validate(e[r]);
  }
}
function T8(t, e) {
  let n = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let i in e)
      n[i] = new ETe(t, i, e[i]);
  return n;
}
let tx = class O8 {
  /**
  @internal
  */
  constructor(e, n, i) {
    this.name = e, this.schema = n, this.spec = i, this.markSet = null, this.groups = i.group ? i.group.split(" ") : [], this.attrs = T8(e, i.attrs), this.defaultAttrs = $8(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(i.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == bo.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : D8(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, n, i) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new wa(this, this.computeAttrs(e), ee.from(n), pt.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, n, i) {
    return n = ee.from(n), this.checkContent(n), new wa(this, this.computeAttrs(e), n, pt.setFrom(i));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, n, i) {
    if (e = this.computeAttrs(e), n = ee.from(n), n.size) {
      let o = this.contentMatch.fillBefore(n);
      if (!o)
        return null;
      n = o.append(n);
    }
    let r = this.contentMatch.matchFragment(n), a = r && r.fillBefore(ee.empty, !0);
    return a ? new wa(this, e, n.append(a), pt.setFrom(i)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let n = this.contentMatch.matchFragment(e);
    if (!n || !n.validEnd)
      return !1;
    for (let i = 0; i < e.childCount; i++)
      if (!this.allowsMarks(e.child(i).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    E8(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let n = 0; n < e.length; n++)
      if (!this.allowsMarkType(e[n].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let n;
    for (let i = 0; i < e.length; i++)
      this.allowsMarkType(e[i].type) ? n && n.push(e[i]) : n || (n = e.slice(0, i));
    return n ? n.length ? n : pt.none : e;
  }
  /**
  @internal
  */
  static compile(e, n) {
    let i = /* @__PURE__ */ Object.create(null);
    e.forEach((a, o) => i[a] = new O8(a, n, o));
    let r = n.spec.topNode || "doc";
    if (!i[r])
      throw new RangeError("Schema is missing its top node type ('" + r + "')");
    if (!i.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let a in i.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return i;
  }
};
function DTe(t, e, n) {
  let i = n.split("|");
  return (r) => {
    let a = r === null ? "null" : typeof r;
    if (i.indexOf(a) < 0)
      throw new RangeError(`Expected value of type ${i} for attribute ${e} on type ${t}, got ${a}`);
  };
}
class ETe {
  constructor(e, n, i) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(i, "default"), this.default = i.default, this.validate = typeof i.validate == "string" ? DTe(e, n, i.validate) : i.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class uh {
  /**
  @internal
  */
  constructor(e, n, i, r) {
    this.name = e, this.rank = n, this.schema = i, this.spec = r, this.attrs = T8(e, r.attrs), this.excluded = null;
    let a = $8(this.attrs);
    this.instance = a ? new pt(this, a) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new pt(this, D8(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, n) {
    let i = /* @__PURE__ */ Object.create(null), r = 0;
    return e.forEach((a, o) => i[a] = new uh(a, r++, n, o)), i;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var n = 0; n < e.length; n++)
      e[n].type == this && (e = e.slice(0, n).concat(e.slice(n + 1)), n--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let n = 0; n < e.length; n++)
      if (e[n].type == this)
        return e[n];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    E8(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
class W8 {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let n = this.spec = {};
    for (let r in e)
      n[r] = e[r];
    n.nodes = ln.from(e.nodes), n.marks = ln.from(e.marks || {}), this.nodes = tx.compile(this.spec.nodes, this), this.marks = uh.compile(this.spec.marks, this);
    let i = /* @__PURE__ */ Object.create(null);
    for (let r in this.nodes) {
      if (r in this.marks)
        throw new RangeError(r + " can not be both a node and a mark");
      let a = this.nodes[r], o = a.spec.content || "", s = a.spec.marks;
      if (a.contentMatch = i[o] || (i[o] = bo.parse(o, this.nodes)), a.inlineContent = a.contentMatch.inlineContent, a.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!a.isInline || !a.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = a;
      }
      a.markSet = s == "_" ? null : s ? nx(this, s.split(" ")) : s == "" || !a.inlineContent ? [] : null;
    }
    for (let r in this.marks) {
      let a = this.marks[r], o = a.spec.excludes;
      a.excluded = o == null ? [a] : o == "" ? [] : nx(this, o.split(" "));
    }
    this.nodeFromJSON = this.nodeFromJSON.bind(this), this.markFromJSON = this.markFromJSON.bind(this), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, n = null, i, r) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof tx) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(n, i, r);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, n) {
    let i = this.nodes.text;
    return new Nf(i, i.defaultAttrs, e, pt.setFrom(n));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, n) {
    return typeof e == "string" && (e = this.marks[e]), e.create(n);
  }
  /**
  Deserialize a node from its JSON representation. This method is
  bound.
  */
  nodeFromJSON(e) {
    return wa.fromJSON(this, e);
  }
  /**
  Deserialize a mark from its JSON representation. This method is
  bound.
  */
  markFromJSON(e) {
    return pt.fromJSON(this, e);
  }
  /**
  @internal
  */
  nodeType(e) {
    let n = this.nodes[e];
    if (!n)
      throw new RangeError("Unknown node type: " + e);
    return n;
  }
}
function nx(t, e) {
  let n = [];
  for (let i = 0; i < e.length; i++) {
    let r = e[i], a = t.marks[r], o = a;
    if (a)
      n.push(a);
    else
      for (let s in t.marks) {
        let l = t.marks[s];
        (r == "_" || l.spec.group && l.spec.group.split(" ").indexOf(r) > -1) && n.push(o = l);
      }
    if (!o)
      throw new SyntaxError("Unknown mark type: '" + e[i] + "'");
  }
  return n;
}
function TTe(t) {
  return t.tag != null;
}
function OTe(t) {
  return t.style != null;
}
let Bl = class Mg {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, n) {
    this.schema = e, this.rules = n, this.tags = [], this.styles = [];
    let i = this.matchedStyles = [];
    n.forEach((r) => {
      if (TTe(r))
        this.tags.push(r);
      else if (OTe(r)) {
        let a = /[^=]*/.exec(r.style)[0];
        i.indexOf(a) < 0 && i.push(a), this.styles.push(r);
      }
    }), this.normalizeLists = !this.tags.some((r) => {
      if (!/^(ul|ol)\b/.test(r.tag) || !r.node)
        return !1;
      let a = e.nodes[r.node];
      return a.contentMatch.matchType(a);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, n = {}) {
    let i = new rx(this, n, !1);
    return i.addAll(e, pt.none, n.from, n.to), i.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, n = {}) {
    let i = new rx(this, n, !0);
    return i.addAll(e, pt.none, n.from, n.to), ye.maxOpen(i.finish());
  }
  /**
  @internal
  */
  matchTag(e, n, i) {
    for (let r = i ? this.tags.indexOf(i) + 1 : 0; r < this.tags.length; r++) {
      let a = this.tags[r];
      if (LTe(e, a.tag) && (a.namespace === void 0 || e.namespaceURI == a.namespace) && (!a.context || n.matchesContext(a.context))) {
        if (a.getAttrs) {
          let o = a.getAttrs(e);
          if (o === !1)
            continue;
          a.attrs = o || void 0;
        }
        return a;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, n, i, r) {
    for (let a = r ? this.styles.indexOf(r) + 1 : 0; a < this.styles.length; a++) {
      let o = this.styles[a], s = o.style;
      if (!(s.indexOf(e) != 0 || o.context && !i.matchesContext(o.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      s.length > e.length && (s.charCodeAt(e.length) != 61 || s.slice(e.length + 1) != n))) {
        if (o.getAttrs) {
          let l = o.getAttrs(n);
          if (l === !1)
            continue;
          o.attrs = l || void 0;
        }
        return o;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let n = [];
    function i(r) {
      let a = r.priority == null ? 50 : r.priority, o = 0;
      for (; o < n.length; o++) {
        let s = n[o];
        if ((s.priority == null ? 50 : s.priority) < a)
          break;
      }
      n.splice(o, 0, r);
    }
    for (let r in e.marks) {
      let a = e.marks[r].spec.parseDOM;
      a && a.forEach((o) => {
        i(o = ax(o)), o.mark || o.ignore || o.clearMark || (o.mark = r);
      });
    }
    for (let r in e.nodes) {
      let a = e.nodes[r].spec.parseDOM;
      a && a.forEach((o) => {
        i(o = ax(o)), o.node || o.ignore || o.mark || (o.node = r);
      });
    }
    return n;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.ParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new Mg(e, Mg.schemaRules(e)));
  }
};
const A8 = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, WTe = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, L8 = { ol: !0, ul: !0 }, gd = 1, Cg = 2, $u = 4;
function ix(t, e, n) {
  return e != null ? (e ? gd : 0) | (e === "full" ? Cg : 0) : t && t.whitespace == "pre" ? gd | Cg : n & -5;
}
class eu {
  constructor(e, n, i, r, a, o) {
    this.type = e, this.attrs = n, this.marks = i, this.solid = r, this.options = o, this.content = [], this.activeMarks = pt.none, this.match = a || (o & $u ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let n = this.type.contentMatch.fillBefore(ee.from(e));
      if (n)
        this.match = this.type.contentMatch.matchFragment(n);
      else {
        let i = this.type.contentMatch, r;
        return (r = i.findWrapping(e.type)) ? (this.match = i, r) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & gd)) {
      let i = this.content[this.content.length - 1], r;
      if (i && i.isText && (r = /[ \t\r\n\u000c]+$/.exec(i.text))) {
        let a = i;
        i.text.length == r[0].length ? this.content.pop() : this.content[this.content.length - 1] = a.withText(a.text.slice(0, a.text.length - r[0].length));
      }
    }
    let n = ee.from(this.content);
    return !e && this.match && (n = n.append(this.match.fillBefore(ee.empty, !0))), this.type ? this.type.create(this.attrs, n, this.marks) : n;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !A8.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class rx {
  constructor(e, n, i) {
    this.parser = e, this.options = n, this.isOpen = i, this.open = 0, this.localPreserveWS = !1;
    let r = n.topNode, a, o = ix(null, n.preserveWhitespace, 0) | (i ? $u : 0);
    r ? a = new eu(r.type, r.attrs, pt.none, !0, n.topMatch || r.type.contentMatch, o) : i ? a = new eu(null, null, pt.none, !0, null, o) : a = new eu(e.schema.topNodeType, null, pt.none, !0, null, o), this.nodes = [a], this.find = n.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, n) {
    e.nodeType == 3 ? this.addTextNode(e, n) : e.nodeType == 1 && this.addElement(e, n);
  }
  addTextNode(e, n) {
    let i = e.nodeValue, r = this.top, a = r.options & Cg ? "full" : this.localPreserveWS || (r.options & gd) > 0;
    if (a === "full" || r.inlineContext(e) || /[^ \t\r\n\u000c]/.test(i)) {
      if (a)
        a !== "full" ? i = i.replace(/\r?\n|\r/g, " ") : i = i.replace(/\r\n?/g, `
`);
      else if (i = i.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(i) && this.open == this.nodes.length - 1) {
        let o = r.content[r.content.length - 1], s = e.previousSibling;
        (!o || s && s.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (i = i.slice(1));
      }
      i && this.insertNode(this.parser.schema.text(i), n), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, n, i) {
    let r = this.localPreserveWS, a = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let o = e.nodeName.toLowerCase(), s;
    L8.hasOwnProperty(o) && this.parser.normalizeLists && ATe(e);
    let l = this.options.ruleFromNode && this.options.ruleFromNode(e) || (s = this.parser.matchTag(e, this, i));
    e: if (l ? l.ignore : WTe.hasOwnProperty(o))
      this.findInside(e), this.ignoreFallback(e, n);
    else if (!l || l.skip || l.closeParent) {
      l && l.closeParent ? this.open = Math.max(0, this.open - 1) : l && l.skip.nodeType && (e = l.skip);
      let c, u = this.needsBlock;
      if (A8.hasOwnProperty(o))
        a.content.length && a.content[0].isInline && this.open && (this.open--, a = this.top), c = !0, a.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, n);
        break e;
      }
      let f = l && l.skip ? n : this.readStyles(e, n);
      f && this.addAll(e, f), c && this.sync(a), this.needsBlock = u;
    } else {
      let c = this.readStyles(e, n);
      c && this.addElementByRule(e, l, c, l.consuming === !1 ? s : void 0);
    }
    this.localPreserveWS = r;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, n) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), n);
  }
  // Called for ignored nodes
  ignoreFallback(e, n) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), n);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, n) {
    let i = e.style;
    if (i && i.length)
      for (let r = 0; r < this.parser.matchedStyles.length; r++) {
        let a = this.parser.matchedStyles[r], o = i.getPropertyValue(a);
        if (o)
          for (let s = void 0; ; ) {
            let l = this.parser.matchStyle(a, o, this, s);
            if (!l)
              break;
            if (l.ignore)
              return null;
            if (l.clearMark ? n = n.filter((c) => !l.clearMark(c)) : n = n.concat(this.parser.schema.marks[l.mark].create(l.attrs)), l.consuming === !1)
              s = l;
            else
              break;
          }
      }
    return n;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, n, i, r) {
    let a, o;
    if (n.node)
      if (o = this.parser.schema.nodes[n.node], o.isLeaf)
        this.insertNode(o.create(n.attrs), i) || this.leafFallback(e, i);
      else {
        let l = this.enter(o, n.attrs || null, i, n.preserveWhitespace);
        l && (a = !0, i = l);
      }
    else {
      let l = this.parser.schema.marks[n.mark];
      i = i.concat(l.create(n.attrs));
    }
    let s = this.top;
    if (o && o.isLeaf)
      this.findInside(e);
    else if (r)
      this.addElement(e, i, r);
    else if (n.getContent)
      this.findInside(e), n.getContent(e, this.parser.schema).forEach((l) => this.insertNode(l, i));
    else {
      let l = e;
      typeof n.contentElement == "string" ? l = e.querySelector(n.contentElement) : typeof n.contentElement == "function" ? l = n.contentElement(e) : n.contentElement && (l = n.contentElement), this.findAround(e, l, !0), this.addAll(l, i), this.findAround(e, l, !1);
    }
    a && this.sync(s) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, n, i, r) {
    let a = i || 0;
    for (let o = i ? e.childNodes[i] : e.firstChild, s = r == null ? null : e.childNodes[r]; o != s; o = o.nextSibling, ++a)
      this.findAtPoint(e, a), this.addDOM(o, n);
    this.findAtPoint(e, a);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, n) {
    let i, r;
    for (let a = this.open; a >= 0; a--) {
      let o = this.nodes[a], s = o.findWrapping(e);
      if (s && (!i || i.length > s.length) && (i = s, r = o, !s.length) || o.solid)
        break;
    }
    if (!i)
      return null;
    this.sync(r);
    for (let a = 0; a < i.length; a++)
      n = this.enterInner(i[a], null, n, !1);
    return n;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, n) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (n = this.enterInner(r, null, n));
    }
    let i = this.findPlace(e, n);
    if (i) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(e.type));
      let a = pt.none;
      for (let o of i.concat(e.marks))
        (r.type ? r.type.allowsMarkType(o.type) : ox(o.type, e.type)) && (a = o.addToSet(a));
      return r.content.push(e.mark(a)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, n, i, r) {
    let a = this.findPlace(e.create(n), i);
    return a && (a = this.enterInner(e, n, i, !0, r)), a;
  }
  // Open a node of the given type
  enterInner(e, n, i, r = !1, a) {
    this.closeExtra();
    let o = this.top;
    o.match = o.match && o.match.matchType(e);
    let s = ix(e, a, o.options);
    o.options & $u && o.content.length == 0 && (s |= $u);
    let l = pt.none;
    return i = i.filter((c) => (o.type ? o.type.allowsMarkType(c.type) : ox(c.type, e)) ? (l = c.addToSet(l), !1) : !0), this.nodes.push(new eu(e, n, l, r, null, s)), this.open++, i;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let n = this.nodes.length - 1;
    if (n > this.open) {
      for (; n > this.open; n--)
        this.nodes[n - 1].content.push(this.nodes[n].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let n = this.open; n >= 0; n--) {
      if (this.nodes[n] == e)
        return this.open = n, !0;
      this.localPreserveWS && (this.nodes[n].options |= gd);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let n = this.open; n >= 0; n--) {
      let i = this.nodes[n].content;
      for (let r = i.length - 1; r >= 0; r--)
        e += i[r].nodeSize;
      n && e++;
    }
    return e;
  }
  findAtPoint(e, n) {
    if (this.find)
      for (let i = 0; i < this.find.length; i++)
        this.find[i].node == e && this.find[i].offset == n && (this.find[i].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].pos == null && e.nodeType == 1 && e.contains(this.find[n].node) && (this.find[n].pos = this.currentPos);
  }
  findAround(e, n, i) {
    if (e != n && this.find)
      for (let r = 0; r < this.find.length; r++)
        this.find[r].pos == null && e.nodeType == 1 && e.contains(this.find[r].node) && n.compareDocumentPosition(this.find[r].node) & (i ? 2 : 4) && (this.find[r].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && (this.find[n].pos = this.currentPos - (e.nodeValue.length - this.find[n].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let n = e.split("/"), i = this.options.context, r = !this.isOpen && (!i || i.parent.type == this.nodes[0].type), a = -(i ? i.depth + 1 : 0) + (r ? 0 : 1), o = (s, l) => {
      for (; s >= 0; s--) {
        let c = n[s];
        if (c == "") {
          if (s == n.length - 1 || s == 0)
            continue;
          for (; l >= a; l--)
            if (o(s - 1, l))
              return !0;
          return !1;
        } else {
          let u = l > 0 || l == 0 && r ? this.nodes[l].type : i && l >= a ? i.node(l - a).type : null;
          if (!u || u.name != c && !u.isInGroup(c))
            return !1;
          l--;
        }
      }
      return !0;
    };
    return o(n.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let n = e.depth; n >= 0; n--) {
        let i = e.node(n).contentMatchAt(e.indexAfter(n)).defaultType;
        if (i && i.isTextblock && i.defaultAttrs)
          return i;
      }
    for (let n in this.parser.schema.nodes) {
      let i = this.parser.schema.nodes[n];
      if (i.isTextblock && i.defaultAttrs)
        return i;
    }
  }
}
function ATe(t) {
  for (let e = t.firstChild, n = null; e; e = e.nextSibling) {
    let i = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    i && L8.hasOwnProperty(i) && n ? (n.appendChild(e), e = n) : i == "li" ? n = e : i && (n = null);
  }
}
function LTe(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function ax(t) {
  let e = {};
  for (let n in t)
    e[n] = t[n];
  return e;
}
function ox(t, e) {
  let n = e.schema.nodes;
  for (let i in n) {
    let r = n[i];
    if (!r.allowsMarkType(t))
      continue;
    let a = [], o = (s) => {
      a.push(s);
      for (let l = 0; l < s.edgeCount; l++) {
        let { type: c, next: u } = s.edge(l);
        if (c == e || a.indexOf(u) < 0 && o(u))
          return !0;
      }
    };
    if (o(r.contentMatch))
      return !0;
  }
}
class Io {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, n) {
    this.nodes = e, this.marks = n;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, n = {}, i) {
    i || (i = O1(n).createDocumentFragment());
    let r = i, a = [];
    return e.forEach((o) => {
      if (a.length || o.marks.length) {
        let s = 0, l = 0;
        for (; s < a.length && l < o.marks.length; ) {
          let c = o.marks[l];
          if (!this.marks[c.type.name]) {
            l++;
            continue;
          }
          if (!c.eq(a[s][0]) || c.type.spec.spanning === !1)
            break;
          s++, l++;
        }
        for (; s < a.length; )
          r = a.pop()[1];
        for (; l < o.marks.length; ) {
          let c = o.marks[l++], u = this.serializeMark(c, o.isInline, n);
          u && (a.push([c, r]), r.appendChild(u.dom), r = u.contentDOM || u.dom);
        }
      }
      r.appendChild(this.serializeNodeInner(o, n));
    }), i;
  }
  /**
  @internal
  */
  serializeNodeInner(e, n) {
    let { dom: i, contentDOM: r } = Du(O1(n), this.nodes[e.type.name](e), null, e.attrs);
    if (r) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, n, r);
    }
    return i;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, n = {}) {
    let i = this.serializeNodeInner(e, n);
    for (let r = e.marks.length - 1; r >= 0; r--) {
      let a = this.serializeMark(e.marks[r], e.isInline, n);
      a && ((a.contentDOM || a.dom).appendChild(i), i = a.dom);
    }
    return i;
  }
  /**
  @internal
  */
  serializeMark(e, n, i = {}) {
    let r = this.marks[e.type.name];
    return r && Du(O1(i), r(e, n), null, e.attrs);
  }
  static renderSpec(e, n, i = null, r) {
    return Du(e, n, i, r);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new Io(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let n = sx(e.nodes);
    return n.text || (n.text = (i) => i.text), n;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return sx(e.marks);
  }
}
function sx(t) {
  let e = {};
  for (let n in t) {
    let i = t[n].spec.toDOM;
    i && (e[n] = i);
  }
  return e;
}
function O1(t) {
  return t.document || window.document;
}
const lx = /* @__PURE__ */ new WeakMap();
function ITe(t) {
  let e = lx.get(t);
  return e === void 0 && lx.set(t, e = RTe(t)), e;
}
function RTe(t) {
  let e = null;
  function n(i) {
    if (i && typeof i == "object")
      if (Array.isArray(i))
        if (typeof i[0] == "string")
          e || (e = []), e.push(i);
        else
          for (let r = 0; r < i.length; r++)
            n(i[r]);
      else
        for (let r in i)
          n(i[r]);
  }
  return n(t), e;
}
function Du(t, e, n, i) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let r = e[0], a;
  if (typeof r != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (i && (a = ITe(i)) && a.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let o = r.indexOf(" ");
  o > 0 && (n = r.slice(0, o), r = r.slice(o + 1));
  let s, l = n ? t.createElementNS(n, r) : t.createElement(r), c = e[1], u = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    u = 2;
    for (let f in c)
      if (c[f] != null) {
        let m = f.indexOf(" ");
        m > 0 ? l.setAttributeNS(f.slice(0, m), f.slice(m + 1), c[f]) : l.setAttribute(f, c[f]);
      }
  }
  for (let f = u; f < e.length; f++) {
    let m = e[f];
    if (m === 0) {
      if (f < e.length - 1 || f > u)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: l, contentDOM: l };
    } else {
      let { dom: h, contentDOM: p } = Du(t, m, n, i);
      if (l.appendChild(h), p) {
        if (s)
          throw new RangeError("Multiple content holes");
        s = p;
      }
    }
  }
  return { dom: l, contentDOM: s };
}
const I8 = 65535, R8 = Math.pow(2, 16);
function jTe(t, e) {
  return t + e * R8;
}
function dx(t) {
  return t & I8;
}
function FTe(t) {
  return (t - (t & I8)) / R8;
}
const j8 = 1, F8 = 2, Eu = 4, z8 = 8;
class Pg {
  /**
  @internal
  */
  constructor(e, n, i) {
    this.pos = e, this.delInfo = n, this.recover = i;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & z8) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & (j8 | Eu)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (F8 | Eu)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & Eu) > 0;
  }
}
class li {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, n = !1) {
    if (this.ranges = e, this.inverted = n, !e.length && li.empty)
      return li.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let n = 0, i = dx(e);
    if (!this.inverted)
      for (let r = 0; r < i; r++)
        n += this.ranges[r * 3 + 2] - this.ranges[r * 3 + 1];
    return this.ranges[i * 3] + n + FTe(e);
  }
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  map(e, n = 1) {
    return this._map(e, n, !0);
  }
  /**
  @internal
  */
  _map(e, n, i) {
    let r = 0, a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? r : 0);
      if (l > e)
        break;
      let c = this.ranges[s + a], u = this.ranges[s + o], f = l + c;
      if (e <= f) {
        let m = c ? e == l ? -1 : e == f ? 1 : n : n, h = l + r + (m < 0 ? 0 : u);
        if (i)
          return h;
        let p = e == (n < 0 ? l : f) ? null : jTe(s / 3, e - l), g = e == l ? F8 : e == f ? j8 : Eu;
        return (n < 0 ? e != l : e != f) && (g |= z8), new Pg(h, g, p);
      }
      r += u - c;
    }
    return i ? e + r : new Pg(e + r, 0, null);
  }
  /**
  @internal
  */
  touches(e, n) {
    let i = 0, r = dx(n), a = this.inverted ? 2 : 1, o = this.inverted ? 1 : 2;
    for (let s = 0; s < this.ranges.length; s += 3) {
      let l = this.ranges[s] - (this.inverted ? i : 0);
      if (l > e)
        break;
      let c = this.ranges[s + a], u = l + c;
      if (e <= u && s == r * 3)
        return !0;
      i += this.ranges[s + o] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let n = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let r = 0, a = 0; r < this.ranges.length; r += 3) {
      let o = this.ranges[r], s = o - (this.inverted ? a : 0), l = o + (this.inverted ? 0 : a), c = this.ranges[r + n], u = this.ranges[r + i];
      e(s, s + c, l, l + u), a += u - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new li(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? li.empty : new li(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
li.empty = new li([]);
class yd {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, n, i = 0, r = e ? e.length : 0) {
    this.mirror = n, this.from = i, this.to = r, this._maps = e || [], this.ownData = !(e || n);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, n = this.maps.length) {
    return new yd(this._maps, this.mirror, e, n);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, n) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), n != null && this.setMirror(this._maps.length - 1, n);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let n = 0, i = this._maps.length; n < e._maps.length; n++) {
      let r = e.getMirror(n);
      this.appendMap(e._maps[n], r != null && r < n ? i + r : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let n = 0; n < this.mirror.length; n++)
        if (this.mirror[n] == e)
          return this.mirror[n + (n % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, n) {
    this.mirror || (this.mirror = []), this.mirror.push(e, n);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let n = e.maps.length - 1, i = this._maps.length + e._maps.length; n >= 0; n--) {
      let r = e.getMirror(n);
      this.appendMap(e._maps[n].invert(), r != null && r > n ? i - r - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new yd();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, n = 1) {
    if (this.mirror)
      return this._map(e, n, !0);
    for (let i = this.from; i < this.to; i++)
      e = this._maps[i].map(e, n);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, n = 1) {
    return this._map(e, n, !1);
  }
  /**
  @internal
  */
  _map(e, n, i) {
    let r = 0;
    for (let a = this.from; a < this.to; a++) {
      let o = this._maps[a], s = o.mapResult(e, n);
      if (s.recover != null) {
        let l = this.getMirror(a);
        if (l != null && l > a && l < this.to) {
          a = l, e = this._maps[l].recover(s.recover);
          continue;
        }
      }
      r |= s.delInfo, e = s.pos;
    }
    return i ? e : new Pg(e, r, null);
  }
}
const W1 = /* @__PURE__ */ Object.create(null);
class Mn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return li.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, n) {
    if (!n || !n.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let i = W1[n.stepType];
    if (!i)
      throw new RangeError(`No step type ${n.stepType} defined`);
    return i.fromJSON(e, n);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, n) {
    if (e in W1)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return W1[e] = n, n.prototype.jsonID = e, n;
  }
}
class Yt {
  /**
  @internal
  */
  constructor(e, n) {
    this.doc = e, this.failed = n;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new Yt(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new Yt(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, n, i, r) {
    try {
      return Yt.ok(e.replace(n, i, r));
    } catch (a) {
      if (a instanceof Pf)
        return Yt.fail(a.message);
      throw a;
    }
  }
}
function I0(t, e, n) {
  let i = [];
  for (let r = 0; r < t.childCount; r++) {
    let a = t.child(r);
    a.content.size && (a = a.copy(I0(a.content, e, a))), a.isInline && (a = e(a, n, r)), i.push(a);
  }
  return ee.fromArray(i);
}
class fa extends Mn {
  /**
  Create a mark step.
  */
  constructor(e, n, i) {
    super(), this.from = e, this.to = n, this.mark = i;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), i = e.resolve(this.from), r = i.node(i.sharedDepth(this.to)), a = new ye(I0(n.content, (o, s) => !o.isAtom || !s.type.allowsMarkType(this.mark.type) ? o : o.mark(this.mark.addToSet(o.marks)), r), n.openStart, n.openEnd);
    return Yt.fromReplace(e, this.from, this.to, a);
  }
  invert() {
    return new dr(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return n.deleted && i.deleted || n.pos >= i.pos ? null : new fa(n.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof fa && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new fa(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new fa(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Mn.jsonID("addMark", fa);
class dr extends Mn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n, i) {
    super(), this.from = e, this.to = n, this.mark = i;
  }
  apply(e) {
    let n = e.slice(this.from, this.to), i = new ye(I0(n.content, (r) => r.mark(this.mark.removeFromSet(r.marks)), e), n.openStart, n.openEnd);
    return Yt.fromReplace(e, this.from, this.to, i);
  }
  invert() {
    return new fa(this.from, this.to, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return n.deleted && i.deleted || n.pos >= i.pos ? null : new dr(n.pos, i.pos, this.mark);
  }
  merge(e) {
    return e instanceof dr && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new dr(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new dr(n.from, n.to, e.markFromJSON(n.mark));
  }
}
Mn.jsonID("removeMark", dr);
class ma extends Mn {
  /**
  Create a node mark step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Yt.fail("No node at mark step's position");
    let i = n.type.create(n.attrs, null, this.mark.addToSet(n.marks));
    return Yt.fromReplace(e, this.pos, this.pos + 1, new ye(ee.from(i), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    if (n) {
      let i = this.mark.addToSet(n.marks);
      if (i.length == n.marks.length) {
        for (let r = 0; r < n.marks.length; r++)
          if (!n.marks[r].isInSet(i))
            return new ma(this.pos, n.marks[r]);
        return new ma(this.pos, this.mark);
      }
    }
    return new $s(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new ma(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new ma(n.pos, e.markFromJSON(n.mark));
  }
}
Mn.jsonID("addNodeMark", ma);
class $s extends Mn {
  /**
  Create a mark-removing step.
  */
  constructor(e, n) {
    super(), this.pos = e, this.mark = n;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Yt.fail("No node at mark step's position");
    let i = n.type.create(n.attrs, null, this.mark.removeFromSet(n.marks));
    return Yt.fromReplace(e, this.pos, this.pos + 1, new ye(ee.from(i), 0, n.isLeaf ? 0 : 1));
  }
  invert(e) {
    let n = e.nodeAt(this.pos);
    return !n || !this.mark.isInSet(n.marks) ? this : new ma(this.pos, this.mark);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new $s(n.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new $s(n.pos, e.markFromJSON(n.mark));
  }
}
Mn.jsonID("removeNodeMark", $s);
class nn extends Mn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, n, i, r = !1) {
    super(), this.from = e, this.to = n, this.slice = i, this.structure = r;
  }
  apply(e) {
    return this.structure && Sg(e, this.from, this.to) ? Yt.fail("Structure replace would overwrite content") : Yt.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new li([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new nn(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let n = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1);
    return n.deletedAcross && i.deletedAcross ? null : new nn(n.pos, Math.max(n.pos, i.pos), this.slice);
  }
  merge(e) {
    if (!(e instanceof nn) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let n = this.slice.size + e.slice.size == 0 ? ye.empty : new ye(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new nn(this.from, this.to + (e.to - e.from), n, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let n = this.slice.size + e.slice.size == 0 ? ye.empty : new ye(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new nn(e.from, this.to, n, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new nn(n.from, n.to, ye.fromJSON(e, n.slice), !!n.structure);
  }
}
Mn.jsonID("replace", nn);
class rn extends Mn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, n, i, r, a, o, s = !1) {
    super(), this.from = e, this.to = n, this.gapFrom = i, this.gapTo = r, this.slice = a, this.insert = o, this.structure = s;
  }
  apply(e) {
    if (this.structure && (Sg(e, this.from, this.gapFrom) || Sg(e, this.gapTo, this.to)))
      return Yt.fail("Structure gap-replace would overwrite content");
    let n = e.slice(this.gapFrom, this.gapTo);
    if (n.openStart || n.openEnd)
      return Yt.fail("Gap is not a flat range");
    let i = this.slice.insertAt(this.insert, n.content);
    return i ? Yt.fromReplace(e, this.from, this.to, i) : Yt.fail("Content does not fit in gap");
  }
  getMap() {
    return new li([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let n = this.gapTo - this.gapFrom;
    return new rn(this.from, this.from + this.slice.size + n, this.from + this.insert, this.from + this.insert + n, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let n = e.mapResult(this.from, 1), i = e.mapResult(this.to, -1), r = this.from == this.gapFrom ? n.pos : e.map(this.gapFrom, -1), a = this.to == this.gapTo ? i.pos : e.map(this.gapTo, 1);
    return n.deletedAcross && i.deletedAcross || r < n.pos || a > i.pos ? null : new rn(n.pos, i.pos, r, a, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.from != "number" || typeof n.to != "number" || typeof n.gapFrom != "number" || typeof n.gapTo != "number" || typeof n.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new rn(n.from, n.to, n.gapFrom, n.gapTo, ye.fromJSON(e, n.slice), n.insert, !!n.structure);
  }
}
Mn.jsonID("replaceAround", rn);
function Sg(t, e, n) {
  let i = t.resolve(e), r = n - e, a = i.depth;
  for (; r > 0 && a > 0 && i.indexAfter(a) == i.node(a).childCount; )
    a--, r--;
  if (r > 0) {
    let o = i.node(a).maybeChild(i.indexAfter(a));
    for (; r > 0; ) {
      if (!o || o.isLeaf)
        return !0;
      o = o.firstChild, r--;
    }
  }
  return !1;
}
function zTe(t, e, n, i) {
  let r = [], a = [], o, s;
  t.doc.nodesBetween(e, n, (l, c, u) => {
    if (!l.isInline)
      return;
    let f = l.marks;
    if (!i.isInSet(f) && u.type.allowsMarkType(i.type)) {
      let m = Math.max(c, e), h = Math.min(c + l.nodeSize, n), p = i.addToSet(f);
      for (let g = 0; g < f.length; g++)
        f[g].isInSet(p) || (o && o.to == m && o.mark.eq(f[g]) ? o.to = h : r.push(o = new dr(m, h, f[g])));
      s && s.to == m ? s.to = h : a.push(s = new fa(m, h, i));
    }
  }), r.forEach((l) => t.step(l)), a.forEach((l) => t.step(l));
}
function VTe(t, e, n, i) {
  let r = [], a = 0;
  t.doc.nodesBetween(e, n, (o, s) => {
    if (!o.isInline)
      return;
    a++;
    let l = null;
    if (i instanceof uh) {
      let c = o.marks, u;
      for (; u = i.isInSet(c); )
        (l || (l = [])).push(u), c = u.removeFromSet(c);
    } else i ? i.isInSet(o.marks) && (l = [i]) : l = o.marks;
    if (l && l.length) {
      let c = Math.min(s + o.nodeSize, n);
      for (let u = 0; u < l.length; u++) {
        let f = l[u], m;
        for (let h = 0; h < r.length; h++) {
          let p = r[h];
          p.step == a - 1 && f.eq(r[h].style) && (m = p);
        }
        m ? (m.to = c, m.step = a) : r.push({ style: f, from: Math.max(s, e), to: c, step: a });
      }
    }
  }), r.forEach((o) => t.step(new dr(o.from, o.to, o.style)));
}
function R0(t, e, n, i = n.contentMatch, r = !0) {
  let a = t.doc.nodeAt(e), o = [], s = e + 1;
  for (let l = 0; l < a.childCount; l++) {
    let c = a.child(l), u = s + c.nodeSize, f = i.matchType(c.type);
    if (!f)
      o.push(new nn(s, u, ye.empty));
    else {
      i = f;
      for (let m = 0; m < c.marks.length; m++)
        n.allowsMarkType(c.marks[m].type) || t.step(new dr(s, u, c.marks[m]));
      if (r && c.isText && n.whitespace != "pre") {
        let m, h = /\r?\n|\r/g, p;
        for (; m = h.exec(c.text); )
          p || (p = new ye(ee.from(n.schema.text(" ", n.allowedMarks(c.marks))), 0, 0)), o.push(new nn(s + m.index, s + m.index + m[0].length, p));
      }
    }
    s = u;
  }
  if (!i.validEnd) {
    let l = i.fillBefore(ee.empty, !0);
    t.replace(s, s, new ye(l, 0, 0));
  }
  for (let l = o.length - 1; l >= 0; l--)
    t.step(o[l]);
}
function HTe(t, e, n) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (n == t.childCount || t.canReplace(0, n));
}
function il(t) {
  let n = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let i = t.depth; ; --i) {
    let r = t.$from.node(i), a = t.$from.index(i), o = t.$to.indexAfter(i);
    if (i < t.depth && r.canReplace(a, o, n))
      return i;
    if (i == 0 || r.type.spec.isolating || !HTe(r, a, o))
      break;
  }
  return null;
}
function BTe(t, e, n) {
  let { $from: i, $to: r, depth: a } = e, o = i.before(a + 1), s = r.after(a + 1), l = o, c = s, u = ee.empty, f = 0;
  for (let p = a, g = !1; p > n; p--)
    g || i.index(p) > 0 ? (g = !0, u = ee.from(i.node(p).copy(u)), f++) : l--;
  let m = ee.empty, h = 0;
  for (let p = a, g = !1; p > n; p--)
    g || r.after(p + 1) < r.end(p) ? (g = !0, m = ee.from(r.node(p).copy(m)), h++) : c++;
  t.step(new rn(l, c, o, s, new ye(u.append(m), f, h), u.size - f, !0));
}
function j0(t, e, n = null, i = t) {
  let r = qTe(t, e), a = r && GTe(i, e);
  return a ? r.map(cx).concat({ type: e, attrs: n }).concat(a.map(cx)) : null;
}
function cx(t) {
  return { type: t, attrs: null };
}
function qTe(t, e) {
  let { parent: n, startIndex: i, endIndex: r } = t, a = n.contentMatchAt(i).findWrapping(e);
  if (!a)
    return null;
  let o = a.length ? a[0] : e;
  return n.canReplaceWith(i, r, o) ? a : null;
}
function GTe(t, e) {
  let { parent: n, startIndex: i, endIndex: r } = t, a = n.child(i), o = e.contentMatch.findWrapping(a.type);
  if (!o)
    return null;
  let l = (o.length ? o[o.length - 1] : e).contentMatch;
  for (let c = i; l && c < r; c++)
    l = l.matchType(n.child(c).type);
  return !l || !l.validEnd ? null : o;
}
function XTe(t, e, n) {
  let i = ee.empty;
  for (let o = n.length - 1; o >= 0; o--) {
    if (i.size) {
      let s = n[o].type.contentMatch.matchFragment(i);
      if (!s || !s.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    i = ee.from(n[o].type.create(n[o].attrs, i));
  }
  let r = e.start, a = e.end;
  t.step(new rn(r, a, r, a, new ye(i, 0, 0), n.length, !0));
}
function YTe(t, e, n, i, r) {
  if (!i.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let a = t.steps.length;
  t.doc.nodesBetween(e, n, (o, s) => {
    let l = typeof r == "function" ? r(o) : r;
    if (o.isTextblock && !o.hasMarkup(i, l) && KTe(t.doc, t.mapping.slice(a).map(s), i)) {
      let c = null;
      if (i.schema.linebreakReplacement) {
        let h = i.whitespace == "pre", p = !!i.contentMatch.matchType(i.schema.linebreakReplacement);
        h && !p ? c = !1 : !h && p && (c = !0);
      }
      c === !1 && H8(t, o, s, a), R0(t, t.mapping.slice(a).map(s, 1), i, void 0, c === null);
      let u = t.mapping.slice(a), f = u.map(s, 1), m = u.map(s + o.nodeSize, 1);
      return t.step(new rn(f, m, f + 1, m - 1, new ye(ee.from(i.create(l, null, o.marks)), 0, 0), 1, !0)), c === !0 && V8(t, o, s, a), !1;
    }
  });
}
function V8(t, e, n, i) {
  e.forEach((r, a) => {
    if (r.isText) {
      let o, s = /\r?\n|\r/g;
      for (; o = s.exec(r.text); ) {
        let l = t.mapping.slice(i).map(n + 1 + a + o.index);
        t.replaceWith(l, l + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function H8(t, e, n, i) {
  e.forEach((r, a) => {
    if (r.type == r.type.schema.linebreakReplacement) {
      let o = t.mapping.slice(i).map(n + 1 + a);
      t.replaceWith(o, o + 1, e.type.schema.text(`
`));
    }
  });
}
function KTe(t, e, n) {
  let i = t.resolve(e), r = i.index();
  return i.parent.canReplaceWith(r, r + 1, n);
}
function UTe(t, e, n, i, r) {
  let a = t.doc.nodeAt(e);
  if (!a)
    throw new RangeError("No node at given position");
  n || (n = a.type);
  let o = n.create(i, null, r || a.marks);
  if (a.isLeaf)
    return t.replaceWith(e, e + a.nodeSize, o);
  if (!n.validContent(a.content))
    throw new RangeError("Invalid content for node type " + n.name);
  t.step(new rn(e, e + a.nodeSize, e + 1, e + a.nodeSize - 1, new ye(ee.from(o), 0, 0), 1, !0));
}
function Or(t, e, n = 1, i) {
  let r = t.resolve(e), a = r.depth - n, o = i && i[i.length - 1] || r.parent;
  if (a < 0 || r.parent.type.spec.isolating || !r.parent.canReplace(r.index(), r.parent.childCount) || !o.type.validContent(r.parent.content.cutByIndex(r.index(), r.parent.childCount)))
    return !1;
  for (let c = r.depth - 1, u = n - 2; c > a; c--, u--) {
    let f = r.node(c), m = r.index(c);
    if (f.type.spec.isolating)
      return !1;
    let h = f.content.cutByIndex(m, f.childCount), p = i && i[u + 1];
    p && (h = h.replaceChild(0, p.type.create(p.attrs)));
    let g = i && i[u] || f;
    if (!f.canReplace(m + 1, f.childCount) || !g.type.validContent(h))
      return !1;
  }
  let s = r.indexAfter(a), l = i && i[0];
  return r.node(a).canReplaceWith(s, s, l ? l.type : r.node(a + 1).type);
}
function JTe(t, e, n = 1, i) {
  let r = t.doc.resolve(e), a = ee.empty, o = ee.empty;
  for (let s = r.depth, l = r.depth - n, c = n - 1; s > l; s--, c--) {
    a = ee.from(r.node(s).copy(a));
    let u = i && i[c];
    o = ee.from(u ? u.type.create(u.attrs, o) : r.node(s).copy(o));
  }
  t.step(new nn(e, e, new ye(a.append(o), n, n), !0));
}
function Va(t, e) {
  let n = t.resolve(e), i = n.index();
  return B8(n.nodeBefore, n.nodeAfter) && n.parent.canReplace(i, i + 1);
}
function QTe(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let n = t.contentMatchAt(t.childCount), { linebreakReplacement: i } = t.type.schema;
  for (let r = 0; r < e.childCount; r++) {
    let a = e.child(r), o = a.type == i ? t.type.schema.nodes.text : a.type;
    if (n = n.matchType(o), !n || !t.type.allowsMarks(a.marks))
      return !1;
  }
  return n.validEnd;
}
function B8(t, e) {
  return !!(t && e && !t.isLeaf && QTe(t, e));
}
function fh(t, e, n = -1) {
  let i = t.resolve(e);
  for (let r = i.depth; ; r--) {
    let a, o, s = i.index(r);
    if (r == i.depth ? (a = i.nodeBefore, o = i.nodeAfter) : n > 0 ? (a = i.node(r + 1), s++, o = i.node(r).maybeChild(s)) : (a = i.node(r).maybeChild(s - 1), o = i.node(r + 1)), a && !a.isTextblock && B8(a, o) && i.node(r).canReplace(s, s + 1))
      return e;
    if (r == 0)
      break;
    e = n < 0 ? i.before(r) : i.after(r);
  }
}
function ZTe(t, e, n) {
  let i = null, { linebreakReplacement: r } = t.doc.type.schema, a = t.doc.resolve(e - n), o = a.node().type;
  if (r && o.inlineContent) {
    let u = o.whitespace == "pre", f = !!o.contentMatch.matchType(r);
    u && !f ? i = !1 : !u && f && (i = !0);
  }
  let s = t.steps.length;
  if (i === !1) {
    let u = t.doc.resolve(e + n);
    H8(t, u.node(), u.before(), s);
  }
  o.inlineContent && R0(t, e + n - 1, o, a.node().contentMatchAt(a.index()), i == null);
  let l = t.mapping.slice(s), c = l.map(e - n);
  if (t.step(new nn(c, l.map(e + n, -1), ye.empty, !0)), i === !0) {
    let u = t.doc.resolve(c);
    V8(t, u.node(), u.before(), t.steps.length);
  }
  return t;
}
function eOe(t, e, n) {
  let i = t.resolve(e);
  if (i.parent.canReplaceWith(i.index(), i.index(), n))
    return e;
  if (i.parentOffset == 0)
    for (let r = i.depth - 1; r >= 0; r--) {
      let a = i.index(r);
      if (i.node(r).canReplaceWith(a, a, n))
        return i.before(r + 1);
      if (a > 0)
        return null;
    }
  if (i.parentOffset == i.parent.content.size)
    for (let r = i.depth - 1; r >= 0; r--) {
      let a = i.indexAfter(r);
      if (i.node(r).canReplaceWith(a, a, n))
        return i.after(r + 1);
      if (a < i.node(r).childCount)
        return null;
    }
  return null;
}
function q8(t, e, n) {
  let i = t.resolve(e);
  if (!n.content.size)
    return e;
  let r = n.content;
  for (let a = 0; a < n.openStart; a++)
    r = r.firstChild.content;
  for (let a = 1; a <= (n.openStart == 0 && n.size ? 2 : 1); a++)
    for (let o = i.depth; o >= 0; o--) {
      let s = o == i.depth ? 0 : i.pos <= (i.start(o + 1) + i.end(o + 1)) / 2 ? -1 : 1, l = i.index(o) + (s > 0 ? 1 : 0), c = i.node(o), u = !1;
      if (a == 1)
        u = c.canReplace(l, l, r);
      else {
        let f = c.contentMatchAt(l).findWrapping(r.firstChild.type);
        u = f && c.canReplaceWith(l, l, f[0]);
      }
      if (u)
        return s == 0 ? i.pos : s < 0 ? i.before(o + 1) : i.after(o + 1);
    }
  return null;
}
function mh(t, e, n = e, i = ye.empty) {
  if (e == n && !i.size)
    return null;
  let r = t.resolve(e), a = t.resolve(n);
  return G8(r, a, i) ? new nn(e, n, i) : new tOe(r, a, i).fit();
}
function G8(t, e, n) {
  return !n.openStart && !n.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), n.content);
}
class tOe {
  constructor(e, n, i) {
    this.$from = e, this.$to = n, this.unplaced = i, this.frontier = [], this.placed = ee.empty;
    for (let r = 0; r <= e.depth; r++) {
      let a = e.node(r);
      this.frontier.push({
        type: a.type,
        match: a.contentMatchAt(e.indexAfter(r))
      });
    }
    for (let r = e.depth; r > 0; r--)
      this.placed = ee.from(e.node(r).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), n = this.placed.size - this.depth - this.$from.depth, i = this.$from, r = this.close(e < 0 ? this.$to : i.doc.resolve(e));
    if (!r)
      return null;
    let a = this.placed, o = i.depth, s = r.depth;
    for (; o && s && a.childCount == 1; )
      a = a.firstChild.content, o--, s--;
    let l = new ye(a, o, s);
    return e > -1 ? new rn(i.pos, e, this.$to.pos, this.$to.end(), l, n) : l.size || i.pos != this.$to.pos ? new nn(i.pos, r.pos, l) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let n = this.unplaced.content, i = 0, r = this.unplaced.openEnd; i < e; i++) {
      let a = n.firstChild;
      if (n.childCount > 1 && (r = 0), a.type.spec.isolating && r <= i) {
        e = i;
        break;
      }
      n = a.content;
    }
    for (let n = 1; n <= 2; n++)
      for (let i = n == 1 ? e : this.unplaced.openStart; i >= 0; i--) {
        let r, a = null;
        i ? (a = A1(this.unplaced.content, i - 1).firstChild, r = a.content) : r = this.unplaced.content;
        let o = r.firstChild;
        for (let s = this.depth; s >= 0; s--) {
          let { type: l, match: c } = this.frontier[s], u, f = null;
          if (n == 1 && (o ? c.matchType(o.type) || (f = c.fillBefore(ee.from(o), !1)) : a && l.compatibleContent(a.type)))
            return { sliceDepth: i, frontierDepth: s, parent: a, inject: f };
          if (n == 2 && o && (u = c.findWrapping(o.type)))
            return { sliceDepth: i, frontierDepth: s, parent: a, wrap: u };
          if (a && c.matchType(a.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: n, openEnd: i } = this.unplaced, r = A1(e, n);
    return !r.childCount || r.firstChild.isLeaf ? !1 : (this.unplaced = new ye(e, n + 1, Math.max(i, r.size + n >= e.size - i ? n + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: n, openEnd: i } = this.unplaced, r = A1(e, n);
    if (r.childCount <= 1 && n > 0) {
      let a = e.size - n <= n + r.size;
      this.unplaced = new ye(Wl(e, n - 1, 1), n - 1, a ? n - 1 : i);
    } else
      this.unplaced = new ye(Wl(e, n, 1), n, i);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: n, parent: i, inject: r, wrap: a }) {
    for (; this.depth > n; )
      this.closeFrontierNode();
    if (a)
      for (let g = 0; g < a.length; g++)
        this.openFrontierNode(a[g]);
    let o = this.unplaced, s = i ? i.content : o.content, l = o.openStart - e, c = 0, u = [], { match: f, type: m } = this.frontier[n];
    if (r) {
      for (let g = 0; g < r.childCount; g++)
        u.push(r.child(g));
      f = f.matchFragment(r);
    }
    let h = s.size + e - (o.content.size - o.openEnd);
    for (; c < s.childCount; ) {
      let g = s.child(c), y = f.matchType(g.type);
      if (!y)
        break;
      c++, (c > 1 || l == 0 || g.content.size) && (f = y, u.push(X8(g.mark(m.allowedMarks(g.marks)), c == 1 ? l : 0, c == s.childCount ? h : -1)));
    }
    let p = c == s.childCount;
    p || (h = -1), this.placed = Al(this.placed, n, ee.from(u)), this.frontier[n].match = f, p && h < 0 && i && i.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let g = 0, y = s; g < h; g++) {
      let v = y.lastChild;
      this.frontier.push({ type: v.type, match: v.contentMatchAt(v.childCount) }), y = v.content;
    }
    this.unplaced = p ? e == 0 ? ye.empty : new ye(Wl(o.content, e - 1, 1), e - 1, h < 0 ? o.openEnd : e - 1) : new ye(Wl(o.content, e, c), o.openStart, o.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], n;
    if (!e.type.isTextblock || !L1(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (n = this.findCloseLevel(this.$to)) && n.depth == this.depth)
      return -1;
    let { depth: i } = this.$to, r = this.$to.after(i);
    for (; i > 1 && r == this.$to.end(--i); )
      ++r;
    return r;
  }
  findCloseLevel(e) {
    e: for (let n = Math.min(this.depth, e.depth); n >= 0; n--) {
      let { match: i, type: r } = this.frontier[n], a = n < e.depth && e.end(n + 1) == e.pos + (e.depth - (n + 1)), o = L1(e, n, r, i, a);
      if (o) {
        for (let s = n - 1; s >= 0; s--) {
          let { match: l, type: c } = this.frontier[s], u = L1(e, s, c, l, !0);
          if (!u || u.childCount)
            continue e;
        }
        return { depth: n, fit: o, move: a ? e.doc.resolve(e.after(n + 1)) : e };
      }
    }
  }
  close(e) {
    let n = this.findCloseLevel(e);
    if (!n)
      return null;
    for (; this.depth > n.depth; )
      this.closeFrontierNode();
    n.fit.childCount && (this.placed = Al(this.placed, n.depth, n.fit)), e = n.move;
    for (let i = n.depth + 1; i <= e.depth; i++) {
      let r = e.node(i), a = r.type.contentMatch.fillBefore(r.content, !0, e.index(i));
      this.openFrontierNode(r.type, r.attrs, a);
    }
    return e;
  }
  openFrontierNode(e, n = null, i) {
    let r = this.frontier[this.depth];
    r.match = r.match.matchType(e), this.placed = Al(this.placed, this.depth, ee.from(e.create(n, i))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let n = this.frontier.pop().match.fillBefore(ee.empty, !0);
    n.childCount && (this.placed = Al(this.placed, this.frontier.length, n));
  }
}
function Wl(t, e, n) {
  return e == 0 ? t.cutByIndex(n, t.childCount) : t.replaceChild(0, t.firstChild.copy(Wl(t.firstChild.content, e - 1, n)));
}
function Al(t, e, n) {
  return e == 0 ? t.append(n) : t.replaceChild(t.childCount - 1, t.lastChild.copy(Al(t.lastChild.content, e - 1, n)));
}
function A1(t, e) {
  for (let n = 0; n < e; n++)
    t = t.firstChild.content;
  return t;
}
function X8(t, e, n) {
  if (e <= 0)
    return t;
  let i = t.content;
  return e > 1 && (i = i.replaceChild(0, X8(i.firstChild, e - 1, i.childCount == 1 ? n - 1 : 0))), e > 0 && (i = t.type.contentMatch.fillBefore(i).append(i), n <= 0 && (i = i.append(t.type.contentMatch.matchFragment(i).fillBefore(ee.empty, !0)))), t.copy(i);
}
function L1(t, e, n, i, r) {
  let a = t.node(e), o = r ? t.indexAfter(e) : t.index(e);
  if (o == a.childCount && !n.compatibleContent(a.type))
    return null;
  let s = i.fillBefore(a.content, !0, o);
  return s && !nOe(n, a.content, o) ? s : null;
}
function nOe(t, e, n) {
  for (let i = n; i < e.childCount; i++)
    if (!t.allowsMarks(e.child(i).marks))
      return !0;
  return !1;
}
function iOe(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function rOe(t, e, n, i) {
  if (!i.size)
    return t.deleteRange(e, n);
  let r = t.doc.resolve(e), a = t.doc.resolve(n);
  if (G8(r, a, i))
    return t.step(new nn(e, n, i));
  let o = K8(r, t.doc.resolve(n));
  o[o.length - 1] == 0 && o.pop();
  let s = -(r.depth + 1);
  o.unshift(s);
  for (let m = r.depth, h = r.pos - 1; m > 0; m--, h--) {
    let p = r.node(m).type.spec;
    if (p.defining || p.definingAsContext || p.isolating)
      break;
    o.indexOf(m) > -1 ? s = m : r.before(m) == h && o.splice(1, 0, -m);
  }
  let l = o.indexOf(s), c = [], u = i.openStart;
  for (let m = i.content, h = 0; ; h++) {
    let p = m.firstChild;
    if (c.push(p), h == i.openStart)
      break;
    m = p.content;
  }
  for (let m = u - 1; m >= 0; m--) {
    let h = c[m], p = iOe(h.type);
    if (p && !h.sameMarkup(r.node(Math.abs(s) - 1)))
      u = m;
    else if (p || !h.type.isTextblock)
      break;
  }
  for (let m = i.openStart; m >= 0; m--) {
    let h = (m + u + 1) % (i.openStart + 1), p = c[h];
    if (p)
      for (let g = 0; g < o.length; g++) {
        let y = o[(g + l) % o.length], v = !0;
        y < 0 && (v = !1, y = -y);
        let w = r.node(y - 1), x = r.index(y - 1);
        if (w.canReplaceWith(x, x, p.type, p.marks))
          return t.replace(r.before(y), v ? a.after(y) : n, new ye(Y8(i.content, 0, i.openStart, h), h, i.openEnd));
      }
  }
  let f = t.steps.length;
  for (let m = o.length - 1; m >= 0 && (t.replace(e, n, i), !(t.steps.length > f)); m--) {
    let h = o[m];
    h < 0 || (e = r.before(h), n = a.after(h));
  }
}
function Y8(t, e, n, i, r) {
  if (e < n) {
    let a = t.firstChild;
    t = t.replaceChild(0, a.copy(Y8(a.content, e + 1, n, i, a)));
  }
  if (e > i) {
    let a = r.contentMatchAt(0), o = a.fillBefore(t).append(t);
    t = o.append(a.matchFragment(o).fillBefore(ee.empty, !0));
  }
  return t;
}
function aOe(t, e, n, i) {
  if (!i.isInline && e == n && t.doc.resolve(e).parent.content.size) {
    let r = eOe(t.doc, e, i.type);
    r != null && (e = n = r);
  }
  t.replaceRange(e, n, new ye(ee.from(i), 0, 0));
}
function oOe(t, e, n) {
  let i = t.doc.resolve(e), r = t.doc.resolve(n), a = K8(i, r);
  for (let o = 0; o < a.length; o++) {
    let s = a[o], l = o == a.length - 1;
    if (l && s == 0 || i.node(s).type.contentMatch.validEnd)
      return t.delete(i.start(s), r.end(s));
    if (s > 0 && (l || i.node(s - 1).canReplace(i.index(s - 1), r.indexAfter(s - 1))))
      return t.delete(i.before(s), r.after(s));
  }
  for (let o = 1; o <= i.depth && o <= r.depth; o++)
    if (e - i.start(o) == i.depth - o && n > i.end(o) && r.end(o) - n != r.depth - o && i.start(o - 1) == r.start(o - 1) && i.node(o - 1).canReplace(i.index(o - 1), r.index(o - 1)))
      return t.delete(i.before(o), n);
  t.delete(e, n);
}
function K8(t, e) {
  let n = [], i = Math.min(t.depth, e.depth);
  for (let r = i; r >= 0; r--) {
    let a = t.start(r);
    if (a < t.pos - (t.depth - r) || e.end(r) > e.pos + (e.depth - r) || t.node(r).type.spec.isolating || e.node(r).type.spec.isolating)
      break;
    (a == e.start(r) || r == t.depth && r == e.depth && t.parent.inlineContent && e.parent.inlineContent && r && e.start(r - 1) == a - 1) && n.push(r);
  }
  return n;
}
class us extends Mn {
  /**
  Construct an attribute step.
  */
  constructor(e, n, i) {
    super(), this.pos = e, this.attr = n, this.value = i;
  }
  apply(e) {
    let n = e.nodeAt(this.pos);
    if (!n)
      return Yt.fail("No node at attribute step's position");
    let i = /* @__PURE__ */ Object.create(null);
    for (let a in n.attrs)
      i[a] = n.attrs[a];
    i[this.attr] = this.value;
    let r = n.type.create(i, null, n.marks);
    return Yt.fromReplace(e, this.pos, this.pos + 1, new ye(ee.from(r), 0, n.isLeaf ? 0 : 1));
  }
  getMap() {
    return li.empty;
  }
  invert(e) {
    return new us(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let n = e.mapResult(this.pos, 1);
    return n.deletedAfter ? null : new us(n.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.pos != "number" || typeof n.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new us(n.pos, n.attr, n.value);
  }
}
Mn.jsonID("attr", us);
class vd extends Mn {
  /**
  Construct an attribute step.
  */
  constructor(e, n) {
    super(), this.attr = e, this.value = n;
  }
  apply(e) {
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in e.attrs)
      n[r] = e.attrs[r];
    n[this.attr] = this.value;
    let i = e.type.create(n, e.content, e.marks);
    return Yt.ok(i);
  }
  getMap() {
    return li.empty;
  }
  invert(e) {
    return new vd(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, n) {
    if (typeof n.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new vd(n.attr, n.value);
  }
}
Mn.jsonID("docAttr", vd);
let Ds = class extends Error {
};
Ds = function t(e) {
  let n = Error.call(this, e);
  return n.__proto__ = t.prototype, n;
};
Ds.prototype = Object.create(Error.prototype);
Ds.prototype.constructor = Ds;
Ds.prototype.name = "TransformError";
class U8 {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new yd();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let n = this.maybeStep(e);
    if (n.failed)
      throw new Ds(n.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let n = e.apply(this.doc);
    return n.failed || this.addStep(e, n.doc), n;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = n;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, n = e, i = ye.empty) {
    let r = mh(this.doc, e, n, i);
    return r && this.step(r), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, n, i) {
    return this.replace(e, n, new ye(ee.from(i), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, n) {
    return this.replace(e, n, ye.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, n) {
    return this.replaceWith(e, e, n);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, n, i) {
    return rOe(this, e, n, i), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, n, i) {
    return aOe(this, e, n, i), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, n) {
    return oOe(this, e, n), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, n) {
    return BTe(this, e, n), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, n = 1) {
    return ZTe(this, e, n), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, n) {
    return XTe(this, e, n), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, n = e, i, r = null) {
    return YTe(this, e, n, i, r), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, n, i = null, r) {
    return UTe(this, e, n, i, r), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, n, i) {
    return this.step(new us(e, n, i)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, n) {
    return this.step(new vd(e, n)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, n) {
    return this.step(new ma(e, n)), this;
  }
  /**
  Remove a mark (or a mark of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, n) {
    if (!(n instanceof pt)) {
      let i = this.doc.nodeAt(e);
      if (!i)
        throw new RangeError("No node at position " + e);
      if (n = n.isInSet(i.marks), !n)
        return this;
    }
    return this.step(new $s(e, n)), this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, n = 1, i) {
    return JTe(this, e, n, i), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, n, i) {
    return zTe(this, e, n, i), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, n, i) {
    return VTe(this, e, n, i), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, n, i) {
    return R0(this, e, n, i), this;
  }
}
const I1 = /* @__PURE__ */ Object.create(null);
class He {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, n, i) {
    this.$anchor = e, this.$head = n, this.ranges = i || [new J8(e.min(n), e.max(n))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let n = 0; n < e.length; n++)
      if (e[n].$from.pos != e[n].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, n = ye.empty) {
    let i = n.content.lastChild, r = null;
    for (let s = 0; s < n.openEnd; s++)
      r = i, i = i.lastChild;
    let a = e.steps.length, o = this.ranges;
    for (let s = 0; s < o.length; s++) {
      let { $from: l, $to: c } = o[s], u = e.mapping.slice(a);
      e.replaceRange(u.map(l.pos), u.map(c.pos), s ? ye.empty : n), s == 0 && mx(e, a, (i ? i.isInline : r && r.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, n) {
    let i = e.steps.length, r = this.ranges;
    for (let a = 0; a < r.length; a++) {
      let { $from: o, $to: s } = r[a], l = e.mapping.slice(i), c = l.map(o.pos), u = l.map(s.pos);
      a ? e.deleteRange(c, u) : (e.replaceRangeWith(c, u, n), mx(e, i, n.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, n, i = !1) {
    let r = e.parent.inlineContent ? new Fe(e) : Qo(e.node(0), e.parent, e.pos, e.index(), n, i);
    if (r)
      return r;
    for (let a = e.depth - 1; a >= 0; a--) {
      let o = n < 0 ? Qo(e.node(0), e.node(a), e.before(a + 1), e.index(a), n, i) : Qo(e.node(0), e.node(a), e.after(a + 1), e.index(a) + 1, n, i);
      if (o)
        return o;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, n = 1) {
    return this.findFrom(e, n) || this.findFrom(e, -n) || new Un(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Qo(e, e, 0, 0, 1) || new Un(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Qo(e, e, e.content.size, e.childCount, -1) || new Un(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, n) {
    if (!n || !n.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let i = I1[n.type];
    if (!i)
      throw new RangeError(`No selection type ${n.type} defined`);
    return i.fromJSON(e, n);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, n) {
    if (e in I1)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return I1[e] = n, n.prototype.jsonID = e, n;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Fe.between(this.$anchor, this.$head).getBookmark();
  }
}
He.prototype.visible = !0;
class J8 {
  /**
  Create a range.
  */
  constructor(e, n) {
    this.$from = e, this.$to = n;
  }
}
let ux = !1;
function fx(t) {
  !ux && !t.parent.inlineContent && (ux = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class Fe extends He {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, n = e) {
    fx(e), fx(n), super(e, n);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, n) {
    let i = e.resolve(n.map(this.head));
    if (!i.parent.inlineContent)
      return He.near(i);
    let r = e.resolve(n.map(this.anchor));
    return new Fe(r.parent.inlineContent ? r : i, i);
  }
  replace(e, n = ye.empty) {
    if (super.replace(e, n), n == ye.empty) {
      let i = this.$from.marksAcross(this.$to);
      i && e.ensureMarks(i);
    }
  }
  eq(e) {
    return e instanceof Fe && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new hh(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number" || typeof n.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Fe(e.resolve(n.anchor), e.resolve(n.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, n, i = n) {
    let r = e.resolve(n);
    return new this(r, i == n ? r : e.resolve(i));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, n, i) {
    let r = e.pos - n.pos;
    if ((!i || r) && (i = r >= 0 ? 1 : -1), !n.parent.inlineContent) {
      let a = He.findFrom(n, i, !0) || He.findFrom(n, -i, !0);
      if (a)
        n = a.$head;
      else
        return He.near(n, i);
    }
    return e.parent.inlineContent || (r == 0 ? e = n : (e = (He.findFrom(e, -i, !0) || He.findFrom(e, i, !0)).$anchor, e.pos < n.pos != r < 0 && (e = n))), new Fe(e, n);
  }
}
He.jsonID("text", Fe);
class hh {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new hh(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Fe.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Ae extends He {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let n = e.nodeAfter, i = e.node(0).resolve(e.pos + n.nodeSize);
    super(e, i), this.node = n;
  }
  map(e, n) {
    let { deleted: i, pos: r } = n.mapResult(this.anchor), a = e.resolve(r);
    return i ? He.near(a) : new Ae(a);
  }
  content() {
    return new ye(ee.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Ae && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new F0(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Ae(e.resolve(n.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, n) {
    return new Ae(e.resolve(n));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Ae.prototype.visible = !1;
He.jsonID("node", Ae);
class F0 {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: n, pos: i } = e.mapResult(this.anchor);
    return n ? new hh(i, i) : new F0(i);
  }
  resolve(e) {
    let n = e.resolve(this.anchor), i = n.nodeAfter;
    return i && Ae.isSelectable(i) ? new Ae(n) : He.near(n);
  }
}
class Un extends He {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, n = ye.empty) {
    if (n == ye.empty) {
      e.delete(0, e.doc.content.size);
      let i = He.atStart(e.doc);
      i.eq(e.selection) || e.setSelection(i);
    } else
      super.replace(e, n);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Un(e);
  }
  map(e) {
    return new Un(e);
  }
  eq(e) {
    return e instanceof Un;
  }
  getBookmark() {
    return sOe;
  }
}
He.jsonID("all", Un);
const sOe = {
  map() {
    return this;
  },
  resolve(t) {
    return new Un(t);
  }
};
function Qo(t, e, n, i, r, a = !1) {
  if (e.inlineContent)
    return Fe.create(t, n);
  for (let o = i - (r > 0 ? 0 : 1); r > 0 ? o < e.childCount : o >= 0; o += r) {
    let s = e.child(o);
    if (s.isAtom) {
      if (!a && Ae.isSelectable(s))
        return Ae.create(t, n - (r < 0 ? s.nodeSize : 0));
    } else {
      let l = Qo(t, s, n + r, r < 0 ? s.childCount : 0, r, a);
      if (l)
        return l;
    }
    n += s.nodeSize * r;
  }
  return null;
}
function mx(t, e, n) {
  let i = t.steps.length - 1;
  if (i < e)
    return;
  let r = t.steps[i];
  if (!(r instanceof nn || r instanceof rn))
    return;
  let a = t.mapping.maps[i], o;
  a.forEach((s, l, c, u) => {
    o == null && (o = u);
  }), t.setSelection(He.near(t.doc.resolve(o), n));
}
const hx = 1, px = 2, gx = 4;
let lOe = class extends U8 {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | hx) & -3, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & hx) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= px, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return pt.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & px) > 0;
  }
  /**
  @internal
  */
  addStep(e, n) {
    super.addStep(e, n), this.updated = this.updated & -3, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, n = !0) {
    let i = this.selection;
    return n && (e = e.mark(this.storedMarks || (i.empty ? i.$from.marks() : i.$from.marksAcross(i.$to) || pt.none))), i.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, n, i) {
    let r = this.doc.type.schema;
    if (n == null)
      return e ? this.replaceSelectionWith(r.text(e), !0) : this.deleteSelection();
    {
      if (i == null && (i = n), i = i ?? n, !e)
        return this.deleteRange(n, i);
      let a = this.storedMarks;
      if (!a) {
        let o = this.doc.resolve(n);
        a = i == n ? o.marks() : o.marksAcross(this.doc.resolve(i));
      }
      return this.replaceRangeWith(n, i, r.text(e, a)), this.selection.empty || this.setSelection(He.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, n) {
    return this.meta[typeof e == "string" ? e : e.key] = n, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= gx, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & gx) > 0;
  }
};
function yx(t, e) {
  return !e || !t ? t : t.bind(e);
}
class Ll {
  constructor(e, n, i) {
    this.name = e, this.init = yx(n.init, i), this.apply = yx(n.apply, i);
  }
}
const dOe = [
  new Ll("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new Ll("selection", {
    init(t, e) {
      return t.selection || He.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new Ll("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, n, i) {
      return i.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new Ll("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class R1 {
  constructor(e, n) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = dOe.slice(), n && n.forEach((i) => {
      if (this.pluginsByKey[i.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + i.key + ")");
      this.plugins.push(i), this.pluginsByKey[i.key] = i, i.spec.state && this.fields.push(new Ll(i.key, i.spec.state, i));
    });
  }
}
class ss {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, n = -1) {
    for (let i = 0; i < this.config.plugins.length; i++)
      if (i != n) {
        let r = this.config.plugins[i];
        if (r.spec.filterTransaction && !r.spec.filterTransaction.call(r, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let n = [e], i = this.applyInner(e), r = null;
    for (; ; ) {
      let a = !1;
      for (let o = 0; o < this.config.plugins.length; o++) {
        let s = this.config.plugins[o];
        if (s.spec.appendTransaction) {
          let l = r ? r[o].n : 0, c = r ? r[o].state : this, u = l < n.length && s.spec.appendTransaction.call(s, l ? n.slice(l) : n, c, i);
          if (u && i.filterTransaction(u, o)) {
            if (u.setMeta("appendedTransaction", e), !r) {
              r = [];
              for (let f = 0; f < this.config.plugins.length; f++)
                r.push(f < o ? { state: i, n: n.length } : { state: this, n: 0 });
            }
            n.push(u), i = i.applyInner(u), a = !0;
          }
          r && (r[o] = { state: i, n: n.length });
        }
      }
      if (!a)
        return { state: i, transactions: n };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let n = new ss(this.config), i = this.config.fields;
    for (let r = 0; r < i.length; r++) {
      let a = i[r];
      n[a.name] = a.apply(e, this[a.name], this, n);
    }
    return n;
  }
  /**
  Start a [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new lOe(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let n = new R1(e.doc ? e.doc.type.schema : e.schema, e.plugins), i = new ss(n);
    for (let r = 0; r < n.fields.length; r++)
      i[n.fields[r].name] = n.fields[r].init(e, i);
    return i;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let n = new R1(this.schema, e.plugins), i = n.fields, r = new ss(n);
    for (let a = 0; a < i.length; a++) {
      let o = i[a].name;
      r[o] = this.hasOwnProperty(o) ? this[o] : i[a].init(e, r);
    }
    return r;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let n = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (n.storedMarks = this.storedMarks.map((i) => i.toJSON())), e && typeof e == "object")
      for (let i in e) {
        if (i == "doc" || i == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let r = e[i], a = r.spec.state;
        a && a.toJSON && (n[i] = a.toJSON.call(r, this[r.key]));
      }
    return n;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, n, i) {
    if (!n)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let r = new R1(e.schema, e.plugins), a = new ss(r);
    return r.fields.forEach((o) => {
      if (o.name == "doc")
        a.doc = wa.fromJSON(e.schema, n.doc);
      else if (o.name == "selection")
        a.selection = He.fromJSON(a.doc, n.selection);
      else if (o.name == "storedMarks")
        n.storedMarks && (a.storedMarks = n.storedMarks.map(e.schema.markFromJSON));
      else {
        if (i)
          for (let s in i) {
            let l = i[s], c = l.spec.state;
            if (l.key == o.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(n, s)) {
              a[o.name] = c.fromJSON.call(l, e, n[s], a);
              return;
            }
          }
        a[o.name] = o.init(e, a);
      }
    }), a;
  }
}
function Q8(t, e, n) {
  for (let i in t) {
    let r = t[i];
    r instanceof Function ? r = r.bind(e) : i == "handleDOMEvents" && (r = Q8(r, e, {})), n[i] = r;
  }
  return n;
}
class ft {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && Q8(e.props, this, this.props), this.key = e.key ? e.key.key : Z8("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const j1 = /* @__PURE__ */ Object.create(null);
function Z8(t) {
  return t in j1 ? t + "$" + ++j1[t] : (j1[t] = 0, t + "$");
}
class yt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = Z8(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const cn = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, Es = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let Ng = null;
const Sr = function(t, e, n) {
  let i = Ng || (Ng = document.createRange());
  return i.setEnd(t, n ?? t.nodeValue.length), i.setStart(t, e || 0), i;
}, cOe = function() {
  Ng = null;
}, wo = function(t, e, n, i) {
  return n && (vx(t, e, n, i, -1) || vx(t, e, n, i, 1));
}, uOe = /^(img|br|input|textarea|hr)$/i;
function vx(t, e, n, i, r) {
  for (; ; ) {
    if (t == n && e == i)
      return !0;
    if (e == (r < 0 ? 0 : bi(t))) {
      let a = t.parentNode;
      if (!a || a.nodeType != 1 || _c(t) || uOe.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = cn(t) + (r < 0 ? 0 : 1), t = a;
    } else if (t.nodeType == 1) {
      if (t = t.childNodes[e + (r < 0 ? -1 : 0)], t.contentEditable == "false")
        return !1;
      e = r < 0 ? bi(t) : 0;
    } else
      return !1;
  }
}
function bi(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function fOe(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = bi(t);
    } else if (t.parentNode && !_c(t))
      e = cn(t), t = t.parentNode;
    else
      return null;
  }
}
function mOe(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !_c(t))
      e = cn(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function hOe(t, e, n) {
  for (let i = e == 0, r = e == bi(t); i || r; ) {
    if (t == n)
      return !0;
    let a = cn(t);
    if (t = t.parentNode, !t)
      return !1;
    i = i && a == 0, r = r && a == bi(t);
  }
}
function _c(t) {
  let e;
  for (let n = t; n && !(e = n.pmViewDesc); n = n.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const ph = function(t) {
  return t.focusNode && wo(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function Za(t, e) {
  let n = document.createEvent("Event");
  return n.initEvent("keydown", !0, !0), n.keyCode = t, n.key = n.code = e, n;
}
function pOe(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function gOe(t, e, n) {
  if (t.caretPositionFromPoint)
    try {
      let i = t.caretPositionFromPoint(e, n);
      if (i)
        return { node: i.offsetNode, offset: Math.min(bi(i.offsetNode), i.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let i = t.caretRangeFromPoint(e, n);
    if (i)
      return { node: i.startContainer, offset: Math.min(bi(i.startContainer), i.startOffset) };
  }
}
const mr = typeof navigator < "u" ? navigator : null, bx = typeof document < "u" ? document : null, Ha = mr && mr.userAgent || "", $g = /Edge\/(\d+)/.exec(Ha), eS = /MSIE \d/.exec(Ha), Dg = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(Ha), Jn = !!(eS || Dg || $g), ka = eS ? document.documentMode : Dg ? +Dg[1] : $g ? +$g[1] : 0, Yi = !Jn && /gecko\/(\d+)/i.test(Ha);
Yi && +(/Firefox\/(\d+)/.exec(Ha) || [0, 0])[1];
const Eg = !Jn && /Chrome\/(\d+)/.exec(Ha), bn = !!Eg, tS = Eg ? +Eg[1] : 0, Rn = !Jn && !!mr && /Apple Computer/.test(mr.vendor), Ts = Rn && (/Mobile\/\w+/.test(Ha) || !!mr && mr.maxTouchPoints > 2), vi = Ts || (mr ? /Mac/.test(mr.platform) : !1), yOe = mr ? /Win/.test(mr.platform) : !1, Er = /Android \d/.test(Ha), Mc = !!bx && "webkitFontSmoothing" in bx.documentElement.style, vOe = Mc ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function bOe(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function xr(t, e) {
  return typeof t == "number" ? t : t[e];
}
function wOe(t) {
  let e = t.getBoundingClientRect(), n = e.width / t.offsetWidth || 1, i = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * n,
    top: e.top,
    bottom: e.top + t.clientHeight * i
  };
}
function wx(t, e, n) {
  let i = t.someProp("scrollThreshold") || 0, r = t.someProp("scrollMargin") || 5, a = t.dom.ownerDocument;
  for (let o = n || t.dom; o; ) {
    if (o.nodeType != 1) {
      o = Es(o);
      continue;
    }
    let s = o, l = s == a.body, c = l ? bOe(a) : wOe(s), u = 0, f = 0;
    if (e.top < c.top + xr(i, "top") ? f = -(c.top - e.top + xr(r, "top")) : e.bottom > c.bottom - xr(i, "bottom") && (f = e.bottom - e.top > c.bottom - c.top ? e.top + xr(r, "top") - c.top : e.bottom - c.bottom + xr(r, "bottom")), e.left < c.left + xr(i, "left") ? u = -(c.left - e.left + xr(r, "left")) : e.right > c.right - xr(i, "right") && (u = e.right - c.right + xr(r, "right")), u || f)
      if (l)
        a.defaultView.scrollBy(u, f);
      else {
        let h = s.scrollLeft, p = s.scrollTop;
        f && (s.scrollTop += f), u && (s.scrollLeft += u);
        let g = s.scrollLeft - h, y = s.scrollTop - p;
        e = { left: e.left - g, top: e.top - y, right: e.right - g, bottom: e.bottom - y };
      }
    let m = l ? "fixed" : getComputedStyle(o).position;
    if (/^(fixed|sticky)$/.test(m))
      break;
    o = m == "absolute" ? o.offsetParent : Es(o);
  }
}
function kOe(t) {
  let e = t.dom.getBoundingClientRect(), n = Math.max(0, e.top), i, r;
  for (let a = (e.left + e.right) / 2, o = n + 1; o < Math.min(innerHeight, e.bottom); o += 5) {
    let s = t.root.elementFromPoint(a, o);
    if (!s || s == t.dom || !t.dom.contains(s))
      continue;
    let l = s.getBoundingClientRect();
    if (l.top >= n - 20) {
      i = s, r = l.top;
      break;
    }
  }
  return { refDOM: i, refTop: r, stack: nS(t.dom) };
}
function nS(t) {
  let e = [], n = t.ownerDocument;
  for (let i = t; i && (e.push({ dom: i, top: i.scrollTop, left: i.scrollLeft }), t != n); i = Es(i))
    ;
  return e;
}
function xOe({ refDOM: t, refTop: e, stack: n }) {
  let i = t ? t.getBoundingClientRect().top : 0;
  iS(n, i == 0 ? 0 : i - e);
}
function iS(t, e) {
  for (let n = 0; n < t.length; n++) {
    let { dom: i, top: r, left: a } = t[n];
    i.scrollTop != r + e && (i.scrollTop = r + e), i.scrollLeft != a && (i.scrollLeft = a);
  }
}
let qo = null;
function _Oe(t) {
  if (t.setActive)
    return t.setActive();
  if (qo)
    return t.focus(qo);
  let e = nS(t);
  t.focus(qo == null ? {
    get preventScroll() {
      return qo = { preventScroll: !0 }, !0;
    }
  } : void 0), qo || (qo = !1, iS(e, 0));
}
function rS(t, e) {
  let n, i = 2e8, r, a = 0, o = e.top, s = e.top, l, c;
  for (let u = t.firstChild, f = 0; u; u = u.nextSibling, f++) {
    let m;
    if (u.nodeType == 1)
      m = u.getClientRects();
    else if (u.nodeType == 3)
      m = Sr(u).getClientRects();
    else
      continue;
    for (let h = 0; h < m.length; h++) {
      let p = m[h];
      if (p.top <= o && p.bottom >= s) {
        o = Math.max(p.bottom, o), s = Math.min(p.top, s);
        let g = p.left > e.left ? p.left - e.left : p.right < e.left ? e.left - p.right : 0;
        if (g < i) {
          n = u, i = g, r = g && n.nodeType == 3 ? {
            left: p.right < e.left ? p.right : p.left,
            top: e.top
          } : e, u.nodeType == 1 && g && (a = f + (e.left >= (p.left + p.right) / 2 ? 1 : 0));
          continue;
        }
      } else p.top > e.top && !l && p.left <= e.left && p.right >= e.left && (l = u, c = { left: Math.max(p.left, Math.min(p.right, e.left)), top: p.top });
      !n && (e.left >= p.right && e.top >= p.top || e.left >= p.left && e.top >= p.bottom) && (a = f + 1);
    }
  }
  return !n && l && (n = l, r = c, i = 0), n && n.nodeType == 3 ? MOe(n, r) : !n || i && n.nodeType == 1 ? { node: t, offset: a } : rS(n, r);
}
function MOe(t, e) {
  let n = t.nodeValue.length, i = document.createRange();
  for (let r = 0; r < n; r++) {
    i.setEnd(t, r + 1), i.setStart(t, r);
    let a = ea(i, 1);
    if (a.top != a.bottom && z0(e, a))
      return { node: t, offset: r + (e.left >= (a.left + a.right) / 2 ? 1 : 0) };
  }
  return { node: t, offset: 0 };
}
function z0(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function COe(t, e) {
  let n = t.parentNode;
  return n && /^li$/i.test(n.nodeName) && e.left < t.getBoundingClientRect().left ? n : t;
}
function POe(t, e, n) {
  let { node: i, offset: r } = rS(e, n), a = -1;
  if (i.nodeType == 1 && !i.firstChild) {
    let o = i.getBoundingClientRect();
    a = o.left != o.right && n.left > (o.left + o.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(i, r, a);
}
function SOe(t, e, n, i) {
  let r = -1;
  for (let a = e, o = !1; a != t.dom; ) {
    let s = t.docView.nearestDesc(a, !0), l;
    if (!s)
      return null;
    if (s.dom.nodeType == 1 && (s.node.isBlock && s.parent || !s.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((l = s.dom.getBoundingClientRect()).width || l.height) && (s.node.isBlock && s.parent && (!o && l.left > i.left || l.top > i.top ? r = s.posBefore : (!o && l.right < i.left || l.bottom < i.top) && (r = s.posAfter), o = !0), !s.contentDOM && r < 0 && !s.node.isText))
      return (s.node.isBlock ? i.top < (l.top + l.bottom) / 2 : i.left < (l.left + l.right) / 2) ? s.posBefore : s.posAfter;
    a = s.dom.parentNode;
  }
  return r > -1 ? r : t.docView.posFromDOM(e, n, -1);
}
function aS(t, e, n) {
  let i = t.childNodes.length;
  if (i && n.top < n.bottom)
    for (let r = Math.max(0, Math.min(i - 1, Math.floor(i * (e.top - n.top) / (n.bottom - n.top)) - 2)), a = r; ; ) {
      let o = t.childNodes[a];
      if (o.nodeType == 1) {
        let s = o.getClientRects();
        for (let l = 0; l < s.length; l++) {
          let c = s[l];
          if (z0(e, c))
            return aS(o, e, c);
        }
      }
      if ((a = (a + 1) % i) == r)
        break;
    }
  return t;
}
function NOe(t, e) {
  let n = t.dom.ownerDocument, i, r = 0, a = gOe(n, e.left, e.top);
  a && ({ node: i, offset: r } = a);
  let o = (t.root.elementFromPoint ? t.root : n).elementFromPoint(e.left, e.top), s;
  if (!o || !t.dom.contains(o.nodeType != 1 ? o.parentNode : o)) {
    let c = t.dom.getBoundingClientRect();
    if (!z0(e, c) || (o = aS(t.dom, e, c), !o))
      return null;
  }
  if (Rn)
    for (let c = o; i && c; c = Es(c))
      c.draggable && (i = void 0);
  if (o = COe(o, e), i) {
    if (Yi && i.nodeType == 1 && (r = Math.min(r, i.childNodes.length), r < i.childNodes.length)) {
      let u = i.childNodes[r], f;
      u.nodeName == "IMG" && (f = u.getBoundingClientRect()).right <= e.left && f.bottom > e.top && r++;
    }
    let c;
    Mc && r && i.nodeType == 1 && (c = i.childNodes[r - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && r--, i == t.dom && r == i.childNodes.length - 1 && i.lastChild.nodeType == 1 && e.top > i.lastChild.getBoundingClientRect().bottom ? s = t.state.doc.content.size : (r == 0 || i.nodeType != 1 || i.childNodes[r - 1].nodeName != "BR") && (s = SOe(t, i, r, e));
  }
  s == null && (s = POe(t, o, e));
  let l = t.docView.nearestDesc(o, !0);
  return { pos: s, inside: l ? l.posAtStart - l.border : -1 };
}
function kx(t) {
  return t.top < t.bottom || t.left < t.right;
}
function ea(t, e) {
  let n = t.getClientRects();
  if (n.length) {
    let i = n[e < 0 ? 0 : n.length - 1];
    if (kx(i))
      return i;
  }
  return Array.prototype.find.call(n, kx) || t.getBoundingClientRect();
}
const $Oe = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function oS(t, e, n) {
  let { node: i, offset: r, atom: a } = t.docView.domFromPos(e, n < 0 ? -1 : 1), o = Mc || Yi;
  if (i.nodeType == 3)
    if (o && ($Oe.test(i.nodeValue) || (n < 0 ? !r : r == i.nodeValue.length))) {
      let l = ea(Sr(i, r, r), n);
      if (Yi && r && /\s/.test(i.nodeValue[r - 1]) && r < i.nodeValue.length) {
        let c = ea(Sr(i, r - 1, r - 1), -1);
        if (c.top == l.top) {
          let u = ea(Sr(i, r, r + 1), -1);
          if (u.top != l.top)
            return Sl(u, u.left < c.left);
        }
      }
      return l;
    } else {
      let l = r, c = r, u = n < 0 ? 1 : -1;
      return n < 0 && !r ? (c++, u = -1) : n >= 0 && r == i.nodeValue.length ? (l--, u = 1) : n < 0 ? l-- : c++, Sl(ea(Sr(i, l, c), u), u < 0);
    }
  if (!t.state.doc.resolve(e - (a || 0)).parent.inlineContent) {
    if (a == null && r && (n < 0 || r == bi(i))) {
      let l = i.childNodes[r - 1];
      if (l.nodeType == 1)
        return F1(l.getBoundingClientRect(), !1);
    }
    if (a == null && r < bi(i)) {
      let l = i.childNodes[r];
      if (l.nodeType == 1)
        return F1(l.getBoundingClientRect(), !0);
    }
    return F1(i.getBoundingClientRect(), n >= 0);
  }
  if (a == null && r && (n < 0 || r == bi(i))) {
    let l = i.childNodes[r - 1], c = l.nodeType == 3 ? Sr(l, bi(l) - (o ? 0 : 1)) : l.nodeType == 1 && (l.nodeName != "BR" || !l.nextSibling) ? l : null;
    if (c)
      return Sl(ea(c, 1), !1);
  }
  if (a == null && r < bi(i)) {
    let l = i.childNodes[r];
    for (; l.pmViewDesc && l.pmViewDesc.ignoreForCoords; )
      l = l.nextSibling;
    let c = l ? l.nodeType == 3 ? Sr(l, 0, o ? 0 : 1) : l.nodeType == 1 ? l : null : null;
    if (c)
      return Sl(ea(c, -1), !0);
  }
  return Sl(ea(i.nodeType == 3 ? Sr(i) : i, -n), n >= 0);
}
function Sl(t, e) {
  if (t.width == 0)
    return t;
  let n = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: n, right: n };
}
function F1(t, e) {
  if (t.height == 0)
    return t;
  let n = e ? t.top : t.bottom;
  return { top: n, bottom: n, left: t.left, right: t.right };
}
function sS(t, e, n) {
  let i = t.state, r = t.root.activeElement;
  i != e && t.updateState(e), r != t.dom && t.focus();
  try {
    return n();
  } finally {
    i != e && t.updateState(i), r != t.dom && r && r.focus();
  }
}
function DOe(t, e, n) {
  let i = e.selection, r = n == "up" ? i.$from : i.$to;
  return sS(t, e, () => {
    let { node: a } = t.docView.domFromPos(r.pos, n == "up" ? -1 : 1);
    for (; ; ) {
      let s = t.docView.nearestDesc(a, !0);
      if (!s)
        break;
      if (s.node.isBlock) {
        a = s.contentDOM || s.dom;
        break;
      }
      a = s.dom.parentNode;
    }
    let o = oS(t, r.pos, 1);
    for (let s = a.firstChild; s; s = s.nextSibling) {
      let l;
      if (s.nodeType == 1)
        l = s.getClientRects();
      else if (s.nodeType == 3)
        l = Sr(s, 0, s.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < l.length; c++) {
        let u = l[c];
        if (u.bottom > u.top + 1 && (n == "up" ? o.top - u.top > (u.bottom - o.top) * 2 : u.bottom - o.bottom > (o.bottom - u.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const EOe = /[\u0590-\u08ac]/;
function TOe(t, e, n) {
  let { $head: i } = e.selection;
  if (!i.parent.isTextblock)
    return !1;
  let r = i.parentOffset, a = !r, o = r == i.parent.content.size, s = t.domSelection();
  return s ? !EOe.test(i.parent.textContent) || !s.modify ? n == "left" || n == "backward" ? a : o : sS(t, e, () => {
    let { focusNode: l, focusOffset: c, anchorNode: u, anchorOffset: f } = t.domSelectionRange(), m = s.caretBidiLevel;
    s.modify("move", n, "character");
    let h = i.depth ? t.docView.domAfterPos(i.before()) : t.dom, { focusNode: p, focusOffset: g } = t.domSelectionRange(), y = p && !h.contains(p.nodeType == 1 ? p : p.parentNode) || l == p && c == g;
    try {
      s.collapse(u, f), l && (l != u || c != f) && s.extend && s.extend(l, c);
    } catch {
    }
    return m != null && (s.caretBidiLevel = m), y;
  }) : i.pos == i.start() || i.pos == i.end();
}
let xx = null, _x = null, Mx = !1;
function OOe(t, e, n) {
  return xx == e && _x == n ? Mx : (xx = e, _x = n, Mx = n == "up" || n == "down" ? DOe(t, e, n) : TOe(t, e, n));
}
const Ci = 0, Cx = 1, io = 2, hr = 3;
class Cc {
  constructor(e, n, i, r) {
    this.parent = e, this.children = n, this.dom = i, this.contentDOM = r, this.dirty = Ci, i.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, n, i) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let n = 0; n < this.children.length; n++)
      e += this.children[n].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let n = 0, i = this.posAtStart; ; n++) {
      let r = this.children[n];
      if (r == e)
        return i;
      i += r.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, n, i) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (i < 0) {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[n - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.previousSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.previousSibling;
        return a ? this.posBeforeChild(o) + o.size : this.posAtStart;
      } else {
        let a, o;
        if (e == this.contentDOM)
          a = e.childNodes[n];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          a = e.nextSibling;
        }
        for (; a && !((o = a.pmViewDesc) && o.parent == this); )
          a = a.nextSibling;
        return a ? this.posBeforeChild(o) : this.posAtEnd;
      }
    let r;
    if (e == this.dom && this.contentDOM)
      r = n > cn(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      r = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (n == 0)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            r = !1;
            break;
          }
          if (a.previousSibling)
            break;
        }
      if (r == null && n == e.childNodes.length)
        for (let a = e; ; a = a.parentNode) {
          if (a == this.dom) {
            r = !0;
            break;
          }
          if (a.nextSibling)
            break;
        }
    }
    return r ?? i > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, n = !1) {
    for (let i = !0, r = e; r; r = r.parentNode) {
      let a = this.getDesc(r), o;
      if (a && (!n || a.node))
        if (i && (o = a.nodeDOM) && !(o.nodeType == 1 ? o.contains(e.nodeType == 1 ? e : e.parentNode) : o == e))
          i = !1;
        else
          return a;
    }
  }
  getDesc(e) {
    let n = e.pmViewDesc;
    for (let i = n; i; i = i.parent)
      if (i == this)
        return n;
  }
  posFromDOM(e, n, i) {
    for (let r = e; r; r = r.parentNode) {
      let a = this.getDesc(r);
      if (a)
        return a.localPosFromDOM(e, n, i);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let n = 0, i = 0; n < this.children.length; n++) {
      let r = this.children[n], a = i + r.size;
      if (i == e && a != i) {
        for (; !r.border && r.children.length; )
          for (let o = 0; o < r.children.length; o++) {
            let s = r.children[o];
            if (s.size) {
              r = s;
              break;
            }
          }
        return r;
      }
      if (e < a)
        return r.descAt(e - i - r.border);
      i = a;
    }
  }
  domFromPos(e, n) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let i = 0, r = 0;
    for (let a = 0; i < this.children.length; i++) {
      let o = this.children[i], s = a + o.size;
      if (s > e || o instanceof dS) {
        r = e - a;
        break;
      }
      a = s;
    }
    if (r)
      return this.children[i].domFromPos(r - this.children[i].border, n);
    for (let a; i && !(a = this.children[i - 1]).size && a instanceof lS && a.side >= 0; i--)
      ;
    if (n <= 0) {
      let a, o = !0;
      for (; a = i ? this.children[i - 1] : null, !(!a || a.dom.parentNode == this.contentDOM); i--, o = !1)
        ;
      return a && n && o && !a.border && !a.domAtom ? a.domFromPos(a.size, n) : { node: this.contentDOM, offset: a ? cn(a.dom) + 1 : 0 };
    } else {
      let a, o = !0;
      for (; a = i < this.children.length ? this.children[i] : null, !(!a || a.dom.parentNode == this.contentDOM); i++, o = !1)
        ;
      return a && o && !a.border && !a.domAtom ? a.domFromPos(0, n) : { node: this.contentDOM, offset: a ? cn(a.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, n, i = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: n, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let r = -1, a = -1;
    for (let o = i, s = 0; ; s++) {
      let l = this.children[s], c = o + l.size;
      if (r == -1 && e <= c) {
        let u = o + l.border;
        if (e >= u && n <= c - l.border && l.node && l.contentDOM && this.contentDOM.contains(l.contentDOM))
          return l.parseRange(e, n, u);
        e = o;
        for (let f = s; f > 0; f--) {
          let m = this.children[f - 1];
          if (m.size && m.dom.parentNode == this.contentDOM && !m.emptyChildAt(1)) {
            r = cn(m.dom) + 1;
            break;
          }
          e -= m.size;
        }
        r == -1 && (r = 0);
      }
      if (r > -1 && (c > n || s == this.children.length - 1)) {
        n = c;
        for (let u = s + 1; u < this.children.length; u++) {
          let f = this.children[u];
          if (f.size && f.dom.parentNode == this.contentDOM && !f.emptyChildAt(-1)) {
            a = cn(f.dom);
            break;
          }
          n += f.size;
        }
        a == -1 && (a = this.contentDOM.childNodes.length);
        break;
      }
      o = c;
    }
    return { node: this.contentDOM, from: e, to: n, fromOffset: r, toOffset: a };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let n = this.children[e < 0 ? 0 : this.children.length - 1];
    return n.size == 0 || n.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: n, offset: i } = this.domFromPos(e, 0);
    if (n.nodeType != 1 || i == n.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return n.childNodes[i];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, n, i, r = !1) {
    let a = Math.min(e, n), o = Math.max(e, n);
    for (let h = 0, p = 0; h < this.children.length; h++) {
      let g = this.children[h], y = p + g.size;
      if (a > p && o < y)
        return g.setSelection(e - p - g.border, n - p - g.border, i, r);
      p = y;
    }
    let s = this.domFromPos(e, e ? -1 : 1), l = n == e ? s : this.domFromPos(n, n ? -1 : 1), c = i.root.getSelection(), u = i.domSelectionRange(), f = !1;
    if ((Yi || Rn) && e == n) {
      let { node: h, offset: p } = s;
      if (h.nodeType == 3) {
        if (f = !!(p && h.nodeValue[p - 1] == `
`), f && p == h.nodeValue.length)
          for (let g = h, y; g; g = g.parentNode) {
            if (y = g.nextSibling) {
              y.nodeName == "BR" && (s = l = { node: y.parentNode, offset: cn(y) + 1 });
              break;
            }
            let v = g.pmViewDesc;
            if (v && v.node && v.node.isBlock)
              break;
          }
      } else {
        let g = h.childNodes[p - 1];
        f = g && (g.nodeName == "BR" || g.contentEditable == "false");
      }
    }
    if (Yi && u.focusNode && u.focusNode != l.node && u.focusNode.nodeType == 1) {
      let h = u.focusNode.childNodes[u.focusOffset];
      h && h.contentEditable == "false" && (r = !0);
    }
    if (!(r || f && Rn) && wo(s.node, s.offset, u.anchorNode, u.anchorOffset) && wo(l.node, l.offset, u.focusNode, u.focusOffset))
      return;
    let m = !1;
    if ((c.extend || e == n) && !f) {
      c.collapse(s.node, s.offset);
      try {
        e != n && c.extend(l.node, l.offset), m = !0;
      } catch {
      }
    }
    if (!m) {
      if (e > n) {
        let p = s;
        s = l, l = p;
      }
      let h = document.createRange();
      h.setEnd(l.node, l.offset), h.setStart(s.node, s.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, n) {
    for (let i = 0, r = 0; r < this.children.length; r++) {
      let a = this.children[r], o = i + a.size;
      if (i == o ? e <= o && n >= i : e < o && n > i) {
        let s = i + a.border, l = o - a.border;
        if (e >= s && n <= l) {
          this.dirty = e == i || n == o ? io : Cx, e == s && n == l && (a.contentLost || a.dom.parentNode != this.contentDOM) ? a.dirty = hr : a.markDirty(e - s, n - s);
          return;
        } else
          a.dirty = a.dom == a.contentDOM && a.dom.parentNode == this.contentDOM && !a.children.length ? io : hr;
      }
      i = o;
    }
    this.dirty = io;
  }
  markParentsDirty() {
    let e = 1;
    for (let n = this.parent; n; n = n.parent, e++) {
      let i = e == 1 ? io : Cx;
      n.dirty < i && (n.dirty = i);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class lS extends Cc {
  constructor(e, n, i, r) {
    let a, o = n.type.toDOM;
    if (typeof o == "function" && (o = o(i, () => {
      if (!a)
        return r;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    })), !n.type.spec.raw) {
      if (o.nodeType != 1) {
        let s = document.createElement("span");
        s.appendChild(o), o = s;
      }
      o.contentEditable = "false", o.classList.add("ProseMirror-widget");
    }
    super(e, [], o, null), this.widget = n, this.widget = n, a = this;
  }
  matchesWidget(e) {
    return this.dirty == Ci && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let n = this.widget.spec.stopEvent;
    return n ? n(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get side() {
    return this.widget.type.side;
  }
}
class WOe extends Cc {
  constructor(e, n, i, r) {
    super(e, [], n, null), this.textDOM = i, this.text = r;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, n) {
    return e != this.textDOM ? this.posAtStart + (n ? this.size : 0) : this.posAtStart + n;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class ko extends Cc {
  constructor(e, n, i, r, a) {
    super(e, [], i, r), this.mark = n, this.spec = a;
  }
  static create(e, n, i, r) {
    let a = r.nodeViews[n.type.name], o = a && a(n, r, i);
    return (!o || !o.dom) && (o = Io.renderSpec(document, n.type.spec.toDOM(n, i), null, n.attrs)), new ko(e, n, o.dom, o.contentDOM || o.dom, o);
  }
  parseRule() {
    return this.dirty & hr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != hr && this.mark.eq(e);
  }
  markDirty(e, n) {
    if (super.markDirty(e, n), this.dirty != Ci) {
      let i = this.parent;
      for (; !i.node; )
        i = i.parent;
      i.dirty < this.dirty && (i.dirty = this.dirty), this.dirty = Ci;
    }
  }
  slice(e, n, i) {
    let r = ko.create(this.parent, this.mark, !0, i), a = this.children, o = this.size;
    n < o && (a = Og(a, n, o, i)), e > 0 && (a = Og(a, 0, e, i));
    for (let s = 0; s < a.length; s++)
      a[s].parent = r;
    return r.children = a, r;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class xa extends Cc {
  constructor(e, n, i, r, a, o, s, l, c) {
    super(e, [], a, o), this.node = n, this.outerDeco = i, this.innerDeco = r, this.nodeDOM = s;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, n, i, r, a, o) {
    let s = a.nodeViews[n.type.name], l, c = s && s(n, a, () => {
      if (!l)
        return o;
      if (l.parent)
        return l.parent.posBeforeChild(l);
    }, i, r), u = c && c.dom, f = c && c.contentDOM;
    if (n.isText) {
      if (!u)
        u = document.createTextNode(n.text);
      else if (u.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else u || ({ dom: u, contentDOM: f } = Io.renderSpec(document, n.type.spec.toDOM(n), null, n.attrs));
    !f && !n.isText && u.nodeName != "BR" && (u.hasAttribute("contenteditable") || (u.contentEditable = "false"), n.type.spec.draggable && (u.draggable = !0));
    let m = u;
    return u = fS(u, i, n), c ? l = new AOe(e, n, i, r, u, f || null, m, c, a, o + 1) : n.isText ? new gh(e, n, i, r, u, m, a) : new xa(e, n, i, r, u, f || null, m, a, o + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let n = this.children.length - 1; n >= 0; n--) {
        let i = this.children[n];
        if (this.dom.contains(i.dom.parentNode)) {
          e.contentElement = i.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => ee.empty);
    }
    return e;
  }
  matchesNode(e, n, i) {
    return this.dirty == Ci && e.eq(this.node) && $f(n, this.outerDeco) && i.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, n) {
    let i = this.node.inlineContent, r = n, a = e.composing ? this.localCompositionInfo(e, n) : null, o = a && a.pos > -1 ? a : null, s = a && a.pos < 0, l = new IOe(this, o && o.node, e);
    FOe(this.node, this.innerDeco, (c, u, f) => {
      c.spec.marks ? l.syncToMarks(c.spec.marks, i, e) : c.type.side >= 0 && !f && l.syncToMarks(u == this.node.childCount ? pt.none : this.node.child(u).marks, i, e), l.placeWidget(c, e, r);
    }, (c, u, f, m) => {
      l.syncToMarks(c.marks, i, e);
      let h;
      l.findNodeMatch(c, u, f, m) || s && e.state.selection.from > r && e.state.selection.to < r + c.nodeSize && (h = l.findIndexWithChild(a.node)) > -1 && l.updateNodeAt(c, u, f, h, e) || l.updateNextNode(c, u, f, e, m, r) || l.addNode(c, u, f, e, r), r += c.nodeSize;
    }), l.syncToMarks([], i, e), this.node.isTextblock && l.addTextblockHacks(), l.destroyRest(), (l.changed || this.dirty == io) && (o && this.protectLocalComposition(e, o), cS(this.contentDOM, this.children, e), Ts && zOe(this.dom));
  }
  localCompositionInfo(e, n) {
    let { from: i, to: r } = e.state.selection;
    if (!(e.state.selection instanceof Fe) || i < n || r > n + this.node.content.size)
      return null;
    let a = e.input.compositionNode;
    if (!a || !this.dom.contains(a.parentNode))
      return null;
    if (this.node.inlineContent) {
      let o = a.nodeValue, s = VOe(this.node.content, o, i - n, r - n);
      return s < 0 ? null : { node: a, pos: s, text: o };
    } else
      return { node: a, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: n, pos: i, text: r }) {
    if (this.getDesc(n))
      return;
    let a = n;
    for (; a.parentNode != this.contentDOM; a = a.parentNode) {
      for (; a.previousSibling; )
        a.parentNode.removeChild(a.previousSibling);
      for (; a.nextSibling; )
        a.parentNode.removeChild(a.nextSibling);
      a.pmViewDesc && (a.pmViewDesc = void 0);
    }
    let o = new WOe(this, a, n, r);
    e.input.compositionNodes.push(o), this.children = Og(this.children, i, i + r.length, e, o);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, n, i, r) {
    return this.dirty == hr || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, n, i, r), !0);
  }
  updateInner(e, n, i, r) {
    this.updateOuterDeco(n), this.node = e, this.innerDeco = i, this.contentDOM && this.updateChildren(r, this.posAtStart), this.dirty = Ci;
  }
  updateOuterDeco(e) {
    if ($f(e, this.outerDeco))
      return;
    let n = this.nodeDOM.nodeType != 1, i = this.dom;
    this.dom = uS(this.dom, this.nodeDOM, Tg(this.outerDeco, this.node, n), Tg(e, this.node, n)), this.dom != i && (i.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.dom.draggable = !0);
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.dom.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function Px(t, e, n, i, r) {
  fS(i, e, t);
  let a = new xa(void 0, t, e, n, i, i, i, r, 0);
  return a.contentDOM && a.updateChildren(r, 0), a;
}
class gh extends xa {
  constructor(e, n, i, r, a, o, s) {
    super(e, n, i, r, a, null, o, s, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, n, i, r) {
    return this.dirty == hr || this.dirty != Ci && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(n), (this.dirty != Ci || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, r.trackWrites == this.nodeDOM && (r.trackWrites = null)), this.node = e, this.dirty = Ci, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let n = this.nodeDOM; n; n = n.parentNode)
      if (n == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, n, i) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(n, this.node.text.length) : super.localPosFromDOM(e, n, i);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, n, i) {
    let r = this.node.cut(e, n), a = document.createTextNode(r.text);
    return new gh(this.parent, r, this.outerDeco, this.innerDeco, a, a, i);
  }
  markDirty(e, n) {
    super.markDirty(e, n), this.dom != this.nodeDOM && (e == 0 || n == this.nodeDOM.nodeValue.length) && (this.dirty = hr);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class dS extends Cc {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == Ci && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class AOe extends xa {
  constructor(e, n, i, r, a, o, s, l, c, u) {
    super(e, n, i, r, a, o, s, c, u), this.spec = l;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, n, i, r) {
    if (this.dirty == hr)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let a = this.spec.update(e, n, i);
      return a && this.updateInner(e, n, i, r), a;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, n, i, r);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, n, i, r) {
    this.spec.setSelection ? this.spec.setSelection(e, n, i.root) : super.setSelection(e, n, i, r);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function cS(t, e, n) {
  let i = t.firstChild, r = !1;
  for (let a = 0; a < e.length; a++) {
    let o = e[a], s = o.dom;
    if (s.parentNode == t) {
      for (; s != i; )
        i = Sx(i), r = !0;
      i = i.nextSibling;
    } else
      r = !0, t.insertBefore(s, i);
    if (o instanceof ko) {
      let l = i ? i.previousSibling : t.lastChild;
      cS(o.contentDOM, o.children, n), i = l ? l.nextSibling : t.firstChild;
    }
  }
  for (; i; )
    i = Sx(i), r = !0;
  r && n.trackWrites == t && (n.trackWrites = null);
}
const ql = function(t) {
  t && (this.nodeName = t);
};
ql.prototype = /* @__PURE__ */ Object.create(null);
const ro = [new ql()];
function Tg(t, e, n) {
  if (t.length == 0)
    return ro;
  let i = n ? ro[0] : new ql(), r = [i];
  for (let a = 0; a < t.length; a++) {
    let o = t[a].type.attrs;
    if (o) {
      o.nodeName && r.push(i = new ql(o.nodeName));
      for (let s in o) {
        let l = o[s];
        l != null && (n && r.length == 1 && r.push(i = new ql(e.isInline ? "span" : "div")), s == "class" ? i.class = (i.class ? i.class + " " : "") + l : s == "style" ? i.style = (i.style ? i.style + ";" : "") + l : s != "nodeName" && (i[s] = l));
      }
    }
  }
  return r;
}
function uS(t, e, n, i) {
  if (n == ro && i == ro)
    return e;
  let r = e;
  for (let a = 0; a < i.length; a++) {
    let o = i[a], s = n[a];
    if (a) {
      let l;
      s && s.nodeName == o.nodeName && r != t && (l = r.parentNode) && l.nodeName.toLowerCase() == o.nodeName || (l = document.createElement(o.nodeName), l.pmIsDeco = !0, l.appendChild(r), s = ro[0]), r = l;
    }
    LOe(r, s || ro[0], o);
  }
  return r;
}
function LOe(t, e, n) {
  for (let i in e)
    i != "class" && i != "style" && i != "nodeName" && !(i in n) && t.removeAttribute(i);
  for (let i in n)
    i != "class" && i != "style" && i != "nodeName" && n[i] != e[i] && t.setAttribute(i, n[i]);
  if (e.class != n.class) {
    let i = e.class ? e.class.split(" ").filter(Boolean) : [], r = n.class ? n.class.split(" ").filter(Boolean) : [];
    for (let a = 0; a < i.length; a++)
      r.indexOf(i[a]) == -1 && t.classList.remove(i[a]);
    for (let a = 0; a < r.length; a++)
      i.indexOf(r[a]) == -1 && t.classList.add(r[a]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != n.style) {
    if (e.style) {
      let i = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, r;
      for (; r = i.exec(e.style); )
        t.style.removeProperty(r[1]);
    }
    n.style && (t.style.cssText += n.style);
  }
}
function fS(t, e, n) {
  return uS(t, t, ro, Tg(e, n, t.nodeType != 1));
}
function $f(t, e) {
  if (t.length != e.length)
    return !1;
  for (let n = 0; n < t.length; n++)
    if (!t[n].type.eq(e[n].type))
      return !1;
  return !0;
}
function Sx(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class IOe {
  constructor(e, n, i) {
    this.lock = n, this.view = i, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = ROe(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, n) {
    if (e != n) {
      for (let i = e; i < n; i++)
        this.top.children[i].destroy();
      this.top.children.splice(e, n - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, n, i) {
    let r = 0, a = this.stack.length >> 1, o = Math.min(a, e.length);
    for (; r < o && (r == a - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < a; )
      this.destroyRest(), this.top.dirty = Ci, this.index = this.stack.pop(), this.top = this.stack.pop(), a--;
    for (; a < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let s = -1;
      for (let l = this.index; l < Math.min(this.index + 3, this.top.children.length); l++) {
        let c = this.top.children[l];
        if (c.matchesMark(e[a]) && !this.isLocked(c.dom)) {
          s = l;
          break;
        }
      }
      if (s > -1)
        s > this.index && (this.changed = !0, this.destroyBetween(this.index, s)), this.top = this.top.children[this.index];
      else {
        let l = ko.create(this.top, e[a], n, i);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, a++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, n, i, r) {
    let a = -1, o;
    if (r >= this.preMatch.index && (o = this.preMatch.matches[r - this.preMatch.index]).parent == this.top && o.matchesNode(e, n, i))
      a = this.top.children.indexOf(o, this.index);
    else
      for (let s = this.index, l = Math.min(this.top.children.length, s + 5); s < l; s++) {
        let c = this.top.children[s];
        if (c.matchesNode(e, n, i) && !this.preMatch.matched.has(c)) {
          a = s;
          break;
        }
      }
    return a < 0 ? !1 : (this.destroyBetween(this.index, a), this.index++, !0);
  }
  updateNodeAt(e, n, i, r, a) {
    let o = this.top.children[r];
    return o.dirty == hr && o.dom == o.contentDOM && (o.dirty = io), o.update(e, n, i, a) ? (this.destroyBetween(this.index, r), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let n = e.parentNode;
      if (!n)
        return -1;
      if (n == this.top.contentDOM) {
        let i = e.pmViewDesc;
        if (i) {
          for (let r = this.index; r < this.top.children.length; r++)
            if (this.top.children[r] == i)
              return r;
        }
        return -1;
      }
      e = n;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, n, i, r, a, o) {
    for (let s = this.index; s < this.top.children.length; s++) {
      let l = this.top.children[s];
      if (l instanceof xa) {
        let c = this.preMatch.matched.get(l);
        if (c != null && c != a)
          return !1;
        let u = l.dom, f, m = this.isLocked(u) && !(e.isText && l.node && l.node.isText && l.nodeDOM.nodeValue == e.text && l.dirty != hr && $f(n, l.outerDeco));
        if (!m && l.update(e, n, i, r))
          return this.destroyBetween(this.index, s), l.dom != u && (this.changed = !0), this.index++, !0;
        if (!m && (f = this.recreateWrapper(l, e, n, i, r, o)))
          return this.destroyBetween(this.index, s), this.top.children[this.index] = f, f.contentDOM && (f.dirty = io, f.updateChildren(r, o + 1), f.dirty = Ci), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, n, i, r, a, o) {
    if (e.dirty || n.isAtom || !e.children.length || !e.node.content.eq(n.content) || !$f(i, e.outerDeco) || !r.eq(e.innerDeco))
      return null;
    let s = xa.create(this.top, n, i, r, a, o);
    if (s.contentDOM) {
      s.children = e.children, e.children = [];
      for (let l of s.children)
        l.parent = s;
    }
    return e.destroy(), s;
  }
  // Insert the node as a newly created node desc.
  addNode(e, n, i, r, a) {
    let o = xa.create(this.top, e, n, i, r, a);
    o.contentDOM && o.updateChildren(r, a + 1), this.top.children.splice(this.index++, 0, o), this.changed = !0;
  }
  placeWidget(e, n, i) {
    let r = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (r && r.matchesWidget(e) && (e == r.widget || !r.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let a = new lS(this.top, e, n, i);
      this.top.children.splice(this.index++, 0, a), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], n = this.top;
    for (; e instanceof ko; )
      n = e, e = n.children[n.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof gh) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((Rn || bn) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", n), this.addHackNode("BR", this.top));
  }
  addHackNode(e, n) {
    if (n == this.top && this.index < n.children.length && n.children[this.index].matchesHack(e))
      this.index++;
    else {
      let i = document.createElement(e);
      e == "IMG" && (i.className = "ProseMirror-separator", i.alt = ""), e == "BR" && (i.className = "ProseMirror-trailingBreak");
      let r = new dS(this.top, [], i, null);
      n != this.top ? n.children.push(r) : n.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function ROe(t, e) {
  let n = e, i = n.children.length, r = t.childCount, a = /* @__PURE__ */ new Map(), o = [];
  e: for (; r > 0; ) {
    let s;
    for (; ; )
      if (i) {
        let c = n.children[i - 1];
        if (c instanceof ko)
          n = c, i = c.children.length;
        else {
          s = c, i--;
          break;
        }
      } else {
        if (n == e)
          break e;
        i = n.parent.children.indexOf(n), n = n.parent;
      }
    let l = s.node;
    if (l) {
      if (l != t.child(r - 1))
        break;
      --r, a.set(s, r), o.push(s);
    }
  }
  return { index: r, matched: a, matches: o.reverse() };
}
function jOe(t, e) {
  return t.type.side - e.type.side;
}
function FOe(t, e, n, i) {
  let r = e.locals(t), a = 0;
  if (r.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let u = t.child(c);
      i(u, r, e.forChild(a, u), c), a += u.nodeSize;
    }
    return;
  }
  let o = 0, s = [], l = null;
  for (let c = 0; ; ) {
    let u, f;
    for (; o < r.length && r[o].to == a; ) {
      let y = r[o++];
      y.widget && (u ? (f || (f = [u])).push(y) : u = y);
    }
    if (u)
      if (f) {
        f.sort(jOe);
        for (let y = 0; y < f.length; y++)
          n(f[y], c, !!l);
      } else
        n(u, c, !!l);
    let m, h;
    if (l)
      h = -1, m = l, l = null;
    else if (c < t.childCount)
      h = c, m = t.child(c++);
    else
      break;
    for (let y = 0; y < s.length; y++)
      s[y].to <= a && s.splice(y--, 1);
    for (; o < r.length && r[o].from <= a && r[o].to > a; )
      s.push(r[o++]);
    let p = a + m.nodeSize;
    if (m.isText) {
      let y = p;
      o < r.length && r[o].from < y && (y = r[o].from);
      for (let v = 0; v < s.length; v++)
        s[v].to < y && (y = s[v].to);
      y < p && (l = m.cut(y - a), m = m.cut(0, y - a), p = y, h = -1);
    } else
      for (; o < r.length && r[o].to < p; )
        o++;
    let g = m.isInline && !m.isLeaf ? s.filter((y) => !y.inline) : s.slice();
    i(m, g, e.forChild(a, m), h), a = p;
  }
}
function zOe(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function VOe(t, e, n, i) {
  for (let r = 0, a = 0; r < t.childCount && a <= i; ) {
    let o = t.child(r++), s = a;
    if (a += o.nodeSize, !o.isText)
      continue;
    let l = o.text;
    for (; r < t.childCount; ) {
      let c = t.child(r++);
      if (a += c.nodeSize, !c.isText)
        break;
      l += c.text;
    }
    if (a >= n) {
      if (a >= i && l.slice(i - e.length - s, i - s) == e)
        return i - e.length;
      let c = s < i ? l.lastIndexOf(e, i - s - 1) : -1;
      if (c >= 0 && c + e.length + s >= n)
        return s + c;
      if (n == i && l.length >= i + e.length - s && l.slice(i - s, i - s + e.length) == e)
        return i;
    }
  }
  return -1;
}
function Og(t, e, n, i, r) {
  let a = [];
  for (let o = 0, s = 0; o < t.length; o++) {
    let l = t[o], c = s, u = s += l.size;
    c >= n || u <= e ? a.push(l) : (c < e && a.push(l.slice(0, e - c, i)), r && (a.push(r), r = void 0), u > n && a.push(l.slice(n - c, l.size, i)));
  }
  return a;
}
function V0(t, e = null) {
  let n = t.domSelectionRange(), i = t.state.doc;
  if (!n.focusNode)
    return null;
  let r = t.docView.nearestDesc(n.focusNode), a = r && r.size == 0, o = t.docView.posFromDOM(n.focusNode, n.focusOffset, 1);
  if (o < 0)
    return null;
  let s = i.resolve(o), l, c;
  if (ph(n)) {
    for (l = o; r && !r.node; )
      r = r.parent;
    let f = r.node;
    if (r && f.isAtom && Ae.isSelectable(f) && r.parent && !(f.isInline && hOe(n.focusNode, n.focusOffset, r.dom))) {
      let m = r.posBefore;
      c = new Ae(o == m ? s : i.resolve(m));
    }
  } else {
    if (n instanceof t.dom.ownerDocument.defaultView.Selection && n.rangeCount > 1) {
      let f = o, m = o;
      for (let h = 0; h < n.rangeCount; h++) {
        let p = n.getRangeAt(h);
        f = Math.min(f, t.docView.posFromDOM(p.startContainer, p.startOffset, 1)), m = Math.max(m, t.docView.posFromDOM(p.endContainer, p.endOffset, -1));
      }
      if (f < 0)
        return null;
      [l, o] = m == t.state.selection.anchor ? [m, f] : [f, m], s = i.resolve(o);
    } else
      l = t.docView.posFromDOM(n.anchorNode, n.anchorOffset, 1);
    if (l < 0)
      return null;
  }
  let u = i.resolve(l);
  if (!c) {
    let f = e == "pointer" || t.state.selection.head < s.pos && !a ? 1 : -1;
    c = H0(t, u, s, f);
  }
  return c;
}
function mS(t) {
  return t.editable ? t.hasFocus() : pS(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function Wr(t, e = !1) {
  let n = t.state.selection;
  if (hS(t, n), !!mS(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && bn) {
      let i = t.domSelectionRange(), r = t.domObserver.currentSelection;
      if (i.anchorNode && r.anchorNode && wo(i.anchorNode, i.anchorOffset, r.anchorNode, r.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      BOe(t);
    else {
      let { anchor: i, head: r } = n, a, o;
      Nx && !(n instanceof Fe) && (n.$from.parent.inlineContent || (a = $x(t, n.from)), !n.empty && !n.$from.parent.inlineContent && (o = $x(t, n.to))), t.docView.setSelection(i, r, t, e), Nx && (a && Dx(a), o && Dx(o)), n.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && HOe(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const Nx = Rn || bn && tS < 63;
function $x(t, e) {
  let { node: n, offset: i } = t.docView.domFromPos(e, 0), r = i < n.childNodes.length ? n.childNodes[i] : null, a = i ? n.childNodes[i - 1] : null;
  if (Rn && r && r.contentEditable == "false")
    return z1(r);
  if ((!r || r.contentEditable == "false") && (!a || a.contentEditable == "false")) {
    if (r)
      return z1(r);
    if (a)
      return z1(a);
  }
}
function z1(t) {
  return t.contentEditable = "true", Rn && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function Dx(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function HOe(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let n = t.domSelectionRange(), i = n.anchorNode, r = n.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (n.anchorNode != i || n.anchorOffset != r) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!mS(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function BOe(t) {
  let e = t.domSelection(), n = document.createRange();
  if (!e)
    return;
  let i = t.cursorWrapper.dom, r = i.nodeName == "IMG";
  r ? n.setStart(i.parentNode, cn(i) + 1) : n.setStart(i, 0), n.collapse(!0), e.removeAllRanges(), e.addRange(n), !r && !t.state.selection.visible && Jn && ka <= 11 && (i.disabled = !0, i.disabled = !1);
}
function hS(t, e) {
  if (e instanceof Ae) {
    let n = t.docView.descAt(e.from);
    n != t.lastSelectedViewDesc && (Ex(t), n && n.selectNode(), t.lastSelectedViewDesc = n);
  } else
    Ex(t);
}
function Ex(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function H0(t, e, n, i) {
  return t.someProp("createSelectionBetween", (r) => r(t, e, n)) || Fe.between(e, n, i);
}
function Tx(t) {
  return t.editable && !t.hasFocus() ? !1 : pS(t);
}
function pS(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function qOe(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), n = t.domSelectionRange();
  return wo(e.node, e.offset, n.anchorNode, n.anchorOffset);
}
function Wg(t, e) {
  let { $anchor: n, $head: i } = t.selection, r = e > 0 ? n.max(i) : n.min(i), a = r.parent.inlineContent ? r.depth ? t.doc.resolve(e > 0 ? r.after() : r.before()) : null : r;
  return a && He.findFrom(a, e);
}
function ta(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function Ox(t, e, n) {
  let i = t.state.selection;
  if (i instanceof Fe)
    if (n.indexOf("s") > -1) {
      let { $head: r } = i, a = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter;
      if (!a || a.isText || !a.isLeaf)
        return !1;
      let o = t.state.doc.resolve(r.pos + a.nodeSize * (e < 0 ? -1 : 1));
      return ta(t, new Fe(i.$anchor, o));
    } else if (i.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let r = Wg(t.state, e);
        return r && r instanceof Ae ? ta(t, r) : !1;
      } else if (!(vi && n.indexOf("m") > -1)) {
        let r = i.$head, a = r.textOffset ? null : e < 0 ? r.nodeBefore : r.nodeAfter, o;
        if (!a || a.isText)
          return !1;
        let s = e < 0 ? r.pos - a.nodeSize : r.pos;
        return a.isAtom || (o = t.docView.descAt(s)) && !o.contentDOM ? Ae.isSelectable(a) ? ta(t, new Ae(e < 0 ? t.state.doc.resolve(r.pos - a.nodeSize) : r)) : Mc ? ta(t, new Fe(t.state.doc.resolve(e < 0 ? s : s + a.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (i instanceof Ae && i.node.isInline)
      return ta(t, new Fe(e > 0 ? i.$to : i.$from));
    {
      let r = Wg(t.state, e);
      return r ? ta(t, r) : !1;
    }
  }
}
function Df(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function Gl(t, e) {
  let n = t.pmViewDesc;
  return n && n.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function Go(t, e) {
  return e < 0 ? GOe(t) : XOe(t);
}
function GOe(t) {
  let e = t.domSelectionRange(), n = e.focusNode, i = e.focusOffset;
  if (!n)
    return;
  let r, a, o = !1;
  for (Yi && n.nodeType == 1 && i < Df(n) && Gl(n.childNodes[i], -1) && (o = !0); ; )
    if (i > 0) {
      if (n.nodeType != 1)
        break;
      {
        let s = n.childNodes[i - 1];
        if (Gl(s, -1))
          r = n, a = --i;
        else if (s.nodeType == 3)
          n = s, i = n.nodeValue.length;
        else
          break;
      }
    } else {
      if (gS(n))
        break;
      {
        let s = n.previousSibling;
        for (; s && Gl(s, -1); )
          r = n.parentNode, a = cn(s), s = s.previousSibling;
        if (s)
          n = s, i = Df(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          i = 0;
        }
      }
    }
  o ? Ag(t, n, i) : r && Ag(t, r, a);
}
function XOe(t) {
  let e = t.domSelectionRange(), n = e.focusNode, i = e.focusOffset;
  if (!n)
    return;
  let r = Df(n), a, o;
  for (; ; )
    if (i < r) {
      if (n.nodeType != 1)
        break;
      let s = n.childNodes[i];
      if (Gl(s, 1))
        a = n, o = ++i;
      else
        break;
    } else {
      if (gS(n))
        break;
      {
        let s = n.nextSibling;
        for (; s && Gl(s, 1); )
          a = s.parentNode, o = cn(s) + 1, s = s.nextSibling;
        if (s)
          n = s, i = 0, r = Df(n);
        else {
          if (n = n.parentNode, n == t.dom)
            break;
          i = r = 0;
        }
      }
    }
  a && Ag(t, a, o);
}
function gS(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function YOe(t, e) {
  for (; t && e == t.childNodes.length && !_c(t); )
    e = cn(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let n = t.childNodes[e];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = 0;
  }
}
function KOe(t, e) {
  for (; t && !e && !_c(t); )
    e = cn(t), t = t.parentNode;
  for (; t && e; ) {
    let n = t.childNodes[e - 1];
    if (n.nodeType == 3)
      return n;
    if (n.nodeType == 1 && n.contentEditable == "false")
      break;
    t = n, e = t.childNodes.length;
  }
}
function Ag(t, e, n) {
  if (e.nodeType != 3) {
    let a, o;
    (o = YOe(e, n)) ? (e = o, n = 0) : (a = KOe(e, n)) && (e = a, n = a.nodeValue.length);
  }
  let i = t.domSelection();
  if (!i)
    return;
  if (ph(i)) {
    let a = document.createRange();
    a.setEnd(e, n), a.setStart(e, n), i.removeAllRanges(), i.addRange(a);
  } else i.extend && i.extend(e, n);
  t.domObserver.setCurSelection();
  let { state: r } = t;
  setTimeout(() => {
    t.state == r && Wr(t);
  }, 50);
}
function Wx(t, e) {
  let n = t.state.doc.resolve(e);
  if (!(bn || yOe) && n.parent.inlineContent) {
    let r = t.coordsAtPos(e);
    if (e > n.start()) {
      let a = t.coordsAtPos(e - 1), o = (a.top + a.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(a.left - r.left) > 1)
        return a.left < r.left ? "ltr" : "rtl";
    }
    if (e < n.end()) {
      let a = t.coordsAtPos(e + 1), o = (a.top + a.bottom) / 2;
      if (o > r.top && o < r.bottom && Math.abs(a.left - r.left) > 1)
        return a.left > r.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function Ax(t, e, n) {
  let i = t.state.selection;
  if (i instanceof Fe && !i.empty || n.indexOf("s") > -1 || vi && n.indexOf("m") > -1)
    return !1;
  let { $from: r, $to: a } = i;
  if (!r.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let o = Wg(t.state, e);
    if (o && o instanceof Ae)
      return ta(t, o);
  }
  if (!r.parent.inlineContent) {
    let o = e < 0 ? r : a, s = i instanceof Un ? He.near(o, e) : He.findFrom(o, e);
    return s ? ta(t, s) : !1;
  }
  return !1;
}
function Lx(t, e) {
  if (!(t.state.selection instanceof Fe))
    return !0;
  let { $head: n, $anchor: i, empty: r } = t.state.selection;
  if (!n.sameParent(i))
    return !0;
  if (!r)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let a = !n.textOffset && (e < 0 ? n.nodeBefore : n.nodeAfter);
  if (a && !a.isText) {
    let o = t.state.tr;
    return e < 0 ? o.delete(n.pos - a.nodeSize, n.pos) : o.delete(n.pos, n.pos + a.nodeSize), t.dispatch(o), !0;
  }
  return !1;
}
function Ix(t, e, n) {
  t.domObserver.stop(), e.contentEditable = n, t.domObserver.start();
}
function UOe(t) {
  if (!Rn || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: n } = t.domSelectionRange();
  if (e && e.nodeType == 1 && n == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let i = e.firstChild;
    Ix(t, i, "true"), setTimeout(() => Ix(t, i, "false"), 20);
  }
  return !1;
}
function JOe(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function QOe(t, e) {
  let n = e.keyCode, i = JOe(e);
  if (n == 8 || vi && n == 72 && i == "c")
    return Lx(t, -1) || Go(t, -1);
  if (n == 46 && !e.shiftKey || vi && n == 68 && i == "c")
    return Lx(t, 1) || Go(t, 1);
  if (n == 13 || n == 27)
    return !0;
  if (n == 37 || vi && n == 66 && i == "c") {
    let r = n == 37 ? Wx(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return Ox(t, r, i) || Go(t, r);
  } else if (n == 39 || vi && n == 70 && i == "c") {
    let r = n == 39 ? Wx(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return Ox(t, r, i) || Go(t, r);
  } else {
    if (n == 38 || vi && n == 80 && i == "c")
      return Ax(t, -1, i) || Go(t, -1);
    if (n == 40 || vi && n == 78 && i == "c")
      return UOe(t) || Ax(t, 1, i) || Go(t, 1);
    if (i == (vi ? "m" : "c") && (n == 66 || n == 73 || n == 89 || n == 90))
      return !0;
  }
  return !1;
}
function B0(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let n = [], { content: i, openStart: r, openEnd: a } = e;
  for (; r > 1 && a > 1 && i.childCount == 1 && i.firstChild.childCount == 1; ) {
    r--, a--;
    let h = i.firstChild;
    n.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), i = h.content;
  }
  let o = t.someProp("clipboardSerializer") || Io.fromSchema(t.state.schema), s = xS(), l = s.createElement("div");
  l.appendChild(o.serializeFragment(i, { document: s }));
  let c = l.firstChild, u, f = 0;
  for (; c && c.nodeType == 1 && (u = kS[c.nodeName.toLowerCase()]); ) {
    for (let h = u.length - 1; h >= 0; h--) {
      let p = s.createElement(u[h]);
      for (; l.firstChild; )
        p.appendChild(l.firstChild);
      l.appendChild(p), f++;
    }
    c = l.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${r} ${a}${f ? ` -${f}` : ""} ${JSON.stringify(n)}`);
  let m = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: l, text: m, slice: e };
}
function yS(t, e, n, i, r) {
  let a = r.parent.type.spec.code, o, s;
  if (!n && !e)
    return null;
  let l = e && (i || a || !n);
  if (l) {
    if (t.someProp("transformPastedText", (m) => {
      e = m(e, a || i, t);
    }), a)
      return e ? new ye(ee.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0) : ye.empty;
    let f = t.someProp("clipboardTextParser", (m) => m(e, r, i, t));
    if (f)
      s = f;
    else {
      let m = r.marks(), { schema: h } = t.state, p = Io.fromSchema(h);
      o = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((g) => {
        let y = o.appendChild(document.createElement("p"));
        g && y.appendChild(p.serializeNode(h.text(g, m)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (f) => {
      n = f(n, t);
    }), o = nWe(n), Mc && iWe(o);
  let c = o && o.querySelector("[data-pm-slice]"), u = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (u && u[3])
    for (let f = +u[3]; f > 0; f--) {
      let m = o.firstChild;
      for (; m && m.nodeType != 1; )
        m = m.nextSibling;
      if (!m)
        break;
      o = m;
    }
  if (s || (s = (t.someProp("clipboardParser") || t.someProp("domParser") || Bl.fromSchema(t.state.schema)).parseSlice(o, {
    preserveWhitespace: !!(l || u),
    context: r,
    ruleFromNode(m) {
      return m.nodeName == "BR" && !m.nextSibling && m.parentNode && !ZOe.test(m.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), u)
    s = rWe(Rx(s, +u[1], +u[2]), u[4]);
  else if (s = ye.maxOpen(eWe(s.content, r), !0), s.openStart || s.openEnd) {
    let f = 0, m = 0;
    for (let h = s.content.firstChild; f < s.openStart && !h.type.spec.isolating; f++, h = h.firstChild)
      ;
    for (let h = s.content.lastChild; m < s.openEnd && !h.type.spec.isolating; m++, h = h.lastChild)
      ;
    s = Rx(s, f, m);
  }
  return t.someProp("transformPasted", (f) => {
    s = f(s, t);
  }), s;
}
const ZOe = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function eWe(t, e) {
  if (t.childCount < 2)
    return t;
  for (let n = e.depth; n >= 0; n--) {
    let r = e.node(n).contentMatchAt(e.index(n)), a, o = [];
    if (t.forEach((s) => {
      if (!o)
        return;
      let l = r.findWrapping(s.type), c;
      if (!l)
        return o = null;
      if (c = o.length && a.length && bS(l, a, s, o[o.length - 1], 0))
        o[o.length - 1] = c;
      else {
        o.length && (o[o.length - 1] = wS(o[o.length - 1], a.length));
        let u = vS(s, l);
        o.push(u), r = r.matchType(u.type), a = l;
      }
    }), o)
      return ee.from(o);
  }
  return t;
}
function vS(t, e, n = 0) {
  for (let i = e.length - 1; i >= n; i--)
    t = e[i].create(null, ee.from(t));
  return t;
}
function bS(t, e, n, i, r) {
  if (r < t.length && r < e.length && t[r] == e[r]) {
    let a = bS(t, e, n, i.lastChild, r + 1);
    if (a)
      return i.copy(i.content.replaceChild(i.childCount - 1, a));
    if (i.contentMatchAt(i.childCount).matchType(r == t.length - 1 ? n.type : t[r + 1]))
      return i.copy(i.content.append(ee.from(vS(n, t, r + 1))));
  }
}
function wS(t, e) {
  if (e == 0)
    return t;
  let n = t.content.replaceChild(t.childCount - 1, wS(t.lastChild, e - 1)), i = t.contentMatchAt(t.childCount).fillBefore(ee.empty, !0);
  return t.copy(n.append(i));
}
function Lg(t, e, n, i, r, a) {
  let o = e < 0 ? t.firstChild : t.lastChild, s = o.content;
  return t.childCount > 1 && (a = 0), r < i - 1 && (s = Lg(s, e, n, i, r + 1, a)), r >= n && (s = e < 0 ? o.contentMatchAt(0).fillBefore(s, a <= r).append(s) : s.append(o.contentMatchAt(o.childCount).fillBefore(ee.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, o.copy(s));
}
function Rx(t, e, n) {
  return e < t.openStart && (t = new ye(Lg(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), n < t.openEnd && (t = new ye(Lg(t.content, 1, n, t.openEnd, 0, 0), t.openStart, n)), t;
}
const kS = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let jx = null;
function xS() {
  return jx || (jx = document.implementation.createHTMLDocument("title"));
}
let V1 = null;
function tWe(t) {
  let e = window.trustedTypes;
  return e ? (V1 || (V1 = e.createPolicy("ProseMirrorClipboard", { createHTML: (n) => n })), V1.createHTML(t)) : t;
}
function nWe(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let n = xS().createElement("div"), i = /<([a-z][^>\s]+)/i.exec(t), r;
  if ((r = i && kS[i[1].toLowerCase()]) && (t = r.map((a) => "<" + a + ">").join("") + t + r.map((a) => "</" + a + ">").reverse().join("")), n.innerHTML = tWe(t), r)
    for (let a = 0; a < r.length; a++)
      n = n.querySelector(r[a]) || n;
  return n;
}
function iWe(t) {
  let e = t.querySelectorAll(bn ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let n = 0; n < e.length; n++) {
    let i = e[n];
    i.childNodes.length == 1 && i.textContent == " " && i.parentNode && i.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), i);
  }
}
function rWe(t, e) {
  if (!t.size)
    return t;
  let n = t.content.firstChild.type.schema, i;
  try {
    i = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: r, openStart: a, openEnd: o } = t;
  for (let s = i.length - 2; s >= 0; s -= 2) {
    let l = n.nodes[i[s]];
    if (!l || l.hasRequiredAttrs())
      break;
    r = ee.from(l.create(i[s + 1], r)), a++, o++;
  }
  return new ye(r, a, o);
}
const jn = {}, Fn = {}, aWe = { touchstart: !0, touchmove: !0 };
class oWe {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "" }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function sWe(t) {
  for (let e in jn) {
    let n = jn[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (i) => {
      dWe(t, i) && !q0(t, i) && (t.editable || !(i.type in Fn)) && n(t, i);
    }, aWe[e] ? { passive: !0 } : void 0);
  }
  Rn && t.dom.addEventListener("input", () => null), Ig(t);
}
function ha(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function lWe(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function Ig(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let n in e)
      t.input.eventHandlers[n] || t.dom.addEventListener(n, t.input.eventHandlers[n] = (i) => q0(t, i));
  });
}
function q0(t, e) {
  return t.someProp("handleDOMEvents", (n) => {
    let i = n[e.type];
    return i ? i(t, e) || e.defaultPrevented : !1;
  });
}
function dWe(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let n = e.target; n != t.dom; n = n.parentNode)
    if (!n || n.nodeType == 11 || n.pmViewDesc && n.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function cWe(t, e) {
  !q0(t, e) && jn[e.type] && (t.editable || !(e.type in Fn)) && jn[e.type](t, e);
}
Fn.keydown = (t, e) => {
  let n = e;
  if (t.input.shiftKey = n.keyCode == 16 || n.shiftKey, !MS(t, n) && (t.input.lastKeyCode = n.keyCode, t.input.lastKeyCodeTime = Date.now(), !(Er && bn && n.keyCode == 13)))
    if (n.keyCode != 229 && t.domObserver.forceFlush(), Ts && n.keyCode == 13 && !n.ctrlKey && !n.altKey && !n.metaKey) {
      let i = Date.now();
      t.input.lastIOSEnter = i, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == i && (t.someProp("handleKeyDown", (r) => r(t, Za(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (i) => i(t, n)) || QOe(t, n) ? n.preventDefault() : ha(t, "key");
};
Fn.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Fn.keypress = (t, e) => {
  let n = e;
  if (MS(t, n) || !n.charCode || n.ctrlKey && !n.altKey || vi && n.metaKey)
    return;
  if (t.someProp("handleKeyPress", (r) => r(t, n))) {
    n.preventDefault();
    return;
  }
  let i = t.state.selection;
  if (!(i instanceof Fe) || !i.$from.sameParent(i.$to)) {
    let r = String.fromCharCode(n.charCode);
    !/[\r\n]/.test(r) && !t.someProp("handleTextInput", (a) => a(t, i.$from.pos, i.$to.pos, r)) && t.dispatch(t.state.tr.insertText(r).scrollIntoView()), n.preventDefault();
  }
};
function yh(t) {
  return { left: t.clientX, top: t.clientY };
}
function uWe(t, e) {
  let n = e.x - t.clientX, i = e.y - t.clientY;
  return n * n + i * i < 100;
}
function G0(t, e, n, i, r) {
  if (i == -1)
    return !1;
  let a = t.state.doc.resolve(i);
  for (let o = a.depth + 1; o > 0; o--)
    if (t.someProp(e, (s) => o > a.depth ? s(t, n, a.nodeAfter, a.before(o), r, !0) : s(t, n, a.node(o), a.before(o), r, !1)))
      return !0;
  return !1;
}
function fs(t, e, n) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let i = t.state.tr.setSelection(e);
  i.setMeta("pointer", !0), t.dispatch(i);
}
function fWe(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.doc.resolve(e), i = n.nodeAfter;
  return i && i.isAtom && Ae.isSelectable(i) ? (fs(t, new Ae(n)), !0) : !1;
}
function mWe(t, e) {
  if (e == -1)
    return !1;
  let n = t.state.selection, i, r;
  n instanceof Ae && (i = n.node);
  let a = t.state.doc.resolve(e);
  for (let o = a.depth + 1; o > 0; o--) {
    let s = o > a.depth ? a.nodeAfter : a.node(o);
    if (Ae.isSelectable(s)) {
      i && n.$from.depth > 0 && o >= n.$from.depth && a.before(n.$from.depth + 1) == n.$from.pos ? r = a.before(n.$from.depth) : r = a.before(o);
      break;
    }
  }
  return r != null ? (fs(t, Ae.create(t.state.doc, r)), !0) : !1;
}
function hWe(t, e, n, i, r) {
  return G0(t, "handleClickOn", e, n, i) || t.someProp("handleClick", (a) => a(t, e, i)) || (r ? mWe(t, n) : fWe(t, n));
}
function pWe(t, e, n, i) {
  return G0(t, "handleDoubleClickOn", e, n, i) || t.someProp("handleDoubleClick", (r) => r(t, e, i));
}
function gWe(t, e, n, i) {
  return G0(t, "handleTripleClickOn", e, n, i) || t.someProp("handleTripleClick", (r) => r(t, e, i)) || yWe(t, n, i);
}
function yWe(t, e, n) {
  if (n.button != 0)
    return !1;
  let i = t.state.doc;
  if (e == -1)
    return i.inlineContent ? (fs(t, Fe.create(i, 0, i.content.size)), !0) : !1;
  let r = i.resolve(e);
  for (let a = r.depth + 1; a > 0; a--) {
    let o = a > r.depth ? r.nodeAfter : r.node(a), s = r.before(a);
    if (o.inlineContent)
      fs(t, Fe.create(i, s + 1, s + 1 + o.content.size));
    else if (Ae.isSelectable(o))
      fs(t, Ae.create(i, s));
    else
      continue;
    return !0;
  }
}
function X0(t) {
  return Ef(t);
}
const _S = vi ? "metaKey" : "ctrlKey";
jn.mousedown = (t, e) => {
  let n = e;
  t.input.shiftKey = n.shiftKey;
  let i = X0(t), r = Date.now(), a = "singleClick";
  r - t.input.lastClick.time < 500 && uWe(n, t.input.lastClick) && !n[_S] && (t.input.lastClick.type == "singleClick" ? a = "doubleClick" : t.input.lastClick.type == "doubleClick" && (a = "tripleClick")), t.input.lastClick = { time: r, x: n.clientX, y: n.clientY, type: a };
  let o = t.posAtCoords(yh(n));
  o && (a == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new vWe(t, o, n, !!i)) : (a == "doubleClick" ? pWe : gWe)(t, o.pos, o.inside, n) ? n.preventDefault() : ha(t, "pointer"));
};
class vWe {
  constructor(e, n, i, r) {
    this.view = e, this.pos = n, this.event = i, this.flushed = r, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!i[_S], this.allowDefault = i.shiftKey;
    let a, o;
    if (n.inside > -1)
      a = e.state.doc.nodeAt(n.inside), o = n.inside;
    else {
      let u = e.state.doc.resolve(n.pos);
      a = u.parent, o = u.depth ? u.before() : 0;
    }
    const s = r ? null : i.target, l = s ? e.docView.nearestDesc(s, !0) : null;
    this.target = l && l.dom.nodeType == 1 ? l.dom : null;
    let { selection: c } = e.state;
    (i.button == 0 && a.type.spec.draggable && a.type.spec.selectable !== !1 || c instanceof Ae && c.from <= o && c.to > o) && (this.mightDrag = {
      node: a,
      pos: o,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && Yi && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), ha(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => Wr(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let n = this.pos;
    this.view.state.doc != this.startDoc && (n = this.view.posAtCoords(yh(e))), this.updateAllowDefault(e), this.allowDefault || !n ? ha(this.view, "pointer") : hWe(this.view, n.pos, n.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    Rn && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    bn && !this.view.state.selection.visible && Math.min(Math.abs(n.pos - this.view.state.selection.from), Math.abs(n.pos - this.view.state.selection.to)) <= 2) ? (fs(this.view, He.near(this.view.state.doc.resolve(n.pos))), e.preventDefault()) : ha(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), ha(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
jn.touchstart = (t) => {
  t.input.lastTouch = Date.now(), X0(t), ha(t, "pointer");
};
jn.touchmove = (t) => {
  t.input.lastTouch = Date.now(), ha(t, "pointer");
};
jn.contextmenu = (t) => X0(t);
function MS(t, e) {
  return t.composing ? !0 : Rn && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const bWe = Er ? 5e3 : -1;
Fn.compositionstart = Fn.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, n = e.selection.$to;
    if (e.selection instanceof Fe && (e.storedMarks || !n.textOffset && n.parentOffset && n.nodeBefore.marks.some((i) => i.type.spec.inclusive === !1)))
      t.markCursor = t.state.storedMarks || n.marks(), Ef(t, !0), t.markCursor = null;
    else if (Ef(t, !e.selection.empty), Yi && e.selection.empty && n.parentOffset && !n.textOffset && n.nodeBefore.marks.length) {
      let i = t.domSelectionRange();
      for (let r = i.focusNode, a = i.focusOffset; r && r.nodeType == 1 && a != 0; ) {
        let o = a < 0 ? r.lastChild : r.childNodes[a - 1];
        if (!o)
          break;
        if (o.nodeType == 3) {
          let s = t.domSelection();
          s && s.collapse(o, o.nodeValue.length);
          break;
        } else
          r = o, a = -1;
      }
    }
    t.input.composing = !0;
  }
  CS(t, bWe);
};
Fn.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, CS(t, 20));
};
function CS(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => Ef(t), e));
}
function PS(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = kWe()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function wWe(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let n = fOe(e.focusNode, e.focusOffset), i = mOe(e.focusNode, e.focusOffset);
  if (n && i && n != i) {
    let r = i.pmViewDesc, a = t.domObserver.lastChangedTextNode;
    if (n == a || i == a)
      return a;
    if (!r || !r.isText(i.nodeValue))
      return i;
    if (t.input.compositionNode == i) {
      let o = n.pmViewDesc;
      if (!(!o || !o.isText(n.nodeValue)))
        return i;
    }
  }
  return n || i;
}
function kWe() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function Ef(t, e = !1) {
  if (!(Er && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), PS(t), e || t.docView && t.docView.dirty) {
      let n = V0(t);
      return n && !n.eq(t.state.selection) ? t.dispatch(t.state.tr.setSelection(n)) : (t.markCursor || e) && !t.state.selection.empty ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function xWe(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.dom.parentNode.appendChild(document.createElement("div"));
  n.appendChild(e), n.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let i = getSelection(), r = document.createRange();
  r.selectNodeContents(e), t.dom.blur(), i.removeAllRanges(), i.addRange(r), setTimeout(() => {
    n.parentNode && n.parentNode.removeChild(n), t.focus();
  }, 50);
}
const bd = Jn && ka < 15 || Ts && vOe < 604;
jn.copy = Fn.cut = (t, e) => {
  let n = e, i = t.state.selection, r = n.type == "cut";
  if (i.empty)
    return;
  let a = bd ? null : n.clipboardData, o = i.content(), { dom: s, text: l } = B0(t, o);
  a ? (n.preventDefault(), a.clearData(), a.setData("text/html", s.innerHTML), a.setData("text/plain", l)) : xWe(t, s), r && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function _We(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function MWe(t, e) {
  if (!t.dom.parentNode)
    return;
  let n = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, i = t.dom.parentNode.appendChild(document.createElement(n ? "textarea" : "div"));
  n || (i.contentEditable = "true"), i.style.cssText = "position: fixed; left: -10000px; top: 10px", i.focus();
  let r = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), i.parentNode && i.parentNode.removeChild(i), n ? wd(t, i.value, null, r, e) : wd(t, i.textContent, i.innerHTML, r, e);
  }, 50);
}
function wd(t, e, n, i, r) {
  let a = yS(t, e, n, i, t.state.selection.$from);
  if (t.someProp("handlePaste", (l) => l(t, r, a || ye.empty)))
    return !0;
  if (!a)
    return !1;
  let o = _We(a), s = o ? t.state.tr.replaceSelectionWith(o, i) : t.state.tr.replaceSelection(a);
  return t.dispatch(s.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function SS(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let n = t.getData("text/uri-list");
  return n ? n.replace(/\r?\n/g, " ") : "";
}
Fn.paste = (t, e) => {
  let n = e;
  if (t.composing && !Er)
    return;
  let i = bd ? null : n.clipboardData, r = t.input.shiftKey && t.input.lastKeyCode != 45;
  i && wd(t, SS(i), i.getData("text/html"), r, n) ? n.preventDefault() : MWe(t, n);
};
class NS {
  constructor(e, n, i) {
    this.slice = e, this.move = n, this.node = i;
  }
}
const $S = vi ? "altKey" : "ctrlKey";
jn.dragstart = (t, e) => {
  let n = e, i = t.input.mouseDown;
  if (i && i.done(), !n.dataTransfer)
    return;
  let r = t.state.selection, a = r.empty ? null : t.posAtCoords(yh(n)), o;
  if (!(a && a.pos >= r.from && a.pos <= (r instanceof Ae ? r.to - 1 : r.to))) {
    if (i && i.mightDrag)
      o = Ae.create(t.state.doc, i.mightDrag.pos);
    else if (n.target && n.target.nodeType == 1) {
      let f = t.docView.nearestDesc(n.target, !0);
      f && f.node.type.spec.draggable && f != t.docView && (o = Ae.create(t.state.doc, f.posBefore));
    }
  }
  let s = (o || t.state.selection).content(), { dom: l, text: c, slice: u } = B0(t, s);
  (!n.dataTransfer.files.length || !bn || tS > 120) && n.dataTransfer.clearData(), n.dataTransfer.setData(bd ? "Text" : "text/html", l.innerHTML), n.dataTransfer.effectAllowed = "copyMove", bd || n.dataTransfer.setData("text/plain", c), t.dragging = new NS(u, !n[$S], o);
};
jn.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Fn.dragover = Fn.dragenter = (t, e) => e.preventDefault();
Fn.drop = (t, e) => {
  let n = e, i = t.dragging;
  if (t.dragging = null, !n.dataTransfer)
    return;
  let r = t.posAtCoords(yh(n));
  if (!r)
    return;
  let a = t.state.doc.resolve(r.pos), o = i && i.slice;
  o ? t.someProp("transformPasted", (p) => {
    o = p(o, t);
  }) : o = yS(t, SS(n.dataTransfer), bd ? null : n.dataTransfer.getData("text/html"), !1, a);
  let s = !!(i && !n[$S]);
  if (t.someProp("handleDrop", (p) => p(t, n, o || ye.empty, s))) {
    n.preventDefault();
    return;
  }
  if (!o)
    return;
  n.preventDefault();
  let l = o ? q8(t.state.doc, a.pos, o) : a.pos;
  l == null && (l = a.pos);
  let c = t.state.tr;
  if (s) {
    let { node: p } = i;
    p ? p.replace(c) : c.deleteSelection();
  }
  let u = c.mapping.map(l), f = o.openStart == 0 && o.openEnd == 0 && o.content.childCount == 1, m = c.doc;
  if (f ? c.replaceRangeWith(u, u, o.content.firstChild) : c.replaceRange(u, u, o), c.doc.eq(m))
    return;
  let h = c.doc.resolve(u);
  if (f && Ae.isSelectable(o.content.firstChild) && h.nodeAfter && h.nodeAfter.sameMarkup(o.content.firstChild))
    c.setSelection(new Ae(h));
  else {
    let p = c.mapping.map(l);
    c.mapping.maps[c.mapping.maps.length - 1].forEach((g, y, v, w) => p = w), c.setSelection(H0(t, h, c.doc.resolve(p)));
  }
  t.focus(), t.dispatch(c.setMeta("uiEvent", "drop"));
};
jn.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && Wr(t);
  }, 20));
};
jn.blur = (t, e) => {
  let n = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), n.relatedTarget && t.dom.contains(n.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
jn.beforeinput = (t, e) => {
  if (bn && Er && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: i } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != i || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (a) => a(t, Za(8, "Backspace")))))
        return;
      let { $cursor: r } = t.state.selection;
      r && r.pos > 0 && t.dispatch(t.state.tr.delete(r.pos - 1, r.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Fn)
  jn[t] = Fn[t];
function kd(t, e) {
  if (t == e)
    return !0;
  for (let n in t)
    if (t[n] !== e[n])
      return !1;
  for (let n in e)
    if (!(n in t))
      return !1;
  return !0;
}
class Tf {
  constructor(e, n) {
    this.toDOM = e, this.spec = n || fo, this.side = this.spec.side || 0;
  }
  map(e, n, i, r) {
    let { pos: a, deleted: o } = e.mapResult(n.from + r, this.side < 0 ? -1 : 1);
    return o ? null : new fn(a - i, a - i, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Tf && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && kd(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class _a {
  constructor(e, n) {
    this.attrs = e, this.spec = n || fo;
  }
  map(e, n, i, r) {
    let a = e.map(n.from + r, this.spec.inclusiveStart ? -1 : 1) - i, o = e.map(n.to + r, this.spec.inclusiveEnd ? 1 : -1) - i;
    return a >= o ? null : new fn(a, o, this);
  }
  valid(e, n) {
    return n.from < n.to;
  }
  eq(e) {
    return this == e || e instanceof _a && kd(this.attrs, e.attrs) && kd(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof _a;
  }
  destroy() {
  }
}
class Y0 {
  constructor(e, n) {
    this.attrs = e, this.spec = n || fo;
  }
  map(e, n, i, r) {
    let a = e.mapResult(n.from + r, 1);
    if (a.deleted)
      return null;
    let o = e.mapResult(n.to + r, -1);
    return o.deleted || o.pos <= a.pos ? null : new fn(a.pos - i, o.pos - i, this);
  }
  valid(e, n) {
    let { index: i, offset: r } = e.content.findIndex(n.from), a;
    return r == n.from && !(a = e.child(i)).isText && r + a.nodeSize == n.to;
  }
  eq(e) {
    return this == e || e instanceof Y0 && kd(this.attrs, e.attrs) && kd(this.spec, e.spec);
  }
  destroy() {
  }
}
class fn {
  /**
  @internal
  */
  constructor(e, n, i) {
    this.from = e, this.to = n, this.type = i;
  }
  /**
  @internal
  */
  copy(e, n) {
    return new fn(e, n, this.type);
  }
  /**
  @internal
  */
  eq(e, n = 0) {
    return this.type.eq(e.type) && this.from + n == e.from && this.to + n == e.to;
  }
  /**
  @internal
  */
  map(e, n, i) {
    return this.type.map(e, this, n, i);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, n, i) {
    return new fn(e, e, new Tf(n, i));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, n, i, r) {
    return new fn(e, n, new _a(i, r));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, n, i, r) {
    return new fn(e, n, new Y0(i, r));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof _a;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Tf;
  }
}
const Zo = [], fo = {};
class ht {
  /**
  @internal
  */
  constructor(e, n) {
    this.local = e.length ? e : Zo, this.children = n.length ? n : Zo;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, n) {
    return n.length ? Of(n, e, 0, fo) : gn;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, n, i) {
    let r = [];
    return this.findInner(e ?? 0, n ?? 1e9, r, 0, i), r;
  }
  findInner(e, n, i, r, a) {
    for (let o = 0; o < this.local.length; o++) {
      let s = this.local[o];
      s.from <= n && s.to >= e && (!a || a(s.spec)) && i.push(s.copy(s.from + r, s.to + r));
    }
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] < n && this.children[o + 1] > e) {
        let s = this.children[o] + 1;
        this.children[o + 2].findInner(e - s, n - s, i, r + s, a);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, n, i) {
    return this == gn || e.maps.length == 0 ? this : this.mapInner(e, n, 0, 0, i || fo);
  }
  /**
  @internal
  */
  mapInner(e, n, i, r, a) {
    let o;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s].map(e, i, r);
      l && l.type.valid(n, l) ? (o || (o = [])).push(l) : a.onRemove && a.onRemove(this.local[s].spec);
    }
    return this.children.length ? CWe(this.children, o || [], e, n, i, r, a) : o ? new ht(o.sort(mo), Zo) : gn;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, n) {
    return n.length ? this == gn ? ht.create(e, n) : this.addInner(e, n, 0) : this;
  }
  addInner(e, n, i) {
    let r, a = 0;
    e.forEach((s, l) => {
      let c = l + i, u;
      if (u = ES(n, s, c)) {
        for (r || (r = this.children.slice()); a < r.length && r[a] < l; )
          a += 3;
        r[a] == l ? r[a + 2] = r[a + 2].addInner(s, u, c + 1) : r.splice(a, 0, l, l + s.nodeSize, Of(u, s, c + 1, fo)), a += 3;
      }
    });
    let o = DS(a ? TS(n) : n, -i);
    for (let s = 0; s < o.length; s++)
      o[s].type.valid(e, o[s]) || o.splice(s--, 1);
    return new ht(o.length ? this.local.concat(o).sort(mo) : this.local, r || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == gn ? this : this.removeInner(e, 0);
  }
  removeInner(e, n) {
    let i = this.children, r = this.local;
    for (let a = 0; a < i.length; a += 3) {
      let o, s = i[a] + n, l = i[a + 1] + n;
      for (let u = 0, f; u < e.length; u++)
        (f = e[u]) && f.from > s && f.to < l && (e[u] = null, (o || (o = [])).push(f));
      if (!o)
        continue;
      i == this.children && (i = this.children.slice());
      let c = i[a + 2].removeInner(o, s + 1);
      c != gn ? i[a + 2] = c : (i.splice(a, 3), a -= 3);
    }
    if (r.length) {
      for (let a = 0, o; a < e.length; a++)
        if (o = e[a])
          for (let s = 0; s < r.length; s++)
            r[s].eq(o, n) && (r == this.local && (r = this.local.slice()), r.splice(s--, 1));
    }
    return i == this.children && r == this.local ? this : r.length || i.length ? new ht(r, i) : gn;
  }
  forChild(e, n) {
    if (this == gn)
      return this;
    if (n.isLeaf)
      return ht.empty;
    let i, r;
    for (let s = 0; s < this.children.length; s += 3)
      if (this.children[s] >= e) {
        this.children[s] == e && (i = this.children[s + 2]);
        break;
      }
    let a = e + 1, o = a + n.content.size;
    for (let s = 0; s < this.local.length; s++) {
      let l = this.local[s];
      if (l.from < o && l.to > a && l.type instanceof _a) {
        let c = Math.max(a, l.from) - a, u = Math.min(o, l.to) - a;
        c < u && (r || (r = [])).push(l.copy(c, u));
      }
    }
    if (r) {
      let s = new ht(r.sort(mo), Zo);
      return i ? new oa([s, i]) : s;
    }
    return i || gn;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof ht) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let n = 0; n < this.local.length; n++)
      if (!this.local[n].eq(e.local[n]))
        return !1;
    for (let n = 0; n < this.children.length; n += 3)
      if (this.children[n] != e.children[n] || this.children[n + 1] != e.children[n + 1] || !this.children[n + 2].eq(e.children[n + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return K0(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == gn)
      return Zo;
    if (e.inlineContent || !this.local.some(_a.is))
      return this.local;
    let n = [];
    for (let i = 0; i < this.local.length; i++)
      this.local[i].type instanceof _a || n.push(this.local[i]);
    return n;
  }
  forEachSet(e) {
    e(this);
  }
}
ht.empty = new ht([], []);
ht.removeOverlap = K0;
const gn = ht.empty;
class oa {
  constructor(e) {
    this.members = e;
  }
  map(e, n) {
    const i = this.members.map((r) => r.map(e, n, fo));
    return oa.from(i);
  }
  forChild(e, n) {
    if (n.isLeaf)
      return ht.empty;
    let i = [];
    for (let r = 0; r < this.members.length; r++) {
      let a = this.members[r].forChild(e, n);
      a != gn && (a instanceof oa ? i = i.concat(a.members) : i.push(a));
    }
    return oa.from(i);
  }
  eq(e) {
    if (!(e instanceof oa) || e.members.length != this.members.length)
      return !1;
    for (let n = 0; n < this.members.length; n++)
      if (!this.members[n].eq(e.members[n]))
        return !1;
    return !0;
  }
  locals(e) {
    let n, i = !0;
    for (let r = 0; r < this.members.length; r++) {
      let a = this.members[r].localsInner(e);
      if (a.length)
        if (!n)
          n = a;
        else {
          i && (n = n.slice(), i = !1);
          for (let o = 0; o < a.length; o++)
            n.push(a[o]);
        }
    }
    return n ? K0(i ? n : n.sort(mo)) : Zo;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return gn;
      case 1:
        return e[0];
      default:
        return new oa(e.every((n) => n instanceof ht) ? e : e.reduce((n, i) => n.concat(i instanceof ht ? i : i.members), []));
    }
  }
  forEachSet(e) {
    for (let n = 0; n < this.members.length; n++)
      this.members[n].forEachSet(e);
  }
}
function CWe(t, e, n, i, r, a, o) {
  let s = t.slice();
  for (let c = 0, u = a; c < n.maps.length; c++) {
    let f = 0;
    n.maps[c].forEach((m, h, p, g) => {
      let y = g - p - (h - m);
      for (let v = 0; v < s.length; v += 3) {
        let w = s[v + 1];
        if (w < 0 || m > w + u - f)
          continue;
        let x = s[v] + u - f;
        h >= x ? s[v + 1] = m <= x ? -2 : -1 : m >= u && y && (s[v] += y, s[v + 1] += y);
      }
      f += y;
    }), u = n.maps[c].map(u, -1);
  }
  let l = !1;
  for (let c = 0; c < s.length; c += 3)
    if (s[c + 1] < 0) {
      if (s[c + 1] == -2) {
        l = !0, s[c + 1] = -1;
        continue;
      }
      let u = n.map(t[c] + a), f = u - r;
      if (f < 0 || f >= i.content.size) {
        l = !0;
        continue;
      }
      let m = n.map(t[c + 1] + a, -1), h = m - r, { index: p, offset: g } = i.content.findIndex(f), y = i.maybeChild(p);
      if (y && g == f && g + y.nodeSize == h) {
        let v = s[c + 2].mapInner(n, y, u + 1, t[c] + a + 1, o);
        v != gn ? (s[c] = f, s[c + 1] = h, s[c + 2] = v) : (s[c + 1] = -2, l = !0);
      } else
        l = !0;
    }
  if (l) {
    let c = PWe(s, t, e, n, r, a, o), u = Of(c, i, 0, o);
    e = u.local;
    for (let f = 0; f < s.length; f += 3)
      s[f + 1] < 0 && (s.splice(f, 3), f -= 3);
    for (let f = 0, m = 0; f < u.children.length; f += 3) {
      let h = u.children[f];
      for (; m < s.length && s[m] < h; )
        m += 3;
      s.splice(m, 0, u.children[f], u.children[f + 1], u.children[f + 2]);
    }
  }
  return new ht(e.sort(mo), s);
}
function DS(t, e) {
  if (!e || !t.length)
    return t;
  let n = [];
  for (let i = 0; i < t.length; i++) {
    let r = t[i];
    n.push(new fn(r.from + e, r.to + e, r.type));
  }
  return n;
}
function PWe(t, e, n, i, r, a, o) {
  function s(l, c) {
    for (let u = 0; u < l.local.length; u++) {
      let f = l.local[u].map(i, r, c);
      f ? n.push(f) : o.onRemove && o.onRemove(l.local[u].spec);
    }
    for (let u = 0; u < l.children.length; u += 3)
      s(l.children[u + 2], l.children[u] + c + 1);
  }
  for (let l = 0; l < t.length; l += 3)
    t[l + 1] == -1 && s(t[l + 2], e[l] + a + 1);
  return n;
}
function ES(t, e, n) {
  if (e.isLeaf)
    return null;
  let i = n + e.nodeSize, r = null;
  for (let a = 0, o; a < t.length; a++)
    (o = t[a]) && o.from > n && o.to < i && ((r || (r = [])).push(o), t[a] = null);
  return r;
}
function TS(t) {
  let e = [];
  for (let n = 0; n < t.length; n++)
    t[n] != null && e.push(t[n]);
  return e;
}
function Of(t, e, n, i) {
  let r = [], a = !1;
  e.forEach((s, l) => {
    let c = ES(t, s, l + n);
    if (c) {
      a = !0;
      let u = Of(c, s, n + l + 1, i);
      u != gn && r.push(l, l + s.nodeSize, u);
    }
  });
  let o = DS(a ? TS(t) : t, -n).sort(mo);
  for (let s = 0; s < o.length; s++)
    o[s].type.valid(e, o[s]) || (i.onRemove && i.onRemove(o[s].spec), o.splice(s--, 1));
  return o.length || r.length ? new ht(o, r) : gn;
}
function mo(t, e) {
  return t.from - e.from || t.to - e.to;
}
function K0(t) {
  let e = t;
  for (let n = 0; n < e.length - 1; n++) {
    let i = e[n];
    if (i.from != i.to)
      for (let r = n + 1; r < e.length; r++) {
        let a = e[r];
        if (a.from == i.from) {
          a.to != i.to && (e == t && (e = t.slice()), e[r] = a.copy(a.from, i.to), Fx(e, r + 1, a.copy(i.to, a.to)));
          continue;
        } else {
          a.from < i.to && (e == t && (e = t.slice()), e[n] = i.copy(i.from, a.from), Fx(e, r, i.copy(a.from, i.to)));
          break;
        }
      }
  }
  return e;
}
function Fx(t, e, n) {
  for (; e < t.length && mo(n, t[e]) > 0; )
    e++;
  t.splice(e, 0, n);
}
function H1(t) {
  let e = [];
  return t.someProp("decorations", (n) => {
    let i = n(t.state);
    i && i != gn && e.push(i);
  }), t.cursorWrapper && e.push(ht.create(t.state.doc, [t.cursorWrapper.deco])), oa.from(e);
}
const SWe = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, NWe = Jn && ka <= 11;
class $We {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class DWe {
  constructor(e, n) {
    this.view = e, this.handleDOMChange = n, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new $We(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((i) => {
      for (let r = 0; r < i.length; r++)
        this.queue.push(i[r]);
      Jn && ka <= 11 && i.some((r) => r.type == "childList" && r.removedNodes.length || r.type == "characterData" && r.oldValue.length > r.target.nodeValue.length) ? this.flushSoon() : this.flush();
    }), NWe && (this.onCharData = (i) => {
      this.queue.push({ target: i.target, type: "characterData", oldValue: i.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, SWe)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let n = 0; n < e.length; n++)
          this.queue.push(e[n]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (Tx(this.view)) {
      if (this.suppressingSelectionUpdates)
        return Wr(this.view);
      if (Jn && ka <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && wo(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let n = /* @__PURE__ */ new Set(), i;
    for (let a = e.focusNode; a; a = Es(a))
      n.add(a);
    for (let a = e.anchorNode; a; a = Es(a))
      if (n.has(a)) {
        i = a;
        break;
      }
    let r = i && this.view.docView.nearestDesc(i);
    if (r && r.ignoreMutation({
      type: "selection",
      target: i.nodeType == 3 ? i.parentNode : i
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let n = this.pendingRecords();
    n.length && (this.queue = []);
    let i = e.domSelectionRange(), r = !this.suppressingSelectionUpdates && !this.currentSelection.eq(i) && Tx(e) && !this.ignoreSelectionChange(i), a = -1, o = -1, s = !1, l = [];
    if (e.editable)
      for (let u = 0; u < n.length; u++) {
        let f = this.registerMutation(n[u], l);
        f && (a = a < 0 ? f.from : Math.min(f.from, a), o = o < 0 ? f.to : Math.max(f.to, o), f.typeOver && (s = !0));
      }
    if (Yi && l.length) {
      let u = l.filter((f) => f.nodeName == "BR");
      if (u.length == 2) {
        let [f, m] = u;
        f.parentNode && f.parentNode.parentNode == m.parentNode ? m.remove() : f.remove();
      } else {
        let { focusNode: f } = this.currentSelection;
        for (let m of u) {
          let h = m.parentNode;
          h && h.nodeName == "LI" && (!f || OWe(e, f) != h) && m.remove();
        }
      }
    }
    let c = null;
    a < 0 && r && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && ph(i) && (c = V0(e)) && c.eq(He.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, Wr(e), this.currentSelection.set(i), e.scrollToSelection()) : (a > -1 || r) && (a > -1 && (e.docView.markDirty(a, o), EWe(e)), this.handleDOMChange(a, o, s, l), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(i) || Wr(e), this.currentSelection.set(i));
  }
  registerMutation(e, n) {
    if (n.indexOf(e.target) > -1)
      return null;
    let i = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (i == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !i || i.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let u = 0; u < e.addedNodes.length; u++) {
        let f = e.addedNodes[u];
        n.push(f), f.nodeType == 3 && (this.lastChangedTextNode = f);
      }
      if (i.contentDOM && i.contentDOM != i.dom && !i.contentDOM.contains(e.target))
        return { from: i.posBefore, to: i.posAfter };
      let r = e.previousSibling, a = e.nextSibling;
      if (Jn && ka <= 11 && e.addedNodes.length)
        for (let u = 0; u < e.addedNodes.length; u++) {
          let { previousSibling: f, nextSibling: m } = e.addedNodes[u];
          (!f || Array.prototype.indexOf.call(e.addedNodes, f) < 0) && (r = f), (!m || Array.prototype.indexOf.call(e.addedNodes, m) < 0) && (a = m);
        }
      let o = r && r.parentNode == e.target ? cn(r) + 1 : 0, s = i.localPosFromDOM(e.target, o, -1), l = a && a.parentNode == e.target ? cn(a) : e.target.childNodes.length, c = i.localPosFromDOM(e.target, l, 1);
      return { from: s, to: c };
    } else return e.type == "attributes" ? { from: i.posAtStart - i.border, to: i.posAtEnd + i.border } : (this.lastChangedTextNode = e.target, {
      from: i.posAtStart,
      to: i.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let zx = /* @__PURE__ */ new WeakMap(), Vx = !1;
function EWe(t) {
  if (!zx.has(t) && (zx.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = Yi, Vx)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Vx = !0;
  }
}
function Hx(t, e) {
  let n = e.startContainer, i = e.startOffset, r = e.endContainer, a = e.endOffset, o = t.domAtPos(t.state.selection.anchor);
  return wo(o.node, o.offset, r, a) && ([n, i, r, a] = [r, a, n, i]), { anchorNode: n, anchorOffset: i, focusNode: r, focusOffset: a };
}
function TWe(t, e) {
  if (e.getComposedRanges) {
    let r = e.getComposedRanges(t.root)[0];
    if (r)
      return Hx(t, r);
  }
  let n;
  function i(r) {
    r.preventDefault(), r.stopImmediatePropagation(), n = r.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", i, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", i, !0), n ? Hx(t, n) : null;
}
function OWe(t, e) {
  for (let n = e.parentNode; n && n != t.dom; n = n.parentNode) {
    let i = t.docView.nearestDesc(n, !0);
    if (i && i.node.isBlock)
      return n;
  }
  return null;
}
function WWe(t, e, n) {
  let { node: i, fromOffset: r, toOffset: a, from: o, to: s } = t.docView.parseRange(e, n), l = t.domSelectionRange(), c, u = l.anchorNode;
  if (u && t.dom.contains(u.nodeType == 1 ? u : u.parentNode) && (c = [{ node: u, offset: l.anchorOffset }], ph(l) || c.push({ node: l.focusNode, offset: l.focusOffset })), bn && t.input.lastKeyCode === 8)
    for (let y = a; y > r; y--) {
      let v = i.childNodes[y - 1], w = v.pmViewDesc;
      if (v.nodeName == "BR" && !w) {
        a = y;
        break;
      }
      if (!w || w.size)
        break;
    }
  let f = t.state.doc, m = t.someProp("domParser") || Bl.fromSchema(t.state.schema), h = f.resolve(o), p = null, g = m.parse(i, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: r,
    to: a,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: AWe,
    context: h
  });
  if (c && c[0].pos != null) {
    let y = c[0].pos, v = c[1] && c[1].pos;
    v == null && (v = y), p = { anchor: y + o, head: v + o };
  }
  return { doc: g, sel: p, from: o, to: s };
}
function AWe(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (Rn && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let n = document.createElement("div");
      return n.appendChild(document.createElement("li")), { skip: n };
    } else if (t.parentNode.lastChild == t || Rn && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const LWe = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function IWe(t, e, n, i, r) {
  let a = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let D = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, W = V0(t, D);
    if (W && !t.state.selection.eq(W)) {
      if (bn && Er && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (O) => O(t, Za(13, "Enter"))))
        return;
      let j = t.state.tr.setSelection(W);
      D == "pointer" ? j.setMeta("pointer", !0) : D == "key" && j.scrollIntoView(), a && j.setMeta("composition", a), t.dispatch(j);
    }
    return;
  }
  let o = t.state.doc.resolve(e), s = o.sharedDepth(n);
  e = o.before(s + 1), n = t.state.doc.resolve(n).after(s + 1);
  let l = t.state.selection, c = WWe(t, e, n), u = t.state.doc, f = u.slice(c.from, c.to), m, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (m = t.state.selection.to, h = "end") : (m = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let p = FWe(f.content, c.doc.content, c.from, m, h);
  if (p && t.input.domChangeCount++, (Ts && t.input.lastIOSEnter > Date.now() - 225 || Er) && r.some((D) => D.nodeType == 1 && !LWe.test(D.nodeName)) && (!p || p.endA >= p.endB) && t.someProp("handleKeyDown", (D) => D(t, Za(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!p)
    if (i && l instanceof Fe && !l.empty && l.$head.sameParent(l.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      p = { start: l.from, endA: l.to, endB: l.to };
    else {
      if (c.sel) {
        let D = Bx(t, t.state.doc, c.sel);
        if (D && !D.eq(t.state.selection)) {
          let W = t.state.tr.setSelection(D);
          a && W.setMeta("composition", a), t.dispatch(W);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && p.start == p.endB && t.state.selection instanceof Fe && (p.start > t.state.selection.from && p.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? p.start = t.state.selection.from : p.endA < t.state.selection.to && p.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (p.endB += t.state.selection.to - p.endA, p.endA = t.state.selection.to)), Jn && ka <= 11 && p.endB == p.start + 1 && p.endA == p.start && p.start > c.from && c.doc.textBetween(p.start - c.from - 1, p.start - c.from + 1) == "  " && (p.start--, p.endA--, p.endB--);
  let g = c.doc.resolveNoCache(p.start - c.from), y = c.doc.resolveNoCache(p.endB - c.from), v = u.resolve(p.start), w = g.sameParent(y) && g.parent.inlineContent && v.end() >= p.endA, x;
  if ((Ts && t.input.lastIOSEnter > Date.now() - 225 && (!w || r.some((D) => D.nodeName == "DIV" || D.nodeName == "P")) || !w && g.pos < c.doc.content.size && !g.sameParent(y) && (x = He.findFrom(c.doc.resolve(g.pos + 1), 1, !0)) && x.head == y.pos) && t.someProp("handleKeyDown", (D) => D(t, Za(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > p.start && jWe(u, p.start, p.endA, g, y) && t.someProp("handleKeyDown", (D) => D(t, Za(8, "Backspace")))) {
    Er && bn && t.domObserver.suppressSelectionUpdates();
    return;
  }
  bn && p.endB == p.start && (t.input.lastChromeDelete = Date.now()), Er && !w && g.start() != y.start() && y.parentOffset == 0 && g.depth == y.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == p.endA && (p.endB -= 2, y = c.doc.resolveNoCache(p.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(D) {
      return D(t, Za(13, "Enter"));
    });
  }, 20));
  let b = p.start, M = p.endA, _, N, $;
  if (w) {
    if (g.pos == y.pos)
      Jn && ka <= 11 && g.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => Wr(t), 20)), _ = t.state.tr.delete(b, M), N = u.resolve(p.start).marksAcross(u.resolve(p.endA));
    else if (
      // Adding or removing a mark
      p.endA == p.endB && ($ = RWe(g.parent.content.cut(g.parentOffset, y.parentOffset), v.parent.content.cut(v.parentOffset, p.endA - v.start())))
    )
      _ = t.state.tr, $.type == "add" ? _.addMark(b, M, $.mark) : _.removeMark(b, M, $.mark);
    else if (g.parent.child(g.index()).isText && g.index() == y.index() - (y.textOffset ? 0 : 1)) {
      let D = g.parent.textBetween(g.parentOffset, y.parentOffset);
      if (t.someProp("handleTextInput", (W) => W(t, b, M, D)))
        return;
      _ = t.state.tr.insertText(D, b, M);
    }
  }
  if (_ || (_ = t.state.tr.replace(b, M, c.doc.slice(p.start - c.from, p.endB - c.from))), c.sel) {
    let D = Bx(t, _.doc, c.sel);
    D && !(bn && t.composing && D.empty && (p.start != p.endB || t.input.lastChromeDelete < Date.now() - 100) && (D.head == b || D.head == _.mapping.map(M) - 1) || Jn && D.empty && D.head == b) && _.setSelection(D);
  }
  N && _.ensureMarks(N), a && _.setMeta("composition", a), t.dispatch(_.scrollIntoView());
}
function Bx(t, e, n) {
  return Math.max(n.anchor, n.head) > e.content.size ? null : H0(t, e.resolve(n.anchor), e.resolve(n.head));
}
function RWe(t, e) {
  let n = t.firstChild.marks, i = e.firstChild.marks, r = n, a = i, o, s, l;
  for (let u = 0; u < i.length; u++)
    r = i[u].removeFromSet(r);
  for (let u = 0; u < n.length; u++)
    a = n[u].removeFromSet(a);
  if (r.length == 1 && a.length == 0)
    s = r[0], o = "add", l = (u) => u.mark(s.addToSet(u.marks));
  else if (r.length == 0 && a.length == 1)
    s = a[0], o = "remove", l = (u) => u.mark(s.removeFromSet(u.marks));
  else
    return null;
  let c = [];
  for (let u = 0; u < e.childCount; u++)
    c.push(l(e.child(u)));
  if (ee.from(c).eq(t))
    return { mark: s, type: o };
}
function jWe(t, e, n, i, r) {
  if (
    // The content must have shrunk
    n - e <= r.pos - i.pos || // newEnd must point directly at or after the end of the block that newStart points into
    B1(i, !0, !1) < r.pos
  )
    return !1;
  let a = t.resolve(e);
  if (!i.parent.isTextblock) {
    let s = a.nodeAfter;
    return s != null && n == e + s.nodeSize;
  }
  if (a.parentOffset < a.parent.content.size || !a.parent.isTextblock)
    return !1;
  let o = t.resolve(B1(a, !0, !0));
  return !o.parent.isTextblock || o.pos > n || B1(o, !0, !1) < n ? !1 : i.parent.content.cut(i.parentOffset).eq(o.parent.content);
}
function B1(t, e, n) {
  let i = t.depth, r = e ? t.end() : t.pos;
  for (; i > 0 && (e || t.indexAfter(i) == t.node(i).childCount); )
    i--, r++, e = !1;
  if (n) {
    let a = t.node(i).maybeChild(t.indexAfter(i));
    for (; a && !a.isLeaf; )
      a = a.firstChild, r++;
  }
  return r;
}
function FWe(t, e, n, i, r) {
  let a = t.findDiffStart(e, n);
  if (a == null)
    return null;
  let { a: o, b: s } = t.findDiffEnd(e, n + t.size, n + e.size);
  if (r == "end") {
    let l = Math.max(0, a - Math.min(o, s));
    i -= o + l - a;
  }
  if (o < a && t.size < e.size) {
    let l = i <= a && i >= o ? a - i : 0;
    a -= l, a && a < e.size && qx(e.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), s = a + (s - o), o = a;
  } else if (s < a) {
    let l = i <= a && i >= s ? a - i : 0;
    a -= l, a && a < t.size && qx(t.textBetween(a - 1, a + 1)) && (a += l ? 1 : -1), o = a + (o - s), s = a;
  }
  return { start: a, endA: o, endB: s };
}
function qx(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), n = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && n >= 55296 && n <= 56319;
}
class zWe {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, n) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new oWe(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = n, this.state = n.state, this.directPlugins = n.plugins || [], this.directPlugins.forEach(Ux), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Yx(this), Xx(this), this.nodeViews = Kx(this), this.docView = Px(this.state.doc, Gx(this), H1(this), this.dom, this), this.domObserver = new DWe(this, (i, r, a, o) => IWe(this, i, r, a, o)), this.domObserver.start(), sWe(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let n in e)
        this._props[n] = e[n];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && Ig(this);
    let n = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Ux), this.directPlugins = e.plugins), this.updateStateInner(e.state, n);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let n = {};
    for (let i in this._props)
      n[i] = this._props[i];
    n.state = this.state;
    for (let i in e)
      n[i] = e[i];
    this.update(n);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, n) {
    var i;
    let r = this.state, a = !1, o = !1;
    e.storedMarks && this.composing && (PS(this), o = !0), this.state = e;
    let s = r.plugins != e.plugins || this._props.plugins != n.plugins;
    if (s || this._props.plugins != n.plugins || this._props.nodeViews != n.nodeViews) {
      let h = Kx(this);
      HWe(h, this.nodeViews) && (this.nodeViews = h, a = !0);
    }
    (s || n.handleDOMEvents != this._props.handleDOMEvents) && Ig(this), this.editable = Yx(this), Xx(this);
    let l = H1(this), c = Gx(this), u = r.plugins != e.plugins && !r.doc.eq(e.doc) ? "reset" : e.scrollToSelection > r.scrollToSelection ? "to selection" : "preserve", f = a || !this.docView.matchesNode(e.doc, c, l);
    (f || !e.selection.eq(r.selection)) && (o = !0);
    let m = u == "preserve" && o && this.dom.style.overflowAnchor == null && kOe(this);
    if (o) {
      this.domObserver.stop();
      let h = f && (Jn || bn) && !this.composing && !r.selection.empty && !e.selection.empty && VWe(r.selection, e.selection);
      if (f) {
        let p = bn ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = wWe(this)), (a || !this.docView.update(e.doc, c, l, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = Px(e.doc, c, l, this.dom, this)), p && !this.trackWrites && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && qOe(this)) ? Wr(this, h) : (hS(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(r), !((i = this.dragging) === null || i === void 0) && i.node && !r.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, r), u == "reset" ? this.dom.scrollTop = 0 : u == "to selection" ? this.scrollToSelection() : m && xOe(m);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (n) => n(this))) if (this.state.selection instanceof Ae) {
        let n = this.docView.domAfterPos(this.state.selection.from);
        n.nodeType == 1 && wx(this, n.getBoundingClientRect(), e);
      } else
        wx(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let n = 0; n < this.directPlugins.length; n++) {
        let i = this.directPlugins[n];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
      for (let n = 0; n < this.state.plugins.length; n++) {
        let i = this.state.plugins[n];
        i.spec.view && this.pluginViews.push(i.spec.view(this));
      }
    } else
      for (let n = 0; n < this.pluginViews.length; n++) {
        let i = this.pluginViews[n];
        i.update && i.update(this, e);
      }
  }
  updateDraggedNode(e, n) {
    let i = e.node, r = -1;
    if (this.state.doc.nodeAt(i.from) == i.node)
      r = i.from;
    else {
      let a = i.from + (this.state.doc.content.size - n.doc.content.size);
      (a > 0 && this.state.doc.nodeAt(a)) == i.node && (r = a);
    }
    this.dragging = new NS(e.slice, e.move, r < 0 ? void 0 : Ae.create(this.state.doc, r));
  }
  someProp(e, n) {
    let i = this._props && this._props[e], r;
    if (i != null && (r = n ? n(i) : i))
      return r;
    for (let o = 0; o < this.directPlugins.length; o++) {
      let s = this.directPlugins[o].props[e];
      if (s != null && (r = n ? n(s) : s))
        return r;
    }
    let a = this.state.plugins;
    if (a)
      for (let o = 0; o < a.length; o++) {
        let s = a[o].props[e];
        if (s != null && (r = n ? n(s) : s))
          return r;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Jn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && _Oe(this.dom), Wr(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let n = this.dom.parentNode; n; n = n.parentNode)
        if (n.nodeType == 9 || n.nodeType == 11 && n.host)
          return n.getSelection || (Object.getPrototypeOf(n).getSelection = () => n.ownerDocument.getSelection()), this._root = n;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return NOe(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, n = 1) {
    return oS(this, e, n);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, n = 0) {
    return this.docView.domFromPos(e, n);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let n = this.docView.descAt(e);
    return n ? n.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, n, i = -1) {
    let r = this.docView.posFromDOM(e, n, i);
    if (r == null)
      throw new RangeError("DOM position not inside the editor");
    return r;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, n) {
    return OOe(this, n || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, n) {
    return wd(this, "", e, !1, n || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, n) {
    return wd(this, e, null, !0, n || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return B0(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (lWe(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], H1(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, cOe());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return cWe(this, e);
  }
  /**
  Dispatch a transaction. Will call
  [`dispatchTransaction`](https://prosemirror.net/docs/ref/#view.DirectEditorProps.dispatchTransaction)
  when given, and otherwise defaults to applying the transaction to
  the current state and calling
  [`updateState`](https://prosemirror.net/docs/ref/#view.EditorView.updateState) with the result.
  This method is bound to the view instance, so that it can be
  easily passed around.
  */
  dispatch(e) {
    let n = this._props.dispatchTransaction;
    n ? n.call(this, e) : this.updateState(this.state.apply(e));
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? Rn && this.root.nodeType === 11 && pOe(this.dom.ownerDocument) == this.dom && TWe(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
function Gx(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (n) => {
    if (typeof n == "function" && (n = n(t.state)), n)
      for (let i in n)
        i == "class" ? e.class += " " + n[i] : i == "style" ? e.style = (e.style ? e.style + ";" : "") + n[i] : !e[i] && i != "contenteditable" && i != "nodeName" && (e[i] = String(n[i]));
  }), e.translate || (e.translate = "no"), [fn.node(0, t.state.doc.content.size, e)];
}
function Xx(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: fn.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Yx(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function VWe(t, e) {
  let n = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(n) != e.$anchor.start(n);
}
function Kx(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function n(i) {
    for (let r in i)
      Object.prototype.hasOwnProperty.call(e, r) || (e[r] = i[r]);
  }
  return t.someProp("nodeViews", n), t.someProp("markViews", n), e;
}
function HWe(t, e) {
  let n = 0, i = 0;
  for (let r in t) {
    if (t[r] != e[r])
      return !0;
    n++;
  }
  for (let r in e)
    i++;
  return n != i;
}
function Ux(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Sa = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Wf = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, BWe = typeof navigator < "u" && /Mac/.test(navigator.platform), qWe = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var un = 0; un < 10; un++) Sa[48 + un] = Sa[96 + un] = String(un);
for (var un = 1; un <= 24; un++) Sa[un + 111] = "F" + un;
for (var un = 65; un <= 90; un++)
  Sa[un] = String.fromCharCode(un + 32), Wf[un] = String.fromCharCode(un);
for (var q1 in Sa) Wf.hasOwnProperty(q1) || (Wf[q1] = Sa[q1]);
function GWe(t) {
  var e = BWe && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || qWe && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", n = !e && t.key || (t.shiftKey ? Wf : Sa)[t.keyCode] || t.key || "Unidentified";
  return n == "Esc" && (n = "Escape"), n == "Del" && (n = "Delete"), n == "Left" && (n = "ArrowLeft"), n == "Up" && (n = "ArrowUp"), n == "Right" && (n = "ArrowRight"), n == "Down" && (n = "ArrowDown"), n;
}
const XWe = typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : !1;
function YWe(t) {
  let e = t.split(/-(?!$)/), n = e[e.length - 1];
  n == "Space" && (n = " ");
  let i, r, a, o;
  for (let s = 0; s < e.length - 1; s++) {
    let l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      XWe ? o = !0 : r = !0;
    else
      throw new Error("Unrecognized modifier name: " + l);
  }
  return i && (n = "Alt-" + n), r && (n = "Ctrl-" + n), o && (n = "Meta-" + n), a && (n = "Shift-" + n), n;
}
function KWe(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let n in t)
    e[YWe(n)] = t[n];
  return e;
}
function G1(t, e, n = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), n && e.shiftKey && (t = "Shift-" + t), t;
}
function UWe(t) {
  return new ft({ props: { handleKeyDown: OS(t) } });
}
function OS(t) {
  let e = KWe(t);
  return function(n, i) {
    let r = GWe(i), a, o = e[G1(r, i)];
    if (o && o(n.state, n.dispatch, n))
      return !0;
    if (r.length == 1 && r != " ") {
      if (i.shiftKey) {
        let s = e[G1(r, i, !1)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
      if ((i.shiftKey || i.altKey || i.metaKey || r.charCodeAt(0) > 127) && (a = Sa[i.keyCode]) && a != r) {
        let s = e[G1(a, i)];
        if (s && s(n.state, n.dispatch, n))
          return !0;
      }
    }
    return !1;
  };
}
const U0 = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function WS(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("backward", t) : n.parentOffset > 0) ? null : n;
}
const AS = (t, e, n) => {
  let i = WS(t, n);
  if (!i)
    return !1;
  let r = J0(i);
  if (!r) {
    let o = i.blockRange(), s = o && il(o);
    return s == null ? !1 : (e && e(t.tr.lift(o, s).scrollIntoView()), !0);
  }
  let a = r.nodeBefore;
  if (BS(t, r, e, -1))
    return !0;
  if (i.parent.content.size == 0 && (Os(a, "end") || Ae.isSelectable(a)))
    for (let o = i.depth; ; o--) {
      let s = mh(t.doc, i.before(o), i.after(o), ye.empty);
      if (s && s.slice.size < s.to - s.from) {
        if (e) {
          let l = t.tr.step(s);
          l.setSelection(Os(a, "end") ? He.findFrom(l.doc.resolve(l.mapping.map(r.pos, -1)), -1) : Ae.create(l.doc, r.pos - a.nodeSize)), e(l.scrollIntoView());
        }
        return !0;
      }
      if (o == 1 || i.node(o - 1).childCount > 1)
        break;
    }
  return a.isAtom && r.depth == i.depth - 1 ? (e && e(t.tr.delete(r.pos - a.nodeSize, r.pos).scrollIntoView()), !0) : !1;
}, JWe = (t, e, n) => {
  let i = WS(t, n);
  if (!i)
    return !1;
  let r = J0(i);
  return r ? LS(t, r, e) : !1;
}, QWe = (t, e, n) => {
  let i = RS(t, n);
  if (!i)
    return !1;
  let r = Q0(i);
  return r ? LS(t, r, e) : !1;
};
function LS(t, e, n) {
  let i = e.nodeBefore, r = i, a = e.pos - 1;
  for (; !r.isTextblock; a--) {
    if (r.type.spec.isolating)
      return !1;
    let u = r.lastChild;
    if (!u)
      return !1;
    r = u;
  }
  let o = e.nodeAfter, s = o, l = e.pos + 1;
  for (; !s.isTextblock; l++) {
    if (s.type.spec.isolating)
      return !1;
    let u = s.firstChild;
    if (!u)
      return !1;
    s = u;
  }
  let c = mh(t.doc, a, l, ye.empty);
  if (!c || c.from != a || c instanceof nn && c.slice.size >= l - a)
    return !1;
  if (n) {
    let u = t.tr.step(c);
    u.setSelection(Fe.create(u.doc, a)), n(u.scrollIntoView());
  }
  return !0;
}
function Os(t, e, n = !1) {
  for (let i = t; i; i = e == "start" ? i.firstChild : i.lastChild) {
    if (i.isTextblock)
      return !0;
    if (n && i.childCount != 1)
      return !1;
  }
  return !1;
}
const IS = (t, e, n) => {
  let { $head: i, empty: r } = t.selection, a = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (n ? !n.endOfTextblock("backward", t) : i.parentOffset > 0)
      return !1;
    a = J0(i);
  }
  let o = a && a.nodeBefore;
  return !o || !Ae.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(Ae.create(t.doc, a.pos - o.nodeSize)).scrollIntoView()), !0);
};
function J0(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function RS(t, e) {
  let { $cursor: n } = t.selection;
  return !n || (e ? !e.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size) ? null : n;
}
const jS = (t, e, n) => {
  let i = RS(t, n);
  if (!i)
    return !1;
  let r = Q0(i);
  if (!r)
    return !1;
  let a = r.nodeAfter;
  if (BS(t, r, e, 1))
    return !0;
  if (i.parent.content.size == 0 && (Os(a, "start") || Ae.isSelectable(a))) {
    let o = mh(t.doc, i.before(), i.after(), ye.empty);
    if (o && o.slice.size < o.to - o.from) {
      if (e) {
        let s = t.tr.step(o);
        s.setSelection(Os(a, "start") ? He.findFrom(s.doc.resolve(s.mapping.map(r.pos)), 1) : Ae.create(s.doc, s.mapping.map(r.pos))), e(s.scrollIntoView());
      }
      return !0;
    }
  }
  return a.isAtom && r.depth == i.depth - 1 ? (e && e(t.tr.delete(r.pos, r.pos + a.nodeSize).scrollIntoView()), !0) : !1;
}, FS = (t, e, n) => {
  let { $head: i, empty: r } = t.selection, a = i;
  if (!r)
    return !1;
  if (i.parent.isTextblock) {
    if (n ? !n.endOfTextblock("forward", t) : i.parentOffset < i.parent.content.size)
      return !1;
    a = Q0(i);
  }
  let o = a && a.nodeAfter;
  return !o || !Ae.isSelectable(o) ? !1 : (e && e(t.tr.setSelection(Ae.create(t.doc, a.pos)).scrollIntoView()), !0);
};
function Q0(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let n = t.node(e);
      if (t.index(e) + 1 < n.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (n.type.spec.isolating)
        break;
    }
  return null;
}
const ZWe = (t, e) => {
  let n = t.selection, i = n instanceof Ae, r;
  if (i) {
    if (n.node.isTextblock || !Va(t.doc, n.from))
      return !1;
    r = n.from;
  } else if (r = fh(t.doc, n.from, -1), r == null)
    return !1;
  if (e) {
    let a = t.tr.join(r);
    i && a.setSelection(Ae.create(a.doc, r - t.doc.resolve(r).nodeBefore.nodeSize)), e(a.scrollIntoView());
  }
  return !0;
}, eAe = (t, e) => {
  let n = t.selection, i;
  if (n instanceof Ae) {
    if (n.node.isTextblock || !Va(t.doc, n.to))
      return !1;
    i = n.to;
  } else if (i = fh(t.doc, n.to, 1), i == null)
    return !1;
  return e && e(t.tr.join(i).scrollIntoView()), !0;
}, tAe = (t, e) => {
  let { $from: n, $to: i } = t.selection, r = n.blockRange(i), a = r && il(r);
  return a == null ? !1 : (e && e(t.tr.lift(r, a).scrollIntoView()), !0);
}, zS = (t, e) => {
  let { $head: n, $anchor: i } = t.selection;
  return !n.parent.type.spec.code || !n.sameParent(i) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function Z0(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
const nAe = (t, e) => {
  let { $head: n, $anchor: i } = t.selection;
  if (!n.parent.type.spec.code || !n.sameParent(i))
    return !1;
  let r = n.node(-1), a = n.indexAfter(-1), o = Z0(r.contentMatchAt(a));
  if (!o || !r.canReplaceWith(a, a, o))
    return !1;
  if (e) {
    let s = n.after(), l = t.tr.replaceWith(s, s, o.createAndFill());
    l.setSelection(He.near(l.doc.resolve(s), 1)), e(l.scrollIntoView());
  }
  return !0;
}, VS = (t, e) => {
  let n = t.selection, { $from: i, $to: r } = n;
  if (n instanceof Un || i.parent.inlineContent || r.parent.inlineContent)
    return !1;
  let a = Z0(r.parent.contentMatchAt(r.indexAfter()));
  if (!a || !a.isTextblock)
    return !1;
  if (e) {
    let o = (!i.parentOffset && r.index() < r.parent.childCount ? i : r).pos, s = t.tr.insert(o, a.createAndFill());
    s.setSelection(Fe.create(s.doc, o + 1)), e(s.scrollIntoView());
  }
  return !0;
}, HS = (t, e) => {
  let { $cursor: n } = t.selection;
  if (!n || n.parent.content.size)
    return !1;
  if (n.depth > 1 && n.after() != n.end(-1)) {
    let a = n.before();
    if (Or(t.doc, a))
      return e && e(t.tr.split(a).scrollIntoView()), !0;
  }
  let i = n.blockRange(), r = i && il(i);
  return r == null ? !1 : (e && e(t.tr.lift(i, r).scrollIntoView()), !0);
};
function iAe(t) {
  return (e, n) => {
    let { $from: i, $to: r } = e.selection;
    if (e.selection instanceof Ae && e.selection.node.isBlock)
      return !i.parentOffset || !Or(e.doc, i.pos) ? !1 : (n && n(e.tr.split(i.pos).scrollIntoView()), !0);
    if (!i.depth)
      return !1;
    let a = [], o, s, l = !1, c = !1;
    for (let h = i.depth; ; h--)
      if (i.node(h).isBlock) {
        l = i.end(h) == i.pos + (i.depth - h), c = i.start(h) == i.pos - (i.depth - h), s = Z0(i.node(h - 1).contentMatchAt(i.indexAfter(h - 1))), a.unshift(l && s ? { type: s } : null), o = h;
        break;
      } else {
        if (h == 1)
          return !1;
        a.unshift(null);
      }
    let u = e.tr;
    (e.selection instanceof Fe || e.selection instanceof Un) && u.deleteSelection();
    let f = u.mapping.map(i.pos), m = Or(u.doc, f, a.length, a);
    if (m || (a[0] = s ? { type: s } : null, m = Or(u.doc, f, a.length, a)), u.split(f, a.length, a), !l && c && i.node(o).type != s) {
      let h = u.mapping.map(i.before(o)), p = u.doc.resolve(h);
      s && i.node(o - 1).canReplaceWith(p.index(), p.index() + 1, s) && u.setNodeMarkup(u.mapping.map(i.before(o)), s);
    }
    return n && n(u.scrollIntoView()), !0;
  };
}
const rAe = iAe(), aAe = (t, e) => {
  let { $from: n, to: i } = t.selection, r, a = n.sharedDepth(i);
  return a == 0 ? !1 : (r = n.before(a), e && e(t.tr.setSelection(Ae.create(t.doc, r))), !0);
};
function oAe(t, e, n) {
  let i = e.nodeBefore, r = e.nodeAfter, a = e.index();
  return !i || !r || !i.type.compatibleContent(r.type) ? !1 : !i.content.size && e.parent.canReplace(a - 1, a) ? (n && n(t.tr.delete(e.pos - i.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(a, a + 1) || !(r.isTextblock || Va(t.doc, e.pos)) ? !1 : (n && n(t.tr.join(e.pos).scrollIntoView()), !0);
}
function BS(t, e, n, i) {
  let r = e.nodeBefore, a = e.nodeAfter, o, s, l = r.type.spec.isolating || a.type.spec.isolating;
  if (!l && oAe(t, e, n))
    return !0;
  let c = !l && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (o = (s = r.contentMatchAt(r.childCount)).findWrapping(a.type)) && s.matchType(o[0] || a.type).validEnd) {
    if (n) {
      let h = e.pos + a.nodeSize, p = ee.empty;
      for (let v = o.length - 1; v >= 0; v--)
        p = ee.from(o[v].create(null, p));
      p = ee.from(r.copy(p));
      let g = t.tr.step(new rn(e.pos - 1, h, e.pos, h, new ye(p, 1, 0), o.length, !0)), y = g.doc.resolve(h + 2 * o.length);
      y.nodeAfter && y.nodeAfter.type == r.type && Va(g.doc, y.pos) && g.join(y.pos), n(g.scrollIntoView());
    }
    return !0;
  }
  let u = a.type.spec.isolating || i > 0 && l ? null : He.findFrom(e, 1), f = u && u.$from.blockRange(u.$to), m = f && il(f);
  if (m != null && m >= e.depth)
    return n && n(t.tr.lift(f, m).scrollIntoView()), !0;
  if (c && Os(a, "start", !0) && Os(r, "end")) {
    let h = r, p = [];
    for (; p.push(h), !h.isTextblock; )
      h = h.lastChild;
    let g = a, y = 1;
    for (; !g.isTextblock; g = g.firstChild)
      y++;
    if (h.canReplace(h.childCount, h.childCount, g.content)) {
      if (n) {
        let v = ee.empty;
        for (let x = p.length - 1; x >= 0; x--)
          v = ee.from(p[x].copy(v));
        let w = t.tr.step(new rn(e.pos - p.length, e.pos + a.nodeSize, e.pos + y, e.pos + a.nodeSize - y, new ye(v, p.length, 0), 0, !0));
        n(w.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function qS(t) {
  return function(e, n) {
    let i = e.selection, r = t < 0 ? i.$from : i.$to, a = r.depth;
    for (; r.node(a).isInline; ) {
      if (!a)
        return !1;
      a--;
    }
    return r.node(a).isTextblock ? (n && n(e.tr.setSelection(Fe.create(e.doc, t < 0 ? r.start(a) : r.end(a)))), !0) : !1;
  };
}
const sAe = qS(-1), lAe = qS(1);
function dAe(t, e = null) {
  return function(n, i) {
    let { $from: r, $to: a } = n.selection, o = r.blockRange(a), s = o && j0(o, t, e);
    return s ? (i && i(n.tr.wrap(o, s).scrollIntoView()), !0) : !1;
  };
}
function Jx(t, e = null) {
  return function(n, i) {
    let r = !1;
    for (let a = 0; a < n.selection.ranges.length && !r; a++) {
      let { $from: { pos: o }, $to: { pos: s } } = n.selection.ranges[a];
      n.doc.nodesBetween(o, s, (l, c) => {
        if (r)
          return !1;
        if (!(!l.isTextblock || l.hasMarkup(t, e)))
          if (l.type == t)
            r = !0;
          else {
            let u = n.doc.resolve(c), f = u.index();
            r = u.parent.canReplaceWith(f, f + 1, t);
          }
      });
    }
    if (!r)
      return !1;
    if (i) {
      let a = n.tr;
      for (let o = 0; o < n.selection.ranges.length; o++) {
        let { $from: { pos: s }, $to: { pos: l } } = n.selection.ranges[o];
        a.setBlockType(s, l, t, e);
      }
      i(a.scrollIntoView());
    }
    return !0;
  };
}
function eb(...t) {
  return function(e, n, i) {
    for (let r = 0; r < t.length; r++)
      if (t[r](e, n, i))
        return !0;
    return !1;
  };
}
eb(U0, AS, IS);
eb(U0, jS, FS);
eb(zS, VS, HS, rAe);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function cAe(t, e = null) {
  return function(n, i) {
    let { $from: r, $to: a } = n.selection, o = r.blockRange(a);
    if (!o)
      return !1;
    let s = i ? n.tr : null;
    return uAe(s, o, t, e) ? (i && i(s.scrollIntoView()), !0) : !1;
  };
}
function uAe(t, e, n, i = null) {
  let r = !1, a = e, o = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(n) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let l = o.resolve(e.start - 2);
    a = new pd(l, l, e.depth), e.endIndex < e.parent.childCount && (e = new pd(e.$from, o.resolve(e.$to.end(e.depth)), e.depth)), r = !0;
  }
  let s = j0(a, n, i, e);
  return s ? (t && fAe(t, e, s, r, n), !0) : !1;
}
function fAe(t, e, n, i, r) {
  let a = ee.empty;
  for (let u = n.length - 1; u >= 0; u--)
    a = ee.from(n[u].type.create(n[u].attrs, a));
  t.step(new rn(e.start - (i ? 2 : 0), e.end, e.start, e.end, new ye(a, 0, 0), n.length, !0));
  let o = 0;
  for (let u = 0; u < n.length; u++)
    n[u].type == r && (o = u + 1);
  let s = n.length - o, l = e.start + n.length - (i ? 2 : 0), c = e.parent;
  for (let u = e.startIndex, f = e.endIndex, m = !0; u < f; u++, m = !1)
    !m && Or(t.doc, l, s) && (t.split(l, s), l += 2 * s), l += c.child(u).nodeSize;
  return t;
}
function mAe(t) {
  return function(e, n) {
    let { $from: i, $to: r } = e.selection, a = i.blockRange(r, (o) => o.childCount > 0 && o.firstChild.type == t);
    return a ? n ? i.node(a.depth - 1).type == t ? hAe(e, n, t, a) : pAe(e, n, a) : !0 : !1;
  };
}
function hAe(t, e, n, i) {
  let r = t.tr, a = i.end, o = i.$to.end(i.depth);
  a < o && (r.step(new rn(a - 1, o, a, o, new ye(ee.from(n.create(null, i.parent.copy())), 1, 0), 1, !0)), i = new pd(r.doc.resolve(i.$from.pos), r.doc.resolve(o), i.depth));
  const s = il(i);
  if (s == null)
    return !1;
  r.lift(i, s);
  let l = r.doc.resolve(r.mapping.map(a, -1) - 1);
  return Va(r.doc, l.pos) && l.nodeBefore.type == l.nodeAfter.type && r.join(l.pos), e(r.scrollIntoView()), !0;
}
function pAe(t, e, n) {
  let i = t.tr, r = n.parent;
  for (let h = n.end, p = n.endIndex - 1, g = n.startIndex; p > g; p--)
    h -= r.child(p).nodeSize, i.delete(h - 1, h + 1);
  let a = i.doc.resolve(n.start), o = a.nodeAfter;
  if (i.mapping.map(n.end) != n.start + a.nodeAfter.nodeSize)
    return !1;
  let s = n.startIndex == 0, l = n.endIndex == r.childCount, c = a.node(-1), u = a.index(-1);
  if (!c.canReplace(u + (s ? 0 : 1), u + 1, o.content.append(l ? ee.empty : ee.from(r))))
    return !1;
  let f = a.pos, m = f + o.nodeSize;
  return i.step(new rn(f - (s ? 1 : 0), m + (l ? 1 : 0), f + 1, m - 1, new ye((s ? ee.empty : ee.from(r.copy(ee.empty))).append(l ? ee.empty : ee.from(r.copy(ee.empty))), s ? 0 : 1, l ? 0 : 1), s ? 0 : 1)), e(i.scrollIntoView()), !0;
}
function gAe(t) {
  return function(e, n) {
    let { $from: i, $to: r } = e.selection, a = i.blockRange(r, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!a)
      return !1;
    let o = a.startIndex;
    if (o == 0)
      return !1;
    let s = a.parent, l = s.child(o - 1);
    if (l.type != t)
      return !1;
    if (n) {
      let c = l.lastChild && l.lastChild.type == s.type, u = ee.from(c ? t.create() : null), f = new ye(ee.from(t.create(null, ee.from(s.type.create(null, u)))), c ? 3 : 1, 0), m = a.start, h = a.end;
      n(e.tr.step(new rn(m - (c ? 3 : 1), h, m, h, f, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
function vh(t) {
  const { state: e, transaction: n } = t;
  let { selection: i } = n, { doc: r } = n, { storedMarks: a } = n;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return a;
    },
    get selection() {
      return i;
    },
    get doc() {
      return r;
    },
    get tr() {
      return i = n.selection, r = n.doc, a = n.storedMarks, n;
    }
  };
}
class bh {
  constructor(e) {
    this.editor = e.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = e.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: e, editor: n, state: i } = this, { view: r } = n, { tr: a } = i, o = this.buildProps(a);
    return Object.fromEntries(Object.entries(e).map(([s, l]) => [s, (...u) => {
      const f = l(...u)(o);
      return !a.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(a), f;
    }]));
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(e, n = !0) {
    const { rawCommands: i, editor: r, state: a } = this, { view: o } = r, s = [], l = !!e, c = e || a.tr, u = () => (!l && n && !c.getMeta("preventDispatch") && !this.hasCustomState && o.dispatch(c), s.every((m) => m === !0)), f = {
      ...Object.fromEntries(Object.entries(i).map(([m, h]) => [m, (...g) => {
        const y = this.buildProps(c, n), v = h(...g)(y);
        return s.push(v), f;
      }])),
      run: u
    };
    return f;
  }
  createCan(e) {
    const { rawCommands: n, state: i } = this, r = !1, a = e || i.tr, o = this.buildProps(a, r);
    return {
      ...Object.fromEntries(Object.entries(n).map(([l, c]) => [l, (...u) => c(...u)({ ...o, dispatch: void 0 })])),
      chain: () => this.createChain(a, r)
    };
  }
  buildProps(e, n = !0) {
    const { rawCommands: i, editor: r, state: a } = this, { view: o } = r, s = {
      tr: e,
      editor: r,
      view: o,
      state: vh({
        state: a,
        transaction: e
      }),
      dispatch: n ? () => {
      } : void 0,
      chain: () => this.createChain(e, n),
      can: () => this.createCan(e),
      get commands() {
        return Object.fromEntries(Object.entries(i).map(([l, c]) => [l, (...u) => c(...u)(s)]));
      }
    };
    return s;
  }
}
class yAe {
  constructor() {
    this.callbacks = {};
  }
  on(e, n) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(n), this;
  }
  emit(e, ...n) {
    const i = this.callbacks[e];
    return i && i.forEach((r) => r.apply(this, n)), this;
  }
  off(e, n) {
    const i = this.callbacks[e];
    return i && (n ? this.callbacks[e] = i.filter((r) => r !== n) : delete this.callbacks[e]), this;
  }
  once(e, n) {
    const i = (...r) => {
      this.off(e, i), n.apply(this, r);
    };
    return this.on(e, i);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
function Ne(t, e, n) {
  return t.config[e] === void 0 && t.parent ? Ne(t.parent, e, n) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...n,
    parent: t.parent ? Ne(t.parent, e, n) : null
  }) : t.config[e];
}
function wh(t) {
  const e = t.filter((r) => r.type === "extension"), n = t.filter((r) => r.type === "node"), i = t.filter((r) => r.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: n,
    markExtensions: i
  };
}
function GS(t) {
  const e = [], { nodeExtensions: n, markExtensions: i } = wh(t), r = [...n, ...i], a = {
    default: null,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  };
  return t.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage,
      extensions: r
    }, l = Ne(o, "addGlobalAttributes", s);
    if (!l)
      return;
    l().forEach((u) => {
      u.types.forEach((f) => {
        Object.entries(u.attributes).forEach(([m, h]) => {
          e.push({
            type: f,
            name: m,
            attribute: {
              ...a,
              ...h
            }
          });
        });
      });
    });
  }), r.forEach((o) => {
    const s = {
      name: o.name,
      options: o.options,
      storage: o.storage
    }, l = Ne(o, "addAttributes", s);
    if (!l)
      return;
    const c = l();
    Object.entries(c).forEach(([u, f]) => {
      const m = {
        ...a,
        ...f
      };
      typeof (m == null ? void 0 : m.default) == "function" && (m.default = m.default()), m != null && m.isRequired && (m == null ? void 0 : m.default) === void 0 && delete m.default, e.push({
        type: o.name,
        name: u,
        attribute: m
      });
    });
  }), e;
}
function sn(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
function rt(...t) {
  return t.filter((e) => !!e).reduce((e, n) => {
    const i = { ...e };
    return Object.entries(n).forEach(([r, a]) => {
      if (!i[r]) {
        i[r] = a;
        return;
      }
      if (r === "class") {
        const s = a ? String(a).split(" ") : [], l = i[r] ? i[r].split(" ") : [], c = s.filter((u) => !l.includes(u));
        i[r] = [...l, ...c].join(" ");
      } else if (r === "style") {
        const s = a ? a.split(";").map((u) => u.trim()).filter(Boolean) : [], l = i[r] ? i[r].split(";").map((u) => u.trim()).filter(Boolean) : [], c = /* @__PURE__ */ new Map();
        l.forEach((u) => {
          const [f, m] = u.split(":").map((h) => h.trim());
          c.set(f, m);
        }), s.forEach((u) => {
          const [f, m] = u.split(":").map((h) => h.trim());
          c.set(f, m);
        }), i[r] = Array.from(c.entries()).map(([u, f]) => `${u}: ${f}`).join("; ");
      } else
        i[r] = a;
    }), i;
  }, {});
}
function Af(t, e) {
  return e.filter((n) => n.type === t.type.name).filter((n) => n.attribute.rendered).map((n) => n.attribute.renderHTML ? n.attribute.renderHTML(t.attrs) || {} : {
    [n.name]: t.attrs[n.name]
  }).reduce((n, i) => rt(n, i), {});
}
function XS(t) {
  return typeof t == "function";
}
function Xe(t, e = void 0, ...n) {
  return XS(t) ? e ? t.bind(e)(...n) : t(...n) : t;
}
function vAe(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function bAe(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function Qx(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (n) => {
      const i = t.getAttrs ? t.getAttrs(n) : t.attrs;
      if (i === !1)
        return !1;
      const r = e.reduce((a, o) => {
        const s = o.attribute.parseHTML ? o.attribute.parseHTML(n) : bAe(n.getAttribute(o.name));
        return s == null ? a : {
          ...a,
          [o.name]: s
        };
      }, {});
      return { ...i, ...r };
    }
  };
}
function Zx(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, n]) => e === "attrs" && vAe(n) ? !1 : n != null)
  );
}
function wAe(t, e) {
  var n;
  const i = GS(t), { nodeExtensions: r, markExtensions: a } = wh(t), o = (n = r.find((c) => Ne(c, "topNode"))) === null || n === void 0 ? void 0 : n.name, s = Object.fromEntries(r.map((c) => {
    const u = i.filter((v) => v.type === c.name), f = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, m = t.reduce((v, w) => {
      const x = Ne(w, "extendNodeSchema", f);
      return {
        ...v,
        ...x ? x(c) : {}
      };
    }, {}), h = Zx({
      ...m,
      content: Xe(Ne(c, "content", f)),
      marks: Xe(Ne(c, "marks", f)),
      group: Xe(Ne(c, "group", f)),
      inline: Xe(Ne(c, "inline", f)),
      atom: Xe(Ne(c, "atom", f)),
      selectable: Xe(Ne(c, "selectable", f)),
      draggable: Xe(Ne(c, "draggable", f)),
      code: Xe(Ne(c, "code", f)),
      whitespace: Xe(Ne(c, "whitespace", f)),
      linebreakReplacement: Xe(Ne(c, "linebreakReplacement", f)),
      defining: Xe(Ne(c, "defining", f)),
      isolating: Xe(Ne(c, "isolating", f)),
      attrs: Object.fromEntries(u.map((v) => {
        var w;
        return [v.name, { default: (w = v == null ? void 0 : v.attribute) === null || w === void 0 ? void 0 : w.default }];
      }))
    }), p = Xe(Ne(c, "parseHTML", f));
    p && (h.parseDOM = p.map((v) => Qx(v, u)));
    const g = Ne(c, "renderHTML", f);
    g && (h.toDOM = (v) => g({
      node: v,
      HTMLAttributes: Af(v, u)
    }));
    const y = Ne(c, "renderText", f);
    return y && (h.toText = y), [c.name, h];
  })), l = Object.fromEntries(a.map((c) => {
    const u = i.filter((y) => y.type === c.name), f = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      editor: e
    }, m = t.reduce((y, v) => {
      const w = Ne(v, "extendMarkSchema", f);
      return {
        ...y,
        ...w ? w(c) : {}
      };
    }, {}), h = Zx({
      ...m,
      inclusive: Xe(Ne(c, "inclusive", f)),
      excludes: Xe(Ne(c, "excludes", f)),
      group: Xe(Ne(c, "group", f)),
      spanning: Xe(Ne(c, "spanning", f)),
      code: Xe(Ne(c, "code", f)),
      attrs: Object.fromEntries(u.map((y) => {
        var v;
        return [y.name, { default: (v = y == null ? void 0 : y.attribute) === null || v === void 0 ? void 0 : v.default }];
      }))
    }), p = Xe(Ne(c, "parseHTML", f));
    p && (h.parseDOM = p.map((y) => Qx(y, u)));
    const g = Ne(c, "renderHTML", f);
    return g && (h.toDOM = (y) => g({
      mark: y,
      HTMLAttributes: Af(y, u)
    })), [c.name, h];
  }));
  return new W8({
    topNode: o,
    nodes: s,
    marks: l
  });
}
function X1(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function e3(t, e) {
  return Array.isArray(e) ? e.some((n) => (typeof n == "string" ? n : n.name) === t.name) : e;
}
function tb(t, e) {
  const n = Io.fromSchema(e).serializeFragment(t), r = document.implementation.createHTMLDocument().createElement("div");
  return r.appendChild(n), r.innerHTML;
}
const kAe = (t, e = 500) => {
  let n = "";
  const i = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, i - e), i, (r, a, o, s) => {
    var l, c;
    const u = ((c = (l = r.type.spec).toText) === null || c === void 0 ? void 0 : c.call(l, {
      node: r,
      pos: a,
      parent: o,
      index: s
    })) || r.textContent || "%leaf%";
    n += r.isAtom && !r.isText ? u : u.slice(0, Math.max(0, i - a));
  }), n;
};
function nb(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
class Pc {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const xAe = (t, e) => {
  if (nb(e))
    return e.exec(t);
  const n = e(t);
  if (!n)
    return null;
  const i = [n.text];
  return i.index = n.index, i.input = t, i.data = n.data, n.replaceWith && (n.text.includes(n.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), i.push(n.replaceWith)), i;
};
function tu(t) {
  var e;
  const { editor: n, from: i, to: r, text: a, rules: o, plugin: s } = t, { view: l } = n;
  if (l.composing)
    return !1;
  const c = l.state.doc.resolve(i);
  if (
    // check for code node
    c.parent.type.spec.code || !((e = c.nodeBefore || c.nodeAfter) === null || e === void 0) && e.marks.find((m) => m.type.spec.code)
  )
    return !1;
  let u = !1;
  const f = kAe(c) + a;
  return o.forEach((m) => {
    if (u)
      return;
    const h = xAe(f, m.find);
    if (!h)
      return;
    const p = l.state.tr, g = vh({
      state: l.state,
      transaction: p
    }), y = {
      from: i - (h[0].length - a.length),
      to: r
    }, { commands: v, chain: w, can: x } = new bh({
      editor: n,
      state: g
    });
    m.handler({
      state: g,
      range: y,
      match: h,
      commands: v,
      chain: w,
      can: x
    }) === null || !p.steps.length || (p.setMeta(s, {
      transform: p,
      from: i,
      to: r,
      text: a
    }), l.dispatch(p), u = !0);
  }), u;
}
function _Ae(t) {
  const { editor: e, rules: n } = t, i = new ft({
    state: {
      init() {
        return null;
      },
      apply(r, a, o) {
        const s = r.getMeta(i);
        if (s)
          return s;
        const l = r.getMeta("applyInputRules");
        return !!l && setTimeout(() => {
          let { text: u } = l;
          typeof u == "string" ? u = u : u = tb(ee.from(u), o.schema);
          const { from: f } = l, m = f + u.length;
          tu({
            editor: e,
            from: f,
            to: m,
            text: u,
            rules: n,
            plugin: i
          });
        }), r.selectionSet || r.docChanged ? null : a;
      }
    },
    props: {
      handleTextInput(r, a, o, s) {
        return tu({
          editor: e,
          from: a,
          to: o,
          text: s,
          rules: n,
          plugin: i
        });
      },
      handleDOMEvents: {
        compositionend: (r) => (setTimeout(() => {
          const { $cursor: a } = r.state.selection;
          a && tu({
            editor: e,
            from: a.pos,
            to: a.pos,
            text: "",
            rules: n,
            plugin: i
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(r, a) {
        if (a.key !== "Enter")
          return !1;
        const { $cursor: o } = r.state.selection;
        return o ? tu({
          editor: e,
          from: o.pos,
          to: o.pos,
          text: `
`,
          rules: n,
          plugin: i
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return i;
}
function MAe(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function nu(t) {
  return MAe(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function kh(t, e) {
  const n = { ...t };
  return nu(t) && nu(e) && Object.keys(e).forEach((i) => {
    nu(e[i]) && nu(t[i]) ? n[i] = kh(t[i], e[i]) : n[i] = e[i];
  }), n;
}
class Di {
  constructor(e = {}) {
    this.type = "mark", this.name = "mark", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Ne(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Ne(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new Di(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => kh(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new Di(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Xe(Ne(n, "addOptions", {
      name: n.name
    })), n.storage = Xe(Ne(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
  static handleExit({ editor: e, mark: n }) {
    const { tr: i } = e.state, r = e.state.selection.$from;
    if (r.pos === r.end()) {
      const o = r.marks();
      if (!!!o.find((c) => (c == null ? void 0 : c.type.name) === n.name))
        return !1;
      const l = o.find((c) => (c == null ? void 0 : c.type.name) === n.name);
      return l && i.removeStoredMark(l), i.insertText(" ", r.pos), e.view.dispatch(i), !0;
    }
    return !1;
  }
}
function CAe(t) {
  return typeof t == "number";
}
class PAe {
  constructor(e) {
    this.find = e.find, this.handler = e.handler;
  }
}
const SAe = (t, e, n) => {
  if (nb(e))
    return [...t.matchAll(e)];
  const i = e(t, n);
  return i ? i.map((r) => {
    const a = [r.text];
    return a.index = r.index, a.input = t, a.data = r.data, r.replaceWith && (r.text.includes(r.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), a.push(r.replaceWith)), a;
  }) : [];
};
function NAe(t) {
  const { editor: e, state: n, from: i, to: r, rule: a, pasteEvent: o, dropEvent: s } = t, { commands: l, chain: c, can: u } = new bh({
    editor: e,
    state: n
  }), f = [];
  return n.doc.nodesBetween(i, r, (h, p) => {
    if (!h.isTextblock || h.type.spec.code)
      return;
    const g = Math.max(i, p), y = Math.min(r, p + h.content.size), v = h.textBetween(g - p, y - p, void 0, "￼");
    SAe(v, a.find, o).forEach((x) => {
      if (x.index === void 0)
        return;
      const b = g + x.index + 1, M = b + x[0].length, _ = {
        from: n.tr.mapping.map(b),
        to: n.tr.mapping.map(M)
      }, N = a.handler({
        state: n,
        range: _,
        match: x,
        commands: l,
        chain: c,
        can: u,
        pasteEvent: o,
        dropEvent: s
      });
      f.push(N);
    });
  }), f.every((h) => h !== null);
}
let iu = null;
const $Ae = (t) => {
  var e;
  const n = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = n.clipboardData) === null || e === void 0 || e.setData("text/html", t), n;
};
function DAe(t) {
  const { editor: e, rules: n } = t;
  let i = null, r = !1, a = !1, o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, s;
  try {
    s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    s = null;
  }
  const l = ({ state: u, from: f, to: m, rule: h, pasteEvt: p }) => {
    const g = u.tr, y = vh({
      state: u,
      transaction: g
    });
    if (!(!NAe({
      editor: e,
      state: y,
      from: Math.max(f - 1, 0),
      to: m.b - 1,
      rule: h,
      pasteEvent: p,
      dropEvent: s
    }) || !g.steps.length)) {
      try {
        s = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        s = null;
      }
      return o = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, g;
    }
  };
  return n.map((u) => new ft({
    // we register a global drag handler to track the current drag source element
    view(f) {
      const m = (p) => {
        var g;
        i = !((g = f.dom.parentElement) === null || g === void 0) && g.contains(p.target) ? f.dom.parentElement : null, i && (iu = e);
      }, h = () => {
        iu && (iu = null);
      };
      return window.addEventListener("dragstart", m), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", m), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (f, m) => {
          if (a = i === f.dom.parentElement, s = m, !a) {
            const h = iu;
            h != null && h.isEditable && setTimeout(() => {
              const p = h.state.selection;
              p && h.commands.deleteRange({ from: p.from, to: p.to });
            }, 10);
          }
          return !1;
        },
        paste: (f, m) => {
          var h;
          const p = (h = m.clipboardData) === null || h === void 0 ? void 0 : h.getData("text/html");
          return o = m, r = !!(p != null && p.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (f, m, h) => {
      const p = f[0], g = p.getMeta("uiEvent") === "paste" && !r, y = p.getMeta("uiEvent") === "drop" && !a, v = p.getMeta("applyPasteRules"), w = !!v;
      if (!g && !y && !w)
        return;
      if (w) {
        let { text: M } = v;
        typeof M == "string" ? M = M : M = tb(ee.from(M), h.schema);
        const { from: _ } = v, N = _ + M.length, $ = $Ae(M);
        return l({
          rule: u,
          state: h,
          from: _,
          to: { b: N },
          pasteEvt: $
        });
      }
      const x = m.doc.content.findDiffStart(h.doc.content), b = m.doc.content.findDiffEnd(h.doc.content);
      if (!(!CAe(x) || !b || x === b.b))
        return l({
          rule: u,
          state: h,
          from: x,
          to: b,
          pasteEvt: o
        });
    }
  }));
}
function EAe(t) {
  const e = t.filter((n, i) => t.indexOf(n) !== i);
  return Array.from(new Set(e));
}
class ls {
  constructor(e, n) {
    this.splittableMarks = [], this.editor = n, this.extensions = ls.resolve(e), this.schema = wAe(this.extensions, n), this.setupExtensions();
  }
  /**
   * Returns a flattened and sorted extension list while
   * also checking for duplicated extensions and warns the user.
   * @param extensions An array of Tiptap extensions
   * @returns An flattened and sorted array of Tiptap extensions
   */
  static resolve(e) {
    const n = ls.sort(ls.flatten(e)), i = EAe(n.map((r) => r.name));
    return i.length && console.warn(`[tiptap warn]: Duplicate extension names found: [${i.map((r) => `'${r}'`).join(", ")}]. This can lead to issues.`), n;
  }
  /**
   * Create a flattened array of extensions by traversing the `addExtensions` field.
   * @param extensions An array of Tiptap extensions
   * @returns A flattened array of Tiptap extensions
   */
  static flatten(e) {
    return e.map((n) => {
      const i = {
        name: n.name,
        options: n.options,
        storage: n.storage
      }, r = Ne(n, "addExtensions", i);
      return r ? [n, ...this.flatten(r())] : n;
    }).flat(10);
  }
  /**
   * Sort extensions by priority.
   * @param extensions An array of Tiptap extensions
   * @returns A sorted array of Tiptap extensions by priority
   */
  static sort(e) {
    return e.sort((i, r) => {
      const a = Ne(i, "priority") || 100, o = Ne(r, "priority") || 100;
      return a > o ? -1 : a < o ? 1 : 0;
    });
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((e, n) => {
      const i = {
        name: n.name,
        options: n.options,
        storage: n.storage,
        editor: this.editor,
        type: X1(n.name, this.schema)
      }, r = Ne(n, "addCommands", i);
      return r ? {
        ...e,
        ...r()
      } : e;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: e } = this, n = ls.sort([...this.extensions].reverse()), i = [], r = [], a = n.map((o) => {
      const s = {
        name: o.name,
        options: o.options,
        storage: o.storage,
        editor: e,
        type: X1(o.name, this.schema)
      }, l = [], c = Ne(o, "addKeyboardShortcuts", s);
      let u = {};
      if (o.type === "mark" && Ne(o, "exitable", s) && (u.ArrowRight = () => Di.handleExit({ editor: e, mark: o })), c) {
        const g = Object.fromEntries(Object.entries(c()).map(([y, v]) => [y, () => v({ editor: e })]));
        u = { ...u, ...g };
      }
      const f = UWe(u);
      l.push(f);
      const m = Ne(o, "addInputRules", s);
      e3(o, e.options.enableInputRules) && m && i.push(...m());
      const h = Ne(o, "addPasteRules", s);
      e3(o, e.options.enablePasteRules) && h && r.push(...h());
      const p = Ne(o, "addProseMirrorPlugins", s);
      if (p) {
        const g = p();
        l.push(...g);
      }
      return l;
    }).flat();
    return [
      _Ae({
        editor: e,
        rules: i
      }),
      ...DAe({
        editor: e,
        rules: r
      }),
      ...a
    ];
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return GS(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: e } = this, { nodeExtensions: n } = wh(this.extensions);
    return Object.fromEntries(n.filter((i) => !!Ne(i, "addNodeView")).map((i) => {
      const r = this.attributes.filter((l) => l.type === i.name), a = {
        name: i.name,
        options: i.options,
        storage: i.storage,
        editor: e,
        type: sn(i.name, this.schema)
      }, o = Ne(i, "addNodeView", a);
      if (!o)
        return [];
      const s = (l, c, u, f, m) => {
        const h = Af(l, r);
        return o()({
          // pass-through
          node: l,
          view: c,
          getPos: u,
          decorations: f,
          innerDecorations: m,
          // tiptap-specific
          editor: e,
          extension: i,
          HTMLAttributes: h
        });
      };
      return [i.name, s];
    }));
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    this.extensions.forEach((e) => {
      var n;
      this.editor.extensionStorage[e.name] = e.storage;
      const i = {
        name: e.name,
        options: e.options,
        storage: e.storage,
        editor: this.editor,
        type: X1(e.name, this.schema)
      };
      e.type === "mark" && (!((n = Xe(Ne(e, "keepOnSplit", i))) !== null && n !== void 0) || n) && this.splittableMarks.push(e.name);
      const r = Ne(e, "onBeforeCreate", i), a = Ne(e, "onCreate", i), o = Ne(e, "onUpdate", i), s = Ne(e, "onSelectionUpdate", i), l = Ne(e, "onTransaction", i), c = Ne(e, "onFocus", i), u = Ne(e, "onBlur", i), f = Ne(e, "onDestroy", i);
      r && this.editor.on("beforeCreate", r), a && this.editor.on("create", a), o && this.editor.on("update", o), s && this.editor.on("selectionUpdate", s), l && this.editor.on("transaction", l), c && this.editor.on("focus", c), u && this.editor.on("blur", u), f && this.editor.on("destroy", f);
    });
  }
}
class gt {
  constructor(e = {}) {
    this.type = "extension", this.name = "extension", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Ne(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Ne(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new gt(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => kh(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new gt({ ...this.config, ...e });
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Xe(Ne(n, "addOptions", {
      name: n.name
    })), n.storage = Xe(Ne(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
}
function YS(t, e, n) {
  const { from: i, to: r } = e, { blockSeparator: a = `

`, textSerializers: o = {} } = n || {};
  let s = "";
  return t.nodesBetween(i, r, (l, c, u, f) => {
    var m;
    l.isBlock && c > i && (s += a);
    const h = o == null ? void 0 : o[l.type.name];
    if (h)
      return u && (s += h({
        node: l,
        pos: c,
        parent: u,
        index: f,
        range: e
      })), !1;
    l.isText && (s += (m = l == null ? void 0 : l.text) === null || m === void 0 ? void 0 : m.slice(Math.max(i, c) - c, r - c));
  }), s;
}
function KS(t) {
  return Object.fromEntries(Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, n]) => [e, n.spec.toText]));
}
const TAe = gt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: n } = t, { doc: i, selection: r } = e, { ranges: a } = r, o = Math.min(...a.map((u) => u.$from.pos)), s = Math.max(...a.map((u) => u.$to.pos)), l = KS(n);
            return YS(i, { from: o, to: s }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: l
            });
          }
        }
      })
    ];
  }
}), OAe = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var n;
  t.isDestroyed || (e.dom.blur(), (n = window == null ? void 0 : window.getSelection()) === null || n === void 0 || n.removeAllRanges());
}), !0), WAe = (t = !1) => ({ commands: e }) => e.setContent("", t), AAe = () => ({ state: t, tr: e, dispatch: n }) => {
  const { selection: i } = e, { ranges: r } = i;
  return n && r.forEach(({ $from: a, $to: o }) => {
    t.doc.nodesBetween(a.pos, o.pos, (s, l) => {
      if (s.type.isText)
        return;
      const { doc: c, mapping: u } = e, f = c.resolve(u.map(l)), m = c.resolve(u.map(l + s.nodeSize)), h = f.blockRange(m);
      if (!h)
        return;
      const p = il(h);
      if (s.type.isTextblock) {
        const { defaultType: g } = f.parent.contentMatchAt(f.index());
        e.setNodeMarkup(h.start, g);
      }
      (p || p === 0) && e.lift(h, p);
    });
  }), !0;
}, LAe = (t) => (e) => t(e), IAe = () => ({ state: t, dispatch: e }) => VS(t, e), RAe = (t, e) => ({ editor: n, tr: i }) => {
  const { state: r } = n, a = r.doc.slice(t.from, t.to);
  i.deleteRange(t.from, t.to);
  const o = i.mapping.map(e);
  return i.insert(o, a.content), i.setSelection(new Fe(i.doc.resolve(Math.max(o - 1, 0)))), !0;
}, jAe = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, i = n.$anchor.node();
  if (i.content.size > 0)
    return !1;
  const r = t.selection.$anchor;
  for (let a = r.depth; a > 0; a -= 1)
    if (r.node(a).type === i.type) {
      if (e) {
        const s = r.before(a), l = r.after(a);
        t.delete(s, l).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, FAe = (t) => ({ tr: e, state: n, dispatch: i }) => {
  const r = sn(t, n.schema), a = e.selection.$anchor;
  for (let o = a.depth; o > 0; o -= 1)
    if (a.node(o).type === r) {
      if (i) {
        const l = a.before(o), c = a.after(o);
        e.delete(l, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, zAe = (t) => ({ tr: e, dispatch: n }) => {
  const { from: i, to: r } = t;
  return n && e.delete(i, r), !0;
}, VAe = () => ({ state: t, dispatch: e }) => U0(t, e), HAe = () => ({ commands: t }) => t.keyboardShortcut("Enter"), BAe = () => ({ state: t, dispatch: e }) => nAe(t, e);
function Lf(t, e, n = { strict: !0 }) {
  const i = Object.keys(e);
  return i.length ? i.every((r) => n.strict ? e[r] === t[r] : nb(e[r]) ? e[r].test(t[r]) : e[r] === t[r]) : !0;
}
function US(t, e, n = {}) {
  return t.find((i) => i.type === e && Lf(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(n).map((r) => [r, i.attrs[r]])),
    n
  ));
}
function t3(t, e, n = {}) {
  return !!US(t, e, n);
}
function ib(t, e, n) {
  var i;
  if (!t || !e)
    return;
  let r = t.parent.childAfter(t.parentOffset);
  if ((!r.node || !r.node.marks.some((u) => u.type === e)) && (r = t.parent.childBefore(t.parentOffset)), !r.node || !r.node.marks.some((u) => u.type === e) || (n = n || ((i = r.node.marks[0]) === null || i === void 0 ? void 0 : i.attrs), !US([...r.node.marks], e, n)))
    return;
  let o = r.index, s = t.start() + r.offset, l = o + 1, c = s + r.node.nodeSize;
  for (; o > 0 && t3([...t.parent.child(o - 1).marks], e, n); )
    o -= 1, s -= t.parent.child(o).nodeSize;
  for (; l < t.parent.childCount && t3([...t.parent.child(l).marks], e, n); )
    c += t.parent.child(l).nodeSize, l += 1;
  return {
    from: s,
    to: c
  };
}
function Ba(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
const qAe = (t, e = {}) => ({ tr: n, state: i, dispatch: r }) => {
  const a = Ba(t, i.schema), { doc: o, selection: s } = n, { $from: l, from: c, to: u } = s;
  if (r) {
    const f = ib(l, a, e);
    if (f && f.from <= c && f.to >= u) {
      const m = Fe.create(o, f.from, f.to);
      n.setSelection(m);
    }
  }
  return !0;
}, GAe = (t) => (e) => {
  const n = typeof t == "function" ? t(e) : t;
  for (let i = 0; i < n.length; i += 1)
    if (n[i](e))
      return !0;
  return !1;
};
function xh(t) {
  return t instanceof Fe;
}
function Tr(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function JS(t, e = null) {
  if (!e)
    return null;
  const n = He.atStart(t), i = He.atEnd(t);
  if (e === "start" || e === !0)
    return n;
  if (e === "end")
    return i;
  const r = n.from, a = i.to;
  return e === "all" ? Fe.create(t, Tr(0, r, a), Tr(t.content.size, r, a)) : Fe.create(t, Tr(e, r, a), Tr(e, r, a));
}
function QS() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function _h() {
  return [
    "iPad Simulator",
    "iPhone Simulator",
    "iPod Simulator",
    "iPad",
    "iPhone",
    "iPod"
  ].includes(navigator.platform) || navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
const XAe = (t = null, e = {}) => ({ editor: n, view: i, tr: r, dispatch: a }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const o = () => {
    (_h() || QS()) && i.dom.focus(), requestAnimationFrame(() => {
      n.isDestroyed || (i.focus(), e != null && e.scrollIntoView && n.commands.scrollIntoView());
    });
  };
  if (i.hasFocus() && t === null || t === !1)
    return !0;
  if (a && t === null && !xh(n.state.selection))
    return o(), !0;
  const s = JS(r.doc, t) || n.state.selection, l = n.state.selection.eq(s);
  return a && (l || r.setSelection(s), l && r.storedMarks && r.setStoredMarks(r.storedMarks), o()), !0;
}, YAe = (t, e) => (n) => t.every((i, r) => e(i, { ...n, index: r })), KAe = (t, e) => ({ tr: n, commands: i }) => i.insertContentAt({ from: n.selection.from, to: n.selection.to }, t, e), ZS = (t) => {
  const e = t.childNodes;
  for (let n = e.length - 1; n >= 0; n -= 1) {
    const i = e[n];
    i.nodeType === 3 && i.nodeValue && /^(\n\s\s|\n)$/.test(i.nodeValue) ? t.removeChild(i) : i.nodeType === 1 && ZS(i);
  }
  return t;
};
function ru(t) {
  const e = `<body>${t}</body>`, n = new window.DOMParser().parseFromString(e, "text/html").body;
  return ZS(n);
}
function xd(t, e, n) {
  if (t instanceof wa || t instanceof ee)
    return t;
  n = {
    slice: !0,
    parseOptions: {},
    ...n
  };
  const i = typeof t == "object" && t !== null, r = typeof t == "string";
  if (i)
    try {
      if (Array.isArray(t) && t.length > 0)
        return ee.fromArray(t.map((s) => e.nodeFromJSON(s)));
      const o = e.nodeFromJSON(t);
      return n.errorOnInvalidContent && o.check(), o;
    } catch (a) {
      if (n.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: a });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", a), xd("", e, n);
    }
  if (r) {
    if (n.errorOnInvalidContent) {
      let o = !1, s = "";
      const l = new W8({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (o = !0, s = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (n.slice ? Bl.fromSchema(l).parseSlice(ru(t), n.parseOptions) : Bl.fromSchema(l).parse(ru(t), n.parseOptions), n.errorOnInvalidContent && o)
        throw new Error("[tiptap error]: Invalid HTML content", { cause: new Error(`Invalid element found: ${s}`) });
    }
    const a = Bl.fromSchema(e);
    return n.slice ? a.parseSlice(ru(t), n.parseOptions).content : a.parse(ru(t), n.parseOptions);
  }
  return xd("", e, n);
}
function UAe(t, e, n) {
  const i = t.steps.length - 1;
  if (i < e)
    return;
  const r = t.steps[i];
  if (!(r instanceof nn || r instanceof rn))
    return;
  const a = t.mapping.maps[i];
  let o = 0;
  a.forEach((s, l, c, u) => {
    o === 0 && (o = u);
  }), t.setSelection(He.near(t.doc.resolve(o), n));
}
const JAe = (t) => !("type" in t), QAe = (t, e, n) => ({ tr: i, dispatch: r, editor: a }) => {
  var o;
  if (r) {
    n = {
      parseOptions: a.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...n
    };
    let s;
    const l = (y) => {
      a.emit("contentError", {
        editor: a,
        error: y,
        disableCollaboration: () => {
          a.storage.collaboration && (a.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...n.parseOptions
    };
    if (!n.errorOnInvalidContent && !a.options.enableContentCheck && a.options.emitContentError)
      try {
        xd(e, a.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (y) {
        l(y);
      }
    try {
      s = xd(e, a.schema, {
        parseOptions: c,
        errorOnInvalidContent: (o = n.errorOnInvalidContent) !== null && o !== void 0 ? o : a.options.enableContentCheck
      });
    } catch (y) {
      return l(y), !1;
    }
    let { from: u, to: f } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, m = !0, h = !0;
    if ((JAe(s) ? s : [s]).forEach((y) => {
      y.check(), m = m ? y.isText && y.marks.length === 0 : !1, h = h ? y.isBlock : !1;
    }), u === f && h) {
      const { parent: y } = i.doc.resolve(u);
      y.isTextblock && !y.type.spec.code && !y.childCount && (u -= 1, f += 1);
    }
    let g;
    if (m) {
      if (Array.isArray(e))
        g = e.map((y) => y.text || "").join("");
      else if (e instanceof ee) {
        let y = "";
        e.forEach((v) => {
          v.text && (y += v.text);
        }), g = y;
      } else typeof e == "object" && e && e.text ? g = e.text : g = e;
      i.insertText(g, u, f);
    } else
      g = s, i.replaceWith(u, f, g);
    n.updateSelection && UAe(i, i.steps.length - 1, -1), n.applyInputRules && i.setMeta("applyInputRules", { from: u, text: g }), n.applyPasteRules && i.setMeta("applyPasteRules", { from: u, text: g });
  }
  return !0;
}, ZAe = () => ({ state: t, dispatch: e }) => ZWe(t, e), eLe = () => ({ state: t, dispatch: e }) => eAe(t, e), tLe = () => ({ state: t, dispatch: e }) => AS(t, e), nLe = () => ({ state: t, dispatch: e }) => jS(t, e), iLe = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const i = fh(t.doc, t.selection.$from.pos, -1);
    return i == null ? !1 : (n.join(i, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, rLe = () => ({ state: t, dispatch: e, tr: n }) => {
  try {
    const i = fh(t.doc, t.selection.$from.pos, 1);
    return i == null ? !1 : (n.join(i, 2), e && e(n), !0);
  } catch {
    return !1;
  }
}, aLe = () => ({ state: t, dispatch: e }) => JWe(t, e), oLe = () => ({ state: t, dispatch: e }) => QWe(t, e);
function e7() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function sLe(t) {
  const e = t.split(/-(?!$)/);
  let n = e[e.length - 1];
  n === "Space" && (n = " ");
  let i, r, a, o;
  for (let s = 0; s < e.length - 1; s += 1) {
    const l = e[s];
    if (/^(cmd|meta|m)$/i.test(l))
      o = !0;
    else if (/^a(lt)?$/i.test(l))
      i = !0;
    else if (/^(c|ctrl|control)$/i.test(l))
      r = !0;
    else if (/^s(hift)?$/i.test(l))
      a = !0;
    else if (/^mod$/i.test(l))
      _h() || e7() ? o = !0 : r = !0;
    else
      throw new Error(`Unrecognized modifier name: ${l}`);
  }
  return i && (n = `Alt-${n}`), r && (n = `Ctrl-${n}`), o && (n = `Meta-${n}`), a && (n = `Shift-${n}`), n;
}
const lLe = (t) => ({ editor: e, view: n, tr: i, dispatch: r }) => {
  const a = sLe(t).split(/-(?!$)/), o = a.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), s = new KeyboardEvent("keydown", {
    key: o === "Space" ? " " : o,
    altKey: a.includes("Alt"),
    ctrlKey: a.includes("Ctrl"),
    metaKey: a.includes("Meta"),
    shiftKey: a.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), l = e.captureTransaction(() => {
    n.someProp("handleKeyDown", (c) => c(n, s));
  });
  return l == null || l.steps.forEach((c) => {
    const u = c.map(i.mapping);
    u && r && i.maybeStep(u);
  }), !0;
};
function _d(t, e, n = {}) {
  const { from: i, to: r, empty: a } = t.selection, o = e ? sn(e, t.schema) : null, s = [];
  t.doc.nodesBetween(i, r, (f, m) => {
    if (f.isText)
      return;
    const h = Math.max(i, m), p = Math.min(r, m + f.nodeSize);
    s.push({
      node: f,
      from: h,
      to: p
    });
  });
  const l = r - i, c = s.filter((f) => o ? o.name === f.node.type.name : !0).filter((f) => Lf(f.node.attrs, n, { strict: !1 }));
  return a ? !!c.length : c.reduce((f, m) => f + m.to - m.from, 0) >= l;
}
const dLe = (t, e = {}) => ({ state: n, dispatch: i }) => {
  const r = sn(t, n.schema);
  return _d(n, r, e) ? tAe(n, i) : !1;
}, cLe = () => ({ state: t, dispatch: e }) => HS(t, e), uLe = (t) => ({ state: e, dispatch: n }) => {
  const i = sn(t, e.schema);
  return mAe(i)(e, n);
}, fLe = () => ({ state: t, dispatch: e }) => zS(t, e);
function Mh(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function n3(t, e) {
  const n = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((i, r) => (n.includes(r) || (i[r] = t[r]), i), {});
}
const mLe = (t, e) => ({ tr: n, state: i, dispatch: r }) => {
  let a = null, o = null;
  const s = Mh(typeof t == "string" ? t : t.name, i.schema);
  return s ? (s === "node" && (a = sn(t, i.schema)), s === "mark" && (o = Ba(t, i.schema)), r && n.selection.ranges.forEach((l) => {
    i.doc.nodesBetween(l.$from.pos, l.$to.pos, (c, u) => {
      a && a === c.type && n.setNodeMarkup(u, void 0, n3(c.attrs, e)), o && c.marks.length && c.marks.forEach((f) => {
        o === f.type && n.addMark(u, u + c.nodeSize, o.create(n3(f.attrs, e)));
      });
    });
  }), !0) : !1;
}, hLe = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), pLe = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const n = new Un(t.doc);
    t.setSelection(n);
  }
  return !0;
}, gLe = () => ({ state: t, dispatch: e }) => IS(t, e), yLe = () => ({ state: t, dispatch: e }) => FS(t, e), vLe = () => ({ state: t, dispatch: e }) => aAe(t, e), bLe = () => ({ state: t, dispatch: e }) => lAe(t, e), wLe = () => ({ state: t, dispatch: e }) => sAe(t, e);
function Rg(t, e, n = {}, i = {}) {
  return xd(t, e, {
    slice: !1,
    parseOptions: n,
    errorOnInvalidContent: i.errorOnInvalidContent
  });
}
const kLe = (t, e = !1, n = {}, i = {}) => ({ editor: r, tr: a, dispatch: o, commands: s }) => {
  var l, c;
  const { doc: u } = a;
  if (n.preserveWhitespace !== "full") {
    const f = Rg(t, r.schema, n, {
      errorOnInvalidContent: (l = i.errorOnInvalidContent) !== null && l !== void 0 ? l : r.options.enableContentCheck
    });
    return o && a.replaceWith(0, u.content.size, f).setMeta("preventUpdate", !e), !0;
  }
  return o && a.setMeta("preventUpdate", !e), s.insertContentAt({ from: 0, to: u.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: (c = i.errorOnInvalidContent) !== null && c !== void 0 ? c : r.options.enableContentCheck
  });
};
function t7(t, e) {
  const n = Ba(e, t.schema), { from: i, to: r, empty: a } = t.selection, o = [];
  a ? (t.storedMarks && o.push(...t.storedMarks), o.push(...t.selection.$head.marks())) : t.doc.nodesBetween(i, r, (l) => {
    o.push(...l.marks);
  });
  const s = o.find((l) => l.type.name === n.name);
  return s ? { ...s.attrs } : {};
}
function xLe(t, e) {
  const n = new U8(t);
  return e.forEach((i) => {
    i.steps.forEach((r) => {
      n.step(r);
    });
  }), n;
}
function rb(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: n } = t.edge(e);
    if (n.isTextblock && !n.hasRequiredAttrs())
      return n;
  }
  return null;
}
function Tu(t, e) {
  const n = [];
  return t.descendants((i, r) => {
    e(i) && n.push({
      node: i,
      pos: r
    });
  }), n;
}
function _Le(t, e, n) {
  const i = [];
  return t.nodesBetween(e.from, e.to, (r, a) => {
    n(r) && i.push({
      node: r,
      pos: a
    });
  }), i;
}
function MLe(t, e) {
  for (let n = t.depth; n > 0; n -= 1) {
    const i = t.node(n);
    if (e(i))
      return {
        pos: n > 0 ? t.before(n) : 0,
        start: t.start(n),
        depth: n,
        node: i
      };
  }
}
function rl(t) {
  return (e) => MLe(e.$from, t);
}
function CLe(t, e) {
  const n = {
    from: 0,
    to: t.content.size
  };
  return YS(t, n, e);
}
function PLe(t, e) {
  const n = sn(e, t.schema), { from: i, to: r } = t.selection, a = [];
  t.doc.nodesBetween(i, r, (s) => {
    a.push(s);
  });
  const o = a.reverse().find((s) => s.type.name === n.name);
  return o ? { ...o.attrs } : {};
}
function n7(t, e) {
  const n = Mh(typeof e == "string" ? e : e.name, t.schema);
  return n === "node" ? PLe(t, e) : n === "mark" ? t7(t, e) : {};
}
function SLe(t, e = JSON.stringify) {
  const n = {};
  return t.filter((i) => {
    const r = e(i);
    return Object.prototype.hasOwnProperty.call(n, r) ? !1 : n[r] = !0;
  });
}
function NLe(t) {
  const e = SLe(t);
  return e.length === 1 ? e : e.filter((n, i) => !e.filter((a, o) => o !== i).some((a) => n.oldRange.from >= a.oldRange.from && n.oldRange.to <= a.oldRange.to && n.newRange.from >= a.newRange.from && n.newRange.to <= a.newRange.to));
}
function $Le(t) {
  const { mapping: e, steps: n } = t, i = [];
  return e.maps.forEach((r, a) => {
    const o = [];
    if (r.ranges.length)
      r.forEach((s, l) => {
        o.push({ from: s, to: l });
      });
    else {
      const { from: s, to: l } = n[a];
      if (s === void 0 || l === void 0)
        return;
      o.push({ from: s, to: l });
    }
    o.forEach(({ from: s, to: l }) => {
      const c = e.slice(a).map(s, -1), u = e.slice(a).map(l), f = e.invert().map(c, -1), m = e.invert().map(u);
      i.push({
        oldRange: {
          from: f,
          to: m
        },
        newRange: {
          from: c,
          to: u
        }
      });
    });
  }), NLe(i);
}
function ab(t, e, n) {
  const i = [];
  return t === e ? n.resolve(t).marks().forEach((r) => {
    const a = n.resolve(t), o = ib(a, r.type);
    o && i.push({
      mark: r,
      ...o
    });
  }) : n.nodesBetween(t, e, (r, a) => {
    !r || (r == null ? void 0 : r.nodeSize) === void 0 || i.push(...r.marks.map((o) => ({
      from: a,
      to: a + r.nodeSize,
      mark: o
    })));
  }), i;
}
function Ou(t, e, n) {
  return Object.fromEntries(Object.entries(n).filter(([i]) => {
    const r = t.find((a) => a.type === e && a.name === i);
    return r ? r.attribute.keepOnSplit : !1;
  }));
}
function jg(t, e, n = {}) {
  const { empty: i, ranges: r } = t.selection, a = e ? Ba(e, t.schema) : null;
  if (i)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((f) => a ? a.name === f.type.name : !0).find((f) => Lf(f.attrs, n, { strict: !1 }));
  let o = 0;
  const s = [];
  if (r.forEach(({ $from: f, $to: m }) => {
    const h = f.pos, p = m.pos;
    t.doc.nodesBetween(h, p, (g, y) => {
      if (!g.isText && !g.marks.length)
        return;
      const v = Math.max(h, y), w = Math.min(p, y + g.nodeSize), x = w - v;
      o += x, s.push(...g.marks.map((b) => ({
        mark: b,
        from: v,
        to: w
      })));
    });
  }), o === 0)
    return !1;
  const l = s.filter((f) => a ? a.name === f.mark.type.name : !0).filter((f) => Lf(f.mark.attrs, n, { strict: !1 })).reduce((f, m) => f + m.to - m.from, 0), c = s.filter((f) => a ? f.mark.type !== a && f.mark.type.excludes(a) : !0).reduce((f, m) => f + m.to - m.from, 0);
  return (l > 0 ? l + c : l) >= o;
}
function i7(t, e, n = {}) {
  if (!e)
    return _d(t, null, n) || jg(t, null, n);
  const i = Mh(e, t.schema);
  return i === "node" ? _d(t, e, n) : i === "mark" ? jg(t, e, n) : !1;
}
function i3(t, e) {
  const { nodeExtensions: n } = wh(e), i = n.find((o) => o.name === t);
  if (!i)
    return !1;
  const r = {
    name: i.name,
    options: i.options,
    storage: i.storage
  }, a = Xe(Ne(i, "group", r));
  return typeof a != "string" ? !1 : a.split(" ").includes("list");
}
function Ch(t, { checkChildren: e = !0, ignoreWhitespace: n = !1 } = {}) {
  var i;
  if (n) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((i = t.text) !== null && i !== void 0 ? i : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let r = !0;
    return t.content.forEach((a) => {
      r !== !1 && (Ch(a, { ignoreWhitespace: n, checkChildren: e }) || (r = !1));
    }), r;
  }
  return !1;
}
function r7(t) {
  return t instanceof Ae;
}
function DLe(t, e, n) {
  const r = t.state.doc.content.size, a = Tr(e, 0, r), o = Tr(n, 0, r), s = t.coordsAtPos(a), l = t.coordsAtPos(o, -1), c = Math.min(s.top, l.top), u = Math.max(s.bottom, l.bottom), f = Math.min(s.left, l.left), m = Math.max(s.right, l.right), h = m - f, p = u - c, v = {
    top: c,
    bottom: u,
    left: f,
    right: m,
    width: h,
    height: p,
    x: f,
    y: c
  };
  return {
    ...v,
    toJSON: () => v
  };
}
function ELe(t, e, n) {
  var i;
  const { selection: r } = e;
  let a = null;
  if (xh(r) && (a = r.$cursor), a) {
    const s = (i = t.storedMarks) !== null && i !== void 0 ? i : a.marks();
    return !!n.isInSet(s) || !s.some((l) => l.type.excludes(n));
  }
  const { ranges: o } = r;
  return o.some(({ $from: s, $to: l }) => {
    let c = s.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(n) : !1;
    return t.doc.nodesBetween(s.pos, l.pos, (u, f, m) => {
      if (c)
        return !1;
      if (u.isInline) {
        const h = !m || m.type.allowsMarkType(n), p = !!n.isInSet(u.marks) || !u.marks.some((g) => g.type.excludes(n));
        c = h && p;
      }
      return !c;
    }), c;
  });
}
const TLe = (t, e = {}) => ({ tr: n, state: i, dispatch: r }) => {
  const { selection: a } = n, { empty: o, ranges: s } = a, l = Ba(t, i.schema);
  if (r)
    if (o) {
      const c = t7(i, l);
      n.addStoredMark(l.create({
        ...c,
        ...e
      }));
    } else
      s.forEach((c) => {
        const u = c.$from.pos, f = c.$to.pos;
        i.doc.nodesBetween(u, f, (m, h) => {
          const p = Math.max(h, u), g = Math.min(h + m.nodeSize, f);
          m.marks.find((v) => v.type === l) ? m.marks.forEach((v) => {
            l === v.type && n.addMark(p, g, l.create({
              ...v.attrs,
              ...e
            }));
          }) : n.addMark(p, g, l.create(e));
        });
      });
  return ELe(i, n, l);
}, OLe = (t, e) => ({ tr: n }) => (n.setMeta(t, e), !0), WLe = (t, e = {}) => ({ state: n, dispatch: i, chain: r }) => {
  const a = sn(t, n.schema);
  let o;
  return n.selection.$anchor.sameParent(n.selection.$head) && (o = n.selection.$anchor.parent.attrs), a.isTextblock ? r().command(({ commands: s }) => Jx(a, { ...o, ...e })(n) ? !0 : s.clearNodes()).command(({ state: s }) => Jx(a, { ...o, ...e })(s, i)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, ALe = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: i } = e, r = Tr(t, 0, i.content.size), a = Ae.create(i, r);
    e.setSelection(a);
  }
  return !0;
}, LLe = (t) => ({ tr: e, dispatch: n }) => {
  if (n) {
    const { doc: i } = e, { from: r, to: a } = typeof t == "number" ? { from: t, to: t } : t, o = Fe.atStart(i).from, s = Fe.atEnd(i).to, l = Tr(r, o, s), c = Tr(a, o, s), u = Fe.create(i, l, c);
    e.setSelection(u);
  }
  return !0;
}, ILe = (t) => ({ state: e, dispatch: n }) => {
  const i = sn(t, e.schema);
  return gAe(i)(e, n);
};
function r3(t, e) {
  const n = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (n) {
    const i = n.filter((r) => e == null ? void 0 : e.includes(r.type.name));
    t.tr.ensureMarks(i);
  }
}
const RLe = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: n, dispatch: i, editor: r }) => {
  const { selection: a, doc: o } = e, { $from: s, $to: l } = a, c = r.extensionManager.attributes, u = Ou(c, s.node().type.name, s.node().attrs);
  if (a instanceof Ae && a.node.isBlock)
    return !s.parentOffset || !Or(o, s.pos) ? !1 : (i && (t && r3(n, r.extensionManager.splittableMarks), e.split(s.pos).scrollIntoView()), !0);
  if (!s.parent.isBlock)
    return !1;
  const f = l.parentOffset === l.parent.content.size, m = s.depth === 0 ? void 0 : rb(s.node(-1).contentMatchAt(s.indexAfter(-1)));
  let h = f && m ? [
    {
      type: m,
      attrs: u
    }
  ] : void 0, p = Or(e.doc, e.mapping.map(s.pos), 1, h);
  if (!h && !p && Or(e.doc, e.mapping.map(s.pos), 1, m ? [{ type: m }] : void 0) && (p = !0, h = m ? [
    {
      type: m,
      attrs: u
    }
  ] : void 0), i) {
    if (p && (a instanceof Fe && e.deleteSelection(), e.split(e.mapping.map(s.pos), 1, h), m && !f && !s.parentOffset && s.parent.type !== m)) {
      const g = e.mapping.map(s.before()), y = e.doc.resolve(g);
      s.node(-1).canReplaceWith(y.index(), y.index() + 1, m) && e.setNodeMarkup(e.mapping.map(s.before()), m);
    }
    t && r3(n, r.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return p;
}, jLe = (t, e = {}) => ({ tr: n, state: i, dispatch: r, editor: a }) => {
  var o;
  const s = sn(t, i.schema), { $from: l, $to: c } = i.selection, u = i.selection.node;
  if (u && u.isBlock || l.depth < 2 || !l.sameParent(c))
    return !1;
  const f = l.node(-1);
  if (f.type !== s)
    return !1;
  const m = a.extensionManager.attributes;
  if (l.parent.content.size === 0 && l.node(-1).childCount === l.indexAfter(-1)) {
    if (l.depth === 2 || l.node(-3).type !== s || l.index(-2) !== l.node(-2).childCount - 1)
      return !1;
    if (r) {
      let v = ee.empty;
      const w = l.index(-1) ? 1 : l.index(-2) ? 2 : 3;
      for (let $ = l.depth - w; $ >= l.depth - 3; $ -= 1)
        v = ee.from(l.node($).copy(v));
      const x = l.indexAfter(-1) < l.node(-2).childCount ? 1 : l.indexAfter(-2) < l.node(-3).childCount ? 2 : 3, b = {
        ...Ou(m, l.node().type.name, l.node().attrs),
        ...e
      }, M = ((o = s.contentMatch.defaultType) === null || o === void 0 ? void 0 : o.createAndFill(b)) || void 0;
      v = v.append(ee.from(s.createAndFill(null, M) || void 0));
      const _ = l.before(l.depth - (w - 1));
      n.replace(_, l.after(-x), new ye(v, 4 - w, 0));
      let N = -1;
      n.doc.nodesBetween(_, n.doc.content.size, ($, D) => {
        if (N > -1)
          return !1;
        $.isTextblock && $.content.size === 0 && (N = D + 1);
      }), N > -1 && n.setSelection(Fe.near(n.doc.resolve(N))), n.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === l.end() ? f.contentMatchAt(0).defaultType : null, p = {
    ...Ou(m, f.type.name, f.attrs),
    ...e
  }, g = {
    ...Ou(m, l.node().type.name, l.node().attrs),
    ...e
  };
  n.delete(l.pos, c.pos);
  const y = h ? [
    { type: s, attrs: p },
    { type: h, attrs: g }
  ] : [{ type: s, attrs: p }];
  if (!Or(n.doc, l.pos, 2))
    return !1;
  if (r) {
    const { selection: v, storedMarks: w } = i, { splittableMarks: x } = a.extensionManager, b = w || v.$to.parentOffset && v.$from.marks();
    if (n.split(l.pos, 2, y).scrollIntoView(), !b || !r)
      return !0;
    const M = b.filter((_) => x.includes(_.type.name));
    n.ensureMarks(M);
  }
  return !0;
}, Y1 = (t, e) => {
  const n = rl((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const i = t.doc.resolve(Math.max(0, n.pos - 1)).before(n.depth);
  if (i === void 0)
    return !0;
  const r = t.doc.nodeAt(i);
  return n.node.type === (r == null ? void 0 : r.type) && Va(t.doc, n.pos) && t.join(n.pos), !0;
}, K1 = (t, e) => {
  const n = rl((o) => o.type === e)(t.selection);
  if (!n)
    return !0;
  const i = t.doc.resolve(n.start).after(n.depth);
  if (i === void 0)
    return !0;
  const r = t.doc.nodeAt(i);
  return n.node.type === (r == null ? void 0 : r.type) && Va(t.doc, i) && t.join(i), !0;
}, FLe = (t, e, n, i = {}) => ({ editor: r, tr: a, state: o, dispatch: s, chain: l, commands: c, can: u }) => {
  const { extensions: f, splittableMarks: m } = r.extensionManager, h = sn(t, o.schema), p = sn(e, o.schema), { selection: g, storedMarks: y } = o, { $from: v, $to: w } = g, x = v.blockRange(w), b = y || g.$to.parentOffset && g.$from.marks();
  if (!x)
    return !1;
  const M = rl((_) => i3(_.type.name, f))(g);
  if (x.depth >= 1 && M && x.depth - M.depth <= 1) {
    if (M.node.type === h)
      return c.liftListItem(p);
    if (i3(M.node.type.name, f) && h.validContent(M.node.content) && s)
      return l().command(() => (a.setNodeMarkup(M.pos, h), !0)).command(() => Y1(a, h)).command(() => K1(a, h)).run();
  }
  return !n || !b || !s ? l().command(() => u().wrapInList(h, i) ? !0 : c.clearNodes()).wrapInList(h, i).command(() => Y1(a, h)).command(() => K1(a, h)).run() : l().command(() => {
    const _ = u().wrapInList(h, i), N = b.filter(($) => m.includes($.type.name));
    return a.ensureMarks(N), _ ? !0 : c.clearNodes();
  }).wrapInList(h, i).command(() => Y1(a, h)).command(() => K1(a, h)).run();
}, zLe = (t, e = {}, n = {}) => ({ state: i, commands: r }) => {
  const { extendEmptyMarkRange: a = !1 } = n, o = Ba(t, i.schema);
  return jg(i, o, e) ? r.unsetMark(o, { extendEmptyMarkRange: a }) : r.setMark(o, e);
}, VLe = (t, e, n = {}) => ({ state: i, commands: r }) => {
  const a = sn(t, i.schema), o = sn(e, i.schema), s = _d(i, a, n);
  let l;
  return i.selection.$anchor.sameParent(i.selection.$head) && (l = i.selection.$anchor.parent.attrs), s ? r.setNode(o, l) : r.setNode(a, { ...l, ...n });
}, HLe = (t, e = {}) => ({ state: n, commands: i }) => {
  const r = sn(t, n.schema);
  return _d(n, r, e) ? i.lift(r) : i.wrapIn(r, e);
}, BLe = () => ({ state: t, dispatch: e }) => {
  const n = t.plugins;
  for (let i = 0; i < n.length; i += 1) {
    const r = n[i];
    let a;
    if (r.spec.isInputRules && (a = r.getState(t))) {
      if (e) {
        const o = t.tr, s = a.transform;
        for (let l = s.steps.length - 1; l >= 0; l -= 1)
          o.step(s.steps[l].invert(s.docs[l]));
        if (a.text) {
          const l = o.doc.resolve(a.from).marks();
          o.replaceWith(a.from, a.to, t.schema.text(a.text, l));
        } else
          o.delete(a.from, a.to);
      }
      return !0;
    }
  }
  return !1;
}, qLe = () => ({ tr: t, dispatch: e }) => {
  const { selection: n } = t, { empty: i, ranges: r } = n;
  return i || e && r.forEach((a) => {
    t.removeMark(a.$from.pos, a.$to.pos);
  }), !0;
}, GLe = (t, e = {}) => ({ tr: n, state: i, dispatch: r }) => {
  var a;
  const { extendEmptyMarkRange: o = !1 } = e, { selection: s } = n, l = Ba(t, i.schema), { $from: c, empty: u, ranges: f } = s;
  if (!r)
    return !0;
  if (u && o) {
    let { from: m, to: h } = s;
    const p = (a = c.marks().find((y) => y.type === l)) === null || a === void 0 ? void 0 : a.attrs, g = ib(c, l, p);
    g && (m = g.from, h = g.to), n.removeMark(m, h, l);
  } else
    f.forEach((m) => {
      n.removeMark(m.$from.pos, m.$to.pos, l);
    });
  return n.removeStoredMark(l), !0;
}, XLe = (t, e = {}) => ({ tr: n, state: i, dispatch: r }) => {
  let a = null, o = null;
  const s = Mh(typeof t == "string" ? t : t.name, i.schema);
  return s ? (s === "node" && (a = sn(t, i.schema)), s === "mark" && (o = Ba(t, i.schema)), r && n.selection.ranges.forEach((l) => {
    const c = l.$from.pos, u = l.$to.pos;
    let f, m, h, p;
    n.selection.empty ? i.doc.nodesBetween(c, u, (g, y) => {
      a && a === g.type && (h = Math.max(y, c), p = Math.min(y + g.nodeSize, u), f = y, m = g);
    }) : i.doc.nodesBetween(c, u, (g, y) => {
      y < c && a && a === g.type && (h = Math.max(y, c), p = Math.min(y + g.nodeSize, u), f = y, m = g), y >= c && y <= u && (a && a === g.type && n.setNodeMarkup(y, void 0, {
        ...g.attrs,
        ...e
      }), o && g.marks.length && g.marks.forEach((v) => {
        if (o === v.type) {
          const w = Math.max(y, c), x = Math.min(y + g.nodeSize, u);
          n.addMark(w, x, o.create({
            ...v.attrs,
            ...e
          }));
        }
      }));
    }), m && (f !== void 0 && n.setNodeMarkup(f, void 0, {
      ...m.attrs,
      ...e
    }), o && m.marks.length && m.marks.forEach((g) => {
      o === g.type && n.addMark(h, p, o.create({
        ...g.attrs,
        ...e
      }));
    }));
  }), !0) : !1;
}, YLe = (t, e = {}) => ({ state: n, dispatch: i }) => {
  const r = sn(t, n.schema);
  return dAe(r, e)(n, i);
}, KLe = (t, e = {}) => ({ state: n, dispatch: i }) => {
  const r = sn(t, n.schema);
  return cAe(r, e)(n, i);
};
var ULe = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blur: OAe,
  clearContent: WAe,
  clearNodes: AAe,
  command: LAe,
  createParagraphNear: IAe,
  cut: RAe,
  deleteCurrentNode: jAe,
  deleteNode: FAe,
  deleteRange: zAe,
  deleteSelection: VAe,
  enter: HAe,
  exitCode: BAe,
  extendMarkRange: qAe,
  first: GAe,
  focus: XAe,
  forEach: YAe,
  insertContent: KAe,
  insertContentAt: QAe,
  joinBackward: tLe,
  joinDown: eLe,
  joinForward: nLe,
  joinItemBackward: iLe,
  joinItemForward: rLe,
  joinTextblockBackward: aLe,
  joinTextblockForward: oLe,
  joinUp: ZAe,
  keyboardShortcut: lLe,
  lift: dLe,
  liftEmptyBlock: cLe,
  liftListItem: uLe,
  newlineInCode: fLe,
  resetAttributes: mLe,
  scrollIntoView: hLe,
  selectAll: pLe,
  selectNodeBackward: gLe,
  selectNodeForward: yLe,
  selectParentNode: vLe,
  selectTextblockEnd: bLe,
  selectTextblockStart: wLe,
  setContent: kLe,
  setMark: TLe,
  setMeta: OLe,
  setNode: WLe,
  setNodeSelection: ALe,
  setTextSelection: LLe,
  sinkListItem: ILe,
  splitBlock: RLe,
  splitListItem: jLe,
  toggleList: FLe,
  toggleMark: zLe,
  toggleNode: VLe,
  toggleWrap: HLe,
  undoInputRule: BLe,
  unsetAllMarks: qLe,
  unsetMark: GLe,
  updateAttributes: XLe,
  wrapIn: YLe,
  wrapInList: KLe
});
const JLe = gt.create({
  name: "commands",
  addCommands() {
    return {
      ...ULe
    };
  }
}), QLe = gt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("tiptapDrop"),
        props: {
          handleDrop: (t, e, n, i) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: n,
              moved: i
            });
          }
        }
      })
    ];
  }
}), ZLe = gt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), eIe = new yt("focusEvents"), tIe = gt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new ft({
        key: eIe,
        props: {
          handleDOMEvents: {
            focus: (e, n) => {
              t.isFocused = !0;
              const i = t.state.tr.setMeta("focus", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            },
            blur: (e, n) => {
              t.isFocused = !1;
              const i = t.state.tr.setMeta("blur", { event: n }).setMeta("addToHistory", !1);
              return e.dispatch(i), !1;
            }
          }
        }
      })
    ];
  }
}), nIe = gt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: o }) => [
      () => o.undoInputRule(),
      // maybe convert first text block node to default node
      () => o.command(({ tr: s }) => {
        const { selection: l, doc: c } = s, { empty: u, $anchor: f } = l, { pos: m, parent: h } = f, p = f.parent.isTextblock && m > 0 ? s.doc.resolve(m - 1) : f, g = p.parent.type.spec.isolating, y = f.pos - f.parentOffset, v = g && p.parent.childCount === 1 ? y === f.pos : He.atStart(c).from === m;
        return !u || !h.type.isTextblock || h.textContent.length || !v || v && f.parent.type.name === "paragraph" ? !1 : o.clearNodes();
      }),
      () => o.deleteSelection(),
      () => o.joinBackward(),
      () => o.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: o }) => [
      () => o.deleteSelection(),
      () => o.deleteCurrentNode(),
      () => o.joinForward(),
      () => o.selectNodeForward()
    ]), i = {
      Enter: () => this.editor.commands.first(({ commands: o }) => [
        () => o.newlineInCode(),
        () => o.createParagraphNear(),
        () => o.liftEmptyBlock(),
        () => o.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, r = {
      ...i
    }, a = {
      ...i,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return _h() || e7() ? a : r;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new ft({
        key: new yt("clearDocument"),
        appendTransaction: (t, e, n) => {
          if (t.some((g) => g.getMeta("composition")))
            return;
          const i = t.some((g) => g.docChanged) && !e.doc.eq(n.doc), r = t.some((g) => g.getMeta("preventClearDocument"));
          if (!i || r)
            return;
          const { empty: a, from: o, to: s } = e.selection, l = He.atStart(e.doc).from, c = He.atEnd(e.doc).to;
          if (a || !(o === l && s === c) || !Ch(n.doc))
            return;
          const m = n.tr, h = vh({
            state: n,
            transaction: m
          }), { commands: p } = new bh({
            editor: this.editor,
            state: h
          });
          if (p.clearNodes(), !!m.steps.length)
            return m;
        }
      })
    ];
  }
}), iIe = gt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("tiptapPaste"),
        props: {
          handlePaste: (t, e, n) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: n
            });
          }
        }
      })
    ];
  }
}), rIe = gt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
});
class eo {
  get name() {
    return this.node.type.name;
  }
  constructor(e, n, i = !1, r = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = i, this.resolvedPos = e, this.editor = n, this.currentNode = r;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) !== null && e !== void 0 ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let n = this.from, i = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      n = this.from + 1, i = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: n, to: i }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), n = this.resolvedPos.doc.resolve(e);
    return new eo(n, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new eo(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new eo(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((n, i) => {
      const r = n.isBlock && !n.isTextblock, a = n.isAtom && !n.isText, o = this.pos + i + (a ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const s = this.resolvedPos.doc.resolve(o);
      if (!r && s.depth <= this.depth)
        return;
      const l = new eo(s, this.editor, r, r ? n : null);
      r && (l.actualDepth = this.depth + 1), e.push(new eo(s, this.editor, r, r ? n : null));
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, n = {}) {
    let i = null, r = this.parent;
    for (; r && !i; ) {
      if (r.node.type.name === e)
        if (Object.keys(n).length > 0) {
          const a = r.node.attrs, o = Object.keys(n);
          for (let s = 0; s < o.length; s += 1) {
            const l = o[s];
            if (a[l] !== n[l])
              break;
          }
        } else
          i = r;
      r = r.parent;
    }
    return i;
  }
  querySelector(e, n = {}) {
    return this.querySelectorAll(e, n, !0)[0] || null;
  }
  querySelectorAll(e, n = {}, i = !1) {
    let r = [];
    if (!this.children || this.children.length === 0)
      return r;
    const a = Object.keys(n);
    return this.children.forEach((o) => {
      i && r.length > 0 || (o.node.type.name === e && a.every((l) => n[l] === o.node.attrs[l]) && r.push(o), !(i && r.length > 0) && (r = r.concat(o.querySelectorAll(e, n, i))));
    }), r;
  }
  setAttribute(e) {
    const { tr: n } = this.editor.state;
    n.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(n);
  }
}
const aIe = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}

.tippy-box[data-animation=fade][data-state=hidden] {
  opacity: 0
}`;
function oIe(t, e, n) {
  const i = document.querySelector("style[data-tiptap-style]");
  if (i !== null)
    return i;
  const r = document.createElement("style");
  return e && r.setAttribute("nonce", e), r.setAttribute("data-tiptap-style", ""), r.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(r), r;
}
class sIe extends yAe {
  constructor(e = {}) {
    super(), this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.options = {
      element: document.createElement("div"),
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: n }) => {
        throw n;
      },
      onPaste: () => null,
      onDrop: () => null
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("contentError", this.options.onContentError), this.createView(), this.injectCSS(), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: n, slice: i, moved: r }) => this.options.onDrop(n, i, r)), this.on("paste", ({ event: n, slice: i }) => this.options.onPaste(n, i)), window.setTimeout(() => {
      this.isDestroyed || (this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && document && (this.css = oIe(aIe, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.view || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, n = !0) {
    this.setOptions({ editable: e }), n && this.emit("update", { editor: this, transaction: this.state.tr });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.view.state;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, n) {
    const i = XS(n) ? n(e, [...this.state.plugins]) : [...this.state.plugins, e], r = this.state.reconfigure({ plugins: i });
    return this.view.updateState(r), r;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const n = this.state.plugins;
    let i = n;
    if ([].concat(e).forEach((a) => {
      const o = typeof a == "string" ? `${a}$` : a.key;
      i = i.filter((s) => !s.key.startsWith(o));
    }), n.length === i.length)
      return;
    const r = this.state.reconfigure({
      plugins: i
    });
    return this.view.updateState(r), r;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, n;
    const r = [...this.options.enableCoreExtensions ? [
      ZLe,
      TAe.configure({
        blockSeparator: (n = (e = this.options.coreExtensionOptions) === null || e === void 0 ? void 0 : e.clipboardTextSerializer) === null || n === void 0 ? void 0 : n.blockSeparator
      }),
      JLe,
      tIe,
      nIe,
      rIe,
      QLe,
      iIe
    ].filter((a) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[a.name] !== !1 : !0) : [], ...this.options.extensions].filter((a) => ["extension", "node", "mark"].includes(a == null ? void 0 : a.type));
    this.extensionManager = new ls(r, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new bh({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView() {
    var e;
    let n;
    try {
      n = Rg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: this.options.enableContentCheck });
    } catch (o) {
      if (!(o instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(o.message))
        throw o;
      this.emit("contentError", {
        editor: this,
        error: o,
        disableCollaboration: () => {
          this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((s) => s.name !== "collaboration"), this.createExtensionManager();
        }
      }), n = Rg(this.options.content, this.schema, this.options.parseOptions, { errorOnInvalidContent: !1 });
    }
    const i = JS(n, this.options.autofocus);
    this.view = new zWe(this.options.element, {
      ...this.options.editorProps,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...(e = this.options.editorProps) === null || e === void 0 ? void 0 : e.attributes
      },
      dispatchTransaction: this.dispatchTransaction.bind(this),
      state: ss.create({
        doc: n,
        selection: i || void 0
      })
    });
    const r = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(r), this.createNodeViews(), this.prependClass();
    const a = this.view.dom;
    a.editor = this;
  }
  /**
   * Creates all node views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `tiptap ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const n = this.capturedTransaction;
    return this.capturedTransaction = null, n;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((o) => {
        var s;
        return (s = this.capturedTransaction) === null || s === void 0 ? void 0 : s.step(o);
      });
      return;
    }
    const n = this.state.apply(e), i = !this.state.selection.eq(n.selection);
    this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: n
    }), this.view.updateState(n), this.emit("transaction", {
      editor: this,
      transaction: e
    }), i && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const r = e.getMeta("focus"), a = e.getMeta("blur");
    r && this.emit("focus", {
      editor: this,
      event: r.event,
      transaction: e
    }), a && this.emit("blur", {
      editor: this,
      event: a.event,
      transaction: e
    }), !(!e.docChanged || e.getMeta("preventUpdate")) && this.emit("update", {
      editor: this,
      transaction: e
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return n7(this.state, e);
  }
  isActive(e, n) {
    const i = typeof e == "string" ? e : null, r = typeof e == "string" ? n : e;
    return i7(this.state, i, r);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return tb(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: n = `

`, textSerializers: i = {} } = e || {};
    return CLe(this.state.doc, {
      blockSeparator: n,
      textSerializers: {
        ...KS(this.schema),
        ...i
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Ch(this.state.doc);
  }
  /**
   * Get the number of characters for the current document.
   *
   * @deprecated
   */
  getCharacterCount() {
    return console.warn('[tiptap warn]: "editor.getCharacterCount()" is deprecated. Please use "editor.storage.characterCount.characters()" instead.'), this.state.doc.content.size - 2;
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    if (this.emit("destroy"), this.view) {
      const e = this.view.dom;
      e && e.editor && delete e.editor, this.view.destroy();
    }
    this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e;
    return !(!((e = this.view) === null || e === void 0) && e.docView);
  }
  $node(e, n) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelector(e, n)) || null;
  }
  $nodes(e, n) {
    var i;
    return ((i = this.$doc) === null || i === void 0 ? void 0 : i.querySelectorAll(e, n)) || null;
  }
  $pos(e) {
    const n = this.state.doc.resolve(e);
    return new eo(n, this);
  }
  get $doc() {
    return this.$pos(0);
  }
}
function xo(t) {
  return new Pc({
    find: t.find,
    handler: ({ state: e, range: n, match: i }) => {
      const r = Xe(t.getAttributes, void 0, i);
      if (r === !1 || r === null)
        return null;
      const { tr: a } = e, o = i[i.length - 1], s = i[0];
      if (o) {
        const l = s.search(/\S/), c = n.from + s.indexOf(o), u = c + o.length;
        if (ab(n.from, n.to, e.doc).filter((h) => h.mark.type.excluded.find((g) => g === t.type && g !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        u < n.to && a.delete(u, n.to), c > n.from && a.delete(n.from + l, c);
        const m = n.from + l + o.length;
        a.addMark(n.from + l, m, t.type.create(r || {})), a.removeStoredMark(t.type);
      }
    }
  });
}
function lIe(t) {
  return new Pc({
    find: t.find,
    handler: ({ state: e, range: n, match: i }) => {
      const r = Xe(t.getAttributes, void 0, i) || {}, { tr: a } = e, o = n.from;
      let s = n.to;
      const l = t.type.create(r);
      if (i[1]) {
        const c = i[0].lastIndexOf(i[1]);
        let u = o + c;
        u > s ? u = s : s = u + i[1].length;
        const f = i[0][i[0].length - 1];
        a.insertText(f, o + i[0].length - 1), a.replaceWith(u, s, l);
      } else if (i[0]) {
        const c = t.type.isInline ? o : o - 1;
        a.insert(c, t.type.create(r)).delete(a.mapping.map(o), a.mapping.map(s));
      }
      a.scrollIntoView();
    }
  });
}
function Fg(t) {
  return new Pc({
    find: t.find,
    handler: ({ state: e, range: n, match: i }) => {
      const r = e.doc.resolve(n.from), a = Xe(t.getAttributes, void 0, i) || {};
      if (!r.node(-1).canReplaceWith(r.index(-1), r.indexAfter(-1), t.type))
        return null;
      e.tr.delete(n.from, n.to).setBlockType(n.from, n.from, t.type, a);
    }
  });
}
function Rt(t) {
  return new Pc({
    find: t.find,
    handler: ({ state: e, range: n, match: i }) => {
      let r = t.replace, a = n.from;
      const o = n.to;
      if (i[1]) {
        const s = i[0].lastIndexOf(i[1]);
        r += i[0].slice(s + i[1].length), a += s;
        const l = a - o;
        l > 0 && (r = i[0].slice(s - l, s) + r, a = o);
      }
      e.tr.insertText(r, a, o);
    }
  });
}
function Ws(t) {
  return new Pc({
    find: t.find,
    handler: ({ state: e, range: n, match: i, chain: r }) => {
      const a = Xe(t.getAttributes, void 0, i) || {}, o = e.tr.delete(n.from, n.to), l = o.doc.resolve(n.from).blockRange(), c = l && j0(l, t.type, a);
      if (!c)
        return null;
      if (o.wrap(l, c), t.keepMarks && t.editor) {
        const { selection: f, storedMarks: m } = e, { splittableMarks: h } = t.editor.extensionManager, p = m || f.$to.parentOffset && f.$from.marks();
        if (p) {
          const g = p.filter((y) => h.includes(y.type.name));
          o.ensureMarks(g);
        }
      }
      if (t.keepAttributes) {
        const f = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        r().updateAttributes(f, a).run();
      }
      const u = o.doc.resolve(n.from - 1).nodeBefore;
      u && u.type === t.type && Va(o.doc, n.from - 1) && (!t.joinPredicate || t.joinPredicate(i, u)) && o.join(n.from - 1);
    }
  });
}
let qt = class zg {
  constructor(e = {}) {
    this.type = "node", this.name = "node", this.parent = null, this.child = null, this.config = {
      name: this.name,
      defaultOptions: {}
    }, this.config = {
      ...this.config,
      ...e
    }, this.name = this.config.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${this.name}".`), this.options = this.config.defaultOptions, this.config.addOptions && (this.options = Xe(Ne(this, "addOptions", {
      name: this.name
    }))), this.storage = Xe(Ne(this, "addStorage", {
      name: this.name,
      options: this.options
    })) || {};
  }
  static create(e = {}) {
    return new zg(e);
  }
  configure(e = {}) {
    const n = this.extend({
      ...this.config,
      addOptions: () => kh(this.options, e)
    });
    return n.name = this.name, n.parent = this.parent, n;
  }
  extend(e = {}) {
    const n = new zg(e);
    return n.parent = this, this.child = n, n.name = e.name ? e.name : n.parent.name, e.defaultOptions && Object.keys(e.defaultOptions).length > 0 && console.warn(`[tiptap warn]: BREAKING CHANGE: "defaultOptions" is deprecated. Please use "addOptions" instead. Found in extension: "${n.name}".`), n.options = Xe(Ne(n, "addOptions", {
      name: n.name
    })), n.storage = Xe(Ne(n, "addStorage", {
      name: n.name,
      options: n.options
    })), n;
  }
};
class dIe {
  constructor(e, n, i) {
    this.isDragging = !1, this.component = e, this.editor = n.editor, this.options = {
      stopEvent: null,
      ignoreMutation: null,
      ...i
    }, this.extension = n.extension, this.node = n.node, this.decorations = n.decorations, this.innerDecorations = n.innerDecorations, this.view = n.view, this.HTMLAttributes = n.HTMLAttributes, this.getPos = n.getPos, this.mount();
  }
  mount() {
  }
  get dom() {
    return this.editor.view.dom;
  }
  get contentDOM() {
    return null;
  }
  onDragStart(e) {
    var n, i, r, a, o, s, l;
    const { view: c } = this.editor, u = e.target, f = u.nodeType === 3 ? (n = u.parentElement) === null || n === void 0 ? void 0 : n.closest("[data-drag-handle]") : u.closest("[data-drag-handle]");
    if (!this.dom || !((i = this.contentDOM) === null || i === void 0) && i.contains(u) || !f)
      return;
    let m = 0, h = 0;
    if (this.dom !== f) {
      const w = this.dom.getBoundingClientRect(), x = f.getBoundingClientRect(), b = (r = e.offsetX) !== null && r !== void 0 ? r : (a = e.nativeEvent) === null || a === void 0 ? void 0 : a.offsetX, M = (o = e.offsetY) !== null && o !== void 0 ? o : (s = e.nativeEvent) === null || s === void 0 ? void 0 : s.offsetY;
      m = x.x - w.x + b, h = x.y - w.y + M;
    }
    const p = this.dom.cloneNode(!0);
    (l = e.dataTransfer) === null || l === void 0 || l.setDragImage(p, m, h);
    const g = this.getPos();
    if (typeof g != "number")
      return;
    const y = Ae.create(c.state.doc, g), v = c.state.tr.setSelection(y);
    c.dispatch(v);
  }
  stopEvent(e) {
    var n;
    if (!this.dom)
      return !1;
    if (typeof this.options.stopEvent == "function")
      return this.options.stopEvent({ event: e });
    const i = e.target;
    if (!(this.dom.contains(i) && !(!((n = this.contentDOM) === null || n === void 0) && n.contains(i))))
      return !1;
    const a = e.type.startsWith("drag"), o = e.type === "drop";
    if ((["INPUT", "BUTTON", "SELECT", "TEXTAREA"].includes(i.tagName) || i.isContentEditable) && !o && !a)
      return !0;
    const { isEditable: l } = this.editor, { isDragging: c } = this, u = !!this.node.type.spec.draggable, f = Ae.isSelectable(this.node), m = e.type === "copy", h = e.type === "paste", p = e.type === "cut", g = e.type === "mousedown";
    if (!u && f && a && e.target === this.dom && e.preventDefault(), u && a && !c && e.target === this.dom)
      return e.preventDefault(), !1;
    if (u && l && !c && g) {
      const y = i.closest("[data-drag-handle]");
      y && (this.dom === y || this.dom.contains(y)) && (this.isDragging = !0, document.addEventListener("dragend", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("drop", () => {
        this.isDragging = !1;
      }, { once: !0 }), document.addEventListener("mouseup", () => {
        this.isDragging = !1;
      }, { once: !0 }));
    }
    return !(c || o || m || h || p || g && f);
  }
  /**
   * Called when a DOM [mutation](https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver) or a selection change happens within the view.
   * @return `false` if the editor should re-read the selection or re-parse the range around the mutation
   * @return `true` if it can safely be ignored.
   */
  ignoreMutation(e) {
    return !this.dom || !this.contentDOM ? !0 : typeof this.options.ignoreMutation == "function" ? this.options.ignoreMutation({ mutation: e }) : this.node.isLeaf || this.node.isAtom ? !0 : e.type === "selection" || this.dom.contains(e.target) && e.type === "childList" && (_h() || QS()) && this.editor.isFocused && [
      ...Array.from(e.addedNodes),
      ...Array.from(e.removedNodes)
    ].every((i) => i.isContentEditable) ? !1 : this.contentDOM === e.target && e.type === "attributes" ? !0 : !this.contentDOM.contains(e.target);
  }
  /**
   * Update the attributes of the prosemirror node.
   */
  updateAttributes(e) {
    this.editor.commands.command(({ tr: n }) => {
      const i = this.getPos();
      return typeof i != "number" ? !1 : (n.setNodeMarkup(i, void 0, {
        ...this.node.attrs,
        ...e
      }), !0);
    });
  }
  /**
   * Delete the node.
   */
  deleteNode() {
    const e = this.getPos();
    if (typeof e != "number")
      return;
    const n = e + this.node.nodeSize;
    this.editor.commands.deleteRange({ from: e, to: n });
  }
}
function Na(t) {
  return new PAe({
    find: t.find,
    handler: ({ state: e, range: n, match: i, pasteEvent: r }) => {
      const a = Xe(t.getAttributes, void 0, i, r);
      if (a === !1 || a === null)
        return null;
      const { tr: o } = e, s = i[i.length - 1], l = i[0];
      let c = n.to;
      if (s) {
        const u = l.search(/\S/), f = n.from + l.indexOf(s), m = f + s.length;
        if (ab(n.from, n.to, e.doc).filter((p) => p.mark.type.excluded.find((y) => y === t.type && y !== p.mark.type)).filter((p) => p.to > f).length)
          return null;
        m < n.to && o.delete(m, n.to), f > n.from && o.delete(n.from + u, f), c = n.from + u + s.length, o.addMark(n.from + u, c, t.type.create(a || {})), o.removeStoredMark(t.type);
      }
    }
  });
}
function cIe(t) {
  return t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
var Qn = "top", Ei = "bottom", Ti = "right", Zn = "left", ob = "auto", Sc = [Qn, Ei, Ti, Zn], As = "start", Md = "end", uIe = "clippingParents", a7 = "viewport", Nl = "popper", fIe = "reference", a3 = /* @__PURE__ */ Sc.reduce(function(t, e) {
  return t.concat([e + "-" + As, e + "-" + Md]);
}, []), o7 = /* @__PURE__ */ [].concat(Sc, [ob]).reduce(function(t, e) {
  return t.concat([e, e + "-" + As, e + "-" + Md]);
}, []), mIe = "beforeRead", hIe = "read", pIe = "afterRead", gIe = "beforeMain", yIe = "main", vIe = "afterMain", bIe = "beforeWrite", wIe = "write", kIe = "afterWrite", xIe = [mIe, hIe, pIe, gIe, yIe, vIe, bIe, wIe, kIe];
function pr(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ci(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function _o(t) {
  var e = ci(t).Element;
  return t instanceof e || t instanceof Element;
}
function Pi(t) {
  var e = ci(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function sb(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ci(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function _Ie(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(n) {
    var i = e.styles[n] || {}, r = e.attributes[n] || {}, a = e.elements[n];
    !Pi(a) || !pr(a) || (Object.assign(a.style, i), Object.keys(r).forEach(function(o) {
      var s = r[o];
      s === !1 ? a.removeAttribute(o) : a.setAttribute(o, s === !0 ? "" : s);
    }));
  });
}
function MIe(t) {
  var e = t.state, n = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, n.popper), e.styles = n, e.elements.arrow && Object.assign(e.elements.arrow.style, n.arrow), function() {
    Object.keys(e.elements).forEach(function(i) {
      var r = e.elements[i], a = e.attributes[i] || {}, o = Object.keys(e.styles.hasOwnProperty(i) ? e.styles[i] : n[i]), s = o.reduce(function(l, c) {
        return l[c] = "", l;
      }, {});
      !Pi(r) || !pr(r) || (Object.assign(r.style, s), Object.keys(a).forEach(function(l) {
        r.removeAttribute(l);
      }));
    });
  };
}
const s7 = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: _Ie,
  effect: MIe,
  requires: ["computeStyles"]
};
function ur(t) {
  return t.split("-")[0];
}
var ho = Math.max, If = Math.min, Ls = Math.round;
function Vg() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function l7() {
  return !/^((?!chrome|android).)*safari/i.test(Vg());
}
function Is(t, e, n) {
  e === void 0 && (e = !1), n === void 0 && (n = !1);
  var i = t.getBoundingClientRect(), r = 1, a = 1;
  e && Pi(t) && (r = t.offsetWidth > 0 && Ls(i.width) / t.offsetWidth || 1, a = t.offsetHeight > 0 && Ls(i.height) / t.offsetHeight || 1);
  var o = _o(t) ? ci(t) : window, s = o.visualViewport, l = !l7() && n, c = (i.left + (l && s ? s.offsetLeft : 0)) / r, u = (i.top + (l && s ? s.offsetTop : 0)) / a, f = i.width / r, m = i.height / a;
  return {
    width: f,
    height: m,
    top: u,
    right: c + f,
    bottom: u + m,
    left: c,
    x: c,
    y: u
  };
}
function lb(t) {
  var e = Is(t), n = t.offsetWidth, i = t.offsetHeight;
  return Math.abs(e.width - n) <= 1 && (n = e.width), Math.abs(e.height - i) <= 1 && (i = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: n,
    height: i
  };
}
function d7(t, e) {
  var n = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (n && sb(n)) {
    var i = e;
    do {
      if (i && t.isSameNode(i))
        return !0;
      i = i.parentNode || i.host;
    } while (i);
  }
  return !1;
}
function qr(t) {
  return ci(t).getComputedStyle(t);
}
function CIe(t) {
  return ["table", "td", "th"].indexOf(pr(t)) >= 0;
}
function qa(t) {
  return ((_o(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function Ph(t) {
  return pr(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (sb(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    qa(t)
  );
}
function o3(t) {
  return !Pi(t) || // https://github.com/popperjs/popper-core/issues/837
  qr(t).position === "fixed" ? null : t.offsetParent;
}
function PIe(t) {
  var e = /firefox/i.test(Vg()), n = /Trident/i.test(Vg());
  if (n && Pi(t)) {
    var i = qr(t);
    if (i.position === "fixed")
      return null;
  }
  var r = Ph(t);
  for (sb(r) && (r = r.host); Pi(r) && ["html", "body"].indexOf(pr(r)) < 0; ) {
    var a = qr(r);
    if (a.transform !== "none" || a.perspective !== "none" || a.contain === "paint" || ["transform", "perspective"].indexOf(a.willChange) !== -1 || e && a.willChange === "filter" || e && a.filter && a.filter !== "none")
      return r;
    r = r.parentNode;
  }
  return null;
}
function Nc(t) {
  for (var e = ci(t), n = o3(t); n && CIe(n) && qr(n).position === "static"; )
    n = o3(n);
  return n && (pr(n) === "html" || pr(n) === "body" && qr(n).position === "static") ? e : n || PIe(t) || e;
}
function db(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function Xl(t, e, n) {
  return ho(t, If(e, n));
}
function SIe(t, e, n) {
  var i = Xl(t, e, n);
  return i > n ? n : i;
}
function c7() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function u7(t) {
  return Object.assign({}, c7(), t);
}
function f7(t, e) {
  return e.reduce(function(n, i) {
    return n[i] = t, n;
  }, {});
}
var NIe = function(e, n) {
  return e = typeof e == "function" ? e(Object.assign({}, n.rects, {
    placement: n.placement
  })) : e, u7(typeof e != "number" ? e : f7(e, Sc));
};
function $Ie(t) {
  var e, n = t.state, i = t.name, r = t.options, a = n.elements.arrow, o = n.modifiersData.popperOffsets, s = ur(n.placement), l = db(s), c = [Zn, Ti].indexOf(s) >= 0, u = c ? "height" : "width";
  if (!(!a || !o)) {
    var f = NIe(r.padding, n), m = lb(a), h = l === "y" ? Qn : Zn, p = l === "y" ? Ei : Ti, g = n.rects.reference[u] + n.rects.reference[l] - o[l] - n.rects.popper[u], y = o[l] - n.rects.reference[l], v = Nc(a), w = v ? l === "y" ? v.clientHeight || 0 : v.clientWidth || 0 : 0, x = g / 2 - y / 2, b = f[h], M = w - m[u] - f[p], _ = w / 2 - m[u] / 2 + x, N = Xl(b, _, M), $ = l;
    n.modifiersData[i] = (e = {}, e[$] = N, e.centerOffset = N - _, e);
  }
}
function DIe(t) {
  var e = t.state, n = t.options, i = n.element, r = i === void 0 ? "[data-popper-arrow]" : i;
  r != null && (typeof r == "string" && (r = e.elements.popper.querySelector(r), !r) || d7(e.elements.popper, r) && (e.elements.arrow = r));
}
const EIe = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: $Ie,
  effect: DIe,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Rs(t) {
  return t.split("-")[1];
}
var TIe = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function OIe(t, e) {
  var n = t.x, i = t.y, r = e.devicePixelRatio || 1;
  return {
    x: Ls(n * r) / r || 0,
    y: Ls(i * r) / r || 0
  };
}
function s3(t) {
  var e, n = t.popper, i = t.popperRect, r = t.placement, a = t.variation, o = t.offsets, s = t.position, l = t.gpuAcceleration, c = t.adaptive, u = t.roundOffsets, f = t.isFixed, m = o.x, h = m === void 0 ? 0 : m, p = o.y, g = p === void 0 ? 0 : p, y = typeof u == "function" ? u({
    x: h,
    y: g
  }) : {
    x: h,
    y: g
  };
  h = y.x, g = y.y;
  var v = o.hasOwnProperty("x"), w = o.hasOwnProperty("y"), x = Zn, b = Qn, M = window;
  if (c) {
    var _ = Nc(n), N = "clientHeight", $ = "clientWidth";
    if (_ === ci(n) && (_ = qa(n), qr(_).position !== "static" && s === "absolute" && (N = "scrollHeight", $ = "scrollWidth")), _ = _, r === Qn || (r === Zn || r === Ti) && a === Md) {
      b = Ei;
      var D = f && _ === M && M.visualViewport ? M.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        _[N]
      );
      g -= D - i.height, g *= l ? 1 : -1;
    }
    if (r === Zn || (r === Qn || r === Ei) && a === Md) {
      x = Ti;
      var W = f && _ === M && M.visualViewport ? M.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        _[$]
      );
      h -= W - i.width, h *= l ? 1 : -1;
    }
  }
  var j = Object.assign({
    position: s
  }, c && TIe), O = u === !0 ? OIe({
    x: h,
    y: g
  }, ci(n)) : {
    x: h,
    y: g
  };
  if (h = O.x, g = O.y, l) {
    var I;
    return Object.assign({}, j, (I = {}, I[b] = w ? "0" : "", I[x] = v ? "0" : "", I.transform = (M.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + g + "px)" : "translate3d(" + h + "px, " + g + "px, 0)", I));
  }
  return Object.assign({}, j, (e = {}, e[b] = w ? g + "px" : "", e[x] = v ? h + "px" : "", e.transform = "", e));
}
function WIe(t) {
  var e = t.state, n = t.options, i = n.gpuAcceleration, r = i === void 0 ? !0 : i, a = n.adaptive, o = a === void 0 ? !0 : a, s = n.roundOffsets, l = s === void 0 ? !0 : s, c = {
    placement: ur(e.placement),
    variation: Rs(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: r,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, s3(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: o,
    roundOffsets: l
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, s3(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: l
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const AIe = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: WIe,
  data: {}
};
var au = {
  passive: !0
};
function LIe(t) {
  var e = t.state, n = t.instance, i = t.options, r = i.scroll, a = r === void 0 ? !0 : r, o = i.resize, s = o === void 0 ? !0 : o, l = ci(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return a && c.forEach(function(u) {
    u.addEventListener("scroll", n.update, au);
  }), s && l.addEventListener("resize", n.update, au), function() {
    a && c.forEach(function(u) {
      u.removeEventListener("scroll", n.update, au);
    }), s && l.removeEventListener("resize", n.update, au);
  };
}
const IIe = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: LIe,
  data: {}
};
var RIe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Wu(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return RIe[e];
  });
}
var jIe = {
  start: "end",
  end: "start"
};
function l3(t) {
  return t.replace(/start|end/g, function(e) {
    return jIe[e];
  });
}
function cb(t) {
  var e = ci(t), n = e.pageXOffset, i = e.pageYOffset;
  return {
    scrollLeft: n,
    scrollTop: i
  };
}
function ub(t) {
  return Is(qa(t)).left + cb(t).scrollLeft;
}
function FIe(t, e) {
  var n = ci(t), i = qa(t), r = n.visualViewport, a = i.clientWidth, o = i.clientHeight, s = 0, l = 0;
  if (r) {
    a = r.width, o = r.height;
    var c = l7();
    (c || !c && e === "fixed") && (s = r.offsetLeft, l = r.offsetTop);
  }
  return {
    width: a,
    height: o,
    x: s + ub(t),
    y: l
  };
}
function zIe(t) {
  var e, n = qa(t), i = cb(t), r = (e = t.ownerDocument) == null ? void 0 : e.body, a = ho(n.scrollWidth, n.clientWidth, r ? r.scrollWidth : 0, r ? r.clientWidth : 0), o = ho(n.scrollHeight, n.clientHeight, r ? r.scrollHeight : 0, r ? r.clientHeight : 0), s = -i.scrollLeft + ub(t), l = -i.scrollTop;
  return qr(r || n).direction === "rtl" && (s += ho(n.clientWidth, r ? r.clientWidth : 0) - a), {
    width: a,
    height: o,
    x: s,
    y: l
  };
}
function fb(t) {
  var e = qr(t), n = e.overflow, i = e.overflowX, r = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(n + r + i);
}
function m7(t) {
  return ["html", "body", "#document"].indexOf(pr(t)) >= 0 ? t.ownerDocument.body : Pi(t) && fb(t) ? t : m7(Ph(t));
}
function Yl(t, e) {
  var n;
  e === void 0 && (e = []);
  var i = m7(t), r = i === ((n = t.ownerDocument) == null ? void 0 : n.body), a = ci(i), o = r ? [a].concat(a.visualViewport || [], fb(i) ? i : []) : i, s = e.concat(o);
  return r ? s : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    s.concat(Yl(Ph(o)))
  );
}
function Hg(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function VIe(t, e) {
  var n = Is(t, !1, e === "fixed");
  return n.top = n.top + t.clientTop, n.left = n.left + t.clientLeft, n.bottom = n.top + t.clientHeight, n.right = n.left + t.clientWidth, n.width = t.clientWidth, n.height = t.clientHeight, n.x = n.left, n.y = n.top, n;
}
function d3(t, e, n) {
  return e === a7 ? Hg(FIe(t, n)) : _o(e) ? VIe(e, n) : Hg(zIe(qa(t)));
}
function HIe(t) {
  var e = Yl(Ph(t)), n = ["absolute", "fixed"].indexOf(qr(t).position) >= 0, i = n && Pi(t) ? Nc(t) : t;
  return _o(i) ? e.filter(function(r) {
    return _o(r) && d7(r, i) && pr(r) !== "body";
  }) : [];
}
function BIe(t, e, n, i) {
  var r = e === "clippingParents" ? HIe(t) : [].concat(e), a = [].concat(r, [n]), o = a[0], s = a.reduce(function(l, c) {
    var u = d3(t, c, i);
    return l.top = ho(u.top, l.top), l.right = If(u.right, l.right), l.bottom = If(u.bottom, l.bottom), l.left = ho(u.left, l.left), l;
  }, d3(t, o, i));
  return s.width = s.right - s.left, s.height = s.bottom - s.top, s.x = s.left, s.y = s.top, s;
}
function h7(t) {
  var e = t.reference, n = t.element, i = t.placement, r = i ? ur(i) : null, a = i ? Rs(i) : null, o = e.x + e.width / 2 - n.width / 2, s = e.y + e.height / 2 - n.height / 2, l;
  switch (r) {
    case Qn:
      l = {
        x: o,
        y: e.y - n.height
      };
      break;
    case Ei:
      l = {
        x: o,
        y: e.y + e.height
      };
      break;
    case Ti:
      l = {
        x: e.x + e.width,
        y: s
      };
      break;
    case Zn:
      l = {
        x: e.x - n.width,
        y: s
      };
      break;
    default:
      l = {
        x: e.x,
        y: e.y
      };
  }
  var c = r ? db(r) : null;
  if (c != null) {
    var u = c === "y" ? "height" : "width";
    switch (a) {
      case As:
        l[c] = l[c] - (e[u] / 2 - n[u] / 2);
        break;
      case Md:
        l[c] = l[c] + (e[u] / 2 - n[u] / 2);
        break;
    }
  }
  return l;
}
function Cd(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, r = i === void 0 ? t.placement : i, a = n.strategy, o = a === void 0 ? t.strategy : a, s = n.boundary, l = s === void 0 ? uIe : s, c = n.rootBoundary, u = c === void 0 ? a7 : c, f = n.elementContext, m = f === void 0 ? Nl : f, h = n.altBoundary, p = h === void 0 ? !1 : h, g = n.padding, y = g === void 0 ? 0 : g, v = u7(typeof y != "number" ? y : f7(y, Sc)), w = m === Nl ? fIe : Nl, x = t.rects.popper, b = t.elements[p ? w : m], M = BIe(_o(b) ? b : b.contextElement || qa(t.elements.popper), l, u, o), _ = Is(t.elements.reference), N = h7({
    reference: _,
    element: x,
    placement: r
  }), $ = Hg(Object.assign({}, x, N)), D = m === Nl ? $ : _, W = {
    top: M.top - D.top + v.top,
    bottom: D.bottom - M.bottom + v.bottom,
    left: M.left - D.left + v.left,
    right: D.right - M.right + v.right
  }, j = t.modifiersData.offset;
  if (m === Nl && j) {
    var O = j[r];
    Object.keys(W).forEach(function(I) {
      var L = [Ti, Ei].indexOf(I) >= 0 ? 1 : -1, R = [Qn, Ei].indexOf(I) >= 0 ? "y" : "x";
      W[I] += O[R] * L;
    });
  }
  return W;
}
function qIe(t, e) {
  e === void 0 && (e = {});
  var n = e, i = n.placement, r = n.boundary, a = n.rootBoundary, o = n.padding, s = n.flipVariations, l = n.allowedAutoPlacements, c = l === void 0 ? o7 : l, u = Rs(i), f = u ? s ? a3 : a3.filter(function(p) {
    return Rs(p) === u;
  }) : Sc, m = f.filter(function(p) {
    return c.indexOf(p) >= 0;
  });
  m.length === 0 && (m = f);
  var h = m.reduce(function(p, g) {
    return p[g] = Cd(t, {
      placement: g,
      boundary: r,
      rootBoundary: a,
      padding: o
    })[ur(g)], p;
  }, {});
  return Object.keys(h).sort(function(p, g) {
    return h[p] - h[g];
  });
}
function GIe(t) {
  if (ur(t) === ob)
    return [];
  var e = Wu(t);
  return [l3(t), e, l3(e)];
}
function XIe(t) {
  var e = t.state, n = t.options, i = t.name;
  if (!e.modifiersData[i]._skip) {
    for (var r = n.mainAxis, a = r === void 0 ? !0 : r, o = n.altAxis, s = o === void 0 ? !0 : o, l = n.fallbackPlacements, c = n.padding, u = n.boundary, f = n.rootBoundary, m = n.altBoundary, h = n.flipVariations, p = h === void 0 ? !0 : h, g = n.allowedAutoPlacements, y = e.options.placement, v = ur(y), w = v === y, x = l || (w || !p ? [Wu(y)] : GIe(y)), b = [y].concat(x).reduce(function(Pe, We) {
      return Pe.concat(ur(We) === ob ? qIe(e, {
        placement: We,
        boundary: u,
        rootBoundary: f,
        padding: c,
        flipVariations: p,
        allowedAutoPlacements: g
      }) : We);
    }, []), M = e.rects.reference, _ = e.rects.popper, N = /* @__PURE__ */ new Map(), $ = !0, D = b[0], W = 0; W < b.length; W++) {
      var j = b[W], O = ur(j), I = Rs(j) === As, L = [Qn, Ei].indexOf(O) >= 0, R = L ? "width" : "height", B = Cd(e, {
        placement: j,
        boundary: u,
        rootBoundary: f,
        altBoundary: m,
        padding: c
      }), F = L ? I ? Ti : Zn : I ? Ei : Qn;
      M[R] > _[R] && (F = Wu(F));
      var z = Wu(F), K = [];
      if (a && K.push(B[O] <= 0), s && K.push(B[F] <= 0, B[z] <= 0), K.every(function(Pe) {
        return Pe;
      })) {
        D = j, $ = !1;
        break;
      }
      N.set(j, K);
    }
    if ($)
      for (var ae = p ? 3 : 1, Q = function(We) {
        var $e = b.find(function(Y) {
          var oe = N.get(Y);
          if (oe)
            return oe.slice(0, We).every(function(se) {
              return se;
            });
        });
        if ($e)
          return D = $e, "break";
      }, te = ae; te > 0; te--) {
        var be = Q(te);
        if (be === "break") break;
      }
    e.placement !== D && (e.modifiersData[i]._skip = !0, e.placement = D, e.reset = !0);
  }
}
const YIe = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: XIe,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function c3(t, e, n) {
  return n === void 0 && (n = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - n.y,
    right: t.right - e.width + n.x,
    bottom: t.bottom - e.height + n.y,
    left: t.left - e.width - n.x
  };
}
function u3(t) {
  return [Qn, Ti, Ei, Zn].some(function(e) {
    return t[e] >= 0;
  });
}
function KIe(t) {
  var e = t.state, n = t.name, i = e.rects.reference, r = e.rects.popper, a = e.modifiersData.preventOverflow, o = Cd(e, {
    elementContext: "reference"
  }), s = Cd(e, {
    altBoundary: !0
  }), l = c3(o, i), c = c3(s, r, a), u = u3(l), f = u3(c);
  e.modifiersData[n] = {
    referenceClippingOffsets: l,
    popperEscapeOffsets: c,
    isReferenceHidden: u,
    hasPopperEscaped: f
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": u,
    "data-popper-escaped": f
  });
}
const UIe = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: KIe
};
function JIe(t, e, n) {
  var i = ur(t), r = [Zn, Qn].indexOf(i) >= 0 ? -1 : 1, a = typeof n == "function" ? n(Object.assign({}, e, {
    placement: t
  })) : n, o = a[0], s = a[1];
  return o = o || 0, s = (s || 0) * r, [Zn, Ti].indexOf(i) >= 0 ? {
    x: s,
    y: o
  } : {
    x: o,
    y: s
  };
}
function QIe(t) {
  var e = t.state, n = t.options, i = t.name, r = n.offset, a = r === void 0 ? [0, 0] : r, o = o7.reduce(function(u, f) {
    return u[f] = JIe(f, e.rects, a), u;
  }, {}), s = o[e.placement], l = s.x, c = s.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += l, e.modifiersData.popperOffsets.y += c), e.modifiersData[i] = o;
}
const ZIe = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: QIe
};
function eRe(t) {
  var e = t.state, n = t.name;
  e.modifiersData[n] = h7({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const tRe = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: eRe,
  data: {}
};
function nRe(t) {
  return t === "x" ? "y" : "x";
}
function iRe(t) {
  var e = t.state, n = t.options, i = t.name, r = n.mainAxis, a = r === void 0 ? !0 : r, o = n.altAxis, s = o === void 0 ? !1 : o, l = n.boundary, c = n.rootBoundary, u = n.altBoundary, f = n.padding, m = n.tether, h = m === void 0 ? !0 : m, p = n.tetherOffset, g = p === void 0 ? 0 : p, y = Cd(e, {
    boundary: l,
    rootBoundary: c,
    padding: f,
    altBoundary: u
  }), v = ur(e.placement), w = Rs(e.placement), x = !w, b = db(v), M = nRe(b), _ = e.modifiersData.popperOffsets, N = e.rects.reference, $ = e.rects.popper, D = typeof g == "function" ? g(Object.assign({}, e.rects, {
    placement: e.placement
  })) : g, W = typeof D == "number" ? {
    mainAxis: D,
    altAxis: D
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, D), j = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, O = {
    x: 0,
    y: 0
  };
  if (_) {
    if (a) {
      var I, L = b === "y" ? Qn : Zn, R = b === "y" ? Ei : Ti, B = b === "y" ? "height" : "width", F = _[b], z = F + y[L], K = F - y[R], ae = h ? -$[B] / 2 : 0, Q = w === As ? N[B] : $[B], te = w === As ? -$[B] : -N[B], be = e.elements.arrow, Pe = h && be ? lb(be) : {
        width: 0,
        height: 0
      }, We = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : c7(), $e = We[L], Y = We[R], oe = Xl(0, N[B], Pe[B]), se = x ? N[B] / 2 - ae - oe - $e - W.mainAxis : Q - oe - $e - W.mainAxis, J = x ? -N[B] / 2 + ae + oe + Y + W.mainAxis : te + oe + Y + W.mainAxis, xe = e.elements.arrow && Nc(e.elements.arrow), De = xe ? b === "y" ? xe.clientTop || 0 : xe.clientLeft || 0 : 0, _e = (I = j == null ? void 0 : j[b]) != null ? I : 0, ce = F + se - _e - De, wt = F + J - _e, St = Xl(h ? If(z, ce) : z, F, h ? ho(K, wt) : K);
      _[b] = St, O[b] = St - F;
    }
    if (s) {
      var ze, A = b === "x" ? Qn : Zn, V = b === "x" ? Ei : Ti, G = _[M], de = M === "y" ? "height" : "width", fe = G + y[A], ne = G - y[V], Te = [Qn, Zn].indexOf(v) !== -1, Ve = (ze = j == null ? void 0 : j[M]) != null ? ze : 0, kt = Te ? fe : G - N[de] - $[de] - Ve + W.altAxis, xt = Te ? G + N[de] + $[de] - Ve - W.altAxis : ne, Zt = h && Te ? SIe(kt, G, xt) : Xl(h ? kt : fe, G, h ? xt : ne);
      _[M] = Zt, O[M] = Zt - G;
    }
    e.modifiersData[i] = O;
  }
}
const rRe = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: iRe,
  requiresIfExists: ["offset"]
};
function aRe(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function oRe(t) {
  return t === ci(t) || !Pi(t) ? cb(t) : aRe(t);
}
function sRe(t) {
  var e = t.getBoundingClientRect(), n = Ls(e.width) / t.offsetWidth || 1, i = Ls(e.height) / t.offsetHeight || 1;
  return n !== 1 || i !== 1;
}
function lRe(t, e, n) {
  n === void 0 && (n = !1);
  var i = Pi(e), r = Pi(e) && sRe(e), a = qa(e), o = Is(t, r, n), s = {
    scrollLeft: 0,
    scrollTop: 0
  }, l = {
    x: 0,
    y: 0
  };
  return (i || !i && !n) && ((pr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  fb(a)) && (s = oRe(e)), Pi(e) ? (l = Is(e, !0), l.x += e.clientLeft, l.y += e.clientTop) : a && (l.x = ub(a))), {
    x: o.left + s.scrollLeft - l.x,
    y: o.top + s.scrollTop - l.y,
    width: o.width,
    height: o.height
  };
}
function dRe(t) {
  var e = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Set(), i = [];
  t.forEach(function(a) {
    e.set(a.name, a);
  });
  function r(a) {
    n.add(a.name);
    var o = [].concat(a.requires || [], a.requiresIfExists || []);
    o.forEach(function(s) {
      if (!n.has(s)) {
        var l = e.get(s);
        l && r(l);
      }
    }), i.push(a);
  }
  return t.forEach(function(a) {
    n.has(a.name) || r(a);
  }), i;
}
function cRe(t) {
  var e = dRe(t);
  return xIe.reduce(function(n, i) {
    return n.concat(e.filter(function(r) {
      return r.phase === i;
    }));
  }, []);
}
function uRe(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(n) {
      Promise.resolve().then(function() {
        e = void 0, n(t());
      });
    })), e;
  };
}
function fRe(t) {
  var e = t.reduce(function(n, i) {
    var r = n[i.name];
    return n[i.name] = r ? Object.assign({}, r, i, {
      options: Object.assign({}, r.options, i.options),
      data: Object.assign({}, r.data, i.data)
    }) : i, n;
  }, {});
  return Object.keys(e).map(function(n) {
    return e[n];
  });
}
var f3 = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function m3() {
  for (var t = arguments.length, e = new Array(t), n = 0; n < t; n++)
    e[n] = arguments[n];
  return !e.some(function(i) {
    return !(i && typeof i.getBoundingClientRect == "function");
  });
}
function mRe(t) {
  t === void 0 && (t = {});
  var e = t, n = e.defaultModifiers, i = n === void 0 ? [] : n, r = e.defaultOptions, a = r === void 0 ? f3 : r;
  return function(s, l, c) {
    c === void 0 && (c = a);
    var u = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, f3, a),
      modifiersData: {},
      elements: {
        reference: s,
        popper: l
      },
      attributes: {},
      styles: {}
    }, f = [], m = !1, h = {
      state: u,
      setOptions: function(v) {
        var w = typeof v == "function" ? v(u.options) : v;
        g(), u.options = Object.assign({}, a, u.options, w), u.scrollParents = {
          reference: _o(s) ? Yl(s) : s.contextElement ? Yl(s.contextElement) : [],
          popper: Yl(l)
        };
        var x = cRe(fRe([].concat(i, u.options.modifiers)));
        return u.orderedModifiers = x.filter(function(b) {
          return b.enabled;
        }), p(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!m) {
          var v = u.elements, w = v.reference, x = v.popper;
          if (m3(w, x)) {
            u.rects = {
              reference: lRe(w, Nc(x), u.options.strategy === "fixed"),
              popper: lb(x)
            }, u.reset = !1, u.placement = u.options.placement, u.orderedModifiers.forEach(function(W) {
              return u.modifiersData[W.name] = Object.assign({}, W.data);
            });
            for (var b = 0; b < u.orderedModifiers.length; b++) {
              if (u.reset === !0) {
                u.reset = !1, b = -1;
                continue;
              }
              var M = u.orderedModifiers[b], _ = M.fn, N = M.options, $ = N === void 0 ? {} : N, D = M.name;
              typeof _ == "function" && (u = _({
                state: u,
                options: $,
                name: D,
                instance: h
              }) || u);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: uRe(function() {
        return new Promise(function(y) {
          h.forceUpdate(), y(u);
        });
      }),
      destroy: function() {
        g(), m = !0;
      }
    };
    if (!m3(s, l))
      return h;
    h.setOptions(c).then(function(y) {
      !m && c.onFirstUpdate && c.onFirstUpdate(y);
    });
    function p() {
      u.orderedModifiers.forEach(function(y) {
        var v = y.name, w = y.options, x = w === void 0 ? {} : w, b = y.effect;
        if (typeof b == "function") {
          var M = b({
            state: u,
            name: v,
            instance: h,
            options: x
          }), _ = function() {
          };
          f.push(M || _);
        }
      });
    }
    function g() {
      f.forEach(function(y) {
        return y();
      }), f = [];
    }
    return h;
  };
}
var hRe = [IIe, tRe, AIe, s7, ZIe, YIe, rRe, EIe, UIe], pRe = /* @__PURE__ */ mRe({
  defaultModifiers: hRe
}), gRe = "tippy-box", p7 = "tippy-content", yRe = "tippy-backdrop", g7 = "tippy-arrow", y7 = "tippy-svg-arrow", Qa = {
  passive: !0,
  capture: !0
}, v7 = function() {
  return document.body;
};
function vRe(t, e) {
  return {}.hasOwnProperty.call(t, e);
}
function U1(t, e, n) {
  if (Array.isArray(t)) {
    var i = t[e];
    return i ?? (Array.isArray(n) ? n[e] : n);
  }
  return t;
}
function mb(t, e) {
  var n = {}.toString.call(t);
  return n.indexOf("[object") === 0 && n.indexOf(e + "]") > -1;
}
function b7(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function h3(t, e) {
  if (e === 0)
    return t;
  var n;
  return function(i) {
    clearTimeout(n), n = setTimeout(function() {
      t(i);
    }, e);
  };
}
function bRe(t, e) {
  var n = Object.assign({}, t);
  return e.forEach(function(i) {
    delete n[i];
  }), n;
}
function wRe(t) {
  return t.split(/\s+/).filter(Boolean);
}
function es(t) {
  return [].concat(t);
}
function p3(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function kRe(t) {
  return t.filter(function(e, n) {
    return t.indexOf(e) === n;
  });
}
function xRe(t) {
  return t.split("-")[0];
}
function Rf(t) {
  return [].slice.call(t);
}
function g3(t) {
  return Object.keys(t).reduce(function(e, n) {
    return t[n] !== void 0 && (e[n] = t[n]), e;
  }, {});
}
function Kl() {
  return document.createElement("div");
}
function Pd(t) {
  return ["Element", "Fragment"].some(function(e) {
    return mb(t, e);
  });
}
function _Re(t) {
  return mb(t, "NodeList");
}
function MRe(t) {
  return mb(t, "MouseEvent");
}
function CRe(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function PRe(t) {
  return Pd(t) ? [t] : _Re(t) ? Rf(t) : Array.isArray(t) ? t : Rf(document.querySelectorAll(t));
}
function J1(t, e) {
  t.forEach(function(n) {
    n && (n.style.transitionDuration = e + "ms");
  });
}
function y3(t, e) {
  t.forEach(function(n) {
    n && n.setAttribute("data-state", e);
  });
}
function SRe(t) {
  var e, n = es(t), i = n[0];
  return i != null && (e = i.ownerDocument) != null && e.body ? i.ownerDocument : document;
}
function NRe(t, e) {
  var n = e.clientX, i = e.clientY;
  return t.every(function(r) {
    var a = r.popperRect, o = r.popperState, s = r.props, l = s.interactiveBorder, c = xRe(o.placement), u = o.modifiersData.offset;
    if (!u)
      return !0;
    var f = c === "bottom" ? u.top.y : 0, m = c === "top" ? u.bottom.y : 0, h = c === "right" ? u.left.x : 0, p = c === "left" ? u.right.x : 0, g = a.top - i + f > l, y = i - a.bottom - m > l, v = a.left - n + h > l, w = n - a.right - p > l;
    return g || y || v || w;
  });
}
function Q1(t, e, n) {
  var i = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(r) {
    t[i](r, n);
  });
}
function v3(t, e) {
  for (var n = e; n; ) {
    var i;
    if (t.contains(n))
      return !0;
    n = n.getRootNode == null || (i = n.getRootNode()) == null ? void 0 : i.host;
  }
  return !1;
}
var rr = {
  isTouch: !1
}, b3 = 0;
function $Re() {
  rr.isTouch || (rr.isTouch = !0, window.performance && document.addEventListener("mousemove", w7));
}
function w7() {
  var t = performance.now();
  t - b3 < 20 && (rr.isTouch = !1, document.removeEventListener("mousemove", w7)), b3 = t;
}
function DRe() {
  var t = document.activeElement;
  if (CRe(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function ERe() {
  document.addEventListener("touchstart", $Re, Qa), window.addEventListener("blur", DRe);
}
var TRe = typeof window < "u" && typeof document < "u", ORe = TRe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1;
function Xo(t) {
  var e = t === "destroy" ? "n already-" : " ";
  return [t + "() was called on a" + e + "destroyed instance. This is a no-op but", "indicates a potential memory leak."].join(" ");
}
function w3(t) {
  var e = /[ \t]{2,}/g, n = /^[ \t]*/gm;
  return t.replace(e, " ").replace(n, "").trim();
}
function WRe(t) {
  return w3(`
  %ctippy.js

  %c` + w3(t) + `

  %c👷‍ This is a development-only message. It will be removed in production.
  `);
}
function k7(t) {
  return [
    WRe(t),
    // title
    "color: #00C584; font-size: 1.3em; font-weight: bold;",
    // message
    "line-height: 1.5",
    // footer
    "color: #a6a095;"
  ];
}
var Sd;
process.env.NODE_ENV !== "production" && ARe();
function ARe() {
  Sd = /* @__PURE__ */ new Set();
}
function Nr(t, e) {
  if (t && !Sd.has(e)) {
    var n;
    Sd.add(e), (n = console).warn.apply(n, k7(e));
  }
}
function Bg(t, e) {
  if (t && !Sd.has(e)) {
    var n;
    Sd.add(e), (n = console).error.apply(n, k7(e));
  }
}
function LRe(t) {
  var e = !t, n = Object.prototype.toString.call(t) === "[object Object]" && !t.addEventListener;
  Bg(e, ["tippy() was passed", "`" + String(t) + "`", "as its targets (first) argument. Valid types are: String, Element,", "Element[], or NodeList."].join(" ")), Bg(n, ["tippy() was passed a plain object which is not supported as an argument", "for virtual positioning. Use props.getReferenceClientRect instead."].join(" "));
}
var x7 = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, IRe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, di = Object.assign({
  appendTo: v7,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, x7, IRe), RRe = Object.keys(di), jRe = function(e) {
  process.env.NODE_ENV !== "production" && M7(e, []);
  var n = Object.keys(e);
  n.forEach(function(i) {
    di[i] = e[i];
  });
};
function _7(t) {
  var e = t.plugins || [], n = e.reduce(function(i, r) {
    var a = r.name, o = r.defaultValue;
    if (a) {
      var s;
      i[a] = t[a] !== void 0 ? t[a] : (s = di[a]) != null ? s : o;
    }
    return i;
  }, {});
  return Object.assign({}, t, n);
}
function FRe(t, e) {
  var n = e ? Object.keys(_7(Object.assign({}, di, {
    plugins: e
  }))) : RRe, i = n.reduce(function(r, a) {
    var o = (t.getAttribute("data-tippy-" + a) || "").trim();
    if (!o)
      return r;
    if (a === "content")
      r[a] = o;
    else
      try {
        r[a] = JSON.parse(o);
      } catch {
        r[a] = o;
      }
    return r;
  }, {});
  return i;
}
function k3(t, e) {
  var n = Object.assign({}, e, {
    content: b7(e.content, [t])
  }, e.ignoreAttributes ? {} : FRe(t, e.plugins));
  return n.aria = Object.assign({}, di.aria, n.aria), n.aria = {
    expanded: n.aria.expanded === "auto" ? e.interactive : n.aria.expanded,
    content: n.aria.content === "auto" ? e.interactive ? null : "describedby" : n.aria.content
  }, n;
}
function M7(t, e) {
  t === void 0 && (t = {}), e === void 0 && (e = []);
  var n = Object.keys(t);
  n.forEach(function(i) {
    var r = bRe(di, Object.keys(x7)), a = !vRe(r, i);
    a && (a = e.filter(function(o) {
      return o.name === i;
    }).length === 0), Nr(a, ["`" + i + "`", "is not a valid prop. You may have spelled it incorrectly, or if it's", "a plugin, forgot to pass it in an array as props.plugins.", `

`, `All props: https://atomiks.github.io/tippyjs/v6/all-props/
`, "Plugins: https://atomiks.github.io/tippyjs/v6/plugins/"].join(" "));
  });
}
var zRe = function() {
  return "innerHTML";
};
function qg(t, e) {
  t[zRe()] = e;
}
function x3(t) {
  var e = Kl();
  return t === !0 ? e.className = g7 : (e.className = y7, Pd(t) ? e.appendChild(t) : qg(e, t)), e;
}
function _3(t, e) {
  Pd(e.content) ? (qg(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? qg(t, e.content) : t.textContent = e.content);
}
function Gg(t) {
  var e = t.firstElementChild, n = Rf(e.children);
  return {
    box: e,
    content: n.find(function(i) {
      return i.classList.contains(p7);
    }),
    arrow: n.find(function(i) {
      return i.classList.contains(g7) || i.classList.contains(y7);
    }),
    backdrop: n.find(function(i) {
      return i.classList.contains(yRe);
    })
  };
}
function C7(t) {
  var e = Kl(), n = Kl();
  n.className = gRe, n.setAttribute("data-state", "hidden"), n.setAttribute("tabindex", "-1");
  var i = Kl();
  i.className = p7, i.setAttribute("data-state", "hidden"), _3(i, t.props), e.appendChild(n), n.appendChild(i), r(t.props, t.props);
  function r(a, o) {
    var s = Gg(e), l = s.box, c = s.content, u = s.arrow;
    o.theme ? l.setAttribute("data-theme", o.theme) : l.removeAttribute("data-theme"), typeof o.animation == "string" ? l.setAttribute("data-animation", o.animation) : l.removeAttribute("data-animation"), o.inertia ? l.setAttribute("data-inertia", "") : l.removeAttribute("data-inertia"), l.style.maxWidth = typeof o.maxWidth == "number" ? o.maxWidth + "px" : o.maxWidth, o.role ? l.setAttribute("role", o.role) : l.removeAttribute("role"), (a.content !== o.content || a.allowHTML !== o.allowHTML) && _3(c, t.props), o.arrow ? u ? a.arrow !== o.arrow && (l.removeChild(u), l.appendChild(x3(o.arrow))) : l.appendChild(x3(o.arrow)) : u && l.removeChild(u);
  }
  return {
    popper: e,
    onUpdate: r
  };
}
C7.$$tippy = !0;
var VRe = 1, ou = [], Z1 = [];
function HRe(t, e) {
  var n = k3(t, Object.assign({}, di, _7(g3(e)))), i, r, a, o = !1, s = !1, l = !1, c = !1, u, f, m, h = [], p = h3(ce, n.interactiveDebounce), g, y = VRe++, v = null, w = kRe(n.plugins), x = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, b = {
    // properties
    id: y,
    reference: t,
    popper: Kl(),
    popperInstance: v,
    props: n,
    state: x,
    plugins: w,
    // methods
    clearDelayTimeouts: kt,
    setProps: xt,
    setContent: Zt,
    show: dl,
    hide: Kr,
    hideWithInteractivity: Ga,
    enable: Te,
    disable: Ve,
    unmount: vr,
    destroy: Xa
  };
  if (!n.render)
    return process.env.NODE_ENV !== "production" && Bg(!0, "render() function has not been supplied."), b;
  var M = n.render(b), _ = M.popper, N = M.onUpdate;
  _.setAttribute("data-tippy-root", ""), _.id = "tippy-" + b.id, b.popper = _, t._tippy = b, _._tippy = b;
  var $ = w.map(function(U) {
    return U.fn(b);
  }), D = t.hasAttribute("aria-expanded");
  return xe(), ae(), F(), z("onCreate", [b]), n.showOnCreate && fe(), _.addEventListener("mouseenter", function() {
    b.props.interactive && b.state.isVisible && b.clearDelayTimeouts();
  }), _.addEventListener("mouseleave", function() {
    b.props.interactive && b.props.trigger.indexOf("mouseenter") >= 0 && L().addEventListener("mousemove", p);
  }), b;
  function W() {
    var U = b.props.touch;
    return Array.isArray(U) ? U : [U, 0];
  }
  function j() {
    return W()[0] === "hold";
  }
  function O() {
    var U;
    return !!((U = b.props.render) != null && U.$$tippy);
  }
  function I() {
    return g || t;
  }
  function L() {
    var U = I().parentNode;
    return U ? SRe(U) : document;
  }
  function R() {
    return Gg(_);
  }
  function B(U) {
    return b.state.isMounted && !b.state.isVisible || rr.isTouch || u && u.type === "focus" ? 0 : U1(b.props.delay, U ? 0 : 1, di.delay);
  }
  function F(U) {
    U === void 0 && (U = !1), _.style.pointerEvents = b.props.interactive && !U ? "" : "none", _.style.zIndex = "" + b.props.zIndex;
  }
  function z(U, Me, Re) {
    if (Re === void 0 && (Re = !0), $.forEach(function(Qe) {
      Qe[U] && Qe[U].apply(Qe, Me);
    }), Re) {
      var it;
      (it = b.props)[U].apply(it, Me);
    }
  }
  function K() {
    var U = b.props.aria;
    if (U.content) {
      var Me = "aria-" + U.content, Re = _.id, it = es(b.props.triggerTarget || t);
      it.forEach(function(Qe) {
        var Se = Qe.getAttribute(Me);
        if (b.state.isVisible)
          Qe.setAttribute(Me, Se ? Se + " " + Re : Re);
        else {
          var Be = Se && Se.replace(Re, "").trim();
          Be ? Qe.setAttribute(Me, Be) : Qe.removeAttribute(Me);
        }
      });
    }
  }
  function ae() {
    if (!(D || !b.props.aria.expanded)) {
      var U = es(b.props.triggerTarget || t);
      U.forEach(function(Me) {
        b.props.interactive ? Me.setAttribute("aria-expanded", b.state.isVisible && Me === I() ? "true" : "false") : Me.removeAttribute("aria-expanded");
      });
    }
  }
  function Q() {
    L().removeEventListener("mousemove", p), ou = ou.filter(function(U) {
      return U !== p;
    });
  }
  function te(U) {
    if (!(rr.isTouch && (l || U.type === "mousedown"))) {
      var Me = U.composedPath && U.composedPath()[0] || U.target;
      if (!(b.props.interactive && v3(_, Me))) {
        if (es(b.props.triggerTarget || t).some(function(Re) {
          return v3(Re, Me);
        })) {
          if (rr.isTouch || b.state.isVisible && b.props.trigger.indexOf("click") >= 0)
            return;
        } else
          z("onClickOutside", [b, U]);
        b.props.hideOnClick === !0 && (b.clearDelayTimeouts(), b.hide(), s = !0, setTimeout(function() {
          s = !1;
        }), b.state.isMounted || $e());
      }
    }
  }
  function be() {
    l = !0;
  }
  function Pe() {
    l = !1;
  }
  function We() {
    var U = L();
    U.addEventListener("mousedown", te, !0), U.addEventListener("touchend", te, Qa), U.addEventListener("touchstart", Pe, Qa), U.addEventListener("touchmove", be, Qa);
  }
  function $e() {
    var U = L();
    U.removeEventListener("mousedown", te, !0), U.removeEventListener("touchend", te, Qa), U.removeEventListener("touchstart", Pe, Qa), U.removeEventListener("touchmove", be, Qa);
  }
  function Y(U, Me) {
    se(U, function() {
      !b.state.isVisible && _.parentNode && _.parentNode.contains(_) && Me();
    });
  }
  function oe(U, Me) {
    se(U, Me);
  }
  function se(U, Me) {
    var Re = R().box;
    function it(Qe) {
      Qe.target === Re && (Q1(Re, "remove", it), Me());
    }
    if (U === 0)
      return Me();
    Q1(Re, "remove", f), Q1(Re, "add", it), f = it;
  }
  function J(U, Me, Re) {
    Re === void 0 && (Re = !1);
    var it = es(b.props.triggerTarget || t);
    it.forEach(function(Qe) {
      Qe.addEventListener(U, Me, Re), h.push({
        node: Qe,
        eventType: U,
        handler: Me,
        options: Re
      });
    });
  }
  function xe() {
    j() && (J("touchstart", _e, {
      passive: !0
    }), J("touchend", wt, {
      passive: !0
    })), wRe(b.props.trigger).forEach(function(U) {
      if (U !== "manual")
        switch (J(U, _e), U) {
          case "mouseenter":
            J("mouseleave", wt);
            break;
          case "focus":
            J(ORe ? "focusout" : "blur", St);
            break;
          case "focusin":
            J("focusout", St);
            break;
        }
    });
  }
  function De() {
    h.forEach(function(U) {
      var Me = U.node, Re = U.eventType, it = U.handler, Qe = U.options;
      Me.removeEventListener(Re, it, Qe);
    }), h = [];
  }
  function _e(U) {
    var Me, Re = !1;
    if (!(!b.state.isEnabled || ze(U) || s)) {
      var it = ((Me = u) == null ? void 0 : Me.type) === "focus";
      u = U, g = U.currentTarget, ae(), !b.state.isVisible && MRe(U) && ou.forEach(function(Qe) {
        return Qe(U);
      }), U.type === "click" && (b.props.trigger.indexOf("mouseenter") < 0 || o) && b.props.hideOnClick !== !1 && b.state.isVisible ? Re = !0 : fe(U), U.type === "click" && (o = !Re), Re && !it && ne(U);
    }
  }
  function ce(U) {
    var Me = U.target, Re = I().contains(Me) || _.contains(Me);
    if (!(U.type === "mousemove" && Re)) {
      var it = de().concat(_).map(function(Qe) {
        var Se, Be = Qe._tippy, tt = (Se = Be.popperInstance) == null ? void 0 : Se.state;
        return tt ? {
          popperRect: Qe.getBoundingClientRect(),
          popperState: tt,
          props: n
        } : null;
      }).filter(Boolean);
      NRe(it, U) && (Q(), ne(U));
    }
  }
  function wt(U) {
    var Me = ze(U) || b.props.trigger.indexOf("click") >= 0 && o;
    if (!Me) {
      if (b.props.interactive) {
        b.hideWithInteractivity(U);
        return;
      }
      ne(U);
    }
  }
  function St(U) {
    b.props.trigger.indexOf("focusin") < 0 && U.target !== I() || b.props.interactive && U.relatedTarget && _.contains(U.relatedTarget) || ne(U);
  }
  function ze(U) {
    return rr.isTouch ? j() !== U.type.indexOf("touch") >= 0 : !1;
  }
  function A() {
    V();
    var U = b.props, Me = U.popperOptions, Re = U.placement, it = U.offset, Qe = U.getReferenceClientRect, Se = U.moveTransition, Be = O() ? Gg(_).arrow : null, tt = Qe ? {
      getBoundingClientRect: Qe,
      contextElement: Qe.contextElement || I()
    } : t, Ze = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(Gt) {
        var Cn = Gt.state;
        if (O()) {
          var ai = R(), Li = ai.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(oi) {
            oi === "placement" ? Li.setAttribute("data-placement", Cn.placement) : Cn.attributes.popper["data-popper-" + oi] ? Li.setAttribute("data-" + oi, "") : Li.removeAttribute("data-" + oi);
          }), Cn.attributes.popper = {};
        }
      }
    }, lt = [{
      name: "offset",
      options: {
        offset: it
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !Se
      }
    }, Ze];
    O() && Be && lt.push({
      name: "arrow",
      options: {
        element: Be,
        padding: 3
      }
    }), lt.push.apply(lt, (Me == null ? void 0 : Me.modifiers) || []), b.popperInstance = pRe(tt, _, Object.assign({}, Me, {
      placement: Re,
      onFirstUpdate: m,
      modifiers: lt
    }));
  }
  function V() {
    b.popperInstance && (b.popperInstance.destroy(), b.popperInstance = null);
  }
  function G() {
    var U = b.props.appendTo, Me, Re = I();
    b.props.interactive && U === v7 || U === "parent" ? Me = Re.parentNode : Me = b7(U, [Re]), Me.contains(_) || Me.appendChild(_), b.state.isMounted = !0, A(), process.env.NODE_ENV !== "production" && Nr(b.props.interactive && U === di.appendTo && Re.nextElementSibling !== _, ["Interactive tippy element may not be accessible via keyboard", "navigation because it is not directly after the reference element", "in the DOM source order.", `

`, "Using a wrapper <div> or <span> tag around the reference element", "solves this by creating a new parentNode context.", `

`, "Specifying `appendTo: document.body` silences this warning, but it", "assumes you are using a focus management solution to handle", "keyboard navigation.", `

`, "See: https://atomiks.github.io/tippyjs/v6/accessibility/#interactivity"].join(" "));
  }
  function de() {
    return Rf(_.querySelectorAll("[data-tippy-root]"));
  }
  function fe(U) {
    b.clearDelayTimeouts(), U && z("onTrigger", [b, U]), We();
    var Me = B(!0), Re = W(), it = Re[0], Qe = Re[1];
    rr.isTouch && it === "hold" && Qe && (Me = Qe), Me ? i = setTimeout(function() {
      b.show();
    }, Me) : b.show();
  }
  function ne(U) {
    if (b.clearDelayTimeouts(), z("onUntrigger", [b, U]), !b.state.isVisible) {
      $e();
      return;
    }
    if (!(b.props.trigger.indexOf("mouseenter") >= 0 && b.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf(U.type) >= 0 && o)) {
      var Me = B(!1);
      Me ? r = setTimeout(function() {
        b.state.isVisible && b.hide();
      }, Me) : a = requestAnimationFrame(function() {
        b.hide();
      });
    }
  }
  function Te() {
    b.state.isEnabled = !0;
  }
  function Ve() {
    b.hide(), b.state.isEnabled = !1;
  }
  function kt() {
    clearTimeout(i), clearTimeout(r), cancelAnimationFrame(a);
  }
  function xt(U) {
    if (process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("setProps")), !b.state.isDestroyed) {
      z("onBeforeUpdate", [b, U]), De();
      var Me = b.props, Re = k3(t, Object.assign({}, Me, g3(U), {
        ignoreAttributes: !0
      }));
      b.props = Re, xe(), Me.interactiveDebounce !== Re.interactiveDebounce && (Q(), p = h3(ce, Re.interactiveDebounce)), Me.triggerTarget && !Re.triggerTarget ? es(Me.triggerTarget).forEach(function(it) {
        it.removeAttribute("aria-expanded");
      }) : Re.triggerTarget && t.removeAttribute("aria-expanded"), ae(), F(), N && N(Me, Re), b.popperInstance && (A(), de().forEach(function(it) {
        requestAnimationFrame(it._tippy.popperInstance.forceUpdate);
      })), z("onAfterUpdate", [b, U]);
    }
  }
  function Zt(U) {
    b.setProps({
      content: U
    });
  }
  function dl() {
    process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("show"));
    var U = b.state.isVisible, Me = b.state.isDestroyed, Re = !b.state.isEnabled, it = rr.isTouch && !b.props.touch, Qe = U1(b.props.duration, 0, di.duration);
    if (!(U || Me || Re || it) && !I().hasAttribute("disabled") && (z("onShow", [b], !1), b.props.onShow(b) !== !1)) {
      if (b.state.isVisible = !0, O() && (_.style.visibility = "visible"), F(), We(), b.state.isMounted || (_.style.transition = "none"), O()) {
        var Se = R(), Be = Se.box, tt = Se.content;
        J1([Be, tt], 0);
      }
      m = function() {
        var lt;
        if (!(!b.state.isVisible || c)) {
          if (c = !0, _.offsetHeight, _.style.transition = b.props.moveTransition, O() && b.props.animation) {
            var en = R(), Gt = en.box, Cn = en.content;
            J1([Gt, Cn], Qe), y3([Gt, Cn], "visible");
          }
          K(), ae(), p3(Z1, b), (lt = b.popperInstance) == null || lt.forceUpdate(), z("onMount", [b]), b.props.animation && O() && oe(Qe, function() {
            b.state.isShown = !0, z("onShown", [b]);
          });
        }
      }, G();
    }
  }
  function Kr() {
    process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("hide"));
    var U = !b.state.isVisible, Me = b.state.isDestroyed, Re = !b.state.isEnabled, it = U1(b.props.duration, 1, di.duration);
    if (!(U || Me || Re) && (z("onHide", [b], !1), b.props.onHide(b) !== !1)) {
      if (b.state.isVisible = !1, b.state.isShown = !1, c = !1, o = !1, O() && (_.style.visibility = "hidden"), Q(), $e(), F(!0), O()) {
        var Qe = R(), Se = Qe.box, Be = Qe.content;
        b.props.animation && (J1([Se, Be], it), y3([Se, Be], "hidden"));
      }
      K(), ae(), b.props.animation ? O() && Y(it, b.unmount) : b.unmount();
    }
  }
  function Ga(U) {
    process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("hideWithInteractivity")), L().addEventListener("mousemove", p), p3(ou, p), p(U);
  }
  function vr() {
    process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("unmount")), b.state.isVisible && b.hide(), b.state.isMounted && (V(), de().forEach(function(U) {
      U._tippy.unmount();
    }), _.parentNode && _.parentNode.removeChild(_), Z1 = Z1.filter(function(U) {
      return U !== b;
    }), b.state.isMounted = !1, z("onHidden", [b]));
  }
  function Xa() {
    process.env.NODE_ENV !== "production" && Nr(b.state.isDestroyed, Xo("destroy")), !b.state.isDestroyed && (b.clearDelayTimeouts(), b.unmount(), De(), delete t._tippy, b.state.isDestroyed = !0, z("onDestroy", [b]));
  }
}
function al(t, e) {
  e === void 0 && (e = {});
  var n = di.plugins.concat(e.plugins || []);
  process.env.NODE_ENV !== "production" && (LRe(t), M7(e, n)), ERe();
  var i = Object.assign({}, e, {
    plugins: n
  }), r = PRe(t);
  if (process.env.NODE_ENV !== "production") {
    var a = Pd(i.content), o = r.length > 1;
    Nr(a && o, ["tippy() was passed an Element as the `content` prop, but more than", "one tippy instance was created by this invocation. This means the", "content element will only be appended to the last tippy instance.", `

`, "Instead, pass the .innerHTML of the element, or use a function that", "returns a cloned version of the element instead.", `

`, `1) content: element.innerHTML
`, "2) content: () => element.cloneNode(true)"].join(" "));
  }
  var s = r.reduce(function(l, c) {
    var u = c && HRe(c, i);
    return u && l.push(u), l;
  }, []);
  return Pd(t) ? s[0] : s;
}
al.defaultProps = di;
al.setDefaultProps = jRe;
al.currentInput = rr;
Object.assign({}, s7, {
  effect: function(e) {
    var n = e.state, i = {
      popper: {
        position: n.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(n.elements.popper.style, i.popper), n.styles = i, n.elements.arrow && Object.assign(n.elements.arrow.style, i.arrow);
  }
});
al.setDefaultProps({
  render: C7
});
class BRe {
  constructor({ editor: e, element: n, view: i, tippyOptions: r = {}, updateDelay: a = 250, shouldShow: o }) {
    this.preventHide = !1, this.shouldShow = ({ view: s, state: l, from: c, to: u }) => {
      const { doc: f, selection: m } = l, { empty: h } = m, p = !f.textBetween(c, u).length && xh(l.selection), g = this.element.contains(document.activeElement);
      return !(!(s.hasFocus() || g) || h || p || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: s }) => {
      var l;
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      s != null && s.relatedTarget && (!((l = this.element.parentNode) === null || l === void 0) && l.contains(s.relatedTarget)) || (s == null ? void 0 : s.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.tippyBlurHandler = (s) => {
      this.blurHandler({ event: s });
    }, this.handleDebouncedUpdate = (s, l) => {
      const c = !(l != null && l.selection.eq(s.state.selection)), u = !(l != null && l.doc.eq(s.state.doc));
      !c && !u || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(s, c, u, l);
      }, this.updateDelay));
    }, this.updateHandler = (s, l, c, u) => {
      var f, m, h;
      const { state: p, composing: g } = s, { selection: y } = p;
      if (g || !l && !c)
        return;
      this.createTooltip();
      const { ranges: w } = y, x = Math.min(...w.map((_) => _.$from.pos)), b = Math.max(...w.map((_) => _.$to.pos));
      if (!((f = this.shouldShow) === null || f === void 0 ? void 0 : f.call(this, {
        editor: this.editor,
        element: this.element,
        view: s,
        state: p,
        oldState: u,
        from: x,
        to: b
      }))) {
        this.hide();
        return;
      }
      (m = this.tippy) === null || m === void 0 || m.setProps({
        getReferenceClientRect: ((h = this.tippyOptions) === null || h === void 0 ? void 0 : h.getReferenceClientRect) || (() => {
          if (r7(p.selection)) {
            let _ = s.nodeDOM(x);
            if (_) {
              const N = _.dataset.nodeViewWrapper ? _ : _.querySelector("[data-node-view-wrapper]");
              if (N && (_ = N.firstChild), _)
                return _.getBoundingClientRect();
            }
          }
          return DLe(s, x, b);
        })
      }), this.show();
    }, this.editor = e, this.element = n, this.view = i, this.updateDelay = a, o && (this.shouldShow = o), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.tippyOptions = r, this.element.remove(), this.element.style.visibility = "visible";
  }
  createTooltip() {
    const { element: e } = this.editor.options, n = !!e.parentElement;
    this.tippy || !n || (this.tippy = al(e, {
      duration: 0,
      getReferenceClientRect: null,
      content: this.element,
      interactive: !0,
      trigger: "manual",
      placement: "top",
      hideOnClick: "toggle",
      ...this.tippyOptions
    }), this.tippy.popper.firstChild && this.tippy.popper.firstChild.addEventListener("blur", this.tippyBlurHandler));
  }
  update(e, n) {
    const { state: i } = e, r = i.selection.from !== i.selection.to;
    if (this.updateDelay > 0 && r) {
      this.handleDebouncedUpdate(e, n);
      return;
    }
    const a = !(n != null && n.selection.eq(e.state.selection)), o = !(n != null && n.doc.eq(e.state.doc));
    this.updateHandler(e, a, o, n);
  }
  show() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.show();
  }
  hide() {
    var e;
    (e = this.tippy) === null || e === void 0 || e.hide();
  }
  destroy() {
    var e, n;
    !((e = this.tippy) === null || e === void 0) && e.popper.firstChild && this.tippy.popper.firstChild.removeEventListener("blur", this.tippyBlurHandler), (n = this.tippy) === null || n === void 0 || n.destroy(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler);
  }
}
const P7 = (t) => new ft({
  key: typeof t.pluginKey == "string" ? new yt(t.pluginKey) : t.pluginKey,
  view: (e) => new BRe({ view: e, ...t })
});
gt.create({
  name: "bubbleMenu",
  addOptions() {
    return {
      element: null,
      tippyOptions: {},
      pluginKey: "bubbleMenu",
      updateDelay: void 0,
      shouldShow: null
    };
  },
  addProseMirrorPlugins() {
    return this.options.element ? [
      P7({
        pluginKey: this.options.pluginKey,
        editor: this.editor,
        element: this.options.element,
        tippyOptions: this.options.tippyOptions,
        updateDelay: this.options.updateDelay,
        shouldShow: this.options.shouldShow
      })
    ] : [];
  }
});
function qRe(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Xg = { exports: {} }, ep = {};
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var M3;
function GRe() {
  if (M3) return ep;
  M3 = 1;
  var t = H;
  function e(f, m) {
    return f === m && (f !== 0 || 1 / f === 1 / m) || f !== f && m !== m;
  }
  var n = typeof Object.is == "function" ? Object.is : e, i = t.useState, r = t.useEffect, a = t.useLayoutEffect, o = t.useDebugValue;
  function s(f, m) {
    var h = m(), p = i({ inst: { value: h, getSnapshot: m } }), g = p[0].inst, y = p[1];
    return a(function() {
      g.value = h, g.getSnapshot = m, l(g) && y({ inst: g });
    }, [f, h, m]), r(function() {
      return l(g) && y({ inst: g }), f(function() {
        l(g) && y({ inst: g });
      });
    }, [f]), o(h), h;
  }
  function l(f) {
    var m = f.getSnapshot;
    f = f.value;
    try {
      var h = m();
      return !n(f, h);
    } catch {
      return !0;
    }
  }
  function c(f, m) {
    return m();
  }
  var u = typeof window > "u" || typeof window.document > "u" || typeof window.document.createElement > "u" ? c : s;
  return ep.useSyncExternalStore = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : u, ep;
}
var tp = {};
/**
 * @license React
 * use-sync-external-store-shim.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var C3;
function XRe() {
  return C3 || (C3 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = H, e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function n(x) {
      {
        for (var b = arguments.length, M = new Array(b > 1 ? b - 1 : 0), _ = 1; _ < b; _++)
          M[_ - 1] = arguments[_];
        i("error", x, M);
      }
    }
    function i(x, b, M) {
      {
        var _ = e.ReactDebugCurrentFrame, N = _.getStackAddendum();
        N !== "" && (b += "%s", M = M.concat([N]));
        var $ = M.map(function(D) {
          return String(D);
        });
        $.unshift("Warning: " + b), Function.prototype.apply.call(console[x], console, $);
      }
    }
    function r(x, b) {
      return x === b && (x !== 0 || 1 / x === 1 / b) || x !== x && b !== b;
    }
    var a = typeof Object.is == "function" ? Object.is : r, o = t.useState, s = t.useEffect, l = t.useLayoutEffect, c = t.useDebugValue, u = !1, f = !1;
    function m(x, b, M) {
      u || t.startTransition !== void 0 && (u = !0, n("You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."));
      var _ = b();
      if (!f) {
        var N = b();
        a(_, N) || (n("The result of getSnapshot should be cached to avoid an infinite loop"), f = !0);
      }
      var $ = o({
        inst: {
          value: _,
          getSnapshot: b
        }
      }), D = $[0].inst, W = $[1];
      return l(function() {
        D.value = _, D.getSnapshot = b, h(D) && W({
          inst: D
        });
      }, [x, _, b]), s(function() {
        h(D) && W({
          inst: D
        });
        var j = function() {
          h(D) && W({
            inst: D
          });
        };
        return x(j);
      }, [x]), c(_), _;
    }
    function h(x) {
      var b = x.getSnapshot, M = x.value;
      try {
        var _ = b();
        return !a(M, _);
      } catch {
        return !0;
      }
    }
    function p(x, b, M) {
      return b();
    }
    var g = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u", y = !g, v = y ? p : m, w = t.useSyncExternalStore !== void 0 ? t.useSyncExternalStore : v;
    tp.useSyncExternalStore = w, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), tp;
}
process.env.NODE_ENV === "production" ? Xg.exports = GRe() : Xg.exports = XRe();
var Sh = Xg.exports;
const YRe = (...t) => (e) => {
  t.forEach((n) => {
    typeof n == "function" ? n(e) : n && (n.current = e);
  });
}, KRe = ({ contentComponent: t }) => {
  const e = Sh.useSyncExternalStore(t.subscribe, t.getSnapshot, t.getServerSnapshot);
  return H.createElement(H.Fragment, null, Object.values(e));
};
function URe() {
  const t = /* @__PURE__ */ new Set();
  let e = {};
  return {
    /**
     * Subscribe to the editor instance's changes.
     */
    subscribe(n) {
      return t.add(n), () => {
        t.delete(n);
      };
    },
    getSnapshot() {
      return e;
    },
    getServerSnapshot() {
      return e;
    },
    /**
     * Adds a new NodeView Renderer to the editor.
     */
    setRenderer(n, i) {
      e = {
        ...e,
        [n]: Em.createPortal(i.reactElement, i.element, n)
      }, t.forEach((r) => r());
    },
    /**
     * Removes a NodeView Renderer from the editor.
     */
    removeRenderer(n) {
      const i = { ...e };
      delete i[n], e = i, t.forEach((r) => r());
    }
  };
}
class JRe extends H.Component {
  constructor(e) {
    var n;
    super(e), this.editorContentRef = H.createRef(), this.initialized = !1, this.state = {
      hasContentComponentInitialized: !!(!((n = e.editor) === null || n === void 0) && n.contentComponent)
    };
  }
  componentDidMount() {
    this.init();
  }
  componentDidUpdate() {
    this.init();
  }
  init() {
    const e = this.props.editor;
    if (e && !e.isDestroyed && e.options.element) {
      if (e.contentComponent)
        return;
      const n = this.editorContentRef.current;
      n.append(...e.options.element.childNodes), e.setOptions({
        element: n
      }), e.contentComponent = URe(), this.state.hasContentComponentInitialized || (this.unsubscribeToContentComponent = e.contentComponent.subscribe(() => {
        this.setState((i) => i.hasContentComponentInitialized ? i : {
          hasContentComponentInitialized: !0
        }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent();
      })), e.createNodeViews(), this.initialized = !0;
    }
  }
  componentWillUnmount() {
    const e = this.props.editor;
    if (!e || (this.initialized = !1, e.isDestroyed || e.view.setProps({
      nodeViews: {}
    }), this.unsubscribeToContentComponent && this.unsubscribeToContentComponent(), e.contentComponent = null, !e.options.element.firstChild))
      return;
    const n = document.createElement("div");
    n.append(...e.options.element.childNodes), e.setOptions({
      element: n
    });
  }
  render() {
    const { editor: e, innerRef: n, ...i } = this.props;
    return H.createElement(
      H.Fragment,
      null,
      H.createElement("div", { ref: YRe(n, this.editorContentRef), ...i }),
      (e == null ? void 0 : e.contentComponent) && H.createElement(KRe, { contentComponent: e.contentComponent })
    );
  }
}
const QRe = X((t, e) => {
  const n = H.useMemo(() => Math.floor(Math.random() * 4294967295).toString(), [t.editor]);
  return H.createElement(JRe, {
    key: n,
    innerRef: e,
    ...t
  });
}), hb = H.memo(QRe);
var ZRe = function t(e, n) {
  if (e === n) return !0;
  if (e && n && typeof e == "object" && typeof n == "object") {
    if (e.constructor !== n.constructor) return !1;
    var i, r, a;
    if (Array.isArray(e)) {
      if (i = e.length, i != n.length) return !1;
      for (r = i; r-- !== 0; )
        if (!t(e[r], n[r])) return !1;
      return !0;
    }
    if (e instanceof Map && n instanceof Map) {
      if (e.size !== n.size) return !1;
      for (r of e.entries())
        if (!n.has(r[0])) return !1;
      for (r of e.entries())
        if (!t(r[1], n.get(r[0]))) return !1;
      return !0;
    }
    if (e instanceof Set && n instanceof Set) {
      if (e.size !== n.size) return !1;
      for (r of e.entries())
        if (!n.has(r[0])) return !1;
      return !0;
    }
    if (ArrayBuffer.isView(e) && ArrayBuffer.isView(n)) {
      if (i = e.length, i != n.length) return !1;
      for (r = i; r-- !== 0; )
        if (e[r] !== n[r]) return !1;
      return !0;
    }
    if (e.constructor === RegExp) return e.source === n.source && e.flags === n.flags;
    if (e.valueOf !== Object.prototype.valueOf) return e.valueOf() === n.valueOf();
    if (e.toString !== Object.prototype.toString) return e.toString() === n.toString();
    if (a = Object.keys(e), i = a.length, i !== Object.keys(n).length) return !1;
    for (r = i; r-- !== 0; )
      if (!Object.prototype.hasOwnProperty.call(n, a[r])) return !1;
    for (r = i; r-- !== 0; ) {
      var o = a[r];
      if (!(o === "_owner" && e.$$typeof) && !t(e[o], n[o]))
        return !1;
    }
    return !0;
  }
  return e !== e && n !== n;
}, eje = /* @__PURE__ */ qRe(ZRe), Yg = { exports: {} }, np = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var P3;
function tje() {
  if (P3) return np;
  P3 = 1;
  var t = H, e = Sh;
  function n(c, u) {
    return c === u && (c !== 0 || 1 / c === 1 / u) || c !== c && u !== u;
  }
  var i = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
  return np.useSyncExternalStoreWithSelector = function(c, u, f, m, h) {
    var p = a(null);
    if (p.current === null) {
      var g = { hasValue: !1, value: null };
      p.current = g;
    } else g = p.current;
    p = s(function() {
      function v(_) {
        if (!w) {
          if (w = !0, x = _, _ = m(_), h !== void 0 && g.hasValue) {
            var N = g.value;
            if (h(N, _)) return b = N;
          }
          return b = _;
        }
        if (N = b, i(x, _)) return N;
        var $ = m(_);
        return h !== void 0 && h(N, $) ? N : (x = _, b = $);
      }
      var w = !1, x, b, M = f === void 0 ? null : f;
      return [function() {
        return v(u());
      }, M === null ? void 0 : function() {
        return v(M());
      }];
    }, [u, f, m, h]);
    var y = r(c, p[0], p[1]);
    return o(function() {
      g.hasValue = !0, g.value = y;
    }, [y]), l(y), y;
  }, np;
}
var ip = {};
/**
 * @license React
 * use-sync-external-store-shim/with-selector.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var S3;
function nje() {
  return S3 || (S3 = 1, process.env.NODE_ENV !== "production" && function() {
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(new Error());
    var t = H, e = Sh;
    function n(u, f) {
      return u === f && (u !== 0 || 1 / u === 1 / f) || u !== u && f !== f;
    }
    var i = typeof Object.is == "function" ? Object.is : n, r = e.useSyncExternalStore, a = t.useRef, o = t.useEffect, s = t.useMemo, l = t.useDebugValue;
    function c(u, f, m, h, p) {
      var g = a(null), y;
      g.current === null ? (y = {
        hasValue: !1,
        value: null
      }, g.current = y) : y = g.current;
      var v = s(function() {
        var M = !1, _, N, $ = function(O) {
          if (!M) {
            M = !0, _ = O;
            var I = h(O);
            if (p !== void 0 && y.hasValue) {
              var L = y.value;
              if (p(L, I))
                return N = L, L;
            }
            return N = I, I;
          }
          var R = _, B = N;
          if (i(R, O))
            return B;
          var F = h(O);
          return p !== void 0 && p(B, F) ? B : (_ = O, N = F, F);
        }, D = m === void 0 ? null : m, W = function() {
          return $(f());
        }, j = D === null ? void 0 : function() {
          return $(D());
        };
        return [W, j];
      }, [f, m, h, p]), w = v[0], x = v[1], b = r(u, w, x);
      return o(function() {
        y.hasValue = !0, y.value = b;
      }, [b]), l(b), b;
    }
    ip.useSyncExternalStoreWithSelector = c, typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ < "u" && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop == "function" && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(new Error());
  }()), ip;
}
process.env.NODE_ENV === "production" ? Yg.exports = tje() : Yg.exports = nje();
var ije = Yg.exports;
const rje = typeof window < "u" ? Zd : le;
class aje {
  constructor(e) {
    this.transactionNumber = 0, this.lastTransactionNumber = 0, this.subscribers = /* @__PURE__ */ new Set(), this.editor = e, this.lastSnapshot = { editor: e, transactionNumber: 0 }, this.getSnapshot = this.getSnapshot.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.watch = this.watch.bind(this), this.subscribe = this.subscribe.bind(this);
  }
  /**
   * Get the current editor instance.
   */
  getSnapshot() {
    return this.transactionNumber === this.lastTransactionNumber ? this.lastSnapshot : (this.lastTransactionNumber = this.transactionNumber, this.lastSnapshot = { editor: this.editor, transactionNumber: this.transactionNumber }, this.lastSnapshot);
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return { editor: null, transactionNumber: 0 };
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscribers.add(e), () => {
      this.subscribers.delete(e);
    };
  }
  /**
   * Watch the editor instance for changes.
   */
  watch(e) {
    if (this.editor = e, this.editor) {
      const n = () => {
        this.transactionNumber += 1, this.subscribers.forEach((r) => r());
      }, i = this.editor;
      return i.on("transaction", n), () => {
        i.off("transaction", n);
      };
    }
  }
}
function oje(t) {
  var e;
  const [n] = q(() => new aje(t.editor)), i = ije.useSyncExternalStoreWithSelector(n.subscribe, n.getSnapshot, n.getServerSnapshot, t.selector, (e = t.equalityFn) !== null && e !== void 0 ? e : eje);
  return rje(() => n.watch(t.editor), [t.editor, n]), y5(i), i;
}
const N3 = process.env.NODE_ENV !== "production", Kg = typeof window > "u", sje = Kg || !!(typeof window < "u" && window.next);
class pb {
  constructor(e) {
    this.editor = null, this.subscriptions = /* @__PURE__ */ new Set(), this.isComponentMounted = !1, this.previousDeps = null, this.instanceId = "", this.options = e, this.subscriptions = /* @__PURE__ */ new Set(), this.setEditor(this.getInitialEditor()), this.scheduleDestroy(), this.getEditor = this.getEditor.bind(this), this.getServerSnapshot = this.getServerSnapshot.bind(this), this.subscribe = this.subscribe.bind(this), this.refreshEditorInstance = this.refreshEditorInstance.bind(this), this.scheduleDestroy = this.scheduleDestroy.bind(this), this.onRender = this.onRender.bind(this), this.createEditor = this.createEditor.bind(this);
  }
  setEditor(e) {
    this.editor = e, this.instanceId = Math.random().toString(36).slice(2, 9), this.subscriptions.forEach((n) => n());
  }
  getInitialEditor() {
    if (this.options.current.immediatelyRender === void 0)
      return Kg || sje ? (N3 && console.warn("Tiptap Error: SSR has been detected, please set `immediatelyRender` explicitly to `false` to avoid hydration mismatches."), null) : this.createEditor();
    if (this.options.current.immediatelyRender && Kg && N3)
      throw new Error("Tiptap Error: SSR has been detected, and `immediatelyRender` has been set to `true` this is an unsupported configuration that may result in errors, explicitly set `immediatelyRender` to `false` to avoid hydration mismatches.");
    return this.options.current.immediatelyRender ? this.createEditor() : null;
  }
  /**
   * Create a new editor instance. And attach event listeners.
   */
  createEditor() {
    const e = {
      ...this.options.current,
      // Always call the most recent version of the callback function by default
      onBeforeCreate: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onBeforeCreate) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onBlur: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onBlur) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onCreate: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onCreate) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onDestroy: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onDestroy) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onFocus: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onFocus) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onSelectionUpdate: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onSelectionUpdate) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onTransaction: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onTransaction) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onUpdate: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onUpdate) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onContentError: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onContentError) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onDrop: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onDrop) === null || a === void 0 ? void 0 : a.call(r, ...i);
      },
      onPaste: (...i) => {
        var r, a;
        return (a = (r = this.options.current).onPaste) === null || a === void 0 ? void 0 : a.call(r, ...i);
      }
    };
    return new sIe(e);
  }
  /**
   * Get the current editor instance.
   */
  getEditor() {
    return this.editor;
  }
  /**
   * Always disable the editor on the server-side.
   */
  getServerSnapshot() {
    return null;
  }
  /**
   * Subscribe to the editor instance's changes.
   */
  subscribe(e) {
    return this.subscriptions.add(e), () => {
      this.subscriptions.delete(e);
    };
  }
  static compareOptions(e, n) {
    return Object.keys(e).every((i) => ["onCreate", "onBeforeCreate", "onDestroy", "onUpdate", "onTransaction", "onFocus", "onBlur", "onSelectionUpdate", "onContentError", "onDrop", "onPaste"].includes(i) ? !0 : i === "extensions" && e.extensions && n.extensions ? e.extensions.length !== n.extensions.length ? !1 : e.extensions.every((r, a) => {
      var o;
      return r === ((o = n.extensions) === null || o === void 0 ? void 0 : o[a]);
    }) : e[i] === n[i]);
  }
  /**
   * On each render, we will create, update, or destroy the editor instance.
   * @param deps The dependencies to watch for changes
   * @returns A cleanup function
   */
  onRender(e) {
    return () => (this.isComponentMounted = !0, clearTimeout(this.scheduledDestructionTimeout), this.editor && !this.editor.isDestroyed && e.length === 0 ? pb.compareOptions(this.options.current, this.editor.options) || this.editor.setOptions({
      ...this.options.current,
      editable: this.editor.isEditable
    }) : this.refreshEditorInstance(e), () => {
      this.isComponentMounted = !1, this.scheduleDestroy();
    });
  }
  /**
   * Recreate the editor instance if the dependencies have changed.
   */
  refreshEditorInstance(e) {
    if (this.editor && !this.editor.isDestroyed) {
      if (this.previousDeps === null) {
        this.previousDeps = e;
        return;
      }
      if (this.previousDeps.length === e.length && this.previousDeps.every((i, r) => i === e[r]))
        return;
    }
    this.editor && !this.editor.isDestroyed && this.editor.destroy(), this.setEditor(this.createEditor()), this.previousDeps = e;
  }
  /**
   * Schedule the destruction of the editor instance.
   * This will only destroy the editor if it was not mounted on the next tick.
   * This is to avoid destroying the editor instance when it's actually still mounted.
   */
  scheduleDestroy() {
    const e = this.instanceId, n = this.editor;
    this.scheduledDestructionTimeout = setTimeout(() => {
      if (this.isComponentMounted && this.instanceId === e) {
        n && n.setOptions(this.options.current);
        return;
      }
      n && !n.isDestroyed && (n.destroy(), this.instanceId === e && this.setEditor(null));
    }, 1);
  }
}
function gb(t = {}, e = []) {
  const n = Oe(t);
  n.current = t;
  const [i] = q(() => new pb(n)), r = Sh.useSyncExternalStore(i.subscribe, i.getEditor, i.getServerSnapshot);
  return y5(r), le(i.onRender(e)), oje({
    editor: r,
    selector: ({ transactionNumber: a }) => t.shouldRerenderOnTransaction === !1 ? null : t.immediatelyRender && a === 0 ? 0 : a + 1
  }), r;
}
const S7 = hn({
  editor: null
});
S7.Consumer;
const lje = () => Wt(S7), dje = (t) => {
  const [e, n] = q(null), { editor: i } = lje();
  return le(() => {
    var r;
    if (!e || !((r = t.editor) === null || r === void 0) && r.isDestroyed || i != null && i.isDestroyed)
      return;
    const { pluginKey: a = "bubbleMenu", editor: o, tippyOptions: s = {}, updateDelay: l, shouldShow: c = null } = t, u = o || i;
    if (!u) {
      console.warn("BubbleMenu component is not rendered inside of an editor component or does not have editor prop.");
      return;
    }
    const f = P7({
      updateDelay: l,
      editor: u,
      element: e,
      pluginKey: a,
      shouldShow: c,
      tippyOptions: s
    });
    return u.registerPlugin(f), () => {
      u.unregisterPlugin(a);
    };
  }, [t.editor, i, e]), H.createElement("div", { ref: n, className: t.className, style: { visibility: "hidden" } }, t.children);
}, N7 = hn({
  onDragStart: void 0
}), $7 = () => Wt(N7), $c = (t) => {
  const e = t.as || "div", { nodeViewContentRef: n } = $7();
  return (
    // @ts-ignore
    H.createElement(e, { ...t, ref: n, "data-node-view-content": "", style: {
      whiteSpace: "pre-wrap",
      ...t.style
    } })
  );
}, Dc = H.forwardRef((t, e) => {
  const { onDragStart: n } = $7(), i = t.as || "div";
  return (
    // @ts-ignore
    H.createElement(i, { ...t, ref: e, "data-node-view-wrapper": "", onDragStart: n, style: {
      whiteSpace: "normal",
      ...t.style
    } })
  );
});
function $3(t) {
  return !!(typeof t == "function" && t.prototype && t.prototype.isReactComponent);
}
function D3(t) {
  return !!(typeof t == "object" && t.$$typeof && (t.$$typeof.toString() === "Symbol(react.forward_ref)" || t.$$typeof.description === "react.forward_ref"));
}
function cje(t) {
  return !!(typeof t == "object" && t.$$typeof && (t.$$typeof.toString() === "Symbol(react.memo)" || t.$$typeof.description === "react.memo"));
}
function uje(t) {
  if ($3(t) || D3(t))
    return !0;
  if (cje(t)) {
    const e = t.type;
    if (e)
      return $3(e) || D3(e);
  }
  return !1;
}
function fje() {
  try {
    if (uw)
      return parseInt(uw.split(".")[0], 10) >= 19;
  } catch {
  }
  return !1;
}
class yb {
  /**
   * Immediately creates element and renders the provided React component.
   */
  constructor(e, { editor: n, props: i = {}, as: r = "div", className: a = "" }) {
    this.ref = null, this.id = Math.floor(Math.random() * 4294967295).toString(), this.component = e, this.editor = n, this.props = i, this.element = document.createElement(r), this.element.classList.add("react-renderer"), a && this.element.classList.add(...a.split(" ")), queueMicrotask(() => {
      this.render();
    });
  }
  /**
   * Render the React component.
   */
  render() {
    var e;
    const n = this.component, i = this.props, r = this.editor, a = fje(), o = uje(n), s = { ...i };
    s.ref && !(a || o) && delete s.ref, !s.ref && (a || o) && (s.ref = (l) => {
      this.ref = l;
    }), this.reactElement = H.createElement(n, { ...s }), (e = r == null ? void 0 : r.contentComponent) === null || e === void 0 || e.setRenderer(this.id, this);
  }
  /**
   * Re-renders the React component with new props.
   */
  updateProps(e = {}) {
    this.props = {
      ...this.props,
      ...e
    }, this.render();
  }
  /**
   * Destroy the React component.
   */
  destroy() {
    var e;
    const n = this.editor;
    (e = n == null ? void 0 : n.contentComponent) === null || e === void 0 || e.removeRenderer(this.id);
  }
  /**
   * Update the attributes of the element that holds the React component.
   */
  updateAttributes(e) {
    Object.keys(e).forEach((n) => {
      this.element.setAttribute(n, e[n]);
    });
  }
}
class mje extends dIe {
  constructor(e, n, i) {
    super(e, n, i), this.node.isLeaf || (this.options.contentDOMElementTag ? this.contentDOMElement = document.createElement(this.options.contentDOMElementTag) : this.contentDOMElement = document.createElement(this.node.isInline ? "span" : "div"), this.contentDOMElement.dataset.nodeViewContentReact = "", this.contentDOMElement.dataset.nodeViewWrapper = "", this.contentDOMElement.style.whiteSpace = "inherit", this.dom.appendChild(this.contentDOMElement));
  }
  /**
   * Setup the React component.
   * Called on initialization.
   */
  mount() {
    const e = {
      editor: this.editor,
      node: this.node,
      decorations: this.decorations,
      innerDecorations: this.innerDecorations,
      view: this.view,
      selected: !1,
      extension: this.extension,
      HTMLAttributes: this.HTMLAttributes,
      getPos: () => this.getPos(),
      updateAttributes: (c = {}) => this.updateAttributes(c),
      deleteNode: () => this.deleteNode(),
      ref: TD()
    };
    if (!this.component.displayName) {
      const c = (u) => u.charAt(0).toUpperCase() + u.substring(1);
      this.component.displayName = c(this.extension.name);
    }
    const r = { onDragStart: this.onDragStart.bind(this), nodeViewContentRef: (c) => {
      c && this.contentDOMElement && c.firstChild !== this.contentDOMElement && (c.hasAttribute("data-node-view-wrapper") && c.removeAttribute("data-node-view-wrapper"), c.appendChild(this.contentDOMElement));
    } }, a = this.component, o = ec((c) => H.createElement(N7.Provider, { value: r }, Gu(a, c)));
    o.displayName = "ReactNodeView";
    let s = this.node.isInline ? "span" : "div";
    this.options.as && (s = this.options.as);
    const { className: l = "" } = this.options;
    this.handleSelectionUpdate = this.handleSelectionUpdate.bind(this), this.renderer = new yb(o, {
      editor: this.editor,
      props: e,
      as: s,
      className: `node-${this.node.type.name} ${l}`.trim()
    }), this.editor.on("selectionUpdate", this.handleSelectionUpdate), this.updateElementAttributes();
  }
  /**
   * Return the DOM element.
   * This is the element that will be used to display the node view.
   */
  get dom() {
    var e;
    if (this.renderer.element.firstElementChild && !(!((e = this.renderer.element.firstElementChild) === null || e === void 0) && e.hasAttribute("data-node-view-wrapper")))
      throw Error("Please use the NodeViewWrapper component for your node view.");
    return this.renderer.element;
  }
  /**
   * Return the content DOM element.
   * This is the element that will be used to display the rich-text content of the node.
   */
  get contentDOM() {
    return this.node.isLeaf ? null : this.contentDOMElement;
  }
  /**
   * On editor selection update, check if the node is selected.
   * If it is, call `selectNode`, otherwise call `deselectNode`.
   */
  handleSelectionUpdate() {
    const { from: e, to: n } = this.editor.state.selection, i = this.getPos();
    if (typeof i == "number")
      if (e <= i && n >= i + this.node.nodeSize) {
        if (this.renderer.props.selected)
          return;
        this.selectNode();
      } else {
        if (!this.renderer.props.selected)
          return;
        this.deselectNode();
      }
  }
  /**
   * On update, update the React component.
   * To prevent unnecessary updates, the `update` option can be used.
   */
  update(e, n, i) {
    const r = (a) => {
      this.renderer.updateProps(a), typeof this.options.attrs == "function" && this.updateElementAttributes();
    };
    if (e.type !== this.node.type)
      return !1;
    if (typeof this.options.update == "function") {
      const a = this.node, o = this.decorations, s = this.innerDecorations;
      return this.node = e, this.decorations = n, this.innerDecorations = i, this.options.update({
        oldNode: a,
        oldDecorations: o,
        newNode: e,
        newDecorations: n,
        oldInnerDecorations: s,
        innerDecorations: i,
        updateProps: () => r({ node: e, decorations: n, innerDecorations: i })
      });
    }
    return e === this.node && this.decorations === n && this.innerDecorations === i || (this.node = e, this.decorations = n, this.innerDecorations = i, r({ node: e, decorations: n, innerDecorations: i })), !0;
  }
  /**
   * Select the node.
   * Add the `selected` prop and the `ProseMirror-selectednode` class.
   */
  selectNode() {
    this.renderer.updateProps({
      selected: !0
    }), this.renderer.element.classList.add("ProseMirror-selectednode");
  }
  /**
   * Deselect the node.
   * Remove the `selected` prop and the `ProseMirror-selectednode` class.
   */
  deselectNode() {
    this.renderer.updateProps({
      selected: !1
    }), this.renderer.element.classList.remove("ProseMirror-selectednode");
  }
  /**
   * Destroy the React component instance.
   */
  destroy() {
    this.renderer.destroy(), this.editor.off("selectionUpdate", this.handleSelectionUpdate), this.contentDOMElement = null;
  }
  /**
   * Update the attributes of the top-level element that holds the React component.
   * Applying the attributes defined in the `attrs` option.
   */
  updateElementAttributes() {
    if (this.options.attrs) {
      let e = {};
      if (typeof this.options.attrs == "function") {
        const n = this.editor.extensionManager.attributes, i = Af(this.node, n);
        e = this.options.attrs({ node: this.node, HTMLAttributes: i });
      } else
        e = this.options.attrs;
      this.renderer.updateAttributes(e);
    }
  }
}
function Ec(t, e) {
  return (n) => n.editor.contentComponent ? new mje(t, n, e) : {};
}
const Nd = X(
  ({
    onClick: t = () => {
    },
    active: e = !1,
    label: n,
    disabled: i,
    icon: r,
    tooltip: a,
    showLabel: o = !1,
    ...s
  }, l) => {
    const c = /* @__PURE__ */ k(
      ga,
      {
        ref: l,
        variant: "ghost",
        size: "md",
        onClick: (u) => {
          u.preventDefault(), i || t();
        },
        className: E(
          "flex items-center gap-1 border border-solid font-medium leading-tight shadow-none transition-all active:scale-90 motion-reduce:transition-none motion-reduce:active:scale-100 [&>button]:m-[-1px] [&>button]:aspect-square [&>button]:px-0",
          e ? "border-f1-border-selected bg-f1-background-selected hover:border-f1-border-selected-bold" : "border-f1-background bg-transparent hover:border-f1-background-secondary hover:bg-f1-background-secondary-hover",
          o && "w-full items-center justify-start px-2"
        ),
        disabled: i,
        "aria-label": n,
        ...s,
        children: [
          /* @__PURE__ */ d(
            me,
            {
              icon: r,
              className: e ? "text-f1-icon-selected" : "text-f1-foreground"
            }
          ),
          o && /* @__PURE__ */ d(
            "span",
            {
              className: E(
                "text-sm",
                e && "text-f1-background-selected-bold"
              ),
              children: n
            }
          )
        ]
      }
    );
    return a ? /* @__PURE__ */ d(
      Kt,
      {
        description: (a == null ? void 0 : a.description) || "",
        label: a == null ? void 0 : a.label,
        shortcut: a == null ? void 0 : a.shortcut,
        children: c
      }
    ) : c;
  }
);
Nd.displayName = "ToolbarButton";
const hje = ({ editor: t, disabled: e, labels: n }) => {
  const i = et(), [r, a] = q(!1), [o, s] = q(t.getAttributes("link").href || ""), l = (p) => {
    p && p.preventDefault(), !e && a(!r);
  }, c = (p) => {
    const g = p.trim();
    return /^(https?:\/\/)([\w-]+(\.[\w-]+)+)(:[0-9]{1,5})?(\/.*)?$/i.test(
      g
    );
  }, u = () => {
    const p = o.trim();
    p && c(p) && (t.chain().focus().extendMarkRange("link").setLink({ href: p }).run(), a(!1));
  }, f = () => {
    s(""), navigator.clipboard.readText().then((p) => {
      s(p);
    });
  }, m = () => {
    t.chain().focus().unsetLink().run(), s("");
  }, h = () => {
    a(!1);
  };
  return /* @__PURE__ */ k(
    Jd,
    {
      open: r,
      onOpenChange: (p) => {
        a(p), p && s(t.getAttributes("link").href || "");
      },
      children: [
        /* @__PURE__ */ d(Oy, { asChild: !0, children: /* @__PURE__ */ d(
          Nd,
          {
            active: t.isActive("link") || r,
            label: n.linkLabel,
            icon: fw,
            disabled: e,
            onClick: l
          }
        ) }),
        /* @__PURE__ */ d(Wy, { container: document.body, children: /* @__PURE__ */ d(
          Qd,
          {
            side: "top",
            align: "start",
            sideOffset: 10,
            collisionPadding: 10,
            alignOffset: -5,
            style: { zIndex: 9999 },
            children: /* @__PURE__ */ d(Ue, { children: r && /* @__PURE__ */ d(
              re.div,
              {
                initial: { opacity: 0, y: 10, scale: 0.95 },
                animate: { opacity: 1, y: 0, scale: 1 },
                exit: { opacity: 0, y: 10, scale: 0.95 },
                transition: { duration: 0.2 },
                "aria-label": "Link popup",
                children: /* @__PURE__ */ k("div", { className: "dark z-50 flex w-max flex-row gap-1 rounded-lg border border-solid border-f1-border bg-f1-background p-1 drop-shadow-sm", children: [
                  /* @__PURE__ */ d(
                    ga,
                    {
                      variant: "ghost",
                      size: "md",
                      onClick: (p) => {
                        p.preventDefault(), h();
                      },
                      className: "[&>button]:aspect-square [&>button]:px-0",
                      children: /* @__PURE__ */ d(me, { icon: Rr })
                    }
                  ),
                  /* @__PURE__ */ k(
                    "div",
                    {
                      className: E(
                        "flex w-80 appearance-none items-center gap-2 rounded border-0 bg-f1-background py-1 pl-2 pr-1 ring-1 ring-inset ring-f1-border transition-all placeholder:text-f1-foreground-tertiary",
                        t.isActive("link") ? "cursor-auto" : Ke("focus:ring-f1-border-hover") + "hover:ring-f1-border-hover"
                      ),
                      children: [
                        /* @__PURE__ */ d(
                          "div",
                          {
                            className: E(
                              "flex items-center justify-center",
                              o.length > 0 ? "w-6" : "w-4"
                            ),
                            children: /* @__PURE__ */ d(
                              Xy,
                              {
                                icon: o.length > 0 ? c(o) ? Nm : LD : fw,
                                type: o ? c(o) ? "positive" : "warning" : "neutral",
                                size: o.length > 0 ? "sm" : "lg"
                              }
                            )
                          }
                        ),
                        /* @__PURE__ */ d(
                          "input",
                          {
                            className: "w-full shrink text-f1-foreground disabled:cursor-not-allowed",
                            type: "text",
                            placeholder: n.linkPlaceholder,
                            value: o,
                            onChange: (p) => s(p.target.value),
                            onKeyDown: (p) => {
                              p.key === "Enter" && u();
                            }
                          }
                        ),
                        t.isActive("link") && /* @__PURE__ */ d(
                          me,
                          {
                            size: "md",
                            icon: vs,
                            className: "cursor-pointer text-f1-foreground-tertiary hover:text-f1-foreground-secondary",
                            onClick: m
                          }
                        ),
                        /* @__PURE__ */ d(
                          ga,
                          {
                            variant: "outline",
                            type: "button",
                            size: "sm",
                            onClick: f,
                            children: n.linkPaste
                          }
                        )
                      ]
                    }
                  ),
                  /* @__PURE__ */ d(
                    ga,
                    {
                      variant: "default",
                      type: "button",
                      size: "sm",
                      onClick: (p) => {
                        p.preventDefault(), u();
                      },
                      children: i.actions.save
                    }
                  )
                ] })
              }
            ) })
          }
        ) })
      ]
    }
  );
}, js = ({ hidden: t = !1 }) => /* @__PURE__ */ d(
  "div",
  {
    className: E(
      "mx-1 h-4 w-[1px] flex-shrink-0 bg-f1-foreground-disabled",
      t && "hidden"
    )
  }
), E3 = ({
  items: t,
  disabled: e = !1,
  activator: n,
  darkMode: i = !1,
  position: r = "top"
}) => {
  const [a, o] = q(!1), s = (c) => {
    c(), o(!1);
  }, l = () => {
    e || o(!a);
  };
  return /* @__PURE__ */ k(Jd, { open: a, modal: !1, onOpenChange: o, children: [
    /* @__PURE__ */ d(Oy, { asChild: !0, children: /* @__PURE__ */ d(
      Nd,
      {
        label: n.label,
        icon: n.icon,
        disabled: e,
        onClick: l
      }
    ) }),
    /* @__PURE__ */ d(Wy, { container: document.body, children: /* @__PURE__ */ d(
      Qd,
      {
        side: r,
        align: "end",
        sideOffset: 10,
        collisionPadding: 10,
        alignOffset: 0,
        style: { zIndex: 9999 },
        children: /* @__PURE__ */ d(Ue, { children: a && /* @__PURE__ */ d(
          re.div,
          {
            initial: { opacity: 0, scale: 0.95, y: 5 },
            animate: { opacity: 1, scale: 1, y: 0 },
            exit: { opacity: 0, scale: 0.95, y: 5 },
            transition: { duration: 0.15 },
            className: E(
              "flex w-40 flex-col gap-0.5 overflow-hidden rounded-md border border-solid border-f1-border bg-f1-background p-0.5 drop-shadow-sm",
              i && "dark"
            ),
            children: t.map((c, u) => /* @__PURE__ */ d(
              Nd,
              {
                onClick: () => s(c.onClick),
                active: c.isActive,
                label: c.label,
                disabled: e || !!c.disabled,
                icon: c.icon,
                showLabel: !0
              },
              `${c.label}-${u}`
            ))
          }
        ) })
      }
    ) })
  ] });
}, pje = (t) => t.isActive({ textAlign: "left" }) ? "Left" : t.isActive({ textAlign: "center" }) ? "Center" : t.isActive({ textAlign: "right" }) ? "Right" : t.isActive({ textAlign: "justify" }) ? "Justify" : "Left", gje = (t) => t.isActive({ textAlign: "left" }) ? Np : t.isActive({ textAlign: "center" }) ? b5 : t.isActive({ textAlign: "right" }) ? k5 : t.isActive({ textAlign: "justify" }) ? w5 : Np, yje = (t, e) => t.map((n, i) => /* @__PURE__ */ k(H.Fragment, { children: [
  n,
  i < t.length - 1 && e
] }, `intersperse-${i}`)), D7 = ({
  editor: t,
  isFullscreen: e = !1,
  disableButtons: n,
  onClose: i,
  animationComplete: r = !0,
  labels: a,
  darkMode: o = !1,
  showEmojiPicker: s = !0,
  plainHtmlMode: l = !1
}) => {
  const c = [
    {
      key: "bold",
      icon: qD,
      active: (x) => x.isActive("bold"),
      onClick: (x) => x.chain().focus().toggleBold().run(),
      tooltip: {
        label: `**${a.bold}**`,
        shortcut: ["cmd", "b"]
      }
    },
    {
      key: "italic",
      icon: EE,
      active: (x) => x.isActive("italic"),
      onClick: (x) => x.chain().focus().toggleItalic().run(),
      tooltip: {
        label: `*${a.italic}*`,
        shortcut: ["cmd", "i"]
      }
    },
    {
      key: "underline",
      icon: PT,
      active: (x) => x.isActive("underline"),
      onClick: (x) => x.chain().focus().toggleUnderline().run(),
      tooltip: {
        label: `_${a.underline}_`,
        shortcut: ["cmd", "u"]
      }
    },
    {
      key: "strike",
      icon: wT,
      active: (x) => x.isActive("strike"),
      onClick: (x) => x.chain().focus().toggleStrike().run(),
      tooltip: {
        label: `~${a.strike}~`,
        shortcut: ["cmd", "shift", "s"]
      }
    }
  ], u = [
    {
      key: "heading1",
      icon: P5,
      active: (x) => x.isActive("heading", { level: 1 }),
      onClick: (x) => x.chain().focus().toggleHeading({ level: 1 }).run(),
      tooltip: {
        label: `# ${a.heading1}`,
        shortcut: ["cmd", "1"]
      }
    },
    {
      key: "heading2",
      icon: S5,
      active: (x) => x.isActive("heading", { level: 2 }),
      onClick: (x) => x.chain().focus().toggleHeading({ level: 2 }).run(),
      tooltip: {
        label: `## ${a.heading2}`,
        shortcut: ["cmd", "2"]
      }
    },
    {
      key: "heading3",
      icon: N5,
      active: (x) => x.isActive("heading", { level: 3 }),
      onClick: (x) => x.chain().focus().toggleHeading({ level: 3 }).run(),
      tooltip: {
        label: `### ${a.heading3}`,
        shortcut: ["cmd", "3"]
      }
    }
  ], f = [
    {
      key: "bulletList",
      icon: Ry,
      active: (x) => x.isActive("bulletList"),
      onClick: (x) => x.chain().focus().toggleBulletList().run(),
      tooltip: {
        label: `- ${a.bulletList}`,
        shortcut: ["cmd", "alt", "8"]
      }
    },
    {
      key: "orderedList",
      icon: E5,
      active: (x) => x.isActive("orderedList"),
      onClick: (x) => x.chain().focus().toggleOrderedList().run(),
      tooltip: {
        label: `1. ${a.orderedList}`,
        shortcut: ["cmd", "alt", "7"]
      }
    },
    ...l ? [] : [
      {
        key: "taskList",
        icon: _5,
        active: (x) => x.isActive("taskList"),
        onClick: (x) => x.chain().focus().toggleTaskList().run(),
        tooltip: {
          label: `[ ] ${a.taskList}`,
          shortcut: ["cmd", "alt", "t"]
        }
      },
      {
        key: "highlight",
        icon: ZE,
        active: (x) => x.isActive("highlight"),
        onClick: (x) => x.chain().focus().toggleHighlight().run(),
        tooltip: {
          label: `==${a.highlight}==`,
          shortcut: ["cmd", "alt", "h"]
        }
      }
    ]
  ], m = (x) => /* @__PURE__ */ d("div", { className: "flex flex-row items-center gap-0.5", children: x.map((b) => /* @__PURE__ */ d(
    Nd,
    {
      active: b.active(t),
      label: a[b.key],
      icon: b.icon,
      disabled: n,
      onClick: () => b.onClick(t),
      tooltip: b.tooltip
    },
    b.key
  )) }), h = m(c), p = m(u), g = /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-0.5", children: [
    /* @__PURE__ */ d(
      E3,
      {
        darkMode: o,
        items: [
          {
            label: a.left,
            icon: Np,
            onClick: () => t.chain().focus().setTextAlign("left").run(),
            isActive: t.isActive({ textAlign: "left" }) || !t.isActive({ textAlign: "justify" }) && !t.isActive({ textAlign: "center" }) && !t.isActive({ textAlign: "right" })
          },
          {
            label: a.center,
            icon: b5,
            onClick: () => t.chain().focus().setTextAlign("center").run(),
            isActive: t.isActive({ textAlign: "center" })
          },
          {
            label: a.right,
            icon: k5,
            onClick: () => t.chain().focus().setTextAlign("right").run(),
            isActive: t.isActive({ textAlign: "right" })
          },
          {
            label: a.justify,
            icon: w5,
            onClick: () => t.chain().focus().setTextAlign("justify").run(),
            isActive: t.isActive({ textAlign: "justify" })
          }
        ],
        disabled: n,
        activator: {
          label: pje(t),
          icon: gje(t)
        }
      }
    ),
    /* @__PURE__ */ d(js, { hidden: !e }),
    m(f),
    /* @__PURE__ */ d(
      E3,
      {
        darkMode: o,
        items: [
          {
            icon: C5,
            label: a.codeBlock,
            onClick: () => t.chain().focus().toggleCodeBlock().run(),
            isActive: t.isActive("codeBlock")
          },
          {
            icon: jy,
            label: a.divider,
            onClick: () => t.chain().focus().setHorizontalRule().run(),
            isActive: t.isActive("horizontalRule")
          },
          {
            icon: A5,
            label: a.quote,
            onClick: () => t.chain().focus().toggleBlockquote().run(),
            isActive: t.isActive("blockquote")
          }
        ],
        disabled: n,
        activator: {
          label: a.moreOptions,
          icon: Tm
        }
      }
    )
  ] }), y = [
    /* @__PURE__ */ d(
      hje,
      {
        editor: t,
        disabled: n,
        labels: a
      },
      "link-popup"
    )
  ], v = /* @__PURE__ */ d(
    Tv,
    {
      variant: "ghost",
      onSelect: (x) => {
        t.chain().focus().insertContent(x).run();
      }
    }
  ), w = f5.compact([
    y,
    s && v,
    h,
    p,
    g
  ]);
  return /* @__PURE__ */ k("div", { className: E("flex flex-row items-start gap-2 overflow-hidden"), children: [
    i && /* @__PURE__ */ d(
      ue,
      {
        onClick: (x) => {
          x.preventDefault(), i();
        },
        variant: "neutral",
        size: "md",
        disabled: n,
        type: "button",
        hideLabel: !0,
        round: !0,
        label: a.close,
        icon: Rr
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        className: E(
          "flex grow flex-row items-center",
          r ? "scrollbar-macos overflow-x-auto" : "overflow-hidden"
        ),
        children: yje(w, /* @__PURE__ */ d(js, {}))
      }
    )
  ] });
}, E7 = ({
  editorId: t,
  editor: e,
  disableButtons: n,
  toolbarLabels: i,
  isToolbarOpen: r,
  isFullscreen: a,
  plainHtmlMode: o = !1
}) => /* @__PURE__ */ d(
  dje,
  {
    tippyOptions: {
      duration: 100,
      placement: "top",
      hideOnClick: !1,
      appendTo: () => a ? document.body : document.getElementById(t) || document.body,
      zIndex: 9999
    },
    editor: e,
    shouldShow: ({ view: s, state: l, from: c, to: u }) => {
      var v;
      const { doc: f, selection: m } = l, { empty: h } = m;
      if (m instanceof Ae)
        return !1;
      const p = !f.textBetween(c, u).length && xh(l.selection), g = (v = document.getElementById(t)) == null ? void 0 : v.contains(document.activeElement);
      return !(!(s.hasFocus() || g) || h || p || !e.isEditable);
    },
    children: !r && /* @__PURE__ */ d("div", { className: "dark z-50 flex w-max flex-row items-center rounded-lg border border-solid border-f1-border bg-f1-background p-1 drop-shadow-sm", children: /* @__PURE__ */ d(
      D7,
      {
        labels: i,
        editor: e,
        disableButtons: n,
        darkMode: !0,
        showEmojiPicker: !1,
        plainHtmlMode: o
      }
    ) })
  }
), vje = (t) => {
  if (!t.children.length)
    return;
  const e = t.querySelectorAll("span");
  e && e.forEach((n) => {
    var i, r;
    const a = n.getAttribute("style"), o = (r = (i = n.parentElement) === null || i === void 0 ? void 0 : i.closest("span")) === null || r === void 0 ? void 0 : r.getAttribute("style");
    n.setAttribute("style", `${o};${a}`);
  });
}, bje = Di.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !1
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        getAttrs: (t) => t.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && vje(t), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      removeEmptyTextStyle: () => ({ tr: t }) => {
        const { selection: e } = t;
        return t.doc.nodesBetween(e.from, e.to, (n, i) => {
          if (n.isTextblock)
            return !0;
          n.marks.filter((r) => r.type === this.type).some((r) => Object.values(r.attrs).some((a) => !!a)) || t.removeMark(i, i + n.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), wje = gt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (t) => {
              var e;
              return (e = t.style.color) === null || e === void 0 ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.color ? {
              style: `color: ${t.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (t) => ({ chain: e }) => e().setMark("textStyle", { color: t }).run(),
      unsetColor: () => ({ chain: t }) => t().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), vb = wje, kje = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, xje = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, _je = Di.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-color") || t.style.backgroundColor,
        renderHTML: (t) => t.color ? {
          "data-color": t.color,
          style: `background-color: ${t.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mark", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setHighlight: (t) => ({ commands: e }) => e.setMark(this.name, t),
      toggleHighlight: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      unsetHighlight: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      xo({
        find: kje,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Na({
        find: xje,
        type: this.type
      })
    ];
  }
}), bb = _je, wb = bje, Mje = (t) => Rt({
  find: /--$/,
  replace: t ?? "—"
}), Cje = (t) => Rt({
  find: /\.\.\.$/,
  replace: t ?? "…"
}), Pje = (t) => Rt({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(")$/,
  replace: t ?? "“"
}), Sje = (t) => Rt({
  find: /"$/,
  replace: t ?? "”"
}), Nje = (t) => Rt({
  find: /(?:^|[\s{[(<'"\u2018\u201C])(')$/,
  replace: t ?? "‘"
}), $je = (t) => Rt({
  find: /'$/,
  replace: t ?? "’"
}), Dje = (t) => Rt({
  find: /<-$/,
  replace: t ?? "←"
}), Eje = (t) => Rt({
  find: /->$/,
  replace: t ?? "→"
}), Tje = (t) => Rt({
  find: /\(c\)$/,
  replace: t ?? "©"
}), Oje = (t) => Rt({
  find: /\(tm\)$/,
  replace: t ?? "™"
}), Wje = (t) => Rt({
  find: /\(sm\)$/,
  replace: t ?? "℠"
}), Aje = (t) => Rt({
  find: /\(r\)$/,
  replace: t ?? "®"
}), Lje = (t) => Rt({
  find: /(?:^|\s)(1\/2)\s$/,
  replace: t ?? "½"
}), Ije = (t) => Rt({
  find: /\+\/-$/,
  replace: t ?? "±"
}), Rje = (t) => Rt({
  find: /!=$/,
  replace: t ?? "≠"
}), jje = (t) => Rt({
  find: /<<$/,
  replace: t ?? "«"
}), Fje = (t) => Rt({
  find: />>$/,
  replace: t ?? "»"
}), zje = (t) => Rt({
  find: /\d+\s?([*x])\s?\d+$/,
  replace: t ?? "×"
}), Vje = (t) => Rt({
  find: /\^2$/,
  replace: t ?? "²"
}), Hje = (t) => Rt({
  find: /\^3$/,
  replace: t ?? "³"
}), Bje = (t) => Rt({
  find: /(?:^|\s)(1\/4)\s$/,
  replace: t ?? "¼"
}), qje = (t) => Rt({
  find: /(?:^|\s)(3\/4)\s$/,
  replace: t ?? "¾"
}), Gje = gt.create({
  name: "typography",
  addOptions() {
    return {
      closeDoubleQuote: "”",
      closeSingleQuote: "’",
      copyright: "©",
      ellipsis: "…",
      emDash: "—",
      laquo: "«",
      leftArrow: "←",
      multiplication: "×",
      notEqual: "≠",
      oneHalf: "½",
      oneQuarter: "¼",
      openDoubleQuote: "“",
      openSingleQuote: "‘",
      plusMinus: "±",
      raquo: "»",
      registeredTrademark: "®",
      rightArrow: "→",
      servicemark: "℠",
      superscriptThree: "³",
      superscriptTwo: "²",
      threeQuarters: "¾",
      trademark: "™"
    };
  },
  addInputRules() {
    const t = [];
    return this.options.emDash !== !1 && t.push(Mje(this.options.emDash)), this.options.ellipsis !== !1 && t.push(Cje(this.options.ellipsis)), this.options.openDoubleQuote !== !1 && t.push(Pje(this.options.openDoubleQuote)), this.options.closeDoubleQuote !== !1 && t.push(Sje(this.options.closeDoubleQuote)), this.options.openSingleQuote !== !1 && t.push(Nje(this.options.openSingleQuote)), this.options.closeSingleQuote !== !1 && t.push($je(this.options.closeSingleQuote)), this.options.leftArrow !== !1 && t.push(Dje(this.options.leftArrow)), this.options.rightArrow !== !1 && t.push(Eje(this.options.rightArrow)), this.options.copyright !== !1 && t.push(Tje(this.options.copyright)), this.options.trademark !== !1 && t.push(Oje(this.options.trademark)), this.options.servicemark !== !1 && t.push(Wje(this.options.servicemark)), this.options.registeredTrademark !== !1 && t.push(Aje(this.options.registeredTrademark)), this.options.oneHalf !== !1 && t.push(Lje(this.options.oneHalf)), this.options.plusMinus !== !1 && t.push(Ije(this.options.plusMinus)), this.options.notEqual !== !1 && t.push(Rje(this.options.notEqual)), this.options.laquo !== !1 && t.push(jje(this.options.laquo)), this.options.raquo !== !1 && t.push(Fje(this.options.raquo)), this.options.multiplication !== !1 && t.push(zje(this.options.multiplication)), this.options.superscriptTwo !== !1 && t.push(Vje(this.options.superscriptTwo)), this.options.superscriptThree !== !1 && t.push(Hje(this.options.superscriptThree)), this.options.oneQuarter !== !1 && t.push(Bje(this.options.oneQuarter)), this.options.threeQuarters !== !1 && t.push(qje(this.options.threeQuarters)), t;
  }
}), kb = Gje, Xje = Di.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
}), xb = Xje, Yje = /^\s*(\[([( |x])?\])\s$/, Kje = qt.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList"
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (t) => {
          const e = t.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (t) => ({
          "data-checked": t.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "li",
      rt(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: t.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  addKeyboardShortcuts() {
    const t = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...t,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : t;
  },
  addNodeView() {
    return ({ node: t, HTMLAttributes: e, getPos: n, editor: i }) => {
      const r = document.createElement("li"), a = document.createElement("label"), o = document.createElement("span"), s = document.createElement("input"), l = document.createElement("div");
      return a.contentEditable = "false", s.type = "checkbox", s.addEventListener("mousedown", (c) => c.preventDefault()), s.addEventListener("change", (c) => {
        if (!i.isEditable && !this.options.onReadOnlyChecked) {
          s.checked = !s.checked;
          return;
        }
        const { checked: u } = c.target;
        i.isEditable && typeof n == "function" && i.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: f }) => {
          const m = n();
          if (typeof m != "number")
            return !1;
          const h = f.doc.nodeAt(m);
          return f.setNodeMarkup(m, void 0, {
            ...h == null ? void 0 : h.attrs,
            checked: u
          }), !0;
        }).run(), !i.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(t, u) || (s.checked = !s.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([c, u]) => {
        r.setAttribute(c, u);
      }), r.dataset.checked = t.attrs.checked, s.checked = t.attrs.checked, a.append(s, o), r.append(a, l), Object.entries(e).forEach(([c, u]) => {
        r.setAttribute(c, u);
      }), {
        dom: r,
        contentDOM: l,
        update: (c) => c.type !== this.type ? !1 : (r.dataset.checked = c.attrs.checked, s.checked = c.attrs.checked, !0)
      };
    };
  },
  addInputRules() {
    return [
      Ws({
        find: Yje,
        type: this.type,
        getAttributes: (t) => ({
          checked: t[t.length - 1] === "x"
        })
      })
    ];
  }
}), Uje = ({
  node: t,
  getPos: e,
  editor: n
}) => {
  const i = t.attrs.checked;
  return /* @__PURE__ */ k(Dc, { className: "mb-2 flex items-start gap-2", children: [
    /* @__PURE__ */ d(
      Ys,
      {
        checked: i,
        onCheckedChange: (a) => {
          n.chain().focus().command(({ tr: o }) => (o.setNodeMarkup(e(), void 0, {
            ...t.attrs,
            checked: a
          }), !0)).run();
        },
        hideLabel: !0
      }
    ),
    /* @__PURE__ */ d(
      "div",
      {
        className: E(i && "text-f1-foreground-secondary line-through"),
        children: /* @__PURE__ */ d($c, { className: "content" })
      }
    )
  ] });
}, Jje = Kje.extend({
  addNodeView() {
    return Ec(Uje);
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "li",
      { class: E("f1-task-item", e.class) },
      [
        "div",
        { class: "flex items-start gap-2" },
        [
          "button",
          {
            type: "button",
            role: "checkbox",
            "aria-checked": t.attrs.checked ? "true" : "false",
            disabled: "disabled",
            class: t.attrs.checked ? "custom-checkbox custom-checkbox-checked" : "custom-checkbox",
            style: "appearance: none; -webkit-appearance: none;"
          }
        ],
        [
          "div",
          {
            class: E(
              t.attrs.checked ? "text-f1-foreground-secondary line-through" : "",
              "content"
            )
          },
          0
        ]
      ]
    ];
  }
}), _b = Jje.configure({
  nested: !0,
  HTMLAttributes: {
    class: "f1-task-item"
  }
});
class Nt extends He {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, n) {
    let i = e.resolve(n.map(this.head));
    return Nt.valid(i) ? new Nt(i) : He.near(i);
  }
  content() {
    return ye.empty;
  }
  eq(e) {
    return e instanceof Nt && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, n) {
    if (typeof n.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new Nt(e.resolve(n.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Mb(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let n = e.parent;
    if (n.isTextblock || !Qje(e) || !Zje(e))
      return !1;
    let i = n.type.spec.allowGapCursor;
    if (i != null)
      return i;
    let r = n.contentMatchAt(e.index()).defaultType;
    return r && r.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, n, i = !1) {
    e: for (; ; ) {
      if (!i && Nt.valid(e))
        return e;
      let r = e.pos, a = null;
      for (let o = e.depth; ; o--) {
        let s = e.node(o);
        if (n > 0 ? e.indexAfter(o) < s.childCount : e.index(o) > 0) {
          a = s.child(n > 0 ? e.indexAfter(o) : e.index(o) - 1);
          break;
        } else if (o == 0)
          return null;
        r += n;
        let l = e.doc.resolve(r);
        if (Nt.valid(l))
          return l;
      }
      for (; ; ) {
        let o = n > 0 ? a.firstChild : a.lastChild;
        if (!o) {
          if (a.isAtom && !a.isText && !Ae.isSelectable(a)) {
            e = e.doc.resolve(r + a.nodeSize * n), i = !1;
            continue e;
          }
          break;
        }
        a = o, r += n;
        let s = e.doc.resolve(r);
        if (Nt.valid(s))
          return s;
      }
      return null;
    }
  }
}
Nt.prototype.visible = !1;
Nt.findFrom = Nt.findGapCursorFrom;
He.jsonID("gapcursor", Nt);
class Mb {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Mb(e.map(this.pos));
  }
  resolve(e) {
    let n = e.resolve(this.pos);
    return Nt.valid(n) ? new Nt(n) : He.near(n);
  }
}
function Qje(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.index(e), i = t.node(e);
    if (n == 0) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = i.child(n - 1); ; r = r.lastChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function Zje(t) {
  for (let e = t.depth; e >= 0; e--) {
    let n = t.indexAfter(e), i = t.node(e);
    if (n == i.childCount) {
      if (i.type.spec.isolating)
        return !0;
      continue;
    }
    for (let r = i.child(n); ; r = r.firstChild) {
      if (r.childCount == 0 && !r.inlineContent || r.isAtom || r.type.spec.isolating)
        return !0;
      if (r.inlineContent)
        return !1;
    }
  }
  return !0;
}
function eFe() {
  return new ft({
    props: {
      decorations: rFe,
      createSelectionBetween(t, e, n) {
        return e.pos == n.pos && Nt.valid(n) ? new Nt(n) : null;
      },
      handleClick: nFe,
      handleKeyDown: tFe,
      handleDOMEvents: { beforeinput: iFe }
    }
  });
}
const tFe = OS({
  ArrowLeft: su("horiz", -1),
  ArrowRight: su("horiz", 1),
  ArrowUp: su("vert", -1),
  ArrowDown: su("vert", 1)
});
function su(t, e) {
  const n = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(i, r, a) {
    let o = i.selection, s = e > 0 ? o.$to : o.$from, l = o.empty;
    if (o instanceof Fe) {
      if (!a.endOfTextblock(n) || s.depth == 0)
        return !1;
      l = !1, s = i.doc.resolve(e > 0 ? s.after() : s.before());
    }
    let c = Nt.findGapCursorFrom(s, e, l);
    return c ? (r && r(i.tr.setSelection(new Nt(c))), !0) : !1;
  };
}
function nFe(t, e, n) {
  if (!t || !t.editable)
    return !1;
  let i = t.state.doc.resolve(e);
  if (!Nt.valid(i))
    return !1;
  let r = t.posAtCoords({ left: n.clientX, top: n.clientY });
  return r && r.inside > -1 && Ae.isSelectable(t.state.doc.nodeAt(r.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new Nt(i))), !0);
}
function iFe(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof Nt))
    return !1;
  let { $from: n } = t.state.selection, i = n.parent.contentMatchAt(n.index()).findWrapping(t.state.schema.nodes.text);
  if (!i)
    return !1;
  let r = ee.empty;
  for (let o = i.length - 1; o >= 0; o--)
    r = ee.from(i[o].createAndFill(null, r));
  let a = t.state.tr.replace(n.pos, n.pos, new ye(r, 0, 0));
  return a.setSelection(Fe.near(a.doc.resolve(n.pos + 1))), t.dispatch(a), !1;
}
function rFe(t) {
  if (!(t.selection instanceof Nt))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", ht.create(t.doc, [fn.widget(t.selection.head, e, { key: "gapcursor" })]);
}
const jf = (t, e) => e.view.domAtPos(t).node.offsetParent !== null, aFe = (t, e, n) => {
  for (let i = t.depth; i > 0; i -= 1) {
    const r = t.node(i), a = e(r), o = jf(t.start(i), n);
    if (a && o)
      return {
        pos: i > 0 ? t.before(i) : 0,
        start: t.start(i),
        depth: i,
        node: r
      };
  }
}, T3 = (t, e) => {
  const { state: n, view: i, extensionManager: r } = t, { schema: a, selection: o } = n, { empty: s, $anchor: l } = o, c = !!r.extensions.find((v) => v.name === "gapCursor");
  if (!s || l.parent.type !== a.nodes.detailsSummary || !c || e === "right" && l.parentOffset !== l.parent.nodeSize - 2)
    return !1;
  const u = rl((v) => v.type === a.nodes.details)(o);
  if (!u)
    return !1;
  const f = Tu(u.node, (v) => v.type === a.nodes.detailsContent);
  if (!f.length || jf(u.start + f[0].pos + 1, t))
    return !1;
  const h = n.doc.resolve(u.pos + u.node.nodeSize), p = Nt.findFrom(h, 1, !1);
  if (!p)
    return !1;
  const { tr: g } = n, y = new Nt(p);
  return g.setSelection(y), g.scrollIntoView(), i.dispatch(g), !0;
}, oFe = qt.create({
  name: "details",
  content: "detailsSummary detailsContent",
  group: "block",
  defining: !0,
  isolating: !0,
  allowGapCursor: !1,
  addOptions() {
    return {
      persist: !1,
      openClassName: "is-open",
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.persist ? {
      open: {
        default: !1,
        parseHTML: (t) => t.hasAttribute("open"),
        renderHTML: ({ open: t }) => t ? { open: "" } : {}
      }
    } : [];
  },
  parseHTML() {
    return [
      {
        tag: "details"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "details",
      rt(this.options.HTMLAttributes, t),
      0
    ];
  },
  addNodeView() {
    return ({ editor: t, getPos: e, node: n, HTMLAttributes: i }) => {
      const r = document.createElement("div"), a = rt(this.options.HTMLAttributes, i, {
        "data-type": this.name
      });
      Object.entries(a).forEach(([c, u]) => r.setAttribute(c, u));
      const o = document.createElement("button");
      o.type = "button", r.append(o);
      const s = document.createElement("div");
      r.append(s);
      const l = (c) => {
        if (c !== void 0)
          if (c) {
            if (r.classList.contains(this.options.openClassName))
              return;
            r.classList.add(this.options.openClassName);
          } else {
            if (!r.classList.contains(this.options.openClassName))
              return;
            r.classList.remove(this.options.openClassName);
          }
        else
          r.classList.toggle(this.options.openClassName);
        const u = new Event("toggleDetailsContent"), f = s.querySelector(':scope > div[data-type="detailsContent"]');
        f == null || f.dispatchEvent(u);
      };
      return n.attrs.open && setTimeout(() => l()), o.addEventListener("click", () => {
        if (l(), !this.options.persist) {
          t.commands.focus(void 0, { scrollIntoView: !1 });
          return;
        }
        if (t.isEditable && typeof e == "function") {
          const { from: c, to: u } = t.state.selection;
          t.chain().command(({ tr: f }) => {
            const m = e(), h = f.doc.nodeAt(m);
            return (h == null ? void 0 : h.type) !== this.type ? !1 : (f.setNodeMarkup(m, void 0, {
              open: !h.attrs.open
            }), !0);
          }).setTextSelection({
            from: c,
            to: u
          }).focus(void 0, { scrollIntoView: !1 }).run();
        }
      }), {
        dom: r,
        contentDOM: s,
        ignoreMutation(c) {
          return c.type === "selection" ? !1 : !r.contains(c.target) || r === c.target;
        },
        update: (c) => c.type !== this.type ? !1 : (c.attrs.open !== void 0 && l(c.attrs.open), !0)
      };
    };
  },
  addCommands() {
    return {
      setDetails: () => ({ state: t, chain: e }) => {
        var n;
        const { schema: i, selection: r } = t, { $from: a, $to: o } = r, s = a.blockRange(o);
        if (!s)
          return !1;
        const l = t.doc.slice(s.start, s.end);
        if (!i.nodes.detailsContent.contentMatch.matchFragment(l.content))
          return !1;
        const u = ((n = l.toJSON()) === null || n === void 0 ? void 0 : n.content) || [];
        return e().insertContentAt({ from: s.start, to: s.end }, {
          type: this.name,
          content: [
            {
              type: "detailsSummary"
            },
            {
              type: "detailsContent",
              content: u
            }
          ]
        }).setTextSelection(s.start + 2).run();
      },
      unsetDetails: () => ({ state: t, chain: e }) => {
        const { selection: n, schema: i } = t, r = rl((v) => v.type === this.type)(n);
        if (!r)
          return !1;
        const a = Tu(r.node, (v) => v.type === i.nodes.detailsSummary), o = Tu(r.node, (v) => v.type === i.nodes.detailsContent);
        if (!a.length || !o.length)
          return !1;
        const s = a[0], l = o[0], c = r.pos, u = t.doc.resolve(c), f = c + r.node.nodeSize, m = { from: c, to: f }, h = l.node.content.toJSON() || [], p = u.parent.type.contentMatch.defaultType, y = [
          p == null ? void 0 : p.create(null, s.node.content).toJSON(),
          ...h
        ];
        return e().insertContentAt(m, y).setTextSelection(c + 1).run();
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => {
        const { schema: t, selection: e } = this.editor.state, { empty: n, $anchor: i } = e;
        return !n || i.parent.type !== t.nodes.detailsSummary ? !1 : i.parentOffset !== 0 ? this.editor.commands.command(({ tr: r }) => {
          const a = i.pos - 1, o = i.pos;
          return r.delete(a, o), !0;
        }) : this.editor.commands.unsetDetails();
      },
      // Creates a new node below it if it is closed.
      // Otherwise inside `DetailsContent`.
      Enter: ({ editor: t }) => {
        const { state: e, view: n } = t, { schema: i, selection: r } = e, { $head: a } = r;
        if (a.parent.type !== i.nodes.detailsSummary)
          return !1;
        const o = jf(a.after() + 1, t), s = o ? e.doc.nodeAt(a.after()) : a.node(-2);
        if (!s)
          return !1;
        const l = o ? 0 : a.indexAfter(-1), c = rb(s.contentMatchAt(l));
        if (!c || !s.canReplaceWith(l, l, c))
          return !1;
        const u = c.createAndFill();
        if (!u)
          return !1;
        const f = o ? a.after() + 1 : a.after(-1), m = e.tr.replaceWith(f, f, u), h = m.doc.resolve(f), p = He.near(h, 1);
        return m.setSelection(p), m.scrollIntoView(), n.dispatch(m), !0;
      },
      // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
      ArrowRight: ({ editor: t }) => T3(t, "right"),
      // The default gapcursor implementation can’t handle hidden content, so we need to fix this.
      ArrowDown: ({ editor: t }) => T3(t, "down")
    };
  },
  addProseMirrorPlugins() {
    return [
      // This plugin prevents text selections within the hidden content in `DetailsContent`.
      // The cursor is moved to the next visible position.
      new ft({
        key: new yt("detailsSelection"),
        appendTransaction: (t, e, n) => {
          const { editor: i, type: r } = this;
          if (!t.some((y) => y.selectionSet) || !e.selection.empty || !n.selection.empty || !i7(n, r.name))
            return;
          const { $from: s } = n.selection;
          if (jf(s.pos, i))
            return;
          const c = aFe(s, (y) => y.type === r, i);
          if (!c)
            return;
          const u = Tu(c.node, (y) => y.type === n.schema.nodes.detailsSummary);
          if (!u.length)
            return;
          const f = u[0], h = (e.selection.from < n.selection.from ? "forward" : "backward") === "forward" ? c.start + f.pos : c.pos + f.pos + f.node.nodeSize, p = Fe.create(n.doc, h);
          return n.tr.setSelection(p);
        }
      })
    ];
  }
}), sFe = oFe.configure({
  persist: !0,
  HTMLAttributes: {
    class: "rich-text-details"
  }
}), lFe = qt.create({
  name: "detailsContent",
  content: "block+",
  defining: !0,
  selectable: !1,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: `div[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "div",
      rt(this.options.HTMLAttributes, t, { "data-type": this.name }),
      0
    ];
  },
  addNodeView() {
    return ({ HTMLAttributes: t }) => {
      const e = document.createElement("div"), n = rt(this.options.HTMLAttributes, t, {
        "data-type": this.name,
        hidden: "hidden"
      });
      return Object.entries(n).forEach(([i, r]) => e.setAttribute(i, r)), e.addEventListener("toggleDetailsContent", () => {
        e.toggleAttribute("hidden");
      }), {
        dom: e,
        contentDOM: e,
        ignoreMutation(i) {
          return i.type === "selection" ? !1 : !e.contains(i.target) || e === i.target;
        },
        update: (i) => i.type === this.type
      };
    };
  },
  addKeyboardShortcuts() {
    return {
      // Escape node on double enter
      Enter: ({ editor: t }) => {
        const { state: e, view: n } = t, { selection: i } = e, { $from: r, empty: a } = i, o = rl((j) => j.type === this.type)(i);
        if (!a || !o || !o.node.childCount)
          return !1;
        const s = r.index(o.depth), { childCount: l } = o.node;
        if (!(l === s + 1))
          return !1;
        const u = o.node.type.contentMatch.defaultType, f = u == null ? void 0 : u.createAndFill();
        if (!f)
          return !1;
        const m = e.doc.resolve(o.pos + 1), h = l - 1, p = o.node.child(h), g = m.posAtIndex(h, o.depth);
        if (!p.eq(f))
          return !1;
        const v = r.node(-3);
        if (!v)
          return !1;
        const w = r.indexAfter(-3), x = rb(v.contentMatchAt(w));
        if (!x || !v.canReplaceWith(w, w, x))
          return !1;
        const b = x.createAndFill();
        if (!b)
          return !1;
        const { tr: M } = e, _ = r.after(-2);
        M.replaceWith(_, _, b);
        const N = M.doc.resolve(_), $ = He.near(N, 1);
        M.setSelection($);
        const D = g, W = g + p.nodeSize;
        return M.delete(D, W), M.scrollIntoView(), n.dispatch(M), !0;
      }
    };
  }
}), dFe = lFe, cFe = qt.create({
  name: "detailsSummary",
  content: "text*",
  defining: !0,
  selectable: !1,
  isolating: !0,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "summary"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "summary",
      rt(this.options.HTMLAttributes, t),
      0
    ];
  }
}), uFe = cFe, fFe = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2ntley5rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6logistics9properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3ncaster6d0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2psy3ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0america6xi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", mFe = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", Fs = (t, e) => {
  for (const n in e)
    t[n] = e[n];
  return t;
}, Ug = "numeric", Jg = "ascii", Qg = "alpha", Ul = "asciinumeric", Il = "alphanumeric", Zg = "domain", T7 = "emoji", hFe = "scheme", pFe = "slashscheme", rp = "whitespace";
function gFe(t, e) {
  return t in e || (e[t] = []), e[t];
}
function ao(t, e, n) {
  e[Ug] && (e[Ul] = !0, e[Il] = !0), e[Jg] && (e[Ul] = !0, e[Qg] = !0), e[Ul] && (e[Il] = !0), e[Qg] && (e[Il] = !0), e[Il] && (e[Zg] = !0), e[T7] && (e[Zg] = !0);
  for (const i in e) {
    const r = gFe(i, n);
    r.indexOf(t) < 0 && r.push(t);
  }
}
function yFe(t, e) {
  const n = {};
  for (const i in e)
    e[i].indexOf(t) >= 0 && (n[i] = !0);
  return n;
}
function Xn(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Xn.groups = {};
Xn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, n = e.j[t];
    if (n)
      return n;
    for (let i = 0; i < e.jr.length; i++) {
      const r = e.jr[i][0], a = e.jr[i][1];
      if (a && r.test(t))
        return a;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, n, i) {
    for (let r = 0; r < t.length; r++)
      this.tt(t[r], e, n, i);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, n, i) {
    i = i || Xn.groups;
    let r;
    return e && e.j ? r = e : (r = new Xn(e), n && i && ao(e, n, i)), this.jr.push([t, r]), r;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, n, i) {
    let r = this;
    const a = t.length;
    if (!a)
      return r;
    for (let o = 0; o < a - 1; o++)
      r = r.tt(t[o]);
    return r.tt(t[a - 1], e, n, i);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, n, i) {
    i = i || Xn.groups;
    const r = this;
    if (e && e.j)
      return r.j[t] = e, e;
    const a = e;
    let o, s = r.go(t);
    if (s ? (o = new Xn(), Fs(o.j, s.j), o.jr.push.apply(o.jr, s.jr), o.jd = s.jd, o.t = s.t) : o = new Xn(), a) {
      if (i)
        if (o.t && typeof o.t == "string") {
          const l = Fs(yFe(o.t, i), n);
          ao(a, l, i);
        } else n && ao(a, n, i);
      o.t = a;
    }
    return r.j[t] = o, o;
  }
};
const Ge = (t, e, n, i, r) => t.ta(e, n, i, r), Tt = (t, e, n, i, r) => t.tr(e, n, i, r), O3 = (t, e, n, i, r) => t.ts(e, n, i, r), ie = (t, e, n, i, r) => t.tt(e, n, i, r), Pr = "WORD", ey = "UWORD", O7 = "ASCIINUMERICAL", W7 = "ALPHANUMERICAL", $d = "LOCALHOST", ty = "TLD", ny = "UTLD", Au = "SCHEME", ts = "SLASH_SCHEME", Cb = "NUM", iy = "WS", Pb = "NL", Jl = "OPENBRACE", Ql = "CLOSEBRACE", Ff = "OPENBRACKET", zf = "CLOSEBRACKET", Vf = "OPENPAREN", Hf = "CLOSEPAREN", Bf = "OPENANGLEBRACKET", qf = "CLOSEANGLEBRACKET", Gf = "FULLWIDTHLEFTPAREN", Xf = "FULLWIDTHRIGHTPAREN", Yf = "LEFTCORNERBRACKET", Kf = "RIGHTCORNERBRACKET", Uf = "LEFTWHITECORNERBRACKET", Jf = "RIGHTWHITECORNERBRACKET", Qf = "FULLWIDTHLESSTHAN", Zf = "FULLWIDTHGREATERTHAN", em = "AMPERSAND", Sb = "APOSTROPHE", tm = "ASTERISK", na = "AT", nm = "BACKSLASH", im = "BACKTICK", rm = "CARET", sa = "COLON", Nb = "COMMA", am = "DOLLAR", tr = "DOT", om = "EQUALS", $b = "EXCLAMATION", pi = "HYPHEN", Zl = "PERCENT", sm = "PIPE", lm = "PLUS", dm = "POUND", ed = "QUERY", Db = "QUOTE", A7 = "FULLWIDTHMIDDLEDOT", Eb = "SEMI", nr = "SLASH", td = "TILDE", cm = "UNDERSCORE", L7 = "EMOJI", um = "SYM";
var I7 = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  WORD: Pr,
  UWORD: ey,
  ASCIINUMERICAL: O7,
  ALPHANUMERICAL: W7,
  LOCALHOST: $d,
  TLD: ty,
  UTLD: ny,
  SCHEME: Au,
  SLASH_SCHEME: ts,
  NUM: Cb,
  WS: iy,
  NL: Pb,
  OPENBRACE: Jl,
  CLOSEBRACE: Ql,
  OPENBRACKET: Ff,
  CLOSEBRACKET: zf,
  OPENPAREN: Vf,
  CLOSEPAREN: Hf,
  OPENANGLEBRACKET: Bf,
  CLOSEANGLEBRACKET: qf,
  FULLWIDTHLEFTPAREN: Gf,
  FULLWIDTHRIGHTPAREN: Xf,
  LEFTCORNERBRACKET: Yf,
  RIGHTCORNERBRACKET: Kf,
  LEFTWHITECORNERBRACKET: Uf,
  RIGHTWHITECORNERBRACKET: Jf,
  FULLWIDTHLESSTHAN: Qf,
  FULLWIDTHGREATERTHAN: Zf,
  AMPERSAND: em,
  APOSTROPHE: Sb,
  ASTERISK: tm,
  AT: na,
  BACKSLASH: nm,
  BACKTICK: im,
  CARET: rm,
  COLON: sa,
  COMMA: Nb,
  DOLLAR: am,
  DOT: tr,
  EQUALS: om,
  EXCLAMATION: $b,
  HYPHEN: pi,
  PERCENT: Zl,
  PIPE: sm,
  PLUS: lm,
  POUND: dm,
  QUERY: ed,
  QUOTE: Db,
  FULLWIDTHMIDDLEDOT: A7,
  SEMI: Eb,
  SLASH: nr,
  TILDE: td,
  UNDERSCORE: cm,
  EMOJI: L7,
  SYM: um
});
const _r = /[a-z]/, $l = new RegExp("\\p{L}", "u"), ap = new RegExp("\\p{Emoji}", "u"), Mr = /\d/, op = /\s/, W3 = "\r", sp = `
`, vFe = "️", bFe = "‍", lp = "￼";
let lu = null, du = null;
function wFe(t = []) {
  const e = {};
  Xn.groups = e;
  const n = new Xn();
  lu == null && (lu = A3(fFe)), du == null && (du = A3(mFe)), ie(n, "'", Sb), ie(n, "{", Jl), ie(n, "}", Ql), ie(n, "[", Ff), ie(n, "]", zf), ie(n, "(", Vf), ie(n, ")", Hf), ie(n, "<", Bf), ie(n, ">", qf), ie(n, "（", Gf), ie(n, "）", Xf), ie(n, "「", Yf), ie(n, "」", Kf), ie(n, "『", Uf), ie(n, "』", Jf), ie(n, "＜", Qf), ie(n, "＞", Zf), ie(n, "&", em), ie(n, "*", tm), ie(n, "@", na), ie(n, "`", im), ie(n, "^", rm), ie(n, ":", sa), ie(n, ",", Nb), ie(n, "$", am), ie(n, ".", tr), ie(n, "=", om), ie(n, "!", $b), ie(n, "-", pi), ie(n, "%", Zl), ie(n, "|", sm), ie(n, "+", lm), ie(n, "#", dm), ie(n, "?", ed), ie(n, '"', Db), ie(n, "/", nr), ie(n, ";", Eb), ie(n, "~", td), ie(n, "_", cm), ie(n, "\\", nm), ie(n, "・", A7);
  const i = Tt(n, Mr, Cb, {
    [Ug]: !0
  });
  Tt(i, Mr, i);
  const r = Tt(i, _r, O7, {
    [Ul]: !0
  }), a = Tt(i, $l, W7, {
    [Il]: !0
  }), o = Tt(n, _r, Pr, {
    [Jg]: !0
  });
  Tt(o, Mr, r), Tt(o, _r, o), Tt(r, Mr, r), Tt(r, _r, r);
  const s = Tt(n, $l, ey, {
    [Qg]: !0
  });
  Tt(s, _r), Tt(s, Mr, a), Tt(s, $l, s), Tt(a, Mr, a), Tt(a, _r), Tt(a, $l, a);
  const l = ie(n, sp, Pb, {
    [rp]: !0
  }), c = ie(n, W3, iy, {
    [rp]: !0
  }), u = Tt(n, op, iy, {
    [rp]: !0
  });
  ie(n, lp, u), ie(c, sp, l), ie(c, lp, u), Tt(c, op, u), ie(u, W3), ie(u, sp), Tt(u, op, u), ie(u, lp, u);
  const f = Tt(n, ap, L7, {
    [T7]: !0
  });
  ie(f, "#"), Tt(f, ap, f), ie(f, vFe, f);
  const m = ie(f, bFe);
  ie(m, "#"), Tt(m, ap, f);
  const h = [[_r, o], [Mr, r]], p = [[_r, null], [$l, s], [Mr, a]];
  for (let g = 0; g < lu.length; g++)
    Jr(n, lu[g], ty, Pr, h);
  for (let g = 0; g < du.length; g++)
    Jr(n, du[g], ny, ey, p);
  ao(ty, {
    tld: !0,
    ascii: !0
  }, e), ao(ny, {
    utld: !0,
    alpha: !0
  }, e), Jr(n, "file", Au, Pr, h), Jr(n, "mailto", Au, Pr, h), Jr(n, "http", ts, Pr, h), Jr(n, "https", ts, Pr, h), Jr(n, "ftp", ts, Pr, h), Jr(n, "ftps", ts, Pr, h), ao(Au, {
    scheme: !0,
    ascii: !0
  }, e), ao(ts, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((g, y) => g[0] > y[0] ? 1 : -1);
  for (let g = 0; g < t.length; g++) {
    const y = t[g][0], w = t[g][1] ? {
      [hFe]: !0
    } : {
      [pFe]: !0
    };
    y.indexOf("-") >= 0 ? w[Zg] = !0 : _r.test(y) ? Mr.test(y) ? w[Ul] = !0 : w[Jg] = !0 : w[Ug] = !0, O3(n, y, y, w);
  }
  return O3(n, "localhost", $d, {
    ascii: !0
  }), n.jd = new Xn(um), {
    start: n,
    tokens: Fs({
      groups: e
    }, I7)
  };
}
function R7(t, e) {
  const n = kFe(e.replace(/[A-Z]/g, (s) => s.toLowerCase())), i = n.length, r = [];
  let a = 0, o = 0;
  for (; o < i; ) {
    let s = t, l = null, c = 0, u = null, f = -1, m = -1;
    for (; o < i && (l = s.go(n[o])); )
      s = l, s.accepts() ? (f = 0, m = 0, u = s) : f >= 0 && (f += n[o].length, m++), c += n[o].length, a += n[o].length, o++;
    a -= f, o -= m, c -= f, r.push({
      t: u.t,
      // token type/name
      v: e.slice(a - c, a),
      // string value
      s: a - c,
      // start index
      e: a
      // end index (excluding)
    });
  }
  return r;
}
function kFe(t) {
  const e = [], n = t.length;
  let i = 0;
  for (; i < n; ) {
    let r = t.charCodeAt(i), a, o = r < 55296 || r > 56319 || i + 1 === n || (a = t.charCodeAt(i + 1)) < 56320 || a > 57343 ? t[i] : t.slice(i, i + 2);
    e.push(o), i += o.length;
  }
  return e;
}
function Jr(t, e, n, i, r) {
  let a;
  const o = e.length;
  for (let s = 0; s < o - 1; s++) {
    const l = e[s];
    t.j[l] ? a = t.j[l] : (a = new Xn(i), a.jr = r.slice(), t.j[l] = a), t = a;
  }
  return a = new Xn(n), a.jr = r.slice(), t.j[e[o - 1]] = a, a;
}
function A3(t) {
  const e = [], n = [];
  let i = 0, r = "0123456789";
  for (; i < t.length; ) {
    let a = 0;
    for (; r.indexOf(t[i + a]) >= 0; )
      a++;
    if (a > 0) {
      e.push(n.join(""));
      for (let o = parseInt(t.substring(i, i + a), 10); o > 0; o--)
        n.pop();
      i += a;
    } else
      n.push(t[i]), i++;
  }
  return e;
}
const Dd = {
  defaultProtocol: "http",
  events: null,
  format: L3,
  formatHref: L3,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Tb(t, e = null) {
  let n = Fs({}, Dd);
  t && (n = Fs(n, t instanceof Tb ? t.o : t));
  const i = n.ignoreTags, r = [];
  for (let a = 0; a < i.length; a++)
    r.push(i[a].toUpperCase());
  this.o = n, e && (this.defaultRender = e), this.ignoreTags = r;
}
Tb.prototype = {
  o: Dd,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, n) {
    const i = e != null;
    let r = this.o[t];
    return r && (typeof r == "object" ? (r = n.t in r ? r[n.t] : Dd[t], typeof r == "function" && i && (r = r(e, n))) : typeof r == "function" && i && (r = r(e, n.t, n)), r);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, n) {
    let i = this.o[t];
    return typeof i == "function" && e != null && (i = i(e, n.t, n)), i;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function L3(t) {
  return t;
}
function j7(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
j7.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), n = t.get("truncate", e, this), i = t.get("format", e, this);
    return n && i.length > n ? i.substring(0, n) + "…" : i;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = Dd.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, n = this.toHref(t.get("defaultProtocol")), i = t.get("formatHref", n, this), r = t.get("tagName", n, e), a = this.toFormattedString(t), o = {}, s = t.get("className", n, e), l = t.get("target", n, e), c = t.get("rel", n, e), u = t.getObj("attributes", n, e), f = t.getObj("events", n, e);
    return o.href = i, s && (o.class = s), l && (o.target = l), c && (o.rel = c), u && Fs(o, u), {
      tagName: r,
      attributes: o,
      content: a,
      eventListeners: f
    };
  }
};
function Nh(t, e) {
  class n extends j7 {
    constructor(r, a) {
      super(r, a), this.t = t;
    }
  }
  for (const i in e)
    n.prototype[i] = e[i];
  return n.t = t, n;
}
const I3 = Nh("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), R3 = Nh("text"), xFe = Nh("nl"), cu = Nh("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = Dd.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== $d && t[1].t === sa;
  }
}), fi = (t) => new Xn(t);
function _Fe({
  groups: t
}) {
  const e = t.domain.concat([em, tm, na, nm, im, rm, am, om, pi, Cb, Zl, sm, lm, dm, nr, um, td, cm]), n = [sa, Nb, tr, $b, Zl, ed, Db, Eb, Bf, qf, Jl, Ql, zf, Ff, Vf, Hf, Gf, Xf, Yf, Kf, Uf, Jf, Qf, Zf], i = [em, Sb, tm, nm, im, rm, am, om, pi, Jl, Ql, Zl, sm, lm, dm, ed, nr, um, td, cm], r = fi(), a = ie(r, td);
  Ge(a, i, a), Ge(a, t.domain, a);
  const o = fi(), s = fi(), l = fi();
  Ge(r, t.domain, o), Ge(r, t.scheme, s), Ge(r, t.slashscheme, l), Ge(o, i, a), Ge(o, t.domain, o);
  const c = ie(o, na);
  ie(a, na, c), ie(s, na, c), ie(l, na, c);
  const u = ie(a, tr);
  Ge(u, i, a), Ge(u, t.domain, a);
  const f = fi();
  Ge(c, t.domain, f), Ge(f, t.domain, f);
  const m = ie(f, tr);
  Ge(m, t.domain, f);
  const h = fi(I3);
  Ge(m, t.tld, h), Ge(m, t.utld, h), ie(c, $d, h);
  const p = ie(f, pi);
  ie(p, pi, p), Ge(p, t.domain, f), Ge(h, t.domain, f), ie(h, tr, m), ie(h, pi, p);
  const g = ie(h, sa);
  Ge(g, t.numeric, I3);
  const y = ie(o, pi), v = ie(o, tr);
  ie(y, pi, y), Ge(y, t.domain, o), Ge(v, i, a), Ge(v, t.domain, o);
  const w = fi(cu);
  Ge(v, t.tld, w), Ge(v, t.utld, w), Ge(w, t.domain, o), Ge(w, i, a), ie(w, tr, v), ie(w, pi, y), ie(w, na, c);
  const x = ie(w, sa), b = fi(cu);
  Ge(x, t.numeric, b);
  const M = fi(cu), _ = fi();
  Ge(M, e, M), Ge(M, n, _), Ge(_, e, M), Ge(_, n, _), ie(w, nr, M), ie(b, nr, M);
  const N = ie(s, sa), $ = ie(l, sa), D = ie($, nr), W = ie(D, nr);
  Ge(s, t.domain, o), ie(s, tr, v), ie(s, pi, y), Ge(l, t.domain, o), ie(l, tr, v), ie(l, pi, y), Ge(N, t.domain, M), ie(N, nr, M), ie(N, ed, M), Ge(W, t.domain, M), Ge(W, e, M), ie(W, nr, M);
  const j = [
    [Jl, Ql],
    // {}
    [Ff, zf],
    // []
    [Vf, Hf],
    // ()
    [Bf, qf],
    // <>
    [Gf, Xf],
    // （）
    [Yf, Kf],
    // 「」
    [Uf, Jf],
    // 『』
    [Qf, Zf]
    // ＜＞
  ];
  for (let O = 0; O < j.length; O++) {
    const [I, L] = j[O], R = ie(M, I);
    ie(_, I, R), ie(R, L, M);
    const B = fi(cu);
    Ge(R, e, B);
    const F = fi();
    Ge(R, n), Ge(B, e, B), Ge(B, n, F), Ge(F, e, B), Ge(F, n, F), ie(B, L, M), ie(F, L, M);
  }
  return ie(r, $d, w), ie(r, Pb, xFe), {
    start: r,
    tokens: I7
  };
}
function MFe(t, e, n) {
  let i = n.length, r = 0, a = [], o = [];
  for (; r < i; ) {
    let s = t, l = null, c = null, u = 0, f = null, m = -1;
    for (; r < i && !(l = s.go(n[r].t)); )
      o.push(n[r++]);
    for (; r < i && (c = l || s.go(n[r].t)); )
      l = null, s = c, s.accepts() ? (m = 0, f = s) : m >= 0 && m++, r++, u++;
    if (m < 0)
      r -= u, r < i && (o.push(n[r]), r++);
    else {
      o.length > 0 && (a.push(dp(R3, e, o)), o = []), r -= m, u -= m;
      const h = f.t, p = n.slice(r - u, r);
      a.push(dp(h, e, p));
    }
  }
  return o.length > 0 && a.push(dp(R3, e, o)), a;
}
function dp(t, e, n) {
  const i = n[0].s, r = n[n.length - 1].e, a = e.slice(i, r);
  return new t(a, n);
}
const CFe = typeof console < "u" && console && console.warn || (() => {
}), PFe = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Mt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function SFe() {
  return Xn.groups = {}, Mt.scanner = null, Mt.parser = null, Mt.tokenQueue = [], Mt.pluginQueue = [], Mt.customSchemes = [], Mt.initialized = !1, Mt;
}
function j3(t, e = !1) {
  if (Mt.initialized && CFe(`linkifyjs: already initialized - will not register custom scheme "${t}" ${PFe}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Mt.customSchemes.push([t, e]);
}
function NFe() {
  Mt.scanner = wFe(Mt.customSchemes);
  for (let t = 0; t < Mt.tokenQueue.length; t++)
    Mt.tokenQueue[t][1]({
      scanner: Mt.scanner
    });
  Mt.parser = _Fe(Mt.scanner.tokens);
  for (let t = 0; t < Mt.pluginQueue.length; t++)
    Mt.pluginQueue[t][1]({
      scanner: Mt.scanner,
      parser: Mt.parser
    });
  return Mt.initialized = !0, Mt;
}
function Ob(t) {
  return Mt.initialized || NFe(), MFe(Mt.parser.start, t, R7(Mt.scanner.start, t));
}
Ob.scan = R7;
function F7(t, e = null, n = null) {
  if (e && typeof e == "object") {
    if (n)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    n = e, e = null;
  }
  const i = new Tb(n), r = Ob(t), a = [];
  for (let o = 0; o < r.length; o++) {
    const s = r[o];
    s.isLink && (!e || s.t === e) && i.check(s) && a.push(s.toFormattedObject(i));
  }
  return a;
}
function $Fe(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function DFe(t) {
  return new ft({
    key: new yt("autolink"),
    appendTransaction: (e, n, i) => {
      const r = e.some((c) => c.docChanged) && !n.doc.eq(i.doc), a = e.some((c) => c.getMeta("preventAutolink"));
      if (!r || a)
        return;
      const { tr: o } = i, s = xLe(n.doc, [...e]);
      if ($Le(s).forEach(({ newRange: c }) => {
        const u = _Le(i.doc, c, (h) => h.isTextblock);
        let f, m;
        if (u.length > 1 ? (f = u[0], m = i.doc.textBetween(f.pos, f.pos + f.node.nodeSize, void 0, " ")) : u.length && i.doc.textBetween(c.from, c.to, " ", " ").endsWith(" ") && (f = u[0], m = i.doc.textBetween(f.pos, c.to, void 0, " ")), f && m) {
          const h = m.split(" ").filter((v) => v !== "");
          if (h.length <= 0)
            return !1;
          const p = h[h.length - 1], g = f.pos + m.lastIndexOf(p);
          if (!p)
            return !1;
          const y = Ob(p).map((v) => v.toObject(t.defaultProtocol));
          if (!$Fe(y))
            return !1;
          y.filter((v) => v.isLink).map((v) => ({
            ...v,
            from: g + v.start + 1,
            to: g + v.end + 1
          })).filter((v) => i.schema.marks.code ? !i.doc.rangeHasMark(v.from, v.to, i.schema.marks.code) : !0).filter((v) => t.validate(v.value)).filter((v) => t.shouldAutoLink(v.value)).forEach((v) => {
            ab(v.from, v.to, i.doc).some((w) => w.mark.type === t.type) || o.addMark(v.from, v.to, t.type.create({
              href: v.href
            }));
          });
        }
      }), !!o.steps.length)
        return o;
    }
  });
}
function EFe(t) {
  return new ft({
    key: new yt("handleClickLink"),
    props: {
      handleClick: (e, n, i) => {
        var r, a;
        if (i.button !== 0 || !e.editable)
          return !1;
        let o = i.target;
        const s = [];
        for (; o.nodeName !== "DIV"; )
          s.push(o), o = o.parentNode;
        if (!s.find((m) => m.nodeName === "A"))
          return !1;
        const l = n7(e.state, t.type.name), c = i.target, u = (r = c == null ? void 0 : c.href) !== null && r !== void 0 ? r : l.href, f = (a = c == null ? void 0 : c.target) !== null && a !== void 0 ? a : l.target;
        return c && u ? (window.open(u, f), !0) : !1;
      }
    }
  });
}
function TFe(t) {
  return new ft({
    key: new yt("handlePasteLink"),
    props: {
      handlePaste: (e, n, i) => {
        const { state: r } = e, { selection: a } = r, { empty: o } = a;
        if (o)
          return !1;
        let s = "";
        i.content.forEach((c) => {
          s += c.textContent;
        });
        const l = F7(s, { defaultProtocol: t.defaultProtocol }).find((c) => c.isLink && c.value === s);
        return !s || !l ? !1 : t.editor.commands.setMark(t.type, {
          href: l.href
        });
      }
    }
  });
}
const OFe = /[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g;
function Ua(t, e) {
  const n = [
    "http",
    "https",
    "ftp",
    "ftps",
    "mailto",
    "tel",
    "callto",
    "sms",
    "cid",
    "xmpp"
  ];
  return e && e.forEach((i) => {
    const r = typeof i == "string" ? i : i.scheme;
    r && n.push(r);
  }), !t || t.replace(OFe, "").match(new RegExp(
    // eslint-disable-next-line no-useless-escape
    `^(?:(?:${n.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
    "i"
  ));
}
const WFe = Di.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        j3(t);
        return;
      }
      j3(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    SFe();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!Ua(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => !!t
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (n) => !!Ua(n, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!Ua(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", rt(this.options.HTMLAttributes, t), 0] : [
      "a",
      rt(this.options.HTMLAttributes, { ...t, href: "" }),
      0
    ];
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (i) => !!Ua(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, t).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (t) => ({ chain: e }) => {
        const { href: n } = t;
        return this.options.isAllowedUri(n, {
          defaultValidate: (i) => !!Ua(i, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run() : !1;
      },
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Na({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: n, defaultProtocol: i } = this.options, r = F7(t).filter((a) => a.isLink && this.options.isAllowedUri(a.value, {
              defaultValidate: (o) => !!Ua(o, n),
              protocols: n,
              defaultProtocol: i
            }));
            r.length && r.forEach((a) => e.push({
              text: a.value,
              data: {
                href: a.href
              },
              index: a.start
            }));
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) === null || e === void 0 ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: n } = this.options;
    return this.options.autolink && t.push(DFe({
      type: this.type,
      defaultProtocol: this.options.defaultProtocol,
      validate: (i) => this.options.isAllowedUri(i, {
        defaultValidate: (r) => !!Ua(r, e),
        protocols: e,
        defaultProtocol: n
      }),
      shouldAutoLink: this.options.shouldAutoLink
    })), this.options.openOnClick === !0 && t.push(EFe({
      type: this.type
    })), this.options.linkOnPaste && t.push(TFe({
      editor: this.editor,
      defaultProtocol: this.options.defaultProtocol,
      type: this.type
    })), t;
  }
}), Wb = WFe.configure({
  openOnClick: !0,
  HTMLAttributes: {
    rel: "noopener noreferrer",
    target: "_blank"
  }
}), AFe = /^\s*>\s$/, LFe = qt.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [
      { tag: "blockquote" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["blockquote", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      Ws({
        find: AFe,
        type: this.type
      })
    ];
  }
}), IFe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, RFe = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, jFe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, FFe = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, zFe = Di.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["strong", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      xo({
        find: IFe,
        type: this.type
      }),
      xo({
        find: jFe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Na({
        find: RFe,
        type: this.type
      }),
      Na({
        find: FFe,
        type: this.type
      })
    ];
  }
}), VFe = "listItem", F3 = "textStyle", z3 = /^\s*([-+*])\s$/, HFe = qt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      { tag: "ul" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(VFe, this.editor.getAttributes(F3)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = Ws({
      find: z3,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Ws({
      find: z3,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(F3),
      editor: this.editor
    })), [
      t
    ];
  }
}), BFe = /(^|[^`])`([^`]+)`(?!`)/, qFe = /(^|[^`])`([^`]+)`(?!`)/g, GFe = Di.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [
      { tag: "code" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      xo({
        find: BFe,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Na({
        find: qFe,
        type: this.type
      })
    ];
  }
}), XFe = /^```([a-z]+)?[\s\n]$/, YFe = /^~~~([a-z]+)?[\s\n]$/, KFe = qt.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: n } = this.options, a = [...((e = t.firstElementChild) === null || e === void 0 ? void 0 : e.classList) || []].filter((o) => o.startsWith(n)).map((o) => o.replace(n, ""))[0];
          return a || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      rt(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, n = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : n || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: n } = e, { $from: i, empty: r } = n;
        if (!r || i.parent.type !== this.type)
          return !1;
        const a = i.parentOffset === i.parent.nodeSize - 2, o = i.parent.textContent.endsWith(`

`);
        return !a || !o ? !1 : t.chain().command(({ tr: s }) => (s.delete(i.pos - 2, i.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: n, doc: i } = e, { $from: r, empty: a } = n;
        if (!a || r.parent.type !== this.type || !(r.parentOffset === r.parent.nodeSize - 2))
          return !1;
        const s = r.after();
        return s === void 0 ? !1 : i.nodeAt(s) ? t.commands.command(({ tr: c }) => (c.setSelection(He.near(i.resolve(s))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      Fg({
        find: XFe,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      Fg({
        find: YFe,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new ft({
        key: new yt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const n = e.clipboardData.getData("text/plain"), i = e.clipboardData.getData("vscode-editor-data"), r = i ? JSON.parse(i) : void 0, a = r == null ? void 0 : r.mode;
            if (!n || !a)
              return !1;
            const { tr: o, schema: s } = t.state, l = s.text(n.replace(/\r\n?/g, `
`));
            return o.replaceSelectionWith(this.type.create({ language: a }, l)), o.selection.$from.parent.type !== this.type && o.setSelection(Fe.near(o.doc.resolve(Math.max(0, o.selection.from - 2)))), o.setMeta("paste", !0), t.dispatch(o), !0;
          }
        }
      })
    ];
  }
}), UFe = qt.create({
  name: "doc",
  topNode: !0,
  content: "block+"
});
function JFe(t = {}) {
  return new ft({
    view(e) {
      return new QFe(e, t);
    }
  });
}
class QFe {
  constructor(e, n) {
    var i;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (i = n.width) !== null && i !== void 0 ? i : 1, this.color = n.color === !1 ? void 0 : n.color || "black", this.class = n.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((r) => {
      let a = (o) => {
        this[r](o);
      };
      return e.dom.addEventListener(r, a), { name: r, handler: a };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: n }) => this.editorView.dom.removeEventListener(e, n));
  }
  update(e, n) {
    this.cursorPos != null && n.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), n = !e.parent.inlineContent, i;
    if (n) {
      let s = e.nodeBefore, l = e.nodeAfter;
      if (s || l) {
        let c = this.editorView.nodeDOM(this.cursorPos - (s ? s.nodeSize : 0));
        if (c) {
          let u = c.getBoundingClientRect(), f = s ? u.bottom : u.top;
          s && l && (f = (f + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2), i = { left: u.left, right: u.right, top: f - this.width / 2, bottom: f + this.width / 2 };
        }
      }
    }
    if (!i) {
      let s = this.editorView.coordsAtPos(this.cursorPos);
      i = { left: s.left - this.width / 2, right: s.left + this.width / 2, top: s.top, bottom: s.bottom };
    }
    let r = this.editorView.dom.offsetParent;
    this.element || (this.element = r.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", n), this.element.classList.toggle("prosemirror-dropcursor-inline", !n);
    let a, o;
    if (!r || r == document.body && getComputedStyle(r).position == "static")
      a = -pageXOffset, o = -pageYOffset;
    else {
      let s = r.getBoundingClientRect();
      a = s.left - r.scrollLeft, o = s.top - r.scrollTop;
    }
    this.element.style.left = i.left - a + "px", this.element.style.top = i.top - o + "px", this.element.style.width = i.right - i.left + "px", this.element.style.height = i.bottom - i.top + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let n = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), i = n && n.inside >= 0 && this.editorView.state.doc.nodeAt(n.inside), r = i && i.type.spec.disableDropCursor, a = typeof r == "function" ? r(this.editorView, n, e) : r;
    if (n && !a) {
      let o = n.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let s = q8(this.editorView.state.doc, o, this.editorView.dragging.slice);
        s != null && (o = s);
      }
      this.setCursor(o), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    (e.target == this.editorView.dom || !this.editorView.dom.contains(e.relatedTarget)) && this.setCursor(null);
  }
}
const ZFe = gt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      JFe(this.options)
    ];
  }
}), eze = gt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [
      eFe()
    ];
  },
  extendNodeSchema(t) {
    var e;
    const n = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Xe(Ne(t, "allowGapCursor", n))) !== null && e !== void 0 ? e : null
    };
  }
}), tze = qt.create({
  name: "hardBreak",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [
      { tag: "br" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", rt(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: n, editor: i }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: r, storedMarks: a } = n;
          if (r.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: o } = this.options, { splittableMarks: s } = i.extensionManager, l = a || r.$to.parentOffset && r.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: u }) => {
            if (u && l && o) {
              const f = l.filter((m) => s.includes(m.type.name));
              c.ensureMarks(f);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), nze = qt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, rt(this.options.HTMLAttributes, e), 0];
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce((t, e) => ({
      ...t,
      [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
    }), {});
  },
  addInputRules() {
    return this.options.levels.map((t) => Fg({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
});
var fm = 200, an = function() {
};
an.prototype.append = function(e) {
  return e.length ? (e = an.from(e), !this.length && e || e.length < fm && this.leafAppend(e) || this.length < fm && e.leafPrepend(this) || this.appendInner(e)) : this;
};
an.prototype.prepend = function(e) {
  return e.length ? an.from(e).append(this) : this;
};
an.prototype.appendInner = function(e) {
  return new ize(this, e);
};
an.prototype.slice = function(e, n) {
  return e === void 0 && (e = 0), n === void 0 && (n = this.length), e >= n ? an.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, n));
};
an.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
an.prototype.forEach = function(e, n, i) {
  n === void 0 && (n = 0), i === void 0 && (i = this.length), n <= i ? this.forEachInner(e, n, i, 0) : this.forEachInvertedInner(e, n, i, 0);
};
an.prototype.map = function(e, n, i) {
  n === void 0 && (n = 0), i === void 0 && (i = this.length);
  var r = [];
  return this.forEach(function(a, o) {
    return r.push(e(a, o));
  }, n, i), r;
};
an.from = function(e) {
  return e instanceof an ? e : e && e.length ? new z7(e) : an.empty;
};
var z7 = /* @__PURE__ */ function(t) {
  function e(i) {
    t.call(this), this.values = i;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var n = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(r, a) {
    return r == 0 && a == this.length ? this : new e(this.values.slice(r, a));
  }, e.prototype.getInner = function(r) {
    return this.values[r];
  }, e.prototype.forEachInner = function(r, a, o, s) {
    for (var l = a; l < o; l++)
      if (r(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(r, a, o, s) {
    for (var l = a - 1; l >= o; l--)
      if (r(this.values[l], s + l) === !1)
        return !1;
  }, e.prototype.leafAppend = function(r) {
    if (this.length + r.length <= fm)
      return new e(this.values.concat(r.flatten()));
  }, e.prototype.leafPrepend = function(r) {
    if (this.length + r.length <= fm)
      return new e(r.flatten().concat(this.values));
  }, n.length.get = function() {
    return this.values.length;
  }, n.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, n), e;
}(an);
an.empty = new z7([]);
var ize = /* @__PURE__ */ function(t) {
  function e(n, i) {
    t.call(this), this.left = n, this.right = i, this.length = n.length + i.length, this.depth = Math.max(n.depth, i.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(i) {
    return i < this.left.length ? this.left.get(i) : this.right.get(i - this.left.length);
  }, e.prototype.forEachInner = function(i, r, a, o) {
    var s = this.left.length;
    if (r < s && this.left.forEachInner(i, r, Math.min(a, s), o) === !1 || a > s && this.right.forEachInner(i, Math.max(r - s, 0), Math.min(this.length, a) - s, o + s) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(i, r, a, o) {
    var s = this.left.length;
    if (r > s && this.right.forEachInvertedInner(i, r - s, Math.max(a, s) - s, o + s) === !1 || a < s && this.left.forEachInvertedInner(i, Math.min(r, s), a, o) === !1)
      return !1;
  }, e.prototype.sliceInner = function(i, r) {
    if (i == 0 && r == this.length)
      return this;
    var a = this.left.length;
    return r <= a ? this.left.slice(i, r) : i >= a ? this.right.slice(i - a, r - a) : this.left.slice(i, a).append(this.right.slice(0, r - a));
  }, e.prototype.leafAppend = function(i) {
    var r = this.right.leafAppend(i);
    if (r)
      return new e(this.left, r);
  }, e.prototype.leafPrepend = function(i) {
    var r = this.left.leafPrepend(i);
    if (r)
      return new e(r, this.right);
  }, e.prototype.appendInner = function(i) {
    return this.left.depth >= Math.max(this.right.depth, i.depth) + 1 ? new e(this.left, new e(this.right, i)) : new e(this, i);
  }, e;
}(an);
const rze = 500;
class Fi {
  constructor(e, n) {
    this.items = e, this.eventCount = n;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, n) {
    if (this.eventCount == 0)
      return null;
    let i = this.items.length;
    for (; ; i--)
      if (this.items.get(i - 1).selection) {
        --i;
        break;
      }
    let r, a;
    n && (r = this.remapping(i, this.items.length), a = r.maps.length);
    let o = e.tr, s, l, c = [], u = [];
    return this.items.forEach((f, m) => {
      if (!f.step) {
        r || (r = this.remapping(i, m + 1), a = r.maps.length), a--, u.push(f);
        return;
      }
      if (r) {
        u.push(new Qr(f.map));
        let h = f.step.map(r.slice(a)), p;
        h && o.maybeStep(h).doc && (p = o.mapping.maps[o.mapping.maps.length - 1], c.push(new Qr(p, void 0, void 0, c.length + u.length))), a--, p && r.appendMap(p, a);
      } else
        o.maybeStep(f.step);
      if (f.selection)
        return s = r ? f.selection.map(r.slice(a)) : f.selection, l = new Fi(this.items.slice(0, i).append(u.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: l, transform: o, selection: s };
  }
  // Create a new branch with the given transform added.
  addTransform(e, n, i, r) {
    let a = [], o = this.eventCount, s = this.items, l = !r && s.length ? s.get(s.length - 1) : null;
    for (let u = 0; u < e.steps.length; u++) {
      let f = e.steps[u].invert(e.docs[u]), m = new Qr(e.mapping.maps[u], f, n), h;
      (h = l && l.merge(m)) && (m = h, u ? a.pop() : s = s.slice(0, s.length - 1)), a.push(m), n && (o++, n = void 0), r || (l = m);
    }
    let c = o - i.depth;
    return c > oze && (s = aze(s, c), o -= c), new Fi(s.append(a), o);
  }
  remapping(e, n) {
    let i = new yd();
    return this.items.forEach((r, a) => {
      let o = r.mirrorOffset != null && a - r.mirrorOffset >= e ? i.maps.length - r.mirrorOffset : void 0;
      i.appendMap(r.map, o);
    }, e, n), i;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Fi(this.items.append(e.map((n) => new Qr(n))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, n) {
    if (!this.eventCount)
      return this;
    let i = [], r = Math.max(0, this.items.length - n), a = e.mapping, o = e.steps.length, s = this.eventCount;
    this.items.forEach((m) => {
      m.selection && s--;
    }, r);
    let l = n;
    this.items.forEach((m) => {
      let h = a.getMirror(--l);
      if (h == null)
        return;
      o = Math.min(o, h);
      let p = a.maps[h];
      if (m.step) {
        let g = e.steps[h].invert(e.docs[h]), y = m.selection && m.selection.map(a.slice(l + 1, h));
        y && s++, i.push(new Qr(p, g, y));
      } else
        i.push(new Qr(p));
    }, r);
    let c = [];
    for (let m = n; m < o; m++)
      c.push(new Qr(a.maps[m]));
    let u = this.items.slice(0, r).append(c).append(i), f = new Fi(u, s);
    return f.emptyItemCount() > rze && (f = f.compress(this.items.length - i.length)), f;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((n) => {
      n.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let n = this.remapping(0, e), i = n.maps.length, r = [], a = 0;
    return this.items.forEach((o, s) => {
      if (s >= e)
        r.push(o), o.selection && a++;
      else if (o.step) {
        let l = o.step.map(n.slice(i)), c = l && l.getMap();
        if (i--, c && n.appendMap(c, i), l) {
          let u = o.selection && o.selection.map(n.slice(i));
          u && a++;
          let f = new Qr(c.invert(), l, u), m, h = r.length - 1;
          (m = r.length && r[h].merge(f)) ? r[h] = m : r.push(f);
        }
      } else o.map && i--;
    }, this.items.length, 0), new Fi(an.from(r.reverse()), a);
  }
}
Fi.empty = new Fi(an.empty, 0);
function aze(t, e) {
  let n;
  return t.forEach((i, r) => {
    if (i.selection && e-- == 0)
      return n = r, !1;
  }), t.slice(n);
}
let Qr = class V7 {
  constructor(e, n, i, r) {
    this.map = e, this.step = n, this.selection = i, this.mirrorOffset = r;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let n = e.step.merge(this.step);
      if (n)
        return new V7(n.getMap().invert(), n, this.selection);
    }
  }
};
class ia {
  constructor(e, n, i, r, a) {
    this.done = e, this.undone = n, this.prevRanges = i, this.prevTime = r, this.prevComposition = a;
  }
}
const oze = 20;
function sze(t, e, n, i) {
  let r = n.getMeta(po), a;
  if (r)
    return r.historyState;
  n.getMeta(cze) && (t = new ia(t.done, t.undone, null, 0, -1));
  let o = n.getMeta("appendedTransaction");
  if (n.steps.length == 0)
    return t;
  if (o && o.getMeta(po))
    return o.getMeta(po).redo ? new ia(t.done.addTransform(n, void 0, i, Lu(e)), t.undone, V3(n.mapping.maps), t.prevTime, t.prevComposition) : new ia(t.done, t.undone.addTransform(n, void 0, i, Lu(e)), null, t.prevTime, t.prevComposition);
  if (n.getMeta("addToHistory") !== !1 && !(o && o.getMeta("addToHistory") === !1)) {
    let s = n.getMeta("composition"), l = t.prevTime == 0 || !o && t.prevComposition != s && (t.prevTime < (n.time || 0) - i.newGroupDelay || !lze(n, t.prevRanges)), c = o ? cp(t.prevRanges, n.mapping) : V3(n.mapping.maps);
    return new ia(t.done.addTransform(n, l ? e.selection.getBookmark() : void 0, i, Lu(e)), Fi.empty, c, n.time, s ?? t.prevComposition);
  } else return (a = n.getMeta("rebased")) ? new ia(t.done.rebased(n, a), t.undone.rebased(n, a), cp(t.prevRanges, n.mapping), t.prevTime, t.prevComposition) : new ia(t.done.addMaps(n.mapping.maps), t.undone.addMaps(n.mapping.maps), cp(t.prevRanges, n.mapping), t.prevTime, t.prevComposition);
}
function lze(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let n = !1;
  return t.mapping.maps[0].forEach((i, r) => {
    for (let a = 0; a < e.length; a += 2)
      i <= e[a + 1] && r >= e[a] && (n = !0);
  }), n;
}
function V3(t) {
  let e = [];
  for (let n = t.length - 1; n >= 0 && e.length == 0; n--)
    t[n].forEach((i, r, a, o) => e.push(a, o));
  return e;
}
function cp(t, e) {
  if (!t)
    return null;
  let n = [];
  for (let i = 0; i < t.length; i += 2) {
    let r = e.map(t[i], 1), a = e.map(t[i + 1], -1);
    r <= a && n.push(r, a);
  }
  return n;
}
function dze(t, e, n) {
  let i = Lu(e), r = po.get(e).spec.config, a = (n ? t.undone : t.done).popEvent(e, i);
  if (!a)
    return null;
  let o = a.selection.resolve(a.transform.doc), s = (n ? t.done : t.undone).addTransform(a.transform, e.selection.getBookmark(), r, i), l = new ia(n ? s : a.remaining, n ? a.remaining : s, null, 0, -1);
  return a.transform.setSelection(o).setMeta(po, { redo: n, historyState: l });
}
let up = !1, H3 = null;
function Lu(t) {
  let e = t.plugins;
  if (H3 != e) {
    up = !1, H3 = e;
    for (let n = 0; n < e.length; n++)
      if (e[n].spec.historyPreserveItems) {
        up = !0;
        break;
      }
  }
  return up;
}
const po = new yt("history"), cze = new yt("closeHistory");
function uze(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new ft({
    key: po,
    state: {
      init() {
        return new ia(Fi.empty, Fi.empty, null, 0, -1);
      },
      apply(e, n, i) {
        return sze(n, i, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, n) {
          let i = n.inputType, r = i == "historyUndo" ? B7 : i == "historyRedo" ? q7 : null;
          return r ? (n.preventDefault(), r(e.state, e.dispatch)) : !1;
        }
      }
    }
  });
}
function H7(t, e) {
  return (n, i) => {
    let r = po.getState(n);
    if (!r || (t ? r.undone : r.done).eventCount == 0)
      return !1;
    if (i) {
      let a = dze(r, n, t);
      a && i(e ? a.scrollIntoView() : a);
    }
    return !0;
  };
}
const B7 = H7(!1, !0), q7 = H7(!0, !0), fze = gt.create({
  name: "history",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => B7(t, e),
      redo: () => ({ state: t, dispatch: e }) => q7(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [
      uze(this.options)
    ];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), mze = qt.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", rt(this.options.HTMLAttributes, t)];
  },
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        const { selection: n } = e, { $from: i, $to: r } = n, a = t();
        return i.parentOffset === 0 ? a.insertContentAt({
          from: Math.max(i.pos - 1, 0),
          to: r.pos
        }, {
          type: this.name
        }) : r7(n) ? a.insertContentAt(r.pos, {
          type: this.name
        }) : a.insertContent({ type: this.name }), a.command(({ tr: o, dispatch: s }) => {
          var l;
          if (s) {
            const { $to: c } = o.selection, u = c.end();
            if (c.nodeAfter)
              c.nodeAfter.isTextblock ? o.setSelection(Fe.create(o.doc, c.pos + 1)) : c.nodeAfter.isBlock ? o.setSelection(Ae.create(o.doc, c.pos)) : o.setSelection(Fe.create(o.doc, c.pos));
            else {
              const f = (l = c.parent.type.contentMatch.defaultType) === null || l === void 0 ? void 0 : l.create();
              f && (o.insert(u, f), o.setSelection(Fe.create(o.doc, u + 1)));
            }
            o.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      lIe({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), hze = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, pze = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, gze = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, yze = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, vze = Di.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      xo({
        find: hze,
        type: this.type
      }),
      xo({
        find: gze,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Na({
        find: pze,
        type: this.type
      }),
      Na({
        find: yze,
        type: this.type
      })
    ];
  }
}), bze = qt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", rt(this.options.HTMLAttributes, t), 0];
  },
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), wze = "listItem", B3 = "textStyle", q3 = /^(\d+)\.\s$/, kze = qt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...n } = t;
    return e === 1 ? ["ol", rt(this.options.HTMLAttributes, n), 0] : ["ol", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(wze, this.editor.getAttributes(B3)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = Ws({
      find: q3,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = Ws({
      find: q3,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(B3) }),
      joinPredicate: (e, n) => n.childCount + n.attrs.start === +e[1],
      editor: this.editor
    })), [
      t
    ];
  }
}), xze = qt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [
      { tag: "p" }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), _ze = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, Mze = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, Cze = Di.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", rt(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      xo({
        find: _ze,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Na({
        find: Mze,
        type: this.type
      })
    ];
  }
}), Pze = qt.create({
  name: "text",
  group: "inline"
}), Sze = gt.create({
  name: "starterKit",
  addExtensions() {
    const t = [];
    return this.options.bold !== !1 && t.push(zFe.configure(this.options.bold)), this.options.blockquote !== !1 && t.push(LFe.configure(this.options.blockquote)), this.options.bulletList !== !1 && t.push(HFe.configure(this.options.bulletList)), this.options.code !== !1 && t.push(GFe.configure(this.options.code)), this.options.codeBlock !== !1 && t.push(KFe.configure(this.options.codeBlock)), this.options.document !== !1 && t.push(UFe.configure(this.options.document)), this.options.dropcursor !== !1 && t.push(ZFe.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && t.push(eze.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && t.push(tze.configure(this.options.hardBreak)), this.options.heading !== !1 && t.push(nze.configure(this.options.heading)), this.options.history !== !1 && t.push(fze.configure(this.options.history)), this.options.horizontalRule !== !1 && t.push(mze.configure(this.options.horizontalRule)), this.options.italic !== !1 && t.push(vze.configure(this.options.italic)), this.options.listItem !== !1 && t.push(bze.configure(this.options.listItem)), this.options.orderedList !== !1 && t.push(kze.configure(this.options.orderedList)), this.options.paragraph !== !1 && t.push(xze.configure(this.options.paragraph)), this.options.strike !== !1 && t.push(Cze.configure(this.options.strike)), this.options.text !== !1 && t.push(Pze.configure(this.options.text)), t;
  }
}), Ab = Sze.configure({
  heading: { levels: [1, 2, 3] },
  bulletList: {
    HTMLAttributes: {
      class: "f1-bullet-list"
    }
  },
  orderedList: {
    HTMLAttributes: {
      class: "f1-ordered-list"
    }
  }
}), Nze = qt.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", rt(this.options.HTMLAttributes, t, { "data-type": this.name }), 0];
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: t }) => t.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
}), Lb = Nze.configure({
  HTMLAttributes: {
    class: "f1-task-list"
  }
}), $ze = gt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: ["left", "center", "right", "justify"],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          textAlign: {
            default: this.options.defaultAlignment,
            parseHTML: (t) => {
              const e = t.style.textAlign;
              return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
            },
            renderHTML: (t) => t.textAlign ? { style: `text-align: ${t.textAlign}` } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((n) => e.updateAttributes(n, { textAlign: t })).every((n) => n) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).every((e) => e)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
}), Ib = $ze.configure({
  types: ["heading", "paragraph"]
}), G3 = (t, e) => {
  const n = t.view.dom;
  n.setAttribute("aria-label", e), n.getAttribute("role") === "textbox" && n.removeAttribute("aria-expanded");
}, Dze = gt.create({
  name: "accessibility",
  addOptions() {
    return {
      label: "Rich text editor"
    };
  },
  onCreate() {
    G3(this.editor, this.options.label);
  },
  onTransaction() {
    G3(this.editor, this.options.label);
  }
}), G7 = (t) => Dze.configure({ label: t || "Rich text" }), Eze = gt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (t) => t.length,
      wordCounter: (t) => t.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc;
      if (((t == null ? void 0 : t.mode) || this.options.mode) === "textSize") {
        const i = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(i);
      }
      return e.nodeSize;
    }, this.storage.words = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc, n = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(n);
    };
  },
  addProseMirrorPlugins() {
    let t = !1;
    return [
      new ft({
        key: new yt("characterCount"),
        appendTransaction: (e, n, i) => {
          if (t)
            return;
          const r = this.options.limit;
          if (r == null || r === 0) {
            t = !0;
            return;
          }
          const a = this.storage.characters({ node: i.doc });
          if (a > r) {
            const o = a - r, s = 0, l = o;
            console.warn(`[CharacterCount] Initial content exceeded limit of ${r} characters. Content was automatically trimmed.`);
            const c = i.tr.deleteRange(s, l);
            return t = !0, c;
          }
          t = !0;
        },
        filterTransaction: (e, n) => {
          const i = this.options.limit;
          if (!e.docChanged || i === 0 || i === null || i === void 0)
            return !0;
          const r = this.storage.characters({ node: n.doc }), a = this.storage.characters({ node: e.doc });
          if (a <= i || r > i && a > i && a <= r)
            return !0;
          if (r > i && a > i && a > r || !e.getMeta("paste"))
            return !1;
          const s = e.selection.$head.pos, l = a - i, c = s - l, u = s;
          return e.deleteRange(c, u), !(this.storage.characters({ node: e.doc }) > i);
        }
      })
    ];
  }
}), Tze = (t) => Eze.configure({ limit: t });
function Oze(t) {
  var e;
  const { char: n, allowSpaces: i, allowToIncludeChar: r, allowedPrefixes: a, startOfLine: o, $position: s } = t, l = i && !r, c = cIe(n), u = new RegExp(`\\s${c}$`), f = o ? "^" : "", m = r ? "" : c, h = l ? new RegExp(`${f}${c}.*?(?=\\s${m}|$)`, "gm") : new RegExp(`${f}(?:^)?${c}[^\\s${m}]*`, "gm"), p = ((e = s.nodeBefore) === null || e === void 0 ? void 0 : e.isText) && s.nodeBefore.text;
  if (!p)
    return null;
  const g = s.pos - p.length, y = Array.from(p.matchAll(h)).pop();
  if (!y || y.input === void 0 || y.index === void 0)
    return null;
  const v = y.input.slice(Math.max(0, y.index - 1), y.index), w = new RegExp(`^[${a == null ? void 0 : a.join("")}\0]?$`).test(v);
  if (a !== null && !w)
    return null;
  const x = g + y.index;
  let b = x + y[0].length;
  return l && u.test(p.slice(b - 1, b + 1)) && (y[0] += " ", b += 1), x < s.pos && b >= s.pos ? {
    range: {
      from: x,
      to: b
    },
    query: y[0].slice(n.length),
    text: y[0]
  } : null;
}
const Wze = new yt("suggestion");
function X7({ pluginKey: t = Wze, editor: e, char: n = "@", allowSpaces: i = !1, allowToIncludeChar: r = !1, allowedPrefixes: a = [" "], startOfLine: o = !1, decorationTag: s = "span", decorationClass: l = "suggestion", command: c = () => null, items: u = () => [], render: f = () => ({}), allow: m = () => !0, findSuggestionMatch: h = Oze }) {
  let p;
  const g = f == null ? void 0 : f(), y = new ft({
    key: t,
    view() {
      return {
        update: async (v, w) => {
          var x, b, M, _, N, $, D;
          const W = (x = this.key) === null || x === void 0 ? void 0 : x.getState(w), j = (b = this.key) === null || b === void 0 ? void 0 : b.getState(v.state), O = W.active && j.active && W.range.from !== j.range.from, I = !W.active && j.active, L = W.active && !j.active, R = !I && !L && W.query !== j.query, B = I || O && R, F = R || O, z = L || O && R;
          if (!B && !F && !z)
            return;
          const K = z && !B ? W : j, ae = v.dom.querySelector(`[data-decoration-id="${K.decorationId}"]`);
          p = {
            editor: e,
            range: K.range,
            query: K.query,
            text: K.text,
            items: [],
            command: (Q) => c({
              editor: e,
              range: K.range,
              props: Q
            }),
            decorationNode: ae,
            // virtual node for popper.js or tippy.js
            // this can be used for building popups without a DOM node
            clientRect: ae ? () => {
              var Q;
              const { decorationId: te } = (Q = this.key) === null || Q === void 0 ? void 0 : Q.getState(e.state), be = v.dom.querySelector(`[data-decoration-id="${te}"]`);
              return (be == null ? void 0 : be.getBoundingClientRect()) || null;
            } : null
          }, B && ((M = g == null ? void 0 : g.onBeforeStart) === null || M === void 0 || M.call(g, p)), F && ((_ = g == null ? void 0 : g.onBeforeUpdate) === null || _ === void 0 || _.call(g, p)), (F || B) && (p.items = await u({
            editor: e,
            query: K.query
          })), z && ((N = g == null ? void 0 : g.onExit) === null || N === void 0 || N.call(g, p)), F && (($ = g == null ? void 0 : g.onUpdate) === null || $ === void 0 || $.call(g, p)), B && ((D = g == null ? void 0 : g.onStart) === null || D === void 0 || D.call(g, p));
        },
        destroy: () => {
          var v;
          p && ((v = g == null ? void 0 : g.onExit) === null || v === void 0 || v.call(g, p));
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        return {
          active: !1,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: !1
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply(v, w, x, b) {
        const { isEditable: M } = e, { composing: _ } = e.view, { selection: N } = v, { empty: $, from: D } = N, W = { ...w };
        if (W.composing = _, M && ($ || e.view.composing)) {
          (D < w.range.from || D > w.range.to) && !_ && !w.composing && (W.active = !1);
          const j = h({
            char: n,
            allowSpaces: i,
            allowToIncludeChar: r,
            allowedPrefixes: a,
            startOfLine: o,
            $position: N.$from
          }), O = `id_${Math.floor(Math.random() * 4294967295)}`;
          j && m({
            editor: e,
            state: b,
            range: j.range,
            isActive: w.active
          }) ? (W.active = !0, W.decorationId = w.decorationId ? w.decorationId : O, W.range = j.range, W.query = j.query, W.text = j.text) : W.active = !1;
        } else
          W.active = !1;
        return W.active || (W.decorationId = null, W.range = { from: 0, to: 0 }, W.query = null, W.text = null), W;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(v, w) {
        var x;
        const { active: b, range: M } = y.getState(v.state);
        return b && ((x = g == null ? void 0 : g.onKeyDown) === null || x === void 0 ? void 0 : x.call(g, { view: v, event: w, range: M })) || !1;
      },
      // Setup decorator on the currently active suggestion.
      decorations(v) {
        const { active: w, range: x, decorationId: b } = y.getState(v);
        return w ? ht.create(v.doc, [
          fn.inline(x.from, x.to, {
            nodeName: s,
            class: l,
            "data-decoration-id": b
          })
        ]) : null;
      }
    }
  });
  return y;
}
const Aze = new yt("mention"), Lze = qt.create({
  name: "mention",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      renderText({ options: t, node: e }) {
        var n;
        return `${t.suggestion.char}${(n = e.attrs.label) !== null && n !== void 0 ? n : e.attrs.id}`;
      },
      deleteTriggerWithBackspace: !1,
      renderHTML({ options: t, node: e }) {
        var n;
        return [
          "span",
          rt(this.HTMLAttributes, t.HTMLAttributes),
          `${t.suggestion.char}${(n = e.attrs.label) !== null && n !== void 0 ? n : e.attrs.id}`
        ];
      },
      suggestion: {
        char: "@",
        pluginKey: Aze,
        command: ({ editor: t, range: e, props: n }) => {
          var i, r, a;
          const o = t.view.state.selection.$to.nodeAfter;
          ((i = o == null ? void 0 : o.text) === null || i === void 0 ? void 0 : i.startsWith(" ")) && (e.to += 1), t.chain().focus().insertContentAt(e, [
            {
              type: this.name,
              attrs: n
            },
            {
              type: "text",
              text: " "
            }
          ]).run(), (a = (r = t.view.dom.ownerDocument.defaultView) === null || r === void 0 ? void 0 : r.getSelection()) === null || a === void 0 || a.collapseToEnd();
        },
        allow: ({ state: t, range: e }) => {
          const n = t.doc.resolve(e.from), i = t.schema.nodes[this.name];
          return !!n.parent.type.contentMatch.matchType(i);
        }
      }
    };
  },
  group: "inline",
  inline: !0,
  selectable: !1,
  atom: !0,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-id"),
        renderHTML: (t) => t.id ? {
          "data-id": t.id
        } : {}
      },
      label: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-label"),
        renderHTML: (t) => t.label ? {
          "data-label": t.label
        } : {}
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    if (this.options.renderLabel !== void 0)
      return console.warn("renderLabel is deprecated use renderText and renderHTML instead"), [
        "span",
        rt({ "data-type": this.name }, this.options.HTMLAttributes, e),
        this.options.renderLabel({
          options: this.options,
          node: t
        })
      ];
    const n = { ...this.options };
    n.HTMLAttributes = rt({ "data-type": this.name }, this.options.HTMLAttributes, e);
    const i = this.options.renderHTML({
      options: n,
      node: t
    });
    return typeof i == "string" ? [
      "span",
      rt({ "data-type": this.name }, this.options.HTMLAttributes, e),
      i
    ] : i;
  },
  renderText({ node: t }) {
    return this.options.renderLabel !== void 0 ? (console.warn("renderLabel is deprecated use renderText and renderHTML instead"), this.options.renderLabel({
      options: this.options,
      node: t
    })) : this.options.renderText({
      options: this.options,
      node: t
    });
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: t, state: e }) => {
        let n = !1;
        const { selection: i } = e, { empty: r, anchor: a } = i;
        return r ? (e.doc.nodesBetween(a - 1, a, (o, s) => {
          if (o.type.name === this.name)
            return n = !0, t.insertText(this.options.deleteTriggerWithBackspace ? "" : this.options.suggestion.char || "", s, s + o.nodeSize), !1;
        }), n) : !1;
      })
    };
  },
  addProseMirrorPlugins() {
    return [
      X7({
        editor: this.editor,
        ...this.options.suggestion
      })
    ];
  }
});
var Yo = {}, X3;
function Ize() {
  if (X3) return Yo;
  X3 = 1;
  var t = Em;
  if (process.env.NODE_ENV === "production")
    Yo.createRoot = t.createRoot, Yo.hydrateRoot = t.hydrateRoot;
  else {
    var e = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    Yo.createRoot = function(n, i) {
      e.usingClientEntryPoint = !0;
      try {
        return t.createRoot(n, i);
      } finally {
        e.usingClientEntryPoint = !1;
      }
    }, Yo.hydrateRoot = function(n, i, r) {
      e.usingClientEntryPoint = !0;
      try {
        return t.hydrateRoot(n, i, r);
      } finally {
        e.usingClientEntryPoint = !1;
      }
    };
  }
  return Yo;
}
var Y7 = Ize();
const Rze = ({ item: t, selected: e }) => /* @__PURE__ */ k(
  "div",
  {
    className: E(
      "flex items-center gap-2 rounded-md border border-solid p-1.5 hover:bg-f1-background-hover",
      e ? "border-f1-border-selected-bold" : "border-f1-border-inverse"
    ),
    children: [
      /* @__PURE__ */ d(
        ti,
        {
          firstName: t.label,
          lastName: "",
          src: t.image_url ?? void 0,
          size: "small"
        }
      ),
      /* @__PURE__ */ d("p", { className: "text-neutral-100 text-md truncate text-ellipsis font-medium", children: t.label })
    ]
  }
), K7 = X(
  ({ items: t, command: e, component: n = Rze }, i) => {
    const [r, a] = q(0), o = Le(
      (u) => {
        const f = t[u];
        f && e(f);
      },
      [t, e]
    ), s = Le(() => {
      a((u) => (u + t.length - 1) % t.length);
    }, [t.length]), l = Le(() => {
      a((u) => (u + 1) % t.length);
    }, [t.length]), c = Le(() => {
      o(r);
    }, [r, o]);
    return le(() => {
      a(0);
    }, [t]), Dm(
      i,
      () => ({
        onKeyDown: ({ event: u }) => u.key === "ArrowUp" ? (s(), !0) : u.key === "ArrowDown" ? (l(), !0) : u.key === "Enter" ? (c(), !0) : !1
      }),
      [s, l, c]
    ), /* @__PURE__ */ d("div", { className: "flex max-h-72 w-60 flex-col gap-2 overflow-y-auto rounded-md border border-solid border-f1-border bg-f1-background p-0.5 drop-shadow-sm", children: t.length === 0 ? /* @__PURE__ */ d("div", { className: "p-2", children: /* @__PURE__ */ d("p", { className: "text-neutral-40 text-sm font-medium", children: "No results found" }) }) : t.map((u, f) => /* @__PURE__ */ d(
      "div",
      {
        onClick: () => o(f),
        onMouseEnter: () => a(f),
        className: "cursor-pointer bg-f1-background",
        children: /* @__PURE__ */ d(
          n,
          {
            item: u,
            index: f,
            selected: f === r
          }
        )
      },
      f
    )) });
  }
);
K7.displayName = "MentionList";
const Y3 = ({
  content: t,
  anchorRect: e,
  editor: n
}) => {
  const i = {
    position: "absolute",
    top: e.bottom + window.scrollY,
    left: e.left + window.scrollX,
    width: 0,
    height: 0
  };
  return /* @__PURE__ */ k(
    Jd,
    {
      open: !0,
      modal: !1,
      onOpenChange: (r) => {
        r && (n == null || n.commands.focus());
      },
      children: [
        /* @__PURE__ */ d("div", { style: i }),
        /* @__PURE__ */ d(m5, { asChild: !0, children: /* @__PURE__ */ d("div", { style: i }) }),
        /* @__PURE__ */ d(
          Qd,
          {
            side: "top",
            align: "start",
            sideOffset: 25,
            collisionPadding: 10,
            style: { zIndex: 9999 },
            onMouseDownCapture: () => {
              n == null || n.commands.focus();
            },
            onOpenAutoFocus: (r) => {
              r.preventDefault();
            },
            onCloseAutoFocus: (r) => {
              r.preventDefault();
            },
            children: /* @__PURE__ */ d(
              "div",
              {
                ref: (r) => {
                  r && t.parentNode !== r && r.appendChild(t);
                }
              }
            )
          }
        )
      ]
    }
  );
};
function jze(t, e, n, i) {
  return {
    char: "@",
    minLength: 0,
    items: async ({ query: r }) => {
      if (n)
        try {
          const a = await n(r);
          return e(a || []), a || [];
        } catch {
          return [];
        }
      else if (i) {
        const a = r.toLowerCase().trim();
        let o;
        return a ? o = i.filter(
          (s) => s.label.toLowerCase().includes(a)
        ) : o = i, e(o), o;
      }
      return t;
    },
    render: () => {
      let r = null, a = null, o = null;
      const s = () => {
        const l = window.getSelection();
        if (l && l.rangeCount > 0) {
          const c = l.getRangeAt(0), { startContainer: u, startOffset: f } = c;
          if (u.nodeType === Node.TEXT_NODE) {
            const h = (u.textContent || "").lastIndexOf("@", f);
            if (h !== -1) {
              const p = document.createRange();
              return p.setStart(u, h), p.setEnd(u, h + 1), p.getBoundingClientRect();
            }
          }
          return c.getBoundingClientRect();
        }
        return document.body.getBoundingClientRect();
      };
      return {
        onStart: (l) => {
          var m;
          const c = (h) => {
            l.command({
              id: String(h.id),
              label: h.label,
              image_url: h.image_url,
              href: h.href
            });
          };
          r = new yb(K7, {
            props: { items: l.items, command: c },
            editor: l.editor
          });
          const f = (() => {
            if (l.clientRect) {
              const h = l.clientRect();
              if (h && h.width && h.height) return h;
            }
            return s();
          })();
          o = document.createElement("div"), document.body.appendChild(o), a = Y7.createRoot(o), a.render(
            /* @__PURE__ */ d(
              Y3,
              {
                content: r.element,
                anchorRect: f,
                editor: l.editor
              }
            )
          ), (m = l.editor) == null || m.commands.focus();
        },
        onUpdate: (l) => {
          if (!r || !o || !a) return;
          r.updateProps({ items: l.items });
          const u = (() => {
            if (l.clientRect) {
              const f = l.clientRect();
              if (f && f.width && f.height) return f;
            }
            return s();
          })();
          a.render(
            /* @__PURE__ */ d(
              Y3,
              {
                content: r.element,
                anchorRect: u,
                editor: l.editor
              }
            )
          );
        },
        onKeyDown: (l) => {
          var c, u;
          return r ? l.event.key === "ArrowUp" || l.event.key === "ArrowDown" ? ((c = r.ref) == null ? void 0 : c.onKeyDown(l)) || !1 : l.event.key === "Escape" ? (a && o && (a.unmount(), o.remove()), !0) : ((u = r.ref) == null ? void 0 : u.onKeyDown(l)) || !1 : !1;
        },
        onExit() {
          a && o && (a.unmount(), o.remove()), r == null || r.destroy();
        }
      };
    }
  };
}
const Fze = Lze.extend({
  addAttributes() {
    var t;
    return {
      ...(t = this.parent) == null ? void 0 : t.call(this),
      id: { default: null },
      label: { default: null },
      href: { default: "#" }
    };
  }
}), zze = (t, e, n) => {
  var i;
  return (i = n == null ? void 0 : n.users) != null && i.length ? [
    Fze.configure({
      HTMLAttributes: {
        class: "mention"
      },
      renderHTML({ options: r, node: a }) {
        return [
          "a",
          {
            onclick: "if(this.closest('.ProseMirror')?.getAttribute('contenteditable') === 'true') { event.preventDefault(); }",
            href: a.attrs.href || "#",
            class: r.HTMLAttributes.class,
            "data-id": a.attrs.id,
            rel: "noopener noreferrer",
            target: "_blank"
          },
          `${a.attrs.label}`
        ];
      },
      suggestion: jze(
        t,
        e,
        n.onMentionQueryStringChanged,
        n.users
      )
    })
  ] : [];
}, Vze = gt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    return [
      new ft({
        key: new yt("placeholder"),
        props: {
          decorations: ({ doc: t, selection: e }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: i } = e, r = [];
            if (!n)
              return null;
            const a = this.editor.isEmpty;
            return t.descendants((o, s) => {
              const l = i >= s && i <= s + o.nodeSize, c = !o.isLeaf && Ch(o);
              if ((l || !this.options.showOnlyCurrent) && c) {
                const u = [this.options.emptyNodeClass];
                a && u.push(this.options.emptyEditorClass);
                const f = fn.node(s, s + o.nodeSize, {
                  class: u.join(" "),
                  "data-placeholder": typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: s,
                    hasAnchor: l
                  }) : this.options.placeholder
                });
                r.push(f);
              }
              return this.options.includeChildren;
            }), ht.create(t, r);
          }
        }
      })
    ];
  }
}), U7 = (t) => Vze.configure({
  includeChildren: !0,
  placeholder: t
}), Hze = () => /* @__PURE__ */ k("div", { className: "space-y-3", children: [
  /* @__PURE__ */ k("div", { className: "flex space-x-2", children: [
    /* @__PURE__ */ d("div", { className: "h-4 w-16 animate-pulse rounded bg-f1-background-secondary" }),
    /* @__PURE__ */ d("div", { className: "h-4 w-32 animate-pulse rounded bg-f1-background-secondary" })
  ] }),
  /* @__PURE__ */ k("div", { className: "space-y-2", children: [
    /* @__PURE__ */ d("div", { className: "h-4 w-full animate-pulse rounded bg-f1-background-secondary" }),
    /* @__PURE__ */ d("div", { className: "h-4 w-4/5 animate-pulse rounded bg-f1-background-secondary" }),
    /* @__PURE__ */ d("div", { className: "h-4 w-3/4 animate-pulse rounded bg-f1-background-secondary" }),
    /* @__PURE__ */ d("div", { className: "h-4 w-full animate-pulse rounded bg-f1-background-secondary" }),
    /* @__PURE__ */ d("div", { className: "h-4 w-1/2 animate-pulse rounded bg-f1-background-secondary" })
  ] })
] }), Bze = (t, e, n, i) => {
  const r = ve(
    () => [
      Ab,
      xb,
      wb,
      vb,
      kb,
      Lb,
      _b,
      bb,
      Ib,
      Wb,
      Rb
    ],
    []
  ), a = Oe(null), o = gb(
    {
      extensions: r,
      content: (t == null ? void 0 : t.content) || null,
      editable: !0,
      editorProps: {
        attributes: {
          class: `ai-block-editor-${n}`,
          "data-testid": `ai-block-content-${n}`
        }
      },
      onUpdate: ({ editor: s }) => {
        const l = s.isEmpty;
        a.current && clearTimeout(a.current), a.current = setTimeout(() => {
          const { from: c, to: u } = s.state.selection;
          if (l && (t != null && t.selectedAction) && !e)
            i({
              data: {
                content: null,
                selectedAction: void 0,
                selectedTitle: void 0,
                selectedEmoji: void 0
              }
            });
          else if (!l) {
            const f = s.getJSON();
            i({
              data: {
                content: f,
                selectedAction: t == null ? void 0 : t.selectedAction,
                selectedTitle: t == null ? void 0 : t.selectedTitle,
                selectedEmoji: t == null ? void 0 : t.selectedEmoji
              }
            });
          }
          setTimeout(() => {
            s && s.isFocused && s.commands.setTextSelection({ from: c, to: u });
          }, 10);
        }, 300);
      }
    },
    [n]
  );
  return le(() => {
    if (o && (t != null && t.content)) {
      const { from: s, to: l } = o.state.selection, c = s !== l;
      o.commands.setContent(t.content), c && o.isFocused && setTimeout(() => {
        o.commands.setTextSelection({ from: s, to: l });
      }, 10);
    }
  }, [o, t == null ? void 0 : t.content]), le(() => () => {
    a.current && clearTimeout(a.current);
  }, []), o;
}, qze = (t, e = !1) => {
  const [n, i] = q(!1), [r, a] = q(e);
  return le(() => {
    t != null && t.selectedAction && !(t != null && t.content) && !n && i(!0);
  }, [t == null ? void 0 : t.selectedAction, t == null ? void 0 : t.content, n]), le(() => {
    t != null && t.content && n && i(!1);
  }, [t == null ? void 0 : t.content, n]), {
    isLoading: n,
    setIsLoading: i,
    isCollapsed: r,
    setIsCollapsed: a
  };
}, Gze = (t, e, n) => ve(() => {
  if (t != null && t.selectedTitle || t != null && t.selectedEmoji)
    return {
      title: t.selectedTitle || e.title,
      emoji: t.selectedEmoji
    };
  if (n) {
    const i = e.buttons.find(
      (r) => r.type === n
    );
    if (i)
      return {
        title: i.label,
        emoji: i.emoji
      };
  }
  return {
    title: e.title
  };
}, [t == null ? void 0 : t.selectedTitle, t == null ? void 0 : t.selectedEmoji, n, e]), Xze = ({
  displayTitle: t,
  displayEmoji: e,
  isLoading: n,
  canCollapse: i,
  isCollapsed: r,
  onToggleCollapse: a,
  onDropdownAction: o
}) => /* @__PURE__ */ k(
  re.div,
  {
    className: "flex flex-row items-center justify-between gap-2",
    layout: !0,
    children: [
      /* @__PURE__ */ k(
        "div",
        {
          className: `flex flex-row items-center gap-2 ${i ? "cursor-pointer" : ""}`,
          onClick: i ? a : void 0,
          children: [
            /* @__PURE__ */ d(
              re.span,
              {
                className: "flex items-center text-lg",
                animate: {
                  scale: n ? [1, 1.1, 1] : 1,
                  rotate: n ? [0, 5, -5, 0] : 0
                },
                transition: {
                  duration: n ? 2 : 0.3,
                  repeat: n ? 1 / 0 : 0,
                  ease: "easeInOut"
                },
                children: e ?? /* @__PURE__ */ d(me, { icon: Ly })
              }
            ),
            /* @__PURE__ */ d("p", { className: "text-f1-text-primary text-lg font-semibold", children: t })
          ]
        }
      ),
      /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
        i && /* @__PURE__ */ d(
          ue,
          {
            onClick: a,
            variant: "outline",
            size: "sm",
            hideLabel: !0,
            label: r ? "Expand" : "Collapse",
            icon: r ? zn : qs
          }
        ),
        /* @__PURE__ */ d(In, { items: o([]), size: "sm" })
      ] })
    ]
  }
), Yze = ({
  config: t,
  isLoading: e,
  onButtonClick: n,
  shouldShow: i
}) => /* @__PURE__ */ d(Ue, { children: i && /* @__PURE__ */ d(
  re.div,
  {
    className: "relative flex flex-row flex-wrap items-center gap-2",
    initial: { opacity: 0, height: 0 },
    animate: { opacity: 1, height: "auto" },
    exit: { opacity: 0, height: 0 },
    transition: { duration: 0.3, ease: "easeInOut" },
    children: t.buttons.map((r, a) => /* @__PURE__ */ d(
      re.div,
      {
        initial: { opacity: 0, x: -20 },
        animate: { opacity: 1, x: 0 },
        transition: {
          delay: a * 0.1,
          duration: 0.3,
          ease: "easeOut"
        },
        children: /* @__PURE__ */ d(
          ue,
          {
            onClick: () => n(r.type),
            variant: "outline",
            size: "md",
            emoji: r.emoji,
            label: r.label,
            disabled: e
          }
        )
      },
      a
    ))
  }
) }), Kze = ({
  isLoading: t,
  hasContent: e,
  isCollapsed: n,
  contentEditor: i
}) => /* @__PURE__ */ k(Ue, { mode: "wait", children: [
  t && /* @__PURE__ */ d(
    re.div,
    {
      initial: { opacity: 0, scale: 0.95 },
      animate: { opacity: 1, scale: 1 },
      exit: { opacity: 0, scale: 0.95 },
      transition: { duration: 0.3, ease: "easeOut" },
      children: /* @__PURE__ */ d(Hze, {})
    },
    "loading"
  ),
  e && !t && !n && i && /* @__PURE__ */ d(
    re.div,
    {
      initial: {
        height: 0,
        opacity: 0
      },
      animate: {
        height: "auto",
        opacity: 1
      },
      exit: {
        height: 0,
        opacity: 0
      },
      transition: {
        duration: 0.3,
        ease: "easeInOut",
        opacity: { duration: 0.2 }
      },
      style: {
        transformOrigin: "top",
        overflow: "hidden"
      },
      children: /* @__PURE__ */ d("div", { className: "text-f1-text-primary", children: /* @__PURE__ */ d(hb, { editor: i }) })
    },
    "content"
  )
] }), Uze = ({
  node: t,
  updateAttributes: e,
  deleteNode: n,
  extension: i
}) => {
  const r = t.attrs.data, a = i.options.currentConfig || t.attrs.config, o = Oe(Math.random().toString(36).substr(2, 9)).current, { isLoading: s, setIsLoading: l, isCollapsed: c, setIsCollapsed: u } = qze(r, t.attrs.isCollapsed ?? !1), { title: f, emoji: m } = Gze(
    r,
    a,
    r == null ? void 0 : r.selectedAction
  ), h = Bze(
    r,
    s,
    o,
    e
  );
  le(() => {
    if (r != null && r.selectedAction && (!(r != null && r.selectedTitle) || !(r != null && r.selectedEmoji)) && (a != null && a.buttons)) {
      const _ = a.buttons.find(
        (N) => N.type === r.selectedAction
      );
      _ && e({
        data: {
          ...r,
          selectedTitle: _.label,
          selectedEmoji: _.emoji
        }
      });
    }
  }, [r, a, e]);
  const p = Le(
    async (_) => {
      const N = a.buttons.find(
        (D) => D.type === _
      );
      l(!0);
      const $ = {
        selectedAction: _,
        selectedTitle: (N == null ? void 0 : N.label) || _,
        selectedEmoji: (N == null ? void 0 : N.emoji) || "🤖",
        content: null
      };
      e({ data: $ });
      try {
        const W = {
          content: await a.onClick(_),
          selectedAction: _,
          selectedTitle: (N == null ? void 0 : N.label) || _,
          selectedEmoji: (N == null ? void 0 : N.emoji) || "🤖"
        };
        e({ data: W });
      } catch (D) {
        console.error("AIBlock error:", D);
        const W = {
          selectedAction: _,
          selectedTitle: (N == null ? void 0 : N.label) || _,
          selectedEmoji: (N == null ? void 0 : N.emoji) || "🤖",
          content: null
        };
        e({ data: W });
      } finally {
        l(!1);
      }
    },
    [a, l, e]
  ), g = Le(() => {
    e({
      data: {
        content: null,
        selectedAction: void 0,
        selectedTitle: void 0,
        selectedEmoji: void 0
      },
      isCollapsed: !1
    }), l(!1), u(!1);
  }, [e, l, u]), y = Le(() => {
    const _ = !c;
    u(_), e({ isCollapsed: _ });
  }, [c, u, e]), v = Le(() => {
    var N, $, D;
    const _ = [];
    return a && (r != null && r.selectedTitle || r != null && r.selectedAction) && !s && _.push({
      label: ((N = a.labels) == null ? void 0 : N.reset) || "Reset",
      description: (($ = a.labels) == null ? void 0 : $.resetDescription) || "Reset the block",
      onClick: g
    }), _.length > 0 && _.push({
      type: "separator"
    }), _.push({
      label: ((D = a == null ? void 0 : a.labels) == null ? void 0 : D.deleteBlock) || "Delete",
      icon: tc,
      critical: !0,
      onClick: () => n()
    }), _;
  }, [
    a,
    r == null ? void 0 : r.selectedTitle,
    r == null ? void 0 : r.selectedAction,
    s,
    g,
    n
  ]), w = !!(r != null && r.content), x = !!(r != null && r.selectedTitle || r != null && r.selectedAction), b = x && w && !s, M = !s && !x && !w;
  return !r || !a ? null : /* @__PURE__ */ k(Dc, { contentEditable: !1, children: [
    /* @__PURE__ */ k(
      re.div,
      {
        className: E(
          "editor-ai-block my-4 flex w-full flex-col gap-4 rounded-md border border-solid border-f1-border-secondary p-3",
          !w && !s && "bg-gradient-to-t from-f1-background to-[#efeafa]"
        ),
        onClick: (_) => _.stopPropagation(),
        layout: !0,
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3, ease: "easeOut" },
        children: [
          /* @__PURE__ */ d(
            Xze,
            {
              displayTitle: f,
              displayEmoji: m,
              isLoading: s,
              canCollapse: b,
              isCollapsed: c,
              onToggleCollapse: y,
              onDropdownAction: v
            }
          ),
          /* @__PURE__ */ d(
            Yze,
            {
              config: a,
              isLoading: s,
              onButtonClick: p,
              shouldShow: M
            }
          ),
          /* @__PURE__ */ d(
            Kze,
            {
              isLoading: s,
              hasContent: w,
              isCollapsed: c,
              contentEditor: h
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ d($c, { style: { display: "none" } })
  ] });
}, Jze = qt.create({
  name: "aiBlock",
  group: "block",
  atom: !0,
  selectable: !0,
  draggable: !0,
  addOptions() {
    return {
      currentConfig: null
    };
  },
  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("data-ai-block");
          return e ? JSON.parse(e) : null;
        },
        renderHTML: (t) => t.data ? {
          "data-ai-block": JSON.stringify(t.data)
        } : {}
      },
      config: {
        default: null
      },
      isCollapsed: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-ai-block]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t, node: e }) {
    const n = e.attrs.data, i = e.attrs.config;
    return !n || !i ? ["div"] : [
      "div",
      {
        ...t,
        class: "ai-block",
        "data-ai-block": JSON.stringify(n)
      },
      ["div", { class: "ai-block-content" }, `AI Block: ${i.title}`]
    ];
  },
  addNodeView() {
    return Ec(Uze);
  },
  addCommands() {
    return {
      insertAIBlock: (t, e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: { data: t, config: e }
      })
    };
  }
}), Qze = Jze, Zze = ({
  node: t,
  deleteNode: e,
  extension: n,
  updateAttributes: i
}) => {
  var u, f, m;
  const [r, a] = q(t.attrs.isOpen ?? !1), o = t.attrs.data, s = n.options.currentConfig || t.attrs.config || {};
  if (!o) return null;
  const l = () => {
    const h = !r;
    a(h), i({ isOpen: h });
  }, c = [
    {
      label: ((u = s.labels) == null ? void 0 : u.deleteBlock) || "Delete",
      icon: tc,
      critical: !0,
      onClick: () => e()
    }
  ];
  return /* @__PURE__ */ k(Dc, { contentEditable: !1, children: [
    /* @__PURE__ */ k(
      re.div,
      {
        className: "editor-mood-tracker my-4 flex w-full flex-col gap-4 rounded-md border border-solid border-f1-border-secondary p-3",
        onClick: (h) => h.stopPropagation(),
        layout: !0,
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3, ease: "easeOut" },
        children: [
          /* @__PURE__ */ k(
            re.div,
            {
              className: "flex flex-row items-center justify-between gap-2",
              layout: !0,
              children: [
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: "flex cursor-pointer flex-row items-center gap-2",
                    onClick: l,
                    children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
                      /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-3", children: [
                        /* @__PURE__ */ d("p", { className: "text-f1-text-primary text-lg font-semibold", children: o.title }),
                        /* @__PURE__ */ d("div", { className: "flex flex-row items-center", children: o.days.map((h, p) => /* @__PURE__ */ d(
                          "div",
                          {
                            className: "-ml-1.5 flex items-center justify-center rounded-full bg-f1-background",
                            children: /* @__PURE__ */ d(
                              me,
                              {
                                icon: cg[h.mood],
                                size: "lg",
                                className: ug({ pulse: h.mood })
                              }
                            )
                          },
                          p
                        )) })
                      ] }),
                      /* @__PURE__ */ d("p", { children: /* @__PURE__ */ d("span", { className: "text-f1-text-primary text-md font-normal", children: o.averageMoodComment }) })
                    ] })
                  }
                ),
                /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
                  /* @__PURE__ */ d(
                    ue,
                    {
                      onClick: l,
                      variant: "outline",
                      hideLabel: !0,
                      label: r ? ((f = s.labels) == null ? void 0 : f.collapse) || "Collapse" : ((m = s.labels) == null ? void 0 : m.expand) || "Expand",
                      icon: r ? qs : zn,
                      size: "sm"
                    }
                  ),
                  /* @__PURE__ */ d(In, { items: c, size: "sm" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ d(Ue, { mode: "wait", children: r && /* @__PURE__ */ d(
            re.div,
            {
              initial: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              animate: {
                height: "auto",
                opacity: 1,
                scaleY: 1
              },
              exit: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              transition: {
                duration: 0.3,
                ease: "easeInOut",
                opacity: { duration: 0.2 }
              },
              style: {
                transformOrigin: "top",
                overflow: "hidden"
              },
              children: /* @__PURE__ */ d(
                re.div,
                {
                  className: "text-f1-text-primary",
                  initial: { opacity: 0, y: -10 },
                  animate: { opacity: 1, y: 0 },
                  transition: { delay: 0.1, duration: 0.3 },
                  children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-2", children: o.days.map((h, p) => /* @__PURE__ */ k(
                    re.div,
                    {
                      initial: {
                        opacity: 0,
                        y: -10,
                        scale: 0.95
                      },
                      animate: {
                        opacity: 1,
                        y: 0,
                        scale: 1
                      },
                      transition: {
                        delay: p * 0.05,
                        duration: 0.2,
                        ease: "easeOut"
                      },
                      className: "flex flex-row items-center gap-2",
                      children: [
                        /* @__PURE__ */ d("div", { className: "flex items-center justify-center rounded-full", children: /* @__PURE__ */ d(
                          me,
                          {
                            icon: cg[h.mood],
                            size: "lg",
                            className: ug({ pulse: h.mood })
                          }
                        ) }),
                        /* @__PURE__ */ k("p", { className: "text-f1-text-primary text-md font-normal", children: [
                          /* @__PURE__ */ k("span", { className: "font-semibold", children: [
                            h.day,
                            ":"
                          ] }),
                          " ",
                          h.comment || "-"
                        ] })
                      ]
                    },
                    p
                  )) })
                }
              )
            },
            "content"
          ) })
        ]
      }
    ),
    /* @__PURE__ */ d($c, { style: { display: "none" } })
  ] });
}, eVe = qt.create({
  name: "moodTracker",
  group: "block",
  atom: !0,
  selectable: !0,
  draggable: !0,
  addOptions() {
    return {
      currentConfig: null
    };
  },
  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("data-mood-tracker");
          return e ? JSON.parse(e) : null;
        },
        renderHTML: (t) => t.data ? {
          "data-mood-tracker": JSON.stringify(t.data)
        } : {}
      },
      config: {
        default: null
      },
      isOpen: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-mood-tracker]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t, node: e }) {
    const n = e.attrs.data;
    return n ? [
      "div",
      {
        ...t,
        class: "mood-tracker-block",
        "data-mood-tracker": JSON.stringify(n)
      },
      ["div", { class: "mood-tracker-content" }, `Mood Tracker: ${n.title}`]
    ] : ["div"];
  },
  addNodeView() {
    return Ec(Zze);
  },
  addCommands() {
    return {
      insertMoodTracker: (t, e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: { data: t, config: e }
      })
    };
  }
}), tVe = eVe, nVe = new yt("persistSelection"), iVe = new ft({
  key: nVe,
  state: {
    init(t, { doc: e, selection: n }) {
      return n.from !== n.to ? ht.create(e, [
        fn.inline(n.from, n.to, {
          class: "preserved-selection"
        })
      ]) : ht.empty;
    },
    apply(t) {
      const { doc: e, selection: n } = t;
      return n.from !== n.to ? ht.create(e, [
        fn.inline(n.from, n.to, {
          class: "preserved-selection"
        })
      ]) : ht.empty;
    }
  },
  props: {
    decorations(t) {
      return this.getState(t);
    }
  }
}), Rb = gt.create({
  name: "persistSelection",
  addProseMirrorPlugins() {
    return [iVe];
  }
}), rVe = (t, e) => ry(t, {
  textStyles: "Text Styles",
  lists: "Lists",
  blocks: "Blocks"
}, e).flatMap((r) => r.commands), ry = (t, e, n) => [
  // Only include AI Block group if config is provided
  ...n ? [
    {
      title: n.title,
      commands: [
        // Add individual commands for each AI button using emoji
        ...n.buttons.map((i) => ({
          title: i.label,
          command: async (r) => {
            r.chain().focus().insertContent([
              {
                type: "aiBlock",
                attrs: {
                  data: {
                    content: null,
                    selectedAction: i.type
                  },
                  config: n
                }
              },
              {
                type: "paragraph"
              }
            ]).run(), setTimeout(async () => {
              try {
                const a = await n.onClick(i.type);
                setTimeout(() => {
                  const { state: o } = r, { doc: s } = o;
                  let l = null;
                  if (s.descendants((c, u) => {
                    var f, m;
                    c.type.name === "aiBlock" && ((f = c.attrs.data) == null ? void 0 : f.selectedAction) === i.type && !((m = c.attrs.data) != null && m.content) && (l = u);
                  }), l !== null) {
                    const c = o.tr.setNodeMarkup(
                      l,
                      void 0,
                      {
                        data: {
                          selectedAction: i.type,
                          content: a
                        },
                        config: n
                      }
                    );
                    r.view.dispatch(c);
                    const u = s.nodeAt(l);
                    if (u) {
                      const f = l + u.nodeSize + 1;
                      r.chain().focus().setTextSelection(f).run();
                    }
                  }
                }, 50);
              } catch (a) {
                console.error("AI action error:", a), setTimeout(() => {
                  const { state: o } = r, { doc: s } = o;
                  let l = null;
                  if (s.descendants((c, u) => {
                    var f, m;
                    c.type.name === "aiBlock" && ((f = c.attrs.data) == null ? void 0 : f.selectedAction) === i.type && !((m = c.attrs.data) != null && m.content) && (l = u);
                  }), l !== null) {
                    const c = o.tr.setNodeMarkup(
                      l,
                      void 0,
                      {
                        data: {
                          selectedAction: i.type,
                          content: null
                        },
                        config: n
                      }
                    );
                    r.view.dispatch(c);
                  }
                }, 50);
              }
            }, 100);
          },
          emoji: i.emoji
          // Use emoji instead of icon
        }))
      ]
    }
  ] : [],
  {
    title: e.textStyles,
    commands: [
      {
        title: t.heading1,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleHeading({ level: 1 }).run();
        },
        icon: P5
      },
      {
        title: t.heading2,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleHeading({ level: 2 }).run();
        },
        icon: S5
      },
      {
        title: t.heading3,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleHeading({ level: 3 }).run();
        },
        icon: N5
      }
    ]
  },
  {
    title: e.lists,
    commands: [
      {
        title: t.bulletList,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleBulletList().run();
        },
        icon: Ry
      },
      {
        title: t.orderedList,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleOrderedList().run();
        },
        icon: E5
      },
      {
        title: t.taskList,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleTaskList().run();
        },
        icon: _5
      }
    ]
  },
  {
    title: e.blocks,
    commands: [
      {
        title: t.details,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).setDetails().run();
        },
        icon: zn
      },
      {
        title: t.codeBlock,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleCodeBlock().run();
        },
        icon: C5
      },
      {
        title: t.quote,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).toggleBlockquote().run();
        },
        icon: A5
      },
      {
        title: t.divider,
        command: (i) => {
          const { from: r, to: a } = i.state.selection;
          i.chain().focus().setTextSelection({ from: r, to: a }).setHorizontalRule().run();
        },
        icon: jy
      }
    ]
  }
], J7 = X(
  ({ items: t, groups: e, command: n }, i) => {
    const [r, a] = q(0), o = Oe(null), s = Oe(null), l = e || [{ title: "", commands: t }], c = l.flatMap((y) => y.commands), u = Le(
      (y) => {
        const v = c[y];
        v && n(v);
      },
      [c, n]
    ), f = Le((y) => {
      const v = o.current;
      if (!v) return;
      const w = v.getBoundingClientRect(), x = y.getBoundingClientRect();
      x.top < w.top ? v.scrollTop += x.top - w.top : x.bottom > w.bottom && (v.scrollTop += x.bottom - w.bottom);
    }, []), m = Le(() => {
      a((y) => y <= 0 ? c.length - 1 : y - 1);
    }, [c.length]), h = Le(() => {
      a((y) => y >= c.length - 1 ? 0 : y + 1);
    }, [c.length]), p = Le(() => {
      u(r);
    }, [r, u]);
    le(() => {
      s.current && f(s.current);
    }, [r, f]), le(() => {
      a(0);
    }, [t.length]), Dm(
      i,
      () => ({
        onKeyDown: ({ event: y }) => y.key === "ArrowUp" ? (y.preventDefault(), m(), !0) : y.key === "ArrowDown" ? (y.preventDefault(), h(), !0) : y.key === "Enter" ? (y.preventDefault(), p(), !0) : !1
      }),
      [m, h, p]
    );
    const g = (y, v) => {
      let w = 0;
      for (let x = 0; x < y; x++)
        w += l[x].commands.length;
      return w + v;
    };
    return /* @__PURE__ */ d(
      "div",
      {
        ref: o,
        className: "scrollbar-macos max-h-96 w-72 overflow-y-auto rounded-lg border border-solid border-f1-border-secondary bg-f1-background drop-shadow-md",
        children: l.map((y, v) => /* @__PURE__ */ k("div", { children: [
          /* @__PURE__ */ k("div", { className: "p-1", children: [
            e && y.title && /* @__PURE__ */ d("div", { className: "p-2", children: /* @__PURE__ */ d("p", { className: "text-sm font-medium tracking-wide text-f1-foreground-secondary", children: y.title }) }),
            y.commands.map((w, x) => {
              const b = g(v, x), M = b === r;
              return /* @__PURE__ */ k(
                "div",
                {
                  ref: M ? s : null,
                  className: E(
                    "flex w-full cursor-pointer items-center gap-2 rounded px-2 py-1.5 text-left text-sm hover:bg-f1-background-hover",
                    M && "bg-f1-background-secondary"
                  ),
                  onClick: () => {
                    a(b), u(b);
                  },
                  onMouseEnter: () => a(b),
                  children: [
                    w.emoji ? /* @__PURE__ */ d("span", { className: "text-base", children: w.emoji }) : w.icon ? /* @__PURE__ */ d(
                      me,
                      {
                        icon: w.icon,
                        className: "text-f1-foreground-secondary"
                      }
                    ) : null,
                    /* @__PURE__ */ d("p", { className: "flex-grow text-sm font-medium text-f1-foreground", children: w.title })
                  ]
                },
                `${v}-${x}`
              );
            })
          ] }),
          e && v < l.length - 1 && /* @__PURE__ */ d("div", { className: "py-1", children: /* @__PURE__ */ d("div", { className: "h-[1px] w-full bg-f1-border-secondary" }) })
        ] }, v))
      }
    );
  }
);
J7.displayName = "CommandList";
const aVe = (t, e, n) => gt.create({
  name: "slashCommand",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        command: ({
          editor: i,
          range: r,
          props: a
        }) => {
          const { state: o } = i, { from: s, to: l } = o.selection, u = o.doc.resolve(s), m = u.parent.textBetween(
            Math.max(0, u.parentOffset - 50),
            // Look back up to 50 chars
            u.parentOffset,
            void 0,
            "￼"
          ).lastIndexOf("/");
          if (m !== -1) {
            const h = s - (u.parentOffset - m), p = l;
            i.chain().focus().deleteRange({ from: h, to: p }).run();
          } else
            i.chain().focus().deleteRange(r).run();
          a.command(i);
        }
      }
    };
  },
  addProseMirrorPlugins() {
    const i = e || {
      textStyles: "Text Styles",
      lists: "Lists",
      blocks: "Blocks"
    };
    return [
      X7({
        editor: this.editor,
        ...this.options.suggestion,
        items: ({ query: r }) => {
          const a = r.toLowerCase().replace(/\s+/g, ""), o = rVe(t, n).filter(
            (s) => s.title.toLowerCase().replace(/\s+/g, "").includes(a)
          );
          return o.length > 0 ? o : [];
        },
        render: () => {
          let r = null, a = null, o = null;
          const s = () => {
            const c = window.getSelection();
            if (c && c.rangeCount > 0) {
              const u = c.getRangeAt(0), { startContainer: f, startOffset: m } = u;
              if (f.nodeType === Node.TEXT_NODE) {
                const p = (f.textContent || "").lastIndexOf("/", m);
                if (p !== -1) {
                  const g = document.createRange();
                  return g.setStart(f, p), g.setEnd(f, p + 1), g.getBoundingClientRect();
                }
              }
              return u.getBoundingClientRect();
            }
            return document.body.getBoundingClientRect();
          }, l = ({
            content: c,
            anchorRect: u
          }) => {
            const f = {
              position: "absolute",
              top: u.bottom + window.scrollY,
              left: u.left + window.scrollX,
              width: 0,
              height: 0
            };
            return /* @__PURE__ */ k(Jd, { open: !0, modal: !1, children: [
              /* @__PURE__ */ d("div", { style: f }),
              /* @__PURE__ */ d(m5, { asChild: !0, children: /* @__PURE__ */ d("div", { style: f }) }),
              /* @__PURE__ */ d(
                Qd,
                {
                  side: "bottom",
                  align: "start",
                  sideOffset: 15,
                  collisionPadding: 10,
                  style: { zIndex: 9999 },
                  onOpenAutoFocus: (m) => {
                    m.preventDefault();
                  },
                  onCloseAutoFocus: (m) => {
                    m.preventDefault();
                  },
                  children: /* @__PURE__ */ d(
                    "div",
                    {
                      ref: (m) => {
                        m && c.parentNode !== m && m.appendChild(c);
                      }
                    }
                  )
                }
              )
            ] });
          };
          return {
            onStart: (c) => {
              if (c.items.length === 0) return;
              const u = ry(
                t,
                i,
                n
              );
              let f = u;
              if (c.query && c.query.trim()) {
                const p = c.query.toLowerCase().replace(/\s+/g, "");
                f = u.map((g) => ({
                  ...g,
                  commands: g.commands.filter(
                    (y) => y.title.toLowerCase().replace(/\s+/g, "").includes(p)
                  )
                })).filter((g) => g.commands.length > 0);
              }
              r = new yb(J7, {
                props: {
                  items: c.items,
                  groups: f,
                  command: c.command
                },
                editor: c.editor
              });
              const h = (() => {
                if (c.clientRect) {
                  const p = c.clientRect();
                  if (p && p.width && p.height) return p;
                }
                return s();
              })();
              o = document.createElement("div"), document.body.appendChild(o), a = Y7.createRoot(o), a.render(
                /* @__PURE__ */ d(
                  l,
                  {
                    content: r.element,
                    anchorRect: h,
                    editor: c.editor
                  }
                )
              );
            },
            onUpdate: (c) => {
              if (c.items.length === 0) {
                a && o && (a.unmount(), o.remove());
                return;
              }
              if (!r || !o || !a) return;
              const u = ry(
                t,
                i,
                n
              );
              let f = u;
              if (c.query && c.query.trim()) {
                const p = c.query.toLowerCase().replace(/\s+/g, "");
                f = u.map((g) => ({
                  ...g,
                  commands: g.commands.filter(
                    (y) => y.title.toLowerCase().replace(/\s+/g, "").includes(p)
                  )
                })).filter((g) => g.commands.length > 0);
              }
              r.updateProps({
                items: c.items,
                groups: f
              });
              const h = (() => {
                if (c.clientRect) {
                  const p = c.clientRect();
                  if (p && p.width && p.height) return p;
                }
                return s();
              })();
              a.render(
                /* @__PURE__ */ d(
                  l,
                  {
                    content: r.element,
                    anchorRect: h,
                    editor: c.editor
                  }
                )
              );
            },
            onKeyDown: (c) => {
              if (c.event.key === "Escape")
                return a && o && (a.unmount(), o.remove()), !0;
              const u = r == null ? void 0 : r.ref;
              return u && typeof u == "object" && "onKeyDown" in u && typeof u.onKeyDown == "function" && u.onKeyDown(c) || !1;
            },
            onExit() {
              a && o && (a.unmount(), o.remove()), r == null || r.destroy();
            }
          };
        }
      })
    ];
  }
}), Bi = () => /* @__PURE__ */ new Map(), ay = (t) => {
  const e = Bi();
  return t.forEach((n, i) => {
    e.set(i, n);
  }), e;
}, Xr = (t, e, n) => {
  let i = t.get(e);
  return i === void 0 && t.set(e, i = n()), i;
}, oVe = (t, e) => {
  const n = [];
  for (const [i, r] of t)
    n.push(e(r, i));
  return n;
}, sVe = (t, e) => {
  for (const [n, i] of t)
    if (e(i, n))
      return !0;
  return !1;
}, Mo = () => /* @__PURE__ */ new Set(), fp = (t) => t[t.length - 1], lVe = (t, e) => {
  for (let n = 0; n < e.length; n++)
    t.push(e[n]);
}, Co = Array.from, dVe = (t, e) => {
  for (let n = 0; n < t.length; n++)
    if (e(t[n], n, t))
      return !0;
  return !1;
}, oy = Array.isArray;
class Q7 {
  constructor() {
    this._observers = Bi();
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  on(e, n) {
    return Xr(
      this._observers,
      /** @type {string} */
      e,
      Mo
    ).add(n), n;
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  once(e, n) {
    const i = (...r) => {
      this.off(
        e,
        /** @type {any} */
        i
      ), n(...r);
    };
    this.on(
      e,
      /** @type {any} */
      i
    );
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  off(e, n) {
    const i = this._observers.get(e);
    i !== void 0 && (i.delete(n), i.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */
  emit(e, n) {
    return Co((this._observers.get(e) || Bi()).values()).forEach((i) => i(...n));
  }
  destroy() {
    this._observers = Bi();
  }
}
const Gr = Math.floor, Iu = Math.abs, zs = (t, e) => t < e ? t : e, $a = (t, e) => t > e ? t : e, Z7 = (t) => t !== 0 ? t < 0 : 1 / t < 0, K3 = 1, U3 = 2, mp = 4, hp = 8, Ed = 32, Ar = 64, Ln = 128, cVe = 1 << 29, $h = 31, sy = 63, go = 127, uVe = 2147483647, eN = Number.MAX_SAFE_INTEGER, fVe = Number.isInteger || ((t) => typeof t == "number" && isFinite(t) && Gr(t) === t), mVe = String.fromCharCode, hVe = (t) => t.toLowerCase(), pVe = /^\s*/g, gVe = (t) => t.replace(pVe, ""), yVe = /([A-Z])/g, J3 = (t, e) => gVe(t.replace(yVe, (n) => `${e}${hVe(n)}`)), vVe = (t) => {
  const e = unescape(encodeURIComponent(t)), n = e.length, i = new Uint8Array(n);
  for (let r = 0; r < n; r++)
    i[r] = /** @type {number} */
    e.codePointAt(r);
  return i;
}, Td = (
  /** @type {TextEncoder} */
  typeof TextEncoder < "u" ? new TextEncoder() : null
), bVe = (t) => Td.encode(t), wVe = Td ? bVe : vVe;
let nd = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
nd && nd.decode(new Uint8Array()).length === 1 && (nd = null);
class Tc {
  constructor() {
    this.cpos = 0, this.cbuf = new Uint8Array(100), this.bufs = [];
  }
}
const Oc = () => new Tc(), kVe = (t) => {
  const e = Oc();
  return t(e), Hi(e);
}, xVe = (t) => {
  let e = t.cpos;
  for (let n = 0; n < t.bufs.length; n++)
    e += t.bufs[n].length;
  return e;
}, Hi = (t) => {
  const e = new Uint8Array(xVe(t));
  let n = 0;
  for (let i = 0; i < t.bufs.length; i++) {
    const r = t.bufs[i];
    e.set(r, n), n += r.length;
  }
  return e.set(new Uint8Array(t.cbuf.buffer, 0, t.cpos), n), e;
}, _Ve = (t, e) => {
  const n = t.cbuf.length;
  n - t.cpos < e && (t.bufs.push(new Uint8Array(t.cbuf.buffer, 0, t.cpos)), t.cbuf = new Uint8Array($a(n, e) * 2), t.cpos = 0);
}, tn = (t, e) => {
  const n = t.cbuf.length;
  t.cpos === n && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(n * 2), t.cpos = 0), t.cbuf[t.cpos++] = e;
}, ly = tn, nt = (t, e) => {
  for (; e > go; )
    tn(t, Ln | go & e), e = Gr(e / 128);
  tn(t, go & e);
}, jb = (t, e) => {
  const n = Z7(e);
  for (n && (e = -e), tn(t, (e > sy ? Ln : 0) | (n ? Ar : 0) | sy & e), e = Gr(e / 64); e > 0; )
    tn(t, (e > go ? Ln : 0) | go & e), e = Gr(e / 128);
}, dy = new Uint8Array(3e4), MVe = dy.length / 3, CVe = (t, e) => {
  if (e.length < MVe) {
    const n = Td.encodeInto(e, dy).written || 0;
    nt(t, n);
    for (let i = 0; i < n; i++)
      tn(t, dy[i]);
  } else
    si(t, wVe(e));
}, PVe = (t, e) => {
  const n = unescape(encodeURIComponent(e)), i = n.length;
  nt(t, i);
  for (let r = 0; r < i; r++)
    tn(
      t,
      /** @type {number} */
      n.codePointAt(r)
    );
}, ms = Td && /** @type {any} */
Td.encodeInto ? CVe : PVe, Dh = (t, e) => {
  const n = t.cbuf.length, i = t.cpos, r = zs(n - i, e.length), a = e.length - r;
  t.cbuf.set(e.subarray(0, r), i), t.cpos += r, a > 0 && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array($a(n * 2, a)), t.cbuf.set(e.subarray(r)), t.cpos = a);
}, si = (t, e) => {
  nt(t, e.byteLength), Dh(t, e);
}, Fb = (t, e) => {
  _Ve(t, e);
  const n = new DataView(t.cbuf.buffer, t.cpos, e);
  return t.cpos += e, n;
}, SVe = (t, e) => Fb(t, 4).setFloat32(0, e, !1), NVe = (t, e) => Fb(t, 8).setFloat64(0, e, !1), $Ve = (t, e) => (
  /** @type {any} */
  Fb(t, 8).setBigInt64(0, e, !1)
), Q3 = new DataView(new ArrayBuffer(4)), DVe = (t) => (Q3.setFloat32(0, t), Q3.getFloat32(0) === t), Vs = (t, e) => {
  switch (typeof e) {
    case "string":
      tn(t, 119), ms(t, e);
      break;
    case "number":
      fVe(e) && Iu(e) <= uVe ? (tn(t, 125), jb(t, e)) : DVe(e) ? (tn(t, 124), SVe(t, e)) : (tn(t, 123), NVe(t, e));
      break;
    case "bigint":
      tn(t, 122), $Ve(t, e);
      break;
    case "object":
      if (e === null)
        tn(t, 126);
      else if (oy(e)) {
        tn(t, 117), nt(t, e.length);
        for (let n = 0; n < e.length; n++)
          Vs(t, e[n]);
      } else if (e instanceof Uint8Array)
        tn(t, 116), si(t, e);
      else {
        tn(t, 118);
        const n = Object.keys(e);
        nt(t, n.length);
        for (let i = 0; i < n.length; i++) {
          const r = n[i];
          ms(t, r), Vs(t, e[r]);
        }
      }
      break;
    case "boolean":
      tn(t, e ? 120 : 121);
      break;
    default:
      tn(t, 127);
  }
};
class Z3 extends Tc {
  /**
   * @param {function(Encoder, T):void} writer
   */
  constructor(e) {
    super(), this.w = e, this.s = null, this.count = 0;
  }
  /**
   * @param {T} v
   */
  write(e) {
    this.s === e ? this.count++ : (this.count > 0 && nt(this, this.count - 1), this.count = 1, this.w(this, e), this.s = e);
  }
}
const e4 = (t) => {
  t.count > 0 && (jb(t.encoder, t.count === 1 ? t.s : -t.s), t.count > 1 && nt(t.encoder, t.count - 2));
};
class Ru {
  constructor() {
    this.encoder = new Tc(), this.s = 0, this.count = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.s === e ? this.count++ : (e4(this), this.count = 1, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return e4(this), Hi(this.encoder);
  }
}
const t4 = (t) => {
  if (t.count > 0) {
    const e = t.diff * 2 + (t.count === 1 ? 0 : 1);
    jb(t.encoder, e), t.count > 1 && nt(t.encoder, t.count - 2);
  }
};
class pp {
  constructor() {
    this.encoder = new Tc(), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.diff === e - this.s ? (this.s = e, this.count++) : (t4(this), this.count = 1, this.diff = e - this.s, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return t4(this), Hi(this.encoder);
  }
}
class EVe {
  constructor() {
    this.sarr = [], this.s = "", this.lensE = new Ru();
  }
  /**
   * @param {string} string
   */
  write(e) {
    this.s += e, this.s.length > 19 && (this.sarr.push(this.s), this.s = ""), this.lensE.write(e.length);
  }
  toUint8Array() {
    const e = new Tc();
    return this.sarr.push(this.s), this.s = "", ms(e, this.sarr.join("")), Dh(e, this.lensE.toUint8Array()), Hi(e);
  }
}
const Da = (t) => new Error(t), qi = () => {
  throw Da("Method unimplemented");
}, ri = () => {
  throw Da("Unexpected case");
}, tN = Da("Unexpected end of array"), nN = Da("Integer out of Range");
class Eh {
  /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */
  constructor(e) {
    this.arr = e, this.pos = 0;
  }
}
const zb = (t) => new Eh(t), TVe = (t) => t.pos !== t.arr.length, OVe = (t, e) => {
  const n = new Uint8Array(t.arr.buffer, t.pos + t.arr.byteOffset, e);
  return t.pos += e, n;
}, gi = (t) => OVe(t, Pt(t)), Od = (t) => t.arr[t.pos++], Pt = (t) => {
  let e = 0, n = 1;
  const i = t.arr.length;
  for (; t.pos < i; ) {
    const r = t.arr[t.pos++];
    if (e = e + (r & go) * n, n *= 128, r < Ln)
      return e;
    if (e > eN)
      throw nN;
  }
  throw tN;
}, Vb = (t) => {
  let e = t.arr[t.pos++], n = e & sy, i = 64;
  const r = (e & Ar) > 0 ? -1 : 1;
  if ((e & Ln) === 0)
    return r * n;
  const a = t.arr.length;
  for (; t.pos < a; ) {
    if (e = t.arr[t.pos++], n = n + (e & go) * i, i *= 128, e < Ln)
      return r * n;
    if (n > eN)
      throw nN;
  }
  throw tN;
}, WVe = (t) => {
  let e = Pt(t);
  if (e === 0)
    return "";
  {
    let n = String.fromCodePoint(Od(t));
    if (--e < 100)
      for (; e--; )
        n += String.fromCodePoint(Od(t));
    else
      for (; e > 0; ) {
        const i = e < 1e4 ? e : 1e4, r = t.arr.subarray(t.pos, t.pos + i);
        t.pos += i, n += String.fromCodePoint.apply(
          null,
          /** @type {any} */
          r
        ), e -= i;
      }
    return decodeURIComponent(escape(n));
  }
}, AVe = (t) => (
  /** @type any */
  nd.decode(gi(t))
), cy = nd ? AVe : WVe, Hb = (t, e) => {
  const n = new DataView(t.arr.buffer, t.arr.byteOffset + t.pos, e);
  return t.pos += e, n;
}, LVe = (t) => Hb(t, 4).getFloat32(0, !1), IVe = (t) => Hb(t, 8).getFloat64(0, !1), RVe = (t) => (
  /** @type {any} */
  Hb(t, 8).getBigInt64(0, !1)
), jVe = [
  (t) => {
  },
  // CASE 127: undefined
  (t) => null,
  // CASE 126: null
  Vb,
  // CASE 125: integer
  LVe,
  // CASE 124: float32
  IVe,
  // CASE 123: float64
  RVe,
  // CASE 122: bigint
  (t) => !1,
  // CASE 121: boolean (false)
  (t) => !0,
  // CASE 120: boolean (true)
  cy,
  // CASE 119: string
  (t) => {
    const e = Pt(t), n = {};
    for (let i = 0; i < e; i++) {
      const r = cy(t);
      n[r] = mm(t);
    }
    return n;
  },
  (t) => {
    const e = Pt(t), n = [];
    for (let i = 0; i < e; i++)
      n.push(mm(t));
    return n;
  },
  gi
  // CASE 116: Uint8Array
], mm = (t) => jVe[127 - Od(t)](t);
class n4 extends Eh {
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  constructor(e, n) {
    super(e), this.reader = n, this.s = null, this.count = 0;
  }
  read() {
    return this.count === 0 && (this.s = this.reader(this), TVe(this) ? this.count = Pt(this) + 1 : this.count = -1), this.count--, /** @type {T} */
    this.s;
  }
}
class ju extends Eh {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0;
  }
  read() {
    if (this.count === 0) {
      this.s = Vb(this);
      const e = Z7(this.s);
      this.count = 1, e && (this.s = -this.s, this.count = Pt(this) + 2);
    }
    return this.count--, /** @type {number} */
    this.s;
  }
}
class gp extends Eh {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @return {number}
   */
  read() {
    if (this.count === 0) {
      const e = Vb(this), n = e & 1;
      this.diff = Gr(e / 2), this.count = 1, n && (this.count = Pt(this) + 2);
    }
    return this.s += this.diff, this.count--, this.s;
  }
}
class FVe {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    this.decoder = new ju(e), this.str = cy(this.decoder), this.spos = 0;
  }
  /**
   * @return {string}
   */
  read() {
    const e = this.spos + this.decoder.read(), n = this.str.slice(this.spos, e);
    return this.spos = e, n;
  }
}
const zVe = crypto.getRandomValues.bind(crypto), VVe = Math.random, iN = () => zVe(new Uint32Array(1))[0], HVe = (t) => t[Gr(VVe() * t.length)], BVe = "10000000-1000-4000-8000" + -1e11, qVe = () => BVe.replace(
  /[018]/g,
  /** @param {number} c */
  (t) => (t ^ iN() & 15 >> t / 4).toString(16)
), GVe = Date.now, i4 = (t) => (
  /** @type {Promise<T>} */
  new Promise(t)
);
Promise.all.bind(Promise);
const r4 = (t) => t === void 0 ? null : t;
class XVe {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem(e, n) {
    this.map.set(e, n);
  }
  /**
   * @param {string} key
   */
  getItem(e) {
    return this.map.get(e);
  }
}
let rN = new XVe(), YVe = !0;
try {
  typeof localStorage < "u" && localStorage && (rN = localStorage, YVe = !1);
} catch {
}
const KVe = rN, UVe = Object.assign, aN = Object.keys, JVe = (t, e) => {
  for (const n in t)
    e(t[n], n);
}, a4 = (t) => aN(t).length, QVe = (t) => {
  for (const e in t)
    return !1;
  return !0;
}, oN = (t, e) => {
  for (const n in t)
    if (!e(t[n], n))
      return !1;
  return !0;
}, ZVe = (t, e) => Object.prototype.hasOwnProperty.call(t, e), eHe = (t, e) => t === e || a4(t) === a4(e) && oN(t, (n, i) => (n !== void 0 || ZVe(e, i)) && e[i] === n), tHe = Object.freeze, sN = (t) => {
  for (const e in t) {
    const n = t[e];
    (typeof n == "object" || typeof n == "function") && sN(t[e]);
  }
  return tHe(t);
}, Bb = (t, e, n = 0) => {
  try {
    for (; n < t.length; n++)
      t[n](...e);
  } finally {
    n < t.length && Bb(t, e, n + 1);
  }
}, nHe = (t, e) => e.includes(t), Hs = typeof process < "u" && process.release && /node|io\.js/.test(process.release.name) && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]", lN = typeof window < "u" && typeof document < "u" && !Hs;
let er;
const iHe = () => {
  if (er === void 0)
    if (Hs) {
      er = Bi();
      const t = process.argv;
      let e = null;
      for (let n = 0; n < t.length; n++) {
        const i = t[n];
        i[0] === "-" ? (e !== null && er.set(e, ""), e = i) : e !== null && (er.set(e, i), e = null);
      }
      e !== null && er.set(e, "");
    } else typeof location == "object" ? (er = Bi(), (location.search || "?").slice(1).split("&").forEach((t) => {
      if (t.length !== 0) {
        const [e, n] = t.split("=");
        er.set(`--${J3(e, "-")}`, n), er.set(`-${J3(e, "-")}`, n);
      }
    })) : er = Bi();
  return er;
}, uy = (t) => iHe().has(t), hm = (t) => r4(Hs ? process.env[t.toUpperCase().replaceAll("-", "_")] : KVe.getItem(t)), dN = (t) => uy("--" + t) || hm(t) !== null;
dN("production");
const rHe = Hs && nHe(process.env.FORCE_COLOR, ["true", "1", "2"]), aHe = rHe || !uy("--no-colors") && // @todo deprecate --no-colors
!dN("no-color") && (!Hs || process.stdout.isTTY) && (!Hs || uy("--color") || hm("COLORTERM") !== null || (hm("TERM") || "").includes("color")), oHe = (t) => {
  let e = "";
  for (let n = 0; n < t.byteLength; n++)
    e += mVe(t[n]);
  return btoa(e);
}, sHe = (t) => Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("base64"), lHe = lN ? oHe : sHe, dHe = (t) => kVe((e) => Vs(e, t));
class cHe {
  /**
   * @param {L} left
   * @param {R} right
   */
  constructor(e, n) {
    this.left = e, this.right = n;
  }
}
const Cr = (t, e) => new cHe(t, e), uHe = (
  /** @type {Document} */
  typeof document < "u" ? document : {}
);
typeof DOMParser < "u" && new DOMParser();
const fHe = (t) => oVe(t, (e, n) => `${n}:${e};`).join(""), mHe = (t) => class {
  /**
   * @param {number} timeoutId
   */
  constructor(n) {
    this._ = n;
  }
  destroy() {
    t(this._);
  }
}, hHe = mHe(clearTimeout), cN = (t, e) => new hHe(setTimeout(e, t)), Yr = Symbol, uN = Yr(), fN = Yr(), pHe = Yr(), gHe = Yr(), yHe = Yr(), mN = Yr(), vHe = Yr(), qb = Yr(), bHe = Yr(), wHe = (t) => {
  var r;
  t.length === 1 && ((r = t[0]) == null ? void 0 : r.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], n = [];
  let i = 0;
  for (; i < t.length; i++) {
    const a = t[i];
    if (a === void 0)
      break;
    if (a.constructor === String || a.constructor === Number)
      e.push(a);
    else if (a.constructor === Object)
      break;
  }
  for (i > 0 && n.push(e.join("")); i < t.length; i++) {
    const a = t[i];
    a instanceof Symbol || n.push(a);
  }
  return n;
}, kHe = {
  [uN]: Cr("font-weight", "bold"),
  [fN]: Cr("font-weight", "normal"),
  [pHe]: Cr("color", "blue"),
  [yHe]: Cr("color", "green"),
  [gHe]: Cr("color", "grey"),
  [mN]: Cr("color", "red"),
  [vHe]: Cr("color", "purple"),
  [qb]: Cr("color", "orange"),
  // not well supported in chrome when debugging node with inspector - TODO: deprecate
  [bHe]: Cr("color", "black")
}, xHe = (t) => {
  var o;
  t.length === 1 && ((o = t[0]) == null ? void 0 : o.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], n = [], i = Bi();
  let r = [], a = 0;
  for (; a < t.length; a++) {
    const s = t[a], l = kHe[s];
    if (l !== void 0)
      i.set(l.left, l.right);
    else {
      if (s === void 0)
        break;
      if (s.constructor === String || s.constructor === Number) {
        const c = fHe(i);
        a > 0 || c.length > 0 ? (e.push("%c" + s), n.push(c)) : e.push(s);
      } else
        break;
    }
  }
  for (a > 0 && (r = n, r.unshift(e.join(""))); a < t.length; a++) {
    const s = t[a];
    s instanceof Symbol || r.push(s);
  }
  return r;
}, hN = aHe ? xHe : wHe, _He = (...t) => {
  console.log(...hN(t)), gN.forEach((e) => e.print(t));
}, pN = (...t) => {
  console.warn(...hN(t)), t.unshift(qb), gN.forEach((e) => e.print(t));
}, gN = Mo(), yN = (t) => ({
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return this;
  },
  // @ts-ignore
  next: t
}), MHe = (t, e) => yN(() => {
  let n;
  do
    n = t.next();
  while (!n.done && !e(n.value));
  return n;
}), yp = (t, e) => yN(() => {
  const { done: n, value: i } = t.next();
  return { done: n, value: n ? void 0 : e(i) };
});
class Gb {
  /**
   * @param {number} clock
   * @param {number} len
   */
  constructor(e, n) {
    this.clock = e, this.len = n;
  }
}
class ol {
  constructor() {
    this.clients = /* @__PURE__ */ new Map();
  }
}
const Ea = (t, e, n) => e.clients.forEach((i, r) => {
  const a = (
    /** @type {Array<GC|Item>} */
    t.doc.store.clients.get(r)
  );
  if (a != null) {
    const o = a[a.length - 1], s = o.id.clock + o.length;
    for (let l = 0, c = i[l]; l < i.length && c.clock < s; c = i[++l])
      CN(t, a, c.clock, c.len, n);
  }
}), CHe = (t, e) => {
  let n = 0, i = t.length - 1;
  for (; n <= i; ) {
    const r = Gr((n + i) / 2), a = t[r], o = a.clock;
    if (o <= e) {
      if (e < o + a.len)
        return r;
      n = r + 1;
    } else
      i = r - 1;
  }
  return null;
}, sl = (t, e) => {
  const n = t.clients.get(e.client);
  return n !== void 0 && CHe(n, e.clock) !== null;
}, Xb = (t) => {
  t.clients.forEach((e) => {
    e.sort((r, a) => r.clock - a.clock);
    let n, i;
    for (n = 1, i = 1; n < e.length; n++) {
      const r = e[i - 1], a = e[n];
      r.clock + r.len >= a.clock ? r.len = $a(r.len, a.clock + a.len - r.clock) : (i < n && (e[i] = a), i++);
    }
    e.length = i;
  });
}, fy = (t) => {
  const e = new ol();
  for (let n = 0; n < t.length; n++)
    t[n].clients.forEach((i, r) => {
      if (!e.clients.has(r)) {
        const a = i.slice();
        for (let o = n + 1; o < t.length; o++)
          lVe(a, t[o].clients.get(r) || []);
        e.clients.set(r, a);
      }
    });
  return Xb(e), e;
}, Wd = (t, e, n, i) => {
  Xr(t.clients, e, () => (
    /** @type {Array<DeleteItem>} */
    []
  )).push(new Gb(n, i));
}, vN = () => new ol(), PHe = (t) => {
  const e = vN();
  return t.clients.forEach((n, i) => {
    const r = [];
    for (let a = 0; a < n.length; a++) {
      const o = n[a];
      if (o.deleted) {
        const s = o.id.clock;
        let l = o.length;
        if (a + 1 < n.length)
          for (let c = n[a + 1]; a + 1 < n.length && c.deleted; c = n[++a + 1])
            l += c.length;
        r.push(new Gb(s, l));
      }
    }
    r.length > 0 && e.clients.set(i, r);
  }), e;
}, Yb = (t, e) => {
  nt(t.restEncoder, e.clients.size), Co(e.clients.entries()).sort((n, i) => i[0] - n[0]).forEach(([n, i]) => {
    t.resetDsCurVal(), nt(t.restEncoder, n);
    const r = i.length;
    nt(t.restEncoder, r);
    for (let a = 0; a < r; a++) {
      const o = i[a];
      t.writeDsClock(o.clock), t.writeDsLen(o.len);
    }
  });
}, SHe = (t) => {
  const e = new ol(), n = Pt(t.restDecoder);
  for (let i = 0; i < n; i++) {
    t.resetDsCurVal();
    const r = Pt(t.restDecoder), a = Pt(t.restDecoder);
    if (a > 0) {
      const o = Xr(e.clients, r, () => (
        /** @type {Array<DeleteItem>} */
        []
      ));
      for (let s = 0; s < a; s++)
        o.push(new Gb(t.readDsClock(), t.readDsLen()));
    }
  }
  return e;
}, o4 = (t, e, n) => {
  const i = new ol(), r = Pt(t.restDecoder);
  for (let a = 0; a < r; a++) {
    t.resetDsCurVal();
    const o = Pt(t.restDecoder), s = Pt(t.restDecoder), l = n.clients.get(o) || [], c = Vt(n, o);
    for (let u = 0; u < s; u++) {
      const f = t.readDsClock(), m = f + t.readDsLen();
      if (f < c) {
        c < m && Wd(i, o, c, m - c);
        let h = Ki(l, f), p = l[h];
        for (!p.deleted && p.id.clock < f && (l.splice(h + 1, 0, km(e, p, f - p.id.clock)), h++); h < l.length && (p = l[h++], p.id.clock < m); )
          p.deleted || (m < p.id.clock + p.length && l.splice(h, 0, km(e, p, m - p.id.clock)), p.delete(e));
      } else
        Wd(i, o, f, m - f);
    }
  }
  if (i.clients.size > 0) {
    const a = new Th();
    return nt(a.restEncoder, 0), Yb(a, i), a.toUint8Array();
  }
  return null;
}, bN = iN;
class Ro extends Q7 {
  /**
   * @param {DocOpts} opts configuration
   */
  constructor({ guid: e = qVe(), collectionid: n = null, gc: i = !0, gcFilter: r = () => !0, meta: a = null, autoLoad: o = !1, shouldLoad: s = !0 } = {}) {
    super(), this.gc = i, this.gcFilter = r, this.clientID = bN(), this.guid = e, this.collectionid = n, this.share = /* @__PURE__ */ new Map(), this.store = new _N(), this._transaction = null, this._transactionCleanups = [], this.subdocs = /* @__PURE__ */ new Set(), this._item = null, this.shouldLoad = s, this.autoLoad = o, this.meta = a, this.isLoaded = !1, this.isSynced = !1, this.isDestroyed = !1, this.whenLoaded = i4((c) => {
      this.on("load", () => {
        this.isLoaded = !0, c(this);
      });
    });
    const l = () => i4((c) => {
      const u = (f) => {
        (f === void 0 || f === !0) && (this.off("sync", u), c());
      };
      this.on("sync", u);
    });
    this.on("sync", (c) => {
      c === !1 && this.isSynced && (this.whenSynced = l()), this.isSynced = c === void 0 || c === !0, this.isSynced && !this.isLoaded && this.emit("load", [this]);
    }), this.whenSynced = l();
  }
  /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */
  load() {
    const e = this._item;
    e !== null && !this.shouldLoad && mt(
      /** @type {any} */
      e.parent.doc,
      (n) => {
        n.subdocsLoaded.add(this);
      },
      null,
      !0
    ), this.shouldLoad = !0;
  }
  getSubdocs() {
    return this.subdocs;
  }
  getSubdocGuids() {
    return new Set(Co(this.subdocs).map((e) => e.guid));
  }
  /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */
  transact(e, n = null) {
    return mt(this, e, n);
  }
  /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */
  get(e, n = (
    /** @type {any} */
    on
  )) {
    const i = Xr(this.share, e, () => {
      const a = new n();
      return a._integrate(this, null), a;
    }), r = i.constructor;
    if (n !== on && r !== n)
      if (r === on) {
        const a = new n();
        a._map = i._map, i._map.forEach(
          /** @param {Item?} n */
          (o) => {
            for (; o !== null; o = o.left)
              o.parent = a;
          }
        ), a._start = i._start;
        for (let o = a._start; o !== null; o = o.right)
          o.parent = a;
        return a._length = i._length, this.share.set(e, a), a._integrate(this, null), /** @type {InstanceType<Type>} */
        a;
      } else
        throw new Error(`Type with the name ${e} has already been defined with a different constructor`);
    return (
      /** @type {InstanceType<Type>} */
      i
    );
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */
  getArray(e = "") {
    return (
      /** @type {YArray<T>} */
      this.get(e, gs)
    );
  }
  /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */
  getText(e = "") {
    return this.get(e, Ta);
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */
  getMap(e = "") {
    return (
      /** @type {YMap<T>} */
      this.get(e, Bs)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */
  getXmlElement(e = "") {
    return (
      /** @type {YXmlElement<{[key:string]:string}>} */
      this.get(e, wn)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */
  getXmlFragment(e = "") {
    return this.get(e, Po);
  }
  /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */
  toJSON() {
    const e = {};
    return this.share.forEach((n, i) => {
      e[i] = n.toJSON();
    }), e;
  }
  /**
   * Emit `destroy` event and unregister all event handlers.
   */
  destroy() {
    this.isDestroyed = !0, Co(this.subdocs).forEach((n) => n.destroy());
    const e = this._item;
    if (e !== null) {
      this._item = null;
      const n = (
        /** @type {ContentDoc} */
        e.content
      );
      n.doc = new Ro({ guid: this.guid, ...n.opts, shouldLoad: !1 }), n.doc._item = e, mt(
        /** @type {any} */
        e.parent.doc,
        (i) => {
          const r = n.doc;
          e.deleted || i.subdocsAdded.add(r), i.subdocsRemoved.add(this);
        },
        null,
        !0
      );
    }
    this.emit("destroyed", [!0]), this.emit("destroy", [this]), super.destroy();
  }
}
class NHe {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    this.dsCurrVal = 0, this.restDecoder = e;
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @return {number}
   */
  readDsClock() {
    return this.dsCurrVal += Pt(this.restDecoder), this.dsCurrVal;
  }
  /**
   * @return {number}
   */
  readDsLen() {
    const e = Pt(this.restDecoder) + 1;
    return this.dsCurrVal += e, e;
  }
}
class pm extends NHe {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    super(e), this.keys = [], Pt(e), this.keyClockDecoder = new gp(gi(e)), this.clientDecoder = new ju(gi(e)), this.leftClockDecoder = new gp(gi(e)), this.rightClockDecoder = new gp(gi(e)), this.infoDecoder = new n4(gi(e), Od), this.stringDecoder = new FVe(gi(e)), this.parentInfoDecoder = new n4(gi(e), Od), this.typeRefDecoder = new ju(gi(e)), this.lenDecoder = new ju(gi(e));
  }
  /**
   * @return {ID}
   */
  readLeftID() {
    return new hs(this.clientDecoder.read(), this.leftClockDecoder.read());
  }
  /**
   * @return {ID}
   */
  readRightID() {
    return new hs(this.clientDecoder.read(), this.rightClockDecoder.read());
  }
  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient() {
    return this.clientDecoder.read();
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo() {
    return (
      /** @type {number} */
      this.infoDecoder.read()
    );
  }
  /**
   * @return {string}
   */
  readString() {
    return this.stringDecoder.read();
  }
  /**
   * @return {boolean}
   */
  readParentInfo() {
    return this.parentInfoDecoder.read() === 1;
  }
  /**
   * @return {number} An unsigned 8-bit integer
   */
  readTypeRef() {
    return this.typeRefDecoder.read();
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */
  readLen() {
    return this.lenDecoder.read();
  }
  /**
   * @return {any}
   */
  readAny() {
    return mm(this.restDecoder);
  }
  /**
   * @return {Uint8Array}
   */
  readBuf() {
    return gi(this.restDecoder);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */
  readJSON() {
    return mm(this.restDecoder);
  }
  /**
   * @return {string}
   */
  readKey() {
    const e = this.keyClockDecoder.read();
    if (e < this.keys.length)
      return this.keys[e];
    {
      const n = this.stringDecoder.read();
      return this.keys.push(n), n;
    }
  }
}
class $He {
  constructor() {
    this.restEncoder = Oc();
  }
  toUint8Array() {
    return Hi(this.restEncoder);
  }
  resetDsCurVal() {
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    nt(this.restEncoder, e);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    nt(this.restEncoder, e);
  }
}
class DHe extends $He {
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    nt(this.restEncoder, e.client), nt(this.restEncoder, e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    nt(this.restEncoder, e.client), nt(this.restEncoder, e.clock);
  }
  /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */
  writeClient(e) {
    nt(this.restEncoder, e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    ly(this.restEncoder, e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    ms(this.restEncoder, e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    nt(this.restEncoder, e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    nt(this.restEncoder, e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    nt(this.restEncoder, e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    Vs(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    si(this.restEncoder, e);
  }
  /**
   * @param {any} embed
   */
  writeJSON(e) {
    ms(this.restEncoder, JSON.stringify(e));
  }
  /**
   * @param {string} key
   */
  writeKey(e) {
    ms(this.restEncoder, e);
  }
}
class EHe {
  constructor() {
    this.restEncoder = Oc(), this.dsCurrVal = 0;
  }
  toUint8Array() {
    return Hi(this.restEncoder);
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    const n = e - this.dsCurrVal;
    this.dsCurrVal = e, nt(this.restEncoder, n);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    e === 0 && ri(), nt(this.restEncoder, e - 1), this.dsCurrVal += e;
  }
}
class Th extends EHe {
  constructor() {
    super(), this.keyMap = /* @__PURE__ */ new Map(), this.keyClock = 0, this.keyClockEncoder = new pp(), this.clientEncoder = new Ru(), this.leftClockEncoder = new pp(), this.rightClockEncoder = new pp(), this.infoEncoder = new Z3(ly), this.stringEncoder = new EVe(), this.parentInfoEncoder = new Z3(ly), this.typeRefEncoder = new Ru(), this.lenEncoder = new Ru();
  }
  toUint8Array() {
    const e = Oc();
    return nt(e, 0), si(e, this.keyClockEncoder.toUint8Array()), si(e, this.clientEncoder.toUint8Array()), si(e, this.leftClockEncoder.toUint8Array()), si(e, this.rightClockEncoder.toUint8Array()), si(e, Hi(this.infoEncoder)), si(e, this.stringEncoder.toUint8Array()), si(e, Hi(this.parentInfoEncoder)), si(e, this.typeRefEncoder.toUint8Array()), si(e, this.lenEncoder.toUint8Array()), Dh(e, Hi(this.restEncoder)), Hi(e);
  }
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    this.clientEncoder.write(e.client), this.leftClockEncoder.write(e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    this.clientEncoder.write(e.client), this.rightClockEncoder.write(e.clock);
  }
  /**
   * @param {number} client
   */
  writeClient(e) {
    this.clientEncoder.write(e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    this.infoEncoder.write(e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    this.stringEncoder.write(e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    this.parentInfoEncoder.write(e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    this.typeRefEncoder.write(e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    this.lenEncoder.write(e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    Vs(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    si(this.restEncoder, e);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */
  writeJSON(e) {
    Vs(this.restEncoder, e);
  }
  /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */
  writeKey(e) {
    const n = this.keyMap.get(e);
    n === void 0 ? (this.keyClockEncoder.write(this.keyClock++), this.stringEncoder.write(e)) : this.keyClockEncoder.write(n);
  }
}
const THe = (t, e, n, i) => {
  i = $a(i, e[0].id.clock);
  const r = Ki(e, i);
  nt(t.restEncoder, e.length - r), t.writeClient(n), nt(t.restEncoder, i);
  const a = e[r];
  a.write(t, i - a.id.clock);
  for (let o = r + 1; o < e.length; o++)
    e[o].write(t, 0);
}, wN = (t, e, n) => {
  const i = /* @__PURE__ */ new Map();
  n.forEach((r, a) => {
    Vt(e, a) > r && i.set(a, r);
  }), Oh(e).forEach((r, a) => {
    n.has(a) || i.set(a, 0);
  }), nt(t.restEncoder, i.size), Co(i.entries()).sort((r, a) => a[0] - r[0]).forEach(([r, a]) => {
    THe(
      t,
      /** @type {Array<GC|Item>} */
      e.clients.get(r),
      r,
      a
    );
  });
}, OHe = (t, e) => {
  const n = Bi(), i = Pt(t.restDecoder);
  for (let r = 0; r < i; r++) {
    const a = Pt(t.restDecoder), o = new Array(a), s = t.readClient();
    let l = Pt(t.restDecoder);
    n.set(s, { i: 0, refs: o });
    for (let c = 0; c < a; c++) {
      const u = t.readInfo();
      switch ($h & u) {
        case 0: {
          const f = t.readLen();
          o[c] = new wi(Ye(s, l), f), l += f;
          break;
        }
        case 10: {
          const f = Pt(t.restDecoder);
          o[c] = new zi(Ye(s, l), f), l += f;
          break;
        }
        default: {
          const f = (u & (Ar | Ln)) === 0, m = new vt(
            Ye(s, l),
            null,
            // left
            (u & Ln) === Ln ? t.readLeftID() : null,
            // origin
            null,
            // right
            (u & Ar) === Ar ? t.readRightID() : null,
            // right origin
            f ? t.readParentInfo() ? e.get(t.readString()) : t.readLeftID() : null,
            // parent
            f && (u & Ed) === Ed ? t.readString() : null,
            // parentSub
            XN(t, u)
            // item content
          );
          o[c] = m, l += m.length;
        }
      }
    }
  }
  return n;
}, WHe = (t, e, n) => {
  const i = [];
  let r = Co(n.keys()).sort((h, p) => h - p);
  if (r.length === 0)
    return null;
  const a = () => {
    if (r.length === 0)
      return null;
    let h = (
      /** @type {{i:number,refs:Array<GC|Item>}} */
      n.get(r[r.length - 1])
    );
    for (; h.refs.length === h.i; )
      if (r.pop(), r.length > 0)
        h = /** @type {{i:number,refs:Array<GC|Item>}} */
        n.get(r[r.length - 1]);
      else
        return null;
    return h;
  };
  let o = a();
  if (o === null)
    return null;
  const s = new _N(), l = /* @__PURE__ */ new Map(), c = (h, p) => {
    const g = l.get(h);
    (g == null || g > p) && l.set(h, p);
  };
  let u = (
    /** @type {any} */
    o.refs[
      /** @type {any} */
      o.i++
    ]
  );
  const f = /* @__PURE__ */ new Map(), m = () => {
    for (const h of i) {
      const p = h.id.client, g = n.get(p);
      g ? (g.i--, s.clients.set(p, g.refs.slice(g.i)), n.delete(p), g.i = 0, g.refs = []) : s.clients.set(p, [h]), r = r.filter((y) => y !== p);
    }
    i.length = 0;
  };
  for (; ; ) {
    if (u.constructor !== zi) {
      const p = Xr(f, u.id.client, () => Vt(e, u.id.client)) - u.id.clock;
      if (p < 0)
        i.push(u), c(u.id.client, u.id.clock - 1), m();
      else {
        const g = u.getMissing(t, e);
        if (g !== null) {
          i.push(u);
          const y = n.get(
            /** @type {number} */
            g
          ) || { refs: [], i: 0 };
          if (y.refs.length === y.i)
            c(
              /** @type {number} */
              g,
              Vt(e, g)
            ), m();
          else {
            u = y.refs[y.i++];
            continue;
          }
        } else (p === 0 || p < u.length) && (u.integrate(t, p), f.set(u.id.client, u.id.clock + u.length));
      }
    }
    if (i.length > 0)
      u = /** @type {GC|Item} */
      i.pop();
    else if (o !== null && o.i < o.refs.length)
      u = /** @type {GC|Item} */
      o.refs[o.i++];
    else {
      if (o = a(), o === null)
        break;
      u = /** @type {GC|Item} */
      o.refs[o.i++];
    }
  }
  if (s.clients.size > 0) {
    const h = new Th();
    return wN(h, s, /* @__PURE__ */ new Map()), nt(h.restEncoder, 0), { missing: l, update: h.toUint8Array() };
  }
  return null;
}, AHe = (t, e) => wN(t, e.doc.store, e.beforeState), LHe = (t, e, n, i = new pm(t)) => mt(e, (r) => {
  r.local = !1;
  let a = !1;
  const o = r.doc, s = o.store, l = OHe(i, o), c = WHe(r, s, l), u = s.pendingStructs;
  if (u) {
    for (const [m, h] of u.missing)
      if (h < Vt(s, m)) {
        a = !0;
        break;
      }
    if (c) {
      for (const [m, h] of c.missing) {
        const p = u.missing.get(m);
        (p == null || p > h) && u.missing.set(m, h);
      }
      u.update = p4([u.update, c.update]);
    }
  } else
    s.pendingStructs = c;
  const f = o4(i, r, s);
  if (s.pendingDs) {
    const m = new pm(zb(s.pendingDs));
    Pt(m.restDecoder);
    const h = o4(m, r, s);
    f && h ? s.pendingDs = p4([f, h]) : s.pendingDs = f || h;
  } else
    s.pendingDs = f;
  if (a) {
    const m = (
      /** @type {{update: Uint8Array}} */
      s.pendingStructs.update
    );
    s.pendingStructs = null, my(r.doc, m);
  }
}, n, !1), my = (t, e, n, i = pm) => {
  const r = zb(e);
  LHe(r, t, n, new i(r));
};
class IHe {
  constructor() {
    this.l = [];
  }
}
const s4 = () => new IHe(), l4 = (t, e) => t.l.push(e), d4 = (t, e) => {
  const n = t.l, i = n.length;
  t.l = n.filter((r) => e !== r), i === t.l.length && console.error("[yjs] Tried to remove event handler that doesn't exist.");
}, kN = (t, e, n) => Bb(t.l, [e, n]);
class hs {
  /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */
  constructor(e, n) {
    this.client = e, this.clock = n;
  }
}
const uu = (t, e) => t === e || t !== null && e !== null && t.client === e.client && t.clock === e.clock, Ye = (t, e) => new hs(t, e), Ad = (t) => {
  for (const [e, n] of t.doc.share.entries())
    if (n === t)
      return e;
  throw ri();
}, Ld = (t, e) => {
  for (; e !== null; ) {
    if (e.parent === t)
      return !0;
    e = /** @type {AbstractType<any>} */
    e.parent._item;
  }
  return !1;
};
class gm {
  /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */
  constructor(e, n, i, r = 0) {
    this.type = e, this.tname = n, this.item = i, this.assoc = r;
  }
}
class RHe {
  /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */
  constructor(e, n, i = 0) {
    this.type = e, this.index = n, this.assoc = i;
  }
}
const jHe = (t, e, n = 0) => new RHe(t, e, n), fu = (t, e, n) => {
  let i = null, r = null;
  return t._item === null ? r = Ad(t) : i = Ye(t._item.id.client, t._item.id.clock), new gm(i, r, e, n);
}, vp = (t, e, n = 0) => {
  let i = t._start;
  if (n < 0) {
    if (e === 0)
      return fu(t, null, n);
    e--;
  }
  for (; i !== null; ) {
    if (!i.deleted && i.countable) {
      if (i.length > e)
        return fu(t, Ye(i.id.client, i.id.clock + e), n);
      e -= i.length;
    }
    if (i.right === null && n < 0)
      return fu(t, i.lastId, n);
    i = i.right;
  }
  return fu(t, null, n);
}, FHe = (t, e) => {
  const n = ps(t, e), i = e.clock - n.id.clock;
  return {
    item: n,
    diff: i
  };
}, zHe = (t, e, n = !0) => {
  const i = e.store, r = t.item, a = t.type, o = t.tname, s = t.assoc;
  let l = null, c = 0;
  if (r !== null) {
    if (Vt(i, r.client) <= r.clock)
      return null;
    const u = n ? yy(i, r) : FHe(i, r), f = u.item;
    if (!(f instanceof vt))
      return null;
    if (l = /** @type {AbstractType<any>} */
    f.parent, l._item === null || !l._item.deleted) {
      c = f.deleted || !f.countable ? 0 : u.diff + (s >= 0 ? 0 : 1);
      let m = f.left;
      for (; m !== null; )
        !m.deleted && m.countable && (c += m.length), m = m.left;
    }
  } else {
    if (o !== null)
      l = e.get(o);
    else if (a !== null) {
      if (Vt(i, a.client) <= a.clock)
        return null;
      const { item: u } = n ? yy(i, a) : { item: ps(i, a) };
      if (u instanceof vt && u.content instanceof Qi)
        l = u.content.type;
      else
        return null;
    } else
      throw ri();
    s >= 0 ? c = l._length : c = 0;
  }
  return jHe(l, c, t.assoc);
};
class Kb {
  /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */
  constructor(e, n) {
    this.ds = e, this.sv = n;
  }
}
const xN = (t, e) => new Kb(t, e), bp = (t) => xN(PHe(t.store), Oh(t.store)), to = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && (e.sv.get(t.id.client) || 0) > t.id.clock && !sl(e.ds, t.id), hy = (t, e) => {
  const n = Xr(t.meta, hy, Mo), i = t.doc.store;
  n.has(e) || (e.sv.forEach((r, a) => {
    r < Vt(i, a) && Yn(t, Ye(a, r));
  }), Ea(t, e.ds, (r) => {
  }), n.add(e));
};
class _N {
  constructor() {
    this.clients = /* @__PURE__ */ new Map(), this.pendingStructs = null, this.pendingDs = null;
  }
}
const Oh = (t) => {
  const e = /* @__PURE__ */ new Map();
  return t.clients.forEach((n, i) => {
    const r = n[n.length - 1];
    e.set(i, r.id.clock + r.length);
  }), e;
}, Vt = (t, e) => {
  const n = t.clients.get(e);
  if (n === void 0)
    return 0;
  const i = n[n.length - 1];
  return i.id.clock + i.length;
}, MN = (t, e) => {
  let n = t.clients.get(e.id.client);
  if (n === void 0)
    n = [], t.clients.set(e.id.client, n);
  else {
    const i = n[n.length - 1];
    if (i.id.clock + i.length !== e.id.clock)
      throw ri();
  }
  n.push(e);
}, Ki = (t, e) => {
  let n = 0, i = t.length - 1, r = t[i], a = r.id.clock;
  if (a === e)
    return i;
  let o = Gr(e / (a + r.length - 1) * i);
  for (; n <= i; ) {
    if (r = t[o], a = r.id.clock, a <= e) {
      if (e < a + r.length)
        return o;
      n = o + 1;
    } else
      i = o - 1;
    o = Gr((n + i) / 2);
  }
  throw ri();
}, VHe = (t, e) => {
  const n = t.clients.get(e.client);
  return n[Ki(n, e.clock)];
}, ps = (
  /** @type {function(StructStore,ID):Item} */
  VHe
), py = (t, e, n) => {
  const i = Ki(e, n), r = e[i];
  return r.id.clock < n && r instanceof vt ? (e.splice(i + 1, 0, km(t, r, n - r.id.clock)), i + 1) : i;
}, Yn = (t, e) => {
  const n = (
    /** @type {Array<Item>} */
    t.doc.store.clients.get(e.client)
  );
  return n[py(t, n, e.clock)];
}, c4 = (t, e, n) => {
  const i = e.clients.get(n.client), r = Ki(i, n.clock), a = i[r];
  return n.clock !== a.id.clock + a.length - 1 && a.constructor !== wi && i.splice(r + 1, 0, km(t, a, n.clock - a.id.clock + 1)), a;
}, HHe = (t, e, n) => {
  const i = (
    /** @type {Array<GC|Item>} */
    t.clients.get(e.id.client)
  );
  i[Ki(i, e.id.clock)] = n;
}, CN = (t, e, n, i, r) => {
  if (i === 0)
    return;
  const a = n + i;
  let o = py(t, e, n), s;
  do
    s = e[o++], a < s.id.clock + s.length && py(t, e, a), r(s);
  while (o < e.length && e[o].id.clock < a);
};
class BHe {
  /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */
  constructor(e, n, i) {
    this.doc = e, this.deleteSet = new ol(), this.beforeState = Oh(e.store), this.afterState = /* @__PURE__ */ new Map(), this.changed = /* @__PURE__ */ new Map(), this.changedParentTypes = /* @__PURE__ */ new Map(), this._mergeStructs = [], this.origin = n, this.meta = /* @__PURE__ */ new Map(), this.local = i, this.subdocsAdded = /* @__PURE__ */ new Set(), this.subdocsRemoved = /* @__PURE__ */ new Set(), this.subdocsLoaded = /* @__PURE__ */ new Set(), this._needFormattingCleanup = !1;
  }
}
const u4 = (t, e) => e.deleteSet.clients.size === 0 && !sVe(e.afterState, (n, i) => e.beforeState.get(i) !== n) ? !1 : (Xb(e.deleteSet), AHe(t, e), Yb(t, e.deleteSet), !0), f4 = (t, e, n) => {
  const i = e._item;
  (i === null || i.id.clock < (t.beforeState.get(i.id.client) || 0) && !i.deleted) && Xr(t.changed, e, Mo).add(n);
}, Fu = (t, e) => {
  let n = t[e], i = t[e - 1], r = e;
  for (; r > 0; n = i, i = t[--r - 1]) {
    if (i.deleted === n.deleted && i.constructor === n.constructor && i.mergeWith(n)) {
      n instanceof vt && n.parentSub !== null && /** @type {AbstractType<any>} */
      n.parent._map.get(n.parentSub) === n && n.parent._map.set(
        n.parentSub,
        /** @type {Item} */
        i
      );
      continue;
    }
    break;
  }
  const a = e - r;
  return a && t.splice(e + 1 - a, a), a;
}, qHe = (t, e, n) => {
  for (const [i, r] of t.clients.entries()) {
    const a = (
      /** @type {Array<GC|Item>} */
      e.clients.get(i)
    );
    for (let o = r.length - 1; o >= 0; o--) {
      const s = r[o], l = s.clock + s.len;
      for (let c = Ki(a, s.clock), u = a[c]; c < a.length && u.id.clock < l; u = a[++c]) {
        const f = a[c];
        if (s.clock + s.len <= f.id.clock)
          break;
        f instanceof vt && f.deleted && !f.keep && n(f) && f.gc(e, !1);
      }
    }
  }
}, GHe = (t, e) => {
  t.clients.forEach((n, i) => {
    const r = (
      /** @type {Array<GC|Item>} */
      e.clients.get(i)
    );
    for (let a = n.length - 1; a >= 0; a--) {
      const o = n[a], s = zs(r.length - 1, 1 + Ki(r, o.clock + o.len - 1));
      for (let l = s, c = r[l]; l > 0 && c.id.clock >= o.clock; c = r[l])
        l -= 1 + Fu(r, l);
    }
  });
}, PN = (t, e) => {
  if (e < t.length) {
    const n = t[e], i = n.doc, r = i.store, a = n.deleteSet, o = n._mergeStructs;
    try {
      Xb(a), n.afterState = Oh(n.doc.store), i.emit("beforeObserverCalls", [n, i]);
      const s = [];
      n.changed.forEach(
        (l, c) => s.push(() => {
          (c._item === null || !c._item.deleted) && c._callObserver(n, l);
        })
      ), s.push(() => {
        n.changedParentTypes.forEach((l, c) => {
          c._dEH.l.length > 0 && (c._item === null || !c._item.deleted) && (l = l.filter(
            (u) => u.target._item === null || !u.target._item.deleted
          ), l.forEach((u) => {
            u.currentTarget = c, u._path = null;
          }), l.sort((u, f) => u.path.length - f.path.length), kN(c._dEH, l, n));
        });
      }), s.push(() => i.emit("afterTransaction", [n, i])), Bb(s, []), n._needFormattingCleanup && fBe(n);
    } finally {
      i.gc && qHe(a, r, i.gcFilter), GHe(a, r), n.afterState.forEach((u, f) => {
        const m = n.beforeState.get(f) || 0;
        if (m !== u) {
          const h = (
            /** @type {Array<GC|Item>} */
            r.clients.get(f)
          ), p = $a(Ki(h, m), 1);
          for (let g = h.length - 1; g >= p; )
            g -= 1 + Fu(h, g);
        }
      });
      for (let u = o.length - 1; u >= 0; u--) {
        const { client: f, clock: m } = o[u].id, h = (
          /** @type {Array<GC|Item>} */
          r.clients.get(f)
        ), p = Ki(h, m);
        p + 1 < h.length && Fu(h, p + 1) > 1 || p > 0 && Fu(h, p);
      }
      if (!n.local && n.afterState.get(i.clientID) !== n.beforeState.get(i.clientID) && (_He(qb, uN, "[yjs] ", fN, mN, "Changed the client-id because another client seems to be using it."), i.clientID = bN()), i.emit("afterTransactionCleanup", [n, i]), i._observers.has("update")) {
        const u = new DHe();
        u4(u, n) && i.emit("update", [u.toUint8Array(), n.origin, i, n]);
      }
      if (i._observers.has("updateV2")) {
        const u = new Th();
        u4(u, n) && i.emit("updateV2", [u.toUint8Array(), n.origin, i, n]);
      }
      const { subdocsAdded: s, subdocsLoaded: l, subdocsRemoved: c } = n;
      (s.size > 0 || c.size > 0 || l.size > 0) && (s.forEach((u) => {
        u.clientID = i.clientID, u.collectionid == null && (u.collectionid = i.collectionid), i.subdocs.add(u);
      }), c.forEach((u) => i.subdocs.delete(u)), i.emit("subdocs", [{ loaded: l, added: s, removed: c }, i, n]), c.forEach((u) => u.destroy())), t.length <= e + 1 ? (i._transactionCleanups = [], i.emit("afterAllTransactions", [i, t])) : PN(t, e + 1);
    }
  }
}, mt = (t, e, n = null, i = !0) => {
  const r = t._transactionCleanups;
  let a = !1, o = null;
  t._transaction === null && (a = !0, t._transaction = new BHe(t, n, i), r.push(t._transaction), r.length === 1 && t.emit("beforeAllTransactions", [t]), t.emit("beforeTransaction", [t._transaction, t]));
  try {
    o = e(t._transaction);
  } finally {
    if (a) {
      const s = t._transaction === r[0];
      t._transaction = null, s && PN(r, 0);
    }
  }
  return o;
};
class XHe {
  /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */
  constructor(e, n) {
    this.insertions = n, this.deletions = e, this.meta = /* @__PURE__ */ new Map();
  }
}
const m4 = (t, e, n) => {
  Ea(t, n.deletions, (i) => {
    i instanceof vt && e.scope.some((r) => r === t.doc || Ld(
      /** @type {AbstractType<any>} */
      r,
      i
    )) && ew(i, !1);
  });
}, h4 = (t, e, n) => {
  let i = null;
  const r = t.doc, a = t.scope;
  mt(r, (s) => {
    for (; e.length > 0 && t.currStackItem === null; ) {
      const l = r.store, c = (
        /** @type {StackItem} */
        e.pop()
      ), u = /* @__PURE__ */ new Set(), f = [];
      let m = !1;
      Ea(s, c.insertions, (h) => {
        if (h instanceof vt) {
          if (h.redone !== null) {
            let { item: p, diff: g } = yy(l, h.id);
            g > 0 && (p = Yn(s, Ye(p.id.client, p.id.clock + g))), h = p;
          }
          !h.deleted && a.some((p) => p === s.doc || Ld(
            /** @type {AbstractType<any>} */
            p,
            /** @type {Item} */
            h
          )) && f.push(h);
        }
      }), Ea(s, c.deletions, (h) => {
        h instanceof vt && a.some((p) => p === s.doc || Ld(
          /** @type {AbstractType<any>} */
          p,
          h
        )) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
        !sl(c.insertions, h.id) && u.add(h);
      }), u.forEach((h) => {
        m = GN(s, h, u, c.insertions, t.ignoreRemoteMapChanges, t) !== null || m;
      });
      for (let h = f.length - 1; h >= 0; h--) {
        const p = f[h];
        t.deleteFilter(p) && (p.delete(s), m = !0);
      }
      t.currStackItem = m ? c : null;
    }
    s.changed.forEach((l, c) => {
      l.has(null) && c._searchMarker && (c._searchMarker.length = 0);
    }), i = s;
  }, t);
  const o = t.currStackItem;
  if (o != null) {
    const s = i.changedParentTypes;
    t.emit("stack-item-popped", [{ stackItem: o, type: n, changedParentTypes: s, origin: t }, t]), t.currStackItem = null;
  }
  return o;
};
class SN extends Q7 {
  /**
   * @param {Doc|AbstractType<any>|Array<AbstractType<any>>} typeScope Limits the scope of the UndoManager. If this is set to a ydoc instance, all changes on that ydoc will be undone. If set to a specific type, only changes on that type or its children will be undone. Also accepts an array of types.
   * @param {UndoManagerOptions} options
   */
  constructor(e, {
    captureTimeout: n = 500,
    captureTransaction: i = (l) => !0,
    deleteFilter: r = () => !0,
    trackedOrigins: a = /* @__PURE__ */ new Set([null]),
    ignoreRemoteMapChanges: o = !1,
    doc: s = (
      /** @type {Doc} */
      oy(e) ? e[0].doc : e instanceof Ro ? e : e.doc
    )
  } = {}) {
    super(), this.scope = [], this.doc = s, this.addToScope(e), this.deleteFilter = r, a.add(this), this.trackedOrigins = a, this.captureTransaction = i, this.undoStack = [], this.redoStack = [], this.undoing = !1, this.redoing = !1, this.currStackItem = null, this.lastChange = 0, this.ignoreRemoteMapChanges = o, this.captureTimeout = n, this.afterTransactionHandler = (l) => {
      if (!this.captureTransaction(l) || !this.scope.some((y) => l.changedParentTypes.has(
        /** @type {AbstractType<any>} */
        y
      ) || y === this.doc) || !this.trackedOrigins.has(l.origin) && (!l.origin || !this.trackedOrigins.has(l.origin.constructor)))
        return;
      const c = this.undoing, u = this.redoing, f = c ? this.redoStack : this.undoStack;
      c ? this.stopCapturing() : u || this.clear(!1, !0);
      const m = new ol();
      l.afterState.forEach((y, v) => {
        const w = l.beforeState.get(v) || 0, x = y - w;
        x > 0 && Wd(m, v, w, x);
      });
      const h = GVe();
      let p = !1;
      if (this.lastChange > 0 && h - this.lastChange < this.captureTimeout && f.length > 0 && !c && !u) {
        const y = f[f.length - 1];
        y.deletions = fy([y.deletions, l.deleteSet]), y.insertions = fy([y.insertions, m]);
      } else
        f.push(new XHe(l.deleteSet, m)), p = !0;
      !c && !u && (this.lastChange = h), Ea(
        l,
        l.deleteSet,
        /** @param {Item|GC} item */
        (y) => {
          y instanceof vt && this.scope.some((v) => v === l.doc || Ld(
            /** @type {AbstractType<any>} */
            v,
            y
          )) && ew(y, !0);
        }
      );
      const g = [{ stackItem: f[f.length - 1], origin: l.origin, type: c ? "redo" : "undo", changedParentTypes: l.changedParentTypes }, this];
      p ? this.emit("stack-item-added", g) : this.emit("stack-item-updated", g);
    }, this.doc.on("afterTransaction", this.afterTransactionHandler), this.doc.on("destroy", () => {
      this.destroy();
    });
  }
  /**
   * Extend the scope.
   *
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */
  addToScope(e) {
    const n = new Set(this.scope);
    e = oy(e) ? e : [e], e.forEach((i) => {
      n.has(i) || (n.add(i), (i instanceof on ? i.doc !== this.doc : i !== this.doc) && pN("[yjs#509] Not same Y.Doc"), this.scope.push(i));
    });
  }
  /**
   * @param {any} origin
   */
  addTrackedOrigin(e) {
    this.trackedOrigins.add(e);
  }
  /**
   * @param {any} origin
   */
  removeTrackedOrigin(e) {
    this.trackedOrigins.delete(e);
  }
  clear(e = !0, n = !0) {
    (e && this.canUndo() || n && this.canRedo()) && this.doc.transact((i) => {
      e && (this.undoStack.forEach((r) => m4(i, this, r)), this.undoStack = []), n && (this.redoStack.forEach((r) => m4(i, this, r)), this.redoStack = []), this.emit("stack-cleared", [{ undoStackCleared: e, redoStackCleared: n }]);
    });
  }
  /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */
  stopCapturing() {
    this.lastChange = 0;
  }
  /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  undo() {
    this.undoing = !0;
    let e;
    try {
      e = h4(this, this.undoStack, "undo");
    } finally {
      this.undoing = !1;
    }
    return e;
  }
  /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  redo() {
    this.redoing = !0;
    let e;
    try {
      e = h4(this, this.redoStack, "redo");
    } finally {
      this.redoing = !1;
    }
    return e;
  }
  /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */
  canUndo() {
    return this.undoStack.length > 0;
  }
  /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */
  canRedo() {
    return this.redoStack.length > 0;
  }
  destroy() {
    this.trackedOrigins.delete(this), this.doc.off("afterTransaction", this.afterTransactionHandler), super.destroy();
  }
}
function* YHe(t) {
  const e = Pt(t.restDecoder);
  for (let n = 0; n < e; n++) {
    const i = Pt(t.restDecoder), r = t.readClient();
    let a = Pt(t.restDecoder);
    for (let o = 0; o < i; o++) {
      const s = t.readInfo();
      if (s === 10) {
        const l = Pt(t.restDecoder);
        yield new zi(Ye(r, a), l), a += l;
      } else if (($h & s) !== 0) {
        const l = (s & (Ar | Ln)) === 0, c = new vt(
          Ye(r, a),
          null,
          // left
          (s & Ln) === Ln ? t.readLeftID() : null,
          // origin
          null,
          // right
          (s & Ar) === Ar ? t.readRightID() : null,
          // right origin
          // @ts-ignore Force writing a string here.
          l ? t.readParentInfo() ? t.readString() : t.readLeftID() : null,
          // parent
          l && (s & Ed) === Ed ? t.readString() : null,
          // parentSub
          XN(t, s)
          // item content
        );
        yield c, a += c.length;
      } else {
        const l = t.readLen();
        yield new wi(Ye(r, a), l), a += l;
      }
    }
  }
}
class KHe {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  constructor(e, n) {
    this.gen = YHe(e), this.curr = null, this.done = !1, this.filterSkips = n, this.next();
  }
  /**
   * @return {Item | GC | Skip |null}
   */
  next() {
    do
      this.curr = this.gen.next().value || null;
    while (this.filterSkips && this.curr !== null && this.curr.constructor === zi);
    return this.curr;
  }
}
class UHe {
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  constructor(e) {
    this.currClient = 0, this.startClock = 0, this.written = 0, this.encoder = e, this.clientStructs = [];
  }
}
const JHe = (t, e) => {
  if (t.constructor === wi) {
    const { client: n, clock: i } = t.id;
    return new wi(Ye(n, i + e), t.length - e);
  } else if (t.constructor === zi) {
    const { client: n, clock: i } = t.id;
    return new zi(Ye(n, i + e), t.length - e);
  } else {
    const n = (
      /** @type {Item} */
      t
    ), { client: i, clock: r } = n.id;
    return new vt(
      Ye(i, r + e),
      null,
      Ye(i, r + e - 1),
      null,
      n.rightOrigin,
      n.parent,
      n.parentSub,
      n.content.splice(e)
    );
  }
}, p4 = (t, e = pm, n = Th) => {
  if (t.length === 1)
    return t[0];
  const i = t.map((u) => new e(zb(u)));
  let r = i.map((u) => new KHe(u, !0)), a = null;
  const o = new n(), s = new UHe(o);
  for (; r = r.filter((m) => m.curr !== null), r.sort(
    /** @type {function(any,any):number} */
    (m, h) => {
      if (m.curr.id.client === h.curr.id.client) {
        const p = m.curr.id.clock - h.curr.id.clock;
        return p === 0 ? m.curr.constructor === h.curr.constructor ? 0 : m.curr.constructor === zi ? 1 : -1 : p;
      } else
        return h.curr.id.client - m.curr.id.client;
    }
  ), r.length !== 0; ) {
    const u = r[0], f = (
      /** @type {Item | GC} */
      u.curr.id.client
    );
    if (a !== null) {
      let m = (
        /** @type {Item | GC | null} */
        u.curr
      ), h = !1;
      for (; m !== null && m.id.clock + m.length <= a.struct.id.clock + a.struct.length && m.id.client >= a.struct.id.client; )
        m = u.next(), h = !0;
      if (m === null || // current decoder is empty
      m.id.client !== f || // check whether there is another decoder that has has updates from `firstClient`
      h && m.id.clock > a.struct.id.clock + a.struct.length)
        continue;
      if (f !== a.struct.id.client)
        Dl(s, a.struct, a.offset), a = { struct: m, offset: 0 }, u.next();
      else if (a.struct.id.clock + a.struct.length < m.id.clock)
        if (a.struct.constructor === zi)
          a.struct.length = m.id.clock + m.length - a.struct.id.clock;
        else {
          Dl(s, a.struct, a.offset);
          const p = m.id.clock - a.struct.id.clock - a.struct.length;
          a = { struct: new zi(Ye(f, a.struct.id.clock + a.struct.length), p), offset: 0 };
        }
      else {
        const p = a.struct.id.clock + a.struct.length - m.id.clock;
        p > 0 && (a.struct.constructor === zi ? a.struct.length -= p : m = JHe(m, p)), a.struct.mergeWith(
          /** @type {any} */
          m
        ) || (Dl(s, a.struct, a.offset), a = { struct: m, offset: 0 }, u.next());
      }
    } else
      a = { struct: (
        /** @type {Item | GC} */
        u.curr
      ), offset: 0 }, u.next();
    for (let m = u.curr; m !== null && m.id.client === f && m.id.clock === a.struct.id.clock + a.struct.length && m.constructor !== zi; m = u.next())
      Dl(s, a.struct, a.offset), a = { struct: m, offset: 0 };
  }
  a !== null && (Dl(s, a.struct, a.offset), a = null), QHe(s);
  const l = i.map((u) => SHe(u)), c = fy(l);
  return Yb(o, c), o.toUint8Array();
}, NN = (t) => {
  t.written > 0 && (t.clientStructs.push({ written: t.written, restEncoder: Hi(t.encoder.restEncoder) }), t.encoder.restEncoder = Oc(), t.written = 0);
}, Dl = (t, e, n) => {
  t.written > 0 && t.currClient !== e.id.client && NN(t), t.written === 0 && (t.currClient = e.id.client, t.encoder.writeClient(e.id.client), nt(t.encoder.restEncoder, e.id.clock + n)), e.write(t.encoder, n), t.written++;
}, QHe = (t) => {
  NN(t);
  const e = t.encoder.restEncoder;
  nt(e, t.clientStructs.length);
  for (let n = 0; n < t.clientStructs.length; n++) {
    const i = t.clientStructs[n];
    nt(e, i.written), Dh(e, i.restEncoder);
  }
}, g4 = "You must not compute changes after the event-handler fired.";
class Wh {
  /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */
  constructor(e, n) {
    this.target = e, this.currentTarget = e, this.transaction = n, this._changes = null, this._keys = null, this._delta = null, this._path = null;
  }
  /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */
  get path() {
    return this._path || (this._path = ZHe(this.currentTarget, this.target));
  }
  /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  deletes(e) {
    return sl(this.transaction.deleteSet, e.id);
  }
  /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any, newValue: any }>}
   */
  get keys() {
    if (this._keys === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw Da(g4);
      const e = /* @__PURE__ */ new Map(), n = this.target;
      /** @type Set<string|null> */
      this.transaction.changed.get(n).forEach((r) => {
        if (r !== null) {
          const a = (
            /** @type {Item} */
            n._map.get(r)
          );
          let o, s;
          if (this.adds(a)) {
            let l = a.left;
            for (; l !== null && this.adds(l); )
              l = l.left;
            if (this.deletes(a))
              if (l !== null && this.deletes(l))
                o = "delete", s = fp(l.content.getContent());
              else
                return;
            else
              l !== null && this.deletes(l) ? (o = "update", s = fp(l.content.getContent())) : (o = "add", s = void 0);
          } else if (this.deletes(a))
            o = "delete", s = fp(
              /** @type {Item} */
              a.content.getContent()
            );
          else
            return;
          e.set(r, { action: o, oldValue: s });
        }
      }), this._keys = e;
    }
    return this._keys;
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */
  get delta() {
    return this.changes.delta;
  }
  /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  adds(e) {
    return e.id.clock >= (this.transaction.beforeState.get(e.id.client) || 0);
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    let e = this._changes;
    if (e === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw Da(g4);
      const n = this.target, i = Mo(), r = Mo(), a = [];
      if (e = {
        added: i,
        deleted: r,
        delta: a,
        keys: this.keys
      }, /** @type Set<string|null> */
      this.transaction.changed.get(n).has(null)) {
        let s = null;
        const l = () => {
          s && a.push(s);
        };
        for (let c = n._start; c !== null; c = c.right)
          c.deleted ? this.deletes(c) && !this.adds(c) && ((s === null || s.delete === void 0) && (l(), s = { delete: 0 }), s.delete += c.length, r.add(c)) : this.adds(c) ? ((s === null || s.insert === void 0) && (l(), s = { insert: [] }), s.insert = s.insert.concat(c.content.getContent()), i.add(c)) : ((s === null || s.retain === void 0) && (l(), s = { retain: 0 }), s.retain += c.length);
        s !== null && s.retain === void 0 && l();
      }
      this._changes = e;
    }
    return (
      /** @type {any} */
      e
    );
  }
}
const ZHe = (t, e) => {
  const n = [];
  for (; e._item !== null && e !== t; ) {
    if (e._item.parentSub !== null)
      n.unshift(e._item.parentSub);
    else {
      let i = 0, r = (
        /** @type {AbstractType<any>} */
        e._item.parent._start
      );
      for (; r !== e._item && r !== null; )
        !r.deleted && r.countable && (i += r.length), r = r.right;
      n.unshift(i);
    }
    e = /** @type {AbstractType<any>} */
    e._item.parent;
  }
  return n;
}, kn = () => {
  pN("Invalid access: Add Yjs type to a document before reading data.");
}, $N = 80;
let Ub = 0;
class eBe {
  /**
   * @param {Item} p
   * @param {number} index
   */
  constructor(e, n) {
    e.marker = !0, this.p = e, this.index = n, this.timestamp = Ub++;
  }
}
const tBe = (t) => {
  t.timestamp = Ub++;
}, DN = (t, e, n) => {
  t.p.marker = !1, t.p = e, e.marker = !0, t.index = n, t.timestamp = Ub++;
}, nBe = (t, e, n) => {
  if (t.length >= $N) {
    const i = t.reduce((r, a) => r.timestamp < a.timestamp ? r : a);
    return DN(i, e, n), i;
  } else {
    const i = new eBe(e, n);
    return t.push(i), i;
  }
}, Ah = (t, e) => {
  if (t._start === null || e === 0 || t._searchMarker === null)
    return null;
  const n = t._searchMarker.length === 0 ? null : t._searchMarker.reduce((a, o) => Iu(e - a.index) < Iu(e - o.index) ? a : o);
  let i = t._start, r = 0;
  for (n !== null && (i = n.p, r = n.index, tBe(n)); i.right !== null && r < e; ) {
    if (!i.deleted && i.countable) {
      if (e < r + i.length)
        break;
      r += i.length;
    }
    i = i.right;
  }
  for (; i.left !== null && r > e; )
    i = i.left, !i.deleted && i.countable && (r -= i.length);
  for (; i.left !== null && i.left.id.client === i.id.client && i.left.id.clock + i.left.length === i.id.clock; )
    i = i.left, !i.deleted && i.countable && (r -= i.length);
  return n !== null && Iu(n.index - r) < /** @type {YText|YArray<any>} */
  i.parent.length / $N ? (DN(n, i, r), n) : nBe(t._searchMarker, i, r);
}, Id = (t, e, n) => {
  for (let i = t.length - 1; i >= 0; i--) {
    const r = t[i];
    if (n > 0) {
      let a = r.p;
      for (a.marker = !1; a && (a.deleted || !a.countable); )
        a = a.left, a && !a.deleted && a.countable && (r.index -= a.length);
      if (a === null || a.marker === !0) {
        t.splice(i, 1);
        continue;
      }
      r.p = a, a.marker = !0;
    }
    (e < r.index || n > 0 && e === r.index) && (r.index = $a(e, r.index + n));
  }
}, Lh = (t, e, n) => {
  const i = t, r = e.changedParentTypes;
  for (; Xr(r, t, () => []).push(n), t._item !== null; )
    t = /** @type {AbstractType<any>} */
    t._item.parent;
  kN(i._eH, n, e);
};
class on {
  constructor() {
    this._item = null, this._map = /* @__PURE__ */ new Map(), this._start = null, this.doc = null, this._length = 0, this._eH = s4(), this._dEH = s4(), this._searchMarker = null;
  }
  /**
   * @return {AbstractType<any>|null}
   */
  get parent() {
    return this._item ? (
      /** @type {AbstractType<any>} */
      this._item.parent
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */
  _integrate(e, n) {
    this.doc = e, this._item = n;
  }
  /**
   * @return {AbstractType<EventType>}
   */
  _copy() {
    throw qi();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */
  clone() {
    throw qi();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */
  _write(e) {
  }
  /**
   * The first non-deleted item
   */
  get _first() {
    let e = this._start;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    !e.local && this._searchMarker && (this._searchMarker.length = 0);
  }
  /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */
  observe(e) {
    l4(this._eH, e);
  }
  /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  observeDeep(e) {
    l4(this._dEH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */
  unobserve(e) {
    d4(this._eH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  unobserveDeep(e) {
    d4(this._dEH, e);
  }
  /**
   * @abstract
   * @return {any}
   */
  toJSON() {
  }
}
const EN = (t, e, n) => {
  t.doc ?? kn(), e < 0 && (e = t._length + e), n < 0 && (n = t._length + n);
  let i = n - e;
  const r = [];
  let a = t._start;
  for (; a !== null && i > 0; ) {
    if (a.countable && !a.deleted) {
      const o = a.content.getContent();
      if (o.length <= e)
        e -= o.length;
      else {
        for (let s = e; s < o.length && i > 0; s++)
          r.push(o[s]), i--;
        e = 0;
      }
    }
    a = a.right;
  }
  return r;
}, TN = (t) => {
  t.doc ?? kn();
  const e = [];
  let n = t._start;
  for (; n !== null; ) {
    if (n.countable && !n.deleted) {
      const i = n.content.getContent();
      for (let r = 0; r < i.length; r++)
        e.push(i[r]);
    }
    n = n.right;
  }
  return e;
}, ON = (t, e) => {
  const n = [];
  let i = t._start;
  for (; i !== null; ) {
    if (i.countable && to(i, e)) {
      const r = i.content.getContent();
      for (let a = 0; a < r.length; a++)
        n.push(r[a]);
    }
    i = i.right;
  }
  return n;
}, Rd = (t, e) => {
  let n = 0, i = t._start;
  for (t.doc ?? kn(); i !== null; ) {
    if (i.countable && !i.deleted) {
      const r = i.content.getContent();
      for (let a = 0; a < r.length; a++)
        e(r[a], n++, t);
    }
    i = i.right;
  }
}, WN = (t, e) => {
  const n = [];
  return Rd(t, (i, r) => {
    n.push(e(i, r, t));
  }), n;
}, iBe = (t) => {
  let e = t._start, n = null, i = 0;
  return {
    [Symbol.iterator]() {
      return this;
    },
    next: () => {
      if (n === null) {
        for (; e !== null && e.deleted; )
          e = e.right;
        if (e === null)
          return {
            done: !0,
            value: void 0
          };
        n = e.content.getContent(), i = 0, e = e.right;
      }
      const r = n[i++];
      return n.length <= i && (n = null), {
        done: !1,
        value: r
      };
    }
  };
}, AN = (t, e) => {
  t.doc ?? kn();
  const n = Ah(t, e);
  let i = t._start;
  for (n !== null && (i = n.p, e -= n.index); i !== null; i = i.right)
    if (!i.deleted && i.countable) {
      if (e < i.length)
        return i.content.getContent()[e];
      e -= i.length;
    }
}, ym = (t, e, n, i) => {
  let r = n;
  const a = t.doc, o = a.clientID, s = a.store, l = n === null ? e._start : n.right;
  let c = [];
  const u = () => {
    c.length > 0 && (r = new vt(Ye(o, Vt(s, o)), r, r && r.lastId, l, l && l.id, e, null, new So(c)), r.integrate(t, 0), c = []);
  };
  i.forEach((f) => {
    if (f === null)
      c.push(f);
    else
      switch (f.constructor) {
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
          c.push(f);
          break;
        default:
          switch (u(), f.constructor) {
            case Uint8Array:
            case ArrayBuffer:
              r = new vt(Ye(o, Vt(s, o)), r, r && r.lastId, l, l && l.id, e, null, new Wc(new Uint8Array(
                /** @type {Uint8Array} */
                f
              ))), r.integrate(t, 0);
              break;
            case Ro:
              r = new vt(Ye(o, Vt(s, o)), r, r && r.lastId, l, l && l.id, e, null, new Ac(
                /** @type {Doc} */
                f
              )), r.integrate(t, 0);
              break;
            default:
              if (f instanceof on)
                r = new vt(Ye(o, Vt(s, o)), r, r && r.lastId, l, l && l.id, e, null, new Qi(f)), r.integrate(t, 0);
              else
                throw new Error("Unexpected content type in insert operation");
          }
      }
  }), u();
}, LN = () => Da("Length exceeded!"), IN = (t, e, n, i) => {
  if (n > e._length)
    throw LN();
  if (n === 0)
    return e._searchMarker && Id(e._searchMarker, n, i.length), ym(t, e, null, i);
  const r = n, a = Ah(e, n);
  let o = e._start;
  for (a !== null && (o = a.p, n -= a.index, n === 0 && (o = o.prev, n += o && o.countable && !o.deleted ? o.length : 0)); o !== null; o = o.right)
    if (!o.deleted && o.countable) {
      if (n <= o.length) {
        n < o.length && Yn(t, Ye(o.id.client, o.id.clock + n));
        break;
      }
      n -= o.length;
    }
  return e._searchMarker && Id(e._searchMarker, r, i.length), ym(t, e, o, i);
}, rBe = (t, e, n) => {
  let r = (e._searchMarker || []).reduce((a, o) => o.index > a.index ? o : a, { index: 0, p: e._start }).p;
  if (r)
    for (; r.right; )
      r = r.right;
  return ym(t, e, r, n);
}, RN = (t, e, n, i) => {
  if (i === 0)
    return;
  const r = n, a = i, o = Ah(e, n);
  let s = e._start;
  for (o !== null && (s = o.p, n -= o.index); s !== null && n > 0; s = s.right)
    !s.deleted && s.countable && (n < s.length && Yn(t, Ye(s.id.client, s.id.clock + n)), n -= s.length);
  for (; i > 0 && s !== null; )
    s.deleted || (i < s.length && Yn(t, Ye(s.id.client, s.id.clock + i)), s.delete(t), i -= s.length), s = s.right;
  if (i > 0)
    throw LN();
  e._searchMarker && Id(
    e._searchMarker,
    r,
    -a + i
    /* in case we remove the above exception */
  );
}, vm = (t, e, n) => {
  const i = e._map.get(n);
  i !== void 0 && i.delete(t);
}, Jb = (t, e, n, i) => {
  const r = e._map.get(n) || null, a = t.doc, o = a.clientID;
  let s;
  if (i == null)
    s = new So([i]);
  else
    switch (i.constructor) {
      case Number:
      case Object:
      case Boolean:
      case Array:
      case String:
      case Date:
      case BigInt:
        s = new So([i]);
        break;
      case Uint8Array:
        s = new Wc(
          /** @type {Uint8Array} */
          i
        );
        break;
      case Ro:
        s = new Ac(
          /** @type {Doc} */
          i
        );
        break;
      default:
        if (i instanceof on)
          s = new Qi(i);
        else
          throw new Error("Unexpected content type");
    }
  new vt(Ye(o, Vt(a.store, o)), r, r && r.lastId, null, null, e, n, s).integrate(t, 0);
}, Qb = (t, e) => {
  t.doc ?? kn();
  const n = t._map.get(e);
  return n !== void 0 && !n.deleted ? n.content.getContent()[n.length - 1] : void 0;
}, jN = (t) => {
  const e = {};
  return t.doc ?? kn(), t._map.forEach((n, i) => {
    n.deleted || (e[i] = n.content.getContent()[n.length - 1]);
  }), e;
}, FN = (t, e) => {
  t.doc ?? kn();
  const n = t._map.get(e);
  return n !== void 0 && !n.deleted;
}, aBe = (t, e) => {
  const n = {};
  return t._map.forEach((i, r) => {
    let a = i;
    for (; a !== null && (!e.sv.has(a.id.client) || a.id.clock >= (e.sv.get(a.id.client) || 0)); )
      a = a.left;
    a !== null && to(a, e) && (n[r] = a.content.getContent()[a.length - 1]);
  }), n;
}, mu = (t) => (t.doc ?? kn(), MHe(
  t._map.entries(),
  /** @param {any} entry */
  (e) => !e[1].deleted
));
class oBe extends Wh {
}
class gs extends on {
  constructor() {
    super(), this._prelimContent = [], this._searchMarker = [];
  }
  /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */
  static from(e) {
    const n = new gs();
    return n.push(e), n;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  /**
   * @return {YArray<T>}
   */
  _copy() {
    return new gs();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */
  clone() {
    const e = new gs();
    return e.insert(0, this.toArray().map(
      (n) => n instanceof on ? (
        /** @type {typeof el} */
        n.clone()
      ) : n
    )), e;
  }
  get length() {
    return this.doc ?? kn(), this._length;
  }
  /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    super._callObserver(e, n), Lh(this, e, new oBe(this, e));
  }
  /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */
  insert(e, n) {
    this.doc !== null ? mt(this.doc, (i) => {
      IN(
        i,
        this,
        e,
        /** @type {any} */
        n
      );
    }) : this._prelimContent.splice(e, 0, ...n);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */
  push(e) {
    this.doc !== null ? mt(this.doc, (n) => {
      rBe(
        n,
        this,
        /** @type {any} */
        e
      );
    }) : this._prelimContent.push(...e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */
  delete(e, n = 1) {
    this.doc !== null ? mt(this.doc, (i) => {
      RN(i, this, e, n);
    }) : this._prelimContent.splice(e, n);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */
  get(e) {
    return AN(this, e);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */
  toArray() {
    return TN(this);
  }
  /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */
  slice(e = 0, n = this.length) {
    return EN(this, e, n);
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */
  toJSON() {
    return this.map((e) => e instanceof on ? e.toJSON() : e);
  }
  /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */
  map(e) {
    return WN(
      this,
      /** @type {any} */
      e
    );
  }
  /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    Rd(this, e);
  }
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return iBe(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(EBe);
  }
}
const sBe = (t) => new gs();
class lBe extends Wh {
  /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */
  constructor(e, n, i) {
    super(e, n), this.keysChanged = i;
  }
}
class Bs extends on {
  /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */
  constructor(e) {
    super(), this._prelimContent = null, e === void 0 ? this._prelimContent = /* @__PURE__ */ new Map() : this._prelimContent = new Map(e);
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this._prelimContent.forEach((i, r) => {
      this.set(r, i);
    }), this._prelimContent = null;
  }
  /**
   * @return {YMap<MapType>}
   */
  _copy() {
    return new Bs();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */
  clone() {
    const e = new Bs();
    return this.forEach((n, i) => {
      e.set(i, n instanceof on ? (
        /** @type {typeof value} */
        n.clone()
      ) : n);
    }), e;
  }
  /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    Lh(this, e, new lBe(this, e, n));
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */
  toJSON() {
    this.doc ?? kn();
    const e = {};
    return this._map.forEach((n, i) => {
      if (!n.deleted) {
        const r = n.content.getContent()[n.length - 1];
        e[i] = r instanceof on ? r.toJSON() : r;
      }
    }), e;
  }
  /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */
  get size() {
    return [...mu(this)].length;
  }
  /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */
  keys() {
    return yp(
      mu(this),
      /** @param {any} v */
      (e) => e[0]
    );
  }
  /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */
  values() {
    return yp(
      mu(this),
      /** @param {any} v */
      (e) => e[1].content.getContent()[e[1].length - 1]
    );
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  entries() {
    return yp(
      mu(this),
      /** @param {any} v */
      (e) => (
        /** @type {any} */
        [e[0], e[1].content.getContent()[e[1].length - 1]]
      )
    );
  }
  /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    this.doc ?? kn(), this._map.forEach((n, i) => {
      n.deleted || e(n.content.getContent()[n.length - 1], i, this);
    });
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */
  delete(e) {
    this.doc !== null ? mt(this.doc, (n) => {
      vm(n, this, e);
    }) : this._prelimContent.delete(e);
  }
  /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */
  set(e, n) {
    return this.doc !== null ? mt(this.doc, (i) => {
      Jb(
        i,
        this,
        e,
        /** @type {any} */
        n
      );
    }) : this._prelimContent.set(e, n), n;
  }
  /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */
  get(e) {
    return (
      /** @type {any} */
      Qb(this, e)
    );
  }
  /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */
  has(e) {
    return FN(this, e);
  }
  /**
   * Removes all elements from this YMap.
   */
  clear() {
    this.doc !== null ? mt(this.doc, (e) => {
      this.forEach(function(n, i, r) {
        vm(e, r, i);
      });
    }) : this._prelimContent.clear();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(TBe);
  }
}
const dBe = (t) => new Bs(), pa = (t, e) => t === e || typeof t == "object" && typeof e == "object" && t && e && eHe(t, e);
class gy {
  /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */
  constructor(e, n, i, r) {
    this.left = e, this.right = n, this.index = i, this.currentAttributes = r;
  }
  /**
   * Only call this if you know that this.right is defined
   */
  forward() {
    switch (this.right === null && ri(), this.right.content.constructor) {
      case Ut:
        this.right.deleted || ll(
          this.currentAttributes,
          /** @type {ContentFormat} */
          this.right.content
        );
        break;
      default:
        this.right.deleted || (this.index += this.right.length);
        break;
    }
    this.left = this.right, this.right = this.right.right;
  }
}
const y4 = (t, e, n) => {
  for (; e.right !== null && n > 0; ) {
    switch (e.right.content.constructor) {
      case Ut:
        e.right.deleted || ll(
          e.currentAttributes,
          /** @type {ContentFormat} */
          e.right.content
        );
        break;
      default:
        e.right.deleted || (n < e.right.length && Yn(t, Ye(e.right.id.client, e.right.id.clock + n)), e.index += e.right.length, n -= e.right.length);
        break;
    }
    e.left = e.right, e.right = e.right.right;
  }
  return e;
}, hu = (t, e, n, i) => {
  const r = /* @__PURE__ */ new Map(), a = i ? Ah(e, n) : null;
  if (a) {
    const o = new gy(a.p.left, a.p, a.index, r);
    return y4(t, o, n - a.index);
  } else {
    const o = new gy(null, e._start, 0, r);
    return y4(t, o, n);
  }
}, zN = (t, e, n, i) => {
  for (; n.right !== null && (n.right.deleted === !0 || n.right.content.constructor === Ut && pa(
    i.get(
      /** @type {ContentFormat} */
      n.right.content.key
    ),
    /** @type {ContentFormat} */
    n.right.content.value
  )); )
    n.right.deleted || i.delete(
      /** @type {ContentFormat} */
      n.right.content.key
    ), n.forward();
  const r = t.doc, a = r.clientID;
  i.forEach((o, s) => {
    const l = n.left, c = n.right, u = new vt(Ye(a, Vt(r.store, a)), l, l && l.lastId, c, c && c.id, e, null, new Ut(s, o));
    u.integrate(t, 0), n.right = u, n.forward();
  });
}, ll = (t, e) => {
  const { key: n, value: i } = e;
  i === null ? t.delete(n) : t.set(n, i);
}, VN = (t, e) => {
  for (; t.right !== null; ) {
    if (!(t.right.deleted || t.right.content.constructor === Ut && pa(
      e[
        /** @type {ContentFormat} */
        t.right.content.key
      ] ?? null,
      /** @type {ContentFormat} */
      t.right.content.value
    ))) break;
    t.forward();
  }
}, HN = (t, e, n, i) => {
  const r = t.doc, a = r.clientID, o = /* @__PURE__ */ new Map();
  for (const s in i) {
    const l = i[s], c = n.currentAttributes.get(s) ?? null;
    if (!pa(c, l)) {
      o.set(s, c);
      const { left: u, right: f } = n;
      n.right = new vt(Ye(a, Vt(r.store, a)), u, u && u.lastId, f, f && f.id, e, null, new Ut(s, l)), n.right.integrate(t, 0), n.forward();
    }
  }
  return o;
}, wp = (t, e, n, i, r) => {
  n.currentAttributes.forEach((m, h) => {
    r[h] === void 0 && (r[h] = null);
  });
  const a = t.doc, o = a.clientID;
  VN(n, r);
  const s = HN(t, e, n, r), l = i.constructor === String ? new Ui(
    /** @type {string} */
    i
  ) : i instanceof on ? new Qi(i) : new jo(i);
  let { left: c, right: u, index: f } = n;
  e._searchMarker && Id(e._searchMarker, n.index, l.getLength()), u = new vt(Ye(o, Vt(a.store, o)), c, c && c.lastId, u, u && u.id, e, null, l), u.integrate(t, 0), n.right = u, n.index = f, n.forward(), zN(t, e, n, s);
}, v4 = (t, e, n, i, r) => {
  const a = t.doc, o = a.clientID;
  VN(n, r);
  const s = HN(t, e, n, r);
  e: for (; n.right !== null && (i > 0 || s.size > 0 && (n.right.deleted || n.right.content.constructor === Ut)); ) {
    if (!n.right.deleted)
      switch (n.right.content.constructor) {
        case Ut: {
          const { key: l, value: c } = (
            /** @type {ContentFormat} */
            n.right.content
          ), u = r[l];
          if (u !== void 0) {
            if (pa(u, c))
              s.delete(l);
            else {
              if (i === 0)
                break e;
              s.set(l, c);
            }
            n.right.delete(t);
          } else
            n.currentAttributes.set(l, c);
          break;
        }
        default:
          i < n.right.length && Yn(t, Ye(n.right.id.client, n.right.id.clock + i)), i -= n.right.length;
          break;
      }
    n.forward();
  }
  if (i > 0) {
    let l = "";
    for (; i > 0; i--)
      l += `
`;
    n.right = new vt(Ye(o, Vt(a.store, o)), n.left, n.left && n.left.lastId, n.right, n.right && n.right.id, e, null, new Ui(l)), n.right.integrate(t, 0), n.forward();
  }
  zN(t, e, n, s);
}, BN = (t, e, n, i, r) => {
  let a = e;
  const o = Bi();
  for (; a && (!a.countable || a.deleted); ) {
    if (!a.deleted && a.content.constructor === Ut) {
      const c = (
        /** @type {ContentFormat} */
        a.content
      );
      o.set(c.key, c);
    }
    a = a.right;
  }
  let s = 0, l = !1;
  for (; e !== a; ) {
    if (n === e && (l = !0), !e.deleted) {
      const c = e.content;
      switch (c.constructor) {
        case Ut: {
          const { key: u, value: f } = (
            /** @type {ContentFormat} */
            c
          ), m = i.get(u) ?? null;
          (o.get(u) !== c || m === f) && (e.delete(t), s++, !l && (r.get(u) ?? null) === f && m !== f && (m === null ? r.delete(u) : r.set(u, m))), !l && !e.deleted && ll(
            r,
            /** @type {ContentFormat} */
            c
          );
          break;
        }
      }
    }
    e = /** @type {Item} */
    e.right;
  }
  return s;
}, cBe = (t, e) => {
  for (; e && e.right && (e.right.deleted || !e.right.countable); )
    e = e.right;
  const n = /* @__PURE__ */ new Set();
  for (; e && (e.deleted || !e.countable); ) {
    if (!e.deleted && e.content.constructor === Ut) {
      const i = (
        /** @type {ContentFormat} */
        e.content.key
      );
      n.has(i) ? e.delete(t) : n.add(i);
    }
    e = e.left;
  }
}, uBe = (t) => {
  let e = 0;
  return mt(
    /** @type {Doc} */
    t.doc,
    (n) => {
      let i = (
        /** @type {Item} */
        t._start
      ), r = t._start, a = Bi();
      const o = ay(a);
      for (; r; ) {
        if (r.deleted === !1)
          switch (r.content.constructor) {
            case Ut:
              ll(
                o,
                /** @type {ContentFormat} */
                r.content
              );
              break;
            default:
              e += BN(n, i, r, a, o), a = ay(o), i = r;
              break;
          }
        r = r.right;
      }
    }
  ), e;
}, fBe = (t) => {
  const e = /* @__PURE__ */ new Set(), n = t.doc;
  for (const [i, r] of t.afterState.entries()) {
    const a = t.beforeState.get(i) || 0;
    r !== a && CN(
      t,
      /** @type {Array<Item|GC>} */
      n.store.clients.get(i),
      a,
      r,
      (o) => {
        !o.deleted && /** @type {Item} */
        o.content.constructor === Ut && o.constructor !== wi && e.add(
          /** @type {any} */
          o.parent
        );
      }
    );
  }
  mt(n, (i) => {
    Ea(t, t.deleteSet, (r) => {
      if (r instanceof wi || !/** @type {YText} */
      r.parent._hasFormatting || e.has(
        /** @type {YText} */
        r.parent
      ))
        return;
      const a = (
        /** @type {YText} */
        r.parent
      );
      r.content.constructor === Ut ? e.add(a) : cBe(i, r);
    });
    for (const r of e)
      uBe(r);
  });
}, b4 = (t, e, n) => {
  const i = n, r = ay(e.currentAttributes), a = e.right;
  for (; n > 0 && e.right !== null; ) {
    if (e.right.deleted === !1)
      switch (e.right.content.constructor) {
        case Qi:
        case jo:
        case Ui:
          n < e.right.length && Yn(t, Ye(e.right.id.client, e.right.id.clock + n)), n -= e.right.length, e.right.delete(t);
          break;
      }
    e.forward();
  }
  a && BN(t, a, e.right, r, e.currentAttributes);
  const o = (
    /** @type {AbstractType<any>} */
    /** @type {Item} */
    (e.left || e.right).parent
  );
  return o._searchMarker && Id(o._searchMarker, e.index, -i + n), e;
};
class mBe extends Wh {
  /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */
  constructor(e, n, i) {
    super(e, n), this.childListChanged = !1, this.keysChanged = /* @__PURE__ */ new Set(), i.forEach((r) => {
      r === null ? this.childListChanged = !0 : this.keysChanged.add(r);
    });
  }
  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    if (this._changes === null) {
      const e = {
        keys: this.keys,
        delta: this.delta,
        added: /* @__PURE__ */ new Set(),
        deleted: /* @__PURE__ */ new Set()
      };
      this._changes = e;
    }
    return (
      /** @type {any} */
      this._changes
    );
  }
  /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */
  get delta() {
    if (this._delta === null) {
      const e = (
        /** @type {Doc} */
        this.target.doc
      ), n = [];
      mt(e, (i) => {
        const r = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Map();
        let o = this.target._start, s = null;
        const l = {};
        let c = "", u = 0, f = 0;
        const m = () => {
          if (s !== null) {
            let h = null;
            switch (s) {
              case "delete":
                f > 0 && (h = { delete: f }), f = 0;
                break;
              case "insert":
                (typeof c == "object" || c.length > 0) && (h = { insert: c }, r.size > 0 && (h.attributes = {}, r.forEach((p, g) => {
                  p !== null && (h.attributes[g] = p);
                }))), c = "";
                break;
              case "retain":
                u > 0 && (h = { retain: u }, QVe(l) || (h.attributes = UVe({}, l))), u = 0;
                break;
            }
            h && n.push(h), s = null;
          }
        };
        for (; o !== null; ) {
          switch (o.content.constructor) {
            case Qi:
            case jo:
              this.adds(o) ? this.deletes(o) || (m(), s = "insert", c = o.content.getContent()[0], m()) : this.deletes(o) ? (s !== "delete" && (m(), s = "delete"), f += 1) : o.deleted || (s !== "retain" && (m(), s = "retain"), u += 1);
              break;
            case Ui:
              this.adds(o) ? this.deletes(o) || (s !== "insert" && (m(), s = "insert"), c += /** @type {ContentString} */
              o.content.str) : this.deletes(o) ? (s !== "delete" && (m(), s = "delete"), f += o.length) : o.deleted || (s !== "retain" && (m(), s = "retain"), u += o.length);
              break;
            case Ut: {
              const { key: h, value: p } = (
                /** @type {ContentFormat} */
                o.content
              );
              if (this.adds(o)) {
                if (!this.deletes(o)) {
                  const g = r.get(h) ?? null;
                  pa(g, p) ? p !== null && o.delete(i) : (s === "retain" && m(), pa(p, a.get(h) ?? null) ? delete l[h] : l[h] = p);
                }
              } else if (this.deletes(o)) {
                a.set(h, p);
                const g = r.get(h) ?? null;
                pa(g, p) || (s === "retain" && m(), l[h] = g);
              } else if (!o.deleted) {
                a.set(h, p);
                const g = l[h];
                g !== void 0 && (pa(g, p) ? g !== null && o.delete(i) : (s === "retain" && m(), p === null ? delete l[h] : l[h] = p));
              }
              o.deleted || (s === "insert" && m(), ll(
                r,
                /** @type {ContentFormat} */
                o.content
              ));
              break;
            }
          }
          o = o.right;
        }
        for (m(); n.length > 0; ) {
          const h = n[n.length - 1];
          if (h.retain !== void 0 && h.attributes === void 0)
            n.pop();
          else
            break;
        }
      }), this._delta = n;
    }
    return (
      /** @type {any} */
      this._delta
    );
  }
}
class Ta extends on {
  /**
   * @param {String} [string] The initial value of the YText.
   */
  constructor(e) {
    super(), this._pending = e !== void 0 ? [() => this.insert(0, e)] : [], this._searchMarker = [], this._hasFormatting = !1;
  }
  /**
   * Number of characters of this text type.
   *
   * @type {number}
   */
  get length() {
    return this.doc ?? kn(), this._length;
  }
  /**
   * @param {Doc} y
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n);
    try {
      this._pending.forEach((i) => i());
    } catch (i) {
      console.error(i);
    }
    this._pending = null;
  }
  _copy() {
    return new Ta();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */
  clone() {
    const e = new Ta();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    super._callObserver(e, n);
    const i = new mBe(this, e, n);
    Lh(this, e, i), !e.local && this._hasFormatting && (e._needFormattingCleanup = !0);
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */
  toString() {
    this.doc ?? kn();
    let e = "", n = this._start;
    for (; n !== null; )
      !n.deleted && n.countable && n.content.constructor === Ui && (e += /** @type {ContentString} */
      n.content.str), n = n.right;
    return e;
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */
  applyDelta(e, { sanitize: n = !0 } = {}) {
    this.doc !== null ? mt(this.doc, (i) => {
      const r = new gy(null, this._start, 0, /* @__PURE__ */ new Map());
      for (let a = 0; a < e.length; a++) {
        const o = e[a];
        if (o.insert !== void 0) {
          const s = !n && typeof o.insert == "string" && a === e.length - 1 && r.right === null && o.insert.slice(-1) === `
` ? o.insert.slice(0, -1) : o.insert;
          (typeof s != "string" || s.length > 0) && wp(i, this, r, s, o.attributes || {});
        } else o.retain !== void 0 ? v4(i, this, r, o.retain, o.attributes || {}) : o.delete !== void 0 && b4(i, r, o.delete);
      }
    }) : this._pending.push(() => this.applyDelta(e));
  }
  /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */
  toDelta(e, n, i) {
    this.doc ?? kn();
    const r = [], a = /* @__PURE__ */ new Map(), o = (
      /** @type {Doc} */
      this.doc
    );
    let s = "", l = this._start;
    function c() {
      if (s.length > 0) {
        const f = {};
        let m = !1;
        a.forEach((p, g) => {
          m = !0, f[g] = p;
        });
        const h = { insert: s };
        m && (h.attributes = f), r.push(h), s = "";
      }
    }
    const u = () => {
      for (; l !== null; ) {
        if (to(l, e) || n !== void 0 && to(l, n))
          switch (l.content.constructor) {
            case Ui: {
              const f = a.get("ychange");
              e !== void 0 && !to(l, e) ? (f === void 0 || f.user !== l.id.client || f.type !== "removed") && (c(), a.set("ychange", i ? i("removed", l.id) : { type: "removed" })) : n !== void 0 && !to(l, n) ? (f === void 0 || f.user !== l.id.client || f.type !== "added") && (c(), a.set("ychange", i ? i("added", l.id) : { type: "added" })) : f !== void 0 && (c(), a.delete("ychange")), s += /** @type {ContentString} */
              l.content.str;
              break;
            }
            case Qi:
            case jo: {
              c();
              const f = {
                insert: l.content.getContent()[0]
              };
              if (a.size > 0) {
                const m = (
                  /** @type {Object<string,any>} */
                  {}
                );
                f.attributes = m, a.forEach((h, p) => {
                  m[p] = h;
                });
              }
              r.push(f);
              break;
            }
            case Ut:
              to(l, e) && (c(), ll(
                a,
                /** @type {ContentFormat} */
                l.content
              ));
              break;
          }
        l = l.right;
      }
      c();
    };
    return e || n ? mt(o, (f) => {
      e && hy(f, e), n && hy(f, n), u();
    }, "cleanup") : u(), r;
  }
  /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */
  insert(e, n, i) {
    if (n.length <= 0)
      return;
    const r = this.doc;
    r !== null ? mt(r, (a) => {
      const o = hu(a, this, e, !i);
      i || (i = {}, o.currentAttributes.forEach((s, l) => {
        i[l] = s;
      })), wp(a, this, o, n, i);
    }) : this._pending.push(() => this.insert(e, n, i));
  }
  /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */
  insertEmbed(e, n, i) {
    const r = this.doc;
    r !== null ? mt(r, (a) => {
      const o = hu(a, this, e, !i);
      wp(a, this, o, n, i || {});
    }) : this._pending.push(() => this.insertEmbed(e, n, i || {}));
  }
  /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */
  delete(e, n) {
    if (n === 0)
      return;
    const i = this.doc;
    i !== null ? mt(i, (r) => {
      b4(r, hu(r, this, e, !0), n);
    }) : this._pending.push(() => this.delete(e, n));
  }
  /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */
  format(e, n, i) {
    if (n === 0)
      return;
    const r = this.doc;
    r !== null ? mt(r, (a) => {
      const o = hu(a, this, e, !1);
      o.right !== null && v4(a, this, o, n, i);
    }) : this._pending.push(() => this.format(e, n, i));
  }
  /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? mt(this.doc, (n) => {
      vm(n, this, e);
    }) : this._pending.push(() => this.removeAttribute(e));
  }
  /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, n) {
    this.doc !== null ? mt(this.doc, (i) => {
      Jb(i, this, e, n);
    }) : this._pending.push(() => this.setAttribute(e, n));
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      Qb(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes() {
    return jN(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(OBe);
  }
}
const hBe = (t) => new Ta();
class kp {
  /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */
  constructor(e, n = () => !0) {
    this._filter = n, this._root = e, this._currentNode = /** @type {Item} */
    e._start, this._firstCall = !0, e.doc ?? kn();
  }
  [Symbol.iterator]() {
    return this;
  }
  /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */
  next() {
    let e = this._currentNode, n = e && e.content && /** @type {any} */
    e.content.type;
    if (e !== null && (!this._firstCall || e.deleted || !this._filter(n)))
      do
        if (n = /** @type {any} */
        e.content.type, !e.deleted && (n.constructor === wn || n.constructor === Po) && n._start !== null)
          e = n._start;
        else
          for (; e !== null; ) {
            const i = e.next;
            if (i !== null) {
              e = i;
              break;
            } else e.parent === this._root ? e = null : e = /** @type {AbstractType<any>} */
            e.parent._item;
          }
      while (e !== null && (e.deleted || !this._filter(
        /** @type {ContentType} */
        e.content.type
      )));
    return this._firstCall = !1, e === null ? { value: void 0, done: !0 } : (this._currentNode = e, { value: (
      /** @type {any} */
      e.content.type
    ), done: !1 });
  }
}
class Po extends on {
  constructor() {
    super(), this._prelimContent = [];
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get firstChild() {
    const e = this._first;
    return e ? e.content.getContent()[0] : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  _copy() {
    return new Po();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */
  clone() {
    const e = new Po();
    return e.insert(0, this.toArray().map((n) => n instanceof on ? n.clone() : n)), e;
  }
  get length() {
    return this.doc ?? kn(), this._prelimContent === null ? this._length : this._prelimContent.length;
  }
  /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */
  createTreeWalker(e) {
    return new kp(this, e);
  }
  /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */
  querySelector(e) {
    e = e.toUpperCase();
    const i = new kp(this, (r) => r.nodeName && r.nodeName.toUpperCase() === e).next();
    return i.done ? null : i.value;
  }
  /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */
  querySelectorAll(e) {
    return e = e.toUpperCase(), Co(new kp(this, (n) => n.nodeName && n.nodeName.toUpperCase() === e));
  }
  /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, n) {
    Lh(this, e, new yBe(this, n, e));
  }
  /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */
  toString() {
    return WN(this, (e) => e.toString()).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, i) {
    const r = e.createDocumentFragment();
    return i !== void 0 && i._createAssociation(r, this), Rd(this, (a) => {
      r.insertBefore(a.toDOM(e, n, i), null);
    }), r;
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insert(e, n) {
    this.doc !== null ? mt(this.doc, (i) => {
      IN(i, this, e, n);
    }) : this._prelimContent.splice(e, 0, ...n);
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insertAfter(e, n) {
    if (this.doc !== null)
      mt(this.doc, (i) => {
        const r = e && e instanceof on ? e._item : e;
        ym(i, this, r, n);
      });
    else {
      const i = (
        /** @type {Array<any>} */
        this._prelimContent
      ), r = e === null ? 0 : i.findIndex((a) => a === e) + 1;
      if (r === 0 && e !== null)
        throw Da("Reference item not found");
      i.splice(r, 0, ...n);
    }
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */
  delete(e, n = 1) {
    this.doc !== null ? mt(this.doc, (i) => {
      RN(i, this, e, n);
    }) : this._prelimContent.splice(e, n);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */
  toArray() {
    return TN(this);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */
  push(e) {
    this.insert(this.length, e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */
  get(e) {
    return AN(this, e);
  }
  /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */
  slice(e = 0, n = this.length) {
    return EN(this, e, n);
  }
  /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    Rd(this, e);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(ABe);
  }
}
const pBe = (t) => new Po();
class wn extends Po {
  constructor(e = "UNDEFINED") {
    super(), this.nodeName = e, this._prelimAttrs = /* @__PURE__ */ new Map();
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, n) {
    super._integrate(e, n), /** @type {Map<string, any>} */
    this._prelimAttrs.forEach((i, r) => {
      this.setAttribute(r, i);
    }), this._prelimAttrs = null;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */
  _copy() {
    return new wn(this.nodeName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */
  clone() {
    const e = new wn(this.nodeName), n = this.getAttributes();
    return JVe(n, (i, r) => {
      typeof i == "string" && e.setAttribute(r, i);
    }), e.insert(0, this.toArray().map((i) => i instanceof on ? i.clone() : i)), e;
  }
  /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */
  toString() {
    const e = this.getAttributes(), n = [], i = [];
    for (const s in e)
      i.push(s);
    i.sort();
    const r = i.length;
    for (let s = 0; s < r; s++) {
      const l = i[s];
      n.push(l + '="' + e[l] + '"');
    }
    const a = this.nodeName.toLocaleLowerCase(), o = n.length > 0 ? " " + n.join(" ") : "";
    return `<${a}${o}>${super.toString()}</${a}>`;
  }
  /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? mt(this.doc, (n) => {
      vm(n, this, e);
    }) : this._prelimAttrs.delete(e);
  }
  /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, n) {
    this.doc !== null ? mt(this.doc, (i) => {
      Jb(i, this, e, n);
    }) : this._prelimAttrs.set(e, n);
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      Qb(this, e)
    );
  }
  /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */
  hasAttribute(e) {
    return (
      /** @type {any} */
      FN(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes(e) {
    return (
      /** @type {any} */
      e ? aBe(this, e) : jN(this)
    );
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, i) {
    const r = e.createElement(this.nodeName), a = this.getAttributes();
    for (const o in a) {
      const s = a[o];
      typeof s == "string" && r.setAttribute(o, s);
    }
    return Rd(this, (o) => {
      r.appendChild(o.toDOM(e, n, i));
    }), i !== void 0 && i._createAssociation(r, this), r;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(WBe), e.writeKey(this.nodeName);
  }
}
const gBe = (t) => new wn(t.readKey());
class yBe extends Wh {
  /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with which the
   *                                  change was created.
   */
  constructor(e, n, i) {
    super(e, i), this.childListChanged = !1, this.attributesChanged = /* @__PURE__ */ new Set(), n.forEach((r) => {
      r === null ? this.childListChanged = !0 : this.attributesChanged.add(r);
    });
  }
}
class bm extends Bs {
  /**
   * @param {string} hookName nodeName of the Dom Node.
   */
  constructor(e) {
    super(), this.hookName = e;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   */
  _copy() {
    return new bm(this.hookName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */
  clone() {
    const e = new bm(this.hookName);
    return this.forEach((n, i) => {
      e.set(i, n);
    }), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n = {}, i) {
    const r = n[this.hookName];
    let a;
    return r !== void 0 ? a = r.createDom(this) : a = document.createElement(this.hookName), a.setAttribute("data-yjs-hook", this.hookName), i !== void 0 && i._createAssociation(a, this), a;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(LBe), e.writeKey(this.hookName);
  }
}
const vBe = (t) => new bm(t.readKey());
class ei extends Ta {
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  _copy() {
    return new ei();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */
  clone() {
    const e = new ei();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, n, i) {
    const r = e.createTextNode(this.toString());
    return i !== void 0 && i._createAssociation(r, this), r;
  }
  toString() {
    return this.toDelta().map((e) => {
      const n = [];
      for (const r in e.attributes) {
        const a = [];
        for (const o in e.attributes[r])
          a.push({ key: o, value: e.attributes[r][o] });
        a.sort((o, s) => o.key < s.key ? -1 : 1), n.push({ nodeName: r, attrs: a });
      }
      n.sort((r, a) => r.nodeName < a.nodeName ? -1 : 1);
      let i = "";
      for (let r = 0; r < n.length; r++) {
        const a = n[r];
        i += `<${a.nodeName}`;
        for (let o = 0; o < a.attrs.length; o++) {
          const s = a.attrs[o];
          i += ` ${s.key}="${s.value}"`;
        }
        i += ">";
      }
      i += e.insert;
      for (let r = n.length - 1; r >= 0; r--)
        i += `</${n[r].nodeName}>`;
      return i;
    }).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(IBe);
  }
}
const bBe = (t) => new ei();
class Zb {
  /**
   * @param {ID} id
   * @param {number} length
   */
  constructor(e, n) {
    this.id = e, this.length = n;
  }
  /**
   * @type {boolean}
   */
  get deleted() {
    throw qi();
  }
  /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */
  write(e, n, i) {
    throw qi();
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    throw qi();
  }
}
const wBe = 0;
class wi extends Zb {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {GC} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    n > 0 && (this.id.clock += n, this.length -= n), MN(e.doc.store, this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeInfo(wBe), e.writeLen(this.length - n);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    return null;
  }
}
class Wc {
  /**
   * @param {Uint8Array} content
   */
  constructor(e) {
    this.content = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.content];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentBinary}
   */
  copy() {
    return new Wc(this.content);
  }
  /**
   * @param {number} offset
   * @return {ContentBinary}
   */
  splice(e) {
    throw qi();
  }
  /**
   * @param {ContentBinary} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeBuf(this.content);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 3;
  }
}
const kBe = (t) => new Wc(t.readBuf());
class jd {
  /**
   * @param {number} len
   */
  constructor(e) {
    this.len = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.len;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentDeleted}
   */
  copy() {
    return new jd(this.len);
  }
  /**
   * @param {number} offset
   * @return {ContentDeleted}
   */
  splice(e) {
    const n = new jd(this.len - e);
    return this.len = e, n;
  }
  /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.len += e.len, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    Wd(e.deleteSet, n.id.client, n.id.clock, this.len), n.markDeleted();
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeLen(this.len - n);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 1;
  }
}
const xBe = (t) => new jd(t.readLen()), qN = (t, e) => new Ro({ guid: t, ...e, shouldLoad: e.shouldLoad || e.autoLoad || !1 });
class Ac {
  /**
   * @param {Doc} doc
   */
  constructor(e) {
    e._item && console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid."), this.doc = e;
    const n = {};
    this.opts = n, e.gc || (n.gc = !1), e.autoLoad && (n.autoLoad = !0), e.meta !== null && (n.meta = e.meta);
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.doc];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentDoc}
   */
  copy() {
    return new Ac(qN(this.doc.guid, this.opts));
  }
  /**
   * @param {number} offset
   * @return {ContentDoc}
   */
  splice(e) {
    throw qi();
  }
  /**
   * @param {ContentDoc} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    this.doc._item = n, e.subdocsAdded.add(this.doc), this.doc.shouldLoad && e.subdocsLoaded.add(this.doc);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    e.subdocsAdded.has(this.doc) ? e.subdocsAdded.delete(this.doc) : e.subdocsRemoved.add(this.doc);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeString(this.doc.guid), e.writeAny(this.opts);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 9;
  }
}
const _Be = (t) => new Ac(qN(t.readString(), t.readAny()));
class jo {
  /**
   * @param {Object} embed
   */
  constructor(e) {
    this.embed = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.embed];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentEmbed}
   */
  copy() {
    return new jo(this.embed);
  }
  /**
   * @param {number} offset
   * @return {ContentEmbed}
   */
  splice(e) {
    throw qi();
  }
  /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeJSON(this.embed);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 5;
  }
}
const MBe = (t) => new jo(t.readJSON());
class Ut {
  /**
   * @param {string} key
   * @param {Object} value
   */
  constructor(e, n) {
    this.key = e, this.value = n;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentFormat}
   */
  copy() {
    return new Ut(this.key, this.value);
  }
  /**
   * @param {number} _offset
   * @return {ContentFormat}
   */
  splice(e) {
    throw qi();
  }
  /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */
  integrate(e, n) {
    const i = (
      /** @type {YText} */
      n.parent
    );
    i._searchMarker = null, i._hasFormatting = !0;
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeKey(this.key), e.writeJSON(this.value);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 6;
  }
}
const CBe = (t) => new Ut(t.readKey(), t.readJSON());
class wm {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentJSON}
   */
  copy() {
    return new wm(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentJSON}
   */
  splice(e) {
    const n = new wm(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), n;
  }
  /**
   * @param {ContentJSON} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    const i = this.arr.length;
    e.writeLen(i - n);
    for (let r = n; r < i; r++) {
      const a = this.arr[r];
      e.writeString(a === void 0 ? "undefined" : JSON.stringify(a));
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 2;
  }
}
const PBe = (t) => {
  const e = t.readLen(), n = [];
  for (let i = 0; i < e; i++) {
    const r = t.readString();
    r === "undefined" ? n.push(void 0) : n.push(JSON.parse(r));
  }
  return new wm(n);
}, SBe = hm("node_env") === "development";
class So {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e, SBe && sN(e);
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentAny}
   */
  copy() {
    return new So(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentAny}
   */
  splice(e) {
    const n = new So(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), n;
  }
  /**
   * @param {ContentAny} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    const i = this.arr.length;
    e.writeLen(i - n);
    for (let r = n; r < i; r++) {
      const a = this.arr[r];
      e.writeAny(a);
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 8;
  }
}
const NBe = (t) => {
  const e = t.readLen(), n = [];
  for (let i = 0; i < e; i++)
    n.push(t.readAny());
  return new So(n);
};
class Ui {
  /**
   * @param {string} str
   */
  constructor(e) {
    this.str = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.str.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.str.split("");
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentString}
   */
  copy() {
    return new Ui(this.str);
  }
  /**
   * @param {number} offset
   * @return {ContentString}
   */
  splice(e) {
    const n = new Ui(this.str.slice(e));
    this.str = this.str.slice(0, e);
    const i = this.str.charCodeAt(e - 1);
    return i >= 55296 && i <= 56319 && (this.str = this.str.slice(0, e - 1) + "�", n.str = "�" + n.str.slice(1)), n;
  }
  /**
   * @param {ContentString} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.str += e.str, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeString(n === 0 ? this.str : this.str.slice(n));
  }
  /**
   * @return {number}
   */
  getRef() {
    return 4;
  }
}
const $Be = (t) => new Ui(t.readString()), DBe = [
  sBe,
  dBe,
  hBe,
  gBe,
  pBe,
  vBe,
  bBe
], EBe = 0, TBe = 1, OBe = 2, WBe = 3, ABe = 4, LBe = 5, IBe = 6;
class Qi {
  /**
   * @param {AbstractType<any>} type
   */
  constructor(e) {
    this.type = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.type];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentType}
   */
  copy() {
    return new Qi(this.type._copy());
  }
  /**
   * @param {number} offset
   * @return {ContentType}
   */
  splice(e) {
    throw qi();
  }
  /**
   * @param {ContentType} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, n) {
    this.type._integrate(e.doc, n);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    let n = this.type._start;
    for (; n !== null; )
      n.deleted ? n.id.clock < (e.beforeState.get(n.id.client) || 0) && e._mergeStructs.push(n) : n.delete(e), n = n.right;
    this.type._map.forEach((i) => {
      i.deleted ? i.id.clock < (e.beforeState.get(i.id.client) || 0) && e._mergeStructs.push(i) : i.delete(e);
    }), e.changed.delete(this.type);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
    let n = this.type._start;
    for (; n !== null; )
      n.gc(e, !0), n = n.right;
    this.type._start = null, this.type._map.forEach(
      /** @param {Item | null} item */
      (i) => {
        for (; i !== null; )
          i.gc(e, !0), i = i.left;
      }
    ), this.type._map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    this.type._write(e);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 7;
  }
}
const RBe = (t) => new Qi(DBe[t.readTypeRef()](t)), yy = (t, e) => {
  let n = e, i = 0, r;
  do
    i > 0 && (n = Ye(n.client, n.clock + i)), r = ps(t, n), i = n.clock - r.id.clock, n = r.redone;
  while (n !== null && r instanceof vt);
  return {
    item: r,
    diff: i
  };
}, ew = (t, e) => {
  for (; t !== null && t.keep !== e; )
    t.keep = e, t = /** @type {AbstractType<any>} */
    t.parent._item;
}, km = (t, e, n) => {
  const { client: i, clock: r } = e.id, a = new vt(
    Ye(i, r + n),
    e,
    Ye(i, r + n - 1),
    e.right,
    e.rightOrigin,
    e.parent,
    e.parentSub,
    e.content.splice(n)
  );
  return e.deleted && a.markDeleted(), e.keep && (a.keep = !0), e.redone !== null && (a.redone = Ye(e.redone.client, e.redone.clock + n)), e.right = a, a.right !== null && (a.right.left = a), t._mergeStructs.push(a), a.parentSub !== null && a.right === null && a.parent._map.set(a.parentSub, a), e.length = n, a;
}, w4 = (t, e) => dVe(
  t,
  /** @param {StackItem} s */
  (n) => sl(n.deletions, e)
), GN = (t, e, n, i, r, a) => {
  const o = t.doc, s = o.store, l = o.clientID, c = e.redone;
  if (c !== null)
    return Yn(t, c);
  let u = (
    /** @type {AbstractType<any>} */
    e.parent._item
  ), f = null, m;
  if (u !== null && u.deleted === !0) {
    if (u.redone === null && (!n.has(u) || GN(t, u, n, i, r, a) === null))
      return null;
    for (; u.redone !== null; )
      u = Yn(t, u.redone);
  }
  const h = u === null ? (
    /** @type {AbstractType<any>} */
    e.parent
  ) : (
    /** @type {ContentType} */
    u.content.type
  );
  if (e.parentSub === null) {
    for (f = e.left, m = e; f !== null; ) {
      let v = f;
      for (; v !== null && /** @type {AbstractType<any>} */
      v.parent._item !== u; )
        v = v.redone === null ? null : Yn(t, v.redone);
      if (v !== null && /** @type {AbstractType<any>} */
      v.parent._item === u) {
        f = v;
        break;
      }
      f = f.left;
    }
    for (; m !== null; ) {
      let v = m;
      for (; v !== null && /** @type {AbstractType<any>} */
      v.parent._item !== u; )
        v = v.redone === null ? null : Yn(t, v.redone);
      if (v !== null && /** @type {AbstractType<any>} */
      v.parent._item === u) {
        m = v;
        break;
      }
      m = m.right;
    }
  } else if (m = null, e.right && !r) {
    for (f = e; f !== null && f.right !== null && (f.right.redone || sl(i, f.right.id) || w4(a.undoStack, f.right.id) || w4(a.redoStack, f.right.id)); )
      for (f = f.right; f.redone; ) f = Yn(t, f.redone);
    if (f && f.right !== null)
      return null;
  } else
    f = h._map.get(e.parentSub) || null;
  const p = Vt(s, l), g = Ye(l, p), y = new vt(
    g,
    f,
    f && f.lastId,
    m,
    m && m.id,
    h,
    e.parentSub,
    e.content.copy()
  );
  return e.redone = g, ew(y, !0), y.integrate(t, 0), y;
};
let vt = class vy extends Zb {
  /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */
  constructor(e, n, i, r, a, o, s, l) {
    super(e, l.getLength()), this.origin = i, this.left = n, this.right = r, this.rightOrigin = a, this.parent = o, this.parentSub = s, this.redone = null, this.content = l, this.info = this.content.isCountable() ? U3 : 0;
  }
  /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */
  set marker(e) {
    (this.info & hp) > 0 !== e && (this.info ^= hp);
  }
  get marker() {
    return (this.info & hp) > 0;
  }
  /**
   * If true, do not garbage collect this Item.
   */
  get keep() {
    return (this.info & K3) > 0;
  }
  set keep(e) {
    this.keep !== e && (this.info ^= K3);
  }
  get countable() {
    return (this.info & U3) > 0;
  }
  /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */
  get deleted() {
    return (this.info & mp) > 0;
  }
  set deleted(e) {
    this.deleted !== e && (this.info ^= mp);
  }
  markDeleted() {
    this.info |= mp;
  }
  /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= Vt(n, this.origin.client))
      return this.origin.client;
    if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= Vt(n, this.rightOrigin.client))
      return this.rightOrigin.client;
    if (this.parent && this.parent.constructor === hs && this.id.client !== this.parent.client && this.parent.clock >= Vt(n, this.parent.client))
      return this.parent.client;
    if (this.origin && (this.left = c4(e, n, this.origin), this.origin = this.left.lastId), this.rightOrigin && (this.right = Yn(e, this.rightOrigin), this.rightOrigin = this.right.id), this.left && this.left.constructor === wi || this.right && this.right.constructor === wi)
      this.parent = null;
    else if (!this.parent)
      this.left && this.left.constructor === vy ? (this.parent = this.left.parent, this.parentSub = this.left.parentSub) : this.right && this.right.constructor === vy && (this.parent = this.right.parent, this.parentSub = this.right.parentSub);
    else if (this.parent.constructor === hs) {
      const i = ps(n, this.parent);
      i.constructor === wi ? this.parent = null : this.parent = /** @type {ContentType} */
      i.content.type;
    }
    return null;
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    if (n > 0 && (this.id.clock += n, this.left = c4(e, e.doc.store, Ye(this.id.client, this.id.clock - 1)), this.origin = this.left.lastId, this.content = this.content.splice(n), this.length -= n), this.parent) {
      if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
        let i = this.left, r;
        if (i !== null)
          r = i.right;
        else if (this.parentSub !== null)
          for (r = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; r !== null && r.left !== null; )
            r = r.left;
        else
          r = /** @type {AbstractType<any>} */
          this.parent._start;
        const a = /* @__PURE__ */ new Set(), o = /* @__PURE__ */ new Set();
        for (; r !== null && r !== this.right; ) {
          if (o.add(r), a.add(r), uu(this.origin, r.origin)) {
            if (r.id.client < this.id.client)
              i = r, a.clear();
            else if (uu(this.rightOrigin, r.rightOrigin))
              break;
          } else if (r.origin !== null && o.has(ps(e.doc.store, r.origin)))
            a.has(ps(e.doc.store, r.origin)) || (i = r, a.clear());
          else
            break;
          r = r.right;
        }
        this.left = i;
      }
      if (this.left !== null) {
        const i = this.left.right;
        this.right = i, this.left.right = this;
      } else {
        let i;
        if (this.parentSub !== null)
          for (i = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; i !== null && i.left !== null; )
            i = i.left;
        else
          i = /** @type {AbstractType<any>} */
          this.parent._start, this.parent._start = this;
        this.right = i;
      }
      this.right !== null ? this.right.left = this : this.parentSub !== null && (this.parent._map.set(this.parentSub, this), this.left !== null && this.left.delete(e)), this.parentSub === null && this.countable && !this.deleted && (this.parent._length += this.length), MN(e.doc.store, this), this.content.integrate(e, this), f4(
        e,
        /** @type {AbstractType<any>} */
        this.parent,
        this.parentSub
      ), /** @type {AbstractType<any>} */
      (this.parent._item !== null && /** @type {AbstractType<any>} */
      this.parent._item.deleted || this.parentSub !== null && this.right !== null) && this.delete(e);
    } else
      new wi(this.id, this.length).integrate(e, 0);
  }
  /**
   * Returns the next non-deleted item
   */
  get next() {
    let e = this.right;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Returns the previous non-deleted item
   */
  get prev() {
    let e = this.left;
    for (; e !== null && e.deleted; )
      e = e.left;
    return e;
  }
  /**
   * Computes the last content address of this Item.
   */
  get lastId() {
    return this.length === 1 ? this.id : Ye(this.id.client, this.id.clock + this.length - 1);
  }
  /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */
  mergeWith(e) {
    if (this.constructor === e.constructor && uu(e.origin, this.lastId) && this.right === e && uu(this.rightOrigin, e.rightOrigin) && this.id.client === e.id.client && this.id.clock + this.length === e.id.clock && this.deleted === e.deleted && this.redone === null && e.redone === null && this.content.constructor === e.content.constructor && this.content.mergeWith(e.content)) {
      const n = (
        /** @type {AbstractType<any>} */
        this.parent._searchMarker
      );
      return n && n.forEach((i) => {
        i.p === e && (i.p = this, !this.deleted && this.countable && (i.index -= this.length));
      }), e.keep && (this.keep = !0), this.right = e.right, this.right !== null && (this.right.left = this), this.length += e.length, !0;
    }
    return !1;
  }
  /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */
  delete(e) {
    if (!this.deleted) {
      const n = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      this.countable && this.parentSub === null && (n._length -= this.length), this.markDeleted(), Wd(e.deleteSet, this.id.client, this.id.clock, this.length), f4(e, n, this.parentSub), this.content.delete(e);
    }
  }
  /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */
  gc(e, n) {
    if (!this.deleted)
      throw ri();
    this.content.gc(e), n ? HHe(e, this, new wi(this.id, this.length)) : this.content = new jd(this.length);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */
  write(e, n) {
    const i = n > 0 ? Ye(this.id.client, this.id.clock + n - 1) : this.origin, r = this.rightOrigin, a = this.parentSub, o = this.content.getRef() & $h | (i === null ? 0 : Ln) | // origin is defined
    (r === null ? 0 : Ar) | // right origin is defined
    (a === null ? 0 : Ed);
    if (e.writeInfo(o), i !== null && e.writeLeftID(i), r !== null && e.writeRightID(r), i === null && r === null) {
      const s = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      if (s._item !== void 0) {
        const l = s._item;
        if (l === null) {
          const c = Ad(s);
          e.writeParentInfo(!0), e.writeString(c);
        } else
          e.writeParentInfo(!1), e.writeLeftID(l.id);
      } else s.constructor === String ? (e.writeParentInfo(!0), e.writeString(s)) : s.constructor === hs ? (e.writeParentInfo(!1), e.writeLeftID(s)) : ri();
      a !== null && e.writeString(a);
    }
    this.content.write(e, n);
  }
};
const XN = (t, e) => jBe[e & $h](t), jBe = [
  () => {
    ri();
  },
  // GC is not ItemContent
  xBe,
  // 1
  PBe,
  // 2
  kBe,
  // 3
  $Be,
  // 4
  MBe,
  // 5
  CBe,
  // 6
  RBe,
  // 7
  NBe,
  // 8
  _Be,
  // 9
  () => {
    ri();
  }
  // 10 - Skip is not ItemContent
], FBe = 10;
class zi extends Zb {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {Skip} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, n) {
    ri();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, n) {
    e.writeInfo(FBe), nt(e.restEncoder, this.length - n);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, n) {
    return null;
  }
}
const YN = (
  /** @type {any} */
  typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : {}
), KN = "__ $YJS$ __";
YN[KN] === !0 && console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
YN[KN] = !0;
const zBe = () => {
  let t = !0;
  return (e, n) => {
    if (t) {
      t = !1;
      try {
        e();
      } finally {
        t = !0;
      }
    } else n !== void 0 && n();
  };
}, VBe = /[\uD800-\uDBFF]/, HBe = /[\uDC00-\uDFFF]/, BBe = (t, e) => {
  let n = 0, i = 0;
  for (; n < t.length && n < e.length && t[n] === e[n]; )
    n++;
  for (n > 0 && VBe.test(t[n - 1]) && n--; i + n < t.length && i + n < e.length && t[t.length - i - 1] === e[e.length - i - 1]; )
    i++;
  return i > 0 && HBe.test(t[t.length - i]) && i--, {
    index: n,
    remove: t.length - n - i,
    insert: e.slice(n, e.length - i)
  };
}, qBe = BBe, Ot = new yt("y-sync"), Lr = new yt("y-undo");
new yt("yjs-cursor");
const fr = (t, e) => t >>> e | t << 32 - e, GBe = (t) => fr(t, 2) ^ fr(t, 13) ^ fr(t, 22), XBe = (t) => fr(t, 6) ^ fr(t, 11) ^ fr(t, 25), YBe = (t) => fr(t, 7) ^ fr(t, 18) ^ t >>> 3, KBe = (t) => fr(t, 17) ^ fr(t, 19) ^ t >>> 10, UBe = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), JBe = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]);
class QBe {
  constructor() {
    const e = new ArrayBuffer(320);
    this._H = new Uint32Array(e, 0, 8), this._H.set(JBe), this._W = new Uint32Array(e, 64, 64);
  }
  _updateHash() {
    const e = this._H, n = this._W;
    for (let f = 16; f < 64; f++)
      n[f] = KBe(n[f - 2]) + n[f - 7] + YBe(n[f - 15]) + n[f - 16];
    let i = e[0], r = e[1], a = e[2], o = e[3], s = e[4], l = e[5], c = e[6], u = e[7];
    for (let f = 0, m, h; f < 64; f++)
      m = u + XBe(s) + (s & l ^ ~s & c) + UBe[f] + n[f] >>> 0, h = GBe(i) + (i & r ^ i & a ^ r & a) >>> 0, u = c, c = l, l = s, s = o + m >>> 0, o = a, a = r, r = i, i = m + h >>> 0;
    e[0] += i, e[1] += r, e[2] += a, e[3] += o, e[4] += s, e[5] += l, e[6] += c, e[7] += u;
  }
  /**
   * Returns a 32-byte hash.
   *
   * @param {Uint8Array} data
   */
  digest(e) {
    let n = 0;
    for (; n + 56 <= e.length; ) {
      let o = 0;
      for (; o < 16 && n + 3 < e.length; o++)
        this._W[o] = e[n++] << 24 | e[n++] << 16 | e[n++] << 8 | e[n++];
      if (n % 64 !== 0) {
        for (this._W.fill(0, o, 16); n < e.length; )
          this._W[o] |= e[n] << (3 - n % 4) * 8, n++;
        this._W[o] |= Ln << (3 - n % 4) * 8;
      }
      this._updateHash();
    }
    const i = n % 64 !== 0;
    this._W.fill(0, 0, 16);
    let r = 0;
    for (; n < e.length; r++)
      for (let o = 3; o >= 0 && n < e.length; o--)
        this._W[r] |= e[n++] << o * 8;
    i || (this._W[r - (n % 4 === 0 ? 0 : 1)] |= Ln << (3 - n % 4) * 8), this._W[14] = e.byteLength / cVe, this._W[15] = e.byteLength * 8, this._updateHash();
    const a = new Uint8Array(32);
    for (let o = 0; o < this._H.length; o++)
      for (let s = 0; s < 4; s++)
        a[o * 4 + s] = this._H[o] >>> (3 - s) * 8;
    return a;
  }
}
const ZBe = (t) => new QBe().digest(t), eqe = (t) => {
  for (let n = 6; n < t.length; n++)
    t[n % 6] = t[n % 6] ^ t[n];
  return t.slice(0, 6);
}, tqe = (t) => lHe(eqe(ZBe(dHe(t)))), xm = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && /** @type {number} */
e.sv.get(t.id.client) > t.id.clock && !sl(e.ds, t.id), nqe = [{ light: "#ecd44433", dark: "#ecd444" }], iqe = (t, e, n) => {
  if (!t.has(n)) {
    if (t.size < e.length) {
      const i = Mo();
      t.forEach((r) => i.add(r)), e = e.filter((r) => !i.has(r));
    }
    t.set(n, HVe(e));
  }
  return (
    /** @type {ColorDef} */
    t.get(n)
  );
}, rqe = (t, {
  colors: e = nqe,
  colorMapping: n = /* @__PURE__ */ new Map(),
  permanentUserData: i = null,
  onFirstRender: r = () => {
  },
  mapping: a
} = {}) => {
  let o = !1;
  const s = new oqe(t, a), l = new ft({
    props: {
      editable: (c) => {
        const u = Ot.getState(c);
        return u.snapshot == null && u.prevSnapshot == null;
      }
    },
    key: Ot,
    state: {
      /**
       * @returns {any}
       */
      init: (c, u) => ({
        type: t,
        doc: t.doc,
        binding: s,
        snapshot: null,
        prevSnapshot: null,
        isChangeOrigin: !1,
        isUndoRedoOperation: !1,
        addToHistory: !0,
        colors: e,
        colorMapping: n,
        permanentUserData: i
      }),
      apply: (c, u) => {
        const f = c.getMeta(Ot);
        if (f !== void 0) {
          u = Object.assign({}, u);
          for (const m in f)
            u[m] = f[m];
        }
        return u.addToHistory = c.getMeta("addToHistory") !== !1, u.isChangeOrigin = f !== void 0 && !!f.isChangeOrigin, u.isUndoRedoOperation = f !== void 0 && !!f.isChangeOrigin && !!f.isUndoRedoOperation, s.prosemirrorView !== null && f !== void 0 && (f.snapshot != null || f.prevSnapshot != null) && cN(0, () => {
          s.prosemirrorView != null && (f.restore == null ? s._renderSnapshot(
            f.snapshot,
            f.prevSnapshot,
            u
          ) : (s._renderSnapshot(
            f.snapshot,
            f.snapshot,
            u
          ), delete u.restore, delete u.snapshot, delete u.prevSnapshot, s.mux(() => {
            s._prosemirrorChanged(
              s.prosemirrorView.state.doc
            );
          })));
        }), u;
      }
    },
    view: (c) => (s.initView(c), a == null && s._forceRerender(), r(), {
      update: () => {
        const u = l.getState(c.state);
        if (u.snapshot == null && u.prevSnapshot == null && // If the content doesn't change initially, we don't render anything to Yjs
        // If the content was cleared by a user action, we want to catch the change and
        // represent it in Yjs
        (o || c.state.doc.content.findDiffStart(
          c.state.doc.type.createAndFill().content
        ) !== null)) {
          if (o = !0, u.addToHistory === !1 && !u.isChangeOrigin) {
            const f = Lr.getState(c.state), m = f && f.undoManager;
            m && m.stopCapturing();
          }
          s.mux(() => {
            u.doc.transact((f) => {
              f.meta.set("addToHistory", u.addToHistory), s._prosemirrorChanged(c.state.doc);
            }, Ot);
          });
        }
      },
      destroy: () => {
        s.destroy();
      }
    })
  });
  return l;
}, aqe = (t, e, n) => {
  if (e !== null && e.anchor !== null && e.head !== null)
    if (e.type === "all")
      t.setSelection(new Un(t.doc));
    else if (e.type === "node") {
      const i = Vu(
        n.doc,
        n.type,
        e.anchor,
        n.mapping
      );
      t.setSelection(Ae.create(t.doc, i));
    } else {
      const i = Vu(
        n.doc,
        n.type,
        e.anchor,
        n.mapping
      ), r = Vu(
        n.doc,
        n.type,
        e.head,
        n.mapping
      );
      if (i !== null && r !== null) {
        const a = Fe.between(t.doc.resolve(i), t.doc.resolve(r));
        t.setSelection(a);
      }
    }
}, by = (t, e) => ({
  type: (
    /** @type {any} */
    e.selection.jsonID
  ),
  anchor: _y(
    e.selection.anchor,
    t.type,
    t.mapping
  ),
  head: _y(
    e.selection.head,
    t.type,
    t.mapping
  )
});
class oqe {
  /**
   * @param {Y.XmlFragment} yXmlFragment The bind source
   * @param {ProsemirrorMapping} mapping
   */
  constructor(e, n = /* @__PURE__ */ new Map()) {
    this.type = e, this.prosemirrorView = null, this.mux = zBe(), this.mapping = n, this.isOMark = /* @__PURE__ */ new Map(), this._observeFunction = this._typeChanged.bind(this), this.doc = e.doc, this.beforeTransactionSelection = null, this.beforeAllTransactions = () => {
      this.beforeTransactionSelection === null && this.prosemirrorView != null && (this.beforeTransactionSelection = by(
        this,
        this.prosemirrorView.state
      ));
    }, this.afterAllTransactions = () => {
      this.beforeTransactionSelection = null;
    }, this._domSelectionInView = null;
  }
  /**
   * Create a transaction for changing the prosemirror state.
   *
   * @returns
   */
  get _tr() {
    return this.prosemirrorView.state.tr.setMeta("addToHistory", !1);
  }
  _isLocalCursorInView() {
    return this.prosemirrorView.hasFocus() ? (lN && this._domSelectionInView === null && (cN(0, () => {
      this._domSelectionInView = null;
    }), this._domSelectionInView = this._isDomSelectionInView()), this._domSelectionInView) : !1;
  }
  _isDomSelectionInView() {
    const e = this.prosemirrorView._root.getSelection();
    if (e == null || e.anchorNode == null) return !1;
    const n = this.prosemirrorView._root.createRange();
    n.setStart(e.anchorNode, e.anchorOffset), n.setEnd(e.focusNode, e.focusOffset), n.getClientRects().length === 0 && n.startContainer && n.collapsed && n.selectNodeContents(n.startContainer);
    const r = n.getBoundingClientRect(), a = uHe.documentElement;
    return r.bottom >= 0 && r.right >= 0 && r.left <= (window.innerWidth || a.clientWidth || 0) && r.top <= (window.innerHeight || a.clientHeight || 0);
  }
  /**
   * @param {Y.Snapshot} snapshot
   * @param {Y.Snapshot} prevSnapshot
   */
  renderSnapshot(e, n) {
    n || (n = xN(vN(), /* @__PURE__ */ new Map())), this.prosemirrorView.dispatch(
      this._tr.setMeta(Ot, { snapshot: e, prevSnapshot: n })
    );
  }
  unrenderSnapshot() {
    this.mapping.clear(), this.mux(() => {
      const e = this.type.toArray().map(
        (i) => zu(
          /** @type {Y.XmlElement} */
          i,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((i) => i !== null), n = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new ye(ee.from(e), 0, 0)
      );
      n.setMeta(Ot, { snapshot: null, prevSnapshot: null }), this.prosemirrorView.dispatch(n);
    });
  }
  _forceRerender() {
    this.mapping.clear(), this.mux(() => {
      const e = this.beforeTransactionSelection !== null ? null : this.prosemirrorView.state.selection, n = this.type.toArray().map(
        (r) => zu(
          /** @type {Y.XmlElement} */
          r,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((r) => r !== null), i = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new ye(ee.from(n), 0, 0)
      );
      if (e) {
        const r = zs($a(e.anchor, 0), i.doc.content.size), a = zs($a(e.head, 0), i.doc.content.size);
        i.setSelection(Fe.create(i.doc, r, a));
      }
      this.prosemirrorView.dispatch(
        i.setMeta(Ot, { isChangeOrigin: !0, binding: this })
      );
    });
  }
  /**
   * @param {Y.Snapshot|Uint8Array} snapshot
   * @param {Y.Snapshot|Uint8Array} prevSnapshot
   * @param {Object} pluginState
   */
  _renderSnapshot(e, n, i) {
    let r = this.doc, a = this.type;
    if (e || (e = bp(this.doc)), e instanceof Uint8Array || n instanceof Uint8Array)
      if ((!(e instanceof Uint8Array) || !(n instanceof Uint8Array)) && ri(), r = new Ro({ gc: !1 }), my(r, n), n = bp(r), my(r, e), e = bp(r), a._item === null) {
        const o = Array.from(this.doc.share.keys()).find(
          (s) => this.doc.share.get(s) === this.type
        );
        a = r.getXmlFragment(o);
      } else {
        const o = r.store.clients.get(a._item.id.client) ?? [], s = Ki(
          o,
          a._item.id.clock
        );
        a = /** @type {Y.XmlFragment} */
        /** @type {Y.ContentType} */
        /** @type {Y.Item} */
        o[s].content.type;
      }
    this.mapping.clear(), this.mux(() => {
      r.transact((o) => {
        const s = i.permanentUserData;
        s && s.dss.forEach((f) => {
          Ea(o, f, (m) => {
          });
        });
        const l = (f, m) => {
          const h = f === "added" ? s.getUserByClientId(m.client) : s.getUserByDeletedId(m);
          return {
            user: h,
            type: f,
            color: iqe(
              i.colorMapping,
              i.colors,
              h
            )
          };
        }, c = ON(
          a,
          new Kb(n.ds, e.sv)
        ).map((f) => !f._item.deleted || xm(f._item, e) || xm(f._item, n) ? zu(
          f,
          this.prosemirrorView.state.schema,
          { mapping: /* @__PURE__ */ new Map(), isOMark: /* @__PURE__ */ new Map() },
          e,
          n,
          l
        ) : null).filter((f) => f !== null), u = this._tr.replace(
          0,
          this.prosemirrorView.state.doc.content.size,
          new ye(ee.from(c), 0, 0)
        );
        this.prosemirrorView.dispatch(
          u.setMeta(Ot, { isChangeOrigin: !0 })
        );
      }, Ot);
    });
  }
  /**
   * @param {Array<Y.YEvent<any>>} events
   * @param {Y.Transaction} transaction
   */
  _typeChanged(e, n) {
    if (this.prosemirrorView == null) return;
    const i = Ot.getState(this.prosemirrorView.state);
    if (e.length === 0 || i.snapshot != null || i.prevSnapshot != null) {
      this.renderSnapshot(i.snapshot, i.prevSnapshot);
      return;
    }
    this.mux(() => {
      const r = (s, l) => this.mapping.delete(l);
      Ea(
        n,
        n.deleteSet,
        (s) => {
          if (s.constructor === vt) {
            const l = (
              /** @type {Y.ContentType} */
              /** @type {Y.Item} */
              s.content.type
            );
            l && this.mapping.delete(l);
          }
        }
      ), n.changed.forEach(r), n.changedParentTypes.forEach(r);
      const a = this.type.toArray().map(
        (s) => UN(
          /** @type {Y.XmlElement | Y.XmlHook} */
          s,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((s) => s !== null);
      let o = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new ye(ee.from(a), 0, 0)
      );
      aqe(o, this.beforeTransactionSelection, this), o = o.setMeta(Ot, { isChangeOrigin: !0, isUndoRedoOperation: n.origin instanceof SN }), this.beforeTransactionSelection !== null && this._isLocalCursorInView() && o.scrollIntoView(), this.prosemirrorView.dispatch(o);
    });
  }
  /**
   * @param {import('prosemirror-model').Node} doc
   */
  _prosemirrorChanged(e) {
    this.doc.transact(() => {
      ky(this.doc, this.type, e, this), this.beforeTransactionSelection = by(
        this,
        this.prosemirrorView.state
      );
    }, Ot);
  }
  /**
   * View is ready to listen to changes. Register observers.
   * @param {any} prosemirrorView
   */
  initView(e) {
    this.prosemirrorView != null && this.destroy(), this.prosemirrorView = e, this.doc.on("beforeAllTransactions", this.beforeAllTransactions), this.doc.on("afterAllTransactions", this.afterAllTransactions), this.type.observeDeep(this._observeFunction);
  }
  destroy() {
    this.prosemirrorView != null && (this.prosemirrorView = null, this.type.unobserveDeep(this._observeFunction), this.doc.off("beforeAllTransactions", this.beforeAllTransactions), this.doc.off("afterAllTransactions", this.afterAllTransactions));
  }
}
const UN = (t, e, n, i, r, a) => {
  const o = (
    /** @type {PModel.Node} */
    n.mapping.get(t)
  );
  if (o === void 0) {
    if (t instanceof wn)
      return zu(
        t,
        e,
        n,
        i,
        r,
        a
      );
    throw qi();
  }
  return o;
}, zu = (t, e, n, i, r, a) => {
  const o = [], s = (l) => {
    var c, u;
    if (l instanceof wn) {
      const f = UN(
        l,
        e,
        n,
        i,
        r,
        a
      );
      f !== null && o.push(f);
    } else {
      const f = (
        /** @type {Y.ContentType} */
        (u = (c = l._item.right) == null ? void 0 : c.content) == null ? void 0 : u.type
      );
      f instanceof Ta && !f._item.deleted && f._item.id.client === f.doc.clientID && (l.applyDelta([
        { retain: l.length },
        ...f.toDelta()
      ]), f.doc.transact((h) => {
        f._item.delete(h);
      }));
      const m = sqe(
        l,
        e,
        n,
        i,
        r,
        a
      );
      m !== null && m.forEach((h) => {
        h !== null && o.push(h);
      });
    }
  };
  i === void 0 || r === void 0 ? t.toArray().forEach(s) : ON(t, new Kb(r.ds, i.sv)).forEach(s);
  try {
    const l = t.getAttributes(i);
    i !== void 0 && (xm(
      /** @type {Y.Item} */
      t._item,
      i
    ) ? xm(
      /** @type {Y.Item} */
      t._item,
      r
    ) || (l.ychange = a ? a(
      "added",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "added" }) : l.ychange = a ? a(
      "removed",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "removed" });
    const c = e.node(t.nodeName, l, o);
    return n.mapping.set(t, c), c;
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, Ot), n.mapping.delete(t), null;
  }
}, sqe = (t, e, n, i, r, a) => {
  const o = [], s = t.toDelta(i, r, a);
  try {
    for (let l = 0; l < s.length; l++) {
      const c = s[l];
      o.push(e.text(c.insert, mqe(c.attributes, e)));
    }
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, Ot), null;
  }
  return o;
}, lqe = (t, e) => {
  const n = new ei(), i = t.map((r) => ({
    // @ts-ignore
    insert: r.text,
    attributes: QN(r.marks, e)
  }));
  return n.applyDelta(i), e.mapping.set(n, t), n;
}, dqe = (t, e) => {
  const n = new wn(t.type.name);
  for (const i in t.attrs) {
    const r = t.attrs[i];
    r !== null && i !== "ychange" && n.setAttribute(i, r);
  }
  return n.insert(
    0,
    Ih(t).map(
      (i) => wy(i, e)
    )
  ), e.mapping.set(n, t), n;
}, wy = (t, e) => t instanceof Array ? lqe(t, e) : dqe(t, e), k4 = (t) => typeof t == "object" && t !== null, tw = (t, e) => {
  const n = Object.keys(t).filter((r) => t[r] !== null);
  let i = n.length === (e == null ? 0 : Object.keys(e).filter((r) => e[r] !== null).length);
  for (let r = 0; r < n.length && i; r++) {
    const a = n[r], o = t[a], s = e[a];
    i = a === "ychange" || o === s || k4(o) && k4(s) && tw(o, s);
  }
  return i;
}, Ih = (t) => {
  const e = t.content.content, n = [];
  for (let i = 0; i < e.length; i++) {
    const r = e[i];
    if (r.isText) {
      const a = [];
      for (let o = e[i]; i < e.length && o.isText; o = e[++i])
        a.push(o);
      i--, n.push(a);
    } else
      n.push(r);
  }
  return n;
}, JN = (t, e) => {
  const n = t.toDelta();
  return n.length === e.length && n.every(
    /** @type {(d:any,i:number) => boolean} */
    (i, r) => i.insert === /** @type {any} */
    e[r].text && aN(i.attributes || {}).length === e[r].marks.length && oN(i.attributes, (a, o) => {
      var c;
      const s = nw(o), l = e[r].marks;
      return tw(a, (c = l.find(
        /** @param {any} mark */
        (u) => u.type.name === s
      )) == null ? void 0 : c.attrs);
    })
  );
}, Fd = (t, e) => {
  if (t instanceof wn && !(e instanceof Array) && xy(t, e)) {
    const n = Ih(e);
    return t._length === n.length && tw(t.getAttributes(), e.attrs) && t.toArray().every(
      (i, r) => Fd(i, n[r])
    );
  }
  return t instanceof ei && e instanceof Array && JN(t, e);
}, _m = (t, e) => t === e || t instanceof Array && e instanceof Array && t.length === e.length && t.every(
  (n, i) => e[i] === n
), x4 = (t, e, n) => {
  const i = t.toArray(), r = Ih(e), a = r.length, o = i.length, s = zs(o, a);
  let l = 0, c = 0, u = !1;
  for (; l < s; l++) {
    const f = i[l], m = r[l];
    if (_m(n.mapping.get(f), m))
      u = !0;
    else if (!Fd(f, m))
      break;
  }
  for (; l + c < s; c++) {
    const f = i[o - c - 1], m = r[a - c - 1];
    if (_m(n.mapping.get(f), m))
      u = !0;
    else if (!Fd(f, m))
      break;
  }
  return {
    equalityFactor: l + c,
    foundMappedChild: u
  };
}, cqe = (t) => {
  let e = "", n = t._start;
  const i = {};
  for (; n !== null; )
    n.deleted || (n.countable && n.content instanceof Ui ? e += n.content.str : n.content instanceof Ut && (i[n.content.key] = null)), n = n.right;
  return {
    str: e,
    nAttrs: i
  };
}, uqe = (t, e, n) => {
  n.mapping.set(t, e);
  const { nAttrs: i, str: r } = cqe(t), a = e.map((c) => ({
    insert: (
      /** @type {any} */
      c.text
    ),
    attributes: Object.assign({}, i, QN(c.marks, n))
  })), { insert: o, remove: s, index: l } = qBe(
    r,
    a.map((c) => c.insert).join("")
  );
  t.delete(l, s), t.insert(l, o), t.applyDelta(
    a.map((c) => ({ retain: c.insert.length, attributes: c.attributes }))
  );
}, fqe = /(.*)(--[a-zA-Z0-9+/=]{8})$/, nw = (t) => {
  var e;
  return ((e = fqe.exec(t)) == null ? void 0 : e[1]) ?? t;
}, mqe = (t, e) => {
  const n = [];
  for (const i in t)
    n.push(e.mark(nw(i), t[i]));
  return n;
}, QN = (t, e) => {
  const n = {};
  return t.forEach((i) => {
    if (i.type.name !== "ychange") {
      const r = Xr(e.isOMark, i.type, () => !i.type.excludes(i.type));
      n[r ? `${i.type.name}--${tqe(i.toJSON())}` : i.type.name] = i.attrs;
    }
  }), n;
}, ky = (t, e, n, i) => {
  if (e instanceof wn && e.nodeName !== n.type.name)
    throw new Error("node name mismatch!");
  if (i.mapping.set(e, n), e instanceof wn) {
    const f = e.getAttributes(), m = n.attrs;
    for (const h in m)
      m[h] !== null ? f[h] !== m[h] && h !== "ychange" && e.setAttribute(h, m[h]) : e.removeAttribute(h);
    for (const h in f)
      m[h] === void 0 && e.removeAttribute(h);
  }
  const r = Ih(n), a = r.length, o = e.toArray(), s = o.length, l = zs(a, s);
  let c = 0, u = 0;
  for (; c < l; c++) {
    const f = o[c], m = r[c];
    if (!_m(i.mapping.get(f), m))
      if (Fd(f, m))
        i.mapping.set(f, m);
      else
        break;
  }
  for (; u + c + 1 < l; u++) {
    const f = o[s - u - 1], m = r[a - u - 1];
    if (!_m(i.mapping.get(f), m))
      if (Fd(f, m))
        i.mapping.set(f, m);
      else
        break;
  }
  t.transact(() => {
    for (; s - c - u > 0 && a - c - u > 0; ) {
      const m = o[c], h = r[c], p = o[s - u - 1], g = r[a - u - 1];
      if (m instanceof ei && h instanceof Array)
        JN(m, h) || uqe(m, h, i), c += 1;
      else {
        let y = m instanceof wn && xy(m, h), v = p instanceof wn && xy(p, g);
        if (y && v) {
          const w = x4(
            /** @type {Y.XmlElement} */
            m,
            /** @type {PModel.Node} */
            h,
            i
          ), x = x4(
            /** @type {Y.XmlElement} */
            p,
            /** @type {PModel.Node} */
            g,
            i
          );
          w.foundMappedChild && !x.foundMappedChild ? v = !1 : !w.foundMappedChild && x.foundMappedChild || w.equalityFactor < x.equalityFactor ? y = !1 : v = !1;
        }
        y ? (ky(
          t,
          /** @type {Y.XmlFragment} */
          m,
          /** @type {PModel.Node} */
          h,
          i
        ), c += 1) : v ? (ky(
          t,
          /** @type {Y.XmlFragment} */
          p,
          /** @type {PModel.Node} */
          g,
          i
        ), u += 1) : (i.mapping.delete(e.get(c)), e.delete(c, 1), e.insert(c, [
          wy(h, i)
        ]), c += 1);
      }
    }
    const f = s - c - u;
    if (s === 1 && a === 0 && o[0] instanceof ei ? (i.mapping.delete(o[0]), o[0].delete(0, o[0].length)) : f > 0 && (e.slice(c, c + f).forEach((m) => i.mapping.delete(m)), e.delete(c, f)), c + u < a) {
      const m = [];
      for (let h = c; h < a - u; h++)
        m.push(wy(r[h], i));
      e.insert(c, m);
    }
  }, Ot);
}, xy = (t, e) => !(e instanceof Array) && t.nodeName === e.type.name, _y = (t, e, n) => {
  if (t === 0)
    return vp(e, 0, e.length === 0 ? -1 : 0);
  let i = e._first === null ? null : (
    /** @type {Y.ContentType} */
    e._first.content.type
  );
  for (; i !== null && e !== i; ) {
    if (i instanceof ei) {
      if (i._length >= t)
        return vp(i, t, e.length === 0 ? -1 : 0);
      if (t -= i._length, i._item !== null && i._item.next !== null)
        i = /** @type {Y.ContentType} */
        i._item.next.content.type;
      else {
        do
          i = i._item === null ? null : i._item.parent, t--;
        while (i !== e && i !== null && i._item !== null && i._item.next === null);
        i !== null && i !== e && (i = i._item === null ? null : (
          /** @type {Y.ContentType} */
          /** @type Y.Item */
          i._item.next.content.type
        ));
      }
    } else {
      const r = (
        /** @type {any} */
        (n.get(i) || { nodeSize: 0 }).nodeSize
      );
      if (i._first !== null && t < r)
        i = /** @type {Y.ContentType} */
        i._first.content.type, t--;
      else {
        if (t === 1 && i._length === 0 && r > 1)
          return new gm(i._item === null ? null : i._item.id, i._item === null ? Ad(i) : null, null);
        if (t -= r, i._item !== null && i._item.next !== null)
          i = /** @type {Y.ContentType} */
          i._item.next.content.type;
        else {
          if (t === 0)
            return i = i._item === null ? i : i._item.parent, new gm(i._item === null ? null : i._item.id, i._item === null ? Ad(i) : null, null);
          do
            i = /** @type {Y.Item} */
            i._item.parent, t--;
          while (i !== e && /** @type {Y.Item} */
          i._item.next === null);
          i !== e && (i = /** @type {Y.ContentType} */
          /** @type {Y.Item} */
          /** @type {Y.Item} */
          i._item.next.content.type);
        }
      }
    }
    if (i === null)
      throw ri();
    if (t === 0 && i.constructor !== ei && i !== e)
      return hqe(i._item.parent, i._item);
  }
  return vp(e, e._length, e.length === 0 ? -1 : 0);
}, hqe = (t, e) => {
  let n = null, i = null;
  return t._item === null ? i = Ad(t) : n = Ye(t._item.id.client, t._item.id.clock), new gm(n, i, e.id);
}, Vu = (t, e, n, i) => {
  const r = zHe(n, t);
  if (r === null || r.type !== e && !Ld(e, r.type._item))
    return null;
  let a = r.type, o = 0;
  if (a.constructor === ei)
    o = r.index;
  else if (a._item === null || !a._item.deleted) {
    let s = a._first, l = 0;
    for (; l < a._length && l < r.index && s !== null; ) {
      if (!s.deleted) {
        const c = (
          /** @type {Y.ContentType} */
          s.content.type
        );
        l++, c instanceof ei ? o += c._length : o += /** @type {any} */
        i.get(c).nodeSize;
      }
      s = /** @type {Y.Item} */
      s.right;
    }
    o += 1;
  }
  for (; a !== e && a._item !== null; ) {
    const s = a._item.parent;
    if (s._item === null || !s._item.deleted) {
      o += 1;
      let l = (
        /** @type {Y.AbstractType} */
        s._first
      );
      for (; l !== null; ) {
        const c = (
          /** @type {Y.ContentType} */
          l.content.type
        );
        if (c === a)
          break;
        l.deleted || (c instanceof ei ? o += c._length : o += /** @type {any} */
        i.get(c).nodeSize), l = l.right;
      }
    }
    a = /** @type {Y.AbstractType} */
    s;
  }
  return o - 1;
};
function pqe(t) {
  const e = t.toArray(), n = (i) => {
    let r;
    if (i instanceof ei)
      r = i.toDelta().map(
        /** @param {any} d */
        (o) => {
          const s = {
            type: "text",
            text: o.insert
          };
          return o.attributes && (s.marks = Object.keys(o.attributes).map((l) => {
            const c = o.attributes[l], f = {
              type: nw(l)
            };
            return Object.keys(c) && (f.attrs = c), f;
          })), s;
        }
      );
    else if (i instanceof wn) {
      r = {
        type: i.nodeName
      };
      const a = i.getAttributes();
      Object.keys(a).length && (r.attrs = a);
      const o = i.toArray();
      o.length && (r.content = o.map(n).flat());
    } else
      ri();
    return r;
  };
  return {
    type: "doc",
    content: e.map(n)
  };
}
const gqe = (t) => {
  var e, n;
  return ((n = (e = Lr.getState(t)) == null ? void 0 : e.undoManager) == null ? void 0 : n.undo()) != null;
}, yqe = (t) => {
  var e, n;
  return ((n = (e = Lr.getState(t)) == null ? void 0 : e.undoManager) == null ? void 0 : n.redo()) != null;
}, vqe = /* @__PURE__ */ new Set(["paragraph"]), bqe = (t, e) => !(t instanceof vt) || !(t.content instanceof Qi) || !(t.content.type instanceof Ta || t.content.type instanceof wn && e.has(t.content.type.nodeName)) || t.content.type._length === 0, wqe = ({ protectedNodes: t = vqe, trackedOrigins: e = [], undoManager: n = null } = {}) => new ft({
  key: Lr,
  state: {
    init: (i, r) => {
      const a = Ot.getState(r), o = n || new SN(a.type, {
        trackedOrigins: new Set([Ot].concat(e)),
        deleteFilter: (s) => bqe(s, t),
        captureTransaction: (s) => s.meta.get("addToHistory") !== !1
      });
      return {
        undoManager: o,
        prevSel: null,
        hasUndoOps: o.undoStack.length > 0,
        hasRedoOps: o.redoStack.length > 0
      };
    },
    apply: (i, r, a, o) => {
      const s = Ot.getState(o).binding, l = r.undoManager, c = l.undoStack.length > 0, u = l.redoStack.length > 0;
      return s ? {
        undoManager: l,
        prevSel: by(s, a),
        hasUndoOps: c,
        hasRedoOps: u
      } : c !== r.hasUndoOps || u !== r.hasRedoOps ? Object.assign({}, r, {
        hasUndoOps: l.undoStack.length > 0,
        hasRedoOps: l.redoStack.length > 0
      }) : r;
    }
  },
  view: (i) => {
    const r = Ot.getState(i.state), a = Lr.getState(i.state).undoManager;
    return a.on("stack-item-added", ({ stackItem: o }) => {
      const s = r.binding;
      s && o.meta.set(s, Lr.getState(i.state).prevSel);
    }), a.on("stack-item-popped", ({ stackItem: o }) => {
      const s = r.binding;
      s && (s.beforeTransactionSelection = o.meta.get(s) || s.beforeTransactionSelection);
    }), {
      destroy: () => {
        a.destroy();
      }
    };
  }
});
gt.create({
  name: "collaboration",
  priority: 1e3,
  addOptions() {
    return {
      document: null,
      field: "default",
      fragment: null
    };
  },
  addStorage() {
    return {
      isDisabled: !1
    };
  },
  onCreate() {
    this.editor.extensionManager.extensions.find((t) => t.name === "history") && console.warn('[tiptap warn]: "@tiptap/extension-collaboration" comes with its own history support and is not compatible with "@tiptap/extension-history".');
  },
  addCommands() {
    return {
      undo: () => ({ tr: t, state: e, dispatch: n }) => (t.setMeta("preventDispatch", !0), Lr.getState(e).undoManager.undoStack.length === 0 ? !1 : n ? gqe(e) : !0),
      redo: () => ({ tr: t, state: e, dispatch: n }) => (t.setMeta("preventDispatch", !0), Lr.getState(e).undoManager.redoStack.length === 0 ? !1 : n ? yqe(e) : !0)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Mod-y": () => this.editor.commands.redo(),
      "Shift-Mod-z": () => this.editor.commands.redo()
    };
  },
  addProseMirrorPlugins() {
    var t;
    const e = this.options.fragment ? this.options.fragment : this.options.document.getXmlFragment(this.options.field), n = wqe(this.options.yUndoOptions), i = n.spec.view;
    n.spec.view = (o) => {
      const { undoManager: s } = Lr.getState(o.state);
      s.restore && (s.restore(), s.restore = () => {
      });
      const l = i ? i(o) : void 0;
      return {
        destroy: () => {
          const c = s.trackedOrigins.has(s), u = s._observers;
          s.restore = () => {
            c && s.trackedOrigins.add(s), s.doc.on("afterTransaction", s.afterTransactionHandler), s._observers = u;
          }, l != null && l.destroy && l.destroy();
        }
      };
    };
    const r = {
      ...this.options.ySyncOptions,
      onFirstRender: this.options.onFirstRender
    }, a = rqe(e, r);
    return this.editor.options.enableContentCheck && ((t = e.doc) === null || t === void 0 || t.on("beforeTransaction", () => {
      try {
        const o = pqe(e);
        if (o.content.length === 0)
          return;
        this.editor.schema.nodeFromJSON(o).check();
      } catch (o) {
        return this.editor.emit("contentError", {
          error: o,
          editor: this.editor,
          disableCollaboration: () => {
            var s;
            (s = e.doc) === null || s === void 0 || s.destroy(), this.storage.isDisabled = !0;
          }
        }), !1;
      }
    })), [
      a,
      n,
      // Only add the filterInvalidContent plugin if content checking is enabled
      this.editor.options.enableContentCheck && new ft({
        key: new yt("filterInvalidContent"),
        filterTransaction: () => {
          var o;
          return this.storage.isDisabled && ((o = e.doc) === null || o === void 0 || o.destroy()), !0;
        }
      })
    ].filter(Boolean);
  }
});
function kqe(t) {
  return !!t.getMeta(Ot);
}
function _4(t) {
  if (!t.length)
    return ht.empty;
  const e = [], n = t[0].$from.node(0);
  return t.forEach((i) => {
    const r = i.$from.pos, a = i.$from.nodeAfter;
    a && e.push(fn.node(r, r + a.nodeSize, {
      class: "ProseMirror-selectednoderange"
    }));
  }), ht.create(n, e);
}
function Rh(t, e, n) {
  const i = [], r = t.node(0);
  n = typeof n == "number" && n >= 0 ? n : t.sameParent(e) ? Math.max(0, t.sharedDepth(e.pos) - 1) : t.sharedDepth(e.pos);
  const a = new pd(t, e, n), o = a.depth === 0 ? 0 : r.resolve(a.start).posAtIndex(0);
  return a.parent.forEach((s, l) => {
    const c = o + l, u = c + s.nodeSize;
    if (c < a.start || c >= a.end)
      return;
    const f = new J8(r.resolve(c), r.resolve(u));
    i.push(f);
  }), i;
}
class iw {
  constructor(e, n) {
    this.anchor = e, this.head = n;
  }
  map(e) {
    return new iw(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const n = e.resolve(this.anchor), i = e.resolve(this.head);
    return new yn(n, i);
  }
}
class yn extends He {
  constructor(e, n, i, r = 1) {
    const { doc: a } = e, o = e === n, s = e.pos === a.content.size && n.pos === a.content.size, l = o && !s ? a.resolve(n.pos + (r > 0 ? 1 : -1)) : n, c = o && s ? a.resolve(e.pos - (r > 0 ? 1 : -1)) : e, u = Rh(c.min(l), c.max(l), i), f = l.pos >= e.pos ? u[0].$from : u[u.length - 1].$to, m = l.pos >= e.pos ? u[u.length - 1].$to : u[0].$from;
    super(f, m, u), this.depth = i;
  }
  // we can safely ignore this TypeScript error: https://github.com/Microsoft/TypeScript/issues/338
  // @ts-ignore
  get $to() {
    return this.ranges[this.ranges.length - 1].$to;
  }
  eq(e) {
    return e instanceof yn && e.$from.pos === this.$from.pos && e.$to.pos === this.$to.pos;
  }
  map(e, n) {
    const i = e.resolve(n.map(this.anchor)), r = e.resolve(n.map(this.head));
    return new yn(i, r);
  }
  toJSON() {
    return {
      type: "nodeRange",
      anchor: this.anchor,
      head: this.head
    };
  }
  get isForwards() {
    return this.head >= this.anchor;
  }
  get isBackwards() {
    return !this.isForwards;
  }
  extendBackwards() {
    const { doc: e } = this.$from;
    if (this.isForwards && this.ranges.length > 1) {
      const r = this.ranges.slice(0, -1), a = r[0].$from, o = r[r.length - 1].$to;
      return new yn(a, o, this.depth);
    }
    const n = this.ranges[0], i = e.resolve(Math.max(0, n.$from.pos - 1));
    return new yn(this.$anchor, i, this.depth);
  }
  extendForwards() {
    const { doc: e } = this.$from;
    if (this.isBackwards && this.ranges.length > 1) {
      const r = this.ranges.slice(1), a = r[0].$from, o = r[r.length - 1].$to;
      return new yn(o, a, this.depth);
    }
    const n = this.ranges[this.ranges.length - 1], i = e.resolve(Math.min(e.content.size, n.$to.pos + 1));
    return new yn(this.$anchor, i, this.depth);
  }
  static fromJSON(e, n) {
    return new yn(e.resolve(n.anchor), e.resolve(n.head));
  }
  static create(e, n, i, r, a = 1) {
    return new this(e.resolve(n), e.resolve(i), r, a);
  }
  getBookmark() {
    return new iw(this.anchor, this.head);
  }
}
yn.prototype.visible = !1;
function pu(t) {
  return t instanceof yn;
}
gt.create({
  name: "nodeRange",
  addOptions() {
    return {
      depth: void 0,
      key: "Mod"
    };
  },
  addKeyboardShortcuts() {
    return {
      // extend NodeRangeSelection upwards
      "Shift-ArrowUp": ({ editor: t }) => {
        const { depth: e } = this.options, { view: n, state: i } = t, { doc: r, selection: a, tr: o } = i, { anchor: s, head: l } = a;
        if (!pu(a)) {
          const u = yn.create(r, s, l, e, -1);
          return o.setSelection(u), n.dispatch(o), !0;
        }
        const c = a.extendBackwards();
        return o.setSelection(c), n.dispatch(o), !0;
      },
      // extend NodeRangeSelection downwards
      "Shift-ArrowDown": ({ editor: t }) => {
        const { depth: e } = this.options, { view: n, state: i } = t, { doc: r, selection: a, tr: o } = i, { anchor: s, head: l } = a;
        if (!pu(a)) {
          const u = yn.create(r, s, l, e);
          return o.setSelection(u), n.dispatch(o), !0;
        }
        const c = a.extendForwards();
        return o.setSelection(c), n.dispatch(o), !0;
      },
      // add `NodeRangeSelection` to all nodes
      "Mod-a": ({ editor: t }) => {
        const { depth: e } = this.options, { view: n, state: i } = t, { doc: r, tr: a } = i, o = yn.create(r, 0, r.content.size, e);
        return a.setSelection(o), n.dispatch(a), !0;
      }
    };
  },
  onSelectionUpdate() {
    const { selection: t } = this.editor.state;
    pu(t) && this.editor.view.dom.classList.add("ProseMirror-noderangeselection");
  },
  addProseMirrorPlugins() {
    let t = !1, e = !1;
    return [
      new ft({
        key: new yt("nodeRange"),
        props: {
          attributes: () => t ? {
            class: "ProseMirror-noderangeselection"
          } : { class: "" },
          handleDOMEvents: {
            mousedown: (n, i) => {
              const { key: r } = this.options, a = /Mac/.test(navigator.platform), o = !!i.shiftKey, s = !!i.ctrlKey, l = !!i.altKey, c = !!i.metaKey, u = a ? c : s;
              return (r == null || r === "Shift" && o || r === "Control" && s || r === "Alt" && l || r === "Meta" && c || r === "Mod" && u) && (e = !0), e && document.addEventListener("mouseup", () => {
                e = !1;
                const { state: f } = n, { doc: m, selection: h, tr: p } = f, { $anchor: g, $head: y } = h;
                if (g.sameParent(y))
                  return;
                const v = yn.create(m, g.pos, y.pos, this.options.depth);
                p.setSelection(v), n.dispatch(p);
              }, { once: !0 }), !1;
            }
          },
          // when selecting some text we want to render some decorations
          // to preview a `NodeRangeSelection`
          decorations: (n) => {
            const { selection: i } = n, r = pu(i);
            if (t = !1, !e)
              return r ? (t = !0, _4(i.ranges)) : null;
            const { $from: a, $to: o } = i;
            if (!r && a.sameParent(o))
              return null;
            const s = Rh(a, o, this.options.depth);
            return s.length ? (t = !0, _4(s)) : null;
          }
        }
      })
    ];
  }
});
function xqe(t) {
  let e = "";
  const n = getComputedStyle(t);
  for (let i = 0; i < n.length; i += 1)
    e += `${n[i]}:${n.getPropertyValue(n[i])};`;
  return e;
}
function _qe(t) {
  const e = t.cloneNode(!0), n = [t, ...Array.from(t.getElementsByTagName("*"))], i = [e, ...Array.from(e.getElementsByTagName("*"))];
  return n.forEach((r, a) => {
    i[a].style.cssText = xqe(r);
  }), e;
}
const ZN = (t) => {
  const { x: e, y: n, direction: i, editor: r } = t;
  let a = null, o = null, s = null, l = e;
  for (; o === null && l < window.innerWidth && l > 0; ) {
    const c = document.elementsFromPoint(l, n), u = c.findIndex((m) => m.classList.contains("ProseMirror")), f = c.slice(0, u);
    if (f.length > 0) {
      const m = f[0];
      if (a = m, s = r.view.posAtDOM(m, 0), s >= 0) {
        o = r.state.doc.nodeAt(Math.max(s - 1, 0)), o != null && o.isText && (o = r.state.doc.nodeAt(Math.max(s - 1, 0))), o || (o = r.state.doc.nodeAt(Math.max(s, 0)));
        break;
      }
    }
    i === "left" ? l -= 1 : l += 1;
  }
  return { resultElement: a, resultNode: o, pos: s ?? null };
};
function gu(t, e) {
  return window.getComputedStyle(t)[e];
}
function Mqe(t = 0, e = 0, n = 0) {
  return Math.min(Math.max(t, e), n);
}
function Cqe(t, e, n) {
  const i = parseInt(gu(t.dom, "paddingLeft"), 10), r = parseInt(gu(t.dom, "paddingRight"), 10), a = parseInt(gu(t.dom, "borderLeftWidth"), 10), o = parseInt(gu(t.dom, "borderLeftWidth"), 10), s = t.dom.getBoundingClientRect();
  return {
    left: Mqe(e, s.left + i + a, s.right - r - o),
    top: n
  };
}
function e$(t) {
  var e;
  (e = t.parentNode) === null || e === void 0 || e.removeChild(t);
}
function Pqe(t, e) {
  const { doc: n } = e.view.state, i = ZN({
    editor: e,
    x: t.clientX,
    y: t.clientY,
    direction: "right"
  });
  if (!i.resultNode || i.pos === null)
    return [];
  const r = t.clientX, a = Cqe(e.view, r, t.clientY), o = e.view.posAtCoords(a);
  if (!o)
    return [];
  const { pos: s } = o;
  if (!n.resolve(s).parent)
    return [];
  const c = n.resolve(i.pos), u = n.resolve(i.pos + 1);
  return Rh(c, u, 0);
}
function Sqe(t, e) {
  const { view: n } = e;
  if (!t.dataTransfer)
    return;
  const { empty: i, $from: r, $to: a } = n.state.selection, o = Pqe(t, e), s = Rh(r, a, 0), l = s.some((y) => o.find((v) => v.$from === y.$from && v.$to === y.$to)), c = i || !l ? o : s;
  if (!c.length)
    return;
  const { tr: u } = n.state, f = document.createElement("div"), m = c[0].$from.pos, h = c[c.length - 1].$to.pos, p = yn.create(n.state.doc, m, h), g = p.content();
  c.forEach((y) => {
    const v = n.nodeDOM(y.$from.pos), w = _qe(v);
    f.append(w);
  }), f.style.position = "absolute", f.style.top = "-10000px", document.body.append(f), t.dataTransfer.clearData(), t.dataTransfer.setDragImage(f, 0, 0), n.dragging = { slice: g, move: !0 }, u.setSelection(p), n.dispatch(u), document.addEventListener("drop", () => e$(f), { once: !0 });
}
const M4 = (t, e) => {
  const n = t.resolve(e), { depth: i } = n;
  return i === 0 ? e : n.pos - n.parentOffset - 1;
}, C4 = (t, e) => {
  const n = t.nodeAt(e), i = t.resolve(e);
  let { depth: r } = i, a = n;
  for (; r > 0; ) {
    const o = i.node(r);
    r -= 1, r === 0 && (a = o);
  }
  return a;
}, xp = (t, e) => {
  const n = Ot.getState(t);
  return n ? _y(e, n.type, n.binding.mapping) : null;
}, Nqe = (t, e) => {
  const n = Ot.getState(t);
  return n ? Vu(n.doc, n.type, e, n.binding.mapping) || 0 : -1;
}, P4 = (t, e) => {
  let n = e;
  for (; n && n.parentNode && n.parentNode !== t.dom; )
    n = n.parentNode;
  return n;
}, t$ = new yt("dragHandle"), n$ = ({ pluginKey: t = t$, element: e, editor: n, tippyOptions: i, onNodeChange: r }) => {
  const a = document.createElement("div");
  let o = null, s = !1, l = null, c = -1, u;
  return e.addEventListener("dragstart", (f) => {
    Sqe(f, n), setTimeout(() => {
      e && (e.style.pointerEvents = "none");
    }, 0);
  }), e.addEventListener("dragend", () => {
    e && (e.style.pointerEvents = "auto");
  }), new ft({
    key: typeof t == "string" ? new yt(t) : t,
    state: {
      init() {
        return { locked: !1 };
      },
      apply(f, m, h, p) {
        const g = f.getMeta("lockDragHandle"), y = f.getMeta("hideDragHandle");
        if (g !== void 0 && (s = g), y && o)
          return o.hide(), s = !1, l = null, c = -1, r == null || r({ editor: n, node: null, pos: -1 }), m;
        if (f.docChanged && c !== -1 && e && o)
          if (kqe(f)) {
            const v = Nqe(p, u);
            v !== c && (c = v);
          } else {
            const v = f.mapping.map(c);
            v !== c && (c = v, u = xp(p, c));
          }
        return m;
      }
    },
    view: (f) => {
      var m;
      return e.draggable = !0, e.style.pointerEvents = "auto", (m = n.view.dom.parentElement) === null || m === void 0 || m.appendChild(a), a.appendChild(e), a.style.pointerEvents = "none", a.style.position = "absolute", a.style.top = "0", a.style.left = "0", {
        update(h, p) {
          if (!e)
            return;
          if (!n.isEditable) {
            o == null || o.destroy(), o = null;
            return;
          }
          if (o || (o = al(f.dom, {
            getReferenceClientRect: null,
            interactive: !0,
            trigger: "manual",
            placement: "left-start",
            hideOnClick: !1,
            duration: 100,
            popperOptions: {
              modifiers: [
                { name: "flip", enabled: !1 },
                {
                  name: "preventOverflow",
                  options: {
                    rootBoundary: "document",
                    mainAxis: !1
                  }
                }
              ]
            },
            ...i,
            appendTo: a,
            content: e
          })), s ? e.draggable = !1 : e.draggable = !0, f.state.doc.eq(p.doc) || c === -1)
            return;
          let g = f.nodeDOM(c);
          if (g = P4(f, g), g === f.dom || (g == null ? void 0 : g.nodeType) !== 1)
            return;
          const y = f.posAtDOM(g, 0), v = C4(n.state.doc, y), w = M4(n.state.doc, y);
          l = v, c = w, u = xp(f.state, c), r == null || r({ editor: n, node: l, pos: c }), o.setProps({
            getReferenceClientRect: () => g.getBoundingClientRect()
          });
        },
        // TODO: Kills even on hot reload
        destroy() {
          o == null || o.destroy(), e && e$(a);
        }
      };
    },
    props: {
      handleDOMEvents: {
        mouseleave(f, m) {
          return s || m.target && !a.contains(m.relatedTarget) && (o == null || o.hide(), l = null, c = -1, r == null || r({ editor: n, node: null, pos: -1 })), !1;
        },
        mousemove(f, m) {
          if (!e || !o || s)
            return !1;
          const h = ZN({
            x: m.clientX,
            y: m.clientY,
            direction: "right",
            editor: n
          });
          if (!h.resultElement)
            return !1;
          let p = h.resultElement;
          if (p = P4(f, p), p === f.dom || (p == null ? void 0 : p.nodeType) !== 1)
            return !1;
          const g = f.posAtDOM(p, 0), y = C4(n.state.doc, g);
          if (y !== l) {
            const v = M4(n.state.doc, g);
            l = y, c = v, u = xp(f.state, c), r == null || r({ editor: n, node: l, pos: c }), o.setProps({
              getReferenceClientRect: () => p.getBoundingClientRect()
            }), o.show();
          }
          return !1;
        }
      }
    }
  });
};
gt.create({
  name: "dragHandle",
  addOptions() {
    return {
      render() {
        const t = document.createElement("div");
        return t.classList.add("drag-handle"), t;
      },
      tippyOptions: {},
      locked: !1,
      onNodeChange: () => null
    };
  },
  addCommands() {
    return {
      lockDragHandle: () => ({ editor: t }) => (this.options.locked = !0, t.commands.setMeta("lockDragHandle", this.options.locked)),
      unlockDragHandle: () => ({ editor: t }) => (this.options.locked = !1, t.commands.setMeta("lockDragHandle", this.options.locked)),
      toggleDragHandle: () => ({ editor: t }) => (this.options.locked = !this.options.locked, t.commands.setMeta("lockDragHandle", this.options.locked))
    };
  },
  addProseMirrorPlugins() {
    const t = this.options.render();
    return [
      n$({
        tippyOptions: this.options.tippyOptions,
        element: t,
        editor: this.editor,
        onNodeChange: this.options.onNodeChange
      })
    ];
  }
});
const $qe = (t) => {
  const { className: e = "drag-handle", children: n, editor: i, pluginKey: r = t$, onNodeChange: a, tippyOptions: o } = t, [s, l] = q(null), c = Oe(null);
  return le(() => s ? i.isDestroyed ? () => {
    c.current = null;
  } : (c.current || (c.current = n$({
    editor: i,
    element: s,
    pluginKey: r,
    tippyOptions: o,
    onNodeChange: a
  }), i.registerPlugin(c.current)), () => {
    i.unregisterPlugin(r), c.current = null;
  }) : () => {
    c.current = null;
  }, [s, i, a, r, o]), H.createElement("div", { className: e, ref: l }, n);
}, Dqe = ({
  node: t,
  deleteNode: e,
  extension: n,
  updateAttributes: i
}) => {
  var u, f, m, h, p;
  const [r, a] = q(t.attrs.isOpen ?? !1), o = t.attrs.data, s = n.options.currentConfig || t.attrs.config || {};
  if (!o) return null;
  const l = () => {
    const g = !r;
    a(g), i({ isOpen: g });
  }, c = [
    {
      label: ((u = s.labels) == null ? void 0 : u.deleteBlock) || "Delete",
      icon: tc,
      critical: !0,
      onClick: () => e()
    }
  ];
  return /* @__PURE__ */ k(Dc, { contentEditable: !1, children: [
    /* @__PURE__ */ k(
      re.div,
      {
        className: "editor-live-companion my-4 flex w-full flex-col gap-4 rounded-md border border-solid border-f1-border-secondary p-3",
        onClick: (g) => g.stopPropagation(),
        layout: !0,
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3, ease: "easeOut" },
        children: [
          /* @__PURE__ */ k(
            re.div,
            {
              className: "flex flex-row items-center justify-between gap-2",
              layout: !0,
              children: [
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: "flex cursor-pointer flex-row items-center gap-2",
                    onClick: l,
                    children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
                      /* @__PURE__ */ d("div", { className: "flex flex-row items-center gap-3", children: /* @__PURE__ */ d("p", { className: "text-f1-text-primary text-lg font-semibold", children: o.title }) }),
                      /* @__PURE__ */ k("p", { className: "text-f1-text-secondary text-sm", children: [
                        o.topics.length,
                        " ",
                        o.topics.length === 1 ? ((f = s.labels) == null ? void 0 : f.oneTopicWithCommentary) || "" : ((m = s.labels) == null ? void 0 : m.multipleTopicsWithCommentary) || ""
                      ] })
                    ] })
                  }
                ),
                /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
                  /* @__PURE__ */ d(
                    ue,
                    {
                      onClick: l,
                      variant: "outline",
                      hideLabel: !0,
                      label: r ? ((h = s.labels) == null ? void 0 : h.collapse) || "Collapse" : ((p = s.labels) == null ? void 0 : p.expand) || "Expand",
                      icon: r ? qs : zn,
                      size: "sm"
                    }
                  ),
                  /* @__PURE__ */ d(In, { items: c, size: "sm" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ d(Ue, { mode: "wait", children: r && /* @__PURE__ */ d(
            re.div,
            {
              initial: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              animate: {
                height: "auto",
                opacity: 1,
                scaleY: 1
              },
              exit: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              transition: {
                duration: 0.3,
                ease: "easeInOut",
                opacity: { duration: 0.2 }
              },
              style: {
                transformOrigin: "top",
                overflow: "hidden"
              },
              children: /* @__PURE__ */ d(
                re.div,
                {
                  className: "text-f1-text-primary",
                  initial: { opacity: 0, y: -10 },
                  animate: { opacity: 1, y: 0 },
                  transition: { delay: 0.1, duration: 0.3 },
                  children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-4", children: o.topics.map((g, y) => /* @__PURE__ */ k(
                    re.div,
                    {
                      initial: {
                        opacity: 0,
                        y: -10,
                        scale: 0.95
                      },
                      animate: {
                        opacity: 1,
                        y: 0,
                        scale: 1
                      },
                      transition: {
                        delay: y * 0.05,
                        duration: 0.2,
                        ease: "easeOut"
                      },
                      className: "flex flex-col",
                      children: [
                        /* @__PURE__ */ d("h3", { className: "text-f1-text-primary text-md font-semibold", children: g.title }),
                        /* @__PURE__ */ d("div", { className: "ml-4 flex flex-col gap-2", children: g.comments.map((v, w) => /* @__PURE__ */ d(
                          re.div,
                          {
                            initial: {
                              opacity: 0,
                              x: -5
                            },
                            animate: {
                              opacity: 1,
                              x: 0
                            },
                            transition: {
                              delay: y * 0.05 + w * 0.03,
                              duration: 0.2
                            },
                            className: "flex flex-row items-start gap-2",
                            children: /* @__PURE__ */ k("p", { className: "text-f1-text-primary text-md", children: [
                              /* @__PURE__ */ k("span", { className: "text-f1-text-secondary font-medium", children: [
                                v.user,
                                ":"
                              ] }),
                              " ",
                              /* @__PURE__ */ d("span", { className: "text-f1-text-secondary font-normal italic", children: v.comment })
                            ] })
                          },
                          w
                        )) })
                      ]
                    },
                    y
                  )) })
                }
              )
            },
            "content"
          ) })
        ]
      }
    ),
    /* @__PURE__ */ d($c, { style: { display: "none" } })
  ] });
}, Eqe = qt.create({
  name: "liveCompanion",
  group: "block",
  atom: !0,
  selectable: !0,
  draggable: !0,
  addOptions() {
    return {
      currentConfig: null
    };
  },
  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("data-live-companion");
          return e ? JSON.parse(e) : null;
        },
        renderHTML: (t) => t.data ? {
          "data-live-companion": JSON.stringify(t.data)
        } : {}
      },
      config: {
        default: null
      },
      isOpen: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-live-companion]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t, node: e }) {
    const n = e.attrs.data;
    return n ? [
      "div",
      {
        ...t,
        class: "live-companion-block",
        "data-live-companion": JSON.stringify(n)
      },
      [
        "div",
        { class: "live-companion-content" },
        `Live Companion: ${n.title}`
      ]
    ] : ["div"];
  },
  addNodeView() {
    return Ec(Dqe);
  },
  addCommands() {
    return {
      insertLiveCompanion: (t, e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: { data: t, config: e }
      })
    };
  }
}), Tqe = Eqe, Oqe = ({
  node: t,
  deleteNode: e,
  extension: n,
  updateAttributes: i
}) => {
  var m, h, p, g, y;
  const [r, a] = q(t.attrs.isOpen ?? !1), o = t.attrs.data, s = n.options.currentConfig || t.attrs.config || {};
  if (!o) return null;
  const l = () => {
    const v = !r;
    a(v), i({ isOpen: v });
  }, c = [
    {
      label: ((m = s.labels) == null ? void 0 : m.deleteBlock) || "Delete",
      icon: tc,
      critical: !0,
      onClick: () => e()
    }
  ], u = (v) => o.users.find((w) => w.id === v), f = (v) => {
    try {
      const w = new Date(v);
      return ii(w, "HH:mm");
    } catch (w) {
      return console.error(w), v;
    }
  };
  return /* @__PURE__ */ k(Dc, { contentEditable: !1, children: [
    /* @__PURE__ */ k(
      re.div,
      {
        className: "editor-transcript my-4 flex w-full flex-col gap-4 rounded-md border border-solid border-f1-border-secondary p-3",
        onClick: (v) => v.stopPropagation(),
        layout: !0,
        initial: { opacity: 0, y: 20 },
        animate: { opacity: 1, y: 0 },
        transition: { duration: 0.3, ease: "easeOut" },
        children: [
          /* @__PURE__ */ k(
            re.div,
            {
              className: "flex flex-row items-center justify-between gap-2",
              layout: !0,
              children: [
                /* @__PURE__ */ d(
                  "div",
                  {
                    className: "flex cursor-pointer flex-row items-center gap-2",
                    onClick: l,
                    children: /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", children: [
                      /* @__PURE__ */ d("div", { className: "flex flex-row items-center gap-3", children: /* @__PURE__ */ d("p", { className: "text-f1-text-primary text-lg font-semibold", children: o.title }) }),
                      /* @__PURE__ */ k("p", { className: "text-f1-text-secondary text-sm", children: [
                        o.messages.length,
                        " ",
                        o.messages.length === 1 ? ((h = s.labels) == null ? void 0 : h.messagesCountSingular) || "" : ((p = s.labels) == null ? void 0 : p.messagesCount) || ""
                      ] })
                    ] })
                  }
                ),
                /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
                  /* @__PURE__ */ d(
                    ue,
                    {
                      onClick: l,
                      variant: "outline",
                      hideLabel: !0,
                      label: r ? ((g = s.labels) == null ? void 0 : g.collapse) || "Collapse" : ((y = s.labels) == null ? void 0 : y.expand) || "Expand",
                      icon: r ? qs : zn,
                      size: "sm"
                    }
                  ),
                  /* @__PURE__ */ d(In, { items: c, size: "sm" })
                ] })
              ]
            }
          ),
          /* @__PURE__ */ d(Ue, { mode: "wait", children: r && /* @__PURE__ */ d(
            re.div,
            {
              initial: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              animate: {
                height: "auto",
                opacity: 1,
                scaleY: 1
              },
              exit: {
                height: 0,
                opacity: 0,
                scaleY: 0
              },
              transition: {
                duration: 0.3,
                ease: "easeInOut",
                opacity: { duration: 0.2 }
              },
              style: {
                transformOrigin: "top",
                overflow: "hidden"
              },
              children: /* @__PURE__ */ d(
                re.div,
                {
                  className: "text-f1-text-primary",
                  initial: { opacity: 0, y: -10 },
                  animate: { opacity: 1, y: 0 },
                  transition: { delay: 0.1, duration: 0.3 },
                  children: /* @__PURE__ */ d("div", { className: "scrollbar-macos flex max-h-[500px] flex-col gap-4 overflow-y-auto", children: o.messages.map((v, w) => {
                    const x = u(v.userId);
                    return /* @__PURE__ */ k(
                      re.div,
                      {
                        initial: {
                          opacity: 0,
                          y: -10,
                          scale: 0.95
                        },
                        animate: {
                          opacity: 1,
                          y: 0,
                          scale: 1
                        },
                        transition: {
                          delay: w * 0.05,
                          duration: 0.2,
                          ease: "easeOut"
                        },
                        className: "flex flex-row gap-3",
                        children: [
                          (x == null ? void 0 : x.imageUrl) && /* @__PURE__ */ d(
                            ti,
                            {
                              size: "xsmall",
                              src: x.imageUrl,
                              firstName: x.fullname,
                              lastName: ""
                            }
                          ),
                          /* @__PURE__ */ k("div", { className: "flex flex-col", children: [
                            /* @__PURE__ */ k("div", { className: "flex items-baseline gap-2", children: [
                              /* @__PURE__ */ d("span", { className: "text-f1-text-primary font-medium", children: (x == null ? void 0 : x.fullname) || "Unknown User" }),
                              /* @__PURE__ */ d("span", { className: "text-f1-text-tertiary text-xs", children: f(v.dateTime) })
                            ] }),
                            /* @__PURE__ */ d("p", { className: "text-f1-text-secondary", children: v.text })
                          ] })
                        ]
                      },
                      w
                    );
                  }) })
                }
              )
            },
            "content"
          ) })
        ]
      }
    ),
    /* @__PURE__ */ d($c, { style: { display: "none" } })
  ] });
}, Wqe = qt.create({
  name: "transcript",
  group: "block",
  atom: !0,
  selectable: !0,
  draggable: !0,
  addOptions() {
    return {
      currentConfig: null
    };
  },
  addAttributes() {
    return {
      data: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("data-transcript");
          return e ? JSON.parse(e) : null;
        },
        renderHTML: (t) => t.data ? {
          "data-transcript": JSON.stringify(t.data)
        } : {}
      },
      config: {
        default: null
      },
      isOpen: {
        default: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-transcript]"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t, node: e }) {
    const n = e.attrs.data;
    return n ? [
      "div",
      {
        ...t,
        class: "transcript-block",
        "data-transcript": JSON.stringify(n)
      },
      ["div", { class: "transcript-content" }, `Transcript: ${n.title}`]
    ] : ["div"];
  },
  addNodeView() {
    return Ec(Oqe);
  },
  addCommands() {
    return {
      insertTranscript: (t, e) => ({ commands: n }) => n.insertContent({
        type: this.name,
        attrs: { data: t, config: e }
      })
    };
  }
}), Aqe = Wqe, Lqe = (t, e, n, i, r, a, o, s) => {
  const l = i && r ? { ...i, labels: r } : i, c = a ? { labels: a } : void 0, u = o ? { labels: o } : void 0, f = s ? { labels: s } : void 0;
  return [
    Ab,
    xb,
    wb,
    vb,
    kb,
    Lb,
    _b,
    bb,
    Ib,
    Wb,
    sFe,
    uFe,
    dFe,
    tVe.configure({
      currentConfig: c
    }),
    Tqe.configure({
      currentConfig: u
    }),
    Aqe.configure({
      currentConfig: f
    }),
    Qze.configure({
      currentConfig: l
    }),
    Rb,
    U7(t),
    G7(t),
    aVe(
      e,
      n,
      l
    )
  ];
}, zYe = X(function({
  onChange: e,
  placeholder: n,
  initialEditorState: i,
  readonly: r = !1,
  labels: a,
  aiBlockConfig: o
}, s) {
  const {
    toolbarLabels: l,
    slashCommandGroupLabels: c,
    aiBlockLabels: u,
    moodTrackerLabels: f,
    liveCompanionLabels: m,
    transcriptLabels: h
  } = a, p = Oe(null), g = Oe(null), y = Wa(), [v] = q(() => (i == null ? void 0 : i.content) || ""), w = gb({
    extensions: Lqe(
      n,
      l,
      c,
      o,
      u,
      f,
      m,
      h
    ),
    content: v,
    onUpdate: ({ editor: _ }) => {
      e(
        _.isEmpty ? { json: null, html: null } : { json: _.getJSON(), html: _.getHTML() }
      );
    },
    editable: !r
  });
  Dm(s, () => ({
    clear: () => w == null ? void 0 : w.commands.clearContent(),
    focus: () => w == null ? void 0 : w.commands.focus(),
    setContent: (_) => w == null ? void 0 : w.commands.setContent(_),
    insertAIBlock: () => {
      if (!w || !o) return;
      const _ = u ? { ...o, labels: u } : o;
      w.commands.insertAIBlock(
        { content: null, selectedAction: void 0 },
        _
      );
    },
    insertTranscript: (_, N, $) => {
      if (!w) return;
      const D = h ? { labels: h } : void 0;
      w.commands.insertTranscript({ title: _, users: N, messages: $ }, D);
    }
  }));
  const x = ve(
    () => ({
      offset: [0, 2]
    }),
    []
  ), b = Le(
    ({ node: _, pos: N }) => {
      g.current = _ ? { pos: N, nodeSize: _.nodeSize } : null;
    },
    []
  ), M = Le(() => {
    const _ = g.current;
    if (!_ || !w) return;
    const { pos: N, nodeSize: $ } = _, D = w.state.doc.nodeAt(N);
    if (D && D.content.size === 0)
      w.chain().focus().setTextSelection(N + 1).insertContent("/").run();
    else {
      const W = N + $;
      w.chain().focus().insertContentAt(W, { type: "paragraph" }).setTextSelection(W + 1).insertContent("/").run();
    }
  }, [w]);
  return w ? /* @__PURE__ */ k("div", { className: "relative w-full", ref: p, id: y, children: [
    /* @__PURE__ */ d(
      $qe,
      {
        editor: w,
        tippyOptions: x,
        onNodeChange: b,
        children: /* @__PURE__ */ k("div", { className: "flex flex-row", children: [
          /* @__PURE__ */ d(
            "div",
            {
              className: "flex h-5 w-[16px] cursor-pointer items-center justify-center rounded-2xs hover:bg-f1-background-hover",
              onClick: M,
              children: /* @__PURE__ */ d(
                me,
                {
                  icon: O5,
                  size: "sm",
                  className: "text-f1-foreground-tertiary"
                }
              )
            }
          ),
          /* @__PURE__ */ d(
            "div",
            {
              "data-drag-handle": !0,
              draggable: !0,
              className: "flex h-5 w-[16px] cursor-grab items-center justify-center rounded-2xs hover:bg-f1-background-hover",
              children: /* @__PURE__ */ d(
                me,
                {
                  icon: ME,
                  size: "xs",
                  className: "text-f1-foreground-tertiary"
                }
              )
            }
          )
        ] })
      }
    ),
    /* @__PURE__ */ d(hb, { editor: w, className: "[&>div]:w-full [&>div]:pl-10" }),
    /* @__PURE__ */ d(
      E7,
      {
        editor: w,
        toolbarLabels: l,
        disableButtons: !1,
        isToolbarOpen: !1,
        isFullscreen: !1,
        editorId: y
      }
    )
  ] }) : null;
}), i$ = X(
  ({ file: t, actions: e = [], disabled: n = !1, className: i, ...r }, a) => {
    const o = e.length > 0, s = e.length === 1 ? e[0] : null, l = e.map((c) => ({
      label: c.label,
      icon: c.icon,
      critical: c.critical,
      onClick: n ? void 0 : c.onClick
    }));
    return /* @__PURE__ */ k(
      "div",
      {
        ref: a,
        className: E(
          "flex w-fit max-w-40 flex-row items-center gap-2 overflow-hidden rounded-md bg-f1-background-tertiary p-0.5 pr-2",
          i
        ),
        ...r,
        children: [
          /* @__PURE__ */ d(MM, { file: t }),
          /* @__PURE__ */ d(Kt, { label: t.name, children: /* @__PURE__ */ d("p", { className: "text-neutral-1000 grow overflow-hidden truncate text-ellipsis text-sm font-medium", children: t.name }) }),
          o && (s ? /* @__PURE__ */ d(
            me,
            {
              size: "md",
              icon: s.icon ?? vs,
              className: E(
                "cursor-pointer text-f1-icon",
                n ? "cursor-not-allowed" : "hover:text-f1-icon-bold",
                s.critical && "text-f1-foreground-critical"
              ),
              onClick: n ? void 0 : s.onClick
            }
          ) : /* @__PURE__ */ d(lc, { items: l, icon: Tm, size: "sm" }))
        ]
      }
    );
  }
);
i$.displayName = "FileItem";
const VYe = X(
  function({ content: e, className: n, ...i }, r) {
    return /* @__PURE__ */ d(
      "div",
      {
        ref: r,
        className: E("rich-text-display-container", n),
        dangerouslySetInnerHTML: { __html: e },
        ...i
      }
    );
  }
), Iqe = ({
  labels: t,
  setLastIntent: e,
  lastIntent: n,
  setIsAcceptChangesOpen: i,
  editor: r,
  handleEnhanceWithAI: a
}) => {
  const o = et();
  return /* @__PURE__ */ k("div", { className: "dark flex items-center gap-1 rounded-md border border-solid border-f1-border bg-f1-background p-0.5 drop-shadow-sm", children: [
    /* @__PURE__ */ d(
      ue,
      {
        label: (t == null ? void 0 : t.rejectChangesButtonLabel) || o.actions.cancel,
        onClick: (s) => {
          s.preventDefault(), r.chain().focus().undo().run(), i(!1), r.setEditable(!0), e(null);
        },
        size: "sm",
        variant: "outline",
        icon: Rr,
        type: "button"
      }
    ),
    /* @__PURE__ */ d(
      ue,
      {
        label: (t == null ? void 0 : t.repeatButtonLabel) || o.collections.filters.retry,
        onClick: (s) => {
          s.preventDefault(), r.chain().focus().undo().run(), a(
            n == null ? void 0 : n.selectedIntent,
            n == null ? void 0 : n.customIntent
          );
        },
        size: "sm",
        variant: "outline",
        icon: sT,
        type: "button"
      }
    ),
    /* @__PURE__ */ d(js, {}),
    /* @__PURE__ */ d(
      ue,
      {
        label: (t == null ? void 0 : t.acceptChangesButtonLabel) || o.actions.save,
        onClick: (s) => {
          s.preventDefault(), i(!1), r.setEditable(!0), e(null);
        },
        size: "sm",
        variant: "default",
        icon: Nm,
        type: "button"
      }
    )
  ] });
}, Rqe = ({ label: t, isFullscreen: e }) => /* @__PURE__ */ d(
  "div",
  {
    className: E(
      "absolute left-0 top-0 z-50 flex h-full w-full items-center justify-center rounded-xl bg-f1-background p-2",
      !e && "max-h-60"
    ),
    children: /* @__PURE__ */ k("div", { className: "flex h-full w-full flex-row items-center justify-center gap-3 rounded-md bg-gradient-to-r from-[#f9f0dd80] to-[#d4ccfd80]", children: [
      /* @__PURE__ */ d(pc, { size: "small" }),
      /* @__PURE__ */ d("p", { className: "font-medium", children: t || "Loading..." })
    ] })
  }
), jqe = ({
  error: t,
  closeErrorButtonLabel: e,
  editor: n,
  errorConfig: i,
  setError: r
}) => /* @__PURE__ */ k("div", { className: "flex w-max max-w-full items-center gap-10 rounded-md bg-f1-background-critical p-1 drop-shadow-sm", children: [
  /* @__PURE__ */ k("div", { className: "flex w-full flex-row items-center gap-2", children: [
    /* @__PURE__ */ d("div", { className: "flex-shrink-0", children: /* @__PURE__ */ d(Gd, { size: "sm", type: "critical" }) }),
    /* @__PURE__ */ d(
      "p",
      {
        className: "w-full max-w-xl flex-grow truncate text-ellipsis text-sm font-semibold text-f1-foreground-critical",
        title: t || "Error",
        children: t || "Error"
      }
    )
  ] }),
  /* @__PURE__ */ d("div", { className: "mr- flex-shrink-0", children: /* @__PURE__ */ d(
    ue,
    {
      variant: "outline",
      onClick: (a) => {
        a.preventDefault(), r(null), n.setEditable(!0), i != null && i.onClose && i.onClose();
      },
      label: e || "Continue editing",
      type: "button",
      size: "sm"
    }
  ) })
] }), mi = {
  PDF: "pdf",
  IMAGE: "image",
  DOC: "doc",
  EXCEL: "excel",
  PPT: "ppt",
  TXT: "txt",
  VIDEO: "video",
  AUDIO: "audio",
  ARCHIVE: "archive",
  CSV: "csv",
  HTML: "html",
  MARKDOWN: "markdown"
}, Fqe = (t, e, n, i) => {
  if (n) {
    const r = n.multipleFiles ? [...e, ...t] : t;
    i(r), n.onFiles(r);
  }
}, zqe = (t, e, n, i) => {
  if (n) {
    const r = [...e];
    r.splice(t, 1), i(r), n.onFiles(r);
  }
}, Vqe = (t) => t != null && t.acceptedFileType && t.acceptedFileType.length > 0 ? t.acceptedFileType.map((e) => {
  switch (e) {
    case mi.IMAGE:
      return "image/*";
    case mi.VIDEO:
      return "video/*";
    case mi.PDF:
      return "application/pdf";
    case mi.DOC:
      return "application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document";
    case mi.EXCEL:
      return "application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    case mi.PPT:
      return "application/vnd.ms-powerpoint, application/vnd.openxmlformats-officedocument.presentationml.presentation";
    case mi.TXT:
      return "text/plain";
    case mi.AUDIO:
      return "audio/*";
    case mi.ARCHIVE:
      return ".zip,.rar,.tar,.gz,.7z";
    case mi.CSV:
      return "text/csv";
    case mi.HTML:
      return "text/html";
    case mi.MARKDOWN:
      return "text/markdown";
    default:
      return "";
  }
}).filter(Boolean).join(", ") : "*", Hqe = ({
  filesConfig: t,
  files: e,
  setFiles: n,
  disabled: i,
  fileInputRef: r
}) => {
  if (!t) return null;
  const a = (o) => {
    const s = o.target.files;
    if (s && s.length > 0) {
      let l = Array.from(s);
      t != null && t.maxFileSize && (l = l.filter(
        (c) => c.size <= t.maxFileSize
      )), Fqe(l, e, t, n);
    }
    r.current && (r.current.value = "");
  };
  return /* @__PURE__ */ k(Ee, { children: [
    /* @__PURE__ */ d(
      "input",
      {
        id: "rich-text-editor-upload-button",
        type: "file",
        multiple: t.multipleFiles,
        onChange: a,
        ref: r,
        className: "hidden",
        accept: Vqe(t),
        "aria-label": "Upload file"
      }
    ),
    /* @__PURE__ */ d(Ue, { children: e.length > 0 && /* @__PURE__ */ d(
      re.div,
      {
        initial: { height: 0, opacity: 0, y: -20 },
        animate: { height: "auto", opacity: 1, y: 0 },
        exit: { height: 0, opacity: 0, y: -20 },
        transition: { duration: 0.3 },
        children: /* @__PURE__ */ d("div", { className: "scrollbar-macos flex w-full items-end gap-2 overflow-x-auto pt-2", children: e.map((o, s) => /* @__PURE__ */ d(
          i$,
          {
            file: o,
            actions: [
              {
                label: "Delete",
                onClick: () => zqe(s, e, t, n)
              }
            ],
            disabled: i
          },
          `${o.name}-${s}`
        )) })
      },
      "filelist-accordion"
    ) })
  ] });
}, S4 = ({ option: t, onClick: e, selectedOption: n = null }) => /* @__PURE__ */ k(
  "div",
  {
    onClick: () => e(t),
    className: E(
      "flex cursor-pointer flex-row items-center gap-2 rounded-md bg-f1-background p-2 hover:bg-f1-background-secondary",
      (n == null ? void 0 : n.id) === t.id && "bg-f1-background-secondary"
    ),
    children: [
      /* @__PURE__ */ d("p", { className: "text-neutral-40 text-md grow text-ellipsis font-normal", children: t.label }),
      t.subOptions && t.subOptions.length > 0 && /* @__PURE__ */ d(me, { icon: Oa, size: "md", className: "text-f1-icon" })
    ]
  }
), Bqe = ({
  onSelect: t,
  onClose: e,
  enhancementOptions: n,
  inputPlaceholder: i
}) => {
  const [r, a] = q(null), [o, s] = q(""), l = Oe(null), c = Oe(null), u = Oe(null);
  le(() => {
    l.current && l.current.focus();
  }, []), le(() => {
    const g = (y) => {
      var b, M;
      if (!r || !(y.target instanceof Element)) return;
      const v = (b = c.current) == null ? void 0 : b.contains(y.target), w = (M = u.current) == null ? void 0 : M.contains(y.target), x = y.target.closest(".option-item");
      !w && (!v || v && (x == null ? void 0 : x.id) !== r.id) && a(null);
    };
    return r && document.addEventListener("mousedown", g), () => {
      document.removeEventListener("mousedown", g);
    };
  }, [r]);
  const f = (g) => {
    g.subOptions && g.subOptions.length > 0 ? a(
      (y) => (y == null ? void 0 : y.id) === g.id ? null : g
    ) : (t({ selectedIntent: g.id, customIntent: void 0 }), e());
  }, m = (g) => {
    t({ selectedIntent: g.id, customIntent: void 0 }), e();
  }, h = (g) => {
    g.key === "Enter" && o.trim() && (t({
      selectedIntent: void 0,
      customIntent: o.trim()
    }), s(""), e());
  }, p = n.filter(
    (g) => g.label.toLowerCase().includes(o.toLowerCase())
  );
  return /* @__PURE__ */ k("div", { className: "relative", children: [
    /* @__PURE__ */ k(
      "div",
      {
        ref: c,
        className: "flex max-h-60 w-80 flex-col overflow-hidden rounded-lg border border-solid border-f1-border bg-f1-background drop-shadow-sm",
        children: [
          /* @__PURE__ */ d("div", { className: "flex w-full flex-row items-center p-2", children: /* @__PURE__ */ d(
            Fr,
            {
              icon: Ly,
              type: "text",
              placeholder: i,
              autoFocus: !0,
              value: o,
              onChange: (g) => s(g.target.value),
              onKeyDown: h,
              ref: l
            }
          ) }),
          n.length > 0 && /* @__PURE__ */ d("div", { className: "scrollbar-macos flex flex-col overflow-y-auto px-1 pb-1", children: p.map((g) => /* @__PURE__ */ d("div", { id: g.id, className: "option-item", children: /* @__PURE__ */ d(
            S4,
            {
              onClick: f,
              option: g,
              selectedOption: r
            }
          ) }, g.id)) })
        ]
      }
    ),
    /* @__PURE__ */ d(Ue, { children: r && r.subOptions && r.subOptions.length > 0 && /* @__PURE__ */ d(
      re.div,
      {
        ref: u,
        className: "absolute bottom-0 left-full z-50 max-h-60 w-60 overflow-y-auto rounded-lg border border-solid border-f1-border bg-f1-background p-1 drop-shadow-sm",
        style: { marginLeft: "8px" },
        initial: { opacity: 0, x: -10 },
        animate: { opacity: 1, x: 0 },
        exit: { opacity: 0, x: -10 },
        transition: { duration: 0.2 },
        children: /* @__PURE__ */ d("div", { className: "scrollbar-macos flex flex-col overflow-y-auto", children: r.subOptions.map((g) => /* @__PURE__ */ d(
          S4,
          {
            onClick: m,
            option: g
          },
          g.id
        )) })
      }
    ) })
  ] });
}, qqe = ({
  editor: t,
  onEnhanceWithAI: e,
  isLoadingEnhance: n,
  enhanceConfig: i,
  disableButtons: r,
  hideLabel: a,
  position: o = "bottom",
  setLastIntent: s
}) => {
  const l = Oe(null), [c, u] = q(!1), f = (m) => {
    m.preventDefault(), l.current ? u((h) => !h) : u(!1);
  };
  return /* @__PURE__ */ k(
    Jd,
    {
      open: c,
      modal: !1,
      onOpenChange: (m) => {
        u(m), m || t.view.dom.classList.remove("maintain-selection");
      },
      children: [
        /* @__PURE__ */ d(Oy, { asChild: !0, children: /* @__PURE__ */ k(
          ga,
          {
            type: "button",
            ref: l,
            variant: "outline",
            size: "md",
            onClick: (m) => {
              f(m);
            },
            disabled: r || n,
            className: E(
              "bg-gradient-to-r from-[#f9f0dd80] to-[#d4ccfd80] text-[#6143a7] dark:from-[#6143a7] dark:to-[#7846ef] dark:text-f1-foreground [&>button>svg]:text-[#6143a7] dark:[&>button>svg]:text-f1-foreground",
              a && "[&>button]:aspect-square [&>button]:px-0"
            ),
            children: [
              /* @__PURE__ */ d(me, { icon: Ly }),
              !a && ((i == null ? void 0 : i.enhanceLabels.enhanceButtonLabel) ?? "Magic")
            ]
          }
        ) }),
        /* @__PURE__ */ d(Wy, { container: document.body, children: /* @__PURE__ */ d(
          Qd,
          {
            side: o,
            align: "start",
            sideOffset: 10,
            alignOffset: 0,
            collisionPadding: 10,
            style: { zIndex: 9999 },
            children: /* @__PURE__ */ d(Ue, { children: c && /* @__PURE__ */ d(
              re.div,
              {
                initial: { opacity: 0, scale: 0.95, y: 10 },
                animate: { opacity: 1, scale: 1, y: 0 },
                exit: { opacity: 0, scale: 0.95, y: 10 },
                transition: { duration: 0.2 },
                children: /* @__PURE__ */ d(
                  Bqe,
                  {
                    onSelect: ({ selectedIntent: m, customIntent: h }) => {
                      e(m, h), s({
                        selectedIntent: m || void 0,
                        customIntent: h || void 0
                      }), u(!1);
                    },
                    onClose: () => {
                      u(!1);
                    },
                    enhancementOptions: (i == null ? void 0 : i.enhancementOptions) || [],
                    inputPlaceholder: (i == null ? void 0 : i.enhanceLabels.customPromptPlaceholder) || ""
                  }
                )
              }
            ) })
          }
        ) })
      ]
    }
  );
}, yo = (t) => t ? t.toLowerCase().replace(" ", "-") : "", Gqe = (t) => t ? Array.isArray(t) ? t : [t] : [], Xqe = (t, e) => {
  var a;
  const n = t ? [
    {
      label: t.action.label,
      value: yo(t.action.label),
      icon: t.action.icon
    }
  ] : [], i = ((a = t == null ? void 0 : t.subActions) == null ? void 0 : a.map((o) => ({
    label: o.label,
    value: yo(o.label),
    icon: o.icon
  }))) || [], r = (e == null ? void 0 : e.map((o) => ({
    label: o.label,
    value: yo(o.label),
    icon: "icon" in o ? o.icon : void 0
  }))) || [];
  return [...n, ...i, ...r];
}, Yqe = (t, e, n) => {
  var r, a;
  if (t === yo(e == null ? void 0 : e.action.label)) {
    e == null || e.action.onClick();
    return;
  }
  const i = n == null ? void 0 : n.find(
    (o) => yo(o.label) === t
  );
  if (i) {
    i.onClick();
    return;
  }
  (a = (r = e == null ? void 0 : e.subActions) == null ? void 0 : r.find((o) => yo(o.label) === t)) == null || a.onClick();
}, Kqe = ({
  secondaryActions: t,
  useLittleMode: e,
  primaryAction: n,
  isFullscreen: i,
  disableButtons: r
}) => {
  if (t.length === 0)
    return null;
  const o = t.filter(
    (c) => c.type === "switch"
  ), s = t.filter(
    (c) => c.type !== "switch"
  ), l = e && n && !i && s.length > 0;
  return /* @__PURE__ */ k("div", { className: "flex items-center gap-3", children: [
    o.map((c, u) => {
      const f = c;
      return /* @__PURE__ */ d(
        qL,
        {
          title: c.label,
          checked: f.checked || !1,
          onCheckedChange: (m) => {
            c.onClick(m);
          },
          disabled: r || c.disabled,
          hideLabel: f.hideLabel || !1
        },
        `switch-${u}`
      );
    }),
    !l && s.map((c, u) => /* @__PURE__ */ d(
      ue,
      {
        onClick: (f) => {
          f.preventDefault(), c.onClick();
        },
        variant: "variant" in c ? c.variant : "outline",
        size: "md",
        label: c.label,
        disabled: r || c.disabled,
        type: "button",
        icon: "icon" in c ? c.icon : void 0
      },
      `button-${u}`
    ))
  ] });
}, N4 = ({
  primaryAction: t,
  disableButtons: e,
  onClick: n
}) => /* @__PURE__ */ d(
  ue,
  {
    onClick: n,
    variant: t.variant ?? "default",
    size: "md",
    label: t.label || "",
    disabled: e || t.disabled,
    icon: t.icon,
    type: "button"
  }
), Uqe = ({
  primaryAction: t,
  isFullscreen: e,
  listOfActions: n,
  handleOnClick: i,
  disableButtons: r,
  includeSecondaryInDropdown: a
}) => {
  var o, s;
  return e ? /* @__PURE__ */ k(Ee, { children: [
    (o = t.subActions) == null ? void 0 : o.map((l) => /* @__PURE__ */ d(
      ue,
      {
        onClick: (c) => {
          c.preventDefault(), l.onClick();
        },
        variant: t.action.variant ?? "default",
        size: "md",
        label: l.label,
        disabled: r || l.disabled,
        icon: l.icon,
        type: "button"
      },
      yo(l.label)
    )),
    ((s = t.subActions) == null ? void 0 : s.length) && /* @__PURE__ */ d(js, {}),
    /* @__PURE__ */ d(
      N4,
      {
        primaryAction: t.action,
        disableButtons: r,
        onClick: (l) => {
          l.preventDefault(), t.action.onClick();
        }
      }
    )
  ] }) : t.subActions || a ? /* @__PURE__ */ d(
    ws,
    {
      items: n,
      onClick: i,
      variant: t.action.variant ?? "default",
      disabled: r,
      size: "md"
    }
  ) : /* @__PURE__ */ d(
    N4,
    {
      primaryAction: t.action,
      disableButtons: r,
      onClick: (l) => {
        l.preventDefault(), t.action.onClick();
      }
    }
  );
}, Jqe = ({
  secondaryAction: t,
  primaryAction: e,
  useLittleMode: n,
  disableButtons: i,
  isFullscreen: r
}) => {
  const a = Gqe(t);
  if (a.length === 0 && !e) return null;
  const o = a.filter(
    (f) => f.type !== "switch"
  ), s = o.length > 0 && n && e && !r, l = Xqe(
    e,
    s ? o : void 0
  ), c = (f) => Yqe(f, e, a), u = a.length > 0 && e && (!n || a.some((f) => f.type === "switch") || r);
  return /* @__PURE__ */ k("div", { className: "scrollbar-macos flex items-center gap-2 overflow-x-auto overflow-y-hidden", children: [
    /* @__PURE__ */ d(
      Kqe,
      {
        secondaryActions: a,
        useLittleMode: n,
        primaryAction: e,
        isFullscreen: r,
        disableButtons: i
      }
    ),
    u && /* @__PURE__ */ d(js, {}),
    e && Uqe({
      primaryAction: e,
      isFullscreen: r,
      listOfActions: l,
      handleOnClick: c,
      disableButtons: i,
      includeSecondaryInDropdown: s ?? !1
    })
  ] });
}, Qqe = ({
  editor: t,
  maxCharacters: e,
  secondaryAction: n,
  primaryAction: i,
  fileInputRef: r,
  canUseFiles: a,
  onEnhanceWithAI: o,
  isLoadingEnhance: s,
  enhanceConfig: l,
  isFullscreen: c,
  setLastIntent: u,
  toolbarLabels: f,
  disableButtons: m,
  setIsToolbarOpen: h,
  isToolbarOpen: p,
  plainHtmlMode: g
}) => {
  const [y, v] = q(!1), w = Oe(null), [x, b] = q(0);
  le(() => {
    w.current && b(w.current.offsetWidth);
    const _ = () => {
      w.current && b(w.current.offsetWidth);
    };
    return window.addEventListener("resize", _), () => window.removeEventListener("resize", _);
  }, []);
  const M = x < 500;
  return /* @__PURE__ */ k("div", { ref: w, className: "flex max-w-full items-center gap-2 py-3", children: [
    /* @__PURE__ */ k("div", { className: "relative flex flex-grow items-center gap-2", children: [
      /* @__PURE__ */ d(
        re.div,
        {
          initial: { width: 0 },
          animate: { width: p ? "100%" : 0 },
          transition: {
            duration: 0.3,
            delay: p ? 0.15 : 0,
            ease: "easeInOut"
          },
          onAnimationComplete: () => v(p),
          className: "absolute left-0 top-0 z-10 h-full bg-f1-background",
          "aria-label": "Rich text editor toolbar",
          children: /* @__PURE__ */ d(
            D7,
            {
              labels: f,
              editor: t,
              isFullscreen: c,
              disableButtons: m,
              onClose: () => {
                h(!1), v(!1);
              },
              animationComplete: y,
              plainHtmlMode: g
            }
          )
        }
      ),
      /* @__PURE__ */ k(
        re.div,
        {
          className: "flex items-center gap-2 overflow-hidden",
          initial: { opacity: 1 },
          animate: {
            opacity: p ? 0 : 1
          },
          transition: {
            duration: p ? 0.15 : 0.25,
            delay: p ? 0 : 0.2,
            ease: "easeInOut"
          },
          children: [
            /* @__PURE__ */ d(
              ue,
              {
                onClick: (_) => {
                  _.preventDefault(), h(!0);
                },
                variant: "outline",
                size: "md",
                label: "Toolbar",
                disabled: m,
                type: "button",
                hideLabel: !0,
                round: !0,
                icon: MT
              }
            ),
            a && /* @__PURE__ */ d(
              ue,
              {
                icon: JE,
                onClick: (_) => {
                  if (_.preventDefault(), r != null && r.current)
                    r.current.click();
                  else {
                    const N = document.getElementById(
                      "rich-text-editor-upload-button"
                    );
                    N == null || N.click();
                  }
                },
                hideLabel: !0,
                round: !0,
                label: "Add Attachment",
                variant: "outline",
                type: "button",
                disabled: m
              }
            ),
            l && /* @__PURE__ */ k(Ee, { children: [
              /* @__PURE__ */ d(js, {}),
              /* @__PURE__ */ d(
                qqe,
                {
                  editor: t,
                  onEnhanceWithAI: o,
                  isLoadingEnhance: s,
                  enhanceConfig: l,
                  disableButtons: m,
                  hideLabel: M,
                  setLastIntent: u,
                  position: "top"
                }
              )
            ] }),
            e && !M && /* @__PURE__ */ k("p", { className: "text-sm font-normal text-f1-foreground-secondary", children: [
              t.storage.characterCount.characters(),
              "/",
              e
            ] })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ d(
      Jqe,
      {
        primaryAction: i,
        secondaryAction: n,
        useLittleMode: M,
        disableButtons: m,
        isFullscreen: c
      }
    )
  ] });
}, Zqe = ({
  isFullscreen: t,
  handleToggleFullscreen: e,
  disableAllButtons: n,
  title: i
}) => /* @__PURE__ */ k(Ee, { children: [
  /* @__PURE__ */ d("div", { className: "absolute right-3 top-3 z-50", children: /* @__PURE__ */ d(
    ue,
    {
      onClick: (r) => {
        r.preventDefault(), e();
      },
      label: "Fullscreen",
      "aria-label": "Toggle fullscreen mode",
      variant: "outline",
      type: "button",
      hideLabel: !0,
      round: !0,
      size: "sm",
      icon: t ? HE : jE,
      disabled: n
    }
  ) }),
  t && /* @__PURE__ */ d("div", { className: "pl-3 pr-10 pt-3", children: /* @__PURE__ */ d("h1", { className: "font-bold truncate text-ellipsis text-lg", children: i }) })
] });
function eGe(t) {
  const e = t.state.selection.to !== t.state.selection.from ? t.state.selection : null, n = t.getHTML(), i = (e == null ? void 0 : e.from) ?? 0, r = (e == null ? void 0 : e.to) ?? t.state.doc.content.size;
  let a = e ? t.state.doc.textBetween(i, r, " ") : n;
  return a.length > 5e3 && (a = a.substring(0, 5e3)), {
    text: a,
    from: i,
    to: r,
    isFullDocumentSelected: !e
  };
}
function tGe(t, e, n) {
  const i = t.getHTML();
  if (i.length < 1e4)
    return i;
  const r = 2500, a = 2500, o = Math.max(0, e - r), s = t.state.doc.textBetween(o, e, " "), l = Math.min(t.state.doc.content.size, n + a), c = t.state.doc.textBetween(n, l, " ");
  return s + " " + c;
}
function nGe(t, e, n, i, r) {
  r ? t.chain().focus().setContent(e).run() : t.chain().focus().deleteRange({ from: n, to: i }).insertContent(e).run();
}
function iGe(t) {
  return t.trim().length > 0;
}
async function rGe({
  editor: t,
  enhanceText: e,
  setIsLoadingEnhance: n,
  selectedIntent: i,
  customIntent: r,
  onSuccess: a,
  onError: o
}) {
  const {
    text: s,
    from: l,
    to: c,
    isFullDocumentSelected: u
  } = eGe(t);
  if (!iGe(s)) return;
  const f = tGe(t, l, c);
  try {
    n(!0);
    const { success: m, text: h, error: p } = await e({
      text: s,
      selectedIntent: i,
      customIntent: r,
      context: f
    });
    m ? (nGe(
      t,
      h,
      l,
      c,
      u || s.toString() === t.getHTML().toString()
    ), a()) : o(p);
  } catch {
    o();
  } finally {
    n(!1);
  }
}
const aGe = ({
  mentionsConfig: t,
  mentionSuggestions: e,
  setMentionSuggestions: n,
  placeholder: i,
  maxCharacters: r,
  plainHtmlMode: a = !1
}) => [
  Ab,
  xb,
  wb,
  vb,
  kb,
  Ib,
  Wb,
  Rb,
  ...a ? [] : [Lb, _b, bb],
  U7(i),
  Tze(r),
  ...zze(
    e,
    n,
    t
  ),
  G7(i)
], oGe = (t, e = 240) => t.current ? t.current.clientHeight >= e : !1, $4 = (t) => {
  if (!t.current) return !0;
  const e = t.current;
  return e.scrollHeight - e.scrollTop - e.clientHeight < 1;
}, sGe = (t) => {
  switch (t) {
    case "xxs":
      return 80;
    case "xs":
      return 112;
    case "sm":
      return 160;
    case "md":
      return 208;
    case "lg":
      return 240;
    case "xl":
      return 288;
    case "2xl":
      return 320;
    case "3xl":
      return 384;
    case "full":
      return 1 / 0;
    case "auto":
      return 240;
    default:
      return 240;
  }
}, lGe = (t) => {
  if (t === "xxs") return "h-20";
  if (t === "xs") return "h-28";
  if (t === "sm") return "h-40";
  if (t === "md") return "h-52";
  if (t === "lg") return "h-60";
  if (t === "xl") return "h-72";
  if (t === "2xl") return "h-80";
  if (t === "3xl") return "h-96";
  if (t === "full") return "h-full";
  if (t === "auto") return "h-auto max-h-60";
}, dGe = ({
  containerRef: t,
  onHeightChange: e,
  onScrollChange: n,
  heightThreshold: i = 240
}) => {
  const r = () => {
    e(oGe(t, i)), n($4(t));
  };
  r();
  const a = t.current;
  if (!a) return () => {
  };
  const o = () => {
    n($4(t));
  };
  a.addEventListener("scroll", o);
  const s = new ResizeObserver(r);
  return s.observe(a), () => {
    a.removeEventListener("scroll", o), s.disconnect();
  };
}, cGe = ({
  editor: t,
  onChange: e,
  setEditorState: n
}) => {
  n({
    html: t.getHTML(),
    json: null
  });
  const i = [];
  if (t.state.doc.descendants((a) => {
    a.type.name === "mention" && i.push(Number(a.attrs.id));
  }), t.isEmpty)
    e({ value: null });
  else {
    const a = t.getHTML();
    i.length > 0 ? e({
      value: a,
      mentionIds: i
    }) : e({ value: a });
  }
}, uGe = ({ editor: t, content: e }) => {
  if (!t) return null;
  t.commands.setContent(e);
}, fGe = X(function({
  mentionsConfig: e,
  enhanceConfig: n,
  filesConfig: i,
  secondaryAction: r,
  primaryAction: a,
  maxCharacters: o,
  initialEditorState: s,
  onChange: l,
  placeholder: c,
  toolbarLabels: u,
  title: f,
  errorConfig: m,
  height: h = "auto",
  plainHtmlMode: p = !1
}, g) {
  const y = Wa(), v = Oe(null), w = Oe(null), x = Oe(null), [b, M] = q(!1), [_, N] = q(!0), [$, D] = q(!1), [W, j] = q(!1), [O, I] = q(!1), [L, R] = q(!1), [B, F] = q(null), [z, K] = q(!1), [ae, Q] = q(null), [te, be] = q((s == null ? void 0 : s.files) || []), [Pe, We] = q(
    (e == null ? void 0 : e.users) || []
  ), [$e, Y] = q({
    html: (s == null ? void 0 : s.content) || "",
    json: null
  });
  le(() => (W ? document.body.style.overflow = "hidden" : document.body.style.overflow = "", () => {
    document.body.style.overflow = "";
  }), [W]), le(() => {
    const _e = W ? window.innerHeight : sGe(h);
    return dGe({
      containerRef: x,
      onHeightChange: M,
      onScrollChange: N,
      heightThreshold: _e
    });
  }, [h, W]), le(() => {
    if ($ && x.current) {
      const _e = x.current.getBoundingClientRect().height;
      R(_e < 64);
    } else
      R(!1);
  }, [$]);
  const oe = () => {
    J && Y({
      ...$e,
      json: J.getJSON()
    }), j((_e) => !_e);
  }, se = !!(O || $ || B), J = gb(
    {
      extensions: aGe({
        mentionsConfig: e,
        mentionSuggestions: Pe,
        setMentionSuggestions: We,
        placeholder: c,
        maxCharacters: o,
        plainHtmlMode: p
      }),
      content: $e.json || $e.html,
      onUpdate: ({ editor: _e }) => {
        cGe({ editor: _e, onChange: l, setEditorState: Y });
      }
    },
    [W]
  );
  le(() => {
    B && J && J.setEditable(!1);
  }, [B, J]), le(() => {
    J && $e.json && Y({
      ...$e,
      json: null
    });
  }, [J, $e]), Dm(g, () => ({
    clear: () => J == null ? void 0 : J.commands.clearContent(),
    clearFiles: () => {
      be([]), i && i.onFiles([]);
    },
    focus: () => J == null ? void 0 : J.commands.focus(),
    setError: (_e) => {
      F(_e), _e ? J == null || J.setEditable(!1) : J == null || J.setEditable(!0);
    },
    setContent: (_e) => {
      J && (uGe({ editor: J, content: _e }), Y({
        html: _e,
        json: null
      }));
    }
  }));
  const xe = async (_e, ce) => {
    n && J && await rGe({
      editor: J,
      enhanceText: n.onEnhanceText,
      setIsLoadingEnhance: D,
      onSuccess: () => {
        J.setEditable(!1), I(!0);
      },
      onError: (wt) => {
        I(!1), F(wt || n.enhanceLabels.defaultError);
      },
      selectedIntent: _e,
      customIntent: ce
    });
  };
  if (!J) return null;
  const De = /* @__PURE__ */ k(
    "div",
    {
      ref: w,
      id: y,
      className: E(
        "rich-text-editor-container flex flex-col bg-f1-background",
        W ? "fixed inset-0 z-50" : "relative w-full rounded-xl border border-solid border-f1-border"
      ),
      children: [
        /* @__PURE__ */ d(
          Zqe,
          {
            isFullscreen: W,
            handleToggleFullscreen: oe,
            disableAllButtons: se,
            title: f
          }
        ),
        /* @__PURE__ */ k(
          "div",
          {
            className: "relative w-full flex-grow overflow-hidden",
            onClick: () => J == null ? void 0 : J.commands.focus(),
            children: [
              /* @__PURE__ */ d(
                "div",
                {
                  ref: x,
                  className: E(
                    "scrollbar-macos relative flex w-full items-start justify-center overflow-y-auto pb-1 pl-3 pr-10 pt-3",
                    W ? "h-full" : lGe(h)
                  ),
                  children: /* @__PURE__ */ d(
                    re.div,
                    {
                      className: E(
                        "w-full overflow-hidden",
                        W && "max-w-4xl"
                      ),
                      initial: !1,
                      animate: {
                        minHeight: L ? "4rem" : "auto",
                        opacity: L ? 0.8 : 1,
                        scale: L ? 0.98 : 1
                      },
                      transition: {
                        duration: 0.4,
                        ease: [0.04, 0.62, 0.23, 0.98]
                      },
                      children: /* @__PURE__ */ d(hb, { editor: J })
                    }
                  )
                }
              ),
              /* @__PURE__ */ d(Ue, { children: $ && /* @__PURE__ */ d(
                re.div,
                {
                  initial: { opacity: 0, scale: 0.95 },
                  animate: { opacity: 1, scale: 1 },
                  exit: { opacity: 0, scale: 0.95 },
                  transition: { duration: 0.3, ease: "easeInOut" },
                  className: "absolute inset-0",
                  children: /* @__PURE__ */ d(
                    Rqe,
                    {
                      isFullscreen: W,
                      label: n == null ? void 0 : n.enhanceLabels.loadingEnhanceLabel
                    }
                  )
                },
                "loading-enhance"
              ) })
            ]
          }
        ),
        /* @__PURE__ */ k(
          "div",
          {
            className: E(
              "rounded-b-lg bg-f1-background px-3",
              b && !_ && "shadow-editor-tools"
            ),
            children: [
              /* @__PURE__ */ d(Ue, { children: (O || B) && /* @__PURE__ */ k(
                re.div,
                {
                  initial: { height: 0, opacity: 0, y: -20 },
                  animate: { height: "auto", opacity: 1, y: 0 },
                  exit: { height: 0, opacity: 0, y: -20 },
                  transition: { duration: 0.3 },
                  className: "flex w-full items-center justify-center pt-2",
                  children: [
                    O && /* @__PURE__ */ d(
                      Iqe,
                      {
                        labels: n == null ? void 0 : n.enhanceLabels,
                        setLastIntent: Q,
                        setIsAcceptChangesOpen: I,
                        editor: J,
                        handleEnhanceWithAI: xe,
                        lastIntent: ae
                      }
                    ),
                    B && /* @__PURE__ */ d(
                      jqe,
                      {
                        error: B,
                        setError: F,
                        editor: J,
                        errorConfig: m,
                        closeErrorButtonLabel: m == null ? void 0 : m.closeErrorButtonLabel
                      }
                    )
                  ]
                },
                "accordion"
              ) }),
              /* @__PURE__ */ d(
                Hqe,
                {
                  files: te,
                  disabled: se,
                  filesConfig: i,
                  setFiles: be,
                  fileInputRef: v
                }
              ),
              /* @__PURE__ */ d(
                Qqe,
                {
                  editor: J,
                  maxCharacters: o,
                  secondaryAction: r,
                  primaryAction: a,
                  fileInputRef: v,
                  canUseFiles: !!i,
                  isLoadingEnhance: $,
                  disableButtons: se,
                  enhanceConfig: n,
                  isFullscreen: W,
                  onEnhanceWithAI: xe,
                  setLastIntent: Q,
                  toolbarLabels: u,
                  setIsToolbarOpen: K,
                  isToolbarOpen: z,
                  plainHtmlMode: p
                }
              ),
              /* @__PURE__ */ d(
                E7,
                {
                  editorId: y,
                  editor: J,
                  disableButtons: se,
                  toolbarLabels: u,
                  isToolbarOpen: z,
                  isFullscreen: W,
                  plainHtmlMode: p
                }
              )
            ]
          }
        )
      ]
    }
  );
  return W ? Em.createPortal(De, document.body) : De;
}), mGe = ({ rows: t = 2 }) => {
  const e = ["75%", "100%", "60%", "85%", "70%"], n = Array.from(
    { length: t },
    (i, r) => e[r % e.length]
  );
  return /* @__PURE__ */ k("div", { className: "relative flex w-full flex-col rounded-xl border border-solid border-f1-border bg-f1-background", children: [
    /* @__PURE__ */ d("div", { className: "relative w-full flex-grow overflow-hidden", children: /* @__PURE__ */ d("div", { className: "h-auto w-full pl-3 pr-4 pt-3", children: /* @__PURE__ */ d("div", { className: "flex flex-col gap-2", children: n.map((i, r) => /* @__PURE__ */ d(Ce, { className: "h-4", style: { width: i } }, r)) }) }) }),
    /* @__PURE__ */ d("div", { className: "px-3 py-3", children: /* @__PURE__ */ k("div", { className: "flex items-center justify-between", children: [
      /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ d(Ce, { className: "h-8 w-8 rounded-md" }),
        /* @__PURE__ */ d(Ce, { className: "h-8 w-8 rounded-md" }),
        /* @__PURE__ */ d(Ce, { className: "h-8 w-8 rounded-md" })
      ] }),
      /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
        /* @__PURE__ */ d(Ce, { className: "h-8 w-24 rounded-md" }),
        /* @__PURE__ */ d(Ce, { className: "h-8 w-32 rounded-md" })
      ] })
    ] }) })
  ] });
}, HYe = Bt(
  fGe,
  mGe
), rw = {
  2: "gap-2",
  4: "gap-4",
  8: "gap-8"
}, hGe = It({
  base: "grid grid-cols-1",
  variants: {
    tileSize: {
      // The amount of columns and autoflow when paginating is an issue if we
      // want to prevent orphan elments. Say, we have 10 elements, we can't just
      // render 3 rows of 3 elements and then an orphan one in the end.
      //
      // This makes sure that everything will look nice when using pages of 48
      // elements, it will always result in even rows.
      sm: "@12xl:grid-cols-16 @md:grid-cols-2 @2xl:grid-cols-3 @4xl:grid-cols-4 @8xl:grid-cols-6 @10xl:grid-cols-8 @11xl:grid-cols-12",
      md: "@lg:grid-cols-2 @4xl:grid-cols-3 @7xl:grid-cols-4 @9xl:grid-cols-6 @10xl:grid-cols-8 @12xl:grid-cols-12",
      lg: "@3xl:grid-cols-2 @7xl:grid-cols-3 @9xl:grid-cols-4 @10xl:grid-cols-6 @12xl:grid-cols-8"
    },
    gap: {
      ...rw
    }
  },
  defaultVariants: {
    tileSize: "md",
    gap: "4"
  }
}), pGe = H.forwardRef(function({ className: e, gap: n, children: i, tileSize: r, ...a }, o) {
  return /* @__PURE__ */ d("div", { className: E("@container", "grow"), ref: o, ...a, children: /* @__PURE__ */ d(
    "div",
    {
      className: E(hGe({ gap: n, tileSize: r }), e),
      ref: o,
      ...a,
      children: i
    }
  ) });
}), gGe = It({
  base: "flex",
  variants: {
    overflow: {
      hidden: "overflow-hidden",
      auto: "overflow-auto"
    },
    paddingX: {
      none: "px-0",
      "p-2": "px-2",
      "p-4": "px-4",
      "p-8": "px-8",
      "p-12": "px-12",
      "p-16": "px-16"
    },
    maxWidth: {
      xs: "max-w-xs",
      sm: "max-w-sm",
      md: "max-w-md",
      xl: "max-w-xl",
      "screen-sm": "max-w-screen-sm",
      "screen-md": "max-w-screen-md",
      "screen-lg": "max-w-screen-lg",
      "screen-xl": "max-w-screen-xl",
      "screen-2xl": "max-w-screen-2xl"
    },
    height: {
      auto: "h-auto",
      full: "h-full"
    },
    width: {
      auto: "w-auto",
      full: "w-full"
    },
    paddingY: {
      none: "py-0",
      "p-2": "py-2",
      "p-4": "py-4",
      "p-8": "py-8",
      "p-12": "py-12",
      "p-16": "py-16"
    },
    basis: {
      0: "basis-0"
    },
    inline: {
      true: "inline-flex",
      false: "flex"
    },
    justifyContent: {
      center: "justify-center",
      end: "justify-end",
      "space-between": "justify-between",
      start: "justify-start",
      stretch: "justify-stretch"
    },
    alignItems: {
      center: "items-center",
      end: "items-end",
      "space-between": "items-between",
      start: "items-start",
      stretch: "items-stretch"
    },
    grow: {
      true: "flex-grow",
      false: "flex-grow-0"
    },
    shrink: {
      true: "flex-shrink",
      false: "flex-shrink-0"
    }
  },
  defaultVariants: {
    paddingX: "none",
    paddingY: "none",
    inline: !1
  }
}), r$ = X(function({
  className: e,
  grow: n,
  basis: i,
  shrink: r,
  paddingX: a,
  paddingY: o,
  inline: s,
  overflow: l,
  maxWidth: c,
  justifyContent: u,
  alignItems: f,
  height: m,
  width: h,
  ...p
}, g) {
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(
        gGe({
          paddingX: a,
          basis: i,
          paddingY: o,
          grow: n,
          shrink: r,
          inline: s,
          overflow: l,
          maxWidth: c,
          justifyContent: u,
          alignItems: f,
          height: m,
          width: h
        }),
        e
      ),
      ref: g,
      ...p
    }
  );
}), yGe = It({
  base: "flex-row",
  variants: {
    gap: {
      ...rw
    },
    wrap: {
      true: "flex-wrap"
    }
  },
  defaultVariants: {
    wrap: !0
  }
}), vGe = H.forwardRef(function({ className: e, gap: n, wrap: i, ...r }, a) {
  return /* @__PURE__ */ d(
    r$,
    {
      className: E(yGe({ gap: n, wrap: i }), e),
      ref: a,
      ...r
    }
  );
}), bGe = It({
  base: "flex-col",
  variants: {
    gap: {
      ...rw
    }
  },
  defaultVariants: {}
}), wGe = X(function({ className: e, gap: n, children: i, ...r }, a) {
  return /* @__PURE__ */ d(
    r$,
    {
      className: E(bGe({ gap: n }), e),
      ref: a,
      ...r,
      children: i
    }
  );
}), BYe = ui(
  {
    name: "Stack",
    type: "layout"
  },
  wGe
), qYe = ui(
  {
    name: "Split",
    type: "layout"
  },
  vGe
), GYe = ui(
  {
    name: "AutoGrid",
    type: "layout"
  },
  pGe
), kGe = ({ children: t }) => {
  const { enabled: e } = h5();
  return /* @__PURE__ */ d(
    "div",
    {
      className: E(
        "inline-flex ring-1 ring-inset ring-transparent transition-all duration-150",
        e && "select-none overflow-hidden rounded-sm bg-f1-background-tertiary ring-f1-border-secondary"
      ),
      "aria-hidden": e,
      children: /* @__PURE__ */ d(
        re.div,
        {
          className: "h-full w-full",
          animate: {
            opacity: e ? 0 : 1,
            scale: e ? 0.95 : 1
          },
          transition: { duration: 0.15 },
          children: t
        }
      )
    }
  );
}, xGe = () => /* @__PURE__ */ d("div", { className: "min-h-[0.15rem] min-w-[0.15rem] rounded-full bg-f1-foreground-secondary" }), _Ge = X(function({ header: e, children: n, action: i, summaries: r, alert: a, status: o, fullHeight: s = !1 }, l) {
  const { enabled: c, toggle: u } = h5();
  le(() => {
    if (a && o)
      throw Error(
        "You cannot pass both alert and status at the same time to this component"
      );
  }, [a, o]);
  const f = (h) => !!h && !(H.isValidElement(h) && h.type === H.Fragment && H.Children.count(h.props.children) === 0), m = () => {
    var h, p;
    (p = (h = e == null ? void 0 : e.link) == null ? void 0 : h.onClick) == null || p.call(h);
  };
  return /* @__PURE__ */ k(
    Xd,
    {
      className: E(
        s ? "h-full" : "",
        "relative flex gap-3 border-f1-border-secondary"
      ),
      style: {
        backgroundColor: "hsl(var(--white-40))"
      },
      ref: l,
      children: [
        e && /* @__PURE__ */ d(Yd, { className: "-mr-1 -mt-1", children: /* @__PURE__ */ k("div", { className: "flex w-full flex-1 flex-col gap-4", children: [
          /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row flex-nowrap items-center justify-between gap-2", children: [
            /* @__PURE__ */ k("div", { className: "flex min-h-6 grow flex-row items-center gap-1 truncate", children: [
              e.title && /* @__PURE__ */ d(Kd, { className: "truncate", children: e.title }),
              e.subtitle && /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-1", children: [
                /* @__PURE__ */ d(xGe, {}),
                /* @__PURE__ */ d(Ty, { className: "truncate", children: e.subtitle })
              ] }),
              e.info && /* @__PURE__ */ d(Kt, { label: e.info, children: /* @__PURE__ */ d(
                me,
                {
                  icon: Ey,
                  size: "sm",
                  className: "text-f1-foreground-secondary"
                }
              ) }),
              e.count && /* @__PURE__ */ d("div", { className: "ml-0.5", children: /* @__PURE__ */ d(Lo, { value: e.count }) })
            ] }),
            /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-3", children: [
              a && /* @__PURE__ */ d(gc, { text: a, level: "critical" }),
              o && /* @__PURE__ */ d(Vr, { text: o.text, variant: o.variant }),
              e.link && /* @__PURE__ */ d(
                pD,
                {
                  onClick: m,
                  href: e.link.url,
                  title: e.link.title,
                  icon: e.link.icon
                }
              )
            ] })
          ] }),
          e.comment && /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-3 overflow-visible", children: [
            /* @__PURE__ */ d(kGe, { children: /* @__PURE__ */ d(gD, { children: e.comment }) }),
            !!e.canBeBlurred && /* @__PURE__ */ d("span", { children: /* @__PURE__ */ d(
              ue,
              {
                icon: c ? lE : cE,
                hideLabel: !0,
                label: "hide/show",
                variant: "outline",
                round: !0,
                onClick: u,
                size: "sm"
              }
            ) })
          ] })
        ] }) }),
        /* @__PURE__ */ k(Ud, { className: "flex h-full flex-col gap-4", children: [
          r && /* @__PURE__ */ d("div", { className: "flex flex-row", children: r.map((h, p) => /* @__PURE__ */ k("div", { className: "grow", children: [
            /* @__PURE__ */ d("div", { className: "mb-0.5 text-sm text-f1-foreground-secondary", children: h.label }),
            /* @__PURE__ */ k("div", { className: "flex flex-row items-end gap-0.5 text-2xl font-semibold", children: [
              !!h.prefixUnit && /* @__PURE__ */ d("div", { className: "text-lg font-medium", children: h.prefixUnit }),
              h.value,
              !!h.postfixUnit && /* @__PURE__ */ d("div", { className: "text-lg font-medium", children: h.postfixUnit })
            ] })
          ] }, p)) }),
          H.Children.toArray(n).filter(f).map((h, p) => /* @__PURE__ */ k(H.Fragment, { children: [
            p > 0 && /* @__PURE__ */ d(yD, { bare: !0 }),
            h
          ] }, p))
        ] }),
        i && /* @__PURE__ */ d(u5, { children: /* @__PURE__ */ d(ue, { variant: "neutral", size: "sm", ...i }) })
      ]
    }
  );
}), MGe = It({
  variants: {
    height: {
      sm: "h-36",
      md: "h-48",
      lg: "h-60"
    }
  }
}), CGe = X(
  function({ header: e, height: n }, i) {
    return /* @__PURE__ */ k(
      Xd,
      {
        className: E(
          "flex gap-4 border-f1-border-secondary",
          n === "full" && "h-full"
        ),
        ref: i,
        "aria-live": "polite",
        "aria-busy": !0,
        children: [
          /* @__PURE__ */ d(Yd, { className: "-mr-1 -mt-1", children: /* @__PURE__ */ k(
            "div",
            {
              className: "flex h-6 w-full flex-row items-center gap-1.5",
              "aria-hidden": !0,
              children: [
                e != null && e.title ? /* @__PURE__ */ d(Kd, { children: e.title }) : /* @__PURE__ */ d(Ce, { className: "h-4 w-full max-w-16" }),
                (e == null ? void 0 : e.subtitle) && /* @__PURE__ */ d(Ty, { children: e.subtitle })
              ]
            }
          ) }),
          /* @__PURE__ */ d(
            Ud,
            {
              "aria-hidden": !0,
              className: E(n !== "full" && MGe({ height: n })),
              children: [...Array(4)].map((r, a) => /* @__PURE__ */ d(
                Ce,
                {
                  className: `mb-1 h-6 ${["w-full", "w-1/2", "w-3/4", "w-1/4"][a]}`
                },
                a
              ))
            }
          )
        ]
      }
    );
  }
), ys = Bt(_Ge, CGe), Oi = Object.assign(
  X(function({ chart: e, summaries: n, ...i }, r) {
    return /* @__PURE__ */ d(ys, { ref: r, ...i, summaries: n, children: e && /* @__PURE__ */ d("div", { className: "min-h-52 min-w-52 grow pt-2", children: e }) });
  }),
  {
    Skeleton: ys.Skeleton
  }
), PGe = Bt(
  X(function({ canBeBlurred: e, ...n }, i) {
    const r = {
      ...n,
      header: {
        ...n.header,
        canBeBlurred: e
      }
    }, a = {
      ...n.chart,
      yAxis: n.chart.yAxis ? { ...n.chart.yAxis } : { hide: !0 }
    };
    return /* @__PURE__ */ d(
      Oi,
      {
        ref: i,
        ...r,
        chart: /* @__PURE__ */ d(vD, { ...a, canBeBlurred: e })
      }
    );
  }),
  Oi.Skeleton
), SGe = X(function(e, n) {
  return /* @__PURE__ */ d(
    Oi,
    {
      ref: n,
      ...e,
      chart: /* @__PURE__ */ d(bD, { yAxis: { hide: !0 }, ...e.chart })
    }
  );
}), NGe = Bt(
  SGe,
  Oi.Skeleton
), $Ge = Bt(
  X(
    function(e, n) {
      return /* @__PURE__ */ d(
        Oi,
        {
          ref: n,
          ...e,
          chart: /* @__PURE__ */ d(wD, { yAxis: { hide: !0 }, ...e.chart })
        }
      );
    }
  ),
  Oi.Skeleton
), DGe = Bt(
  X(
    function(e, n) {
      return /* @__PURE__ */ d(
        Oi,
        {
          ref: n,
          ...e,
          chart: /* @__PURE__ */ d(kD, { ...e.chart })
        }
      );
    }
  ),
  Oi.Skeleton
), EGe = Bt(
  X(
    function(e, n) {
      return /* @__PURE__ */ d(Oi, { ref: n, ...e, chart: null });
    }
  ),
  Oi.Skeleton
), TGe = Bt(
  X(
    function(e, n) {
      return /* @__PURE__ */ d(
        Oi,
        {
          ref: n,
          ...e,
          chart: /* @__PURE__ */ d(xD, { xAxis: { hide: !0 }, ...e.chart })
        }
      );
    }
  ),
  Oi.Skeleton
), XYe = ui(
  {
    name: "AreaChartWidget",
    type: "info"
  },
  PGe
), YYe = ui(
  {
    name: "BarChartWidget",
    type: "info"
  },
  NGe
), KYe = ui(
  {
    name: "LineChartWidget",
    type: "info"
  },
  $Ge
), UYe = ui(
  {
    name: "PieChartWidget",
    type: "info"
  },
  DGe
), JYe = ui(
  {
    name: "VerticalBarChartWidget",
    type: "info"
  },
  TGe
), QYe = ui(
  {
    name: "SummariesWidget",
    type: "info"
  },
  EGe
), OGe = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    width: "366",
    height: "146",
    viewBox: "0 0 366 146",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d("g", { filter: "url(#filter0_b_378_17717)", children: /* @__PURE__ */ d(
        "rect",
        {
          y: "60",
          width: "40",
          height: "86",
          rx: "10",
          fill: "#F5A51C",
          fillOpacity: "0.1"
        }
      ) }),
      /* @__PURE__ */ d("g", { filter: "url(#filter1_b_378_17717)", children: /* @__PURE__ */ d(
        "rect",
        {
          x: "80",
          y: "33",
          width: "40",
          height: "113",
          rx: "10",
          fill: "#F5A51C",
          fillOpacity: "0.1"
        }
      ) }),
      /* @__PURE__ */ d("g", { filter: "url(#filter2_b_378_17717)", children: /* @__PURE__ */ d(
        "rect",
        {
          x: "162",
          y: "60",
          width: "40",
          height: "86",
          rx: "10",
          fill: "#F5A51C",
          fillOpacity: "0.1"
        }
      ) }),
      /* @__PURE__ */ d("g", { filter: "url(#filter3_b_378_17717)", children: /* @__PURE__ */ d(
        "rect",
        {
          x: "244",
          y: "38",
          width: "40",
          height: "108",
          rx: "10",
          fill: "#F5A51C",
          fillOpacity: "0.1"
        }
      ) }),
      /* @__PURE__ */ d("g", { filter: "url(#filter4_b_378_17717)", children: /* @__PURE__ */ d(
        "rect",
        {
          x: "326",
          width: "40",
          height: "146",
          rx: "10",
          fill: "#F5A51C",
          fillOpacity: "0.1"
        }
      ) }),
      /* @__PURE__ */ k("defs", { children: [
        /* @__PURE__ */ k(
          "filter",
          {
            id: "filter0_b_378_17717",
            x: "-40",
            y: "20",
            width: "120",
            height: "166",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ d("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ d("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "20" }),
              /* @__PURE__ */ d(
                "feComposite",
                {
                  in2: "SourceAlpha",
                  operator: "in",
                  result: "effect1_backgroundBlur_378_17717"
                }
              ),
              /* @__PURE__ */ d(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_backgroundBlur_378_17717",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ k(
          "filter",
          {
            id: "filter1_b_378_17717",
            x: "40",
            y: "-7",
            width: "120",
            height: "193",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ d("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ d("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "20" }),
              /* @__PURE__ */ d(
                "feComposite",
                {
                  in2: "SourceAlpha",
                  operator: "in",
                  result: "effect1_backgroundBlur_378_17717"
                }
              ),
              /* @__PURE__ */ d(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_backgroundBlur_378_17717",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ k(
          "filter",
          {
            id: "filter2_b_378_17717",
            x: "122",
            y: "20",
            width: "120",
            height: "166",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ d("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ d("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "20" }),
              /* @__PURE__ */ d(
                "feComposite",
                {
                  in2: "SourceAlpha",
                  operator: "in",
                  result: "effect1_backgroundBlur_378_17717"
                }
              ),
              /* @__PURE__ */ d(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_backgroundBlur_378_17717",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ k(
          "filter",
          {
            id: "filter3_b_378_17717",
            x: "204",
            y: "-2",
            width: "120",
            height: "188",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ d("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ d("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "20" }),
              /* @__PURE__ */ d(
                "feComposite",
                {
                  in2: "SourceAlpha",
                  operator: "in",
                  result: "effect1_backgroundBlur_378_17717"
                }
              ),
              /* @__PURE__ */ d(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_backgroundBlur_378_17717",
                  result: "shape"
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ k(
          "filter",
          {
            id: "filter4_b_378_17717",
            x: "286",
            y: "-40",
            width: "120",
            height: "226",
            filterUnits: "userSpaceOnUse",
            colorInterpolationFilters: "sRGB",
            children: [
              /* @__PURE__ */ d("feFlood", { floodOpacity: "0", result: "BackgroundImageFix" }),
              /* @__PURE__ */ d("feGaussianBlur", { in: "BackgroundImageFix", stdDeviation: "20" }),
              /* @__PURE__ */ d(
                "feComposite",
                {
                  in2: "SourceAlpha",
                  operator: "in",
                  result: "effect1_backgroundBlur_378_17717"
                }
              ),
              /* @__PURE__ */ d(
                "feBlend",
                {
                  mode: "normal",
                  in: "SourceGraphic",
                  in2: "effect1_backgroundBlur_378_17717",
                  result: "shape"
                }
              )
            ]
          }
        )
      ] })
    ]
  }
), WGe = X(OGe), AGe = (t, e) => /* @__PURE__ */ k(
  "svg",
  {
    width: "406",
    height: "179",
    viewBox: "0 0 406 179",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: e,
    ...t,
    children: [
      /* @__PURE__ */ d(
        "path",
        {
          d: "M406 1L352.178 11.5985C343.237 13.359 334.653 16.5974 326.777 21.1805L270.327 54.031L208.727 80.0238C204.915 81.6326 200.986 82.9506 196.974 83.9662L146.837 96.6597C139.431 98.5348 132.323 101.436 125.72 105.279L80.2168 131.758C71.6933 136.718 62.3449 140.1 52.6208 141.742L1.12057e-05 150.623",
          stroke: "#E51943",
          strokeOpacity: "0.1",
          strokeWidth: "1.3",
          strokeLinejoin: "round"
        }
      ),
      /* @__PURE__ */ d(
        "path",
        {
          d: "M203 82.4405L270.327 54.031L338.673 14.2578L406 1V179H0V150.623L67.3266 139.26L135.673 99.4862L203 82.4405Z",
          fill: "url(#paint0_linear_3715_9085)"
        }
      ),
      /* @__PURE__ */ d("defs", { children: /* @__PURE__ */ k(
        "linearGradient",
        {
          id: "paint0_linear_3715_9085",
          x1: "203",
          y1: "179",
          x2: "203",
          y2: "1",
          gradientUnits: "userSpaceOnUse",
          children: [
            /* @__PURE__ */ d("stop", { stopColor: "#E51943", stopOpacity: "0" }),
            /* @__PURE__ */ d("stop", { offset: "1", stopColor: "#E51943", stopOpacity: "0.05" })
          ]
        }
      ) })
    ]
  }
), LGe = X(AGe), IGe = {
  "line-chart": "border-f1-border-accent-alpha20",
  "bar-chart": "border-f1-border-promote-alpha30"
}, RGe = {
  "line-chart": "min-h-48",
  "bar-chart": "min-h-64"
}, jGe = {
  "line-chart": "from-f1-background-accent-alpha5",
  "bar-chart": "from-f1-background-promote-alpha5"
}, FGe = {
  "line-chart": "default",
  "bar-chart": "promote"
}, ZYe = X(
  function({ title: e, content: n, buttonLabel: i, buttonIcon: r, buttonAction: a, type: o }, s) {
    const l = IGe[o], c = RGe[o], u = jGe[o], f = FGe[o];
    return /* @__PURE__ */ k(
      Xd,
      {
        className: E(
          "relative flex gap-4 overflow-hidden border-dashed",
          l
        ),
        ref: s,
        children: [
          /* @__PURE__ */ d(Yd, { className: "-mt-0.5", children: /* @__PURE__ */ d(Kd, { children: e }) }),
          /* @__PURE__ */ k(Ud, { className: E("flex flex-col gap-4", c), children: [
            /* @__PURE__ */ k(
              "div",
              {
                className: E(
                  "absolute -top-12 bottom-0 left-0 right-0 flex flex-col justify-end bg-gradient-to-b to-transparent",
                  u
                ),
                children: [
                  o === "bar-chart" && /* @__PURE__ */ d("div", { className: "absolute bottom-1 left-4 right-4", children: /* @__PURE__ */ d(WGe, { className: "w-full" }) }),
                  o === "line-chart" && /* @__PURE__ */ d(LGe, { className: "w-full" })
                ]
              }
            ),
            /* @__PURE__ */ k("div", { className: "relative flex min-h-28 flex-1 flex-col items-start gap-5", children: [
              /* @__PURE__ */ d("p", { className: "flex w-3/4 text-xl font-semibold", children: n }),
              i && /* @__PURE__ */ d(
                ue,
                {
                  label: i,
                  icon: r,
                  variant: f,
                  onClick: a
                }
              )
            ] })
          ] })
        ]
      }
    );
  }
);
function zGe(t, e) {
  const n = Oe(null), i = Oe(null), [r, a] = q({
    visibleItems: [],
    overflowItems: []
  });
  qu({
    ref: n,
    onResize: () => {
      c();
    }
  });
  const o = Le(
    (u, f, m) => f < m - 1 ? u + e : u,
    [e]
  ), s = Le(() => {
    if (!i.current) return [];
    const u = i.current.children, f = [];
    for (let m = 0; m < u.length; m++) {
      const h = u[m].getBoundingClientRect().height;
      f.push(h);
    }
    return f;
  }, []), l = Le(
    (u, f) => {
      let m = 0, h = 0;
      for (let p = 0; p < u.length; p++) {
        const g = h + u[p];
        if (g > f + 30) break;
        h = g, h = o(
          h,
          p,
          u.length
        ), m++;
      }
      return m;
    },
    [o]
  ), c = Le(() => {
    if (!n.current || t.length === 0) return;
    const u = n.current.clientHeight, f = s(), m = l(
      f,
      u
    );
    a(m === 0 ? {
      visibleItems: [],
      overflowItems: t
    } : (h) => h.visibleItems.length === m && h.overflowItems.length === t.length - m ? h : {
      visibleItems: t.slice(0, m),
      overflowItems: t.slice(m)
    });
  }, [t, s, l]);
  return le(() => {
    c();
  }, [c]), {
    containerRef: n,
    measurementContainerRef: i,
    visibleItems: r.visibleItems,
    overflowItems: r.overflowItems
  };
}
const jh = function({
  items: e,
  renderListItem: n,
  className: i,
  gap: r = 0,
  minSize: a,
  onVisibleItemsChange: o
}) {
  const { containerRef: s, measurementContainerRef: l, visibleItems: c } = zGe(e, r);
  return le(() => {
    o == null || o(c);
  }, [o, c]), /* @__PURE__ */ k(
    "div",
    {
      ref: s,
      className: E("relative flex h-full flex-col", i),
      style: {
        minHeight: `${a}px`
      },
      children: [
        /* @__PURE__ */ d(
          "div",
          {
            ref: l,
            "aria-hidden": "true",
            className: "pointer-events-none invisible absolute left-0 right-0 top-0 flex flex-col opacity-0",
            style: { gap: `${r}px` },
            "data-testid": "overflow-measurement-container",
            children: e.map((u, f) => /* @__PURE__ */ d("div", { "data-testid": "overflow-measurement-item", children: n(u, f, !1) }, `measure-${f}`))
          }
        ),
        /* @__PURE__ */ d(
          "div",
          {
            className: "flex flex-col",
            style: { gap: `${r}px` },
            "data-testid": "overflow-visible-container",
            children: c.map((u, f) => /* @__PURE__ */ d(
              "div",
              {
                className: "transition-all duration-150",
                "data-testid": "overflow-visible-item",
                children: n(u, f, !0)
              },
              `item-${f}`
            ))
          }
        )
      ]
    }
  );
};
jh.displayName = "VerticalOverflowList";
const eKe = ({
  events: t,
  showAllItems: e,
  gap: n = 8,
  minSize: i = 184
}) => t.length ? e ? /* @__PURE__ */ d("div", { className: "flex flex-col", children: t.map((r) => /* @__PURE__ */ d(ig, { ...r }, r.title)) }) : /* @__PURE__ */ d(
  jh,
  {
    items: t,
    gap: n,
    minSize: i,
    renderListItem: (r) => /* @__PURE__ */ d(ig, { ...r }, r.title)
  }
) : null;
function tKe({
  title: t,
  subtitle: e,
  data: n,
  helpText: i,
  legend: r = !1,
  hideTooltip: a = !1
}) {
  return /* @__PURE__ */ k("div", { children: [
    /* @__PURE__ */ k("div", { className: "flex items-baseline justify-between", children: [
      /* @__PURE__ */ d("span", { className: "text-3xl font-semibold", children: t }),
      /* @__PURE__ */ d("span", { className: "text-xl text-f1-foreground-secondary", children: e })
    ] }),
    /* @__PURE__ */ d("div", { className: "mt-2", children: /* @__PURE__ */ d(
      _D,
      {
        data: n,
        legend: r,
        hideTooltip: a
      }
    ) }),
    !!i && /* @__PURE__ */ d("div", { className: r ? "mt-1" : "mt-2", children: /* @__PURE__ */ d(
      "span",
      {
        className: E(
          "text-f1-foreground",
          r ? "text-sm" : "text-base"
        ),
        children: i
      }
    ) })
  ] });
}
const a$ = (t, e) => ((e ?? 0) < -1 * (t ?? 0) ? -1 * t : e) ?? 0, VGe = ({
  data: t = [],
  labels: e,
  trackedMinutes: n,
  remainingMinutes: i,
  canSeeRemainingTime: r = !0
}) => {
  const a = t[t.length - 1], o = (a == null ? void 0 : a.variant) || "clocked-out", s = {
    "clocked-out": e.clockedOut,
    "clocked-in": e.clockedIn,
    break: e.onBreak
  }[o], l = (() => {
    if (!r || i === void 0) return;
    const u = a$(
      n,
      i
    ), f = Math.abs(u), m = Math.floor(f / 60), h = Math.floor(f % 60), p = `${m.toString().padStart(2, "0")}:${h.toString().padStart(2, "0")}`;
    return i >= 0 ? `${e.remainingTime} ${p}` : `${e.overtime} ${p}`;
  })(), c = oo[o];
  return {
    status: o,
    statusText: s,
    subtitle: l,
    statusColor: c
  };
}, _p = "--:--", HGe = (t, e) => {
  if (t && t > 0)
    return {
      value: t * 60 / e,
      color: oo.empty
    };
  if (!e)
    return {
      value: 1,
      color: oo.empty
    };
}, BGe = ({
  data: t = [],
  trackedMinutes: e,
  remainingMinutes: n = 0
}) => {
  const i = n < 0 && n < -1 * e, r = a$(
    e,
    n
  ), a = t.reduce(
    (u, f) => u + (f.to.getTime() - f.from.getTime()) / 1e3,
    0
  ) + (r ?? 0) * 60, o = i || (r ?? 0) < 0 ? void 0 : HGe(
    r ?? 0,
    a
  );
  let s = (r ?? 0) < 0 ? Math.abs(r ?? 0) * 60 : 0, c = [
    ...[...t].reverse().reduce(
      (u, f) => {
        const m = (f.to.getTime() - f.from.getTime()) / 1e3, h = f.variant === "clocked-in" ? Math.min(m, s) : 0, g = (m - h) / a;
        return s -= h, f.variant === "clocked-in" && i ? [
          ...u,
          {
            value: h / a + g,
            color: oo.overtime
          }
        ] : [
          ...u,
          {
            value: h / a,
            color: oo.overtime
          },
          {
            value: g,
            color: oo[f.variant]
          }
        ];
      },
      []
    ).reverse(),
    ...o ? [o] : []
  ];
  return c = c.filter((u) => u.value > 0), c.length || c.push({
    value: 1,
    color: oo.empty
  }), c;
}, qGe = ({
  data: t = [],
  remainingMinutes: e,
  trackedMinutes: n = 0
}) => {
  var m;
  const i = (m = t.find((h) => h.variant === "clocked-in")) == null ? void 0 : m.from, r = t.at(-1), a = i ? sk(i) : _p, o = e === void 0 || e > 0 ? _p : r ? sk(r.to) : _p, l = (r == null ? void 0 : r.variant) === "break" ? (r == null ? void 0 : r.to.getTime()) - (r == null ? void 0 : r.from.getTime()) || 0 : n * 60 * 1e3, c = Math.floor(l / (1e3 * 60 * 60)), u = Math.floor(l % (1e3 * 60 * 60) / (1e3 * 60)), f = `${c.toString().padStart(2, "0")}:${u.toString().padStart(2, "0")}`;
  return {
    primaryLabel: a,
    secondaryLabel: o,
    time: f
  };
}, oo = {
  "clocked-in": "hsl(var(--positive-50))",
  break: "hsl(var(--promote-50))",
  empty: "hsl(var(--neutral-10))",
  "clocked-out": "hsl(var(--neutral-10))",
  overtime: "hsl(var(--warning-50))"
};
function GGe({
  data: t = [],
  trackedMinutes: e = 0,
  remainingMinutes: n
}) {
  const i = BGe({
    data: t,
    trackedMinutes: e,
    remainingMinutes: n
  }), { primaryLabel: r, secondaryLabel: a, time: o } = qGe({
    data: t,
    trackedMinutes: e,
    remainingMinutes: n
  });
  return /* @__PURE__ */ k("div", { className: "relative h-40 w-40", children: [
    /* @__PURE__ */ d(MD, { width: 156, height: 156, children: /* @__PURE__ */ d(
      CD,
      {
        data: i,
        cx: 74,
        cy: 74,
        innerRadius: 62,
        outerRadius: 74,
        startAngle: 225,
        endAngle: -45,
        paddingAngle: 2,
        cornerRadius: 4,
        dataKey: "value",
        strokeWidth: 0,
        isAnimationActive: !1,
        children: i.map((s, l) => /* @__PURE__ */ d(
          PD,
          {
            fill: s.color,
            role: "presentation",
            "aria-label": `${s.value} minutes`
          },
          `cell-${l}`
        ))
      }
    ) }),
    /* @__PURE__ */ d("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ d("span", { className: "text-3xl font-semibold tabular-nums text-f1-foreground", children: o }) }),
    /* @__PURE__ */ k("div", { className: "absolute bottom-3 flex w-full justify-between px-8 text-f1-foreground-secondary", children: [
      /* @__PURE__ */ d("span", { className: "text-sm font-medium opacity-60", children: r }),
      /* @__PURE__ */ d("span", { className: "text-sm font-medium opacity-60", children: a })
    ] })
  ] });
}
function XGe({
  text: t,
  placeholder: e,
  icon: n,
  onClick: i
}) {
  return /* @__PURE__ */ k(
    "div",
    {
      className: "flex cursor-default flex-row items-center gap-1 rounded-xs px-1 py-0.5 hover:bg-f1-background-hover",
      onClick: i,
      children: [
        n && /* @__PURE__ */ d(me, { icon: n, className: "text-f1-icon" }),
        /* @__PURE__ */ d(
          "span",
          {
            className: E(
              "font-medium",
              t ? "text-f1-foreground" : "text-f1-foreground-secondary"
            ),
            children: t ?? e
          }
        ),
        /* @__PURE__ */ d(me, { icon: rE })
      ]
    }
  );
}
function nKe({
  trackedMinutes: t,
  remainingMinutes: e,
  data: n = [],
  labels: i,
  locationId: r,
  locations: a,
  canShowLocation: o = !0,
  locationSelectorDisabled: s = !1,
  onClockIn: l,
  onClockOut: c,
  onBreak: u,
  breakTypes: f,
  onChangeBreakTypeId: m,
  canShowBreakButton: h = !0,
  canSeeGraph: p = !0,
  canSeeRemainingTime: g = !0,
  // onClickProjectSelector,
  onChangeLocationId: y,
  canShowProject: v = !0,
  projectSelectorElement: w,
  breakTypeName: x
}) {
  const { status: b, statusText: M, subtitle: _, statusColor: N } = VGe({
    data: n,
    labels: i,
    trackedMinutes: t,
    remainingMinutes: e,
    canSeeRemainingTime: g
  }), $ = b === "clocked-out", D = (f == null ? void 0 : f.map((ae) => ({
    value: ae.id,
    label: ae.duration ? `${ae.name} · ${ae.duration}` : ae.name,
    description: ae.description,
    tag: ae.isPaid ? i.paid : i.unpaid
  }))) ?? [], [W, j] = q(!1), O = () => {
    var ae;
    if (D.length > 1)
      W || j(!0);
    else {
      const Q = (ae = D == null ? void 0 : D[0]) == null ? void 0 : ae.value;
      u == null || u(Q);
    }
  }, I = (ae) => {
    m == null || m(ae), j(!1), u == null || u(ae);
  }, L = $ && a.length && !s && o, R = a.find((ae) => ae.id === r), B = a.map((ae) => ({
    value: ae.id,
    label: ae.name,
    icon: ae.icon
  })), F = b === "break", [z, K] = q(!1);
  return /* @__PURE__ */ d("div", { className: "@container", children: /* @__PURE__ */ k("div", { className: "flex-grow flex-col", children: [
    /* @__PURE__ */ k("div", { className: "flex flex-col-reverse items-center gap-2 @xs:flex-row", children: [
      /* @__PURE__ */ k("div", { className: "flex-1 space-y-4", children: [
        /* @__PURE__ */ k("div", { className: "flex flex-col items-center space-y-0.5 @xs:items-start", children: [
          /* @__PURE__ */ k("div", { className: "flex items-center gap-2", children: [
            /* @__PURE__ */ d("span", { className: "line-clamp-1 text-2xl font-semibold text-f1-foreground", children: M }),
            /* @__PURE__ */ k("div", { className: "relative aspect-square h-4", children: [
              /* @__PURE__ */ d(
                re.div,
                {
                  className: "absolute inset-0 rounded-full opacity-20",
                  style: {
                    backgroundColor: N
                  },
                  initial: { scale: 0.5, opacity: 0.6 },
                  animate: { scale: 1.6, opacity: 0 },
                  transition: {
                    duration: 1.5,
                    repeat: 1 / 0,
                    repeatDelay: 1
                  }
                }
              ),
              /* @__PURE__ */ d(
                "div",
                {
                  className: "absolute inset-[3px] rounded-full",
                  style: {
                    backgroundColor: N
                  }
                }
              )
            ] })
          ] }),
          _ && /* @__PURE__ */ d("p", { className: "line-clamp-1 text-f1-foreground-secondary", children: _ })
        ] }),
        /* @__PURE__ */ k("div", { className: "flex justify-center gap-2 @xs:justify-start", children: [
          b === "clocked-out" && /* @__PURE__ */ d("div", { className: "mr-3 @xs:mr-0", children: /* @__PURE__ */ d(
            ue,
            {
              onClick: l,
              label: i.clockIn,
              icon: pw
            }
          ) }),
          b === "clocked-in" && /* @__PURE__ */ k(Ee, { children: [
            h && /* @__PURE__ */ d(Ee, { children: D.length > 1 && m ? /* @__PURE__ */ d(
              Ca,
              {
                value: "",
                options: D,
                onChange: I,
                open: W,
                onOpenChange: j,
                selectContentClassName: "min-w-80",
                children: /* @__PURE__ */ d("div", { "aria-label": "Select break type", children: /* @__PURE__ */ d(
                  ue,
                  {
                    label: i.break,
                    variant: "neutral",
                    icon: hw,
                    hideLabel: !0
                  }
                ) })
              }
            ) : /* @__PURE__ */ d(
              ue,
              {
                onClick: O,
                label: i.break,
                variant: "neutral",
                icon: hw,
                hideLabel: !0
              }
            ) }),
            /* @__PURE__ */ d(
              ue,
              {
                onClick: c,
                label: i.clockOut,
                variant: "neutral",
                icon: gw
              }
            )
          ] }),
          b === "break" && /* @__PURE__ */ k(Ee, { children: [
            /* @__PURE__ */ d(
              ue,
              {
                onClick: c,
                label: i.clockOut,
                variant: "neutral",
                icon: gw,
                hideLabel: !0
              }
            ),
            /* @__PURE__ */ d(
              ue,
              {
                onClick: l,
                label: i.resume,
                icon: pw
              }
            )
          ] })
        ] })
      ] }),
      p && /* @__PURE__ */ d(
        GGe,
        {
          data: n,
          trackedMinutes: t,
          remainingMinutes: g ? e : 0
        }
      )
    ] }),
    /* @__PURE__ */ d("div", { className: "mt-6 flex flex-row flex-wrap items-center justify-center gap-2 @xs:justify-start", children: L ? /* @__PURE__ */ k(Ee, { children: [
      /* @__PURE__ */ d(
        Ca,
        {
          value: r,
          options: B,
          onChange: y,
          open: z,
          onOpenChange: K,
          disabled: s,
          children: /* @__PURE__ */ d("div", { "aria-label": "Select location", children: /* @__PURE__ */ d(
            XGe,
            {
              text: R == null ? void 0 : R.name,
              placeholder: i.selectLocation,
              icon: R == null ? void 0 : R.icon
            }
          ) })
        }
      ),
      v && w
    ] }) : /* @__PURE__ */ k(Ee, { children: [
      o && R && /* @__PURE__ */ d(Ee, { children: /* @__PURE__ */ d(Ni, { text: R.name, icon: R.icon }) }),
      v && w,
      F && x && /* @__PURE__ */ d(Ni, { text: x })
    ] }) })
  ] }) });
}
const YGe = ({ onClick: t, children: e }) => {
  const n = "block rounded-lg border border-solid border-transparent p-[1px] -m-1";
  return t ? /* @__PURE__ */ d(
    "a",
    {
      className: E(
        n,
        "cursor-pointer focus:border-f1-background-selected-bold focus:outline-none"
      ),
      onClick: t,
      tabIndex: 0,
      children: e
    }
  ) : /* @__PURE__ */ d("div", { className: n, tabIndex: 1, children: e });
};
function iKe({
  label: t,
  count: e,
  icon: n,
  iconClassName: i,
  onClick: r
}) {
  return /* @__PURE__ */ d(YGe, { onClick: r, children: /* @__PURE__ */ k(
    "div",
    {
      className: E(
        "flex flex-col gap-0.5 rounded-md border border-solid border-f1-border-secondary px-3 py-2.5",
        r && "hover:border-f1-border-hover"
      ),
      children: [
        /* @__PURE__ */ k("div", { className: "flex flex-row items-center", children: [
          /* @__PURE__ */ d("p", { className: "line-clamp-1 flex-1 text-f1-foreground-secondary", children: t }),
          /* @__PURE__ */ d(me, { icon: n, size: "md", className: i })
        ] }),
        /* @__PURE__ */ d("p", { className: "line-clamp-1 flex-1 text-3xl font-semibold text-f1-foreground", children: e })
      ]
    }
  ) });
}
const KGe = X(
  function({ content: e, label: n, color: i, ...r }, a) {
    return /* @__PURE__ */ k("div", { className: "flex flex-col gap-1", ref: a, children: [
      /* @__PURE__ */ d("p", { className: "text-3xl font-semibold", children: e }),
      /* @__PURE__ */ k("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ d(
          "p",
          {
            className: "line-clamp-1 text-f1-foreground-secondary",
            title: n,
            children: n
          }
        ),
        "icon" in r && r.icon && /* @__PURE__ */ d("span", { className: E("flex", i), children: /* @__PURE__ */ d(me, { icon: r.icon }) }),
        "emoji" in r && r.emoji && /* @__PURE__ */ d("span", { className: E("flex", i), children: /* @__PURE__ */ d(Bd, { emoji: r.emoji, size: "md" }) })
      ] })
    ] }, n);
  }
), rKe = X(
  function({ items: e }, n) {
    return /* @__PURE__ */ d(
      "div",
      {
        ref: n,
        className: "grid auto-cols-fr grid-flow-col items-end gap-x-3",
        children: e.map(({ label: i, content: r, color: a, ...o }) => /* @__PURE__ */ d(
          KGe,
          {
            label: i,
            content: r,
            color: a,
            ...o
          },
          `${i}-${r}`
        ))
      }
    );
  }
), UGe = ({
  onClick: t,
  withEmoji: e,
  withPointerCursor: n,
  children: i
}) => {
  const r = E(
    "flex flex-row items-center rounded-md border border-solid border-transparent p-2 text-f1-foreground",
    e ? "gap-2" : "gap-2.5",
    n ? "cursor-pointer" : "cursor-default",
    t ? "hover:bg-f1-background-tertiary focus:border-f1-background-selected-bold focus:outline-none" : void 0
  );
  return t ? /* @__PURE__ */ d("a", { className: r, onClick: t, children: i }) : /* @__PURE__ */ d("div", { className: r, children: i });
};
function aKe({
  id: t,
  title: e,
  subtitle: n,
  avatars: i,
  remainingCount: r,
  withPointerCursor: a = !1,
  onClick: o,
  ...s
}) {
  return /* @__PURE__ */ k(
    UGe,
    {
      onClick: (c) => {
        c.preventDefault(), o == null || o(t);
      },
      withEmoji: "emoji" in s && !!s.emoji,
      withPointerCursor: a,
      children: [
        "alert" in s && /* @__PURE__ */ d(Gd, { type: s.alert, icon: s.alertIcon }),
        "emoji" in s && s.emoji && /* @__PURE__ */ d($v, { emoji: s.emoji }),
        /* @__PURE__ */ k("div", { className: "flex-1", children: [
          /* @__PURE__ */ d("p", { className: "line-clamp-1 font-medium", children: e }),
          /* @__PURE__ */ d("p", { className: "line-clamp-1 text-f1-foreground-secondary", children: n })
        ] }),
        /* @__PURE__ */ d(
          Js,
          {
            avatars: i,
            remainingCount: r,
            size: "emoji" in s && s.emoji ? "medium" : "small",
            type: "person"
          }
        )
      ]
    }
  );
}
const JGe = ({ onClick: t, className: e, children: n }) => t ? /* @__PURE__ */ d("a", { className: e, onClick: t, tabIndex: 0, children: n }) : /* @__PURE__ */ d("div", { className: e, tabIndex: -1, children: n });
function D4({
  id: t,
  title: e,
  subtitle: n,
  onClick: i,
  module: r
}) {
  const a = E(
    "flex flex-row gap-2 rounded-md border border-solid border-transparent p-2 text-f1-foreground",
    i ? "cursor-pointer hover:bg-f1-background-tertiary focus:border-f1-background-selected-bold focus:outline-none" : void 0
  );
  return /* @__PURE__ */ k(JGe, { onClick: (s) => {
    s.preventDefault(), i == null || i(t);
  }, className: a, children: [
    /* @__PURE__ */ d(Sm, { module: r ?? "inbox", size: "md" }),
    /* @__PURE__ */ k("div", { className: "flex-1", children: [
      /* @__PURE__ */ d("p", { className: "line-clamp-1 font-medium", children: e }),
      /* @__PURE__ */ d("p", { className: "line-clamp-1 text-f1-foreground-secondary", children: n })
    ] })
  ] });
}
const QGe = ({ onClick: t, className: e, children: n }) => t ? /* @__PURE__ */ d("a", { className: e, onClick: t, tabIndex: 0, children: n }) : /* @__PURE__ */ d("div", { className: e, tabIndex: -1, children: n });
function My({
  id: t,
  title: e,
  alert: n,
  rawTag: i,
  count: r,
  icon: a,
  rightIcon: o,
  iconClassName: s = "text-f1-icon-secondary",
  rightIconClassName: l = "text-f1-icon-secondary",
  onClick: c
}) {
  const u = E(
    "flex flex-row items-start gap-1 rounded-md border border-solid border-transparent px-2 py-1.5 text-f1-foreground",
    c ? "cursor-pointer hover:bg-f1-background-tertiary focus:border-f1-background-selected-bold focus:outline-none" : void 0
  );
  return /* @__PURE__ */ k(QGe, { onClick: (m) => {
    m.preventDefault(), c == null || c(t);
  }, className: u, children: [
    /* @__PURE__ */ k("div", { className: "flex flex-1 flex-row items-start gap-1", children: [
      a && /* @__PURE__ */ d(me, { icon: a, size: "md", className: E("mt-0.5", s) }),
      /* @__PURE__ */ d("p", { className: "mt-0.5 line-clamp-2 font-medium", children: e }),
      o && /* @__PURE__ */ d(
        me,
        {
          icon: o,
          size: "md",
          className: E("mt-0.5", l)
        }
      )
    ] }),
    /* @__PURE__ */ k("div", { className: "flex flex-row items-center gap-2", children: [
      n && /* @__PURE__ */ d(gc, { ...n }),
      i && /* @__PURE__ */ d(Ni, { ...i }),
      !!r && /* @__PURE__ */ d(Lo, { value: r })
    ] })
  ] });
}
function oKe({
  items: t,
  minSize: e = 184,
  onClickItem: n,
  showAllItems: i,
  onVisibleItemsChange: r
}) {
  return i ? /* @__PURE__ */ d("div", { className: "flex flex-col gap-2", children: t.map((a) => /* @__PURE__ */ d(D4, { ...a, onClick: n }, a.id)) }) : /* @__PURE__ */ d(
    jh,
    {
      items: t,
      minSize: e,
      renderListItem: (a) => /* @__PURE__ */ d(D4, { ...a, onClick: n }, a.id),
      onVisibleItemsChange: r,
      gap: 8
    }
  );
}
function sKe({
  items: t,
  gap: e,
  minSize: n = 184,
  onClickItem: i,
  showAllItems: r
}) {
  return r ? /* @__PURE__ */ d("div", { className: "flex flex-col", style: { minHeight: `${n}px` }, children: t.map((a) => /* @__PURE__ */ d(My, { ...a, onClick: i }, a.id)) }) : /* @__PURE__ */ d(
    jh,
    {
      items: t,
      gap: e,
      renderListItem: (a) => /* @__PURE__ */ d(My, { ...a, onClick: i }),
      minSize: n
    }
  );
}
function ZGe({
  task: t,
  status: e,
  onClick: n,
  hideIcon: i = !1
}) {
  var o;
  const r = () => {
    n == null || n(t);
  }, a = ve(() => {
    if (!i) {
      if (e === "todo")
        return SD;
      if (e === "in-progress")
        return $E;
    }
  }, [e, i]);
  return /* @__PURE__ */ d(
    My,
    {
      id: t.id,
      title: t.text,
      icon: a,
      iconClassName: e === "todo" ? "text-f1-icon" : "text-f1-icon-info",
      alert: (o = t.badge) != null && o.isPastDue ? {
        text: t.badge.text,
        level: "critical"
      } : void 0,
      rawTag: t.badge && !t.badge.isPastDue ? {
        text: t.badge.text,
        icon: XD
      } : void 0,
      count: t.counter,
      onClick: r
    }
  );
}
function lKe({
  tasks: t,
  onClickTask: e,
  hideIcons: n = !1,
  maxTasksToShow: i = 5,
  emptyMessage: r = "No tasks assigned"
}) {
  const o = [
    { key: "inProgress", status: "in-progress" },
    { key: "todo", status: "todo" }
  ].flatMap(
    ({ key: l, status: c }) => (t[l] || []).map(
      (u) => typeof u == "string" ? {
        id: u,
        text: u
      } : u
    ).map(({ id: u, text: f, badge: m, counter: h }) => ({
      id: u,
      text: f,
      badge: m,
      counter: h,
      status: c
    }))
  ), s = !o.length;
  return /* @__PURE__ */ d("div", { className: "flex flex-col gap-0", children: s ? /* @__PURE__ */ d("p", { className: "pl-2 font-medium", children: r }) : o.slice(0, i).map((l) => /* @__PURE__ */ d(
    ZGe,
    {
      task: l,
      status: l.status,
      hideIcon: n,
      onClick: e
    },
    l.id
  )) });
}
const eXe = ({ title: t, info: e }) => /* @__PURE__ */ k("div", { className: "flex items-center justify-between", children: [
  /* @__PURE__ */ d("p", { className: "flex text-f1-foreground-secondary", children: t }),
  /* @__PURE__ */ d("div", { className: "basis-16 justify-self-end text-right font-medium", children: e })
] }), dKe = X(
  function({ title: e, list: n }, i) {
    return /* @__PURE__ */ k("div", { ref: i, className: "flex flex-col gap-2", children: [
      e && /* @__PURE__ */ d("div", { className: "font-medium", children: e }),
      n.map((r) => /* @__PURE__ */ d(eXe, { title: r.title, info: r.info }, r.title))
    ] });
  }
);
var tXe = Object.defineProperty, nXe = Object.defineProperties, iXe = Object.getOwnPropertyDescriptors, Mm = Object.getOwnPropertySymbols, o$ = Object.prototype.hasOwnProperty, s$ = Object.prototype.propertyIsEnumerable, E4 = (t, e, n) => e in t ? tXe(t, e, { enumerable: !0, configurable: !0, writable: !0, value: n }) : t[e] = n, xi = (t, e) => {
  for (var n in e || (e = {})) o$.call(e, n) && E4(t, n, e[n]);
  if (Mm) for (var n of Mm(e)) s$.call(e, n) && E4(t, n, e[n]);
  return t;
}, Fh = (t, e) => nXe(t, iXe(e)), rXe = (t, e) => {
  var n = {};
  for (var i in t) o$.call(t, i) && e.indexOf(i) < 0 && (n[i] = t[i]);
  if (t != null && Mm) for (var i of Mm(t)) e.indexOf(i) < 0 && s$.call(t, i) && (n[i] = t[i]);
  return n;
}, aXe = (t) => t.right - t.left < 5 || t.bottom && t.bottom - t.top < 5, oXe = ({ spotsList: t, usedSpot: e }) => t.some((n) => n !== e && e.left === n.left), sXe = ({ position: t, spot: e, stone: n }) => {
  if (t.left > e.left && e.right >= t.left && t.top + n.height > e.top) {
    if (e.bottom && e.bottom < t.top) return e;
    let i = xi({}, e);
    return i.right = t.left, i;
  }
  return null;
}, lXe = ({ position: t, stone: e, spot: n }) => {
  if (t.left + e.width > n.left && t.top >= n.top) {
    if (n.bottom && n.bottom < t.top || n.right < t.left) return n;
    let i = xi({}, n);
    return i.bottom = t.top, i;
  }
  return null;
}, dXe = ({ stone: t, position: e, spotsList: n, optimalSpot: i }) => {
  let r = xi({}, i);
  return r.left = e.left + t.width, aXe(r) || oXe({ usedSpot: r, spotsList: n }) ? null : r;
}, cXe = ({ spots: t, position: e, optimalSpot: n, stone: i }) => t.map((r, a, o) => {
  if (r === n) return dXe({ stone: i, position: e, optimalSpot: n, spotsList: o });
  let s = sXe({ position: e, spot: r, stone: i });
  return s || lXe({ position: e, stone: i, spot: r }) || r;
});
function uXe(t, e) {
  for (let n = 0, i = e.length; n < i; n++) {
    let r = e[n];
    if (t(r)) return r;
  }
  return null;
}
var fXe = (t, e) => e.filter(t), mXe = (t, e) => [...e].sort(t), hXe = (t, e) => t.top === e.top ? t.left < e.left ? -1 : 1 : t.top < e.top ? -1 : 1, pXe = (t) => mXe(hXe, t), gXe = ({ availableSpots: t, optimalSpot: e, containerSize: n, stone: i }) => {
  let r = { right: n, top: e.top + i.height, left: e.left };
  e.bottom && (r.bottom = e.bottom);
  for (let a = 0, o = t.length; a < o; a += 1) {
    let s = t[a];
    if (r.left < s.left && r.top < s.top) {
      r.right = s.left;
      break;
    }
  }
  return r;
}, yXe = (t, e) => {
  let n = t.right - t.left >= e.width;
  if (!t.bottom) return n;
  let i = t.bottom - t.top >= e.height;
  return n && i;
}, vXe = ({ availableSpots: t, stone: e }) => uXe((n) => yXe(n, e), t);
function bXe({ stone: t, availableSpots: e, containerSize: n }) {
  let i = vXe({ availableSpots: e, stone: t }), r = { left: i.left, top: i.top }, a = gXe({ optimalSpot: i, availableSpots: e.filter((l) => l !== i), stone: t, containerSize: n }), o = [...e, a], s = cXe({ spots: o, position: r, optimalSpot: i, stone: t });
  return o = [...fXe(Boolean, s)], o = pXe(o), { position: r, availableSpots: o };
}
var wXe = ({ stones: t, containerSize: e }) => {
  let n = { positions: [], containerHeight: 0, availableSpots: [] };
  if (!t.length) return n;
  let i = 0, r = [], a = [{ top: 0, left: 0, right: e }];
  for (let o of t) {
    let s = bXe({ availableSpots: a, stone: o, containerSize: e }), l = s.position.top + o.height;
    i < l && (i = l), r.push(s.position), a = s.availableSpots;
  }
  return { availableSpots: a, positions: r, containerHeight: i };
}, kXe = (t) => t.reduce((e, n) => {
  if (!n) return e;
  let i = n.getBoundingClientRect();
  return e.push({ width: i.width, height: i.height }), e;
}, []), xXe = ({ boxesRefs: t, wrapperRef: e, children: n, windowWidth: i, wrapperWidth: r }) => {
  let [{ positions: a, containerHeight: o, stones: s, availableSpots: l }, c] = q({ positions: [], containerHeight: null, stones: [], availableSpots: [] });
  return le(() => {
    var u, f;
    let m = kXe(t.current), h = (f = (u = e.current) == null ? void 0 : u.offsetWidth) != null ? f : 0;
    if (h === null) return;
    let p = wXe({ stones: m, containerSize: h });
    c(Fh(xi({}, p), { stones: m }));
  }, [n, t, e, i, r]), { positions: a, containerHeight: o, stones: s, availableSpots: l };
}, _Xe = (t) => ({ fade: `${t}ms opacity ease`, fadeMove: `
    ${t}ms opacity ease,
    ${t}ms top ease,
    ${t}ms left ease
  `, move: `
    ${t}ms top ease,
    ${t}ms left ease
  ` }), MXe = ({ transition: t, transitionDuration: e }) => t ? { transition: _Xe(e)[t] } : null, CXe = (t) => t ? Fh(xi({}, t), { opacity: 1 }) : { opacity: 0, top: 0, left: 0 }, PXe = ({ style: t, position: e, transition: n, transitionDuration: i }) => xi(xi(Fh(xi({}, t), { position: "absolute" }), CXe(e)), MXe({ transition: n, transitionDuration: i }));
function SXe(t, e, n) {
  let i;
  return function(...r) {
    i && clearTimeout(i), i = setTimeout(function() {
      i = null, t.apply(null, r);
    }, e);
  };
}
var NXe = () => {
  let [t, e] = q(), n = Oe(SXe(e, 300));
  return le(() => {
    let i = () => {
      n.current(window.innerWidth);
    };
    return window.addEventListener("resize", i), () => {
      window.removeEventListener("resize", i);
    };
  }, []), t;
}, $Xe = (t) => {
  let [e, n] = q(null);
  return le(() => {
    let i = new ResizeObserver((r) => {
      for (let a of r) n(a.contentRect.width);
    });
    return t.current && i.observe(t.current), () => {
      i.disconnect();
    };
  }, [t]), e;
}, DXe = (t) => {
  var e = t, { children: n, style: i, transition: r = !1, transitionDuration: a = 500, transitionStep: o = 50 } = e, s = rXe(e, ["children", "style", "transition", "transitionDuration", "transitionStep"]);
  let l = Oe([]), c = Oe(null), u = NXe(), f = $Xe(c), { positions: m, containerHeight: h } = xXe({ boxesRefs: l, wrapperRef: c, children: n, windowWidth: u, wrapperWidth: f }), p = xi({ minHeight: h ?? 0, position: "relative" }, i);
  return d("div", Fh(xi({ ref: c, style: p }, s), { children: v5.map(n, (g, y) => {
    if (typeof g != "object" || !g || !("type" in g)) return g;
    let v = { style: PXe({ style: g.props.style, position: m[y], transition: r, transitionDuration: a }), ref: (w) => l.current[y] = w };
    return g5(g, xi(xi({}, g.props), v));
  }) }));
};
const EXe = { sm: 340, md: 480, lg: 640 }, T4 = X(
  function({ children: e, widgetWidth: n = "sm" }, i) {
    const r = EXe[n], [a, o] = q(), s = v5.toArray(e), l = Oe(null);
    return le(() => {
      const c = () => {
        var f;
        const u = (f = l.current) == null ? void 0 : f.offsetWidth;
        u && o(Math.floor(u / r) || 1);
      };
      return c(), window.addEventListener("resize", c), () => {
        window.removeEventListener("resize", c);
      };
    }, [o, r]), /* @__PURE__ */ d("div", { ref: i, className: "text-f1-foreground", children: /* @__PURE__ */ d("div", { ref: l, children: a === 1 ? /* @__PURE__ */ d("div", { className: "flex flex-col gap-4 *:shadow", children: e }) : a && a > 1 && /* @__PURE__ */ d("div", { className: "relative -mr-4", children: /* @__PURE__ */ d(DXe, { children: s.map((c, u) => /* @__PURE__ */ d(
      "div",
      {
        style: {
          width: `${Math.floor(1 / a * 1e4) / 100 - 0.05}%`
        },
        className: "pb-[0.01px] pr-4 *:mb-4 *:shadow",
        children: c
      },
      u
    )) }, a) }) }) });
  }
), TXe = ["sm", "lg", "md", "md", "lg", "sm", "lg", "lg", "sm", "sm", "md", "md"], cKe = Bt(T4, () => /* @__PURE__ */ d(p5, { children: /* @__PURE__ */ d(T4, { children: TXe.map((t, e) => /* @__PURE__ */ d(ys.Skeleton, { height: t }, e)) }) })), O4 = ({ children: t }) => /* @__PURE__ */ d("div", { className: "flex min-h-40 flex-row items-stretch gap-4 text-f1-foreground @container [&>div]:min-w-[calc(100vw-64px)] @2xl:[&>div]:min-w-[calc(50vw-48px)]", children: t }), uKe = Bt(
  X(function({ children: e }, n) {
    return /* @__PURE__ */ d(No, { ref: n, showBar: !1, children: /* @__PURE__ */ d(O4, { children: e }) });
  }),
  () => /* @__PURE__ */ d(p5, { orientation: "horizontal", children: /* @__PURE__ */ k(O4, { children: [
    /* @__PURE__ */ d(ys.Skeleton, {}),
    /* @__PURE__ */ d(ys.Skeleton, {}),
    /* @__PURE__ */ d(ys.Skeleton, {})
  ] }) })
);
function fKe({
  title: t,
  description: e,
  emoji: n,
  actions: i
}) {
  if (((i == null ? void 0 : i.length) ?? 0) > 2)
    throw Error(
      "You can only provide up to two actions for the WidgetEmptyState"
    );
  return /* @__PURE__ */ d(
    RP,
    {
      title: t,
      description: e,
      ...n ? { emoji: n } : { variant: "warning" },
      actions: i
    }
  );
}
const OXe = X(
  ({ title: t, children: e }, n) => (To(t, { disallowEmpty: !0 }), /* @__PURE__ */ k("div", { ref: n, className: "flex flex-col gap-2", children: [
    /* @__PURE__ */ d("p", { className: "text-base font-medium text-f1-foreground-secondary", children: t }),
    e
  ] }))
);
OXe.displayName = "WidgetSection";
const mKe = ui(
  {
    name: "ScrollArea",
    type: "layout"
  },
  No
);
export {
  tYe as ActivityItemList,
  Aj as ActivityItemListSkeleton,
  nYe as Alert,
  Gd as AlertAvatar,
  rYe as AlertDescription,
  gc as AlertTag,
  iYe as AlertTitle,
  CYe as ApplicationFrame,
  XYe as AreaChartWidget,
  GYe as AutoGrid,
  ni as Avatar,
  Js as AvatarList,
  Xy as Badge,
  yC as BalanceTag,
  YYe as BarChartWidget,
  Wj as BaseActivityItemList,
  Mz as BaseCelebration,
  AV as BaseCommunityPost,
  TH as BaseTabs,
  zYe as BasicTextEditor,
  VH as BreadcrumbSelect,
  zH as Breadcrumbs,
  ig as CalendarEvent,
  eKe as CalendarEventList,
  lD as Carousel,
  tKe as CategoryBarSection,
  sYe as Celebration,
  Cz as CelebrationSkeleton,
  ZYe as ChartWidgetEmptyState,
  nKe as ClockInControls,
  yYe as CommunityPost,
  LV as CommunityPostSkeleton,
  ac as CompanyAvatar,
  sB as CompanySelector,
  vC as CompanyTag,
  Lo as Counter,
  cKe as Dashboard,
  qp as DateAvatar,
  rB as DaytimePage,
  tH as DetailsItem,
  kYe as DetailsItemsList,
  RYe as Dialog,
  Qs as DotTag,
  In as Dropdown,
  $v as EmojiAvatar,
  qXe as EntitySelect,
  I6 as F1SearchBox,
  mi as FILE_TYPES,
  MM as FileAvatar,
  i$ as FileItem,
  JXe as Form,
  QXe as FormActions,
  ZXe as FormField,
  lYe as HighlightBanner,
  df as IconAvatar,
  rKe as IndicatorsList,
  GXe as Input,
  KYe as LineChartWidget,
  DYe as Menu,
  Fv as MobileDropdown,
  Sm as ModuleAvatar,
  XXe as NumberInput,
  PYe as OmniButton,
  OYe as OneAlert,
  WYe as OneApprovalHistory,
  IP as OneCalendar,
  FDe as OneCard,
  IYe as OneDataCollection,
  hEe as OneDateNavigator,
  RP as OneEmptyState,
  Zv as OneModal,
  OEe as OnePagination,
  xYe as OnePersonListItem,
  oB as Page,
  MYe as PageHeader,
  ti as PersonAvatar,
  bC as PersonTag,
  UYe as PieChartWidget,
  kGe as PrivateBox,
  jXe as RadarChart,
  Ni as RawTag,
  bYe as ResourceHeader,
  VYe as RichTextDisplay,
  HYe as RichTextEditor,
  mKe as ScrollArea,
  EYe as SearchBar,
  wYe as SectionHeader,
  Ca as Select,
  M6 as Shortcut,
  TYe as Sidebar,
  SYe as SidebarFooter,
  NYe as SidebarHeader,
  pc as Spinner,
  qYe as Split,
  BYe as Stack,
  Vr as StatusTag,
  QYe as SummariesWidget,
  qL as Switch,
  WH as Tabs,
  OH as TabsSkeleton,
  kC as TagList,
  lKe as TasksList,
  Fm as TeamAvatar,
  wC as TeamTag,
  KXe as Textarea,
  g9 as ToggleGroup,
  y9 as ToggleGroupItem,
  Kt as Tooltip,
  dKe as TwoColumnsList,
  JYe as VerticalBarChartWidget,
  UV as Weekdays,
  ys as Widget,
  aKe as WidgetAvatarsListItem,
  fKe as WidgetEmptyState,
  iKe as WidgetHighlightButton,
  oKe as WidgetInboxList,
  D4 as WidgetInboxListItem,
  OXe as WidgetSection,
  sKe as WidgetSimpleList,
  My as WidgetSimpleListItem,
  uKe as WidgetStrip,
  yO as _RadarChart,
  vYe as dotTagColors,
  RDe as getGranularityDefinition,
  IDe as getGranularitySimpleDefinition,
  _t as granularityDefinitions,
  gKe as modules,
  AYe as predefinedPresets,
  md as rangeSeparator,
  LYe as useDataSource,
  gI as useForm,
  eYe as useFormSchema,
  vc as useSidebar
};
